import "./speech.f14ceeb8.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $inFmq = parcelRequire("inFmq");

var $jZc0w = parcelRequire("jZc0w");

var $lWdx1 = parcelRequire("lWdx1");
const $16b3f81f6e835ccb$export$8311873a6069f3c6 = {
    kernelName: (0, $hl418.Abs),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $jZc0w.mul)(dy, (0, $lWdx1.step)((0, $inFmq.cast)(x, 'float32'), -1))
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $inFmq = parcelRequire("inFmq");

var $1QPqB = parcelRequire("1QPqB");

var $15cGp = parcelRequire("15cGp");

var $3xp7o = parcelRequire("3xp7o");

var $iAb3z = parcelRequire("iAb3z");

var $iDd8d = parcelRequire("iDd8d");

var $7kouu = parcelRequire("7kouu");
const $abc3f6692a074231$export$25410aeefefd68e9 = {
    kernelName: (0, $hl418.Acos),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>{
                const a = (0, $iDd8d.square)((0, $inFmq.cast)(x, 'float32'));
                const b = (0, $iAb3z.sqrt)((0, $7kouu.sub)((0, $3xp7o.scalar)(1), a));
                return (0, $15cGp.neg)((0, $1QPqB.div)(dy, b));
            }
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $inFmq = parcelRequire("inFmq");

var $1QPqB = parcelRequire("1QPqB");

var $iAb3z = parcelRequire("iAb3z");

var $iDd8d = parcelRequire("iDd8d");

var $7kouu = parcelRequire("7kouu");
const $44e3410f91274d15$export$2ec6994297162d56 = {
    kernelName: (0, $hl418.Acosh),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>{
                const a = (0, $iAb3z.sqrt)((0, $7kouu.sub)((0, $iDd8d.square)((0, $inFmq.cast)(x, 'float32')), 1));
                return (0, $1QPqB.div)(dy, a);
            }
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $8BaGO = parcelRequire("8BaGO");

var $4sqA7 = parcelRequire("4sqA7");

var $9NgTx = parcelRequire("9NgTx");
const $f34466425f1ab9ba$export$817a98e7fbc08f69 = {
    kernelName: (0, $hl418.Add),
    inputsToSave: [
        'a',
        'b'
    ],
    gradFunc: (dy, saved)=>{
        const [a, b] = saved;
        const outShape = $8BaGO.assertAndGetBroadcastShape(a.shape, b.shape);
        const derA = ()=>{
            let res = dy;
            const reduceAxes = $8BaGO.getReductionAxes(a.shape, outShape);
            if (reduceAxes.length > 0) res = (0, $9NgTx.sum)(res, reduceAxes);
            return (0, $4sqA7.reshape)(res, a.shape);
        };
        const derB = ()=>{
            let res = dy;
            const reduceAxes = $8BaGO.getReductionAxes(b.shape, outShape);
            if (reduceAxes.length > 0) res = (0, $9NgTx.sum)(res, reduceAxes);
            return (0, $4sqA7.reshape)(res, b.shape);
        };
        return {
            a: derA,
            b: derB
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");
const $40725ecfd14bd52a$export$9dda03cc9e4ef85c = {
    kernelName: (0, $hl418.AddN),
    saveAllInputs: true,
    gradFunc: (dy, saved)=>{
        const ders = {};
        saved.forEach((_, i)=>{
            ders[i] = ()=>dy.clone();
        });
        return ders;
    }
};


/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $8EjnK = parcelRequire("8EjnK");
const $e1ef11eb5c42d53e$export$1d99392d6c64a702 = {
    kernelName: (0, $hl418.ArgMax),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $8EjnK.zerosLike)(x)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $8EjnK = parcelRequire("8EjnK");
const $68e623e9c8752b63$export$af12a090c1c7b332 = {
    kernelName: (0, $hl418.ArgMin),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $8EjnK.zerosLike)(x)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $inFmq = parcelRequire("inFmq");

var $1QPqB = parcelRequire("1QPqB");

var $3xp7o = parcelRequire("3xp7o");

var $iAb3z = parcelRequire("iAb3z");

var $iDd8d = parcelRequire("iDd8d");

var $7kouu = parcelRequire("7kouu");
const $1038d963c8903264$export$3f8c1d33cc0ed430 = {
    kernelName: (0, $hl418.Asin),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $1QPqB.div)(dy, (0, $iAb3z.sqrt)((0, $7kouu.sub)((0, $3xp7o.scalar)(1), (0, $iDd8d.square)((0, $inFmq.cast)(x, 'float32')))))
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $hgacW = parcelRequire("hgacW");

var $inFmq = parcelRequire("inFmq");

var $1QPqB = parcelRequire("1QPqB");

var $3xp7o = parcelRequire("3xp7o");

var $iAb3z = parcelRequire("iAb3z");

var $iDd8d = parcelRequire("iDd8d");
const $1443a963105306fb$export$375f857062067cfd = {
    kernelName: (0, $hl418.Asinh),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>{
                const a = (0, $iAb3z.sqrt)((0, $hgacW.add)((0, $3xp7o.scalar)(1), (0, $iDd8d.square)((0, $inFmq.cast)(x, 'float32'))));
                return (0, $1QPqB.div)(dy, a);
            }
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $hgacW = parcelRequire("hgacW");

var $8BaGO = parcelRequire("8BaGO");

var $1QPqB = parcelRequire("1QPqB");

var $jZc0w = parcelRequire("jZc0w");

var $15cGp = parcelRequire("15cGp");

var $4sqA7 = parcelRequire("4sqA7");

var $iDd8d = parcelRequire("iDd8d");

var $9NgTx = parcelRequire("9NgTx");
const $8299722d66a7479c$export$cdf09477d70d7ce9 = {
    kernelName: (0, $hl418.Atan2),
    inputsToSave: [
        'a',
        'b'
    ],
    gradFunc: (dy, saved)=>{
        const [a, b] = saved;
        const outShape = (0, $8BaGO.assertAndGetBroadcastShape)(a.shape, b.shape);
        const derA = ()=>{
            const d = (0, $hgacW.add)((0, $iDd8d.square)(a), (0, $iDd8d.square)(b));
            let res = (0, $jZc0w.mul)(dy, (0, $1QPqB.div)(b, d));
            const reduceAxes = (0, $8BaGO.getReductionAxes)(a.shape, outShape);
            if (reduceAxes.length > 0) res = (0, $9NgTx.sum)(res, reduceAxes);
            return (0, $4sqA7.reshape)(res, a.shape);
        };
        const derB = ()=>{
            const d = (0, $hgacW.add)((0, $iDd8d.square)(a), (0, $iDd8d.square)(b));
            let res = (0, $15cGp.neg)((0, $jZc0w.mul)(dy, (0, $1QPqB.div)(a, d)));
            const reduceAxes = (0, $8BaGO.getReductionAxes)(b.shape, outShape);
            if (reduceAxes.length > 0) res = (0, $9NgTx.sum)(res, reduceAxes);
            return (0, $4sqA7.reshape)(res, b.shape);
        };
        return {
            a: derA,
            b: derB
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $hgacW = parcelRequire("hgacW");

var $inFmq = parcelRequire("inFmq");

var $1QPqB = parcelRequire("1QPqB");

var $iDd8d = parcelRequire("iDd8d");
const $1e790246ae1a8a74$export$87ed559988dd857 = {
    kernelName: (0, $hl418.Atan),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $1QPqB.div)(dy, (0, $hgacW.add)((0, $iDd8d.square)((0, $inFmq.cast)(x, 'float32')), 1))
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $inFmq = parcelRequire("inFmq");

var $1QPqB = parcelRequire("1QPqB");

var $iDd8d = parcelRequire("iDd8d");

var $7kouu = parcelRequire("7kouu");

var $3xp7o = parcelRequire("3xp7o");
const $914f9524978b3333$export$465efa1ebdf13d21 = {
    kernelName: (0, $hl418.Atanh),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $1QPqB.div)(dy, (0, $7kouu.sub)((0, $3xp7o.scalar)(1), (0, $iDd8d.square)((0, $inFmq.cast)(x, 'float32'))))
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $frznq = parcelRequire("frznq");

var $jqSCG = parcelRequire("jqSCG");

var $4sqA7 = parcelRequire("4sqA7");
/**
 * Computes the backprop of a 3d avg pool.
 *
 * @param dy The dy error, of rank 5 of shape
 *     [batchSize, depth, height, width, channels].
 * assumed.
 * @param input The original input image, of rank 5 or rank4 of shape
 *     [batchSize, depth, height, width, channels].
 * @param filterSize The filter size:
 *     `[filterDepth, filterHeight, filterWidth]`.
 *     `filterSize` is a single number,
 *     then `filterDepth == filterHeight == filterWidth`.
 * @param strides The strides of the pooling:
 *     `[strideDepth, strideHeight, strideWidth]`. If
 *     `strides` is a single number, then `strideHeight == strideWidth`.
 * @param pad A string from: 'same', 'valid'. The type of padding algorithm
 *     used in the forward prop of the op.
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 */ function $4d26a67fd9470f7e$var$avgPool3dGrad_(dy, input, filterSize, strides, pad, dimRoundingMode) {
    const $dy = (0, $5xBLk.convertToTensor)(dy, 'dy', 'avgPool3dGrad');
    const $input = (0, $5xBLk.convertToTensor)(input, 'input', 'avgPool3dGrad');
    let dy5D = $dy;
    let input5D = $input;
    let reshapedTo5D = false;
    if ($input.rank === 4) {
        reshapedTo5D = true;
        dy5D = (0, $4sqA7.reshape)($dy, [
            1,
            $dy.shape[0],
            $dy.shape[1],
            $dy.shape[2],
            $dy.shape[3]
        ]);
        input5D = (0, $4sqA7.reshape)($input, [
            1,
            $input.shape[0],
            $input.shape[1],
            $input.shape[2],
            $input.shape[3]
        ]);
    }
    $8cCb2.assert(dy5D.rank === 5, ()=>`Error in avgPool3dGrad: dy must be rank 5 but got rank ` + `${dy5D.rank}.`);
    $8cCb2.assert(input5D.rank === 5, ()=>`Error in avgPool3dGrad: input must be rank 5 but got rank ` + `${input5D.rank}.`);
    (0, $frznq.checkPadOnDimRoundingMode)('avgPool3dGrad', pad, dimRoundingMode);
    const inputs = {
        dy: dy5D,
        input: input5D
    };
    const attrs = {
        filterSize: filterSize,
        strides: strides,
        pad: pad,
        dimRoundingMode: dimRoundingMode
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $38WwN.ENGINE).runKernel((0, $hl418.AvgPool3DGrad), inputs, attrs);
    if (reshapedTo5D) return (0, $4sqA7.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3],
        res.shape[4]
    ]);
    return res;
}
const $4d26a67fd9470f7e$export$e8424a7f676b4e30 = /* @__PURE__ */ (0, $jqSCG.op)({
    avgPool3dGrad_: $4d26a67fd9470f7e$var$avgPool3dGrad_
});


const $71e09be9109c2502$export$1eeb8780807d0508 = {
    kernelName: (0, $hl418.AvgPool3D),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x] = saved;
        const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
        return {
            x: ()=>(0, $4d26a67fd9470f7e$export$e8424a7f676b4e30)(dy, x, filterSize, strides, pad, dimRoundingMode)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");

var $4sqA7 = parcelRequire("4sqA7");
/**
 * Computes the backprop of an 2D avg pool.
 *
 * @param dy The dy error, of rank 4 or rank 3 of shape
 *     [batchSize, height, width, channels]. If rank 3, batch of 1 is
 * assumed.
 * @param input The input image, of rank 4 or rank 3 of shape
 *     [batchSize, height, width, channels]. If rank 3, batch of 1 is
 * assumed.
 * @param filterSize The filter size: `[filterHeight, filterWidth]`. If
 *     `filterSize` is a single number, then `filterHeight == filterWidth`.
 * @param strides The strides of the pooling: `[strideHeight, strideWidth]`. If
 *     `strides` is a single number, then `strideHeight == strideWidth`.
 * @param pad The type of padding algorithm used in the forward prop of the op.
 *     'same', 'valid', for more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *         https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 */ function $59da56c3e9e68483$var$avgPoolGrad_(dy, input, filterSize, strides, pad) {
    const $dy = (0, $5xBLk.convertToTensor)(dy, 'dy', 'avgPoolGrad');
    const $input = (0, $5xBLk.convertToTensor)(input, 'input', 'avgPoolGrad');
    $8cCb2.assert($input.rank === $dy.rank, ()=>`Rank of input (${$input.rank}) does not match rank of dy (${$dy.rank})`);
    let input4D = $input;
    let dy4D = $dy;
    let reshapedTo4D = false;
    if ($input.rank === 3) {
        reshapedTo4D = true;
        input4D = (0, $4sqA7.reshape)($input, [
            1,
            $input.shape[0],
            $input.shape[1],
            $input.shape[2]
        ]);
        dy4D = (0, $4sqA7.reshape)($dy, [
            1,
            $dy.shape[0],
            $dy.shape[1],
            $dy.shape[2]
        ]);
    }
    $8cCb2.assert(dy4D.rank === 4, ()=>`Error in avgPoolGrad: dy must be rank 4 but got rank ` + `${dy4D.rank}.`);
    $8cCb2.assert(input4D.rank === 4, ()=>`Error in avgPoolGrad: input must be rank 4 but got rank ` + `${input4D.rank}.`);
    const inputs = {
        dy: dy4D,
        input: input4D
    };
    const attrs = {
        filterSize: filterSize,
        strides: strides,
        pad: pad
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $38WwN.ENGINE).runKernel((0, $hl418.AvgPoolGrad), inputs, attrs);
    if (reshapedTo4D) return (0, $4sqA7.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $59da56c3e9e68483$export$2f098171d1c79aea = /* @__PURE__ */ (0, $jqSCG.op)({
    avgPoolGrad_: $59da56c3e9e68483$var$avgPoolGrad_
});


const $98f0415292ab533e$export$ac3f8709351ab225 = {
    kernelName: (0, $hl418.AvgPool),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x] = saved;
        const { filterSize: filterSize, strides: strides, pad: pad } = attrs;
        return {
            x: ()=>(0, $59da56c3e9e68483$export$2f098171d1c79aea)(dy, x, filterSize, strides, pad)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $aUFou = parcelRequire("aUFou");
const $b96889729ac833ab$export$88221f1a5167c38c = {
    kernelName: (0, $hl418.BatchMatMul),
    inputsToSave: [
        'a',
        'b'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [a, b] = saved;
        const { transposeA: transposeA, transposeB: transposeB } = attrs;
        if (!transposeA && !transposeB) return {
            a: ()=>(0, $aUFou.matMul)(dy, b, false, true),
            b: ()=>(0, $aUFou.matMul)(a, dy, true, false)
        };
        else if (!transposeA && transposeB) return {
            a: ()=>(0, $aUFou.matMul)(dy, b, false, false),
            b: ()=>(0, $aUFou.matMul)(dy, a, true, false)
        };
        else if (transposeA && !transposeB) return {
            a: ()=>(0, $aUFou.matMul)(b, dy, false, true),
            b: ()=>(0, $aUFou.matMul)(a, dy, false, false)
        };
        else return {
            a: ()=>(0, $aUFou.matMul)(b, dy, true, true),
            b: ()=>(0, $aUFou.matMul)(dy, a, true, true)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $ePI8Y = parcelRequire("ePI8Y");
const $0f45e0ae0abc1a3c$export$b6582e1705c4f42d = {
    kernelName: (0, $hl418.BatchToSpaceND),
    gradFunc: (dy, saved, attrs)=>{
        const { blockShape: blockShape, crops: crops } = attrs;
        return {
            x: ()=>(0, $ePI8Y.spaceToBatchND)(dy, blockShape, crops)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $9NgTx = parcelRequire("9NgTx");
const $96da7667e2fb7a2d$export$1fc1d8b1fdae546a = {
    kernelName: (0, $hl418.BroadcastTo),
    gradFunc: (dy, saved, attrs)=>{
        const broadCastToAttrs = attrs;
        const inputShape = broadCastToAttrs.inputShape;
        const outputShape = broadCastToAttrs.shape;
        const reps = Array.from(outputShape);
        for(let i = inputShape.length - 1; i >= 0; i--){
            if (inputShape[i] === outputShape[i]) reps[i] = 1;
            else if (inputShape[i] !== 1) throw new Error(`broadcastTo(): [${inputShape}] cannot be broadcast to [${outputShape}].`);
        }
        const axes = [];
        for(let i = 0; i < reps.length; i++)if (reps[i] > 1) axes.push(i);
        return {
            x: ()=>(0, $9NgTx.sum)(dy, axes, true)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");
const $dcfa4e321c02cbc6$export$77a4f6320d798df2 = {
    kernelName: (0, $hl418.Cast),
    gradFunc: (dy)=>{
        return {
            x: ()=>dy.clone()
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $8EjnK = parcelRequire("8EjnK");
const $fc8c9416ddcd9d99$export$1789d8956379862a = {
    kernelName: (0, $hl418.Ceil),
    gradFunc: (dy)=>{
        // TODO(manrajgrover): Return null for gradients when backprop supports it.
        return {
            x: ()=>(0, $8EjnK.zerosLike)(dy)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $l0Zxl = parcelRequire("l0Zxl");

var $7LQ38 = parcelRequire("7LQ38");

var $kg1Wp = parcelRequire("kg1Wp");

var $l2P14 = parcelRequire("l2P14");

var $8EjnK = parcelRequire("8EjnK");
const $af4d1d593ac568df$export$3f1764b1eedfe2cb = {
    kernelName: (0, $hl418.ClipByValue),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x] = saved;
        const { clipValueMin: clipValueMin, clipValueMax: clipValueMax } = attrs;
        return {
            x: ()=>(0, $l2P14.where)((0, $kg1Wp.logicalAnd)((0, $l0Zxl.greaterEqual)(x, clipValueMin), (0, $7LQ38.lessEqual)(x, clipValueMax)), dy, (0, $8EjnK.zerosLike)(dy))
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

const $0e4da148ad506942$export$b8ff856642294896 = {
    kernelName: (0, $hl418.ComplexAbs),
    inputsToSave: [
        'x'
    ],
    gradFunc: (0, $16b3f81f6e835ccb$export$8311873a6069f3c6).gradFunc
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $9fmAX = parcelRequire("9fmAX");

var $8cCb2 = parcelRequire("8cCb2");
const $a38d450e94cb4b12$export$ddda159860ceb06e = {
    kernelName: (0, $hl418.Concat),
    saveAllInputs: true,
    gradFunc: (dy, saved, attrs)=>{
        const shapes = saved.map((t)=>t.shape);
        const { axis: axis } = attrs;
        const $axis = (0, $8cCb2.parseAxisParam)(axis, saved[0].shape)[0];
        const sizeSplits = shapes.map((s)=>s[$axis]);
        const derTensors = (0, $9fmAX.split)(dy, sizeSplits, $axis);
        return derTensors.map((t)=>()=>t);
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $4Tgmn = parcelRequire("4Tgmn");

var $6eptr = parcelRequire("6eptr");

var $frznq = parcelRequire("frznq");

var $8cCb2 = parcelRequire("8cCb2");
const $78881e9ce019c175$export$2fd622114dede0fc = {
    kernelName: (0, $hl418.Conv2D),
    inputsToSave: [
        'x',
        'filter'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x4D, $filter] = saved;
        const { dilations: dilations, strides: strides, pad: pad, dataFormat: dataFormat } = attrs;
        $8cCb2.assert($frznq.tupleValuesAreOne(dilations), ()=>'Error in gradient of conv2D: dilation rates greater than 1 ' + `are not yet supported in gradients. Got dilations '${dilations}'`);
        return {
            x: ()=>(0, $6eptr.conv2DBackpropInput)(x4D.shape, dy, $filter, strides, pad, dataFormat),
            filter: ()=>(0, $4Tgmn.conv2DBackpropFilter)(x4D, dy, $filter.shape, strides, pad, dataFormat)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $5Nkm1 = parcelRequire("5Nkm1");

var $4Tgmn = parcelRequire("4Tgmn");
const $fd2ffcfd5328d080$export$cdb8a95f3d598a0d = {
    kernelName: (0, $hl418.Conv2DBackpropInput),
    inputsToSave: [
        'dy',
        'filter'
    ],
    gradFunc: (ddx, saved, attrs)=>{
        const [dy, filter] = saved;
        const { strides: strides, pad: pad, dataFormat: dataFormat, dimRoundingMode: dimRoundingMode } = attrs;
        return {
            dy: ()=>(0, $5Nkm1.conv2d)(ddx, filter, strides, pad, dataFormat, 1 /* dilations */ , dimRoundingMode),
            filter: ()=>(0, $4Tgmn.conv2DBackpropFilter)(ddx, dy, filter.shape, strides, pad, dataFormat, dimRoundingMode)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $8cCb2 = parcelRequire("8cCb2");

var $jqSCG = parcelRequire("jqSCG");

var $4sqA7 = parcelRequire("4sqA7");
/**
 * Computes the derivative of the filter of a 3D convolution.
 *
 * @param x The input tensor, of rank 5 or rank 4 of shape
 *     [batch, depth, height, width, inChannels]. If rank 4, batch of 1 is
 *     assumed.
 * @param dy The dy image, of rank 5 or rank 4, of shape
 *     [batch, depth, height, width, outDepth]. If rank 4, batch of 1 is
 *     assumed.
 * @param filterShape The shape of the filter, length 5,
 *     [filterDepth, filterHeight, filterWidth, inDepth, outDepth].
 * @param strides The strides of the convolution: [strideDepth, strideHeight,
 * strideWidth].
 * @param pad A string from: 'same', 'valid'. The type of padding algorithm
 *     used in the forward prop of the op.
 */ function $51a6125254397b41$var$conv3DBackpropFilter_(x, dy, filterShape, strides, pad) {
    let x5D = x;
    if (x.rank === 4) x5D = (0, $4sqA7.reshape)(x, [
        1,
        x.shape[0],
        x.shape[1],
        x.shape[2],
        x.shape[3]
    ]);
    let dy5D = dy;
    if (dy5D.rank === 4) dy5D = (0, $4sqA7.reshape)(dy, [
        1,
        dy.shape[0],
        dy.shape[1],
        dy.shape[2],
        dy.shape[3]
    ]);
    $8cCb2.assert(x5D.rank === 5, ()=>`Error in conv3dDerFilter: input must be rank 5, but got shape ` + `${x5D.shape}.`);
    $8cCb2.assert(dy5D.rank === 5, ()=>`Error in conv3dDerFilter: dy must be rank 5, but got shape ` + `${dy5D.shape}.`);
    $8cCb2.assert(filterShape.length === 5, ()=>`Error in conv3dDerFilter: filterShape must be length 5, but got ` + `${filterShape}.`);
    $8cCb2.assert(x5D.shape[4] === filterShape[3], ()=>`Error in conv3dDerFilter: depth of input ${x5D.shape[4]}) must ` + `match input depth in filter (${filterShape[3]}.`);
    $8cCb2.assert(dy5D.shape[4] === filterShape[4], ()=>`Error in conv3dDerFilter: depth of dy (${dy5D.shape[4]}) must ` + `match output depth for filter (${filterShape[4]}).`);
    const inputs = {
        x: x5D,
        dy: dy5D
    };
    const attrs = {
        strides: strides,
        pad: pad,
        filterShape: filterShape
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.Conv3DBackpropFilterV2), inputs, attrs);
}
const $51a6125254397b41$export$6119875a1cee531e = /* @__PURE__ */ (0, $jqSCG.op)({
    conv3DBackpropFilter_: $51a6125254397b41$var$conv3DBackpropFilter_
});



var $AHZ4U = parcelRequire("AHZ4U");

var $frznq = parcelRequire("frznq");

var $8cCb2 = parcelRequire("8cCb2");
const $b7c6bf2d7d34b346$export$2456b335ba19aa7b = {
    kernelName: (0, $hl418.Conv3D),
    inputsToSave: [
        'x',
        'filter'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const { dilations: dilations, strides: strides, pad: pad } = attrs;
        $8cCb2.assert((0, $frznq.tupleValuesAreOne)(dilations), ()=>'Error in gradient of conv3D: dilation rates greater than 1 are ' + `not yet supported in gradients. Got dilations '${dilations}'`);
        const [x5D, $filter] = saved;
        return {
            x: ()=>(0, $AHZ4U.conv3DBackpropInput)(x5D.shape, dy, $filter, strides, pad),
            filter: ()=>(0, $51a6125254397b41$export$6119875a1cee531e)(x5D, dy, $filter.shape, strides, pad)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $inFmq = parcelRequire("inFmq");

var $jZc0w = parcelRequire("jZc0w");

var $15cGp = parcelRequire("15cGp");

var $4xqM7 = parcelRequire("4xqM7");
const $b072f3424ce545fe$export$fc646268baa57098 = {
    kernelName: (0, $hl418.Cos),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $jZc0w.mul)((0, $15cGp.neg)((0, $4xqM7.sin)((0, $inFmq.cast)(x, 'float32'))), dy)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $inFmq = parcelRequire("inFmq");

var $jZc0w = parcelRequire("jZc0w");

var $fAOzm = parcelRequire("fAOzm");
const $4f2c5ffd0bea16e5$export$bcde595585c16638 = {
    kernelName: (0, $hl418.Cosh),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $jZc0w.mul)((0, $fAOzm.sinh)((0, $inFmq.cast)(x, 'float32')), dy)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $kTunp = parcelRequire("kTunp");

var $7lqwF = parcelRequire("7lqwF");

var $aDHKy = parcelRequire("aDHKy");
const $2aa441de0118cd33$export$9f1ba0cc8e88cb76 = {
    kernelName: (0, $hl418.Cumsum),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x] = saved;
        const { axis: axis, exclusive: exclusive, reverse: reverse } = attrs;
        return {
            x: ()=>{
                const permutation = (0, $kTunp.getAxesPermutation)([
                    axis
                ], x.rank);
                let out = (0, $7lqwF.cumsum)(dy, axis, exclusive, !reverse);
                if (permutation != null) out = (0, $aDHKy.transpose)(out, permutation);
                return out;
            }
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $frznq = parcelRequire("frznq");

var $j2Gyr = parcelRequire("j2Gyr");

var $1C2e1 = parcelRequire("1C2e1");

var $8cCb2 = parcelRequire("8cCb2");
const $8f577a148fb4dc15$export$66192798aa3d6196 = {
    kernelName: (0, $hl418.DepthwiseConv2dNative),
    inputsToSave: [
        'x',
        'filter'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const { dilations: dilations, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
        const $dilations = dilations == null ? [
            1,
            1
        ] : dilations;
        $8cCb2.assert($frznq.tupleValuesAreOne($dilations), ()=>'Error in gradient of depthwiseConv2dNative: dilation rates ' + `greater than 1 are not yet supported. Got dilations ` + `'${$dilations}'`);
        const [x, filter] = saved;
        $8cCb2.assert(x.rank === 4, ()=>`Error in gradient of depthwiseConv2dNative: input must be ` + `rank 4, but got rank ${x.rank}.`);
        $8cCb2.assert(filter.rank === 4, ()=>`Error in gradient of depthwiseConv2dNative: filter must be ` + `rank 4, but got rank ${filter.rank}.`);
        $8cCb2.assert(x.shape[3] === filter.shape[2], ()=>`Error in gradient of depthwiseConv2d: number of input ` + `channels (${x.shape[3]}) must match the inChannels dimension ` + `in filter ${filter.shape[2]}.`);
        $8cCb2.assert($frznq.eitherStridesOrDilationsAreOne(strides, $dilations), ()=>'Error in gradient of depthwiseConv2d: Either strides or ' + `dilations must be  1. Got strides ${strides} and dilations ` + `'${$dilations}'.`);
        $frznq.checkPadOnDimRoundingMode('depthwiseConv2d', pad, dimRoundingMode);
        return {
            x: ()=>(0, $1C2e1.depthwiseConv2dNativeBackpropInput)(x.shape, dy, filter, strides, pad, $dilations, dimRoundingMode),
            filter: ()=>(0, $j2Gyr.depthwiseConv2dNativeBackpropFilter)(x, dy, filter.shape, strides, pad, $dilations, dimRoundingMode)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");
const $f7b40b8415be55d0$export$3d2aed5cf11b13ba = {
    kernelName: (0, $hl418.Dilation2D),
    inputsToSave: [
        'x',
        'filter'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x, filter] = saved;
        const inputInputs = {
            x: x,
            filter: filter,
            dy: dy
        };
        const filterInputs = {
            x: x,
            filter: filter,
            dy: dy
        };
        return {
            x: ()=>(0, $38WwN.ENGINE).runKernel((0, $hl418.Dilation2DBackpropInput), inputInputs, attrs),
            filter: ()=>(0, $38WwN.ENGINE).runKernel((0, $hl418.Dilation2DBackpropFilter), filterInputs, attrs)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");
const $335df656b9a24fdd$export$59bb07dd04647a1d = {
    kernelName: (0, $hl418.Elu),
    outputsToSave: [
        true
    ],
    gradFunc: (dy, saved)=>{
        const [y] = saved;
        const inputs = {
            dy: dy,
            y: y
        };
        return {
            x: ()=>(0, $38WwN.ENGINE).runKernel((0, $hl418.EluGrad), inputs)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $2PcQK = parcelRequire("2PcQK");

var $jZc0w = parcelRequire("jZc0w");

var $15cGp = parcelRequire("15cGp");

var $iDd8d = parcelRequire("iDd8d");
const $f757cdc63fe9f758$export$80bb9a361ec8d601 = {
    kernelName: (0, $hl418.Erf),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        const a = (0, $jZc0w.mul)((0, $2PcQK.exp)((0, $15cGp.neg)((0, $iDd8d.square)(x))), 2 / Math.sqrt(Math.PI));
        return {
            x: ()=>(0, $jZc0w.mul)(dy, a)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $jZc0w = parcelRequire("jZc0w");
const $fd72fd91250c8bce$export$e3362b875cf81ebc = {
    kernelName: (0, $hl418.Exp),
    outputsToSave: [
        true
    ],
    gradFunc: (dy, saved)=>{
        const [y] = saved;
        return {
            x: ()=>(0, $jZc0w.mul)(dy, y)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $4sqA7 = parcelRequire("4sqA7");
const $e590481eef288d43$export$27394e9fa8330490 = {
    kernelName: (0, $hl418.ExpandDims),
    inputsToSave: [
        'input'
    ],
    gradFunc: (dy, saved)=>{
        const [input] = saved;
        return {
            input: ()=>(0, $4sqA7.reshape)(dy, input.shape)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $2PcQK = parcelRequire("2PcQK");

var $jZc0w = parcelRequire("jZc0w");
const $0a67a90fdf6f1af1$export$758f509582468c75 = {
    kernelName: (0, $hl418.Expm1),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $jZc0w.mul)(dy, (0, $2PcQK.exp)(x))
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $8EjnK = parcelRequire("8EjnK");
const $026c20739f202e7e$export$2a943001dbfa8fd1 = {
    kernelName: (0, $hl418.Floor),
    gradFunc: (dy)=>{
        return {
            x: ()=>(0, $8EjnK.zerosLike)(dy)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $8BaGO = parcelRequire("8BaGO");

var $inFmq = parcelRequire("inFmq");

var $1QPqB = parcelRequire("1QPqB");

var $jZc0w = parcelRequire("jZc0w");

var $15cGp = parcelRequire("15cGp");

var $4sqA7 = parcelRequire("4sqA7");

var $iDd8d = parcelRequire("iDd8d");

var $9NgTx = parcelRequire("9NgTx");
const $b6dd29b4aaeec0af$export$1f5798c5c4ca3f10 = {
    kernelName: (0, $hl418.FloorDiv),
    inputsToSave: [
        'a',
        'b'
    ],
    gradFunc: (dy, saved)=>{
        const [a, b] = saved;
        const outShape = (0, $8BaGO.assertAndGetBroadcastShape)(a.shape, b.shape);
        const derA = ()=>{
            const res = (0, $1QPqB.div)(dy, (0, $inFmq.cast)(b, 'float32'));
            const reduceAxes = (0, $8BaGO.getReductionAxes)(a.shape, outShape);
            if (reduceAxes.length > 0) return (0, $4sqA7.reshape)((0, $9NgTx.sum)(res, reduceAxes), a.shape);
            return res;
        };
        const derB = ()=>{
            let res = (0, $jZc0w.mul)(dy, (0, $inFmq.cast)(a, 'float32'));
            const reduceAxes = (0, $8BaGO.getReductionAxes)(b.shape, outShape);
            if (reduceAxes.length > 0) res = (0, $4sqA7.reshape)((0, $9NgTx.sum)(res, reduceAxes), b.shape);
            const tmp = (0, $iDd8d.square)(b);
            return (0, $15cGp.neg)((0, $1QPqB.div)(res, (0, $inFmq.cast)(tmp, 'float32')));
        };
        return {
            a: derA,
            b: derB
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $hgacW = parcelRequire("hgacW");

var $8BaGO = parcelRequire("8BaGO");

var $jZc0w = parcelRequire("jZc0w");

var $4sqA7 = parcelRequire("4sqA7");

var $5pj7R = parcelRequire("5pj7R");

var $3xp7o = parcelRequire("3xp7o");

var $7kouu = parcelRequire("7kouu");

var $9NgTx = parcelRequire("9NgTx");

var $61ay4 = parcelRequire("61ay4");
const $8f2035325d395bd9$export$3b83e7a588d720e9 = {
    kernelName: (0, $hl418.FusedBatchNorm),
    inputsToSave: [
        'x',
        'mean',
        'variance',
        'scale'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const { varianceEpsilon: varianceEpsilon } = attrs;
        const [x, mean, variance, scale] = saved;
        const scaleValue = scale == null ? (0, $3xp7o.scalar)(1) : scale;
        const reductionAxes = (0, $8BaGO.getReductionAxes)(mean.shape, x.shape);
        const tileShape = [];
        if (mean.rank === 1) {
            for(let i = 0; i < x.shape.length - 1; ++i)tileShape.push(x.shape[i]);
            tileShape.push(1);
        }
        const xMinusMean = (0, $7kouu.sub)(x, mean);
        const dyTimesScaleValue = (0, $jZc0w.mul)(dy, scaleValue);
        const oneOverSqrtVariance = (0, $5pj7R.rsqrt)((0, $hgacW.add)(variance, (0, $3xp7o.scalar)(varianceEpsilon)));
        const minusHalfRCube = (0, $jZc0w.mul)((0, $jZc0w.mul)((0, $jZc0w.mul)(oneOverSqrtVariance, oneOverSqrtVariance), oneOverSqrtVariance), (0, $3xp7o.scalar)(-0.5));
        const derX = ()=>{
            if (mean.rank === 1) return (0, $4sqA7.reshape)((0, $jZc0w.mul)((0, $jZc0w.mul)(dy, (0, $61ay4.tile)((0, $4sqA7.reshape)(oneOverSqrtVariance, [
                1,
                1,
                1,
                mean.shape[0]
            ]), tileShape)), scaleValue), x.shape);
            else return (0, $4sqA7.reshape)((0, $jZc0w.mul)((0, $jZc0w.mul)(dy, oneOverSqrtVariance), scaleValue), x.shape);
        };
        const derMean = ()=>{
            let meanDer = (0, $jZc0w.mul)((0, $jZc0w.mul)(oneOverSqrtVariance, (0, $3xp7o.scalar)(-1)), dyTimesScaleValue);
            if (mean.rank === 1) meanDer = (0, $9NgTx.sum)(meanDer, reductionAxes);
            return (0, $4sqA7.reshape)(meanDer, mean.shape);
        };
        const derVariance = ()=>{
            let varianceDer = (0, $jZc0w.mul)((0, $jZc0w.mul)(minusHalfRCube, xMinusMean), dyTimesScaleValue);
            if (mean.rank === 1) varianceDer = (0, $9NgTx.sum)(varianceDer, reductionAxes);
            return (0, $4sqA7.reshape)(varianceDer, mean.shape);
        };
        const derScale = ()=>{
            const xMinusMean2TimesRsqrt = (0, $jZc0w.mul)(xMinusMean, oneOverSqrtVariance);
            let scaleDer = (0, $jZc0w.mul)(dy, xMinusMean2TimesRsqrt);
            if (mean.rank === 1) scaleDer = (0, $9NgTx.sum)(scaleDer, reductionAxes);
            return (0, $4sqA7.reshape)(scaleDer, mean.shape);
        };
        const derOffset = ()=>{
            let offsetDer = dy;
            if (mean.rank === 1) offsetDer = (0, $9NgTx.sum)(offsetDer, reductionAxes);
            return (0, $4sqA7.reshape)(offsetDer, mean.shape);
        };
        return {
            x: derX,
            mean: derMean,
            variance: derVariance,
            scale: derScale,
            offset: derOffset
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $kTunp = parcelRequire("kTunp");

var $4sqA7 = parcelRequire("4sqA7");

var $8BrLX = parcelRequire("8BrLX");

var $aDHKy = parcelRequire("aDHKy");

var $djGEF = parcelRequire("djGEF");

var $8cCb2 = parcelRequire("8cCb2");
const $e16960b683502aa3$export$793739cdccafd2d1 = {
    kernelName: (0, $hl418.GatherV2),
    inputsToSave: [
        'x',
        'indices'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x, indices] = saved;
        const { axis: axis, batchDims: batchDims } = attrs;
        const parsedAxis = (0, $8cCb2.parseAxisParam)(axis, x.shape)[0];
        const derXBatch = (x, indices, dy)=>{
            return ()=>{
                const paramsShape = x.shape;
                const indicesSize = indices.size;
                const outerShape = paramsShape.slice(0, parsedAxis);
                const outerDims = outerShape.length;
                const innerShape = paramsShape.slice(axis, paramsShape.length).slice(1);
                const innerDims = innerShape.length;
                const outerAxesIndices = $e16960b683502aa3$var$arrayRange(0, outerDims);
                const innerAxesIndices = $e16960b683502aa3$var$arrayRange(outerDims + 1, outerDims + 1 + innerDims);
                const valuesShape = $e16960b683502aa3$var$arrayConcat([
                    outerShape,
                    [
                        indicesSize
                    ],
                    innerShape
                ]);
                const values = (0, $4sqA7.reshape)(dy, valuesShape);
                const reshapedIndices = (0, $4sqA7.reshape)(indices, [
                    indicesSize
                ]);
                const transposeDims = $e16960b683502aa3$var$arrayConcat([
                    [
                        outerDims
                    ],
                    outerAxesIndices,
                    innerAxesIndices
                ]);
                const valuesTranspose = (0, $aDHKy.transpose)(values, transposeDims);
                let paramsGrad = (0, $djGEF.unsortedSegmentSum)(valuesTranspose, reshapedIndices, x.shape[parsedAxis]);
                const invertTransposeDims = (0, $kTunp.getUndoAxesPermutation)(transposeDims);
                paramsGrad = (0, $aDHKy.transpose)(paramsGrad, invertTransposeDims);
                return paramsGrad;
            };
        };
        if (batchDims === 1) {
            const batchSize = x.shape[0];
            const xBatch = x.split(batchSize, 0);
            const derXBatched = ()=>{
                const stacked = (0, $8BrLX.stack)(xBatch.map((x, i)=>{
                    return derXBatch(x, indices.slice(i, 1), dy.slice(i, 1))();
                }));
                return stacked.reshape(x.shape);
            };
            return {
                x: derXBatched,
                indices: ()=>indices
            };
        } else return {
            x: derXBatch(x, indices, dy),
            indices: ()=>indices
        };
    }
};
function $e16960b683502aa3$var$arrayRange(start, stop) {
    const result = [];
    for(let i = start; i < stop; ++i)result.push(i);
    return result;
}
function $e16960b683502aa3$var$arrayConcat(arrays) {
    const result = [];
    for(let i = 0; i < arrays.length; ++i)for(let j = 0; j < arrays[i].length; ++j)result.push(arrays[i][j]);
    return result;
}


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $8EjnK = parcelRequire("8EjnK");
const $065131d780336c97$export$fba648816411e438 = {
    kernelName: (0, $hl418.GreaterEqual),
    inputsToSave: [
        'a',
        'b'
    ],
    gradFunc: (dy, saved)=>{
        const [a, b] = saved;
        return {
            a: ()=>(0, $8EjnK.zerosLike)(a),
            b: ()=>(0, $8EjnK.zerosLike)(b)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $inFmq = parcelRequire("inFmq");
const $213f2721fd34b65c$export$bddb155b34767c3a = {
    kernelName: (0, $hl418.Identity),
    gradFunc: (dy)=>{
        return {
            x: ()=>(0, $inFmq.cast)(dy, 'float32')
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $8EjnK = parcelRequire("8EjnK");
const $d5d13e7c5ccb0cc8$export$108f33db0f535e77 = {
    kernelName: (0, $hl418.IsFinite),
    gradFunc: (dy)=>{
        // TODO(nsthorat): Let gradients be null for cases where we want to stop
        // backpropgation.
        return {
            x: ()=>(0, $8EjnK.zerosLike)(dy)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $8EjnK = parcelRequire("8EjnK");
const $2a05110eaea550ef$export$af7d3cc575a3d37d = {
    kernelName: (0, $hl418.IsInf),
    gradFunc: (dy)=>{
        // TODO(nsthorat): Let gradients be null for cases where we want to stop
        // backpropgation.
        return {
            x: ()=>(0, $8EjnK.zerosLike)(dy)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $8EjnK = parcelRequire("8EjnK");
const $f23fa02982844776$export$a2997336d9064f51 = {
    kernelName: (0, $hl418.IsNan),
    gradFunc: (dy)=>{
        // TODO(nsthorat): Let gradients be null for cases where we want to stop
        // backpropgation.
        return {
            x: ()=>(0, $8EjnK.zerosLike)(dy)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $bRRKf = parcelRequire("bRRKf");

var $jZc0w = parcelRequire("jZc0w");

var $l2P14 = parcelRequire("l2P14");
const $c3082ed837b873c5$export$8aba4169a7423780 = {
    kernelName: (0, $hl418.LeakyRelu),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x] = saved;
        const { alpha: alpha } = attrs;
        const mask = (0, $bRRKf.greater)(x, 0);
        // Returns `gradients * (features > 0) + alpha * gradients * (features <=
        // 0)`.
        return {
            x: ()=>(0, $l2P14.where)(mask, dy, (0, $jZc0w.mul)(dy, alpha))
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $hgacW = parcelRequire("hgacW");

var $1QPqB = parcelRequire("1QPqB");
const $adac90ba519e0f93$export$2a0e1acd37a49488 = {
    kernelName: (0, $hl418.Log1p),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $1QPqB.div)(dy, (0, $hgacW.add)(x, 1))
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $inFmq = parcelRequire("inFmq");

var $1QPqB = parcelRequire("1QPqB");
const $89b496877029f4af$export$a6f98c34c79ddc6c = {
    kernelName: (0, $hl418.Log),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $1QPqB.div)(dy, (0, $inFmq.cast)(x, 'float32'))
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $2PcQK = parcelRequire("2PcQK");

var $jZc0w = parcelRequire("jZc0w");

var $7kouu = parcelRequire("7kouu");

var $9NgTx = parcelRequire("9NgTx");
const $accfa3a1cfb3ba7d$export$556818e7703f08a6 = {
    kernelName: (0, $hl418.LogSoftmax),
    inputsToSave: [],
    outputsToSave: [
        true
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [value] = saved;
        const { axis: axis } = attrs;
        return {
            logits: ()=>{
                const keepDims = true;
                const softmax = (0, $2PcQK.exp)(value);
                return (0, $7kouu.sub)(dy, (0, $jZc0w.mul)((0, $9NgTx.sum)(dy, axis, keepDims), softmax));
            }
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $jqSCG = parcelRequire("jqSCG");
function $f4d44c8f6724f869$var$localResponseNormalizationBackprop_(x, y, dy, depthRadius = 5, bias = 1, alpha = 1, beta = 0.5) {
    const inputs = {
        x: x,
        y: y,
        dy: dy
    };
    const attrs = {
        depthRadius: depthRadius,
        bias: bias,
        alpha: alpha,
        beta: beta
    };
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.LRNGrad), inputs, attrs);
}
const $f4d44c8f6724f869$export$855c82875e6b50cd = (0, $jqSCG.op)({
    localResponseNormalizationBackprop_: $f4d44c8f6724f869$var$localResponseNormalizationBackprop_
});


const $ad71facd2d26f201$export$9250622395b66a34 = {
    kernelName: (0, $hl418.LRN),
    inputsToSave: [
        'x'
    ],
    outputsToSave: [
        true
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x, y] = saved;
        const { depthRadius: depthRadius, bias: bias, alpha: alpha, beta: beta } = attrs;
        return {
            x: ()=>(0, $f4d44c8f6724f869$export$855c82875e6b50cd)(x, y, dy, depthRadius, bias, alpha, beta)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $8cCb2 = parcelRequire("8cCb2");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $kTunp = parcelRequire("kTunp");

var $inFmq = parcelRequire("inFmq");

var $7R9HC = parcelRequire("7R9HC");

var $jZc0w = parcelRequire("jZc0w");

var $4sqA7 = parcelRequire("4sqA7");
function $89b2a8a3d345321a$export$c166528825895f87(dy, y, xOrig, origAxes) {
    if (y.rank < xOrig.rank) y = (0, $4sqA7.reshape)(y, $kTunp.expandShapeToKeepDim(y.shape, origAxes));
    if (dy.rank < xOrig.rank) dy = (0, $4sqA7.reshape)(dy, $kTunp.expandShapeToKeepDim(dy.shape, origAxes));
    return {
        x: ()=>{
            const dx = (0, $jZc0w.mul)(dy, (0, $inFmq.cast)((0, $7R9HC.equal)(xOrig, y), dy.dtype));
            return dx;
        }
    };
}


const $c7dcffda09f32f55$export$c8c367f50d71c477 = {
    kernelName: (0, $hl418.Max),
    inputsToSave: [
        'x'
    ],
    outputsToSave: [
        true
    ],
    gradFunc: (dy, saved, attrs)=>{
        const maxAttrs = attrs;
        const { reductionIndices: reductionIndices } = maxAttrs;
        const x = saved[0];
        const y = saved[1];
        const origAxes = $8cCb2.parseAxisParam(reductionIndices, x.shape);
        const maxGrad = (0, $89b2a8a3d345321a$export$c166528825895f87)(dy, y, x, origAxes);
        return {
            x: ()=>{
                return maxGrad['x']();
            }
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $inFmq = parcelRequire("inFmq");

var $l0Zxl = parcelRequire("l0Zxl");

var $jTDVJ = parcelRequire("jTDVJ");

var $jZc0w = parcelRequire("jZc0w");
const $32876797c927a598$export$b394285cea805997 = {
    kernelName: (0, $hl418.Maximum),
    inputsToSave: [
        'a',
        'b'
    ],
    gradFunc: (dy, saved)=>{
        const [a, b] = saved;
        const derA = ()=>(0, $jZc0w.mul)(dy, (0, $inFmq.cast)((0, $l0Zxl.greaterEqual)(a, b), 'float32'));
        const derB = ()=>(0, $jZc0w.mul)(dy, (0, $inFmq.cast)((0, $jTDVJ.less)(a, b), 'float32'));
        return {
            a: derA,
            b: derB
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $frznq = parcelRequire("frznq");

var $jqSCG = parcelRequire("jqSCG");

var $4sqA7 = parcelRequire("4sqA7");
/**
 * Computes the backprop of a 3d max pool.
 *
 * @param dy The dy error, of rank 5 of shape
 *     [batchSize, depth, height, width, channels].
 * assumed.
 * @param input The original input image, of rank 5 or rank 4 of shape
 *     [batchSize, depth, height, width, channels].
 * @param output The original output image, of rank 5 of shape
 *     [batchSize, outDepth, outHeight, outWidth, channels].
 * @param filterSize The filter size:
 *     `[filterDepth, filterHeight, filterWidth]`.
 *     `filterSize` is a single number,
 *     then `filterDepth == filterHeight == filterWidth`.
 * @param strides The strides of the pooling:
 *     `[strideDepth, strideHeight, strideWidth]`. If
 *     `strides` is a single number, then `strideHeight == strideWidth`.
 * @param pad A string from: 'same', 'valid'. The type of padding algorithm
 *     used in the forward prop of the op.
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 */ function $d753257ec04095c2$var$maxPool3dGrad_(dy, input, output, filterSize, strides, pad, dimRoundingMode) {
    const $dy = (0, $5xBLk.convertToTensor)(dy, 'dy', 'maxPool3dGrad');
    const $input = (0, $5xBLk.convertToTensor)(input, 'input', 'maxPool3dGrad');
    const $output = (0, $5xBLk.convertToTensor)(output, 'output', 'maxPool3dGrad');
    let dy5D = $dy;
    let input5D = $input;
    let output5D = $output;
    let reshapedTo5D = false;
    if ($input.rank === 4) {
        reshapedTo5D = true;
        dy5D = (0, $4sqA7.reshape)($dy, [
            1,
            $dy.shape[0],
            $dy.shape[1],
            $dy.shape[2],
            $dy.shape[3]
        ]);
        input5D = (0, $4sqA7.reshape)($input, [
            1,
            $input.shape[0],
            $input.shape[1],
            $input.shape[2],
            $input.shape[3]
        ]);
        output5D = (0, $4sqA7.reshape)($output, [
            1,
            $output.shape[0],
            $output.shape[1],
            $output.shape[2],
            $output.shape[3]
        ]);
    }
    $8cCb2.assert(dy5D.rank === 5, ()=>`Error in maxPool3dGrad: dy must be rank 5 but got rank ` + `${dy5D.rank}.`);
    $8cCb2.assert(input5D.rank === 5, ()=>`Error in maxPool3dGrad: input must be rank 5 but got rank ` + `${input5D.rank}.`);
    $8cCb2.assert(output5D.rank === 5, ()=>`Error in maxPool3dGrad: output must be rank 5 but got rank ` + `${output5D.rank}.`);
    (0, $frznq.checkPadOnDimRoundingMode)('maxPool3dGrad', pad, dimRoundingMode);
    const inputs = {
        dy: dy5D,
        input: input5D,
        output: output5D
    };
    const attrs = {
        filterSize: filterSize,
        strides: strides,
        pad: pad,
        dimRoundingMode: dimRoundingMode
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $38WwN.ENGINE).runKernel((0, $hl418.MaxPool3DGrad), inputs, attrs);
    if (reshapedTo5D) return (0, $4sqA7.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3],
        res.shape[4]
    ]);
    return res;
}
const $d753257ec04095c2$export$aa5e236dfd3a66ef = /* @__PURE__ */ (0, $jqSCG.op)({
    maxPool3dGrad_: $d753257ec04095c2$var$maxPool3dGrad_
});


const $44f7090a30c7cbd5$export$5201426bb10bd5eb = {
    kernelName: (0, $hl418.MaxPool3D),
    inputsToSave: [
        'x'
    ],
    outputsToSave: [
        true
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x, y] = saved;
        const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
        return {
            x: ()=>(0, $d753257ec04095c2$export$aa5e236dfd3a66ef)(dy, x, y, filterSize, strides, pad, dimRoundingMode)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");

var $5xBLk = parcelRequire("5xBLk");

var $8cCb2 = parcelRequire("8cCb2");

var $frznq = parcelRequire("frznq");

var $jqSCG = parcelRequire("jqSCG");
/**
 * Computes the backprop of a 2D max pool.
 *
 * @param dy The dy error, of rank 4 or rank 3 of shape
 *     [batchSize, height, width, channels]. If rank 3, batch of 1 is
 * assumed.
 * @param input The original input image, of rank 4, of shape
 *     [batchSize, height, width, channels].
 * @param output The original output image, of rank 4, of shape
 *     [batchSize, outHeight, outWidth, channels].
 * @param filterSize The filter size: `[filterHeight, filterWidth]`. If
 *     `filterSize` is a single number, then `filterHeight == filterWidth`.
 * @param strides The strides of the pooling: `[strideHeight, strideWidth]`. If
 *     `strides` is a single number, then `strideHeight == strideWidth`.
 * @param pad The type of padding algorithm used in the forward prop of the op.
 *     'same', 'valid', for more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 */ function $e012cebe185e229d$var$maxPoolGrad_(dy, input, output, filterSize, strides, pad, dimRoundingMode) {
    const $dy = (0, $5xBLk.convertToTensor)(dy, 'dy', 'maxPoolGrad');
    const $input = (0, $5xBLk.convertToTensor)(input, 'input', 'maxPoolGrad');
    const $output = (0, $5xBLk.convertToTensor)(output, 'output', 'maxPoolGrad');
    $8cCb2.assert($input.rank === $dy.rank, ()=>`Rank of input (${$input.rank}) does not match rank of dy ` + `(${$dy.rank})`);
    $8cCb2.assert($dy.rank === 4, ()=>`Error in maxPoolGrad: dy must be rank 4 but got rank ` + `${$dy.rank}.`);
    $8cCb2.assert($input.rank === 4, ()=>`Error in maxPoolGrad: input must be rank 4 but got rank ` + `${$input.rank}.`);
    $frznq.checkPadOnDimRoundingMode('maxPoolGrad', pad, dimRoundingMode);
    const inputs = {
        dy: $dy,
        input: $input,
        output: $output
    };
    const attrs = {
        filterSize: filterSize,
        strides: strides,
        pad: pad,
        dimRoundingMode: dimRoundingMode
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    return (0, $38WwN.ENGINE).runKernel((0, $hl418.MaxPoolGrad), inputs, attrs);
}
const $e012cebe185e229d$export$85dfd1121f049514 = /* @__PURE__ */ (0, $jqSCG.op)({
    maxPoolGrad_: $e012cebe185e229d$var$maxPoolGrad_
});


const $52ed693396405b71$export$e01a7f8dbee29127 = {
    kernelName: (0, $hl418.MaxPool),
    inputsToSave: [
        'x'
    ],
    outputsToSave: [
        true
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x, y] = saved;
        const { filterSize: filterSize, strides: strides, pad: pad } = attrs;
        return {
            x: ()=>(0, $e012cebe185e229d$export$85dfd1121f049514)(dy, x, y, filterSize, strides, pad)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $kTunp = parcelRequire("kTunp");

var $1QPqB = parcelRequire("1QPqB");

var $jZc0w = parcelRequire("jZc0w");

var $fOBRA = parcelRequire("fOBRA");

var $4sqA7 = parcelRequire("4sqA7");

var $8cCb2 = parcelRequire("8cCb2");
const $340ba42e0ddb0098$export$ac394d88e62d3236 = {
    kernelName: (0, $hl418.Mean),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x] = saved;
        const { axis: axis } = attrs;
        const axes = $8cCb2.parseAxisParam(axis, x.shape);
        const shapes = (0, $kTunp.computeOutAndReduceShapes)(x.shape, axes);
        const reduceShape = shapes[1];
        const reduceSize = $8cCb2.sizeFromShape(reduceShape);
        const derX = ()=>{
            const expandedDyShape = x.shape.slice();
            axes.forEach((axis)=>{
                expandedDyShape[axis] = 1;
            });
            const expandedDy = (0, $4sqA7.reshape)(dy, expandedDyShape);
            const res = (0, $1QPqB.div)((0, $jZc0w.mul)(expandedDy, (0, $fOBRA.ones)(x.shape, 'float32')), reduceSize);
            return res;
        };
        return {
            x: derX
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $8cCb2 = parcelRequire("8cCb2");

const $fb4dcb6e8ced730e$export$414be41faed05c5f = {
    kernelName: (0, $hl418.Min),
    inputsToSave: [
        'x'
    ],
    outputsToSave: [
        true
    ],
    gradFunc: (dy, saved, attrs)=>{
        const minAttrs = attrs;
        const { axis: axis } = minAttrs;
        const [x, y] = saved;
        const origAxes = $8cCb2.parseAxisParam(axis, x.shape);
        const minGrad = (0, $89b2a8a3d345321a$export$c166528825895f87)(dy, y, x, origAxes);
        return {
            x: ()=>{
                return minGrad['x']();
            }
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $inFmq = parcelRequire("inFmq");

var $bRRKf = parcelRequire("bRRKf");

var $7LQ38 = parcelRequire("7LQ38");

var $jZc0w = parcelRequire("jZc0w");
const $89735e320c3c4c06$export$6c859b9b59a13286 = {
    kernelName: (0, $hl418.Minimum),
    inputsToSave: [
        'a',
        'b'
    ],
    gradFunc: (dy, saved)=>{
        const [a, b] = saved;
        const derA = ()=>(0, $jZc0w.mul)(dy, (0, $inFmq.cast)((0, $7LQ38.lessEqual)(a, b), 'float32'));
        const derB = ()=>(0, $jZc0w.mul)(dy, (0, $inFmq.cast)((0, $bRRKf.greater)(a, b), 'float32'));
        return {
            a: derA,
            b: derB
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $79KOG = parcelRequire("79KOG");
const $b041387a418bdb37$export$83a1d4320d554b59 = {
    kernelName: (0, $hl418.MirrorPad),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved, attrs)=>{
        // Pad introduces values around the original tensor, so the gradient
        // slices the original shape out of the gradient.
        const x = saved[0];
        const { paddings: paddings } = attrs;
        const begin = paddings.map((p)=>p[0]);
        return {
            x: ()=>(0, $79KOG.slice)(dy, begin, x.shape)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $8BaGO = parcelRequire("8BaGO");

var $1QPqB = parcelRequire("1QPqB");

var $4ZUCz = parcelRequire("4ZUCz");

var $jZc0w = parcelRequire("jZc0w");

var $15cGp = parcelRequire("15cGp");

var $4sqA7 = parcelRequire("4sqA7");

var $9NgTx = parcelRequire("9NgTx");
const $d29217a57daf0c25$export$6ef350a1f32ed6e2 = {
    kernelName: (0, $hl418.Mod),
    inputsToSave: [
        'a',
        'b'
    ],
    gradFunc: (dy, saved)=>{
        const [a, b] = saved;
        const outShape = (0, $8BaGO.assertAndGetBroadcastShape)(a.shape, b.shape);
        const derA = ()=>{
            const reduceAxes = (0, $8BaGO.getReductionAxes)(a.shape, outShape);
            if (reduceAxes.length > 0) return (0, $4sqA7.reshape)((0, $9NgTx.sum)(dy, reduceAxes), a.shape);
            return dy;
        };
        const derB = ()=>{
            const res = (0, $jZc0w.mul)(dy, (0, $15cGp.neg)((0, $4ZUCz.floor)((0, $1QPqB.div)(a, b))));
            const reduceAxes = (0, $8BaGO.getReductionAxes)(b.shape, outShape);
            if (reduceAxes.length > 0) return (0, $4sqA7.reshape)((0, $9NgTx.sum)(res, reduceAxes), b.shape);
            return res;
        };
        return {
            a: derA,
            b: derB
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $8BaGO = parcelRequire("8BaGO");

var $inFmq = parcelRequire("inFmq");

var $jZc0w = parcelRequire("jZc0w");

var $4sqA7 = parcelRequire("4sqA7");

var $9NgTx = parcelRequire("9NgTx");
const $1b71026463fc74f9$export$13098dd2211fc557 = {
    kernelName: (0, $hl418.Multiply),
    inputsToSave: [
        'a',
        'b'
    ],
    gradFunc: (dy, saved)=>{
        const [a, b] = saved;
        const outShape = (0, $8BaGO.assertAndGetBroadcastShape)(a.shape, b.shape);
        const derA = ()=>{
            const res = (0, $jZc0w.mul)(dy, (0, $inFmq.cast)(b, 'float32'));
            const reduceAxes = (0, $8BaGO.getReductionAxes)(a.shape, outShape);
            if (reduceAxes.length > 0) return (0, $4sqA7.reshape)((0, $9NgTx.sum)(res, reduceAxes), a.shape);
            return res;
        };
        const derB = ()=>{
            const res = (0, $jZc0w.mul)(dy, (0, $inFmq.cast)(a, 'float32'));
            const reduceAxes = (0, $8BaGO.getReductionAxes)(b.shape, outShape);
            if (reduceAxes.length > 0) return (0, $4sqA7.reshape)((0, $9NgTx.sum)(res, reduceAxes), b.shape);
            return res;
        };
        return {
            a: derA,
            b: derB
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $15cGp = parcelRequire("15cGp");
const $abe23bdf32b4ba6a$export$9c8adee9ba64cfc3 = {
    kernelName: (0, $hl418.Neg),
    gradFunc: (dy)=>{
        return {
            x: ()=>(0, $15cGp.neg)(dy)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $hxi4c = parcelRequire("hxi4c");
const $064328644082f372$export$fec82556b8ba1992 = {
    kernelName: (0, $hl418.OneHot),
    inputsToSave: [
        'indices'
    ],
    gradFunc: (dy, saved)=>{
        const indices = saved[0];
        return {
            indices: ()=>(0, $hxi4c.zeros)(indices.shape, 'float32')
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $8EjnK = parcelRequire("8EjnK");
const $69ce364be1660162$export$693d483aaf035f85 = {
    kernelName: (0, $hl418.OnesLike),
    gradFunc: (dy)=>{
        return {
            x: ()=>(0, $8EjnK.zerosLike)(dy)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $gBOC6 = parcelRequire("gBOC6");
const $99f792b2a0ad46a5$export$2deaaffbc5347dbd = {
    kernelName: (0, $hl418.Pack),
    saveAllInputs: true,
    gradFunc: (dy, saved, attrs)=>{
        const { axis: axis } = attrs;
        const derTensors = (0, $gBOC6.unstack)(dy, axis);
        return derTensors.map((t)=>()=>t);
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $79KOG = parcelRequire("79KOG");
const $fb7817d456d5918d$export$beb610947bf972b5 = {
    kernelName: (0, $hl418.PadV2),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved, attrs)=>{
        // Pad introduces values around the original tensor, so the gradient
        // slices the original shape out of the gradient.
        const x = saved[0];
        const { paddings: paddings } = attrs;
        const begin = paddings.map((p)=>p[0]);
        return {
            x: ()=>(0, $79KOG.slice)(dy, begin, x.shape)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $8BaGO = parcelRequire("8BaGO");

var $inFmq = parcelRequire("inFmq");

var $bRRKf = parcelRequire("bRRKf");

var $dcoCo = parcelRequire("dcoCo");

var $jZc0w = parcelRequire("jZc0w");

var $ad1of = parcelRequire("ad1of");

var $4sqA7 = parcelRequire("4sqA7");

var $3xp7o = parcelRequire("3xp7o");

var $7kouu = parcelRequire("7kouu");

var $9NgTx = parcelRequire("9NgTx");

var $l2P14 = parcelRequire("l2P14");

var $8EjnK = parcelRequire("8EjnK");
const $089ec11516686031$export$2ca042d8bad66ff = {
    kernelName: (0, $hl418.Pow),
    inputsToSave: [
        'a',
        'b'
    ],
    outputsToSave: [
        true
    ],
    gradFunc: (dy, saved)=>{
        const [a, b, y] = saved;
        const base = a;
        const exp = b;
        const outShape = $8BaGO.assertAndGetBroadcastShape(base.shape, exp.shape);
        const derBase = ()=>{
            const expFloat = (0, $inFmq.cast)(exp, 'float32');
            let res = (0, $jZc0w.mul)(dy, (0, $jZc0w.mul)(expFloat, (0, $ad1of.pow)(base, (0, $7kouu.sub)(expFloat, (0, $3xp7o.scalar)(1)))));
            const reduceAxes = $8BaGO.getReductionAxes(base.shape, outShape);
            if (reduceAxes.length > 0) res = (0, $9NgTx.sum)(res, reduceAxes);
            return (0, $4sqA7.reshape)(res, base.shape);
        };
        const derExp = ()=>{
            const condition = (0, $bRRKf.greater)(base, 0);
            const logBase = (0, $l2P14.where)(condition, (0, $dcoCo.log)(base), (0, $8EjnK.zerosLike)(base));
            let res = (0, $jZc0w.mul)(dy, (0, $jZc0w.mul)(y, logBase));
            const reduceAxes = $8BaGO.getReductionAxes(exp.shape, outShape);
            if (reduceAxes.length > 0) res = (0, $9NgTx.sum)(res, reduceAxes);
            return (0, $4sqA7.reshape)(res, exp.shape);
        };
        return {
            a: derBase,
            b: derExp
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $8BaGO = parcelRequire("8BaGO");

var $bRRKf = parcelRequire("bRRKf");

var $jZc0w = parcelRequire("jZc0w");

var $4sqA7 = parcelRequire("4sqA7");

var $9NgTx = parcelRequire("9NgTx");

var $l2P14 = parcelRequire("l2P14");

var $8EjnK = parcelRequire("8EjnK");
const $dedac27249238d13$export$737d9f7a914424e7 = {
    kernelName: (0, $hl418.Prelu),
    inputsToSave: [
        'x',
        'alpha'
    ],
    gradFunc: (dy, saved)=>{
        const [x, alpha] = saved;
        const mask = (0, $bRRKf.greater)(x, 0);
        return {
            x: ()=>(0, $l2P14.where)(mask, dy, (0, $jZc0w.mul)(dy, alpha)),
            alpha: ()=>{
                let res = (0, $l2P14.where)(mask, (0, $8EjnK.zerosLike)(dy), (0, $jZc0w.mul)(dy, x));
                const reduceAxes = (0, $8BaGO.getReductionAxes)(alpha.shape, dy.shape);
                if (reduceAxes.length > 0) res = (0, $9NgTx.sum)(res, reduceAxes);
                return (0, $4sqA7.reshape)(res, alpha.shape);
            }
        };
    }
};


/**
 * @license
 * Copyright 2022 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $7MaPk = parcelRequire("7MaPk");

var $hl418 = parcelRequire("hl418");

var $bhhSS = parcelRequire("bhhSS");

var $jZc0w = parcelRequire("jZc0w");

var $4sqA7 = parcelRequire("4sqA7");

var $aDHKy = parcelRequire("aDHKy");
// Gradient for product operation on a single axis.
function $22052a2a415e7005$var$prodGradFn_(x, dy, axis) {
    // The gradient tensor (dy) has a set of axes removed, so we create re-shaped
    // versions (of size 1) for the removed axis; this supports broadcasting over
    // those dimensions.
    const expandedYShape = x.shape.slice();
    expandedYShape[axis] = 1;
    // The actual gradient computation.
    const expandedDy = (0, $4sqA7.reshape)(dy, expandedYShape);
    const xCumProd = (0, $bhhSS.cumprod)(x, axis, true, false);
    const xCumRevProd = (0, $bhhSS.cumprod)(x, axis, true, true);
    const dx = (0, $jZc0w.mul)(xCumProd, xCumRevProd);
    return (0, $jZc0w.mul)(expandedDy, dx);
}
// Support gradients when the product is done on many axes at once.
// This done py pushing all the axes on which the product is applied into a
// single axis.
function $22052a2a415e7005$var$prodsGradFn_(x, dy, axis) {
    // Move all axes for doing prod over to the end of the tensor.
    const xRank = x.shape.length;
    const finalProdAxis = xRank - axis.length;
    const xPermutation = (0, $7MaPk).getAxesPermutation(axis, xRank);
    let permutedX = x;
    if (xPermutation != null) permutedX = (0, $aDHKy.transpose)(x, xPermutation);
    // Reshape all the prod dimensions into a single one, and do compute prod
    // gradients on that.
    const newShape = permutedX.shape.slice();
    const removedShape = newShape.splice(xRank - axis.length, axis.length);
    const endPartShape = removedShape.reduce((p, c)=>p * c, 1);
    newShape.push(endPartShape);
    const reshapedPermutedX = permutedX.reshape(newShape);
    let prodGrad = $22052a2a415e7005$var$prodGradFn_(reshapedPermutedX, dy, finalProdAxis);
    // Undo the re-shaping now we have the dx vector, and permute back to
    // original axes order.
    prodGrad = prodGrad.reshape(permutedX.shape);
    if (xPermutation != null) {
        const undoPermutation = (0, $7MaPk).getUndoAxesPermutation(xPermutation);
        prodGrad = (0, $aDHKy.transpose)(prodGrad, undoPermutation);
    }
    return prodGrad;
}
const $22052a2a415e7005$export$18b8f1986a9cc9fb = {
    kernelName: (0, $hl418.Prod),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x] = saved;
        const { axis: axis } = attrs;
        let axisArr = [];
        if (axis === undefined || axis === null) axisArr = x.shape.map((_, i)=>i);
        else if (typeof axis === 'number') axisArr = [
            axis
        ];
        else axisArr = axis;
        return {
            x: ()=>$22052a2a415e7005$var$prodsGradFn_(x, dy, axisArr)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $8BaGO = parcelRequire("8BaGO");

var $inFmq = parcelRequire("inFmq");

var $1QPqB = parcelRequire("1QPqB");

var $jZc0w = parcelRequire("jZc0w");

var $15cGp = parcelRequire("15cGp");

var $4sqA7 = parcelRequire("4sqA7");

var $iDd8d = parcelRequire("iDd8d");

var $9NgTx = parcelRequire("9NgTx");
const $12a942fac0e32cf1$export$9c51f12fdbfaf1a1 = {
    kernelName: (0, $hl418.RealDiv),
    inputsToSave: [
        'a',
        'b'
    ],
    gradFunc: (dy, saved)=>{
        const [a, b] = saved;
        const outShape = $8BaGO.assertAndGetBroadcastShape(a.shape, b.shape);
        const derA = ()=>{
            const res = (0, $1QPqB.div)(dy, (0, $inFmq.cast)(b, 'float32'));
            const reduceAxes = $8BaGO.getReductionAxes(a.shape, outShape);
            if (reduceAxes.length > 0) return (0, $4sqA7.reshape)((0, $9NgTx.sum)(res, reduceAxes), a.shape);
            return res;
        };
        const derB = ()=>{
            let res = (0, $jZc0w.mul)(dy, (0, $inFmq.cast)(a, 'float32'));
            const reduceAxes = $8BaGO.getReductionAxes(b.shape, outShape);
            if (reduceAxes.length > 0) res = (0, $4sqA7.reshape)((0, $9NgTx.sum)(res, reduceAxes), b.shape);
            const tmp = (0, $iDd8d.square)(b);
            return (0, $15cGp.neg)((0, $1QPqB.div)(res, (0, $inFmq.cast)(tmp, 'float32')));
        };
        return {
            a: derA,
            b: derB
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $1QPqB = parcelRequire("1QPqB");

var $15cGp = parcelRequire("15cGp");

var $iDd8d = parcelRequire("iDd8d");
const $202e7f1a8e8b14fc$export$ae80392febfc338b = {
    kernelName: (0, $hl418.Reciprocal),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $1QPqB.div)(dy, (0, $15cGp.neg)((0, $iDd8d.square)(x)))
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $inFmq = parcelRequire("inFmq");

var $7LQ38 = parcelRequire("7LQ38");

var $jZc0w = parcelRequire("jZc0w");

var $lWdx1 = parcelRequire("lWdx1");
const $6345c4699749e6cf$export$41de35156decb8c9 = {
    kernelName: (0, $hl418.Relu6),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        const mask = (0, $jZc0w.mul)((0, $7LQ38.lessEqual)(x, 6), (0, $lWdx1.step)(x));
        return {
            x: ()=>(0, $jZc0w.mul)(dy, (0, $inFmq.cast)(mask, 'float32'))
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $inFmq = parcelRequire("inFmq");

var $jZc0w = parcelRequire("jZc0w");

var $lWdx1 = parcelRequire("lWdx1");
const $c1d62c0426df25d3$export$a206627c8f00ffd0 = {
    kernelName: (0, $hl418.Relu),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $jZc0w.mul)(dy, (0, $inFmq.cast)((0, $lWdx1.step)(x), 'float32'))
        };
    }
};


/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $4sqA7 = parcelRequire("4sqA7");
const $c0ce3046ebe580bf$export$24950d669898f1bd = {
    kernelName: (0, $hl418.Reshape),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $4sqA7.reshape)(dy, x.shape)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");
const $2fb90f740d2bac02$export$51f84ca614e84763 = {
    kernelName: (0, $hl418.ResizeBilinear),
    inputsToSave: [
        'images'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [images] = saved;
        const inputs = {
            dy: dy,
            images: images
        };
        const imagesDer = ()=>// tslint:disable-next-line: no-unnecessary-type-assertion
            (0, $38WwN.ENGINE).runKernel((0, $hl418.ResizeBilinearGrad), inputs, attrs);
        return {
            images: imagesDer
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $38WwN = parcelRequire("38WwN");

var $hl418 = parcelRequire("hl418");
const $e55fb3ee29374576$export$2b08d810b5090fe1 = {
    kernelName: (0, $hl418.ResizeNearestNeighbor),
    inputsToSave: [
        'images'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [images] = saved;
        const inputs = {
            dy: dy,
            images: images
        };
        const imagesDer = ()=>// tslint:disable-next-line: no-unnecessary-type-assertion
            (0, $38WwN.ENGINE).runKernel((0, $hl418.ResizeNearestNeighborGrad), inputs, attrs);
        return {
            images: imagesDer
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $6act6 = parcelRequire("6act6");

var $8cCb2 = parcelRequire("8cCb2");
const $75bf4a0bdc50f359$export$f990078b2a817279 = {
    kernelName: (0, $hl418.Reverse),
    gradFunc: (dy, saved, attrs)=>{
        const { dims: dims } = attrs;
        const axes = (0, $8cCb2.parseAxisParam)(dims, dy.shape);
        return {
            x: ()=>(0, $6act6.reverse)(dy, axes)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $8EjnK = parcelRequire("8EjnK");
const $fea8ca14a5199329$export$f26d18fb6c60d7 = {
    kernelName: (0, $hl418.Round),
    gradFunc: (dy)=>{
        // TODO(nsthorat): Let gradients be null for cases where we want to stop
        // backpropgation.
        return {
            x: ()=>(0, $8EjnK.zerosLike)(dy)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $1QPqB = parcelRequire("1QPqB");

var $jZc0w = parcelRequire("jZc0w");

var $15cGp = parcelRequire("15cGp");

var $ad1of = parcelRequire("ad1of");
const $7002deedaf5b747d$export$925fbc88de33c42d = {
    kernelName: (0, $hl418.Rsqrt),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $15cGp.neg)((0, $1QPqB.div)(dy, (0, $jZc0w.mul)((0, $ad1of.pow)(x, 1.5), 2)))
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $inFmq = parcelRequire("inFmq");

var $7NVSX = parcelRequire("7NVSX");

var $jZc0w = parcelRequire("jZc0w");

var $8EjnK = parcelRequire("8EjnK");
const $764488b5754ee54f$export$b017819c6a2a1f57 = {
    kernelName: (0, $hl418.Select),
    inputsToSave: [
        'condition'
    ],
    gradFunc: (dy, saved)=>{
        const [condition] = saved;
        return {
            // TODO(julianoks): Return null for condition gradient
            // when backprop supports it.
            condition: ()=>(0, $inFmq.cast)((0, $8EjnK.zerosLike)(condition), 'float32'),
            t: ()=>(0, $jZc0w.mul)(dy, (0, $inFmq.cast)(condition, dy.dtype)),
            e: ()=>(0, $jZc0w.mul)(dy, (0, $inFmq.cast)((0, $7NVSX.logicalNot)(condition), dy.dtype))
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $inFmq = parcelRequire("inFmq");

var $2PcQK = parcelRequire("2PcQK");

var $bRRKf = parcelRequire("bRRKf");

var $jZc0w = parcelRequire("jZc0w");

var $3xp7o = parcelRequire("3xp7o");

var $eowEY = parcelRequire("eowEY");

var $l2P14 = parcelRequire("l2P14");
const $1c0a9ec839da51cb$export$e1936da196fc058a = {
    kernelName: (0, $hl418.Selu),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>{
                const mask = (0, $bRRKf.greater)(x, (0, $3xp7o.scalar)(0));
                const scaleAlpha = (0, $3xp7o.scalar)((0, $eowEY.SELU_SCALEALPHA));
                const scale = (0, $3xp7o.scalar)((0, $eowEY.SELU_SCALE));
                const greaterThanZeroDer = (0, $jZc0w.mul)(dy, scale);
                const lessEqualZeroDer = (0, $jZc0w.mul)((0, $jZc0w.mul)(dy, scaleAlpha), (0, $2PcQK.exp)((0, $inFmq.cast)(x, 'float32')));
                return (0, $l2P14.where)(mask, greaterThanZeroDer, lessEqualZeroDer);
            }
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $jZc0w = parcelRequire("jZc0w");

var $3xp7o = parcelRequire("3xp7o");

var $7kouu = parcelRequire("7kouu");
const $a6e4514cb159431b$export$a5acbf5a3558774b = {
    kernelName: (0, $hl418.Sigmoid),
    outputsToSave: [
        true
    ],
    gradFunc: (dy, saved)=>{
        const [y] = saved;
        return {
            x: ()=>(0, $jZc0w.mul)(dy, (0, $jZc0w.mul)(y, (0, $7kouu.sub)((0, $3xp7o.scalar)(1), y)))
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $8EjnK = parcelRequire("8EjnK");
const $e3dcf5da5124f101$export$1d075457cdd4d64 = {
    kernelName: (0, $hl418.Sign),
    gradFunc: (dy)=>{
        return {
            x: ()=>(0, $8EjnK.zerosLike)(dy)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $inFmq = parcelRequire("inFmq");

var $3BU7G = parcelRequire("3BU7G");

var $jZc0w = parcelRequire("jZc0w");
const $6db999e11ad79f3f$export$e555a7ac73c36c03 = {
    kernelName: (0, $hl418.Sin),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $jZc0w.mul)((0, $3BU7G.cos)((0, $inFmq.cast)(x, 'float32')), dy)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $inFmq = parcelRequire("inFmq");

var $bTdqT = parcelRequire("bTdqT");

var $jZc0w = parcelRequire("jZc0w");
const $45c72fae2df231b4$export$441b7b34bae5ccc = {
    kernelName: (0, $hl418.Sinh),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $jZc0w.mul)((0, $bTdqT.cosh)((0, $inFmq.cast)(x, 'float32')), dy)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $fSZF6 = parcelRequire("fSZF6");

var $bszZn = parcelRequire("bszZn");
const $94c5f35816462fe5$export$df7b8be23ca4ae36 = {
    kernelName: (0, $hl418.Slice),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x] = saved;
        const { begin: begin, size: size } = attrs;
        const inputShape = x.shape;
        const [begin_, size_] = (0, $bszZn.parseSliceParams)(x, begin, size);
        // Create an Nx2 padding where the first column represents how many
        // zeros are prepended (at start) for each dimension, and the second
        // column indicates how many zeros are appended (at end).
        // The number of zeros to append is the shape of the input
        // elementwise-subtracted by both the begin vector and sizes vector.
        const paddings = [];
        for(let i = 0; i < dy.rank; i++)paddings.push([
            begin_[i],
            inputShape[i] - begin_[i] - size_[i]
        ]);
        return {
            x: ()=>(0, $fSZF6.pad)(dy, paddings)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $jZc0w = parcelRequire("jZc0w");

var $7kouu = parcelRequire("7kouu");

var $9NgTx = parcelRequire("9NgTx");
const $714dcbd122de8bf1$export$986b1eccb1e11659 = {
    kernelName: (0, $hl418.Softmax),
    outputsToSave: [
        true
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [y] = saved;
        const { dim: dim } = attrs;
        const keepDims = true;
        const dyTimesY = (0, $jZc0w.mul)(dy, y);
        return {
            logits: ()=>(0, $7kouu.sub)(dyTimesY, (0, $jZc0w.mul)((0, $9NgTx.sum)(dyTimesY, [
                    dim
                ], keepDims), y))
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $jZc0w = parcelRequire("jZc0w");

var $jvtSq = parcelRequire("jvtSq");
const $d9a467911a8e6a2c$export$25385fb73a9df5f0 = {
    kernelName: (0, $hl418.Softplus),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $jZc0w.mul)(dy, (0, $jvtSq.sigmoid)(x))
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $31sZ7 = parcelRequire("31sZ7");
const $e9bffec71b07e45e$export$384e163073b8980c = {
    kernelName: (0, $hl418.SpaceToBatchND),
    gradFunc: (dy, saved, attrs)=>{
        const { blockShape: blockShape, paddings: paddings } = attrs;
        return {
            x: ()=>(0, $31sZ7.batchToSpaceND)(dy, blockShape, paddings)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $iTu6j = parcelRequire("iTu6j");
const $c59defe91ac990b4$export$4ad3bd16fe45e539 = {
    kernelName: (0, $hl418.SplitV),
    gradFunc: (dy, saved, attrs)=>{
        const { axis: axis } = attrs;
        return {
            x: ()=>(0, $iTu6j.concat)(dy, axis)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $inFmq = parcelRequire("inFmq");

var $1QPqB = parcelRequire("1QPqB");

var $jZc0w = parcelRequire("jZc0w");

var $iAb3z = parcelRequire("iAb3z");
const $e2ac259a41addb27$export$e33c4e6eabff8df2 = {
    kernelName: (0, $hl418.Sqrt),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $1QPqB.div)(dy, (0, $jZc0w.mul)((0, $iAb3z.sqrt)((0, $inFmq.cast)(x, 'float32')), 2))
        };
    }
};


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $inFmq = parcelRequire("inFmq");

var $jZc0w = parcelRequire("jZc0w");
const $1f3121b81d380540$export$3fb060af275bf525 = {
    kernelName: (0, $hl418.Square),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $jZc0w.mul)(dy, (0, $jZc0w.mul)((0, $inFmq.cast)(x, 'float32'), 2))
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $jZc0w = parcelRequire("jZc0w");

var $3xp7o = parcelRequire("3xp7o");

var $7kouu = parcelRequire("7kouu");
const $7ecfb4c5cc41dfa4$export$ac87edeb32ba1ce1 = {
    kernelName: (0, $hl418.SquaredDifference),
    inputsToSave: [
        'a',
        'b'
    ],
    gradFunc: (dy, saved)=>{
        const [a, b] = saved;
        const two = (0, $3xp7o.scalar)(2);
        const derA = ()=>(0, $jZc0w.mul)(dy, (0, $jZc0w.mul)(two, (0, $7kouu.sub)(a, b)));
        const derB = ()=>(0, $jZc0w.mul)(dy, (0, $jZc0w.mul)(two, (0, $7kouu.sub)(b, a)));
        return {
            a: derA,
            b: derB
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $8EjnK = parcelRequire("8EjnK");
const $83834b8f2da2d16a$export$51a8fd534d085770 = {
    kernelName: (0, $hl418.Step),
    gradFunc: (dy)=>{
        // TODO(manrajgrover): Return null for gradients when backprop supports
        // it.
        return {
            x: ()=>(0, $8EjnK.zerosLike)(dy)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $8BaGO = parcelRequire("8BaGO");

var $15cGp = parcelRequire("15cGp");

var $4sqA7 = parcelRequire("4sqA7");

var $9NgTx = parcelRequire("9NgTx");
const $413af8acea63ddf4$export$7fa26ec41cd14ac = {
    kernelName: (0, $hl418.Sub),
    inputsToSave: [
        'a',
        'b'
    ],
    gradFunc: (dy, saved)=>{
        const [a, b] = saved;
        const outShape = $8BaGO.assertAndGetBroadcastShape(a.shape, b.shape);
        const derA = ()=>{
            let res = dy;
            const reduceAxes = $8BaGO.getReductionAxes(a.shape, outShape);
            if (reduceAxes.length > 0) res = (0, $9NgTx.sum)(res, reduceAxes);
            return (0, $4sqA7.reshape)(res, a.shape);
        };
        const derB = ()=>{
            let res = dy;
            const reduceAxes = $8BaGO.getReductionAxes(b.shape, outShape);
            if (reduceAxes.length > 0) res = (0, $9NgTx.sum)(res, reduceAxes);
            return (0, $4sqA7.reshape)((0, $15cGp.neg)(res), b.shape);
        };
        return {
            a: derA,
            b: derB
        };
    }
};


/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $jZc0w = parcelRequire("jZc0w");

var $fOBRA = parcelRequire("fOBRA");

var $4sqA7 = parcelRequire("4sqA7");

var $8cCb2 = parcelRequire("8cCb2");
const $382304820770e18d$export$5b5372b406109dcd = {
    kernelName: (0, $hl418.Sum),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x] = saved;
        const expandedDyShape = x.shape.slice();
        const { axis: axis } = attrs;
        const axes = (0, $8cCb2.parseAxisParam)(axis, x.shape);
        axes.forEach((axis)=>{
            expandedDyShape[axis] = 1;
        });
        const expandedDy = (0, $4sqA7.reshape)(dy, expandedDyShape);
        const derX = (0, $jZc0w.mul)(expandedDy, (0, $fOBRA.ones)(x.shape, 'float32'));
        return {
            x: ()=>derX
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $3BU7G = parcelRequire("3BU7G");

var $1QPqB = parcelRequire("1QPqB");

var $iDd8d = parcelRequire("iDd8d");
const $98b519ac1df2d2e1$export$26050e3e7c704591 = {
    kernelName: (0, $hl418.Tan),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $1QPqB.div)(dy, (0, $iDd8d.square)((0, $3BU7G.cos)(x)))
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $jZc0w = parcelRequire("jZc0w");

var $3xp7o = parcelRequire("3xp7o");

var $iDd8d = parcelRequire("iDd8d");

var $7kouu = parcelRequire("7kouu");
const $3d81555b5002dcfb$export$50a7f4d5b41706bd = {
    kernelName: (0, $hl418.Tanh),
    outputsToSave: [
        true
    ],
    gradFunc: (dy, saved)=>{
        const [y] = saved;
        return {
            x: ()=>(0, $jZc0w.mul)((0, $7kouu.sub)((0, $3xp7o.scalar)(1), (0, $iDd8d.square)(y)), dy)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $hgacW = parcelRequire("hgacW");

var $79KOG = parcelRequire("79KOG");

var $8EjnK = parcelRequire("8EjnK");
const $372d8cc6fa3486cf$export$fd5cce480fa5176f = {
    kernelName: (0, $hl418.Tile),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x] = saved;
        const { reps: reps } = attrs;
        const derX = ()=>{
            let xGrad = (0, $8EjnK.zerosLike)(x);
            // TODO(cais): Maybe reduce memory footprint by avoiding repeated
            // slicing.
            if (x.rank === 1) for(let i = 0; i < reps[0]; ++i)xGrad = (0, $hgacW.add)(xGrad, (0, $79KOG.slice)(dy, [
                i * x.shape[0]
            ], [
                x.shape[0]
            ]));
            else if (x.rank === 2) {
                for(let i = 0; i < reps[0]; ++i)for(let j = 0; j < reps[1]; ++j)xGrad = (0, $hgacW.add)(xGrad, (0, $79KOG.slice)(dy, [
                    i * x.shape[0],
                    j * x.shape[1]
                ], [
                    x.shape[0],
                    x.shape[1]
                ]));
            } else if (x.rank === 3) for(let i = 0; i < reps[0]; ++i){
                for(let j = 0; j < reps[1]; ++j)for(let k = 0; k < reps[2]; ++k)xGrad = (0, $hgacW.add)(xGrad, (0, $79KOG.slice)(dy, [
                    i * x.shape[0],
                    j * x.shape[1],
                    k * x.shape[2]
                ], [
                    x.shape[0],
                    x.shape[1],
                    x.shape[2]
                ]));
            }
            else if (x.rank === 4) {
                for(let i = 0; i < reps[0]; ++i)for(let j = 0; j < reps[1]; ++j){
                    for(let k = 0; k < reps[2]; ++k)for(let l = 0; l < reps[3]; ++l)xGrad = (0, $hgacW.add)(xGrad, (0, $79KOG.slice)(dy, [
                        i * x.shape[0],
                        j * x.shape[1],
                        k * x.shape[2],
                        l * x.shape[3]
                    ], [
                        x.shape[0],
                        x.shape[1],
                        x.shape[2],
                        x.shape[3]
                    ]));
                }
            } else throw new Error(`Gradient for tile operation is not implemented for rank-` + `${x.rank} tensors yet.`);
            return xGrad;
        };
        return {
            x: derX
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $kTunp = parcelRequire("kTunp");

var $aDHKy = parcelRequire("aDHKy");
const $27f760d5f3234c03$export$c40368da30e9b1df = {
    kernelName: (0, $hl418.Transpose),
    gradFunc: (dy, saved, attrs)=>{
        const transposeAttrs = attrs;
        const { perm: perm } = transposeAttrs;
        const undoPerm = $kTunp.getUndoAxesPermutation(perm);
        return {
            x: ()=>(0, $aDHKy.transpose)(dy, undoPerm)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $8BrLX = parcelRequire("8BrLX");
const $3b1bafbaf3ec681e$export$e778502f377d32a9 = {
    kernelName: (0, $hl418.Unpack),
    gradFunc: (dy, saved, attrs)=>{
        const unpackAttrs = attrs;
        const { axis: axis } = unpackAttrs;
        return {
            value: ()=>(0, $8BrLX.stack)(dy, axis)
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $iPDWZ = parcelRequire("iPDWZ");

var $3qUjU = parcelRequire("3qUjU");

var $l0Zxl = parcelRequire("l0Zxl");

var $kg1Wp = parcelRequire("kg1Wp");

var $g5Jt1 = parcelRequire("g5Jt1");

var $fOBRA = parcelRequire("fOBRA");

var $3xp7o = parcelRequire("3xp7o");

var $l2P14 = parcelRequire("l2P14");

var $8EjnK = parcelRequire("8EjnK");
const $19058851e3bdfce7$export$b02449f948377b8 = {
    kernelName: (0, $hl418.UnsortedSegmentSum),
    inputsToSave: [
        'segmentIds'
    ],
    gradFunc: (dy, saved)=>{
        const [segmentIds] = saved;
        const derX = ()=>{
            return $19058851e3bdfce7$var$gatherDropNegatives(dy, segmentIds);
        };
        return {
            x: derX
        };
    }
};
function $19058851e3bdfce7$var$gatherDropNegatives(x, indices) {
    // Helper function for unsorted segment ops. Gathers params for
    // positive segment ids and gathers 0 for inputs with negative segment id.
    // Mirrors _GatherDropNegatives from tensorflow/python/ops/math_grad.py
    const zeroClippedIndices = (0, $g5Jt1.maximum)(indices, (0, $8EjnK.zerosLike)(indices));
    const gathered = (0, $3qUjU.gather)(x, zeroClippedIndices);
    let isPositive = (0, $l0Zxl.greaterEqual)(indices, (0, $3xp7o.scalar)(0, 'int32'));
    const numIters = gathered.rank - isPositive.rank;
    for(let i = 0; i < numIters; ++i)isPositive = (0, $iPDWZ.expandDims)(isPositive, i + 1);
    isPositive = (0, $kg1Wp.logicalAnd)(isPositive, (0, $fOBRA.ones)(gathered.shape, 'bool'));
    const zeroSlice = (0, $8EjnK.zerosLike)(gathered);
    return (0, $l2P14.where)(isPositive, gathered, zeroSlice);
}


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hl418 = parcelRequire("hl418");

var $8EjnK = parcelRequire("8EjnK");
const $40fb8733f5a4d3ed$export$33fce8206ddf321b = {
    kernelName: (0, $hl418.ZerosLike),
    gradFunc: (dy)=>{
        return {
            x: ()=>(0, $8EjnK.zerosLike)(dy)
        };
    }
};



var $eky5o = parcelRequire("eky5o");
// Export all kernel configs here so that the package can auto register them
const $3d2f75e90e41aba4$var$gradConfigs = [
    (0, $16b3f81f6e835ccb$export$8311873a6069f3c6),
    (0, $abc3f6692a074231$export$25410aeefefd68e9),
    (0, $44e3410f91274d15$export$2ec6994297162d56),
    (0, $f34466425f1ab9ba$export$817a98e7fbc08f69),
    (0, $40725ecfd14bd52a$export$9dda03cc9e4ef85c),
    (0, $e1ef11eb5c42d53e$export$1d99392d6c64a702),
    (0, $68e623e9c8752b63$export$af12a090c1c7b332),
    (0, $1038d963c8903264$export$3f8c1d33cc0ed430),
    (0, $1443a963105306fb$export$375f857062067cfd),
    (0, $8299722d66a7479c$export$cdf09477d70d7ce9),
    (0, $1e790246ae1a8a74$export$87ed559988dd857),
    (0, $914f9524978b3333$export$465efa1ebdf13d21),
    (0, $71e09be9109c2502$export$1eeb8780807d0508),
    (0, $98f0415292ab533e$export$ac3f8709351ab225),
    (0, $b96889729ac833ab$export$88221f1a5167c38c),
    (0, $0f45e0ae0abc1a3c$export$b6582e1705c4f42d),
    (0, $96da7667e2fb7a2d$export$1fc1d8b1fdae546a),
    (0, $dcfa4e321c02cbc6$export$77a4f6320d798df2),
    (0, $fc8c9416ddcd9d99$export$1789d8956379862a),
    (0, $af4d1d593ac568df$export$3f1764b1eedfe2cb),
    (0, $0e4da148ad506942$export$b8ff856642294896),
    (0, $a38d450e94cb4b12$export$ddda159860ceb06e),
    (0, $fd2ffcfd5328d080$export$cdb8a95f3d598a0d),
    (0, $78881e9ce019c175$export$2fd622114dede0fc),
    (0, $b7c6bf2d7d34b346$export$2456b335ba19aa7b),
    (0, $b072f3424ce545fe$export$fc646268baa57098),
    (0, $4f2c5ffd0bea16e5$export$bcde595585c16638),
    (0, $2aa441de0118cd33$export$9f1ba0cc8e88cb76),
    (0, $8f577a148fb4dc15$export$66192798aa3d6196),
    (0, $f7b40b8415be55d0$export$3d2aed5cf11b13ba),
    (0, $12a942fac0e32cf1$export$9c51f12fdbfaf1a1),
    (0, $335df656b9a24fdd$export$59bb07dd04647a1d),
    (0, $f757cdc63fe9f758$export$80bb9a361ec8d601),
    (0, $fd72fd91250c8bce$export$e3362b875cf81ebc),
    (0, $e590481eef288d43$export$27394e9fa8330490),
    (0, $0a67a90fdf6f1af1$export$758f509582468c75),
    (0, $b6dd29b4aaeec0af$export$1f5798c5c4ca3f10),
    (0, $026c20739f202e7e$export$2a943001dbfa8fd1),
    (0, $8f2035325d395bd9$export$3b83e7a588d720e9),
    (0, $e16960b683502aa3$export$793739cdccafd2d1),
    (0, $065131d780336c97$export$fba648816411e438),
    (0, $213f2721fd34b65c$export$bddb155b34767c3a),
    (0, $d5d13e7c5ccb0cc8$export$108f33db0f535e77),
    (0, $2a05110eaea550ef$export$af7d3cc575a3d37d),
    (0, $f23fa02982844776$export$a2997336d9064f51),
    (0, $c3082ed837b873c5$export$8aba4169a7423780),
    (0, $adac90ba519e0f93$export$2a0e1acd37a49488),
    (0, $89b496877029f4af$export$a6f98c34c79ddc6c),
    (0, $accfa3a1cfb3ba7d$export$556818e7703f08a6),
    (0, $ad71facd2d26f201$export$9250622395b66a34),
    (0, $c7dcffda09f32f55$export$c8c367f50d71c477),
    (0, $c7dcffda09f32f55$export$c8c367f50d71c477),
    (0, $32876797c927a598$export$b394285cea805997),
    (0, $44f7090a30c7cbd5$export$5201426bb10bd5eb),
    (0, $52ed693396405b71$export$e01a7f8dbee29127),
    (0, $340ba42e0ddb0098$export$ac394d88e62d3236),
    (0, $fb4dcb6e8ced730e$export$414be41faed05c5f),
    (0, $89735e320c3c4c06$export$6c859b9b59a13286),
    (0, $b041387a418bdb37$export$83a1d4320d554b59),
    (0, $d29217a57daf0c25$export$6ef350a1f32ed6e2),
    (0, $1b71026463fc74f9$export$13098dd2211fc557),
    (0, $abe23bdf32b4ba6a$export$9c8adee9ba64cfc3),
    (0, $064328644082f372$export$fec82556b8ba1992),
    (0, $69ce364be1660162$export$693d483aaf035f85),
    (0, $99f792b2a0ad46a5$export$2deaaffbc5347dbd),
    (0, $fb7817d456d5918d$export$beb610947bf972b5),
    (0, $fb7817d456d5918d$export$beb610947bf972b5),
    (0, $089ec11516686031$export$2ca042d8bad66ff),
    (0, $dedac27249238d13$export$737d9f7a914424e7),
    (0, $22052a2a415e7005$export$18b8f1986a9cc9fb),
    (0, $202e7f1a8e8b14fc$export$ae80392febfc338b),
    (0, $6345c4699749e6cf$export$41de35156decb8c9),
    (0, $c1d62c0426df25d3$export$a206627c8f00ffd0),
    (0, $c0ce3046ebe580bf$export$24950d669898f1bd),
    (0, $2fb90f740d2bac02$export$51f84ca614e84763),
    (0, $e55fb3ee29374576$export$2b08d810b5090fe1),
    (0, $75bf4a0bdc50f359$export$f990078b2a817279),
    (0, $fea8ca14a5199329$export$f26d18fb6c60d7),
    (0, $7002deedaf5b747d$export$925fbc88de33c42d),
    (0, $764488b5754ee54f$export$b017819c6a2a1f57),
    (0, $1c0a9ec839da51cb$export$e1936da196fc058a),
    (0, $a6e4514cb159431b$export$a5acbf5a3558774b),
    (0, $e3dcf5da5124f101$export$1d075457cdd4d64),
    (0, $6db999e11ad79f3f$export$e555a7ac73c36c03),
    (0, $45c72fae2df231b4$export$441b7b34bae5ccc),
    (0, $94c5f35816462fe5$export$df7b8be23ca4ae36),
    (0, $714dcbd122de8bf1$export$986b1eccb1e11659),
    (0, $d9a467911a8e6a2c$export$25385fb73a9df5f0),
    (0, $e9bffec71b07e45e$export$384e163073b8980c),
    (0, $e9bffec71b07e45e$export$384e163073b8980c),
    (0, $c59defe91ac990b4$export$4ad3bd16fe45e539),
    (0, $c59defe91ac990b4$export$4ad3bd16fe45e539),
    (0, $e2ac259a41addb27$export$e33c4e6eabff8df2),
    (0, $7ecfb4c5cc41dfa4$export$ac87edeb32ba1ce1),
    (0, $1f3121b81d380540$export$3fb060af275bf525),
    (0, $83834b8f2da2d16a$export$51a8fd534d085770),
    (0, $413af8acea63ddf4$export$7fa26ec41cd14ac),
    (0, $382304820770e18d$export$5b5372b406109dcd),
    (0, $98b519ac1df2d2e1$export$26050e3e7c704591),
    (0, $3d81555b5002dcfb$export$50a7f4d5b41706bd),
    (0, $372d8cc6fa3486cf$export$fd5cce480fa5176f),
    (0, $27f760d5f3234c03$export$c40368da30e9b1df),
    (0, $3b1bafbaf3ec681e$export$e778502f377d32a9),
    (0, $19058851e3bdfce7$export$b02449f948377b8),
    (0, $40fb8733f5a4d3ed$export$33fce8206ddf321b)
];
for (const gradientConfig of $3d2f75e90e41aba4$var$gradConfigs)(0, $eky5o.registerGradient)(gradientConfig);


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $7j49I = parcelRequire("7j49I");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.abs = function() {
    this.throwIfDisposed();
    return (0, $7j49I.abs)(this);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $lhgWX = parcelRequire("lhgWX");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.acos = function() {
    this.throwIfDisposed();
    return (0, $lhgWX.acos)(this);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $c0yr6 = parcelRequire("c0yr6");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.acosh = function() {
    this.throwIfDisposed();
    return (0, $c0yr6.acosh)(this);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hgacW = parcelRequire("hgacW");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.add = function(b) {
    this.throwIfDisposed();
    return (0, $hgacW.add)(this, b);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $baxp3 = parcelRequire("baxp3");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.all = function(axis, keepDims) {
    this.throwIfDisposed();
    return (0, $baxp3.all)(this, axis, keepDims);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $3cXYO = parcelRequire("3cXYO");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.any = function(axis, keepDims) {
    this.throwIfDisposed();
    return (0, $3cXYO.any)(this, axis, keepDims);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $jctS7 = parcelRequire("jctS7");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.argMax = function(axis) {
    this.throwIfDisposed();
    return (0, $jctS7.argMax)(this, axis);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hNrdr = parcelRequire("hNrdr");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.argMin = function(axis) {
    this.throwIfDisposed();
    return (0, $hNrdr.argMin)(this, axis);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $4sqA7 = parcelRequire("4sqA7");

var $9jCh7 = parcelRequire("9jCh7");

var $8cCb2 = parcelRequire("8cCb2");
/**
 * Converts a size-1 `tf.Tensor` to a `tf.Scalar`.
 * @doc {heading: 'Tensors', subheading: 'Classes'}
 */ (0, $9jCh7.getGlobalTensorClass)().prototype.asScalar = function() {
    this.throwIfDisposed();
    (0, $8cCb2.assert)(this.size === 1, ()=>'The array must have only 1 element.');
    return (0, $4sqA7.reshape)(this, []);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $inFmq = parcelRequire("inFmq");

var $9jCh7 = parcelRequire("9jCh7");
/**
 * Casts a `tf.Tensor` to a specified dtype.
 *
 * @param dtype Data-type to cast the tensor to.
 *
 * @doc {heading: 'Tensors', subheading: 'Classes'}
 */ (0, $9jCh7.getGlobalTensorClass)().prototype.asType = function(dtype) {
    this.throwIfDisposed();
    return (0, $inFmq.cast)(this, dtype);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $4sqA7 = parcelRequire("4sqA7");

var $9jCh7 = parcelRequire("9jCh7");
/**
 * Converts a `tf.Tensor` to a `tf.Tensor1D`.
 * @doc {heading: 'Tensors', subheading: 'Classes'}
 */ (0, $9jCh7.getGlobalTensorClass)().prototype.as1D = function() {
    this.throwIfDisposed();
    return (0, $4sqA7.reshape)(this, [
        this.size
    ]);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $4sqA7 = parcelRequire("4sqA7");

var $9jCh7 = parcelRequire("9jCh7");
/**
 * Converts a `tf.Tensor` to a `tf.Tensor2D`.
 *
 * @param rows Number of rows in `tf.Tensor2D`.
 * @param columns Number of columns in `tf.Tensor2D`.
 * @doc {heading: 'Tensors', subheading: 'Classes'}
 */ (0, $9jCh7.getGlobalTensorClass)().prototype.as2D = function(rows, columns) {
    this.throwIfDisposed();
    return (0, $4sqA7.reshape)(this, [
        rows,
        columns
    ]);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $4sqA7 = parcelRequire("4sqA7");

var $9jCh7 = parcelRequire("9jCh7");
/**
 * Converts a `tf.Tensor` to a `tf.Tensor3D`.
 *
 * @param rows Number of rows in `tf.Tensor3D`.
 * @param columns Number of columns in `tf.Tensor3D`.
 * @param depth Depth of `tf.Tensor3D`.
 * @doc {heading: 'Tensors', subheading: 'Classes'}
 */ (0, $9jCh7.getGlobalTensorClass)().prototype.as3D = function(rows, columns, depth) {
    this.throwIfDisposed();
    return (0, $4sqA7.reshape)(this, [
        rows,
        columns,
        depth
    ]);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $4sqA7 = parcelRequire("4sqA7");

var $9jCh7 = parcelRequire("9jCh7");
/**
 * Converts a `tf.Tensor` to a `tf.Tensor4D`.
 *
 * @param rows Number of rows in `tf.Tensor4D`.
 * @param columns Number of columns in `tf.Tensor4D`.
 * @param depth Depth of `tf.Tensor4D`.
 * @param depth2 4th dimension of `tf.Tensor4D`.
 * @doc {heading: 'Tensors', subheading: 'Classes'}
 */ (0, $9jCh7.getGlobalTensorClass)().prototype.as4D = function(rows, columns, depth, depth2) {
    this.throwIfDisposed();
    return (0, $4sqA7.reshape)(this, [
        rows,
        columns,
        depth,
        depth2
    ]);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $4sqA7 = parcelRequire("4sqA7");

var $9jCh7 = parcelRequire("9jCh7");
/**
 * Converts a `tf.Tensor` to a `tf.Tensor5D`.
 *
 * @param rows Number of rows in `tf.Tensor5D`.
 * @param columns Number of columns in `tf.Tensor5D`.
 * @param depth Depth of `tf.Tensor5D`.
 * @param depth2 4th dimension of `tf.Tensor5D`.
 * @param depth3 5th dimension of 'tf.Tensor5D'
 *
 * @doc {heading: 'Tensors', subheading: 'Classes'}
 */ (0, $9jCh7.getGlobalTensorClass)().prototype.as5D = function(rows, columns, depth, depth2, depth3) {
    this.throwIfDisposed();
    return (0, $4sqA7.reshape)(this, [
        rows,
        columns,
        depth,
        depth2,
        depth3
    ]);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $8ZwsA = parcelRequire("8ZwsA");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.asin = function() {
    this.throwIfDisposed();
    return (0, $8ZwsA.asin)(this);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $9a9km = parcelRequire("9a9km");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.asinh = function() {
    this.throwIfDisposed();
    return (0, $9a9km.asinh)(this);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $PYQvk = parcelRequire("PYQvk");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.atan = function() {
    this.throwIfDisposed();
    return (0, $PYQvk.atan)(this);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8ikBQ = parcelRequire("8ikBQ");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.atan2 = function(b) {
    this.throwIfDisposed();
    return (0, $8ikBQ.atan2)(this, b);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $5vfVv = parcelRequire("5vfVv");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.atanh = function() {
    this.throwIfDisposed();
    return (0, $5vfVv.atanh)(this);
};



var $j4oHC = parcelRequire("j4oHC");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.avgPool = function(filterSize, strides, pad, dimRoundingMode) {
    this.throwIfDisposed();
    return (0, $j4oHC.avgPool)(this, filterSize, strides, pad, dimRoundingMode);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $31sZ7 = parcelRequire("31sZ7");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.batchToSpaceND = function(blockShape, crops) {
    this.throwIfDisposed();
    return (0, $31sZ7.batchToSpaceND)(this, blockShape, crops);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5ULLz = parcelRequire("5ULLz");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.batchNorm = function(mean, variance, offset, scale, varianceEpsilon) {
    this.throwIfDisposed();
    return (0, $5ULLz.batchNorm)(this, mean, variance, offset, scale, varianceEpsilon);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aeB3Z = parcelRequire("aeB3Z");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.broadcastTo = function(shape) {
    this.throwIfDisposed();
    return (0, $aeB3Z.broadcastTo)(this, shape);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $inFmq = parcelRequire("inFmq");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.cast = function(dtype) {
    this.throwIfDisposed();
    return (0, $inFmq.cast)(this, dtype);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $jDrkY = parcelRequire("jDrkY");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.ceil = function() {
    this.throwIfDisposed();
    return (0, $jDrkY.ceil)(this);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $cOWuO = parcelRequire("cOWuO");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.clipByValue = function(min, max) {
    this.throwIfDisposed();
    return (0, $cOWuO.clipByValue)(this, min, max);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $iTu6j = parcelRequire("iTu6j");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.concat = function(x, axis) {
    this.throwIfDisposed();
    if (x instanceof (0, $9jCh7.Tensor)) x = [
        x
    ];
    return (0, $iTu6j.concat)([
        this,
        ...x
    ], axis);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $ebPOp = parcelRequire("ebPOp");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.conv1d = function(filter, stride, pad, dataFormat, dilation, dimRoundingMode) {
    this.throwIfDisposed();
    return (0, $ebPOp.conv1d)(this, filter, stride, pad, dataFormat, dilation, dimRoundingMode);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5rn1J = parcelRequire("5rn1J");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.conv2dTranspose = function(filter, outputShape, strides, pad, dimRoundingMode) {
    this.throwIfDisposed();
    return (0, $5rn1J.conv2dTranspose)(this, filter, outputShape, strides, pad, dimRoundingMode);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5Nkm1 = parcelRequire("5Nkm1");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.conv2d = function(filter, strides, pad, dataFormat, dilations, dimRoundingMode) {
    this.throwIfDisposed();
    return (0, $5Nkm1.conv2d)(this, filter, strides, pad, dataFormat, dilations, dimRoundingMode);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $3BU7G = parcelRequire("3BU7G");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.cos = function() {
    this.throwIfDisposed();
    return (0, $3BU7G.cos)(this);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $bTdqT = parcelRequire("bTdqT");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.cosh = function() {
    this.throwIfDisposed();
    return (0, $bTdqT.cosh)(this);
};


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $bhhSS = parcelRequire("bhhSS");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.cumprod = function(axis, exclusive, reverse) {
    this.throwIfDisposed();
    return (0, $bhhSS.cumprod)(this, axis, exclusive, reverse);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $7lqwF = parcelRequire("7lqwF");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.cumsum = function(axis, exclusive, reverse) {
    this.throwIfDisposed();
    return (0, $7lqwF.cumsum)(this, axis, exclusive, reverse);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $lIVEL = parcelRequire("lIVEL");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.depthToSpace = function(blockSize, dataFormat) {
    this.throwIfDisposed();
    return (0, $lIVEL.depthToSpace)(this, blockSize, dataFormat);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $182Rc = parcelRequire("182Rc");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.depthwiseConv2d = function(filter, strides, pad, dataFormat, dilations, dimRoundingMode) {
    this.throwIfDisposed();
    return (0, $182Rc.depthwiseConv2d)(this, filter, strides, pad, dataFormat, dilations, dimRoundingMode);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $leKzP = parcelRequire("leKzP");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.dilation2d = function(filter, strides, pad, dilations, dataFormat) {
    this.throwIfDisposed();
    return (0, $leKzP.dilation2d)(this, filter, strides, pad, dilations, dataFormat);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $3pBq5 = parcelRequire("3pBq5");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.divNoNan = function(b) {
    this.throwIfDisposed();
    return (0, $3pBq5.divNoNan)(this, b);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $1QPqB = parcelRequire("1QPqB");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.div = function(b) {
    this.throwIfDisposed();
    return (0, $1QPqB.div)(this, b);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $67T3W = parcelRequire("67T3W");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.dot = function(b) {
    this.throwIfDisposed();
    return (0, $67T3W.dot)(this, b);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $7UQTl = parcelRequire("7UQTl");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.elu = function() {
    this.throwIfDisposed();
    return (0, $7UQTl.elu)(this);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $7R9HC = parcelRequire("7R9HC");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.equal = function(b) {
    this.throwIfDisposed();
    return (0, $7R9HC.equal)(this, b);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $3q8h0 = parcelRequire("3q8h0");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.erf = function() {
    this.throwIfDisposed();
    return (0, $3q8h0.erf)(this);
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $4PmMp = parcelRequire("4PmMp");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.euclideanNorm = function(axis, keepDims) {
    this.throwIfDisposed();
    return (0, $4PmMp.euclideanNorm)(this, axis, keepDims);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $2PcQK = parcelRequire("2PcQK");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.exp = function() {
    this.throwIfDisposed();
    return (0, $2PcQK.exp)(this);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $iPDWZ = parcelRequire("iPDWZ");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.expandDims = function(axis) {
    this.throwIfDisposed();
    return (0, $iPDWZ.expandDims)(this, axis);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $cUuFo = parcelRequire("cUuFo");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.expm1 = function() {
    this.throwIfDisposed();
    return (0, $cUuFo.expm1)(this);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $aosGd = parcelRequire("aosGd");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.fft = function() {
    this.throwIfDisposed();
    return (0, $aosGd.fft)(this);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $4sqA7 = parcelRequire("4sqA7");

var $9jCh7 = parcelRequire("9jCh7");
/**
 * Flatten a Tensor to a 1D array.
 * @doc {heading: 'Tensors', subheading: 'Classes'}
 */ (0, $9jCh7.getGlobalTensorClass)().prototype.flatten = function() {
    this.throwIfDisposed();
    return (0, $4sqA7.reshape)(this, [
        this.size
    ]);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $4ZUCz = parcelRequire("4ZUCz");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.floor = function() {
    this.throwIfDisposed();
    return (0, $4ZUCz.floor)(this);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $6a2Ft = parcelRequire("6a2Ft");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.floorDiv = function(b) {
    this.throwIfDisposed();
    return (0, $6a2Ft.floorDiv)(this, b);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $3qUjU = parcelRequire("3qUjU");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.gather = function(indices, axis, batchDims) {
    this.throwIfDisposed();
    return (0, $3qUjU.gather)(this, indices, axis, batchDims);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $l0Zxl = parcelRequire("l0Zxl");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.greaterEqual = function(b) {
    this.throwIfDisposed();
    return (0, $l0Zxl.greaterEqual)(this, b);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $bRRKf = parcelRequire("bRRKf");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.greater = function(b) {
    this.throwIfDisposed();
    return (0, $bRRKf.greater)(this, b);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $aosGd = parcelRequire("aosGd");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.ifft = function() {
    this.throwIfDisposed();
    return (0, $aosGd.ifft)(this);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $aosGd = parcelRequire("aosGd");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.irfft = function() {
    this.throwIfDisposed();
    return (0, $aosGd.irfft)(this);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $eaZNC = parcelRequire("eaZNC");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.isFinite = function() {
    this.throwIfDisposed();
    return (0, $eaZNC.isFinite)(this);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $ahjR1 = parcelRequire("ahjR1");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.isInf = function() {
    this.throwIfDisposed();
    return (0, $ahjR1.isInf)(this);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $5FmUe = parcelRequire("5FmUe");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.isNaN = function() {
    this.throwIfDisposed();
    return (0, $5FmUe.isNaN)(this);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $3XskU = parcelRequire("3XskU");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.leakyRelu = function(alpha) {
    this.throwIfDisposed();
    return (0, $3XskU.leakyRelu)(this, alpha);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $7LQ38 = parcelRequire("7LQ38");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.lessEqual = function(b) {
    this.throwIfDisposed();
    return (0, $7LQ38.lessEqual)(this, b);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $jTDVJ = parcelRequire("jTDVJ");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.less = function(b) {
    this.throwIfDisposed();
    return (0, $jTDVJ.less)(this, b);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $k8D3u = parcelRequire("k8D3u");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.localResponseNormalization = function(depthRadius, bias, alpha, beta) {
    this.throwIfDisposed();
    return (0, $k8D3u.localResponseNormalization)(this, depthRadius, bias, alpha, beta);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $7hYeW = parcelRequire("7hYeW");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.logSigmoid = function() {
    this.throwIfDisposed();
    return (0, $7hYeW.logSigmoid)(this);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $2NPdY = parcelRequire("2NPdY");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.logSoftmax = function(axis) {
    this.throwIfDisposed();
    return (0, $2NPdY.logSoftmax)(this, axis);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9dGIC = parcelRequire("9dGIC");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.logSumExp = function(axis, keepDims) {
    this.throwIfDisposed();
    return (0, $9dGIC.logSumExp)(this, axis, keepDims);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $dcoCo = parcelRequire("dcoCo");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.log = function() {
    this.throwIfDisposed();
    return (0, $dcoCo.log)(this);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $5QUXI = parcelRequire("5QUXI");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.log1p = function() {
    this.throwIfDisposed();
    return (0, $5QUXI.log1p)(this);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $kg1Wp = parcelRequire("kg1Wp");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.logicalAnd = function(b) {
    this.throwIfDisposed();
    return (0, $kg1Wp.logicalAnd)(this, b);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $7NVSX = parcelRequire("7NVSX");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.logicalNot = function() {
    this.throwIfDisposed();
    return (0, $7NVSX.logicalNot)(this);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $iok2K = parcelRequire("iok2K");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.logicalOr = function(b) {
    this.throwIfDisposed();
    return (0, $iok2K.logicalOr)(this, b);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $iIobM = parcelRequire("iIobM");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.logicalXor = function(b) {
    this.throwIfDisposed();
    return (0, $iIobM.logicalXor)(this, b);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aUFou = parcelRequire("aUFou");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.matMul = function(b, transposeA, transposeB) {
    this.throwIfDisposed();
    return (0, $aUFou.matMul)(this, b, transposeA, transposeB);
};



var $gscJF = parcelRequire("gscJF");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.maxPool = function(filterSize, strides, pad, dimRoundingMode) {
    this.throwIfDisposed();
    return (0, $gscJF.maxPool)(this, filterSize, strides, pad, dimRoundingMode);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $05cMR = parcelRequire("05cMR");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.max = function(axis, keepDims) {
    this.throwIfDisposed();
    return (0, $05cMR.max)(this, axis, keepDims);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $g5Jt1 = parcelRequire("g5Jt1");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.maximum = function(b) {
    this.throwIfDisposed();
    return (0, $g5Jt1.maximum)(this, b);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $67GCc = parcelRequire("67GCc");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.mean = function(axis, keepDims) {
    this.throwIfDisposed();
    return (0, $67GCc.mean)(this, axis, keepDims);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $fySTI = parcelRequire("fySTI");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.min = function(axis, keepDims) {
    this.throwIfDisposed();
    return (0, $fySTI.min)(this, axis, keepDims);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $6V8xR = parcelRequire("6V8xR");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.minimum = function(b) {
    this.throwIfDisposed();
    return (0, $6V8xR.minimum)(this, b);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $ejlRR = parcelRequire("ejlRR");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.mirrorPad = function(paddings, mode) {
    this.throwIfDisposed();
    return (0, $ejlRR.mirrorPad)(this, paddings, mode);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $jR4my = parcelRequire("jR4my");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.mod = function(b) {
    this.throwIfDisposed();
    return (0, $jR4my.mod)(this, b);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $jZc0w = parcelRequire("jZc0w");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.mul = function(b) {
    this.throwIfDisposed();
    return (0, $jZc0w.mul)(this, b);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $15cGp = parcelRequire("15cGp");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.neg = function() {
    this.throwIfDisposed();
    return (0, $15cGp.neg)(this);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $7k6dx = parcelRequire("7k6dx");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.norm = function(ord, axis, keepDims) {
    this.throwIfDisposed();
    return (0, $7k6dx.norm)(this, ord, axis, keepDims);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8WSnu = parcelRequire("8WSnu");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.notEqual = function(b) {
    this.throwIfDisposed();
    return (0, $8WSnu.notEqual)(this, b);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i3U4j = parcelRequire("i3U4j");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.oneHot = function(depth, onValue = 1, offValue = 0) {
    this.throwIfDisposed();
    return (0, $i3U4j.oneHot)(this, depth, onValue, offValue);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $67iid = parcelRequire("67iid");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.onesLike = function() {
    this.throwIfDisposed();
    return (0, $67iid.onesLike)(this);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $fSZF6 = parcelRequire("fSZF6");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.pad = function(paddings, constantValue) {
    this.throwIfDisposed();
    return (0, $fSZF6.pad)(this, paddings, constantValue);
};



var $9PaVS = parcelRequire("9PaVS");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.pool = function(windowShape, poolingType, padding, dilationRate, strides, dimRoundingMode) {
    this.throwIfDisposed();
    return (0, $9PaVS.pool)(this, windowShape, poolingType, padding, dilationRate, strides, dimRoundingMode);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $ad1of = parcelRequire("ad1of");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.pow = function(exp) {
    this.throwIfDisposed();
    return (0, $ad1of.pow)(this, exp);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $a3pvF = parcelRequire("a3pvF");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.prelu = function(alpha) {
    this.throwIfDisposed();
    return (0, $a3pvF.prelu)(this, alpha);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $bWQC3 = parcelRequire("bWQC3");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.prod = function(axis, keepDims) {
    this.throwIfDisposed();
    return (0, $bWQC3.prod)(this, axis, keepDims);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $3aqJ6 = parcelRequire("3aqJ6");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.reciprocal = function() {
    this.throwIfDisposed();
    return (0, $3aqJ6.reciprocal)(this);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8wbQq = parcelRequire("8wbQq");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.relu = function() {
    this.throwIfDisposed();
    return (0, $8wbQq.relu)(this);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $fvNYr = parcelRequire("fvNYr");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.relu6 = function() {
    this.throwIfDisposed();
    return (0, $fvNYr.relu6)(this);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $4sqA7 = parcelRequire("4sqA7");

var $9jCh7 = parcelRequire("9jCh7");
/**
 * Reshapes the tensor into the shape of the provided tensor.
 *
 * @param x The tensor of required shape.
 *
 * @doc {heading: 'Tensors', subheading: 'Classes'}
 */ (0, $9jCh7.getGlobalTensorClass)().prototype.reshapeAs = function(x) {
    this.throwIfDisposed();
    return (0, $4sqA7.reshape)(this, x.shape);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $4sqA7 = parcelRequire("4sqA7");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.reshape = function(shape) {
    this.throwIfDisposed();
    return (0, $4sqA7.reshape)(this, shape);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $6zgXB = parcelRequire("6zgXB");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.resizeBilinear = function(newShape2D, alignCorners, halfPixelCenters) {
    this.throwIfDisposed();
    return (0, $6zgXB.resizeBilinear)(this, newShape2D, alignCorners, halfPixelCenters);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $ek5OW = parcelRequire("ek5OW");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.resizeNearestNeighbor = function(newShape2D, alignCorners, halfFloatCenters) {
    this.throwIfDisposed();
    return (0, $ek5OW.resizeNearestNeighbor)(this, newShape2D, alignCorners, halfFloatCenters);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $6act6 = parcelRequire("6act6");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.reverse = function(axis) {
    this.throwIfDisposed();
    return (0, $6act6.reverse)(this, axis);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $aosGd = parcelRequire("aosGd");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.rfft = function() {
    this.throwIfDisposed();
    return (0, $aosGd.rfft)(this);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $9YKoa = parcelRequire("9YKoa");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.round = function() {
    this.throwIfDisposed();
    return (0, $9YKoa.round)(this);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $5pj7R = parcelRequire("5pj7R");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.rsqrt = function() {
    this.throwIfDisposed();
    return (0, $5pj7R.rsqrt)(this);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $b636r = parcelRequire("b636r");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.selu = function() {
    this.throwIfDisposed();
    return (0, $b636r.selu)(this);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8uLn4 = parcelRequire("8uLn4");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.separableConv2d = function(depthwiseFilter, pointwiseFilter, strides, pad, dilation, dataFormat) {
    this.throwIfDisposed();
    return (0, $8uLn4.separableConv2d)(this, depthwiseFilter, pointwiseFilter, strides, pad, dilation, dataFormat);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $jvtSq = parcelRequire("jvtSq");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.sigmoid = function() {
    this.throwIfDisposed();
    return (0, $jvtSq.sigmoid)(this);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $3zBCT = parcelRequire("3zBCT");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.sign = function() {
    this.throwIfDisposed();
    return (0, $3zBCT.sign)(this);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $4xqM7 = parcelRequire("4xqM7");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.sin = function() {
    this.throwIfDisposed();
    return (0, $4xqM7.sin)(this);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $fAOzm = parcelRequire("fAOzm");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.sinh = function() {
    this.throwIfDisposed();
    return (0, $fAOzm.sinh)(this);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $79KOG = parcelRequire("79KOG");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.slice = function(begin, size) {
    this.throwIfDisposed();
    return (0, $79KOG.slice)(this, begin, size);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $dnEu5 = parcelRequire("dnEu5");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.softmax = function(dim) {
    this.throwIfDisposed();
    return (0, $dnEu5.softmax)(this, dim);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $4Udpd = parcelRequire("4Udpd");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.softplus = function() {
    this.throwIfDisposed();
    return (0, $4Udpd.softplus)(this);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $ePI8Y = parcelRequire("ePI8Y");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.spaceToBatchND = function(blockShape, paddings) {
    this.throwIfDisposed();
    return (0, $ePI8Y.spaceToBatchND)(this, blockShape, paddings);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9fmAX = parcelRequire("9fmAX");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.split = function(numOrSizeSplits, axis) {
    this.throwIfDisposed();
    return (0, $9fmAX.split)(this, numOrSizeSplits, axis);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $iAb3z = parcelRequire("iAb3z");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.sqrt = function() {
    this.throwIfDisposed();
    return (0, $iAb3z.sqrt)(this);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $iDd8d = parcelRequire("iDd8d");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.square = function() {
    this.throwIfDisposed();
    return (0, $iDd8d.square)(this);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $ay2Nw = parcelRequire("ay2Nw");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.squaredDifference = function(b) {
    this.throwIfDisposed();
    return (0, $ay2Nw.squaredDifference)(this, b);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $kX8Hd = parcelRequire("kX8Hd");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.squeeze = function(axis) {
    this.throwIfDisposed();
    return (0, $kX8Hd.squeeze)(this, axis);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8BrLX = parcelRequire("8BrLX");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.stack = function(x, axis) {
    this.throwIfDisposed();
    const tensorsToBeStacked = x instanceof (0, $9jCh7.Tensor) ? [
        this,
        x
    ] : [
        this,
        ...x
    ];
    return (0, $8BrLX.stack)(tensorsToBeStacked, axis);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $lWdx1 = parcelRequire("lWdx1");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.step = function(alpha) {
    this.throwIfDisposed();
    return (0, $lWdx1.step)(this, alpha);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $dqRnt = parcelRequire("dqRnt");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.stridedSlice = function(begin, end, strides, beginMask, endMask, ellipsisMask, newAxisMask, shrinkAxisMask) {
    this.throwIfDisposed();
    return (0, $dqRnt.stridedSlice)(this, begin, end, strides, beginMask, endMask, ellipsisMask, newAxisMask, shrinkAxisMask);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $7kouu = parcelRequire("7kouu");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.sub = function(b) {
    this.throwIfDisposed();
    return (0, $7kouu.sub)(this, b);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9NgTx = parcelRequire("9NgTx");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.sum = function(axis, keepDims) {
    this.throwIfDisposed();
    return (0, $9NgTx.sum)(this, axis, keepDims);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $l8Hok = parcelRequire("l8Hok");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.tan = function() {
    this.throwIfDisposed();
    return (0, $l8Hok.tan)(this);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $etcYL = parcelRequire("etcYL");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.tanh = function() {
    this.throwIfDisposed();
    return (0, $etcYL.tanh)(this);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $61ay4 = parcelRequire("61ay4");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.tile = function(reps) {
    this.throwIfDisposed();
    return (0, $61ay4.tile)(this, reps);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $inFmq = parcelRequire("inFmq");

var $9jCh7 = parcelRequire("9jCh7");
/**
 * Casts the array to type `bool`
 *
 * @doc {heading: 'Tensors', subheading: 'Classes'}
 */ (0, $9jCh7.getGlobalTensorClass)().prototype.toBool = function() {
    this.throwIfDisposed();
    return (0, $inFmq.cast)(this, 'bool');
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $inFmq = parcelRequire("inFmq");

var $9jCh7 = parcelRequire("9jCh7");
/**
 * Casts the array to type `float32`
 *
 * @doc {heading: 'Tensors', subheading: 'Classes'}
 */ (0, $9jCh7.getGlobalTensorClass)().prototype.toFloat = function() {
    this.throwIfDisposed();
    return (0, $inFmq.cast)(this, 'float32');
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $inFmq = parcelRequire("inFmq");

var $9jCh7 = parcelRequire("9jCh7");
/**
 * Casts the array to type `int32`
 *
 * @doc {heading: 'Tensors', subheading: 'Classes'}
 */ (0, $9jCh7.getGlobalTensorClass)().prototype.toInt = function() {
    this.throwIfDisposed();
    return (0, $inFmq.cast)(this, 'int32');
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $cRAvI = parcelRequire("cRAvI");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.topk = function(k, sorted) {
    this.throwIfDisposed();
    return (0, $cRAvI.topk)(this, k, sorted);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aDHKy = parcelRequire("aDHKy");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.transpose = function(perm) {
    this.throwIfDisposed();
    return (0, $aDHKy.transpose)(this, perm);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aEpp6 = parcelRequire("aEpp6");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.unique = function(axis) {
    this.throwIfDisposed();
    return (0, $aEpp6.unique)(this, axis);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $djGEF = parcelRequire("djGEF");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.unsortedSegmentSum = function(segmentIds, numSegments) {
    this.throwIfDisposed();
    return (0, $djGEF.unsortedSegmentSum)(this, segmentIds, numSegments);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $gBOC6 = parcelRequire("gBOC6");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.unstack = function(axis) {
    this.throwIfDisposed();
    return (0, $gBOC6.unstack)(this, axis);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $l2P14 = parcelRequire("l2P14");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.where = function(condition, x) {
    this.throwIfDisposed();
    return (0, $l2P14.where)(condition, this, x);
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $8EjnK = parcelRequire("8EjnK");

var $9jCh7 = parcelRequire("9jCh7");
(0, $9jCh7.getGlobalTensorClass)().prototype.zerosLike = function() {
    this.throwIfDisposed();
    return (0, $8EjnK.zerosLike)(this);
};




/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * Executor: Evaluates SymbolicTensor based on feeds.
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * Explicit error types.
 *
 * See the following link for more information about why the code includes
 * calls to setPrototypeOf:
 *
 * https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
 */ // tslint:enable
/**
 * Equivalent of Python's AttributeError.
 */ class $af476738b120e938$export$3869bf0637a5d0ff extends Error {
    constructor(message){
        super(message);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, $af476738b120e938$export$3869bf0637a5d0ff.prototype);
    }
}
class $af476738b120e938$export$4a24a86bdbcf02bb extends Error {
    constructor(message){
        super(message);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, $af476738b120e938$export$4a24a86bdbcf02bb.prototype);
    }
}
class $af476738b120e938$export$54d4c18dc78a26d4 extends Error {
    constructor(message){
        super(message);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, $af476738b120e938$export$54d4c18dc78a26d4.prototype);
    }
}
class $af476738b120e938$export$e162153238934121 extends Error {
    constructor(message){
        super(message);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, $af476738b120e938$export$e162153238934121.prototype);
    }
}
class $af476738b120e938$export$7750cdfb4db2c3d extends Error {
    constructor(message){
        super(message);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, $af476738b120e938$export$7750cdfb4db2c3d.prototype);
    }
}
class $af476738b120e938$export$efa5eacb1304c464 extends Error {
    constructor(message){
        super(message);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, $af476738b120e938$export$efa5eacb1304c464.prototype);
    }
}


/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * LruCache: A mapping from the String to T. If the number of the entries is
 * exceeding the `maxEntries`, the LruCache will delete the least recently
 * used entry.
 */ class $f023038a555cadeb$export$ec63a4108685a0aa {
    constructor(maxEntries){
        this.maxEntries = maxEntries || 100;
        this.cache = new Map();
    }
    /**
     * Get the entry for the key and mark it as used recently.
     */ get(key) {
        let entry;
        if (this.cache.has(key)) {
            entry = this.cache.get(key);
            this.cache.delete(key);
            this.cache.set(key, entry);
        }
        return entry;
    }
    /**
     * Put the entry into the cache. If the key already existed, mark the key as
     * used recently.
     */ put(key, value) {
        if (this.cache.has(key)) this.cache.delete(key);
        else if (this.cache.size >= this.maxEntries) {
            const keyToDelete = this.cache.keys().next().value;
            this.cache.delete(keyToDelete);
        }
        this.cache.set(key, value);
    }
    /**
     * Get the MaxEntries of the cache.
     */ getMaxEntries() {
        return this.maxEntries;
    }
    /**
     * Set the MaxEntries of the cache. If the maxEntries is decreased, reduce
     * entries in the cache.
     */ setMaxEntries(maxEntries) {
        if (maxEntries < 0) throw new Error(`The maxEntries of LRU caches must be at least 0, but got ${maxEntries}.`);
        if (this.maxEntries > maxEntries) for(let i = 0; i < this.maxEntries - maxEntries; i++){
            const keyToDelete = this.cache.keys().next().value;
            this.cache.delete(keyToDelete);
        }
        this.maxEntries = maxEntries;
    }
}


/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /* Original source: utils/generic_utils.py */ 
var $i64bB = parcelRequire("i64bB");

function $b5cd0926a1c6df1f$export$f24d1f1e6cb42785(value, numValues) {
    if (Array.isArray(value)) {
        // tslint:disable-next-line:no-any
        let newArray = [];
        for(let i = 0; i < numValues; i++)newArray = newArray.concat(value);
        return newArray;
    } else {
        const newArray = new Array(numValues);
        newArray.fill(value);
        return newArray;
    }
}
function $b5cd0926a1c6df1f$export$a7a9523472993e97(val, message) {
    if (!val) throw new (0, $af476738b120e938$export$7750cdfb4db2c3d)(message);
}
function $b5cd0926a1c6df1f$export$85b9a36db797e02b(array, refernce) {
    let counter = 0;
    for (const item of array)if (item === refernce) counter++;
    return counter;
}
function $b5cd0926a1c6df1f$export$8366660815493a21(xs) {
    if (xs.length === 1) return xs[0];
    return xs;
}
function $b5cd0926a1c6df1f$export$effcdbd76139450(x) {
    if (Array.isArray(x)) return x;
    return [
        x
    ];
}
function $b5cd0926a1c6df1f$export$a75d309e098886ab(objs) {
    const objectList = $b5cd0926a1c6df1f$export$effcdbd76139450(objs);
    let retVal = '';
    for (const obj of objectList){
        if (obj.id == null) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Object ${obj} passed to objectListUid without an id`);
        if (retVal !== '') retVal = retVal + ', ';
        retVal = `${retVal}${Math.abs(obj.id)}`;
    }
    return retVal;
}
function $b5cd0926a1c6df1f$export$cc8b315fc368b20a(name) {
    const intermediate = name.replace(/(.)([A-Z][a-z0-9]+)/g, '$1_$2');
    const insecure = intermediate.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase();
    /*
     If the class is private the name starts with "_" which is not secure
     for creating scopes. We prefix the name with "private" in this case.
     */ if (insecure[0] !== '_') return insecure;
    return 'private' + insecure;
}
function $b5cd0926a1c6df1f$export$86f54f62aa7a7514(identifier) {
    // quick return for empty string or single character strings
    if (identifier.length <= 1) return identifier;
    // Check for the underscore indicating snake_case
    if (identifier.indexOf('_') === -1) return identifier;
    return identifier.replace(/[_]+(\w|$)/g, (m, p1)=>p1.toUpperCase());
}
// tslint:disable-next-line:no-any
let $b5cd0926a1c6df1f$var$_GLOBAL_CUSTOM_OBJECTS = {};
function $b5cd0926a1c6df1f$export$78f846918d17a884(instance) {
    if (instance === null || instance === undefined) return null;
    const dict = {};
    dict['className'] = instance.getClassName();
    dict['config'] = instance.getConfig();
    return dict;
}
/**
 * Replace ndarray-style scalar objects in serialization objects with numbers.
 *
 * Background: In some versions of tf.keras, certain scalar values in the HDF5
 * model save file can be serialized as: `{'type': 'ndarray', 'value': num}`,
 * where in `num` is a plain number. This method converts such serialization
 * to a `number`.
 *
 * @param config The keras-format serialization object to be processed
 *   (in place).
 */ function $b5cd0926a1c6df1f$var$convertNDArrayScalarsInConfig(config) {
    if (config == null || typeof config !== 'object') return;
    else if (Array.isArray(config)) config.forEach((configItem)=>$b5cd0926a1c6df1f$var$convertNDArrayScalarsInConfig(configItem));
    else {
        const fields = Object.keys(config);
        for (const field of fields){
            const value = config[field];
            if (value != null && typeof value === 'object') {
                if (!Array.isArray(value) && value['type'] === 'ndarray' && typeof value['value'] === 'number') config[field] = value['value'];
                else $b5cd0926a1c6df1f$var$convertNDArrayScalarsInConfig(value);
            }
        }
    }
}
function $b5cd0926a1c6df1f$export$c33061eb381c60f9(identifier, moduleObjects = {}, customObjects = {}, printableModuleName = 'object', fastWeightInit = false) {
    // tslint:enable
    if (typeof identifier === 'string') {
        const functionName = identifier;
        let fn;
        if (functionName in customObjects) fn = customObjects[functionName];
        else if (functionName in $b5cd0926a1c6df1f$var$_GLOBAL_CUSTOM_OBJECTS) fn = $b5cd0926a1c6df1f$var$_GLOBAL_CUSTOM_OBJECTS[functionName];
        else {
            fn = moduleObjects[functionName];
            if (fn == null) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Unknown ${printableModuleName}: ${identifier}. ` + `This may be due to one of the following reasons:\n` + `1. The ${printableModuleName} is defined in Python, in which ` + `case it needs to be ported to TensorFlow.js or your JavaScript ` + `code.\n` + `2. The custom ${printableModuleName} is defined in JavaScript, ` + `but is not registered properly with ` + `tf.serialization.registerClass().`);
        }
        return fn;
    } else {
        // In this case we are dealing with a Keras config dictionary.
        const config = identifier;
        if (config['className'] == null || config['config'] == null) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`${printableModuleName}: Improper config format: ` + `${JSON.stringify(config)}.\n` + `'className' and 'config' must set.`);
        const className = config['className'];
        let cls, fromConfig;
        if (className in customObjects) [cls, fromConfig] = customObjects[className];
        else if (className in $b5cd0926a1c6df1f$var$_GLOBAL_CUSTOM_OBJECTS) [cls, fromConfig] = $b5cd0926a1c6df1f$var$_GLOBAL_CUSTOM_OBJECTS['className'];
        else if (className in moduleObjects) [cls, fromConfig] = moduleObjects[className];
        if (cls == null) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Unknown ${printableModuleName}: ${className}. ` + `This may be due to one of the following reasons:\n` + `1. The ${printableModuleName} is defined in Python, in which ` + `case it needs to be ported to TensorFlow.js or your JavaScript ` + `code.\n` + `2. The custom ${printableModuleName} is defined in JavaScript, ` + `but is not registered properly with ` + `tf.serialization.registerClass().`);
        if (fromConfig != null) {
            // Porting notes: Instead of checking to see whether fromConfig accepts
            // customObjects, we create a customObjects dictionary and tack it on to
            // config['config'] as config['config'].customObjects. Objects can use it,
            // if they want.
            // tslint:disable-next-line:no-any
            const customObjectsCombined = {};
            for (const key of Object.keys($b5cd0926a1c6df1f$var$_GLOBAL_CUSTOM_OBJECTS))customObjectsCombined[key] = $b5cd0926a1c6df1f$var$_GLOBAL_CUSTOM_OBJECTS[key];
            for (const key of Object.keys(customObjects))customObjectsCombined[key] = customObjects[key];
            // Add the customObjects to config
            const nestedConfig = config['config'];
            nestedConfig['customObjects'] = customObjectsCombined;
            const backupCustomObjects = Object.assign({}, $b5cd0926a1c6df1f$var$_GLOBAL_CUSTOM_OBJECTS);
            for (const key of Object.keys(customObjects))$b5cd0926a1c6df1f$var$_GLOBAL_CUSTOM_OBJECTS[key] = customObjects[key];
            $b5cd0926a1c6df1f$var$convertNDArrayScalarsInConfig(config['config']);
            const returnObj = fromConfig(cls, config['config'], customObjects, fastWeightInit);
            $b5cd0926a1c6df1f$var$_GLOBAL_CUSTOM_OBJECTS = Object.assign({}, backupCustomObjects);
            return returnObj;
        } else {
            // Then `cls` may be a function returning a class.
            // In this case by convention `config` holds
            // the kwargs of the function.
            const backupCustomObjects = Object.assign({}, $b5cd0926a1c6df1f$var$_GLOBAL_CUSTOM_OBJECTS);
            for (const key of Object.keys(customObjects))$b5cd0926a1c6df1f$var$_GLOBAL_CUSTOM_OBJECTS[key] = customObjects[key];
            // In python this is **config['config'], for tfjs-layers we require
            // classes that use this fall-through construction method to take
            // a config interface that mimics the expansion of named parameters.
            const returnObj = new cls(config['config']);
            $b5cd0926a1c6df1f$var$_GLOBAL_CUSTOM_OBJECTS = Object.assign({}, backupCustomObjects);
            return returnObj;
        }
    }
}
function $b5cd0926a1c6df1f$export$d40c4ae552b5068b(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}
function $b5cd0926a1c6df1f$export$964007bb9b7e1f75(a, b) {
    return -1 * $b5cd0926a1c6df1f$export$d40c4ae552b5068b(a, b);
}
function $b5cd0926a1c6df1f$export$1502380f22ccb6a5(dtype) {
    switch(dtype){
        case 'float32':
            return 'float32';
        default:
            throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Invalid dtype: ${dtype}`);
    }
}
function $b5cd0926a1c6df1f$export$cc4775daf8d91b53(xs, ys) {
    if (xs == null || ys == null) return xs === ys;
    if (xs.length !== ys.length) return false;
    for(let i = 0; i < xs.length; ++i){
        if (xs[i] !== ys[i]) return false;
    }
    return true;
}
function $b5cd0926a1c6df1f$export$7a5d5c156e7dc406(xs) {
    if (xs == null) return xs;
    const out = [];
    // TODO(cais): Maybe improve performance by sorting.
    for (const x of xs)if (out.indexOf(x) === -1) out.push(x);
    return out;
}
function $b5cd0926a1c6df1f$export$23cfe696632d10f4(obj) {
    if (obj == null) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Invalid value in obj: ${JSON.stringify(obj)}`);
    for(const key in obj){
        if (obj.hasOwnProperty(key)) return false;
    }
    return true;
}
function $b5cd0926a1c6df1f$export$f49e87e6cde0274b(values, label, value) {
    if (value == null) return;
    if (values.indexOf(value) < 0) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`${value} is not a valid ${label}.  Valid values are ${values} or null/undefined.`);
}
function $b5cd0926a1c6df1f$export$9c1c2eaf0ddbb1d3(x, expectedType, minLength = 0, maxLength = Infinity) {
    $b5cd0926a1c6df1f$export$a7a9523472993e97(minLength >= 0);
    $b5cd0926a1c6df1f$export$a7a9523472993e97(maxLength >= minLength);
    return Array.isArray(x) && x.length >= minLength && x.length <= maxLength && x.every((e)=>typeof e === expectedType);
}
function $b5cd0926a1c6df1f$export$7ac3b6580cbed983(value, name) {
    if (Array.isArray(value)) {
        (0, $i64bB.util).assert(value.length > 0, ()=>`${name} is unexpectedly an empty array.`);
        value.forEach((v, i)=>$b5cd0926a1c6df1f$export$7ac3b6580cbed983(v, `element ${i + 1} of ${name}`));
    } else (0, $i64bB.util).assert(Number.isInteger(value) && value > 0, ()=>`Expected ${name} to be a positive integer, but got ` + `${$b5cd0926a1c6df1f$export$7a0c59ae8d81831f(value)}.`);
}
function $b5cd0926a1c6df1f$export$7a0c59ae8d81831f(value) {
    if (value === null) return 'null';
    else if (Array.isArray(value)) return '[' + value.map((v)=>$b5cd0926a1c6df1f$export$7a0c59ae8d81831f(v)).join(',') + ']';
    else if (typeof value === 'string') return `"${value}"`;
    else return `${value}`;
}
function $b5cd0926a1c6df1f$export$61fc7d43ac8f84b0(f, waitMs, nowFunc) {
    let lastTime = nowFunc != null ? nowFunc() : (0, $i64bB.util).now();
    let lastResult;
    const f2 = (...args)=>{
        const now = nowFunc != null ? nowFunc() : (0, $i64bB.util).now();
        if (now - lastTime < waitMs) return lastResult;
        lastTime = now;
        lastResult = f(...args);
        return lastResult;
    };
    return f2;
}
function $b5cd0926a1c6df1f$export$aa3e0e68e0c6329f(activationName) {
    if (activationName === 'relu') return 'relu';
    if (activationName === 'linear') return 'linear';
    if (activationName === 'elu') return 'elu';
    return null;
}
function $b5cd0926a1c6df1f$export$a670de672a83f477(...arrayOfValues) {
    $b5cd0926a1c6df1f$export$a7a9523472993e97(arrayOfValues.length > 0, 'arrayOfValues is empty');
    for (const values of arrayOfValues){
        $b5cd0926a1c6df1f$export$a7a9523472993e97(Array.isArray(values), 'one of the values is not an array');
        $b5cd0926a1c6df1f$export$a7a9523472993e97(values.length > 0, 'one of the values is empty');
    }
    return arrayOfValues.reduce((products, values)=>{
        if (products.length === 0) return values.map((value)=>[
                value
            ]);
        return values.map((value)=>{
            return products.map((prevValue)=>[
                    ...prevValue,
                    value
                ]);
        }).reduce((flattenedProduct, unflattenedProduct)=>{
            return flattenedProduct.concat(unflattenedProduct);
        }, []);
    }, []);
}


/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * Utilities related to persistent state in the backend.
 */ /**
 * An ID to track `tf.SymbolicTensor`s and derived classes.
 * Required in different places in engine/topology.ts to identify unique
 * tensors.
 */ let $cde2737e4648ad82$var$_nextUniqueTensorId = 0;
function $cde2737e4648ad82$export$b7ad53ecc0eccaf() {
    return $cde2737e4648ad82$var$_nextUniqueTensorId++;
}
const $cde2737e4648ad82$var$_uidPrefixes = {};
function $cde2737e4648ad82$export$5e82334337e0f204(prefix = '') {
    if (!(prefix in $cde2737e4648ad82$var$_uidPrefixes)) $cde2737e4648ad82$var$_uidPrefixes[prefix] = 0;
    $cde2737e4648ad82$var$_uidPrefixes[prefix] += 1;
    return prefix + $cde2737e4648ad82$var$_uidPrefixes[prefix].toString();
}



/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /* Original source: keras/engine/topology.py */ 
var $i64bB = parcelRequire("i64bB");

/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * Common functions for TensorFlow.js Layers.
 */ /**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ const $a55a2b5e485fd150$export$57a9e614626b5380 = [
    'channelsFirst',
    'channelsLast'
];
const $a55a2b5e485fd150$export$b8823bf7d44e4d59 = [
    'nearest',
    'bilinear'
];
const $a55a2b5e485fd150$export$48aea51acf1bce87 = [
    'valid',
    'same',
    'causal'
];
const $a55a2b5e485fd150$export$f450a7a6767a84d4 = [
    'max',
    'avg'
];
const $a55a2b5e485fd150$export$954d8bae11304008 = [
    'sum',
    'mul',
    'concat',
    'ave'
];
const $a55a2b5e485fd150$export$96db941b47dbf9ff = [
    'temporal'
];



// A map from the requested scoped name of a Tensor to the number of Tensors
// wanting that name so far.  This allows enforcing name uniqueness by appending
// an incrementing index, e.g. scope/name, scope/name_1, scope/name_2, etc.
const $860027d3b2c99a1d$var$nameMap = new Map();
function $860027d3b2c99a1d$export$f5f6472a2b993816(value) {
    (0, $b5cd0926a1c6df1f$export$f49e87e6cde0274b)((0, $a55a2b5e485fd150$export$57a9e614626b5380), 'DataFormat', value);
}
function $860027d3b2c99a1d$export$2c8c51ca0cb16cd2(value) {
    (0, $b5cd0926a1c6df1f$export$f49e87e6cde0274b)((0, $a55a2b5e485fd150$export$b8823bf7d44e4d59), 'InterpolationFormat', value);
}
function $860027d3b2c99a1d$export$a6c1e84f1d33d64d(value) {
    (0, $b5cd0926a1c6df1f$export$f49e87e6cde0274b)((0, $a55a2b5e485fd150$export$48aea51acf1bce87), 'PaddingMode', value);
}
function $860027d3b2c99a1d$export$4ac7885ddd005702(value) {
    (0, $b5cd0926a1c6df1f$export$f49e87e6cde0274b)((0, $a55a2b5e485fd150$export$f450a7a6767a84d4), 'PoolMode', value);
}
const $860027d3b2c99a1d$var$_nameScopeStack = [];
const $860027d3b2c99a1d$var$_nameScopeDivider = '/';
function $860027d3b2c99a1d$export$e820b4f57a8e33d1(name, fn) {
    $860027d3b2c99a1d$var$_nameScopeStack.push(name);
    try {
        const val = fn();
        $860027d3b2c99a1d$var$_nameScopeStack.pop();
        return val;
    } catch (e) {
        $860027d3b2c99a1d$var$_nameScopeStack.pop();
        throw e;
    }
}
/**
 * Get the current namescope as a flat, concatenated string.
 */ function $860027d3b2c99a1d$var$currentNameScopePrefix() {
    if ($860027d3b2c99a1d$var$_nameScopeStack.length === 0) return '';
    else return $860027d3b2c99a1d$var$_nameScopeStack.join($860027d3b2c99a1d$var$_nameScopeDivider) + $860027d3b2c99a1d$var$_nameScopeDivider;
}
function $860027d3b2c99a1d$export$ff30fd7baa750729(tensorName) {
    if (!$860027d3b2c99a1d$export$f372abc09dacf0d5(tensorName)) throw new Error('Not a valid tensor name: \'' + tensorName + '\'');
    return $860027d3b2c99a1d$var$currentNameScopePrefix() + tensorName;
}
function $860027d3b2c99a1d$export$9227bff0c10d827e(scopedName) {
    if (!$860027d3b2c99a1d$export$f372abc09dacf0d5(scopedName)) throw new Error('Not a valid tensor name: \'' + scopedName + '\'');
    if (!$860027d3b2c99a1d$var$nameMap.has(scopedName)) $860027d3b2c99a1d$var$nameMap.set(scopedName, 0);
    const index = $860027d3b2c99a1d$var$nameMap.get(scopedName);
    $860027d3b2c99a1d$var$nameMap.set(scopedName, $860027d3b2c99a1d$var$nameMap.get(scopedName) + 1);
    if (index > 0) {
        const result = `${scopedName}_${index}`;
        // Mark the composed name as used in case someone wants
        // to call getUniqueTensorName("name_1").
        $860027d3b2c99a1d$var$nameMap.set(result, 1);
        return result;
    } else return scopedName;
}
const $860027d3b2c99a1d$var$tensorNameRegex = new RegExp(/^[A-Za-z0-9][-A-Za-z0-9\._\/]*$/);
function $860027d3b2c99a1d$export$f372abc09dacf0d5(name) {
    return !!name.match($860027d3b2c99a1d$var$tensorNameRegex);
}



/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * deeplearn.js backend.
 */ 
var $i64bB = parcelRequire("i64bB");


/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * Math utility functions.
 *
 * This file contains some frequently used math function that operates on
 * number[] or Float32Array and return a number. Many of these functions are
 * not-so-thick wrappers around TF.js Core functions. But they offer the
 * convenience of
 * 1) not having to convert the inputs into Tensors,
 * 2) not having to convert the returned Tensors to numbers.
 */ 
function $edee0645f45d9428$export$a287f47fed4544b8(x) {
    return x === parseInt(x.toString(), 10);
}
function $edee0645f45d9428$export$3b5d61e59fec5e86(array, begin, end) {
    if (begin == null) begin = 0;
    if (end == null) end = array.length;
    let prod = 1;
    for(let i = begin; i < end; ++i)prod *= array[i];
    return prod;
}
function $edee0645f45d9428$export$96ec731ed4dcb222(array) {
    // same behavior as tf.min()
    if (array.length === 0) return Number.NaN;
    let min = Number.POSITIVE_INFINITY;
    for(let i = 0; i < array.length; i++){
        const value = array[i];
        if (value < min) min = value;
    }
    return min;
}
function $edee0645f45d9428$export$8960430cfd85939f(array) {
    // same behavior as tf.max()
    if (array.length === 0) return Number.NaN;
    let max = Number.NEGATIVE_INFINITY;
    for(let i = 0; i < array.length; i++){
        const value = array[i];
        if (value > max) max = value;
    }
    return max;
}
function $edee0645f45d9428$export$8a63f25cc62965f1(array) {
    let sum = 0;
    for(let i = 0; i < array.length; i++){
        const value = array[i];
        sum += value;
    }
    return sum;
}
function $edee0645f45d9428$export$1ce691f85baaa52(array) {
    return $edee0645f45d9428$export$8a63f25cc62965f1(array) / array.length;
}
function $edee0645f45d9428$export$9b77da0927470c3d(array) {
    const meanValue = $edee0645f45d9428$export$1ce691f85baaa52(array);
    const demeaned = array.map((value)=>value - meanValue);
    let sumSquare = 0;
    for(let i = 0; i < demeaned.length; i++){
        const value = demeaned[i];
        sumSquare += value * value;
    }
    return sumSquare / array.length;
}
function $edee0645f45d9428$export$9c490b34b2f16a34(array) {
    const arraySorted = array.slice().sort((a, b)=>a - b);
    const lowIdx = Math.floor((arraySorted.length - 1) / 2);
    const highIdx = Math.ceil((arraySorted.length - 1) / 2);
    if (lowIdx === highIdx) return arraySorted[lowIdx];
    return (arraySorted[lowIdx] + arraySorted[highIdx]) / 2;
}
function $edee0645f45d9428$export$d02631cccf789723(begin, end) {
    if (end < begin) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`end (${end}) < begin (${begin}) is forbidden.`);
    const out = [];
    for(let i = begin; i < end; ++i)out.push(i);
    return out;
}


/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
let $043e1401aa799097$var$_epsilon;
function $043e1401aa799097$export$6c421550c66a327d() {
    if ($043e1401aa799097$var$_epsilon == null) $043e1401aa799097$var$_epsilon = (0, $i64bB.backend)().epsilon();
    return $043e1401aa799097$var$_epsilon;
}
function $043e1401aa799097$export$15daaec7a0b3c780(e) {
    $043e1401aa799097$var$_epsilon = e;
}
function $043e1401aa799097$export$9cb785636e5e0d8() {
    return 'channelsLast';
}


// tslint:enable
/* Setting and getting backend from deeplearn.js. */ // Default deeplearn.js backend is WebGL (GPU).
let $33b0bdd0433db936$var$backend = 'webgl';
function $33b0bdd0433db936$export$7953970fabc9c2(requestedBackend) {
    $i64bB.setBackend(requestedBackend);
    $33b0bdd0433db936$var$backend = requestedBackend;
}
function $33b0bdd0433db936$export$b098501f764cdf30() {
    return $33b0bdd0433db936$var$backend;
}
function $33b0bdd0433db936$export$c3a33bdbf7249794() {
    return false;
}
function $33b0bdd0433db936$export$230bf2dc3171638d(x) {
    const shape = x.shape;
    if (shape.length > 0) return shape.reduce((a, b)=>a * b);
    else // Scalar.
    return 1;
}
function $33b0bdd0433db936$export$f2db7d5238e1d23f(x, dtype) {
    return $i64bB.cast(x, dtype);
}
function $33b0bdd0433db936$export$d660d8ed21f46635(x, axis = -1) {
    const outShape = x.shape.slice();
    if (axis < 0) axis = outShape.length + axis + 1;
    outShape.splice(axis, 0, 1);
    return $i64bB.reshape(x, outShape);
}
function $33b0bdd0433db936$export$76d90c956114f2c2(x, n) {
    return (0, $i64bB.tidy)(()=>{
        if (x.shape.length !== 2) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`repeat() expects a rank-2 tensor, but received a ` + `rank-${x.shape.length} tensor.`);
        const y = $33b0bdd0433db936$export$d660d8ed21f46635(x, 1);
        return $33b0bdd0433db936$export$3c17558da18e4d75(y, [
            1,
            n,
            1
        ]);
    });
}
function $33b0bdd0433db936$export$bffa455ba8c619a6(x) {
    const newShape = [
        $edee0645f45d9428$export$3b5d61e59fec5e86(x.shape)
    ];
    return $i64bB.reshape(x, newShape);
}
function $33b0bdd0433db936$export$6d182438241cb7ab(x) {
    if (x.rank <= 1) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`batchFlatten requires a minimum rank of 2. Got rank: ${x.rank}.`);
    const newShape = [
        x.shape[0],
        $edee0645f45d9428$export$3b5d61e59fec5e86(x.shape, 1)
    ];
    return $i64bB.reshape(x, newShape);
}
function $33b0bdd0433db936$export$4f266636a9634575(array, start, size) {
    return (0, $i64bB.tidy)(()=>{
        switch(array.rank){
            case 1:
                return $i64bB.slice1d(array, start, size);
            case 2:
                return $i64bB.slice2d(array, [
                    start,
                    0
                ], [
                    size,
                    array.shape[1]
                ]);
            case 3:
                return $i64bB.slice3d(array, [
                    start,
                    0,
                    0
                ], [
                    size,
                    array.shape[1],
                    array.shape[2]
                ]);
            case 4:
                return $i64bB.slice4d(array, [
                    start,
                    0,
                    0,
                    0
                ], [
                    size,
                    array.shape[1],
                    array.shape[2],
                    array.shape[3]
                ]);
            case 5:
                return $i64bB.slice(array, [
                    start,
                    0,
                    0,
                    0,
                    0
                ], [
                    size,
                    array.shape[1],
                    array.shape[2],
                    array.shape[3],
                    array.shape[4]
                ]);
            case 6:
                return $i64bB.slice(array, [
                    start,
                    0,
                    0,
                    0,
                    0,
                    0
                ], [
                    size,
                    array.shape[1],
                    array.shape[2],
                    array.shape[3],
                    array.shape[4],
                    array.shape[5]
                ]);
            default:
                throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`sliceAlongFirstAxis() received an unsupported tensor rank: ` + `${array.rank}`);
        }
    });
}
function $33b0bdd0433db936$export$7eb01d0ca77de013(array, start, size) {
    return (0, $i64bB.tidy)(()=>{
        switch(array.rank){
            case 1:
                return $i64bB.slice1d(array, start, size);
            case 2:
                return $i64bB.slice2d(array, [
                    0,
                    start
                ], [
                    array.shape[0],
                    size
                ]);
            case 3:
                return $i64bB.slice3d(array, [
                    0,
                    0,
                    start
                ], [
                    array.shape[0],
                    array.shape[1],
                    size
                ]);
            case 4:
                return $i64bB.slice4d(array, [
                    0,
                    0,
                    0,
                    start
                ], [
                    array.shape[0],
                    array.shape[1],
                    array.shape[2],
                    size
                ]);
            default:
                throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`sliceAlongLastAxis() received an unsupported tensor rank: ` + `${array.rank}`);
        }
    });
}
function $33b0bdd0433db936$export$4f25f657b7083746(array, start, size, axis) {
    return (0, $i64bB.tidy)(()=>{
        switch(array.rank){
            case 1:
                return $i64bB.slice1d(array, start, size);
            case 2:
                switch(axis){
                    case 1:
                        return $33b0bdd0433db936$export$4f266636a9634575(array, start, size);
                    case 2:
                        return $33b0bdd0433db936$export$7eb01d0ca77de013(array, start, size);
                    default:
                        throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`The axis is not within the rank of the tensor ` + `${axis}`);
                }
            case 3:
                switch(axis){
                    case 1:
                        return $33b0bdd0433db936$export$4f266636a9634575(array, start, size);
                    case 2:
                        return $i64bB.slice3d(array, [
                            0,
                            start,
                            0
                        ], [
                            array.shape[0],
                            size,
                            array.shape[2]
                        ]);
                    case 3:
                        return $33b0bdd0433db936$export$7eb01d0ca77de013(array, start, size);
                    default:
                        throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`The axis is not within the rank of the tensor ` + `${axis}`);
                }
            case 4:
                switch(axis){
                    case 1:
                        return $33b0bdd0433db936$export$4f266636a9634575(array, start, size);
                    case 2:
                        return $i64bB.slice4d(array, [
                            0,
                            start,
                            0,
                            0
                        ], [
                            array.shape[0],
                            size,
                            array.shape[2],
                            array.shape[3]
                        ]);
                    case 3:
                        return $i64bB.slice4d(array, [
                            0,
                            0,
                            start,
                            0
                        ], [
                            array.shape[0],
                            array.shape[1],
                            size,
                            array.shape[3]
                        ]);
                    case 4:
                        return $33b0bdd0433db936$export$7eb01d0ca77de013(array, start, size);
                    default:
                        throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`The axis is not within the rank of the tensor ` + `${axis}`);
                }
            default:
                throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`sliceAlongLastAxis() received an unsupported tensor rank: ` + `${array.rank}`);
        }
    });
}
function $33b0bdd0433db936$export$375c71d43969527d(tensors, axis = -1) {
    let rank;
    if (axis < 0) {
        rank = tensors[0].rank;
        if (rank !== 0) axis = rank;
        else axis = 0;
    }
    if (axis === tensors[0].rank) // Porting Note: This is necessary because tfc.concat() requires axis to be
    //   in the interval [-rank, rank).
    axis = -1;
    // Porting Note: Sparse concat is not supported yet.
    return $i64bB.concat(tensors, axis);
}
function $33b0bdd0433db936$export$2c8a4d3eab2092a2(a, b) {
    switch(a.rank){
        case 1:
            return $i64bB.concat1d([
                a,
                b
            ]);
        case 2:
            return $i64bB.concat2d([
                a,
                b
            ], 0);
        case 3:
            return $i64bB.concat3d([
                a,
                b
            ], 0);
        case 4:
            return $i64bB.concat4d([
                a,
                b
            ], 0);
        default:
            throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`concatAlongFirstAxis() received an unsupported ` + `tensor rank: ${a.rank}`);
    }
}
function $33b0bdd0433db936$export$3c17558da18e4d75(x, n) {
    if (!Array.isArray(n)) n = [
        n
    ];
    if (x.rank !== n.length) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`The length of input n (${n.length}) does not match ` + `the number of dimensions in input x (${x.rank})`);
    return $i64bB.tile(x, n);
}
function $33b0bdd0433db936$export$a0ac5549a8bec918(shape, mean = 0.0, stddev = 1.0, dtype, seed) {
    return $i64bB.randomNormal(shape, mean, stddev, dtype, seed);
}
function $33b0bdd0433db936$export$94132a0e348806d4(a, b, activation, bias) {
    if (a.rank < 2 || b.rank < 2) throw new (0, $af476738b120e938$export$e162153238934121)(`dot requires both inputs to be rank >= 2` + ` but got x shape = ${a.shape} and y shape = ${b.shape}`);
    if (b.rank >= 3) {
        const xLastDim = a.shape.slice(-1)[0];
        const ySecondLastDim = b.shape.slice(-2)[0];
        if (xLastDim !== ySecondLastDim) throw new (0, $af476738b120e938$export$e162153238934121)(`If rank y >= 3, then the second last dim` + ` of y must equal the last dim of x but got x shape = ${a.shape} and ` + ` y shape = ${b.shape}`);
    }
    // Handle basic 2D x 2D case.
    if (a.rank === 2 && b.rank === 2) {
        const transposeA = false;
        const transposeB = false;
        // tfc.fused.matMul only fuses certain activation functions. Unsupported
        // activation functions are treated as 'linear' activations, which is
        // equivalent to a no-op.
        return $i64bB.fused.matMul({
            a: a,
            b: b,
            transposeA: transposeA,
            transposeB: transposeB,
            bias: bias ? $33b0bdd0433db936$var$reshapeBias(a.rank, bias, (0, $043e1401aa799097$export$9cb785636e5e0d8)()) : null,
            activation: activation
        });
    } else {
        // Reshape x into the analogous 2D Tensor.
        const aFirstDims = a.shape.slice(); // Holds all but the last dim of x.
        const aLastDim = aFirstDims.pop();
        a = $i64bB.reshape(a, [
            -1,
            aLastDim
        ]);
        // Reshape y into the analogous 2D Tensor, and keep track of the
        // required dimensions to reproduce the output shape.
        const bShape = b.shape.slice();
        const bLastDim = bShape.pop();
        const ySecondLastDim = bShape.pop();
        const yOtherDims = [
            ...bShape,
            bLastDim
        ];
        // permutation should be like [r-2, 0, 1, 2, ... r-4, r-3, r-1]
        // where r is the rank of y.
        const perm = Array.from({
            length: b.rank
        }, (_, i)=>{
            if (i === 0) return b.rank - 2;
            else if (i <= b.rank - 2) return i - 1;
            return i;
        });
        b = $i64bB.reshape($i64bB.transpose(b, perm), [
            ySecondLastDim,
            -1
        ]);
        // Multiply x and y as 2D Tensors, and then reshape back to original.
        const outputShape = [
            ...aFirstDims,
            ...yOtherDims
        ];
        const transposeA = false;
        const transposeB = false;
        return $i64bB.reshape($i64bB.fused.matMul({
            a: a,
            b: b,
            transposeA: transposeA,
            transposeB: transposeB,
            bias: bias ? $33b0bdd0433db936$var$reshapeBias(a.rank, bias, (0, $043e1401aa799097$export$9cb785636e5e0d8)()) : null,
            activation: activation
        }), outputShape);
    }
}
function $33b0bdd0433db936$export$c5552dfdbc7cec71(x) {
    // TODO(cais): Move to the core.
    return (0, $i64bB.tidy)(()=>{
        const zerosLikeX = (0, $i64bB.zerosLike)(x);
        const onesLikeX = (0, $i64bB.onesLike)(x);
        return (0, $i64bB.where)($i64bB.equal(x, zerosLikeX), zerosLikeX, (0, $i64bB.where)($i64bB.greater(x, (0, $i64bB.zerosLike)(x)), onesLikeX, $i64bB.mul(-1, onesLikeX)));
    });
}
function $33b0bdd0433db936$export$341b5490a776d041(indices, numClasses) {
    return (0, $i64bB.tidy)(()=>{
        if (indices.rank !== 1) throw new Error("Only 1D one-hot tensors are supported in the deeplearn backend, at present.");
        indices = $i64bB.cast(indices, 'int32');
        return $i64bB.cast($i64bB.oneHot(indices, numClasses), 'float32');
    });
}
function $33b0bdd0433db936$export$9e05546f00427e8(reference, indices, axis) {
    return (0, $i64bB.tidy)(()=>{
        if (Array.isArray(indices)) indices = (0, $i64bB.tensor1d)(indices, 'int32');
        else indices = $i64bB.cast(indices, 'int32');
        return $i64bB.gather(reference, indices, axis);
    });
}
function $33b0bdd0433db936$export$dd4f28cef696bc7d(x) {
    return $i64bB.mul(x, x);
}
function $33b0bdd0433db936$export$9c297f60e22e3389(x, a) {
    return (0, $i64bB.tidy)(()=>{
        if (typeof a === 'number') a = (0, $i64bB.scalar)(Math.round(a), 'int32');
        if (a.dtype !== 'int32') throw new (0, $af476738b120e938$export$e162153238934121)(`Non-int32 dtype (${a.dtype}) is not supported by pow() yet`);
        return $i64bB.pow(x, a);
    });
}
/**
 * Reshapes bias tensor according to rank of x.
 */ function $33b0bdd0433db936$var$reshapeBias(xRank, bias, dataFormat) {
    const biasShape = bias.shape;
    if (bias.rank !== 1 && bias.rank !== xRank) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Unexpected bias dimensions: ${bias.rank}` + `; expected it to be 1 or ${xRank}`);
    if (xRank === 5) {
        if (dataFormat === 'channelsFirst') {
            if (biasShape.length === 1) return $i64bB.reshape(bias, [
                1,
                biasShape[0],
                1,
                1,
                1
            ]);
            else return $i64bB.reshape(bias, [
                1,
                biasShape[3],
                biasShape[0],
                biasShape[1],
                biasShape[2]
            ]);
        } else if (dataFormat === 'channelsLast') {
            if (biasShape.length === 1) return $i64bB.reshape(bias, [
                1,
                1,
                1,
                1,
                biasShape[0]
            ]);
            else return $i64bB.reshape(bias, [
                1
            ].concat(biasShape));
        }
    } else if (xRank === 4) {
        if (dataFormat === 'channelsFirst') {
            if (biasShape.length === 1) return $i64bB.reshape(bias, [
                1,
                biasShape[0],
                1,
                1
            ]);
            else return $i64bB.reshape(bias, [
                1,
                biasShape[2],
                biasShape[0],
                biasShape[1]
            ]);
        } else if (dataFormat === 'channelsLast') {
            if (biasShape.length === 1) return $i64bB.reshape(bias, [
                1,
                1,
                1,
                biasShape[0]
            ]);
            else return $i64bB.reshape(bias, [
                1
            ].concat(biasShape));
        }
    } else if (xRank === 3) {
        if (dataFormat === 'channelsFirst') {
            if (biasShape.length === 1) return $i64bB.reshape(bias, [
                1,
                biasShape[0],
                1
            ]);
            else return $i64bB.reshape(bias, [
                1,
                biasShape[1],
                biasShape[0]
            ]);
        } else if (dataFormat === 'channelsLast') {
            if (biasShape.length === 1) return $i64bB.reshape(bias, [
                1,
                1,
                biasShape[0]
            ]);
            else return $i64bB.reshape(bias, [
                1
            ].concat(biasShape));
        }
    } else if (xRank < 3) return bias;
    throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Unsupported input rank by biasAdd: ${bias.rank}`);
}
function $33b0bdd0433db936$export$917ce53bce63bd4b(x, bias, dataFormat) {
    return (0, $i64bB.tidy)(()=>{
        if (dataFormat == null) dataFormat = (0, $043e1401aa799097$export$9cb785636e5e0d8)();
        (0, $860027d3b2c99a1d$export$f5f6472a2b993816)(dataFormat);
        return $i64bB.add(x, $33b0bdd0433db936$var$reshapeBias(x.rank, bias, dataFormat));
    });
}
function $33b0bdd0433db936$export$796b583dd79d8524(x, alpha = 1) {
    // TODO(cais): Add support for alpha values other than 1.
    if (alpha !== 1) throw new (0, $af476738b120e938$export$e162153238934121)(`Support for alpha values other than 1 (${alpha}) is not implemented ` + `yet.`);
    return $i64bB.elu(x);
}
function $33b0bdd0433db936$export$6def925d7f33a45c(x) {
    return (0, $i64bB.tidy)(()=>$i64bB.div(x, $i64bB.add($i64bB.abs(x), 1)));
}
function $33b0bdd0433db936$export$fe05aa12367b4e47(x, level, noiseShape, seed) {
    return (0, $i64bB.tidy)(()=>$i64bB.dropout(x, level, noiseShape, seed));
}
function $33b0bdd0433db936$export$150f2d52960480ef(x) {
    return (0, $i64bB.tidy)(()=>{
        const y = $i64bB.add(.5, $i64bB.mul(.2, x));
        return $i64bB.clipByValue(y, 0, 1);
    });
}
function $33b0bdd0433db936$export$5a6eea8e1dcefeb7(x, alt, training = false) {
    return training ? x() : alt();
}




/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ const $80c4890c243b6798$export$6f4ea9ac290c463f = [
    'fanIn',
    'fanOut',
    'fanAvg'
];
const $80c4890c243b6798$export$a0651197744e50ce = [
    'normal',
    'uniform',
    'truncatedNormal'
];
const $80c4890c243b6798$export$989dbab10a7a8537 = [
    'Zeros',
    'Ones',
    'Constant',
    'RandomNormal',
    'RandomUniform',
    'TruncatedNormal',
    'VarianceScaling',
    'Orthogonal',
    'Identity'
];




function $49135dd97e6043ca$export$c2c5543c407dbda7(value) {
    (0, $b5cd0926a1c6df1f$export$f49e87e6cde0274b)((0, $80c4890c243b6798$export$6f4ea9ac290c463f), 'FanMode', value);
}
function $49135dd97e6043ca$export$46d720aa775f5a50(value) {
    (0, $b5cd0926a1c6df1f$export$f49e87e6cde0274b)((0, $80c4890c243b6798$export$a0651197744e50ce), 'Distribution', value);
}
class $49135dd97e6043ca$export$9e14a7677ef1423c extends (0, $i64bB.serialization).Serializable {
    fromConfigUsesCustomObjects() {
        return false;
    }
    getConfig() {
        return {};
    }
}
class $49135dd97e6043ca$export$7a572cb9dc6aa81b extends $49135dd97e6043ca$export$9e14a7677ef1423c {
    apply(shape, dtype) {
        return (0, $i64bB.zeros)(shape, dtype);
    }
}
/** @nocollapse */ $49135dd97e6043ca$export$7a572cb9dc6aa81b.className = 'Zeros';
(0, $i64bB.serialization).registerClass($49135dd97e6043ca$export$7a572cb9dc6aa81b);
class $49135dd97e6043ca$export$30750dcb47d2f6b extends $49135dd97e6043ca$export$9e14a7677ef1423c {
    apply(shape, dtype) {
        return (0, $i64bB.ones)(shape, dtype);
    }
}
/** @nocollapse */ $49135dd97e6043ca$export$30750dcb47d2f6b.className = 'Ones';
(0, $i64bB.serialization).registerClass($49135dd97e6043ca$export$30750dcb47d2f6b);
class $49135dd97e6043ca$export$3c508fb3f8ac1ad4 extends $49135dd97e6043ca$export$9e14a7677ef1423c {
    constructor(args){
        super();
        if (typeof args !== 'object') throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Expected argument of type ConstantConfig but got ${args}`);
        if (args.value === undefined) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`config must have value set but got ${args}`);
        this.value = args.value;
    }
    apply(shape, dtype) {
        return (0, $i64bB.tidy)(()=>(0, $i64bB.mul)((0, $i64bB.scalar)(this.value), (0, $i64bB.ones)(shape, dtype)));
    }
    getConfig() {
        return {
            value: this.value
        };
    }
}
/** @nocollapse */ $49135dd97e6043ca$export$3c508fb3f8ac1ad4.className = 'Constant';
(0, $i64bB.serialization).registerClass($49135dd97e6043ca$export$3c508fb3f8ac1ad4);
class $49135dd97e6043ca$export$29e2b6f5e4b82e2f extends $49135dd97e6043ca$export$9e14a7677ef1423c {
    constructor(args){
        super();
        this.DEFAULT_MINVAL = -0.05;
        this.DEFAULT_MAXVAL = 0.05;
        this.minval = args.minval || this.DEFAULT_MINVAL;
        this.maxval = args.maxval || this.DEFAULT_MAXVAL;
        this.seed = args.seed;
    }
    apply(shape, dtype) {
        return (0, $i64bB.randomUniform)(shape, this.minval, this.maxval, dtype, this.seed);
    }
    getConfig() {
        return {
            minval: this.minval,
            maxval: this.maxval,
            seed: this.seed
        };
    }
}
/** @nocollapse */ $49135dd97e6043ca$export$29e2b6f5e4b82e2f.className = 'RandomUniform';
(0, $i64bB.serialization).registerClass($49135dd97e6043ca$export$29e2b6f5e4b82e2f);
class $49135dd97e6043ca$export$66e863738cfcc40 extends $49135dd97e6043ca$export$9e14a7677ef1423c {
    constructor(args){
        super();
        this.DEFAULT_MEAN = 0.;
        this.DEFAULT_STDDEV = 0.05;
        this.mean = args.mean || this.DEFAULT_MEAN;
        this.stddev = args.stddev || this.DEFAULT_STDDEV;
        this.seed = args.seed;
    }
    apply(shape, dtype) {
        dtype = dtype || 'float32';
        if (dtype !== 'float32' && dtype !== 'int32') throw new (0, $af476738b120e938$export$e162153238934121)(`randomNormal does not support dType ${dtype}.`);
        return $33b0bdd0433db936$export$a0ac5549a8bec918(shape, this.mean, this.stddev, dtype, this.seed);
    }
    getConfig() {
        return {
            mean: this.mean,
            stddev: this.stddev,
            seed: this.seed
        };
    }
}
/** @nocollapse */ $49135dd97e6043ca$export$66e863738cfcc40.className = 'RandomNormal';
(0, $i64bB.serialization).registerClass($49135dd97e6043ca$export$66e863738cfcc40);
class $49135dd97e6043ca$export$5f0e8a39027050d5 extends $49135dd97e6043ca$export$9e14a7677ef1423c {
    constructor(args){
        super();
        this.DEFAULT_MEAN = 0.;
        this.DEFAULT_STDDEV = 0.05;
        this.mean = args.mean || this.DEFAULT_MEAN;
        this.stddev = args.stddev || this.DEFAULT_STDDEV;
        this.seed = args.seed;
    }
    apply(shape, dtype) {
        dtype = dtype || 'float32';
        if (dtype !== 'float32' && dtype !== 'int32') throw new (0, $af476738b120e938$export$e162153238934121)(`truncatedNormal does not support dType ${dtype}.`);
        return (0, $i64bB.truncatedNormal)(shape, this.mean, this.stddev, dtype, this.seed);
    }
    getConfig() {
        return {
            mean: this.mean,
            stddev: this.stddev,
            seed: this.seed
        };
    }
}
/** @nocollapse */ $49135dd97e6043ca$export$5f0e8a39027050d5.className = 'TruncatedNormal';
(0, $i64bB.serialization).registerClass($49135dd97e6043ca$export$5f0e8a39027050d5);
class $49135dd97e6043ca$export$544bf02140fa9a77 extends $49135dd97e6043ca$export$9e14a7677ef1423c {
    constructor(args){
        super();
        this.gain = args.gain != null ? args.gain : 1.0;
    }
    apply(shape, dtype) {
        return (0, $i64bB.tidy)(()=>{
            if (shape.length !== 2 || shape[0] !== shape[1]) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)("Identity matrix initializer can only be used for 2D square matrices.");
            else return (0, $i64bB.mul)(this.gain, (0, $i64bB.eye)(shape[0]));
        });
    }
    getConfig() {
        return {
            gain: this.gain
        };
    }
}
/** @nocollapse */ $49135dd97e6043ca$export$544bf02140fa9a77.className = 'Identity';
(0, $i64bB.serialization).registerClass($49135dd97e6043ca$export$544bf02140fa9a77);
/**
 * Computes the number of input and output units for a weight shape.
 * @param shape Shape of weight.
 * @param dataFormat data format to use for convolution kernels.
 *   Note that all kernels in Keras are standardized on the
 *   CHANNEL_LAST ordering (even when inputs are set to CHANNEL_FIRST).
 * @return An length-2 array: fanIn, fanOut.
 */ function $49135dd97e6043ca$var$computeFans(shape, dataFormat = 'channelsLast') {
    let fanIn;
    let fanOut;
    (0, $860027d3b2c99a1d$export$f5f6472a2b993816)(dataFormat);
    if (shape.length === 2) {
        fanIn = shape[0];
        fanOut = shape[1];
    } else if ([
        3,
        4,
        5
    ].indexOf(shape.length) !== -1) {
        if (dataFormat === 'channelsFirst') {
            const receptiveFieldSize = (0, $edee0645f45d9428$export$3b5d61e59fec5e86)(shape, 2);
            fanIn = shape[1] * receptiveFieldSize;
            fanOut = shape[0] * receptiveFieldSize;
        } else if (dataFormat === 'channelsLast') {
            const receptiveFieldSize = (0, $edee0645f45d9428$export$3b5d61e59fec5e86)(shape, 0, shape.length - 2);
            fanIn = shape[shape.length - 2] * receptiveFieldSize;
            fanOut = shape[shape.length - 1] * receptiveFieldSize;
        }
    } else {
        const shapeProd = (0, $edee0645f45d9428$export$3b5d61e59fec5e86)(shape);
        fanIn = Math.sqrt(shapeProd);
        fanOut = Math.sqrt(shapeProd);
    }
    return [
        fanIn,
        fanOut
    ];
}
class $49135dd97e6043ca$export$c2ba607ca0c6b5b3 extends $49135dd97e6043ca$export$9e14a7677ef1423c {
    /**
     * Constructor of VarianceScaling.
     * @throws ValueError for invalid value in scale.
     */ constructor(args){
        super();
        if (args.scale < 0.0) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`scale must be a positive float. Got: ${args.scale}`);
        this.scale = args.scale == null ? 1.0 : args.scale;
        this.mode = args.mode == null ? 'fanIn' : args.mode;
        $49135dd97e6043ca$export$c2c5543c407dbda7(this.mode);
        this.distribution = args.distribution == null ? 'normal' : args.distribution;
        $49135dd97e6043ca$export$46d720aa775f5a50(this.distribution);
        this.seed = args.seed;
    }
    apply(shape, dtype) {
        const fans = $49135dd97e6043ca$var$computeFans(shape);
        const fanIn = fans[0];
        const fanOut = fans[1];
        let scale = this.scale;
        if (this.mode === 'fanIn') scale /= Math.max(1, fanIn);
        else if (this.mode === 'fanOut') scale /= Math.max(1, fanOut);
        else scale /= Math.max(1, (fanIn + fanOut) / 2);
        if (this.distribution === 'normal') {
            const stddev = Math.sqrt(scale);
            dtype = dtype || 'float32';
            if (dtype !== 'float32' && dtype !== 'int32') throw new (0, $af476738b120e938$export$e162153238934121)(`${this.getClassName()} does not support dType ${dtype}.`);
            return (0, $i64bB.truncatedNormal)(shape, 0, stddev, dtype, this.seed);
        } else {
            const limit = Math.sqrt(3 * scale);
            return (0, $i64bB.randomUniform)(shape, -limit, limit, dtype, this.seed);
        }
    }
    getConfig() {
        return {
            scale: this.scale,
            mode: this.mode,
            distribution: this.distribution,
            seed: this.seed
        };
    }
}
/** @nocollapse */ $49135dd97e6043ca$export$c2ba607ca0c6b5b3.className = 'VarianceScaling';
(0, $i64bB.serialization).registerClass($49135dd97e6043ca$export$c2ba607ca0c6b5b3);
class $49135dd97e6043ca$export$c820ee55503e6df3 extends $49135dd97e6043ca$export$c2ba607ca0c6b5b3 {
    /**
     * Constructor of GlorotUniform
     * @param scale
     * @param mode
     * @param distribution
     * @param seed
     */ constructor(args){
        super({
            scale: 1.0,
            mode: 'fanAvg',
            distribution: 'uniform',
            seed: args == null ? null : args.seed
        });
    }
    getClassName() {
        // In Python Keras, GlorotUniform is not a class, but a helper method
        // that creates a VarianceScaling object. Use 'VarianceScaling' as
        // class name to be compatible with that.
        return $49135dd97e6043ca$export$c2ba607ca0c6b5b3.className;
    }
}
/** @nocollapse */ $49135dd97e6043ca$export$c820ee55503e6df3.className = 'GlorotUniform';
(0, $i64bB.serialization).registerClass($49135dd97e6043ca$export$c820ee55503e6df3);
class $49135dd97e6043ca$export$dcc636dfa962cdc9 extends $49135dd97e6043ca$export$c2ba607ca0c6b5b3 {
    /**
     * Constructor of GlorotNormal.
     * @param scale
     * @param mode
     * @param distribution
     * @param seed
     */ constructor(args){
        super({
            scale: 1.0,
            mode: 'fanAvg',
            distribution: 'normal',
            seed: args == null ? null : args.seed
        });
    }
    getClassName() {
        // In Python Keras, GlorotNormal is not a class, but a helper method
        // that creates a VarianceScaling object. Use 'VarianceScaling' as
        // class name to be compatible with that.
        return $49135dd97e6043ca$export$c2ba607ca0c6b5b3.className;
    }
}
/** @nocollapse */ $49135dd97e6043ca$export$dcc636dfa962cdc9.className = 'GlorotNormal';
(0, $i64bB.serialization).registerClass($49135dd97e6043ca$export$dcc636dfa962cdc9);
class $49135dd97e6043ca$export$399f315e5cbd5eed extends $49135dd97e6043ca$export$c2ba607ca0c6b5b3 {
    constructor(args){
        super({
            scale: 2.0,
            mode: 'fanIn',
            distribution: 'normal',
            seed: args == null ? null : args.seed
        });
    }
    getClassName() {
        // In Python Keras, HeNormal is not a class, but a helper method
        // that creates a VarianceScaling object. Use 'VarianceScaling' as
        // class name to be compatible with that.
        return $49135dd97e6043ca$export$c2ba607ca0c6b5b3.className;
    }
}
/** @nocollapse */ $49135dd97e6043ca$export$399f315e5cbd5eed.className = 'HeNormal';
(0, $i64bB.serialization).registerClass($49135dd97e6043ca$export$399f315e5cbd5eed);
class $49135dd97e6043ca$export$4799f50fbef71375 extends $49135dd97e6043ca$export$c2ba607ca0c6b5b3 {
    constructor(args){
        super({
            scale: 2.0,
            mode: 'fanIn',
            distribution: 'uniform',
            seed: args == null ? null : args.seed
        });
    }
    getClassName() {
        // In Python Keras, HeUniform is not a class, but a helper method
        // that creates a VarianceScaling object. Use 'VarianceScaling' as
        // class name to be compatible with that.
        return $49135dd97e6043ca$export$c2ba607ca0c6b5b3.className;
    }
}
/** @nocollapse */ $49135dd97e6043ca$export$4799f50fbef71375.className = 'HeUniform';
(0, $i64bB.serialization).registerClass($49135dd97e6043ca$export$4799f50fbef71375);
class $49135dd97e6043ca$export$f0843b4cb97b93f5 extends $49135dd97e6043ca$export$c2ba607ca0c6b5b3 {
    constructor(args){
        super({
            scale: 1.0,
            mode: 'fanIn',
            distribution: 'normal',
            seed: args == null ? null : args.seed
        });
    }
    getClassName() {
        // In Python Keras, LeCunNormal is not a class, but a helper method
        // that creates a VarianceScaling object. Use 'VarianceScaling' as
        // class name to be compatible with that.
        return $49135dd97e6043ca$export$c2ba607ca0c6b5b3.className;
    }
}
/** @nocollapse */ $49135dd97e6043ca$export$f0843b4cb97b93f5.className = 'LeCunNormal';
(0, $i64bB.serialization).registerClass($49135dd97e6043ca$export$f0843b4cb97b93f5);
class $49135dd97e6043ca$export$41b487c9c7cedfae extends $49135dd97e6043ca$export$c2ba607ca0c6b5b3 {
    constructor(args){
        super({
            scale: 1.0,
            mode: 'fanIn',
            distribution: 'uniform',
            seed: args == null ? null : args.seed
        });
    }
    getClassName() {
        // In Python Keras, LeCunUniform is not a class, but a helper method
        // that creates a VarianceScaling object. Use 'VarianceScaling' as
        // class name to be compatible with that.
        return $49135dd97e6043ca$export$c2ba607ca0c6b5b3.className;
    }
}
/** @nocollapse */ $49135dd97e6043ca$export$41b487c9c7cedfae.className = 'LeCunUniform';
(0, $i64bB.serialization).registerClass($49135dd97e6043ca$export$41b487c9c7cedfae);
class $49135dd97e6043ca$export$7d101801017ddeaf extends $49135dd97e6043ca$export$9e14a7677ef1423c {
    constructor(args){
        super();
        this.DEFAULT_GAIN = 1;
        this.ELEMENTS_WARN_SLOW = 2000;
        this.gain = args.gain == null ? this.DEFAULT_GAIN : args.gain;
        this.seed = args.seed;
    }
    apply(shape, dtype) {
        return (0, $i64bB.tidy)(()=>{
            if (shape.length < 2) throw new (0, $af476738b120e938$export$e162153238934121)('Shape must be at least 2D.');
            if (dtype !== 'int32' && dtype !== 'float32' && dtype !== undefined) throw new TypeError(`Unsupported data type ${dtype}.`);
            dtype;
            // flatten the input shape with the last dimension remaining its
            // original shape so it works for conv2d
            const numRows = (0, $i64bB.util).sizeFromShape(shape.slice(0, -1));
            const numCols = shape[shape.length - 1];
            const numElements = numRows * numCols;
            if (numElements > this.ELEMENTS_WARN_SLOW) console.warn(`Orthogonal initializer is being called on a matrix with more ` + `than ${this.ELEMENTS_WARN_SLOW} (${numElements}) elements: ` + `Slowness may result.`);
            const flatShape = [
                Math.max(numCols, numRows),
                Math.min(numCols, numRows)
            ];
            // Generate a random matrix
            const randNormalMat = $33b0bdd0433db936$export$a0ac5549a8bec918(flatShape, 0, 1, dtype, this.seed);
            // Compute QR factorization
            const qr = (0, $i64bB.linalg).qr(randNormalMat, false);
            let qMat = qr[0];
            const rMat = qr[1];
            // Make Q uniform
            const diag = rMat.flatten().stridedSlice([
                0
            ], [
                Math.min(numCols, numRows) * Math.min(numCols, numRows)
            ], [
                Math.min(numCols, numRows) + 1
            ]);
            qMat = (0, $i64bB.mul)(qMat, diag.sign());
            if (numRows < numCols) qMat = qMat.transpose();
            return (0, $i64bB.mul)((0, $i64bB.scalar)(this.gain), qMat.reshape(shape));
        });
    }
    getConfig() {
        return {
            gain: this.gain,
            seed: this.seed
        };
    }
}
/** @nocollapse */ $49135dd97e6043ca$export$7d101801017ddeaf.className = 'Orthogonal';
(0, $i64bB.serialization).registerClass($49135dd97e6043ca$export$7d101801017ddeaf);
const $49135dd97e6043ca$export$10005499b3b3c1de = {
    'constant': 'Constant',
    'glorotNormal': 'GlorotNormal',
    'glorotUniform': 'GlorotUniform',
    'heNormal': 'HeNormal',
    'heUniform': 'HeUniform',
    'identity': 'Identity',
    'leCunNormal': 'LeCunNormal',
    'leCunUniform': 'LeCunUniform',
    'ones': 'Ones',
    'orthogonal': 'Orthogonal',
    'randomNormal': 'RandomNormal',
    'randomUniform': 'RandomUniform',
    'truncatedNormal': 'TruncatedNormal',
    'varianceScaling': 'VarianceScaling',
    'zeros': 'Zeros'
};
function $49135dd97e6043ca$var$deserializeInitializer(config, customObjects = {}) {
    return (0, $b5cd0926a1c6df1f$export$c33061eb381c60f9)(config, (0, $i64bB.serialization).SerializationMap.getMap().classNameMap, customObjects, 'initializer');
}
function $49135dd97e6043ca$export$68de06a18c23bdbc(initializer) {
    return (0, $b5cd0926a1c6df1f$export$78f846918d17a884)(initializer);
}
function $49135dd97e6043ca$export$558b7d1a338df84b(identifier) {
    if (typeof identifier === 'string') {
        const className = identifier in $49135dd97e6043ca$export$10005499b3b3c1de ? $49135dd97e6043ca$export$10005499b3b3c1de[identifier] : identifier;
        /* We have four 'helper' classes for common initializers that
        all get serialized as 'VarianceScaling' and shouldn't go through
        the deserializeInitializer pathway. */ if (className === 'GlorotNormal') return new $49135dd97e6043ca$export$dcc636dfa962cdc9();
        else if (className === 'GlorotUniform') return new $49135dd97e6043ca$export$c820ee55503e6df3();
        else if (className === 'HeNormal') return new $49135dd97e6043ca$export$399f315e5cbd5eed();
        else if (className === 'HeUniform') return new $49135dd97e6043ca$export$4799f50fbef71375();
        else if (className === 'LeCunNormal') return new $49135dd97e6043ca$export$f0843b4cb97b93f5();
        else if (className === 'LeCunUniform') return new $49135dd97e6043ca$export$41b487c9c7cedfae();
        else {
            const config = {};
            config['className'] = className;
            config['config'] = {};
            return $49135dd97e6043ca$var$deserializeInitializer(config);
        }
    } else if (identifier instanceof $49135dd97e6043ca$export$9e14a7677ef1423c) return identifier;
    else return $49135dd97e6043ca$var$deserializeInitializer(identifier);
}



/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ 
function $e11ae28082970f77$export$3297ca286d903db0(x) {
    return Array.isArray(x) && Array.isArray(x[0]);
}
function $e11ae28082970f77$export$4cdd3da5579ac4c4(x) {
    if (x.length === 0) return [];
    if (!Array.isArray(x[0])) return [
        x
    ];
    return x;
}
function $e11ae28082970f77$export$5327fe015af69a7b(xs) {
    let x;
    if (Array.isArray(xs)) {
        if (xs.length !== 1) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Expected Tensor length to be 1; got ${xs.length}`);
        x = xs[0];
    } else x = xs;
    return x;
}
function $e11ae28082970f77$export$25c35af872e8abca(shapes) {
    if (Array.isArray(shapes) && Array.isArray(shapes[0])) {
        if (shapes.length === 1) {
            shapes;
            return shapes[0];
        } else throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Expected exactly 1 Shape; got ${shapes.length}`);
    } else return shapes;
}


/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * Count the elements in an Array of LayerVariables.
 *
 * @param weights: The LayerVariables of which the constituent numbers are to
 *   be counted.
 * @returns A count of the elements in all the LayerVariables
 */ function $ed799730592766a6$export$2a41d41251f01d03(weights) {
    let count = 0;
    for (const weight of weights)if (weight.shape.length === 0) count += 1;
    else count += weight.shape.reduce((a, b)=>a * b);
    return count;
}


/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");



const $47730a883443b08f$var$DEFAULT_VARIABLE_NAME_PREFIX = 'Variable';
class $47730a883443b08f$export$25de78a5a5bf7257 {
    /**
     * Construct Variable from a `tf.Tensor`.
     *
     * If not explicitly named, the Variable will be given a name with the
     * prefix 'Variable'. Variable names are unique. In the case of name
     * collision, suffixies '_<num>' will be added to the name.
     *
     * @param val Initial value of the Variable.
     * @param name Name of the variable. If `null` or `undefined` is provided, it
     *   will default a name with the prefix 'Variable'.
     * @param constraint Optional, projection function to be applied to the
     * variable after optimize updates
     * @throws ValueError if `name` is `null` or `undefined`.
     */ constructor(val, dtype = 'float32', name = $47730a883443b08f$var$DEFAULT_VARIABLE_NAME_PREFIX, trainable = true, constraint = null){
        this.dtype = dtype == null ? 'float32' : dtype;
        this.shape = val.shape;
        this.id = (0, $cde2737e4648ad82$export$b7ad53ecc0eccaf)();
        name = name == null ? $47730a883443b08f$var$DEFAULT_VARIABLE_NAME_PREFIX : name;
        this.originalName = (0, $860027d3b2c99a1d$export$ff30fd7baa750729)(name);
        this.name = (0, $860027d3b2c99a1d$export$9227bff0c10d827e)(this.originalName);
        this.trainable_ = trainable;
        this.constraint = constraint;
        this.val = $i64bB.variable(val, this.trainable_, this.name, this.dtype);
    }
    /**
     * Get a snapshot of the Variable's value.
     *
     * The returned value is a snapshot of the Variable's value at the time of
     * the invocation. Future mutations in the value of the tensor will only
     * be reflected by future calls to this method.
     */ read() {
        this.assertNotDisposed();
        return this.val;
    }
    /**
     * Update the value of the Variable.
     *
     * @param newVal: The new value to update to. Must be consistent with the
     *   dtype and shape of the Variable.
     * @return This Variable.
     */ write(newVal) {
        // TODO(cais): Once  TF.js Core supports Tensor.dtype, check dtype match.
        this.assertNotDisposed();
        $47730a883443b08f$var$checkShapesMatch(this.val, newVal);
        // Skip updating if this is the exact same tensor.
        if (this.val.id !== newVal.id) {
            this.val.assign(newVal);
            if (this.constraint != null) this.val.assign(this.constraint.apply(this.val));
        }
        return this;
    }
    /**
     * Dispose this LayersVariable instance from memory.
     */ dispose() {
        this.assertNotDisposed();
        this.val.dispose();
    }
    assertNotDisposed() {
        if (this.val.isDisposed) throw new Error(`LayersVariable ${this.name} is already disposed.`);
    }
    get trainable() {
        return this.trainable_;
    }
    set trainable(trainable) {
        this.trainable_ = trainable;
        this.val.trainable = trainable;
    }
}
function $47730a883443b08f$var$checkShapesMatch(x, y) {
    if (x.shape.toString() !== y.shape.toString()) throw new Error('Shape mismatch: ' + JSON.stringify(x.shape) + ' vs. ' + JSON.stringify(y.shape));
}
function $47730a883443b08f$export$3a9d57cefcd2c285(x, dtype, name, constraint) {
    return new $47730a883443b08f$export$25de78a5a5bf7257(x, dtype, name, true, constraint);
}
function $47730a883443b08f$export$b57b9b034d1223d7(shape, dtype, name) {
    // TODO(cais): Implement logic for dtype.
    return new $47730a883443b08f$export$25de78a5a5bf7257($i64bB.zeros(shape), dtype, name);
}
function $47730a883443b08f$export$cb1f824e7733584d(x, dtype, name) {
    return new $47730a883443b08f$export$25de78a5a5bf7257($i64bB.zerosLike(x), dtype, name);
}
function $47730a883443b08f$export$f21b2d0b36d5e3a3(shape, dtype, name) {
    // TODO(cais): Implement logic for dtype.
    const allocated = $i64bB.ones(shape);
    return new $47730a883443b08f$export$25de78a5a5bf7257(allocated, dtype, name);
}
function $47730a883443b08f$export$fb6afd6214fee9e9(x, dtype, name) {
    const allocated = $i64bB.onesLike(x);
    return new $47730a883443b08f$export$25de78a5a5bf7257(allocated, dtype, name);
}
function $47730a883443b08f$export$a48ae747268ddcb4(size, dtype, name) {
    return new $47730a883443b08f$export$25de78a5a5bf7257($i64bB.eye(size), dtype, name);
}
function $47730a883443b08f$export$53e488f964846878(shape, minval, maxval, dtype, seed, name = 'randomUniform') {
    return new $47730a883443b08f$export$25de78a5a5bf7257($i64bB.randomUniform(shape, minval, maxval, dtype), dtype, name);
}
function $47730a883443b08f$export$6a7d47f4711fe0f5(shape, mean = 0.0, stddev = 1.0, dtype, seed, name = 'truncatedNormal') {
    // TODO(cais): Implement logic for dtype and seed once they are supported
    // by deeplearn.js.
    dtype = dtype || 'float32';
    if (dtype !== 'float32' && dtype !== 'int32') throw new (0, $af476738b120e938$export$e162153238934121)(`randomNormal does not support dType ${dtype}.`);
    return new $47730a883443b08f$export$25de78a5a5bf7257($i64bB.truncatedNormal(shape, mean, stddev, dtype, seed), dtype, name);
}
function $47730a883443b08f$export$3f33dee25c54e076(shape, mean = 0.0, stddev = 1.0, dtype, seed, name = 'randomNormal') {
    dtype = dtype || 'float32';
    if (dtype !== 'float32' && dtype !== 'int32') throw new (0, $af476738b120e938$export$e162153238934121)(`randomNormalVariable does not support dType ${dtype}.`);
    return new $47730a883443b08f$export$25de78a5a5bf7257($i64bB.randomNormal(shape, mean, stddev, dtype, seed), dtype, name);
}
function $47730a883443b08f$export$722fbec263ad908a(x, xNew) {
    return x.write(xNew);
}
function $47730a883443b08f$export$35b829383d705ade(x, increment) {
    return x.write($i64bB.add(x.read(), increment));
}
function $47730a883443b08f$export$f213ae8d294bd578(x, decrement) {
    return x.write($i64bB.sub(x.read(), decrement));
}
function $47730a883443b08f$export$3702262f615cc9f0(xs) {
    return xs.map((x)=>x.read());
}
function $47730a883443b08f$export$6b1a34257a4982e4(variablesAndValues) {
    variablesAndValues.forEach((variableAndValue)=>{
        const variable = variableAndValue[0];
        variable.write(variableAndValue[1]);
    });
}
function $47730a883443b08f$export$fc5727d09955ec17(lossFn, variables) {
    // TODO(cais): The return type signature can be simplified if deeplearn makes
    //   the corresponding type public.
    const variableList = variables.map((variable)=>variable.read());
    const valudAndGrads = (0, $i64bB.variableGrads)(lossFn, variableList);
    return variables.map((variable)=>valudAndGrads.grads[variable.name]);
}


class $03271f6b4e448384$export$7705ee67def9d40a {
    constructor(args){
        this.dtype = args.dtype;
        this.shape = args.shape;
        /*
          TODO(michaelterry): Could throw error if ndim and shape are both defined
            (then backport).
        */ if (args.shape != null) this.ndim = args.shape.length;
        else this.ndim = args.ndim;
        this.maxNDim = args.maxNDim;
        this.minNDim = args.minNDim;
        this.axes = args.axes || {};
    }
}
class $03271f6b4e448384$export$c6d6977640680568 {
    /**
     *
     * @param dtype
     * @param shape
     * @param sourceLayer The Layer that produced this symbolic tensor.
     * @param inputs The inputs passed to sourceLayer's __call__() method.
     * @param nodeIndex
     * @param tensorIndex
     * @param callArgs The keyword arguments passed to the __call__() method.
     * @param name
     * @param outputTensorIndex The index of this tensor in the list of outputs
     *   returned by apply().
     */ constructor(dtype, shape, sourceLayer, inputs, callArgs, name, outputTensorIndex){
        this.dtype = dtype;
        this.shape = shape;
        this.sourceLayer = sourceLayer;
        this.inputs = inputs;
        this.callArgs = callArgs;
        this.outputTensorIndex = outputTensorIndex;
        this.id = (0, $cde2737e4648ad82$export$b7ad53ecc0eccaf)();
        if (name != null) {
            this.originalName = (0, $860027d3b2c99a1d$export$ff30fd7baa750729)(name);
            this.name = (0, $860027d3b2c99a1d$export$9227bff0c10d827e)(this.originalName);
        }
        this.rank = shape.length;
    }
}
let $03271f6b4e448384$var$_nextNodeID = 0;
class $03271f6b4e448384$export$85c928794f8d04d4 {
    constructor(args, // TODO(michaelterry): Define actual type for this.
    callArgs){
        this.callArgs = callArgs;
        this.id = $03271f6b4e448384$var$_nextNodeID++;
        /*
          Layer instance (NOT a list).
          this is the layer that takes a list of input tensors
          and turns them into a list of output tensors.
          the current node will be added to
          the inboundNodes of outboundLayer.
        */ this.outboundLayer = args.outboundLayer;
        /*
            The following 3 properties describe where
            the input tensors come from: which layers,
            and for each layer, which node and which
            tensor output of each node.
        */ // List of layer instances.
        this.inboundLayers = args.inboundLayers;
        // List of integers, 1:1 mapping with inboundLayers.
        this.nodeIndices = args.nodeIndices;
        // List of integers, 1:1 mapping with inboundLayers.
        this.tensorIndices = args.tensorIndices;
        /*
            Following 2 properties:
            tensor inputs and outputs of outboundLayer.
        */ // List of tensors. 1:1 mapping with inboundLayers.
        this.inputTensors = args.inputTensors;
        // List of tensors, created by outboundLayer.call().
        this.outputTensors = args.outputTensors;
        /*
            Following 2 properties: input and output masks.
            List of tensors, 1:1 mapping with inputTensor.
        */ this.inputMasks = args.inputMasks;
        // List of tensors, created by outboundLayer.computeMask().
        this.outputMasks = args.outputMasks;
        // Following 2 properties: input and output shapes.
        // List of shape tuples, shapes of inputTensors.
        this.inputShapes = args.inputShapes;
        // List of shape tuples, shapes of outputTensors.
        this.outputShapes = args.outputShapes;
        // Add nodes to all layers involved.
        for (const layer of args.inboundLayers)if (layer != null) layer.outboundNodes.push(this);
        args.outboundLayer.inboundNodes.push(this);
    }
    getConfig() {
        const inboundNames = [];
        for (const layer of this.inboundLayers)if (layer != null) inboundNames.push(layer.name);
        else inboundNames.push(null);
        return {
            outboundLayer: this.outboundLayer ? this.outboundLayer.name : null,
            inboundLayers: inboundNames,
            nodeIndices: this.nodeIndices,
            tensorIndices: this.tensorIndices
        };
    }
}
let $03271f6b4e448384$var$_nextLayerID = 0;
class $03271f6b4e448384$export$936d0764594b6eb3 extends (0, $i64bB.serialization).Serializable {
    constructor(args = {}){
        super();
        this._callHook = null;
        this._addedWeightNames = [];
        // Porting Notes: PyKeras does not have this property in this base Layer
        //   class. Instead lets Layer subclass set it dynamically and checks the
        //   value with `hasattr`. In tfjs-layers, we let this be a member of this
        //   base class.
        this._stateful = false;
        this.id = $03271f6b4e448384$var$_nextLayerID++;
        this.activityRegularizer = null;
        this.inputSpec = null;
        this.supportsMasking = false;
        // These properties will be set upon call of this.build()
        this._trainableWeights = [];
        this._nonTrainableWeights = [];
        this._losses = [];
        this._updates = [];
        this._built = false;
        /*
          These lists will be filled via successive calls
          to this.addInboundNode().
         */ this.inboundNodes = [];
        this.outboundNodes = [];
        let name = args.name;
        if (!name) {
            const prefix = this.getClassName();
            name = $b5cd0926a1c6df1f$export$cc8b315fc368b20a(prefix) + '_' + (0, $cde2737e4648ad82$export$5e82334337e0f204)(prefix);
        }
        this.name = name;
        this.trainable_ = args.trainable == null ? true : args.trainable;
        if (args.inputShape != null || args.batchInputShape != null) {
            /*
              In this case we will later create an input layer
              to insert before the current layer
             */ let batchInputShape;
            if (args.batchInputShape != null) batchInputShape = args.batchInputShape;
            else if (args.inputShape != null) {
                let batchSize = null;
                if (args.batchSize != null) batchSize = args.batchSize;
                batchInputShape = [
                    batchSize
                ].concat(args.inputShape);
            }
            this.batchInputShape = batchInputShape;
            // Set dtype.
            let dtype = args.dtype;
            if (dtype == null) dtype = args.inputDType;
            if (dtype == null) dtype = 'float32';
            this.dtype = dtype;
        }
        if (args.weights != null) this.initialWeights = args.weights;
        else this.initialWeights = null;
        // The value of `_refCount` is initialized to null. When the layer is used
        // in a symbolic way for the first time, it will be set to 1.
        this._refCount = null;
        this.fastWeightInitDuringBuild = false;
    }
    /**
     * Converts a layer and its index to a unique (immutable type) name.
     * This function is used internally with `this.containerNodes`.
     * @param layer The layer.
     * @param nodeIndex The layer's position (e.g. via enumerate) in a list of
     *   nodes.
     *
     * @returns The unique name.
     */ static nodeKey(layer, nodeIndex) {
        return layer.name + '_ib-' + nodeIndex.toString();
    }
    /**
     * Returns this.inboundNode at index nodeIndex.
     *
     * Porting note: This is a replacement for _get_node_attribute_at_index()
     * @param nodeIndex
     * @param attrName The name of the attribute related to request for this node.
     */ getNodeAtIndex(nodeIndex, attrName) {
        if (this.inboundNodes.length === 0) throw new (0, $af476738b120e938$export$4a24a86bdbcf02bb)('The layer has never been called ' + `and thus has no defined ${attrName}.`);
        if (this.inboundNodes.length <= nodeIndex) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Asked to get ${attrName} at node ${nodeIndex}, ` + `but the layer has only ${this.inboundNodes.length} inbound nodes.`);
        return this.inboundNodes[nodeIndex];
    }
    /**
     * Retrieves the input tensor(s) of a layer at a given node.
     *
     * @param nodeIndex Integer, index of the node from which to retrieve the
     *   attribute. E.g. `nodeIndex=0` will correspond to the first time the layer
     *   was called.
     *
     * @return A tensor (or list of tensors if the layer has multiple inputs).
     */ getInputAt(nodeIndex) {
        return $b5cd0926a1c6df1f$export$8366660815493a21(this.getNodeAtIndex(nodeIndex, 'input').inputTensors);
    }
    /**
     * Retrieves the output tensor(s) of a layer at a given node.
     *
     * @param nodeIndex Integer, index of the node from which to retrieve the
     *   attribute. E.g. `nodeIndex=0` will correspond to the first time the layer
     *   was called.
     *
     * @return A tensor (or list of tensors if the layer has multiple outputs).
     */ getOutputAt(nodeIndex) {
        return $b5cd0926a1c6df1f$export$8366660815493a21(this.getNodeAtIndex(nodeIndex, 'output').outputTensors);
    }
    // Properties
    /**
     * Retrieves the input tensor(s) of a layer.
     *
     * Only applicable if the layer has exactly one inbound node,
     * i.e. if it is connected to one incoming layer.
     *
     * @return Input tensor or list of input tensors.
     *
     * @exception AttributeError if the layer is connected to more than one
     *   incoming layers.
     */ get input() {
        if (this.inboundNodes.length > 1) throw new (0, $af476738b120e938$export$3869bf0637a5d0ff)(`Layer ${this.name}` + ' has multiple inbound nodes, ' + 'hence the notion of "layer input" ' + 'is ill-defined. ' + 'Use `getInputAt(nodeIndex)` instead.');
        else if (this.inboundNodes.length === 0) throw new (0, $af476738b120e938$export$3869bf0637a5d0ff)(`Layer ${this.name}` + ' is not connected, no input to return.');
        return $b5cd0926a1c6df1f$export$8366660815493a21(this.getNodeAtIndex(0, 'input').inputTensors);
    }
    /**
     * Retrieves the output tensor(s) of a layer.
     *
     * Only applicable if the layer has exactly one inbound node,
     * i.e. if it is connected to one incoming layer.
     *
     * @return Output tensor or list of output tensors.
     *
     * @exception AttributeError if the layer is connected to more than one
     *   incoming layers.
     */ get output() {
        if (this.inboundNodes.length === 0) throw new (0, $af476738b120e938$export$3869bf0637a5d0ff)(`Layer ${this.name}` + ' has no inbound nodes.');
        if (this.inboundNodes.length > 1) throw new (0, $af476738b120e938$export$3869bf0637a5d0ff)(`Layer ${this.name}` + ' has multiple inbound nodes, ' + 'hence the notion of "layer output" ' + 'is ill-defined. ' + 'Use `getOutputAt(nodeIndex)` instead.');
        return $b5cd0926a1c6df1f$export$8366660815493a21(this.getNodeAtIndex(0, 'output').outputTensors);
    }
    get losses() {
        return this._losses;
    }
    /**
     * Retrieves the Layer's current loss values.
     *
     * Used for regularizers during training.
     */ calculateLosses() {
        // Porting Node: This is an augmentation to Layer.loss in PyKeras.
        //   In PyKeras, Layer.loss returns symbolic tensors. Here a concrete
        //   Tensor (specifically Scalar) values are returned. This is due to the
        //   imperative backend.
        return this.losses.map((lossFn)=>lossFn());
    }
    get updates() {
        return this._updates;
    }
    get built() {
        return this._built;
    }
    set built(built) {
        this._built = built;
    }
    get trainable() {
        return this.trainable_;
    }
    set trainable(trainable) {
        this._trainableWeights.forEach((w)=>w.trainable = trainable);
        this.trainable_ = trainable;
    }
    get trainableWeights() {
        if (this.trainable_) return this._trainableWeights.filter((w)=>w.trainable);
        else return [];
    }
    set trainableWeights(weights) {
        this._trainableWeights = weights;
    }
    get nonTrainableWeights() {
        if (this.trainable) return this._trainableWeights.filter((w)=>!w.trainable).concat(this._nonTrainableWeights);
        else return this._trainableWeights.concat(this._nonTrainableWeights);
    }
    set nonTrainableWeights(weights) {
        this._nonTrainableWeights = weights;
    }
    /**
     * The concatenation of the lists trainableWeights and nonTrainableWeights
     * (in this order).
     */ get weights() {
        return this.trainableWeights.concat(this.nonTrainableWeights);
    }
    get stateful() {
        return this._stateful;
    }
    /**
     * Reset the states of the layer.
     *
     * This method of the base Layer class is essentially a no-op.
     * Subclasses that are stateful (e.g., stateful RNNs) should override this
     * method.
     */ resetStates() {
        if (!this.stateful) throw new Error("Cannot call the resetStates() method of a non-stateful Layer object.");
    }
    /**
     * Checks compatibility between the layer and provided inputs.
     *
     * This checks that the tensor(s) `input`
     * verify the input assumptions of the layer
     * (if any). If not, exceptions are raised.
     *
     * @param inputs Input tensor or list of input tensors.
     *
     * @exception ValueError in case of mismatch between
     *   the provided inputs and the expectations of the layer.
     */ assertInputCompatibility(inputs) {
        const inputsList = $b5cd0926a1c6df1f$export$effcdbd76139450(inputs);
        if (this.inputSpec == null || this.inputSpec.length === 0) return;
        const inputSpec = $b5cd0926a1c6df1f$export$effcdbd76139450(this.inputSpec);
        if (inputsList.length !== inputSpec.length) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Layer ${this.name} expects ${inputSpec.length} inputs, ` + `but it received ${inputsList.length} input tensors. ` + `Input received: ${inputs}`);
        for(let inputIndex = 0; inputIndex < inputsList.length; inputIndex++){
            const x = inputsList[inputIndex];
            const spec = inputSpec[inputIndex];
            if (spec == null) continue;
            // Check ndim.
            const ndim = x.rank;
            if (spec.ndim != null) {
                if (ndim !== spec.ndim) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Input ${inputIndex} is incompatible with layer ${this.name}: ` + `expected ndim=${spec.ndim}, found ndim=${ndim}`);
            }
            if (spec.maxNDim != null) {
                if (ndim > spec.maxNDim) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Input ${inputIndex} is incompatible with layer ${this.name}` + `: expected max_ndim=${spec.maxNDim}, found ndim=${ndim}`);
            }
            if (spec.minNDim != null) {
                if (ndim < spec.minNDim) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Input ${inputIndex} is incompatible with layer ${this.name}` + `: expected min_ndim=${spec.minNDim}, found ndim=${ndim}.`);
            }
            // Check dtype.
            if (spec.dtype != null) {
                if (x.dtype !== spec.dtype) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Input ${inputIndex} is incompatible with layer ${this.name} ` + `: expected dtype=${spec.dtype}, found dtype=${x.dtype}.`);
            }
            // Check specific shape axes.
            if (spec.axes) {
                const xShape = x.shape;
                for(const key in spec.axes){
                    const axis = Number(key);
                    const value = spec.axes[key];
                    // Perform Python-style slicing in case axis < 0;
                    // TODO(cais): Use https://github.com/alvivi/typescript-underscore to
                    // ensure type safety through Underscore calls.
                    const xShapeAtAxis = axis >= 0 ? xShape[axis] : xShape[xShape.length + axis];
                    if (value != null && [
                        value,
                        null
                    ].indexOf(xShapeAtAxis) === -1) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Input ${inputIndex} is incompatible with layer ` + `${this.name}: expected axis ${axis} of input shape to ` + `have value ${value} but got shape ${xShape}.`);
                }
            }
            // Check shape.
            if (spec.shape != null) for(let i = 0; i < spec.shape.length; ++i){
                const specDim = spec.shape[i];
                const dim = x.shape[i];
                if (specDim != null && dim != null) {
                    if (specDim !== dim) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Input ${inputIndex} is incompatible with layer ` + `${this.name}: expected shape=${spec.shape}, ` + `found shape=${x.shape}.`);
                }
            }
        }
    }
    /**
     * This is where the layer's logic lives.
     *
     * @param inputs Input tensor, or list/tuple of input tensors.
     * @param kwargs Additional keyword arguments.
     *
     * @return A tensor or list/tuple of tensors.
     */ call(inputs, kwargs) {
        return inputs;
    }
    invokeCallHook(inputs, kwargs) {
        if (this._callHook != null) this._callHook(inputs, kwargs);
    }
    /**
     * Set call hook.
     * This is currently used for testing only.
     * @param callHook
     */ setCallHook(callHook) {
        this._callHook = callHook;
    }
    /**
     * Clear call hook.
     * This is currently used for testing only.
     */ clearCallHook() {
        this._callHook = null;
    }
    /**
     * Builds or executes a `Layer`'s logic.
     *
     * When called with `tf.Tensor`(s), execute the `Layer`'s computation and
     * return Tensor(s). For example:
     *
     * ```js
     * const denseLayer = tf.layers.dense({
     *   units: 1,
     *   kernelInitializer: 'zeros',
     *   useBias: false
     * });
     *
     * // Invoke the layer's apply() method with a `tf.Tensor` (with concrete
     * // numeric values).
     * const input = tf.ones([2, 2]);
     * const output = denseLayer.apply(input);
     *
     * // The output's value is expected to be [[0], [0]], due to the fact that
     * // the dense layer has a kernel initialized to all-zeros and does not have
     * // a bias.
     * output.print();
     * ```
     *
     * When called with `tf.SymbolicTensor`(s), this will prepare the layer for
     * future execution.  This entails internal book-keeping on shapes of
     * expected Tensors, wiring layers together, and initializing weights.
     *
     * Calling `apply` with `tf.SymbolicTensor`s are typically used during the
     * building of non-`tf.Sequential` models. For example:
     *
     * ```js
     * const flattenLayer = tf.layers.flatten();
     * const denseLayer = tf.layers.dense({units: 1});
     *
     * // Use tf.layers.input() to obtain a SymbolicTensor as input to apply().
     * const input = tf.input({shape: [2, 2]});
     * const output1 = flattenLayer.apply(input);
     *
     * // output1.shape is [null, 4]. The first dimension is the undetermined
     * // batch size. The second dimension comes from flattening the [2, 2]
     * // shape.
     * console.log(JSON.stringify(output1.shape));
     *
     * // The output SymbolicTensor of the flatten layer can be used to call
     * // the apply() of the dense layer:
     * const output2 = denseLayer.apply(output1);
     *
     * // output2.shape is [null, 1]. The first dimension is the undetermined
     * // batch size. The second dimension matches the number of units of the
     * // dense layer.
     * console.log(JSON.stringify(output2.shape));
     *
     * // The input and output can be used to construct a model that consists
     * // of the flatten and dense layers.
     * const model = tf.model({inputs: input, outputs: output2});
     * ```
     *
     * @param inputs a `tf.Tensor` or `tf.SymbolicTensor` or an Array of them.
     * @param kwargs Additional keyword arguments to be passed to `call()`.
     *
     * @return Output of the layer's `call` method.
     *
     * @exception ValueError error in case the layer is missing shape information
     *   for its `build` call.
     *
     * @doc {heading: 'Models', 'subheading': 'Classes'}
     */ // Porting Note: This is a replacement for __call__() in Python.
    apply(inputs, kwargs) {
        kwargs = kwargs || {};
        this.assertNotDisposed();
        // Ensure inputs are all the same type.
        const inputsList = $b5cd0926a1c6df1f$export$effcdbd76139450(inputs);
        const allAreSymbolic = $03271f6b4e448384$var$checkAllSymbolic(inputs);
        const noneAreSymbolic = $03271f6b4e448384$var$checkNoneSymbolic(inputs);
        if (allAreSymbolic === noneAreSymbolic) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)("Arguments to apply() must be all SymbolicTensors or all Tensors");
        // TODO(michaelterry): nameScope() may not be necessary.
        return (0, $860027d3b2c99a1d$export$e820b4f57a8e33d1)(this.name, ()=>{
            // Handle laying building (weight creating, input spec locking).
            if (!this.built) {
                /*
                  Throw exceptions in case the input is not compatible
                  with the inputSpec specified in the layer constructor.
                 */ this.assertInputCompatibility(inputs);
                // Collect input shapes to build layer.
                const inputShapes = [];
                for (const xElem of $b5cd0926a1c6df1f$export$effcdbd76139450(inputs))inputShapes.push(xElem.shape);
                this.build($b5cd0926a1c6df1f$export$8366660815493a21(inputShapes));
                this.built = true;
                // Load weights that were specified at layer instantiation.
                if (this.initialWeights) this.setWeights(this.initialWeights);
                if (this._refCount === null && noneAreSymbolic) // The first use of this layer is a non-symbolic call, set ref count
                // to 1 so the Layer can be properly disposed if its dispose() method
                // is called.
                this._refCount = 1;
            }
            /*
              Throw exceptions in case the input is not compatible
              with the inputSpec set at build time.
            */ this.assertInputCompatibility(inputs);
            // Handle mask propagation.
            // TODO(michaelterry): Mask propagation not currently implemented.
            // Actually call the layer, collecting output(s), mask(s), and shape(s).
            if (noneAreSymbolic) {
                let output = this.call(inputs, kwargs);
                // Apply masks to the output tensors if the layer supports it.
                if (this.supportsMasking) // TODO(mattsoulanille): pass the input tensors' masks to computeMask
                this.setMaskMetadata(inputs, output);
                // If the layer returns tensors from its inputs, unmodified,
                // we copy them to avoid loss of tensor metadata.
                const outputList = $b5cd0926a1c6df1f$export$effcdbd76139450(output);
                const outputListCopy = [];
                // TODO(michaelterry): This copying may not be necessary given our eager
                // backend.
                for (let x of outputList){
                    if (inputsList.indexOf(x) !== -1) x = x.clone();
                    outputListCopy.push(x);
                }
                output = $b5cd0926a1c6df1f$export$8366660815493a21(outputListCopy);
                if (this.activityRegularizer != null) throw new (0, $af476738b120e938$export$e162153238934121)("Layer invocation in the presence of activity regularizer(s) is not supported yet.");
                // TODO(michaelterry): Call addInboundNode()?
                return output;
            } else {
                const inputShape = $03271f6b4e448384$var$collectInputShape(inputs);
                const outputShape = this.computeOutputShape(inputShape);
                let output;
                const outputDType = $03271f6b4e448384$var$guessOutputDType(inputs);
                this.warnOnIncompatibleInputShape(Array.isArray(inputs) ? inputShape[0] : inputShape);
                if (outputShape != null && outputShape.length > 0 && Array.isArray(outputShape[0])) // We have multiple output shapes. Create multiple output tensors.
                output = outputShape.map((shape, index)=>new $03271f6b4e448384$export$c6d6977640680568(outputDType, shape, this, $b5cd0926a1c6df1f$export$effcdbd76139450(inputs), kwargs, this.name, index));
                else output = new $03271f6b4e448384$export$c6d6977640680568(outputDType, outputShape, this, $b5cd0926a1c6df1f$export$effcdbd76139450(inputs), kwargs, this.name);
                /*
                  Add an inbound node to the layer, so that it keeps track
                  of the call and of all new variables created during the call.
                  This also updates the layer history of the output tensor(s).
                  If the input tensor(s) had no previous history,
                  this does nothing.
                */ this.addInboundNode(inputs, output, null, null, inputShape, outputShape, kwargs);
                this._refCount++;
                if (this.activityRegularizer != null) throw new (0, $af476738b120e938$export$e162153238934121)("Layer invocation in the presence of activity regularizer(s) is not supported yet.");
                return output;
            }
        });
    }
    /**
     * Check compatibility between input shape and this layer's batchInputShape.
     *
     * Print warning if any incompatibility is found.
     *
     * @param inputShape Input shape to be checked.
     */ warnOnIncompatibleInputShape(inputShape) {
        if (this.batchInputShape == null) return;
        else if (inputShape.length !== this.batchInputShape.length) console.warn(`The rank of the input tensor provided (shape: ` + `${JSON.stringify(inputShape)}) does not match that of the ` + `batchInputShape (${JSON.stringify(this.batchInputShape)}) ` + `of the layer ${this.name}`);
        else {
            let dimMismatch = false;
            this.batchInputShape.forEach((dimension, i)=>{
                if (dimension != null && inputShape[i] != null && inputShape[i] !== dimension) dimMismatch = true;
            });
            if (dimMismatch) console.warn(`The shape of the input tensor ` + `(${JSON.stringify(inputShape)}) does not ` + `match the expectation of layer ${this.name}: ` + `${JSON.stringify(this.batchInputShape)}`);
        }
    }
    /**
     * Retrieves the output shape(s) of a layer.
     *
     * Only applicable if the layer has only one inbound node, or if all inbound
     * nodes have the same output shape.
     *
     * @returns Output shape or shapes.
     * @throws AttributeError: if the layer is connected to more than one incoming
     *   nodes.
     *
     * @doc {heading: 'Models', 'subheading': 'Classes'}
     */ get outputShape() {
        if (this.inboundNodes == null || this.inboundNodes.length === 0) throw new (0, $af476738b120e938$export$3869bf0637a5d0ff)(`The layer ${this.name} has never been called and thus has no ` + `defined output shape.`);
        const allOutputShapes = [];
        for (const node of this.inboundNodes){
            const shapeString = JSON.stringify(node.outputShapes);
            if (allOutputShapes.indexOf(shapeString) === -1) allOutputShapes.push(shapeString);
        }
        if (allOutputShapes.length === 1) {
            const outputShapes = this.inboundNodes[0].outputShapes;
            if (Array.isArray(outputShapes) && Array.isArray(outputShapes[0]) && outputShapes.length === 1) return outputShapes[0];
            else return outputShapes;
        } else throw new (0, $af476738b120e938$export$3869bf0637a5d0ff)(`The layer ${this.name} has multiple inbound nodes with different ` + `output shapes. Hence the notion of "output shape" is ill-defined ` + `for the layer.`);
    }
    /**
     * Counts the total number of numbers (e.g., float32, int32) in the
     * weights.
     *
     * @returns An integer count.
     * @throws RuntimeError: If the layer is not built yet (in which case its
     *   weights are not defined yet.)
     *
     * @doc {heading: 'Models', 'subheading': 'Classes'}
     */ countParams() {
        if (!this.built) throw new (0, $af476738b120e938$export$4a24a86bdbcf02bb)(`You tried to call countParams() on ${this.name}, ` + `but the layer is not built yet. Build it first by calling ` + `build(batchInputShape).`);
        return $ed799730592766a6$export$2a41d41251f01d03(this.weights);
    }
    /**
     * Creates the layer weights.
     *
     * Must be implemented on all layers that have weights.
     *
     * Called when apply() is called to construct the weights.
     *
     * @param inputShape A `Shape` or array of `Shape` (unused).
     *
     * @doc {heading: 'Models', 'subheading': 'Classes'}
     */ build(inputShape) {
        this.built = true;
    }
    /**
     * Returns the current values of the weights of the layer.
     *
     * @param trainableOnly Whether to get the values of only trainable weights.
     * @returns Weight values as an `Array` of `tf.Tensor`s.
     *
     * @doc {heading: 'Models', 'subheading': 'Classes'}
     */ getWeights(trainableOnly = false) {
        return (0, $47730a883443b08f$export$3702262f615cc9f0)(trainableOnly ? this.trainableWeights : this.weights);
    }
    /**
     * Sets the weights of the layer, from Tensors.
     *
     * @param weights a list of Tensors. The number of arrays and their shape
     *   must match number of the dimensions of the weights of the layer (i.e.
     *   it should match the output of `getWeights`).
     *
     * @exception ValueError If the provided weights list does not match the
     *   layer's specifications.
     *
     * @doc {heading: 'Models', 'subheading': 'Classes'}
     */ setWeights(weights) {
        (0, $i64bB.tidy)(()=>{
            const params = this.weights;
            if (params.length !== weights.length) // TODO(cais): Restore the following and use `providedWeights`, instead
            // of `weights` in the error message, once the deeplearn.js bug is
            // fixed: https://github.com/PAIR-code/deeplearnjs/issues/498 const
            // providedWeights = JSON.stringify(weights).slice(0, 50);
            throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`You called setWeights(weights) on layer "${this.name}" ` + `with a weight list of length ${weights.length}, ` + `but the layer was expecting ${params.length} weights. ` + `Provided weights: ${weights}...`);
            if (params.length === 0) return;
            const weightValueTuples = [];
            const paramValues = (0, $47730a883443b08f$export$3702262f615cc9f0)(params);
            for(let i = 0; i < paramValues.length; ++i){
                const pv = paramValues[i];
                const p = params[i];
                const w = weights[i];
                if (!(0, $i64bB.util).arraysEqual(pv.shape, w.shape)) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Layer weight shape ${pv.shape} ` + `not compatible with provided weight shape ${w.shape}`);
                weightValueTuples.push([
                    p,
                    w
                ]);
            }
            (0, $47730a883443b08f$export$6b1a34257a4982e4)(weightValueTuples);
        });
    }
    /**
     * Adds a weight variable to the layer.
     *
     * @param name Name of the new weight variable.
     * @param shape The shape of the weight.
     * @param dtype The dtype of the weight.
     * @param initializer An initializer instance.
     * @param regularizer A regularizer instance.
     * @param trainable Whether the weight should be trained via backprop or not
     *   (assuming that the layer itself is also trainable).
     * @param constraint An optional trainable.
     * @return The created weight variable.
     *
     * @doc {heading: 'Models', 'subheading': 'Classes'}
     */ addWeight(name, shape, dtype, initializer, regularizer, trainable, constraint, getInitializerFunc) {
        // Reject duplicate weight names.
        if (this._addedWeightNames.indexOf(name) !== -1) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Duplicate weight name ${name} for layer ${this.name}`);
        this._addedWeightNames.push(name);
        if (dtype == null) dtype = 'float32';
        if (this.fastWeightInitDuringBuild) initializer = getInitializerFunc != null ? getInitializerFunc() : (0, $49135dd97e6043ca$export$558b7d1a338df84b)('zeros');
        const initValue = initializer.apply(shape, dtype);
        const weight = new (0, $47730a883443b08f$export$25de78a5a5bf7257)(initValue, dtype, name, trainable, constraint);
        initValue.dispose();
        // Request backend not to dispose the weights of the model on scope() exit.
        if (regularizer != null) this.addLoss(()=>regularizer.apply(weight.read()));
        if (trainable == null) trainable = true;
        if (trainable) this._trainableWeights.push(weight);
        else this._nonTrainableWeights.push(weight);
        return weight;
    }
    /**
     * Set the fast-weight-initialization flag.
     *
     * In cases where the initialized weight values will be immediately
     * overwritten by loaded weight values during model loading, setting
     * the flag to `true` saves unnecessary calls to potentially expensive
     * initializers and speeds up the loading process.
     *
     * @param value Target value of the flag.
     */ setFastWeightInitDuringBuild(value) {
        this.fastWeightInitDuringBuild = value;
    }
    /**
     * Add losses to the layer.
     *
     * The loss may potentially be conditional on some inputs tensors,
     * for instance activity losses are conditional on the layer's inputs.
     *
     * @doc {heading: 'Models', 'subheading': 'Classes'}
     */ addLoss(losses) {
        if (losses == null || Array.isArray(losses) && losses.length === 0) return;
        // Update this.losses
        losses = $b5cd0926a1c6df1f$export$effcdbd76139450(losses);
        if (this._losses !== undefined && this._losses !== null) this.losses.push(...losses);
    }
    /**
     * Computes the output shape of the layer.
     *
     * Assumes that the layer will be built to match that input shape provided.
     *
     * @param inputShape A shape (tuple of integers) or a list of shape tuples
     *   (one per output tensor of the layer). Shape tuples can include null for
     *   free dimensions, instead of an integer.
     *
     * @doc {heading: 'Models', 'subheading': 'Classes'}
     */ computeOutputShape(inputShape) {
        return inputShape;
    }
    /**
     * Computes an output mask tensor.
     *
     * @param inputs Tensor or list of tensors.
     * @param mask Tensor or list of tensors.
     *
     * @return null or a tensor (or list of tensors, one per output tensor of the
     * layer).
     */ computeMask(inputs, mask) {
        if (!this.supportsMasking) {
            if (mask != null) {
                if (Array.isArray(mask)) mask.forEach((maskElement)=>{
                    if (maskElement != null) throw new TypeError(`Layer ${this.name} does not support masking, ` + 'but was passed an inputMask.');
                });
                else throw new TypeError(`Layer ${this.name} does not support masking, ` + 'but was passed an inputMask.');
            }
            // masking not explicitly supported: return null as mask
            return null;
        }
        // if masking is explictly supported, by default
        // carry over the input mask
        return mask;
    }
    setMaskMetadata(inputs, outputs, previousMask) {
        if (!this.supportsMasking) return;
        const outputMasks = this.computeMask(inputs, previousMask);
        const outputsList = $b5cd0926a1c6df1f$export$effcdbd76139450(outputs);
        const outputMasksList = $b5cd0926a1c6df1f$export$effcdbd76139450(outputMasks);
        if (outputsList.length !== outputMasksList.length) throw new Error(`${this.name} outputs ${outputsList.length} tensors ` + `but ${outputsList.length} masks for those tensors`);
        for(let i = 0; i < outputsList.length; i++)outputsList[i].kerasMask = outputMasksList[i];
    }
    /**
     * Internal method to create an inbound node for the layer.
     *
     * @param inputTensors List of input tensors.
     * @param outputTensors List of output tensors.
     * @param inputMasks List of input masks (a mask can be a tensor, or null).
     * @param outputMasks List of output masks (a mask can be a tensor, or null).
     * @param inputShapes List of input shape tuples.
     * @param outputShapes List of output shape tuples.
     * @param kwargs Dictionary of keyword arguments that were passed to the
     *   `call` method of the layer at the call that created the node.
     */ addInboundNode(inputTensors, outputTensors, inputMasks, outputMasks, inputShapes, outputShapes, kwargs = null) {
        const inputTensorList = $b5cd0926a1c6df1f$export$effcdbd76139450(inputTensors);
        outputTensors = $b5cd0926a1c6df1f$export$effcdbd76139450(outputTensors);
        inputMasks = $b5cd0926a1c6df1f$export$effcdbd76139450(inputMasks);
        outputMasks = $b5cd0926a1c6df1f$export$effcdbd76139450(outputMasks);
        inputShapes = $e11ae28082970f77$export$4cdd3da5579ac4c4(inputShapes);
        outputShapes = $e11ae28082970f77$export$4cdd3da5579ac4c4(outputShapes);
        // Collect input tensor(s) coordinates.
        const inboundLayers = [];
        const nodeIndices = [];
        const tensorIndices = [];
        for (const x of inputTensorList){
            /*
             * TODO(michaelterry): Keras adds this value to tensors; it's not
             * clear whether we'll use this or not.
             */ inboundLayers.push(x.sourceLayer);
            nodeIndices.push(x.nodeIndex);
            tensorIndices.push(x.tensorIndex);
        }
        // Create node, add it to inbound nodes.
        // (This call has side effects.)
        // tslint:disable-next-line:no-unused-expression
        new $03271f6b4e448384$export$85c928794f8d04d4({
            outboundLayer: this,
            inboundLayers: inboundLayers,
            nodeIndices: nodeIndices,
            tensorIndices: tensorIndices,
            inputTensors: inputTensorList,
            outputTensors: outputTensors,
            inputMasks: inputMasks,
            outputMasks: outputMasks,
            inputShapes: inputShapes,
            outputShapes: outputShapes
        }, kwargs);
        // Update tensor history
        for(let i = 0; i < outputTensors.length; i++){
            // TODO(michaelterry: _uses_learning_phase not tracked.
            outputTensors[i].sourceLayer = this;
            outputTensors[i].nodeIndex = this.inboundNodes.length - 1;
            outputTensors[i].tensorIndex = i;
        }
    }
    /**
     * Returns the config of the layer.
     *
     * A layer config is a TS dictionary (serializable)
     * containing the configuration of a layer.
     * The same layer can be reinstantiated later
     * (without its trained weights) from this configuration.
     *
     * The config of a layer does not include connectivity
     * information, nor the layer class name.  These are handled
     * by 'Container' (one layer of abstraction above).
     *
     * Porting Note: The TS dictionary follows TS naming standards for
     * keys, and uses tfjs-layers type-safe Enums.  Serialization methods
     * should use a helper function to convert to the pythonic storage
     * standard. (see serialization_utils.convertTsToPythonic)
     *
     * @returns TS dictionary of configuration.
     *
     * @doc {heading: 'Models', 'subheading': 'Classes'}
     */ getConfig() {
        const config = {
            name: this.name,
            trainable: this.trainable
        };
        if (this.batchInputShape != null) config['batchInputShape'] = this.batchInputShape;
        if (this.dtype != null) config['dtype'] = this.dtype;
        return config;
    }
    /**
     * Dispose the weight variables that this Layer instance holds.
     *
     * @returns {number} Number of disposed variables.
     */ disposeWeights() {
        this.weights.forEach((weight)=>weight.dispose());
        return this.weights.length;
    }
    assertNotDisposed() {
        if (this._refCount === 0) throw new Error(`Layer '${this.name}' is already disposed.`);
    }
    /**
     * Attempt to dispose layer's weights.
     *
     * This method decreases the reference count of the Layer object by 1.
     *
     * A Layer is reference-counted. Its reference count is incremented by 1
     * the first item its `apply()` method is called and when it becomes a part
     * of a new `Node` (through calling the `apply()` method on a
     * `tf.SymbolicTensor`).
     *
     * If the reference count of a Layer becomes 0, all the weights will be
     * disposed and the underlying memory (e.g., the textures allocated in WebGL)
     * will be freed.
     *
     * Note: If the reference count is greater than 0 after the decrement, the
     * weights of the Layer will *not* be disposed.
     *
     * After a Layer is disposed, it cannot be used in calls such as `apply()`,
     * `getWeights()` or `setWeights()` anymore.
     *
     * @returns A DisposeResult Object with the following fields:
     *   - refCountAfterDispose: The reference count of the Container after this
     *     `dispose()` call.
     *   - numDisposedVariables: Number of `tf.Variable`s (i.e., weights) disposed
     *     during this `dispose()` call.
     * @throws {Error} If the layer is not built yet, or if the layer has already
     *   been disposed.
     *
     * @doc {heading: 'Models', 'subheading': 'Classes'}
     */ dispose() {
        if (!this.built) throw new Error(`Cannot dispose Layer ${this.name} because it has not been ` + `built yet.`);
        if (this._refCount === null) throw new Error(`Cannot dispose Layer ${this.name} because it has not been used ` + `yet.`);
        this.assertNotDisposed();
        let numDisposedVariables = 0;
        if (--this._refCount === 0) numDisposedVariables = this.disposeWeights();
        return {
            refCountAfterDispose: this._refCount,
            numDisposedVariables: numDisposedVariables
        };
    }
}
/**
 * Collects the input shape(s) of a list of `tf.Tensor`s or
 * `tf.SymbolicTensor`s.
 *
 * TODO(michaelterry): Update PyKeras docs (backport).
 *
 * @param inputTensors List of input tensors (or single input tensor).
 *
 * @return List of shape tuples (or single tuple), one tuple per input.
 */ function $03271f6b4e448384$var$collectInputShape(inputTensors) {
    inputTensors = $b5cd0926a1c6df1f$export$effcdbd76139450(inputTensors);
    const shapes = [];
    for (const x of inputTensors)shapes.push(x.shape);
    return $b5cd0926a1c6df1f$export$8366660815493a21(shapes);
}
/**
 * Guesses output dtype based on inputs.
 *
 * At present, just returns 'float32' for any input.
 *
 * @param inputTensors List of input tensors (or single input tensor).
 *
 * @return The guessed DType. At present, always returns 'float32'.
 */ function $03271f6b4e448384$var$guessOutputDType(inputTensors) {
    return 'float32';
}
function $03271f6b4e448384$export$6d61b4ed0b6fb596(tensor, layer, nodeIndex) {
    if (layer == null || nodeIndex != null && nodeIndex > 0) {
        layer = tensor.sourceLayer;
        nodeIndex = tensor.nodeIndex;
    }
    if (layer.inboundNodes.length === 0) return [
        tensor
    ];
    else {
        const node = layer.inboundNodes[nodeIndex];
        if (node.inboundLayers.length === 0) return node.inputTensors;
        else {
            const sourceTensors = [];
            for(let i = 0; i < node.inboundLayers.length; i++){
                const x = node.inputTensors[i];
                const layer = node.inboundLayers[i];
                const nodeIndex = node.nodeIndices[i];
                const previousSources = $03271f6b4e448384$export$6d61b4ed0b6fb596(x, layer, nodeIndex);
                // Avoid input redundancy.
                for (const x of previousSources)if (sourceTensors.indexOf(x) === -1) sourceTensors.push(x);
            }
            return sourceTensors;
        }
    }
}
function $03271f6b4e448384$var$checkAllSymbolic(tensors) {
    let allAreSymbolic = true;
    for (const tensor of $b5cd0926a1c6df1f$export$effcdbd76139450(tensors))if (!(tensor instanceof $03271f6b4e448384$export$c6d6977640680568)) {
        allAreSymbolic = false;
        break;
    }
    return allAreSymbolic;
}
function $03271f6b4e448384$var$checkNoneSymbolic(tensors) {
    let noneAreSymbolic = true;
    for (const tensor of $b5cd0926a1c6df1f$export$effcdbd76139450(tensors))if (tensor instanceof $03271f6b4e448384$export$c6d6977640680568) {
        noneAreSymbolic = false;
        break;
    }
    return noneAreSymbolic;
}


class $b470cf8df79854ee$export$191123fdb608c9b4 extends (0, $03271f6b4e448384$export$936d0764594b6eb3) {
    constructor(args){
        super({
            dtype: args.dtype,
            name: args.name != null ? args.name : (0, $cde2737e4648ad82$export$5e82334337e0f204)('input').toString()
        });
        // Normalize config.batchSize and config.sparse
        if (args.batchSize == null) args.batchSize = null;
        if (args.sparse == null) args.sparse = false;
        this.trainable = false;
        this.built = true;
        this.sparse = args.sparse;
        if (args.inputShape != null && args.batchInputShape != null) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)("Only provide the inputShape OR batchInputShape argument to inputLayer, not both at the same time.");
        let batchInputShape = args.batchInputShape;
        if (batchInputShape == null) {
            if (args.inputShape == null) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)("An InputLayer should be passed either a `batchInputShape` or an `inputShape`.");
            else batchInputShape = [
                args.batchSize
            ].concat(args.inputShape);
        } else {
            // TODO(michaelterry): Backport to PyKeras
            if (args.batchSize != null) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)("Cannot specify batchSize if batchInputShape is specified when creating an InputLayer.");
        }
        const dtype = args.dtype || 'float32';
        this.batchInputShape = batchInputShape;
        this.dtype = dtype;
        // TODO(michaelterry): Backport this to PyKeras?
        this.inputSpec = [
            {
                shape: batchInputShape
            }
        ];
        const inputTensor = new (0, $03271f6b4e448384$export$c6d6977640680568)(this.dtype, this.batchInputShape, this, [], {}, this.name);
        inputTensor.nodeIndex = 0;
        inputTensor.tensorIndex = 0;
        // Create an input node to add to this.outboundNode.
        // (This call has side effects.)
        // tslint:disable-next-line:no-unused-expression
        new (0, $03271f6b4e448384$export$85c928794f8d04d4)({
            outboundLayer: this,
            inboundLayers: [],
            nodeIndices: [],
            tensorIndices: [],
            inputTensors: [
                inputTensor
            ],
            outputTensors: [
                inputTensor
            ],
            inputMasks: [
                null
            ],
            outputMasks: [
                null
            ],
            inputShapes: [
                batchInputShape
            ],
            outputShapes: [
                batchInputShape
            ]
        });
    }
    apply(inputs, kwargs) {
        throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)('Cannot pass any input to an ' + `InputLayer's apply() method. InputLayer name: ${this.name}`);
    }
    dispose() {
        // dispose() for InputLayer is overridden as no-op.
        return {
            refCountAfterDispose: this._refCount,
            numDisposedVariables: 0
        };
    }
    getConfig() {
        return {
            batchInputShape: this.batchInputShape,
            dtype: this.dtype,
            sparse: this.sparse,
            name: this.name
        };
    }
}
/** @nocollapse */ $b470cf8df79854ee$export$191123fdb608c9b4.className = 'InputLayer';
(0, $i64bB.serialization).registerClass($b470cf8df79854ee$export$191123fdb608c9b4);
function $b470cf8df79854ee$export$f5b8910cec6cf069(config) {
    if (config.batchShape == null && config.shape == null) throw new Error("Please provide to Input either a `shape` or a `batchShape` argument. Note that `shape` does not include the batch dimension.");
    if (config.batchShape != null && config.shape != null) // TODO(michaelterry): Backport to PyKeras.
    throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)("Please provide either a `shape` or `batchShape` argument to Input, but not both.");
    let batchShape = config.batchShape;
    if (config.shape != null && batchShape == null) batchShape = [
        null
    ].concat(config.shape);
    let dtype = config.dtype;
    if (dtype == null) dtype = 'float32';
    const inputLayer = new $b470cf8df79854ee$export$191123fdb608c9b4({
        batchInputShape: batchShape,
        name: config.name,
        dtype: dtype,
        sparse: config.sparse
    });
    const outputs = inputLayer.inboundNodes[0].outputTensors;
    return outputs[0];
}



/**
 * Helper function to check the dtype and shape compatibility of a feed value.
 */ function $2aacd5aadd0fd9b5$var$assertFeedCompatibility(key, val) {
    // Check dtype compatibility.
    if (key.dtype == null || key.dtype === val.dtype) //  a.  If types match, return val tensor as is.
    return val;
    try {
        //  b. Attempt to convert to expected type.
        return (0, $i64bB.cast)(val, key.dtype);
    } catch (err) {
        //  c. If conversion fails, return helpful error.
        throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`The dtype of the feed (${val.dtype}) can not be cast to the dtype ` + `of the key '${key.name}' (${key.dtype}).`);
    }
}
class $2aacd5aadd0fd9b5$export$1f554ac52b4b6917 {
    /**
     * Constructor, optionally does copy-construction.
     * @param feeds An Array of `Feed`s, or another `FeedDict`, in which case
     *   copy-construction will be performed.
     */ constructor(feeds){
        this.id2Value = {};
        this.id2Mask = {};
        this.name2Id = {};
        if (feeds instanceof $2aacd5aadd0fd9b5$export$1f554ac52b4b6917) for(const id in feeds.id2Value){
            this.id2Value[id] = feeds.id2Value[id];
            if (id in feeds.id2Mask) this.id2Mask[id] = feeds.id2Mask[id];
        }
        else {
            if (feeds == null) return;
            for (const feed of feeds)this.add(feed.key, feed.value);
        }
    }
    /**
     * Add a key-value pair to the FeedDict.
     *
     * @param key The key of the feed.
     * @param value The value of the tensor feed.
     * @param mask The value of the mask feed (optional).
     * @returns This `FeedDict`.
     * @throws ValueError: If the key `SymbolicTensor` already exists in the
     *   `FeedDict`.
     */ add(key, value, mask) {
        if (this.id2Value[key.id] == null) {
            this.id2Value[key.id] = $2aacd5aadd0fd9b5$var$assertFeedCompatibility(key, value);
            this.name2Id[key.name] = key.id;
            if (mask != null) this.id2Mask[key.id] = mask;
        } else throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Duplicate key: name=${key.name}, id=${key.id}`);
        return this;
    }
    /**
     * Add a Feed to the FeedDict.
     * @param feed The new `Feed` to add.
     * @returns This `FeedDict`.
     */ addFeed(feed) {
        this.add(feed.key, feed.value);
    }
    /**
     * Probe whether a key already exists in the FeedDict.
     * @param key
     */ hasKey(key) {
        return this.id2Value[key.id] != null;
    }
    /**
     * Get all the SymbolicTensor available in this FeedDict.
     */ names() {
        return Object.keys(this.name2Id);
    }
    /**
     * Get the feed value for given key.
     * @param key The SymbolicTensor, or its name (as a string), of which the
     *     value is sought.
     * @returns If `key` exists, the corresponding feed value.
     * @throws ValueError: If `key` does not exist in this `FeedDict`.
     */ getValue(key) {
        if (key instanceof (0, $03271f6b4e448384$export$c6d6977640680568)) {
            if (this.id2Value[key.id] == null) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Nonexistent key: ${key.name}`);
            else return this.id2Value[key.id];
        } else {
            const id = this.name2Id[key];
            if (id == null) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Feed dict has no SymbolicTensor name: ${key}`);
            return this.id2Value[id];
        }
    }
    /**
     * Get the feed mask for given key.
     * @param key The SymbolicTensor, or its name (as a string), of which the
     *     value is sought.
     * @returns If `key` exists, the corresponding feed mask.
     * @throws ValueError: If `key` does not exist in this `FeedDict`.
     */ getMask(key) {
        if (key instanceof (0, $03271f6b4e448384$export$c6d6977640680568)) {
            if (this.id2Value[key.id] == null) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Nonexistent key: ${key.name}`);
            else return this.id2Mask[key.id];
        } else {
            const id = this.name2Id[key];
            if (id == null) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Feed dict has no SymbolicTensor name: ${key}`);
            return this.id2Mask[id];
        }
    }
    /** Dispose all mask Tensors held by this object. */ disposeMasks() {
        if (this.id2Mask != null) (0, $i64bB.dispose)(this.id2Mask);
    }
}
const $2aacd5aadd0fd9b5$export$44a630df56e5b996 = new (0, $f023038a555cadeb$export$ec63a4108685a0aa)();
const $2aacd5aadd0fd9b5$export$f790425d308658ea = new (0, $f023038a555cadeb$export$ec63a4108685a0aa)();
function $2aacd5aadd0fd9b5$export$2dc27e9d70f80ac7(maxEntries) {
    if ($2aacd5aadd0fd9b5$export$44a630df56e5b996 != null) $2aacd5aadd0fd9b5$export$44a630df56e5b996.setMaxEntries(maxEntries);
    if ($2aacd5aadd0fd9b5$export$f790425d308658ea != null) $2aacd5aadd0fd9b5$export$f790425d308658ea.setMaxEntries(maxEntries);
}
function $2aacd5aadd0fd9b5$export$51396ec711da548b(fetches, feedDict, kwargs, probe) {
    const training = kwargs == null ? false : kwargs['training'];
    const arrayFetches = Array.isArray(fetches);
    const fetchArray = arrayFetches ? fetches : [
        fetches
    ];
    const outputNames = fetchArray.map((t)=>t.name);
    const finalOutputs = [];
    const feedNames = feedDict.names();
    for (const outputName of outputNames)if (feedNames.indexOf(outputName) !== -1) finalOutputs.push(feedDict.getValue(outputName));
    else finalOutputs.push(null);
    if (probe != null) {
        // For optional probing of memory footprint during execution.
        probe.maxNumTensors = -Infinity;
        probe.minNumTensors = Infinity;
    }
    // Check cache.
    const fetchAndFeedKey = outputNames.join(',') + '|' + feedDict.names().sort().join(',');
    let sorted = $2aacd5aadd0fd9b5$export$44a630df56e5b996.get(fetchAndFeedKey);
    let recipientCounts;
    if (sorted == null) {
        // Cache doesn't contain the desired combination of fetches. Compute
        // topological sort for the combination for the first time.
        const out = $2aacd5aadd0fd9b5$var$getTopologicalSortAndRecipientCounts(fetchArray, feedDict);
        sorted = out.sorted;
        recipientCounts = out.recipientCounts;
        // Store results in cache for future use.
        $2aacd5aadd0fd9b5$export$44a630df56e5b996.put(fetchAndFeedKey, sorted);
        $2aacd5aadd0fd9b5$export$f790425d308658ea.put(fetchAndFeedKey, recipientCounts);
    }
    recipientCounts = {};
    if (!training) Object.assign(recipientCounts, $2aacd5aadd0fd9b5$export$f790425d308658ea.get(fetchAndFeedKey));
    const internalFeedDict = new $2aacd5aadd0fd9b5$export$1f554ac52b4b6917(feedDict);
    // Start iterative execution on the topologically-sorted SymbolicTensors.
    for(let i = 0; i < sorted.length; ++i){
        if (probe != null) {
            // For optional probing of memory usage during execution.
            const numTensors = (0, $i64bB.memory)().numTensors;
            if (numTensors > probe.maxNumTensors) probe.maxNumTensors = numTensors;
            if (numTensors < probe.minNumTensors) probe.minNumTensors = numTensors;
        }
        const symbolic = sorted[i];
        const srcLayer = symbolic.sourceLayer;
        if (srcLayer instanceof (0, $b470cf8df79854ee$export$191123fdb608c9b4)) continue;
        const inputValues = [];
        const inputMasks = [];
        const tensorsToDispose = [];
        let maskExists = false;
        for (const input of symbolic.inputs){
            const value = internalFeedDict.getValue(input);
            const mask = internalFeedDict.getMask(input);
            inputValues.push(value);
            inputMasks.push(mask);
            if (mask != null) maskExists = true;
            if (!training) {
                recipientCounts[input.name]--;
                if (recipientCounts[input.name] === 0 && !feedDict.hasKey(input) && outputNames.indexOf(input.name) === -1 && !value.isDisposed && input.sourceLayer.stateful !== true) tensorsToDispose.push(value);
            }
        }
        if (maskExists) {
            kwargs = kwargs || {};
            kwargs['mask'] = inputMasks[0];
        }
        const outputTensors = (0, $b5cd0926a1c6df1f$export$effcdbd76139450)(srcLayer.apply(inputValues, kwargs));
        let outputMask = null;
        if (srcLayer.supportsMasking) outputMask = srcLayer.computeMask(inputValues, inputMasks);
        const layerOutputs = $2aacd5aadd0fd9b5$var$getNodeOutputs(symbolic);
        const outputSymbolicTensors = Array.isArray(layerOutputs) ? layerOutputs : [
            layerOutputs
        ];
        for(let i = 0; i < outputSymbolicTensors.length; ++i){
            if (!internalFeedDict.hasKey(outputSymbolicTensors[i])) internalFeedDict.add(outputSymbolicTensors[i], outputTensors[i], Array.isArray(outputMask) ? outputMask[0] : outputMask);
            const index = outputNames.indexOf(outputSymbolicTensors[i].name);
            if (index !== -1) finalOutputs[index] = outputTensors[i];
        }
        if (!training) // Clean up Tensors that are no longer needed.
        (0, $i64bB.dispose)(tensorsToDispose);
    }
    // NOTE(cais): Unlike intermediate tensors, we don't discard mask
    // tensors as we go, because these tensors are sometimes passed over a
    // series of mutliple layers, i.e., not obeying the immediate input
    // relations in the graph. If this becomes a memory-usage concern,
    // we can improve this in the future.
    internalFeedDict.disposeMasks();
    return arrayFetches ? finalOutputs : finalOutputs[0];
}
/**
 * Sort the `SymbolicTensor`s topologically, for an array of fetches.
 *
 * This function calls getTopologicalSortAndRecipientCountsForOneFetch and
 * merges their results.
 *
 * @param fetch The array of fetches requested. Must be a non-empty array.
 * @param feedDict The dictionary of fed values.
 * @returns sorted: Topologically-sorted array of SymbolicTensors.
 *   recipientCounts: Recipient counts for all SymbolicTensors in `sorted`.
 */ function $2aacd5aadd0fd9b5$var$getTopologicalSortAndRecipientCounts(fetches, feedDict) {
    (0, $i64bB.util).assert(fetches != null && fetches.length > 0, ()=>`Expected at least one fetch, got none`);
    let finalSorted = [];
    let finalRecipientMap = {};
    if (fetches.length === 1) {
        // Special-casing 1 fetch for efficiency.
        const out = $2aacd5aadd0fd9b5$export$a8bd8d591d4e6bd9(fetches[0], feedDict);
        finalSorted = out.sorted;
        finalRecipientMap = out.recipientMap;
    } else {
        const visited = new Set();
        for (const fetch of fetches){
            const { sorted: sorted, recipientMap: recipientMap } = $2aacd5aadd0fd9b5$export$a8bd8d591d4e6bd9(fetch, feedDict);
            // Merge sorted SymbolicTensor Arrays.
            for (const symbolicTensor of sorted)if (!visited.has(symbolicTensor.name)) {
                finalSorted.push(symbolicTensor);
                visited.add(symbolicTensor.name);
            }
            // Merge recipient maps.
            for(const name in recipientMap){
                if (finalRecipientMap[name] == null) finalRecipientMap[name] = new Set();
                recipientMap[name].forEach((recipient)=>finalRecipientMap[name].add(recipient));
            }
        }
    }
    return {
        sorted: finalSorted,
        recipientCounts: $2aacd5aadd0fd9b5$var$recipientMap2Counts(finalRecipientMap)
    };
}
function $2aacd5aadd0fd9b5$var$recipientMap2Counts(recipientMap) {
    const recipientCounts = {};
    for(const name in recipientMap)recipientCounts[name] = recipientMap[name].size;
    return recipientCounts;
}
function $2aacd5aadd0fd9b5$export$a8bd8d591d4e6bd9(fetch, feedDict) {
    const visited = new Set();
    const sorted = [];
    const recipientMap = {};
    // Put keys of the feedDict into visited first, so they don't have to be
    // walked. This is needed in case where there are feeds for intermediate
    // SymbolicTensors of the graph.
    for (const key of feedDict.names())visited.add(key);
    const stack = [];
    const marks = [];
    // Initial population of stack and marks.
    stack.push(fetch);
    while(stack.length > 0){
        const top = stack[stack.length - 1];
        if (visited.has(top.name)) {
            stack.pop();
            continue;
        }
        const topIsMarked = marks[marks.length - 1] === stack.length - 1;
        if (top.inputs.length === 0 || topIsMarked) {
            // Input SymbolicTensor or all children have been visited.
            stack.pop();
            sorted.push(top);
            visited.add(top.name);
            if (topIsMarked) marks.pop();
        } else {
            // A non-input SymbolicTensor whose upstream SymbolicTensors haven't
            // been visited yet. Push them onto the stack.
            marks.push(stack.length - 1);
            for (const input of top.inputs){
                // Increment the recipient count. Note that this needs to happen
                // regardless of whether the SymbolicTensor has been visited before.
                if (recipientMap[input.name] == null) recipientMap[input.name] = new Set();
                recipientMap[input.name].add(top.name);
                if (visited.has(input.name)) continue; // Avoid repeated visits to the same SymbolicTensor.
                stack.push(input);
            }
        }
    }
    return {
        sorted: sorted,
        recipientMap: recipientMap
    };
}
/**
 * Get the symbolic output tensors of the node to which a given fetch belongs.
 * @param fetch The fetched symbolic tensor.
 * @returns The Array of symbolic tensors output by the node to which `fetch`
 *   belongs.
 */ function $2aacd5aadd0fd9b5$var$getNodeOutputs(fetch) {
    let layerOutputs;
    if (fetch.sourceLayer.inboundNodes.length === 1) layerOutputs = fetch.sourceLayer.output;
    else {
        let nodeIndex = null;
        for(let i = 0; i < fetch.sourceLayer.inboundNodes.length; ++i){
            for (const outputTensor of fetch.sourceLayer.inboundNodes[i].outputTensors)if (outputTensor.id === fetch.id) {
                nodeIndex = i;
                break;
            }
        }
        layerOutputs = fetch.sourceLayer.getOutputAt(nodeIndex);
    }
    return layerOutputs;
}


const $e2138e534aa276ae$export$83401e34d5e11bf4 = (0, $i64bB.env)();
/** The max number of entries for the caches of layers' topological sort. */ $e2138e534aa276ae$export$83401e34d5e11bf4.registerFlag('TOPOLOGICAL_SORT_CACHE_MAX_ENTRIES', ()=>100, (0, $2aacd5aadd0fd9b5$export$2dc27e9d70f80ac7));


parcelRequire("i64bB");

/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ // tslint:disable-next-line:max-line-length
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /* Original source: keras/contraints.py */ 
var $i64bB = parcelRequire("i64bB");


/**
 * Helper function used by many of the Constraints to find the L2Norms.
 */ function $ef279f7fc82ac2a7$var$calcL2Norms(w, axis) {
    return (0, $i64bB.tidy)(()=>$i64bB.sqrt($i64bB.sum($i64bB.mul(w, w), axis, true)));
}
class $ef279f7fc82ac2a7$export$aec1359a0a40a615 extends (0, $i64bB.serialization).Serializable {
    getConfig() {
        return {};
    }
}
class $ef279f7fc82ac2a7$export$9bae576b4abeeb5b extends $ef279f7fc82ac2a7$export$aec1359a0a40a615 {
    constructor(args){
        super();
        this.defaultMaxValue = 2;
        this.defaultAxis = 0;
        this.maxValue = args.maxValue != null ? args.maxValue : this.defaultMaxValue;
        this.axis = args.axis != null ? args.axis : this.defaultAxis;
    }
    apply(w) {
        return (0, $i64bB.tidy)(()=>{
            const norms = $ef279f7fc82ac2a7$var$calcL2Norms(w, this.axis);
            const desired = $i64bB.clipByValue(norms, 0, this.maxValue);
            return $i64bB.mul(w, $i64bB.div(desired, $i64bB.add((0, $043e1401aa799097$export$6c421550c66a327d)(), norms)));
        });
    }
    getConfig() {
        return {
            maxValue: this.maxValue,
            axis: this.axis
        };
    }
}
/** @nocollapse */ $ef279f7fc82ac2a7$export$9bae576b4abeeb5b.className = 'MaxNorm';
(0, $i64bB.serialization).registerClass($ef279f7fc82ac2a7$export$9bae576b4abeeb5b);
class $ef279f7fc82ac2a7$export$d308398b296446e8 extends $ef279f7fc82ac2a7$export$aec1359a0a40a615 {
    constructor(args){
        super();
        this.defaultAxis = 0;
        this.axis = args.axis != null ? args.axis : this.defaultAxis;
    }
    apply(w) {
        return (0, $i64bB.tidy)(()=>$i64bB.div(w, $i64bB.add((0, $043e1401aa799097$export$6c421550c66a327d)(), $ef279f7fc82ac2a7$var$calcL2Norms(w, this.axis))));
    }
    getConfig() {
        return {
            axis: this.axis
        };
    }
}
/** @nocollapse */ $ef279f7fc82ac2a7$export$d308398b296446e8.className = 'UnitNorm';
(0, $i64bB.serialization).registerClass($ef279f7fc82ac2a7$export$d308398b296446e8);
class $ef279f7fc82ac2a7$export$e401f85674f409b extends $ef279f7fc82ac2a7$export$aec1359a0a40a615 {
    apply(w) {
        return $i64bB.relu(w);
    }
}
/** @nocollapse */ $ef279f7fc82ac2a7$export$e401f85674f409b.className = 'NonNeg';
(0, $i64bB.serialization).registerClass($ef279f7fc82ac2a7$export$e401f85674f409b);
class $ef279f7fc82ac2a7$export$b6619aa7a63dac34 extends $ef279f7fc82ac2a7$export$aec1359a0a40a615 {
    constructor(args){
        super();
        this.defaultMinValue = 0.0;
        this.defaultMaxValue = 1.0;
        this.defaultRate = 1.0;
        this.defaultAxis = 0;
        this.minValue = args.minValue != null ? args.minValue : this.defaultMinValue;
        this.maxValue = args.maxValue != null ? args.maxValue : this.defaultMaxValue;
        this.rate = args.rate != null ? args.rate : this.defaultRate;
        this.axis = args.axis != null ? args.axis : this.defaultAxis;
    }
    apply(w) {
        return (0, $i64bB.tidy)(()=>{
            const norms = $ef279f7fc82ac2a7$var$calcL2Norms(w, this.axis);
            const desired = $i64bB.add($i64bB.mul(this.rate, $i64bB.clipByValue(norms, this.minValue, this.maxValue)), $i64bB.mul(1.0 - this.rate, norms));
            return $i64bB.mul(w, $i64bB.div(desired, $i64bB.add((0, $043e1401aa799097$export$6c421550c66a327d)(), norms)));
        });
    }
    getConfig() {
        return {
            minValue: this.minValue,
            maxValue: this.maxValue,
            rate: this.rate,
            axis: this.axis
        };
    }
}
/** @nocollapse */ $ef279f7fc82ac2a7$export$b6619aa7a63dac34.className = 'MinMaxNorm';
(0, $i64bB.serialization).registerClass($ef279f7fc82ac2a7$export$b6619aa7a63dac34);
const $ef279f7fc82ac2a7$export$78360a76bbd2e9aa = {
    'maxNorm': 'MaxNorm',
    'minMaxNorm': 'MinMaxNorm',
    'nonNeg': 'NonNeg',
    'unitNorm': 'UnitNorm'
};
function $ef279f7fc82ac2a7$export$e449710617725987(constraint) {
    return (0, $b5cd0926a1c6df1f$export$78f846918d17a884)(constraint);
}
function $ef279f7fc82ac2a7$export$20c8aa8a8b337f29(config, customObjects = {}) {
    return (0, $b5cd0926a1c6df1f$export$c33061eb381c60f9)(config, (0, $i64bB.serialization).SerializationMap.getMap().classNameMap, customObjects, 'constraint');
}
function $ef279f7fc82ac2a7$export$492f40394cb58978(identifier) {
    if (identifier == null) return null;
    if (typeof identifier === 'string') {
        const className = identifier in $ef279f7fc82ac2a7$export$78360a76bbd2e9aa ? $ef279f7fc82ac2a7$export$78360a76bbd2e9aa[identifier] : identifier;
        const config = {
            className: className,
            config: {}
        };
        return $ef279f7fc82ac2a7$export$20c8aa8a8b337f29(config);
    } else if (identifier instanceof $ef279f7fc82ac2a7$export$aec1359a0a40a615) return identifier;
    else return $ef279f7fc82ac2a7$export$20c8aa8a8b337f29(identifier);
}


function $a904a9337a2bb7cf$export$72d88ae287ab22e0(args) {
    return new (0, $ef279f7fc82ac2a7$export$9bae576b4abeeb5b)(args);
}
function $a904a9337a2bb7cf$export$4a1c05456842cde3(args) {
    return new (0, $ef279f7fc82ac2a7$export$d308398b296446e8)(args);
}
function $a904a9337a2bb7cf$export$38cf945efb543ffe() {
    return new (0, $ef279f7fc82ac2a7$export$e401f85674f409b)();
}
function $a904a9337a2bb7cf$export$a7a432272dbc707f(config) {
    return new (0, $ef279f7fc82ac2a7$export$b6619aa7a63dac34)(config);
}


/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ // tslint:disable-next-line:max-line-length

function $2a1665087e205ef6$export$4445a00dafa2633b() {
    return new (0, $49135dd97e6043ca$export$7a572cb9dc6aa81b)();
}
function $2a1665087e205ef6$export$21041dee6b8001b0() {
    return new (0, $49135dd97e6043ca$export$30750dcb47d2f6b)();
}
function $2a1665087e205ef6$export$c983f826f44ff86(args) {
    return new (0, $49135dd97e6043ca$export$3c508fb3f8ac1ad4)(args);
}
function $2a1665087e205ef6$export$bd6fd37822e292fa(args) {
    return new (0, $49135dd97e6043ca$export$29e2b6f5e4b82e2f)(args);
}
function $2a1665087e205ef6$export$a0ac5549a8bec918(args) {
    return new (0, $49135dd97e6043ca$export$66e863738cfcc40)(args);
}
function $2a1665087e205ef6$export$8ad5625727f3fa1d(args) {
    return new (0, $49135dd97e6043ca$export$5f0e8a39027050d5)(args);
}
function $2a1665087e205ef6$export$f0954fd7d5368655(args) {
    return new (0, $49135dd97e6043ca$export$544bf02140fa9a77)(args);
}
function $2a1665087e205ef6$export$206fc9a68431980(config) {
    return new (0, $49135dd97e6043ca$export$c2ba607ca0c6b5b3)(config);
}
function $2a1665087e205ef6$export$28a06568c84ecf15(args) {
    return new (0, $49135dd97e6043ca$export$c820ee55503e6df3)(args);
}
function $2a1665087e205ef6$export$92c012eb6ea18446(args) {
    return new (0, $49135dd97e6043ca$export$dcc636dfa962cdc9)(args);
}
function $2a1665087e205ef6$export$61e5648a74c4c89d(args) {
    return new (0, $49135dd97e6043ca$export$399f315e5cbd5eed)(args);
}
function $2a1665087e205ef6$export$89cebdcf433bb1f3(args) {
    return new (0, $49135dd97e6043ca$export$4799f50fbef71375)(args);
}
function $2a1665087e205ef6$export$e6506404c2021f85(args) {
    return new (0, $49135dd97e6043ca$export$f0843b4cb97b93f5)(args);
}
function $2a1665087e205ef6$export$fbc1aa9dab0cc647(args) {
    return new (0, $49135dd97e6043ca$export$41b487c9c7cedfae)(args);
}
function $2a1665087e205ef6$export$92fddceccd4ce8b5(args) {
    return new (0, $49135dd97e6043ca$export$7d101801017ddeaf)(args);
}


/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ 

/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * Exported functions.
 */ /**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /* Original source: keras/callbacks.py */ 
var $i64bB = parcelRequire("i64bB");

/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
async function $60719b6320089bc4$export$edec74c62c989297(logs) {
    if (logs == null) return;
    const promises = [];
    const keys = [];
    const scalarsToDispose = [];
    for(const key in logs){
        const value = logs[key];
        if (typeof value !== 'number') {
            const valueScalar = value;
            promises.push(valueScalar.data());
            keys.push(key);
            scalarsToDispose.push(valueScalar);
        }
    }
    if (promises.length > 0) {
        const values = await Promise.all(promises);
        for(let i = 0; i < values.length; ++i)logs[keys[i]] = values[i][0];
        // Dispose the original scalar tensors.
        (0, $i64bB.dispose)(scalarsToDispose);
    }
}
function $60719b6320089bc4$export$f4920d82017cd044(logs) {
    if (logs == null) return;
    for(const key in logs){
        const value = logs[key];
        if (typeof value !== 'number') value.dispose();
    }
}



var $65144a7424fc1c41$export$7770e64db700cbdd;
(function(ModelLoggingVerbosity) {
    ModelLoggingVerbosity[ModelLoggingVerbosity["SILENT"] = 0] = "SILENT";
    ModelLoggingVerbosity[ModelLoggingVerbosity["VERBOSE"] = 1] = "VERBOSE";
})($65144a7424fc1c41$export$7770e64db700cbdd || ($65144a7424fc1c41$export$7770e64db700cbdd = {}));
const $65144a7424fc1c41$export$2966f81b7af02452 = 125;
class $65144a7424fc1c41$export$ac023a7995700a90 {
    constructor(){
        // TODO(michaelterry): This type is a best guess.
        this.validationData = null;
    }
    setParams(params) {
        this.params = params;
    }
    async onEpochBegin(epoch, logs) {}
    async onEpochEnd(epoch, logs) {}
    async onBatchBegin(batch, logs) {}
    async onBatchEnd(batch, logs) {}
    async onTrainBegin(logs) {}
    async onTrainEnd(logs) {}
    // LayersModel needs to call Callback.setModel(), but cannot actually depend
    // on Callback because that creates a cyclic dependency.  Providing this no-op
    // method on BaseCallback breaks the cycle: this way LayersModel can depend on
    // BaseCallback but not on Callback.  The argument is typed as `Container`
    // (the superclass of LayersModel) to avoid recapitulating the cycle. Callback
    // overrides this method and enforces that the argument is really a
    // LayersModel.
    setModel(model) {
    // Do nothing. Use Callback instead of BaseCallback to track the model.
    }
}
class $65144a7424fc1c41$export$435cb83c816395fd {
    // TODO(cais): When the need arises, uncomment the following lines and
    // implement the queue for time values.
    // private deltaTBatch: number;
    // private deltaTsBatchBegin: Array<number>;
    // private deltaTsBatchEnd: Array<number>;
    /**
     * Constructor of CallbackList.
     * @param callbacks Array of `Callback` instances.
     * @param queueLength Queue length for keeping running statistics over
     *   callback execution time.
     */ constructor(callbacks, queueLength = 10){
        // TODO(cais): Make use of queueLength when implementing the queue for time
        // values.
        if (callbacks == null) callbacks = [];
        this.callbacks = callbacks;
        this.queueLength = queueLength;
    }
    append(callback) {
        this.callbacks.push(callback);
    }
    setParams(params) {
        for (const callback of this.callbacks)callback.setParams(params);
    }
    setModel(model) {
        for (const callback of this.callbacks)callback.setModel(model);
    }
    /**
     * Called at the start of an epoch.
     * @param epoch Index of epoch.
     * @param logs Dictionary of logs.
     */ async onEpochBegin(epoch, logs) {
        if (logs == null) logs = {};
        for (const callback of this.callbacks)await callback.onEpochBegin(epoch, logs);
    }
    /**
     * Called at the end of an epoch.
     * @param epoch Index of epoch.
     * @param logs Dictionary of logs.
     */ async onEpochEnd(epoch, logs) {
        if (logs == null) logs = {};
        for (const callback of this.callbacks)await callback.onEpochEnd(epoch, logs);
    }
    /**
     * Called  right before processing a batch.
     * @param batch Index of batch within the current epoch.
     * @param logs Dictionary of logs.
     */ async onBatchBegin(batch, logs) {
        if (logs == null) logs = {};
        for (const callback of this.callbacks)await callback.onBatchBegin(batch, logs);
    }
    /**
     * Called at the end of a batch.
     * @param batch Index of batch within the current epoch.
     * @param logs Dictionary of logs.
     */ async onBatchEnd(batch, logs) {
        if (logs == null) logs = {};
        for (const callback of this.callbacks)await callback.onBatchEnd(batch, logs);
    }
    /**
     * Called at the beginning of training.
     * @param logs Dictionary of logs.
     */ async onTrainBegin(logs) {
        if (logs == null) logs = {};
        for (const callback of this.callbacks)await callback.onTrainBegin(logs);
    }
    /**
     * Called at the end of training.
     * @param logs Dictionary of logs.
     */ async onTrainEnd(logs) {
        if (logs == null) logs = {};
        for (const callback of this.callbacks)await callback.onTrainEnd(logs);
    }
}
class $65144a7424fc1c41$export$bf796c2da54a4a40 extends $65144a7424fc1c41$export$ac023a7995700a90 {
    constructor(){
        super();
    }
    async onEpochBegin(epoch) {
        this.seen = 0;
        this.totals = {};
    }
    async onBatchEnd(batch, logs) {
        if (logs == null) logs = {};
        const batchSize = logs['size'] == null ? 0 : logs['size'];
        this.seen += batchSize;
        for(const key in logs){
            const value = logs[key];
            if (typeof value === 'number') {
                if (!this.totals.hasOwnProperty(key)) this.totals[key] = 0;
                this.totals[key] = this.totals[key] + value * batchSize;
            } else {
                let oldTotalsToDispose;
                if (key in this.totals) oldTotalsToDispose = this.totals[key];
                else this.totals[key] = 0;
                const total = (0, $i64bB.tidy)(()=>(0, $i64bB.add)(this.totals[key], (0, $i64bB.mul)(value, batchSize)));
                this.totals[key] = total;
                if (oldTotalsToDispose != null) oldTotalsToDispose.dispose();
            }
        }
    }
    async onEpochEnd(epoch, logs) {
        if (logs != null) for (const key of this.params['metrics']){
            if (this.totals[key] == null) continue;
            if (typeof this.totals[key] === 'number') logs[key] = this.totals[key] / this.seen;
            else (0, $i64bB.tidy)(()=>{
                const log = (0, $i64bB.mul)((0, $i64bB.div)(1, this.seen), this.totals[key]);
                logs[key] = log;
                this.totals[key].dispose();
                (0, $i64bB.keep)(logs[key]);
            });
        }
    }
}
class $65144a7424fc1c41$export$84202caead5689ba extends $65144a7424fc1c41$export$ac023a7995700a90 {
    async onTrainBegin(logs) {
        this.epoch = [];
        this.history = {};
    }
    async onEpochEnd(epoch, logs) {
        if (logs == null) logs = {};
        this.epoch.push(epoch);
        for(const key in logs){
            if (this.history[key] == null) this.history[key] = [];
            this.history[key].push(logs[key]);
        }
    }
    /**
     * Await the values of all losses and metrics.
     */ async syncData() {
        const promises = [];
        const keys = [];
        const indices = [];
        for(const key in this.history){
            const valueArray = this.history[key];
            for(let i = 0; i < valueArray.length; ++i)if (typeof valueArray[i] !== 'number') {
                const valueScalar = valueArray[i];
                promises.push(valueScalar.data());
                keys.push(key);
                indices.push(i);
            }
        }
        const values = await Promise.all(promises);
        for(let n = 0; n < values.length; ++n){
            const tensorToDispose = this.history[keys[n]][indices[n]];
            tensorToDispose.dispose();
            this.history[keys[n]][indices[n]] = values[n][0];
        }
    }
}
class $65144a7424fc1c41$export$5682c09493042ec8 extends $65144a7424fc1c41$export$ac023a7995700a90 {
    constructor(args, yieldEvery){
        super();
        this.currentEpoch = 0;
        this.nowFunc = args.nowFunc;
        this.nextFrameFunc = args.nextFrameFunc || (0, $i64bB.nextFrame);
        this.yieldEvery = yieldEvery || 'auto';
        if (this.yieldEvery === 'auto') this.yieldEvery = $65144a7424fc1c41$export$2966f81b7af02452;
        if (this.yieldEvery === 'never' && args.onYield != null) throw new Error("yieldEvery is `never` but you provided an `onYield` callback. Either change `yieldEvery` or remove the callback");
        if ((0, $i64bB.util).isNumber(this.yieldEvery)) // Decorate `maybeWait` so it will be called at most once every
        // `yieldEvery` ms.
        this.maybeWait = $b5cd0926a1c6df1f$export$61fc7d43ac8f84b0(this.maybeWait.bind(this), this.yieldEvery, this.nowFunc);
        this.trainBegin = args.onTrainBegin;
        this.trainEnd = args.onTrainEnd;
        this.epochBegin = args.onEpochBegin;
        this.epochEnd = args.onEpochEnd;
        this.batchBegin = args.onBatchBegin;
        this.batchEnd = args.onBatchEnd;
        this.yield = args.onYield;
    }
    async maybeWait(epoch, batch, logs) {
        const ps = [];
        if (this.yield != null) {
            await (0, $60719b6320089bc4$export$edec74c62c989297)(logs);
            ps.push(this.yield(epoch, batch, logs));
        }
        ps.push(this.nextFrameFunc());
        await Promise.all(ps);
    }
    async onEpochBegin(epoch, logs) {
        this.currentEpoch = epoch;
        if (this.epochBegin != null) {
            await (0, $60719b6320089bc4$export$edec74c62c989297)(logs);
            await this.epochBegin(epoch, logs);
        }
    }
    async onEpochEnd(epoch, logs) {
        const ps = [];
        if (this.epochEnd != null) {
            await (0, $60719b6320089bc4$export$edec74c62c989297)(logs);
            ps.push(this.epochEnd(epoch, logs));
        }
        if (this.yieldEvery === 'epoch') ps.push(this.nextFrameFunc());
        await Promise.all(ps);
    }
    async onBatchBegin(batch, logs) {
        if (this.batchBegin != null) {
            await (0, $60719b6320089bc4$export$edec74c62c989297)(logs);
            await this.batchBegin(batch, logs);
        }
    }
    async onBatchEnd(batch, logs) {
        const ps = [];
        if (this.batchEnd != null) {
            await (0, $60719b6320089bc4$export$edec74c62c989297)(logs);
            ps.push(this.batchEnd(batch, logs));
        }
        if (this.yieldEvery === 'batch') ps.push(this.nextFrameFunc());
        else if ((0, $i64bB.util).isNumber(this.yieldEvery)) ps.push(this.maybeWait(this.currentEpoch, batch, logs));
        await Promise.all(ps);
    }
    async onTrainBegin(logs) {
        if (this.trainBegin != null) {
            await (0, $60719b6320089bc4$export$edec74c62c989297)(logs);
            await this.trainBegin(logs);
        }
    }
    async onTrainEnd(logs) {
        if (this.trainEnd != null) {
            await (0, $60719b6320089bc4$export$edec74c62c989297)(logs);
            await this.trainEnd(logs);
        }
    }
}
function $65144a7424fc1c41$export$8ea03bd28ba7b2ff(callbacks, yieldEvery) {
    if (callbacks == null) callbacks = {};
    if (callbacks instanceof $65144a7424fc1c41$export$ac023a7995700a90) return [
        callbacks
    ];
    if (Array.isArray(callbacks) && callbacks[0] instanceof $65144a7424fc1c41$export$ac023a7995700a90) return callbacks;
    // Convert custom callback configs to custom callback objects.
    const callbackConfigs = $b5cd0926a1c6df1f$export$effcdbd76139450(callbacks);
    return callbackConfigs.map((callbackConfig)=>new $65144a7424fc1c41$export$5682c09493042ec8(callbackConfig, yieldEvery));
}
/**
 * A global registry for callback constructors to be used during
 * LayersModel.fit().
 */ class $65144a7424fc1c41$export$3b4f51c3fa9f338c {
    /**
     * Blocks public access to constructor.
     */ constructor(){}
    /**
     * Register a tf.LayersModel.fit() callback constructor.
     *
     * The registered callback constructor will be used to instantiate
     * callbacks for every tf.LayersModel.fit() call afterwards.
     *
     * @param verbosityLevel Level of verbosity at which the `callbackConstructor`
     *   is to be reigstered.
     * @param callbackConstructor A no-arg constructor for `tf.Callback`.
     * @throws Error, if the same callbackConstructor has been registered before,
     *   either at the same or a different `verbosityLevel`.
     */ static registerCallbackConstructor(verbosityLevel, callbackConstructor) {
        (0, $i64bB.util).assert(verbosityLevel >= 0 && Number.isInteger(verbosityLevel), ()=>`Verbosity level is expected to be an integer >= 0, ` + `but got ${verbosityLevel}`);
        $65144a7424fc1c41$export$3b4f51c3fa9f338c.checkForDuplicate(callbackConstructor);
        if ($65144a7424fc1c41$export$3b4f51c3fa9f338c.constructors[verbosityLevel] == null) $65144a7424fc1c41$export$3b4f51c3fa9f338c.constructors[verbosityLevel] = [];
        $65144a7424fc1c41$export$3b4f51c3fa9f338c.constructors[verbosityLevel].push(callbackConstructor);
    }
    static checkForDuplicate(callbackConstructor) {
        for(const levelName in $65144a7424fc1c41$export$3b4f51c3fa9f338c.constructors){
            const constructors = $65144a7424fc1c41$export$3b4f51c3fa9f338c.constructors[+levelName];
            constructors.forEach((ctor)=>{
                if (ctor === callbackConstructor) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)('Duplicate callback constructor.');
            });
        }
    }
    /**
     * Clear all registered callback constructors.
     */ static clear() {
        $65144a7424fc1c41$export$3b4f51c3fa9f338c.constructors = {};
    }
    /**
     * Create callbacks using the registered callback constructors.
     *
     * Given `verbosityLevel`, all constructors registered at that level or above
     * will be called and the instantiated callbacks will be used.
     *
     * @param verbosityLevel: Level of verbosity.
     */ static createCallbacks(verbosityLevel) {
        const constructors = [];
        for(const levelName in $65144a7424fc1c41$export$3b4f51c3fa9f338c.constructors){
            const level = +levelName;
            if (verbosityLevel >= level) constructors.push(...$65144a7424fc1c41$export$3b4f51c3fa9f338c.constructors[level]);
        }
        return constructors.map((ctor)=>new ctor());
    }
}
$65144a7424fc1c41$export$3b4f51c3fa9f338c.constructors = {};
function $65144a7424fc1c41$export$18b2cd3db6266dd9(callbacks, verbose, epochs, initialEpoch, numTrainSamples, stepsPerEpoch, batchSize, doValidation, callbackMetrics) {
    const history = new $65144a7424fc1c41$export$84202caead5689ba();
    const actualCallbacks = [
        new $65144a7424fc1c41$export$bf796c2da54a4a40(),
        ...$65144a7424fc1c41$export$3b4f51c3fa9f338c.createCallbacks(verbose)
    ];
    if (callbacks != null) actualCallbacks.push(...callbacks);
    actualCallbacks.push(history);
    const callbackList = new $65144a7424fc1c41$export$435cb83c816395fd(actualCallbacks);
    // TODO(cais): Figure out when this LayersModel instance can have a
    // dynamically
    //   set property called 'callback_model' as in PyKeras.
    callbackList.setParams({
        epochs: epochs,
        initialEpoch: initialEpoch,
        samples: numTrainSamples,
        steps: stepsPerEpoch,
        batchSize: batchSize,
        verbose: verbose,
        doValidation: doValidation,
        metrics: callbackMetrics
    });
    return {
        callbackList: callbackList,
        history: history
    };
}



/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /* Original Source: engine/training.py */ 
var $i64bB = parcelRequire("i64bB");




/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /* Original Source layers/__init__.py */ 
var $i64bB = parcelRequire("i64bB");

function $61cac79a6a78765b$export$efcd34ab6248d3cd(config, customObjects = {}, fastWeightInit = false) {
    return (0, $b5cd0926a1c6df1f$export$c33061eb381c60f9)(config, (0, $i64bB.serialization).SerializationMap.getMap().classNameMap, customObjects, 'layer', fastWeightInit);
}



/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /* Original Source: losses.py */ 
var $i64bB = parcelRequire("i64bB");



function $7d695629521dc3d5$export$56804db0f45bf789(x, axis) {
    return (0, $i64bB.tidy)(()=>{
        if (x.dtype !== 'float32') x = $i64bB.cast(x, 'float32');
        const squareSum = $i64bB.sum($33b0bdd0433db936$export$dd4f28cef696bc7d(x), axis, true);
        const epsilonTensor = $i64bB.fill(squareSum.shape, (0, $043e1401aa799097$export$6c421550c66a327d)());
        const norm = $i64bB.sqrt($i64bB.maximum(squareSum, epsilonTensor));
        return $i64bB.div(x, norm);
    });
}
function $7d695629521dc3d5$export$33de16355e97f7fb(yTrue, yPred) {
    return (0, $i64bB.tidy)(()=>$i64bB.mean($33b0bdd0433db936$export$dd4f28cef696bc7d($i64bB.sub(yPred, yTrue)), -1));
}
function $7d695629521dc3d5$export$607988531ba584e6(yTrue, yPred) {
    return (0, $i64bB.tidy)(()=>$i64bB.mean($i64bB.abs($i64bB.sub(yPred, yTrue)), -1));
}
function $7d695629521dc3d5$export$29f745e8786a84d(yTrue, yPred) {
    return (0, $i64bB.tidy)(()=>{
        const diff = $i64bB.sub(yTrue, yPred);
        const clippedTrue = $i64bB.clipByValue($i64bB.abs(yTrue), (0, $043e1401aa799097$export$6c421550c66a327d)(), Number.MAX_VALUE);
        const absResult = $i64bB.abs($i64bB.div(diff, clippedTrue));
        return $i64bB.mul(100, $i64bB.mean(absResult, -1));
    });
}
function $7d695629521dc3d5$export$6f3c2909d4934f8e(yTrue, yPred) {
    return (0, $i64bB.tidy)(()=>{
        const clippedPred = $i64bB.clipByValue(yPred, (0, $043e1401aa799097$export$6c421550c66a327d)(), Number.MAX_VALUE);
        const firstLog = $i64bB.log($i64bB.add(1, clippedPred));
        const clippedTrue = $i64bB.clipByValue(yTrue, (0, $043e1401aa799097$export$6c421550c66a327d)(), Number.MAX_VALUE);
        const secondLog = $i64bB.log($i64bB.add(1, clippedTrue));
        return $i64bB.mean($33b0bdd0433db936$export$dd4f28cef696bc7d($i64bB.sub(firstLog, secondLog)), -1);
    });
}
function $7d695629521dc3d5$export$6e9184938bd4bdfd(yTrue, yPred) {
    return (0, $i64bB.tidy)(()=>{
        const maxResult = $i64bB.maximum(0, $i64bB.sub(1, $i64bB.mul(yTrue, yPred)));
        return $i64bB.mean($33b0bdd0433db936$export$dd4f28cef696bc7d(maxResult), -1);
    });
}
function $7d695629521dc3d5$export$321a3d0bf2c75(yTrue, yPred) {
    return (0, $i64bB.tidy)(()=>{
        const maxResult = $i64bB.maximum(0, $i64bB.sub(1, $i64bB.mul(yTrue, yPred)));
        return $i64bB.mean(maxResult, -1);
    });
}
function $7d695629521dc3d5$export$21844282d987078(yTrue, yPred) {
    return (0, $i64bB.tidy)(()=>{
        const pos = $i64bB.sum($i64bB.mul(yTrue, yPred), -1);
        const neg = $i64bB.max($i64bB.mul($i64bB.sub(1, yTrue), yPred), -1);
        return $i64bB.maximum(0, $i64bB.add(1, $i64bB.sub(neg, pos)));
    });
}
function $7d695629521dc3d5$export$d3a5506af1f5d4c0(yTrue, yPred) {
    return (0, $i64bB.tidy)(()=>{
        const log2 = Math.log(2);
        const predictionDiff = $i64bB.sub(yPred, yTrue);
        const logcoshResult = $i64bB.sub($i64bB.add(predictionDiff, $i64bB.softplus($i64bB.mul(-2, predictionDiff))), log2);
        return $i64bB.mean(logcoshResult, -1);
    });
}
function $7d695629521dc3d5$export$3d5544849562b631(target, output, fromLogits = false) {
    return (0, $i64bB.tidy)(()=>{
        if (fromLogits) output = $i64bB.softmax(output);
        else {
            // scale preds so that the class probabilities of each sample sum to 1.
            const outputSum = $i64bB.sum(output, output.shape.length - 1, true);
            output = $i64bB.div(output, outputSum);
        }
        output = $i64bB.clipByValue(output, (0, $043e1401aa799097$export$6c421550c66a327d)(), 1 - (0, $043e1401aa799097$export$6c421550c66a327d)());
        return $i64bB.neg($i64bB.sum($i64bB.mul($i64bB.cast(target, 'float32'), $i64bB.log(output)), output.shape.length - 1));
    });
}
function $7d695629521dc3d5$export$d02551222e9364f0(target, output, fromLogits = false) {
    return (0, $i64bB.tidy)(()=>{
        const flatTarget = $i64bB.cast($i64bB.floor($33b0bdd0433db936$export$bffa455ba8c619a6(target)), 'int32');
        output = $i64bB.clipByValue(output, (0, $043e1401aa799097$export$6c421550c66a327d)(), 1 - (0, $043e1401aa799097$export$6c421550c66a327d)());
        const outputShape = output.shape;
        const oneHotTarget = $i64bB.reshape($i64bB.oneHot(flatTarget, outputShape[outputShape.length - 1]), outputShape);
        return $7d695629521dc3d5$export$3d5544849562b631(oneHotTarget, output, fromLogits);
    });
}
function $7d695629521dc3d5$export$ba12332959c7f31a(labels, logits) {
    if (!(0, $i64bB.util).arraysEqual(labels.shape, logits.shape)) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`logits and labels must have the same shape, but got shapes ` + `${JSON.stringify(labels.shape)} and ${JSON.stringify(logits.shape)}`);
    return (0, $i64bB.tidy)(()=>{
        // The logistic loss formula from above is
        //   x - x * z + log(1 + exp(-x))
        // For x < 0, a more numerically stable formula is
        //   -x * z + log(1 + exp(x))
        // Note that these two expressions can be combined into the following:
        //   max(x, 0) - x * z + log(1 + exp(-abs(x)))
        const reluLogits = $i64bB.relu(logits);
        const negAbsLogits = $i64bB.neg($i64bB.abs(logits));
        return $i64bB.add($i64bB.sub(reluLogits, $i64bB.mul(logits, labels)), $i64bB.log1p($i64bB.exp(negAbsLogits)));
    });
}
function $7d695629521dc3d5$export$f9fa66c6bf49fbe1(yTrue, yPred) {
    return (0, $i64bB.tidy)(()=>{
        let y;
        y = $i64bB.clipByValue(yPred, (0, $043e1401aa799097$export$6c421550c66a327d)(), 1 - (0, $043e1401aa799097$export$6c421550c66a327d)());
        y = $i64bB.log($i64bB.div(y, $i64bB.sub(1, y)));
        return $i64bB.mean($7d695629521dc3d5$export$ba12332959c7f31a(yTrue, y), -1);
    });
}
function $7d695629521dc3d5$export$ca6ae4762880179a(yTrue, yPred) {
    return (0, $i64bB.tidy)(()=>{
        const clippedTrue = $i64bB.clipByValue(yTrue, (0, $043e1401aa799097$export$6c421550c66a327d)(), 1);
        const clippedPred = $i64bB.clipByValue(yPred, (0, $043e1401aa799097$export$6c421550c66a327d)(), 1);
        return $i64bB.sum($i64bB.mul(yTrue, $i64bB.log($i64bB.div(clippedTrue, clippedPred))), -1);
    });
}
function $7d695629521dc3d5$export$e2342249434e96a8(yTrue, yPred) {
    return (0, $i64bB.tidy)(()=>{
        const logPred = $i64bB.log($i64bB.add((0, $043e1401aa799097$export$6c421550c66a327d)(), yPred));
        return $i64bB.mean($i64bB.sub(yPred, $i64bB.mul(yTrue, logPred)), -1);
    });
}
function $7d695629521dc3d5$export$a39f0fc1fa1caacd(yTrue, yPred) {
    return (0, $i64bB.tidy)(()=>{
        const trueNormalized = $7d695629521dc3d5$export$56804db0f45bf789(yTrue, -1);
        const predNormalized = $7d695629521dc3d5$export$56804db0f45bf789(yPred, -1);
        const trueXPred = $i64bB.mul(trueNormalized, predNormalized);
        return $i64bB.neg($i64bB.sum(trueXPred, -1));
    });
}
const $7d695629521dc3d5$export$5af2a467647891e2 = $7d695629521dc3d5$export$33de16355e97f7fb;
const $7d695629521dc3d5$export$19fa95397f41c30f = $7d695629521dc3d5$export$33de16355e97f7fb;
const $7d695629521dc3d5$export$1d5f948d69c1bb9e = $7d695629521dc3d5$export$607988531ba584e6;
const $7d695629521dc3d5$export$5763e506e192f1c3 = $7d695629521dc3d5$export$607988531ba584e6;
const $7d695629521dc3d5$export$1d9e5626781fbee = $7d695629521dc3d5$export$29f745e8786a84d;
const $7d695629521dc3d5$export$520a6d354b1a7026 = $7d695629521dc3d5$export$29f745e8786a84d;
const $7d695629521dc3d5$export$863e9fcd25a63ca1 = $7d695629521dc3d5$export$6f3c2909d4934f8e;
const $7d695629521dc3d5$export$52f45e1331da5a2d = $7d695629521dc3d5$export$6f3c2909d4934f8e;
const $7d695629521dc3d5$export$832ecf683c672b43 = $7d695629521dc3d5$export$ca6ae4762880179a;
const $7d695629521dc3d5$export$cb1c1cc0b7255a = $7d695629521dc3d5$export$ca6ae4762880179a;
const $7d695629521dc3d5$export$c2a6cd60d490c7cc = $7d695629521dc3d5$export$a39f0fc1fa1caacd;
const $7d695629521dc3d5$export$80c8fb006fb174f5 = {
    meanSquaredError: $7d695629521dc3d5$export$33de16355e97f7fb,
    meanAbsoluteError: $7d695629521dc3d5$export$607988531ba584e6,
    meanAbsolutePercentageError: $7d695629521dc3d5$export$29f745e8786a84d,
    meanSquaredLogarithmicError: $7d695629521dc3d5$export$6f3c2909d4934f8e,
    squaredHinge: $7d695629521dc3d5$export$6e9184938bd4bdfd,
    hinge: $7d695629521dc3d5$export$321a3d0bf2c75,
    categoricalHinge: $7d695629521dc3d5$export$21844282d987078,
    logcosh: $7d695629521dc3d5$export$d3a5506af1f5d4c0,
    categoricalCrossentropy: $7d695629521dc3d5$export$3d5544849562b631,
    sparseCategoricalCrossentropy: $7d695629521dc3d5$export$d02551222e9364f0,
    binaryCrossentropy: $7d695629521dc3d5$export$f9fa66c6bf49fbe1,
    kullbackLeiblerDivergence: $7d695629521dc3d5$export$ca6ae4762880179a,
    poisson: $7d695629521dc3d5$export$e2342249434e96a8,
    cosineProximity: $7d695629521dc3d5$export$a39f0fc1fa1caacd
};
function $7d695629521dc3d5$export$3988ae62b71be9a3(identifierOrFn) {
    if (typeof identifierOrFn === 'string') {
        if (identifierOrFn in $7d695629521dc3d5$export$80c8fb006fb174f5) return $7d695629521dc3d5$export$80c8fb006fb174f5[identifierOrFn];
        let errMsg = `Unknown loss ${identifierOrFn}`;
        if (identifierOrFn.toLowerCase().includes('softmaxcrossentropy')) errMsg = `Unknown loss ${identifierOrFn}. ` + 'Use "categoricalCrossentropy" as the string name for ' + 'tf.losses.softmaxCrossEntropy';
        throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(errMsg);
    } else return identifierOrFn;
}


/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * Built-in metrics.
 */ 
var $i64bB = parcelRequire("i64bB");




function $7612942a5d22baee$export$7b3d02e9a01c1ca(yTrue, yPred) {
    return (0, $i64bB.tidy)(()=>{
        const threshold = $i64bB.mul(.5, $i64bB.onesLike(yPred));
        const yPredThresholded = $33b0bdd0433db936$export$f2db7d5238e1d23f($i64bB.greater(yPred, threshold), yTrue.dtype);
        return $i64bB.mean($i64bB.equal(yTrue, yPredThresholded), -1);
    });
}
function $7612942a5d22baee$export$1365401eb6b7aeeb(yTrue, yPred) {
    return (0, $i64bB.tidy)(()=>$33b0bdd0433db936$export$f2db7d5238e1d23f($i64bB.equal($i64bB.argMax(yTrue, -1), $i64bB.argMax(yPred, -1)), 'float32'));
}
function $7612942a5d22baee$var$truePositives(yTrue, yPred) {
    return (0, $i64bB.tidy)(()=>{
        return $i64bB.cast($i64bB.sum($i64bB.logicalAnd($i64bB.equal(yTrue, 1), $i64bB.equal(yPred, 1))), 'float32');
    });
}
function $7612942a5d22baee$var$falseNegatives(yTrue, yPred) {
    return (0, $i64bB.tidy)(()=>{
        return $i64bB.cast($i64bB.sum($i64bB.logicalAnd($i64bB.equal(yTrue, 1), $i64bB.equal(yPred, 0))), 'float32');
    });
}
function $7612942a5d22baee$var$falsePositives(yTrue, yPred) {
    return (0, $i64bB.tidy)(()=>{
        return $i64bB.cast($i64bB.sum($i64bB.logicalAnd($i64bB.equal(yTrue, 0), $i64bB.equal(yPred, 1))), 'float32');
    });
}
function $7612942a5d22baee$export$b70eeb0e623ceb0d(yTrue, yPred) {
    return (0, $i64bB.tidy)(()=>{
        const tp = $7612942a5d22baee$var$truePositives(yTrue, yPred);
        const fp = $7612942a5d22baee$var$falsePositives(yTrue, yPred);
        const denominator = $i64bB.add(tp, fp);
        return $i64bB.cast($i64bB.where($i64bB.greater(denominator, 0), $i64bB.div(tp, denominator), 0), 'float32');
    });
}
function $7612942a5d22baee$export$479490328e25f530(yTrue, yPred) {
    return (0, $i64bB.tidy)(()=>{
        const tp = $7612942a5d22baee$var$truePositives(yTrue, yPred);
        const fn = $7612942a5d22baee$var$falseNegatives(yTrue, yPred);
        const denominator = $i64bB.add(tp, fn);
        return $i64bB.cast($i64bB.where($i64bB.greater(denominator, 0), $i64bB.div(tp, denominator), 0), 'float32');
    });
}
function $7612942a5d22baee$export$f9fa66c6bf49fbe1(yTrue, yPred) {
    return (0, $7d695629521dc3d5$export$f9fa66c6bf49fbe1)(yTrue, yPred);
}
function $7612942a5d22baee$export$b35c43b77daa3523(yTrue, yPred) {
    if (yTrue.rank === yPred.rank) yTrue = $i64bB.squeeze(yTrue, [
        yTrue.rank - 1
    ]);
    yPred = $i64bB.argMax(yPred, -1);
    if (yPred.dtype !== yTrue.dtype) yPred = $i64bB.cast(yPred, yTrue.dtype);
    return $i64bB.cast($i64bB.equal(yTrue, yPred), 'float32');
}
function $7612942a5d22baee$export$1a189de14358fa71(yTrue, yPred) {
    throw new (0, $af476738b120e938$export$e162153238934121)();
}
function $7612942a5d22baee$export$a15ee75d9e4cf4ae(yTrue, yPred) {
    throw new (0, $af476738b120e938$export$e162153238934121)();
}
function $7612942a5d22baee$export$3c864af03e35a80e(yTrue, yPred) {
    return (0, $i64bB.tidy)(()=>{
        const sumSquaresResiduals = yTrue.sub(yPred).square().sum();
        const sumSquares = yTrue.sub(yTrue.mean()).square().sum();
        return $i64bB.scalar(1).sub(sumSquaresResiduals.div(sumSquares));
    });
}
const $7612942a5d22baee$export$5af2a467647891e2 = (0, $7d695629521dc3d5$export$33de16355e97f7fb);
const $7612942a5d22baee$export$19fa95397f41c30f = (0, $7d695629521dc3d5$export$33de16355e97f7fb);
const $7612942a5d22baee$export$1d5f948d69c1bb9e = (0, $7d695629521dc3d5$export$607988531ba584e6);
const $7612942a5d22baee$export$5763e506e192f1c3 = (0, $7d695629521dc3d5$export$607988531ba584e6);
const $7612942a5d22baee$export$1d9e5626781fbee = (0, $7d695629521dc3d5$export$29f745e8786a84d);
const $7612942a5d22baee$export$520a6d354b1a7026 = (0, $7d695629521dc3d5$export$29f745e8786a84d);
const $7612942a5d22baee$export$3d5544849562b631 = (0, $7d695629521dc3d5$export$3d5544849562b631);
const $7612942a5d22baee$export$c2a6cd60d490c7cc = (0, $7d695629521dc3d5$export$a39f0fc1fa1caacd);
const $7612942a5d22baee$export$d02551222e9364f0 = (0, $7d695629521dc3d5$export$d02551222e9364f0);
const $7612942a5d22baee$export$17c75e85c6265c88 = {
    binaryAccuracy: $7612942a5d22baee$export$7b3d02e9a01c1ca,
    categoricalAccuracy: $7612942a5d22baee$export$1365401eb6b7aeeb,
    precision: $7612942a5d22baee$export$b70eeb0e623ceb0d,
    categoricalCrossentropy: $7612942a5d22baee$export$3d5544849562b631,
    sparseCategoricalCrossentropy: $7612942a5d22baee$export$d02551222e9364f0,
    mse: $7612942a5d22baee$export$5af2a467647891e2,
    MSE: $7612942a5d22baee$export$19fa95397f41c30f,
    mae: $7612942a5d22baee$export$1d5f948d69c1bb9e,
    MAE: $7612942a5d22baee$export$5763e506e192f1c3,
    mape: $7612942a5d22baee$export$1d9e5626781fbee,
    MAPE: $7612942a5d22baee$export$520a6d354b1a7026,
    cosine: $7612942a5d22baee$export$c2a6cd60d490c7cc
};
function $7612942a5d22baee$export$3988ae62b71be9a3(identifier) {
    if (typeof identifier === 'string' && identifier in $7612942a5d22baee$export$17c75e85c6265c88) return $7612942a5d22baee$export$17c75e85c6265c88[identifier];
    else if (typeof identifier !== 'string' && identifier != null) return identifier;
    else throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Unknown metric ${identifier}`);
}
function $7612942a5d22baee$export$9fb8307a5eeccc76(fn) {
    $b5cd0926a1c6df1f$export$a7a9523472993e97(fn !== null, `Unknown LossOrMetricFn ${fn}`);
    if (typeof fn === 'string') return fn;
    else {
        let fnName;
        for (const key of Object.keys((0, $7d695629521dc3d5$export$80c8fb006fb174f5)))if ((0, $7d695629521dc3d5$export$80c8fb006fb174f5)[key] === fn) {
            fnName = key;
            break;
        }
        if (fnName !== undefined) return fnName;
        for (const key of Object.keys($7612942a5d22baee$export$17c75e85c6265c88))if ($7612942a5d22baee$export$17c75e85c6265c88[key] === fn) {
            fnName = key;
            break;
        }
        if (fnName !== undefined) return fnName;
        return fn.name;
    }
}


/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * Optimizers.
 */ 
var $i64bB = parcelRequire("i64bB");


function $ad044476a7bc432e$export$93a6cd925bf0fb14(identifier) {
    const optimizerMap = {
        'Adagrad': ()=>(0, $i64bB.train).adagrad(0.01),
        'Adadelta': ()=>(0, $i64bB.train).adadelta(1, 0.95, (0, $043e1401aa799097$export$6c421550c66a327d)()),
        'Adam': ()=>(0, $i64bB.train).adam(0.001, 0.9, 0.999, (0, $043e1401aa799097$export$6c421550c66a327d)()),
        'Adamax': ()=>(0, $i64bB.train).adamax(0.002, 0.9, 0.999, (0, $043e1401aa799097$export$6c421550c66a327d)(), 0),
        'RMSProp': ()=>(0, $i64bB.train).rmsprop(0.001, 0.9, 0, (0, $043e1401aa799097$export$6c421550c66a327d)()),
        'SGD': ()=>(0, $i64bB.train).sgd(0.01)
    };
    optimizerMap['adagrad'] = optimizerMap['Adagrad'];
    optimizerMap['adadelta'] = optimizerMap['Adadelta'];
    optimizerMap['adam'] = optimizerMap['Adam'];
    optimizerMap['adamax'] = optimizerMap['Adamax'];
    optimizerMap['rmsprop'] = optimizerMap['RMSProp'];
    optimizerMap['sgd'] = optimizerMap['SGD'];
    if (identifier in optimizerMap) return optimizerMap[identifier]();
    throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Unknown Optimizer ${identifier}`);
}


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /** Utility functions related to user-defined metadata. */ // Maximum recommended serialized size for user-defined metadata.
// Beyond this limit, a warning message will be printed during model loading and
// saving.
const $7f72a7225653b029$export$60e49adbc1213273 = 1048576;
function $7f72a7225653b029$export$5c1c8db6517969f5(userDefinedMetadata, modelName, checkSize = false) {
    if (userDefinedMetadata == null || typeof userDefinedMetadata !== 'object' || Object.getPrototypeOf(userDefinedMetadata) !== Object.prototype || !$7f72a7225653b029$export$62cb934243969363(userDefinedMetadata)) throw new Error('User-defined metadata is expected to be a JSON object, but is not.');
    if (checkSize) {
        const out = JSON.stringify(userDefinedMetadata);
        if (out.length > $7f72a7225653b029$export$60e49adbc1213273) console.warn(`User-defined metadata of model "${modelName}" is too large in ` + `size (length=${out.length} when serialized). It is not ` + `recommended to store such large objects in user-defined metadata. ` + `Please make sure its serialized length is <= ` + `${$7f72a7225653b029$export$60e49adbc1213273}.`);
    }
}
function $7f72a7225653b029$export$62cb934243969363(x) {
    if (x === null) // Note: typeof `null` is 'object', and `null` is valid in JSON.
    return true;
    else if (typeof x === 'object') {
        if (Object.getPrototypeOf(x) === Object.prototype) {
            // `x` is a JavaScript object and its prototype is Object.
            const keys = Object.keys(x);
            for (const key of keys){
                if (typeof key !== 'string') // JSON keys must be strings.
                return false;
                if (!$7f72a7225653b029$export$62cb934243969363(x[key])) return false;
            }
            return true;
        } else {
            // `x` is a JavaScript object but its prototype is not Object.
            if (Array.isArray(x)) {
                // `x` is a JavaScript array.
                for (const item of x){
                    if (!$7f72a7225653b029$export$62cb934243969363(item)) return false;
                }
                return true;
            } else // `x` is a JavaScript object and its prototype is not Object,
            // and it's not an Array. I.e., it's a complex object such as
            // `Error` and `Date`.
            return false;
        }
    } else {
        // `x` is not a JavaScript object or `null`.
        const xType = typeof x;
        return xType === 'string' || xType === 'number' || xType === 'boolean';
    }
}



/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ 
function $a31b9cc9c573d4af$export$9b5fcd5d170a598e(model, lineLength, positions, // tslint:disable-next-line:no-any
printFn = console.log) {
    const sequentialLike = $a31b9cc9c573d4af$var$isModelSequentialLike(model);
    // Header names for different log elements.
    const toDisplay = [
        'Layer (type)',
        'Input Shape',
        'Output shape',
        'Param #'
    ];
    if (sequentialLike) {
        lineLength = lineLength || 90;
        positions = positions || [
            0.32,
            0.61,
            0.89,
            1
        ];
    } else {
        lineLength = lineLength || 115;
        positions = positions || [
            0.24,
            0.48,
            0.70,
            0.80,
            1
        ];
    // Header names for different log elements.
    }
    if (positions[positions.length - 1] <= 1) // `positions` is relative. Convert it to absolute positioning.
    positions = positions.map((p)=>Math.floor(lineLength * p));
    let relevantNodes;
    if (!sequentialLike) {
        toDisplay.push('Receives inputs');
        relevantNodes = [];
        for(const depth in model.nodesByDepth)relevantNodes.push(...model.nodesByDepth[depth]);
    }
    printFn('_'.repeat(lineLength));
    $a31b9cc9c573d4af$var$printRow(toDisplay, positions, printFn);
    printFn('='.repeat(lineLength));
    const layers = model.layers;
    for(let i = 0; i < layers.length; ++i){
        if (sequentialLike) $a31b9cc9c573d4af$var$printLayerSummary(layers[i], positions, printFn);
        else $a31b9cc9c573d4af$var$printLayerSummaryWithConnections(layers[i], positions, relevantNodes, printFn);
        printFn((i === layers.length - 1 ? '=' : '_').repeat(lineLength));
    }
    // tslint:disable-next-line:no-any
    model.checkTrainableWeightsConsistency();
    const trainableCount = $a31b9cc9c573d4af$var$countTrainableParams(model);
    const nonTrainableCount = (0, $ed799730592766a6$export$2a41d41251f01d03)(model.nonTrainableWeights);
    printFn(`Total params: ${trainableCount + nonTrainableCount}`);
    printFn(`Trainable params: ${trainableCount}`);
    printFn(`Non-trainable params: ${nonTrainableCount}`);
    printFn('_'.repeat(lineLength));
}
function $a31b9cc9c573d4af$var$countTrainableParams(model) {
    let trainableCount;
    // tslint:disable:no-any
    if (model.collectedTrainableWeights != null) trainableCount = (0, $ed799730592766a6$export$2a41d41251f01d03)(model.collectedTrainableWeights);
    else trainableCount = (0, $ed799730592766a6$export$2a41d41251f01d03)(model.trainableWeights);
    // tslint:enable:no-any
    return trainableCount;
}
function $a31b9cc9c573d4af$var$isModelSequentialLike(model) {
    let sequentialLike = true;
    const nodesByDepth = [];
    const nodes = [];
    for(const depth in model.nodesByDepth)nodesByDepth.push(model.nodesByDepth[depth]);
    for (const depthNodes of nodesByDepth){
        if (depthNodes.length > 1 || depthNodes.length === 1 && depthNodes[0].inboundLayers.length > 1) {
            sequentialLike = false;
            break;
        }
        nodes.push(...depthNodes);
    }
    if (sequentialLike) // Search for shared layers.
    for (const layer of model.layers){
        let flag = false;
        for (const node of layer.inboundNodes)if (nodes.indexOf(node) !== -1) {
            if (flag) {
                sequentialLike = false;
                break;
            } else flag = true;
        }
        if (!sequentialLike) break;
    }
    return sequentialLike;
}
function $a31b9cc9c573d4af$var$printRow(fields, positions, // tslint:disable-next-line:no-any
printFn = console.log) {
    let line = '';
    for(let i = 0; i < fields.length; ++i){
        if (i > 0) line = line.slice(0, line.length - 1) + ' ';
        line += fields[i];
        line = line.slice(0, positions[i]);
        line += ' '.repeat(positions[i] - line.length);
    }
    printFn(line);
}
/**
 * Prints a summary for a single Layer, without connectivity information.
 *
 * @param layer: Layer instance to print.
 */ function $a31b9cc9c573d4af$var$printLayerSummary(layer, positions, // tslint:disable-next-line:no-any
printFn) {
    let outputShape;
    let inputShape;
    try {
        inputShape = layer.inboundNodes.map((x)=>JSON.stringify(x.inputShapes)).join(',');
    } catch (err) {
        inputShape = 'multiple';
    }
    try {
        outputShape = JSON.stringify(layer.outputShape);
    } catch (err) {
        outputShape = 'multiple';
    }
    const name = layer.name;
    const className = layer.getClassName();
    const fields = [
        `${name} (${className})`,
        inputShape,
        outputShape,
        layer.countParams().toString()
    ];
    $a31b9cc9c573d4af$var$printRow(fields, positions, printFn);
}
/**
 * Prints a summary for a single Layer, with connectivity information.
 */ function $a31b9cc9c573d4af$var$printLayerSummaryWithConnections(layer, positions, relevantNodes, // tslint:disable-next-line:no-any
printFn) {
    let outputShape;
    let inputShape;
    try {
        inputShape = layer.inboundNodes.map((x)=>JSON.stringify(x.inputShapes)).join(',');
    } catch (err) {
        inputShape = 'multiple';
    }
    try {
        outputShape = JSON.stringify(layer.outputShape);
    } catch (err) {
        outputShape = 'multiple';
    }
    const connections = [];
    for (const node of layer.inboundNodes){
        if (relevantNodes != null && relevantNodes.length > 0 && relevantNodes.indexOf(node) === -1) continue;
        for(let i = 0; i < node.inboundLayers.length; ++i){
            const inboundLayer = node.inboundLayers[i].name;
            const inboundLayerIndex = node.nodeIndices[i];
            const inboundTensorIndex = node.tensorIndices[i];
            connections.push(`${inboundLayer}[${inboundLayerIndex}][${inboundTensorIndex}]`);
        }
    }
    const name = layer.name;
    const className = layer.getClassName();
    const firstConnection = connections.length === 0 ? '' : connections[0];
    const fields = [
        `${name} (${className})`,
        inputShape,
        outputShape,
        layer.countParams().toString(),
        firstConnection
    ];
    $a31b9cc9c573d4af$var$printRow(fields, positions, printFn);
    for(let i = 1; i < connections.length; ++i)$a31b9cc9c573d4af$var$printRow([
        '',
        '',
        '',
        '',
        connections[i]
    ], positions, printFn);
}



/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ 
// tslint:enable
/**
 * Test whether a value in an array is the name of a LayersModel or Layer.
 * @param key The key name that the value is found under. Note that the key
 *   may not be at the level immediately above the value, if the value is in a
 *   nested array.
 * @param index Index of the value in the Array that it is found in.
 * @param value The value object.
 * @returns A boolean indicating whether value is a name.
 */ function $d02abf89bc2c0202$var$isArrayItemInputOrOutputName(key, index, value) {
    return (key === 'inboundNodes' || key === 'outputLayers' || key === 'inputLayers') && index === 0 && typeof value === 'string';
}
function $d02abf89bc2c0202$export$c0fd0796420499e6(pythonicConfig, key) {
    if (pythonicConfig === null) return null;
    else if (typeof pythonicConfig === 'string') return $b5cd0926a1c6df1f$export$86f54f62aa7a7514(pythonicConfig);
    else if (typeof pythonicConfig === 'number' || typeof pythonicConfig === 'boolean') return pythonicConfig;
    else if (pythonicConfig instanceof Array) {
        const tsArray = [];
        const arrayLength = pythonicConfig.length;
        for(let i = 0; i < arrayLength; ++i){
            const item = pythonicConfig[i];
            if ($d02abf89bc2c0202$var$isArrayItemInputOrOutputName(key, i, item)) tsArray.push(item);
            else tsArray.push($d02abf89bc2c0202$export$c0fd0796420499e6(item, key));
        }
        return tsArray;
    } else {
        const tsDict = {};
        for (const pythonicKey of Object.keys(pythonicConfig)){
            const pythonicValue = pythonicConfig[pythonicKey];
            if (pythonicKey === 'name' && typeof pythonicValue === 'string') // Special case the 'name' key with a string value. Name values, such as
            // the names of LayersModel and Layer instances, should not undergo the
            // camel-case conversion.
            tsDict[pythonicKey] = pythonicValue;
            else {
                const tsKey = $b5cd0926a1c6df1f$export$86f54f62aa7a7514(pythonicKey);
                tsDict[tsKey] = $d02abf89bc2c0202$export$c0fd0796420499e6(pythonicValue, tsKey);
            }
        }
        return tsDict;
    }
}
function $d02abf89bc2c0202$export$b63a5d81d6846026(tsConfig, key) {
    if (tsConfig === null || tsConfig === undefined) return null;
    else if (typeof tsConfig === 'string') return $b5cd0926a1c6df1f$export$cc8b315fc368b20a(tsConfig);
    else if (typeof tsConfig === 'number' || typeof tsConfig === 'boolean') return tsConfig;
    else if (tsConfig instanceof Array) {
        const pyArray = [];
        const arrayLength = tsConfig.length;
        for(let i = 0; i < arrayLength; ++i){
            const item = tsConfig[i];
            if ($d02abf89bc2c0202$var$isArrayItemInputOrOutputName(key, i, item)) pyArray.push(item);
            else pyArray.push($d02abf89bc2c0202$export$b63a5d81d6846026(item, key));
        }
        return pyArray;
    } else {
        const pyDict = {};
        for (const tsKey of Object.keys(tsConfig)){
            const tsValue = tsConfig[tsKey];
            const pyKey = $b5cd0926a1c6df1f$export$cc8b315fc368b20a(tsKey);
            if ((tsKey === 'name' || tsKey === 'className') && typeof tsValue === 'string') // Special case the 'name' key with a string value. Name values, such as
            // the names of LayersModel and Layer instances, should not undergo the
            // snake-case conversion.
            pyDict[pyKey] = tsValue;
            else pyDict[pyKey] = $d02abf89bc2c0202$export$b63a5d81d6846026(tsValue, tsKey);
        }
        return pyDict;
    }
}


/** @license See the LICENSE file. */ // This code is auto-generated, do not modify this file!
const $3e25243b0afd8066$export$83d89fbfd8236492 = '4.22.0';


/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /* Original source: keras/engine/topology.py */ 
var $i64bB = parcelRequire("i64bB");











// get weights key from tensor map in order to check if it is from keras v3.
// e.g. dense/0
const $f4daf0419fd2b7c5$var$isKerasSavedModelFormat = (weights)=>{
    const keys = Object.keys(weights);
    if (keys.length === 0) return false;
    const key = keys[0].split('/');
    return !isNaN(parseInt(key[key.length - 1], 10));
};
class $f4daf0419fd2b7c5$export$42a852a2b6b56249 extends (0, $03271f6b4e448384$export$936d0764594b6eb3) {
    constructor(args){
        // No args passed to super's constructor.
        super({});
        this.containerNodes = new Set();
        this.name = args.name;
        if (this.name == null) {
            const prefix = this.getClassName().toLowerCase();
            this.name = (0, $cde2737e4648ad82$export$5e82334337e0f204)(prefix);
        }
        this.supportsMasking = false;
        this.trainable_ = true;
        // TODO(michaelterry): Initialize perInputLosses/Updates here.
        // Container-specific properties.
        if (Array.isArray(args.inputs)) this.inputs = args.inputs.slice();
        else this.inputs = [
            args.inputs
        ];
        if (Array.isArray(args.outputs)) this.outputs = args.outputs.slice();
        else this.outputs = [
            args.outputs
        ];
        // Check for redundancy in inputs.
        if ($b5cd0926a1c6df1f$export$7a5d5c156e7dc406(this.inputs).length !== this.inputs.length) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)("The list of inputs passed to the model is redundant. All inputs should only appear once. Found: " + `${this.inputs.map((x)=>x.name)}`);
        // Check for redundancy in outputs.
        if ($b5cd0926a1c6df1f$export$7a5d5c156e7dc406(this.outputs).length !== this.outputs.length) console.warn("The list of outputs passed to the model is redundant. All outputs should only appear once. Found: " + `${this.outputs.map((x)=>x.name)}`);
        /*
          List of initial layers (1 to 1 mapping with this.inputs, hence the same
          layer might appear twice)
        */ this.inputLayers = [];
        this.inputLayersNodeIndices = [];
        this.inputLayersTensorIndices = [];
        /*
          List of layers (1 to 1 mapping with this.outputs, hence the same layer
          might appear twice)
        */ this.outputLayers = [];
        this.outputLayersNodeIndices = [];
        this.outputLayersTensorIndices = [];
        /*
          All layers in order of horizontal graph traversal. Entries are unique.
          Includes input and output layers.
        */ this.layers = [];
        /*
          References to container layers that were constructed internally. We need
          these to properly dispose of tensors from nested containers.
        */ this.internalContainerRefs = [];
        // TODO(michaelterry): Determine if caching still needed with eager
        // backend.
        /*
          This is for performance optimization when calling the Container on new
          inputs. Every time the Container is called on a set on input tensors,
          we compute the output tensors, output masks and output shapes in one pass,
          then cache them here. When one of these outputs is queried later,
          we retrieve it from there instead of recomputing it.
        */ // this.outputTensorCache = {};
        // this.outputShapeCache = {};
        // Build this.outputLayers:
        for (const x of this.outputs){
            const layer = x.sourceLayer;
            const nodeIndex = x.nodeIndex;
            const tensorIndex = x.tensorIndex;
            this.outputLayers.push(layer);
            this.outputLayersNodeIndices.push(nodeIndex);
            this.outputLayersTensorIndices.push(tensorIndex);
        }
        // TODO(michaelterry): Add output mask cache code.
        // Build this.inputLayers:
        for (const x of this.inputs){
            const layer = x.sourceLayer;
            const nodeIndex = x.nodeIndex;
            const tensorIndex = x.tensorIndex;
            /*
              It's supposed to be an input layer, so only one node
              and one tensor output.
            */ $b5cd0926a1c6df1f$export$a7a9523472993e97(nodeIndex === 0, 'input layer has >1 nodes');
            $b5cd0926a1c6df1f$export$a7a9523472993e97(tensorIndex === 0, 'input layer has >1 tensors');
            this.inputLayers.push(layer);
            this.inputLayersNodeIndices.push(nodeIndex);
            this.inputLayersTensorIndices.push(tensorIndex);
        }
        // Build this.inputNames and this.outputNames.
        this.inputNames = [];
        this.outputNames = [];
        this.feedInputShapes = [];
        this.feedInputNames = [];
        this.feedOutputNames = [];
        for(let i = 0; i < this.inputLayers.length; i++){
            const layer = this.inputLayers[i];
            // Check that layer is an InputLayer.
            if (!(layer instanceof (0, $b470cf8df79854ee$export$191123fdb608c9b4))) throw new TypeError('Input layers to a LayersModel must be InputLayer objects. ' + `Received inputs: ${args.inputs}. ` + `Input ${i} (0-based) originates ` + `from layer type ${layer.getClassName()}.`);
            this.inputNames.push(layer.name);
            this.feedInputShapes.push(layer.batchInputShape);
            this.feedInputNames.push(layer.name);
        }
        for (const layer of this.outputLayers)this.outputNames.push(layer.name);
        this.internalInputShapes = this.inputs.map((x)=>x.shape);
        this.internalOutputShapes = this.outputs.map((x)=>x.shape);
        /*
          Container_nodes: set of nodes included in the graph (not all nodes
          included in the layers are relevant to the current graph).
        */ // ids of all nodes relevant to the Container:
        const nodesDepths = {};
        // To recover nodes from their ID.
        const nodeIDToNode = {};
        const layersDepths = {};
        // To layers from their ID.
        const layerIDToLayer = {};
        const layerIndices = {};
        const nodesInDecreasingDepth = [];
        /**
         * Builds a map of the graph of layers.
         *
         * This recursively updates the map `layerIndices`,
         * the list `nodesInDecreasingDepth` and the set `containerNodes`.
         *
         * @param tensor Some tensor in a graph.
         * @param finishedNodes Set of nodes whose subgraphs have been traversed
         *         completely. Useful to prevent duplicated work.
         * @param nodesInProgress Set of nodes that are currently active on the
         *         recursion stack. Useful to detect cycles.
         * @param layer Layer from which `tensor` comes from. If not provided,
         *   will be obtained from tensor.sourceLayer.
         * @param nodeIndex Node index from which `tensor` comes from.
         * @param tensorIndex TensorIndex from which `tensor` comes from.
         *
         * @exception RuntimeError if a cycle is detected.
         */ const buildMapOfGraph = (tensor, finishedNodes, nodesInProgress, layer, nodeIndex, tensorIndex)=>{
            if (layer == null || nodeIndex == null || tensorIndex == null) {
                layer = tensor.sourceLayer;
                nodeIndex = tensor.nodeIndex;
                tensorIndex = tensor.tensorIndex;
            }
            const node = layer.inboundNodes[nodeIndex];
            // Prevent cycles.
            if (nodesInProgress.indexOf(node) !== -1) throw new (0, $af476738b120e938$export$4a24a86bdbcf02bb)(`The tensor ${tensor.name} at layer "${layer.name}" ` + 'is part of a cycle.');
            // Don't repeat work for shared subgraphs
            if (finishedNodes.indexOf(node) !== -1) return;
            // Update containerNodes.
            this.containerNodes.add($f4daf0419fd2b7c5$export$42a852a2b6b56249.nodeKey(layer, nodeIndex));
            // Store the traversal order for layer sorting.
            if (!(layer.id in layerIndices)) layerIndices[layer.id] = Object.keys(layerIndices).length;
            if (nodesInProgress.indexOf(node) === -1) nodesInProgress.push(node);
            // Propagate to all previous tensors connected to this node.
            const numInboundLayers = node.inboundLayers.length;
            for(let i = 0; i < numInboundLayers; i++){
                const x = node.inputTensors[i];
                const layer = node.inboundLayers[i];
                const nodeIndex = node.nodeIndices[i];
                const tensorIndex = node.tensorIndices[i];
                buildMapOfGraph(x, finishedNodes, nodesInProgress, layer, nodeIndex, tensorIndex);
            }
            finishedNodes.push(node);
            while(nodesInProgress.indexOf(node) >= 0)nodesInProgress.splice(nodesInProgress.indexOf(node), 1);
            nodesInDecreasingDepth.push(node);
        };
        const finishedNodes = [];
        const nodesInProgress = [];
        for (const x of this.outputs)buildMapOfGraph(x, finishedNodes, nodesInProgress);
        const reversedNodesInDecreasingDepth = nodesInDecreasingDepth.slice().reverse();
        for (const node of reversedNodesInDecreasingDepth){
            nodeIDToNode[node.id] = node;
            // If the depth is not set, the node has no outbound nodes (depth 0).
            if (!(node.id in nodesDepths)) nodesDepths[node.id] = 0;
            let depth = nodesDepths[node.id];
            // Update the depth of the corresponding layer
            const previousDepth = layersDepths[node.outboundLayer.id] == null ? 0 : layersDepths[node.outboundLayer.id];
            /*
              If we've seen this layer before at a higher depth, we should use that
              depth instead of the node depth.  This is necessary for shared layers
              that have inputs at different depth levels in the graph.
            */ depth = Math.max(depth, previousDepth);
            layersDepths[node.outboundLayer.id] = depth;
            layerIDToLayer[node.outboundLayer.id] = node.outboundLayer;
            nodesDepths[node.id] = depth;
            // Update the depth of inbound nodes.
            for(let i = 0; i < node.inboundLayers.length; i++){
                const inboundLayer = node.inboundLayers[i];
                const nodeIndex = node.nodeIndices[i];
                const inboundNode = inboundLayer.inboundNodes[nodeIndex];
                const previousDepth = nodesDepths[inboundNode.id] == null ? 0 : nodesDepths[inboundNode.id];
                nodesDepths[inboundNode.id] = Math.max(depth + 1, previousDepth);
                nodeIDToNode[inboundNode.id] = inboundNode;
            }
        }
        // Build a dict {depth: list of nodes with this depth}
        const nodesByDepth = {};
        for(const nodeID in nodesDepths){
            const depth = nodesDepths[nodeID];
            if (!(depth in nodesByDepth)) nodesByDepth[depth] = [];
            nodesByDepth[depth].push(nodeIDToNode[nodeID]);
        }
        // Build a dict {depth: list of layers with this depth}
        const layersByDepth = {};
        for(const layerID in layersDepths){
            const depth = layersDepths[layerID];
            if (!(depth in layersByDepth)) layersByDepth[depth] = [];
            layersByDepth[depth].push(layerIDToLayer[layerID]);
        }
        // Get sorted list of layer depths.
        let depthKeys = Object.keys(layersByDepth).map((x)=>parseInt(x, 10)).sort($b5cd0926a1c6df1f$export$964007bb9b7e1f75);
        // Set this.layers and this.layersByDepth.
        this.layers = [];
        for (const depth of depthKeys){
            const layersForDepth = layersByDepth[depth];
            // Container.layers needs to have a deterministic order:
            // here we order them by traversal order.
            layersForDepth.sort((a, b)=>{
                const aIndex = layerIndices[a.id];
                const bIndex = layerIndices[b.id];
                if (aIndex < bIndex) return -1;
                if (aIndex > bIndex) return 1;
                return 0;
            });
            for (const layer of layersForDepth){
                if (layer instanceof $f4daf0419fd2b7c5$export$42a852a2b6b56249) this.internalContainerRefs.push(layer);
                this.layers.push(layer);
            }
        }
        this.layersByDepth = layersByDepth;
        // Get sorted list of node depths;
        depthKeys = Object.keys(nodesByDepth).map((x)=>parseInt(x, 10)).sort($b5cd0926a1c6df1f$export$964007bb9b7e1f75);
        // Check that all tensors required are computable.
        // computable_tensors: all tensors in the graph
        // that can be computed from the inputs provided.
        const computableTensors = this.inputs.slice();
        // To provide a better error msg.
        const layersWithCompleteInput = [];
        for (const depth of depthKeys)for (const node of nodesByDepth[depth]){
            const layer = node.outboundLayer;
            if (layer != null) {
                for (const x of node.inputTensors){
                    if (computableTensors.indexOf(x) === -1) throw new (0, $af476738b120e938$export$4a24a86bdbcf02bb)(`Graph disconnected: cannot obtain value for tensor ${x}` + ` at layer "${layer.name}". ` + 'The following previous layers were accessed without ' + `issue: ${layersWithCompleteInput}`);
                }
                for (const x of node.outputTensors)computableTensors.push(x);
                layersWithCompleteInput.push(layer.name);
            }
        }
        // Set this.containerNodes and this.nodesByDepth.
        this.nodesByDepth = nodesByDepth;
        // Ensure name unicity, which will be crucial for serialization
        // (since serialized nodes refer to layers by their name).
        const allNames = this.layers.map((x)=>x.name);
        for (const name of allNames){
            const numOccurrences = allNames.filter((x)=>x === name).length;
            if (numOccurrences !== 1) throw new (0, $af476738b120e938$export$4a24a86bdbcf02bb)(`The name "${name}" is used ${numOccurrences} times ` + 'in the model. All layer names should be unique. Layer names: ' + JSON.stringify(allNames));
        }
        // Layer parameters.
        // The new container starts with a single inbound node
        // for its inputs, and no outbound nodes.
        // Will be appended to by future calls to apply().
        this.outboundNodes = [];
        // Will be appended to below, and by future calls to apply().
        this.inboundNodes = [];
        // Create the node linking internal inputs to internal outputs.
        // (This call has side effects.)
        // tslint:disable-next-line:no-unused-expression
        new (0, $03271f6b4e448384$export$85c928794f8d04d4)({
            outboundLayer: this,
            inboundLayers: [],
            nodeIndices: [],
            tensorIndices: [],
            inputTensors: this.inputs,
            outputTensors: this.outputs,
            inputMasks: this.inputs.map((x)=>null),
            outputMasks: this.outputs.map((x)=>null),
            inputShapes: this.inputs.map((x)=>x.shape),
            outputShapes: this.outputs.map((x)=>x.shape)
        });
        this.built = true;
        this._refCount = 1; // The ref count of a container always start at 1.
    }
    assertNotDisposed() {
        if (this._refCount === 0) throw new Error(`Container '${this.name}' is already disposed.`);
    }
    /**
     * Attempt to dispose a LayersModel's weights.
     *
     * This method decrease the reference count of the LayersModel object by 1.
     *
     * A LayersModel is reference-counted. Its reference count is incremented by 1
     * when it is first constructed and when it is used as a Layer of another
     * LayersModel.
     *
     * If the reference count of a LayersModel becomes 0, the `dispose` method of
     * all its constituent `Layer`s will be called.
     *
     * Note: If the reference count is greater than 0 after the decrement, the
     * `dispose` method of its constituent `Layer`s will *not* be called.
     *
     * After a LayersModel is disposed, it cannot be used in calls such as
     * 'predict`, `evaluate` or `fit` anymore.
     *
     * @returns A DisposeResult Object with the following fields:
     *   - refCountAfterDispose: The reference count of the LayersModel after this
     *     `dispose()` call.
     *   - numDisposedVariables: Number of `tf.Variable`s (i.e., weights) disposed
     *     during this `dispose()` call.
     * @throws {Error} If the layer is not built yet, or if the LayersModel has
     *   already been disposed.
     */ dispose() {
        this.assertNotDisposed();
        const result = {
            refCountAfterDispose: null,
            numDisposedVariables: 0
        };
        if (--this._refCount === 0) {
            for (const layer of this.layers)result.numDisposedVariables += layer.dispose().numDisposedVariables;
            // Call dispose on each internally created container layer again to ensure
            // their refCounts hit zero and their tensors are subsequently deleted.
            for (const container of this.internalContainerRefs)result.numDisposedVariables += container.dispose().numDisposedVariables;
        }
        result.refCountAfterDispose = this._refCount;
        return result;
    }
    get trainable() {
        return this.trainable_;
    }
    set trainable(trainable) {
        this.layers.forEach((layer)=>{
            // tslint:disable-next-line:no-any
            layer._trainableWeights.forEach((w)=>w.trainable = trainable);
        });
        this.trainable_ = trainable;
    }
    get trainableWeights() {
        // Porting Note: This check below is to prevent errors where the
        //   _trainableWeights inherited from the parent class (Layer) gets
        //   inadvertently used.
        if (this._trainableWeights.length > 0) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)("Container instance unexpectedly contains _trainableWeights.The trainable weights of a Container are a union of the trainable weights of its consituent Layers. Its own _trainableWeights must remain an empty Array.");
        if (!this.trainable) return [];
        let weights = [];
        for (const layer of this.layers)weights = weights.concat(layer.trainableWeights);
        return weights;
    }
    get nonTrainableWeights() {
        const weights = [];
        for (const layer of this.layers)weights.push(...layer.nonTrainableWeights);
        if (!this.trainable) {
            const trainableWeights = [];
            for (const layer of this.layers)trainableWeights.push(...layer.trainableWeights);
            return trainableWeights.concat(weights);
        }
        return weights;
    }
    get weights() {
        return this.trainableWeights.concat(this.nonTrainableWeights);
    }
    /**
     * Loads all layer weights from a JSON object.
     *
     * Porting Note: HDF5 weight files cannot be directly loaded in JavaScript /
     *   TypeScript. The utility script at `scripts/pykeras.py` offers means
     *   to convert them into JSON strings compatible with this method.
     * Porting Note: TensorFlow.js Layers supports only loading by name currently.
     *
     * @param weights A JSON mapping weight names to weight values as nested
     *   arrays of numbers, or a `NamedTensorMap`, i.e., a JSON mapping weight
     *   names to `tf.Tensor` objects.
     * @param strict Require that the provided weights exactly match those
     *   required by the container.  Default: `true`.  Passing `false` means that
     *   extra weights and missing weights will be silently ignored.
     */ loadWeights(weights, strict = true) {
        const nameToWeight = {};
        let totalWeightsCount = 0;
        const modelIsKerasSavedModelFormat = $f4daf0419fd2b7c5$var$isKerasSavedModelFormat(weights);
        if (modelIsKerasSavedModelFormat) this.parseWeights(weights);
        // Check if weights from keras v3.
        for (const layer of this.layers)for (const [index, weight] of layer.weights.entries()){
            // Parse the name to layerName/index.
            // e.g. dense/0, dense/1, dense_1/0, dense_1/1
            const parsedName = modelIsKerasSavedModelFormat ? `${weight.name.split('/').slice(0, -1).join('/') + '/'}${index}` : weight.originalName;
            if (nameToWeight[parsedName] != null) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Duplicate weight name: ${parsedName}`);
            nameToWeight[parsedName] = weight;
            totalWeightsCount++;
        }
        const weightValueTuples = [];
        for(const name in weights){
            // TF 2.2.0 added cell name to the weight name in the format of
            // layer_name/cell_name/weight_name, we need to remove
            // the inner cell name.
            let validatedName = name;
            if (nameToWeight[name] == null) {
                const tokens = name.split('/');
                const shortenNameArray = tokens.slice(0, -2).concat([
                    tokens[tokens.length - 1]
                ]);
                validatedName = shortenNameArray.join('/');
            }
            if (nameToWeight[validatedName] != null) weightValueTuples.push([
                nameToWeight[validatedName],
                weights[name]
            ]);
            else if (strict) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Provided weight data has no target variable: ${name}`);
            delete nameToWeight[validatedName];
        }
        if (strict) {
            // Check that all weights are set.
            const unsetNames = [];
            for(const name in nameToWeight)unsetNames.push(name);
            if (unsetNames.length > 0) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`${unsetNames.length} of ${totalWeightsCount} weights are not set: ` + `${unsetNames}`);
        }
        (0, $47730a883443b08f$export$6b1a34257a4982e4)(weightValueTuples);
    }
    parseWeights(weights) {
        for(const key in Object.keys(weights)){
            const listParts = key.split('/');
            const list = [
                'vars',
                'layer_checkpoint_dependencies'
            ];
            // For keras v3, the weights name are saved based on the folder structure.
            // e.g. _backbone/_layer_checkpoint_dependencies/transformer/_self../
            // _output_dense/vars/0
            // Therefore we discard the `vars` and `layer_checkpoint_depencies` within
            // the saved name and only keeps the layer name and weights.
            // This can help to mapping the actual name of the layers and load each
            // weight accordingly.
            const newKey = listParts.map((str)=>{
                if (str.startsWith('_')) return str.slice(1);
                return str;
            }).filter((str)=>!list.includes(str)).join('/');
            if (newKey !== key) {
                weights[newKey] = weights[key];
                delete weights[key];
            }
        }
    }
    /**
     * Util shared between different serialization methods.
     * @returns LayersModel config with Keras version information added.
     */ updatedConfig() {
        const theConfig = this.getConfig();
        const modelConfig = {};
        modelConfig['className'] = this.getClassName();
        modelConfig['config'] = theConfig;
        modelConfig['kerasVersion'] = `tfjs-layers ${0, $3e25243b0afd8066$export$83d89fbfd8236492}`;
        // TODO(nielsene): Replace something like K.backend() once
        // possible.
        modelConfig['backend'] = 'TensorFlow.js';
        return modelConfig;
    }
    /**
     * Returns a JSON string containing the network configuration.
     *
     * To load a network from a JSON save file, use
     * models.modelFromJSON(jsonString);
     * @param extraJsonArgs Unused in tfjs-layers, maintained for PyKeras
     * @param returnString Whether the return value should be stringified
     *    (default: `true`).
     * @returns a JSON string if `returnString` (default), or a JSON object if
     *   `!returnString`.
     */ // tslint:disable-next-line:no-any
    toJSON(unused, returnString = true) {
        const modelConfig = (0, $d02abf89bc2c0202$export$b63a5d81d6846026)(this.updatedConfig());
        return returnString ? JSON.stringify(modelConfig) : modelConfig;
    }
    /**
     * Call the model on new inputs.
     *
     * In this case `call` just reapplies all ops in the graph to the new inputs
     * (e.g. build a new computational graph from the provided inputs).
     *
     * @param inputs A tensor or list of tensors.
     * @param mask A mask or list of masks. A mask can be either a tensor or null
     *   (no mask).
     *
     * @return A tensor if there is a single output, or a list of tensors if there
     *   are more than one outputs.
     */ call(inputs, kwargs) {
        return (0, $i64bB.tidy)(()=>{
            inputs = $b5cd0926a1c6df1f$export$effcdbd76139450(inputs);
            const feedDict = new (0, $2aacd5aadd0fd9b5$export$1f554ac52b4b6917)();
            for(let i = 0; i < this.inputs.length; ++i)feedDict.add(this.inputs[i], inputs[i]);
            return (0, $2aacd5aadd0fd9b5$export$51396ec711da548b)(this.outputs, feedDict, kwargs);
        });
    }
    /**
     * Computes an output mask tensor.
     *
     * @param inputs Tensor or list of tensors.
     * @param mask Tensor or list of tensors.
     *
     * @return null or a tensor (or list of tensors, one per output tensor of the
     * layer).
     */ computeMask(inputs, mask) {
        return (0, $i64bB.tidy)(()=>{
            inputs = $b5cd0926a1c6df1f$export$effcdbd76139450(inputs);
            let masks;
            if (mask == null) masks = $b5cd0926a1c6df1f$export$f24d1f1e6cb42785(null, inputs.length);
            else masks = $b5cd0926a1c6df1f$export$effcdbd76139450(mask);
            // TODO(michaelterry): Add support for mask caching.
            return this.runInternalGraph(inputs, masks)[1];
        });
    }
    /**
     * Computes the output shape of the layer.
     *
     * Assumes that the layer will be built to match that input shape provided.
     *
     * @param inputShape A shape (tuple of integers) or a list of shape tuples
     *   (one per output tensor of the layer). Shape tuples can include null for
     *   free dimensions, instead of an integer.
     */ computeOutputShape(inputShape) {
        const inputShapes = $e11ae28082970f77$export$4cdd3da5579ac4c4(inputShape);
        if (inputShapes.length !== this.inputLayers.length) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Invalid inputShape argument ${inputShape}: ` + `model has ${this.inputLayers.length} tensor inputs.`);
        // TODO(michaelterry): Add caching
        const layersToOutputShapes = {};
        for(let i = 0; i < inputShapes.length; i++){
            const layer = this.inputLayers[i];
            const inputShape = inputShapes[i];
            // It's an input layer: computeOutputShape is identity,
            // and there is only one node and one tensor output.
            const shapeKey = layer.name + '_0_0';
            layersToOutputShapes[shapeKey] = inputShape;
        }
        const depthKeys = Object.keys(this.nodesByDepth).map((x)=>parseInt(x, 10)).sort($b5cd0926a1c6df1f$export$964007bb9b7e1f75);
        // Iterate over nodes, by depth level.
        if (depthKeys.length > 1) for (const depth of depthKeys){
            const nodes = this.nodesByDepth[depth];
            for (const node of nodes){
                // This is always a single layer, never a list.
                const layer = node.outboundLayer;
                if (this.inputLayers.map((x)=>x.id).indexOf(layer.id) !== -1) continue;
                // Potentially redundant list, same size of node.inputTensors.
                const inputShapes = [];
                for(let j = 0; j < node.inboundLayers.length; j++){
                    const inboundLayer = node.inboundLayers[j];
                    const nodeIndex = node.nodeIndices[j];
                    const tensorIndex = node.tensorIndices[j];
                    const shapeKey = `${inboundLayer.name}_${nodeIndex}_${tensorIndex}`;
                    const inputShape = layersToOutputShapes[shapeKey];
                    inputShapes.push(inputShape);
                }
                const outputShape = layer.computeOutputShape($b5cd0926a1c6df1f$export$8366660815493a21(inputShapes));
                const outputShapes = $e11ae28082970f77$export$4cdd3da5579ac4c4(outputShape);
                const nodeIndex = layer.inboundNodes.indexOf(node);
                for(let j = 0; j < outputShapes.length; j++){
                    const shapeKey = `${layer.name}_${nodeIndex}_${j}`;
                    layersToOutputShapes[shapeKey] = outputShapes[j];
                }
            }
        }
        // Read final output shapes from layersToOutputShapes.
        const outputShapes = [];
        const outputShapeKeys = [];
        for(let i = 0; i < this.outputLayers.length; i++){
            const layer = this.outputLayers[i];
            const nodeIndex = this.outputLayersNodeIndices[i];
            const tensorIndex = this.outputLayersTensorIndices[i];
            const shapeKey = `${layer.name}_${nodeIndex}_${tensorIndex}`;
            outputShapeKeys.push(shapeKey);
        }
        for(let i = 0; i < outputShapeKeys.length; i++){
            const key = outputShapeKeys[i];
            $b5cd0926a1c6df1f$export$a7a9523472993e97(key in layersToOutputShapes);
            outputShapes.push(layersToOutputShapes[key]);
        }
        // TODO(michaelterry): Update cache
        return $b5cd0926a1c6df1f$export$8366660815493a21(outputShapes);
    }
    /**
     * Computes output tensors for new inputs.
     *
     * Note:
     *   - Expects `inputs` to be a list (potentially with 1 element).
     *
     * @param inputs List of tensors
     * @param masks List of masks (tensors or null).
     * @return Three lists: outputTensors, outputMasks, outputShapes
     */ runInternalGraph(inputs, masks) {
        if (masks == null) masks = $b5cd0926a1c6df1f$export$f24d1f1e6cb42785(null, inputs.length);
        // Dictionary mapping reference tensors to tuples
        // (computed tensor, compute mask)
        // we assume a 1:1 mapping from tensor to mask
        // TODO: raise exception when a `.computeMask()` call
        // does not return a list the same size as `call`
        const tensorMap = {};
        for(let i = 0; i < this.inputs.length; ++i){
            const x = this.inputs[i];
            const y = inputs[i];
            const mask = masks[i];
            tensorMap[x.id] = [
                y,
                mask
            ];
        }
        const depthKeys = Object.keys(this.nodesByDepth).map((x)=>parseInt(x, 10)).sort($b5cd0926a1c6df1f$export$964007bb9b7e1f75);
        for (const depth of depthKeys){
            const nodes = this.nodesByDepth[depth];
            for (const node of nodes){
                // This is always a single layer, never a list.
                const layer = node.outboundLayer;
                const referenceInputTensors = node.inputTensors;
                const referenceOutputTensors = node.outputTensors;
                // If all previous input tensors are available in tensorMap,
                // then call node.inboundLayer on them.
                // List of tuples [input, mask]:
                const computedData = new Array();
                for (const x of referenceInputTensors)if (x.id in tensorMap) computedData.push(tensorMap[x.id]);
                if (computedData.length === referenceInputTensors.length) {
                    // TODO(michaelterry): Add K.name_scope here, if we need it.
                    let kwargs = {};
                    let computedTensors;
                    let computedMasks;
                    let outputTensors;
                    let outputMasks;
                    // call layer
                    if (node.callArgs != null) kwargs = node.callArgs;
                    if (computedData.length === 1) {
                        const [computedTensor, computedMask] = computedData[0];
                        if (kwargs['mask'] == null) kwargs['mask'] = computedMask;
                        outputTensors = $b5cd0926a1c6df1f$export$effcdbd76139450(layer.call(computedTensor, kwargs));
                        outputMasks = $b5cd0926a1c6df1f$export$effcdbd76139450(layer.computeMask(computedTensor, computedMask));
                        computedTensors = [
                            computedTensor
                        ];
                        computedMasks = [
                            computedMask
                        ];
                    } else {
                        computedTensors = computedData.map((x)=>x[0]);
                        computedMasks = computedData.map((x)=>x[1]);
                        if (kwargs['mask'] == null) kwargs['mask'] = computedMasks;
                        outputTensors = $b5cd0926a1c6df1f$export$effcdbd76139450(layer.call(computedTensors, kwargs));
                        outputMasks = $b5cd0926a1c6df1f$export$effcdbd76139450(layer.computeMask(computedTensors, computedMasks));
                    }
                    if (layer.activityRegularizer) throw new (0, $af476738b120e938$export$e162153238934121)("LayersModel invocation with concrete Tensor value(s) in the presence of activity regularizer(s) is not supported yet.");
                    // TODO(michaelterry): Add model updates and losses
                    // Update tensor map.
                    for(let i = 0; i < referenceOutputTensors.length; ++i){
                        const x = referenceOutputTensors[i];
                        const y = outputTensors[i];
                        const mask = outputMasks[i];
                        tensorMap[x.id] = [
                            y,
                            mask
                        ];
                    }
                }
            }
        }
        const outputTensors = [];
        const outputMasks = [];
        const outputShapes = [];
        for (const x of this.outputs){
            $b5cd0926a1c6df1f$export$a7a9523472993e97(x.id in tensorMap, `Could not compute output ${x.name} : ${x.id}`);
            const [tensor, mask] = tensorMap[x.id];
            outputShapes.push(tensor.shape);
            outputTensors.push(tensor);
            outputMasks.push(mask);
        }
        // TODO(michaelterry): Add support for caches.
        return [
            outputTensors,
            outputMasks,
            outputShapes
        ];
    }
    /**
     * Builds a map of internal node keys to node ordering.
     * Used in serializaion a node orderings may change as unused nodes are
     * dropped. Porting Note:  This helper method was pulled out of getConfig to
     * improve readability.
     * @param layers An array of Layers in the model.
     * @returns Map of Node Keys to index order within the layer.
     */ buildNodeConversionMap(layers) {
        const nodeConversionMap = {};
        let keptNodes;
        for (const layer of this.layers){
            keptNodes = layer instanceof $f4daf0419fd2b7c5$export$42a852a2b6b56249 ? 1 : 0;
            for(let originalNodeIndex = 0; originalNodeIndex < layer.inboundNodes.length; originalNodeIndex++){
                const nodeKey = $f4daf0419fd2b7c5$export$42a852a2b6b56249.nodeKey(layer, originalNodeIndex);
                if (this.containerNodes.has(nodeKey)) {
                    // i.e. we mark it to be saved
                    nodeConversionMap[nodeKey] = keptNodes;
                    keptNodes += 1;
                }
            }
        }
        return nodeConversionMap;
    }
    getLayer(nameOrIndex, index) {
        if (index != null) return this.findLayer(index);
        else {
            if (nameOrIndex == null) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)('Provide either a layer name or layer index');
            if (typeof nameOrIndex === 'number') return this.findLayer(nameOrIndex);
        }
        for (const layer of this.layers){
            if (layer.name === nameOrIndex) return layer;
        }
        throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`No such layer: ${nameOrIndex}`);
    }
    findLayer(index) {
        if (this.layers.length <= index) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Was asked to retrieve layer at index ${index}, but model only ` + `has ${this.layers.length} layer(s).`);
        else return this.layers[index];
    }
    /**
     * Retrieves the Container's current loss values.
     *
     * Used for regularizers during training.
     */ calculateLosses() {
        // Porting Node: This is an augmentation to Container.loss in PyKeras.
        //   In PyKeras, Container.loss returns symbolic tensors. Here a concrete
        //   Tensor (specifically Scalar) values are returned. This is due to the
        //   imperative backend.
        return (0, $i64bB.tidy)(()=>{
            const losses = [];
            for (const layer of this.layers)for(let nodeIndex = 0; nodeIndex < layer.inboundNodes.length; ++nodeIndex){
                const nodeKey = $f4daf0419fd2b7c5$export$42a852a2b6b56249.nodeKey(layer, nodeIndex);
                if (this.containerNodes.has(nodeKey)) losses.push(...layer.calculateLosses());
            }
            // TODO(cais): Add any unconditional model-level losses?
            return losses;
        });
    }
    getConfig() {
        const config = {
            name: this.name
        };
        // Build a map from layer unique name (self._node_key)
        // to the index of the nodes that are saved in the config.
        // Only nodes in container_nodes are saved.
        const nodeConversionMap = this.buildNodeConversionMap(this.layers);
        // Serialize and save the layers in layerConfigs
        const layerConfigs = [];
        for (const layer of this.layers){
            const layerClassName = layer.getClassName();
            const layerConfig = layer.getConfig();
            const filteredInboundNodes = [];
            for(let originalNodeIndex = 0; originalNodeIndex < layer.inboundNodes.length; originalNodeIndex++){
                const node = layer.inboundNodes[originalNodeIndex];
                const nodeKey = $f4daf0419fd2b7c5$export$42a852a2b6b56249.nodeKey(layer, originalNodeIndex);
                let kwargs = {};
                if (this.containerNodes.has(nodeKey)) {
                    // The node is relevant to the model:
                    // add to filteredInboundNodes.
                    if (node.callArgs) try {
                        JSON.stringify(node.callArgs);
                        kwargs = node.callArgs;
                    } catch (err) {
                        console.warn(`Layer ${layer.name} was passed ` + `non-serializable keyword arguments: ` + `${node.callArgs}. They will not be included ` + `in the serialized model (and thus will be ` + `missing at deserialization time).`);
                        kwargs = {};
                    }
                    if (node.inboundLayers.length > 0) {
                        const nodeData = [];
                        for(let i = 0; i < node.inboundLayers.length; i++){
                            const inboundLayer = node.inboundLayers[i];
                            const nodeIndex = node.nodeIndices[i];
                            const tensorIndex = node.tensorIndices[i];
                            const nodeKey = $f4daf0419fd2b7c5$export$42a852a2b6b56249.nodeKey(inboundLayer, nodeIndex);
                            let newNodeIndex = nodeConversionMap[nodeKey];
                            if (newNodeIndex == null) newNodeIndex = 0;
                            nodeData.push([
                                inboundLayer.name,
                                newNodeIndex,
                                tensorIndex,
                                kwargs
                            ]);
                        }
                        filteredInboundNodes.push(nodeData);
                    }
                }
            }
            const dict = {};
            dict['name'] = layer.name;
            dict['className'] = layerClassName;
            dict['config'] = layerConfig;
            dict['inboundNodes'] = filteredInboundNodes;
            layerConfigs.push(dict);
        }
        config['layers'] = layerConfigs;
        // Gather info about inputs and outputs
        const modelInputs = [];
        for(let i = 0; i < this.inputLayers.length; i++){
            const layer = this.inputLayers[i];
            const nodeIndex = this.inputLayersNodeIndices[i];
            const nodeKey = $f4daf0419fd2b7c5$export$42a852a2b6b56249.nodeKey(layer, nodeIndex);
            if (!this.containerNodes.has(nodeKey)) continue;
            let newNodeIndex = nodeConversionMap[nodeKey];
            if (newNodeIndex === null || newNodeIndex === undefined) newNodeIndex = 0;
            const tensorIndex = this.inputLayersTensorIndices[i];
            modelInputs.push([
                layer.name,
                newNodeIndex,
                tensorIndex
            ]);
        }
        config['inputLayers'] = modelInputs;
        const modelOutputs = [];
        for(let i = 0; i < this.outputLayers.length; i++){
            const layer = this.outputLayers[i];
            const nodeIndex = this.outputLayersNodeIndices[i];
            const nodeKey = $f4daf0419fd2b7c5$export$42a852a2b6b56249.nodeKey(layer, nodeIndex);
            if (!this.containerNodes.has(nodeKey)) continue;
            let newNodeIndex = nodeConversionMap[nodeKey];
            if (newNodeIndex === null || newNodeIndex === undefined) newNodeIndex = 0;
            const tensorIndex = this.outputLayersTensorIndices[i];
            modelOutputs.push([
                layer.name,
                newNodeIndex,
                tensorIndex
            ]);
        }
        config['outputLayers'] = modelOutputs;
        return config;
    }
    /**
     * Instantiates a LayersModel from its config (output of `get_config()`).
     * @param cls the class to create
     * @param config LayersModel config dictionary.
     * @param customObjects An optional dictionary of custom objects.
     * @param fastWeightInit Optional flag to use fast weight initialization
     *   during deserialization. This is applicable to cases in which
     *   the initialization will be immediately overwritten by loaded weight
     *   values. Default: `false`.
     * @returns A LayersModel instance.
     * @throws ValueError: In case of improperly formatted config dict.
     */ /** @nocollapse */ static fromConfig(cls, config, customObjects = {}, fastWeightInit = false) {
        // Layer instances created during
        // the graph reconstruction process
        const createdLayers = {};
        // Dictionary mapping layer instances to
        // node data that specifies a layer call.
        // It acts as a queue that maintains any unprocessed
        // layer call until it becomes possible to process it
        // (i.e. until the input tensors to the call all exist).
        const unprocessedNodes = {};
        function addUnprocessedNode(layer, nodeData) {
            if (!(layer.name in unprocessedNodes)) unprocessedNodes[layer.name] = [
                nodeData
            ];
            else unprocessedNodes[layer.name].push(nodeData);
        }
        function processNode(layer, nodeData) {
            const inputTensors = [];
            let kwargs;
            for (const inputData of nodeData){
                const inboundLayerName = inputData[0];
                const inboundNodeIndex = inputData[1];
                const inboundTensorIndex = inputData[2];
                kwargs = inputData[3] == null ? {} : inputData[3];
                if (!(inboundLayerName in createdLayers)) {
                    addUnprocessedNode(layer, nodeData);
                    return;
                }
                const inboundLayer = createdLayers[inboundLayerName];
                if (inboundLayer.inboundNodes.length <= inboundNodeIndex) {
                    addUnprocessedNode(layer, nodeData);
                    return;
                }
                const inboundNode = inboundLayer.inboundNodes[inboundNodeIndex];
                inputTensors.push(inboundNode.outputTensors[inboundTensorIndex]);
            }
            // Call layer on its inputs, thus creating the node
            // and building the layer if needed.
            // Note: This has Eager vs Graph Implications.
            if (inputTensors.length > 0) layer.apply($b5cd0926a1c6df1f$export$8366660815493a21(inputTensors), kwargs); // was ** kwargs
        }
        /**
         * Deserialize a layer, then call it on appropriate inputs.
         * @param layerData: layer config dict.
         * @throws ValueError: In case of improperly formatted `layer_data`
         * dict.
         */ function processLayer(layerData) {
            const layerName = layerData['name'];
            // Instantiate layer.
            const layer = (0, $61cac79a6a78765b$export$efcd34ab6248d3cd)(layerData, config['customObjects'] != null ? config['customObjects'] : {});
            layer.setFastWeightInitDuringBuild(fastWeightInit);
            createdLayers[layerName] = layer;
            // Gather layer inputs.
            const inboundNodesData = layerData['inboundNodes'];
            inboundNodesData.forEach((nodeData)=>{
                if (!(nodeData instanceof Array)) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Corrupted configuration, expected array for nodeData: ${nodeData}`);
                // We don't process nodes (i.e. make layer calls)
                // on the fly because the inbound node may not yet exist,
                // in case of layer shared at different topological depths
                // (e.g.a model such as A(B(A(B(x)))))
                addUnprocessedNode(layer, nodeData);
            });
        }
        // First, we create all layers and enqueue nodes to be processed.
        const name = config['name'];
        const layersFromConfig = config['layers'];
        for (const layerData of layersFromConfig)processLayer(layerData);
        // Then we process nodes in order of layer depth.
        // Nodes that cannot yet be processed(if the inbound node
        // does not yet exist) are re - enqueued, and the process
        // is repeated until all nodes are processed.
        while(!$b5cd0926a1c6df1f$export$23cfe696632d10f4(unprocessedNodes))for (const layerData of layersFromConfig){
            const layer = createdLayers[layerData['name']];
            if (layer.name in unprocessedNodes) {
                const currentUnprocessedNodesForLayer = unprocessedNodes[layer.name];
                delete unprocessedNodes[layer.name];
                for (const nodeData of currentUnprocessedNodesForLayer)processNode(layer, nodeData);
            }
        }
        const inputTensors = [];
        const outputTensors = [];
        const inputLayersFromConfig = config['inputLayers'];
        for (const layerData of inputLayersFromConfig){
            const layerName = layerData[0];
            const nodeIndex = layerData[1];
            const tensorIndex = layerData[2];
            $b5cd0926a1c6df1f$export$a7a9523472993e97(layerName in createdLayers);
            const layer = createdLayers[layerName];
            const layerOutputTensors = layer.inboundNodes[nodeIndex].outputTensors;
            inputTensors.push(layerOutputTensors[tensorIndex]);
        }
        const outputLayersFromConfig = config['outputLayers'];
        for (const layerData of outputLayersFromConfig){
            const layerName = layerData[0];
            const nodeIndex = layerData[1];
            const tensorIndex = layerData[2];
            $b5cd0926a1c6df1f$export$a7a9523472993e97(layerName in createdLayers);
            const layer = createdLayers[layerName];
            const layerOutputTensors = layer.inboundNodes[nodeIndex].outputTensors;
            outputTensors.push(layerOutputTensors[tensorIndex]);
        }
        return new cls({
            inputs: inputTensors,
            outputs: outputTensors,
            name: name
        });
    }
    /**
     * Determine whether the container is stateful.
     *
     * Porting Note: this is the equivalent of the stateful @property of
     *   the Container class in PyKeras.
     */ get stateful() {
        // Porting Note: This check is to prevent inadvertent setting of the
        //   _stateful property of the Container instance.
        if (this._stateful) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)("Container instance unexpectedly has _stateful = true. The statefulness of a Container is determined by the Layers it contains. Its _stateful property must remain the default false.");
        for (const layer of this.layers){
            if (layer.stateful) return true;
        }
        return false;
    }
    /**
     * Reset the state of all stateful constituent layers (if any).
     *
     * Examples of stateful layers include RNN layers whose `stateful` property
     * is set as `true`.
     */ resetStates() {
        (0, $i64bB.tidy)(()=>{
            this.layers.forEach((layer)=>{
                // tslint:disable:no-any
                if (layer.stateful) layer.resetStates();
            // tslint:enable:no-any
            });
        });
    }
}



/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * Interfaces and methods for training models using TensorFlow.js datasets.
 */ 
var $i64bB = parcelRequire("i64bB");




/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
function $8ded3c04f5c1e232$var$standardizeSampleOrClassWeights(xWeight, outputNames, weightType) {
    const numOutputs = outputNames.length;
    if (xWeight == null || Array.isArray(xWeight) && xWeight.length === 0) return outputNames.map((name)=>null);
    if (numOutputs === 1) {
        if (Array.isArray(xWeight) && xWeight.length === 1) return xWeight;
        else if (typeof xWeight === 'object' && outputNames[0] in xWeight) return [
            xWeight[outputNames[0]]
        ];
        else return [
            xWeight
        ];
    }
    if (Array.isArray(xWeight)) {
        if (xWeight.length !== numOutputs) throw new Error(`Provided ${weightType} is an array of ${xWeight.length} ` + `element(s), but the model has ${numOutputs} outputs. ` + `Make sure a set of weights is provided for each model output.`);
        return xWeight;
    } else if (typeof xWeight === 'object' && Object.keys(xWeight).length > 0 && typeof xWeight[Object.keys(xWeight)[0]] === 'object') {
        const output = [];
        outputNames.forEach((outputName)=>{
            if (outputName in xWeight) output.push(xWeight[outputName]);
            else output.push(null);
        });
        return output;
    } else throw new Error(`The model has multiple (${numOutputs}) outputs, ` + `so ${weightType} must be either an array with ` + `${numOutputs} elements or an object with ${outputNames} keys. ` + `Provided ${weightType} not understood: ${JSON.stringify(xWeight)}`);
}
function $8ded3c04f5c1e232$export$9122f8f77cba9cbe(classWeight, outputNames) {
    return $8ded3c04f5c1e232$var$standardizeSampleOrClassWeights(classWeight, outputNames, 'classWeight');
}
function $8ded3c04f5c1e232$export$bcbbad49dddf28d(classWeight, outputNames) {
    return $8ded3c04f5c1e232$var$standardizeSampleOrClassWeights(classWeight, outputNames, 'sampleWeight');
}
async function $8ded3c04f5c1e232$export$cecca6094cb0d869(y, sampleWeight, classWeight, sampleWeightMode) {
    if (sampleWeight != null || sampleWeightMode != null) // TODO(cais): Once 'temporal' mode is implemented, document it in the doc
    // string.
    throw new Error('Support sampleWeight is not implemented yet');
    if (classWeight != null) {
        // Apply class weights per sample.
        const yClasses = (0, $i64bB.tidy)(()=>{
            if (y.shape.length === 1) // Assume class indices.
            return (0, $i64bB.clone)(y);
            else if (y.shape.length === 2) {
                if (y.shape[1] > 1) {
                    // Assume one-hot encoding of classes.
                    const axis = 1;
                    return (0, $i64bB.argMax)(y, axis);
                } else if (y.shape[1] === 1) // Class index.
                return (0, $i64bB.reshape)(y, [
                    y.shape[0]
                ]);
                else throw new Error(`Encountered unexpected last-dimension size (${y.shape[1]}) ` + `during handling of class weights. The size is expected to be ` + `>= 1.`);
            } else throw new Error(`Unexpected rank of target (y) tensor (${y.rank}) during ` + `handling of class weights. The rank is expected to be 1 or 2.`);
        });
        const yClassIndices = Array.from(await yClasses.data());
        (0, $i64bB.dispose)(yClasses);
        const classSampleWeight = [];
        yClassIndices.forEach((classIndex)=>{
            if (classWeight[classIndex] == null) throw new Error(`classWeight must contain all classes in the training data. ` + `The class ${classIndex} exists in the data but not in ` + `classWeight`);
            else classSampleWeight.push(classWeight[classIndex]);
        });
        return (0, $i64bB.tensor1d)(classSampleWeight, 'float32');
    } else return null;
}
function $8ded3c04f5c1e232$export$23bdc4cea2e28782(losses, sampleWeights) {
    return (0, $i64bB.mul)(losses, sampleWeights);
}


// Default batch size used during tensor-based validation.
const $5d730fc8c84c48e3$var$DEFAULT_VALIDATION_BATCH_SIZE = 32;
/**
 * Standardize the output of a dataset iterator for use by
 * LayersModel.fitDataset().
 *
 * @param model: A `tf.LayersModel` object.
 * @param iteratorOut The output of a dataset iterator. It is required to be
 *   an object of the form `{xs: TensorOrArrayOrMap, ys:
 * TensorOrArrayOrMap}`, where `TensorOrArrayOrMap` is a single `tf.Tensor`,
 * a `tf.Tensor[]`, or a flat map from string names to `tf.Tensor`s.
 * @returns A flat array of `tf.Tensor` objects: the input `tf.Tensor`s
 *   followed by the target `tf.Tensor`s.  When `tf.Tensor`s are provided
 *   as a map, the order in the resulting array is taken from the `inputNames`
 *   and `outputNames` of the model.
 */ function $5d730fc8c84c48e3$var$standardizeDataIteratorOutput(// Type `model` as `any` here to avoid circular dependency w/
// training.ts.
// tslint:disable-next-line:no-any
model, iteratorOut) {
    let xs;
    let ys;
    const iteratorOutObj = iteratorOut;
    xs = iteratorOutObj['xs'];
    ys = iteratorOutObj['ys'];
    $i64bB.util.assert(xs != null && ys != null, ()=>"A Dataset iterator for fitDataset() is expected to generate objects of the form `{xs: xVal, ys: yVal}`, where the two values may be `tf.Tensor`, an array of Tensors, or a map of string to Tensor.  The provided Dataset instead generates " + `${iteratorOut}`);
    const flattenedXs = $5d730fc8c84c48e3$var$flattenTensorOrArrayOrMap('input', model.inputNames, xs);
    const flattenedYs = $5d730fc8c84c48e3$var$flattenTensorOrArrayOrMap('output', model.outputNames, ys);
    const batchSize = flattenedXs[0].shape[0];
    $i64bB.util.assert(flattenedXs.length === model.inputs.length, ()=>`LayersModel has ${model.inputs.length} inputs, but the dataset ` + `provides ${flattenedXs.length} inputs.  (Expected input keys: ` + `${JSON.stringify(model.inputNames)})`);
    $i64bB.util.assert(flattenedYs.length === model.outputs.length, ()=>`LayersModel has ${model.outputs.length} outputs, but the dataset ` + `provides ${flattenedYs.length} outputs.  (Expected output keys: ` + `${JSON.stringify(model.outputNames)})`);
    for(let xIndex = 0; xIndex < flattenedXs.length; xIndex++)$i64bB.util.assert(flattenedXs[xIndex].shape[0] === batchSize, ()=>`Batch size mismatch: input ` + `${model.inputNames[xIndex]} has ${flattenedXs[xIndex].shape[0]}; ` + `expected  ${batchSize} based on input ${model.inputNames[0]}.`);
    for(let yIndex = 0; yIndex < flattenedYs.length; yIndex++)$i64bB.util.assert(flattenedYs[yIndex].shape[0] === batchSize, ()=>`Batch size mismatch: output ` + `${model.outputNames[yIndex]} has ${flattenedYs[yIndex].shape[0]}; ` + `expected  ${batchSize} based on input ${model.inputNames[0]}.`);
    return {
        xs: flattenedXs,
        ys: flattenedYs
    };
}
function $5d730fc8c84c48e3$var$flattenTensorOrArrayOrMap(inputOrOutput, names, values) {
    if (values instanceof $i64bB.Tensor) return [
        values
    ];
    else if (Array.isArray(values)) {
        $i64bB.util.assert(values.length === names.length, ()=>`Received an array of ${values.length} Tensors, but expected ${names.length} to match the ${inputOrOutput} keys ${names}.`);
        return values;
    } else {
        const result = [];
        // Check that all the required keys are available.
        for (const name of names){
            if (values[name] == null) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`The feature data generated by the dataset lacks the required ` + `${inputOrOutput} key '${name}'.`);
            result.push(values[name]);
        }
        return result;
    }
}
function $5d730fc8c84c48e3$var$standardizeTensorValidationData(data) {
    if (data.length === 3) throw new (0, $af476738b120e938$export$e162153238934121)('Validation with sample weights is not implemented yet.');
    return {
        xs: data[0],
        ys: data[1]
    };
}
async function $5d730fc8c84c48e3$export$4e883c052383550c(// Type `model` as `any` here to avoid circular dependency w/
// training.ts.
// tslint:disable-next-line:no-any
model, dataset, args) {
    const hasBatchesPerEpoch = args.batchesPerEpoch != null;
    $i64bB.util.assert(model.optimizer != null, ()=>"You must compile a model before training/testing. Use LayersModel.compile(modelCompileConfig).");
    $i64bB.util.assert(args != null, ()=>`For fitDataset(), the 2nd argument (config) is required, ` + `but it is not provided in this call.`);
    $i64bB.util.assert(args.epochs != null && args.epochs > 0 && Number.isInteger(args.epochs), ()=>`For fitDataset(), config.epochs is expected to be a positive ` + `integer, but got ${args.epochs}`);
    $i64bB.util.assert(!hasBatchesPerEpoch || args.batchesPerEpoch > 0 && Number.isInteger(args.batchesPerEpoch), ()=>`For fitDataset(), config.batchesPerEpoch is expected to be a ` + `positive integer if specified, but got ${args.batchesPerEpoch}`);
    $i64bB.util.assert(// tslint:disable-next-line:no-any
    args['validationSplit'] == null, ()=>"`validationSplit` is not supported by `fitDataset()`. Use validationData instead.");
    if (model.isTraining) throw new Error('Cannot start training because another fit() call is ongoing.');
    model.isTraining = true;
    try {
        const doValidation = args.validationData != null;
        let valXs;
        let valYs;
        if (doValidation) {
            if ($5d730fc8c84c48e3$var$isDatasetObject(args.validationData)) $i64bB.util.assert(args.validationBatches == null || args.validationBatches > 0 && Number.isInteger(args.validationBatches), ()=>`For fitDataset() with dataset-based validation, ` + `config.validationBatches is expected not to be provided, ` + `or to be a positive integer, ` + `but got ${args.validationBatches}`);
            else {
                const validationData = $5d730fc8c84c48e3$var$standardizeTensorValidationData(args.validationData);
                valXs = validationData.xs;
                valYs = validationData.ys;
            }
        }
        const trainFunction = model.makeTrainFunction();
        const outLabels = model.getDedupedMetricsNames();
        let callbackMetrics;
        if (doValidation) callbackMetrics = outLabels.slice().concat(outLabels.map((n)=>'val_' + n));
        else callbackMetrics = outLabels.slice();
        const callbacks = (0, $65144a7424fc1c41$export$8ea03bd28ba7b2ff)(args.callbacks, args.yieldEvery);
        const verbose = args.verbose == null ? 1 : args.verbose;
        const { callbackList: callbackList, history: history } = (0, $65144a7424fc1c41$export$18b2cd3db6266dd9)(callbacks, verbose, args.epochs, null, null, $5d730fc8c84c48e3$var$getStepsPerEpoch(dataset, args), null, doValidation, callbackMetrics);
        callbackList.setModel(model);
        model.history = history;
        await callbackList.onTrainBegin();
        model.stopTraining_ = false;
        let epoch = args.initialEpoch == null ? 0 : args.initialEpoch;
        let dataIterator = await dataset.iterator();
        while(epoch < args.epochs){
            const epochLogs = {};
            await callbackList.onEpochBegin(epoch);
            let stepsDone = 0;
            let batchIndex = 0;
            if (!hasBatchesPerEpoch) dataIterator = await dataset.iterator();
            while(hasBatchesPerEpoch ? stepsDone < args.batchesPerEpoch : true){
                const iteratorOut = await dataIterator.next();
                // If `batchesPerEpoch` is specified, the dataset should not be
                // exhausted until all epoches are done.
                if (hasBatchesPerEpoch && iteratorOut.done) {
                    console.warn('You provided `batchesPerEpoch` as ' + `${args.batchesPerEpoch}, ` + 'but your dataset iterator ran out of data after ' + `${stepsDone} batches; ` + 'interrupting training. Make sure that your ' + 'dataset can generate at least `batchesPerEpoch * epochs` ' + 'batches (in this case, ' + `${args.batchesPerEpoch * args.epochs} batches). ` + 'You may need to use the repeat() function when building ' + 'your dataset.');
                    break;
                }
                if (iteratorOut.value != null) {
                    const { xs: xs, ys: ys } = $5d730fc8c84c48e3$var$standardizeDataIteratorOutput(model, iteratorOut.value);
                    const batchLogs = {};
                    batchLogs['batch'] = batchIndex;
                    batchLogs['size'] = xs[0].shape[0];
                    await callbackList.onBatchBegin(batchIndex, batchLogs);
                    const sampleWeights = [];
                    if (args.classWeight != null) {
                        const standardClassWeights = (0, $8ded3c04f5c1e232$export$9122f8f77cba9cbe)(args.classWeight, model.outputNames);
                        for(let i = 0; i < standardClassWeights.length; ++i)sampleWeights.push(await (0, $8ded3c04f5c1e232$export$cecca6094cb0d869)(ys[i], null, standardClassWeights[i]));
                    }
                    // Train on batch.
                    const ins = xs.concat(ys).concat(sampleWeights);
                    const outs = trainFunction(ins);
                    $i64bB.dispose(ins);
                    for(let i = 0; i < outLabels.length; ++i){
                        const label = outLabels[i];
                        const out = outs[i];
                        batchLogs[label] = out;
                        $i64bB.keep(out);
                    }
                    await callbackList.onBatchEnd(batchIndex, batchLogs);
                    (0, $60719b6320089bc4$export$f4920d82017cd044)(batchLogs);
                    batchIndex++;
                    stepsDone++;
                }
                if (hasBatchesPerEpoch ? stepsDone >= args.batchesPerEpoch : iteratorOut.done) {
                    // Epoch finished. Perform validation.
                    if (doValidation) {
                        let valOuts;
                        if ($5d730fc8c84c48e3$var$isDatasetObject(args.validationData)) valOuts = (0, $b5cd0926a1c6df1f$export$effcdbd76139450)(await model.evaluateDataset(args.validationData, {
                            batches: args.validationBatches
                        }));
                        else valOuts = (0, $b5cd0926a1c6df1f$export$effcdbd76139450)(model.evaluate(valXs, valYs, {
                            batchSize: args.validationBatchSize == null ? $5d730fc8c84c48e3$var$DEFAULT_VALIDATION_BATCH_SIZE : args.validationBatchSize,
                            verbose: 0
                        }));
                        for(let i = 0; i < model.metricsNames.length; ++i)epochLogs[`val_${model.metricsNames[i]}`] = valOuts[i];
                    }
                    break;
                }
                if (model.stopTraining_) break;
            }
            await callbackList.onEpochEnd(epoch, epochLogs);
            epoch++;
            if (model.stopTraining_) break;
        }
        await callbackList.onTrainEnd();
        await model.history.syncData();
        return model.history;
    } finally{
        model.isTraining = false;
    }
}
/** Helper function that determines number of steps (batches) per epoch. */ function $5d730fc8c84c48e3$var$getStepsPerEpoch(dataset, args) {
    // Attempt to determine # of batches in an epoch.
    let stepsPerEpoch = null;
    if (args.batchesPerEpoch != null) stepsPerEpoch = args.batchesPerEpoch;
    else if (Number.isFinite(dataset.size)) stepsPerEpoch = dataset.size;
    return stepsPerEpoch;
}
// Check if provided object is a Dataset object by checking its .iterator
// element.
function $5d730fc8c84c48e3$var$isDatasetObject(dataset) {
    return typeof dataset.iterator === 'function';
}
// Check if provided object is a LazyIterator object by checking it's .next
// element.
function $5d730fc8c84c48e3$var$isLazyIteratorObject(iterator) {
    return typeof iterator.next === 'function';
}
async function $5d730fc8c84c48e3$export$56e284faddc3ba42(// Type `model` as `any` here to avoid circular dependency w/
// training.ts.
// tslint:disable-next-line:no-any
model, dataset, args) {
    args = args || {};
    const hasBatches = args.batches != null;
    const f = model.testFunction;
    let outs = [];
    if (args.verbose > 0) throw new (0, $af476738b120e938$export$e162153238934121)('Verbose mode is not implemented yet.');
    $i64bB.util.assert(!hasBatches || args.batches > 0 && Number.isInteger(args.batches), ()=>'Test loop expects `batches` to be a positive integer, but ' + `received ${JSON.stringify(args.batches)}`);
    const dataIterator = $5d730fc8c84c48e3$var$isLazyIteratorObject(dataset) ? dataset : await dataset.iterator();
    // Keeps track of number of examples used in this evaluation.
    let numExamples = 0;
    let batch = 0;
    while(hasBatches ? batch < args.batches : true){
        const iteratorOut = await dataIterator.next();
        outs = $i64bB.tidy(()=>{
            if (iteratorOut.value) {
                // TODO(cais): Once real dataset is available, use
                //   `map(x => standardizeDataIteratorOutput(model, x).map(f)`.
                const { xs: xs, ys: ys } = $5d730fc8c84c48e3$var$standardizeDataIteratorOutput(model, iteratorOut.value);
                const xsAndYs = xs.concat(ys);
                const batchOuts = $i64bB.tidy(()=>f(xsAndYs));
                $i64bB.dispose(xsAndYs);
                if (batch === 0) for(let i = 0; i < batchOuts.length; ++i)outs.push((0, $i64bB.scalar)(0));
                const batchSize = xsAndYs[0].shape[0];
                for(let i = 0; i < batchOuts.length; ++i){
                    const batchOut = batchOuts[i];
                    const oldScalar = outs[i];
                    outs[i] = $i64bB.tidy(()=>$i64bB.add(outs[i], $i64bB.mul(batchSize, batchOut)));
                    if (batch > 0) $i64bB.dispose(oldScalar);
                }
                $i64bB.dispose(batchOuts);
                numExamples += batchSize;
                ++batch;
            }
            return outs;
        });
        if (iteratorOut.done) {
            if (hasBatches) console.warn("Your dataset iterator ran out of data during evaluateDataset(). Interrupting evalution. Make sure that your dataset can generate at least `batches` " + `batches (in this case, ${args.batches} batches). ` + 'You may need to use the repeat() function when building ' + 'your dataset.');
            break;
        }
    }
    for(let i = 0; i < outs.length; ++i){
        const oldScalar = outs[i];
        outs[i] = $i64bB.div(outs[i], numExamples);
        $i64bB.dispose(oldScalar);
    }
    return (0, $b5cd0926a1c6df1f$export$8366660815493a21)(outs);
}


/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * Interfaces and methods for training models using tf.Tensor objects.
 */ 
var $i64bB = parcelRequire("i64bB");

function $5c897b21a1c3d59d$export$2f80f09f3b9f932e(batchSize) {
    $i64bB.util.assert(batchSize > 0 && Number.isInteger(batchSize), ()=>`batchSize is required to be a positive integer, but got ${batchSize}`);
}
function $5c897b21a1c3d59d$export$45b6cbb437b1b016(arrays, start, stop) {
    if (arrays == null) return [
        null
    ];
    else if (Array.isArray(arrays)) return arrays.map((array)=>(0, $33b0bdd0433db936$export$4f266636a9634575)(array, start, stop - start));
    else return (0, $33b0bdd0433db936$export$4f266636a9634575)(arrays, start, stop - start);
}
function $5c897b21a1c3d59d$export$4a7d2c6b9b0d590(arrays, indices) {
    return $i64bB.tidy(()=>{
        if (arrays == null) return null;
        else if (Array.isArray(arrays)) return arrays.map((array)=>$5c897b21a1c3d59d$export$4a7d2c6b9b0d590(array, indices));
        else // TODO(cais): indices should be a pre-constructed Tensor1D to avoid
        //   tensor1d() calls.
        return (0, $33b0bdd0433db936$export$9e05546f00427e8)(arrays, indices.dtype === 'int32' ? indices : $i64bB.cast(indices, 'int32'));
    });
}
function $5c897b21a1c3d59d$export$7ce16f2471062005(size, batchSize) {
    const output = [];
    let batchStart = 0;
    let batchEnd = null;
    while(batchStart < size){
        batchEnd = batchStart + batchSize;
        if (batchEnd >= size) batchEnd = size;
        output.push([
            batchStart,
            batchEnd
        ]);
        batchStart = batchEnd;
    }
    return output;
}
function $5c897b21a1c3d59d$export$b2d45309fc343ee1(tensors) {
    const outs = [];
    if (tensors instanceof (0, $i64bB.Tensor)) tensors = [
        tensors
    ];
    // Make Tensors at least 2D.
    for(let i = 0; i < tensors.length; ++i){
        const tensor = tensors[i];
        if (tensor.rank === 1) outs.push((0, $33b0bdd0433db936$export$d660d8ed21f46635)(tensor, 1));
        else if (tensor.rank === 0) throw new Error("Expected tensor to be at least 1D, but received a 0D tensor (scalar).");
        else outs.push(tensor);
    }
    return outs;
}
function $5c897b21a1c3d59d$export$55dac70a20481db3(tensors, refTensors) {
    if (tensors == null) return;
    const oldTensorIds = [];
    if (refTensors instanceof (0, $i64bB.Tensor)) oldTensorIds.push(refTensors.id);
    else if (Array.isArray(refTensors)) refTensors.forEach((t)=>oldTensorIds.push(t.id));
    else if (refTensors != null) // `oldTensors` is a map from string name to Tensor.
    for(const name in refTensors){
        const oldTensor = refTensors[name];
        oldTensorIds.push(oldTensor.id);
    }
    const tensorsToDispose = [];
    if (tensors instanceof (0, $i64bB.Tensor)) {
        if (oldTensorIds.indexOf(tensors.id) === -1) tensorsToDispose.push(tensors);
    } else if (Array.isArray(tensors)) tensors.forEach((t)=>{
        if (oldTensorIds.indexOf(t.id) === -1) tensorsToDispose.push(t);
    });
    else if (tensors != null) // `oldTensors` is a map from string name to Tensor.
    for(const name in tensors){
        const tensor = tensors[name];
        if (oldTensorIds.indexOf(tensor.id) === -1) tensorsToDispose.push(tensor);
    }
    tensorsToDispose.forEach((t)=>{
        if (!t.isDisposed) t.dispose();
    });
}



function $c4ed419014cbc39b$export$73ccac4188109750(x) {
    return x instanceof (0, $i64bB.Tensor);
}
function $c4ed419014cbc39b$export$d011a650f00557e2(x) {
    return Array.isArray(x);
}
function $c4ed419014cbc39b$export$6af9d9020dbc362d(x) {
    return !$c4ed419014cbc39b$export$73ccac4188109750(x) && !$c4ed419014cbc39b$export$d011a650f00557e2(x);
}
function $c4ed419014cbc39b$export$69dd7486f5c87261(data, names, shapes, checkBatchAxis = true, exceptionPrefix = '') {
    if (names == null || names.length === 0) {
        // Check for the case where the model expected no data, but some data got
        // sent.
        if (data != null) {
            let gotUnexpectedData = false;
            if ($c4ed419014cbc39b$export$d011a650f00557e2(data) && data.length > 0) gotUnexpectedData = true;
            else if ($c4ed419014cbc39b$export$6af9d9020dbc362d(data)) {
                for(const key in data)if (data.hasOwnProperty(key)) {
                    gotUnexpectedData = true;
                    break;
                }
            } else // `data` is a singleton Tensor in this case.
            gotUnexpectedData = true;
            if (gotUnexpectedData) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Error when checking model ${exceptionPrefix} expected no data, ` + `but got ${data}`);
        }
        return [];
    }
    if (data == null) return names.map((name)=>null);
    let arrays;
    if ($c4ed419014cbc39b$export$6af9d9020dbc362d(data)) {
        data;
        arrays = [];
        for (const name of names){
            if (data[name] == null) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`No data provided for "${name}". Need data for each key in: ` + `${names}`);
            arrays.push(data[name]);
        }
    } else if ($c4ed419014cbc39b$export$d011a650f00557e2(data)) {
        data;
        if (data.length !== names.length) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Error when checking model ${exceptionPrefix}: the Array of ` + `Tensors that you are passing to your model is not the size the ` + `model expected. Expected to see ${names.length} Tensor(s), but ` + `instead got the following list of Tensor(s): ${data}`);
        arrays = data;
    } else {
        data;
        if (names.length > 1) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`The model ${exceptionPrefix} expects ${names.length} Tensor(s), ` + `but only received one Tensor. Found: Tensor with shape ${data.shape}`);
        arrays = [
            data
        ];
    }
    arrays = (0, $5c897b21a1c3d59d$export$b2d45309fc343ee1)(arrays);
    // Check shape compatibility.
    if (shapes != null) for(let i = 0; i < names.length; ++i){
        if (shapes[i] == null) continue;
        const array = arrays[i];
        if (array.shape.length !== shapes[i].length) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Error when checking ${exceptionPrefix}: expected ${names[i]} ` + `to have ${shapes[i].length} dimension(s). but got array with ` + `shape ${array.shape}`);
        for(let j = 0; j < shapes[i].length; ++j){
            if (j === 0 && !checkBatchAxis) continue;
            const dim = array.shape[j];
            const refDim = shapes[i][j];
            if (refDim != null && refDim >= 0 && dim !== refDim) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`${exceptionPrefix} expected a batch of elements where each ` + `example has shape [${shapes[i].slice(1, shapes[i].length)}] ` + `(i.e.,tensor shape [*,${shapes[i].slice(1, shapes[i].length)}])` + ` but the ${exceptionPrefix} received an input with ${array.shape[0]}` + ` examples, each with shape [${array.shape.slice(1, array.shape.length)}]` + ` (tensor shape [${array.shape}])`);
        }
    }
    return arrays;
}
function $c4ed419014cbc39b$export$4b125fd48a812392(inputs, targets, weights) {
    const setX = (0, $b5cd0926a1c6df1f$export$7a5d5c156e7dc406)(inputs.map((input)=>input.shape[0]));
    setX.sort();
    const setY = (0, $b5cd0926a1c6df1f$export$7a5d5c156e7dc406)(targets.map((target)=>target.shape[0]));
    setY.sort();
    // TODO(cais): Check `weights` as well.
    if (setX.length > 1) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`All input Tensors (x) should have the same number of samples. ` + `Got array shapes: ` + `${JSON.stringify(inputs.map((input)=>input.shape))}`);
    if (setY.length > 1) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`All target Tensors (y) should have the same number of samples. ` + `Got array shapes: ` + `${JSON.stringify(targets.map((target)=>target.shape))}`);
    if (setX.length > 0 && setY.length > 0 && !(0, $i64bB.util).arraysEqual(setX, setY)) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Input Tensors should have the same number of samples as target ` + `Tensors. Found ${setX[0]} input sample(s) and ${setY[0]} target ` + `sample(s).`);
}
/**
 * Validation on the compatibility of targes and loss functions.
 *
 * This helps prevent users from using loss functions incorrectly.
 *
 * @param targets `Array` of `tf.Tensor`s of targets.
 * @param lossFns `Array` of loss functions.
 * @param outputShapes `Array` of shapes of model outputs.
 */ function $c4ed419014cbc39b$var$checkLossAndTargetCompatibility(targets, lossFns, outputShapes) {
    // TODO(cais): Dedicated test coverage?
    const keyLosses = [
        $7d695629521dc3d5$export$33de16355e97f7fb,
        $7d695629521dc3d5$export$f9fa66c6bf49fbe1,
        $7d695629521dc3d5$export$3d5544849562b631
    ];
    for(let i = 0; i < targets.length; ++i){
        const y = targets[i];
        const loss = lossFns[i];
        const shape = outputShapes[i];
        if (loss == null) continue;
        if (loss === $7d695629521dc3d5$export$3d5544849562b631) {
            if (y.shape[y.shape.length - 1] === 1) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`You are passing a target array of shape ${y.shape} while using ` + `a loss 'categorical_crossentropy'. 'categorical_crossentropy'` + `expects targets to be binary matrices (1s and 0s) of shape ` + `[samples, classes].`);
        }
        if (keyLosses.indexOf(loss) !== -1) {
            const slicedYShape = y.shape.slice(1);
            const slicedShape = shape.slice(1);
            for(let j = 0; j < slicedYShape.length; ++j){
                const targetDim = slicedYShape[j];
                const outDim = slicedShape[j];
                if (outDim != null && targetDim !== outDim) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`A target Tensor with shape ${y.shape} was passed for an ` + `output of shape ${shape}, while using a loss function that ` + `expects targets to have the same shape as the output.`);
            }
        }
    }
}
/**
 * Check inputs provided by the user.
 *
 * Porting Note: This corresponds to _standardize_input_data() in Python
 *   Keras. Because of the strong typing in TF.js, we do not need to convert
 *   the data. Specifically:
 *   1) in PyKeras, `data` can be `DataFrame` instances from pandas, for
 *      example. We don't need to worry about that here because there is no
 *      widely popular javascript/typesdcript equivalent of pandas (so far).
 *      If one becomes available in the future, we can add support.
 *   2) in PyKeras, inputs can be Python dict. But here we are stipulating
 * that the data is either a single `tf.Tensor` or an Array of `tf.Tensor`s. We
 * may add support for `Object` data inputs in the future when the need
 * arises.
 *
 * Instead, we perform basic checks for number of parameters and shapes.
 *
 * @param data: The input data.
 * @param names: Name for the inputs, from the model.
 * @param shapes: Expected shapes for the input data, from the model.
 * @param checkBatchAxis: Whether the size along the batch axis (i.e., the
 *   first dimension) will be checked for matching.
 * @param exceptionPrefix: Execption prefix message, used in generating error
 *   messages.
 * @throws ValueError: on incorrect number of inputs or mismatches in shapes.
 */ function $c4ed419014cbc39b$var$checkInputData(data, names, shapes, checkBatchAxis = true, exceptionPrefix = '') {
    let arrays;
    if (Array.isArray(data)) {
        if (data.length !== names.length) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Error when checking model ${exceptionPrefix}: the Array of ` + `Tensors that you are passing to your model is not the size the ` + `the model expected. Expected to see ${names.length} Tensor(s),` + ` but instead got ${data.length} Tensors(s).`);
        arrays = data;
    } else {
        if (names.length > 1) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`The model expects ${names.length} ${exceptionPrefix} Tensors, ` + `but only received one Tensor. Found: array with shape ` + `${JSON.stringify(data.shape)}.`);
        arrays = [
            data
        ];
    }
    if (shapes != null) for(let i = 0; i < names.length; ++i){
        if (shapes[i] == null) continue;
        const array = arrays[i];
        if (array.shape.length !== shapes[i].length) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Error when checking ${exceptionPrefix}: expected ${names[i]} ` + `to have ${shapes[i].length} dimension(s), but got array with ` + `shape ${JSON.stringify(array.shape)}`);
        for(let j = 0; j < shapes[i].length; ++j){
            if (j === 0 && !checkBatchAxis) continue;
            const dim = array.shape[j];
            const refDim = shapes[i][j];
            if (refDim != null) {
                if (refDim !== dim) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Error when checking ${exceptionPrefix}: expected ` + `${names[i]} to have shape ${JSON.stringify(shapes[i])} but ` + `got array with shape ${JSON.stringify(array.shape)}.`);
            }
        }
    }
}
function $c4ed419014cbc39b$export$f17c6a7c45a213ae(metrics, outputNames) {
    if (metrics == null || Array.isArray(metrics) && metrics.length === 0) return outputNames.map((name)=>[]);
    let wrappedMetrics;
    if (typeof metrics === 'string' || typeof metrics === 'function') wrappedMetrics = [
        metrics
    ];
    else if (Array.isArray(metrics) || typeof metrics === 'object') wrappedMetrics = metrics;
    else throw new TypeError('Type of metrics argument not understood. Expected an string,' + `function, Array, or Object, found: ${metrics}`);
    if (Array.isArray(wrappedMetrics)) // We then apply all metrics to all outputs.
    return outputNames.map((name)=>wrappedMetrics);
    else {
        // In this case, metrics is a dict.
        const nestedMetrics = [];
        for (const name of outputNames){
            let outputMetrics = wrappedMetrics.hasOwnProperty(name) ? wrappedMetrics[name] : [];
            if (!Array.isArray(outputMetrics)) outputMetrics = [
                outputMetrics
            ];
            nestedMetrics.push(outputMetrics);
        }
        return nestedMetrics;
    }
}
const $c4ed419014cbc39b$var$LAYERS_MODEL_FORMAT_NAME = 'layers-model';
/**
 * A `tf.LayersModel` is a directed, acyclic graph of `tf.Layer`s plus methods
 * for training, evaluation, prediction and saving.
 *
 * `tf.LayersModel` is the basic unit of training, inference and evaluation in
 * TensorFlow.js. To create a `tf.LayersModel`, use `tf.LayersModel`.
 *
 * See also:
 *   `tf.Sequential`, `tf.loadLayersModel`.
 *
 * @doc {heading: 'Models', subheading: 'Classes'}
 */ class $c4ed419014cbc39b$export$f8e130845653852b extends (0, $f4daf0419fd2b7c5$export$42a852a2b6b56249) {
    constructor(args){
        super(args);
        this.isTraining = false;
    }
    /**
     * Print a text summary of the model's layers.
     *
     * The summary includes
     * - Name and type of all layers that comprise the model.
     * - Output shape(s) of the layers
     * - Number of weight parameters of each layer
     * - If the model has non-sequential-like topology, the inputs each layer
     *   receives
     * - The total number of trainable and non-trainable parameters of the model.
     *
     * ```js
     * const input1 = tf.input({shape: [10]});
     * const input2 = tf.input({shape: [20]});
     * const dense1 = tf.layers.dense({units: 4}).apply(input1);
     * const dense2 = tf.layers.dense({units: 8}).apply(input2);
     * const concat = tf.layers.concatenate().apply([dense1, dense2]);
     * const output =
     *     tf.layers.dense({units: 3, activation: 'softmax'}).apply(concat);
     *
     * const model = tf.model({inputs: [input1, input2], outputs: output});
     * model.summary();
     * ```
     *
     * @param lineLength Custom line length, in number of characters.
     * @param positions Custom widths of each of the columns, as either
     *   fractions of `lineLength` (e.g., `[0.5, 0.75, 1]`) or absolute number
     *   of characters (e.g., `[30, 50, 65]`). Each number corresponds to
     *   right-most (i.e., ending) position of a column.
     * @param printFn Custom print function. Can be used to replace the default
     *   `console.log`. For example, you can use `x => {}` to mute the printed
     *   messages in the console.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ summary(lineLength, positions, printFn = console.log) {
        if (!this.built) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`This model has never been called, thus its weights have not been ` + `created yet. So no summary can be displayed. Build the model ` + `first (e.g., by calling it on some test data).`);
        (0, $a31b9cc9c573d4af$export$9b5fcd5d170a598e)(this, lineLength, positions, printFn);
    }
    /**
     * Configures and prepares the model for training and evaluation.  Compiling
     * outfits the model with an optimizer, loss, and/or metrics.  Calling `fit`
     * or `evaluate` on an un-compiled model will throw an error.
     *
     * @param args a `ModelCompileArgs` specifying the loss, optimizer, and
     * metrics to be used for fitting and evaluating this model.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ compile(args) {
        if (args.loss == null) args.loss = [];
        this.loss = args.loss;
        if (typeof args.optimizer === 'string') {
            this.optimizer_ = $ad044476a7bc432e$export$93a6cd925bf0fb14(args.optimizer);
            this.isOptimizerOwned = true;
        } else {
            if (!(args.optimizer instanceof (0, $i64bB.Optimizer))) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`User-defined optimizer must be an instance of tf.Optimizer.`);
            this.optimizer_ = args.optimizer;
            this.isOptimizerOwned = false;
        }
        // TODO(cais): Add lossWeights.
        // TODO(cais): Add sampleWeightMode.
        // Prepare loss functions.
        let lossFunctions = [];
        if (!Array.isArray(args.loss) && typeof args.loss !== 'string' && typeof args.loss !== 'function') {
            args.loss = args.loss;
            for(const name in args.loss){
                if (this.outputNames.indexOf(name) === -1) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Unknown entry in loss dictionary: "${name}". ` + `Only expected the following keys: ${this.outputNames}`);
            }
            for (const name of this.outputNames){
                if (args.loss[name] == null) console.warn(`Output "${name}" is missing from loss dictionary. We assume ` + `this was done on purpose, and we will not be expecting data ` + `to be passed to ${name} during training`);
                lossFunctions.push($7d695629521dc3d5$export$3988ae62b71be9a3(args.loss[name]));
            }
        } else if (Array.isArray(args.loss)) {
            if (args.loss.length !== this.outputs.length) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`When passing an Array as loss, it should have one entry per ` + `model output. The model has ${this.outputs.length} output(s), ` + `but you passed loss=${args.loss}.`);
            const theLosses = args.loss;
            lossFunctions = theLosses.map((l)=>$7d695629521dc3d5$export$3988ae62b71be9a3(l));
        } else {
            const lossFunction = $7d695629521dc3d5$export$3988ae62b71be9a3(args.loss);
            this.outputs.forEach((_)=>{
                lossFunctions.push(lossFunction);
            });
        }
        this.lossFunctions = lossFunctions;
        this.feedOutputNames = [];
        this.feedOutputShapes = [];
        this.feedLossFns = [];
        for(let i = 0; i < this.outputs.length; ++i){
            // TODO(cais): Logic for skipping target(s).
            const shape = this.internalOutputShapes[i];
            const name = this.outputNames[i];
            this.feedOutputNames.push(name);
            this.feedOutputShapes.push(shape);
            this.feedLossFns.push(this.lossFunctions[i]);
        }
        // TODO(cais): Add logic for output masks.
        // TODO(cais): Add logic for sample weights.
        const skipTargetIndices = [];
        // Prepare metrics.
        this.metrics = args.metrics;
        // TODO(cais): Add weightedMetrics.
        this.metricsNames = [
            'loss'
        ];
        this.metricsTensors = [];
        // Compute total loss.
        // Porting Note: In PyKeras, metrics_tensors are symbolic tensor objects.
        //   Here, metricsTensors are TypeScript functions. This difference is due
        //   to the difference in symbolic/imperative property of the backends.
        (0, $860027d3b2c99a1d$export$e820b4f57a8e33d1)('loss', ()=>{
            for(let i = 0; i < this.outputs.length; ++i){
                if (skipTargetIndices.indexOf(i) !== -1) continue;
                // TODO(cais): Add weightedLoss, sampleWeight and mask.
                //   The following line should be weightedLoss
                const weightedLoss = this.lossFunctions[i];
                if (this.outputs.length > 1) {
                    this.metricsTensors.push([
                        weightedLoss,
                        i
                    ]);
                    this.metricsNames.push(this.outputNames[i] + '_loss');
                }
            }
        // Porting Note: Due to the imperative nature of the backend, we calculate
        //   the regularizer penalties in the totalLossFunction, instead of here.
        });
        const nestedMetrics = $c4ed419014cbc39b$export$f17c6a7c45a213ae(args.metrics, this.outputNames);
        // TODO(cais): Add nestedWeightedMetrics.
        /**
         * Helper function used in loop below.
         */ const appendMetric = (outputIndex, metricName, metricTensor)=>{
            if (this.outputNames.length > 1) metricName = this.outputNames[outputIndex] + '_' + metricName;
            this.metricsNames.push(metricName);
            this.metricsTensors.push([
                metricTensor,
                outputIndex
            ]);
        };
        (0, $860027d3b2c99a1d$export$e820b4f57a8e33d1)('metric', ()=>{
            for(let i = 0; i < this.outputs.length; ++i){
                if (skipTargetIndices.indexOf(i) !== -1) continue;
                const outputMetrics = nestedMetrics[i];
                // TODO(cais): Add weights and outputWeightedMetrics.
                // TODO(cais): Add optional arg `weights` to the following function.
                const handleMetrics = (metrics)=>{
                    const metricNamePrefix = '';
                    let metricName;
                    let accFn;
                    let weightedMetricFn;
                    //  TODO(cais): Use 'weights_' for weighted metrics.
                    for (const metric of metrics){
                        if (typeof metric === 'string' && [
                            'accuracy',
                            'acc',
                            'crossentropy',
                            'ce'
                        ].indexOf(metric) !== -1) {
                            const outputShape = this.internalOutputShapes[i];
                            if (outputShape[outputShape.length - 1] === 1 || this.lossFunctions[i] === $7d695629521dc3d5$export$f9fa66c6bf49fbe1) {
                                // case: binary accuracy/crossentropy.
                                if ([
                                    'accuracy',
                                    'acc'
                                ].indexOf(metric) !== -1) accFn = $7612942a5d22baee$export$7b3d02e9a01c1ca;
                                else if ([
                                    'crossentropy',
                                    'ce'
                                ].indexOf(metric) !== -1) accFn = $7612942a5d22baee$export$f9fa66c6bf49fbe1;
                            } else if (this.lossFunctions[i] === $7d695629521dc3d5$export$d02551222e9364f0) {
                                // case: categorical accuracy / crossentropy with sparse
                                // targets.
                                if ([
                                    'accuracy',
                                    'acc'
                                ].indexOf(metric) !== -1) accFn = $7612942a5d22baee$export$b35c43b77daa3523;
                                else if ([
                                    'crossentropy',
                                    'ce'
                                ].indexOf(metric) !== -1) accFn = $7612942a5d22baee$export$d02551222e9364f0;
                            } else {
                                // case: categorical accuracy / crossentropy.
                                if ([
                                    'accuracy',
                                    'acc'
                                ].indexOf(metric) !== -1) accFn = $7612942a5d22baee$export$1365401eb6b7aeeb;
                                else if ([
                                    'crossentropy',
                                    'ce'
                                ].indexOf(metric) !== -1) accFn = $7612942a5d22baee$export$3d5544849562b631;
                            }
                            let suffix;
                            if ([
                                'accuracy',
                                'acc'
                            ].indexOf(metric) !== -1) suffix = 'acc';
                            else if ([
                                'crossentropy',
                                'ce'
                            ].indexOf(metric) !== -1) suffix = 'ce';
                            // TODO(cais): Add weighting actually.
                            weightedMetricFn = accFn;
                            metricName = metricNamePrefix + suffix;
                        } else {
                            const metricFn = $7612942a5d22baee$export$3988ae62b71be9a3(metric);
                            // TODO(cais): Add weighting actually.
                            weightedMetricFn = metricFn;
                            metricName = metricNamePrefix + $7612942a5d22baee$export$9fb8307a5eeccc76(metric);
                        }
                        // TODO(cais): Add weighting and masking to metricResult.
                        let metricResult;
                        (0, $860027d3b2c99a1d$export$e820b4f57a8e33d1)(metricName, ()=>{
                            metricResult = weightedMetricFn;
                        });
                        appendMetric(i, metricName, metricResult);
                    }
                };
                handleMetrics(outputMetrics);
            // TODO(cais): Call handleMetrics with weights.
            }
        });
        // Porting Notes: Given the imperative backend of tfjs-core,
        //   there is no need for constructing the symbolic graph and placeholders.
        this.collectedTrainableWeights = this.trainableWeights;
    }
    /**
     * Check trainable weights count consistency.
     *
     * This will raise a warning if `this.trainableWeights` and
     * `this.collectedTrainableWeights` are inconsistent (i.e., have different
     * numbers of parameters).
     * Inconsistency will typically arise when one modifies `model.trainable`
     * without calling `model.compile()` again.
     */ checkTrainableWeightsConsistency() {
        if (this.collectedTrainableWeights == null) return;
        if (this.trainableWeights.length !== this.collectedTrainableWeights.length) console.warn("Discrepancy between trainableweights and collected trainable weights. Did you set `model.trainable` without calling `model.compile()` afterwards?");
    }
    /**
     * Returns the loss value & metrics values for the model in test mode.
     *
     * Loss and metrics are specified during `compile()`, which needs to happen
     * before calls to `evaluate()`.
     *
     * Computation is done in batches.
     *
     * ```js
     * const model = tf.sequential({
     *   layers: [tf.layers.dense({units: 1, inputShape: [10]})]
     * });
     * model.compile({optimizer: 'sgd', loss: 'meanSquaredError'});
     * const result = model.evaluate(
     *     tf.ones([8, 10]), tf.ones([8, 1]), {batchSize: 4});
     * result.print();
     * ```
     *
     * @param x `tf.Tensor` of test data, or an `Array` of `tf.Tensor`s if the
     * model has multiple inputs.
     * @param y `tf.Tensor` of target data, or an `Array` of `tf.Tensor`s if the
     * model has multiple outputs.
     * @param args A `ModelEvaluateArgs`, containing optional fields.
     *
     * @return `Scalar` test loss (if the model has a single output and no
     *   metrics) or `Array` of `Scalar`s (if the model has multiple outputs
     *   and/or metrics). The attribute `model.metricsNames`
     *   will give you the display labels for the scalar outputs.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ evaluate(x, y, args = {}) {
        const batchSize = args.batchSize == null ? 32 : args.batchSize;
        (0, $5c897b21a1c3d59d$export$2f80f09f3b9f932e)(batchSize);
        // TODO(cais): Standardize `config.sampleWeights` as well.
        // Validate user data.
        const checkBatchAxis = true;
        const standardizedOuts = this.standardizeUserDataXY(x, y, checkBatchAxis, batchSize);
        try {
            // TODO(cais): If uses `useLearningPhase`, set the corresponding element
            // of the input to 0.
            const ins = standardizedOuts[0].concat(standardizedOuts[1]);
            this.makeTestFunction();
            const f = this.testFunction;
            const testOuts = this.testLoop(f, ins, batchSize, args.verbose, args.steps);
            return (0, $b5cd0926a1c6df1f$export$8366660815493a21)(testOuts);
        } finally{
            (0, $5c897b21a1c3d59d$export$55dac70a20481db3)(standardizedOuts[0], x);
            (0, $5c897b21a1c3d59d$export$55dac70a20481db3)(standardizedOuts[1], y);
        }
    }
    // TODO(cais): Add code snippet below once real dataset objects are
    //   available.
    /**
     * Evaluate model using a dataset object.
     *
     * Note: Unlike `evaluate()`, this method is asynchronous (`async`).
     *
     * @param dataset A dataset object. Its `iterator()` method is expected
     *   to generate a dataset iterator object, the `next()` method of which
     *   is expected to produce data batches for evaluation. The return value
     *   of the `next()` call ought to contain a boolean `done` field and a
     *   `value` field. The `value` field is expected to be an array of two
     *   `tf.Tensor`s or an array of two nested `tf.Tensor` structures. The former
     *   case is for models with exactly one input and one output (e.g.
     *   a sequential model). The latter case is for models with multiple
     *   inputs and/or multiple outputs. Of the two items in the array, the
     *   first is the input feature(s) and the second is the output target(s).
     * @param args A configuration object for the dataset-based evaluation.
     * @returns Loss and metric values as an Array of `Scalar` objects.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ async evaluateDataset(dataset, args) {
        this.makeTestFunction();
        return (0, $5d730fc8c84c48e3$export$56e284faddc3ba42)(this, dataset, args);
    }
    /**
     * Get number of samples provided for training, evaluation or prediction.
     *
     * @param ins Input `tf.Tensor`.
     * @param batchSize Integer batch size, optional.
     * @param steps Total number of steps (batches of samples) before
     * declaring loop finished. Optional.
     * @param stepsName The public API's parameter name for `steps`.
     * @returns Number of samples provided.
     */ checkNumSamples(ins, batchSize, steps, stepsName = 'steps') {
        let numSamples;
        if (steps != null) {
            numSamples = null;
            if (batchSize != null) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`If ${stepsName} is set, batchSize must be null or undefined.` + `Got batchSize = ${batchSize}`);
        } else if (ins != null) {
            if (Array.isArray(ins)) numSamples = ins[0].shape[0];
            else numSamples = ins.shape[0];
        } else throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Either the input data should have a defined shape, or ` + `${stepsName} shoud be specified.`);
        return numSamples;
    }
    /**
     * Execute internal tensors of the model with input data feed.
     * @param inputs Input data feed. Must match the inputs of the model.
     * @param outputs Names of the output tensors to be fetched. Must match
     *   names of the SymbolicTensors that belong to the graph.
     * @returns Fetched values for `outputs`.
     */ execute(inputs, outputs) {
        if (Array.isArray(outputs) && outputs.length === 0) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)('`outputs` is an empty Array, which is not allowed.');
        const outputsIsArray = Array.isArray(outputs);
        const outputNames = outputsIsArray ? outputs : [
            outputs
        ];
        const outputSymbolicTensors = this.retrieveSymbolicTensors(outputNames);
        // Format the input into a FeedDict.
        const feedDict = new (0, $2aacd5aadd0fd9b5$export$1f554ac52b4b6917)();
        if (inputs instanceof (0, $i64bB.Tensor)) inputs = [
            inputs
        ];
        if (Array.isArray(inputs)) {
            if (inputs.length !== this.inputs.length) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`The number of inputs provided (${inputs.length}) ` + `does not match the number of inputs of this model ` + `(${this.inputs.length}).`);
            for(let i = 0; i < this.inputs.length; ++i)feedDict.add(this.inputs[i], inputs[i]);
        } else for (const input of this.inputs){
            const tensorValue = inputs[input.name];
            if (tensorValue == null) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`No value is provided for the model's input ${input.name}`);
            feedDict.add(input, tensorValue);
        }
        // Run execution.
        const executeOutputs = (0, $2aacd5aadd0fd9b5$export$51396ec711da548b)(outputSymbolicTensors, feedDict);
        return outputsIsArray ? executeOutputs : executeOutputs[0];
    }
    /**
     * Retrieve the model's internal symbolic tensors from symbolic-tensor names.
     */ retrieveSymbolicTensors(symbolicTensorNames) {
        const outputSymbolicTensors = (0, $b5cd0926a1c6df1f$export$f24d1f1e6cb42785)(null, symbolicTensorNames.length);
        let outputsRemaining = symbolicTensorNames.length;
        for (const layer of this.layers){
            const layerOutputs = Array.isArray(layer.output) ? layer.output : [
                layer.output
            ];
            const layerOutputNames = layerOutputs.map((output)=>output.name);
            for(let i = 0; i < symbolicTensorNames.length; ++i){
                const index = layerOutputNames.indexOf(symbolicTensorNames[i]);
                if (index !== -1) {
                    outputSymbolicTensors[i] = layerOutputs[index];
                    outputsRemaining--;
                }
                if (outputsRemaining === 0) break;
            }
            if (outputsRemaining === 0) break;
        }
        if (outputsRemaining > 0) {
            const remainingNames = [];
            outputSymbolicTensors.forEach((tensor, i)=>{
                if (tensor == null) remainingNames.push(symbolicTensorNames[i]);
            });
            throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Cannot find SymbolicTensors for output name(s): ` + `${JSON.stringify(remainingNames)}`);
        }
        return outputSymbolicTensors;
    }
    /**
     * Helper method to loop over some data in batches.
     *
     * Porting Note: Not using the functional approach in the Python equivalent
     *   due to the imperative backend.
     * Porting Note: Does not support step mode currently.
     *
     * @param ins: input data
     * @param batchSize: integer batch size.
     * @param verbose: verbosity model
     * @returns: Predictions as `tf.Tensor` (if a single output) or an `Array` of
     *   `tf.Tensor` (if multipe outputs).
     */ predictLoop(ins, batchSize = 32, verbose = false) {
        return $i64bB.tidy(()=>{
            const numSamples = this.checkNumSamples(ins);
            if (verbose) throw new (0, $af476738b120e938$export$e162153238934121)('Verbose predictLoop() is not implemented yet.');
            // Sample-based predictions.
            // Porting Note: Tensor currently does not support sliced assignments as
            //   in numpy, e.g., x[1:3] = y. Therefore we use concatenation while
            //   iterating over the batches.
            const batches = (0, $5c897b21a1c3d59d$export$7ce16f2471062005)(numSamples, batchSize);
            const outsBatches = this.outputs.map((output)=>[]);
            // TODO(cais): Can the scope() be pushed down inside the for loop?
            for(let batchIndex = 0; batchIndex < batches.length; ++batchIndex){
                const batchOuts = $i64bB.tidy(()=>{
                    const batchStart = batches[batchIndex][0];
                    const batchEnd = batches[batchIndex][1];
                    // TODO(cais): Take care of the case of the last element is a flag for
                    //   training/test.
                    const insBatch = (0, $5c897b21a1c3d59d$export$45b6cbb437b1b016)(ins, batchStart, batchEnd);
                    // Construct the feeds for execute();
                    const feeds = [];
                    if (Array.isArray(insBatch)) for(let i = 0; i < insBatch.length; ++i)feeds.push({
                        key: this.inputs[i],
                        value: insBatch[i]
                    });
                    else feeds.push({
                        key: this.inputs[0],
                        value: insBatch
                    });
                    const feedDict = new (0, $2aacd5aadd0fd9b5$export$1f554ac52b4b6917)(feeds);
                    return (0, $2aacd5aadd0fd9b5$export$51396ec711da548b)(this.outputs, feedDict);
                });
                batchOuts.forEach((batchOut, i)=>outsBatches[i].push(batchOut));
            }
            return (0, $b5cd0926a1c6df1f$export$8366660815493a21)(outsBatches.map((batches)=>$i64bB.concat(batches, 0)));
        });
    }
    /**
     * Generates output predictions for the input samples.
     *
     * Computation is done in batches.
     *
     * Note: the "step" mode of predict() is currently not supported.
     *   This is because the TensorFlow.js core backend is imperative only.
     *
     * ```js
     * const model = tf.sequential({
     *   layers: [tf.layers.dense({units: 1, inputShape: [10]})]
     * });
     * model.predict(tf.ones([8, 10]), {batchSize: 4}).print();
     * ```
     *
     * @param x The input data, as a Tensor, or an `Array` of `tf.Tensor`s if
     *   the model has multiple inputs.
     * @param args A `ModelPredictArgs` object containing optional fields.
     *
     * @return Prediction results as a `tf.Tensor`(s).
     *
     * @exception ValueError In case of mismatch between the provided input data
     *   and the model's expectations, or in case a stateful model receives a
     *   number of samples that is not a multiple of the batch size.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ predict(x, args = {}) {
        const xsRank2OrHigher = (0, $5c897b21a1c3d59d$export$b2d45309fc343ee1)(x);
        $c4ed419014cbc39b$var$checkInputData(xsRank2OrHigher, this.inputNames, this.feedInputShapes, false);
        try {
            // TODO(cais): Take care of stateful models.
            //   if (this.stateful) ...
            // TODO(cais): Take care of the learning_phase boolean flag.
            //   if (this.useLearningPhase) ...
            const batchSize = args.batchSize == null ? 32 : args.batchSize;
            (0, $5c897b21a1c3d59d$export$2f80f09f3b9f932e)(batchSize);
            return this.predictLoop(xsRank2OrHigher, batchSize);
        } finally{
            (0, $5c897b21a1c3d59d$export$55dac70a20481db3)(xsRank2OrHigher, x);
        }
    }
    /**
     * Returns predictions for a single batch of samples.
     *
     * ```js
     * const model = tf.sequential({
     *   layers: [tf.layers.dense({units: 1, inputShape: [10]})]
     * });
     * model.predictOnBatch(tf.ones([8, 10])).print();
     * ```
     * @param x: Input samples, as a Tensor (for models with exactly one
     *   input) or an array of Tensors (for models with more than one input).
     * @return Tensor(s) of predictions
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ predictOnBatch(x) {
        $c4ed419014cbc39b$var$checkInputData(x, this.inputNames, this.feedInputShapes, true);
        // TODO(cais): Take care of the learning_phase boolean flag.
        //   if (this.useLearningPhase) ...
        const batchSize = (Array.isArray(x) ? x[0] : x).shape[0];
        return this.predictLoop(x, batchSize);
    }
    standardizeUserDataXY(x, y, checkBatchAxis = true, batchSize) {
        // TODO(cais): Add sampleWeight, classWeight
        if (this.optimizer_ == null) throw new (0, $af476738b120e938$export$4a24a86bdbcf02bb)("You must compile a model before training/testing. Use LayersModel.compile(modelCompileArgs).");
        const outputShapes = [];
        for(let i = 0; i < this.feedOutputShapes.length; ++i){
            const outputShape = this.feedOutputShapes[i];
            const lossFn = this.feedLossFns[i];
            if (lossFn === $7d695629521dc3d5$export$d02551222e9364f0) outputShapes.push(outputShape.slice(0, outputShape.length - 1).concat([
                1
            ]));
            else // Porting Note: Because of strong typing `lossFn` must be a function.
            outputShapes.push(outputShape);
        }
        x = $c4ed419014cbc39b$export$69dd7486f5c87261(x, this.feedInputNames, this.feedInputShapes, false, 'input');
        y = $c4ed419014cbc39b$export$69dd7486f5c87261(y, this.feedOutputNames, outputShapes, false, 'target');
        // TODO(cais): Standardize sampleWeights & classWeights.
        $c4ed419014cbc39b$export$4b125fd48a812392(x, y, null);
        // TODO(cais): Check sampleWeights as well.
        $c4ed419014cbc39b$var$checkLossAndTargetCompatibility(y, this.feedLossFns, this.feedOutputShapes);
        if (this.stateful && batchSize != null && batchSize > 0) {
            if (x[0].shape[0] % batchSize !== 0) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`In a stateful network, you should only pass inputs with a ` + `number of samples that is divisible by the batch size ` + `${batchSize}. Found: ${x[0].shape[0]} sample(s).`);
        }
        return [
            x,
            y
        ];
    }
    async standardizeUserData(x, y, sampleWeight, classWeight, checkBatchAxis = true, batchSize) {
        const [standardXs, standardYs] = this.standardizeUserDataXY(x, y, checkBatchAxis, batchSize);
        // TODO(cais): Handle sampleWeights.
        if (sampleWeight != null) throw new Error('sample weight is not supported yet.');
        let standardSampleWeights = null;
        if (classWeight != null) {
            const classWeights = (0, $8ded3c04f5c1e232$export$9122f8f77cba9cbe)(classWeight, this.outputNames);
            standardSampleWeights = [];
            for(let i = 0; i < classWeights.length; ++i)standardSampleWeights.push(await (0, $8ded3c04f5c1e232$export$cecca6094cb0d869)(standardYs[i], null, classWeights[i]));
        }
        // TODO(cais): Deal with the case of model.stateful == true.
        return [
            standardXs,
            standardYs,
            standardSampleWeights
        ];
    }
    /**
     * Loop over some test data in batches.
     * @param f A Function returning a list of tensors.
     * @param ins Array of tensors to be fed to `f`.
     * @param batchSize Integer batch size or `null` / `undefined`.
     * @param verbose verbosity mode.
     * @param steps Total number of steps (batches of samples) before
     * declaring test finished. Ignored with the default value of `null` /
     * `undefined`.
     * @returns Array of Scalars.
     */ testLoop(f, ins, batchSize, verbose = 0, steps) {
        return $i64bB.tidy(()=>{
            const numSamples = this.checkNumSamples(ins, batchSize, steps, 'steps');
            const outs = [];
            if (verbose > 0) throw new (0, $af476738b120e938$export$e162153238934121)('Verbose mode is not implemented yet.');
            // TODO(cais): Use `indicesForConversionToDense' to prevent slow down.
            if (steps != null) throw new (0, $af476738b120e938$export$e162153238934121)('steps mode in testLoop() is not implemented yet');
            else {
                const batches = (0, $5c897b21a1c3d59d$export$7ce16f2471062005)(numSamples, batchSize);
                const indexArray = (0, $i64bB.tensor1d)((0, $edee0645f45d9428$export$d02631cccf789723)(0, numSamples));
                for(let batchIndex = 0; batchIndex < batches.length; ++batchIndex){
                    const batchStart = batches[batchIndex][0];
                    const batchEnd = batches[batchIndex][1];
                    const batchIds = $33b0bdd0433db936$export$4f266636a9634575(indexArray, batchStart, batchEnd - batchStart);
                    // TODO(cais): In ins, train flag can be a number, instead of an
                    //   Tensor? Do we need to handle this in tfjs-layers?
                    const insBatch = (0, $5c897b21a1c3d59d$export$4a7d2c6b9b0d590)(ins, batchIds);
                    const batchOuts = f(insBatch);
                    if (batchIndex === 0) for(let i = 0; i < batchOuts.length; ++i)outs.push((0, $i64bB.scalar)(0));
                    for(let i = 0; i < batchOuts.length; ++i){
                        const batchOut = batchOuts[i];
                        outs[i] = $i64bB.add(outs[i], $i64bB.mul(batchEnd - batchStart, batchOut));
                    }
                }
                for(let i = 0; i < outs.length; ++i)outs[i] = $i64bB.div(outs[i], numSamples);
            }
            return outs;
        });
    }
    getDedupedMetricsNames() {
        const outLabels = this.metricsNames;
        // Rename duplicated metrics names (can happen with an output layer
        // shared among multiple dataflows).
        const dedupedOutLabels = [];
        for(let i = 0; i < outLabels.length; ++i){
            const label = outLabels[i];
            let newLabel = label;
            if ((0, $b5cd0926a1c6df1f$export$85b9a36db797e02b)(outLabels, label) > 1) {
                const dupIndex = (0, $b5cd0926a1c6df1f$export$85b9a36db797e02b)(outLabels.slice(0, i), label);
                newLabel += `_${dupIndex}`;
            }
            dedupedOutLabels.push(newLabel);
        }
        return dedupedOutLabels;
    }
    /**
     * Creates a function that performs the following actions:
     *
     * 1. computes the losses
     * 2. sums them to get the total loss
     * 3. call the optimizer computes the gradients of the LayersModel's
     *    trainable weights w.r.t. the total loss and update the variables
     * 4. calculates the metrics
     * 5. returns the values of the losses and metrics.
     */ makeTrainFunction() {
        return (data)=>{
            const lossValues = [];
            const inputs = data.slice(0, this.inputs.length);
            const targets = data.slice(this.inputs.length, this.inputs.length + this.outputs.length);
            const sampleWeights = data.slice(this.inputs.length + this.outputs.length, this.inputs.length + this.outputs.length * 2);
            const metricsValues = [];
            // Create a function that computes the total loss based on the
            // inputs. This function is used for obtaining gradients through
            // backprop.
            const totalLossFunction = ()=>{
                const feeds = [];
                for(let i = 0; i < this.inputs.length; ++i)feeds.push({
                    key: this.inputs[i],
                    value: inputs[i]
                });
                const feedDict = new (0, $2aacd5aadd0fd9b5$export$1f554ac52b4b6917)(feeds);
                const outputs = (0, $2aacd5aadd0fd9b5$export$51396ec711da548b)(this.outputs, feedDict, {
                    'training': true
                });
                // TODO(cais): Take care of the case of multiple outputs from a
                //   single layer?
                let totalLoss;
                for(let i = 0; i < this.lossFunctions.length; ++i){
                    const lossFunction = this.lossFunctions[i];
                    let loss = lossFunction(targets[i], outputs[i]);
                    if (sampleWeights[i] != null) loss = (0, $8ded3c04f5c1e232$export$23bdc4cea2e28782)(loss, sampleWeights[i]);
                    // TODO(cais): push Scalar instead.
                    const meanLoss = $i64bB.mean(loss);
                    // TODO(cais): Use a scope() instead, to avoid ownership.
                    lossValues.push(meanLoss);
                    if (i === 0) totalLoss = loss;
                    else totalLoss = $i64bB.add(totalLoss, loss);
                }
                // Compute the metrics.
                // TODO(cais): These should probably be calculated outside
                //   totalLossFunction to benefit speed?
                for(let i = 0; i < this.metricsTensors.length; ++i){
                    let weightedMetric;
                    if (this.outputs.length > 1 && i < this.outputs.length) weightedMetric = lossValues[i];
                    else {
                        const metric = this.metricsTensors[i][0];
                        const outputIndex = this.metricsTensors[i][1];
                        weightedMetric = $i64bB.mean(metric(targets[outputIndex], outputs[outputIndex]));
                    }
                    $i64bB.keep(weightedMetric);
                    // TODO(cais): Use a scope() instead, to avoid ownership.
                    metricsValues.push(weightedMetric);
                }
                totalLoss = $i64bB.mean(totalLoss);
                // Add regularizer penalties.
                this.calculateLosses().forEach((regularizerLoss)=>{
                    totalLoss = $i64bB.add(totalLoss, regularizerLoss);
                });
                return totalLoss;
            };
            const variables = this.collectedTrainableWeights.map((param)=>param.read());
            const returnCost = true;
            const totalLossValue = this.optimizer_.minimize(totalLossFunction, returnCost, variables);
            return [
                totalLossValue
            ].concat(metricsValues);
        };
    }
    /**
     * Create a function which, when invoked with an array of `tf.Tensor`s as a
     * batch of inputs, returns the prespecified loss and metrics of the model
     * under the batch of input data.
     */ makeTestFunction() {
        this.testFunction = (data)=>{
            return $i64bB.tidy(()=>{
                const valOutputs = [];
                let totalLoss;
                const inputs = data.slice(0, this.inputs.length);
                const targets = data.slice(this.inputs.length, this.inputs.length + this.outputs.length);
                const feeds = [];
                for(let i = 0; i < this.inputs.length; ++i)feeds.push({
                    key: this.inputs[i],
                    value: inputs[i]
                });
                const feedDict = new (0, $2aacd5aadd0fd9b5$export$1f554ac52b4b6917)(feeds);
                const outputs = (0, $2aacd5aadd0fd9b5$export$51396ec711da548b)(this.outputs, feedDict);
                // Compute total loss.
                for(let i = 0; i < this.lossFunctions.length; ++i){
                    const lossFunction = this.lossFunctions[i];
                    // TODO(cais): Add sample weighting and replace the simple
                    // averaging.
                    const loss = $i64bB.mean(lossFunction(targets[i], outputs[i]));
                    if (i === 0) totalLoss = loss;
                    else totalLoss = $i64bB.add(totalLoss, loss);
                    valOutputs.push(totalLoss);
                }
                // Compute the metrics.
                for(let i = 0; i < this.metricsTensors.length; ++i){
                    const metric = this.metricsTensors[i][0];
                    const outputIndex = this.metricsTensors[i][1];
                    // TODO(cais): Replace K.mean() with a proper weighting function.
                    const meanMetric = $i64bB.mean(metric(targets[outputIndex], outputs[outputIndex]));
                    valOutputs.push(meanMetric);
                }
                return valOutputs;
            });
        };
    }
    /**
     * Trains the model for a fixed number of epochs (iterations on a
     * dataset).
     *
     * ```js
     * const model = tf.sequential({
     *     layers: [tf.layers.dense({units: 1, inputShape: [10]})]
     * });
     * model.compile({optimizer: 'sgd', loss: 'meanSquaredError'});
     * for (let i = 1; i < 5 ; ++i) {
     *   const h = await model.fit(tf.ones([8, 10]), tf.ones([8, 1]), {
     *       batchSize: 4,
     *       epochs: 3
     *   });
     *   console.log("Loss after Epoch " + i + " : " + h.history.loss[0]);
     * }
     * ```
     *
     * @param x `tf.Tensor` of training data, or an array of `tf.Tensor`s if the
     * model has multiple inputs. If all inputs in the model are named, you
     * can also pass a dictionary mapping input names to `tf.Tensor`s.
     * @param y `tf.Tensor` of target (label) data, or an array of `tf.Tensor`s if
     * the model has multiple outputs. If all outputs in the model are named,
     * you can also pass a dictionary mapping output names to `tf.Tensor`s.
     * @param args A `ModelFitArgs`, containing optional fields.
     *
     * @return A `History` instance. Its `history` attribute contains all
     *   information collected during training.
     *
     * @exception ValueError In case of mismatch between the provided input
     * data and what the model expects.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ async fit(x, y, args = {}) {
        if (this.isTraining) throw new Error('Cannot start training because another fit() call is ongoing.');
        this.isTraining = true;
        let inputs;
        let targets;
        let originalInputs;
        let originalTargets;
        let inputValX;
        let inputValY;
        let valX;
        let valY;
        let sampleWeights;
        try {
            const batchSize = args.batchSize == null ? 32 : args.batchSize;
            (0, $5c897b21a1c3d59d$export$2f80f09f3b9f932e)(batchSize);
            // Validate user data.
            // TODO(cais): Support sampleWeight.
            const checkBatchAxis = false;
            const standardizedOuts = await this.standardizeUserData(x, y, args.sampleWeight, args.classWeight, checkBatchAxis, batchSize);
            inputs = standardizedOuts[0];
            targets = standardizedOuts[1];
            sampleWeights = standardizedOuts[2];
            // Prepare validation data.
            let doValidation = false;
            let valIns;
            if (args.validationData != null && args.validationData.length > 0) {
                doValidation = true;
                if (args.validationData.length === 2) {
                    // config.validationData consists of valX and valY.
                    inputValX = args.validationData[0];
                    inputValY = args.validationData[1];
                } else if (args.validationData.length === 3) throw new (0, $af476738b120e938$export$e162153238934121)('validationData including sample weights is not supported yet.');
                else throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`When passing validation data, it must contain 2 (valX, valY) ` + `or 3 (valX, valY, valSampleWeight) items; ` + `${args.validationData} is invalid.`);
                const checkBatchAxis = true;
                const valStandardized = await this.standardizeUserData(inputValX, inputValY, null, /** Unused sample weights. */ null, /** Unused class weights. */ checkBatchAxis, batchSize);
                valX = valStandardized[0];
                valY = valStandardized[1];
                valIns = valX.concat(valY);
            // TODO(cais): Add useLearningPhase data properly.
            } else if (args.validationSplit != null && args.validationSplit > 0 && args.validationSplit < 1) {
                doValidation = true;
                // Porting Note: In tfjs-layers, inputs[0] is always a Tensor.
                const splitAt = Math.floor(inputs[0].shape[0] * (1 - args.validationSplit));
                const originalBatchSize = inputs[0].shape[0];
                valX = (0, $5c897b21a1c3d59d$export$45b6cbb437b1b016)(inputs, splitAt, originalBatchSize);
                originalInputs = inputs;
                inputs = (0, $5c897b21a1c3d59d$export$45b6cbb437b1b016)(inputs, 0, splitAt);
                valY = (0, $5c897b21a1c3d59d$export$45b6cbb437b1b016)(targets, splitAt, originalBatchSize);
                originalTargets = targets;
                targets = (0, $5c897b21a1c3d59d$export$45b6cbb437b1b016)(targets, 0, splitAt);
                // TODO(cais): Once sampleWeights becomes available, slice it to get
                //   valSampleWeights.
                valIns = valX.concat(valY);
            // TODO(cais): Add useLearningPhase data properly.
            } else if (args.validationSteps != null) doValidation = true;
            const ins = inputs.concat(targets).concat(sampleWeights);
            this.checkTrainableWeightsConsistency();
            // TODO(cais): Handle use_learning_phase and learning_phase?
            // Porting Note: Here we see a key deviation of tfjs-layers from
            // Keras.
            //  Due to the imperative nature of tfjs-layers' backend (tfjs-core),
            //  we do not construct symbolic computation graphs to embody the
            //  training process. Instead, we define a function that performs the
            //  training action. In PyKeras, the data (inputs and targets) are fed
            //  through graph placeholders. In tfjs-layers, the data are fed as
            //  function arguments. Since the function are defined below in the
            //  scope, we don't have equivalents of PyKeras's
            //  `_make_train_funciton`.
            const trainFunction = this.makeTrainFunction();
            const outLabels = this.getDedupedMetricsNames();
            let valFunction;
            let callbackMetrics;
            if (doValidation) {
                this.makeTestFunction();
                valFunction = this.testFunction;
                callbackMetrics = outLabels.slice().concat(outLabels.map((n)=>'val_' + n));
            } else {
                valFunction = null;
                valIns = [];
                callbackMetrics = outLabels.slice();
            }
            const callbacks = (0, $65144a7424fc1c41$export$8ea03bd28ba7b2ff)(args.callbacks, args.yieldEvery);
            const out = await this.fitLoop(trainFunction, ins, outLabels, batchSize, args.epochs, args.verbose, callbacks, valFunction, valIns, args.shuffle, callbackMetrics, args.initialEpoch, null, null);
            return out;
        } finally{
            this.isTraining = false;
            // Memory clean up.
            (0, $5c897b21a1c3d59d$export$55dac70a20481db3)(inputs, x);
            (0, $5c897b21a1c3d59d$export$55dac70a20481db3)(targets, y);
            (0, $5c897b21a1c3d59d$export$55dac70a20481db3)(originalInputs, x);
            (0, $5c897b21a1c3d59d$export$55dac70a20481db3)(originalTargets, y);
            (0, $5c897b21a1c3d59d$export$55dac70a20481db3)(valX, inputValX);
            (0, $5c897b21a1c3d59d$export$55dac70a20481db3)(valY, inputValY);
            if (sampleWeights != null) $i64bB.dispose(sampleWeights);
        }
    // TODO(cais): Add value to outLabels.
    }
    /**
     * Abstract fit function for `f(ins)`.
     * @param f A Function returning a list of tensors. For training, this
     *   function is expected to perform the updates to the variables.
     * @param ins List of tensors to be fed to `f`.
     * @param outLabels List of strings, display names of the outputs of `f`.
     * @param batchSize Integer batch size or `== null` if unknown. Default : 32.
     * @param epochs Number of times to iterate over the data. Default : 1.
     * @param verbose Verbosity mode: 0, 1, or 2. Default: 1.
     * @param callbacks List of callbacks to be called during training.
     * @param valF Function to call for validation.
     * @param valIns List of tensors to be fed to `valF`.
     * @param shuffle Whether to shuffle the data at the beginning of every
     * epoch. Default : true.
     * @param callbackMetrics List of strings, the display names of the metrics
     *   passed to the callbacks. They should be the concatenation of the
     *   display names of the outputs of `f` and the list of display names
     *   of the outputs of `valF`.
     * @param initialEpoch Epoch at which to start training (useful for
     *   resuming a previous training run). Default : 0.
     * @param stepsPerEpoch Total number of steps (batches on samples) before
     *   declaring one epoch finished and starting the next epoch. Ignored with
     *   the default value of `undefined` or `null`.
     * @param validationSteps Number of steps to run validation for (only if
     *   doing validation from data tensors). Not applicable for tfjs-layers.
     * @returns A `History` object.
     */ async fitLoop(f, ins, outLabels, batchSize, epochs, verbose, callbacks, valF, valIns, shuffle, callbackMetrics, initialEpoch, stepsPerEpoch, validationSteps) {
        if (batchSize == null) batchSize = 32;
        if (epochs == null) epochs = 1;
        if (shuffle == null) shuffle = true;
        if (initialEpoch == null) initialEpoch = 0;
        // TODO(cais): Change const to let below when implementing validation.
        let doValidation = false;
        if (valF != null && valIns != null) doValidation = true;
        if (validationSteps != null) {
            doValidation = true;
            if (stepsPerEpoch == null) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)("Can only use `validationSteps` when doing step-wise training, i.e., `stepsPerEpoch` must be set.");
        }
        const numTrainSamples = this.checkNumSamples(ins, batchSize, stepsPerEpoch, 'steps_per_epoch');
        let indexArray;
        if (numTrainSamples != null) indexArray = (0, $edee0645f45d9428$export$d02631cccf789723)(0, numTrainSamples);
        if (verbose == null) verbose = 1;
        const { callbackList: callbackList, history: history } = (0, $65144a7424fc1c41$export$18b2cd3db6266dd9)(callbacks, verbose, epochs, initialEpoch, numTrainSamples, stepsPerEpoch, batchSize, doValidation, callbackMetrics);
        callbackList.setModel(this);
        this.history = history;
        await callbackList.onTrainBegin();
        this.stopTraining_ = false;
        // TODO(cais): Take care of callbacks.validation_data as in PyKeras.
        // TODO(cais): Pre-convert feeds for performance as in PyKeras.
        for(let epoch = initialEpoch; epoch < epochs; ++epoch){
            await callbackList.onEpochBegin(epoch);
            const epochLogs = {};
            if (stepsPerEpoch != null) throw new (0, $af476738b120e938$export$e162153238934121)('stepsPerEpoch mode is not implemented yet.');
            else {
                if (shuffle === 'batch') throw new (0, $af476738b120e938$export$e162153238934121)("batch shuffling is not implemneted yet");
                else if (shuffle) (0, $i64bB.util).shuffle(indexArray);
                // Convert the potentially shuffled indices to Tensor1D, to avoid the
                // cost of repeated creation of Array1Ds later on.
                const epochIndexArray1D = (0, $i64bB.tensor1d)(indexArray);
                const batches = (0, $5c897b21a1c3d59d$export$7ce16f2471062005)(numTrainSamples, batchSize);
                for(let batchIndex = 0; batchIndex < batches.length; ++batchIndex){
                    const batchLogs = {};
                    await callbackList.onBatchBegin(batchIndex, batchLogs);
                    $i64bB.tidy(()=>{
                        const batchStart = batches[batchIndex][0];
                        const batchEnd = batches[batchIndex][1];
                        const batchIds = $33b0bdd0433db936$export$4f266636a9634575(epochIndexArray1D, batchStart, batchEnd - batchStart);
                        batchLogs['batch'] = batchIndex;
                        batchLogs['size'] = batchEnd - batchStart;
                        // TODO(cais): In ins, train flag can be a number, instead of an
                        //   Tensor? Do we need to handle this in tfjs-layers?
                        const insBatch = (0, $5c897b21a1c3d59d$export$4a7d2c6b9b0d590)(ins, batchIds);
                        const outs = f(insBatch);
                        for(let i = 0; i < outLabels.length; ++i){
                            const label = outLabels[i];
                            const out = outs[i];
                            batchLogs[label] = out;
                            $i64bB.keep(out);
                        // TODO(cais): Use scope() to avoid ownership.
                        }
                        if (batchIndex === batches.length - 1) {
                            if (doValidation) {
                                const valOuts = this.testLoop(valF, valIns, batchSize);
                                // Porting Notes: In tfjs-layers, valOuts is always an Array.
                                for(let i = 0; i < outLabels.length; ++i){
                                    const label = outLabels[i];
                                    const out = valOuts[i];
                                    $i64bB.keep(out);
                                    // TODO(cais): Use scope() to avoid ownership.
                                    epochLogs['val_' + label] = out;
                                }
                            }
                        }
                    });
                    await callbackList.onBatchEnd(batchIndex, batchLogs);
                    (0, $60719b6320089bc4$export$f4920d82017cd044)(batchLogs);
                    if (this.stopTraining_) break;
                // TODO(cais): return outs as list of Tensor.
                }
                epochIndexArray1D.dispose();
            }
            // TODO(cais): Run validation at the end of the epoch.
            await callbackList.onEpochEnd(epoch, epochLogs);
            if (this.stopTraining_) break;
        }
        await callbackList.onTrainEnd();
        await this.history.syncData();
        return this.history;
    }
    // TODO(cais): Add code snippet below when it's possible to instantiate
    //   actual dataset objects.
    /**
     * Trains the model using a dataset object.
     *
     * @param dataset A dataset object. Its `iterator()` method is expected
     *   to generate a dataset iterator object, the `next()` method of which
     *   is expected to produce data batches for training. The return value
     *   of the `next()` call ought to contain a boolean `done` field and a
     *   `value` field. The `value` field is expected to be an array of two
     *   `tf.Tensor`s or an array of two nested `tf.Tensor` structures. The former
     *   case is for models with exactly one input and one output (e.g.
     *   a sequential model). The latter case is for models with multiple
     *   inputs and/or multiple outputs.
     *   Of the two items in the array, the first is the input feature(s) and
     *   the second is the output target(s).
     * @param args A `ModelFitDatasetArgs`, containing optional fields.
     *
     * @return A `History` instance. Its `history` attribute contains all
     *   information collected during training.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ async fitDataset(dataset, args) {
        return (0, $5d730fc8c84c48e3$export$4e883c052383550c)(this, dataset, args);
    }
    /**
     * Runs a single gradient update on a single batch of data.
     *
     * This method differs from `fit()` and `fitDataset()` in the following
     * regards:
     *   - It operates on exactly one batch of data.
     *   - It returns only the loss and metric values, instead of
     *     returning the batch-by-batch loss and metric values.
     *   - It doesn't support fine-grained options such as verbosity and
     *     callbacks.
     *
     * @param x Input data. It could be one of the following:
     *   - A `tf.Tensor`, or an Array of `tf.Tensor`s (in case the model has
     *     multiple inputs).
     *   - An Object mapping input names to corresponding `tf.Tensor` (if the
     *     model has named inputs).
     * @param y Target data. It could be either a `tf.Tensor` or multiple
     *   `tf.Tensor`s. It should be consistent with `x`.
     * @returns Training loss or losses (in case the model has
     *   multiple outputs), along with metrics (if any), as numbers.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ async trainOnBatch(x, y) {
        // TODO(cais): Support sampleWeight and classWeight.
        // TODO(cais): Support Dataset objects.
        const standardizeOut = await this.standardizeUserData(x, y);
        const inputs = standardizeOut[0];
        const targets = standardizeOut[1];
        const trainFunction = this.makeTrainFunction();
        const losses = trainFunction(inputs.concat(targets));
        const lossValues = [];
        for (const loss of losses){
            const v = await loss.data();
            lossValues.push(v[0]);
        }
        $i64bB.dispose(losses);
        (0, $5c897b21a1c3d59d$export$55dac70a20481db3)(standardizeOut[0], x);
        (0, $5c897b21a1c3d59d$export$55dac70a20481db3)(standardizeOut[1], y);
        return (0, $b5cd0926a1c6df1f$export$8366660815493a21)(lossValues);
    }
    /**
     * Extract weight values of the model.
     *
     * @param config: An instance of `io.SaveConfig`, which specifies
     * model-saving options such as whether only trainable weights are to be
     * saved.
     * @returns A `NamedTensorMap` mapping original weight names (i.e.,
     *   non-uniqueified weight names) to their values.
     */ getNamedWeights(config) {
        const namedWeights = [];
        const trainableOnly = config != null && config.trainableOnly;
        const weights = trainableOnly ? this.trainableWeights : this.weights;
        const weightValues = this.getWeights(trainableOnly);
        for(let i = 0; i < weights.length; ++i){
            if (trainableOnly && !weights[i].trainable) continue;
            namedWeights.push({
                name: weights[i].originalName,
                tensor: weightValues[i]
            });
        }
        return namedWeights;
    }
    /**
     * Setter used for force stopping of LayersModel.fit() (i.e., training).
     *
     * Example:
     *
     * ```js
     * const input = tf.input({shape: [10]});
     * const output = tf.layers.dense({units: 1}).apply(input);
     * const model = tf.model({inputs: [input], outputs: [output]});
     * model.compile({loss: 'meanSquaredError', optimizer: 'sgd'});
     * const xs = tf.ones([8, 10]);
     * const ys = tf.zeros([8, 1]);
     *
     * const history = await model.fit(xs, ys, {
     *   epochs: 10,
     *   callbacks: {
     *     onEpochEnd: async (epoch, logs) => {
     *       if (epoch === 2) {
     *         model.stopTraining = true;
     *       }
     *     }
     *   }
     * });
     *
     * // There should be only 3 values in the loss array, instead of 10
     * values,
     * // due to the stopping after 3 epochs.
     * console.log(history.history.loss);
     * ```
     */ set stopTraining(stop) {
        this.stopTraining_ = stop;
    }
    get stopTraining() {
        return this.stopTraining_;
    }
    get optimizer() {
        return this.optimizer_;
    }
    set optimizer(optimizer) {
        if (this.optimizer_ !== optimizer) {
            this.optimizer_ = optimizer;
            this.isOptimizerOwned = false;
        }
    }
    dispose() {
        const result = super.dispose();
        if (result.refCountAfterDispose === 0 && this.optimizer != null && this.isOptimizerOwned) {
            const numTensorsBeforeOptmizerDisposal = $i64bB.memory().numTensors;
            this.optimizer_.dispose();
            result.numDisposedVariables += numTensorsBeforeOptmizerDisposal - $i64bB.memory().numTensors;
        }
        return result;
    }
    getLossIdentifiers() {
        let lossNames;
        if (typeof this.loss === 'string') lossNames = (0, $b5cd0926a1c6df1f$export$cc8b315fc368b20a)(this.loss);
        else if (Array.isArray(this.loss)) {
            for (const loss of this.loss){
                if (typeof loss !== 'string') throw new Error('Serialization of non-string loss is not supported.');
            }
            lossNames = this.loss.map((name)=>(0, $b5cd0926a1c6df1f$export$cc8b315fc368b20a)(name));
        } else {
            const outputNames = Object.keys(this.loss);
            lossNames = {};
            const losses = this.loss;
            for (const outputName of outputNames){
                if (typeof losses[outputName] === 'string') lossNames[outputName] = (0, $b5cd0926a1c6df1f$export$cc8b315fc368b20a)(losses[outputName]);
                else throw new Error('Serialization of non-string loss is not supported.');
            }
        }
        return lossNames;
    }
    getMetricIdentifiers() {
        if (typeof this.metrics === 'string' || typeof this.metrics === 'function') return [
            (0, $b5cd0926a1c6df1f$export$cc8b315fc368b20a)($7612942a5d22baee$export$9fb8307a5eeccc76(this.metrics))
        ];
        else if (Array.isArray(this.metrics)) return this.metrics.map((metric)=>(0, $b5cd0926a1c6df1f$export$cc8b315fc368b20a)($7612942a5d22baee$export$9fb8307a5eeccc76(metric)));
        else {
            const metricsIdentifiers = {};
            for(const key in this.metrics)metricsIdentifiers[key] = (0, $b5cd0926a1c6df1f$export$cc8b315fc368b20a)($7612942a5d22baee$export$9fb8307a5eeccc76(this.metrics[key]));
            return metricsIdentifiers;
        }
    }
    getTrainingConfig() {
        return {
            loss: this.getLossIdentifiers(),
            metrics: this.getMetricIdentifiers(),
            optimizer_config: {
                class_name: this.optimizer.getClassName(),
                config: this.optimizer.getConfig()
            }
        };
    // TODO(cais): Add weight_metrics when they are supported.
    // TODO(cais): Add sample_weight_mode when it's supported.
    // TODO(cais): Add loss_weights when it's supported.
    }
    loadTrainingConfig(trainingConfig) {
        if (trainingConfig.weighted_metrics != null) throw new Error('Loading weight_metrics is not supported yet.');
        if (trainingConfig.loss_weights != null) throw new Error('Loading loss_weights is not supported yet.');
        if (trainingConfig.sample_weight_mode != null) throw new Error('Loading sample_weight_mode is not supported yet.');
        const tsConfig = (0, $d02abf89bc2c0202$export$c0fd0796420499e6)(trainingConfig.optimizer_config);
        const optimizer = (0, $61cac79a6a78765b$export$efcd34ab6248d3cd)(tsConfig);
        let loss;
        if (typeof trainingConfig.loss === 'string') loss = (0, $b5cd0926a1c6df1f$export$86f54f62aa7a7514)(trainingConfig.loss);
        else if (Array.isArray(trainingConfig.loss)) loss = trainingConfig.loss.map((lossEntry)=>(0, $b5cd0926a1c6df1f$export$86f54f62aa7a7514)(lossEntry));
        else if (trainingConfig.loss != null) {
            loss = {};
            for(const key in trainingConfig.loss)loss[key] = (0, $b5cd0926a1c6df1f$export$86f54f62aa7a7514)(trainingConfig.loss[key]);
        }
        let metrics;
        if (Array.isArray(trainingConfig.metrics)) metrics = trainingConfig.metrics.map((metric)=>(0, $b5cd0926a1c6df1f$export$86f54f62aa7a7514)(metric));
        else if (trainingConfig.metrics != null) {
            metrics = {};
            for(const key in trainingConfig.metrics)metrics[key] = (0, $b5cd0926a1c6df1f$export$86f54f62aa7a7514)(trainingConfig.metrics[key]);
        }
        this.compile({
            loss: loss,
            metrics: metrics,
            optimizer: optimizer
        });
    }
    /**
     * Save the configuration and/or weights of the LayersModel.
     *
     * An `IOHandler` is an object that has a `save` method of the proper
     * signature defined. The `save` method manages the storing or
     * transmission of serialized data ("artifacts") that represent the
     * model's topology and weights onto or via a specific medium, such as
     * file downloads, local storage, IndexedDB in the web browser and HTTP
     * requests to a server. TensorFlow.js provides `IOHandler`
     * implementations for a number of frequently used saving mediums, such as
     * `tf.io.browserDownloads` and `tf.io.browserLocalStorage`. See `tf.io`
     * for more details.
     *
     * This method also allows you to refer to certain types of `IOHandler`s
     * as URL-like string shortcuts, such as 'localstorage://' and
     * 'indexeddb://'.
     *
     * Example 1: Save `model`'s topology and weights to browser [local
     * storage](https://developer.mozilla.org/en-US/docs/Web/API/Window/localStorage);
     * then load it back.
     *
     * ```js
     * const model = tf.sequential(
     *     {layers: [tf.layers.dense({units: 1, inputShape: [3]})]});
     * console.log('Prediction from original model:');
     * model.predict(tf.ones([1, 3])).print();
     *
     * const saveResults = await model.save('localstorage://my-model-1');
     *
     * const loadedModel = await tf.loadLayersModel('localstorage://my-model-1');
     * console.log('Prediction from loaded model:');
     * loadedModel.predict(tf.ones([1, 3])).print();
     * ```
     *
     * Example 2. Saving `model`'s topology and weights to browser
     * [IndexedDB](https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API);
     * then load it back.
     *
     * ```js
     * const model = tf.sequential(
     *     {layers: [tf.layers.dense({units: 1, inputShape: [3]})]});
     * console.log('Prediction from original model:');
     * model.predict(tf.ones([1, 3])).print();
     *
     * const saveResults = await model.save('indexeddb://my-model-1');
     *
     * const loadedModel = await tf.loadLayersModel('indexeddb://my-model-1');
     * console.log('Prediction from loaded model:');
     * loadedModel.predict(tf.ones([1, 3])).print();
     * ```
     *
     * Example 3. Saving `model`'s topology and weights as two files
     * (`my-model-1.json` and `my-model-1.weights.bin`) downloaded from
     * browser.
     *
     * ```js
     * const model = tf.sequential(
     *     {layers: [tf.layers.dense({units: 1, inputShape: [3]})]});
     * const saveResults = await model.save('downloads://my-model-1');
     * ```
     *
     * Example 4. Send  `model`'s topology and weights to an HTTP server.
     * See the documentation of `tf.io.http` for more details
     * including specifying request parameters and implementation of the
     * server.
     *
     * ```js
     * const model = tf.sequential(
     *     {layers: [tf.layers.dense({units: 1, inputShape: [3]})]});
     * const saveResults = await model.save('http://my-server/model/upload');
     * ```
     *
     * @param handlerOrURL An instance of `IOHandler` or a URL-like,
     * scheme-based string shortcut for `IOHandler`.
     * @param config Options for saving the model.
     * @returns A `Promise` of `SaveResult`, which summarizes the result of
     * the saving, such as byte sizes of the saved artifacts for the model's
     *   topology and weight values.
     *
     * @doc {heading: 'Models', subheading: 'Classes', ignoreCI: true}
     */ async save(handlerOrURL, config) {
        if (typeof handlerOrURL === 'string') {
            const handlers = (0, $i64bB.io).getSaveHandlers(handlerOrURL);
            if (handlers.length === 0) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Cannot find any save handlers for URL '${handlerOrURL}'`);
            else if (handlers.length > 1) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Found more than one (${handlers.length}) save handlers for ` + `URL '${handlerOrURL}'`);
            handlerOrURL = handlers[0];
        }
        if (handlerOrURL.save == null) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)("LayersModel.save() cannot proceed because the IOHandler provided does not have the `save` attribute defined.");
        const weightDataAndSpecs = await (0, $i64bB.io).encodeWeights(this.getNamedWeights(config));
        const returnString = false;
        const unusedArg = null;
        const modelConfig = this.toJSON(unusedArg, returnString);
        const modelArtifacts = {
            modelTopology: modelConfig,
            format: $c4ed419014cbc39b$var$LAYERS_MODEL_FORMAT_NAME,
            generatedBy: `TensorFlow.js tfjs-layers v${(0, $3e25243b0afd8066$export$83d89fbfd8236492)}`,
            convertedBy: null
        };
        const includeOptimizer = config == null ? false : config.includeOptimizer;
        if (includeOptimizer && this.optimizer != null) {
            modelArtifacts.trainingConfig = this.getTrainingConfig();
            const weightType = 'optimizer';
            const { data: optimizerWeightData, specs: optimizerWeightSpecs } = await (0, $i64bB.io).encodeWeights(await this.optimizer.getWeights(), weightType);
            weightDataAndSpecs.specs.push(...optimizerWeightSpecs);
            weightDataAndSpecs.data = (0, $i64bB.io).concatenateArrayBuffers([
                weightDataAndSpecs.data,
                optimizerWeightData
            ]);
        }
        if (this.userDefinedMetadata != null) {
            // Check serialized size of user-defined metadata.
            const checkSize = true;
            (0, $7f72a7225653b029$export$5c1c8db6517969f5)(this.userDefinedMetadata, this.name, checkSize);
            modelArtifacts.userDefinedMetadata = this.userDefinedMetadata;
        }
        modelArtifacts.weightData = weightDataAndSpecs.data;
        modelArtifacts.weightSpecs = weightDataAndSpecs.specs;
        return handlerOrURL.save(modelArtifacts);
    }
    /**
     * Set user-defined metadata.
     *
     * The set metadata will be serialized together with the topology
     * and weights of the model during `save()` calls.
     *
     * @param setUserDefinedMetadata
     */ setUserDefinedMetadata(userDefinedMetadata) {
        (0, $7f72a7225653b029$export$5c1c8db6517969f5)(userDefinedMetadata, this.name);
        this.userDefinedMetadata = userDefinedMetadata;
    }
    /**
     * Get user-defined metadata.
     *
     * The metadata is supplied via one of the two routes:
     *   1. By calling `setUserDefinedMetadata()`.
     *   2. Loaded during model loading (if the model is constructed
     *      via `tf.loadLayersModel()`.)
     *
     * If no user-defined metadata is available from either of the
     * two routes, this function will return `undefined`.
     */ getUserDefinedMetadata() {
        return this.userDefinedMetadata;
    }
}
// The class name is 'Model' rather than 'LayersModel' for backwards
// compatibility since this class name shows up in the serialization format.
/** @nocollapse */ $c4ed419014cbc39b$export$f8e130845653852b.className = 'Model';
(0, $i64bB.serialization).registerClass($c4ed419014cbc39b$export$f8e130845653852b);
/**
 * A `tf.Functional` is an alias to `tf.LayersModel`.
 *
 * See also:
 *   `tf.LayersModel`, `tf.Sequential`, `tf.loadLayersModel`.
 */ /** @doc {heading: 'Models', subheading: 'Classes'} */ class $c4ed419014cbc39b$export$ab287cb77f6ba7e extends $c4ed419014cbc39b$export$f8e130845653852b {
}
$c4ed419014cbc39b$export$ab287cb77f6ba7e.className = 'Functional';
(0, $i64bB.serialization).registerClass($c4ed419014cbc39b$export$ab287cb77f6ba7e);


/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /* Original source keras/models.py */ 
var $i64bB = parcelRequire("i64bB");









async function $dd5f24360d756fd3$export$6e76de3ed4e5bd6a(modelAndWeightsConfig, customObjects) {
    if (!('modelTopology' in modelAndWeightsConfig)) modelAndWeightsConfig = {
        modelTopology: modelAndWeightsConfig
    };
    modelAndWeightsConfig;
    let modelTopology = modelAndWeightsConfig.modelTopology;
    if (modelTopology['model_config'] != null) // If the model-topology JSON contains a 'model_config' field, then it is
    // a full model JSON (e.g., from `keras.Model.save()`), which contains
    // not only the model's architecture in its 'model_config' field, but
    // additional information such as the model's optimizer. We use only the
    // 'model_config' field currently.
    modelTopology = modelTopology['model_config'];
    const tsConfig = (0, $d02abf89bc2c0202$export$c0fd0796420499e6)(modelTopology);
    const model = (0, $61cac79a6a78765b$export$efcd34ab6248d3cd)(tsConfig, customObjects);
    if (modelAndWeightsConfig.weightsManifest != null) {
        // Load the weight values keyed by the original tensor names in the model
        // file that was loaded.  These should match the keys of the weight
        // manifest.
        const weightValues = await (0, $i64bB.io).loadWeights(modelAndWeightsConfig.weightsManifest, modelAndWeightsConfig.pathPrefix, model.weights.map((weight)=>weight.originalName));
        // Map the weights to the unique tensor names generated during model loading
        const uniqueWeightValues = {};
        for (const weight of model.weights)uniqueWeightValues[weight.originalName] = weightValues[weight.originalName];
        model.loadWeights(uniqueWeightValues);
        // Dispose temporary weight values.
        (0, $i64bB.dispose)(weightValues);
    }
    return model;
}
async function $dd5f24360d756fd3$export$f379ad49c680b84a(pathOrIOHandler, options) {
    if (options == null) options = {};
    if (typeof pathOrIOHandler === 'string') {
        const handlers = (0, $i64bB.io).getLoadHandlers(pathOrIOHandler, options);
        if (handlers.length === 0) // For backward compatibility: if no load handler can be found,
        // assume it is a relative http path.
        // TODO(cais): Reformat the args into a single `LoadOptions` once the core
        // is refactored.
        handlers.push((0, $i64bB.io).browserHTTPRequest(pathOrIOHandler, options));
        else if (handlers.length > 1) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Found more than one (${handlers.length}) load handlers for ` + `URL '${pathOrIOHandler}'`);
        pathOrIOHandler = handlers[0];
    }
    return $dd5f24360d756fd3$export$fe68a3692f105118(pathOrIOHandler, undefined, options);
}
async function $dd5f24360d756fd3$export$fe68a3692f105118(handler, customObjects, options) {
    if (options == null) options = {};
    if (handler.load == null) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)("Cannot proceed with model loading because the IOHandler provided does not have the `load` method implemented.");
    const artifacts = await handler.load();
    let modelTopology = artifacts.modelTopology;
    if (modelTopology['model_config'] != null) modelTopology = modelTopology['model_config'];
    const strict = options.strict == null ? true : options.strict;
    // If weights are provided and the weight-loading mode is strict, use
    // fast weight initialization. This skips costly initializers such as
    // 'orthogonal' and saves unnecessary computation in cases where
    // the initialized weight values will immediately be overwritten by
    // loaded weight values.
    const fastWeightInit = artifacts.weightData != null && artifacts.weightSpecs != null && strict;
    const model = (0, $61cac79a6a78765b$export$efcd34ab6248d3cd)((0, $d02abf89bc2c0202$export$c0fd0796420499e6)(modelTopology), customObjects, fastWeightInit);
    const trainingConfig = artifacts.trainingConfig;
    if (trainingConfig != null) model.loadTrainingConfig(trainingConfig);
    if (artifacts.userDefinedMetadata != null) model.setUserDefinedMetadata(artifacts.userDefinedMetadata);
    // If weightData is present, load the weights into the model.
    if (artifacts.weightData != null) {
        // Loading weights requires weightSpecs.
        if (artifacts.weightSpecs == null) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)("LayersModel artifacts contains weight data, but not weight specs. Therefore loading of weights cannot proceed.");
        const { modelWeights: modelWeights, optimizerWeights: optimizerWeights } = $dd5f24360d756fd3$var$decodeModelAndOptimizerWeights(artifacts.weightData, artifacts.weightSpecs);
        model.loadWeights(modelWeights, strict);
        if (model.optimizer != null && optimizerWeights.length > 0) await model.optimizer.setWeights(optimizerWeights);
        // Dispose temporary weight values.
        (0, $i64bB.dispose)(modelWeights);
        (0, $i64bB.dispose)(optimizerWeights.map((w)=>w.tensor));
    }
    return model;
}
function $dd5f24360d756fd3$var$decodeModelAndOptimizerWeights(weightData, specs) {
    const name2Tensor = (0, $i64bB.io).decodeWeights(weightData, specs);
    const modelWeights = {};
    const optimizerWeights = [];
    specs.forEach((spec)=>{
        if (spec.group === 'optimizer') optimizerWeights.push({
            name: spec.name,
            tensor: name2Tensor[spec.name]
        });
        else modelWeights[spec.name] = name2Tensor[spec.name];
    });
    return {
        modelWeights: modelWeights,
        optimizerWeights: optimizerWeights
    };
}
/**
 * A model with a stack of layers, feeding linearly from one to the next.
 *
 * `tf.sequential` is a factory function that creates an instance of
 * `tf.Sequential`.
 *
 * ```js
 *  // Define a model for linear regression.
 *  const model = tf.sequential();
 *  model.add(tf.layers.dense({units: 1, inputShape: [1]}));
 *
 *  // Prepare the model for training: Specify the loss and the optimizer.
 *  model.compile({loss: 'meanSquaredError', optimizer: 'sgd'});
 *
 *  // Generate some synthetic data for training.
 *  const xs = tf.tensor2d([1, 2, 3, 4], [4, 1]);
 *  const ys = tf.tensor2d([1, 3, 5, 7], [4, 1]);
 *
 *  // Train the model using the data then do inference on a data point the
 *  // model hasn't seen:
 *  await model.fit(xs, ys);
 *  model.predict(tf.tensor2d([5], [1, 1])).print();
 * ```
 *
 * @doc {heading: 'Models', subheading: 'Classes'}
 */ class $dd5f24360d756fd3$export$a77f6a295a72306 extends (0, $c4ed419014cbc39b$export$f8e130845653852b) {
    constructor(args){
        super({
            inputs: [],
            outputs: []
        });
        args = args || {};
        this.trainable = true;
        this.built = false;
        // Set model name.
        this.name = args.name != null ? args.name : (0, $cde2737e4648ad82$export$5e82334337e0f204)('sequential_');
        // Add to the model any layers passed to the constructor.
        if (args.layers != null) for (const layer of args.layers)this.add(layer);
    }
    // Helper function to Sequential.add  Throws if the new output shape will be
    // invalid.
    checkShape(layer) {
        const shape = layer.inboundNodes[0].outputTensors[0].shape;
        if (shape.some((x)=>x < 0)) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)('Negative dimension size caused by adding layer ' + `${layer.name} with input shape [` + `${layer.inboundNodes[0].inputTensors[0].shape}]`);
    }
    /**
     * Adds a layer instance on top of the layer stack.
     *
     * ```js
     *  const model = tf.sequential();
     *  model.add(tf.layers.dense({units: 8, inputShape: [1]}));
     *  model.add(tf.layers.dense({units: 4, activation: 'relu6'}));
     *  model.add(tf.layers.dense({units: 1, activation: 'relu6'}));
     *  // Note that the untrained model is random at this point.
     *  model.predict(tf.randomNormal([10, 1])).print();
     * ```
     * @param layer Layer instance.
     *
     * @exception ValueError In case the `layer` argument does not know its
     * input shape.
     * @exception ValueError In case the `layer` argument has multiple output
     *   tensors, or is already connected somewhere else (forbidden in
     *   `Sequential` models).
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ add(layer) {
        const isLayerModelInstance = layer instanceof $dd5f24360d756fd3$export$a77f6a295a72306 || layer instanceof (0, $c4ed419014cbc39b$export$f8e130845653852b);
        let modelLayer;
        if (isLayerModelInstance) {
            modelLayer = layer;
            if (modelLayer.outputs.length !== 1) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)("All layers in a Sequential model should have a single output tensor. For multi-output layers, use the functional API.");
            if (modelLayer.inputs.length !== 1) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)("All layers in a Sequential model should have a single input tensor. For multi-input layers, use the functional API.");
        }
        if (this.outputs.length === 0) {
            // first layer in model: check that it is an input layer
            if (layer.inboundNodes.length === 0) {
                // create an input layer
                if (layer.batchInputShape == null) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)("The first layer in a Sequential model must get an `inputShape` or `batchInputShape` argument.");
                // Instantiate the input layer.
                const x = (0, $b470cf8df79854ee$export$f5b8910cec6cf069)({
                    batchShape: layer.batchInputShape,
                    dtype: layer.dtype,
                    name: layer.name + '_input'
                });
                // This will build the current layer and create the node connecting
                // the current layer to the input layer we just created.
                layer.apply(x);
            }
            if (isLayerModelInstance) {
                this.outputs = modelLayer.outputs;
                this.inputs = modelLayer.inputs;
            } else {
                if (layer.inboundNodes.length !== 1) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)('A layer added to a Sequential model must not already be ' + `connected somewhere else. LayersModel received layer ${layer.name} ` + `which has ${layer.inboundNodes.length} pre-existing inbound ` + 'connections.');
                if (layer.inboundNodes[0].outputTensors.length !== 1) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)("All layers in a Sequential model should have a single output tensor. For multi-output layers, use the functional API.");
                this.checkShape(layer);
                this.outputs = [
                    layer.inboundNodes[0].outputTensors[0]
                ];
                this.inputs = (0, $03271f6b4e448384$export$6d61b4ed0b6fb596)(this.outputs[0]);
            }
            this.inboundNodes = [];
            // We create an input node, which we will keep updated
            // as we add more layers.
            // (This call has side effects.)
            // tslint:disable-next-line:no-unused-expression
            new (0, $03271f6b4e448384$export$85c928794f8d04d4)({
                outboundLayer: this,
                inboundLayers: [],
                nodeIndices: [],
                tensorIndices: [],
                inputTensors: this.inputs,
                outputTensors: this.outputs,
                // no model-level masking for now
                inputMasks: $b5cd0926a1c6df1f$export$f24d1f1e6cb42785(null, this.inputs.length),
                outputMasks: [
                    null
                ],
                inputShapes: this.inputs.map((x)=>x.shape),
                outputShapes: this.outputs[0].shape
            });
        } else {
            const outputTensor = layer.apply(this.outputs[0]);
            if (Array.isArray(outputTensor)) throw new TypeError("All layers in a Sequential model should have a single output tensor. For multi-output layers, use the functional API.");
            this.checkShape(layer);
            this.outputs = [
                outputTensor
            ];
            // update self.inbound_nodes
            this.inboundNodes[0].outputTensors = this.outputs;
            this.inboundNodes[0].outputShapes = [
                this.outputs[0].shape
            ];
        }
        this.layers.push(layer);
        this.built = false;
    }
    /**
     * Removes the last layer in the model.
     *
     * @exception TypeError if there are no layers in the model.
     */ pop() {
        if (this.layers.length === 0) throw new TypeError('There are no layers in the model.');
        this.layers.pop();
        if (this.layers.length === 0) {
            this.outputs = [];
            this.inboundNodes = [];
            this.outboundNodes = [];
        } else {
            const lastLayerIndex = this.layers.length - 1;
            this.layers[lastLayerIndex].outboundNodes = [];
            this.outputs = [
                this.layers[lastLayerIndex].output
            ];
            // update self.inbound_nodes
            this.inboundNodes[0].outputTensors = this.outputs;
            this.inboundNodes[0].outputShapes = [
                this.outputs[0].shape
            ];
        }
    }
    call(inputs, kwargs) {
        if (this.model == null) this.build();
        return this.model.call(inputs, kwargs);
    }
    build(inputShape) {
        // Call `getExactlyOneShape` without using its return value,
        // to verify that exactly one input shape is provided.
        (0, $e11ae28082970f77$export$25c35af872e8abca)(inputShape);
        if (this.inputs.length === 0 || this.outputs.length === 0) throw new TypeError("Sequential model cannot be built: model is empty. Add some layers first.");
        // actually create the model
        this.model = new (0, $c4ed419014cbc39b$export$f8e130845653852b)({
            inputs: this.inputs,
            outputs: this.outputs[0],
            name: this.name + '_model'
        });
        this.model.trainable = this.trainable;
        // mirror model attributes
        this.supportsMasking = this.model.supportsMasking;
        // TODO(michaelterry): Add caches
        this.inputLayers = this.model.inputLayers;
        this.inputLayersNodeIndices = this.model.inputLayersNodeIndices;
        this.inputLayersTensorIndices = this.model.inputLayersTensorIndices;
        this.outputLayers = this.model.outputLayers;
        this.outputLayersNodeIndices = this.model.outputLayersNodeIndices;
        this.outputLayersTensorIndices = this.model.outputLayersTensorIndices;
        this.nodesByDepth = this.model.nodesByDepth;
        this.containerNodes = this.model.containerNodes;
        this.outputNames = this.model.outputNames;
        this.inputNames = this.model.inputNames;
        // TODO(michaelterry): Add feedInputNames, feedInputs, if needed.
        // TODO(michaelterry): Add callbackModel if needed.
        this.built = true;
    }
    countParams() {
        if (!this.built) this.build();
        return super.countParams();
    }
    /**
     * Print a text summary of the Sequential model's layers.
     *
     * The summary includes
     * - Name and type of all layers that comprise the model.
     * - Output shape(s) of the layers
     * - Number of weight parameters of each layer
     * - The total number of trainable and non-trainable parameters of the
     * model.
     *
     * ```js
     * const model = tf.sequential();
     * model.add(
     *     tf.layers.dense({units: 100, inputShape: [10], activation: 'relu'}));
     * model.add(tf.layers.dense({units: 1, activation: 'sigmoid'}));
     *
     * model.summary();
     * ```
     *
     * @param lineLength Custom line length, in number of characters.
     * @param positions Custom widths of each of the columns, as either
     *   fractions of `lineLength` (e.g., `[0.5, 0.75, 1]`) or absolute number
     *   of characters (e.g., `[30, 50, 65]`). Each number corresponds to
     *   right-most (i.e., ending) position of a column.
     * @param printFn Custom print function. Can be used to replace the default
     *   `console.log`. For example, you can use `x => {}` to mute the printed
     *   messages in the console.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ summary(lineLength, positions, printFn = console.log) {
        if (!this.built) this.build();
        super.summary(lineLength, positions, printFn);
    }
    /**
     * Sets the weights of the model.
     *
     * @param weights Should be a list of Tensors with shapes and types matching
     *   the output of `model.getWeights()`.
     */ setWeights(weights) {
        if (this.model == null) this.build();
        this.model.setWeights(weights);
    }
    /**
     * Returns the loss value & metrics values for the model in test mode.
     *
     * Loss and metrics are specified during `compile()`, which needs to happen
     * before calls to `evaluate()`.
     *
     * Computation is done in batches.
     *
     * ```js
     * const model = tf.sequential({
     *   layers: [tf.layers.dense({units: 1, inputShape: [10]})]
     * });
     * model.compile({optimizer: 'sgd', loss: 'meanSquaredError'});
     * const result = model.evaluate(tf.ones([8, 10]), tf.ones([8, 1]), {
     *   batchSize: 4,
     * });
     * result.print();
     * ```
     *
     * @param x `tf.Tensor` of test data, or an `Array` of `tf.Tensor`s if the
     * model has multiple inputs.
     * @param y `tf.Tensor` of target data, or an `Array` of `tf.Tensor`s if the
     * model has multiple outputs.
     * @param args A `ModelEvaluateConfig`, containing optional fields.
     *
     * @return `Scalar` test loss (if the model has a single output and no
     *   metrics) or `Array` of `Scalar`s (if the model has multiple outputs
     *   and/or metrics). The attribute `model.metricsNames`
     *   will give you the display labels for the scalar outputs.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ evaluate(x, y, args = {}) {
        if (!this.built) throw new (0, $af476738b120e938$export$4a24a86bdbcf02bb)('The model needs to be compiled before being used.');
        return this.model.evaluate(x, y, args);
    }
    // TODO(cais): Add code snippet below once real dataset objects are
    //   available.
    /**
     * Evaluate model using a dataset object.
     *
     * Note: Unlike `evaluate()`, this method is asynchronous (`async`).
     *
     * @param dataset A dataset object. Its `iterator()` method is expected
     *   to generate a dataset iterator object, the `next()` method of which
     *   is expected to produce data batches for evaluation. The return value
     *   of the `next()` call ought to contain a boolean `done` field and a
     *   `value` field. The `value` field is expected to be an array of two
     *   `tf.Tensor`s or an array of two nested `tf.Tensor` structures. The former
     *   case is for models with exactly one input and one output (e.g.
     *   a sequential model). The latter case is for models with multiple
     *   inputs and/or multiple outputs. Of the two items in the array, the
     *   first is the input feature(s) and the second is the output target(s).
     * @param args A configuration object for the dataset-based evaluation.
     * @returns Loss and metric values as an Array of `Scalar` objects.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ async evaluateDataset(dataset, args) {
        if (!this.built) throw new (0, $af476738b120e938$export$4a24a86bdbcf02bb)('The model needs to be compiled before being used.');
        return this.model.evaluateDataset(dataset, args);
    }
    /**
     * Generates output predictions for the input samples.
     *
     * Computation is done in batches.
     *
     * Note: the "step" mode of predict() is currently not supported.
     *   This is because the TensorFlow.js core backend is imperative only.
     *
     * ```js
     * const model = tf.sequential({
     *   layers: [tf.layers.dense({units: 1, inputShape: [10]})]
     * });
     * model.predict(tf.ones([2, 10])).print();
     * ```
     *
     * @param x The input data, as a Tensor, or an `Array` of `tf.Tensor`s if
     *   the model has multiple inputs.
     * @param conifg A `ModelPredictConfig` object containing optional fields.
     *
     * @return `tf.Tensor`(s) of predictions.
     *
     * @exception ValueError In case of mismatch between the provided input data
     *   and the model's expectations, or in case a stateful model receives a
     *   number of samples that is not a multiple of the batch size.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ predict(x, args = {}) {
        if (this.model == null) this.build();
        return this.model.predict(x, args);
    }
    /**
     * Returns predictions for a single batch of samples.
     *
     * @param x: Input samples, as a Tensor, or list of Tensors (if the model
     *   has multiple inputs).
     * @return Tensor(s) of predictions
     */ predictOnBatch(x) {
        if (this.model == null) this.build();
        return this.model.predictOnBatch(x);
    }
    /**
     * See `LayersModel.compile`.
     *
     * @param args
     */ compile(args) {
        this.build();
        this.model.compile(args);
        this.optimizer_ = this.model.optimizer;
        // tslint:disable-next-line:no-any
        this.isOptimizerOwned = this.model.isOptimizerOwned;
        this.loss = this.model.loss;
        this.metrics = this.model.metrics;
        // TODO(cais): Add this.lossWeights, this.sampleWeightMode,
        //   this.weightedMetrics, this.targets.
        this.metricsTensors = this.model.metricsTensors;
        this.metricsNames = this.model.metricsNames;
    // TODO(cais): Add sampleWeights.
    }
    get optimizer() {
        return this.model == null ? undefined : this.model.optimizer;
    }
    set optimizer(optimizer) {
        this.model.optimizer = optimizer;
    }
    /**
     * Trains the model for a fixed number of epochs (iterations on a dataset).
     *
     * ```js
     * const model = tf.sequential({
     *   layers: [tf.layers.dense({units: 1, inputShape: [10]})]
     * });
     * model.compile({optimizer: 'sgd', loss: 'meanSquaredError'});
     * const history = await model.fit(tf.ones([8, 10]), tf.ones([8, 1]), {
     *   batchSize: 4,
     *   epochs: 3
     * });
     * console.log(history.history.loss[0]);
     * ```
     *
     * @param x `tf.Tensor` of training data, or an array of `tf.Tensor`s if the
     * model has multiple inputs. If all inputs in the model are named, you can
     * also pass a dictionary mapping input names to `tf.Tensor`s.
     * @param y `tf.Tensor` of target (label) data, or an array of `tf.Tensor`s if
     * the model has multiple outputs. If all outputs in the model are named, you
     *  can also pass a dictionary mapping output names to `tf.Tensor`s.
     * @param args  A `ModelFitConfig`, containing optional fields.
     *
     * @return A `History` instance. Its `history` attribute contains all
     *   information collected during training.
     *
     * @exception ValueError In case of mismatch between the provided input data
     *   and what the model expects.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ async fit(x, y, args = {}) {
        if (!this.built) throw new (0, $af476738b120e938$export$4a24a86bdbcf02bb)("The model needs to be compiled before being used.");
        return this.model.fit(x, y, args);
    }
    /**
     * Trains the model using a dataset object.
     *
     * ```js
     * const xArray = [
     *   [1, 1, 1, 1, 1, 1, 1, 1, 1],
     *   [1, 1, 1, 1, 1, 1, 1, 1, 1],
     *   [1, 1, 1, 1, 1, 1, 1, 1, 1],
     *   [1, 1, 1, 1, 1, 1, 1, 1, 1],
     * ];
     * const yArray = [1, 1, 1, 1];
     * // Create a dataset from the JavaScript array.
     * const xDataset = tf.data.array(xArray);
     * const yDataset = tf.data.array(yArray);
     * // Zip combines the `x` and `y` Datasets into a single Dataset, the
     * // iterator of which will return an object containing of two tensors,
     * // corresponding to `x` and `y`.  The call to `batch(4)` will bundle
     * // four such samples into a single object, with the same keys now pointing
     * // to tensors that hold 4 examples, organized along the batch dimension.
     * // The call to `shuffle(4)` causes each iteration through the dataset to
     * // happen in a different order.  The size of the shuffle window is 4.
     * const xyDataset = tf.data.zip({xs: xDataset, ys: yDataset})
     *     .batch(4)
     *     .shuffle(4);
     * const model = tf.sequential({
     *   layers: [tf.layers.dense({units: 1, inputShape: [9]})]
     * });
     * model.compile({optimizer: 'sgd', loss: 'meanSquaredError'});
     * const history = await model.fitDataset(xyDataset, {
     *   epochs: 4,
     *   callbacks: {onEpochEnd: (epoch, logs) => console.log(logs.loss)}
     * });
     * ```
     *
     * @param dataset A dataset object. Its `iterator()` method is expected to
     *   generate a dataset iterator object, the `next()` method of which is
     *   expected to produce data batches for evaluation. The return value of the
     *   `next()` call ought to contain a boolean `done` field and a `value`
     *   field.
     *
     *   The `value` field is expected to be an object of with fields
     *   `xs` and `ys`, which point to the feature tensor and the target tensor,
     *   respectively. This case is for models with exactly one input and one
     *   output (e.g. a sequential model). For example:
     *   ```js
     *   {value: {xs: xsTensor, ys: ysTensor}, done: false}
     *   ```
     *
     *   If the model has multiple inputs, the `xs` field of `value` should
     *   be an object mapping input names to their respective feature tensors.
     *   For example:
     *   ```js
     *   {
     *     value: {
     *       xs: {
     *         input_1: xsTensor1,
     *         input_2: xsTensor2
     *       },
     *       ys: ysTensor
     *     },
     *     done: false
     *   }
     *   ```
     *   If the model has multiple outputs, the `ys` field of `value` should
     *   be an object mapping output names to their respective target tensors.
     *   For example:
     *   ```js
     *   {
     *     value: {
     *       xs: xsTensor,
     *       ys: {
     *         output_1: ysTensor1,
     *         output_2: ysTensor2
     *       },
     *     },
     *     done: false
     *   }
     *   ```
     * @param args A `ModelFitDatasetArgs`, containing optional fields.
     *
     * @return A `History` instance. Its `history` attribute contains all
     *   information collected during training.
     *
     * @doc {heading: 'Models', subheading: 'Classes', ignoreCI: true}
     */ async fitDataset(dataset, args) {
        if (!this.built) throw new (0, $af476738b120e938$export$4a24a86bdbcf02bb)("The model needs to be compiled before being used.");
        return this.model.fitDataset(dataset, args);
    }
    /**
     * Runs a single gradient update on a single batch of data.
     *
     * This method differs from `fit()` and `fitDataset()` in the following
     * regards:
     *   - It operates on exactly one batch of data.
     *   - It returns only the loss and metric values, instead of
     *     returning the batch-by-batch loss and metric values.
     *   - It doesn't support fine-grained options such as verbosity and
     *     callbacks.
     *
     * @param x Input data. It could be one of the following:
     *   - A `tf.Tensor`, or an Array of `tf.Tensor`s (in case the model has
     *     multiple inputs).
     *   - An Object mapping input names to corresponding `tf.Tensor` (if the
     *     model has named inputs).
     * @param y Target data. It could be either a `tf.Tensor` or multiple
     *   `tf.Tensor`s. It should be consistent with `x`.
     * @returns Training loss or losses (in case the model has
     *   multiple outputs), along with metrics (if any), as numbers.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ async trainOnBatch(x, y) {
        return this.model.trainOnBatch(x, y);
    }
    /* See parent class for JsDoc */ /** @nocollapse */ static fromConfig(cls, config, customObjects = {}, fastWeightInit = false) {
        let configArray;
        let extraModelConfig = {};
        if (config instanceof Array) {
            if (!(config[0].className != null) || config[0]['className'] === 'Merge') throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)('Legacy serialization format not supported yet.');
            configArray = config;
        } else {
            (0, $i64bB.util).assert(config['layers'] != null, ()=>`When the config data for a Sequential model is not an Array, ` + `it must be an Object that contains the 'layers' field.`);
            configArray = config['layers'];
            delete config['layers'];
            extraModelConfig = config;
        }
        const model = new cls(extraModelConfig);
        if (!(model instanceof $dd5f24360d756fd3$export$a77f6a295a72306)) throw new (0, $af476738b120e938$export$e162153238934121)(`Sequential.fromConfig called on non-Sequential input: ${model}`);
        for (const conf of configArray){
            const customObjects = undefined;
            const layer = (0, $61cac79a6a78765b$export$efcd34ab6248d3cd)(conf, customObjects, fastWeightInit);
            if (fastWeightInit) layer.setFastWeightInitDuringBuild(true);
            model.add(layer);
        }
        return model;
    }
    /**
     * Setter used for force stopping of LayersModel.fit() (i.e., training).
     *
     * Example:
     *
     * ```js
     * const model = tf.sequential();
     * model.add(tf.layers.dense({units: 1, inputShape: [10]}));
     * model.compile({loss: 'meanSquaredError', optimizer: 'sgd'});
     * const xs = tf.ones([8, 10]);
     * const ys = tf.zeros([8, 1]);
     *
     * const history = await model.fit(xs, ys, {
     *   epochs: 10,
     *   callbacks: {
     *     onEpochEnd: async (epoch, logs) => {
     *       if (epoch === 2) {
     *         model.stopTraining = true;
     *       }
     *     }
     *   }
     * });
     *
     * // There should be only 3 values in the loss array, instead of 10 values,
     * // due to the stopping after 3 epochs.
     * console.log(history.history.loss);
     * ```
     */ set stopTraining(stop) {
        // TODO(cais): When refactoring to remove the composition pattern happens,
        // remove this method overriding.
        if (this.model == null) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)("Cannot set the stopTraining property of a sequential model before it is compiled.");
        this.model.stopTraining = stop;
    }
    get stopTraining() {
        if (this.model == null) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)("Cannot get the stopTraining property of a sequential model before it is compiled.");
        return this.model.stopTraining;
    }
    // TODO(cais): Override get trainableWeights() here
    // tslint:disable-next-line:no-any
    getConfig() {
        // NOTE(cais): We override the return type of getConfig() to `any` here,
        //   because the `Sequential` class is a special case among `Container`
        //   subtypes in that its getConfig() method returns an Array (not a
        //   dict).
        const layers = [];
        for (const layer of this.layers){
            const dict = {};
            dict['className'] = layer.getClassName();
            dict['config'] = layer.getConfig();
            layers.push(dict);
        }
        return {
            name: this.name,
            layers: layers
        };
    }
}
/** @nocollapse */ $dd5f24360d756fd3$export$a77f6a295a72306.className = 'Sequential';
(0, $i64bB.serialization).registerClass($dd5f24360d756fd3$export$a77f6a295a72306);


function $1aab14422fdfa568$export$39a8f6bed6e94390(args) {
    return new (0, $c4ed419014cbc39b$export$f8e130845653852b)(args);
}
function $1aab14422fdfa568$export$3c7b24ce1c81e349(config) {
    return new (0, $dd5f24360d756fd3$export$a77f6a295a72306)(config);
}
function $1aab14422fdfa568$export$b7e3ae3d7c15e42e(config) {
    return (0, $b470cf8df79854ee$export$f5b8910cec6cf069)(config);
}
function $1aab14422fdfa568$export$e4ead4e2d6e9b3fd(verbosityLevel, callbackConstructor) {
    (0, $65144a7424fc1c41$export$3b4f51c3fa9f338c).registerCallbackConstructor(verbosityLevel, callbackConstructor);
}


/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 *  Advanced activation layers.
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ // Layer activation functions

var $i64bB = parcelRequire("i64bB");


class $30ca3c776e202113$export$d4842319833f6f14 extends (0, $i64bB.serialization).Serializable {
    getConfig() {
        return {};
    }
}
/**
 * Exponential linear unit (ELU).
 * Reference: https://arxiv.org/abs/1511.07289
 */ class $30ca3c776e202113$export$64636e173424d83d extends $30ca3c776e202113$export$d4842319833f6f14 {
    /**
     * Calculate the activation function.
     *
     * @param x: Input.
     * @param alpha: Scaling factor the negative section.
     * @return Output of the ELU activation.
     */ apply(x, alpha = 1) {
        return $33b0bdd0433db936$export$796b583dd79d8524(x, alpha);
    }
}
/** @nocollapse */ $30ca3c776e202113$export$64636e173424d83d.className = 'elu';
(0, $i64bB.serialization).registerClass($30ca3c776e202113$export$64636e173424d83d);
/**
 * Scaled Exponential Linear Unit. (Klambauer et al., 2017).
 * Reference: Self-Normalizing Neural Networks, https://arxiv.org/abs/1706.02515
 * Notes:
 *   - To be used together with the initialization "lecunNormal".
 *   - To be used together with the dropout variant "AlphaDropout".
 */ class $30ca3c776e202113$export$6760d858e6f2594a extends $30ca3c776e202113$export$d4842319833f6f14 {
    apply(x) {
        return $i64bB.selu(x);
    }
}
/** @nocollapse */ $30ca3c776e202113$export$6760d858e6f2594a.className = 'selu';
(0, $i64bB.serialization).registerClass($30ca3c776e202113$export$6760d858e6f2594a);
/**
 *  Rectified linear unit
 */ class $30ca3c776e202113$export$9a6ff968bf961432 extends $30ca3c776e202113$export$d4842319833f6f14 {
    apply(x) {
        return $i64bB.relu(x);
    }
}
/** @nocollapse */ $30ca3c776e202113$export$9a6ff968bf961432.className = 'relu';
(0, $i64bB.serialization).registerClass($30ca3c776e202113$export$9a6ff968bf961432);
/**
 * Rectified linear unit activation maxing out at 6.0.
 */ class $30ca3c776e202113$export$3be9e924f629054e extends $30ca3c776e202113$export$d4842319833f6f14 {
    apply(x) {
        return (0, $i64bB.tidy)(()=>$i64bB.minimum(6.0, $i64bB.relu(x)));
    }
}
/** @nocollapse */ $30ca3c776e202113$export$3be9e924f629054e.className = 'relu6';
(0, $i64bB.serialization).registerClass($30ca3c776e202113$export$3be9e924f629054e);
//* Linear activation (no-op) */
class $30ca3c776e202113$export$cff00ccf6e2392de extends $30ca3c776e202113$export$d4842319833f6f14 {
    apply(x) {
        return x;
    }
}
/** @nocollapse */ $30ca3c776e202113$export$cff00ccf6e2392de.className = 'linear';
(0, $i64bB.serialization).registerClass($30ca3c776e202113$export$cff00ccf6e2392de);
/**
 * Sigmoid activation function.
 */ class $30ca3c776e202113$export$fde18c826dda6b1b extends $30ca3c776e202113$export$d4842319833f6f14 {
    apply(x) {
        return $i64bB.sigmoid(x);
    }
}
/** @nocollapse */ $30ca3c776e202113$export$fde18c826dda6b1b.className = 'sigmoid';
(0, $i64bB.serialization).registerClass($30ca3c776e202113$export$fde18c826dda6b1b);
/**
 * Segment-wise linear approximation of sigmoid.
 */ class $30ca3c776e202113$export$6098198c337d3dd8 extends $30ca3c776e202113$export$d4842319833f6f14 {
    apply(x) {
        return $33b0bdd0433db936$export$150f2d52960480ef(x);
    }
}
/** @nocollapse */ $30ca3c776e202113$export$6098198c337d3dd8.className = 'hardSigmoid';
(0, $i64bB.serialization).registerClass($30ca3c776e202113$export$6098198c337d3dd8);
/**
 * Softplus activation function.
 */ class $30ca3c776e202113$export$c5af433747f1fd0a extends $30ca3c776e202113$export$d4842319833f6f14 {
    apply(x) {
        return $i64bB.softplus(x);
    }
}
/** @nocollapse */ $30ca3c776e202113$export$c5af433747f1fd0a.className = 'softplus';
(0, $i64bB.serialization).registerClass($30ca3c776e202113$export$c5af433747f1fd0a);
/**
 * Softsign activation function.
 */ class $30ca3c776e202113$export$abea6258cd16deb6 extends $30ca3c776e202113$export$d4842319833f6f14 {
    apply(x) {
        return $33b0bdd0433db936$export$6def925d7f33a45c(x);
    }
}
/** @nocollapse */ $30ca3c776e202113$export$abea6258cd16deb6.className = 'softsign';
(0, $i64bB.serialization).registerClass($30ca3c776e202113$export$abea6258cd16deb6);
/**
 * Hyperbolic tangent function.
 */ class $30ca3c776e202113$export$893b6e865e352c83 extends $30ca3c776e202113$export$d4842319833f6f14 {
    apply(x) {
        return $i64bB.tanh(x);
    }
}
/** @nocollapse */ $30ca3c776e202113$export$893b6e865e352c83.className = 'tanh';
(0, $i64bB.serialization).registerClass($30ca3c776e202113$export$893b6e865e352c83);
/**
 * Softmax activation function
 */ class $30ca3c776e202113$export$350a526055d3ca6e extends $30ca3c776e202113$export$d4842319833f6f14 {
    /**
     * Calculate the activation function.
     *
     * @param x Tensor.
     * @param axis Integer, axis along which the softmax normalization is applied.
     * Invalid if < 2, as softmax across 1 (the batch dimension) is assumed to be
     * an error.
     *
     * @returns a Tensor of the same shape as x
     *
     * @throws ValueError: In case `dim(x) < 2`.
     */ apply(x, axis = -1) {
        return $i64bB.softmax(x, axis);
    }
}
/** @nocollapse */ $30ca3c776e202113$export$350a526055d3ca6e.className = 'softmax';
(0, $i64bB.serialization).registerClass($30ca3c776e202113$export$350a526055d3ca6e);
/**
 * Log softmax activation function
 */ class $30ca3c776e202113$export$85b5bcbd60848a10 extends $30ca3c776e202113$export$d4842319833f6f14 {
    /**
     * Calculate the activation function of log softmax:
     * log( exp(x_i) / sum(exp(x)) )
     *
     * @param x Tensor.
     * @param axis Integer, axis along which the softmax normalization is applied.
     * Invalid if < 2, as softmax across 1 (the batch dimension) is assumed to be
     * an error.
     *
     * @returns a Tensor of the same shape as x
     *
     * @throws ValueError: In case `dim(x) < 2`.
     */ apply(x, axis = -1) {
        return $i64bB.logSoftmax(x, axis);
    }
}
/** @nocollapse */ $30ca3c776e202113$export$85b5bcbd60848a10.className = 'logSoftmax';
(0, $i64bB.serialization).registerClass($30ca3c776e202113$export$85b5bcbd60848a10);
/**
 * Gelu activation function
 */ class $30ca3c776e202113$export$88ac613df6c4ef11 extends $30ca3c776e202113$export$d4842319833f6f14 {
    /**
     * Calculate the activation function.
     *
     * @param x Tensor.
     * @returns a Tensor of the same shape as x
     */ apply(x) {
        return (0, $i64bB.tidy)(()=>{
            return $i64bB.tidy(()=>{
                const sqrtTwo = Math.sqrt(2);
                // Compute Φ(x) using the erf function
                const cdf = $i64bB.mul(0.5, $i64bB.add(1, $i64bB.erf($i64bB.div(x, sqrtTwo))));
                // Compute GELU(x) = x * Φ(x)
                return $i64bB.mul(x, cdf);
            });
        });
    }
}
/** @nocollapse */ $30ca3c776e202113$export$88ac613df6c4ef11.className = 'gelu';
(0, $i64bB.serialization).registerClass($30ca3c776e202113$export$88ac613df6c4ef11);
/**
 * GeluNew activation function
 */ class $30ca3c776e202113$export$564b1c5fff9e16df extends $30ca3c776e202113$export$d4842319833f6f14 {
    /**
     * Calculate the activation function.
     *
     * @param x Tensor.
     * @returns a Tensor of the same shape as x
     */ apply(x) {
        return (0, $i64bB.tidy)(()=>{
            return $i64bB.mul(0.5, $i64bB.mul(x, $i64bB.add(1, $i64bB.tanh($i64bB.mul($i64bB.sqrt($i64bB.div(2, Math.PI)), $i64bB.add(x, $i64bB.mul(0.044715, $i64bB.pow(x, 3))))))));
        });
    }
}
/** @nocollapse */ $30ca3c776e202113$export$564b1c5fff9e16df.className = 'gelu_new';
(0, $i64bB.serialization).registerClass($30ca3c776e202113$export$564b1c5fff9e16df);
/**
 * Mish activation function
 */ class $30ca3c776e202113$export$61e2977e0c740f20 extends $30ca3c776e202113$export$d4842319833f6f14 {
    /**
     * Calculate the activation function.
     *
     * @param x Tensor.
     * @returns a Tensor of the same shape as x
     */ apply(x) {
        return (0, $i64bB.tidy)(()=>$i64bB.mul(x, $i64bB.tanh($i64bB.softplus(x))));
    }
}
/** @nocollapse */ $30ca3c776e202113$export$61e2977e0c740f20.className = 'mish';
(0, $i64bB.serialization).registerClass($30ca3c776e202113$export$61e2977e0c740f20);
/**
 * Swish activation function
 */ class $30ca3c776e202113$export$ca163985819ed934 extends $30ca3c776e202113$export$d4842319833f6f14 {
    /**
     * Calculate the activation function.
     *
     * @param x Tensor.
     * @param alpha Scaling factor for the sigmoid function.
     * @returns a Tensor of the same shape as x
     */ apply(x, alpha = 1) {
        return (0, $i64bB.tidy)(()=>$i64bB.mul($i64bB.sigmoid($i64bB.mul(x, alpha)), x));
    }
}
/** @nocollapse */ $30ca3c776e202113$export$ca163985819ed934.className = 'swish';
(0, $i64bB.serialization).registerClass($30ca3c776e202113$export$ca163985819ed934);
function $30ca3c776e202113$export$8a2c1643c67d0487(activation) {
    return activation.getClassName();
}
function $30ca3c776e202113$export$3feed769d94b8fdf(config, customObjects = {}) {
    return (0, $b5cd0926a1c6df1f$export$c33061eb381c60f9)(config, (0, $i64bB.serialization).SerializationMap.getMap().classNameMap, customObjects, 'activation');
}
function $30ca3c776e202113$export$ed84f867ffcf9364(identifier) {
    if (identifier == null) {
        const config = {};
        config['className'] = 'linear';
        config['config'] = {};
        return $30ca3c776e202113$export$3feed769d94b8fdf(config);
    }
    if (typeof identifier === 'string') {
        const config = {};
        config['className'] = identifier;
        config['config'] = {};
        return $30ca3c776e202113$export$3feed769d94b8fdf(config);
    } else if (identifier instanceof $30ca3c776e202113$export$d4842319833f6f14) return identifier;
    else return $30ca3c776e202113$export$3feed769d94b8fdf(identifier);
}






/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /* original source: keras/regularizers.py */ 
var $i64bB = parcelRequire("i64bB");


function $030044d54dc1235d$var$assertObjectArgs(args) {
    if (args != null && typeof args !== 'object') throw new Error(`Argument to L1L2 regularizer's constructor is expected to be an ` + `object, but received: ${args}`);
}
class $030044d54dc1235d$export$49735e7db1366677 extends (0, $i64bB.serialization).Serializable {
}
class $030044d54dc1235d$export$fb258565fa710653 extends $030044d54dc1235d$export$49735e7db1366677 {
    constructor(args){
        super();
        $030044d54dc1235d$var$assertObjectArgs(args);
        this.l1 = args == null || args.l1 == null ? 0.01 : args.l1;
        this.l2 = args == null || args.l2 == null ? 0.01 : args.l2;
        this.hasL1 = this.l1 !== 0;
        this.hasL2 = this.l2 !== 0;
    }
    /**
     * Porting note: Renamed from __call__.
     * @param x Variable of which to calculate the regularization score.
     */ apply(x) {
        return (0, $i64bB.tidy)(()=>{
            let regularization = (0, $i64bB.zeros)([
                1
            ]);
            if (this.hasL1) regularization = (0, $i64bB.add)(regularization, (0, $i64bB.sum)($i64bB.mul(this.l1, (0, $i64bB.abs)(x))));
            if (this.hasL2) regularization = (0, $i64bB.add)(regularization, (0, $i64bB.sum)($i64bB.mul(this.l2, $33b0bdd0433db936$export$dd4f28cef696bc7d(x))));
            return $i64bB.reshape(regularization, []);
        });
    }
    getConfig() {
        return {
            'l1': this.l1,
            'l2': this.l2
        };
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls({
            l1: config['l1'],
            l2: config['l2']
        });
    }
}
/** @nocollapse */ $030044d54dc1235d$export$fb258565fa710653.className = 'L1L2';
(0, $i64bB.serialization).registerClass($030044d54dc1235d$export$fb258565fa710653);
function $030044d54dc1235d$export$b35c4719d0ff29eb(args) {
    $030044d54dc1235d$var$assertObjectArgs(args);
    return new $030044d54dc1235d$export$fb258565fa710653({
        l1: args != null ? args.l1 : null,
        l2: 0
    });
}
function $030044d54dc1235d$export$683828dad49492ec(args) {
    $030044d54dc1235d$var$assertObjectArgs(args);
    return new $030044d54dc1235d$export$fb258565fa710653({
        l2: args != null ? args.l2 : null,
        l1: 0
    });
}
const $030044d54dc1235d$export$c242128098ecbfe1 = {
    'l1l2': 'L1L2'
};
function $030044d54dc1235d$export$7e8cf5899b350405(constraint) {
    return (0, $b5cd0926a1c6df1f$export$78f846918d17a884)(constraint);
}
function $030044d54dc1235d$export$e53995a1d2fa3dd6(config, customObjects = {}) {
    return (0, $b5cd0926a1c6df1f$export$c33061eb381c60f9)(config, (0, $i64bB.serialization).SerializationMap.getMap().classNameMap, customObjects, 'regularizer');
}
function $030044d54dc1235d$export$b3404716bfee324c(identifier) {
    if (identifier == null) return null;
    if (typeof identifier === 'string') {
        const className = identifier in $030044d54dc1235d$export$c242128098ecbfe1 ? $030044d54dc1235d$export$c242128098ecbfe1[identifier] : identifier;
        const config = {
            className: className,
            config: {}
        };
        return $030044d54dc1235d$export$e53995a1d2fa3dd6(config);
    } else if (identifier instanceof $030044d54dc1235d$export$49735e7db1366677) return identifier;
    else return $030044d54dc1235d$export$e53995a1d2fa3dd6(identifier);
}



class $c446169fb509cc58$export$b6bead732c285ccc extends (0, $03271f6b4e448384$export$936d0764594b6eb3) {
    constructor(args){
        super(args == null ? {} : args);
        this.supportsMasking = true;
        if (args != null) this.maxValue = args.maxValue;
    }
    call(inputs, kwargs) {
        inputs = (0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs);
        let output = (0, $i64bB.relu)(inputs);
        if (this.maxValue != null) output = (0, $i64bB.clipByValue)(output, 0, this.maxValue);
        return output;
    }
    computeOutputShape(inputShape) {
        return inputShape;
    }
    getConfig() {
        const config = {
            maxValue: this.maxValue
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $c446169fb509cc58$export$b6bead732c285ccc.className = 'ReLU';
(0, $i64bB.serialization).registerClass($c446169fb509cc58$export$b6bead732c285ccc);
class $c446169fb509cc58$export$aef2e2f253bc592f extends (0, $03271f6b4e448384$export$936d0764594b6eb3) {
    constructor(args){
        super(args == null ? {} : args);
        this.DEFAULT_ALPHA = 0.3;
        if (args == null) args = {};
        this.alpha = args.alpha == null ? this.DEFAULT_ALPHA : args.alpha;
    }
    call(inputs, kwargs) {
        const x = (0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs);
        return (0, $i64bB.leakyRelu)(x, this.alpha);
    }
    computeOutputShape(inputShape) {
        return inputShape;
    }
    getConfig() {
        const config = {
            alpha: this.alpha
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $c446169fb509cc58$export$aef2e2f253bc592f.className = 'LeakyReLU';
(0, $i64bB.serialization).registerClass($c446169fb509cc58$export$aef2e2f253bc592f);
class $c446169fb509cc58$export$e8f536be4d0c9e9f extends (0, $03271f6b4e448384$export$936d0764594b6eb3) {
    constructor(args){
        super(args == null ? {} : args);
        this.DEFAULT_ALPHA_INITIALIZER = 'zeros';
        if (args == null) args = {};
        this.supportsMasking = true;
        this.alphaInitializer = (0, $49135dd97e6043ca$export$558b7d1a338df84b)(args.alphaInitializer || this.DEFAULT_ALPHA_INITIALIZER);
        this.alphaRegularizer = (0, $030044d54dc1235d$export$b3404716bfee324c)(args.alphaRegularizer);
        this.alphaConstraint = (0, $ef279f7fc82ac2a7$export$492f40394cb58978)(args.alphaConstraint);
        if (args.sharedAxes == null) this.sharedAxes = null;
        else if (Array.isArray(args.sharedAxes)) this.sharedAxes = args.sharedAxes;
        else if (typeof args.sharedAxes === 'number') this.sharedAxes = [
            args.sharedAxes
        ];
        else throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Expected sharedAxes to be a number or an array of numbers, ` + `but got ${args.sharedAxes}`);
    }
    build(inputShape) {
        inputShape = (0, $e11ae28082970f77$export$25c35af872e8abca)(inputShape);
        const paramShape = inputShape.slice(1);
        if (this.sharedAxes != null) for (const i of this.sharedAxes)paramShape[i - 1] = 1;
        this.alpha = this.addWeight('alpha', paramShape, 'float32', this.alphaInitializer, this.alphaRegularizer, true, this.alphaConstraint);
        // Set input spec.
        const axes = {};
        if (this.sharedAxes != null) for(let i = 1; i < inputShape.length; ++i)axes[i] = inputShape[i];
        this.inputSpec = [
            new (0, $03271f6b4e448384$export$7705ee67def9d40a)({
                ndim: inputShape.length,
                axes: axes
            })
        ];
        this.built = true;
    }
    call(inputs, kwargs) {
        inputs = (0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs);
        return (0, $i64bB.prelu)(inputs, this.alpha.read());
    }
    getConfig() {
        const config = {
            alphaInitializer: (0, $49135dd97e6043ca$export$68de06a18c23bdbc)(this.alphaInitializer),
            alphaRegularizer: (0, $030044d54dc1235d$export$7e8cf5899b350405)(this.alphaRegularizer),
            alphaConstraint: (0, $ef279f7fc82ac2a7$export$e449710617725987)(this.alphaConstraint),
            sharedAxes: this.sharedAxes
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $c446169fb509cc58$export$e8f536be4d0c9e9f.className = 'PReLU';
(0, $i64bB.serialization).registerClass($c446169fb509cc58$export$e8f536be4d0c9e9f);
class $c446169fb509cc58$export$945a5ccf96adb3b2 extends (0, $03271f6b4e448384$export$936d0764594b6eb3) {
    constructor(args){
        super(args == null ? {} : args);
        this.DEFAULT_ALPHA = 1.0;
        if (args == null) args = {};
        if (args.alpha != null && args.alpha !== this.DEFAULT_ALPHA) throw new (0, $af476738b120e938$export$e162153238934121)(`Non-default alpha value (${args.alpha}) is not supported by the ` + `ELU layer yet.`);
        this.alpha = args.alpha == null ? this.DEFAULT_ALPHA : args.alpha;
    }
    call(inputs, kwargs) {
        const x = (0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs);
        return (0, $i64bB.elu)(x);
    }
    computeOutputShape(inputShape) {
        return inputShape;
    }
    getConfig() {
        const config = {
            alpha: this.alpha
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $c446169fb509cc58$export$945a5ccf96adb3b2.className = 'ELU';
(0, $i64bB.serialization).registerClass($c446169fb509cc58$export$945a5ccf96adb3b2);
class $c446169fb509cc58$export$e0ad929c946d21d1 extends (0, $03271f6b4e448384$export$936d0764594b6eb3) {
    constructor(args){
        super(args == null ? {} : args);
        this.DEFAULT_THETA = 1.0;
        if (args == null) args = {};
        this.theta = args.theta == null ? this.DEFAULT_THETA : args.theta;
    }
    call(inputs, kwargs) {
        const x = (0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs);
        return (0, $i64bB.mul)(x, (0, $i64bB.cast)((0, $i64bB.greater)(x, this.theta), 'float32'));
    }
    computeOutputShape(inputShape) {
        return inputShape;
    }
    getConfig() {
        const config = {
            theta: this.theta
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $c446169fb509cc58$export$e0ad929c946d21d1.className = 'ThresholdedReLU';
(0, $i64bB.serialization).registerClass($c446169fb509cc58$export$e0ad929c946d21d1);
class $c446169fb509cc58$export$350a526055d3ca6e extends (0, $03271f6b4e448384$export$936d0764594b6eb3) {
    constructor(args){
        super(args == null ? {} : args);
        this.DEFAULT_AXIS = 1.0;
        if (args == null) args = {};
        this.softmax = new (0, $30ca3c776e202113$export$350a526055d3ca6e)().apply;
        this.axis = args.axis == null ? this.DEFAULT_AXIS : args.axis;
    }
    call(inputs, kwargs) {
        // TODO(pforderique): Add tests for when `this.axis` is a number[].
        return (0, $i64bB.tidy)(()=>{
            let x = (0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs);
            const mask = kwargs['mask'];
            if (mask != null) {
                // Since mask is 1.0 for positions we want to keep and 0.0 for masked
                // positions, this operation will create a tensor which is 0.0 for
                // positions we want to attend and -1e.9 for masked positions.
                const adder = (0, $i64bB.mul)((0, $i64bB.sub)((0, $i64bB.ones)(x.shape), (0, $i64bB.cast)(mask, x.dtype)), (0, $i64bB.scalar)(-1000000000));
                // Since we are adding it to the raw scores before the softmax, this
                // is effectively the same as removing these entirely.
                x = (0, $i64bB.add)(x, adder);
            }
            if (this.axis instanceof Array) {
                if (this.axis.length > 1) return (0, $i64bB.exp)((0, $i64bB.sub)(x, (0, $i64bB.logSumExp)(x, this.axis, true)));
                else return this.softmax(x, this.axis[0]);
            }
            return this.softmax(x, this.axis);
        });
    }
    computeOutputShape(inputShape) {
        return inputShape;
    }
    getConfig() {
        const config = {
            axis: this.axis
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $c446169fb509cc58$export$350a526055d3ca6e.className = 'Softmax';
(0, $i64bB.serialization).registerClass($c446169fb509cc58$export$350a526055d3ca6e);


/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * TensorFlow.js Layers: Convolutional Layers
 */ 
var $i64bB = parcelRequire("i64bB");









/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ 


function $1e685a09ff935a2e$export$8f561980df117376(value, n, name) {
    if (typeof value === 'number') return (0, $b5cd0926a1c6df1f$export$f24d1f1e6cb42785)(value, n);
    else {
        if (value.length !== n) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`The ${name} argument must be an integer or tuple of ${n} integers.` + ` Received: ${value.length} elements.`);
        for(let i = 0; i < n; ++i){
            const singleValue = value[i];
            if (!(0, $edee0645f45d9428$export$a287f47fed4544b8)(singleValue)) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`The ${name} argument must be an integer or tuple of ${n}` + ` integers. Received: ${JSON.stringify(value)} including a` + ` non-integer number ${singleValue}`);
        }
        return value;
    }
}
function $1e685a09ff935a2e$export$50b0adaed374172(inputLength, filterSize, padding, stride, dilation = 1) {
    if (inputLength == null) return inputLength;
    const dilatedFilterSize = filterSize + (filterSize - 1) * (dilation - 1);
    let outputLength;
    if (padding === 'same') outputLength = inputLength;
    else outputLength = inputLength - dilatedFilterSize + 1;
    return Math.floor((outputLength + stride - 1) / stride);
}
function $1e685a09ff935a2e$export$5a2f093e914c7860(dimSize, strideSize, kernelSize, padding) {
    if (dimSize == null) return null;
    if (padding === 'valid') dimSize = dimSize * strideSize + (0, $edee0645f45d9428$export$8960430cfd85939f)([
        kernelSize - strideSize,
        0
    ]);
    else if (padding === 'same') dimSize = dimSize * strideSize;
    else throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Unsupport padding mode: ${padding}.`);
    return dimSize;
}




function $510b56cd08d87ce7$export$8434bfc73196ab6c(x, dataFormat) {
    // TODO(cais): Cast type to float32 if not.
    return (0, $i64bB.tidy)(()=>{
        (0, $860027d3b2c99a1d$export$f5f6472a2b993816)(dataFormat);
        if (dataFormat === 'channelsFirst') return $i64bB.transpose(x, [
            0,
            2,
            3,
            1
        ]); // NCHW -> NHWC.
        else return x;
    });
}
function $510b56cd08d87ce7$export$4ce11465fb76c4e6(x, dataFormat) {
    return (0, $i64bB.tidy)(()=>{
        (0, $860027d3b2c99a1d$export$f5f6472a2b993816)(dataFormat);
        if (dataFormat === 'channelsFirst') return $i64bB.transpose(x, [
            0,
            2,
            3,
            4,
            1
        ]); // NCDHW -> NDHWC.
        else return x;
    });
}
function $510b56cd08d87ce7$export$5e4c51f717878325(x, kernel, bias, strides = 1, padding = 'valid', dataFormat, dilationRate = 1) {
    return (0, $i64bB.tidy)(()=>{
        if (dataFormat == null) dataFormat = (0, $043e1401aa799097$export$9cb785636e5e0d8)();
        (0, $860027d3b2c99a1d$export$f5f6472a2b993816)(dataFormat);
        // Check the ranks of x, kernel and bias.
        if (x.shape.length !== 3) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`The input of a conv1dWithBias operation should be 3, but is ` + `${x.shape.length} instead.`);
        if (kernel.shape.length !== 3) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`The kernel for a conv1dWithBias operation should be 3, but is ` + `${kernel.shape.length} instead`);
        if (bias != null && bias.shape.length !== 1) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`The bias for a conv1dWithBias operation should be 1, but is ` + `${bias.shape.length} instead`);
        // TODO(cais): Support CAUSAL padding mode.
        if (dataFormat === 'channelsFirst') x = $i64bB.transpose(x, [
            0,
            2,
            1
        ]); // NCW -> NWC.
        if (padding === 'causal') throw new (0, $af476738b120e938$export$e162153238934121)("The support for CAUSAL padding mode in conv1dWithBias is not implemented yet.");
        let y = $i64bB.conv1d(x, kernel, strides, padding === 'same' ? 'same' : 'valid', 'NWC', dilationRate);
        if (bias != null) y = $33b0bdd0433db936$export$917ce53bce63bd4b(y, bias);
        return y;
    });
}
function $510b56cd08d87ce7$export$d8aa844fa36b350e(x, kernel, strides = 1, padding = 'valid', dataFormat, dilationRate = 1) {
    return (0, $i64bB.tidy)(()=>{
        (0, $860027d3b2c99a1d$export$f5f6472a2b993816)(dataFormat);
        return $510b56cd08d87ce7$export$5e4c51f717878325(x, kernel, null, strides, padding, dataFormat, dilationRate);
    });
}
function $510b56cd08d87ce7$export$188f9215482e3db8(x, kernel, strides = [
    1,
    1
], padding = 'valid', dataFormat, dilationRate) {
    return (0, $i64bB.tidy)(()=>{
        (0, $860027d3b2c99a1d$export$f5f6472a2b993816)(dataFormat);
        return $510b56cd08d87ce7$export$8fcf8ce8bb1af9d(x, kernel, null, strides, padding, dataFormat, dilationRate);
    });
}
function $510b56cd08d87ce7$export$8fcf8ce8bb1af9d(x, kernel, bias, strides = [
    1,
    1
], padding = 'valid', dataFormat, dilationRate, activation = null) {
    return (0, $i64bB.tidy)(()=>{
        if (dataFormat == null) dataFormat = (0, $043e1401aa799097$export$9cb785636e5e0d8)();
        (0, $860027d3b2c99a1d$export$f5f6472a2b993816)(dataFormat);
        if (x.rank !== 3 && x.rank !== 4) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`conv2dWithBiasActivation expects input to be of rank 3 or 4, ` + `but received ${x.rank}.`);
        if (kernel.rank !== 3 && kernel.rank !== 4) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`conv2dWithBiasActivation expects kernel to be of rank 3 or 4, ` + `but received ${x.rank}.`);
        let y = $510b56cd08d87ce7$export$8434bfc73196ab6c(x, dataFormat);
        if (padding === 'causal') throw new (0, $af476738b120e938$export$e162153238934121)("The support for CAUSAL padding mode in conv1dWithBias is not implemented yet.");
        y = $i64bB.fused.conv2d({
            x: y,
            filter: kernel,
            strides: strides,
            pad: padding === 'same' ? 'same' : 'valid',
            dilations: dilationRate,
            dataFormat: 'NHWC',
            bias: bias,
            activation: activation
        });
        if (dataFormat === 'channelsFirst') y = $i64bB.transpose(y, [
            0,
            3,
            1,
            2
        ]);
        return y;
    });
}
function $510b56cd08d87ce7$export$c476b02bcf7b2def(x, kernel, strides = [
    1,
    1,
    1
], padding = 'valid', dataFormat, dilationRate) {
    return (0, $i64bB.tidy)(()=>{
        (0, $860027d3b2c99a1d$export$f5f6472a2b993816)(dataFormat);
        return $510b56cd08d87ce7$export$cffde359467c6702(x, kernel, null, strides, padding, dataFormat, dilationRate);
    });
}
function $510b56cd08d87ce7$export$cffde359467c6702(x, kernel, bias, strides = [
    1,
    1,
    1
], padding = 'valid', dataFormat, dilationRate) {
    return (0, $i64bB.tidy)(()=>{
        if (dataFormat == null) dataFormat = (0, $043e1401aa799097$export$9cb785636e5e0d8)();
        (0, $860027d3b2c99a1d$export$f5f6472a2b993816)(dataFormat);
        if (x.rank !== 4 && x.rank !== 5) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`conv3dWithBias expects input to be of rank 4 or 5, but received ` + `${x.rank}.`);
        if (kernel.rank !== 4 && kernel.rank !== 5) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`conv3dWithBias expects kernel to be of rank 4 or 5, but received ` + `${x.rank}.`);
        let y = $510b56cd08d87ce7$export$4ce11465fb76c4e6(x, dataFormat);
        if (padding === 'causal') throw new (0, $af476738b120e938$export$e162153238934121)("The support for CAUSAL padding mode in conv3dWithBias is not implemented yet.");
        y = $i64bB.conv3d(y, kernel, strides, padding === 'same' ? 'same' : 'valid', 'NDHWC', dilationRate);
        if (bias != null) y = $33b0bdd0433db936$export$917ce53bce63bd4b(y, bias);
        if (dataFormat === 'channelsFirst') y = $i64bB.transpose(y, [
            0,
            4,
            1,
            2,
            3
        ]);
        return y;
    });
}
class $510b56cd08d87ce7$export$ed9aa941a71a9fd2 extends (0, $03271f6b4e448384$export$936d0764594b6eb3) {
    constructor(rank, args){
        super(args);
        this.bias = null;
        this.DEFAULT_KERNEL_INITIALIZER = 'glorotNormal';
        this.DEFAULT_BIAS_INITIALIZER = 'zeros';
        $510b56cd08d87ce7$export$ed9aa941a71a9fd2.verifyArgs(args);
        this.rank = rank;
        $b5cd0926a1c6df1f$export$7ac3b6580cbed983(this.rank, 'rank');
        if (this.rank !== 1 && this.rank !== 2 && this.rank !== 3) throw new (0, $af476738b120e938$export$e162153238934121)(`Convolution layer for rank other than 1, 2, or 3 (${this.rank}) is ` + `not implemented yet.`);
        this.kernelSize = (0, $1e685a09ff935a2e$export$8f561980df117376)(args.kernelSize, rank, 'kernelSize');
        this.strides = (0, $1e685a09ff935a2e$export$8f561980df117376)(args.strides == null ? 1 : args.strides, rank, 'strides');
        this.padding = args.padding == null ? 'valid' : args.padding;
        (0, $860027d3b2c99a1d$export$a6c1e84f1d33d64d)(this.padding);
        this.dataFormat = args.dataFormat == null ? 'channelsLast' : args.dataFormat;
        (0, $860027d3b2c99a1d$export$f5f6472a2b993816)(this.dataFormat);
        this.activation = (0, $30ca3c776e202113$export$ed84f867ffcf9364)(args.activation);
        this.useBias = args.useBias == null ? true : args.useBias;
        this.biasInitializer = (0, $49135dd97e6043ca$export$558b7d1a338df84b)(args.biasInitializer || this.DEFAULT_BIAS_INITIALIZER);
        this.biasConstraint = (0, $ef279f7fc82ac2a7$export$492f40394cb58978)(args.biasConstraint);
        this.biasRegularizer = (0, $030044d54dc1235d$export$b3404716bfee324c)(args.biasRegularizer);
        this.activityRegularizer = (0, $030044d54dc1235d$export$b3404716bfee324c)(args.activityRegularizer);
        this.dilationRate = (0, $1e685a09ff935a2e$export$8f561980df117376)(args.dilationRate == null ? 1 : args.dilationRate, rank, 'dilationRate');
        if (this.rank === 1 && Array.isArray(this.dilationRate) && this.dilationRate.length !== 1) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`dilationRate must be a number or an array of a single number ` + `for 1D convolution, but received ` + `${JSON.stringify(this.dilationRate)}`);
        else if (this.rank === 2) {
            if (typeof this.dilationRate === 'number') this.dilationRate = [
                this.dilationRate,
                this.dilationRate
            ];
            else if (this.dilationRate.length !== 2) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`dilationRate must be a number or array of two numbers for 2D ` + `convolution, but received ${JSON.stringify(this.dilationRate)}`);
        } else if (this.rank === 3) {
            if (typeof this.dilationRate === 'number') this.dilationRate = [
                this.dilationRate,
                this.dilationRate,
                this.dilationRate
            ];
            else if (this.dilationRate.length !== 3) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`dilationRate must be a number or array of three numbers for 3D ` + `convolution, but received ${JSON.stringify(this.dilationRate)}`);
        }
    }
    static verifyArgs(args) {
        // Check config.kernelSize type and shape.
        $b5cd0926a1c6df1f$export$a7a9523472993e97('kernelSize' in args, `required key 'kernelSize' not in config`);
        if (typeof args.kernelSize !== 'number' && !$b5cd0926a1c6df1f$export$9c1c2eaf0ddbb1d3(args.kernelSize, 'number', 1, 3)) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`BaseConv expects config.kernelSize to be number or number[] with ` + `length 1, 2, or 3, but received ${JSON.stringify(args.kernelSize)}.`);
    }
    getConfig() {
        const config = {
            kernelSize: this.kernelSize,
            strides: this.strides,
            padding: this.padding,
            dataFormat: this.dataFormat,
            dilationRate: this.dilationRate,
            activation: (0, $30ca3c776e202113$export$8a2c1643c67d0487)(this.activation),
            useBias: this.useBias,
            biasInitializer: (0, $49135dd97e6043ca$export$68de06a18c23bdbc)(this.biasInitializer),
            biasRegularizer: (0, $030044d54dc1235d$export$7e8cf5899b350405)(this.biasRegularizer),
            activityRegularizer: (0, $030044d54dc1235d$export$7e8cf5899b350405)(this.activityRegularizer),
            biasConstraint: (0, $ef279f7fc82ac2a7$export$e449710617725987)(this.biasConstraint)
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
class $510b56cd08d87ce7$export$d9f5537266743215 extends $510b56cd08d87ce7$export$ed9aa941a71a9fd2 {
    constructor(rank, args){
        super(rank, args);
        this.kernel = null;
        $510b56cd08d87ce7$export$d9f5537266743215.verifyArgs(args);
        this.filters = args.filters;
        $b5cd0926a1c6df1f$export$7ac3b6580cbed983(this.filters, 'filters');
        this.kernelInitializer = (0, $49135dd97e6043ca$export$558b7d1a338df84b)(args.kernelInitializer || this.DEFAULT_KERNEL_INITIALIZER);
        this.kernelConstraint = (0, $ef279f7fc82ac2a7$export$492f40394cb58978)(args.kernelConstraint);
        this.kernelRegularizer = (0, $030044d54dc1235d$export$b3404716bfee324c)(args.kernelRegularizer);
    }
    build(inputShape) {
        inputShape = (0, $e11ae28082970f77$export$25c35af872e8abca)(inputShape);
        const channelAxis = this.dataFormat === 'channelsFirst' ? 1 : inputShape.length - 1;
        if (inputShape[channelAxis] == null) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`The channel dimension of the input should be defined. ` + `Found ${inputShape[channelAxis]}`);
        const inputDim = inputShape[channelAxis];
        const kernelShape = this.kernelSize.concat([
            inputDim,
            this.filters
        ]);
        this.kernel = this.addWeight('kernel', kernelShape, null, this.kernelInitializer, this.kernelRegularizer, true, this.kernelConstraint);
        if (this.useBias) this.bias = this.addWeight('bias', [
            this.filters
        ], null, this.biasInitializer, this.biasRegularizer, true, this.biasConstraint);
        this.inputSpec = [
            {
                ndim: this.rank + 2,
                axes: {
                    [channelAxis]: inputDim
                }
            }
        ];
        this.built = true;
    }
    call(inputs, kwargs) {
        return (0, $i64bB.tidy)(()=>{
            inputs = (0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs);
            let outputs;
            const biasValue = this.bias == null ? null : this.bias.read();
            const fusedActivationName = $b5cd0926a1c6df1f$export$aa3e0e68e0c6329f(this.activation.getClassName());
            if (fusedActivationName != null && this.rank === 2) outputs = $510b56cd08d87ce7$export$8fcf8ce8bb1af9d(inputs, this.kernel.read(), biasValue, this.strides, this.padding, this.dataFormat, this.dilationRate, fusedActivationName);
            else {
                if (this.rank === 1) outputs = $510b56cd08d87ce7$export$5e4c51f717878325(inputs, this.kernel.read(), biasValue, this.strides[0], this.padding, this.dataFormat, this.dilationRate[0]);
                else if (this.rank === 2) // TODO(cais): Move up to constructor.
                outputs = $510b56cd08d87ce7$export$8fcf8ce8bb1af9d(inputs, this.kernel.read(), biasValue, this.strides, this.padding, this.dataFormat, this.dilationRate);
                else if (this.rank === 3) outputs = $510b56cd08d87ce7$export$cffde359467c6702(inputs, this.kernel.read(), biasValue, this.strides, this.padding, this.dataFormat, this.dilationRate);
                else throw new (0, $af476738b120e938$export$e162153238934121)('convolutions greater than 3D are not implemented yet.');
                if (this.activation != null) outputs = this.activation.apply(outputs);
            }
            return outputs;
        });
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $e11ae28082970f77$export$25c35af872e8abca)(inputShape);
        const newSpace = [];
        const space = this.dataFormat === 'channelsLast' ? inputShape.slice(1, inputShape.length - 1) : inputShape.slice(2);
        for(let i = 0; i < space.length; ++i){
            const newDim = (0, $1e685a09ff935a2e$export$50b0adaed374172)(space[i], this.kernelSize[i], this.padding, this.strides[i], typeof this.dilationRate === 'number' ? this.dilationRate : this.dilationRate[i]);
            newSpace.push(newDim);
        }
        let outputShape = [
            inputShape[0]
        ];
        if (this.dataFormat === 'channelsLast') {
            outputShape = outputShape.concat(newSpace);
            outputShape.push(this.filters);
        } else {
            outputShape.push(this.filters);
            outputShape = outputShape.concat(newSpace);
        }
        return outputShape;
    }
    getConfig() {
        const config = {
            filters: this.filters,
            kernelInitializer: (0, $49135dd97e6043ca$export$68de06a18c23bdbc)(this.kernelInitializer),
            kernelRegularizer: (0, $030044d54dc1235d$export$7e8cf5899b350405)(this.kernelRegularizer),
            kernelConstraint: (0, $ef279f7fc82ac2a7$export$e449710617725987)(this.kernelConstraint)
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
    static verifyArgs(args) {
        // Check config.filters type, shape, and value.
        if (!('filters' in args) || typeof args.filters !== 'number' || args.filters < 1) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Convolution layer expected config.filters to be a 'number' > 0 ` + `but got ${JSON.stringify(args.filters)}`);
    }
}
class $510b56cd08d87ce7$export$57742e605d475795 extends $510b56cd08d87ce7$export$d9f5537266743215 {
    constructor(args){
        super(2, args);
        $510b56cd08d87ce7$export$57742e605d475795.verifyArgs(args);
    }
    getConfig() {
        const config = super.getConfig();
        delete config['rank'];
        return config;
    }
    static verifyArgs(args) {
        // config.kernelSize must be a number or array of numbers.
        if (typeof args.kernelSize !== 'number' && !$b5cd0926a1c6df1f$export$9c1c2eaf0ddbb1d3(args.kernelSize, 'number', 1, 2)) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Conv2D expects config.kernelSize to be number or number[] with ` + `length 1 or 2, but received ${JSON.stringify(args.kernelSize)}.`);
    }
}
/** @nocollapse */ $510b56cd08d87ce7$export$57742e605d475795.className = 'Conv2D';
(0, $i64bB.serialization).registerClass($510b56cd08d87ce7$export$57742e605d475795);
class $510b56cd08d87ce7$export$9d3874201dd21933 extends $510b56cd08d87ce7$export$d9f5537266743215 {
    constructor(args){
        super(3, args);
        $510b56cd08d87ce7$export$9d3874201dd21933.verifyArgs(args);
    }
    getConfig() {
        const config = super.getConfig();
        delete config['rank'];
        return config;
    }
    static verifyArgs(args) {
        // config.kernelSize must be a number or array of numbers.
        if (typeof args.kernelSize !== 'number') {
            if (!(Array.isArray(args.kernelSize) && (args.kernelSize.length === 1 || args.kernelSize.length === 3))) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Conv3D expects config.kernelSize to be number or` + ` [number, number, number], but received ${JSON.stringify(args.kernelSize)}.`);
        }
    }
}
/** @nocollapse */ $510b56cd08d87ce7$export$9d3874201dd21933.className = 'Conv3D';
(0, $i64bB.serialization).registerClass($510b56cd08d87ce7$export$9d3874201dd21933);
class $510b56cd08d87ce7$export$7dbaf9916b0932fc extends $510b56cd08d87ce7$export$57742e605d475795 {
    constructor(args){
        super(args);
        this.inputSpec = [
            new (0, $03271f6b4e448384$export$7705ee67def9d40a)({
                ndim: 4
            })
        ];
        if (this.padding !== 'same' && this.padding !== 'valid') throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Conv2DTranspose currently supports only padding modes 'same' ` + `and 'valid', but received padding mode ${this.padding}`);
    }
    build(inputShape) {
        inputShape = (0, $e11ae28082970f77$export$25c35af872e8abca)(inputShape);
        if (inputShape.length !== 4) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)('Input should have rank 4; Received input shape: ' + JSON.stringify(inputShape));
        const channelAxis = this.dataFormat === 'channelsFirst' ? 1 : inputShape.length - 1;
        if (inputShape[channelAxis] == null) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)("The channel dimension of the inputs should be defined. Found `None`.");
        const inputDim = inputShape[channelAxis];
        const kernelShape = this.kernelSize.concat([
            this.filters,
            inputDim
        ]);
        this.kernel = this.addWeight('kernel', kernelShape, 'float32', this.kernelInitializer, this.kernelRegularizer, true, this.kernelConstraint);
        if (this.useBias) this.bias = this.addWeight('bias', [
            this.filters
        ], 'float32', this.biasInitializer, this.biasRegularizer, true, this.biasConstraint);
        // Set input spec.
        this.inputSpec = [
            new (0, $03271f6b4e448384$export$7705ee67def9d40a)({
                ndim: 4,
                axes: {
                    [channelAxis]: inputDim
                }
            })
        ];
        this.built = true;
    }
    call(inputs, kwargs) {
        return $i64bB.tidy(()=>{
            let input = (0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs);
            if (input.shape.length !== 4) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Conv2DTranspose.call() expects input tensor to be rank-4, but ` + `received a tensor of rank-${input.shape.length}`);
            const inputShape = input.shape;
            const batchSize = inputShape[0];
            let hAxis;
            let wAxis;
            if (this.dataFormat === 'channelsFirst') {
                hAxis = 2;
                wAxis = 3;
            } else {
                hAxis = 1;
                wAxis = 2;
            }
            const height = inputShape[hAxis];
            const width = inputShape[wAxis];
            const kernelH = this.kernelSize[0];
            const kernelW = this.kernelSize[1];
            const strideH = this.strides[0];
            const strideW = this.strides[1];
            // Infer the dynamic output shape.
            const outHeight = (0, $1e685a09ff935a2e$export$5a2f093e914c7860)(height, strideH, kernelH, this.padding);
            const outWidth = (0, $1e685a09ff935a2e$export$5a2f093e914c7860)(width, strideW, kernelW, this.padding);
            // Porting Note: We don't branch based on `this.dataFormat` here,
            // because
            //   the tjfs-core function `conv2dTranspose` called below always
            //   assumes channelsLast.
            const outputShape = [
                batchSize,
                outHeight,
                outWidth,
                this.filters
            ];
            if (this.dataFormat !== 'channelsLast') input = $i64bB.transpose(input, [
                0,
                2,
                3,
                1
            ]);
            let outputs = $i64bB.conv2dTranspose(input, this.kernel.read(), outputShape, this.strides, this.padding);
            if (this.dataFormat !== 'channelsLast') outputs = $i64bB.transpose(outputs, [
                0,
                3,
                1,
                2
            ]);
            if (this.bias != null) outputs = $33b0bdd0433db936$export$917ce53bce63bd4b(outputs, this.bias.read(), this.dataFormat);
            if (this.activation != null) outputs = this.activation.apply(outputs);
            return outputs;
        });
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $e11ae28082970f77$export$25c35af872e8abca)(inputShape);
        const outputShape = inputShape.slice();
        let channelAxis;
        let heightAxis;
        let widthAxis;
        if (this.dataFormat === 'channelsFirst') {
            channelAxis = 1;
            heightAxis = 2;
            widthAxis = 3;
        } else {
            channelAxis = 3;
            heightAxis = 1;
            widthAxis = 2;
        }
        const kernelH = this.kernelSize[0];
        const kernelW = this.kernelSize[1];
        const strideH = this.strides[0];
        const strideW = this.strides[1];
        outputShape[channelAxis] = this.filters;
        outputShape[heightAxis] = (0, $1e685a09ff935a2e$export$5a2f093e914c7860)(outputShape[heightAxis], strideH, kernelH, this.padding);
        outputShape[widthAxis] = (0, $1e685a09ff935a2e$export$5a2f093e914c7860)(outputShape[widthAxis], strideW, kernelW, this.padding);
        return outputShape;
    }
    getConfig() {
        const config = super.getConfig();
        delete config['dilationRate'];
        return config;
    }
}
/** @nocollapse */ $510b56cd08d87ce7$export$7dbaf9916b0932fc.className = 'Conv2DTranspose';
(0, $i64bB.serialization).registerClass($510b56cd08d87ce7$export$7dbaf9916b0932fc);
class $510b56cd08d87ce7$export$56aa8cf0209e38c1 extends $510b56cd08d87ce7$export$9d3874201dd21933 {
    constructor(args){
        super(args);
        this.inputSpec = [
            new (0, $03271f6b4e448384$export$7705ee67def9d40a)({
                ndim: 5
            })
        ];
        if (this.padding !== 'same' && this.padding !== 'valid') throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Conv3DTranspose currently supports only padding modes 'same' ` + `and 'valid', but received padding mode ${this.padding}`);
    }
    build(inputShape) {
        inputShape = (0, $e11ae28082970f77$export$25c35af872e8abca)(inputShape);
        if (inputShape.length !== 5) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)('Input should have rank 5; Received input shape: ' + JSON.stringify(inputShape));
        const channelAxis = this.dataFormat === 'channelsFirst' ? 1 : inputShape.length - 1;
        if (inputShape[channelAxis] == null) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)("The channel dimension of the inputs should be defined. Found `None`.");
        const inputDim = inputShape[channelAxis];
        const kernelShape = this.kernelSize.concat([
            this.filters,
            inputDim
        ]);
        this.kernel = this.addWeight('kernel', kernelShape, 'float32', this.kernelInitializer, this.kernelRegularizer, true, this.kernelConstraint);
        if (this.useBias) this.bias = this.addWeight('bias', [
            this.filters
        ], 'float32', this.biasInitializer, this.biasRegularizer, true, this.biasConstraint);
        // Set input spec.
        this.inputSpec = [
            new (0, $03271f6b4e448384$export$7705ee67def9d40a)({
                ndim: 5,
                axes: {
                    [channelAxis]: inputDim
                }
            })
        ];
        this.built = true;
    }
    call(inputs, kwargs) {
        return $i64bB.tidy(()=>{
            let input = (0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs);
            if (input.shape.length !== 5) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Conv3DTranspose.call() expects input tensor to be rank-4, but ` + `received a tensor of rank-${input.shape.length}`);
            const inputShape = input.shape;
            const batchSize = inputShape[0];
            let hAxis;
            let wAxis;
            let dAxis;
            if (this.dataFormat === 'channelsFirst') {
                dAxis = 2;
                hAxis = 3;
                wAxis = 4;
            } else {
                dAxis = 1;
                hAxis = 2;
                wAxis = 3;
            }
            const depth = inputShape[dAxis];
            const height = inputShape[hAxis];
            const width = inputShape[wAxis];
            const kernelD = this.kernelSize[0];
            const kernelH = this.kernelSize[1];
            const kernelW = this.kernelSize[2];
            const strideD = this.strides[0];
            const strideH = this.strides[1];
            const strideW = this.strides[2];
            // Infer the dynamic output shape.
            const outDepth = (0, $1e685a09ff935a2e$export$5a2f093e914c7860)(depth, strideD, kernelD, this.padding);
            const outHeight = (0, $1e685a09ff935a2e$export$5a2f093e914c7860)(height, strideH, kernelH, this.padding);
            const outWidth = (0, $1e685a09ff935a2e$export$5a2f093e914c7860)(width, strideW, kernelW, this.padding);
            // Same as `conv2dTranspose`. We always assumes channelsLast.
            const outputShape = [
                batchSize,
                outDepth,
                outHeight,
                outWidth,
                this.filters
            ];
            if (this.dataFormat !== 'channelsLast') input = $i64bB.transpose(input, [
                0,
                2,
                3,
                4,
                1
            ]);
            let outputs = $i64bB.conv3dTranspose(input, this.kernel.read(), outputShape, this.strides, this.padding);
            if (this.dataFormat !== 'channelsLast') outputs = $i64bB.transpose(outputs, [
                0,
                4,
                1,
                2,
                3
            ]);
            if (this.bias !== null) outputs = $33b0bdd0433db936$export$917ce53bce63bd4b(outputs, this.bias.read(), this.dataFormat);
            if (this.activation !== null) outputs = this.activation.apply(outputs);
            return outputs;
        });
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $e11ae28082970f77$export$25c35af872e8abca)(inputShape);
        const outputShape = inputShape.slice();
        let channelAxis;
        let depthAxis;
        let heightAxis;
        let widthAxis;
        if (this.dataFormat === 'channelsFirst') {
            channelAxis = 1;
            depthAxis = 2;
            heightAxis = 3;
            widthAxis = 4;
        } else {
            channelAxis = 4;
            depthAxis = 1;
            heightAxis = 2;
            widthAxis = 3;
        }
        const kernelD = this.kernelSize[0];
        const kernelH = this.kernelSize[1];
        const kernelW = this.kernelSize[2];
        const strideD = this.strides[0];
        const strideH = this.strides[1];
        const strideW = this.strides[2];
        outputShape[channelAxis] = this.filters;
        outputShape[depthAxis] = (0, $1e685a09ff935a2e$export$5a2f093e914c7860)(outputShape[depthAxis], strideD, kernelD, this.padding);
        outputShape[heightAxis] = (0, $1e685a09ff935a2e$export$5a2f093e914c7860)(outputShape[heightAxis], strideH, kernelH, this.padding);
        outputShape[widthAxis] = (0, $1e685a09ff935a2e$export$5a2f093e914c7860)(outputShape[widthAxis], strideW, kernelW, this.padding);
        return outputShape;
    }
    getConfig() {
        const config = super.getConfig();
        delete config['dilationRate'];
        return config;
    }
}
/** @nocollapse */ $510b56cd08d87ce7$export$56aa8cf0209e38c1.className = 'Conv3DTranspose';
(0, $i64bB.serialization).registerClass($510b56cd08d87ce7$export$56aa8cf0209e38c1);
class $510b56cd08d87ce7$export$1b7b94ed9bbc01d1 extends $510b56cd08d87ce7$export$d9f5537266743215 {
    constructor(rank, config){
        super(rank, config);
        this.DEFAULT_DEPTHWISE_INITIALIZER = 'glorotUniform';
        this.DEFAULT_POINTWISE_INITIALIZER = 'glorotUniform';
        this.depthwiseKernel = null;
        this.pointwiseKernel = null;
        if (config.filters == null) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)("The `filters` configuration field is required by SeparableConv, but is unspecified.");
        if (config.kernelInitializer != null || config.kernelRegularizer != null || config.kernelConstraint != null) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)("Fields kernelInitializer, kernelRegularizer and kernelConstraint are invalid for SeparableConv2D. Use depthwiseInitializer, depthwiseRegularizer, depthwiseConstraint, pointwiseInitializer, pointwiseRegularizer and pointwiseConstraint instead.");
        if (config.padding != null && config.padding !== 'same' && config.padding !== 'valid') throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`SeparableConv${this.rank}D supports only padding modes: ` + `'same' and 'valid', but received ${JSON.stringify(config.padding)}`);
        this.depthMultiplier = config.depthMultiplier == null ? 1 : config.depthMultiplier;
        this.depthwiseInitializer = (0, $49135dd97e6043ca$export$558b7d1a338df84b)(config.depthwiseInitializer || this.DEFAULT_DEPTHWISE_INITIALIZER);
        this.depthwiseRegularizer = (0, $030044d54dc1235d$export$b3404716bfee324c)(config.depthwiseRegularizer);
        this.depthwiseConstraint = (0, $ef279f7fc82ac2a7$export$492f40394cb58978)(config.depthwiseConstraint);
        this.pointwiseInitializer = (0, $49135dd97e6043ca$export$558b7d1a338df84b)(config.depthwiseInitializer || this.DEFAULT_POINTWISE_INITIALIZER);
        this.pointwiseRegularizer = (0, $030044d54dc1235d$export$b3404716bfee324c)(config.pointwiseRegularizer);
        this.pointwiseConstraint = (0, $ef279f7fc82ac2a7$export$492f40394cb58978)(config.pointwiseConstraint);
    }
    build(inputShape) {
        inputShape = (0, $e11ae28082970f77$export$25c35af872e8abca)(inputShape);
        if (inputShape.length < this.rank + 2) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Inputs to SeparableConv${this.rank}D should have rank ` + `${this.rank + 2}, but received input shape: ` + `${JSON.stringify(inputShape)}`);
        const channelAxis = this.dataFormat === 'channelsFirst' ? 1 : inputShape.length - 1;
        if (inputShape[channelAxis] == null || inputShape[channelAxis] < 0) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`The channel dimension of the inputs should be defined, ` + `but found ${JSON.stringify(inputShape[channelAxis])}`);
        const inputDim = inputShape[channelAxis];
        const depthwiseKernelShape = this.kernelSize.concat([
            inputDim,
            this.depthMultiplier
        ]);
        const pointwiseKernelShape = [];
        for(let i = 0; i < this.rank; ++i)pointwiseKernelShape.push(1);
        pointwiseKernelShape.push(inputDim * this.depthMultiplier, this.filters);
        const trainable = true;
        this.depthwiseKernel = this.addWeight('depthwise_kernel', depthwiseKernelShape, 'float32', this.depthwiseInitializer, this.depthwiseRegularizer, trainable, this.depthwiseConstraint);
        this.pointwiseKernel = this.addWeight('pointwise_kernel', pointwiseKernelShape, 'float32', this.pointwiseInitializer, this.pointwiseRegularizer, trainable, this.pointwiseConstraint);
        if (this.useBias) this.bias = this.addWeight('bias', [
            this.filters
        ], 'float32', this.biasInitializer, this.biasRegularizer, trainable, this.biasConstraint);
        else this.bias = null;
        this.inputSpec = [
            new (0, $03271f6b4e448384$export$7705ee67def9d40a)({
                ndim: this.rank + 2,
                axes: {
                    [channelAxis]: inputDim
                }
            })
        ];
        this.built = true;
    }
    call(inputs, kwargs) {
        return (0, $i64bB.tidy)(()=>{
            inputs = (0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs);
            let output;
            if (this.rank === 1) throw new (0, $af476738b120e938$export$e162153238934121)('1D separable convolution is not implemented yet.');
            else if (this.rank === 2) {
                if (this.dataFormat === 'channelsFirst') inputs = $i64bB.transpose(inputs, [
                    0,
                    2,
                    3,
                    1
                ]); // NCHW -> NHWC.
                output = $i64bB.separableConv2d(inputs, this.depthwiseKernel.read(), this.pointwiseKernel.read(), this.strides, this.padding, this.dilationRate, 'NHWC');
            }
            if (this.useBias) output = $33b0bdd0433db936$export$917ce53bce63bd4b(output, this.bias.read(), this.dataFormat);
            if (this.activation != null) output = this.activation.apply(output);
            if (this.dataFormat === 'channelsFirst') output = $i64bB.transpose(output, [
                0,
                3,
                1,
                2
            ]); // NHWC -> NCHW.
            return output;
        });
    }
    getConfig() {
        const config = super.getConfig();
        delete config['rank'];
        delete config['kernelInitializer'];
        delete config['kernelRegularizer'];
        delete config['kernelConstraint'];
        config['depthwiseInitializer'] = (0, $49135dd97e6043ca$export$68de06a18c23bdbc)(this.depthwiseInitializer);
        config['pointwiseInitializer'] = (0, $49135dd97e6043ca$export$68de06a18c23bdbc)(this.pointwiseInitializer);
        config['depthwiseRegularizer'] = (0, $030044d54dc1235d$export$7e8cf5899b350405)(this.depthwiseRegularizer);
        config['pointwiseRegularizer'] = (0, $030044d54dc1235d$export$7e8cf5899b350405)(this.pointwiseRegularizer);
        config['depthwiseConstraint'] = (0, $ef279f7fc82ac2a7$export$e449710617725987)(this.depthwiseConstraint);
        config['pointwiseConstraint'] = (0, $ef279f7fc82ac2a7$export$e449710617725987)(this.pointwiseConstraint);
        return config;
    }
}
/** @nocollapse */ $510b56cd08d87ce7$export$1b7b94ed9bbc01d1.className = 'SeparableConv';
class $510b56cd08d87ce7$export$711e1c2609c1fbb3 extends $510b56cd08d87ce7$export$1b7b94ed9bbc01d1 {
    constructor(args){
        super(2, args);
    }
}
/** @nocollapse */ $510b56cd08d87ce7$export$711e1c2609c1fbb3.className = 'SeparableConv2D';
(0, $i64bB.serialization).registerClass($510b56cd08d87ce7$export$711e1c2609c1fbb3);
class $510b56cd08d87ce7$export$34a445ae5c2580eb extends $510b56cd08d87ce7$export$d9f5537266743215 {
    constructor(args){
        super(1, args);
        $510b56cd08d87ce7$export$34a445ae5c2580eb.verifyArgs(args);
        this.inputSpec = [
            {
                ndim: 3
            }
        ];
    }
    getConfig() {
        const config = super.getConfig();
        delete config['rank'];
        delete config['dataFormat'];
        return config;
    }
    static verifyArgs(args) {
        // config.kernelSize must be a number or array of numbers.
        if (typeof args.kernelSize !== 'number' && !$b5cd0926a1c6df1f$export$9c1c2eaf0ddbb1d3(args.kernelSize, 'number', 1, 1)) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Conv1D expects config.kernelSize to be number or number[] with ` + `length 1, but received ${JSON.stringify(args.kernelSize)}.`);
    }
}
/** @nocollapse */ $510b56cd08d87ce7$export$34a445ae5c2580eb.className = 'Conv1D';
(0, $i64bB.serialization).registerClass($510b56cd08d87ce7$export$34a445ae5c2580eb);
class $510b56cd08d87ce7$export$8c24c9344a3b8089 extends (0, $03271f6b4e448384$export$936d0764594b6eb3) {
    constructor(args){
        super(args);
        if (typeof args.cropping === 'number') this.cropping = [
            [
                args.cropping,
                args.cropping
            ],
            [
                args.cropping,
                args.cropping
            ]
        ];
        else if (typeof args.cropping[0] === 'number') this.cropping = [
            [
                args.cropping[0],
                args.cropping[0]
            ],
            [
                args.cropping[1],
                args.cropping[1]
            ]
        ];
        else this.cropping = args.cropping;
        this.dataFormat = args.dataFormat === undefined ? 'channelsLast' : args.dataFormat;
        this.inputSpec = [
            {
                ndim: 4
            }
        ];
    }
    computeOutputShape(inputShape) {
        if (this.dataFormat === 'channelsFirst') return [
            inputShape[0],
            inputShape[1],
            inputShape[2] - this.cropping[0][0] - this.cropping[0][1],
            inputShape[3] - this.cropping[1][0] - this.cropping[1][1]
        ];
        else return [
            inputShape[0],
            inputShape[1] - this.cropping[0][0] - this.cropping[0][1],
            inputShape[2] - this.cropping[1][0] - this.cropping[1][1],
            inputShape[3]
        ];
    }
    call(inputs, kwargs) {
        return (0, $i64bB.tidy)(()=>{
            inputs = (0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs);
            if (this.dataFormat === 'channelsLast') {
                const hSliced = $33b0bdd0433db936$export$4f25f657b7083746(inputs, this.cropping[0][0], inputs.shape[1] - this.cropping[0][0] - this.cropping[0][1], 2);
                return $33b0bdd0433db936$export$4f25f657b7083746(hSliced, this.cropping[1][0], inputs.shape[2] - this.cropping[1][1] - this.cropping[1][0], 3);
            } else {
                const hSliced = $33b0bdd0433db936$export$4f25f657b7083746(inputs, this.cropping[0][0], inputs.shape[2] - this.cropping[0][0] - this.cropping[0][1], 3);
                return $33b0bdd0433db936$export$4f25f657b7083746(hSliced, this.cropping[1][0], inputs.shape[3] - this.cropping[1][1] - this.cropping[1][0], 4);
            }
        });
    }
    getConfig() {
        const config = {
            cropping: this.cropping,
            dataFormat: this.dataFormat
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $510b56cd08d87ce7$export$8c24c9344a3b8089.className = 'Cropping2D';
(0, $i64bB.serialization).registerClass($510b56cd08d87ce7$export$8c24c9344a3b8089);
class $510b56cd08d87ce7$export$4b8be6e684923935 extends (0, $03271f6b4e448384$export$936d0764594b6eb3) {
    constructor(args){
        super(args);
        this.DEFAULT_SIZE = [
            2,
            2
        ];
        this.inputSpec = [
            {
                ndim: 4
            }
        ];
        this.size = args.size == null ? this.DEFAULT_SIZE : args.size;
        this.dataFormat = args.dataFormat == null ? 'channelsLast' : args.dataFormat;
        (0, $860027d3b2c99a1d$export$f5f6472a2b993816)(this.dataFormat);
        this.interpolation = args.interpolation == null ? 'nearest' : args.interpolation;
        (0, $860027d3b2c99a1d$export$2c8c51ca0cb16cd2)(this.interpolation);
    }
    computeOutputShape(inputShape) {
        if (this.dataFormat === 'channelsFirst') {
            const height = inputShape[2] == null ? null : this.size[0] * inputShape[2];
            const width = inputShape[3] == null ? null : this.size[1] * inputShape[3];
            return [
                inputShape[0],
                inputShape[1],
                height,
                width
            ];
        } else {
            const height = inputShape[1] == null ? null : this.size[0] * inputShape[1];
            const width = inputShape[2] == null ? null : this.size[1] * inputShape[2];
            return [
                inputShape[0],
                height,
                width,
                inputShape[3]
            ];
        }
    }
    call(inputs, kwargs) {
        return $i64bB.tidy(()=>{
            let input = (0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs);
            const inputShape = input.shape;
            if (this.dataFormat === 'channelsFirst') {
                input = $i64bB.transpose(input, [
                    0,
                    2,
                    3,
                    1
                ]);
                const height = this.size[0] * inputShape[2];
                const width = this.size[1] * inputShape[3];
                const resized = this.interpolation === 'nearest' ? $i64bB.image.resizeNearestNeighbor(input, [
                    height,
                    width
                ]) : $i64bB.image.resizeBilinear(input, [
                    height,
                    width
                ]);
                return $i64bB.transpose(resized, [
                    0,
                    3,
                    1,
                    2
                ]);
            } else {
                const height = this.size[0] * inputShape[1];
                const width = this.size[1] * inputShape[2];
                return this.interpolation === 'nearest' ? $i64bB.image.resizeNearestNeighbor(input, [
                    height,
                    width
                ]) : $i64bB.image.resizeBilinear(input, [
                    height,
                    width
                ]);
            }
        });
    }
    getConfig() {
        const config = {
            size: this.size,
            dataFormat: this.dataFormat,
            interpolation: this.interpolation
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $510b56cd08d87ce7$export$4b8be6e684923935.className = 'UpSampling2D';
(0, $i64bB.serialization).registerClass($510b56cd08d87ce7$export$4b8be6e684923935);


/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * TensorFlow.js Layers: Depthwise Convolutional Layers
 */ 
var $i64bB = parcelRequire("i64bB");










function $9ed43e21c47c0ee3$export$48a8ad9494a8fad8(x, depthwiseKernel, strides = [
    1,
    1
], padding = 'valid', dataFormat, dilationRate) {
    return (0, $i64bB.tidy)(()=>{
        if (dataFormat == null) dataFormat = (0, $043e1401aa799097$export$9cb785636e5e0d8)();
        (0, $860027d3b2c99a1d$export$f5f6472a2b993816)(dataFormat);
        let y = (0, $510b56cd08d87ce7$export$8434bfc73196ab6c)(x, dataFormat);
        if (x.rank !== 4) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Input for depthwiseConv2d is required to be 4-D, but is instead ` + `${x.rank}-D`);
        if (depthwiseKernel.rank !== 4) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`depthwiseKernel is required to be 4-D, but is instead ` + `${depthwiseKernel.rank}-D`);
        y = $i64bB.depthwiseConv2d(y, depthwiseKernel, strides, padding === 'same' ? 'same' : 'valid', 'NHWC', dilationRate);
        if (dataFormat === 'channelsFirst') y = $i64bB.transpose(y, [
            0,
            3,
            1,
            2
        ]);
        return y;
    });
}
class $9ed43e21c47c0ee3$export$292dab92c4661cc4 extends (0, $510b56cd08d87ce7$export$ed9aa941a71a9fd2) {
    constructor(args){
        super(2, args);
        this.depthwiseKernel = null;
        this.depthMultiplier = args.depthMultiplier == null ? 1 : args.depthMultiplier;
        this.depthwiseInitializer = (0, $49135dd97e6043ca$export$558b7d1a338df84b)(args.depthwiseInitializer || this.DEFAULT_KERNEL_INITIALIZER);
        this.depthwiseConstraint = (0, $ef279f7fc82ac2a7$export$492f40394cb58978)(args.depthwiseConstraint);
        this.depthwiseRegularizer = (0, $030044d54dc1235d$export$b3404716bfee324c)(args.depthwiseRegularizer);
    }
    build(inputShape) {
        inputShape = (0, $e11ae28082970f77$export$25c35af872e8abca)(inputShape);
        if (inputShape.length < 4) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Inputs to DepthwiseConv2D should have rank 4. ` + `Received input shape: ${JSON.stringify(inputShape)}.`);
        const channelAxis = this.dataFormat === 'channelsFirst' ? 1 : 3;
        if (inputShape[channelAxis] == null || inputShape[channelAxis] < 0) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)('The channel dimension of the inputs to DepthwiseConv2D should ' + `be defined, but is not (${inputShape[channelAxis]}).`);
        const inputDim = inputShape[channelAxis];
        const depthwiseKernelShape = [
            this.kernelSize[0],
            this.kernelSize[1],
            inputDim,
            this.depthMultiplier
        ];
        this.depthwiseKernel = this.addWeight('depthwise_kernel', depthwiseKernelShape, null, this.depthwiseInitializer, this.depthwiseRegularizer, true, this.depthwiseConstraint);
        if (this.useBias) this.bias = this.addWeight('bias', [
            inputDim * this.depthMultiplier
        ], null, this.biasInitializer, this.biasRegularizer, true, this.biasConstraint);
        else this.bias = null;
        this.built = true;
    }
    call(inputs, kwargs) {
        return (0, $i64bB.tidy)(()=>{
            inputs = (0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs);
            let outputs = $9ed43e21c47c0ee3$export$48a8ad9494a8fad8(inputs, this.depthwiseKernel.read(), this.strides, this.padding, this.dataFormat, null);
            // TODO(cais): Add support for dilation.
            if (this.useBias) outputs = $33b0bdd0433db936$export$917ce53bce63bd4b(outputs, this.bias.read(), this.dataFormat);
            if (this.activation != null) outputs = this.activation.apply(outputs);
            return outputs;
        });
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $e11ae28082970f77$export$25c35af872e8abca)(inputShape);
        const rows = this.dataFormat === 'channelsFirst' ? inputShape[2] : inputShape[1];
        const cols = this.dataFormat === 'channelsFirst' ? inputShape[3] : inputShape[2];
        const outFilters = this.dataFormat === 'channelsFirst' ? inputShape[1] * this.depthMultiplier : inputShape[3] * this.depthMultiplier;
        const outRows = (0, $1e685a09ff935a2e$export$50b0adaed374172)(rows, this.kernelSize[0], this.padding, this.strides[0]);
        const outCols = (0, $1e685a09ff935a2e$export$50b0adaed374172)(cols, this.kernelSize[1], this.padding, this.strides[1]);
        if (this.dataFormat === 'channelsFirst') return [
            inputShape[0],
            outFilters,
            outRows,
            outCols
        ];
        else // In this case, assume 'channelsLast'.
        return [
            inputShape[0],
            outRows,
            outCols,
            outFilters
        ];
    }
    getConfig() {
        const config = super.getConfig();
        config['depthMultiplier'] = this.depthMultiplier;
        config['depthwiseInitializer'] = (0, $49135dd97e6043ca$export$68de06a18c23bdbc)(this.depthwiseInitializer);
        config['depthwiseRegularizer'] = (0, $030044d54dc1235d$export$7e8cf5899b350405)(this.depthwiseRegularizer);
        config['depthwiseConstraint'] = (0, $ef279f7fc82ac2a7$export$e449710617725987)(this.depthwiseRegularizer);
        return config;
    }
}
/** @nocollapse */ $9ed43e21c47c0ee3$export$292dab92c4661cc4.className = 'DepthwiseConv2D';
(0, $i64bB.serialization).registerClass($9ed43e21c47c0ee3$export$292dab92c4661cc4);


/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");








/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * TensorFlow.js Layers: Recurrent Neural Network Layers.
 */ 
var $i64bB = parcelRequire("i64bB");













function $9cf49ab16f0373b1$export$b9ab3f5c89688c2(inputs, initialState, constants, numConstants) {
    if (Array.isArray(inputs)) {
        if (initialState != null || constants != null) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)("When inputs is an array, neither initialState or constants should be provided");
        if (numConstants != null) {
            constants = inputs.slice(inputs.length - numConstants, inputs.length);
            inputs = inputs.slice(0, inputs.length - numConstants);
        }
        if (inputs.length > 1) initialState = inputs.slice(1, inputs.length);
        inputs = inputs[0];
    }
    function toListOrNull(x) {
        if (x == null || Array.isArray(x)) return x;
        else return [
            x
        ];
    }
    initialState = toListOrNull(initialState);
    constants = toListOrNull(constants);
    return {
        inputs: inputs,
        initialState: initialState,
        constants: constants
    };
}
function $9cf49ab16f0373b1$export$3e66d5ce8f778ebc(stepFunction, inputs, initialStates, goBackwards = false, mask, constants, unroll = false, needPerStepOutputs = false) {
    return $i64bB.tidy(()=>{
        const ndim = inputs.shape.length;
        if (ndim < 3) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Input should be at least 3D, but is ${ndim}D.`);
        // Transpose to time-major, i.e., from [batch, time, ...] to [time, batch,
        // ...].
        const axes = [
            1,
            0
        ].concat($edee0645f45d9428$export$d02631cccf789723(2, ndim));
        inputs = $i64bB.transpose(inputs, axes);
        if (constants != null) throw new (0, $af476738b120e938$export$e162153238934121)("The rnn() functoin of the deeplearn.js backend does not support constants yet.");
        // Porting Note: the unroll option is ignored by the imperative backend.
        if (unroll) console.warn("Backend rnn(): the unroll = true option is not applicable to the imperative deeplearn.js backend.");
        if (mask != null) {
            mask = $i64bB.cast($i64bB.cast(mask, 'bool'), 'float32');
            if (mask.rank === ndim - 1) mask = $i64bB.expandDims(mask, -1);
            mask = $i64bB.transpose(mask, axes);
        }
        if (goBackwards) {
            inputs = $i64bB.reverse(inputs, 0);
            if (mask != null) mask = $i64bB.reverse(mask, 0);
        }
        // Porting Note: PyKeras with TensorFlow backend uses a symbolic loop
        //   (tf.while_loop). But for the imperative deeplearn.js backend, we just
        //   use the usual TypeScript control flow to iterate over the time steps in
        //   the inputs.
        // Porting Note: PyKeras patches a "_use_learning_phase" attribute to
        // outputs.
        //   This is not idiomatic in TypeScript. The info regarding whether we are
        //   in a learning (i.e., training) phase for RNN is passed in a different
        //   way.
        const perStepOutputs = [];
        let lastOutput;
        let states = initialStates;
        const timeSteps = inputs.shape[0];
        const perStepInputs = $i64bB.unstack(inputs);
        let perStepMasks;
        if (mask != null) perStepMasks = $i64bB.unstack(mask);
        for(let t = 0; t < timeSteps; ++t){
            const currentInput = perStepInputs[t];
            const stepOutputs = $i64bB.tidy(()=>stepFunction(currentInput, states));
            if (mask == null) {
                lastOutput = stepOutputs[0];
                states = stepOutputs[1];
            } else {
                const maskedOutputs = $i64bB.tidy(()=>{
                    const stepMask = perStepMasks[t];
                    const negStepMask = $i64bB.sub($i64bB.onesLike(stepMask), stepMask);
                    // TODO(cais): Would tfc.where() be better for performance?
                    const output = $i64bB.add($i64bB.mul(stepOutputs[0], stepMask), $i64bB.mul(states[0], negStepMask));
                    const newStates = states.map((state, i)=>{
                        return $i64bB.add($i64bB.mul(stepOutputs[1][i], stepMask), $i64bB.mul(state, negStepMask));
                    });
                    return {
                        output: output,
                        newStates: newStates
                    };
                });
                lastOutput = maskedOutputs.output;
                states = maskedOutputs.newStates;
            }
            if (needPerStepOutputs) perStepOutputs.push(lastOutput);
        }
        let outputs;
        if (needPerStepOutputs) {
            const axis = 1;
            outputs = $i64bB.stack(perStepOutputs, axis);
        }
        return [
            lastOutput,
            outputs,
            states
        ];
    });
}
class $9cf49ab16f0373b1$export$2b97bcdf1d6f1b16 extends (0, $03271f6b4e448384$export$936d0764594b6eb3) {
    constructor(args){
        super(args);
        let cell;
        if (args.cell == null) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)('cell property is missing for the constructor of RNN.');
        else if (Array.isArray(args.cell)) cell = new $9cf49ab16f0373b1$export$966a21a552328009({
            cells: args.cell
        });
        else cell = args.cell;
        if (cell.stateSize == null) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)("The RNN cell should have an attribute `stateSize` (tuple of integers, one integer per RNN state).");
        this.cell = cell;
        this.returnSequences = args.returnSequences == null ? false : args.returnSequences;
        this.returnState = args.returnState == null ? false : args.returnState;
        this.goBackwards = args.goBackwards == null ? false : args.goBackwards;
        this._stateful = args.stateful == null ? false : args.stateful;
        this.unroll = args.unroll == null ? false : args.unroll;
        this.supportsMasking = true;
        this.inputSpec = [
            new (0, $03271f6b4e448384$export$7705ee67def9d40a)({
                ndim: 3
            })
        ];
        this.stateSpec = null;
        this.states_ = null;
        // TODO(cais): Add constantsSpec and numConstants.
        this.numConstants = null;
        // TODO(cais): Look into the use of initial_state in the kwargs of the
        //   constructor.
        this.keptStates = [];
    }
    // Porting Note: This is the equivalent of `RNN.states` property getter in
    //   PyKeras.
    getStates() {
        if (this.states_ == null) {
            const numStates = Array.isArray(this.cell.stateSize) ? this.cell.stateSize.length : 1;
            return $edee0645f45d9428$export$d02631cccf789723(0, numStates).map((x)=>null);
        } else return this.states_;
    }
    // Porting Note: This is the equivalent of the `RNN.states` property setter in
    //   PyKeras.
    setStates(states) {
        this.states_ = states;
    }
    computeOutputShape(inputShape) {
        if ((0, $e11ae28082970f77$export$3297ca286d903db0)(inputShape)) inputShape = inputShape[0];
        inputShape;
        // TODO(cais): Remove the casting once stacked RNN cells become supported.
        let stateSize = this.cell.stateSize;
        if (!Array.isArray(stateSize)) stateSize = [
            stateSize
        ];
        const outputDim = stateSize[0];
        let outputShape;
        if (this.returnSequences) outputShape = [
            inputShape[0],
            inputShape[1],
            outputDim
        ];
        else outputShape = [
            inputShape[0],
            outputDim
        ];
        if (this.returnState) {
            const stateShape = [];
            for (const dim of stateSize)stateShape.push([
                inputShape[0],
                dim
            ]);
            return [
                outputShape
            ].concat(stateShape);
        } else return outputShape;
    }
    computeMask(inputs, mask) {
        return $i64bB.tidy(()=>{
            if (Array.isArray(mask)) mask = mask[0];
            const outputMask = this.returnSequences ? mask : null;
            if (this.returnState) {
                const stateMask = this.states.map((s)=>null);
                return [
                    outputMask
                ].concat(stateMask);
            } else return outputMask;
        });
    }
    /**
     * Get the current state tensors of the RNN.
     *
     * If the state hasn't been set, return an array of `null`s of the correct
     * length.
     */ get states() {
        if (this.states_ == null) {
            const numStates = Array.isArray(this.cell.stateSize) ? this.cell.stateSize.length : 1;
            const output = [];
            for(let i = 0; i < numStates; ++i)output.push(null);
            return output;
        } else return this.states_;
    }
    set states(s) {
        this.states_ = s;
    }
    build(inputShape) {
        // Note inputShape will be an Array of Shapes of initial states and
        // constants if these are passed in apply().
        const constantShape = null;
        if (this.numConstants != null) throw new (0, $af476738b120e938$export$e162153238934121)('Constants support is not implemented in RNN yet.');
        if ((0, $e11ae28082970f77$export$3297ca286d903db0)(inputShape)) inputShape = inputShape[0];
        inputShape;
        const batchSize = this.stateful ? inputShape[0] : null;
        const inputDim = inputShape.slice(2);
        this.inputSpec[0] = new (0, $03271f6b4e448384$export$7705ee67def9d40a)({
            shape: [
                batchSize,
                null,
                ...inputDim
            ]
        });
        // Allow cell (if RNNCell Layer) to build before we set or validate
        // stateSpec.
        const stepInputShape = [
            inputShape[0]
        ].concat(inputShape.slice(2));
        if (constantShape != null) throw new (0, $af476738b120e938$export$e162153238934121)('Constants support is not implemented in RNN yet.');
        else this.cell.build(stepInputShape);
        // Set or validate stateSpec.
        let stateSize;
        if (Array.isArray(this.cell.stateSize)) stateSize = this.cell.stateSize;
        else stateSize = [
            this.cell.stateSize
        ];
        if (this.stateSpec != null) {
            if (!(0, $i64bB.util).arraysEqual(this.stateSpec.map((spec)=>spec.shape[spec.shape.length - 1]), stateSize)) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`An initialState was passed that is not compatible with ` + `cell.stateSize. Received stateSpec=${this.stateSpec}; ` + `However cell.stateSize is ${this.cell.stateSize}`);
        } else this.stateSpec = stateSize.map((dim)=>new (0, $03271f6b4e448384$export$7705ee67def9d40a)({
                shape: [
                    null,
                    dim
                ]
            }));
        if (this.stateful) this.resetStates();
    }
    /**
     * Reset the state tensors of the RNN.
     *
     * If the `states` argument is `undefined` or `null`, will set the
     * state tensor(s) of the RNN to all-zero tensors of the appropriate
     * shape(s).
     *
     * If `states` is provided, will set the state tensors of the RNN to its
     * value.
     *
     * @param states Optional externally-provided initial states.
     * @param training Whether this call is done during training. For stateful
     *   RNNs, this affects whether the old states are kept or discarded. In
     *   particular, if `training` is `true`, the old states will be kept so
     *   that subsequent backpropgataion through time (BPTT) may work properly.
     *   Else, the old states will be discarded.
     */ resetStates(states, training = false) {
        (0, $i64bB.tidy)(()=>{
            if (!this.stateful) throw new (0, $af476738b120e938$export$3869bf0637a5d0ff)('Cannot call resetStates() on an RNN Layer that is not stateful.');
            const batchSize = this.inputSpec[0].shape[0];
            if (batchSize == null) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)("If an RNN is stateful, it needs to know its batch size. Specify the batch size of your input tensors: \n- If using a Sequential model, specify the batch size by passing a `batchInputShape` option to your first layer.\n- If using the functional API, specify the batch size by passing a `batchShape` option to your Input layer.");
            // Initialize state if null.
            if (this.states_ == null) {
                if (Array.isArray(this.cell.stateSize)) this.states_ = this.cell.stateSize.map((dim)=>$i64bB.zeros([
                        batchSize,
                        dim
                    ]));
                else this.states_ = [
                    $i64bB.zeros([
                        batchSize,
                        this.cell.stateSize
                    ])
                ];
            } else if (states == null) {
                // Dispose old state tensors.
                $i64bB.dispose(this.states_);
                // For stateful RNNs, fully dispose kept old states.
                if (this.keptStates != null) {
                    $i64bB.dispose(this.keptStates);
                    this.keptStates = [];
                }
                if (Array.isArray(this.cell.stateSize)) this.states_ = this.cell.stateSize.map((dim)=>$i64bB.zeros([
                        batchSize,
                        dim
                    ]));
                else this.states_[0] = $i64bB.zeros([
                    batchSize,
                    this.cell.stateSize
                ]);
            } else {
                if (!Array.isArray(states)) states = [
                    states
                ];
                if (states.length !== this.states_.length) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Layer ${this.name} expects ${this.states_.length} state(s), ` + `but it received ${states.length} state value(s). Input ` + `received: ${states}`);
                if (training === true) // Store old state tensors for complete disposal later, i.e., during
                // the next no-arg call to this method. We do not dispose the old
                // states immediately because that BPTT (among other things) require
                // them.
                this.keptStates.push(this.states_.slice());
                else $i64bB.dispose(this.states_);
                for(let index = 0; index < this.states_.length; ++index){
                    const value = states[index];
                    const dim = Array.isArray(this.cell.stateSize) ? this.cell.stateSize[index] : this.cell.stateSize;
                    const expectedShape = [
                        batchSize,
                        dim
                    ];
                    if (!(0, $i64bB.util).arraysEqual(value.shape, expectedShape)) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`State ${index} is incompatible with layer ${this.name}: ` + `expected shape=${expectedShape}, received shape=${value.shape}`);
                    this.states_[index] = value;
                }
            }
            this.states_ = this.states_.map((state)=>$i64bB.keep(state.clone()));
        });
    }
    apply(inputs, kwargs) {
        // TODO(cais): Figure out whether initialState is in kwargs or inputs.
        let initialState = kwargs == null ? null : kwargs['initialState'];
        let constants = kwargs == null ? null : kwargs['constants'];
        if (kwargs == null) kwargs = {};
        const standardized = $9cf49ab16f0373b1$export$b9ab3f5c89688c2(inputs, initialState, constants, this.numConstants);
        inputs = standardized.inputs;
        initialState = standardized.initialState;
        constants = standardized.constants;
        // If any of `initial_state` or `constants` are specified and are
        // `tf.SymbolicTensor`s, then add them to the inputs and temporarily modify
        // the input_spec to include them.
        let additionalInputs = [];
        let additionalSpecs = [];
        if (initialState != null) {
            kwargs['initialState'] = initialState;
            additionalInputs = additionalInputs.concat(initialState);
            this.stateSpec = [];
            for (const state of initialState)this.stateSpec.push(new (0, $03271f6b4e448384$export$7705ee67def9d40a)({
                shape: state.shape
            }));
            // TODO(cais): Use the following instead.
            // this.stateSpec = initialState.map(state => new InputSpec({shape:
            // state.shape}));
            additionalSpecs = additionalSpecs.concat(this.stateSpec);
        }
        if (constants != null) {
            kwargs['constants'] = constants;
            additionalInputs = additionalInputs.concat(constants);
            // TODO(cais): Add this.constantsSpec.
            this.numConstants = constants.length;
        }
        const isTensor = additionalInputs[0] instanceof (0, $03271f6b4e448384$export$c6d6977640680568);
        if (isTensor) {
            // Compute full input spec, including state and constants.
            const fullInput = [
                inputs
            ].concat(additionalInputs);
            const fullInputSpec = this.inputSpec.concat(additionalSpecs);
            // Perform the call with temporarily replaced inputSpec.
            const originalInputSpec = this.inputSpec;
            this.inputSpec = fullInputSpec;
            const output = super.apply(fullInput, kwargs);
            this.inputSpec = originalInputSpec;
            return output;
        } else return super.apply(inputs, kwargs);
    }
    // tslint:disable-next-line:no-any
    call(inputs, kwargs) {
        // Input shape: `[samples, time (padded with zeros), input_dim]`.
        // Note that the .build() method of subclasses **must** define
        // this.inputSpec and this.stateSpec owith complete input shapes.
        return (0, $i64bB.tidy)(()=>{
            const mask = kwargs == null ? null : kwargs['mask'];
            const training = kwargs == null ? null : kwargs['training'];
            let initialState = kwargs == null ? null : kwargs['initialState'];
            inputs = (0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs);
            if (initialState == null) {
                if (this.stateful) initialState = this.states_;
                else initialState = this.getInitialState(inputs);
            }
            const numStates = Array.isArray(this.cell.stateSize) ? this.cell.stateSize.length : 1;
            if (initialState.length !== numStates) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`RNN Layer has ${numStates} state(s) but was passed ` + `${initialState.length} initial state(s).`);
            if (this.unroll) console.warn('Ignoring unroll = true for RNN layer, due to imperative backend.');
            const cellCallKwargs = {
                training: training
            };
            // TODO(cais): Add support for constants.
            const step = (inputs, states)=>{
                // `inputs` and `states` are concatenated to form a single `Array` of
                // `tf.Tensor`s as the input to `cell.call()`.
                const outputs = this.cell.call([
                    inputs
                ].concat(states), cellCallKwargs);
                // Marshall the return value into output and new states.
                return [
                    outputs[0],
                    outputs.slice(1)
                ];
            };
            // TODO(cais): Add support for constants.
            const rnnOutputs = $9cf49ab16f0373b1$export$3e66d5ce8f778ebc(step, inputs, initialState, this.goBackwards, mask, null, this.unroll, this.returnSequences);
            const lastOutput = rnnOutputs[0];
            const outputs = rnnOutputs[1];
            const states = rnnOutputs[2];
            if (this.stateful) this.resetStates(states, training);
            const output = this.returnSequences ? outputs : lastOutput;
            // TODO(cais): Property set learning phase flag.
            if (this.returnState) return [
                output
            ].concat(states);
            else return output;
        });
    }
    getInitialState(inputs) {
        return (0, $i64bB.tidy)(()=>{
            // Build an all-zero tensor of shape [samples, outputDim].
            // [Samples, timeSteps, inputDim].
            let initialState = $i64bB.zeros(inputs.shape);
            // [Samples].
            initialState = $i64bB.sum(initialState, [
                1,
                2
            ]);
            initialState = $33b0bdd0433db936$export$d660d8ed21f46635(initialState); // [Samples, 1].
            if (Array.isArray(this.cell.stateSize)) return this.cell.stateSize.map((dim)=>dim > 1 ? $33b0bdd0433db936$export$3c17558da18e4d75(initialState, [
                    1,
                    dim
                ]) : initialState);
            else return this.cell.stateSize > 1 ? [
                $33b0bdd0433db936$export$3c17558da18e4d75(initialState, [
                    1,
                    this.cell.stateSize
                ])
            ] : [
                initialState
            ];
        });
    }
    get trainableWeights() {
        if (!this.trainable) return [];
        // Porting Note: In TypeScript, `this` is always an instance of `Layer`.
        return this.cell.trainableWeights;
    }
    get nonTrainableWeights() {
        // Porting Note: In TypeScript, `this` is always an instance of `Layer`.
        if (!this.trainable) return this.cell.weights;
        return this.cell.nonTrainableWeights;
    }
    setFastWeightInitDuringBuild(value) {
        super.setFastWeightInitDuringBuild(value);
        if (this.cell != null) this.cell.setFastWeightInitDuringBuild(value);
    }
    getConfig() {
        const baseConfig = super.getConfig();
        const config = {
            returnSequences: this.returnSequences,
            returnState: this.returnState,
            goBackwards: this.goBackwards,
            stateful: this.stateful,
            unroll: this.unroll
        };
        if (this.numConstants != null) config['numConstants'] = this.numConstants;
        const cellConfig = this.cell.getConfig();
        if (this.getClassName() === $9cf49ab16f0373b1$export$2b97bcdf1d6f1b16.className) config['cell'] = {
            'className': this.cell.getClassName(),
            'config': cellConfig
        };
        // this order is necessary, to prevent cell name from replacing layer name
        return Object.assign(Object.assign(Object.assign({}, cellConfig), baseConfig), config);
    }
    /** @nocollapse */ static fromConfig(cls, config, customObjects = {}) {
        const cellConfig = config['cell'];
        const cell = (0, $61cac79a6a78765b$export$efcd34ab6248d3cd)(cellConfig, customObjects);
        return new cls(Object.assign(config, {
            cell: cell
        }));
    }
}
/** @nocollapse */ $9cf49ab16f0373b1$export$2b97bcdf1d6f1b16.className = 'RNN';
(0, $i64bB.serialization).registerClass($9cf49ab16f0373b1$export$2b97bcdf1d6f1b16);
class $9cf49ab16f0373b1$export$405d8fca8f98aafd extends (0, $03271f6b4e448384$export$936d0764594b6eb3) {
}
class $9cf49ab16f0373b1$export$c8a45b8cd42f689 extends $9cf49ab16f0373b1$export$405d8fca8f98aafd {
    constructor(args){
        super(args);
        this.DEFAULT_ACTIVATION = 'tanh';
        this.DEFAULT_KERNEL_INITIALIZER = 'glorotNormal';
        this.DEFAULT_RECURRENT_INITIALIZER = 'orthogonal';
        this.DEFAULT_BIAS_INITIALIZER = 'zeros';
        this.units = args.units;
        (0, $b5cd0926a1c6df1f$export$7ac3b6580cbed983)(this.units, `units`);
        this.activation = (0, $30ca3c776e202113$export$ed84f867ffcf9364)(args.activation == null ? this.DEFAULT_ACTIVATION : args.activation);
        this.useBias = args.useBias == null ? true : args.useBias;
        this.kernelInitializer = (0, $49135dd97e6043ca$export$558b7d1a338df84b)(args.kernelInitializer || this.DEFAULT_KERNEL_INITIALIZER);
        this.recurrentInitializer = (0, $49135dd97e6043ca$export$558b7d1a338df84b)(args.recurrentInitializer || this.DEFAULT_RECURRENT_INITIALIZER);
        this.biasInitializer = (0, $49135dd97e6043ca$export$558b7d1a338df84b)(args.biasInitializer || this.DEFAULT_BIAS_INITIALIZER);
        this.kernelRegularizer = (0, $030044d54dc1235d$export$b3404716bfee324c)(args.kernelRegularizer);
        this.recurrentRegularizer = (0, $030044d54dc1235d$export$b3404716bfee324c)(args.recurrentRegularizer);
        this.biasRegularizer = (0, $030044d54dc1235d$export$b3404716bfee324c)(args.biasRegularizer);
        this.kernelConstraint = (0, $ef279f7fc82ac2a7$export$492f40394cb58978)(args.kernelConstraint);
        this.recurrentConstraint = (0, $ef279f7fc82ac2a7$export$492f40394cb58978)(args.recurrentConstraint);
        this.biasConstraint = (0, $ef279f7fc82ac2a7$export$492f40394cb58978)(args.biasConstraint);
        this.dropout = $edee0645f45d9428$export$96ec731ed4dcb222([
            1,
            $edee0645f45d9428$export$8960430cfd85939f([
                0,
                args.dropout == null ? 0 : args.dropout
            ])
        ]);
        this.recurrentDropout = $edee0645f45d9428$export$96ec731ed4dcb222([
            1,
            $edee0645f45d9428$export$8960430cfd85939f([
                0,
                args.recurrentDropout == null ? 0 : args.recurrentDropout
            ])
        ]);
        this.dropoutFunc = args.dropoutFunc;
        this.stateSize = this.units;
        this.dropoutMask = null;
        this.recurrentDropoutMask = null;
    }
    build(inputShape) {
        inputShape = (0, $e11ae28082970f77$export$25c35af872e8abca)(inputShape);
        // TODO(cais): Use regularizer.
        this.kernel = this.addWeight('kernel', [
            inputShape[inputShape.length - 1],
            this.units
        ], null, this.kernelInitializer, this.kernelRegularizer, true, this.kernelConstraint);
        this.recurrentKernel = this.addWeight('recurrent_kernel', [
            this.units,
            this.units
        ], null, this.recurrentInitializer, this.recurrentRegularizer, true, this.recurrentConstraint);
        if (this.useBias) this.bias = this.addWeight('bias', [
            this.units
        ], null, this.biasInitializer, this.biasRegularizer, true, this.biasConstraint);
        else this.bias = null;
        this.built = true;
    }
    // Porting Note: PyKeras' equivalent of this method takes two tensor inputs:
    //   `inputs` and `states`. Here, the two tensors are combined into an
    //   `Tensor[]` Array as the first input argument.
    //   Similarly, PyKeras' equivalent of this method returns two values:
    //    `output` and `[output]`. Here the two are combined into one length-2
    //    `Tensor[]`, consisting of `output` repeated.
    call(inputs, kwargs) {
        return (0, $i64bB.tidy)(()=>{
            inputs;
            if (inputs.length !== 2) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`SimpleRNNCell expects 2 input Tensors, got ${inputs.length}.`);
            let prevOutput = inputs[1];
            inputs = inputs[0];
            const training = kwargs['training'] == null ? false : kwargs['training'];
            if (0 < this.dropout && this.dropout < 1 && this.dropoutMask == null) this.dropoutMask = $9cf49ab16f0373b1$export$9eb0cce22b72569f({
                ones: ()=>$i64bB.onesLike(inputs),
                rate: this.dropout,
                training: training,
                dropoutFunc: this.dropoutFunc
            });
            if (0 < this.recurrentDropout && this.recurrentDropout < 1 && this.recurrentDropoutMask == null) this.recurrentDropoutMask = $9cf49ab16f0373b1$export$9eb0cce22b72569f({
                ones: ()=>$i64bB.onesLike(prevOutput),
                rate: this.recurrentDropout,
                training: training,
                dropoutFunc: this.dropoutFunc
            });
            let h;
            const dpMask = this.dropoutMask;
            const recDpMask = this.recurrentDropoutMask;
            if (dpMask != null) h = $33b0bdd0433db936$export$94132a0e348806d4($i64bB.mul(inputs, dpMask), this.kernel.read());
            else h = $33b0bdd0433db936$export$94132a0e348806d4(inputs, this.kernel.read());
            if (this.bias != null) h = $33b0bdd0433db936$export$917ce53bce63bd4b(h, this.bias.read());
            if (recDpMask != null) prevOutput = $i64bB.mul(prevOutput, recDpMask);
            let output = $i64bB.add(h, $33b0bdd0433db936$export$94132a0e348806d4(prevOutput, this.recurrentKernel.read()));
            if (this.activation != null) output = this.activation.apply(output);
            // TODO(cais): Properly set learning phase on output tensor?
            return [
                output,
                output
            ];
        });
    }
    getConfig() {
        const baseConfig = super.getConfig();
        const config = {
            units: this.units,
            activation: (0, $30ca3c776e202113$export$8a2c1643c67d0487)(this.activation),
            useBias: this.useBias,
            kernelInitializer: (0, $49135dd97e6043ca$export$68de06a18c23bdbc)(this.kernelInitializer),
            recurrentInitializer: (0, $49135dd97e6043ca$export$68de06a18c23bdbc)(this.recurrentInitializer),
            biasInitializer: (0, $49135dd97e6043ca$export$68de06a18c23bdbc)(this.biasInitializer),
            kernelRegularizer: (0, $030044d54dc1235d$export$7e8cf5899b350405)(this.kernelRegularizer),
            recurrentRegularizer: (0, $030044d54dc1235d$export$7e8cf5899b350405)(this.recurrentRegularizer),
            biasRegularizer: (0, $030044d54dc1235d$export$7e8cf5899b350405)(this.biasRegularizer),
            activityRegularizer: (0, $030044d54dc1235d$export$7e8cf5899b350405)(this.activityRegularizer),
            kernelConstraint: (0, $ef279f7fc82ac2a7$export$e449710617725987)(this.kernelConstraint),
            recurrentConstraint: (0, $ef279f7fc82ac2a7$export$e449710617725987)(this.recurrentConstraint),
            biasConstraint: (0, $ef279f7fc82ac2a7$export$e449710617725987)(this.biasConstraint),
            dropout: this.dropout,
            recurrentDropout: this.recurrentDropout
        };
        return Object.assign(Object.assign({}, baseConfig), config);
    }
}
/** @nocollapse */ $9cf49ab16f0373b1$export$c8a45b8cd42f689.className = 'SimpleRNNCell';
(0, $i64bB.serialization).registerClass($9cf49ab16f0373b1$export$c8a45b8cd42f689);
class $9cf49ab16f0373b1$export$9f3b0efd8738b035 extends $9cf49ab16f0373b1$export$2b97bcdf1d6f1b16 {
    constructor(args){
        args.cell = new $9cf49ab16f0373b1$export$c8a45b8cd42f689(args);
        super(args);
    // TODO(cais): Add activityRegularizer.
    }
    call(inputs, kwargs) {
        return (0, $i64bB.tidy)(()=>{
            if (this.cell.dropoutMask != null) {
                $i64bB.dispose(this.cell.dropoutMask);
                this.cell.dropoutMask = null;
            }
            if (this.cell.recurrentDropoutMask != null) {
                $i64bB.dispose(this.cell.recurrentDropoutMask);
                this.cell.recurrentDropoutMask = null;
            }
            const mask = kwargs == null ? null : kwargs['mask'];
            const training = kwargs == null ? null : kwargs['training'];
            const initialState = kwargs == null ? null : kwargs['initialState'];
            return super.call(inputs, {
                mask: mask,
                training: training,
                initialState: initialState
            });
        });
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config);
    }
}
/** @nocollapse */ $9cf49ab16f0373b1$export$9f3b0efd8738b035.className = 'SimpleRNN';
(0, $i64bB.serialization).registerClass($9cf49ab16f0373b1$export$9f3b0efd8738b035);
class $9cf49ab16f0373b1$export$dad94e00e5c3737 extends $9cf49ab16f0373b1$export$405d8fca8f98aafd {
    constructor(args){
        super(args);
        this.DEFAULT_ACTIVATION = 'tanh';
        this.DEFAULT_RECURRENT_ACTIVATION = 'hardSigmoid';
        this.DEFAULT_KERNEL_INITIALIZER = 'glorotNormal';
        this.DEFAULT_RECURRENT_INITIALIZER = 'orthogonal';
        this.DEFAULT_BIAS_INITIALIZER = 'zeros';
        if (args.resetAfter) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`GRUCell does not support reset_after parameter set to true.`);
        this.units = args.units;
        (0, $b5cd0926a1c6df1f$export$7ac3b6580cbed983)(this.units, 'units');
        this.activation = (0, $30ca3c776e202113$export$ed84f867ffcf9364)(args.activation === undefined ? this.DEFAULT_ACTIVATION : args.activation);
        this.recurrentActivation = (0, $30ca3c776e202113$export$ed84f867ffcf9364)(args.recurrentActivation === undefined ? this.DEFAULT_RECURRENT_ACTIVATION : args.recurrentActivation);
        this.useBias = args.useBias == null ? true : args.useBias;
        this.kernelInitializer = (0, $49135dd97e6043ca$export$558b7d1a338df84b)(args.kernelInitializer || this.DEFAULT_KERNEL_INITIALIZER);
        this.recurrentInitializer = (0, $49135dd97e6043ca$export$558b7d1a338df84b)(args.recurrentInitializer || this.DEFAULT_RECURRENT_INITIALIZER);
        this.biasInitializer = (0, $49135dd97e6043ca$export$558b7d1a338df84b)(args.biasInitializer || this.DEFAULT_BIAS_INITIALIZER);
        this.kernelRegularizer = (0, $030044d54dc1235d$export$b3404716bfee324c)(args.kernelRegularizer);
        this.recurrentRegularizer = (0, $030044d54dc1235d$export$b3404716bfee324c)(args.recurrentRegularizer);
        this.biasRegularizer = (0, $030044d54dc1235d$export$b3404716bfee324c)(args.biasRegularizer);
        this.kernelConstraint = (0, $ef279f7fc82ac2a7$export$492f40394cb58978)(args.kernelConstraint);
        this.recurrentConstraint = (0, $ef279f7fc82ac2a7$export$492f40394cb58978)(args.recurrentConstraint);
        this.biasConstraint = (0, $ef279f7fc82ac2a7$export$492f40394cb58978)(args.biasConstraint);
        this.dropout = $edee0645f45d9428$export$96ec731ed4dcb222([
            1,
            $edee0645f45d9428$export$8960430cfd85939f([
                0,
                args.dropout == null ? 0 : args.dropout
            ])
        ]);
        this.recurrentDropout = $edee0645f45d9428$export$96ec731ed4dcb222([
            1,
            $edee0645f45d9428$export$8960430cfd85939f([
                0,
                args.recurrentDropout == null ? 0 : args.recurrentDropout
            ])
        ]);
        this.dropoutFunc = args.dropoutFunc;
        this.implementation = args.implementation;
        this.stateSize = this.units;
        this.dropoutMask = null;
        this.recurrentDropoutMask = null;
    }
    build(inputShape) {
        inputShape = (0, $e11ae28082970f77$export$25c35af872e8abca)(inputShape);
        const inputDim = inputShape[inputShape.length - 1];
        this.kernel = this.addWeight('kernel', [
            inputDim,
            this.units * 3
        ], null, this.kernelInitializer, this.kernelRegularizer, true, this.kernelConstraint);
        this.recurrentKernel = this.addWeight('recurrent_kernel', [
            this.units,
            this.units * 3
        ], null, this.recurrentInitializer, this.recurrentRegularizer, true, this.recurrentConstraint);
        if (this.useBias) this.bias = this.addWeight('bias', [
            this.units * 3
        ], null, this.biasInitializer, this.biasRegularizer, true, this.biasConstraint);
        else this.bias = null;
        // Porting Notes: Unlike the PyKeras implementation, we perform slicing
        //   of the weights and bias in the call() method, at execution time.
        this.built = true;
    }
    call(inputs, kwargs) {
        return (0, $i64bB.tidy)(()=>{
            inputs;
            if (inputs.length !== 2) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`GRUCell expects 2 input Tensors (inputs, h, c), got ` + `${inputs.length}.`);
            const training = kwargs['training'] == null ? false : kwargs['training'];
            let hTMinus1 = inputs[1]; // Previous memory state.
            inputs = inputs[0];
            // Note: For superior performance, TensorFlow.js always uses
            // implementation 2, regardless of the actual value of
            // config.implementation.
            if (0 < this.dropout && this.dropout < 1 && this.dropoutMask == null) this.dropoutMask = $9cf49ab16f0373b1$export$9eb0cce22b72569f({
                ones: ()=>$i64bB.onesLike(inputs),
                rate: this.dropout,
                training: training,
                count: 3,
                dropoutFunc: this.dropoutFunc
            });
            if (0 < this.recurrentDropout && this.recurrentDropout < 1 && this.recurrentDropoutMask == null) this.recurrentDropoutMask = $9cf49ab16f0373b1$export$9eb0cce22b72569f({
                ones: ()=>$i64bB.onesLike(hTMinus1),
                rate: this.recurrentDropout,
                training: training,
                count: 3,
                dropoutFunc: this.dropoutFunc
            });
            const dpMask = this.dropoutMask;
            const recDpMask = this.recurrentDropoutMask;
            let z;
            let r;
            let hh;
            if (0 < this.dropout && this.dropout < 1) inputs = $i64bB.mul(inputs, dpMask[0]);
            let matrixX = $33b0bdd0433db936$export$94132a0e348806d4(inputs, this.kernel.read());
            if (this.useBias) matrixX = $33b0bdd0433db936$export$917ce53bce63bd4b(matrixX, this.bias.read());
            if (0 < this.recurrentDropout && this.recurrentDropout < 1) hTMinus1 = $i64bB.mul(hTMinus1, recDpMask[0]);
            const recurrentKernelValue = this.recurrentKernel.read();
            const [rk1, rk2] = $i64bB.split(recurrentKernelValue, [
                2 * this.units,
                this.units
            ], recurrentKernelValue.rank - 1);
            const matrixInner = $33b0bdd0433db936$export$94132a0e348806d4(hTMinus1, rk1);
            const [xZ, xR, xH] = $i64bB.split(matrixX, 3, matrixX.rank - 1);
            const [recurrentZ, recurrentR] = $i64bB.split(matrixInner, 2, matrixInner.rank - 1);
            z = this.recurrentActivation.apply($i64bB.add(xZ, recurrentZ));
            r = this.recurrentActivation.apply($i64bB.add(xR, recurrentR));
            const recurrentH = $33b0bdd0433db936$export$94132a0e348806d4($i64bB.mul(r, hTMinus1), rk2);
            hh = this.activation.apply($i64bB.add(xH, recurrentH));
            const h = $i64bB.add($i64bB.mul(z, hTMinus1), $i64bB.mul($i64bB.add(1, $i64bB.neg(z)), hh));
            // TODO(cais): Add use_learning_phase flag properly.
            return [
                h,
                h
            ];
        });
    }
    getConfig() {
        const baseConfig = super.getConfig();
        const config = {
            units: this.units,
            activation: (0, $30ca3c776e202113$export$8a2c1643c67d0487)(this.activation),
            recurrentActivation: (0, $30ca3c776e202113$export$8a2c1643c67d0487)(this.recurrentActivation),
            useBias: this.useBias,
            kernelInitializer: (0, $49135dd97e6043ca$export$68de06a18c23bdbc)(this.kernelInitializer),
            recurrentInitializer: (0, $49135dd97e6043ca$export$68de06a18c23bdbc)(this.recurrentInitializer),
            biasInitializer: (0, $49135dd97e6043ca$export$68de06a18c23bdbc)(this.biasInitializer),
            kernelRegularizer: (0, $030044d54dc1235d$export$7e8cf5899b350405)(this.kernelRegularizer),
            recurrentRegularizer: (0, $030044d54dc1235d$export$7e8cf5899b350405)(this.recurrentRegularizer),
            biasRegularizer: (0, $030044d54dc1235d$export$7e8cf5899b350405)(this.biasRegularizer),
            activityRegularizer: (0, $030044d54dc1235d$export$7e8cf5899b350405)(this.activityRegularizer),
            kernelConstraint: (0, $ef279f7fc82ac2a7$export$e449710617725987)(this.kernelConstraint),
            recurrentConstraint: (0, $ef279f7fc82ac2a7$export$e449710617725987)(this.recurrentConstraint),
            biasConstraint: (0, $ef279f7fc82ac2a7$export$e449710617725987)(this.biasConstraint),
            dropout: this.dropout,
            recurrentDropout: this.recurrentDropout,
            implementation: this.implementation,
            resetAfter: false
        };
        return Object.assign(Object.assign({}, baseConfig), config);
    }
}
/** @nocollapse */ $9cf49ab16f0373b1$export$dad94e00e5c3737.className = 'GRUCell';
(0, $i64bB.serialization).registerClass($9cf49ab16f0373b1$export$dad94e00e5c3737);
class $9cf49ab16f0373b1$export$effa27cfcc4408f4 extends $9cf49ab16f0373b1$export$2b97bcdf1d6f1b16 {
    constructor(args){
        if (args.implementation === 0) console.warn("`implementation=0` has been deprecated, and now defaults to `implementation=1`. Please update your layer call.");
        args.cell = new $9cf49ab16f0373b1$export$dad94e00e5c3737(args);
        super(args);
    // TODO(cais): Add activityRegularizer.
    }
    call(inputs, kwargs) {
        return (0, $i64bB.tidy)(()=>{
            if (this.cell.dropoutMask != null) {
                $i64bB.dispose(this.cell.dropoutMask);
                this.cell.dropoutMask = null;
            }
            if (this.cell.recurrentDropoutMask != null) {
                $i64bB.dispose(this.cell.recurrentDropoutMask);
                this.cell.recurrentDropoutMask = null;
            }
            const mask = kwargs == null ? null : kwargs['mask'];
            const training = kwargs == null ? null : kwargs['training'];
            const initialState = kwargs == null ? null : kwargs['initialState'];
            return super.call(inputs, {
                mask: mask,
                training: training,
                initialState: initialState
            });
        });
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        if (config['implmentation'] === 0) config['implementation'] = 1;
        return new cls(config);
    }
}
/** @nocollapse */ $9cf49ab16f0373b1$export$effa27cfcc4408f4.className = 'GRU';
(0, $i64bB.serialization).registerClass($9cf49ab16f0373b1$export$effa27cfcc4408f4);
class $9cf49ab16f0373b1$export$17aacc547a045ab0 extends $9cf49ab16f0373b1$export$405d8fca8f98aafd {
    constructor(args){
        super(args);
        this.DEFAULT_ACTIVATION = 'tanh';
        this.DEFAULT_RECURRENT_ACTIVATION = 'hardSigmoid';
        this.DEFAULT_KERNEL_INITIALIZER = 'glorotNormal';
        this.DEFAULT_RECURRENT_INITIALIZER = 'orthogonal';
        this.DEFAULT_BIAS_INITIALIZER = 'zeros';
        this.units = args.units;
        (0, $b5cd0926a1c6df1f$export$7ac3b6580cbed983)(this.units, 'units');
        this.activation = (0, $30ca3c776e202113$export$ed84f867ffcf9364)(args.activation === undefined ? this.DEFAULT_ACTIVATION : args.activation);
        this.recurrentActivation = (0, $30ca3c776e202113$export$ed84f867ffcf9364)(args.recurrentActivation === undefined ? this.DEFAULT_RECURRENT_ACTIVATION : args.recurrentActivation);
        this.useBias = args.useBias == null ? true : args.useBias;
        this.kernelInitializer = (0, $49135dd97e6043ca$export$558b7d1a338df84b)(args.kernelInitializer || this.DEFAULT_KERNEL_INITIALIZER);
        this.recurrentInitializer = (0, $49135dd97e6043ca$export$558b7d1a338df84b)(args.recurrentInitializer || this.DEFAULT_RECURRENT_INITIALIZER);
        this.biasInitializer = (0, $49135dd97e6043ca$export$558b7d1a338df84b)(args.biasInitializer || this.DEFAULT_BIAS_INITIALIZER);
        this.unitForgetBias = args.unitForgetBias;
        this.kernelRegularizer = (0, $030044d54dc1235d$export$b3404716bfee324c)(args.kernelRegularizer);
        this.recurrentRegularizer = (0, $030044d54dc1235d$export$b3404716bfee324c)(args.recurrentRegularizer);
        this.biasRegularizer = (0, $030044d54dc1235d$export$b3404716bfee324c)(args.biasRegularizer);
        this.kernelConstraint = (0, $ef279f7fc82ac2a7$export$492f40394cb58978)(args.kernelConstraint);
        this.recurrentConstraint = (0, $ef279f7fc82ac2a7$export$492f40394cb58978)(args.recurrentConstraint);
        this.biasConstraint = (0, $ef279f7fc82ac2a7$export$492f40394cb58978)(args.biasConstraint);
        this.dropout = $edee0645f45d9428$export$96ec731ed4dcb222([
            1,
            $edee0645f45d9428$export$8960430cfd85939f([
                0,
                args.dropout == null ? 0 : args.dropout
            ])
        ]);
        this.recurrentDropout = $edee0645f45d9428$export$96ec731ed4dcb222([
            1,
            $edee0645f45d9428$export$8960430cfd85939f([
                0,
                args.recurrentDropout == null ? 0 : args.recurrentDropout
            ])
        ]);
        this.dropoutFunc = args.dropoutFunc;
        this.implementation = args.implementation;
        this.stateSize = [
            this.units,
            this.units
        ];
        this.dropoutMask = null;
        this.recurrentDropoutMask = null;
    }
    build(inputShape) {
        var _a;
        inputShape = (0, $e11ae28082970f77$export$25c35af872e8abca)(inputShape);
        const inputDim = inputShape[inputShape.length - 1];
        this.kernel = this.addWeight('kernel', [
            inputDim,
            this.units * 4
        ], null, this.kernelInitializer, this.kernelRegularizer, true, this.kernelConstraint);
        this.recurrentKernel = this.addWeight('recurrent_kernel', [
            this.units,
            this.units * 4
        ], null, this.recurrentInitializer, this.recurrentRegularizer, true, this.recurrentConstraint);
        let biasInitializer;
        if (this.useBias) {
            if (this.unitForgetBias) {
                const capturedBiasInit = this.biasInitializer;
                const capturedUnits = this.units;
                biasInitializer = new (_a = class CustomInit extends (0, $49135dd97e6043ca$export$9e14a7677ef1423c) {
                    apply(shape, dtype) {
                        // TODO(cais): More informative variable names?
                        const bI = capturedBiasInit.apply([
                            capturedUnits
                        ]);
                        const bF = new (0, $49135dd97e6043ca$export$30750dcb47d2f6b)().apply([
                            capturedUnits
                        ]);
                        const bCAndH = capturedBiasInit.apply([
                            capturedUnits * 2
                        ]);
                        return $33b0bdd0433db936$export$2c8a4d3eab2092a2($33b0bdd0433db936$export$2c8a4d3eab2092a2(bI, bF), bCAndH);
                    }
                }, /** @nocollapse */ _a.className = 'CustomInit', _a)();
            } else biasInitializer = this.biasInitializer;
            this.bias = this.addWeight('bias', [
                this.units * 4
            ], null, biasInitializer, this.biasRegularizer, true, this.biasConstraint);
        } else this.bias = null;
        // Porting Notes: Unlike the PyKeras implementation, we perform slicing
        //   of the weights and bias in the call() method, at execution time.
        this.built = true;
    }
    call(inputs, kwargs) {
        return (0, $i64bB.tidy)(()=>{
            const training = kwargs['training'] == null ? false : kwargs['training'];
            inputs;
            if (inputs.length !== 3) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`LSTMCell expects 3 input Tensors (inputs, h, c), got ` + `${inputs.length}.`);
            let hTMinus1 = inputs[1]; // Previous memory state.
            const cTMinus1 = inputs[2]; // Previous carry state.
            inputs = inputs[0];
            if (0 < this.dropout && this.dropout < 1 && this.dropoutMask == null) this.dropoutMask = $9cf49ab16f0373b1$export$9eb0cce22b72569f({
                ones: ()=>$i64bB.onesLike(inputs),
                rate: this.dropout,
                training: training,
                count: 4,
                dropoutFunc: this.dropoutFunc
            });
            if (0 < this.recurrentDropout && this.recurrentDropout < 1 && this.recurrentDropoutMask == null) this.recurrentDropoutMask = $9cf49ab16f0373b1$export$9eb0cce22b72569f({
                ones: ()=>$i64bB.onesLike(hTMinus1),
                rate: this.recurrentDropout,
                training: training,
                count: 4,
                dropoutFunc: this.dropoutFunc
            });
            const dpMask = this.dropoutMask;
            const recDpMask = this.recurrentDropoutMask;
            // Note: For superior performance, TensorFlow.js always uses
            // implementation 2 regardless of the actual value of
            // config.implementation.
            let i;
            let f;
            let c;
            let o;
            if (0 < this.dropout && this.dropout < 1) inputs = $i64bB.mul(inputs, dpMask[0]);
            let z = $33b0bdd0433db936$export$94132a0e348806d4(inputs, this.kernel.read());
            if (0 < this.recurrentDropout && this.recurrentDropout < 1) hTMinus1 = $i64bB.mul(hTMinus1, recDpMask[0]);
            z = $i64bB.add(z, $33b0bdd0433db936$export$94132a0e348806d4(hTMinus1, this.recurrentKernel.read()));
            if (this.useBias) z = $33b0bdd0433db936$export$917ce53bce63bd4b(z, this.bias.read());
            const [z0, z1, z2, z3] = $i64bB.split(z, 4, z.rank - 1);
            i = this.recurrentActivation.apply(z0);
            f = this.recurrentActivation.apply(z1);
            c = $i64bB.add($i64bB.mul(f, cTMinus1), $i64bB.mul(i, this.activation.apply(z2)));
            o = this.recurrentActivation.apply(z3);
            const h = $i64bB.mul(o, this.activation.apply(c));
            // TODO(cais): Add use_learning_phase flag properly.
            return [
                h,
                h,
                c
            ];
        });
    }
    getConfig() {
        const baseConfig = super.getConfig();
        const config = {
            units: this.units,
            activation: (0, $30ca3c776e202113$export$8a2c1643c67d0487)(this.activation),
            recurrentActivation: (0, $30ca3c776e202113$export$8a2c1643c67d0487)(this.recurrentActivation),
            useBias: this.useBias,
            kernelInitializer: (0, $49135dd97e6043ca$export$68de06a18c23bdbc)(this.kernelInitializer),
            recurrentInitializer: (0, $49135dd97e6043ca$export$68de06a18c23bdbc)(this.recurrentInitializer),
            biasInitializer: (0, $49135dd97e6043ca$export$68de06a18c23bdbc)(this.biasInitializer),
            unitForgetBias: this.unitForgetBias,
            kernelRegularizer: (0, $030044d54dc1235d$export$7e8cf5899b350405)(this.kernelRegularizer),
            recurrentRegularizer: (0, $030044d54dc1235d$export$7e8cf5899b350405)(this.recurrentRegularizer),
            biasRegularizer: (0, $030044d54dc1235d$export$7e8cf5899b350405)(this.biasRegularizer),
            activityRegularizer: (0, $030044d54dc1235d$export$7e8cf5899b350405)(this.activityRegularizer),
            kernelConstraint: (0, $ef279f7fc82ac2a7$export$e449710617725987)(this.kernelConstraint),
            recurrentConstraint: (0, $ef279f7fc82ac2a7$export$e449710617725987)(this.recurrentConstraint),
            biasConstraint: (0, $ef279f7fc82ac2a7$export$e449710617725987)(this.biasConstraint),
            dropout: this.dropout,
            recurrentDropout: this.recurrentDropout,
            implementation: this.implementation
        };
        return Object.assign(Object.assign({}, baseConfig), config);
    }
}
/** @nocollapse */ $9cf49ab16f0373b1$export$17aacc547a045ab0.className = 'LSTMCell';
(0, $i64bB.serialization).registerClass($9cf49ab16f0373b1$export$17aacc547a045ab0);
class $9cf49ab16f0373b1$export$c8c9213153497ce0 extends $9cf49ab16f0373b1$export$2b97bcdf1d6f1b16 {
    constructor(args){
        if (args.implementation === 0) console.warn("`implementation=0` has been deprecated, and now defaults to `implementation=1`. Please update your layer call.");
        args.cell = new $9cf49ab16f0373b1$export$17aacc547a045ab0(args);
        super(args);
    // TODO(cais): Add activityRegularizer.
    }
    call(inputs, kwargs) {
        return (0, $i64bB.tidy)(()=>{
            if (this.cell.dropoutMask != null) {
                $i64bB.dispose(this.cell.dropoutMask);
                this.cell.dropoutMask = null;
            }
            if (this.cell.recurrentDropoutMask != null) {
                $i64bB.dispose(this.cell.recurrentDropoutMask);
                this.cell.recurrentDropoutMask = null;
            }
            const mask = kwargs == null ? null : kwargs['mask'];
            const training = kwargs == null ? null : kwargs['training'];
            const initialState = kwargs == null ? null : kwargs['initialState'];
            return super.call(inputs, {
                mask: mask,
                training: training,
                initialState: initialState
            });
        });
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        if (config['implmentation'] === 0) config['implementation'] = 1;
        return new cls(config);
    }
}
/** @nocollapse */ $9cf49ab16f0373b1$export$c8c9213153497ce0.className = 'LSTM';
(0, $i64bB.serialization).registerClass($9cf49ab16f0373b1$export$c8c9213153497ce0);
class $9cf49ab16f0373b1$export$966a21a552328009 extends $9cf49ab16f0373b1$export$405d8fca8f98aafd {
    constructor(args){
        super(args);
        this.cells = args.cells;
    }
    get stateSize() {
        // States are a flat list in reverse order of the cell stack.
        // This allows preserving the requirement `stack.statesize[0] ===
        // outputDim`. E.g., states of a 2-layer LSTM would be `[h2, c2, h1, c1]`,
        // assuming one LSTM has states `[h, c]`.
        const stateSize = [];
        for (const cell of this.cells.slice().reverse())if (Array.isArray(cell.stateSize)) stateSize.push(...cell.stateSize);
        else stateSize.push(cell.stateSize);
        return stateSize;
    }
    call(inputs, kwargs) {
        return (0, $i64bB.tidy)(()=>{
            inputs;
            let states = inputs.slice(1);
            // Recover per-cell states.
            const nestedStates = [];
            for (const cell of this.cells.slice().reverse())if (Array.isArray(cell.stateSize)) nestedStates.push(states.splice(0, cell.stateSize.length));
            else nestedStates.push(states.splice(0, 1));
            nestedStates.reverse();
            // Call the cells in order and store the returned states.
            const newNestedStates = [];
            let callInputs;
            for(let i = 0; i < this.cells.length; ++i){
                const cell = this.cells[i];
                states = nestedStates[i];
                // TODO(cais): Take care of constants.
                if (i === 0) callInputs = [
                    inputs[0]
                ].concat(states);
                else callInputs = [
                    callInputs[0]
                ].concat(states);
                callInputs = cell.call(callInputs, kwargs);
                newNestedStates.push(callInputs.slice(1));
            }
            // Format the new states as a flat list in reverse cell order.
            states = [];
            for (const cellStates of newNestedStates.slice().reverse())states.push(...cellStates);
            return [
                callInputs[0]
            ].concat(states);
        });
    }
    build(inputShape) {
        if ((0, $e11ae28082970f77$export$3297ca286d903db0)(inputShape)) // TODO(cais): Take care of input constants.
        // const constantShape = inputShape.slice(1);
        inputShape = inputShape[0];
        inputShape;
        let outputDim;
        this.cells.forEach((cell, i)=>{
            (0, $860027d3b2c99a1d$export$e820b4f57a8e33d1)(`RNNCell_${i}`, ()=>{
                // TODO(cais): Take care of input constants.
                cell.build(inputShape);
                if (Array.isArray(cell.stateSize)) outputDim = cell.stateSize[0];
                else outputDim = cell.stateSize;
                inputShape = [
                    inputShape[0],
                    outputDim
                ];
            });
        });
        this.built = true;
    }
    getConfig() {
        const baseConfig = super.getConfig();
        const getCellConfig = (cell)=>{
            return {
                'className': cell.getClassName(),
                'config': cell.getConfig()
            };
        };
        const cellConfigs = this.cells.map(getCellConfig);
        const config = {
            'cells': cellConfigs
        };
        return Object.assign(Object.assign({}, baseConfig), config);
    }
    /** @nocollapse */ static fromConfig(cls, config, customObjects = {}) {
        const cells = [];
        for (const cellConfig of config['cells'])cells.push((0, $61cac79a6a78765b$export$efcd34ab6248d3cd)(cellConfig, customObjects));
        return new cls({
            cells: cells
        });
    }
    get trainableWeights() {
        if (!this.trainable) return [];
        const weights = [];
        for (const cell of this.cells)weights.push(...cell.trainableWeights);
        return weights;
    }
    get nonTrainableWeights() {
        const weights = [];
        for (const cell of this.cells)weights.push(...cell.nonTrainableWeights);
        if (!this.trainable) {
            const trainableWeights = [];
            for (const cell of this.cells)trainableWeights.push(...cell.trainableWeights);
            return trainableWeights.concat(weights);
        }
        return weights;
    }
    /**
     * Retrieve the weights of a the model.
     *
     * @returns A flat `Array` of `tf.Tensor`s.
     */ getWeights() {
        const weights = [];
        for (const cell of this.cells)weights.push(...cell.weights);
        return (0, $47730a883443b08f$export$3702262f615cc9f0)(weights);
    }
    /**
     * Set the weights of the model.
     *
     * @param weights An `Array` of `tf.Tensor`s with shapes and types matching
     *     the output of `getWeights()`.
     */ setWeights(weights) {
        const tuples = [];
        for (const cell of this.cells){
            const numParams = cell.weights.length;
            const inputWeights = weights.splice(numParams);
            for(let i = 0; i < cell.weights.length; ++i)tuples.push([
                cell.weights[i],
                inputWeights[i]
            ]);
        }
        (0, $47730a883443b08f$export$6b1a34257a4982e4)(tuples);
    }
}
/** @nocollapse */ $9cf49ab16f0373b1$export$966a21a552328009.className = 'StackedRNNCells';
(0, $i64bB.serialization).registerClass($9cf49ab16f0373b1$export$966a21a552328009);
function $9cf49ab16f0373b1$export$9eb0cce22b72569f(args) {
    const { ones: ones, rate: rate, training: training = false, count: count = 1, dropoutFunc: dropoutFunc } = args;
    const droppedInputs = ()=>dropoutFunc != null ? dropoutFunc(ones(), rate) : $33b0bdd0433db936$export$fe05aa12367b4e47(ones(), rate);
    const createMask = ()=>$33b0bdd0433db936$export$5a6eea8e1dcefeb7(droppedInputs, ones, training);
    // just in case count is provided with null or undefined
    if (!count || count <= 1) return $i64bB.keep(createMask().clone());
    const masks = Array(count).fill(undefined).map(createMask);
    return masks.map((m)=>$i64bB.keep(m.clone()));
}


var $42b2362441f50a9b$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
class $42b2362441f50a9b$var$ConvRNN2DCell extends (0, $9cf49ab16f0373b1$export$405d8fca8f98aafd) {
}
/**
 * Base class for convolutional-recurrent layers.
 */ class $42b2362441f50a9b$var$ConvRNN2D extends (0, $9cf49ab16f0373b1$export$2b97bcdf1d6f1b16) {
    constructor(args){
        if (args.unroll) throw new (0, $af476738b120e938$export$e162153238934121)('Unrolling is not possible with convolutional RNNs.');
        if (Array.isArray(args.cell)) throw new (0, $af476738b120e938$export$e162153238934121)('It is not possible at the moment to stack convolutional cells.');
        super(args);
        this.inputSpec = [
            new (0, $03271f6b4e448384$export$7705ee67def9d40a)({
                ndim: 5
            })
        ];
    }
    call(inputs, kwargs) {
        return $i64bB.tidy(()=>{
            if (this.cell.dropoutMask != null) {
                $i64bB.dispose(this.cell.dropoutMask);
                this.cell.dropoutMask = null;
            }
            if (this.cell.recurrentDropoutMask != null) {
                $i64bB.dispose(this.cell.recurrentDropoutMask);
                this.cell.recurrentDropoutMask = null;
            }
            if (kwargs && kwargs['constants']) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)('ConvRNN2D cell does not support constants');
            const mask = kwargs == null ? null : kwargs['mask'];
            const training = kwargs == null ? null : kwargs['training'];
            const initialState = kwargs == null ? null : kwargs['initialState'];
            return super.call(inputs, {
                mask: mask,
                training: training,
                initialState: initialState
            });
        });
    }
    computeOutputShape(inputShape) {
        let outShape = this.computeSingleOutputShape(inputShape);
        if (!this.returnSequences) outShape = [
            outShape[0],
            ...outShape.slice(2)
        ];
        if (this.returnState) outShape = [
            outShape,
            ...Array(2).fill([
                inputShape[0],
                ...outShape.slice(-3)
            ])
        ];
        return outShape;
    }
    getInitialState(inputs) {
        return $i64bB.tidy(()=>{
            const { stateSize: stateSize } = this.cell;
            const inputShape = inputs.shape;
            const outputShape = this.computeSingleOutputShape(inputShape);
            const stateShape = [
                outputShape[0],
                ...outputShape.slice(2)
            ];
            const initialState = $i64bB.zeros(stateShape);
            if (Array.isArray(stateSize)) return Array(stateSize.length).fill(initialState);
            return [
                initialState
            ];
        });
    }
    resetStates(states, training = false) {
        $i64bB.tidy(()=>{
            if (!this.stateful) throw new (0, $af476738b120e938$export$3869bf0637a5d0ff)('Cannot call resetStates() on an RNN Layer that is not stateful.');
            const inputShape = this.inputSpec[0].shape;
            const outputShape = this.computeSingleOutputShape(inputShape);
            const stateShape = [
                outputShape[0],
                ...outputShape.slice(2)
            ];
            const batchSize = inputShape[0];
            if (batchSize == null) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)("If an RNN is stateful, it needs to know its batch size. Specify the batch size of your input tensors: \n- If using a Sequential model, specify the batch size by passing a `batchInputShape` option to your first layer.\n- If using the functional API, specify the batch size by passing a `batchShape` option to your Input layer.");
            // Initialize state if null.
            if (this.getStates() == null) {
                if (Array.isArray(this.cell.stateSize)) this.states_ = this.cell.stateSize.map(()=>$i64bB.zeros(stateShape));
                else this.states_ = [
                    $i64bB.zeros(stateShape)
                ];
            } else if (states == null) {
                // Dispose old state tensors.
                $i64bB.dispose(this.states_);
                // For stateful RNNs, fully dispose kept old states.
                if (this.keptStates != null) {
                    $i64bB.dispose(this.keptStates);
                    this.keptStates = [];
                }
                if (Array.isArray(this.cell.stateSize)) this.states_ = this.cell.stateSize.map(()=>$i64bB.zeros(stateShape));
                else this.states_[0] = $i64bB.zeros(stateShape);
            } else {
                if (!Array.isArray(states)) states = [
                    states
                ];
                if (states.length !== this.states_.length) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Layer ${this.name} expects ${this.states_.length} state(s), ` + `but it received ${states.length} state value(s). Input ` + `received: ${states}`);
                if (training) // Store old state tensors for complete disposal later, i.e., during
                // the next no-arg call to this method. We do not dispose the old
                // states immediately because that BPTT (among other things) require
                // them.
                this.keptStates.push(this.states_.slice());
                else $i64bB.dispose(this.states_);
                for(let index = 0; index < this.states_.length; ++index){
                    const value = states[index];
                    const expectedShape = stateShape;
                    if (!(0, $i64bB.util).arraysEqual(value.shape, expectedShape)) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`State ${index} is incompatible with layer ${this.name}: ` + `expected shape=${expectedShape}, received shape=${value.shape}`);
                    this.states_[index] = value;
                }
            }
            this.states_ = this.states_.map((state)=>$i64bB.keep(state.clone()));
        });
    }
    computeSingleOutputShape(inputShape) {
        const { dataFormat: dataFormat, filters: filters, kernelSize: kernelSize, padding: padding, strides: strides, dilationRate: dilationRate } = this.cell;
        const isChannelsFirst = dataFormat === 'channelsFirst';
        const h = inputShape[isChannelsFirst ? 3 : 2];
        const w = inputShape[isChannelsFirst ? 4 : 3];
        const hOut = (0, $1e685a09ff935a2e$export$50b0adaed374172)(h, kernelSize[0], padding, strides[0], dilationRate[0]);
        const wOut = (0, $1e685a09ff935a2e$export$50b0adaed374172)(w, kernelSize[1], padding, strides[1], dilationRate[1]);
        const outShape = [
            ...inputShape.slice(0, 2),
            ...isChannelsFirst ? [
                filters,
                hOut,
                wOut
            ] : [
                hOut,
                wOut,
                filters
            ]
        ];
        return outShape;
    }
}
/** @nocollapse */ $42b2362441f50a9b$var$ConvRNN2D.className = 'ConvRNN2D';
class $42b2362441f50a9b$export$6fd0801294342e82 extends (0, $9cf49ab16f0373b1$export$17aacc547a045ab0) {
    constructor(args){
        const { filters: filters, kernelSize: kernelSize, strides: strides, padding: padding, dataFormat: dataFormat, dilationRate: dilationRate } = args;
        super(Object.assign(Object.assign({}, args), {
            units: filters
        }));
        this.filters = filters;
        (0, $b5cd0926a1c6df1f$export$7ac3b6580cbed983)(this.filters, 'filters');
        this.kernelSize = (0, $1e685a09ff935a2e$export$8f561980df117376)(kernelSize, 2, 'kernelSize');
        this.kernelSize.forEach((size)=>(0, $b5cd0926a1c6df1f$export$7ac3b6580cbed983)(size, 'kernelSize'));
        this.strides = (0, $1e685a09ff935a2e$export$8f561980df117376)(strides || 1, 2, 'strides');
        this.strides.forEach((stride)=>(0, $b5cd0926a1c6df1f$export$7ac3b6580cbed983)(stride, 'strides'));
        this.padding = padding || 'valid';
        (0, $860027d3b2c99a1d$export$a6c1e84f1d33d64d)(this.padding);
        this.dataFormat = dataFormat || 'channelsLast';
        (0, $860027d3b2c99a1d$export$f5f6472a2b993816)(this.dataFormat);
        this.dilationRate = (0, $1e685a09ff935a2e$export$8f561980df117376)(dilationRate || 1, 2, 'dilationRate');
        this.dilationRate.forEach((rate)=>(0, $b5cd0926a1c6df1f$export$7ac3b6580cbed983)(rate, 'dilationRate'));
    }
    build(inputShape) {
        var _a;
        inputShape = (0, $e11ae28082970f77$export$25c35af872e8abca)(inputShape);
        const channelAxis = this.dataFormat === 'channelsFirst' ? 1 : inputShape.length - 1;
        if (inputShape[channelAxis] == null) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`The channel dimension of the input should be defined. ` + `Found ${inputShape[channelAxis]}`);
        const inputDim = inputShape[channelAxis];
        const numOfKernels = 4;
        const kernelShape = this.kernelSize.concat([
            inputDim,
            this.filters * numOfKernels
        ]);
        this.kernel = this.addWeight('kernel', kernelShape, null, this.kernelInitializer, this.kernelRegularizer, true, this.kernelConstraint);
        const recurrentKernelShape = this.kernelSize.concat([
            this.filters,
            this.filters * numOfKernels
        ]);
        this.recurrentKernel = this.addWeight('recurrent_kernel', recurrentKernelShape, null, this.recurrentInitializer, this.recurrentRegularizer, true, this.recurrentConstraint);
        if (this.useBias) {
            let biasInitializer;
            if (this.unitForgetBias) {
                const init = this.biasInitializer;
                const filters = this.filters;
                biasInitializer = new (_a = class CustomInit extends (0, $49135dd97e6043ca$export$9e14a7677ef1423c) {
                    apply(shape, dtype) {
                        const biasI = init.apply([
                            filters
                        ]);
                        const biasF = $i64bB.ones([
                            filters
                        ]);
                        const biasCAndO = init.apply([
                            filters * 2
                        ]);
                        return $33b0bdd0433db936$export$375c71d43969527d([
                            biasI,
                            biasF,
                            biasCAndO
                        ]);
                    }
                }, /** @nocollapse */ _a.className = 'CustomInit', _a)();
            } else biasInitializer = this.biasInitializer;
            this.bias = this.addWeight('bias', [
                this.filters * numOfKernels
            ], null, biasInitializer, this.biasRegularizer, true, this.biasConstraint);
        }
        this.built = true;
    }
    call(inputs, kwargs) {
        return $i64bB.tidy(()=>{
            if (inputs.length !== 3) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`ConvLSTM2DCell expects 3 input Tensors (inputs, h, c), got ` + `${inputs.length}.`);
            const training = kwargs['training'] || false;
            const x = inputs[0]; // Current input
            const hTMinus1 = inputs[1]; // Previous memory state.
            const cTMinus1 = inputs[2]; // Previous carry state.
            const numOfKernels = 4;
            if (0 < this.dropout && this.dropout < 1 && this.dropoutMask == null) this.dropoutMask = (0, $9cf49ab16f0373b1$export$9eb0cce22b72569f)({
                ones: ()=>$i64bB.onesLike(x),
                rate: this.dropout,
                training: training,
                count: numOfKernels,
                dropoutFunc: this.dropoutFunc
            });
            const dropoutMask = this.dropoutMask;
            const applyDropout = (x, mask, index)=>{
                if (!mask || !mask[index]) return x;
                return $i64bB.mul(mask[index], x);
            };
            let xI = applyDropout(x, dropoutMask, 0);
            let xF = applyDropout(x, dropoutMask, 1);
            let xC = applyDropout(x, dropoutMask, 2);
            let xO = applyDropout(x, dropoutMask, 3);
            if (0 < this.recurrentDropout && this.recurrentDropout < 1 && this.recurrentDropoutMask == null) this.recurrentDropoutMask = (0, $9cf49ab16f0373b1$export$9eb0cce22b72569f)({
                ones: ()=>$i64bB.onesLike(hTMinus1),
                rate: this.recurrentDropout,
                training: training,
                count: numOfKernels,
                dropoutFunc: this.dropoutFunc
            });
            const recDropoutMask = this.recurrentDropoutMask;
            let hI = applyDropout(hTMinus1, recDropoutMask, 0);
            let hF = applyDropout(hTMinus1, recDropoutMask, 1);
            let hC = applyDropout(hTMinus1, recDropoutMask, 2);
            let hO = applyDropout(hTMinus1, recDropoutMask, 3);
            const kernelChannelAxis = 3;
            const [kernelI, kernelF, kernelC, kernelO] = $i64bB.split(this.kernel.read(), numOfKernels, kernelChannelAxis);
            const [biasI, biasF, biasC, biasO] = this.useBias ? $i64bB.split(this.bias.read(), numOfKernels) : [
                null,
                null,
                null,
                null
            ];
            xI = this.inputConv(xI, kernelI, biasI, this.padding);
            xF = this.inputConv(xF, kernelF, biasF, this.padding);
            xC = this.inputConv(xC, kernelC, biasC, this.padding);
            xO = this.inputConv(xO, kernelO, biasO, this.padding);
            const [recKernelI, recKernelF, recKernelC, recKernelO] = $i64bB.split(this.recurrentKernel.read(), numOfKernels, kernelChannelAxis);
            hI = this.recurrentConv(hI, recKernelI);
            hF = this.recurrentConv(hF, recKernelF);
            hC = this.recurrentConv(hC, recKernelC);
            hO = this.recurrentConv(hO, recKernelO);
            const i = this.recurrentActivation.apply($i64bB.add(xI, hI));
            const f = this.recurrentActivation.apply($i64bB.add(xF, hF));
            const c = $i64bB.add($i64bB.mul(f, cTMinus1), $i64bB.mul(i, this.activation.apply($i64bB.add(xC, hC))));
            const h = $i64bB.mul(this.recurrentActivation.apply($i64bB.add(xO, hO)), this.activation.apply(c));
            return [
                h,
                h,
                c
            ];
        });
    }
    getConfig() {
        const _a = super.getConfig(), { 'units': _ } = _a, baseConfig = $42b2362441f50a9b$var$__rest(_a, [
            'units'
        ]);
        const config = {
            filters: this.filters,
            kernelSize: this.kernelSize,
            padding: this.padding,
            dataFormat: this.dataFormat,
            dilationRate: this.dilationRate,
            strides: this.strides
        };
        return Object.assign(Object.assign({}, baseConfig), config);
    }
    inputConv(x, w, b, padding) {
        const out = $i64bB.conv2d(x, w, this.strides, padding || 'valid', this.dataFormat === 'channelsFirst' ? 'NCHW' : 'NHWC', this.dilationRate);
        if (b) return $33b0bdd0433db936$export$917ce53bce63bd4b(out, b, this.dataFormat);
        return out;
    }
    recurrentConv(x, w) {
        const strides = 1;
        return $i64bB.conv2d(x, w, strides, 'same', this.dataFormat === 'channelsFirst' ? 'NCHW' : 'NHWC');
    }
}
/** @nocollapse */ $42b2362441f50a9b$export$6fd0801294342e82.className = 'ConvLSTM2DCell';
$i64bB.serialization.registerClass($42b2362441f50a9b$export$6fd0801294342e82);
class $42b2362441f50a9b$export$d5828f4b24c3231 extends $42b2362441f50a9b$var$ConvRNN2D {
    constructor(args){
        const cell = new $42b2362441f50a9b$export$6fd0801294342e82(args);
        super(Object.assign(Object.assign({}, args), {
            cell: cell
        }));
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config);
    }
}
/** @nocollapse */ $42b2362441f50a9b$export$d5828f4b24c3231.className = 'ConvLSTM2D';
$i64bB.serialization.registerClass($42b2362441f50a9b$export$d5828f4b24c3231);


/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * TensorFlow.js Layers: Basic Layers.
 */ 
var $i64bB = parcelRequire("i64bB");










class $c118003cd9cae39f$export$bb75bf17e9ebd794 extends (0, $03271f6b4e448384$export$936d0764594b6eb3) {
    constructor(args){
        super(args);
        this.rate = Math.max(Math.min(args.rate, 1), 0);
        // So that the scalar doesn't get tidied up between executions.
        this.noiseShape = args.noiseShape;
        this.seed = args.seed;
        this.supportsMasking = true;
    }
    getNoiseShape(input) {
        if (this.noiseShape == null) return this.noiseShape;
        const inputShape = input.shape;
        const noiseShape = [];
        for(let i = 0; i < this.noiseShape.length; ++i)noiseShape.push(this.noiseShape[i] == null ? inputShape[i] : this.noiseShape[i]);
        return noiseShape;
    }
    call(inputs, kwargs) {
        return (0, $i64bB.tidy)(()=>{
            this.invokeCallHook(inputs, kwargs);
            const input = (0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs);
            if (0 < this.rate && this.rate < 1) {
                const training = kwargs['training'] == null ? false : kwargs['training'];
                const noiseShape = this.getNoiseShape(input);
                const output = $33b0bdd0433db936$export$5a6eea8e1dcefeb7(()=>$33b0bdd0433db936$export$fe05aa12367b4e47(input, this.rate, noiseShape, this.seed), ()=>input, training);
                return output;
            }
            return inputs;
        });
    }
    getConfig() {
        const config = {
            rate: this.rate,
            noiseShape: this.noiseShape,
            seed: this.seed
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
    dispose() {
        return super.dispose();
    }
}
/** @nocollapse */ $c118003cd9cae39f$export$bb75bf17e9ebd794.className = 'Dropout';
(0, $i64bB.serialization).registerClass($c118003cd9cae39f$export$bb75bf17e9ebd794);
class $c118003cd9cae39f$export$f86f27a3d1240824 extends $c118003cd9cae39f$export$bb75bf17e9ebd794 {
    constructor(args){
        super(args);
        this.inputSpec = [
            {
                ndim: 3
            }
        ];
    }
    getNoiseShape(input) {
        const inputShape = input.shape;
        return [
            inputShape[0],
            1,
            inputShape[2]
        ];
    }
}
/** @nocollapse */ $c118003cd9cae39f$export$f86f27a3d1240824.className = 'SpatialDropout1D';
(0, $i64bB.serialization).registerClass($c118003cd9cae39f$export$f86f27a3d1240824);
class $c118003cd9cae39f$export$7db6feeaf0335f8 extends (0, $03271f6b4e448384$export$936d0764594b6eb3) {
    constructor(args){
        super(args);
        // Default activation: Linear (none).
        this.activation = null;
        this.useBias = true;
        this.kernel = null;
        this.bias = null;
        this.DEFAULT_KERNEL_INITIALIZER = 'glorotNormal';
        this.DEFAULT_BIAS_INITIALIZER = 'zeros';
        if (args.batchInputShape == null && args.inputShape == null && args.inputDim != null) {
            // This logic is copied from Layer's constructor, since we can't
            // do exactly what the Python constructor does for Dense().
            let batchSize = null;
            if (args.batchSize != null) batchSize = args.batchSize;
            this.batchInputShape = [
                batchSize,
                args.inputDim
            ];
        }
        this.units = args.units;
        (0, $b5cd0926a1c6df1f$export$7ac3b6580cbed983)(this.units, 'units');
        this.activation = (0, $30ca3c776e202113$export$ed84f867ffcf9364)(args.activation);
        if (args.useBias != null) this.useBias = args.useBias;
        this.kernelInitializer = (0, $49135dd97e6043ca$export$558b7d1a338df84b)(args.kernelInitializer || this.DEFAULT_KERNEL_INITIALIZER);
        this.biasInitializer = (0, $49135dd97e6043ca$export$558b7d1a338df84b)(args.biasInitializer || this.DEFAULT_BIAS_INITIALIZER);
        this.kernelConstraint = (0, $ef279f7fc82ac2a7$export$492f40394cb58978)(args.kernelConstraint);
        this.biasConstraint = (0, $ef279f7fc82ac2a7$export$492f40394cb58978)(args.biasConstraint);
        this.kernelRegularizer = (0, $030044d54dc1235d$export$b3404716bfee324c)(args.kernelRegularizer);
        this.biasRegularizer = (0, $030044d54dc1235d$export$b3404716bfee324c)(args.biasRegularizer);
        this.activityRegularizer = (0, $030044d54dc1235d$export$b3404716bfee324c)(args.activityRegularizer);
        this.supportsMasking = true;
        this.inputSpec = [
            {
                minNDim: 2
            }
        ];
    }
    build(inputShape) {
        inputShape = (0, $e11ae28082970f77$export$25c35af872e8abca)(inputShape);
        const inputLastDim = inputShape[inputShape.length - 1];
        if (this.kernel == null) {
            this.kernel = this.addWeight('kernel', [
                inputLastDim,
                this.units
            ], null, this.kernelInitializer, this.kernelRegularizer, true, this.kernelConstraint);
            if (this.useBias) this.bias = this.addWeight('bias', [
                this.units
            ], null, this.biasInitializer, this.biasRegularizer, true, this.biasConstraint);
        }
        this.inputSpec = [
            {
                minNDim: 2,
                axes: {
                    [-1]: inputLastDim
                }
            }
        ];
        this.built = true;
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $e11ae28082970f77$export$25c35af872e8abca)(inputShape);
        const outputShape = inputShape.slice();
        outputShape[outputShape.length - 1] = this.units;
        return outputShape;
    }
    call(inputs, kwargs) {
        return (0, $i64bB.tidy)(()=>{
            this.invokeCallHook(inputs, kwargs);
            // Dense layer accepts only a single input.
            const input = (0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs);
            const fusedActivationName = (0, $b5cd0926a1c6df1f$export$aa3e0e68e0c6329f)(this.activation.getClassName());
            let output;
            if (fusedActivationName != null) output = $33b0bdd0433db936$export$94132a0e348806d4(input, this.kernel.read(), fusedActivationName, this.bias ? this.bias.read() : null);
            else {
                output = $33b0bdd0433db936$export$94132a0e348806d4(input, this.kernel.read());
                if (this.bias != null) output = $33b0bdd0433db936$export$917ce53bce63bd4b(output, this.bias.read());
                if (this.activation != null) output = this.activation.apply(output);
            }
            return output;
        });
    }
    getConfig() {
        const config = {
            units: this.units,
            activation: (0, $30ca3c776e202113$export$8a2c1643c67d0487)(this.activation),
            useBias: this.useBias,
            kernelInitializer: (0, $49135dd97e6043ca$export$68de06a18c23bdbc)(this.kernelInitializer),
            biasInitializer: (0, $49135dd97e6043ca$export$68de06a18c23bdbc)(this.biasInitializer),
            kernelRegularizer: (0, $030044d54dc1235d$export$7e8cf5899b350405)(this.kernelRegularizer),
            biasRegularizer: (0, $030044d54dc1235d$export$7e8cf5899b350405)(this.biasRegularizer),
            activityRegularizer: (0, $030044d54dc1235d$export$7e8cf5899b350405)(this.activityRegularizer),
            kernelConstraint: (0, $ef279f7fc82ac2a7$export$e449710617725987)(this.kernelConstraint),
            biasConstraint: (0, $ef279f7fc82ac2a7$export$e449710617725987)(this.biasConstraint)
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $c118003cd9cae39f$export$7db6feeaf0335f8.className = 'Dense';
(0, $i64bB.serialization).registerClass($c118003cd9cae39f$export$7db6feeaf0335f8);
class $c118003cd9cae39f$export$929ed232258ef592 extends (0, $03271f6b4e448384$export$936d0764594b6eb3) {
    constructor(args){
        args = args || {};
        super(args);
        this.inputSpec = [
            {
                minNDim: 3
            }
        ];
        this.dataFormat = args.dataFormat;
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $e11ae28082970f77$export$25c35af872e8abca)(inputShape);
        for (const dim of inputShape.slice(1)){
            if (dim == null) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`The shape of the input to "Flatten" is not fully defined ` + `(got ${inputShape.slice(1)}). Make sure to pass a complete ` + `"input_shape" or "batch_input_shape" argument to the first ` + `layer in your model.`);
        }
        return [
            inputShape[0],
            (0, $edee0645f45d9428$export$3b5d61e59fec5e86)(inputShape, 1)
        ];
    }
    call(inputs, kwargs) {
        return (0, $i64bB.tidy)(()=>{
            this.invokeCallHook(inputs, kwargs);
            let input = (0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs);
            if (this.dataFormat === 'channelsFirst' && input.rank > 1) {
                const permutation = [
                    0
                ];
                for(let i = 2; i < input.rank; ++i)permutation.push(i);
                permutation.push(1);
                input = (0, $i64bB.transpose)(input, permutation);
            }
            return $33b0bdd0433db936$export$6d182438241cb7ab(input);
        });
    }
    getConfig() {
        const config = {};
        if (this.dataFormat != null) config['dataFormat'] = this.dataFormat;
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $c118003cd9cae39f$export$929ed232258ef592.className = 'Flatten';
(0, $i64bB.serialization).registerClass($c118003cd9cae39f$export$929ed232258ef592);
class $c118003cd9cae39f$export$d4842319833f6f14 extends (0, $03271f6b4e448384$export$936d0764594b6eb3) {
    constructor(args){
        super(args);
        this.supportsMasking = true;
        this.activation = (0, $30ca3c776e202113$export$ed84f867ffcf9364)(args.activation);
    }
    call(inputs, kwargs) {
        return (0, $i64bB.tidy)(()=>{
            this.invokeCallHook(inputs, kwargs);
            const input = (0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs);
            return this.activation.apply(input);
        });
    }
    getConfig() {
        const config = {
            activation: (0, $30ca3c776e202113$export$8a2c1643c67d0487)(this.activation)
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $c118003cd9cae39f$export$d4842319833f6f14.className = 'Activation';
(0, $i64bB.serialization).registerClass($c118003cd9cae39f$export$d4842319833f6f14);
class $c118003cd9cae39f$export$6cf81e630ba27dd9 extends (0, $03271f6b4e448384$export$936d0764594b6eb3) {
    constructor(args){
        super(args);
        this.n = args.n;
        this.inputSpec = [
            {
                ndim: 2
            }
        ];
    }
    computeOutputShape(inputShape) {
        return [
            inputShape[0],
            this.n,
            inputShape[1]
        ];
    }
    call(inputs, kwargs) {
        return (0, $i64bB.tidy)(()=>{
            inputs = (0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs);
            return $33b0bdd0433db936$export$76d90c956114f2c2(inputs, this.n);
        });
    }
    getConfig() {
        const config = {
            n: this.n
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $c118003cd9cae39f$export$6cf81e630ba27dd9.className = 'RepeatVector';
(0, $i64bB.serialization).registerClass($c118003cd9cae39f$export$6cf81e630ba27dd9);
class $c118003cd9cae39f$export$755ddd847e5abe03 extends (0, $03271f6b4e448384$export$936d0764594b6eb3) {
    constructor(args){
        super(args);
        this.targetShape = args.targetShape;
        // Make sure that all unknown dimensions are represented as `null`.
        for(let i = 0; i < this.targetShape.length; ++i)if (this.isUnknown(this.targetShape[i])) this.targetShape[i] = null;
    }
    isUnknown(dim) {
        return dim < 0 || dim == null;
    }
    /**
     * Finds and replaces a missing dimension in output shape.
     *
     * This is a near direct port of the internal Numpy function
     * `_fix_unknown_dimension` in `numpy/core/src/multiarray/shape.c`.
     *
     * @param inputShape: Original shape of array begin reshape.
     * @param outputShape: Target shape of the array, with at most a single
     * `null` or negative number, which indicates an underdetermined dimension
     * that should be derived from `inputShape` and the known dimensions of
     *   `outputShape`.
     * @returns: The output shape with `null` replaced with its computed value.
     * @throws: ValueError: If `inputShape` and `outputShape` do not match.
     */ fixUnknownDimension(inputShape, outputShape) {
        const errorMsg = 'Total size of new array must be unchanged.';
        const finalShape = outputShape.slice();
        let known = 1;
        let unknown = null;
        for(let i = 0; i < finalShape.length; ++i){
            const dim = finalShape[i];
            if (this.isUnknown(dim)) {
                if (unknown === null) unknown = i;
                else throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)('Can only specifiy one unknown dimension.');
            } else known *= dim;
        }
        const originalSize = (0, $edee0645f45d9428$export$3b5d61e59fec5e86)(inputShape);
        if (unknown !== null) {
            if (known === 0 || originalSize % known !== 0) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(errorMsg);
            finalShape[unknown] = originalSize / known;
        } else if (originalSize !== known) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(errorMsg);
        return finalShape;
    }
    computeOutputShape(inputShape) {
        let anyUnknownDims = false;
        for(let i = 0; i < inputShape.length; ++i)if (this.isUnknown(inputShape[i])) {
            anyUnknownDims = true;
            break;
        }
        if (anyUnknownDims) return inputShape.slice(0, 1).concat(this.targetShape);
        else return inputShape.slice(0, 1).concat(this.fixUnknownDimension(inputShape.slice(1), this.targetShape));
    }
    call(inputs, kwargs) {
        return (0, $i64bB.tidy)(()=>{
            this.invokeCallHook(inputs, kwargs);
            const input = (0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs);
            const inputShape = input.shape;
            const outputShape = inputShape.slice(0, 1).concat(this.fixUnknownDimension(inputShape.slice(1), this.targetShape));
            return (0, $i64bB.reshape)(input, outputShape);
        });
    }
    getConfig() {
        const config = {
            targetShape: this.targetShape
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $c118003cd9cae39f$export$755ddd847e5abe03.className = 'Reshape';
(0, $i64bB.serialization).registerClass($c118003cd9cae39f$export$755ddd847e5abe03);
class $c118003cd9cae39f$export$f107458f792fb62e extends (0, $03271f6b4e448384$export$936d0764594b6eb3) {
    constructor(args){
        super(args);
        if (args.dims == null) throw new Error("Required configuration field `dims` is missing during Permute constructor call.");
        if (!Array.isArray(args.dims)) throw new Error('Permute constructor requires `dims` to be an Array, but received ' + `${args.dims} instead.`);
        // Check the validity of the permutation indices.
        const expectedSortedIndices = (0, $edee0645f45d9428$export$d02631cccf789723)(1, args.dims.length + 1);
        if (!(0, $i64bB.util).arraysEqual(args.dims.slice().sort(), expectedSortedIndices)) throw new Error('Invalid permutation `dims`: ' + JSON.stringify(args.dims) + ' `dims` must contain consecutive integers starting from 1.');
        this.dims = args.dims;
        this.dimsIncludingBatch = [
            0
        ].concat(this.dims);
        this.inputSpec = [
            new (0, $03271f6b4e448384$export$7705ee67def9d40a)({
                ndim: this.dims.length + 1
            })
        ];
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $e11ae28082970f77$export$25c35af872e8abca)(inputShape);
        const outputShape = inputShape.slice();
        this.dims.forEach((dim, i)=>{
            outputShape[i + 1] = inputShape[dim];
        });
        return outputShape;
    }
    call(inputs, kwargs) {
        return (0, $i64bB.transpose)((0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs), this.dimsIncludingBatch);
    }
    getConfig() {
        const config = {
            dims: this.dims
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $c118003cd9cae39f$export$f107458f792fb62e.className = 'Permute';
(0, $i64bB.serialization).registerClass($c118003cd9cae39f$export$f107458f792fb62e);
class $c118003cd9cae39f$export$b713323c862a70bd extends (0, $03271f6b4e448384$export$936d0764594b6eb3) {
    constructor(args){
        super(args == null ? {} : args);
        this.supportsMasking = true;
        if (args != null) this.maskValue = args.maskValue == null ? 0 : args.maskValue;
        else this.maskValue = 0;
    }
    computeOutputShape(inputShape) {
        return inputShape;
    }
    getConfig() {
        const baseConfig = super.getConfig();
        const config = {
            maskValue: this.maskValue
        };
        Object.assign(config, baseConfig);
        return config;
    }
    computeMask(inputs, mask) {
        const input = (0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs);
        const axis = -1;
        return (0, $i64bB.any)((0, $i64bB.notEqual)(input, this.maskValue), axis);
    }
    call(inputs, kwargs) {
        return (0, $i64bB.tidy)(()=>{
            this.invokeCallHook(inputs, kwargs);
            const input = (0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs);
            const axis = -1;
            const keepDims = true;
            const booleanMask = (0, $i64bB.any)((0, $i64bB.notEqual)(input, this.maskValue), axis, keepDims);
            const output = (0, $i64bB.mul)(input, (0, $i64bB.cast)(booleanMask, input.dtype));
            return output;
        });
    }
}
/** @nocollapse */ $c118003cd9cae39f$export$b713323c862a70bd.className = 'Masking';
(0, $i64bB.serialization).registerClass($c118003cd9cae39f$export$b713323c862a70bd);


/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * TensorFlow.js Layers: Embedding Layer.
 *
 * Original source: keras/constraints.py
 */ 
var $i64bB = parcelRequire("i64bB");








class $9dd3d81b8a7d8f81$export$d4aa6cf23314fd52 extends (0, $03271f6b4e448384$export$936d0764594b6eb3) {
    constructor(args){
        super(args);
        this.embeddings = null;
        this.DEFAULT_EMBEDDINGS_INITIALIZER = 'randomUniform';
        if (args.batchInputShape == null && args.inputShape == null) {
            // Porting Note: This logic is copied from Layer's constructor, since we
            // can't do exactly what the Python constructor does for Embedding().
            // Specifically, the super constructor can not be called after the
            // mutation of the `config` argument.
            let batchSize = null;
            if (args.batchSize != null) batchSize = args.batchSize;
            if (args.inputLength == null) // Fix super-constructor to what it would have done if
            // 'config.inputShape' were (None, )
            this.batchInputShape = [
                batchSize,
                null
            ];
            else // Fix super-constructor to what it would have done if
            // 'config.inputShape' were (config.inputLength, )
            this.batchInputShape = [
                batchSize
            ].concat($b5cd0926a1c6df1f$export$effcdbd76139450(args.inputLength));
        }
        this.inputDim = args.inputDim;
        $b5cd0926a1c6df1f$export$7ac3b6580cbed983(this.inputDim, 'inputDim');
        this.outputDim = args.outputDim;
        $b5cd0926a1c6df1f$export$7ac3b6580cbed983(this.outputDim, 'outputDim');
        this.embeddingsInitializer = (0, $49135dd97e6043ca$export$558b7d1a338df84b)(args.embeddingsInitializer || this.DEFAULT_EMBEDDINGS_INITIALIZER);
        this.embeddingsRegularizer = (0, $030044d54dc1235d$export$b3404716bfee324c)(args.embeddingsRegularizer);
        this.activityRegularizer = (0, $030044d54dc1235d$export$b3404716bfee324c)(args.activityRegularizer);
        this.embeddingsConstraint = (0, $ef279f7fc82ac2a7$export$492f40394cb58978)(args.embeddingsConstraint);
        this.maskZero = args.maskZero;
        this.supportsMasking = args.maskZero;
        this.inputLength = args.inputLength;
    }
    build(inputShape) {
        this.embeddings = this.addWeight('embeddings', [
            this.inputDim,
            this.outputDim
        ], this.dtype, this.embeddingsInitializer, this.embeddingsRegularizer, true, this.embeddingsConstraint);
        this.built = true;
    }
    // Override warnOnIncompatibleInputShape because an embedding layer allows
    // the input to have varying ranks.
    warnOnIncompatibleInputShape(inputShape) {}
    computeMask(inputs, mask) {
        return (0, $i64bB.tidy)(()=>{
            if (!this.maskZero) return null;
            else {
                inputs = (0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs);
                return (0, $i64bB.notEqual)(inputs, (0, $i64bB.zerosLike)(inputs));
            }
        });
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $e11ae28082970f77$export$25c35af872e8abca)(inputShape);
        if (this.inputLength == null) return [
            ...inputShape,
            this.outputDim
        ];
        // inputLength can be an array if input is 3D or higher.
        const inLens = $b5cd0926a1c6df1f$export$effcdbd76139450(this.inputLength);
        if (inLens.length !== inputShape.length - 1) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`"inputLength" is ${this.inputLength}, but received ` + `input shape has shape ${inputShape}`);
        else {
            let i = 0;
            for(let k = 0; k < inLens.length; ++k){
                const s1 = inLens[k];
                const s2 = inputShape[k + 1];
                if (s1 != null && s2 != null && s1 !== s2) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`"inputLength" is ${this.inputLength}, but received ` + `input shape has shape ${inputShape}`);
                else if (s1 == null) inLens[i] = s2;
                i++;
            }
        }
        return [
            inputShape[0],
            ...inLens,
            this.outputDim
        ];
    }
    call(inputs, kwargs) {
        return (0, $i64bB.tidy)(()=>{
            this.invokeCallHook(inputs, kwargs);
            // Embedding layer accepts only a single input.
            let input = (0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs);
            if (input.dtype !== 'int32') input = $33b0bdd0433db936$export$f2db7d5238e1d23f(input, 'int32');
            const output = $33b0bdd0433db936$export$9e05546f00427e8(this.embeddings.read(), (0, $i64bB.reshape)(input, [
                input.size
            ]));
            return (0, $i64bB.reshape)(output, (0, $e11ae28082970f77$export$25c35af872e8abca)(this.computeOutputShape(input.shape)));
        });
    }
    getConfig() {
        const config = {
            inputDim: this.inputDim,
            outputDim: this.outputDim,
            embeddingsInitializer: (0, $49135dd97e6043ca$export$68de06a18c23bdbc)(this.embeddingsInitializer),
            embeddingsRegularizer: (0, $030044d54dc1235d$export$7e8cf5899b350405)(this.embeddingsRegularizer),
            activityRegularizer: (0, $030044d54dc1235d$export$7e8cf5899b350405)(this.activityRegularizer),
            embeddingsConstraint: (0, $ef279f7fc82ac2a7$export$e449710617725987)(this.embeddingsConstraint),
            maskZero: this.maskZero,
            inputLength: this.inputLength
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $9dd3d81b8a7d8f81$export$d4aa6cf23314fd52.className = 'Embedding';
(0, $i64bB.serialization).registerClass($9dd3d81b8a7d8f81$export$d4aa6cf23314fd52);


/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * TensorFlow.js Layers: Merge Layers.
 */ 
var $i64bB = parcelRequire("i64bB");







class $ada5d50a4ce56f10$export$70ce1d34efd3b886 extends (0, $03271f6b4e448384$export$936d0764594b6eb3) {
    constructor(args){
        super(args || {});
        this.supportsMasking = true;
    }
    /**
     * Logic for merging multiple tensors, to be overridden by subclasses.
     * @param inputs
     */ mergeFunction(inputs) {
        throw new (0, $af476738b120e938$export$e162153238934121)();
    }
    /**
     * Computes the shape of the result of an elementwise operation.
     *
     * @param shape1: Shape of the first tensor.
     * @param shape2: Shape of the second tensor.
     * @returns Expected output shape when an elementwise operation is carried
     *   out on 2 tensors with shapes `shape1` and `shape2`.
     * @throws ValueError: If `shape1` and `shape2` are not compatible for
     *   element-wise operations.
     */ computeElementwiseOpOutputShape(shape1, shape2) {
        if (shape1 == null || shape2 == null) return null;
        else if (shape1.length < shape2.length) return this.computeElementwiseOpOutputShape(shape2, shape1);
        else if (shape2.length === 0) return shape1;
        const outputShape = shape1.slice(0, shape1.length - shape2.length);
        for(let k = 0; k < shape2.length; ++k){
            const i = shape1[shape1.length - shape2.length + k];
            const j = shape2[k];
            if (i == null || j == null || i < 0 || j < 0) outputShape.push(null);
            else if (i === 1) outputShape.push(j);
            else if (j === 1) outputShape.push(i);
            else {
                if (i !== j) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)('Operands could not be broadcast together with shapes ' + JSON.stringify(shape1) + ' ' + JSON.stringify(shape2));
                outputShape.push(i);
            }
        }
        return outputShape;
    }
    build(inputShape) {
        // Used purely for shape validation.
        if (Array.isArray(inputShape) && !Array.isArray(inputShape[0])) // Make sure that inputShape is an Array of shape.
        inputShape = [
            (0, $e11ae28082970f77$export$25c35af872e8abca)(inputShape)
        ];
        inputShape;
        if (inputShape.length < 2) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)('A merge layer should be called on an Array of at least 2 inputs.' + ` Got ${inputShape.length} input(s).`);
        // Make sure that there is at most one unique batch size among the input
        // shapes.
        let batchSizes = [];
        for (const shape of inputShape)if (shape != null && shape[0] !== null) batchSizes.push(shape[0]);
        batchSizes = $b5cd0926a1c6df1f$export$7a5d5c156e7dc406(batchSizes);
        if (batchSizes.length > 1) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Can not merge tensors with different batch sizes. ` + `Got tensors with shapes: ${JSON.stringify(inputShape)}.`);
        let outputShape = inputShape[0] == null ? null : inputShape[0].slice(1);
        for(let i = 1; i < inputShape.length; ++i){
            const shape = inputShape[i] == null ? null : inputShape[i].slice(1);
            outputShape = this.computeElementwiseOpOutputShape(outputShape, shape);
        }
        // If the inputs have different ranks, we have to reshape them to make them
        // broadcastable.
        const allRanks = inputShape.map((shape)=>shape.length);
        if (inputShape.indexOf(null) === -1 && $b5cd0926a1c6df1f$export$7a5d5c156e7dc406(allRanks).length === 1) this.reshapeRequired = false;
        else this.reshapeRequired = true;
    }
    call(inputs, kwargs) {
        return (0, $i64bB.tidy)(()=>{
            inputs;
            if (this.reshapeRequired) {
                const reshapedInputs = [];
                const inputDims = inputs.map((input)=>input.rank);
                if (inputDims.indexOf(null) === -1) {
                    // If ranks of all inputs are available, we simply expand each of them
                    // at axis=1 until all of them have the same rank.
                    const maxNDim = $edee0645f45d9428$export$8960430cfd85939f(inputDims);
                    for (let x of inputs){
                        const xNDim = x.rank;
                        for(let k = 0; k < maxNDim - xNDim; ++k)x = $33b0bdd0433db936$export$d660d8ed21f46635(x, 1);
                        reshapedInputs.push(x);
                    }
                    return this.mergeFunction(reshapedInputs);
                } else {
                    // Transpose all inputs so that batch size is the last dimension.
                    // [batchSize, dim1, dim2, ...] -> [dim1, dim2, ..., batchSize]
                    let transposed = false;
                    for (const x of inputs){
                        const xNDim = x.rank;
                        if (xNDim == null) {
                            const xShape = x.shape;
                            const batchSize = xShape[0];
                            const newShape = xShape.slice(1).concat([
                                batchSize
                            ]);
                            let xTransposed = $i64bB.reshape(x, [
                                batchSize
                            ].concat($edee0645f45d9428$export$3b5d61e59fec5e86(xShape.slice(1))));
                            xTransposed = $i64bB.transpose(xTransposed, [
                                1,
                                0
                            ]);
                            xTransposed = $i64bB.reshape(xTransposed, newShape);
                            reshapedInputs.push(xTransposed);
                            transposed = true;
                        } else if (xNDim > 1) {
                            const dims = $edee0645f45d9428$export$d02631cccf789723(1, xNDim).concat([
                                0
                            ]);
                            reshapedInputs.push($i64bB.transpose(x, dims));
                            transposed = true;
                        } else // We don't transpose inputs if they are 1D vectors or scalars.
                        reshapedInputs.push(x);
                    }
                    let y = this.mergeFunction(reshapedInputs);
                    const yNDim = y.rank;
                    if (transposed) {
                        // If inputs have been transposed, we have to transpose the output
                        // too.
                        if (yNDim == null) {
                            const yShape = y.shape;
                            const yNDim = yShape.length;
                            const batchSize = yShape[yNDim - 1];
                            const newShape = [
                                batchSize
                            ].concat(yShape.slice(0, yShape.length - 1));
                            y = $i64bB.reshape($i64bB.transpose($i64bB.reshape(y, [
                                -1,
                                batchSize
                            ]), [
                                1,
                                0
                            ]), newShape);
                        } else if (yNDim > 1) {
                            const dims = [
                                yNDim - 1
                            ].concat($edee0645f45d9428$export$d02631cccf789723(0, yNDim - 1));
                            y = $i64bB.transpose(y, dims);
                        }
                    }
                    return y;
                }
            } else return this.mergeFunction(inputs);
        });
    }
    computeOutputShape(inputShape) {
        inputShape;
        let outputShape;
        if (inputShape[0] == null) outputShape = null;
        else outputShape = inputShape[0].slice(1);
        for(let i = 1; i < inputShape.length; ++i){
            const shape = inputShape[i] == null ? null : inputShape[i].slice(1);
            outputShape = this.computeElementwiseOpOutputShape(outputShape, shape);
        }
        let batchSizes = [];
        for (const shape of inputShape)if (shape != null && shape[0] !== null) batchSizes.push(shape[0]);
        batchSizes = $b5cd0926a1c6df1f$export$7a5d5c156e7dc406(batchSizes);
        if (batchSizes.length === 1) outputShape = batchSizes.concat(outputShape);
        else outputShape = [
            null
        ].concat(outputShape);
        return outputShape;
    }
    computeMask(inputs, mask) {
        return $i64bB.tidy(()=>{
            if (mask == null) return null;
            if (!Array.isArray(mask)) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)('`mask` should be an Array');
            if (!Array.isArray(inputs)) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)('`inputs` should be an Array');
            if (mask.length !== inputs.length) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`The Array 'inputs' and 'mask' are expected to have the same ` + `length, but have different lengths ` + `(${inputs.length} vs ${mask.length})`);
            if (mask.every((m)=>m == null)) return null;
            mask = mask.map((m)=>m == null ? m : $i64bB.expandDims(m, 0));
            let output = mask[0];
            for(let i = 1; i < mask.length - 1; ++i)output = $i64bB.logicalAnd(output, mask[i]);
            return output;
        });
    }
}
class $ada5d50a4ce56f10$export$d0265b2c425512d6 extends $ada5d50a4ce56f10$export$70ce1d34efd3b886 {
    constructor(args){
        super(args);
    }
    mergeFunction(inputs) {
        return (0, $i64bB.tidy)(()=>{
            let output = inputs[0].clone();
            for(let i = 1; i < inputs.length; ++i)output = $i64bB.add(output, inputs[i]);
            return output;
        });
    }
}
/** @nocollapse */ $ada5d50a4ce56f10$export$d0265b2c425512d6.className = 'Add';
(0, $i64bB.serialization).registerClass($ada5d50a4ce56f10$export$d0265b2c425512d6);
function $ada5d50a4ce56f10$export$e16d8520af44a096(config) {
    if (Array.isArray(config)) {
        const layer = new $ada5d50a4ce56f10$export$d0265b2c425512d6({});
        return layer.apply(config);
    } else return new $ada5d50a4ce56f10$export$d0265b2c425512d6(config);
}
class $ada5d50a4ce56f10$export$f14f83b3b531d498 extends $ada5d50a4ce56f10$export$70ce1d34efd3b886 {
    constructor(args){
        super(args);
    }
    mergeFunction(inputs) {
        return (0, $i64bB.tidy)(()=>{
            let output = inputs[0].clone();
            for(let i = 1; i < inputs.length; ++i)output = $i64bB.mul(output, inputs[i]);
            return output;
        });
    }
}
/** @nocollapse */ $ada5d50a4ce56f10$export$f14f83b3b531d498.className = 'Multiply';
(0, $i64bB.serialization).registerClass($ada5d50a4ce56f10$export$f14f83b3b531d498);
function $ada5d50a4ce56f10$export$2060d2db72cce88f(config) {
    if (Array.isArray(config)) {
        const layer = new $ada5d50a4ce56f10$export$f14f83b3b531d498({});
        return layer.apply(config);
    } else return new $ada5d50a4ce56f10$export$f14f83b3b531d498(config);
}
class $ada5d50a4ce56f10$export$7725e1a7540355cb extends $ada5d50a4ce56f10$export$70ce1d34efd3b886 {
    constructor(args){
        super(args);
    }
    mergeFunction(inputs) {
        return (0, $i64bB.tidy)(()=>{
            let output = inputs[0].clone();
            for(let i = 1; i < inputs.length; ++i)output = $i64bB.add(output, inputs[i]);
            return $i64bB.mul(1 / inputs.length, output);
        });
    }
}
/** @nocollapse */ $ada5d50a4ce56f10$export$7725e1a7540355cb.className = 'Average';
(0, $i64bB.serialization).registerClass($ada5d50a4ce56f10$export$7725e1a7540355cb);
function $ada5d50a4ce56f10$export$cc6710ee5f037d57(config) {
    if (Array.isArray(config)) {
        const layer = new $ada5d50a4ce56f10$export$7725e1a7540355cb({});
        return layer.apply(config);
    } else return new $ada5d50a4ce56f10$export$7725e1a7540355cb(config);
}
class $ada5d50a4ce56f10$export$d8d02ac92d161004 extends $ada5d50a4ce56f10$export$70ce1d34efd3b886 {
    constructor(args){
        super(args);
    }
    mergeFunction(inputs) {
        return (0, $i64bB.tidy)(()=>{
            let output = inputs[0];
            for(let i = 1; i < inputs.length; ++i)output = $i64bB.maximum(output, inputs[i]);
            return output;
        });
    }
}
/** @nocollapse */ $ada5d50a4ce56f10$export$d8d02ac92d161004.className = 'Maximum';
(0, $i64bB.serialization).registerClass($ada5d50a4ce56f10$export$d8d02ac92d161004);
function $ada5d50a4ce56f10$export$b25e0be55f42c9a(config) {
    if (Array.isArray(config)) {
        const layer = new $ada5d50a4ce56f10$export$d8d02ac92d161004({});
        return layer.apply(config);
    } else return new $ada5d50a4ce56f10$export$d8d02ac92d161004(config);
}
class $ada5d50a4ce56f10$export$23cb308301e89d6b extends $ada5d50a4ce56f10$export$70ce1d34efd3b886 {
    constructor(args){
        super(args);
    }
    mergeFunction(inputs) {
        return (0, $i64bB.tidy)(()=>{
            let output = inputs[0];
            for(let i = 1; i < inputs.length; ++i)output = $i64bB.minimum(output, inputs[i]);
            return output;
        });
    }
}
/** @nocollapse */ $ada5d50a4ce56f10$export$23cb308301e89d6b.className = 'Minimum';
(0, $i64bB.serialization).registerClass($ada5d50a4ce56f10$export$23cb308301e89d6b);
function $ada5d50a4ce56f10$export$916782c1f0ddb132(config) {
    if (Array.isArray(config)) {
        const layer = new $ada5d50a4ce56f10$export$23cb308301e89d6b({});
        return layer.apply(config);
    } else return new $ada5d50a4ce56f10$export$23cb308301e89d6b(config);
}
class $ada5d50a4ce56f10$export$e55b597c359d82cd extends $ada5d50a4ce56f10$export$70ce1d34efd3b886 {
    constructor(args){
        super(args);
        this.DEFAULT_AXIS = -1;
        if (args == null) args = {};
        this.axis = args.axis == null ? this.DEFAULT_AXIS : args.axis;
        this.supportsMasking = true;
        this.reshapeRequired = false;
    }
    build(inputShape) {
        // Used purely for shape validation.]
        if (!(Array.isArray(inputShape) && Array.isArray(inputShape[0])) || inputShape.length === 1) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)("A `Concatenate` layer should be called on a list of at least 2 inputs");
        inputShape;
        let allNoneShape = true;
        for (const shape of inputShape)if (shape != null) {
            allNoneShape = false;
            break;
        }
        if (allNoneShape) return;
        const shapeSet = [];
        for(let i = 0; i < inputShape.length; ++i){
            const shapeWithoutConcatAxis = inputShape[i].slice();
            shapeWithoutConcatAxis.splice(this.axis, 1);
            let exists = false;
            for (const shape of shapeSet)if ((0, $i64bB.util).arraysEqual(shape, shapeWithoutConcatAxis)) {
                exists = true;
                break;
            }
            if (!exists) shapeSet.push(shapeWithoutConcatAxis);
        }
        if (shapeSet.length > 1) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)("A `Concatenate` layer requires inputs with matching shapes except for the concat axis. Got input shapes: " + JSON.stringify(inputShape));
    }
    mergeFunction(inputs) {
        return (0, $i64bB.tidy)(()=>{
            return $33b0bdd0433db936$export$375c71d43969527d(inputs, this.axis);
        });
    }
    computeOutputShape(inputShape) {
        if (!(Array.isArray(inputShape) && Array.isArray(inputShape[0]))) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)('A `Concatenate` layer should be called on a list of inputs.');
        const inputShapes = inputShape;
        const outputShape = inputShapes[0].slice();
        const axis = this.axis < 0 ? outputShape.length + this.axis : this.axis;
        // Porting Note: the line above is because TypeScript doesn't support
        //   negative indices.
        for (const shape of inputShapes.slice(1)){
            if (outputShape[axis] == null || shape[axis] == null) {
                outputShape[axis] = null;
                break;
            }
            outputShape[axis] += shape[axis];
        }
        return outputShape;
    }
    computeMask(inputs, mask) {
        if (mask == null) return null;
        if (!Array.isArray(mask)) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)('`mask` should be an array for Concatenate');
        if (!Array.isArray(inputs)) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)('`inputs` should be an array for Concatenate');
        if (mask.length !== inputs.length) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Mismatch in the length of mask (${mask.length}) ` + `and the legnth of inputs (${inputs.length})`);
        return $i64bB.tidy(()=>{
            let allNullMasks = true;
            mask.forEach((m)=>{
                if (m != null) {
                    allNullMasks = false;
                    return;
                }
            });
            if (allNullMasks) return null;
            const outputMasks = [];
            for(let i = 0; i < inputs.length; ++i){
                if (mask[i] == null) // Input is unmasked. Append all 1's to masks.
                outputMasks.push($i64bB.cast($i64bB.onesLike(inputs[i]), 'bool'));
                else if (mask[i].rank < inputs[i].rank) // Mask is smaller than the input, expand it.
                outputMasks.push($i64bB.expandDims(mask[i], -1));
                else outputMasks.push(mask[i]);
            }
            const concatenatedMasks = $i64bB.concat(outputMasks, this.axis);
            return $i64bB.all(concatenatedMasks, -1, false);
        });
    }
    getConfig() {
        const config = {
            'axis': this.axis
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $ada5d50a4ce56f10$export$e55b597c359d82cd.className = 'Concatenate';
(0, $i64bB.serialization).registerClass($ada5d50a4ce56f10$export$e55b597c359d82cd);
function $ada5d50a4ce56f10$export$375c71d43969527d(config) {
    if (Array.isArray(config)) {
        const layer = new $ada5d50a4ce56f10$export$e55b597c359d82cd({});
        return layer.apply(config);
    } else return new $ada5d50a4ce56f10$export$e55b597c359d82cd(config);
}
/**
 * Interpretable potentially negative axis index.
 *
 * For example, given axis = -1, and dim = 3, this function will return 2.
 *
 * @param axis The axis index, may be a positive, zero or negative integer.
 * @param dim Total number of dimensions, a positive integer.
 * @returns A non-negative axis index equivalent to the input `axis`.
 */ function $ada5d50a4ce56f10$var$interpretAxis(axis, dim) {
    while(axis < 0)axis += dim;
    return axis;
}
function $ada5d50a4ce56f10$var$batchDot(x, y, axes) {
    if (x.shape.length > 3 || y.shape.length > 3) throw new (0, $af476738b120e938$export$e162153238934121)('batchDot is not implemented for tensors of 4D or higher rank yet');
    $i64bB.util.assert(x.shape.length >= 2, ()=>`batchDot requires the rank of x to be >= 2, ` + `but got ${x.shape.length}`);
    $i64bB.util.assert(x.shape.length >= 2, ()=>`batchDot requires the rank of y to be >= 2, ` + `but got ${y.shape.length}`);
    if (typeof axes === 'number') axes = [
        axes,
        axes
    ];
    if (x.dtype === 'complex64' || y.dtype === 'complex64') throw new (0, $af476738b120e938$export$e162153238934121)('batchDot is not implemented for complex64-type Tensors yet.');
    const xNDim = x.shape.length;
    const yNDim = y.shape.length;
    if (axes == null) // Behave like batchMatmul by default.
    axes = [
        xNDim - 1,
        yNDim - 2
    ];
    const axesArray = axes;
    return $i64bB.tidy(()=>{
        let diff;
        if (xNDim > yNDim) {
            diff = xNDim - yNDim;
            const diffShape = [];
            for(let i = 0; i < diff; ++i)diffShape.push(1);
            y = $i64bB.reshape(y, y.shape.concat(diffShape));
        } else if (yNDim > xNDim) {
            diff = yNDim - xNDim;
            const diffShape = [];
            for(let i = 0; i < diff; ++i)diffShape.push(1);
            x = $i64bB.reshape(x, x.shape.concat(diffShape));
        } else diff = 0;
        let out;
        if (x.shape.length === 2 && y.shape.length === 2) {
            if (axesArray[0] === axesArray[1]) out = $i64bB.sum($i64bB.mul(x, y), axesArray[0]);
            else out = $i64bB.sum($i64bB.mul($i64bB.transpose(x, [
                1,
                0
            ]), y), axesArray[1]);
        } else {
            const adjX = axesArray[0] !== x.shape.length - 1;
            const adjY = axesArray[1] === y.shape.length - 1;
            out = $i64bB.matMul(x, y, adjX, adjY);
        }
        if (diff > 0) {
            let idx;
            if (xNDim > yNDim) idx = xNDim + yNDim - 3;
            else idx = xNDim - 1;
            const squeezeAxes = [];
            for(let i = idx; i < idx + diff; ++i)squeezeAxes.push(i);
            out = $i64bB.squeeze(out, squeezeAxes);
        }
        if (out.shape.length === 1) out = $i64bB.expandDims(out, 1);
        return out;
    });
}
class $ada5d50a4ce56f10$export$d046b3c4a416f60d extends $ada5d50a4ce56f10$export$70ce1d34efd3b886 {
    constructor(args){
        super(args);
        this.axes = args.axes;
        this.normalize = args.normalize == null ? false : args.normalize;
        this.supportsMasking = true;
        this.reshapeRequired = false;
    }
    build(inputShape) {
        $i64bB.util.assert(Array.isArray(inputShape) && inputShape.length === 2 && Array.isArray(inputShape[0]) && Array.isArray(inputShape[1]), ()=>'A `Dot` layer should be called on a list of exactly 2 inputs.');
        const shape1 = inputShape[0];
        const shape2 = inputShape[1];
        if (shape1.length > 3 || shape2.length > 3) throw new (0, $af476738b120e938$export$e162153238934121)('Dot layer does not support tensors of 4D or higher rank yet.');
        const axes = this.interpretAxes(shape1, shape2);
        if (shape1[axes[0]] !== shape2[axes[1]]) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Dimension incompatibility: ` + `${shape1[axes[0]]} !== ${shape2[axes[1]]}`);
    }
    mergeFunction(inputs) {
        if (inputs.length !== 2) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)('A `Dot` layer must be called on exactly 2 inputs, ' + `but received ${inputs.length} input(s).`);
        let x1 = inputs[0];
        let x2 = inputs[1];
        let axes;
        if (!Array.isArray(this.axes)) axes = [
            $ada5d50a4ce56f10$var$interpretAxis(this.axes, x1.shape.length),
            $ada5d50a4ce56f10$var$interpretAxis(this.axes, x2.shape.length)
        ];
        else axes = this.axes.map((axis, i)=>$ada5d50a4ce56f10$var$interpretAxis(axis, inputs[i].shape.length));
        if (this.normalize) {
            x1 = (0, $7d695629521dc3d5$export$56804db0f45bf789)(x1, axes[0]);
            x2 = (0, $7d695629521dc3d5$export$56804db0f45bf789)(x2, axes[1]);
        }
        return $ada5d50a4ce56f10$var$batchDot(x1, x2, axes);
    }
    interpretAxes(shape1, shape2) {
        let axes;
        if (!Array.isArray(this.axes)) // `this.axes` is a single integer.
        axes = [
            $ada5d50a4ce56f10$var$interpretAxis(this.axes, shape1.length),
            $ada5d50a4ce56f10$var$interpretAxis(this.axes, shape2.length)
        ];
        else // `this.axes` is an Array of integers.
        axes = this.axes;
        return axes;
    }
    computeOutputShape(inputShape) {
        $i64bB.util.assert(Array.isArray(inputShape) && inputShape.length === 2 && Array.isArray(inputShape[0]) && Array.isArray(inputShape[1]), ()=>'A `Dot` layer should be called on a list of exactly 2 inputs.');
        const shape1 = inputShape[0].slice();
        const shape2 = inputShape[1].slice();
        if (shape1.length > 3 || shape2.length > 3) throw new (0, $af476738b120e938$export$e162153238934121)('Dot layer does not support tensors of 4D or higher rank yet.');
        const axes = this.interpretAxes(shape1, shape2);
        shape1.splice(axes[0], 1);
        shape2.splice(axes[1], 1);
        shape2.splice(0, 1);
        const outputShape = shape1.concat(shape2);
        if (outputShape.length === 1) outputShape.push(1);
        return outputShape;
    }
    computeMask(inputs, mask) {
        return null;
    }
    getConfig() {
        const config = {
            'axes': this.axes,
            'normalize': this.normalize
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $ada5d50a4ce56f10$export$d046b3c4a416f60d.className = 'Dot';
(0, $i64bB.serialization).registerClass($ada5d50a4ce56f10$export$d046b3c4a416f60d); // TODO(cais): Add functional interfaces for the merge layers.


/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * TensorFlow.js Layers: Noise Layers.
 */ 
var $i64bB = parcelRequire("i64bB");



class $7fc8091152fb4d5a$export$d18d3f770cea837e extends (0, $03271f6b4e448384$export$936d0764594b6eb3) {
    constructor(args){
        super(args);
        this.supportsMasking = true;
        this.stddev = args.stddev;
    }
    computeOutputShape(inputShape) {
        return inputShape;
    }
    getConfig() {
        const baseConfig = super.getConfig();
        const config = {
            stddev: this.stddev
        };
        Object.assign(config, baseConfig);
        return config;
    }
    call(inputs, kwargs) {
        return (0, $i64bB.tidy)(()=>{
            this.invokeCallHook(inputs, kwargs);
            const input = (0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs);
            const noised = ()=>(0, $i64bB.add)($33b0bdd0433db936$export$a0ac5549a8bec918(input.shape, 0, this.stddev), input);
            const output = $33b0bdd0433db936$export$5a6eea8e1dcefeb7(noised, ()=>input, kwargs['training'] || false);
            return output;
        });
    }
}
/** @nocollapse */ $7fc8091152fb4d5a$export$d18d3f770cea837e.className = 'GaussianNoise';
(0, $i64bB.serialization).registerClass($7fc8091152fb4d5a$export$d18d3f770cea837e);
class $7fc8091152fb4d5a$export$c07c4bcc10d07979 extends (0, $03271f6b4e448384$export$936d0764594b6eb3) {
    constructor(args){
        super(args);
        this.supportsMasking = true;
        this.rate = args.rate;
    }
    computeOutputShape(inputShape) {
        return inputShape;
    }
    getConfig() {
        const baseConfig = super.getConfig();
        const config = {
            rate: this.rate
        };
        Object.assign(config, baseConfig);
        return config;
    }
    call(inputs, kwargs) {
        return (0, $i64bB.tidy)(()=>{
            this.invokeCallHook(inputs, kwargs);
            const input = (0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs);
            if (this.rate > 0 && this.rate < 1) {
                const noised = ()=>{
                    const stddev = Math.sqrt(this.rate / (1 - this.rate));
                    return (0, $i64bB.mul)(input, $33b0bdd0433db936$export$a0ac5549a8bec918(input.shape, 1, stddev));
                };
                return $33b0bdd0433db936$export$5a6eea8e1dcefeb7(noised, ()=>input, kwargs['training'] || false);
            }
            return input;
        });
    }
}
/** @nocollapse */ $7fc8091152fb4d5a$export$c07c4bcc10d07979.className = 'GaussianDropout';
(0, $i64bB.serialization).registerClass($7fc8091152fb4d5a$export$c07c4bcc10d07979);
/**
 * Applies Alpha Dropout to the input.
 *
 * As it is a regularization layer, it is only active at training time.
 *
 * Alpha Dropout is a `Dropout` that keeps mean and variance of inputs
 * to their original values, in order to ensure the self-normalizing property
 * even after this dropout.
 * Alpha Dropout fits well to Scaled Exponential Linear Units
 * by randomly setting activations to the negative saturation value.
 *
 * Arguments:
 *   - `rate`: float, drop probability (as with `Dropout`).
 *     The multiplicative noise will have
 *     standard deviation `sqrt(rate / (1 - rate))`.
 *   - `noise_shape`: A 1-D `Tensor` of type `int32`, representing the
 *     shape for randomly generated keep/drop flags.
 *
 * Input shape:
 *   Arbitrary. Use the keyword argument `inputShape`
 *   (tuple of integers, does not include the samples axis)
 *   when using this layer as the first layer in a model.
 *
 * Output shape:
 *   Same shape as input.
 *
 * References:
 *   - [Self-Normalizing Neural Networks](https://arxiv.org/abs/1706.02515)
 */ class $7fc8091152fb4d5a$export$8a44d71014be114 extends (0, $03271f6b4e448384$export$936d0764594b6eb3) {
    constructor(args){
        super(args);
        this.supportsMasking = true;
        this.rate = args.rate;
        this.noiseShape = args.noiseShape;
    }
    _getNoiseShape(inputs) {
        return this.noiseShape || (0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs).shape;
    }
    computeOutputShape(inputShape) {
        return inputShape;
    }
    getConfig() {
        const baseConfig = super.getConfig();
        const config = {
            rate: this.rate
        };
        Object.assign(config, baseConfig);
        return config;
    }
    call(inputs, kwargs) {
        return (0, $i64bB.tidy)(()=>{
            if (this.rate < 1 && this.rate > 0) {
                const noiseShape = this._getNoiseShape(inputs);
                const droppedInputs = ()=>{
                    const input = (0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs);
                    const alpha = 1.6732632423543772848170429916717;
                    const scale = 1.0507009873554804934193349852946;
                    const alphaP = -alpha * scale;
                    let keptIdx = (0, $i64bB.greaterEqual)((0, $i64bB.randomUniform)(noiseShape), this.rate);
                    keptIdx = $33b0bdd0433db936$export$f2db7d5238e1d23f(keptIdx, 'float32'); // get default dtype.
                    // Get affine transformation params.
                    const a = ((1 - this.rate) * (1 + this.rate * alphaP ** 2)) ** -0.5;
                    const b = -a * alphaP * this.rate;
                    // Apply mask.
                    const x = (0, $i64bB.add)((0, $i64bB.mul)(input, keptIdx), (0, $i64bB.mul)((0, $i64bB.add)(keptIdx, -1), alphaP));
                    return (0, $i64bB.add)((0, $i64bB.mul)(x, a), b);
                };
                return $33b0bdd0433db936$export$5a6eea8e1dcefeb7(droppedInputs, ()=>(0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs), kwargs['training'] || false);
            }
            return inputs;
        });
    }
}
/** @nocollapse */ $7fc8091152fb4d5a$export$8a44d71014be114.className = 'AlphaDropout';
(0, $i64bB.serialization).registerClass($7fc8091152fb4d5a$export$8a44d71014be114);


/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * Normalization layers.
 */ 
var $i64bB = parcelRequire("i64bB");








function $04e1a8dc21076a19$export$598a795b5a50c0b5(x, mean, variance, beta, gamma, epsilon = 1e-3) {
    let out;
    if (x.rank === 2) out = $i64bB.batchNorm2d(x, mean, variance, beta, gamma, epsilon);
    else if (x.rank === 3) // TODO(cais): Check rank; give proper error message.
    out = $i64bB.batchNorm3d(x, mean, variance, beta, gamma, epsilon);
    else if (x.rank === 4) out = $i64bB.batchNorm4d(x, mean, variance, beta, gamma, epsilon);
    else throw new (0, $af476738b120e938$export$e162153238934121)(`batchNormalization is not implemented for array of rank ${x.rank} ` + `yet`);
    return out;
}
/**
 * Non-broadcasting batch normalization for use in training (not inference).
 *
 * The input is normalized to zero mean and unit variance along the
 * `reductionAxes`, followed by scaling with `gamma` and shifted by `beta`.
 * The result of that is returned as the first element
 * of the returned `Array`. The other two elements are the mean and variance,
 * respectively.
 *
 * @param x Input tensor to be normalized.
 * @param gamma Tensor by which to scale the input.
 * @param beta Tensor by which to center the input.
 * @param reductionAxes Axes over which to normalize.
 * @param epsilon Fuzz factor.
 * @returns An `Array` of three `Tensors`:
 *   [normalized tensor, mean of input, variance of input].
 */ function $04e1a8dc21076a19$var$regularNormalizeBatchInTraining(x, gamma, beta, reductionAxes, epsilon = 1e-3) {
    return (0, $i64bB.tidy)(()=>{
        const meanAndVariance = $i64bB.moments(x, reductionAxes);
        const mean = meanAndVariance.mean;
        const variance = meanAndVariance.variance;
        const normed = $04e1a8dc21076a19$export$598a795b5a50c0b5(x, mean, variance, beta, gamma, epsilon);
        return [
            normed,
            mean,
            variance
        ];
    });
}
/**
 * Broadcasting batch normalization for use in training (not inference).
 *
 * The input is normalized to zero mean and unit variance along the
 * `reductionAxes`, followed by scaling with `gamma` and shifted by `beta`.
 * The result of that is returned as the first element
 * of the returned `Array`. The other two elements are the mean and variance,
 * respectively.
 *
 * @param x Input tensor to be normalized.
 * @param gamma Tensor by which to scale the input.
 * @param beta Tensor by which to center the input.
 * @param reductionAxes Axes over which to normalize.
 * @param epsilon Fuzz factor.
 * @returns An `Array` of three `Tensors`:
 *   [normalized tensor, mean of input, variance of input].
 */ function $04e1a8dc21076a19$var$broadcastNormalizeBatchInTraining(x, gamma, beta, reductionAxes, epsilon = 1e-3) {
    return (0, $i64bB.tidy)(()=>{
        const meanAndVariance = $i64bB.moments(x, reductionAxes);
        const mean = meanAndVariance.mean;
        const variance = meanAndVariance.variance;
        const targetShape = [];
        for (const axis of $edee0645f45d9428$export$d02631cccf789723(0, x.rank))if (reductionAxes.indexOf(axis) !== -1) targetShape.push(1);
        else targetShape.push(x.shape[axis]);
        const broadcastMean = (0, $i64bB.reshape)(mean, targetShape);
        const broadcastVariance = (0, $i64bB.reshape)(variance, targetShape);
        const broadcastGamma = gamma == null ? null : (0, $i64bB.reshape)(gamma, targetShape);
        const broadcastBeta = beta == null ? null : (0, $i64bB.reshape)(beta, targetShape);
        const normed = $04e1a8dc21076a19$export$598a795b5a50c0b5(x, broadcastMean, broadcastVariance, broadcastBeta, broadcastGamma, epsilon);
        return [
            normed,
            mean,
            variance
        ];
    });
}
function $04e1a8dc21076a19$export$edbf80b9b58fbf69(x, gamma, beta, reductionAxes, epsilon = 1e-3) {
    if ((0, $i64bB.util).arraysEqual(reductionAxes.slice().sort(), $edee0645f45d9428$export$d02631cccf789723(0, x.rank - 1))) return $04e1a8dc21076a19$var$regularNormalizeBatchInTraining(x, gamma, beta, reductionAxes, epsilon);
    else return $04e1a8dc21076a19$var$broadcastNormalizeBatchInTraining(x, gamma, beta, reductionAxes, epsilon);
}
class $04e1a8dc21076a19$export$21e75adabb5b0994 extends (0, $03271f6b4e448384$export$936d0764594b6eb3) {
    constructor(args){
        if (args == null) args = {};
        super(args);
        this.supportsMasking = true;
        this.axis = args.axis == null ? -1 : args.axis;
        this.momentum = args.momentum == null ? 0.99 : args.momentum;
        this.epsilon = args.epsilon == null ? 1e-3 : args.epsilon;
        this.center = args.center == null ? true : args.center;
        this.scale = args.scale == null ? true : args.scale;
        this.betaInitializer = (0, $49135dd97e6043ca$export$558b7d1a338df84b)(args.betaInitializer || 'zeros');
        this.gammaInitializer = (0, $49135dd97e6043ca$export$558b7d1a338df84b)(args.gammaInitializer || 'ones');
        this.movingMeanInitializer = (0, $49135dd97e6043ca$export$558b7d1a338df84b)(args.movingMeanInitializer || 'zeros');
        this.movingVarianceInitializer = (0, $49135dd97e6043ca$export$558b7d1a338df84b)(args.movingVarianceInitializer || 'ones');
        this.betaConstraint = (0, $ef279f7fc82ac2a7$export$492f40394cb58978)(args.betaConstraint);
        this.gammaConstraint = (0, $ef279f7fc82ac2a7$export$492f40394cb58978)(args.gammaConstraint);
        this.betaRegularizer = (0, $030044d54dc1235d$export$b3404716bfee324c)(args.betaRegularizer);
        this.gammaRegularizer = (0, $030044d54dc1235d$export$b3404716bfee324c)(args.gammaRegularizer);
    }
    build(inputShape) {
        inputShape = (0, $e11ae28082970f77$export$25c35af872e8abca)(inputShape);
        const axis = this.axis >= 0 ? this.axis : this.axis + inputShape.length;
        const dim = inputShape[axis];
        if (dim == null) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Axis ${axis} of input tensor should have a defined dimension but ` + `the layer received an input with shape ` + `${JSON.stringify(inputShape)}.`);
        this.inputSpec = [
            new (0, $03271f6b4e448384$export$7705ee67def9d40a)({
                ndim: inputShape.length,
                axes: {
                    [axis]: dim
                }
            })
        ];
        const shape = [
            dim
        ];
        if (this.scale) this.gamma = this.addWeight('gamma', shape, null, this.gammaInitializer, this.gammaRegularizer, true, this.gammaConstraint);
        if (this.center) this.beta = this.addWeight('beta', shape, null, this.betaInitializer, this.betaRegularizer, true, this.betaConstraint);
        this.movingMean = this.addWeight('moving_mean', shape, null, this.movingMeanInitializer, null, false);
        this.movingVariance = this.addWeight('moving_variance', shape, null, this.movingVarianceInitializer, null, false);
        this.built = true;
    }
    call(inputs, kwargs) {
        return (0, $i64bB.tidy)(()=>{
            const training = kwargs['training'] == null ? false : kwargs['training'];
            const input = (0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs);
            const inputShape = input.shape;
            const ndim = inputShape.length;
            const reductionAxes = $edee0645f45d9428$export$d02631cccf789723(0, ndim);
            const axis = this.axis >= 0 ? this.axis : this.axis + ndim;
            reductionAxes.splice(axis, 1);
            const broadcastShape = $b5cd0926a1c6df1f$export$f24d1f1e6cb42785(1, ndim);
            broadcastShape[axis] = inputShape[axis];
            const sortedReductionAxes = reductionAxes.slice();
            sortedReductionAxes.sort();
            const needsBroadcasting = !(0, $i64bB.util).arraysEqual(sortedReductionAxes, $edee0645f45d9428$export$d02631cccf789723(0, ndim).slice(0, ndim - 1));
            const normalizeInference = ()=>{
                if (needsBroadcasting) {
                    const broadcastMovingMean = (0, $i64bB.reshape)(this.movingMean.read(), broadcastShape);
                    const broadcastMovingVariance = (0, $i64bB.reshape)(this.movingVariance.read(), broadcastShape);
                    const broadcastBeta = this.center ? (0, $i64bB.reshape)(this.beta.read(), broadcastShape) : null;
                    const broadcastGamma = this.scale ? (0, $i64bB.reshape)(this.gamma.read(), broadcastShape) : null;
                    return $04e1a8dc21076a19$export$598a795b5a50c0b5(input, broadcastMovingMean, broadcastMovingVariance, broadcastBeta, broadcastGamma, this.epsilon);
                } else return $04e1a8dc21076a19$export$598a795b5a50c0b5(input, this.movingMean.read(), this.movingVariance.read(), this.beta == null ? null : this.beta.read(), this.gamma == null ? null : this.gamma.read(), this.epsilon);
            };
            if (!training) return normalizeInference();
            const [normedTraining, mean, variance] = $04e1a8dc21076a19$export$edbf80b9b58fbf69(input, this.gamma.read(), this.beta.read(), reductionAxes, this.epsilon);
            const doMovingAverage = (variable, value, momentum)=>{
                $i64bB.tidy(()=>{
                    const decay = 1 - momentum;
                    const origValue = variable.read();
                    const updateDelta = $i64bB.mul($i64bB.sub(origValue, value), decay);
                    variable.write($i64bB.sub(origValue, updateDelta));
                });
            };
            // Perform updates to moving mean and moving variance for training.
            // Porting Note: In PyKeras, these updates to `movingMean` and
            //   `movingAverage` are done as a deferred Graph, added to the `Layer`'s
            //   `update`s using the `add_update()` method. Here we do it imperatively
            //   and encapsulate the updates in a function that is invoked
            //   immediately.
            const updateMovingMeanAndVariance = ()=>{
                doMovingAverage(this.movingMean, mean, this.momentum);
                doMovingAverage(this.movingVariance, variance, this.momentum);
            };
            updateMovingMeanAndVariance();
            return normedTraining;
        });
    }
    getConfig() {
        const config = {
            axis: this.axis,
            momentum: this.momentum,
            epsilon: this.epsilon,
            center: this.center,
            scale: this.scale,
            betaInitializer: (0, $49135dd97e6043ca$export$68de06a18c23bdbc)(this.betaInitializer),
            gammaInitializer: (0, $49135dd97e6043ca$export$68de06a18c23bdbc)(this.gammaInitializer),
            movingMeanInitializer: (0, $49135dd97e6043ca$export$68de06a18c23bdbc)(this.movingMeanInitializer),
            movingVarianceInitializer: (0, $49135dd97e6043ca$export$68de06a18c23bdbc)(this.movingVarianceInitializer),
            betaRegularizer: (0, $030044d54dc1235d$export$7e8cf5899b350405)(this.betaRegularizer),
            gammaRegularizer: (0, $030044d54dc1235d$export$7e8cf5899b350405)(this.gammaRegularizer),
            betaConstraint: (0, $ef279f7fc82ac2a7$export$e449710617725987)(this.betaConstraint),
            gammaConstraint: (0, $ef279f7fc82ac2a7$export$e449710617725987)(this.gammaConstraint)
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $04e1a8dc21076a19$export$21e75adabb5b0994.className = 'BatchNormalization';
(0, $i64bB.serialization).registerClass($04e1a8dc21076a19$export$21e75adabb5b0994);
class $04e1a8dc21076a19$export$12bc76b160b1bdc extends (0, $03271f6b4e448384$export$936d0764594b6eb3) {
    constructor(args){
        if (args == null) args = {};
        super(args);
        this.axis = args.axis == null ? -1 : args.axis;
        if (typeof this.axis === 'number') {
            if (!Number.isInteger(this.axis)) throw new Error(`Expected axis to be an integer, but received ${this.axis}`);
        } else if (Array.isArray(this.axis)) for (const axis of this.axis){
            if (!Number.isInteger(axis)) throw new Error(`Expected axis to be an array of integers, ` + `but received ${JSON.stringify(this.axis)}`);
        }
        else throw new Error(`Expected axis to be an integer or an array of integers, ` + `but received ${JSON.stringify(this.axis)}`);
        this.epsilon = args.epsilon == null ? 1e-3 : args.epsilon;
        this.center = args.center == null ? true : args.center;
        this.scale = args.scale == null ? true : args.scale;
        this.betaInitializer = (0, $49135dd97e6043ca$export$558b7d1a338df84b)(args.betaInitializer || 'zeros');
        this.gammaInitializer = (0, $49135dd97e6043ca$export$558b7d1a338df84b)(args.gammaInitializer || 'ones');
        this.betaRegularizer = (0, $030044d54dc1235d$export$b3404716bfee324c)(args.betaRegularizer);
        this.gammaRegularizer = (0, $030044d54dc1235d$export$b3404716bfee324c)(args.gammaRegularizer);
        this.supportsMasking = true;
    }
    build(inputShape) {
        inputShape = (0, $e11ae28082970f77$export$25c35af872e8abca)(inputShape);
        const nDims = inputShape.length;
        // Convert axis to array and resolve negatives.
        if (typeof this.axis === 'number') this.axis = [
            this.axis
        ];
        for(let i = 0; i < this.axis.length; ++i)if (this.axis[i] < 0) this.axis[i] += nDims;
        // Further validate axes.
        for (const axis of this.axis){
            if (axis < 0 || axis >= nDims) throw new Error(`Invalid axis: ${axis}`);
        }
        if (this.axis.length !== $b5cd0926a1c6df1f$export$7a5d5c156e7dc406(this.axis).length) throw new Error(`Found duplicate axes in: ${this.axis}`);
        const paramShape = this.axis.map((axis)=>inputShape[axis]);
        const trainable = true;
        if (this.scale) this.gamma = this.addWeight('gamma', paramShape, 'float32', this.gammaInitializer, this.gammaRegularizer, trainable);
        else this.gamma = null;
        if (this.center) this.beta = this.addWeight('beta', paramShape, 'float32', this.betaInitializer, this.betaRegularizer, trainable);
        else this.beta = null;
        this.built = true;
    }
    call(inputs, kwargs) {
        const input = (0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs);
        const inputShape = input.shape;
        const nDims = inputShape.length;
        return (0, $i64bB.tidy)(()=>{
            const keepDims = true;
            let { mean: mean, variance: variance } = (0, $i64bB.moments)(input, this.axis, keepDims);
            const broadcastShape = $b5cd0926a1c6df1f$export$f24d1f1e6cb42785(1, nDims);
            for (const dim of this.axis)broadcastShape[dim] = inputShape[dim];
            const broadcast = (v)=>{
                if (v != null && v.shape.length !== nDims) return $i64bB.reshape(v, broadcastShape);
                else return v;
            };
            let scale = this.scale ? broadcast(this.gamma.read()) : null;
            let offset = this.center ? broadcast(this.beta.read()) : null;
            // TODO(https://github.com/tensorflow/tfjs/issues/2120): The tiling below
            // is a workaround for the limitation of core's batchNormalization?d don't
            // support broadcasting in their gradients. In addition, the tiling is
            // necessary to ensure correctness on the browser CPU backend regardless
            // of forward or backward computation. Remove this workaround once the
            // limitation is addressed. See .
            const momentsTiling = [];
            const scaleOffsetTiling = [];
            for(let i = 0; i < nDims; ++i)if (this.axis.indexOf(i) !== -1) {
                momentsTiling.push(inputShape[i]);
                scaleOffsetTiling.push(1);
            } else {
                momentsTiling.push(1);
                scaleOffsetTiling.push(inputShape[i]);
            }
            mean = $i64bB.tile(mean, momentsTiling);
            variance = $i64bB.tile(variance, momentsTiling);
            if (scale != null) scale = $i64bB.tile(scale, scaleOffsetTiling);
            if (offset != null) offset = $i64bB.tile(offset, scaleOffsetTiling);
            return $04e1a8dc21076a19$export$598a795b5a50c0b5(input, mean, variance, offset, scale, this.epsilon);
        });
    }
    getConfig() {
        const config = {
            axis: this.axis,
            epsilon: this.epsilon,
            center: this.center,
            scale: this.scale,
            betaInitializer: (0, $49135dd97e6043ca$export$68de06a18c23bdbc)(this.betaInitializer),
            gammaInitializer: (0, $49135dd97e6043ca$export$68de06a18c23bdbc)(this.gammaInitializer),
            betaRegularizer: (0, $030044d54dc1235d$export$7e8cf5899b350405)(this.betaRegularizer),
            gammaRegularizer: (0, $030044d54dc1235d$export$7e8cf5899b350405)(this.gammaRegularizer)
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $04e1a8dc21076a19$export$12bc76b160b1bdc.className = 'LayerNormalization';
(0, $i64bB.serialization).registerClass($04e1a8dc21076a19$export$12bc76b160b1bdc);


/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * Padding Layers.
 */ // Porting Note: In Python Keras, the padding layers are in convolutional.py,
//   but we decided to put them in a separate file (padding.ts) for clarity.

var $i64bB = parcelRequire("i64bB");




function $d1251ced663d6b6e$export$cea7cd04e6f6329e(x, padding) {
    return (0, $i64bB.tidy)(()=>{
        if (x.rank !== 3) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`temporalPadding expects input tensor to be 3-D, but received a ` + `${x.rank}-D tensor.`);
        if (padding == null) padding = [
            1,
            1
        ];
        if (padding.length !== 2) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`temporalPadding expects input padding pattern to be a length-2 ` + `array, but received a length-${padding.length} array.`);
        const pattern = [
            [
                0,
                0
            ],
            padding,
            [
                0,
                0
            ]
        ];
        return $i64bB.pad(x, pattern);
    });
}
function $d1251ced663d6b6e$export$c1e7b1f1a92c089a(x, padding, dataFormat) {
    return (0, $i64bB.tidy)(()=>{
        if (x.rank !== 4) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`temporalPadding expects input tensor to be 4-D, but received a ` + `${x.rank}-D tensor.`);
        if (padding == null) padding = [
            [
                1,
                1
            ],
            [
                1,
                1
            ]
        ];
        if (padding.length !== 2 || padding[0].length !== 2 || padding[1].length !== 2) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)("spatial2dPadding expects `padding` to be an Array of two Arrays, each of which is an Array of two integers.");
        if (dataFormat == null) dataFormat = (0, $043e1401aa799097$export$9cb785636e5e0d8)();
        if (dataFormat !== 'channelsLast' && dataFormat !== 'channelsFirst') throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Unknown data format: ${dataFormat}. ` + `Supported data formats are 'channelsLast' and 'channelsFirst.`);
        let pattern;
        if (dataFormat === 'channelsFirst') pattern = [
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            padding[0],
            padding[1]
        ];
        else pattern = [
            [
                0,
                0
            ],
            padding[0],
            padding[1],
            [
                0,
                0
            ]
        ];
        return $i64bB.pad(x, pattern);
    });
}
class $d1251ced663d6b6e$export$3ae403604f7452b3 extends (0, $03271f6b4e448384$export$936d0764594b6eb3) {
    constructor(args){
        if (args == null) args = {};
        super(args);
        this.dataFormat = args.dataFormat == null ? (0, $043e1401aa799097$export$9cb785636e5e0d8)() : args.dataFormat;
        // TODO(cais): Maybe refactor the following logic surrounding `padding`
        //   into a helper method.
        if (args.padding == null) this.padding = [
            [
                1,
                1
            ],
            [
                1,
                1
            ]
        ];
        else if (typeof args.padding === 'number') this.padding = [
            [
                args.padding,
                args.padding
            ],
            [
                args.padding,
                args.padding
            ]
        ];
        else {
            args.padding = args.padding;
            if (args.padding.length !== 2) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`ZeroPadding2D expects padding to be a length-2 array, but ` + `received a length-${args.padding.length} array.`);
            let heightPadding;
            let widthPadding;
            if (typeof args.padding[0] === 'number') {
                heightPadding = [
                    args.padding[0],
                    args.padding[0]
                ];
                widthPadding = [
                    args.padding[1],
                    args.padding[1]
                ];
            } else {
                args.padding = args.padding;
                if (args.padding[0].length !== 2) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`ZeroPadding2D expects height padding to be a length-2 array, ` + `but received a length-${args.padding[0].length} array.`);
                heightPadding = args.padding[0];
                if (args.padding[1].length !== 2) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`ZeroPadding2D expects width padding to be a length-2 array, ` + `but received a length-${args.padding[1].length} array.`);
                widthPadding = args.padding[1];
            }
            this.padding = [
                heightPadding,
                widthPadding
            ];
        }
        this.inputSpec = [
            new (0, $03271f6b4e448384$export$7705ee67def9d40a)({
                ndim: 4
            })
        ];
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $e11ae28082970f77$export$25c35af872e8abca)(inputShape);
        let rows;
        let cols;
        if (this.dataFormat === 'channelsFirst') {
            if (inputShape[2] != null && inputShape[2] >= 0) rows = inputShape[2] + this.padding[0][0] + this.padding[0][1];
            else rows = null;
            if (inputShape[3] != null && inputShape[3] >= 0) cols = inputShape[3] + this.padding[1][0] + this.padding[1][1];
            else cols = null;
            return [
                inputShape[0],
                inputShape[1],
                rows,
                cols
            ];
        } else {
            if (inputShape[1] != null && inputShape[1] >= 0) rows = inputShape[1] + this.padding[0][0] + this.padding[0][1];
            else rows = null;
            if (inputShape[2] != null && inputShape[2] >= 0) cols = inputShape[2] + this.padding[1][0] + this.padding[1][1];
            else cols = null;
            return [
                inputShape[0],
                rows,
                cols,
                inputShape[3]
            ];
        }
    }
    call(inputs, kwargs) {
        return (0, $i64bB.tidy)(()=>$d1251ced663d6b6e$export$c1e7b1f1a92c089a((0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs), this.padding, this.dataFormat));
    }
    getConfig() {
        const config = {
            padding: this.padding,
            dataFormat: this.dataFormat
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $d1251ced663d6b6e$export$3ae403604f7452b3.className = 'ZeroPadding2D';
(0, $i64bB.serialization).registerClass($d1251ced663d6b6e$export$3ae403604f7452b3);


/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * TensorFlow.js Layers: Pooling Layers.
 */ 
var $i64bB = parcelRequire("i64bB");









function $4724c3b50de979cc$export$d27fa8d08ae02aab(x, poolSize, strides, padding, dataFormat, poolMode) {
    return (0, $i64bB.tidy)(()=>{
        (0, $860027d3b2c99a1d$export$f5f6472a2b993816)(dataFormat);
        (0, $860027d3b2c99a1d$export$4ac7885ddd005702)(poolMode);
        (0, $860027d3b2c99a1d$export$a6c1e84f1d33d64d)(padding);
        if (strides == null) strides = [
            1,
            1
        ];
        if (padding == null) padding = 'valid';
        if (dataFormat == null) dataFormat = (0, $043e1401aa799097$export$9cb785636e5e0d8)();
        if (poolMode == null) poolMode = 'max';
        // TODO(cais): Remove the preprocessing step once deeplearn.js supports
        // dataFormat as an input argument.
        x = (0, $510b56cd08d87ce7$export$8434bfc73196ab6c)(x, dataFormat); // x is NHWC after preprocessing.
        let y;
        const paddingString = padding === 'same' ? 'same' : 'valid';
        if (poolMode === 'max') // TODO(cais): Rank check?
        y = $i64bB.maxPool(x, poolSize, strides, paddingString);
        else // TODO(cais): Check the dtype and rank of x and give clear error message
        //   if those are incorrect.
        y = $i64bB.avgPool(// TODO(cais): Rank check?
        x, poolSize, strides, paddingString);
        if (dataFormat === 'channelsFirst') y = $i64bB.transpose(y, [
            0,
            3,
            1,
            2
        ]); // NHWC -> NCHW.
        return y;
    });
}
function $4724c3b50de979cc$export$3712ebf21d29ff82(x, poolSize, strides, padding, dataFormat, poolMode) {
    return (0, $i64bB.tidy)(()=>{
        (0, $860027d3b2c99a1d$export$f5f6472a2b993816)(dataFormat);
        (0, $860027d3b2c99a1d$export$4ac7885ddd005702)(poolMode);
        (0, $860027d3b2c99a1d$export$a6c1e84f1d33d64d)(padding);
        if (strides == null) strides = [
            1,
            1,
            1
        ];
        if (padding == null) padding = 'valid';
        if (dataFormat == null) dataFormat = (0, $043e1401aa799097$export$9cb785636e5e0d8)();
        if (poolMode == null) poolMode = 'max';
        // x is NDHWC after preprocessing.
        x = (0, $510b56cd08d87ce7$export$4ce11465fb76c4e6)(x, dataFormat);
        let y;
        const paddingString = padding === 'same' ? 'same' : 'valid';
        if (poolMode === 'max') y = $i64bB.maxPool3d(x, poolSize, strides, paddingString);
        else y = $i64bB.avgPool3d(x, poolSize, strides, paddingString);
        if (dataFormat === 'channelsFirst') y = $i64bB.transpose(y, [
            0,
            4,
            1,
            2,
            3
        ]); // NDHWC -> NCDHW.
        return y;
    });
}
class $4724c3b50de979cc$export$56e907da703e3750 extends (0, $03271f6b4e448384$export$936d0764594b6eb3) {
    /**
     *
     * @param args Parameters for the Pooling layer.
     *
     * config.poolSize defaults to 2.
     */ constructor(args){
        if (args.poolSize == null) args.poolSize = 2;
        super(args);
        if (typeof args.poolSize === 'number') this.poolSize = [
            args.poolSize
        ];
        else if (Array.isArray(args.poolSize) && args.poolSize.length === 1 && typeof args.poolSize[0] === 'number') this.poolSize = args.poolSize;
        else throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`poolSize for 1D convolutional layer must be a number or an ` + `Array of a single number, but received ` + `${JSON.stringify(args.poolSize)}`);
        (0, $b5cd0926a1c6df1f$export$7ac3b6580cbed983)(this.poolSize, 'poolSize');
        if (args.strides == null) this.strides = this.poolSize;
        else {
            if (typeof args.strides === 'number') this.strides = [
                args.strides
            ];
            else if (Array.isArray(args.strides) && args.strides.length === 1 && typeof args.strides[0] === 'number') this.strides = args.strides;
            else throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`strides for 1D convolutional layer must be a number or an ` + `Array of a single number, but received ` + `${JSON.stringify(args.strides)}`);
        }
        (0, $b5cd0926a1c6df1f$export$7ac3b6580cbed983)(this.strides, 'strides');
        this.padding = args.padding == null ? 'valid' : args.padding;
        (0, $860027d3b2c99a1d$export$a6c1e84f1d33d64d)(this.padding);
        this.inputSpec = [
            new (0, $03271f6b4e448384$export$7705ee67def9d40a)({
                ndim: 3
            })
        ];
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $e11ae28082970f77$export$25c35af872e8abca)(inputShape);
        const length = (0, $1e685a09ff935a2e$export$50b0adaed374172)(inputShape[1], this.poolSize[0], this.padding, this.strides[0]);
        return [
            inputShape[0],
            length,
            inputShape[2]
        ];
    }
    call(inputs, kwargs) {
        return (0, $i64bB.tidy)(()=>{
            this.invokeCallHook(inputs, kwargs);
            // Add dummy last dimension.
            inputs = $33b0bdd0433db936$export$d660d8ed21f46635((0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs), 2);
            const output = this.poolingFunction((0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs), [
                this.poolSize[0],
                1
            ], [
                this.strides[0],
                1
            ], this.padding, 'channelsLast');
            // Remove dummy last dimension.
            return $i64bB.squeeze(output, [
                2
            ]);
        });
    }
    getConfig() {
        const config = {
            poolSize: this.poolSize,
            padding: this.padding,
            strides: this.strides
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
class $4724c3b50de979cc$export$ee33f1d34d09a0fd extends $4724c3b50de979cc$export$56e907da703e3750 {
    constructor(args){
        super(args);
    }
    poolingFunction(inputs, poolSize, strides, padding, dataFormat) {
        (0, $860027d3b2c99a1d$export$f5f6472a2b993816)(dataFormat);
        (0, $860027d3b2c99a1d$export$a6c1e84f1d33d64d)(padding);
        return $4724c3b50de979cc$export$d27fa8d08ae02aab(inputs, poolSize, strides, padding, dataFormat, 'max');
    }
}
/** @nocollapse */ $4724c3b50de979cc$export$ee33f1d34d09a0fd.className = 'MaxPooling1D';
(0, $i64bB.serialization).registerClass($4724c3b50de979cc$export$ee33f1d34d09a0fd);
class $4724c3b50de979cc$export$abb9a5c13378a7fc extends $4724c3b50de979cc$export$56e907da703e3750 {
    constructor(args){
        super(args);
    }
    poolingFunction(inputs, poolSize, strides, padding, dataFormat) {
        (0, $860027d3b2c99a1d$export$f5f6472a2b993816)(dataFormat);
        (0, $860027d3b2c99a1d$export$a6c1e84f1d33d64d)(padding);
        return $4724c3b50de979cc$export$d27fa8d08ae02aab(inputs, poolSize, strides, padding, dataFormat, 'avg');
    }
}
/** @nocollapse */ $4724c3b50de979cc$export$abb9a5c13378a7fc.className = 'AveragePooling1D';
(0, $i64bB.serialization).registerClass($4724c3b50de979cc$export$abb9a5c13378a7fc);
class $4724c3b50de979cc$export$3f5b37e58ac9bb8f extends (0, $03271f6b4e448384$export$936d0764594b6eb3) {
    constructor(args){
        if (args.poolSize == null) args.poolSize = [
            2,
            2
        ];
        super(args);
        this.poolSize = Array.isArray(args.poolSize) ? args.poolSize : [
            args.poolSize,
            args.poolSize
        ];
        if (args.strides == null) this.strides = this.poolSize;
        else if (Array.isArray(args.strides)) {
            if (args.strides.length !== 2) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`If the strides property of a 2D pooling layer is an Array, ` + `it is expected to have a length of 2, but received length ` + `${args.strides.length}.`);
            this.strides = args.strides;
        } else // `config.strides` is a number.
        this.strides = [
            args.strides,
            args.strides
        ];
        (0, $b5cd0926a1c6df1f$export$7ac3b6580cbed983)(this.poolSize, 'poolSize');
        (0, $b5cd0926a1c6df1f$export$7ac3b6580cbed983)(this.strides, 'strides');
        this.padding = args.padding == null ? 'valid' : args.padding;
        this.dataFormat = args.dataFormat == null ? 'channelsLast' : args.dataFormat;
        (0, $860027d3b2c99a1d$export$f5f6472a2b993816)(this.dataFormat);
        (0, $860027d3b2c99a1d$export$a6c1e84f1d33d64d)(this.padding);
        this.inputSpec = [
            new (0, $03271f6b4e448384$export$7705ee67def9d40a)({
                ndim: 4
            })
        ];
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $e11ae28082970f77$export$25c35af872e8abca)(inputShape);
        let rows = this.dataFormat === 'channelsFirst' ? inputShape[2] : inputShape[1];
        let cols = this.dataFormat === 'channelsFirst' ? inputShape[3] : inputShape[2];
        rows = (0, $1e685a09ff935a2e$export$50b0adaed374172)(rows, this.poolSize[0], this.padding, this.strides[0]);
        cols = (0, $1e685a09ff935a2e$export$50b0adaed374172)(cols, this.poolSize[1], this.padding, this.strides[1]);
        if (this.dataFormat === 'channelsFirst') return [
            inputShape[0],
            inputShape[1],
            rows,
            cols
        ];
        else return [
            inputShape[0],
            rows,
            cols,
            inputShape[3]
        ];
    }
    call(inputs, kwargs) {
        return (0, $i64bB.tidy)(()=>{
            this.invokeCallHook(inputs, kwargs);
            return this.poolingFunction((0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs), this.poolSize, this.strides, this.padding, this.dataFormat);
        });
    }
    getConfig() {
        const config = {
            poolSize: this.poolSize,
            padding: this.padding,
            strides: this.strides,
            dataFormat: this.dataFormat
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
class $4724c3b50de979cc$export$fae6981b13a5bc64 extends $4724c3b50de979cc$export$3f5b37e58ac9bb8f {
    constructor(args){
        super(args);
    }
    poolingFunction(inputs, poolSize, strides, padding, dataFormat) {
        (0, $860027d3b2c99a1d$export$f5f6472a2b993816)(dataFormat);
        (0, $860027d3b2c99a1d$export$a6c1e84f1d33d64d)(padding);
        return $4724c3b50de979cc$export$d27fa8d08ae02aab(inputs, poolSize, strides, padding, dataFormat, 'max');
    }
}
/** @nocollapse */ $4724c3b50de979cc$export$fae6981b13a5bc64.className = 'MaxPooling2D';
(0, $i64bB.serialization).registerClass($4724c3b50de979cc$export$fae6981b13a5bc64);
class $4724c3b50de979cc$export$ba5e0a247bd733ca extends $4724c3b50de979cc$export$3f5b37e58ac9bb8f {
    constructor(args){
        super(args);
    }
    poolingFunction(inputs, poolSize, strides, padding, dataFormat) {
        (0, $860027d3b2c99a1d$export$f5f6472a2b993816)(dataFormat);
        (0, $860027d3b2c99a1d$export$a6c1e84f1d33d64d)(padding);
        return $4724c3b50de979cc$export$d27fa8d08ae02aab(inputs, poolSize, strides, padding, dataFormat, 'avg');
    }
}
/** @nocollapse */ $4724c3b50de979cc$export$ba5e0a247bd733ca.className = 'AveragePooling2D';
(0, $i64bB.serialization).registerClass($4724c3b50de979cc$export$ba5e0a247bd733ca);
class $4724c3b50de979cc$export$d922ad75eee6c49f extends (0, $03271f6b4e448384$export$936d0764594b6eb3) {
    constructor(args){
        if (args.poolSize == null) args.poolSize = [
            2,
            2,
            2
        ];
        super(args);
        this.poolSize = Array.isArray(args.poolSize) ? args.poolSize : [
            args.poolSize,
            args.poolSize,
            args.poolSize
        ];
        if (args.strides == null) this.strides = this.poolSize;
        else if (Array.isArray(args.strides)) {
            if (args.strides.length !== 3) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`If the strides property of a 3D pooling layer is an Array, ` + `it is expected to have a length of 3, but received length ` + `${args.strides.length}.`);
            this.strides = args.strides;
        } else // `config.strides` is a number.
        this.strides = [
            args.strides,
            args.strides,
            args.strides
        ];
        (0, $b5cd0926a1c6df1f$export$7ac3b6580cbed983)(this.poolSize, 'poolSize');
        (0, $b5cd0926a1c6df1f$export$7ac3b6580cbed983)(this.strides, 'strides');
        this.padding = args.padding == null ? 'valid' : args.padding;
        this.dataFormat = args.dataFormat == null ? 'channelsLast' : args.dataFormat;
        (0, $860027d3b2c99a1d$export$f5f6472a2b993816)(this.dataFormat);
        (0, $860027d3b2c99a1d$export$a6c1e84f1d33d64d)(this.padding);
        this.inputSpec = [
            new (0, $03271f6b4e448384$export$7705ee67def9d40a)({
                ndim: 5
            })
        ];
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $e11ae28082970f77$export$25c35af872e8abca)(inputShape);
        let depths = this.dataFormat === 'channelsFirst' ? inputShape[2] : inputShape[1];
        let rows = this.dataFormat === 'channelsFirst' ? inputShape[3] : inputShape[2];
        let cols = this.dataFormat === 'channelsFirst' ? inputShape[4] : inputShape[3];
        depths = (0, $1e685a09ff935a2e$export$50b0adaed374172)(depths, this.poolSize[0], this.padding, this.strides[0]);
        rows = (0, $1e685a09ff935a2e$export$50b0adaed374172)(rows, this.poolSize[1], this.padding, this.strides[1]);
        cols = (0, $1e685a09ff935a2e$export$50b0adaed374172)(cols, this.poolSize[2], this.padding, this.strides[2]);
        if (this.dataFormat === 'channelsFirst') return [
            inputShape[0],
            inputShape[1],
            depths,
            rows,
            cols
        ];
        else return [
            inputShape[0],
            depths,
            rows,
            cols,
            inputShape[4]
        ];
    }
    call(inputs, kwargs) {
        return (0, $i64bB.tidy)(()=>{
            this.invokeCallHook(inputs, kwargs);
            return this.poolingFunction((0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs), this.poolSize, this.strides, this.padding, this.dataFormat);
        });
    }
    getConfig() {
        const config = {
            poolSize: this.poolSize,
            padding: this.padding,
            strides: this.strides,
            dataFormat: this.dataFormat
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
class $4724c3b50de979cc$export$5a12007b35aee0a extends $4724c3b50de979cc$export$d922ad75eee6c49f {
    constructor(args){
        super(args);
    }
    poolingFunction(inputs, poolSize, strides, padding, dataFormat) {
        (0, $860027d3b2c99a1d$export$f5f6472a2b993816)(dataFormat);
        (0, $860027d3b2c99a1d$export$a6c1e84f1d33d64d)(padding);
        return $4724c3b50de979cc$export$3712ebf21d29ff82(inputs, poolSize, strides, padding, dataFormat, 'max');
    }
}
/** @nocollapse */ $4724c3b50de979cc$export$5a12007b35aee0a.className = 'MaxPooling3D';
(0, $i64bB.serialization).registerClass($4724c3b50de979cc$export$5a12007b35aee0a);
class $4724c3b50de979cc$export$ee30b46b17aabb8f extends $4724c3b50de979cc$export$d922ad75eee6c49f {
    constructor(args){
        super(args);
    }
    poolingFunction(inputs, poolSize, strides, padding, dataFormat) {
        (0, $860027d3b2c99a1d$export$f5f6472a2b993816)(dataFormat);
        (0, $860027d3b2c99a1d$export$a6c1e84f1d33d64d)(padding);
        return $4724c3b50de979cc$export$3712ebf21d29ff82(inputs, poolSize, strides, padding, dataFormat, 'avg');
    }
}
/** @nocollapse */ $4724c3b50de979cc$export$ee30b46b17aabb8f.className = 'AveragePooling3D';
(0, $i64bB.serialization).registerClass($4724c3b50de979cc$export$ee30b46b17aabb8f);
class $4724c3b50de979cc$export$ac2acb21ca818c40 extends (0, $03271f6b4e448384$export$936d0764594b6eb3) {
    constructor(args){
        super(args);
        this.inputSpec = [
            new (0, $03271f6b4e448384$export$7705ee67def9d40a)({
                ndim: 3
            })
        ];
    }
    computeOutputShape(inputShape) {
        return [
            inputShape[0],
            inputShape[2]
        ];
    }
    call(inputs, kwargs) {
        throw new (0, $af476738b120e938$export$e162153238934121)();
    }
}
class $4724c3b50de979cc$export$2c6cc528d2786e91 extends $4724c3b50de979cc$export$ac2acb21ca818c40 {
    constructor(args){
        super(args || {});
    }
    call(inputs, kwargs) {
        return (0, $i64bB.tidy)(()=>{
            const input = (0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs);
            return $i64bB.mean(input, 1);
        });
    }
}
/** @nocollapse */ $4724c3b50de979cc$export$2c6cc528d2786e91.className = 'GlobalAveragePooling1D';
(0, $i64bB.serialization).registerClass($4724c3b50de979cc$export$2c6cc528d2786e91);
class $4724c3b50de979cc$export$ab40543f12b91a51 extends $4724c3b50de979cc$export$ac2acb21ca818c40 {
    constructor(args){
        super(args || {});
    }
    call(inputs, kwargs) {
        return (0, $i64bB.tidy)(()=>{
            const input = (0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs);
            return $i64bB.max(input, 1);
        });
    }
}
/** @nocollapse */ $4724c3b50de979cc$export$ab40543f12b91a51.className = 'GlobalMaxPooling1D';
(0, $i64bB.serialization).registerClass($4724c3b50de979cc$export$ab40543f12b91a51);
class $4724c3b50de979cc$export$5eafa45e8fcdd59f extends (0, $03271f6b4e448384$export$936d0764594b6eb3) {
    constructor(args){
        super(args);
        this.dataFormat = args.dataFormat == null ? 'channelsLast' : args.dataFormat;
        (0, $860027d3b2c99a1d$export$f5f6472a2b993816)(this.dataFormat);
        this.inputSpec = [
            new (0, $03271f6b4e448384$export$7705ee67def9d40a)({
                ndim: 4
            })
        ];
    }
    computeOutputShape(inputShape) {
        inputShape;
        if (this.dataFormat === 'channelsLast') return [
            inputShape[0],
            inputShape[3]
        ];
        else return [
            inputShape[0],
            inputShape[1]
        ];
    }
    call(inputs, kwargs) {
        throw new (0, $af476738b120e938$export$e162153238934121)();
    }
    getConfig() {
        const config = {
            dataFormat: this.dataFormat
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
class $4724c3b50de979cc$export$2bd55677c48d3dfa extends $4724c3b50de979cc$export$5eafa45e8fcdd59f {
    call(inputs, kwargs) {
        return (0, $i64bB.tidy)(()=>{
            const input = (0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs);
            if (this.dataFormat === 'channelsLast') return $i64bB.mean(input, [
                1,
                2
            ]);
            else return $i64bB.mean(input, [
                2,
                3
            ]);
        });
    }
}
/** @nocollapse */ $4724c3b50de979cc$export$2bd55677c48d3dfa.className = 'GlobalAveragePooling2D';
(0, $i64bB.serialization).registerClass($4724c3b50de979cc$export$2bd55677c48d3dfa);
class $4724c3b50de979cc$export$46257bff79157c32 extends $4724c3b50de979cc$export$5eafa45e8fcdd59f {
    call(inputs, kwargs) {
        return (0, $i64bB.tidy)(()=>{
            const input = (0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs);
            if (this.dataFormat === 'channelsLast') return $i64bB.max(input, [
                1,
                2
            ]);
            else return $i64bB.max(input, [
                2,
                3
            ]);
        });
    }
}
/** @nocollapse */ $4724c3b50de979cc$export$46257bff79157c32.className = 'GlobalMaxPooling2D';
(0, $i64bB.serialization).registerClass($4724c3b50de979cc$export$46257bff79157c32);



/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * Layers that augment the functionality of a base layer.
 */ 
var $i64bB = parcelRequire("i64bB");









class $4f4a7b6b71f57ad7$export$e6dfd72ab29f8598 extends (0, $03271f6b4e448384$export$936d0764594b6eb3) {
    constructor(args){
        // Porting Note: In PyKeras, `self.layer` is set prior to the calling
        //   `super()`. But we can't do that here due to TypeScript's restriction.
        //   See: https://github.com/Microsoft/TypeScript/issues/8277
        //   As a result, we have to add checks in `get trainable()` and
        //   `set trainable()` below in order to prevent using `this.layer` when
        //   its value is `undefined`. The super constructor does use the getter
        //   and the setter of `this.layer`.
        super(args);
        this.layer = args.layer;
    }
    build(inputShape) {
        this.built = true;
    }
    // TODO(cais): Implement activityRegularizer getter.
    get trainable() {
        // Porting Note: the check of `this.layer` here is necessary due to the
        //   way the `constructor` of this class is written (see Porting Note
        //   above).
        if (this.layer != null) return this.layer.trainable;
        else return false;
    }
    set trainable(value) {
        // Porting Note: the check of `this.layer` here is necessary due to the
        //   way the `constructor` of this class is written (see Porting Note
        //   above).
        if (this.layer != null) this.layer.trainable = value;
    }
    get trainableWeights() {
        return this.layer.trainableWeights;
    }
    // TODO(cais): Implement setter for trainableWeights.
    get nonTrainableWeights() {
        return this.layer.nonTrainableWeights;
    }
    // TODO(cais): Implement setter for nonTrainableWeights.
    get updates() {
        // tslint:disable-next-line:no-any
        return this.layer._updates;
    }
    // TODO(cais): Implement getUpdatesFor().
    get losses() {
        return this.layer.losses;
    }
    // TODO(cais): Implement getLossesFor().
    getWeights() {
        return this.layer.getWeights();
    }
    setWeights(weights) {
        this.layer.setWeights(weights);
    }
    getConfig() {
        const config = {
            'layer': {
                'className': this.layer.getClassName(),
                'config': this.layer.getConfig()
            }
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
    setFastWeightInitDuringBuild(value) {
        super.setFastWeightInitDuringBuild(value);
        if (this.layer != null) this.layer.setFastWeightInitDuringBuild(value);
    }
    /** @nocollapse */ static fromConfig(cls, config, customObjects = {}) {
        const layerConfig = config['layer'];
        const layer = (0, $61cac79a6a78765b$export$efcd34ab6248d3cd)(layerConfig, customObjects);
        delete config['layer'];
        const newConfig = {
            layer: layer
        };
        Object.assign(newConfig, config);
        return new cls(newConfig);
    }
}
class $4f4a7b6b71f57ad7$export$72d58104314bdbf3 extends $4f4a7b6b71f57ad7$export$e6dfd72ab29f8598 {
    constructor(args){
        super(args);
        this.supportsMasking = true;
    }
    build(inputShape) {
        inputShape = (0, $e11ae28082970f77$export$25c35af872e8abca)(inputShape);
        if (inputShape.length < 3) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`TimeDistributed layer expects an input shape >= 3D, but received ` + `input shape ${JSON.stringify(inputShape)}`);
        this.inputSpec = [
            {
                shape: inputShape
            }
        ];
        const childInputShape = [
            inputShape[0]
        ].concat(inputShape.slice(2));
        if (!this.layer.built) {
            this.layer.build(childInputShape);
            this.layer.built = true;
        }
        super.build(inputShape);
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $e11ae28082970f77$export$25c35af872e8abca)(inputShape);
        const childInputShape = [
            inputShape[0]
        ].concat(inputShape.slice(2));
        const childOutputShape = this.layer.computeOutputShape(childInputShape);
        const timesteps = inputShape[1];
        return [
            childOutputShape[0],
            timesteps
        ].concat(childOutputShape.slice(1));
    }
    call(inputs, kwargs) {
        return (0, $i64bB.tidy)(()=>{
            // TODO(cais): Add 'training' and 'useLearningPhase' to kwargs.
            inputs = (0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs);
            // Porting Note: In tfjs-layers, `inputs` are always concrete tensor
            // values. Hence the inputs can't have an undetermined first (batch)
            // dimension, which is why we always use the K.rnn approach here.
            const step = (inputs, states)=>{
                // TODO(cais): Add useLearningPhase.
                // NOTE(cais): `layer.call` may return a length-1 array of Tensor in
                //   some cases (e.g., `layer` is a `Sequential` instance), which is
                //   why `getExactlyOneTensor` is used below.
                const output = (0, $e11ae28082970f77$export$5327fe015af69a7b)(this.layer.call(inputs, kwargs));
                return [
                    output,
                    []
                ];
            };
            const rnnOutputs = (0, $9cf49ab16f0373b1$export$3e66d5ce8f778ebc)(step, inputs, [], false, null, null, false, true);
            const y = rnnOutputs[1];
            // TODO(cais): Add activity regularization.
            // TODO(cais): Add useLearningPhase.
            return y;
        });
    }
}
/** @nocollapse */ $4f4a7b6b71f57ad7$export$72d58104314bdbf3.className = 'TimeDistributed';
(0, $i64bB.serialization).registerClass($4f4a7b6b71f57ad7$export$72d58104314bdbf3);
function $4f4a7b6b71f57ad7$export$8095babf98f3d922(value) {
    $b5cd0926a1c6df1f$export$f49e87e6cde0274b((0, $a55a2b5e485fd150$export$954d8bae11304008), 'BidirectionalMergeMode', value);
}
const $4f4a7b6b71f57ad7$var$DEFAULT_BIDIRECTIONAL_MERGE_MODE = 'concat';
class $4f4a7b6b71f57ad7$export$edf712313f3d75dd extends $4f4a7b6b71f57ad7$export$e6dfd72ab29f8598 {
    constructor(args){
        super(args);
        // Note: When creating `this.forwardLayer`, the original Layer object
        //   (`config.layer`) ought to be cloned. This is why we call
        //   `getConfig()` followed by `deserialize()`. Without this cloning,
        //   the layer names saved during serialization will incorrectly contain
        //   the 'forward_' prefix. In Python Keras, this is done using
        //   `copy.copy` (shallow copy), which does not have a simple equivalent
        //   in JavaScript. JavaScript's `Object.assign()` does not copy
        //   methods.
        const layerConfig = args.layer.getConfig();
        const forwDict = {};
        forwDict['className'] = args.layer.getClassName();
        forwDict['config'] = layerConfig;
        this.forwardLayer = (0, $61cac79a6a78765b$export$efcd34ab6248d3cd)(forwDict);
        layerConfig['goBackwards'] = layerConfig['goBackwards'] === true ? false : true;
        const backDict = {};
        backDict['className'] = args.layer.getClassName();
        backDict['config'] = layerConfig;
        this.backwardLayer = (0, $61cac79a6a78765b$export$efcd34ab6248d3cd)(backDict);
        this.forwardLayer.name = 'forward_' + this.forwardLayer.name;
        this.backwardLayer.name = 'backward_' + this.backwardLayer.name;
        this.mergeMode = args.mergeMode === undefined ? $4f4a7b6b71f57ad7$var$DEFAULT_BIDIRECTIONAL_MERGE_MODE : args.mergeMode;
        $4f4a7b6b71f57ad7$export$8095babf98f3d922(this.mergeMode);
        if (args.weights) throw new (0, $af476738b120e938$export$e162153238934121)('weights support is not implemented for Bidirectional layer yet.');
        this._stateful = args.layer.stateful;
        this.returnSequences = args.layer.returnSequences;
        this.returnState = args.layer.returnState;
        this.supportsMasking = true;
        this._trainable = true;
        this.inputSpec = args.layer.inputSpec;
        this.numConstants = null;
    }
    get trainable() {
        return this._trainable;
    }
    set trainable(value) {
        // Porting Note: the check of `this.layer` here is necessary due to the
        //   way the `constructor` of this class is written (see Porting Note
        //   above).
        this._trainable = value;
        if (this.forwardLayer != null) this.forwardLayer.trainable = value;
        if (this.backwardLayer != null) this.backwardLayer.trainable = value;
    }
    getWeights() {
        return this.forwardLayer.getWeights().concat(this.backwardLayer.getWeights());
    }
    setWeights(weights) {
        const numWeights = weights.length;
        const numeightsOver2 = Math.floor(numWeights / 2);
        this.forwardLayer.setWeights(weights.slice(0, numeightsOver2));
        this.backwardLayer.setWeights(weights.slice(numeightsOver2));
    }
    computeOutputShape(inputShape) {
        let layerShapes = this.forwardLayer.computeOutputShape(inputShape);
        if (!(Array.isArray(layerShapes) && Array.isArray(layerShapes[0]))) layerShapes = [
            layerShapes
        ];
        layerShapes;
        let outputShape;
        let outputShapes;
        let stateShape;
        if (this.returnState) {
            stateShape = layerShapes.slice(1);
            outputShape = layerShapes[0];
        } else outputShape = layerShapes[0];
        outputShape;
        if (this.mergeMode === 'concat') {
            outputShape[outputShape.length - 1] *= 2;
            outputShapes = [
                outputShape
            ];
        } else if (this.mergeMode == null) outputShapes = [
            outputShape,
            outputShape.slice()
        ];
        else outputShapes = [
            outputShape
        ];
        if (this.returnState) {
            if (this.mergeMode == null) return outputShapes.concat(stateShape).concat(stateShape.slice());
            return [
                outputShape
            ].concat(stateShape).concat(stateShape.slice());
        }
        return $b5cd0926a1c6df1f$export$8366660815493a21(outputShapes);
    }
    apply(inputs, kwargs) {
        let initialState = kwargs == null ? null : kwargs['initialState'];
        let constants = kwargs == null ? null : kwargs['constants'];
        if (kwargs == null) kwargs = {};
        const standardized = (0, $9cf49ab16f0373b1$export$b9ab3f5c89688c2)(inputs, initialState, constants, this.numConstants);
        inputs = standardized.inputs;
        initialState = standardized.initialState;
        constants = standardized.constants;
        if (Array.isArray(inputs)) {
            initialState = inputs.slice(1);
            inputs = inputs[0];
        }
        if ((initialState == null || initialState.length === 0) && constants == null) return super.apply(inputs, kwargs);
        const additionalInputs = [];
        const additionalSpecs = [];
        if (initialState != null) {
            const numStates = initialState.length;
            if (numStates % 2 > 0) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)("When passing `initialState` to a Bidrectional RNN, the state should be an Array containing the states of the underlying RNNs.");
            kwargs['initialState'] = initialState;
            additionalInputs.push(...initialState);
            const stateSpecs = initialState.map((state)=>new (0, $03271f6b4e448384$export$7705ee67def9d40a)({
                    shape: state.shape
                }));
            this.forwardLayer.stateSpec = stateSpecs.slice(0, numStates / 2);
            this.backwardLayer.stateSpec = stateSpecs.slice(numStates / 2);
            additionalSpecs.push(...stateSpecs);
        }
        if (constants != null) throw new (0, $af476738b120e938$export$e162153238934121)("Support for constants in Bidirectional layers is not implemented yet.");
        const isSymbolicTensor = additionalInputs[0] instanceof (0, $03271f6b4e448384$export$c6d6977640680568);
        for (const tensor of additionalInputs){
            if (tensor instanceof (0, $03271f6b4e448384$export$c6d6977640680568) !== isSymbolicTensor) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)("The initial state of a Bidirectional layer cannot be specified as a mix of symbolic and non-symbolic tensors");
        }
        if (isSymbolicTensor) {
            // Compute the full input and specs, including the states.
            const fullInput = [
                inputs
            ].concat(additionalInputs);
            const fullInputSpec = this.inputSpec.concat(additionalSpecs);
            // Perform the call temporarily and replace inputSpec.
            // Note: with initial states symbolic calls and non-symbolic calls to
            // this method differ in how the initial states are passed. For
            // symbolic calls, the initial states are passed in the first arg, as
            // an Array of SymbolicTensors; for non-symbolic calls, they are
            // passed in the second arg as a part of the kwargs. Hence the need to
            // temporarily modify inputSpec here.
            // TODO(cais): Make refactoring so that this hacky code below is no
            // longer needed.
            const originalInputSpec = this.inputSpec;
            this.inputSpec = fullInputSpec;
            const output = super.apply(fullInput, kwargs);
            this.inputSpec = originalInputSpec;
            return output;
        } else return super.apply(inputs, kwargs);
    }
    call(inputs, kwargs) {
        return (0, $i64bB.tidy)(()=>{
            const initialState = kwargs['initialState'];
            let y;
            let yRev;
            if (initialState == null) {
                y = this.forwardLayer.call(inputs, kwargs);
                yRev = this.backwardLayer.call(inputs, kwargs);
            } else {
                const forwardState = initialState.slice(0, initialState.length / 2);
                const backwardState = initialState.slice(initialState.length / 2);
                y = this.forwardLayer.call(inputs, Object.assign(kwargs, {
                    initialState: forwardState
                }));
                yRev = this.backwardLayer.call(inputs, Object.assign(kwargs, {
                    initialState: backwardState
                }));
            }
            let states;
            if (this.returnState) {
                if (Array.isArray(y)) states = y.slice(1).concat(yRev.slice(1));
                y = y[0];
                yRev = yRev[0];
            }
            if (this.returnSequences) yRev = $i64bB.reverse(yRev, 1);
            let output;
            if (this.mergeMode === 'concat') output = $33b0bdd0433db936$export$375c71d43969527d([
                y,
                yRev
            ]);
            else if (this.mergeMode === 'sum') output = $i64bB.add(y, yRev);
            else if (this.mergeMode === 'ave') output = $i64bB.mul(.5, $i64bB.add(y, yRev));
            else if (this.mergeMode === 'mul') output = $i64bB.mul(y, yRev);
            else if (this.mergeMode == null) output = [
                y,
                yRev
            ];
            // TODO(cais): Properly set learning phase.
            if (this.returnState) {
                if (this.mergeMode == null) return output.concat(states);
                return [
                    output
                ].concat(states);
            }
            return output;
        });
    }
    resetStates(states) {
        this.forwardLayer.resetStates();
        this.backwardLayer.resetStates();
    }
    build(inputShape) {
        (0, $860027d3b2c99a1d$export$e820b4f57a8e33d1)(this.forwardLayer.name, ()=>{
            this.forwardLayer.build(inputShape);
        });
        (0, $860027d3b2c99a1d$export$e820b4f57a8e33d1)(this.backwardLayer.name, ()=>{
            this.backwardLayer.build(inputShape);
        });
        this.built = true;
    }
    computeMask(inputs, mask) {
        if (Array.isArray(mask)) mask = mask[0];
        let outputMask;
        if (this.returnSequences) {
            if (this.mergeMode == null) outputMask = [
                mask,
                mask
            ];
            else outputMask = mask;
        } else if (this.mergeMode == null) outputMask = [
            null,
            null
        ];
        else outputMask = null;
        if (this.returnState) {
            const states = this.forwardLayer.states;
            const stateMask = states.map((state)=>null);
            if (Array.isArray(outputMask)) return outputMask.concat(stateMask).concat(stateMask);
            else return [
                outputMask
            ].concat(stateMask).concat(stateMask);
        } else return outputMask;
    }
    get trainableWeights() {
        return this.forwardLayer.trainableWeights.concat(this.backwardLayer.trainableWeights);
    }
    get nonTrainableWeights() {
        return this.forwardLayer.nonTrainableWeights.concat(this.backwardLayer.nonTrainableWeights);
    }
    // TODO(cais): Implement constraints().
    setFastWeightInitDuringBuild(value) {
        super.setFastWeightInitDuringBuild(value);
        if (this.forwardLayer != null) this.forwardLayer.setFastWeightInitDuringBuild(value);
        if (this.backwardLayer != null) this.backwardLayer.setFastWeightInitDuringBuild(value);
    }
    getConfig() {
        const config = {
            'mergeMode': this.mergeMode
        };
        // TODO(cais): Add logic for `numConstants` once the property is added.
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        const rnnLayer = (0, $61cac79a6a78765b$export$efcd34ab6248d3cd)(config['layer']);
        delete config['layer'];
        // TODO(cais): Add logic for `numConstants` once the property is added.
        if (config['numConstants'] != null) throw new (0, $af476738b120e938$export$e162153238934121)(`Deserialization of a Bidirectional layer with numConstants ` + `present is not supported yet.`);
        // tslint:disable-next-line:no-any
        const newConfig = config;
        newConfig['layer'] = rnnLayer;
        return new cls(newConfig);
    }
}
/** @nocollapse */ $4f4a7b6b71f57ad7$export$edf712313f3d75dd.className = 'Bidirectional';
(0, $i64bB.serialization).registerClass($4f4a7b6b71f57ad7$export$edf712313f3d75dd);


/**
 * @license
 * Copyright 2022 CodeSmith LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ 

var $i64bB = parcelRequire("i64bB");


/**
 * Preprocessing Rescaling Layer
 *
 * This rescales images by a scaling and offset factor
 */ class $8fa6431efbd381c3$export$7dddadc545bab6c4 extends (0, $03271f6b4e448384$export$936d0764594b6eb3) {
    constructor(args){
        super(args);
        this.scale = args.scale;
        if (args.offset) this.offset = args.offset;
        else this.offset = 0;
    }
    getConfig() {
        const config = {
            'scale': this.scale,
            'offset': this.offset
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
    call(inputs, kwargs) {
        return (0, $i64bB.tidy)(()=>{
            inputs = (0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs);
            if (inputs.dtype !== 'float32') inputs = $33b0bdd0433db936$export$f2db7d5238e1d23f(inputs, 'float32');
            return (0, $i64bB.add)((0, $i64bB.mul)(inputs, this.scale), this.offset);
        });
    }
}
/** @nocollapse */ $8fa6431efbd381c3$export$7dddadc545bab6c4.className = 'Rescaling';
(0, $i64bB.serialization).registerClass($8fa6431efbd381c3$export$7dddadc545bab6c4);


/**
 * @license
 * Copyright 2022 CodeSmith LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");



const { resizeBilinear: $327ffef856450a6f$var$resizeBilinear, cropAndResize: $327ffef856450a6f$var$cropAndResize } = (0, $i64bB.image);
class $327ffef856450a6f$export$975b110751426855 extends (0, $03271f6b4e448384$export$936d0764594b6eb3) {
    constructor(args){
        super(args);
        this.height = args.height;
        this.width = args.width;
    }
    centerCrop(inputs, hBuffer, wBuffer, height, width, inputHeight, inputWidth, dtype) {
        return (0, $i64bB.tidy)(()=>{
            let input;
            let isRank3 = false;
            const top = hBuffer / inputHeight;
            const left = wBuffer / inputWidth;
            const bottom = (height + hBuffer) / inputHeight;
            const right = (width + wBuffer) / inputWidth;
            const bound = [
                top,
                left,
                bottom,
                right
            ];
            const boxesArr = [];
            if (inputs.rank === 3) {
                isRank3 = true;
                input = (0, $i64bB.stack)([
                    inputs
                ]);
            } else input = inputs;
            for(let i = 0; i < input.shape[0]; i++)boxesArr.push(bound);
            const boxes = (0, $i64bB.tensor)(boxesArr, [
                boxesArr.length,
                4
            ]);
            const boxInd = (0, $i64bB.range)(0, boxesArr.length, 1, 'int32');
            const cropSize = [
                height,
                width
            ];
            const cropped = $327ffef856450a6f$var$cropAndResize(input, boxes, boxInd, cropSize, 'nearest');
            if (isRank3) return $33b0bdd0433db936$export$f2db7d5238e1d23f((0, $e11ae28082970f77$export$5327fe015af69a7b)((0, $i64bB.unstack)(cropped)), dtype);
            return $33b0bdd0433db936$export$f2db7d5238e1d23f(cropped, dtype);
        });
    }
    upsize(inputs, height, width, dtype) {
        return (0, $i64bB.tidy)(()=>{
            const outputs = $327ffef856450a6f$var$resizeBilinear(inputs, [
                height,
                width
            ]);
            return $33b0bdd0433db936$export$f2db7d5238e1d23f(outputs, dtype);
        });
    }
    call(inputs, kwargs) {
        return (0, $i64bB.tidy)(()=>{
            const rankedInputs = (0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs);
            const dtype = rankedInputs.dtype;
            const inputShape = rankedInputs.shape;
            const inputHeight = inputShape[inputShape.length - 3];
            const inputWidth = inputShape[inputShape.length - 2];
            let hBuffer = 0;
            if (inputHeight !== this.height) hBuffer = Math.floor((inputHeight - this.height) / 2);
            let wBuffer = 0;
            if (inputWidth !== this.width) {
                wBuffer = Math.floor((inputWidth - this.width) / 2);
                if (wBuffer === 0) wBuffer = 1;
            }
            if (hBuffer >= 0 && wBuffer >= 0) return this.centerCrop(rankedInputs, hBuffer, wBuffer, this.height, this.width, inputHeight, inputWidth, dtype);
            else return this.upsize(inputs, this.height, this.width, dtype);
        });
    }
    getConfig() {
        const config = {
            'height': this.height,
            'width': this.width
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $e11ae28082970f77$export$25c35af872e8abca)(inputShape);
        const hAxis = inputShape.length - 3;
        const wAxis = inputShape.length - 2;
        inputShape[hAxis] = this.height;
        inputShape[wAxis] = this.width;
        return inputShape;
    }
}
/** @nocollapse */ $327ffef856450a6f$export$975b110751426855.className = 'CenterCrop';
(0, $i64bB.serialization).registerClass($327ffef856450a6f$export$975b110751426855);


/**
 * @license
 * Copyright 2022 CodeSmith LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ 

var $i64bB = parcelRequire("i64bB");



/**
 * @license
 * Copyright 2022 CodeSmith LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");



function $95c3c49a35a1e698$export$dd4f0cc5ab8b289d(inputs, outputMode, depth, weights) {
    let input = (0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs);
    if (input.dtype !== 'int32') input = $33b0bdd0433db936$export$f2db7d5238e1d23f(input, 'int32');
    if (outputMode === 'int') return input;
    const originalShape = input.shape;
    if (input.rank === 0) input = (0, $i64bB.expandDims)(input, -1);
    if (outputMode === 'oneHot') {
        if (input.shape[input.shape.length - 1] !== 1) input = (0, $i64bB.expandDims)(input, -1);
    }
    if (input.rank > 2) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`When outputMode is not int, maximum output rank is 2` + ` Received outputMode ${outputMode} and input shape ${originalShape}` + ` which would result in output rank ${input.rank}.`);
    const binaryOutput = [
        'multiHot',
        'oneHot'
    ].includes(outputMode);
    const denseBincountInput = input;
    let binCounts;
    if (typeof weights !== 'undefined' && outputMode === 'count') binCounts = (0, $i64bB.denseBincount)(denseBincountInput, weights, depth, binaryOutput);
    else binCounts = (0, $i64bB.denseBincount)(denseBincountInput, [], depth, binaryOutput);
    if (outputMode !== 'tfIdf') return binCounts;
    if (weights) return (0, $i64bB.mul)(binCounts, weights);
    else throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`When outputMode is 'tfIdf', weights must be provided.`);
}


class $f3706e4293333f96$export$157716bc075e0048 extends (0, $03271f6b4e448384$export$936d0764594b6eb3) {
    constructor(args){
        super(args);
        this.numTokens = args.numTokens;
        if (args.outputMode) this.outputMode = args.outputMode;
        else this.outputMode = 'multiHot';
    }
    getConfig() {
        const config = {
            'numTokens': this.numTokens,
            'outputMode': this.outputMode
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $e11ae28082970f77$export$25c35af872e8abca)(inputShape);
        if (inputShape == null) return [
            this.numTokens
        ];
        if (this.outputMode === 'oneHot' && inputShape[inputShape.length - 1] !== 1) {
            inputShape.push(this.numTokens);
            return inputShape;
        }
        inputShape[inputShape.length - 1] = this.numTokens;
        return inputShape;
    }
    call(inputs, kwargs) {
        return (0, $i64bB.tidy)(()=>{
            inputs = (0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs);
            if (inputs.dtype !== 'int32') inputs = $33b0bdd0433db936$export$f2db7d5238e1d23f(inputs, 'int32');
            let countWeights;
            if (typeof kwargs['countWeights'] !== 'undefined') {
                if (this.outputMode !== 'count') throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`countWeights is not used when outputMode !== count.
              Received countWeights=${kwargs['countWeights']}`);
                countWeights = (0, $e11ae28082970f77$export$5327fe015af69a7b)(kwargs['countWeights']);
            }
            const maxValue = (0, $i64bB.max)(inputs);
            const minValue = (0, $i64bB.min)(inputs);
            const greaterEqualMax = (0, $i64bB.greater)(this.numTokens, maxValue).bufferSync().get(0);
            const greaterMin = (0, $i64bB.greaterEqual)(minValue, 0).bufferSync().get(0);
            if (!(greaterEqualMax && greaterMin)) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)('Input values must be between 0 < values <=' + ` numTokens with numTokens=${this.numTokens}`);
            return $95c3c49a35a1e698$export$dd4f0cc5ab8b289d(inputs, this.outputMode, this.numTokens, countWeights);
        });
    }
}
/** @nocollapse */ $f3706e4293333f96$export$157716bc075e0048.className = 'CategoryEncoding';
(0, $i64bB.serialization).registerClass($f3706e4293333f96$export$157716bc075e0048);


/**
 * @license
 * Copyright 2022 CodeSmith LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");



// tf methods unimplemented in tfjs: 'bicubic', 'area', 'lanczos3', 'lanczos5',
//                                   'gaussian', 'mitchellcubic'
const $60615e8810660055$var$INTERPOLATION_KEYS = [
    'bilinear',
    'nearest'
];
const $60615e8810660055$var$INTERPOLATION_METHODS = new Set($60615e8810660055$var$INTERPOLATION_KEYS);
/**
 * Preprocessing Resizing Layer
 *
 * This resizes images by a scaling and offset factor
 */ class $60615e8810660055$export$9942248a1ae255c2 extends (0, $03271f6b4e448384$export$936d0764594b6eb3) {
    constructor(args){
        super(args);
        this.height = args.height;
        this.width = args.width;
        if (args.interpolation) {
            if ($60615e8810660055$var$INTERPOLATION_METHODS.has(args.interpolation)) this.interpolation = args.interpolation;
            else throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Invalid interpolation parameter: ${args.interpolation} is not implemented`);
        } else this.interpolation = 'bilinear';
        this.cropToAspectRatio = Boolean(args.cropToAspectRatio);
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $e11ae28082970f77$export$25c35af872e8abca)(inputShape);
        const numChannels = inputShape[2];
        return [
            this.height,
            this.width,
            numChannels
        ];
    }
    getConfig() {
        const config = {
            'height': this.height,
            'width': this.width,
            'interpolation': this.interpolation,
            'cropToAspectRatio': this.cropToAspectRatio
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
    call(inputs, kwargs) {
        return (0, $i64bB.tidy)(()=>{
            const size = [
                this.height,
                this.width
            ];
            if (this.interpolation === 'bilinear') return (0, $i64bB.image).resizeBilinear(inputs, size, !this.cropToAspectRatio);
            else if (this.interpolation === 'nearest') return (0, $i64bB.image).resizeNearestNeighbor(inputs, size, !this.cropToAspectRatio);
            else throw new Error(`Interpolation is ${this.interpolation} but only ${[
                ...$60615e8810660055$var$INTERPOLATION_METHODS
            ]} are supported`);
        });
    }
}
/** @nocollapse */ $60615e8810660055$export$9942248a1ae255c2.className = 'Resizing';
(0, $i64bB.serialization).registerClass($60615e8810660055$export$9942248a1ae255c2);


/**
 * @license
 * Copyright 2023 CodeSmith LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


/**
 * @license
 * Copyright 2023 CodeSmith LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2023 CodeSmith LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * Keeps track of seed and handles pseudorandomness
 * Instance created in BaseRandomLayer class
 * Utilized for random preprocessing layers
 */ class $b2af1e8bb7cce42b$export$2d071615d5c9266f {
    constructor(seed){
        this.seed = seed;
    }
    next() {
        if (this.seed === undefined) return undefined;
        return this.seed++;
    }
}
$b2af1e8bb7cce42b$export$2d071615d5c9266f.className = 'RandomSeed';


class $2fd78a3840c1f36e$export$c4beed44a310e6fd extends (0, $03271f6b4e448384$export$936d0764594b6eb3) {
    constructor(args){
        super(args);
        this.randomGenerator = new (0, $b2af1e8bb7cce42b$export$2d071615d5c9266f)(args.seed);
    }
    getConfig() {
        const config = {
            'seed': this.randomGenerator.seed
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
// A layer handle the random number creation and savemodel behavior.
/** @nocollapse */ $2fd78a3840c1f36e$export$c4beed44a310e6fd.className = 'BaseRandomLayer';


const $9ca6805e782a41d7$var$INTERPOLATION_KEYS = [
    'bilinear',
    'nearest'
];
const $9ca6805e782a41d7$export$c4a1b8c76872ce6e = new Set($9ca6805e782a41d7$var$INTERPOLATION_KEYS);
/**
 * Preprocessing Layer with randomly varies image during training
 *
 * This layer randomly adjusts the width of a batch of images of a
 * batch of images by a random factor.
 *
 * The input should be a 3D (unbatched) or
 * 4D (batched) tensor in the `"channels_last"` image data format. Input pixel
 * values can be of any range (e.g. `[0., 1.)` or `[0, 255]`) and of integer
 * or floating point dtype. By default, the layer will output floats.
 *
 * tf methods implemented in tfjs: 'bilinear', 'nearest',
 * tf methods unimplemented in tfjs: 'bicubic', 'area', 'lanczos3', 'lanczos5',
 *                                   'gaussian', 'mitchellcubic'
 *
 */ class $9ca6805e782a41d7$export$d35b9a2fd40085ff extends (0, $2fd78a3840c1f36e$export$c4beed44a310e6fd) {
    constructor(args){
        super(args);
        const { factor: factor, interpolation: interpolation = 'bilinear' } = args;
        this.factor = factor;
        if (Array.isArray(this.factor) && this.factor.length === 2) {
            this.widthLower = this.factor[0];
            this.widthUpper = this.factor[1];
        } else if (!Array.isArray(this.factor) && this.factor > 0) {
            this.widthLower = -this.factor;
            this.widthUpper = this.factor;
        } else throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Invalid factor: ${this.factor}. Must be positive number or tuple of 2 numbers`);
        if (this.widthLower < -1 || this.widthUpper < -1) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`factor must have values larger than -1. Got: ${this.factor}`);
        if (this.widthUpper < this.widthLower) throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`factor cannot have upper bound less than lower bound.
        Got upper bound: ${this.widthUpper}.
        Got lower bound: ${this.widthLower}
      `);
        if (interpolation) {
            if ($9ca6805e782a41d7$export$c4a1b8c76872ce6e.has(interpolation)) this.interpolation = interpolation;
            else throw new (0, $af476738b120e938$export$54d4c18dc78a26d4)(`Invalid interpolation parameter: ${interpolation} is not implemented`);
        }
    }
    getConfig() {
        const config = {
            'factor': this.factor,
            'interpolation': this.interpolation
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $e11ae28082970f77$export$25c35af872e8abca)(inputShape);
        const numChannels = inputShape[2];
        return [
            this.imgHeight,
            -1,
            numChannels
        ];
    }
    call(inputs, kwargs) {
        return (0, $i64bB.tidy)(()=>{
            const input = (0, $e11ae28082970f77$export$5327fe015af69a7b)(inputs);
            this.imgHeight = input.shape[input.shape.length - 3];
            const imgWidth = input.shape[input.shape.length - 2];
            this.widthFactor = (0, $i64bB.randomUniform)([
                1
            ], 1.0 + this.widthLower, 1.0 + this.widthUpper, 'float32', this.randomGenerator.next());
            let adjustedWidth = this.widthFactor.dataSync()[0] * imgWidth;
            adjustedWidth = Math.round(adjustedWidth);
            const size = [
                this.imgHeight,
                adjustedWidth
            ];
            switch(this.interpolation){
                case 'bilinear':
                    return (0, $i64bB.image).resizeBilinear(inputs, size);
                case 'nearest':
                    return (0, $i64bB.image).resizeNearestNeighbor(inputs, size);
                default:
                    throw new Error(`Interpolation is ${this.interpolation}
          but only ${[
                        ...$9ca6805e782a41d7$export$c4a1b8c76872ce6e
                    ]} are supported`);
            }
        });
    }
}
/** @nocollapse */ $9ca6805e782a41d7$export$d35b9a2fd40085ff.className = 'RandomWidth';
(0, $i64bB.serialization).registerClass($9ca6805e782a41d7$export$d35b9a2fd40085ff);


function $cac5b245e2b6bafb$export$d13ae670ceaa55be(args) {
    return new (0, $b470cf8df79854ee$export$191123fdb608c9b4)(args);
}
function $cac5b245e2b6bafb$export$796b583dd79d8524(args) {
    return new (0, $c446169fb509cc58$export$945a5ccf96adb3b2)(args);
}
function $cac5b245e2b6bafb$export$a65e70706ebcefb3(args) {
    return new (0, $c446169fb509cc58$export$b6bead732c285ccc)(args);
}
function $cac5b245e2b6bafb$export$22dc2b3e145b90ac(args) {
    return new (0, $c446169fb509cc58$export$aef2e2f253bc592f)(args);
}
function $cac5b245e2b6bafb$export$5882f235222e6729(args) {
    return new (0, $c446169fb509cc58$export$e8f536be4d0c9e9f)(args);
}
function $cac5b245e2b6bafb$export$e008137e76238601(args) {
    return new (0, $c446169fb509cc58$export$350a526055d3ca6e)(args);
}
function $cac5b245e2b6bafb$export$39138c8eaf72c4cb(args) {
    return new (0, $c446169fb509cc58$export$e0ad929c946d21d1)(args);
}
function $cac5b245e2b6bafb$export$d8aa844fa36b350e(args) {
    return new (0, $510b56cd08d87ce7$export$34a445ae5c2580eb)(args);
}
function $cac5b245e2b6bafb$export$188f9215482e3db8(args) {
    return new (0, $510b56cd08d87ce7$export$57742e605d475795)(args);
}
function $cac5b245e2b6bafb$export$d5e924cbc07fb966(args) {
    return new (0, $510b56cd08d87ce7$export$7dbaf9916b0932fc)(args);
}
function $cac5b245e2b6bafb$export$c476b02bcf7b2def(args) {
    return new (0, $510b56cd08d87ce7$export$9d3874201dd21933)(args);
}
function $cac5b245e2b6bafb$export$5eac62031b3f449f(args) {
    return new (0, $510b56cd08d87ce7$export$56aa8cf0209e38c1)(args);
}
function $cac5b245e2b6bafb$export$2586c92899c2d0fb(args) {
    return new (0, $510b56cd08d87ce7$export$711e1c2609c1fbb3)(args);
}
function $cac5b245e2b6bafb$export$285835edada5f19f(args) {
    return new (0, $510b56cd08d87ce7$export$8c24c9344a3b8089)(args);
}
function $cac5b245e2b6bafb$export$1bc6b6356b35b9d0(args) {
    return new (0, $510b56cd08d87ce7$export$4b8be6e684923935)(args);
}
function $cac5b245e2b6bafb$export$48a8ad9494a8fad8(args) {
    return new (0, $9ed43e21c47c0ee3$export$292dab92c4661cc4)(args);
}
function $cac5b245e2b6bafb$export$80175f455852d1e4(args) {
    return new (0, $c118003cd9cae39f$export$d4842319833f6f14)(args);
}
function $cac5b245e2b6bafb$export$467fe43f0f8da2cc(args) {
    return new (0, $c118003cd9cae39f$export$7db6feeaf0335f8)(args);
}
function $cac5b245e2b6bafb$export$fe05aa12367b4e47(args) {
    return new (0, $c118003cd9cae39f$export$bb75bf17e9ebd794)(args);
}
function $cac5b245e2b6bafb$export$6ab26addce721936(args) {
    return new (0, $c118003cd9cae39f$export$f86f27a3d1240824)(args);
}
function $cac5b245e2b6bafb$export$bffa455ba8c619a6(args) {
    return new (0, $c118003cd9cae39f$export$929ed232258ef592)(args);
}
function $cac5b245e2b6bafb$export$1dcc9b52fbdb892c(args) {
    return new (0, $c118003cd9cae39f$export$6cf81e630ba27dd9)(args);
}
function $cac5b245e2b6bafb$export$9eaad88cf88cee2b(args) {
    return new (0, $c118003cd9cae39f$export$755ddd847e5abe03)(args);
}
function $cac5b245e2b6bafb$export$95e62ad65da8b7d2(args) {
    return new (0, $c118003cd9cae39f$export$f107458f792fb62e)(args);
}
function $cac5b245e2b6bafb$export$ffae51527c311cac(args) {
    return new (0, $9dd3d81b8a7d8f81$export$d4aa6cf23314fd52)(args);
}
function $cac5b245e2b6bafb$export$e16d8520af44a096(args) {
    return new (0, $ada5d50a4ce56f10$export$d0265b2c425512d6)(args);
}
function $cac5b245e2b6bafb$export$cc6710ee5f037d57(args) {
    return new (0, $ada5d50a4ce56f10$export$7725e1a7540355cb)(args);
}
function $cac5b245e2b6bafb$export$375c71d43969527d(args) {
    return new (0, $ada5d50a4ce56f10$export$e55b597c359d82cd)(args);
}
function $cac5b245e2b6bafb$export$b25e0be55f42c9a(args) {
    return new (0, $ada5d50a4ce56f10$export$d8d02ac92d161004)(args);
}
function $cac5b245e2b6bafb$export$916782c1f0ddb132(args) {
    return new (0, $ada5d50a4ce56f10$export$23cb308301e89d6b)(args);
}
function $cac5b245e2b6bafb$export$2060d2db72cce88f(args) {
    return new (0, $ada5d50a4ce56f10$export$f14f83b3b531d498)(args);
}
function $cac5b245e2b6bafb$export$94132a0e348806d4(args) {
    return new (0, $ada5d50a4ce56f10$export$d046b3c4a416f60d)(args);
}
function $cac5b245e2b6bafb$export$598a795b5a50c0b5(args) {
    return new (0, $04e1a8dc21076a19$export$21e75adabb5b0994)(args);
}
function $cac5b245e2b6bafb$export$d46ad5357bc3d7f6(args) {
    return new (0, $04e1a8dc21076a19$export$12bc76b160b1bdc)(args);
}
function $cac5b245e2b6bafb$export$34e2ef2c537eafd4(args) {
    return new (0, $d1251ced663d6b6e$export$3ae403604f7452b3)(args);
}
function $cac5b245e2b6bafb$export$e308d3e6c3deb4b5(args) {
    return new (0, $4724c3b50de979cc$export$abb9a5c13378a7fc)(args);
}
function $cac5b245e2b6bafb$export$b44f2e4690260fec(args) {
    return $cac5b245e2b6bafb$export$e308d3e6c3deb4b5(args);
}
function $cac5b245e2b6bafb$export$42629f014f8228f7(args) {
    return $cac5b245e2b6bafb$export$e308d3e6c3deb4b5(args);
}
function $cac5b245e2b6bafb$export$d5f09f295e795be0(args) {
    return new (0, $4724c3b50de979cc$export$ba5e0a247bd733ca)(args);
}
function $cac5b245e2b6bafb$export$18e398525949757(args) {
    return $cac5b245e2b6bafb$export$d5f09f295e795be0(args);
}
function $cac5b245e2b6bafb$export$3009909165cde72c(args) {
    return $cac5b245e2b6bafb$export$d5f09f295e795be0(args);
}
function $cac5b245e2b6bafb$export$a60791858ca3b1a2(args) {
    return new (0, $4724c3b50de979cc$export$ee30b46b17aabb8f)(args);
}
function $cac5b245e2b6bafb$export$ee1b0efb53eb29c3(args) {
    return $cac5b245e2b6bafb$export$a60791858ca3b1a2(args);
}
function $cac5b245e2b6bafb$export$149ead6bf7dd851c(args) {
    return $cac5b245e2b6bafb$export$a60791858ca3b1a2(args);
}
function $cac5b245e2b6bafb$export$30e0dcdbab04acb(args) {
    return new (0, $4724c3b50de979cc$export$2c6cc528d2786e91)(args);
}
function $cac5b245e2b6bafb$export$4ff10070d09b111d(args) {
    return new (0, $4724c3b50de979cc$export$2bd55677c48d3dfa)(args);
}
function $cac5b245e2b6bafb$export$52aa533ccda11c4c(args) {
    return new (0, $4724c3b50de979cc$export$ab40543f12b91a51)(args);
}
function $cac5b245e2b6bafb$export$e1bfae148b2f4ec8(args) {
    return new (0, $4724c3b50de979cc$export$46257bff79157c32)(args);
}
function $cac5b245e2b6bafb$export$c49c691c8f72af06(args) {
    return new (0, $4724c3b50de979cc$export$ee33f1d34d09a0fd)(args);
}
function $cac5b245e2b6bafb$export$fcf913567033698f(args) {
    return new (0, $4724c3b50de979cc$export$fae6981b13a5bc64)(args);
}
function $cac5b245e2b6bafb$export$64421faebeee5ef8(args) {
    return new (0, $4724c3b50de979cc$export$5a12007b35aee0a)(args);
}
function $cac5b245e2b6bafb$export$e12d2defa419b53a(args) {
    return new (0, $9cf49ab16f0373b1$export$effa27cfcc4408f4)(args);
}
function $cac5b245e2b6bafb$export$d3685ad59ec626a6(args) {
    return new (0, $9cf49ab16f0373b1$export$dad94e00e5c3737)(args);
}
function $cac5b245e2b6bafb$export$fe5a22aa5359fc69(args) {
    return new (0, $9cf49ab16f0373b1$export$c8c9213153497ce0)(args);
}
function $cac5b245e2b6bafb$export$79425027c2dd20e6(args) {
    return new (0, $9cf49ab16f0373b1$export$17aacc547a045ab0)(args);
}
function $cac5b245e2b6bafb$export$5ccbc90d85639fb9(args) {
    return new (0, $9cf49ab16f0373b1$export$9f3b0efd8738b035)(args);
}
function $cac5b245e2b6bafb$export$8e8d4a6c4528553(args) {
    return new (0, $9cf49ab16f0373b1$export$c8a45b8cd42f689)(args);
}
function $cac5b245e2b6bafb$export$807c24c535353095(args) {
    return new (0, $42b2362441f50a9b$export$d5828f4b24c3231)(args);
}
function $cac5b245e2b6bafb$export$e8d3b2ad5b300a03(args) {
    return new (0, $42b2362441f50a9b$export$6fd0801294342e82)(args);
}
function $cac5b245e2b6bafb$export$3e66d5ce8f778ebc(args) {
    return new (0, $9cf49ab16f0373b1$export$2b97bcdf1d6f1b16)(args);
}
function $cac5b245e2b6bafb$export$d977f05737668a6(args) {
    return new (0, $9cf49ab16f0373b1$export$966a21a552328009)(args);
}
function $cac5b245e2b6bafb$export$ad322fa54f969043(args) {
    return new (0, $4f4a7b6b71f57ad7$export$edf712313f3d75dd)(args);
}
function $cac5b245e2b6bafb$export$8b8f46f74cfe04dc(args) {
    return new (0, $4f4a7b6b71f57ad7$export$72d58104314bdbf3)(args);
}
const $cac5b245e2b6bafb$export$2efd4c09521df503 = $cac5b245e2b6bafb$export$52aa533ccda11c4c;
const $cac5b245e2b6bafb$export$4a73421a2f7eceac = $cac5b245e2b6bafb$export$e1bfae148b2f4ec8;
const $cac5b245e2b6bafb$export$b4ce5850fd040d92 = $cac5b245e2b6bafb$export$c49c691c8f72af06;
const $cac5b245e2b6bafb$export$cb09112eb789ff08 = $cac5b245e2b6bafb$export$fcf913567033698f;
function $cac5b245e2b6bafb$export$cd62c6b94cb3c213(args) {
    return new (0, $7fc8091152fb4d5a$export$d18d3f770cea837e)(args);
}
function $cac5b245e2b6bafb$export$bc128cd40ed5bfda(args) {
    return new (0, $7fc8091152fb4d5a$export$c07c4bcc10d07979)(args);
}
function $cac5b245e2b6bafb$export$d73d2c7da153e772(args) {
    return new (0, $7fc8091152fb4d5a$export$8a44d71014be114)(args);
}
function $cac5b245e2b6bafb$export$2918598f73ee1e32(args) {
    return new (0, $c118003cd9cae39f$export$b713323c862a70bd)(args);
}
function $cac5b245e2b6bafb$export$a512ecbbed70f3e(args) {
    return new (0, $8fa6431efbd381c3$export$7dddadc545bab6c4)(args);
}
function $cac5b245e2b6bafb$export$22e2caf9ef2c32c0(args) {
    return new (0, $327ffef856450a6f$export$975b110751426855)(args);
}
function $cac5b245e2b6bafb$export$51be41c2a8dd482c(args) {
    return new (0, $60615e8810660055$export$9942248a1ae255c2)(args);
}
function $cac5b245e2b6bafb$export$5fd5c67c8b5e540b(args) {
    return new (0, $f3706e4293333f96$export$157716bc075e0048)(args);
}
function $cac5b245e2b6bafb$export$6fdd63ba3cdc7680(args) {
    return new (0, $9ca6805e782a41d7$export$d35b9a2fd40085ff)(args);
}




function $458f110353b722ca$export$7b3d02e9a01c1ca(yTrue, yPred) {
    return $7612942a5d22baee$export$7b3d02e9a01c1ca(yTrue, yPred);
}
function $458f110353b722ca$export$f9fa66c6bf49fbe1(yTrue, yPred) {
    return $7612942a5d22baee$export$f9fa66c6bf49fbe1(yTrue, yPred);
}
function $458f110353b722ca$export$b35c43b77daa3523(yTrue, yPred) {
    return $7612942a5d22baee$export$b35c43b77daa3523(yTrue, yPred);
}
function $458f110353b722ca$export$1365401eb6b7aeeb(yTrue, yPred) {
    return $7612942a5d22baee$export$1365401eb6b7aeeb(yTrue, yPred);
}
function $458f110353b722ca$export$3d5544849562b631(yTrue, yPred) {
    return $7612942a5d22baee$export$3d5544849562b631(yTrue, yPred);
}
function $458f110353b722ca$export$b70eeb0e623ceb0d(yTrue, yPred) {
    return $7612942a5d22baee$export$b70eeb0e623ceb0d(yTrue, yPred);
}
function $458f110353b722ca$export$479490328e25f530(yTrue, yPred) {
    return $7612942a5d22baee$export$479490328e25f530(yTrue, yPred);
}
function $458f110353b722ca$export$a39f0fc1fa1caacd(yTrue, yPred) {
    return $7d695629521dc3d5$export$a39f0fc1fa1caacd(yTrue, yPred);
}
function $458f110353b722ca$export$607988531ba584e6(yTrue, yPred) {
    return $7d695629521dc3d5$export$607988531ba584e6(yTrue, yPred);
}
function $458f110353b722ca$export$29f745e8786a84d(yTrue, yPred) {
    return $7d695629521dc3d5$export$29f745e8786a84d(yTrue, yPred);
}
function $458f110353b722ca$export$520a6d354b1a7026(yTrue, yPred) {
    return $7d695629521dc3d5$export$29f745e8786a84d(yTrue, yPred);
}
function $458f110353b722ca$export$1d9e5626781fbee(yTrue, yPred) {
    return $7d695629521dc3d5$export$29f745e8786a84d(yTrue, yPred);
}
function $458f110353b722ca$export$33de16355e97f7fb(yTrue, yPred) {
    return $7d695629521dc3d5$export$33de16355e97f7fb(yTrue, yPred);
}
function $458f110353b722ca$export$19fa95397f41c30f(yTrue, yPred) {
    return $7d695629521dc3d5$export$33de16355e97f7fb(yTrue, yPred);
}
function $458f110353b722ca$export$5af2a467647891e2(yTrue, yPred) {
    return $7d695629521dc3d5$export$33de16355e97f7fb(yTrue, yPred);
}
function $458f110353b722ca$export$3c864af03e35a80e(yTrue, yPred) {
    return $7612942a5d22baee$export$3c864af03e35a80e(yTrue, yPred);
}


/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ 


/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ 
function $6e8f8de4d0682ff2$export$19d549ef0ddd23b0(config) {
    return new (0, $030044d54dc1235d$export$fb258565fa710653)(config);
}
function $6e8f8de4d0682ff2$export$b35c4719d0ff29eb(config) {
    return $030044d54dc1235d$export$b35c4719d0ff29eb(config);
}
function $6e8f8de4d0682ff2$export$683828dad49492ec(config) {
    return $030044d54dc1235d$export$683828dad49492ec(config);
}



/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /* Original source: keras/callbacks.py */ 



class $649aa1f6fdb22fba$export$78f58e2a70333412 extends (0, $65144a7424fc1c41$export$ac023a7995700a90) {
    constructor(){
        super(...arguments);
        /** Instance of `keras.models.Model`. Reference of the model being trained. */ this.model = null;
    }
    setModel(model) {
        if (!(model instanceof (0, $c4ed419014cbc39b$export$f8e130845653852b))) throw new Error('model must be a LayersModel, not some other Container');
        this.model = model;
    }
}
function $649aa1f6fdb22fba$var$less(currVal, prevVal) {
    return currVal < prevVal;
}
function $649aa1f6fdb22fba$var$greater(currVal, prevVal) {
    return currVal > prevVal;
}
class $649aa1f6fdb22fba$export$be8b2554758a52cc extends $649aa1f6fdb22fba$export$78f58e2a70333412 {
    constructor(args){
        super();
        if (args == null) args = {};
        if (args.restoreBestWeights) throw new (0, $af476738b120e938$export$e162153238934121)('restoreBestWeights = True is not implemented in EarlyStopping yet.');
        this.monitor = args.monitor || 'val_loss';
        this.minDelta = Math.abs(args.minDelta || 0);
        this.patience = args.patience || 0;
        this.verbose = args.verbose || 0;
        this.mode = args.mode || 'auto';
        this.baseline = args.baseline;
        if ([
            'auto',
            'min',
            'max'
        ].indexOf(this.mode) === -1) {
            console.warn(`EarlyStopping mode '${this.mode}' is invalid. ` + `Falling back to mode 'auto'.`);
            this.mode = 'auto';
        }
        if (this.mode === 'min') this.monitorFunc = $649aa1f6fdb22fba$var$less;
        else if (this.mode === 'max') this.monitorFunc = $649aa1f6fdb22fba$var$greater;
        else // For mode === 'auto'.
        if (this.monitor.indexOf('acc') !== -1) this.monitorFunc = $649aa1f6fdb22fba$var$greater;
        else this.monitorFunc = $649aa1f6fdb22fba$var$less;
        if (this.monitorFunc === $649aa1f6fdb22fba$var$less) this.minDelta *= -1;
    }
    async onTrainBegin(logs) {
        this.wait = 0;
        this.stoppedEpoch = 0;
        if (this.baseline != null) this.best = this.baseline;
        else this.best = this.monitorFunc === $649aa1f6fdb22fba$var$less ? Infinity : -Infinity;
    }
    async onEpochEnd(epoch, logs) {
        await (0, $60719b6320089bc4$export$edec74c62c989297)(logs);
        const current = this.getMonitorValue(logs);
        if (current == null) return;
        if (this.monitorFunc(current - this.minDelta, this.best)) {
            this.best = current;
            this.wait = 0;
        // TODO(cais): Logic for restoreBestWeights.
        } else {
            this.wait++;
            if (this.wait >= this.patience) {
                this.stoppedEpoch = epoch;
                this.model.stopTraining = true;
            }
        // TODO(cais): Logic for restoreBestWeights.
        }
    }
    async onTrainEnd(logs) {
        if (this.stoppedEpoch > 0 && this.verbose) console.log(`Epoch ${this.stoppedEpoch}: early stopping.`);
    }
    getMonitorValue(logs) {
        if (logs == null) logs = {};
        const monitorValue = logs[this.monitor];
        if (monitorValue == null) console.warn(`Metric for EarlyStopping ${this.monitor} is not available. ` + `Available metrics are: ${Object.keys(logs)}`);
        return monitorValue;
    }
}
function $649aa1f6fdb22fba$export$f951bfa445288ab1(args) {
    return new $649aa1f6fdb22fba$export$be8b2554758a52cc(args);
}
const $649aa1f6fdb22fba$export$b89c5c1b934d8237 = {
    earlyStopping: $649aa1f6fdb22fba$export$f951bfa445288ab1
};












var $40l72 = parcelRequire("40l72");
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $3mnBW = parcelRequire("3mnBW");
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $3mnBW = parcelRequire("3mnBW");
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
function $2432561787a47ba4$export$ce7eaaed37329a1b(input, mapFn) {
    return $2432561787a47ba4$var$deepMapInternal(input, mapFn);
}
/**
 * @param seen: A Map of known object mappings (i.e., memoized results of
 *   `mapFn()`)
 * @param containedIn: An set containing objects on the reference path currently
 *   being processed (used to detect cycles).
 */ function $2432561787a47ba4$var$deepMapInternal(input, mapFn, seen = new Map(), containedIn = new Set()) {
    if (input == null) return null;
    if (typeof Blob === 'function' && input instanceof Blob) return input.slice();
    if (containedIn.has(input)) throw new Error('Circular references are not supported.');
    if (seen.has(input)) return seen.get(input);
    const result = mapFn(input);
    if (result.recurse && result.value !== null) throw new Error('A deep map function may not return both a value and recurse=true.');
    if (!result.recurse) {
        seen.set(input, result.value);
        return result.value;
    } else if ($2432561787a47ba4$export$9652023d9040757(input)) {
        // tslint:disable-next-line:no-any
        const mappedIterable = Array.isArray(input) ? [] : {};
        containedIn.add(input);
        for(const k in input){
            const child = input[k];
            const childResult = $2432561787a47ba4$var$deepMapInternal(child, mapFn, seen, containedIn);
            mappedIterable[k] = childResult;
        }
        containedIn.delete(input);
        if (input.__proto__) mappedIterable.__proto__ = input.__proto__;
        return mappedIterable;
    } else throw new Error(`Can't recurse into non-iterable type: ${input}`);
}
function $2432561787a47ba4$export$de254daced10325b(inputs, zipFn = $2432561787a47ba4$export$5af6628663604bcb) {
    return $2432561787a47ba4$var$deepZipInternal(inputs, zipFn);
}
/**
 * @param containedIn: An set containing objects on the reference path currently
 *   being processed (used to detect cycles).
 */ function $2432561787a47ba4$var$deepZipInternal(inputs, zipFn, containedIn = new Set()) {
    // The recursion follows the structure of input 0; it's assumed that all the
    // other inputs have the same structure.
    const input = inputs[0];
    if (containedIn.has(input)) throw new Error('Circular references are not supported.');
    const result = zipFn(inputs);
    if (result.recurse && result.value !== null) throw new Error('A deep zip function may not return both a value and recurse=true.');
    if (!result.recurse) return result.value;
    else if ($2432561787a47ba4$export$9652023d9040757(input)) {
        // tslint:disable-next-line:no-any
        const mappedIterable = Array.isArray(input) ? [] : {};
        containedIn.add(input);
        for(const k in input){
            const children = inputs.map((x)=>x[k]);
            const childResult = $2432561787a47ba4$var$deepZipInternal(children, zipFn, containedIn);
            mappedIterable[k] = childResult;
        }
        containedIn.delete(input);
        return mappedIterable;
    } else throw new Error(`Can't recurse into non-iterable type: ${input}`);
}
function $2432561787a47ba4$export$5af6628663604bcb(x) {
    if (x === null) return null;
    // TODO(soergel): validate array type?
    if ($2432561787a47ba4$export$9652023d9040757(x[0])) return {
        value: null,
        recurse: true
    };
    else return {
        value: x,
        recurse: false
    };
}
async function $2432561787a47ba4$export$20eea0c38ad5b6db(input, mapFn) {
    const seen = new Map();
    // First do a normal deepMap, collecting Promises in 'seen' as a side effect.
    $2432561787a47ba4$var$deepMapInternal(input, mapFn, seen);
    // Replace the Promises in 'seen' in place.
    // Note TypeScript provides no async map iteration, and regular map iteration
    // is broken too, so sadly we have to do Array.from() to make it work.
    // (There's no advantage to Promise.all(), and that would be tricky anyway.)
    for (const key of Array.from(seen.keys())){
        const value = seen.get(key);
        if ($i64bB.util.isPromise(value)) {
            const mappedValue = await value;
            seen.set(key, mappedValue);
        }
    }
    // Normal deepMap again, this time filling in the resolved values.
    // It's unfortunate that we have to do two passes.
    // TODO(soergel): test performance and think harder about a fast solution.
    const result = $2432561787a47ba4$var$deepMapInternal(input, mapFn, seen);
    return result;
}

function $2432561787a47ba4$export$9652023d9040757(obj) {
    let isTextDecoder = false;
    if ($i64bB.env().get('IS_BROWSER')) isTextDecoder = obj instanceof TextDecoder;
    else {
        // tslint:disable-next-line:no-require-imports
        const { StringDecoder: StringDecoder } = (parcelRequire("kjyEk"));
        isTextDecoder = obj instanceof StringDecoder;
    }
    return obj != null && !ArrayBuffer.isView(obj) && (Array.isArray(obj) || typeof obj === 'object' && !(obj instanceof $i64bB.Tensor) && !(obj instanceof Promise) && !isTextDecoder);
}
function $2432561787a47ba4$export$2714d9e1645b25ab(obj) {
    return obj == null || $2432561787a47ba4$var$isPrimitive(obj) || Array.isArray(obj) || typeof obj === 'object' && obj instanceof $i64bB.Tensor || $i64bB.util.isTypedArray(obj);
}
/**
 * Returns true if the given `value` is a primitive type. Otherwise returns
 * false. This is equivalant to node util.isPrimitive
 */ function $2432561787a47ba4$var$isPrimitive(value) {
    return value === null || typeof value !== 'object' && typeof value !== 'function';
}


function $fdfe2e4c14b2132a$export$b7d58db314e0ac27(container) {
    return (0, $2432561787a47ba4$export$ce7eaaed37329a1b)(container, $fdfe2e4c14b2132a$var$cloneIfTensor);
}
// tslint:disable-next-line: no-any
function $fdfe2e4c14b2132a$var$cloneIfTensor(item) {
    if (item instanceof $i64bB.Tensor) return {
        value: item.clone(),
        recurse: false
    };
    else if ((0, $2432561787a47ba4$export$9652023d9040757)(item)) return {
        value: null,
        recurse: true
    };
    else return {
        value: item,
        recurse: false
    };
}



/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ /**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ /**
 * A ring buffer, providing O(1) FIFO, LIFO, and related operations.
 */ class $36c94bc6b99a24ce$export$575ef0eeec6e42f5 {
    /**
     * Constructs a `RingBuffer`.
     * @param capacity The number of items that the buffer can accomodate.
     */ constructor(capacity){
        this.capacity = capacity;
        // Note we store the indices in the range 0 <= index < 2*capacity.
        // This allows us to distinguish the full from the empty case.
        // See https://www.snellman.net/blog/archive/2016-12-13-ring-buffers/
        this.begin = 0; // inclusive
        this.end = 0; // exclusive
        if (capacity == null) throw new RangeError('Can\'t create a ring buffer of unknown capacity.');
        if (capacity < 1) throw new RangeError('Can\'t create ring buffer of capacity < 1.');
        this.data = new Array(capacity);
        this.doubledCapacity = 2 * capacity;
    }
    /**
     * Map any index into the range 0 <= index < 2*capacity.
     */ wrap(index) {
        // don't trust % on negative numbers
        while(index < 0)index += this.doubledCapacity;
        return index % this.doubledCapacity;
    }
    get(index) {
        if (index < 0) throw new RangeError('Can\'t get item at a negative index.');
        return this.data[index % this.capacity];
    }
    set(index, value) {
        if (index < 0) throw new RangeError('Can\'t set item at a negative index.');
        this.data[index % this.capacity] = value;
    }
    /**
     * Returns the current number of items in the buffer.
     */ length() {
        let length = this.end - this.begin;
        if (length < 0) length = this.doubledCapacity + length;
        return length;
    }
    /**
     * Reports whether the buffer is full.
     * @returns true if the number of items in the buffer equals its capacity, and
     *   false otherwise.
     */ isFull() {
        return this.length() === this.capacity;
    }
    /**
     * Reports whether the buffer is empty.
     * @returns true if the number of items in the buffer equals zero, and
     *   false otherwise.
     */ isEmpty() {
        return this.length() === 0;
    }
    /**
     * Adds an item to the end of the buffer.
     */ push(value) {
        if (this.isFull()) throw new RangeError('Ring buffer is full.');
        this.set(this.end, value);
        this.end = this.wrap(this.end + 1);
    }
    /**
     * Adds many items to the end of the buffer, in order.
     */ pushAll(values) {
        for (const value of values)this.push(value);
    }
    /**
     * Removes and returns the last item in the buffer.
     */ pop() {
        if (this.isEmpty()) throw new RangeError('Ring buffer is empty.');
        this.end = this.wrap(this.end - 1);
        const result = this.get(this.end);
        this.set(this.end, undefined);
        return result;
    }
    /**
     * Adds an item to the beginning of the buffer.
     */ unshift(value) {
        if (this.isFull()) throw new RangeError('Ring buffer is full.');
        this.begin = this.wrap(this.begin - 1);
        this.set(this.begin, value);
    }
    /**
     * Removes and returns the first item in the buffer.
     */ shift() {
        if (this.isEmpty()) throw new RangeError('Ring buffer is empty.');
        const result = this.get(this.begin);
        this.set(this.begin, undefined);
        this.begin = this.wrap(this.begin + 1);
        return result;
    }
    /**
     * Removes and returns a specific item in the buffer, and moves the last item
     * to the vacated slot.  This is useful for implementing a shuffling stream.
     * Note that this operation necessarily scrambles the original order.
     *
     * @param relativeIndex: the index of the item to remove, relative to the
     *   first item in the buffer (e.g., hiding the ring nature of the underlying
     *   storage).
     */ shuffleExcise(relativeIndex) {
        if (this.isEmpty()) throw new RangeError('Ring buffer is empty.');
        const index = this.wrap(this.begin + relativeIndex);
        const result = this.get(index);
        this.set(index, this.pop());
        return result;
    }
}


class $5aaff1bb9f94472d$export$bd4eb95ce427db4d extends (0, $36c94bc6b99a24ce$export$575ef0eeec6e42f5) {
    /**
     * Constructs a `GrowingRingBuffer`.
     */ constructor(){
        super($5aaff1bb9f94472d$export$bd4eb95ce427db4d.INITIAL_CAPACITY);
    }
    isFull() {
        return false;
    }
    push(value) {
        if (super.isFull()) this.expand();
        super.push(value);
    }
    unshift(value) {
        if (super.isFull()) this.expand();
        super.unshift(value);
    }
    /**
     * Doubles the capacity of the buffer.
     */ expand() {
        const newCapacity = this.capacity * 2;
        const newData = new Array(newCapacity);
        const len = this.length();
        // Rotate the buffer to start at index 0 again, since we can't just
        // allocate more space at the end.
        for(let i = 0; i < len; i++)newData[i] = this.get(this.wrap(this.begin + i));
        this.data = newData;
        this.capacity = newCapacity;
        this.doubledCapacity = 2 * this.capacity;
        this.begin = 0;
        this.end = len;
    }
}
$5aaff1bb9f94472d$export$bd4eb95ce427db4d.INITIAL_CAPACITY = 32;



function $b1fde1aac6b3a764$export$313b11d04150405f(items) {
    return new $b1fde1aac6b3a764$var$ArrayIterator(items);
}
function $b1fde1aac6b3a764$export$8dc48c1840268a(start) {
    let i = start;
    return $b1fde1aac6b3a764$export$392feaf09f7ef035(()=>({
            value: i++,
            done: false
        }));
}
function $b1fde1aac6b3a764$export$392feaf09f7ef035(func) {
    return new $b1fde1aac6b3a764$var$FunctionCallIterator(func);
}
function $b1fde1aac6b3a764$export$a9a63cf863a3bed5(baseIterators, baseErrorHandler) {
    return new $b1fde1aac6b3a764$export$22a7cbb11e3b9068(baseIterators, baseErrorHandler);
}
function $b1fde1aac6b3a764$export$89912d30bab1596b(iteratorFunc, count, baseErrorHandler) {
    return $b1fde1aac6b3a764$export$a9a63cf863a3bed5($b1fde1aac6b3a764$export$392feaf09f7ef035(iteratorFunc).take(count), baseErrorHandler);
}
function $b1fde1aac6b3a764$export$5ecdf828f976b66e(iterators, mismatchMode = $b1fde1aac6b3a764$export$4b13032c4dd08391.FAIL) {
    return new $b1fde1aac6b3a764$var$ZipIterator(iterators, mismatchMode);
}
class $b1fde1aac6b3a764$export$b7f78d762925efef {
    /**
     * Collect all remaining elements of a bounded stream into an array.
     * Obviously this will succeed only for small streams that fit in memory.
     * Useful for testing.
     *
     * @returns A Promise for an array of stream elements, which will resolve
     *   when the stream is exhausted.
     */ async toArray() {
        const result = [];
        let x = await this.next();
        while(!x.done){
            result.push(x.value);
            x = await this.next();
        }
        return result;
    }
    /**
     * Collect all elements of this dataset into an array with prefetching 100
     * elements. This is useful for testing, because the prefetch changes the
     * order in which the Promises are resolved along the processing pipeline.
     * This may help expose bugs where results are dependent on the order of
     * Promise resolution rather than on the logical order of the stream (i.e.,
     * due to hidden mutable state).
     *
     * @returns A Promise for an array of stream elements, which will resolve
     *   when the stream is exhausted.
     */ async toArrayForTest() {
        const stream = this.prefetch(100);
        const result = [];
        let x = await stream.next();
        while(!x.done){
            result.push(x.value);
            x = await stream.next();
        }
        return result;
    }
    /**
     * Draw items from the stream until it is exhausted.
     *
     * This can be useful when the stream has side effects but no output.  In
     * that case, calling this function guarantees that the stream will be
     * fully processed.
     */ async resolveFully() {
        let x = await this.next();
        while(!x.done)x = await this.next();
    }
    /**
     * Draw items from the stream until it is exhausted, or a predicate fails.
     *
     * This can be useful when the stream has side effects but no output.  In
     * that case, calling this function guarantees that the stream will be
     * fully processed.
     */ async resolveWhile(predicate) {
        let x = await this.next();
        let shouldContinue = predicate(x.value);
        while(!x.done && shouldContinue){
            x = await this.next();
            shouldContinue = predicate(x.value);
        }
    }
    /**
     * Handles errors thrown on this stream using a provided handler function.
     *
     * @param handler A function that handles any `Error` thrown during a `next()`
     *   call and returns true if the stream should continue (dropping the failed
     *   call) or false if the stream should quietly terminate.  If the handler
     *   itself throws (or rethrows) an `Error`, that will be propagated.
     *
     * @returns A `LazyIterator` of elements passed through from upstream,
     *   possibly filtering or terminating on upstream `next()` calls that
     *   throw an `Error`.
     */ handleErrors(handler) {
        return new $b1fde1aac6b3a764$var$ErrorHandlingLazyIterator(this, handler);
    }
    // TODO(soergel): Implement reduce() etc.
    /**
     * Filters this stream according to `predicate`.
     *
     * @param predicate A function mapping a stream element to a boolean or a
     * `Promise` for one.
     *
     * @returns A `LazyIterator` of elements for which the predicate was true.
     */ filter(predicate) {
        return new $b1fde1aac6b3a764$var$FilterIterator(this, predicate);
    }
    /**
     * Maps this stream through a 1-to-1 transform.
     *
     * @param transform A function mapping a stream element to a transformed
     *   element.
     *
     * @returns A `LazyIterator` of transformed elements.
     */ map(transform) {
        return new $b1fde1aac6b3a764$var$MapIterator(this, transform);
    }
    /**
     * Maps this stream through an async 1-to-1 transform.
     *
     * @param transform A function mapping a stream element to a `Promise` for a
     *   transformed stream element.
     *
     * @returns A `LazyIterator` of transformed elements.
     */ mapAsync(transform) {
        return new $b1fde1aac6b3a764$var$AsyncMapIterator(this, transform);
    }
    /**
     * Maps this stream through a 1-to-1 transform, forcing serial execution.
     *
     * @param transform A function mapping a stream element to a transformed
     *   element.
     *
     * @returns A `LazyIterator` of transformed elements.
     */ serialMapAsync(transform) {
        return new $b1fde1aac6b3a764$var$AsyncMapIterator(this, transform).serial();
    }
    /**
     * Maps this stream through a 1-to-many transform.
     *
     * @param transform A function mapping a stream element to an array of
     *   transformed elements.
     *
     * @returns A `DataStream` of transformed elements.
     */ flatmap(transform) {
        return new $b1fde1aac6b3a764$var$FlatmapIterator(this, transform);
    }
    /**
     * Apply a function to every element of the stream.
     *
     * @param f A function to apply to each stream element.
     */ async forEachAsync(f) {
        return this.map(f).resolveFully();
    }
    /**
     * Apply a function to every element of the stream, forcing serial execution.
     *
     * @param f A function to apply to each stream element.  Should return 'true'
     *   to indicate that the stream should continue, or 'false' to cause it to
     *   terminate.
     */ async serialForEach(f) {
        return this.serialMapAsync(f).resolveWhile((x)=>x === true);
    }
    /**
     * Groups elements into batches, represented as arrays of elements.
     *
     * We can think of the elements of this iterator as 'rows' (even if they are
     * nested structures).  By the same token, consecutive values for a given
     * key within the elements form a 'column'.  This matches the usual sense of
     * 'row' and 'column' when processing tabular data (e.g., parsing a CSV).
     *
     * Thus, "Row-major" means that the resulting batch is simply a collection of
     * rows: `[row1, row2, row3, ...]`.  This is contrast to the column-major
     * form, which is needed for vectorized computation.
     *
     * @param batchSize The number of elements desired per batch.
     * @param smallLastBatch Whether to emit the final batch when it has fewer
     *   than batchSize elements. Default true.
     * @returns A `LazyIterator` of batches of elements, represented as arrays
     *   of the original element type.
     */ rowMajorBatch(batchSize, smallLastBatch = true) {
        return new $b1fde1aac6b3a764$var$RowMajorBatchIterator(this, batchSize, smallLastBatch);
    }
    /**
     * Groups elements into batches, represented in column-major form.
     *
     * We can think of the elements of this iterator as 'rows' (even if they are
     * nested structures).  By the same token, consecutive values for a given
     * key within the elements form a 'column'.  This matches the usual sense of
     * 'row' and 'column' when processing tabular data (e.g., parsing a CSV).
     *
     * Thus, "column-major" means that the resulting batch is a (potentially
     * nested) structure representing the columns.  Each column entry, then,
     * contains a collection of the values found in that column for a range of
     * input elements.  This representation allows for vectorized computation, in
     * contrast to the row-major form.
     *
     * The inputs should all have the same nested structure (i.e., of arrays and
     * dicts).  The result is a single object with the same nested structure,
     * where the leaves are arrays collecting the values of the inputs at that
     * location (or, optionally, the result of a custom function applied to those
     * arrays).
     *
     * @param batchSize The number of elements desired per batch.
     * @param smallLastBatch Whether to emit the final batch when it has fewer
     *   than batchSize elements. Default true.
     * @param zipFn: (optional) A function that expects an array of elements at a
     *   single node of the object tree, and returns a `DeepMapResult`.  The
     *   `DeepMapResult` either provides a result value for that node (i.e.,
     *   representing the subtree), or indicates that the node should be processed
     *   recursively.  The default zipFn recurses as far as possible and places
     *   arrays at the leaves.
     * @returns A `LazyIterator` of batches of elements, represented as an object
     *   with collections at the leaves.
     */ columnMajorBatch(batchSize, smallLastBatch = true, // tslint:disable-next-line:no-any
    zipFn = (0, $2432561787a47ba4$export$5af6628663604bcb)) {
        // First collect the desired number of input elements as a row-major batch.
        const rowBatches = this.rowMajorBatch(batchSize, smallLastBatch);
        // Now 'rotate' or 'pivot' the data, collecting all values from each column
        // in the batch (i.e., for each key within the elements) into an array.
        return rowBatches.map((x)=>(0, $2432561787a47ba4$export$de254daced10325b)(x, zipFn));
    }
    /**
     * Concatenate this `LazyIterator` with another.
     *
     * @param iterator A `LazyIterator` to be concatenated onto this one.
     * @param baseErrorHandler An optional function that can intercept `Error`s
     *   raised during a `next()` call on the base stream.  This function can
     *   decide whether the error should be propagated, whether the error should
     *   be ignored, or whether the base stream should be terminated.
     * @returns A `LazyIterator`.
     */ concatenate(iterator, baseErrorHandler) {
        return new $b1fde1aac6b3a764$export$22a7cbb11e3b9068($b1fde1aac6b3a764$export$313b11d04150405f([
            this,
            iterator
        ]), baseErrorHandler);
    }
    /**
     * Limits this stream to return at most `count` items.
     *
     * @param count The maximum number of items to provide from the stream. If
     * a negative or undefined value is given, the entire stream is returned
     *   unaltered.
     */ take(count) {
        if (count < 0 || count == null) return this;
        return new $b1fde1aac6b3a764$var$TakeIterator(this, count);
    }
    /**
     * Skips the first `count` items in this stream.
     *
     * @param count The number of items to skip.  If a negative or undefined
     * value is given, the entire stream is returned unaltered.
     */ skip(count) {
        if (count < 0 || count == null) return this;
        return new $b1fde1aac6b3a764$var$SkipIterator(this, count);
    }
    /**
     * Prefetch the first `bufferSize` items in this stream.
     *
     * Note this prefetches Promises, but makes no guarantees about when those
     * Promises resolve.
     *
     * @param bufferSize: An integer specifying the number of elements to be
     *   prefetched.
     */ prefetch(bufferSize) {
        return new $b1fde1aac6b3a764$export$7126304418df8697(this, bufferSize);
    }
    // TODO(soergel): deep sharded shuffle, where supported
    /**
     * Randomly shuffles the elements of this stream.
     *
     * @param bufferSize: An integer specifying the number of elements from
     * this stream from which the new stream will sample.
     * @param seed: (Optional.) An integer specifying the random seed that
     * will be used to create the distribution.
     */ shuffle(windowSize, seed) {
        return new $b1fde1aac6b3a764$export$50d642f401310a09(this, windowSize, seed);
    }
    /**
     * Force an iterator to execute serially: each next() call will await the
     * prior one, so that they cannot execute concurrently.
     */ serial() {
        return new $b1fde1aac6b3a764$var$SerialIterator(this);
    }
}
// ============================================================================
// The following private classes serve to implement the chainable methods
// on LazyIterator.  Unfortunately they can't be placed in separate files,
// due to resulting trouble with circular imports.
// ============================================================================
// Iterators that just extend LazyIterator directly
// ============================================================================
class $b1fde1aac6b3a764$var$ArrayIterator extends $b1fde1aac6b3a764$export$b7f78d762925efef {
    constructor(items){
        super();
        this.items = items;
        this.trav = 0;
    }
    summary() {
        return `Array of ${this.items.length} items`;
    }
    async next() {
        if (this.trav >= this.items.length) return {
            value: null,
            done: true
        };
        const item = this.items[this.trav];
        this.trav++;
        return {
            value: (0, $fdfe2e4c14b2132a$export$b7d58db314e0ac27)(item),
            done: false
        };
    }
}
class $b1fde1aac6b3a764$var$FunctionCallIterator extends $b1fde1aac6b3a764$export$b7f78d762925efef {
    constructor(nextFn){
        super();
        this.nextFn = nextFn;
    }
    summary() {
        return `Function call`;
    }
    async next() {
        try {
            return this.nextFn();
        } catch (e) {
            // Modify the error message but leave the stack trace intact
            e.message = `Error thrown while iterating through a dataset: ${e.message}`;
            throw e;
        }
    }
}
class $b1fde1aac6b3a764$var$SerialIterator extends $b1fde1aac6b3a764$export$b7f78d762925efef {
    constructor(upstream){
        super();
        this.upstream = upstream;
        this.lastRead = Promise.resolve({
            value: null,
            done: false
        });
    }
    summary() {
        return `${this.upstream.summary()} -> Serial`;
    }
    async next() {
        // This sets this.lastRead to a new Promise right away, as opposed to
        // saying `await this.lastRead; this.lastRead = this.serialNext();` which
        // would not work because this.nextRead would be updated only after the
        // promise resolves.
        this.lastRead = this.lastRead.then(()=>this.serialNext());
        return this.lastRead;
    }
    async serialNext() {
        return this.upstream.next();
    }
}
class $b1fde1aac6b3a764$var$SkipIterator extends $b1fde1aac6b3a764$export$b7f78d762925efef {
    constructor(upstream, maxCount){
        super();
        this.upstream = upstream;
        this.maxCount = maxCount;
        // Local state that should not be clobbered by out-of-order execution.
        this.count = 0;
        this.lastRead = Promise.resolve({
            value: null,
            done: false
        });
    }
    summary() {
        return `${this.upstream.summary()} -> Skip`;
    }
    async next() {
        // This sets this.lastRead to a new Promise right away, as opposed to
        // saying `await this.lastRead; this.lastRead = this.serialNext();` which
        // would not work because this.nextRead would be updated only after the
        // promise resolves.
        this.lastRead = this.lastRead.then(()=>this.serialNext());
        return this.lastRead;
    }
    async serialNext() {
        // TODO(soergel): consider tradeoffs of reading in parallel, eg.
        // collecting next() promises in an Array and then waiting for
        // Promise.all() of those. Benefit: pseudo-parallel execution.  Drawback:
        // maybe delayed GC.
        while(this.count++ < this.maxCount){
            const skipped = await this.upstream.next();
            // short-circuit if upstream is already empty
            if (skipped.done) return skipped;
            $i64bB.dispose(skipped.value);
        }
        return this.upstream.next();
    }
}
class $b1fde1aac6b3a764$var$TakeIterator extends $b1fde1aac6b3a764$export$b7f78d762925efef {
    constructor(upstream, maxCount){
        super();
        this.upstream = upstream;
        this.maxCount = maxCount;
        this.count = 0;
    }
    summary() {
        return `${this.upstream.summary()} -> Take`;
    }
    async next() {
        if (this.count++ >= this.maxCount) return {
            value: null,
            done: true
        };
        return this.upstream.next();
    }
}
// Note this batch just groups items into row-wise element arrays.
// Rotating these to a column-wise representation happens only at the dataset
// level.
class $b1fde1aac6b3a764$var$RowMajorBatchIterator extends $b1fde1aac6b3a764$export$b7f78d762925efef {
    constructor(upstream, batchSize, enableSmallLastBatch = true){
        super();
        this.upstream = upstream;
        this.batchSize = batchSize;
        this.enableSmallLastBatch = enableSmallLastBatch;
        this.lastRead = Promise.resolve({
            value: null,
            done: false
        });
    }
    summary() {
        return `${this.upstream.summary()} -> RowMajorBatch`;
    }
    async next() {
        // This sets this.lastRead to a new Promise right away, as opposed to
        // saying `await this.lastRead; this.lastRead = this.serialNext();` which
        // would not work because this.nextRead would be updated only after the
        // promise resolves.
        this.lastRead = this.lastRead.then(()=>this.serialNext());
        return this.lastRead;
    }
    async serialNext() {
        const batch = [];
        while(batch.length < this.batchSize){
            const item = await this.upstream.next();
            if (item.done) {
                if (this.enableSmallLastBatch && batch.length > 0) return {
                    value: batch,
                    done: false
                };
                return {
                    value: null,
                    done: true
                };
            }
            batch.push(item.value);
        }
        return {
            value: batch,
            done: false
        };
    }
}
class $b1fde1aac6b3a764$var$FilterIterator extends $b1fde1aac6b3a764$export$b7f78d762925efef {
    constructor(upstream, predicate){
        super();
        this.upstream = upstream;
        this.predicate = predicate;
        this.lastRead = Promise.resolve({
            value: null,
            done: false
        });
    }
    summary() {
        return `${this.upstream.summary()} -> Filter`;
    }
    async next() {
        // This sets this.lastRead to a new Promise right away, as opposed to
        // saying `await this.lastRead; this.lastRead = this.serialNext();` which
        // would not work because this.nextRead would be updated only after the
        // promise resolves.
        this.lastRead = this.lastRead.then(()=>this.serialNext());
        return this.lastRead;
    }
    async serialNext() {
        while(true){
            const item = await this.upstream.next();
            if (item.done || this.predicate(item.value)) return item;
            $i64bB.dispose(item.value);
        }
    }
}
class $b1fde1aac6b3a764$var$MapIterator extends $b1fde1aac6b3a764$export$b7f78d762925efef {
    constructor(upstream, transform){
        super();
        this.upstream = upstream;
        this.transform = transform;
    }
    summary() {
        return `${this.upstream.summary()} -> Map`;
    }
    async next() {
        const item = await this.upstream.next();
        if (item.done) return {
            value: null,
            done: true
        };
        const inputTensors = $i64bB.tensor_util.getTensorsInContainer(item.value);
        // Careful: the transform may mutate the item in place.
        // That's why we have to remember the input Tensors above, and then
        // below dispose only those that were not passed through to the output.
        // Note too that the transform function is responsible for tidying
        // any intermediate Tensors.  Here we are concerned only about the
        // inputs.
        const mapped = this.transform(item.value);
        const outputTensors = $i64bB.tensor_util.getTensorsInContainer(mapped);
        // TODO(soergel) faster intersection
        // TODO(soergel) move to tf.disposeExcept(in, out)?
        for (const t of inputTensors)if (!$i64bB.tensor_util.isTensorInList(t, outputTensors)) t.dispose();
        return {
            value: mapped,
            done: false
        };
    }
}
class $b1fde1aac6b3a764$var$ErrorHandlingLazyIterator extends $b1fde1aac6b3a764$export$b7f78d762925efef {
    constructor(upstream, handler){
        super();
        this.upstream = upstream;
        this.handler = handler;
        this.count = 0;
        this.lastRead = Promise.resolve({
            value: null,
            done: false
        });
    }
    summary() {
        return `${this.upstream.summary()} -> handleErrors`;
    }
    async next() {
        // This sets this.lastRead to a new Promise right away, as opposed to
        // saying `await this.lastRead; this.lastRead = this.serialNext();` which
        // would not work because this.nextRead would be updated only after the
        // promise resolves.
        this.lastRead = this.lastRead.then(()=>this.serialNext());
        return this.lastRead;
    }
    async serialNext() {
        while(true)try {
            return await this.upstream.next();
        } catch (e) {
            if (!this.handler(e)) return {
                value: null,
                done: true
            };
        // If the handler returns true, loop and fetch the next upstream item.
        // If the upstream iterator throws an endless stream of errors, and if
        // the handler says to ignore them, then we loop forever here.  That is
        // the correct behavior-- it's up to the handler to decide when to stop.
        }
    }
}
class $b1fde1aac6b3a764$var$AsyncMapIterator extends $b1fde1aac6b3a764$export$b7f78d762925efef {
    constructor(upstream, transform){
        super();
        this.upstream = upstream;
        this.transform = transform;
    }
    summary() {
        return `${this.upstream.summary()} -> AsyncMap`;
    }
    async next() {
        const item = await this.upstream.next();
        if (item.done) return {
            value: null,
            done: true
        };
        const inputTensors = $i64bB.tensor_util.getTensorsInContainer(item.value);
        // Careful: the transform may mutate the item in place.
        // That's why we have to remember the input Tensors above, and then
        // below dispose only those that were not passed through to the output.
        // Note too that the transform function is responsible for tidying
        // any intermediate Tensors.  Here we are concerned only about the
        // inputs.
        const mapped = await this.transform(item.value);
        const outputTensors = $i64bB.tensor_util.getTensorsInContainer(mapped);
        // TODO(soergel) faster intersection
        // TODO(soergel) move to tf.disposeExcept(in, out)?
        for (const t of inputTensors)if (!$i64bB.tensor_util.isTensorInList(t, outputTensors)) t.dispose();
        return {
            value: mapped,
            done: false
        };
    }
}
class $b1fde1aac6b3a764$export$3c2cec00242a8bd8 extends $b1fde1aac6b3a764$export$b7f78d762925efef {
    constructor(){
        super();
        this.outputQueue = new (0, $5aaff1bb9f94472d$export$bd4eb95ce427db4d)();
        this.lastRead = Promise.resolve({
            value: null,
            done: false
        });
    }
    async next() {
        // This sets this.lastRead to a new Promise right away, as opposed to
        // saying `await this.lastRead; this.lastRead = this.serialNext();` which
        // would not work because this.nextRead would be updated only after the
        // promise resolves.
        this.lastRead = this.lastRead.then(()=>this.serialNext());
        return this.lastRead;
    }
    async serialNext() {
        // Fetch so that the queue contains at least one item if possible.
        // If the upstream source is exhausted, AND there are no items left in
        // the output queue, then this stream is also exhausted.
        while(this.outputQueue.length() === 0){
            // TODO(soergel): consider parallel reads.
            if (!await this.pump()) return {
                value: null,
                done: true
            };
        }
        return {
            value: this.outputQueue.shift(),
            done: false
        };
    }
}
class $b1fde1aac6b3a764$var$FlatmapIterator extends $b1fde1aac6b3a764$export$3c2cec00242a8bd8 {
    constructor(upstream, transform){
        super();
        this.upstream = upstream;
        this.transform = transform;
    }
    summary() {
        return `${this.upstream.summary()} -> Flatmap`;
    }
    async pump() {
        const item = await this.upstream.next();
        if (item.done) return false;
        const inputTensors = $i64bB.tensor_util.getTensorsInContainer(item.value);
        // Careful: the transform may mutate the item in place.
        // that's why we have to remember the input Tensors above, and then
        // below dispose only those that were not passed through to the output.
        // Note too that the transform function is responsible for tidying any
        // intermediate Tensors.  Here we are concerned only about the inputs.
        const mappedArray = this.transform(item.value);
        const outputTensors = $i64bB.tensor_util.getTensorsInContainer(mappedArray);
        this.outputQueue.pushAll(mappedArray);
        // TODO(soergel) faster intersection, and deduplicate outputTensors
        // TODO(soergel) move to tf.disposeExcept(in, out)?
        for (const t of inputTensors)if (!$i64bB.tensor_util.isTensorInList(t, outputTensors)) t.dispose();
        return true;
    }
}
class $b1fde1aac6b3a764$export$22a7cbb11e3b9068 extends $b1fde1aac6b3a764$export$b7f78d762925efef {
    constructor(iterators, baseErrorHandler){
        super();
        this.baseErrorHandler = baseErrorHandler;
        // Strict Promise execution order:
        // a next() call may not even begin until the previous one completes.
        this.lastRead = null;
        // Local state that should not be clobbered by out-of-order execution.
        this.iterator = null;
        this.moreIterators = iterators;
    }
    summary() {
        const upstreamSummaries = 'TODO: fill in upstream of chained summaries';
        return `${upstreamSummaries} -> Chained`;
    }
    async next() {
        this.lastRead = this.readFromChain(this.lastRead);
        return this.lastRead;
    }
    async readFromChain(lastRead) {
        // Must await on the previous read since the previous read may have advanced
        // the stream of streams, from which we need to read.
        // This is unfortunate since we can't parallelize reads. Which means
        // prefetching of chained streams is a no-op.
        // One solution is to prefetch immediately upstream of this.
        await lastRead;
        if (this.iterator == null) {
            const iteratorResult = await this.moreIterators.next();
            if (iteratorResult.done) // No more streams to stream from.
            return {
                value: null,
                done: true
            };
            this.iterator = iteratorResult.value;
            if (this.baseErrorHandler != null) this.iterator = this.iterator.handleErrors(this.baseErrorHandler);
        }
        const itemResult = await this.iterator.next();
        if (itemResult.done) {
            this.iterator = null;
            return this.readFromChain(lastRead);
        }
        return itemResult;
    }
}
var $b1fde1aac6b3a764$export$4b13032c4dd08391;
(function(ZipMismatchMode) {
    ZipMismatchMode[ZipMismatchMode["FAIL"] = 0] = "FAIL";
    ZipMismatchMode[ZipMismatchMode["SHORTEST"] = 1] = "SHORTEST";
    ZipMismatchMode[ZipMismatchMode["LONGEST"] = 2] = "LONGEST"; // use nulls for exhausted streams; use up the longest stream.
})($b1fde1aac6b3a764$export$4b13032c4dd08391 || ($b1fde1aac6b3a764$export$4b13032c4dd08391 = {}));
/**
 * Provides a `LazyIterator` that zips together an array, dict, or nested
 * structure of `LazyIterator`s (and perhaps additional constants).
 *
 * The underlying streams must provide elements in a consistent order such
 * that they correspond.
 *
 * Typically, the underlying streams should have the same number of
 * elements. If they do not, the behavior is determined by the
 * `mismatchMode` argument.
 *
 * The nested structure of the `iterators` argument determines the
 * structure of elements in the resulting iterator.
 *
 * Doing this in a concurrency-safe way requires some trickery.  In
 * particular, we want this stream to return the elements from the
 * underlying streams in the correct order according to when next() was
 * called, even if the resulting Promises resolve in a different order.
 *
 * @param iterators: An array or object containing LazyIterators at the
 * leaves.
 * @param mismatchMode: Determines what to do when one underlying iterator
 * is exhausted before the others.  `ZipMismatchMode.FAIL` (the default)
 * causes an error to be thrown in this case.  `ZipMismatchMode.SHORTEST`
 * causes the zipped iterator to terminate with the furst underlying
 * streams, so elements remaining on the longer streams are ignored.
 * `ZipMismatchMode.LONGEST` causes the zipped stream to continue, filling
 * in nulls for the exhausted streams, until all streams are exhausted.
 */ class $b1fde1aac6b3a764$var$ZipIterator extends $b1fde1aac6b3a764$export$b7f78d762925efef {
    constructor(iterators, mismatchMode = $b1fde1aac6b3a764$export$4b13032c4dd08391.FAIL){
        super();
        this.iterators = iterators;
        this.mismatchMode = mismatchMode;
        this.count = 0;
        this.currentPromise = null;
    }
    summary() {
        const upstreamSummaries = 'TODO: fill in upstream of zip summaries';
        return `{${upstreamSummaries}} -> Zip`;
    }
    async nextState(afterState) {
        // This chaining ensures that the underlying next() are not even called
        // before the previous ones have resolved.
        await afterState;
        // Collect underlying iterator "done" signals as a side effect in
        // getNext()
        let numIterators = 0;
        let iteratorsDone = 0;
        function getNext(container) {
            if (container instanceof $b1fde1aac6b3a764$export$b7f78d762925efef) {
                const result = container.next();
                return {
                    value: result.then((x)=>{
                        numIterators++;
                        if (x.done) iteratorsDone++;
                        return x.value;
                    }),
                    recurse: false
                };
            } else return {
                value: null,
                recurse: true
            };
        }
        const mapped = await (0, $2432561787a47ba4$export$20eea0c38ad5b6db)(this.iterators, getNext);
        if (numIterators === iteratorsDone) // The streams have all ended.
        return {
            value: null,
            done: true
        };
        if (iteratorsDone > 0) switch(this.mismatchMode){
            case $b1fde1aac6b3a764$export$4b13032c4dd08391.FAIL:
                throw new Error('Zipped streams should have the same length. ' + `Mismatched at element ${this.count}.`);
            case $b1fde1aac6b3a764$export$4b13032c4dd08391.SHORTEST:
                return {
                    value: null,
                    done: true
                };
            case $b1fde1aac6b3a764$export$4b13032c4dd08391.LONGEST:
            default:
        }
        this.count++;
        return {
            value: mapped,
            done: false
        };
    }
    async next() {
        this.currentPromise = this.nextState(this.currentPromise);
        return this.currentPromise;
    }
}
class $b1fde1aac6b3a764$export$7126304418df8697 extends $b1fde1aac6b3a764$export$b7f78d762925efef {
    constructor(upstream, bufferSize){
        super();
        this.upstream = upstream;
        this.bufferSize = bufferSize;
        this.buffer = new (0, $36c94bc6b99a24ce$export$575ef0eeec6e42f5)(bufferSize);
    }
    summary() {
        return `${this.upstream.summary()} -> Prefetch`;
    }
    /**
     * Refill the prefetch buffer.  Returns only after the buffer is full, or
     * the upstream source is exhausted.
     */ refill() {
        while(!this.buffer.isFull()){
            const v = this.upstream.next();
            this.buffer.push(v);
        }
    }
    next() {
        this.refill();
        // This shift will never throw an error because the buffer is always
        // full after a refill. If the stream is exhausted, the buffer will be
        // full of Promises that will resolve to the end-of-stream signal.
        return this.buffer.shift();
    }
}
class $b1fde1aac6b3a764$export$50d642f401310a09 extends $b1fde1aac6b3a764$export$7126304418df8697 {
    constructor(upstream, windowSize, seed){
        super(upstream, windowSize);
        this.upstream = upstream;
        this.windowSize = windowSize;
        // Local state that should not be clobbered by out-of-order execution.
        this.upstreamExhausted = false;
        this.random = $3mnBW.alea(seed || $i64bB.util.now().toString());
        this.lastRead = Promise.resolve({
            value: null,
            done: false
        });
    }
    async next() {
        // This sets this.lastRead to a new Promise right away, as opposed to
        // saying `await this.lastRead; this.lastRead = this.serialNext();` which
        // would not work because this.nextRead would be updated only after the
        // promise resolves.
        this.lastRead = this.lastRead.then(()=>this.serialNext());
        return this.lastRead;
    }
    randomInt(max) {
        return Math.floor(this.random() * max);
    }
    chooseIndex() {
        return this.randomInt(this.buffer.length());
    }
    async serialNext() {
        // TODO(soergel): consider performance
        if (!this.upstreamExhausted) this.refill();
        while(!this.buffer.isEmpty()){
            const chosenIndex = this.chooseIndex();
            const result = await this.buffer.shuffleExcise(chosenIndex);
            if (result.done) this.upstreamExhausted = true;
            else {
                this.refill();
                return result;
            }
        }
        return {
            value: null,
            done: true
        };
    }
}



// TODO(soergel): consider vectorized operations within the pipeline.
/**
 * Represents a potentially large list of independent data elements (typically
 * 'samples' or 'examples').
 *
 * A 'data example' may be a primitive, an array, a map from string keys to
 * values, or any nested structure of these.
 *
 * A `Dataset` represents an ordered collection of elements, together with a
 * chain of transformations to be performed on those elements. Each
 * transformation is a method of `Dataset` that returns another `Dataset`, so
 * these may be chained, e.g.
 * `const processedDataset = rawDataset.filter(...).map(...).batch(...)`.
 *
 * Data loading and transformation is done in a lazy, streaming fashion.  The
 * dataset may be iterated over multiple times; each iteration starts the data
 * loading anew and recapitulates the transformations.
 *
 * A `Dataset` is typically processed as a stream of unbatched examples -- i.e.,
 * its transformations are applied one example at a time. Batching produces a
 * new `Dataset` where each element is a batch. Batching should usually come
 * last in a pipeline, because data transformations are easier to express on a
 * per-example basis than on a per-batch basis.
 *
 * The following code examples are calling `await dataset.forEachAsync(...)` to
 * iterate once over the entire dataset in order to print out the data.
 *
 * @doc {heading: 'Data', subheading: 'Classes', namespace: 'data'}
 */ class $088f40d26e8580f1$export$827063163a0a89f5 {
    constructor(){
        this.size = null;
    }
    // TODO(soergel): Make Datasets report whether repeated iterator() calls
    // produce the same result (e.g., reading from a file) or different results
    // (e.g., from the webcam).  Currently we don't make this distinction but it
    // could be important for the user to know.
    // abstract isDeterministic(): boolean;
    /**
     * Groups elements into batches.
     *
     * It is assumed that each of the incoming dataset elements has the same
     * structure -- i.e. the same set of keys at each location in an object
     * hierarchy.  For each key, the resulting `Dataset` provides a batched
     * element collecting all of the incoming values for that key.
     *
     *  * Incoming primitives are grouped into a 1-D Tensor.
     *  * Incoming Tensors are grouped into a new Tensor where the 0th axis is
     *    the batch dimension.
     *  * Incoming arrays are converted to Tensor and then batched.
     *  * A nested array is interpreted as an n-D Tensor, so the batched result
     *    has n+1 dimensions.
     *  * An array that cannot be converted to Tensor produces an error.
     *
     * If an array should not be batched as a unit, it should first be converted
     * to an object with integer keys.
     *
     * Here are a few examples:
     *
     * Batch a dataset of numbers:
     * ```js
     * const a = tf.data.array([1, 2, 3, 4, 5, 6, 7, 8]).batch(4);
     * await a.forEachAsync(e => e.print());
     * ```
     *
     * Batch a dataset of arrays:
     * ```js
     * const b = tf.data.array([[1], [2], [3], [4], [5], [6], [7], [8]]).batch(4);
     * await b.forEachAsync(e => e.print());
     * ```
     *
     * Batch a dataset of objects:
     * ```js
     * const c = tf.data.array([{a: 1, b: 11}, {a: 2, b: 12}, {a: 3, b: 13},
     *   {a: 4, b: 14}, {a: 5, b: 15}, {a: 6, b: 16}, {a: 7, b: 17},
     *   {a: 8, b: 18}]).batch(4);
     * await c.forEachAsync(e => {
     *   console.log('{');
     *   for(var key in e) {
     *     console.log(key+':');
     *     e[key].print();
     *   }
     *   console.log('}');
     * })
     * ```
     *
     * @param batchSize The number of elements desired per batch.
     * @param smallLastBatch Whether to emit the final batch when it has fewer
     *   than batchSize elements. Default true.
     * @returns A `Dataset`, from which a stream of batches can be obtained.
     *
     * @doc {heading: 'Data', subheading: 'Classes'}
     */ batch(batchSize, smallLastBatch = true) {
        const base = this;
        $i64bB.util.assert(batchSize > 0, ()=>`batchSize needs to be positive, but it is
      ${batchSize}`);
        let size;
        if (this.size === Infinity || this.size == null) // If the size of this dataset is infinity or null, the new size keeps the
        // same.
        size = this.size;
        else if (smallLastBatch) // If the size of this dataset is known and include small last batch, the
        // new size is full batch count plus last batch.
        size = Math.ceil(this.size / batchSize);
        else // If the size of this dataset is known and not include small last batch,
        // the new size is full batch count.
        size = Math.floor(this.size / batchSize);
        return $088f40d26e8580f1$export$3a70158aa38bbd76(async ()=>{
            return (await base.iterator()).columnMajorBatch(batchSize, smallLastBatch, $088f40d26e8580f1$var$deepBatchConcat);
        }, size);
    }
    /**
     * Concatenates this `Dataset` with another.
     *
     * ```js
     * const a = tf.data.array([1, 2, 3]);
     * const b = tf.data.array([4, 5, 6]);
     * const c = a.concatenate(b);
     * await c.forEachAsync(e => console.log(e));
     * ```
     *
     * @param dataset A `Dataset` to be concatenated onto this one.
     * @returns A `Dataset`.
     *
     * @doc {heading: 'Data', subheading: 'Classes'}
     */ concatenate(dataset) {
        const base = this;
        let size;
        if (this.size === Infinity || dataset.size === Infinity) // If the size of any of these two dataset is infinity, new size is
        // infinity.
        size = Infinity;
        else if (this.size != null && dataset.size != null) // If the size of both datasets are known and not infinity, new size is
        // sum the size of these two datasets.
        size = this.size + dataset.size;
        else // If neither of these two datasets has infinite size and any of these two
        // datasets' size is null, the new size is null.
        size = null;
        return $088f40d26e8580f1$export$3a70158aa38bbd76(async ()=>(await base.iterator()).concatenate(await dataset.iterator()), size);
    }
    /**
     * Filters this dataset according to `predicate`.
     *
     * ```js
     * const a = tf.data.array([1, 2, 3, 4, 5, 6, 7, 8, 9, 10])
     *   .filter(x => x%2 === 0);
     * await a.forEachAsync(e => console.log(e));
     * ```
     *
     * @param predicate A function mapping a dataset element to a boolean or a
     * `Promise` for one.
     *
     * @returns A `Dataset` of elements for which the predicate was true.
     *
     * @doc {heading: 'Data', subheading: 'Classes'}
     */ filter(predicate) {
        const base = this;
        let size;
        if (this.size === Infinity) // If the size of this dataset is infinity, new size is infinity
        size = Infinity;
        else // If this dataset has limited elements, new size is null because it might
        // exhausted randomly.
        size = null;
        return $088f40d26e8580f1$export$3a70158aa38bbd76(async ()=>{
            return (await base.iterator()).filter((x)=>$i64bB.tidy(()=>predicate(x)));
        }, size);
    }
    /**
     * Apply a function to every element of the dataset.
     *
     * After the function is applied to a dataset element, any Tensors contained
     * within that element are disposed.
     *
     * ```js
     * const a = tf.data.array([1, 2, 3]);
     * await a.forEachAsync(e => console.log(e));
     * ```
     *
     * @param f A function to apply to each dataset element.
     * @returns A `Promise` that resolves after all elements have been processed.
     *
     * @doc {heading: 'Data', subheading: 'Classes'}
     */ async forEachAsync(f) {
        return (await this.iterator()).forEachAsync(f);
    }
    /**
     * Maps this dataset through a 1-to-1 transform.
     *
     * ```js
     * const a = tf.data.array([1, 2, 3]).map(x => x*x);
     * await a.forEachAsync(e => console.log(e));
     * ```
     *
     * @param transform A function mapping a dataset element to a transformed
     *   dataset element.
     *
     * @returns A `Dataset` of transformed elements.
     *
     * @doc {heading: 'Data', subheading: 'Classes'}
     */ map(transform) {
        const base = this;
        return $088f40d26e8580f1$export$3a70158aa38bbd76(async ()=>{
            return (await base.iterator()).map((x)=>$i64bB.tidy(()=>transform(x)));
        }, this.size);
    }
    /**
     * Maps this dataset through an async 1-to-1 transform.
     *
     * ```js
     * const a =
     *  tf.data.array([1, 2, 3]).mapAsync(x => new Promise(function(resolve){
     *    setTimeout(() => {
     *      resolve(x * x);
     *    }, Math.random()*1000 + 500);
     *  }));
     * console.log(await a.toArray());
     * ```
     *
     * @param transform A function mapping a dataset element to a `Promise` for a
     *   transformed dataset element.  This transform is responsible for disposing
     *   any intermediate `Tensor`s, i.e. by wrapping its computation in
     *   `tf.tidy()`; that cannot be automated here (as it is in the synchronous
     *   `map()` case).
     *
     * @returns A `Dataset` of transformed elements.
     *
     * @doc {heading: 'Data', subheading: 'Classes'}
     */ mapAsync(transform) {
        const base = this;
        return $088f40d26e8580f1$export$3a70158aa38bbd76(async ()=>{
            return (await base.iterator()).mapAsync(transform);
        }, this.size);
    }
    /**
     *  Creates a `Dataset` that prefetches elements from this dataset.
     *
     * @param bufferSize: An integer specifying the number of elements to be
     *   prefetched.
     * @returns A `Dataset`.
     *
     * @doc {heading: 'Data', subheading: 'Classes'}
     */ prefetch(bufferSize) {
        if (bufferSize == null) throw new RangeError('`Dataset.prefetch()` requires bufferSize to be specified.');
        const base = this;
        return $088f40d26e8580f1$export$3a70158aa38bbd76(async ()=>(await base.iterator()).prefetch(bufferSize), this.size);
    }
    /**
     * Repeats this dataset `count` times.
     *
     * NOTE: If this dataset is a function of global state (e.g. a random number
     * generator), then different repetitions may produce different elements.
     *
     * ```js
     * const a = tf.data.array([1, 2, 3]).repeat(3);
     * await a.forEachAsync(e => console.log(e));
     * ```
     *
     * @param count: (Optional) An integer, representing the number of times
     *   the dataset should be repeated. The default behavior (if `count` is
     *   `undefined` or negative) is for the dataset be repeated indefinitely.
     * @returns A `Dataset`.
     *
     * @doc {heading: 'Data', subheading: 'Classes'}
     */ repeat(count) {
        const base = this;
        let size;
        if (this.size != null && count > 0) // If this dataset has size and count is positive, new size is current
        // size multiply count. This also covers the case that current size is
        // infinity.
        size = this.size * count;
        else if (count === 0) // If count is 0, new size is 0.
        size = 0;
        else if (this.size != null && (count === undefined || count < 0)) // If this dataset has size and count is undefined or negative, the
        // dataset will be repeated indefinitely and new size is infinity.
        size = Infinity;
        else // If the size of this dataset is null, the new dataset's size is null.
        size = null;
        return $088f40d26e8580f1$export$3a70158aa38bbd76(async ()=>{
            const iteratorIterator = (0, $b1fde1aac6b3a764$export$392feaf09f7ef035)(async ()=>({
                    value: await base.iterator(),
                    done: false
                }));
            return (0, $b1fde1aac6b3a764$export$a9a63cf863a3bed5)(iteratorIterator.take(count));
        }, size);
    }
    /**
     * Creates a `Dataset` that skips `count` initial elements from this dataset.
     *
     * ```js
     * const a = tf.data.array([1, 2, 3, 4, 5, 6]).skip(3);
     * await a.forEachAsync(e => console.log(e));
     * ```
     *
     * @param count: The number of elements of this dataset that should be skipped
     *   to form the new dataset.  If `count` is greater than the size of this
     *   dataset, the new dataset will contain no elements.  If `count`
     *   is `undefined` or negative, skips the entire dataset.
     *
     * @returns A `Dataset`.
     *
     * @doc {heading: 'Data', subheading: 'Classes'}
     */ skip(count) {
        const base = this;
        let size;
        if (this.size != null && count >= 0 && this.size >= count) // If the size of this dataset is greater than count, the new dataset's
        // size is current size minus skipped size.This also covers the case that
        // current size is infinity.
        size = this.size - count;
        else if (this.size != null && (this.size < count || count === undefined || count < 0)) // If the size of this dataset is smaller than count, or count is
        // undefined or negative, skips the entire dataset and the new size is 0.
        size = 0;
        else // If the size of this dataset is null, the new dataset's size is null.
        size = null;
        return $088f40d26e8580f1$export$3a70158aa38bbd76(async ()=>(await base.iterator()).skip(count), size);
    }
    /**
     * Pseudorandomly shuffles the elements of this dataset. This is done in a
     * streaming manner, by sampling from a given number of prefetched elements.
     *
     * ```js
     * const a = tf.data.array([1, 2, 3, 4, 5, 6]).shuffle(3);
     * await a.forEachAsync(e => console.log(e));
     * ```
     *
     * @param bufferSize: An integer specifying the number of elements from this
     *   dataset from which the new dataset will sample.
     * @param seed: (Optional) An integer specifying the random seed that will
     *   be used to create the distribution.
     * @param reshuffleEachIteration: (Optional) A boolean, which if true
     *   indicates that the dataset should be pseudorandomly reshuffled each time
     *   it is iterated over. If false, elements will be returned in the same
     *   shuffled order on each iteration. (Defaults to `true`.)
     * @returns A `Dataset`.
     *
     * @doc {heading: 'Data', subheading: 'Classes'}
     */ shuffle(bufferSize, seed, reshuffleEachIteration = true) {
        if (bufferSize == null || bufferSize < 0) {
            if (this.size == null) throw new RangeError('`Dataset.shuffle()` requires bufferSize to be specified.');
            else throw new RangeError("`Dataset.shuffle()` requires bufferSize to be specified.  If your data fits in main memory (for regular JS objects), and/or GPU memory (for `tf.Tensor`s), consider setting " + `bufferSize to the dataset size (${this.size} elements)`);
        }
        const base = this;
        const random = $3mnBW.alea(seed || $i64bB.util.now().toString());
        return $088f40d26e8580f1$export$3a70158aa38bbd76(async ()=>{
            let seed2 = random.int32();
            if (reshuffleEachIteration) seed2 += random.int32();
            return (await base.iterator()).shuffle(bufferSize, seed2.toString());
        }, this.size);
    }
    /**
     * Creates a `Dataset` with at most `count` initial elements from this
     * dataset.
     *
     * ```js
     * const a = tf.data.array([1, 2, 3, 4, 5, 6]).take(3);
     * await a.forEachAsync(e => console.log(e));
     * ```
     *
     * @param count: The number of elements of this dataset that should be taken
     *   to form the new dataset.  If `count` is `undefined` or negative, or if
     *   `count` is greater than the size of this dataset, the new dataset will
     *   contain all elements of this dataset.
     * @returns A `Dataset`.
     *
     * @doc {heading: 'Data', subheading: 'Classes'}
     */ take(count) {
        const base = this;
        let size;
        if (this.size != null && this.size > count) // If the size of this dataset is greater than count, the new dataset's
        // size is count.
        size = count;
        else if (this.size != null && this.size <= count) // If the size of this dataset is equal or smaller than count, the new
        // dataset's size is the size of this dataset.
        size = this.size;
        else // If the size of this dataset is null, the new dataset's size is null.
        size = null;
        return $088f40d26e8580f1$export$3a70158aa38bbd76(async ()=>(await base.iterator()).take(count), size);
    }
    /**
     * Collect all elements of this dataset into an array.
     *
     * Obviously this will succeed only for small datasets that fit in memory.
     * Useful for testing and generally should be avoided if possible.
     *
     * ```js
     * const a = tf.data.array([1, 2, 3, 4, 5, 6]);
     * console.log(await a.toArray());
     * ```
     *
     * @returns A Promise for an array of elements, which will resolve
     *   when a new stream has been obtained and fully consumed.
     *
     * @doc {heading: 'Data', subheading: 'Classes'}
     */ async toArray() {
        if (this.size === Infinity) throw new Error('Can not convert infinite data stream to array.');
        return (await this.iterator()).toArray();
    }
    /**
     * Collect all elements of this dataset into an array with prefetching 100
     * elements. This is useful for testing, because the prefetch changes the
     * order in which the Promises are resolved along the processing pipeline.
     * This may help expose bugs where results are dependent on the order of
     * Promise resolution rather than on the logical order of the stream (i.e.,
     * due to hidden mutable state).
     *
     * @returns A Promise for an array of elements, which will resolve
     *   when a new stream has been obtained and fully consumed.
     */ async toArrayForTest() {
        if (this.size === Infinity) throw new Error('Can not convert infinite data stream to array.');
        return (await this.iterator()).toArrayForTest();
    }
}
// TODO(soergel): deep sharded shuffle, where supported
$088f40d26e8580f1$export$827063163a0a89f5.MAX_BUFFER_SIZE = 10000;
function $088f40d26e8580f1$export$3a70158aa38bbd76(iteratorFn, size = null) {
    return new class extends $088f40d26e8580f1$export$827063163a0a89f5 {
        constructor(){
            super(...arguments);
            this.size = size;
        }
        /*
         * Provide a new stream of elements.  Note this will also start new streams
         * from any underlying `Dataset`s.
         */ async iterator() {
            return iteratorFn();
        }
    }();
}
function $088f40d26e8580f1$export$2f23118c22fb2630(items) {
    return $088f40d26e8580f1$export$3a70158aa38bbd76(async ()=>(0, $b1fde1aac6b3a764$export$313b11d04150405f)(items), items.length);
}
function $088f40d26e8580f1$export$8901015135f2fb22(datasets) {
    // manually type-check the argument for JS users
    if (!(0, $2432561787a47ba4$export$9652023d9040757)(datasets)) throw new Error('The argument to zip() must be an object or array.');
    let size;
    if (Array.isArray(datasets)) for(let i = 0; i < datasets.length; i++)size = size == null ? datasets[i].size : Math.min(size, datasets[i].size);
    else if (datasets instanceof Object) for(const ds in datasets)size = size == null ? datasets[ds].size : Math.min(size, datasets[ds].size);
    return $088f40d26e8580f1$export$3a70158aa38bbd76(async ()=>{
        const streams = await (0, $2432561787a47ba4$export$20eea0c38ad5b6db)(datasets, (d)=>{
            if (d instanceof $088f40d26e8580f1$export$827063163a0a89f5) return {
                value: d.iterator(),
                recurse: false
            };
            else if ((0, $2432561787a47ba4$export$9652023d9040757)(d)) return {
                value: null,
                recurse: true
            };
            else throw new Error("Leaves of the structure passed to zip() must be Datasets, not primitives.");
        });
        return (0, $b1fde1aac6b3a764$export$5ecdf828f976b66e)(streams, (0, $b1fde1aac6b3a764$export$4b13032c4dd08391).SHORTEST);
    }, size);
}
/**
 * A zip function for use with deepZip, passed via the columnMajorBatch call.
 *
 * Accepts an array of identically-structured nested elements and either batches
 * them (if they are primitives, numeric arrays, or Tensors) or requests
 * recursion (if not).
 */ // tslint:disable-next-line:no-any
function $088f40d26e8580f1$var$deepBatchConcat(rows) {
    if (rows === null) return null;
    // use the first item to decide whether to recurse or batch here.
    const exampleRow = rows[0];
    if ((0, $2432561787a47ba4$export$2714d9e1645b25ab)(exampleRow)) {
        // rows is an array of primitives, Tensors, or arrays.  Batch them.
        const value = $088f40d26e8580f1$var$batchConcat(rows);
        return {
            value: value,
            recurse: false
        };
    }
    // the example row is an object, so recurse into it.
    return {
        value: null,
        recurse: true
    };
}
/**
 * Assembles a list of same-shaped numbers, number arrays, or Tensors
 * into a single new Tensor where axis 0 is the batch dimension.
 */ function $088f40d26e8580f1$var$batchConcat(arrays) {
    if (arrays.length === 0) // We can't return an empty Tensor because we don't know the element shape.
    throw new Error('Can\'t make a batch of zero elements.');
    if (arrays[0] instanceof $i64bB.Tensor) // Input is an array of Tensors
    return $i64bB.stack(arrays);
    else // Input is a possibly-nested array of numbers.
    return $i64bB.tensor(arrays);
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ 
class $fde1ad8560dfb230$export$e3ec11e2ed15d2cb extends (0, $088f40d26e8580f1$export$827063163a0a89f5) {
    /**
     * Create a `TextLineDataset`.
     *
     * @param input A `DataSource` providing a chunked, UTF8-encoded byte stream.
     */ constructor(input){
        super();
        this.input = input;
    }
    async iterator() {
        const inputIterator = await this.input.iterator();
        const utf8Iterator = inputIterator.decodeUTF8();
        const lineIterator = utf8Iterator.split('\n').map((line)=>{
            // Windows/DOS format text file has extra line breaker at the end of line.
            if (line.endsWith('\r')) line = line.slice(0, -1);
            return line;
        });
        return lineIterator;
    }
}


const $2db741498231248f$var$CODE_QUOTE = '"';
const $2db741498231248f$var$STATE_OUT = Symbol('out');
const $2db741498231248f$var$STATE_FIELD = Symbol('field');
const $2db741498231248f$var$STATE_QUOTE = Symbol('quote');
const $2db741498231248f$var$STATE_QUOTE_AFTER_QUOTE = Symbol('quoteafterquote');
const $2db741498231248f$var$STATE_WITHIN_QUOTE_IN_QUOTE = Symbol('quoteinquote');
class $2db741498231248f$export$1e441948ffa5f20a extends (0, $088f40d26e8580f1$export$827063163a0a89f5) {
    /**
     * Returns column names of the csv dataset. If `configuredColumnsOnly` is
     * true, return column names in `columnConfigs`. If `configuredColumnsOnly` is
     * false and `columnNames` is provided, `columnNames`. If
     * `configuredColumnsOnly` is false and `columnNames` is not provided, return
     * all column names parsed from the csv file. For example usage please go to
     * `tf.data.csv`.
     *
     * @doc {heading: 'Data', subheading: 'Classes'}
     */ async columnNames() {
        if (!this.columnNamesValidated) await this.setColumnNames();
        return this.configuredColumnsOnly ? Object.keys(this.columnConfigs) : this.fullColumnNames;
    }
    /* 1) If `columnNames` is provided as string[], use this string[] as output
     * keys in corresponding order. The length must match the number of inferred
     * columns if `hasHeader` is true .
     * 2) If `columnNames` is not provided, parse header line as `columnNames` if
     * hasHeader is true. If `hasHeader` is false, throw an error.
     * 3) If `columnConfigs` is provided, all the keys in `columnConfigs` must
     * exist in parsed `columnNames`.
     */ async setColumnNames() {
        const columnNamesFromFile = await this.maybeReadHeaderLine();
        if (!this.fullColumnNames && !columnNamesFromFile) // Throw an error if columnNames is not provided and no header line.
        throw new Error('Column names must be provided if there is no header line.');
        else if (this.fullColumnNames && columnNamesFromFile) // Check provided columnNames match header line.
        (0, $i64bB.util).assert(columnNamesFromFile.length === this.fullColumnNames.length, ()=>'The length of provided columnNames (' + this.fullColumnNames.length.toString() + ') does not match the length of the header line read from ' + 'file (' + columnNamesFromFile.length.toString() + ').');
        if (!this.fullColumnNames) this.fullColumnNames = columnNamesFromFile;
        // Check if there are duplicate column names.
        const counts = this.fullColumnNames.reduce((countAcc, name)=>{
            countAcc[name] = countAcc[name] + 1 || 1;
            return countAcc;
        }, {});
        const duplicateNames = Object.keys(counts).filter((name)=>counts[name] > 1);
        (0, $i64bB.util).assert(duplicateNames.length === 0, ()=>'Duplicate column names found: ' + duplicateNames.toString());
        // Check if keys in columnConfigs match columnNames.
        if (this.columnConfigs) for (const key of Object.keys(this.columnConfigs)){
            const index = this.fullColumnNames.indexOf(key);
            if (index === -1) throw new Error('The key "' + key + '" provided in columnConfigs does not match any of the column ' + 'names (' + this.fullColumnNames.toString() + ').');
        }
        this.columnNamesValidated = true;
    }
    async maybeReadHeaderLine() {
        if (this.hasHeader) {
            const iter = await this.base.iterator();
            const firstElement = await iter.next();
            if (firstElement.done) throw new Error('No data was found for CSV parsing.');
            const firstLine = firstElement.value;
            const headers = this.parseRow(firstLine, false);
            return headers;
        } else return null;
    }
    /**
     * Create a `CSVDataset`.
     *
     * @param input A `DataSource` providing a chunked, UTF8-encoded byte stream.
     * @param csvConfig (Optional) A CSVConfig object that contains configurations
     *     of reading and decoding from CSV file(s).
     *
     *     hasHeader: (Optional) A boolean value that indicates whether the first
     *     row of provided CSV file is a header line with column names, and should
     *     not be included in the data. Defaults to `true`.
     *
     *     columnNames: (Optional) A list of strings that corresponds to
     *     the CSV column names, in order. If provided, it ignores the column
     *     names inferred from the header row. If not provided, infers the column
     *     names from the first row of the records. If hasHeader is false and
     *     columnNames is not provided, this method throws an error.
     *
     *     columnConfigs: (Optional) A dictionary whose key is column names, value
     *     is an object stating if this column is required, column's data type,
     *     default value, and if this column is label. If provided, keys must
     *     correspond to names provided in columnNames or inferred from the file
     *     header lines. If isLabel is true any column, returns an array of two
     *     items: the first item is a dict of features key/value pairs, the second
     *     item is a dict of labels key/value pairs. If no feature is marked as
     *     label, returns a dict of features only.
     *
     *     configuredColumnsOnly (Optional) If true, only columns provided in
     *     columnConfigs will be parsed and provided during iteration.
     *
     *     delimiter (Optional) The string used to parse each line of the input
     *     file. Defaults to `,`.
     */ constructor(input, csvConfig){
        super();
        this.input = input;
        this.hasHeader = true;
        this.fullColumnNames = null;
        this.columnNamesValidated = false;
        this.columnConfigs = null;
        this.configuredColumnsOnly = false;
        this.delimiter = ',';
        this.delimWhitespace = false;
        this.base = new (0, $fde1ad8560dfb230$export$e3ec11e2ed15d2cb)(input);
        if (!csvConfig) csvConfig = {};
        this.hasHeader = csvConfig.hasHeader === false ? false : true;
        this.fullColumnNames = csvConfig.columnNames;
        this.columnConfigs = csvConfig.columnConfigs;
        this.configuredColumnsOnly = csvConfig.configuredColumnsOnly;
        if (csvConfig.delimWhitespace) {
            (0, $i64bB.util).assert(csvConfig.delimiter == null, ()=>'Delimiter should not be provided when delimWhitespace is true.');
            this.delimWhitespace = true;
            this.delimiter = ' ';
        } else this.delimiter = csvConfig.delimiter ? csvConfig.delimiter : ',';
    }
    async iterator() {
        if (!this.columnNamesValidated) await this.setColumnNames();
        let lines = await this.base.iterator();
        if (this.hasHeader) // We previously read the first line to get the columnNames.
        // Now that we're providing data, skip it.
        lines = lines.skip(1);
        return lines.map((x)=>this.makeDataElement(x));
    }
    makeDataElement(line) {
        const values = this.parseRow(line);
        const features = {};
        const labels = {};
        for(let i = 0; i < this.fullColumnNames.length; i++){
            const key = this.fullColumnNames[i];
            const config = this.columnConfigs ? this.columnConfigs[key] : null;
            if (this.configuredColumnsOnly && !config) continue;
            else {
                const value = values[i];
                let parsedValue = null;
                if (value === '') {
                    // If default value is provided, use it. If default value is not
                    // provided, set as undefined.
                    if (config && config.default !== undefined) parsedValue = config.default;
                    else if (config && (config.required || config.isLabel)) throw new Error(`Required column ${key} is empty in this line: ${line}`);
                    else parsedValue = undefined;
                } else {
                    // A value is present, so parse it based on type
                    const valueAsNum = Number(value);
                    if (isNaN(valueAsNum)) {
                        // The value is a string and this column is declared as boolean
                        // in config, parse it as boolean.
                        if (config && config.dtype === 'bool') parsedValue = this.getBoolean(value);
                        else // Set value as string
                        parsedValue = value;
                    } else if (!config || !config.dtype) // If this value is a number and no type config is provided, return
                    // it as number.
                    parsedValue = valueAsNum;
                    else // If this value is a number and data type is provided, parse it
                    // according to provided data type.
                    switch(config.dtype){
                        case 'float32':
                            parsedValue = valueAsNum;
                            break;
                        case 'int32':
                            parsedValue = Math.floor(valueAsNum);
                            break;
                        case 'bool':
                            parsedValue = this.getBoolean(value);
                            break;
                        default:
                            parsedValue = valueAsNum;
                    }
                }
                // Check if this column is label.
                config && config.isLabel ? labels[key] = parsedValue : features[key] = parsedValue;
            }
        }
        // If label exists, return an object of features and labels as {xs:features,
        // ys:labels}, otherwise return features only.
        if (Object.keys(labels).length === 0) return features;
        else return {
            xs: features,
            ys: labels
        };
    }
    getBoolean(value) {
        if (value === '1' || value.toLowerCase() === 'true') return 1;
        else return 0;
    }
    // adapted from https://beta.observablehq.com/@mbostock/streaming-csv
    parseRow(line, validateElementCount = true) {
        const result = [];
        let readOffset = 0;
        const readLength = line.length;
        let currentState = $2db741498231248f$var$STATE_OUT;
        // Goes through the line to parse quote.
        for(let i = 0; i < readLength; i++)switch(currentState){
            // Before enter a new field
            case $2db741498231248f$var$STATE_OUT:
                switch(line.charAt(i)){
                    // Enter a quoted field
                    case $2db741498231248f$var$CODE_QUOTE:
                        readOffset = i + 1;
                        currentState = $2db741498231248f$var$STATE_QUOTE;
                        break;
                    // Read an empty field
                    case this.delimiter:
                        readOffset = i + 1;
                        // If delimiter is white space and configured to collapse
                        // multiple white spaces, ignore this white space.
                        if (this.delimiter === ' ' && this.delimWhitespace) break;
                        result.push('');
                        currentState = $2db741498231248f$var$STATE_OUT;
                        break;
                    // Enter an unquoted field
                    default:
                        currentState = $2db741498231248f$var$STATE_FIELD;
                        readOffset = i;
                        break;
                }
                break;
            // In an unquoted field
            case $2db741498231248f$var$STATE_FIELD:
                switch(line.charAt(i)){
                    // Exit an unquoted field, add it to result
                    case this.delimiter:
                        result.push(line.substring(readOffset, i));
                        currentState = $2db741498231248f$var$STATE_OUT;
                        readOffset = i + 1;
                        break;
                    default:
                }
                break;
            // In a quoted field
            case $2db741498231248f$var$STATE_QUOTE:
                switch(line.charAt(i)){
                    // Read a quote after a quote
                    case $2db741498231248f$var$CODE_QUOTE:
                        currentState = $2db741498231248f$var$STATE_QUOTE_AFTER_QUOTE;
                        break;
                    default:
                }
                break;
            // This state means it's right after a second quote in a field
            case $2db741498231248f$var$STATE_QUOTE_AFTER_QUOTE:
                switch(line.charAt(i)){
                    // Finished a quoted field
                    case this.delimiter:
                        result.push(line.substring(readOffset, i - 1));
                        currentState = $2db741498231248f$var$STATE_OUT;
                        readOffset = i + 1;
                        break;
                    // Finished a quoted part in a quoted field
                    case $2db741498231248f$var$CODE_QUOTE:
                        currentState = $2db741498231248f$var$STATE_QUOTE;
                        break;
                    // In a quoted part in a quoted field
                    default:
                        currentState = $2db741498231248f$var$STATE_WITHIN_QUOTE_IN_QUOTE;
                        break;
                }
                break;
            case $2db741498231248f$var$STATE_WITHIN_QUOTE_IN_QUOTE:
                switch(line.charAt(i)){
                    // Exit a quoted part in a quoted field
                    case $2db741498231248f$var$CODE_QUOTE:
                        currentState = $2db741498231248f$var$STATE_QUOTE;
                        break;
                    default:
                }
                break;
            default:
        }
        // Adds last item based on if it is quoted.
        if (currentState === $2db741498231248f$var$STATE_QUOTE_AFTER_QUOTE) result.push(line.substring(readOffset, readLength - 1));
        else result.push(line.substring(readOffset));
        // Check if each row has the same number of elements as column names.
        if (validateElementCount && result.length !== this.fullColumnNames.length) throw new Error(`Invalid row in csv file. Should have ${this.fullColumnNames.length} elements in a row, but got ${result}`);
        return result;
    }
} // TODO(soergel): add more basic datasets for parity with tf.data
 // tf.data.FixedLengthRecordDataset()
 // tf.data.TFRecordDataset()



/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ 


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

class $0288fd0f132cae94$export$e44e755604080137 extends (0, $b1fde1aac6b3a764$export$b7f78d762925efef) {
    constructor(microphoneConfig){
        super();
        this.microphoneConfig = microphoneConfig;
        this.isClosed = false;
        this.fftSize = microphoneConfig.fftSize || 1024;
        const fftSizeLog2 = Math.log2(this.fftSize);
        if (this.fftSize < 0 || fftSizeLog2 < 4 || fftSizeLog2 > 14 || !Number.isInteger(fftSizeLog2)) throw new Error(`Invalid fftSize: it must be a power of 2 between ` + `2 to 4 and 2 to 14, but got ${this.fftSize}`);
        this.numFrames = microphoneConfig.numFramesPerSpectrogram || 43;
        this.sampleRateHz = microphoneConfig.sampleRateHz;
        this.columnTruncateLength = microphoneConfig.columnTruncateLength || this.fftSize;
        this.audioTrackConstraints = microphoneConfig.audioTrackConstraints;
        this.smoothingTimeConstant = microphoneConfig.smoothingTimeConstant || 0;
        this.includeSpectrogram = microphoneConfig.includeSpectrogram === false ? false : true;
        this.includeWaveform = microphoneConfig.includeWaveform === true ? true : false;
        if (!this.includeSpectrogram && !this.includeWaveform) throw new Error("Both includeSpectrogram and includeWaveform are false. At least one type of data should be returned.");
    }
    summary() {
        return `microphone`;
    }
    // Construct a MicrophoneIterator and start the audio stream.
    static async create(microphoneConfig = {}) {
        if (!(0, $i64bB.env)().get('IS_BROWSER')) throw new Error('microphone API is only supported in browser environment.');
        const microphoneIterator = new $0288fd0f132cae94$export$e44e755604080137(microphoneConfig);
        // Call async function start() to initialize the audio stream.
        await microphoneIterator.start();
        return microphoneIterator;
    }
    // Start the audio stream and FFT.
    async start() {
        try {
            this.stream = await navigator.mediaDevices.getUserMedia({
                audio: this.audioTrackConstraints == null ? true : this.audioTrackConstraints,
                video: false
            });
        } catch (e) {
            throw new Error(`Error thrown while initializing video stream: ${e.message}`);
        }
        if (!this.stream) throw new Error('Could not obtain audio from microphone.');
        const ctxConstructor = // tslint:disable-next-line:no-any
        window.AudioContext || window.webkitAudioContext;
        this.audioContext = new ctxConstructor();
        if (!this.sampleRateHz) // If sample rate is not provided, use the available sample rate on
        // device.
        this.sampleRateHz = this.audioContext.sampleRate;
        else if (this.audioContext.sampleRate !== this.sampleRateHz) throw new Error(`Mismatch in sampling rate: ` + `Expected: ${this.sampleRateHz}; ` + `Actual: ${this.audioContext.sampleRate}`);
        const streamSource = this.audioContext.createMediaStreamSource(this.stream);
        this.analyser = this.audioContext.createAnalyser();
        this.analyser.fftSize = this.fftSize * 2;
        this.analyser.smoothingTimeConstant = this.smoothingTimeConstant;
        streamSource.connect(this.analyser);
        this.freqData = new Float32Array(this.fftSize);
        this.timeData = new Float32Array(this.fftSize);
        return;
    }
    async next() {
        if (this.isClosed) return {
            value: null,
            done: true
        };
        let spectrogramTensor;
        let waveformTensor;
        const audioDataQueue = await this.getAudioData();
        if (this.includeSpectrogram) {
            const freqData = this.flattenQueue(audioDataQueue.freqDataQueue);
            spectrogramTensor = this.getTensorFromAudioDataArray(freqData, [
                this.numFrames,
                this.columnTruncateLength,
                1
            ]);
        }
        if (this.includeWaveform) {
            const timeData = this.flattenQueue(audioDataQueue.timeDataQueue);
            waveformTensor = this.getTensorFromAudioDataArray(timeData, [
                this.numFrames * this.fftSize,
                1
            ]);
        }
        return {
            value: {
                'spectrogram': spectrogramTensor,
                'waveform': waveformTensor
            },
            done: false
        };
    }
    // Capture one result from the audio stream, and extract the value from
    // iterator.next() result.
    async capture() {
        return (await this.next()).value;
    }
    async getAudioData() {
        const freqDataQueue = [];
        const timeDataQueue = [];
        let currentFrames = 0;
        return new Promise((resolve)=>{
            const intervalID = setInterval(()=>{
                if (this.includeSpectrogram) {
                    this.analyser.getFloatFrequencyData(this.freqData);
                    // If the audio stream is initializing, return empty queue.
                    if (this.freqData[0] === -Infinity) resolve({
                        freqDataQueue: freqDataQueue,
                        timeDataQueue: timeDataQueue
                    });
                    freqDataQueue.push(this.freqData.slice(0, this.columnTruncateLength));
                }
                if (this.includeWaveform) {
                    this.analyser.getFloatTimeDomainData(this.timeData);
                    timeDataQueue.push(this.timeData.slice());
                }
                // Clean interval and return when all frames have been collected
                if (++currentFrames === this.numFrames) {
                    clearInterval(intervalID);
                    resolve({
                        freqDataQueue: freqDataQueue,
                        timeDataQueue: timeDataQueue
                    });
                }
            }, this.fftSize / this.sampleRateHz * 1e3);
        });
    }
    // Stop the audio stream and pause the iterator.
    stop() {
        if (!this.isClosed) {
            this.isClosed = true;
            this.analyser.disconnect();
            this.audioContext.close();
            if (this.stream != null && this.stream.getTracks().length > 0) this.stream.getTracks()[0].stop();
        }
    }
    // Override toArray() function to prevent collecting.
    toArray() {
        throw new Error('Can not convert infinite audio stream to array.');
    }
    // Return audio sampling rate in Hz
    getSampleRate() {
        return this.sampleRateHz;
    }
    flattenQueue(queue) {
        const frameSize = queue[0].length;
        const freqData = new Float32Array(queue.length * frameSize);
        queue.forEach((data, i)=>freqData.set(data, i * frameSize));
        return freqData;
    }
    getTensorFromAudioDataArray(freqData, shape) {
        const vals = new Float32Array((0, $i64bB.util).sizeFromShape(shape));
        // If the data is less than the output shape, the rest is padded with zeros.
        vals.set(freqData, vals.length - freqData.length);
        return (0, $i64bB.tensor)(vals, shape);
    }
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

class $9f677e272edd9344$export$da055602df533e23 extends (0, $b1fde1aac6b3a764$export$b7f78d762925efef) {
    constructor(webcamVideoElement, webcamConfig){
        super();
        this.webcamVideoElement = webcamVideoElement;
        this.webcamConfig = webcamConfig;
        this.isClosed = true;
        this.resize = false;
        if (this.needToResize()) {
            this.resize = true;
            this.cropSize = [
                this.webcamConfig.resizeHeight,
                this.webcamConfig.resizeWidth
            ];
            this.cropBoxInd = (0, $i64bB.tensor1d)([
                0
            ], 'int32');
            if (this.webcamConfig.centerCrop) {
                // Calculate the box based on resizing shape.
                const widthCroppingRatio = this.webcamConfig.resizeWidth * 1.0 / this.webcamVideoElement.width;
                const heightCroppingRatio = this.webcamConfig.resizeHeight * 1.0 / this.webcamVideoElement.height;
                const widthCropStart = (1 - widthCroppingRatio) / 2;
                const heightCropStart = (1 - heightCroppingRatio) / 2;
                const widthCropEnd = widthCropStart + widthCroppingRatio;
                const heightCropEnd = heightCroppingRatio + heightCropStart;
                this.cropBox = (0, $i64bB.tensor2d)([
                    heightCropStart,
                    widthCropStart,
                    heightCropEnd,
                    widthCropEnd
                ], [
                    1,
                    4
                ]);
            } else this.cropBox = (0, $i64bB.tensor2d)([
                0,
                0,
                1,
                1
            ], [
                1,
                4
            ]);
        }
    }
    summary() {
        return `webcam`;
    }
    // Construct a WebcamIterator and start it's video stream.
    static async create(webcamVideoElement, webcamConfig = {}) {
        if (!(0, $i64bB.env)().get('IS_BROWSER')) throw new Error('tf.data.webcam is only supported in browser environment.');
        if (!webcamVideoElement) {
            // If webcam video element is not provided, create a hidden video element
            // with provided width and height.
            webcamVideoElement = document.createElement('video');
            if (!webcamConfig.resizeWidth || !webcamConfig.resizeHeight) throw new Error("Please provide webcam video element, or resizeWidth and resizeHeight to create a hidden video element.");
            webcamVideoElement.width = webcamConfig.resizeWidth;
            webcamVideoElement.height = webcamConfig.resizeHeight;
        }
        const webcamIterator = new $9f677e272edd9344$export$da055602df533e23(webcamVideoElement, webcamConfig);
        // Call async function to initialize the video stream.
        await webcamIterator.start();
        return webcamIterator;
    }
    // Async function to start video stream.
    async start() {
        if (this.webcamConfig.facingMode) (0, $i64bB.util).assert(this.webcamConfig.facingMode === 'user' || this.webcamConfig.facingMode === 'environment', ()=>`Invalid webcam facing mode: ${this.webcamConfig.facingMode}. ` + `Please provide 'user' or 'environment'`);
        try {
            this.stream = await navigator.mediaDevices.getUserMedia({
                video: {
                    deviceId: this.webcamConfig.deviceId,
                    facingMode: this.webcamConfig.facingMode ? this.webcamConfig.facingMode : 'user',
                    width: this.webcamVideoElement.width,
                    height: this.webcamVideoElement.height
                }
            });
        } catch (e) {
            // Modify the error message but leave the stack trace intact
            e.message = `Error thrown while initializing video stream: ${e.message}`;
            throw e;
        }
        if (!this.stream) throw new Error('Could not obtain video from webcam.');
        // Older browsers may not have srcObject
        try {
            this.webcamVideoElement.srcObject = this.stream;
        } catch (error) {
            console.log(error);
            this.webcamVideoElement.src = window.URL.createObjectURL(this.stream);
        }
        // Start the webcam video stream
        this.webcamVideoElement.play();
        this.isClosed = false;
        return new Promise((resolve)=>{
            // Add event listener to make sure the webcam has been fully initialized.
            this.webcamVideoElement.onloadedmetadata = ()=>{
                resolve();
            };
        });
    }
    async next() {
        if (this.isClosed) return {
            value: null,
            done: true
        };
        let img;
        try {
            img = (0, $i64bB.browser).fromPixels(this.webcamVideoElement);
        } catch (e) {
            throw new Error(`Error thrown converting video to pixels: ${JSON.stringify(e)}`);
        }
        if (this.resize) try {
            return {
                value: this.cropAndResizeFrame(img),
                done: false
            };
        } catch (e) {
            throw new Error(`Error thrown cropping the video: ${e.message}`);
        } finally{
            img.dispose();
        }
        else return {
            value: img,
            done: false
        };
    }
    needToResize() {
        // If resizeWidth and resizeHeight are provided, and different from the
        // width and height of original HTMLVideoElement, then resizing and cropping
        // is required.
        if (this.webcamConfig.resizeWidth && this.webcamConfig.resizeHeight && (this.webcamVideoElement.width !== this.webcamConfig.resizeWidth || this.webcamVideoElement.height !== this.webcamConfig.resizeHeight)) return true;
        return false;
    }
    // Cropping and resizing each frame based on config
    cropAndResizeFrame(img) {
        return (0, $i64bB.tidy)(()=>{
            const expandedImage = (0, $i64bB.expandDims)((0, $i64bB.cast)(img, 'float32'), 0);
            let resizedImage;
            resizedImage = (0, $i64bB.image).cropAndResize(expandedImage, this.cropBox, this.cropBoxInd, this.cropSize, 'bilinear');
            // Extract image from batch cropping.
            const shape = resizedImage.shape;
            return (0, $i64bB.reshape)(resizedImage, shape.slice(1));
        });
    }
    // Capture one frame from the video stream, and extract the value from
    // iterator.next() result.
    async capture() {
        return (await this.next()).value;
    }
    // Stop the video stream and pause webcam iterator.
    stop() {
        const tracks = this.stream.getTracks();
        tracks.forEach((track)=>track.stop());
        try {
            this.webcamVideoElement.srcObject = null;
        } catch (error) {
            console.log(error);
            this.webcamVideoElement.src = null;
        }
        this.isClosed = true;
    }
    // Override toArray() function to prevent collecting.
    toArray() {
        throw new Error('Can not convert infinite video stream to array.');
    }
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ /**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ /**
 * Represents a data source readable as a stream of binary data chunks.
 *
 * Because `Dataset`s can be read repeatedly (via `Dataset.iterator()`), this
 * provides a means to repeatedly create streams from the underlying data
 * sources.
 */ class $5b0a682a3f539253$export$accd73d198d77d2f {
} // TODO(soergel): consider convenience factory functions here
 // in combination with chainable source->dataset above, e.g.:
 // tf.data.url(...).asCsvDataset().shuffle().batch()


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ // inspired by https://github.com/maxogden/filereader-stream

var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ 
class $fa93de2903cf8753$export$fa893445807b0b3b extends (0, $b1fde1aac6b3a764$export$b7f78d762925efef) {
    /**
     * Splits a string stream on a given separator.
     *
     * It is assumed that the incoming chunk boundaries have no semantic meaning,
     * so conceptually the incoming stream is treated simply as the concatenation
     * of its elements.
     *
     * The outgoing stream provides chunks corresponding to the results of the
     * standard string split() operation (even if such a chunk spanned incoming
     * chunks).  The separators are not included.
     *
     * A typical usage is to split a text file (represented as a stream with
     * arbitrary chunk boundaries) into lines.
     *
     * @param upstream A readable stream of strings that can be treated as
     *   concatenated.
     * @param separator A character to split on.
     */ split(separator) {
        return new $fa93de2903cf8753$var$SplitIterator(this, separator);
    }
}
// ============================================================================
// The following private classes serve to implement the chainable methods
// on StringIterator.  Unfortunately they can't be placed in separate files, due
// to resulting trouble with circular imports.
// ============================================================================
// We wanted multiple inheritance, e.g.
//   class SplitIterator extends QueueIterator<string>, StringIterator
// but the TypeScript mixin approach is a bit hacky, so we take this adapter
// approach instead.
class $fa93de2903cf8753$var$SplitIterator extends $fa93de2903cf8753$export$fa893445807b0b3b {
    constructor(upstream, separator){
        super();
        this.upstream = upstream;
        this.impl = new $fa93de2903cf8753$var$SplitIteratorImpl(upstream, separator);
    }
    summary() {
        return this.impl.summary();
    }
    async next() {
        return this.impl.next();
    }
}
class $fa93de2903cf8753$var$SplitIteratorImpl extends (0, $b1fde1aac6b3a764$export$3c2cec00242a8bd8) {
    constructor(upstream, separator){
        super();
        this.upstream = upstream;
        this.separator = separator;
        // A partial string at the end of an upstream chunk
        this.carryover = '';
    }
    summary() {
        return `${this.upstream.summary()} -> Split('${this.separator}')`;
    }
    async pump() {
        const chunkResult = await this.upstream.next();
        if (chunkResult.done) {
            if (this.carryover === '') return false;
            // Pretend that the pump succeeded in order to emit the small last batch.
            // The next pump() call will actually fail.
            this.outputQueue.push(this.carryover);
            this.carryover = '';
            return true;
        }
        const lines = chunkResult.value.split(this.separator);
        // Note the behavior: " ab ".split(' ') === ['', 'ab', '']
        // Thus the carryover may be '' if the separator falls on a chunk
        // boundary; this produces the correct result.
        lines[0] = this.carryover + lines[0];
        for (const line of lines.slice(0, -1))this.outputQueue.push(line);
        this.carryover = lines[lines.length - 1];
        return true;
    }
}



var $6ZWSX = parcelRequire("6ZWSX");
var $98346553b57aab2b$require$Buffer = $6ZWSX.Buffer;
class $98346553b57aab2b$export$6a47bd14492beb24 extends (0, $b1fde1aac6b3a764$export$b7f78d762925efef) {
    /**
     * Decode a stream of UTF8-encoded byte arrays to a stream of strings.
     *
     * The byte arrays producetd from the ByteChunkIterator on which this is
     * called will be interpreted as concatenated.  No assumptions are made about
     * the boundaries of the incoming chunks, so a multi-byte UTF8 encoding of a
     * character may span the boundary between chunks.  This naturally happens,
     * for instance, when reading fixed-size byte arrays from a file.
     */ decodeUTF8() {
        return new $98346553b57aab2b$var$Utf8Iterator(this);
    }
}
// ============================================================================
// The following private classes serve to implement the chainable methods
// on ByteChunkIterator.  Unfortunately they can't be placed in separate files,
// due to resulting trouble with circular imports.
// ============================================================================
// We wanted multiple inheritance, e.g.
//   class Utf8Iterator extends QueueIterator<string>, StringIterator
// but the TypeScript mixin approach is a bit hacky, so we take this adapter
// approach instead.
class $98346553b57aab2b$var$Utf8Iterator extends (0, $fa93de2903cf8753$export$fa893445807b0b3b) {
    constructor(upstream){
        super();
        this.upstream = upstream;
        this.impl = new $98346553b57aab2b$var$Utf8IteratorImpl(upstream);
    }
    summary() {
        return this.impl.summary();
    }
    async next() {
        return this.impl.next();
    }
}

/**
 * Decode a stream of UTF8-encoded byte arrays to a stream of strings.
 *
 * This is tricky because the incoming byte array boundaries may disrupt a
 * multi-byte UTF8 character. Thus any incomplete character data at the end of
 * a chunk must be carried over and prepended to the next chunk before
 * decoding. Luckily with native decoder, TextDecoder in browser and
 * string_decoder in node, byte array boundaries are handled automatically.
 *
 * In the context of an input pipeline for machine learning, UTF8 decoding is
 * needed to parse text files containing training examples or prediction
 * requests (e.g., formatted as CSV or JSON). We cannot use the built-in
 * decoding provided by FileReader.readAsText() because here we are in a
 * streaming context, which FileReader does not support.
 *
 * @param upstream A `LazyIterator` of `Uint8Arrays` containing UTF8-encoded
 *   text, which should be interpreted as concatenated.  No assumptions are
 *   made about the boundaries of the incoming chunks, so a multi-byte UTF8
 *   encoding of a character may span the boundary between chunks.  This
 *   naturally happens, for instance, when reading fixed-size byte arrays from a
 *   file.
 */ class $98346553b57aab2b$var$Utf8IteratorImpl extends (0, $b1fde1aac6b3a764$export$3c2cec00242a8bd8) {
    constructor(upstream){
        super();
        this.upstream = upstream;
        if ((0, $i64bB.env)().get('IS_BROWSER')) this.decoder = new TextDecoder('utf-8');
        else {
            // tslint:disable-next-line:no-require-imports
            const { StringDecoder: StringDecoder } = (parcelRequire("kjyEk"));
            this.decoder = new StringDecoder('utf8');
        }
    }
    summary() {
        return `${this.upstream.summary()} -> Utf8`;
    }
    async pump() {
        const chunkResult = await this.upstream.next();
        let chunk;
        if (chunkResult.done) return false;
        else chunk = chunkResult.value;
        let text;
        if ((0, $i64bB.env)().get('IS_BROWSER')) text = this.decoder.decode(chunk, {
            stream: true
        });
        else text = this.decoder.write($98346553b57aab2b$require$Buffer.from(chunk.buffer));
        this.outputQueue.push(text);
        return true;
    }
}


class $e88367b777e727cc$export$2624998eee2e5c56 extends (0, $98346553b57aab2b$export$6a47bd14492beb24) {
    constructor(file, options = {}){
        super();
        this.file = file;
        this.options = options;
        (0, $i64bB.util).assert(file instanceof Uint8Array || ((0, $i64bB.env)().get('IS_BROWSER') ? file instanceof File || file instanceof Blob : false), ()=>"FileChunkIterator only supports File, Blob and Uint8Array right now.");
        this.offset = options.offset || 0;
        // default 1MB chunk has tolerable perf on large files
        this.chunkSize = options.chunkSize || 1048576;
    }
    summary() {
        return `FileChunks ${this.file}`;
    }
    async next() {
        if (this.offset >= (this.file instanceof Uint8Array ? this.file.byteLength : this.file.size)) return {
            value: null,
            done: true
        };
        const chunk = new Promise((resolve, reject)=>{
            const end = this.offset + this.chunkSize;
            if (this.file instanceof Uint8Array) // Note if end > this.uint8Array.byteLength, we just get a small last
            // chunk.
            resolve(new Uint8Array(this.file.slice(this.offset, end)));
            else {
                // This branch assumes that this.file type is File or Blob, which
                // means it is in the browser environment.
                // TODO(soergel): is this a performance issue?
                const fileReader = new FileReader();
                fileReader.onload = (event)=>{
                    let data = fileReader.result;
                    // Not sure we can trust the return type of
                    // FileReader.readAsArrayBuffer See e.g.
                    // https://github.com/node-file-api/FileReader/issues/2
                    if (data instanceof ArrayBuffer) data = new Uint8Array(data);
                    if (!(data instanceof Uint8Array)) return reject(new TypeError('FileReader returned unknown type.'));
                    resolve(data);
                };
                fileReader.onabort = (event)=>{
                    return reject(new Error('Aborted'));
                };
                fileReader.onerror = (event)=>{
                    return reject(new Error(event.type));
                };
                // TODO(soergel): better handle onabort, onerror
                // Note if end > this.file.size, we just get a small last chunk.
                const slice = this.file.slice(this.offset, end);
                // We can't use readAsText here (even if we know the file is text)
                // because the slice boundary may fall within a multi-byte character.
                fileReader.readAsArrayBuffer(slice);
            }
            this.offset = end;
        });
        return {
            value: await chunk,
            done: false
        };
    }
}


async function $53101913465c3cba$export$158ba3195ecace84(url, options = {}, fetchFunc) {
    let urlString;
    let requestInit;
    if (typeof url === 'string') urlString = url;
    else {
        urlString = url.url;
        requestInit = $53101913465c3cba$var$getRequestInitFromRequest(url);
    }
    const response = await (fetchFunc || (0, $i64bB.util).fetch)(urlString, requestInit);
    if (response.ok) {
        const uint8Array = new Uint8Array(await response.arrayBuffer());
        return new (0, $e88367b777e727cc$export$2624998eee2e5c56)(uint8Array, options);
    } else throw new Error(response.statusText);
}
// Generate RequestInit from Request to match tf.util.fetch signature.
const $53101913465c3cba$var$getRequestInitFromRequest = (request)=>{
    const init = {
        method: request.method,
        headers: request.headers,
        body: request.body,
        mode: request.mode,
        credentials: request.credentials,
        cache: request.cache,
        redirect: request.redirect,
        referrer: request.referrer,
        integrity: request.integrity
    };
    return init;
};


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ // Skip tslint any type check cause this method is aiming to check type of
// input.
// tslint:disable-next-line:no-any
function $31d139de60b1b4fe$export$9fce4fde36401560(source) {
    return typeof source === 'string' && source.slice(0, 7) === 'file://';
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");




class $13e334c03aedcd61$export$e7de913bc6153b84 extends (0, $5b0a682a3f539253$export$accd73d198d77d2f) {
    /**
     * Create a `FileDataSource`.
     *
     * @param input Local file path, or `File`/`Blob`/`Uint8Array` object to
     *     read. Local file only works in node environment.
     * @param options Options passed to the underlying `FileChunkIterator`s,
     *   such as {chunksize: 1024}.
     */ constructor(input, options = {}){
        super();
        this.input = input;
        this.options = options;
    }
    async iterator() {
        if ((0, $31d139de60b1b4fe$export$9fce4fde36401560)(this.input) && (0, $i64bB.env)().get('IS_NODE')) {
            // tslint:disable-next-line:no-require-imports
            const fs = (parcelRequire("kjyEk"));
            this.input = fs.readFileSync(this.input.slice(7));
        }
        // TODO(kangyizhang): Add LocalFileChunkIterator to split local streaming
        // with file in browser.
        return new (0, $e88367b777e727cc$export$2624998eee2e5c56)(this.input, this.options);
    }
}


class $83c1bd41004c1cc0$export$d8d4d86de1937e34 extends (0, $5b0a682a3f539253$export$accd73d198d77d2f) {
    /**
     * Create a `URLDataSource`.
     *
     * @param url A source URL string, or a `Request` object.
     * @param options Options passed to the underlying `FileChunkIterator`s,
     *   such as {chunksize: 1024}.
     */ constructor(url, fileOptions = {}){
        super();
        this.url = url;
        this.fileOptions = fileOptions;
    }
    // TODO(soergel): provide appropriate caching options.  Currently this
    // will download the URL anew for each call to iterator().  Since we have
    // to treat the downloaded file as a blob/buffer anyway, we may as well retain
    // it-- but that raises GC issues.  Also we may want a persistent disk cache.
    async iterator() {
        if ((0, $31d139de60b1b4fe$export$9fce4fde36401560)(this.url)) return new (0, $13e334c03aedcd61$export$e7de913bc6153b84)(this.url, this.fileOptions).iterator();
        else return (0, $53101913465c3cba$export$158ba3195ecace84)(this.url, this.fileOptions);
    }
}


function $6ea01d67222555cb$export$901ba78aa04f49da(source, csvConfig = {}) {
    return new (0, $2db741498231248f$export$1e441948ffa5f20a)(new (0, $83c1bd41004c1cc0$export$d8d4d86de1937e34)(source), csvConfig);
}
function $6ea01d67222555cb$export$86951950244e2001(f) {
    const iter = (0, $b1fde1aac6b3a764$export$392feaf09f7ef035)(f);
    return (0, $088f40d26e8580f1$export$3a70158aa38bbd76)(async ()=>iter);
}
function $6ea01d67222555cb$export$2b513308e642d699(generator) {
    return (0, $088f40d26e8580f1$export$3a70158aa38bbd76)(async ()=>{
        const gen = await generator();
        return (0, $b1fde1aac6b3a764$export$392feaf09f7ef035)(()=>gen.next());
    });
}
async function $6ea01d67222555cb$export$62c2c555d8a25fb5(webcamVideoElement, webcamConfig) {
    return (0, $9f677e272edd9344$export$da055602df533e23).create(webcamVideoElement, webcamConfig);
}
async function $6ea01d67222555cb$export$e852da8bac022cf9(microphoneConfig) {
    return (0, $0288fd0f132cae94$export$e44e755604080137).create(microphoneConfig);
}




/** @license See the LICENSE file. */ // This code is auto-generated, do not modify this file!
const $4bf16420126b0bf6$export$83d89fbfd8236492 = '4.22.0';




/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // All exports from this package should be in base.
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /*
 * base.ts contains all the exports from tfjs-backend-cpu
 * without auto-kernel registration
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");
const $9829ff9d82f25b05$var$whereImpl = (0, $i64bB.kernel_impls).whereImpl;
class $9829ff9d82f25b05$export$65286aecbd5a8de9 extends (0, $i64bB.KernelBackend) {
    nextDataId() {
        return $9829ff9d82f25b05$export$65286aecbd5a8de9.nextDataId++;
    }
    constructor(){
        super();
        this.blockSize = 48;
        this.firstUse = true;
        this.data = new (0, $i64bB.DataStorage)(this, (0, $i64bB.engine)());
    }
    write(values, shape, dtype) {
        if (this.firstUse) {
            this.firstUse = false;
            if ((0, $i64bB.env)().get('IS_NODE')) (0, $i64bB.backend_util).warn("\n============================\nHi, looks like you are running TensorFlow.js in Node.js. To speed things up dramatically, install our node backend, visit https://github.com/tensorflow/tfjs-node for more details. \n============================");
        }
        const dataId = {
            id: this.nextDataId()
        };
        this.data.set(dataId, {
            values: values,
            dtype: dtype,
            refCount: 1
        });
        return dataId;
    }
    /**
     * Create a data bucket in cpu backend.
     * @param shape Shape of the `TensorInfo`.
     * @param dtype DType of the `TensorInfo`.
     * @param values The value of the `TensorInfo` stored as a flattened array.
     */ makeTensorInfo(shape, dtype, values) {
        let outId;
        if (dtype === 'string' && values != null && values.length > 0 && (0, $i64bB.util).isString(values[0])) {
            const encodedValues = values.map((d)=>(0, $i64bB.util).encodeString(d));
            outId = this.write(encodedValues, shape, dtype);
        } else outId = this.write(values, shape, dtype);
        return {
            dataId: outId,
            shape: shape,
            dtype: dtype
        };
    }
    /** Return refCount of a `TensorData`. */ refCount(dataId) {
        if (this.data.has(dataId)) {
            const tensorData = this.data.get(dataId);
            return tensorData.refCount;
        }
        return 0;
    }
    /** Increase refCount of a `TensorData`. */ incRef(dataId) {
        const tensorData = this.data.get(dataId);
        tensorData.refCount++;
    }
    /** Decrease refCount of a `TensorData`. */ decRef(dataId) {
        if (this.data.has(dataId)) {
            const tensorData = this.data.get(dataId);
            tensorData.refCount--;
        }
    }
    move(dataId, values, shape, dtype, refCount) {
        this.data.set(dataId, {
            values: values,
            dtype: dtype,
            refCount: refCount
        });
    }
    numDataIds() {
        return this.data.numDataIds();
    }
    async read(dataId) {
        return this.readSync(dataId);
    }
    readSync(dataId) {
        const { dtype: dtype, complexTensorInfos: complexTensorInfos } = this.data.get(dataId);
        if (dtype === 'complex64') {
            const realValues = this.readSync(complexTensorInfos.real.dataId);
            const imagValues = this.readSync(complexTensorInfos.imag.dataId);
            return (0, $i64bB.backend_util).mergeRealAndImagArrays(realValues, imagValues);
        }
        return (0, $i64bB.util).convertBackendValuesAndArrayBuffer(this.data.get(dataId).values, dtype);
    }
    bufferSync(t) {
        const data = this.readSync(t.dataId);
        if (t.dtype === 'string') try {
            // Decode the bytes into string.
            const strings = data.map((d)=>(0, $i64bB.util).decodeString(d));
            return (0, $i64bB.buffer)(t.shape, t.dtype, strings);
        } catch (_a) {
            throw new Error('Failed to decode encoded string bytes into utf-8');
        }
        return (0, $i64bB.buffer)(t.shape, t.dtype, data);
    }
    makeOutput(values, shape, dtype) {
        return (0, $i64bB.engine)().makeTensorFromTensorInfo(this.makeTensorInfo(shape, dtype, values), this);
    }
    /**
     * Dispose the memory if the dataId has 0 refCount. Return true if the memory
     * is released or memory is not managed in this backend, false if memory is
     * not cleared.
     * @param dataId
     * @oaram force Optional, remove the data regardless of refCount
     */ disposeData(dataId, force = false) {
        if (this.data.has(dataId)) {
            this.data.get(dataId).refCount--;
            if (!force && this.data.get(dataId).refCount > 0) return false;
            const { complexTensorInfos: complexTensorInfos } = this.data.get(dataId);
            if (complexTensorInfos != null) {
                this.disposeData(complexTensorInfos.real.dataId, true);
                this.disposeData(complexTensorInfos.imag.dataId, true);
            }
            this.data.delete(dataId);
        }
        return true;
    }
    disposeIntermediateTensorInfo(tensorInfo) {
        this.disposeData(tensorInfo.dataId);
    }
    async time(f) {
        const start = (0, $i64bB.util).now();
        f();
        const kernelMs = (0, $i64bB.util).now() - start;
        return {
            kernelMs: kernelMs
        };
    }
    memory() {
        return {
            // Unreliable due to automatic gc. The numbers above are cumulative.
            unreliable: true,
            reasons: [
                "The reported memory is an upper bound. Due to automatic garbage collection, the true allocated memory may be less."
            ]
        };
    }
    where(condition) {
        (0, $csahy.assertNotComplex)([
            condition
        ], 'where');
        const condVals = this.readSync(condition.dataId);
        return $9829ff9d82f25b05$var$whereImpl(condition.shape, condVals);
    }
    dispose() {}
    floatPrecision() {
        return 32;
    }
    /** Returns the smallest representable number.  */ epsilon() {
        return super.epsilon();
    }
}
$9829ff9d82f25b05$export$65286aecbd5a8de9.nextDataId = 0;



/** @license See the LICENSE file. */ // This code is auto-generated, do not modify this file!
const $a2dd452fb583d973$export$83d89fbfd8236492 = '4.22.0';


// Side effects for default initialization of MathBackendCPU
(0, $i64bB.registerBackend)('cpu', ()=>new (0, $9829ff9d82f25b05$export$65286aecbd5a8de9)(), 1 /* priority */ );


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // We explicitly import the modular kernels so they get registered in the
// global registry when we compile the library. A modular build would replace
// the contents of this file and import only the kernels that are needed.

var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $l6afd = parcelRequire("l6afd");
const $4be447923eb31a08$export$796b583dd79d8524 = (0, $l6afd.unaryKernelFunc)((0, $i64bB.Elu), (xi)=>xi >= 0 ? xi : Math.exp(xi) - 1);
const $4be447923eb31a08$export$b990686634ee3cce = {
    kernelName: (0, $i64bB.Elu),
    backendName: 'cpu',
    kernelFunc: $4be447923eb31a08$export$796b583dd79d8524
};



var $lcqBv = parcelRequire("lcqBv");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");
function $81269e84b542f8c3$export$23a860e40a2c6b61(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { alpha: alpha } = attrs;
    (0, $csahy.assertNotComplex)([
        x
    ], 'leakyRelu');
    const xSize = (0, $i64bB.util).sizeFromShape(x.shape);
    const xVals = backend.data.get(x.dataId).values;
    const outVals = (0, $i64bB.util).getTypedArrayFromDType('float32', xSize);
    for(let i = 0; i < xVals.length; i++)outVals[i] = xVals[i] < 0 ? alpha * xVals[i] : xVals[i];
    return backend.makeTensorInfo(x.shape, 'float32', outVals);
}
const $81269e84b542f8c3$export$aa04ab963fdf437f = {
    kernelName: (0, $i64bB.LeakyRelu),
    backendName: 'cpu',
    kernelFunc: $81269e84b542f8c3$export$23a860e40a2c6b61
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");

var $jQJ39 = parcelRequire("jQJ39");
const $773ba90ab8dc0ec9$var$preluImpl = (0, $jQJ39.createSimpleBinaryKernelImpl)((xValue, aValue)=>xValue < 0 ? aValue * xValue : xValue);
function $773ba90ab8dc0ec9$export$5882f235222e6729(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x, alpha: alpha } = inputs;
    (0, $csahy.assertNotComplex)([
        x,
        alpha
    ], 'prelu');
    const aVals = backend.data.get(x.dataId).values;
    const bVals = backend.data.get(alpha.dataId).values;
    const [resultData, resultShape] = $773ba90ab8dc0ec9$var$preluImpl(x.shape, alpha.shape, aVals, bVals, 'float32');
    return backend.makeTensorInfo(resultShape, 'float32', resultData);
}
const $773ba90ab8dc0ec9$export$a5c4a9b694579636 = {
    kernelName: (0, $i64bB.Prelu),
    backendName: 'cpu',
    kernelFunc: $773ba90ab8dc0ec9$export$5882f235222e6729
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $l6afd = parcelRequire("l6afd");
const $7f66a4e69afa64f7$export$16d1e4612cc0139f = (0, $l6afd.unaryKernelFunc)((0, $i64bB.Relu), (xi)=>Math.max(0, xi));
const $7f66a4e69afa64f7$export$731f9199bde068eb = {
    kernelName: (0, $i64bB.Relu),
    backendName: 'cpu',
    kernelFunc: $7f66a4e69afa64f7$export$16d1e4612cc0139f
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $l6afd = parcelRequire("l6afd");
const $5ac347e14aab137b$export$4a62bcb95e9c44c4 = (0, $l6afd.unaryKernelFunc)((0, $i64bB.Relu6), (xi)=>Math.min(Math.max(0, xi), 6));
const $5ac347e14aab137b$export$92c30890ad649d53 = {
    kernelName: (0, $i64bB.Relu6),
    backendName: 'cpu',
    kernelFunc: $5ac347e14aab137b$export$4a62bcb95e9c44c4
};



var $dMdBj = parcelRequire("dMdBj");
function $2e3684d349b4bf60$export$a0f250a2ba84196(backend, x, activation, preluActivationWeights, leakyreluAlpha) {
    if (activation === 'linear') return (0, $lcqBv.identity)({
        inputs: {
            x: x
        },
        backend: backend
    });
    else if (activation === 'relu') return (0, $7f66a4e69afa64f7$export$16d1e4612cc0139f)({
        inputs: {
            x: x
        },
        backend: backend
    });
    else if (activation === 'elu') return (0, $4be447923eb31a08$export$796b583dd79d8524)({
        inputs: {
            x: x
        },
        backend: backend
    });
    else if (activation === 'relu6') return (0, $5ac347e14aab137b$export$4a62bcb95e9c44c4)({
        inputs: {
            x: x
        },
        backend: backend
    });
    else if (activation === 'prelu') return (0, $773ba90ab8dc0ec9$export$5882f235222e6729)({
        inputs: {
            x: x,
            alpha: preluActivationWeights
        },
        backend: backend
    });
    else if (activation === 'leakyrelu') return (0, $81269e84b542f8c3$export$23a860e40a2c6b61)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            alpha: leakyreluAlpha
        }
    });
    else if (activation === 'sigmoid') return (0, $dMdBj.sigmoid)({
        inputs: {
            x: x
        },
        backend: backend
    });
    throw new Error(`Activation ${activation} has not been implemented for the CPU backend.`);
}



var $e8yCG = parcelRequire("e8yCG");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
function $abec025db4e7e093$export$9eaad88cf88cee2b(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { shape: shape } = attrs;
    const xSize = (0, $i64bB.util).sizeFromShape(x.shape);
    const $shape = (0, $i64bB.util).inferFromImplicitShape(shape, xSize);
    const $xSize = (0, $i64bB.util).sizeFromShape($shape);
    (0, $i64bB.util).assert(xSize === $xSize, ()=>`The new shape (${$shape}) has ${$xSize} elements and the old ` + `shape (${x.shape}) has ${xSize} elements. The new shape and old ` + `shape must have the same number of elements.`);
    backend.incRef(x.dataId);
    const xData = backend.data.get(x.dataId);
    if (xData.complexTensorInfos != null) {
        const real = xData.complexTensorInfos.real;
        const imag = xData.complexTensorInfos.imag;
        real.shape = $shape;
        imag.shape = $shape;
    }
    return {
        dataId: x.dataId,
        shape: $shape,
        dtype: x.dtype
    };
}
const $abec025db4e7e093$export$cfa02e698602aca2 = {
    kernelName: (0, $i64bB.Reshape),
    backendName: 'cpu',
    kernelFunc: $abec025db4e7e093$export$9eaad88cf88cee2b
};


function $1f35b9edc36b4c50$export$8f97894b482227f0(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { a: a, b: b } = inputs;
    const { transposeA: transposeA, transposeB: transposeB } = attrs;
    (0, $csahy.assertNotComplex)([
        a,
        b
    ], 'matMul');
    const aRank = a.shape.length;
    const bRank = b.shape.length;
    const innerShapeA = transposeA ? a.shape[aRank - 2] : a.shape[aRank - 1];
    const innerShapeB = transposeB ? b.shape[bRank - 1] : b.shape[bRank - 2];
    const outerShapeA = transposeA ? a.shape[aRank - 1] : a.shape[aRank - 2];
    const outerShapeB = transposeB ? b.shape[bRank - 2] : b.shape[bRank - 1];
    const outerDimsA = a.shape.slice(0, -2);
    const outerDimsB = b.shape.slice(0, -2);
    const batchDimA = (0, $i64bB.util).sizeFromShape(outerDimsA);
    const batchDimB = (0, $i64bB.util).sizeFromShape(outerDimsB);
    const outShapeOuterDims = (0, $i64bB.broadcast_util).assertAndGetBroadcastShape(a.shape.slice(0, -2), b.shape.slice(0, -2));
    const outShape = outShapeOuterDims.concat([
        outerShapeA,
        outerShapeB
    ]);
    (0, $i64bB.util).assert(innerShapeA === innerShapeB, ()=>`Error in matMul: inner shapes (${innerShapeA}) and (` + `${innerShapeB}) of Tensors with shapes ${a.shape} and ` + `${b.shape} and transposeA=${transposeA}` + ` and transposeB=${transposeB} must match.`);
    const a3dShape = transposeA ? [
        batchDimA,
        innerShapeA,
        outerShapeA
    ] : [
        batchDimA,
        outerShapeA,
        innerShapeA
    ];
    const b3dShape = transposeB ? [
        batchDimB,
        outerShapeB,
        innerShapeB
    ] : [
        batchDimB,
        innerShapeB,
        outerShapeB
    ];
    // The rest of the implementation is designed to operate on rank-3 tensors
    const a3d = (0, $abec025db4e7e093$export$9eaad88cf88cee2b)({
        inputs: {
            x: a
        },
        backend: backend,
        attrs: {
            shape: a3dShape
        }
    });
    const b3d = (0, $abec025db4e7e093$export$9eaad88cf88cee2b)({
        inputs: {
            x: b
        },
        backend: backend,
        attrs: {
            shape: b3dShape
        }
    });
    const sharedDim = transposeA ? a3d.shape[1] : a3d.shape[2];
    const leftDim = transposeA ? a3d.shape[2] : a3d.shape[1];
    const rightDim = transposeB ? b3d.shape[1] : b3d.shape[2];
    const batchDim = Math.max(batchDimA, batchDimB);
    const a3dValues = backend.data.get(a3d.dataId).values;
    const b3dValues = backend.data.get(b3d.dataId).values;
    const a3dStrides = (0, $i64bB.util).computeStrides(a3d.shape);
    const b3dStrides = (0, $i64bB.util).computeStrides(b3d.shape);
    const [aBatch, aOuterStep, aInnerStep] = transposeA ? [
        a3dStrides[0],
        1,
        a3dStrides[1]
    ] : [
        a3dStrides[0],
        a3dStrides[1],
        1
    ];
    const [bInnerStep, bOuterStep, bBatch] = transposeB ? [
        1,
        b3dStrides[1],
        b3dStrides[0]
    ] : [
        b3dStrides[1],
        1,
        b3dStrides[0]
    ];
    const size = leftDim * rightDim;
    const result = (0, $i64bB.buffer)([
        batchDim,
        leftDim,
        rightDim
    ], a3d.dtype);
    const resVals = result.values;
    const blockSize = backend.blockSize;
    for(let bi = 0; bi < batchDim; bi++){
        const batchIndexA = bi % batchDimA;
        const batchIndexB = bi % batchDimB;
        for(let i0 = 0; i0 < leftDim; i0 += blockSize){
            // for when blockSize doesn't evenly divide the input
            const iBlock = Math.min(i0 + blockSize, leftDim);
            for(let j0 = 0; j0 < rightDim; j0 += blockSize){
                const jBlock = Math.min(j0 + blockSize, rightDim);
                for(let k0 = 0; k0 < sharedDim; k0 += blockSize){
                    const kBlock = Math.min(k0 + blockSize, sharedDim);
                    for(let i = i0; i < iBlock; i++)for(let j = j0; j < jBlock; j++){
                        let sum = 0.0;
                        for(let k = k0; k < kBlock; k++){
                            const aVal = // tslint:disable-next-line: max-line-length
                            a3dValues[batchIndexA * aBatch + i * aOuterStep + k * aInnerStep];
                            const bVal = // tslint:disable-next-line: max-line-length
                            b3dValues[k * bInnerStep + j * bOuterStep + batchIndexB * bBatch];
                            sum += aVal * bVal;
                        }
                        resVals[bi * size + (i * rightDim + j)] += sum;
                    }
                }
            }
        }
    }
    backend.disposeIntermediateTensorInfo(a3d);
    backend.disposeIntermediateTensorInfo(b3d);
    // set correct shape on output.
    return backend.makeTensorInfo(outShape, result.dtype, result.values);
}
const $1f35b9edc36b4c50$export$d0dd993198185538 = {
    kernelName: (0, $i64bB.BatchMatMul),
    backendName: 'cpu',
    kernelFunc: $1f35b9edc36b4c50$export$8f97894b482227f0
};


function $b14ccf0770109385$export$d86ca0bbe0236889(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { a: a, b: b, bias: bias, preluActivationWeights: preluActivationWeights } = inputs;
    const { transposeA: transposeA, transposeB: transposeB, activation: activation, leakyreluAlpha: leakyreluAlpha } = attrs;
    let current;
    let addRes;
    let activationRes;
    const intermediates = [];
    const matMulRes = (0, $1f35b9edc36b4c50$export$8f97894b482227f0)({
        inputs: {
            a: a,
            b: b
        },
        attrs: {
            transposeA: transposeA,
            transposeB: transposeB
        },
        backend: backend
    });
    current = matMulRes;
    if (bias) {
        addRes = (0, $e8yCG.add)({
            inputs: {
                a: current,
                b: bias
            },
            backend: backend
        });
        intermediates.push(current);
        current = addRes;
    }
    if (activation) {
        activationRes = (0, $2e3684d349b4bf60$export$a0f250a2ba84196)(backend, current, activation, preluActivationWeights, leakyreluAlpha);
        intermediates.push(current);
        current = activationRes;
    }
    for (const i of intermediates)backend.disposeIntermediateTensorInfo(i);
    return current;
}
const $b14ccf0770109385$export$f70d36da1c218f84 = {
    kernelName: (0, $i64bB._FusedMatMul),
    backendName: 'cpu',
    kernelFunc: $b14ccf0770109385$export$d86ca0bbe0236889
};



var $ep8sG = parcelRequire("ep8sG");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $l6afd = parcelRequire("l6afd");
const $8ab22af32e0a4a26$export$fd6306be3fde5b04 = (0, $l6afd.unaryKernelFunc)((0, $i64bB.Acos), (xi)=>Math.acos(xi));
const $8ab22af32e0a4a26$export$255826ca70737275 = {
    kernelName: (0, $i64bB.Acos),
    backendName: 'cpu',
    kernelFunc: $8ab22af32e0a4a26$export$fd6306be3fde5b04
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $l6afd = parcelRequire("l6afd");
const $2c892ef40794bb4b$export$b26caf0f29211d08 = (0, $l6afd.unaryKernelFunc)((0, $i64bB.Acosh), (xi)=>Math.acosh(xi));
const $2c892ef40794bb4b$export$3f520b71a56c9e70 = {
    kernelName: (0, $i64bB.Acosh),
    backendName: 'cpu',
    kernelFunc: $2c892ef40794bb4b$export$b26caf0f29211d08
};



var $e8yCG = parcelRequire("e8yCG");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");
function $b425d90a3aee84b9$export$37b75d0026f96b8d(args) {
    const { inputs: inputs, backend: backend } = args;
    const tensors = inputs;
    (0, $csahy.assertNotComplex)(inputs, 'addN');
    const vals = tensors.map((t)=>backend.data.get(t.dataId).values);
    const outBuf = (0, $i64bB.buffer)(tensors[0].shape, tensors[0].dtype);
    const outVals = outBuf.values;
    for(let i = 0; i < tensors.length; i++){
        const currVals = vals[i];
        for(let j = 0; j < outVals.length; j++)outVals[j] += currVals[j];
    }
    return backend.makeTensorInfo(outBuf.shape, outBuf.dtype, outBuf.values);
}
const $b425d90a3aee84b9$export$ff8000bc6f0313e1 = {
    kernelName: (0, $i64bB.AddN),
    backendName: 'cpu',
    kernelFunc: $b425d90a3aee84b9$export$37b75d0026f96b8d
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");


var $EOTYn = parcelRequire("EOTYn");
function $677649d6815f7b0d$export$84bf76cd7afc7469(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    (0, $csahy.assertNotComplex)(x, 'all');
    const origAxes = (0, $i64bB.util).parseAxisParam(axis, x.shape);
    let axes = origAxes;
    const permutedAxes = (0, $i64bB.backend_util).getAxesPermutation(axes, x.shape.length);
    let $x = x;
    if (permutedAxes != null) {
        $x = (0, $EOTYn.transpose)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutedAxes
            }
        });
        axes = (0, $i64bB.backend_util).getInnerMostAxes(axes.length, x.shape.length);
    }
    (0, $i64bB.backend_util).assertAxesAreInnerMostDims('all', axes, $x.shape.length);
    const [outShape, reduceShape] = (0, $i64bB.backend_util).computeOutAndReduceShapes($x.shape, axes);
    const reduceSize = (0, $i64bB.util).sizeFromShape(reduceShape);
    const vals = (0, $i64bB.util).makeZerosTypedArray((0, $i64bB.util).sizeFromShape(outShape), $x.dtype);
    const aVals = backend.data.get($x.dataId).values;
    for(let i = 0; i < vals.length; ++i){
        const offset = i * reduceSize;
        let all = aVals[offset];
        for(let j = 0; j < reduceSize; ++j){
            const value = aVals[offset + j];
            all = all && value;
        }
        vals[i] = all;
    }
    if (permutedAxes != null) backend.disposeIntermediateTensorInfo($x);
    const result = backend.makeTensorInfo(outShape, $x.dtype, vals);
    if (keepDims) {
        const expandedShape = (0, $i64bB.backend_util).expandShapeToKeepDim(outShape, origAxes);
        const reshapedResult = (0, $abec025db4e7e093$export$9eaad88cf88cee2b)({
            inputs: {
                x: result
            },
            backend: backend,
            attrs: {
                shape: expandedShape
            }
        });
        backend.disposeIntermediateTensorInfo(result);
        return reshapedResult;
    }
    return result;
}
const $677649d6815f7b0d$export$4e3f081eb1a330fa = {
    kernelName: (0, $i64bB.All),
    backendName: 'cpu',
    kernelFunc: $677649d6815f7b0d$export$84bf76cd7afc7469
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");


var $EOTYn = parcelRequire("EOTYn");
function $f73b719f10282e8f$export$4154a199d7d90455(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    (0, $csahy.assertNotComplex)(x, 'any');
    const origAxes = (0, $i64bB.util).parseAxisParam(axis, x.shape);
    let axes = origAxes;
    const permutedAxes = (0, $i64bB.backend_util).getAxesPermutation(axes, x.shape.length);
    let $x = x;
    if (permutedAxes != null) {
        $x = (0, $EOTYn.transpose)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutedAxes
            }
        });
        axes = (0, $i64bB.backend_util).getInnerMostAxes(axes.length, x.shape.length);
    }
    (0, $i64bB.backend_util).assertAxesAreInnerMostDims('any', axes, $x.shape.length);
    const [outShape, reduceShape] = (0, $i64bB.backend_util).computeOutAndReduceShapes($x.shape, axes);
    const reduceSize = (0, $i64bB.util).sizeFromShape(reduceShape);
    const vals = (0, $i64bB.util).makeZerosTypedArray((0, $i64bB.util).sizeFromShape(outShape), $x.dtype);
    const aVals = backend.data.get($x.dataId).values;
    for(let i = 0; i < vals.length; ++i){
        const offset = i * reduceSize;
        let anyVal = aVals[offset];
        for(let j = 0; j < reduceSize; ++j){
            const value = aVals[offset + j];
            anyVal = anyVal || value;
        }
        vals[i] = anyVal;
    }
    if (permutedAxes != null) backend.disposeIntermediateTensorInfo($x);
    const result = backend.makeTensorInfo(outShape, $x.dtype, vals);
    if (keepDims) {
        const expandedShape = (0, $i64bB.backend_util).expandShapeToKeepDim(outShape, origAxes);
        const reshapedResult = (0, $abec025db4e7e093$export$9eaad88cf88cee2b)({
            inputs: {
                x: result
            },
            backend: backend,
            attrs: {
                shape: expandedShape
            }
        });
        backend.disposeIntermediateTensorInfo(result);
        return reshapedResult;
    }
    return result;
}
const $f73b719f10282e8f$export$1a8ff634f2df3da6 = {
    kernelName: (0, $i64bB.Any),
    backendName: 'cpu',
    kernelFunc: $f73b719f10282e8f$export$4154a199d7d90455
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");

var $EOTYn = parcelRequire("EOTYn");
function $5eaa7ab354e6d455$export$7980a683c1b852b4(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis } = attrs;
    (0, $csahy.assertNotComplex)(x, 'argMax');
    let axes = (0, $i64bB.util).parseAxisParam(axis, x.shape);
    const permutedAxes = (0, $i64bB.backend_util).getAxesPermutation(axes, x.shape.length);
    let $x = x;
    const intermediateTensorInfos = [];
    if (permutedAxes != null) {
        $x = (0, $EOTYn.transpose)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutedAxes
            }
        });
        intermediateTensorInfos.push($x);
        axes = (0, $i64bB.backend_util).getInnerMostAxes(axes.length, $x.shape.length);
    }
    axes = [
        axes[0]
    ];
    (0, $i64bB.backend_util).assertAxesAreInnerMostDims('argMax', axes, $x.shape.length);
    const [outShape, reduceShape] = (0, $i64bB.backend_util).computeOutAndReduceShapes($x.shape, axes);
    const outSize = (0, $i64bB.util).sizeFromShape(outShape);
    const vals = (0, $i64bB.util).makeZerosTypedArray(outSize, 'int32');
    const reduceSize = (0, $i64bB.util).sizeFromShape(reduceShape);
    const aVals = backend.data.get($x.dataId).values;
    for(let i = 0; i < vals.length; ++i){
        const offset = i * reduceSize;
        let max = aVals[offset];
        let maxIndex = 0;
        for(let j = 0; j < reduceSize; ++j){
            const value = aVals[offset + j];
            if (value > max) {
                max = value;
                maxIndex = j;
            }
        }
        vals[i] = maxIndex;
    }
    intermediateTensorInfos.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return backend.makeTensorInfo(outShape, 'int32', vals);
}
const $5eaa7ab354e6d455$export$ec7419fc9ad0069e = {
    kernelName: (0, $i64bB.ArgMax),
    backendName: 'cpu',
    kernelFunc: $5eaa7ab354e6d455$export$7980a683c1b852b4
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");

var $EOTYn = parcelRequire("EOTYn");
function $f80ee889f51b6cc0$export$ec99a91cddfb29a2(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis } = attrs;
    (0, $csahy.assertNotComplex)(x, 'argMin');
    let axes = (0, $i64bB.util).parseAxisParam(axis, x.shape);
    const permutedAxes = (0, $i64bB.backend_util).getAxesPermutation(axes, x.shape.length);
    let $x = x;
    const intermediateTensorInfos = [];
    if (permutedAxes != null) {
        $x = (0, $EOTYn.transpose)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutedAxes
            }
        });
        intermediateTensorInfos.push($x);
        axes = (0, $i64bB.backend_util).getInnerMostAxes(axes.length, $x.shape.length);
    }
    axes = [
        axes[0]
    ];
    (0, $i64bB.backend_util).assertAxesAreInnerMostDims('argMin', axes, $x.shape.length);
    const [outShape, reduceShape] = (0, $i64bB.backend_util).computeOutAndReduceShapes($x.shape, axes);
    const outSize = (0, $i64bB.util).sizeFromShape(outShape);
    const vals = (0, $i64bB.util).makeZerosTypedArray(outSize, 'int32');
    const reduceSize = (0, $i64bB.util).sizeFromShape(reduceShape);
    const aVals = backend.data.get($x.dataId).values;
    for(let i = 0; i < vals.length; ++i){
        const offset = i * reduceSize;
        let min = aVals[offset];
        let minIndex = 0;
        for(let j = 0; j < reduceSize; ++j){
            const value = aVals[offset + j];
            if (value < min) {
                min = value;
                minIndex = j;
            }
        }
        vals[i] = minIndex;
    }
    intermediateTensorInfos.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return backend.makeTensorInfo(outShape, 'int32', vals);
}
const $f80ee889f51b6cc0$export$21836a5e5fa09eb4 = {
    kernelName: (0, $i64bB.ArgMin),
    backendName: 'cpu',
    kernelFunc: $f80ee889f51b6cc0$export$ec99a91cddfb29a2
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $l6afd = parcelRequire("l6afd");
const $def28fc1ddfc81e6$export$41726bdb1fc63f = (0, $l6afd.unaryKernelFunc)((0, $i64bB.Asin), (xi)=>Math.asin(xi));
const $def28fc1ddfc81e6$export$de5cb0ef95dd6700 = {
    kernelName: (0, $i64bB.Asin),
    backendName: 'cpu',
    kernelFunc: $def28fc1ddfc81e6$export$41726bdb1fc63f
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $l6afd = parcelRequire("l6afd");
const $b64917d0bfd8937f$export$839d8a01b6af4fc0 = (0, $l6afd.unaryKernelFunc)((0, $i64bB.Asinh), (xi)=>Math.asinh(xi));
const $b64917d0bfd8937f$export$20d424616c76166 = {
    kernelName: (0, $i64bB.Asinh),
    backendName: 'cpu',
    kernelFunc: $b64917d0bfd8937f$export$839d8a01b6af4fc0
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $l6afd = parcelRequire("l6afd");
const $b1539910302f7e24$export$628dc4eed22b0fbd = (0, $l6afd.unaryKernelFunc)((0, $i64bB.Atan), (xi)=>Math.atan(xi));
const $b1539910302f7e24$export$159d632e3ff13624 = {
    kernelName: (0, $i64bB.Atan),
    backendName: 'cpu',
    kernelFunc: $b1539910302f7e24$export$628dc4eed22b0fbd
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $jQJ39 = parcelRequire("jQJ39");

var $kgSwn = parcelRequire("kgSwn");
const $68efd56ecaa2a8cc$export$2420f4f902e099a2 = (0, $jQJ39.createSimpleBinaryKernelImpl)((aValue, bValue)=>Math.atan2(aValue, bValue));
const $68efd56ecaa2a8cc$export$b8b770ee6a0d9760 = (0, $kgSwn.binaryKernelFunc)((0, $i64bB.Atan2), $68efd56ecaa2a8cc$export$2420f4f902e099a2);
const $68efd56ecaa2a8cc$export$c53c7ab019edb8a0 = {
    kernelName: (0, $i64bB.Atan2),
    backendName: 'cpu',
    kernelFunc: $68efd56ecaa2a8cc$export$b8b770ee6a0d9760
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $l6afd = parcelRequire("l6afd");
const $4cde3dd073a9865a$export$21ea955025ceb08b = (0, $l6afd.unaryKernelFunc)((0, $i64bB.Atanh), (xi)=>Math.atanh(xi));
const $4cde3dd073a9865a$export$e9ce1ba75fc9b746 = {
    kernelName: (0, $i64bB.Atanh),
    backendName: 'cpu',
    kernelFunc: $4cde3dd073a9865a$export$21ea955025ceb08b
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
function $e9280844b6abe1d7$export$7a0e2789ec54f0db(xValues, xShape, dtype, strides, convInfo, poolType) {
    const strideHeight = convInfo.strideHeight;
    const strideWidth = convInfo.strideWidth;
    const dilationHeight = convInfo.dilationHeight;
    const dilationWidth = convInfo.dilationWidth;
    const effectiveFilterHeight = convInfo.effectiveFilterHeight;
    const effectiveFilterWidth = convInfo.effectiveFilterWidth;
    const padTop = convInfo.padInfo.top;
    const padLeft = convInfo.padInfo.left;
    const initialValue = poolType === 'max' ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY;
    const output = (0, $i64bB.buffer)(convInfo.outShape, dtype);
    const outputVals = output.values;
    const outputBatchStrides = convInfo.outShape[1] * convInfo.outShape[2] * convInfo.outShape[3];
    const outputRowStrides = convInfo.outShape[2] * convInfo.outShape[3];
    const outputColStrides = convInfo.outShape[3];
    for(let b = 0; b < convInfo.batchSize; ++b){
        const outputBatchOffset = b * outputBatchStrides;
        const inputBatchOffset = b * strides[0];
        for(let d = 0; d < convInfo.inChannels; ++d)for(let yR = 0; yR < convInfo.outHeight; ++yR){
            const xRCorner = yR * strideHeight - padTop;
            const xRMin = Math.max(0, xRCorner);
            const xRMax = Math.min(convInfo.inHeight, effectiveFilterHeight + xRCorner);
            const outputRowOffset = outputBatchOffset + yR * outputRowStrides;
            for(let yC = 0; yC < convInfo.outWidth; ++yC){
                const xCCorner = yC * strideWidth - padLeft;
                const xCMin = Math.max(0, xCCorner);
                const xCMax = Math.min(convInfo.inWidth, effectiveFilterWidth + xCCorner);
                let minMaxValue = initialValue;
                let avgValue = 0;
                let count = 0;
                for(let xR = xRMin; xR < xRMax; xR += dilationHeight){
                    const xROffset = inputBatchOffset + xR * strides[1];
                    for(let xC = xCMin; xC < xCMax; xC += dilationWidth){
                        const xCOffset = xROffset + xC * strides[2];
                        const pixel = xValues[xCOffset + d];
                        if (poolType === 'max' && pixel > minMaxValue) minMaxValue = pixel;
                        else if (poolType === 'avg') {
                            avgValue += pixel;
                            count++;
                        }
                    }
                    if (isNaN(minMaxValue)) break;
                }
                const outputOffset = outputRowOffset + yC * outputColStrides + d;
                outputVals[outputOffset] = poolType === 'avg' ? avgValue / count : minMaxValue;
            }
        }
    }
    return output;
}
function $e9280844b6abe1d7$export$60b78444d0fe518d(xValues, xShape, dtype, convInfo, flattenPositions = false, includeBatchInIndex = false) {
    const maxPositions = (0, $i64bB.buffer)(convInfo.outShape, 'int32');
    const strideHeight = convInfo.strideHeight;
    const strideWidth = convInfo.strideWidth;
    const dilationHeight = convInfo.dilationHeight;
    const dilationWidth = convInfo.dilationWidth;
    const effectiveFilterHeight = convInfo.effectiveFilterHeight;
    const effectiveFilterWidth = convInfo.effectiveFilterWidth;
    const padTop = convInfo.padInfo.top;
    const padLeft = convInfo.padInfo.left;
    const xBuf = (0, $i64bB.buffer)(xShape, dtype, xValues);
    for(let b = 0; b < convInfo.batchSize; ++b){
        for(let d = 0; d < convInfo.inChannels; ++d)for(let yR = 0; yR < convInfo.outHeight; ++yR){
            const xRCorner = yR * strideHeight - padTop;
            let xRMin = xRCorner;
            while(xRMin < 0)xRMin += dilationHeight;
            // const xRMin = Math.max(0, xRCorner);
            const xRMax = Math.min(convInfo.inHeight, effectiveFilterHeight + xRCorner);
            for(let yC = 0; yC < convInfo.outWidth; ++yC){
                const xCCorner = yC * strideWidth - padLeft;
                let xCMin = xCCorner;
                while(xCMin < 0)xCMin += dilationWidth;
                const xCMax = Math.min(convInfo.inWidth, effectiveFilterWidth + xCCorner);
                let maxValue = Number.NEGATIVE_INFINITY;
                let maxPosition = -1;
                for(let xR = xRMin; xR < xRMax; xR += dilationHeight){
                    const wR = xR - xRCorner;
                    for(let xC = xCMin; xC < xCMax; xC += dilationWidth){
                        const wC = xC - xCCorner;
                        // For some reason, disable-next-line is not working
                        // TODO(mattsoulanille): Remove this when switching to TS5.
                        /* tslint:disable: no-unnecessary-type-assertion */ const pixel = xBuf.get(b, xR, xC, d);
                        if (pixel > maxValue) {
                            maxValue = pixel;
                            if (flattenPositions) maxPosition = includeBatchInIndex ? ((b * convInfo.inHeight + xR) * convInfo.inWidth + xC) * convInfo.inChannels + d : (xR * convInfo.inWidth + xC) * convInfo.inChannels + d;
                            else maxPosition = wR * effectiveFilterWidth + wC;
                        }
                    }
                }
                maxPositions.set(maxPosition, b, yR, yC, d);
            }
        }
    }
    return maxPositions;
}
function $e9280844b6abe1d7$export$3712ebf21d29ff82(xValues, xShape, dtype, strides, convInfo, poolType) {
    const strideDepth = convInfo.strideDepth;
    const strideHeight = convInfo.strideHeight;
    const strideWidth = convInfo.strideWidth;
    const dilationDepth = convInfo.dilationDepth;
    const dilationHeight = convInfo.dilationHeight;
    const dilationWidth = convInfo.dilationWidth;
    const effectiveFilterDepth = convInfo.effectiveFilterDepth;
    const effectiveFilterHeight = convInfo.effectiveFilterHeight;
    const effectiveFilterWidth = convInfo.effectiveFilterWidth;
    const padFront = convInfo.padInfo.front;
    const padTop = convInfo.padInfo.top;
    const padLeft = convInfo.padInfo.left;
    const initialValue = poolType === 'max' ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY;
    const output = (0, $i64bB.buffer)(convInfo.outShape, dtype);
    const outputVals = output.values;
    const outputBatchStrides = convInfo.outShape[1] * convInfo.outShape[2] * convInfo.outShape[3] * convInfo.outShape[4];
    const outputDepthStrides = convInfo.outShape[2] * convInfo.outShape[3] * convInfo.outShape[4];
    const outputRowStrides = convInfo.outShape[3] * convInfo.outShape[4];
    const outputColStrides = convInfo.outShape[4];
    for(let batch = 0; batch < convInfo.batchSize; ++batch){
        const outputBatchOffset = batch * outputBatchStrides;
        const inputBatchOffset = batch * strides[0];
        for(let channel = 0; channel < convInfo.inChannels; ++channel)for(let yDepth = 0; yDepth < convInfo.outDepth; ++yDepth){
            const xDepthCorner = yDepth * strideDepth - padFront;
            let xDepthMin = xDepthCorner;
            while(xDepthMin < 0)xDepthMin += dilationDepth;
            const xDepthMax = Math.min(convInfo.inDepth, effectiveFilterDepth + xDepthCorner);
            const outputDepthOffset = outputBatchOffset + yDepth * outputDepthStrides;
            for(let yRow = 0; yRow < convInfo.outHeight; ++yRow){
                const xRowCorner = yRow * strideHeight - padTop;
                let xRowMin = xRowCorner;
                while(xRowMin < 0)xRowMin += dilationHeight;
                const xRowMax = Math.min(convInfo.inHeight, effectiveFilterHeight + xRowCorner);
                const outputRowOffset = outputDepthOffset + yRow * outputRowStrides;
                for(let yCol = 0; yCol < convInfo.outWidth; ++yCol){
                    const xColCorner = yCol * strideWidth - padLeft;
                    let xColMin = xColCorner;
                    while(xColMin < 0)xColMin += dilationWidth;
                    const xColMax = Math.min(convInfo.inWidth, effectiveFilterWidth + xColCorner);
                    // Shader code begins
                    const outputColOffset = outputRowOffset + yCol * outputColStrides;
                    let minMaxValue = initialValue;
                    let avgValue = 0;
                    let count = 0;
                    for(let xDepth = xDepthMin; xDepth < xDepthMax; xDepth += dilationDepth){
                        const xDepthOffset = inputBatchOffset + xDepth * strides[1];
                        for(let xRow = xRowMin; xRow < xRowMax; xRow += dilationHeight){
                            const xRowOffset = xDepthOffset + xRow * strides[2];
                            for(let xCol = xColMin; xCol < xColMax; xCol += dilationWidth){
                                const xColOffset = xRowOffset + xCol * strides[3];
                                const pixel = xValues[xColOffset + channel];
                                if (poolType === 'max' && pixel > minMaxValue) minMaxValue = pixel;
                                else if (poolType === 'avg') {
                                    avgValue += pixel;
                                    count++;
                                }
                                if (isNaN(minMaxValue)) break;
                            }
                            if (isNaN(minMaxValue)) break;
                        }
                        if (isNaN(minMaxValue)) break;
                    }
                    const outputOffset = outputColOffset + channel;
                    outputVals[outputOffset] = poolType === 'avg' ? avgValue / Math.max(count, 1) : minMaxValue;
                }
            }
        }
    }
    return output;
}
function $e9280844b6abe1d7$export$e389a84eda2bb69e(xBuf, convInfo) {
    const maxPositions = (0, $i64bB.buffer)(convInfo.outShape, 'int32');
    const strideDepth = convInfo.strideDepth;
    const strideHeight = convInfo.strideHeight;
    const strideWidth = convInfo.strideWidth;
    const dilationDepth = convInfo.dilationDepth;
    const dilationHeight = convInfo.dilationHeight;
    const dilationWidth = convInfo.dilationWidth;
    const effectiveFilterDepth = convInfo.effectiveFilterDepth;
    const effectiveFilterHeight = convInfo.effectiveFilterHeight;
    const effectiveFilterWidth = convInfo.effectiveFilterWidth;
    const padFront = convInfo.padInfo.front;
    const padTop = convInfo.padInfo.top;
    const padLeft = convInfo.padInfo.left;
    for(let batch = 0; batch < convInfo.batchSize; ++batch){
        for(let channel = 0; channel < convInfo.inChannels; ++channel)for(let yDepth = 0; yDepth < convInfo.outDepth; ++yDepth){
            const xDepthCorner = yDepth * strideDepth - padFront;
            let xDepthMin = xDepthCorner;
            while(xDepthMin < 0)xDepthMin += dilationDepth;
            const xDepthMax = Math.min(convInfo.inDepth, effectiveFilterDepth + xDepthCorner);
            for(let yRow = 0; yRow < convInfo.outHeight; ++yRow){
                const xRowCorner = yRow * strideHeight - padTop;
                let xRowMin = xRowCorner;
                while(xRowMin < 0)xRowMin += dilationHeight;
                const xRowMax = Math.min(convInfo.inHeight, effectiveFilterHeight + xRowCorner);
                for(let yCol = 0; yCol < convInfo.outWidth; ++yCol){
                    const xColCorner = yCol * strideWidth - padLeft;
                    let xColMin = xColCorner;
                    while(xColMin < 0)xColMin += dilationWidth;
                    const xColMax = Math.min(convInfo.inWidth, effectiveFilterWidth + xColCorner);
                    // Shader code begins
                    let maxValue = Number.NEGATIVE_INFINITY;
                    let maxPosition = -1;
                    for(let xDepth = xDepthMin; xDepth < xDepthMax; xDepth += dilationDepth){
                        const wDepth = xDepth - xDepthCorner;
                        for(let xRow = xRowMin; xRow < xRowMax; xRow += dilationHeight){
                            const wRow = xRow - xRowCorner;
                            for(let xCol = xColMin; xCol < xColMax; xCol += dilationWidth){
                                const wCol = xCol - xColCorner;
                                const pixel = xBuf.get(batch, xDepth, xRow, xCol, channel);
                                if (pixel >= maxValue) {
                                    maxValue = pixel;
                                    maxPosition = wDepth * effectiveFilterHeight * effectiveFilterWidth + wRow * effectiveFilterHeight + wCol;
                                }
                            }
                        }
                    }
                    maxPositions.set(maxPosition, batch, yDepth, yRow, yCol, channel);
                }
            }
        }
    }
    return maxPositions;
}



var $lcqBv = parcelRequire("lcqBv");
function $294b48d57f4be026$export$d5c65a2abd3d97dc(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    (0, $csahy.assertNotComplex)(x, 'avgPool');
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    const dilations = 1;
    (0, $i64bB.util).assert((0, $i64bB.backend_util).eitherStridesOrDilationsAreOne(strides, dilations), ()=>'Error in avgPool: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    const convInfo = (0, $i64bB.backend_util).computePool2DInfo(x.shape, filterSize, strides, dilations, pad, dimRoundingMode);
    let res;
    if (convInfo.filterWidth === 1 && convInfo.filterHeight === 1 && (0, $i64bB.util).arraysEqual(convInfo.inShape, convInfo.outShape)) res = (0, $lcqBv.identity)({
        inputs: {
            x: x
        },
        backend: backend
    });
    else {
        const xValues = backend.data.get(x.dataId).values;
        const strides = (0, $i64bB.util).computeStrides(x.shape);
        const buffer = (0, $e9280844b6abe1d7$export$7a0e2789ec54f0db)(xValues, x.shape, x.dtype, strides, convInfo, 'avg');
        res = backend.makeTensorInfo(convInfo.outShape, x.dtype, buffer.values);
    }
    return res;
}
const $294b48d57f4be026$export$6c901824a23e6150 = {
    kernelName: (0, $i64bB.AvgPool),
    backendName: 'cpu',
    kernelFunc: $294b48d57f4be026$export$d5c65a2abd3d97dc
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");

function $05891176cdea595d$export$8e92f7d23b27f144(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode, dataFormat: dataFormat } = attrs;
    (0, $csahy.assertNotComplex)(x, 'avgPool3d');
    const convInfo = (0, $i64bB.backend_util).computePool3DInfo(x.shape, filterSize, strides, 1 /* dilations */ , pad, dimRoundingMode, dataFormat);
    const xValues = backend.data.get(x.dataId).values;
    const outBuf = (0, $e9280844b6abe1d7$export$3712ebf21d29ff82)(xValues, x.shape, x.dtype, (0, $i64bB.util).computeStrides(x.shape), convInfo, 'avg');
    return backend.makeTensorInfo(outBuf.shape, 'float32', outBuf.values);
}
const $05891176cdea595d$export$5a9c81d240244392 = {
    kernelName: (0, $i64bB.AvgPool3D),
    backendName: 'cpu',
    kernelFunc: $05891176cdea595d$export$8e92f7d23b27f144
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");
function $39b08ff2cf4451c5$export$798cb4034e996ff4(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, input: input } = inputs;
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    (0, $csahy.assertNotComplex)([
        dy,
        input
    ], 'avgPool3DGrad');
    const convInfo = (0, $i64bB.backend_util).computePool3DInfo(input.shape, filterSize, strides, 1 /* dilations */ , pad, dimRoundingMode);
    const strideDepth = convInfo.strideDepth;
    const strideHeight = convInfo.strideHeight;
    const strideWidth = convInfo.strideWidth;
    const filterDepth = convInfo.filterDepth;
    const filterHeight = convInfo.filterHeight;
    const filterWidth = convInfo.filterWidth;
    const dilationDepth = convInfo.dilationDepth;
    const dilationHeight = convInfo.dilationHeight;
    const dilationWidth = convInfo.dilationWidth;
    const effectiveFilterDepth = convInfo.effectiveFilterDepth;
    const effectiveFilterHeight = convInfo.effectiveFilterHeight;
    const effectiveFilterWidth = convInfo.effectiveFilterWidth;
    const padFront = effectiveFilterDepth - 1 - convInfo.padInfo.front;
    const padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
    const padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
    const dx = (0, $i64bB.buffer)(input.shape, 'float32');
    const avgMultiplier = 1 / (filterDepth * filterHeight * filterWidth);
    const dyBuf = backend.bufferSync(dy);
    for(let batch = 0; batch < convInfo.batchSize; ++batch){
        for(let channel = 0; channel < convInfo.inChannels; ++channel)for(let dxDepth = 0; dxDepth < convInfo.inDepth; ++dxDepth){
            for(let dxRow = 0; dxRow < convInfo.inHeight; ++dxRow)for(let dxCol = 0; dxCol < convInfo.inWidth; ++dxCol){
                // Shader code begins.
                const dyDepthCorner = dxDepth - padFront;
                const dyRowCorner = dxRow - padTop;
                const dyColCorner = dxCol - padLeft;
                let dotProd = 0;
                for(let wDepth = 0; wDepth < effectiveFilterDepth; wDepth += dilationDepth){
                    const dyDepth = (dyDepthCorner + wDepth) / strideDepth;
                    if (dyDepth < 0 || dyDepth >= convInfo.outDepth || Math.floor(dyDepth) !== dyDepth) continue;
                    for(let wRow = 0; wRow < effectiveFilterHeight; wRow += dilationHeight){
                        const dyRow = (dyRowCorner + wRow) / strideHeight;
                        if (dyRow < 0 || dyRow >= convInfo.outHeight || Math.floor(dyRow) !== dyRow) continue;
                        for(let wCol = 0; wCol < effectiveFilterWidth; wCol += dilationWidth){
                            const dyCol = (dyColCorner + wCol) / strideWidth;
                            if (dyCol < 0 || dyCol >= convInfo.outWidth || Math.floor(dyCol) !== dyCol) continue;
                            const pixel = dyBuf.get(batch, dyDepth, dyRow, dyCol, channel);
                            dotProd += pixel;
                        }
                    }
                }
                dx.set(dotProd * avgMultiplier, batch, dxDepth, dxRow, dxCol, channel);
            }
        }
    }
    return backend.makeTensorInfo(dx.shape, dx.dtype, dx.values);
}
const $39b08ff2cf4451c5$export$1eeb8780807d0508 = {
    kernelName: (0, $i64bB.AvgPool3DGrad),
    backendName: 'cpu',
    kernelFunc: $39b08ff2cf4451c5$export$798cb4034e996ff4
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");
function $44da085f019c43ff$export$2f098171d1c79aea(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, input: input } = inputs;
    const x = input;
    (0, $csahy.assertNotComplex)([
        dy,
        input
    ], 'avgPoolGrad');
    const { filterSize: filterSize, strides: strides, pad: pad } = attrs;
    const convInfo = (0, $i64bB.backend_util).computePool2DInfo(x.shape, filterSize, strides, 1 /* dilations */ , pad);
    const strideHeight = convInfo.strideHeight;
    const strideWidth = convInfo.strideWidth;
    const filterHeight = convInfo.filterHeight;
    const filterWidth = convInfo.filterWidth;
    const dilationHeight = convInfo.dilationHeight;
    const dilationWidth = convInfo.dilationWidth;
    const effectiveFilterHeight = convInfo.effectiveFilterHeight;
    const effectiveFilterWidth = convInfo.effectiveFilterWidth;
    const padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
    const padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
    const dx = (0, $i64bB.buffer)(x.shape, 'float32');
    const avgMultiplier = 1 / (filterHeight * filterWidth);
    const dyData = backend.data.get(dy.dataId).values;
    const dyBuf = (0, $i64bB.buffer)(dy.shape, 'float32', dyData);
    for(let b = 0; b < convInfo.batchSize; ++b)for(let d = 0; d < convInfo.inChannels; ++d){
        for(let dxR = 0; dxR < convInfo.inHeight; ++dxR)for(let dxC = 0; dxC < convInfo.inWidth; ++dxC){
            // Shader code begins.
            const dyRCorner = dxR - padTop;
            const dyCCorner = dxC - padLeft;
            let dotProd = 0;
            for(let wR = 0; wR < effectiveFilterHeight; wR += dilationHeight){
                const dyR = (dyRCorner + wR) / strideHeight;
                if (dyR < 0 || dyR >= convInfo.outHeight || Math.floor(dyR) !== dyR) continue;
                for(let wC = 0; wC < effectiveFilterWidth; wC += dilationWidth){
                    const dyC = (dyCCorner + wC) / strideWidth;
                    if (dyC < 0 || dyC >= convInfo.outWidth || Math.floor(dyC) !== dyC) continue;
                    const pixel = dyBuf.get(b, dyR, dyC, d);
                    dotProd += pixel;
                }
            }
            dx.set(dotProd * avgMultiplier, b, dxR, dxC, d);
        }
    }
    return backend.makeTensorInfo(dx.shape, dx.dtype, dx.values);
}
const $44da085f019c43ff$export$ac3f8709351ab225 = {
    kernelName: (0, $i64bB.AvgPoolGrad),
    backendName: 'cpu',
    kernelFunc: $44da085f019c43ff$export$2f098171d1c79aea
};



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");
function $bebb632d95232ffb$export$8ea8088e6d0cdd02(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, scale: scale, offset: offset, mean: mean, variance: variance } = inputs;
    (0, $i64bB.util).assert(mean.shape.length === variance.shape.length, ()=>"Batch normalization gradient requires mean and variance to have equal ranks.");
    (0, $i64bB.util).assert(offset == null || mean.shape.length === offset.shape.length, ()=>"Batch normalization gradient requires mean and offset to have equal ranks.");
    (0, $i64bB.util).assert(scale == null || mean.shape.length === scale.shape.length, ()=>"Batch normalization gradient requires mean and scale to have equal ranks.");
    (0, $csahy.assertNotComplex)([
        x,
        mean,
        variance,
        scale,
        offset
    ], 'batchNorm');
    let { varianceEpsilon: varianceEpsilon } = attrs;
    if (varianceEpsilon == null) varianceEpsilon = 0.001;
    const xVals = backend.data.get(x.dataId).values;
    const mVals = backend.data.get(mean.dataId).values;
    const varVals = backend.data.get(variance.dataId).values;
    const sVals = scale ? backend.data.get(scale.dataId).values : new Float32Array([
        1
    ]);
    const offVals = offset ? backend.data.get(offset.dataId).values : new Float32Array([
        0
    ]);
    const outVals = new Float32Array(xVals.length);
    const offValsLength = offVals.length;
    const sValsLength = sVals.length;
    const varValsLength = varVals.length;
    const mValsLength = mVals.length;
    let offi = 0;
    let mi = 0;
    let si = 0;
    let vi = 0;
    for(let i = 0; i < xVals.length; ++i){
        outVals[i] = offVals[offi++] + (xVals[i] - mVals[mi++]) * sVals[si++] / Math.sqrt(varVals[vi++] + varianceEpsilon);
        if (offi >= offValsLength) offi = 0;
        if (mi >= mValsLength) mi = 0;
        if (si >= sValsLength) si = 0;
        if (vi >= varValsLength) vi = 0;
    }
    return backend.makeTensorInfo(x.shape, x.dtype, outVals);
}
const $bebb632d95232ffb$export$df2dc5c7a755e418 = {
    kernelName: (0, $i64bB.FusedBatchNorm),
    backendName: 'cpu',
    kernelFunc: $bebb632d95232ffb$export$8ea8088e6d0cdd02
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");


var $aYBRE = parcelRequire("aYBRE");

var $EOTYn = parcelRequire("EOTYn");
function $ff970e8b72618187$export$ea37d960c1808536(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { blockShape: blockShape, crops: crops } = attrs;
    (0, $csahy.assertNotComplex)([
        x
    ], 'batchToSpaceND');
    const prod = blockShape.reduce((a, b)=>a * b);
    const reshaped = (0, $i64bB.backend_util).getReshaped(x.shape, blockShape, prod);
    const permuted = (0, $i64bB.backend_util).getPermuted(reshaped.length, blockShape.length);
    const reshapedPermuted = (0, $i64bB.backend_util).getReshapedPermuted(x.shape, blockShape, prod);
    const sliceBeginCoords = (0, $i64bB.backend_util).getSliceBeginCoords(crops, blockShape.length);
    const sliceSize = (0, $i64bB.backend_util).getSliceSize(reshapedPermuted, crops, blockShape.length);
    const xReshaped = (0, $abec025db4e7e093$export$9eaad88cf88cee2b)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            shape: reshaped
        }
    });
    const xTransposed = (0, $EOTYn.transpose)({
        inputs: {
            x: xReshaped
        },
        backend: backend,
        attrs: {
            perm: permuted
        }
    });
    const xTransposedReshaped = (0, $abec025db4e7e093$export$9eaad88cf88cee2b)({
        inputs: {
            x: xTransposed
        },
        backend: backend,
        attrs: {
            shape: reshapedPermuted
        }
    });
    const result = (0, $aYBRE.slice)({
        inputs: {
            x: xTransposedReshaped
        },
        backend: backend,
        attrs: {
            begin: sliceBeginCoords,
            size: sliceSize
        }
    });
    backend.disposeIntermediateTensorInfo(xReshaped);
    backend.disposeIntermediateTensorInfo(xTransposed);
    backend.disposeIntermediateTensorInfo(xTransposedReshaped);
    return result;
}
const $ff970e8b72618187$export$44e08e19f97e5513 = {
    kernelName: (0, $i64bB.BatchToSpaceND),
    backendName: 'cpu',
    kernelFunc: $ff970e8b72618187$export$ea37d960c1808536
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $34gHf = parcelRequire("34gHf");
function $a5ee11d42e3cdab3$export$7e474bab088ed182(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, weights: weights } = inputs;
    const { size: size } = attrs;
    const xVals = backend.data.get(x.dataId).values;
    const weightsVals = backend.data.get(weights.dataId).values;
    const outVals = (0, $34gHf.bincountImpl)(xVals, weightsVals, weights.dtype, weights.shape, size);
    return backend.makeTensorInfo([
        size
    ], weights.dtype, outVals);
}
const $a5ee11d42e3cdab3$export$af9f0093738840fb = {
    kernelName: (0, $i64bB.Bincount),
    backendName: 'cpu',
    kernelFunc: $a5ee11d42e3cdab3$export$7e474bab088ed182
};



var $eYl2h = parcelRequire("eYl2h");
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
function $7ea71d038e9fa638$export$d226d344aedce941(args) {
    const { inputs: inputs, backend: backend } = args;
    const { s0: s0, s1: s1 } = inputs;
    const s0Vals = backend.data.get(s0.dataId).values;
    const s1Vals = backend.data.get(s1.dataId).values;
    const broadcastShape = (0, $i64bB.backend_util).assertAndGetBroadcastShape(Array.from(s0Vals), Array.from(s1Vals));
    return backend.makeTensorInfo([
        broadcastShape.length
    ], 'int32', Int32Array.from(broadcastShape));
}
const $7ea71d038e9fa638$export$8f7b2ec0c6f08fb2 = {
    kernelName: (0, $i64bB.BroadcastArgs),
    backendName: 'cpu',
    kernelFunc: $7ea71d038e9fa638$export$d226d344aedce941
};



var $7LLjQ = parcelRequire("7LLjQ");

var $bs8Xr = parcelRequire("bs8Xr");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $l6afd = parcelRequire("l6afd");
const $c5d6f1913dfc8e32$export$fa97baf70ad024c0 = (0, $l6afd.unaryKernelFunc)((0, $i64bB.ClipByValue), (xi, attrs)=>{
    const clipAttrs = attrs;
    if (xi > clipAttrs.clipValueMax) return clipAttrs.clipValueMax;
    return xi < clipAttrs.clipValueMin ? clipAttrs.clipValueMin : xi;
});
const $c5d6f1913dfc8e32$export$f7ee8f07ce0ff4e1 = {
    kernelName: (0, $i64bB.ClipByValue),
    backendName: 'cpu',
    kernelFunc: $c5d6f1913dfc8e32$export$fa97baf70ad024c0
};



var $bwMVz = parcelRequire("bwMVz");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
const $87d587b356a80841$export$2837bc62566f8808 = (args)=>{
    const { x: x } = args.inputs;
    const cpuBackend = args.backend;
    const resultValues = new Float32Array((0, $i64bB.util).sizeFromShape(x.shape));
    const complexVals = cpuBackend.data.get(x.dataId);
    const real = complexVals.complexTensorInfos.real;
    const imag = complexVals.complexTensorInfos.imag;
    const realVals = cpuBackend.data.get(real.dataId).values;
    const imagVals = cpuBackend.data.get(imag.dataId).values;
    for(let i = 0; i < realVals.length; i++){
        const real = realVals[i];
        const imag = imagVals[i];
        resultValues[i] = Math.hypot(real, imag);
    }
    return cpuBackend.makeOutput(resultValues, x.shape, 'float32');
};
const $87d587b356a80841$export$a4817d2978acc054 = {
    kernelName: (0, $i64bB.ComplexAbs),
    backendName: 'cpu',
    kernelFunc: $87d587b356a80841$export$2837bc62566f8808
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $bwMVz = parcelRequire("bwMVz");

var $3wcyL = parcelRequire("3wcyL");

var $lcqBv = parcelRequire("lcqBv");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
function $235b2b9db5d2b70b$export$d78fab5778ab392b(args) {
    const { inputs: inputs, backend: backend } = args;
    const { input: input } = inputs;
    const imag = backend.data.get(input.dataId).complexTensorInfos.imag;
    const imagVal = backend.data.get(imag.dataId).values;
    // When complex tensor is disposed, its underlying parts will be disposed too.
    // Make new tensor out of the imag value of the complex. This makes sure the
    // value is still accessible even if complex tensor is disposed.
    return backend.makeTensorInfo(imag.shape, imag.dtype, imagVal);
}
const $235b2b9db5d2b70b$export$ddfc128c2801add7 = {
    kernelName: (0, $i64bB.Imag),
    backendName: 'cpu',
    kernelFunc: $235b2b9db5d2b70b$export$d78fab5778ab392b
};



var $linqd = parcelRequire("linqd");

function $3284dfd9bccede0e$export$ee1b3e54f0441b22(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { axis: axis } = attrs;
    const $axis = (0, $i64bB.util).parseAxisParam(axis, inputs[0].shape)[0];
    const shapes = inputs.map((t)=>t.shape);
    (0, $i64bB.backend_util).assertParamsConsistent(shapes, $axis);
    let outShape = (0, $i64bB.backend_util).computeOutShape(inputs.map((t)=>t.shape), $axis);
    if ((0, $i64bB.util).sizeFromShape(outShape) === 0) return backend.makeTensorInfo(outShape, inputs[0].dtype, []);
    // Keep only non-empty tensors (ignore tensors with 0 in their shape).
    const $inputs = inputs.filter((t)=>(0, $i64bB.util).sizeFromShape(t.shape) > 0);
    if ($inputs.length === 1) return (0, $lcqBv.identity)({
        inputs: {
            x: $inputs[0]
        },
        backend: backend
    });
    if ($inputs[0].dtype === 'complex64') {
        const reals = $inputs.map((t)=>(0, $linqd.real)({
                inputs: {
                    input: t
                },
                backend: backend
            }));
        const imags = $inputs.map((t)=>(0, $235b2b9db5d2b70b$export$d78fab5778ab392b)({
                inputs: {
                    input: t
                },
                backend: backend
            }));
        const realConcated = $3284dfd9bccede0e$export$ee1b3e54f0441b22({
            inputs: reals,
            backend: backend,
            attrs: {
                axis: $axis
            }
        });
        const imagConcated = $3284dfd9bccede0e$export$ee1b3e54f0441b22({
            inputs: imags,
            backend: backend,
            attrs: {
                axis: $axis
            }
        });
        const result = (0, $bwMVz.complex)({
            inputs: {
                real: realConcated,
                imag: imagConcated
            },
            backend: backend
        });
        reals.forEach((r)=>backend.disposeIntermediateTensorInfo(r));
        imags.forEach((i)=>backend.disposeIntermediateTensorInfo(i));
        backend.disposeIntermediateTensorInfo(realConcated);
        backend.disposeIntermediateTensorInfo(imagConcated);
        return result;
    }
    // Any concat of n-dimensional tensors across any axis can be reduced to
    // a concatenation of two-dimensional tensors across the axis 1 by first
    // partitioning the axes of the original tensors into those less than the
    // axis to be concatenated and the rest. Then reshape the tensors
    // into a two-dimensional tensor by collapsing these two sets of axes and
    // concatenate the resulting matrices across the axis 1, finally reshaping
    // the result to have the proper shape.
    const inputs2D = $inputs.map((t)=>{
        const innerSize = (0, $i64bB.util).sizeFromShape(t.shape.slice($axis));
        const shape = [
            -1,
            innerSize
        ];
        return (0, $abec025db4e7e093$export$9eaad88cf88cee2b)({
            inputs: {
                x: t
            },
            backend: backend,
            attrs: {
                shape: shape
            }
        });
    });
    const inputsValShapes = inputs2D.map((t)=>{
        return {
            vals: backend.data.get(t.dataId).values,
            shape: t.shape
        };
    });
    // Concats 2d tensors along axis=1.
    outShape = (0, $i64bB.backend_util).computeOutShape(inputs2D.map((t)=>t.shape), 1 /* axis */ );
    const simplyConcat = inputs2D[0].shape[0] === 1;
    const outVals = (0, $3wcyL.concatImpl)(inputsValShapes, outShape, inputs[0].dtype, simplyConcat);
    const finalOutShape = (0, $i64bB.backend_util).computeOutShape($inputs.map((t)=>t.shape), $axis);
    const outInfo = backend.makeTensorInfo(finalOutShape, inputs[0].dtype, outVals);
    inputs2D.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return outInfo;
}
const $3284dfd9bccede0e$export$c8cf96dae25282e5 = {
    kernelName: (0, $i64bB.Concat),
    backendName: 'cpu',
    kernelFunc: $3284dfd9bccede0e$export$ee1b3e54f0441b22
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");
function $33872f5c298aaa1e$export$5a2ce5b05041d9e4(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter } = inputs;
    const { strides: strides, pad: pad, dataFormat: dataFormat, dilations: dilations, dimRoundingMode: dimRoundingMode } = attrs;
    (0, $csahy.assertNotComplex)([
        x,
        filter
    ], 'conv2d');
    const $dataFormat = (0, $i64bB.backend_util).convertConv2DDataFormat(dataFormat);
    const convInfo = (0, $i64bB.backend_util).computeConv2DInfo(x.shape, filter.shape, strides, dilations, pad, dimRoundingMode, false, $dataFormat);
    const filterHeight = convInfo.filterHeight;
    const filterWidth = convInfo.filterWidth;
    const dilationHeight = convInfo.dilationHeight;
    const dilationWidth = convInfo.dilationWidth;
    const padLeft = convInfo.padInfo.left;
    const padTop = convInfo.padInfo.top;
    const isChannelsLast = convInfo.dataFormat === 'channelsLast';
    const y = new (0, $i64bB.TensorBuffer)(convInfo.outShape, x.dtype);
    const xStrides = (0, $i64bB.util).computeStrides(x.shape);
    const filterStrides = (0, $i64bB.util).computeStrides(filter.shape);
    const xBatchStride = xStrides[0];
    const xRowStride = isChannelsLast ? xStrides[1] : xStrides[2];
    const xColStride = isChannelsLast ? xStrides[2] : 1;
    const xChannelStride = isChannelsLast ? 1 : xStrides[1];
    const yBatchStride = y.strides[0];
    const yRowStride = isChannelsLast ? y.strides[1] : y.strides[2];
    const yColStride = isChannelsLast ? y.strides[2] : 1;
    const yChannelStride = isChannelsLast ? 1 : y.strides[1];
    const xVals = backend.data.get(x.dataId).values;
    const wVals = backend.data.get(filter.dataId).values;
    const yVals = y.values;
    for(let b = 0; b < convInfo.batchSize; ++b){
        const xOffset1 = b * xBatchStride;
        const yOffset1 = b * yBatchStride;
        for(let yR = 0; yR < convInfo.outHeight; ++yR){
            const yOffset2 = yOffset1 + yR * yRowStride;
            const xRCorner = yR * convInfo.strideHeight - padTop;
            for(let wR = 0; wR < filterHeight; ++wR){
                const xR = xRCorner + wR * dilationHeight;
                if (xR < 0 || xR >= convInfo.inHeight) continue;
                const wOffset1 = wR * filterStrides[0];
                const xOffset2 = xOffset1 + xR * xRowStride;
                for(let yC = 0; yC < convInfo.outWidth; ++yC){
                    const yOffset3 = yOffset2 + yC * yColStride;
                    const xCCorner = yC * convInfo.strideWidth - padLeft;
                    for(let wC = 0; wC < filterWidth; ++wC){
                        const xC = xCCorner + wC * dilationWidth;
                        if (xC < 0 || xC >= convInfo.inWidth) continue;
                        const wOffset2 = wOffset1 + wC * filterStrides[1];
                        const xOffset3 = xOffset2 + xC * xColStride;
                        let wOffset3 = wOffset2;
                        for(let d1 = 0; d1 < convInfo.inChannels; ++d1){
                            const xVal = xVals[xOffset3 + d1 * xChannelStride];
                            for(let d2 = 0; d2 < convInfo.outChannels; ++d2)yVals[yOffset3 + d2 * yChannelStride] += xVal * wVals[wOffset3 + d2];
                            wOffset3 += convInfo.outChannels;
                        }
                    }
                }
            }
        }
    }
    return backend.makeTensorInfo(y.shape, y.dtype, yVals);
}
const $33872f5c298aaa1e$export$4a39bf13b4378042 = {
    kernelName: (0, $i64bB.Conv2D),
    backendName: 'cpu',
    kernelFunc: $33872f5c298aaa1e$export$5a2ce5b05041d9e4
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");
function $dade238f5679ecff$export$652a30c9379f3de7(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, dy: dy } = inputs;
    const { strides: strides, pad: pad, dataFormat: dataFormat, dimRoundingMode: dimRoundingMode, filterShape: filterShape } = attrs;
    (0, $csahy.assertNotComplex)([
        x,
        dy
    ], 'conv2dBackpropFilter');
    const $dataFormat = (0, $i64bB.backend_util).convertConv2DDataFormat(dataFormat);
    const convInfo = (0, $i64bB.backend_util).computeConv2DInfo(x.shape, filterShape, strides, 1 /* dilations */ , pad, dimRoundingMode, false, $dataFormat);
    const { strideHeight: strideHeight, strideWidth: strideWidth, filterHeight: filterHeight, filterWidth: filterWidth } = convInfo;
    const isChannelsLast = convInfo.dataFormat === 'channelsLast';
    const dW = new (0, $i64bB.TensorBuffer)(convInfo.filterShape, 'float32');
    const leftPad = convInfo.padInfo.left;
    const topPad = convInfo.padInfo.top;
    const xVals = backend.data.get(x.dataId).values;
    const dyVals = backend.data.get(dy.dataId).values;
    const xBuf = new (0, $i64bB.TensorBuffer)(x.shape, x.dtype, xVals);
    const dyBuf = new (0, $i64bB.TensorBuffer)(dy.shape, dy.dtype, dyVals);
    for(let wR = 0; wR < filterHeight; ++wR){
        const yRMin = Math.max(0, Math.ceil((topPad - wR) / strideHeight));
        const yRMax = Math.min(convInfo.outHeight, (convInfo.inHeight + topPad - wR) / strideHeight);
        for(let wC = 0; wC < filterWidth; ++wC){
            const yCMin = Math.max(0, Math.ceil((leftPad - wC) / strideWidth));
            const yCMax = Math.min(convInfo.outWidth, (convInfo.inWidth + leftPad - wC) / strideWidth);
            for(let d1 = 0; d1 < convInfo.inChannels; ++d1)for(let d2 = 0; d2 < convInfo.outChannels; ++d2){
                let dotProd = 0;
                for(let b = 0; b < convInfo.batchSize; ++b)for(let yR = yRMin; yR < yRMax; ++yR){
                    const xR = wR + yR * strideHeight - topPad;
                    for(let yC = yCMin; yC < yCMax; ++yC){
                        const xC = wC + yC * strideWidth - leftPad;
                        if (isChannelsLast) dotProd += xBuf.get(b, xR, xC, d1) * dyBuf.get(b, yR, yC, d2);
                        else dotProd += xBuf.get(b, d1, xR, xC) * dyBuf.get(b, d2, yR, yC);
                    }
                }
                dW.set(dotProd, wR, wC, d1, d2);
            }
        }
    }
    return backend.makeTensorInfo(dW.shape, dW.dtype, dW.values);
}
const $dade238f5679ecff$export$7a95f55d2d2e7d24 = {
    kernelName: (0, $i64bB.Conv2DBackpropFilter),
    backendName: 'cpu',
    kernelFunc: $dade238f5679ecff$export$652a30c9379f3de7
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");
function $722475b93e7c95c1$export$633310eed0c26e72(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, filter: filter } = inputs;
    const { inputShape: inputShape, strides: strides, pad: pad, dataFormat: dataFormat, dimRoundingMode: dimRoundingMode } = attrs;
    (0, $csahy.assertNotComplex)([
        dy,
        filter
    ], 'conv2dBackpropInput');
    const filterStrides = (0, $i64bB.util).computeStrides(filter.shape);
    const dyStrides = (0, $i64bB.util).computeStrides(dy.shape);
    let $dataFormat = (0, $i64bB.backend_util).convertConv2DDataFormat(dataFormat);
    const convInfo = (0, $i64bB.backend_util).computeConv2DInfo(inputShape, filter.shape, strides, 1 /* dilations */ , pad, dimRoundingMode, false, $dataFormat);
    const dx = new (0, $i64bB.TensorBuffer)(convInfo.inShape, 'float32');
    const dxValues = dx.values;
    const dyValues = backend.data.get(dy.dataId).values;
    const fltValues = backend.data.get(filter.dataId).values;
    const [fltS0, fltS1, fltS2] = filterStrides;
    const { batchSize: batchSize, filterHeight: filterHeight, filterWidth: filterWidth, inChannels: inChannels, inHeight: inHeight, inWidth: inWidth, outChannels: outChannels, outHeight: outHeight, outWidth: outWidth, strideHeight: strideHeight, strideWidth: strideWidth } = convInfo;
    $dataFormat = convInfo.dataFormat;
    const topPad = filterHeight - 1 - convInfo.padInfo.top;
    const leftPad = filterWidth - 1 - convInfo.padInfo.left;
    const isChannelsLast = $dataFormat === 'channelsLast';
    const xBatchStride = dx.strides[0];
    const xRowStride = isChannelsLast ? dx.strides[1] : dx.strides[2];
    const xColStride = isChannelsLast ? dx.strides[2] : 1;
    const xChannelStride = isChannelsLast ? 1 : dx.strides[1];
    const yBatchStride = dyStrides[0];
    const yRowStride = isChannelsLast ? dyStrides[1] : dyStrides[2];
    const yColStride = isChannelsLast ? dyStrides[2] : 1;
    const yChannelStride = isChannelsLast ? 1 : dyStrides[1];
    for(let b = 0; b < batchSize; ++b){
        for(let d1 = 0; d1 < inChannels; ++d1)for(let xR = 0; xR < inHeight; ++xR){
            const xRCorner = xR - topPad;
            const xRMin = Math.max(0, Math.ceil(xRCorner / strideHeight));
            const yRMax = Math.min(outHeight, (filterHeight + xRCorner) / strideHeight);
            for(let xC = 0; xC < inWidth; ++xC){
                const xCCorner = xC - leftPad;
                const xCMin = Math.max(0, Math.ceil(xCCorner / strideWidth));
                const yCMax = Math.min(outWidth, (filterWidth + xCCorner) / strideWidth);
                let dotProd = 0;
                for(let yR = xRMin; yR < yRMax; ++yR){
                    const wR = yR * strideHeight - xRCorner;
                    for(let yC = xCMin; yC < yCMax; ++yC){
                        const wC = yC * strideWidth - xCCorner;
                        const dyOffset = yBatchStride * b + yRowStride * yR + yColStride * yC;
                        const fltOffset = fltS0 * (filterHeight - 1 - wR) + fltS1 * (filterWidth - 1 - wC) + fltS2 * d1;
                        for(let d2 = 0; d2 < outChannels; ++d2){
                            const pixel = dyValues[dyOffset + yChannelStride * d2];
                            const weight = fltValues[fltOffset + d2];
                            dotProd += pixel * weight;
                        }
                    }
                }
                const dxOffset = xBatchStride * b + xRowStride * xR + xColStride * xC + xChannelStride * d1;
                dxValues[dxOffset] = dotProd;
            }
        }
    }
    return backend.makeTensorInfo(dx.shape, dx.dtype, dx.values);
}
const $722475b93e7c95c1$export$19bbc19fff1ed26f = {
    kernelName: (0, $i64bB.Conv2DBackpropInput),
    backendName: 'cpu',
    kernelFunc: $722475b93e7c95c1$export$633310eed0c26e72
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");
function $b58c6a43c853326f$export$1929932f31d07956(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter } = inputs;
    const { strides: strides, pad: pad, dilations: dilations } = attrs;
    (0, $csahy.assertNotComplex)([
        x,
        filter
    ], 'conv3d');
    const convInfo = (0, $i64bB.backend_util).computeConv3DInfo(x.shape, filter.shape, strides, dilations, pad);
    const { filterDepth: filterDepth, filterHeight: filterHeight, filterWidth: filterWidth, dilationDepth: dilationDepth, dilationHeight: dilationHeight, dilationWidth: dilationWidth, padInfo: padInfo } = convInfo;
    const padFront = padInfo.front;
    const padLeft = padInfo.left;
    const padTop = padInfo.top;
    const y = new (0, $i64bB.TensorBuffer)(convInfo.outShape, x.dtype);
    const xVals = backend.data.get(x.dataId).values;
    const wVals = backend.data.get(filter.dataId).values;
    const yVals = y.values;
    const xStrides = (0, $i64bB.util).computeStrides(x.shape);
    const filterStrides = (0, $i64bB.util).computeStrides(filter.shape);
    for(let b = 0; b < convInfo.batchSize; ++b){
        const xOffset1 = b * xStrides[0];
        const yOffset1 = b * y.strides[0];
        for(let yF = 0; yF < convInfo.outDepth; ++yF){
            const yOffset2 = yOffset1 + yF * y.strides[1];
            const xFCorner = yF * convInfo.strideDepth - padFront;
            for(let wF = 0; wF < filterDepth; ++wF){
                const xF = xFCorner + wF * dilationDepth;
                if (xF < 0 || xF >= convInfo.inDepth) continue;
                const wOffset1 = wF * filterStrides[0];
                const xOffset2 = xOffset1 + xF * xStrides[1];
                for(let yR = 0; yR < convInfo.outHeight; ++yR){
                    const yOffset3 = yOffset2 + yR * y.strides[2];
                    const xRCorner = yR * convInfo.strideHeight - padTop;
                    for(let wR = 0; wR < filterHeight; ++wR){
                        const xR = xRCorner + wR * dilationHeight;
                        if (xR < 0 || xR >= convInfo.inHeight) continue;
                        const wOffset2 = wOffset1 + wR * filterStrides[1];
                        const xOffset3 = xOffset2 + xR * xStrides[2];
                        for(let yC = 0; yC < convInfo.outWidth; ++yC){
                            const yOffset4 = yOffset3 + yC * convInfo.outChannels;
                            const xCCorner = yC * convInfo.strideWidth - padLeft;
                            for(let wC = 0; wC < filterWidth; ++wC){
                                const xC = xCCorner + wC * dilationWidth;
                                if (xC < 0 || xC >= convInfo.inWidth) continue;
                                const wOffset3 = wOffset2 + wC * filterStrides[2];
                                const xOffset4 = xOffset3 + xC * convInfo.inChannels;
                                let wOffset4 = wOffset3;
                                for(let d1 = 0; d1 < convInfo.inChannels; ++d1){
                                    const xVal = xVals[xOffset4 + d1];
                                    for(let d2 = 0; d2 < convInfo.outChannels; ++d2)yVals[yOffset4 + d2] += xVal * wVals[wOffset4 + d2];
                                    wOffset4 += convInfo.outChannels;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    return backend.makeTensorInfo(y.shape, y.dtype, y.values);
}
const $b58c6a43c853326f$export$1fe590fda0829040 = {
    kernelName: (0, $i64bB.Conv3D),
    backendName: 'cpu',
    kernelFunc: $b58c6a43c853326f$export$1929932f31d07956
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");
function $b340a29664bf88e4$export$b57760dc3101cea7(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, dy: dy } = inputs;
    const { strides: strides, pad: pad, filterShape: filterShape } = attrs;
    (0, $csahy.assertNotComplex)([
        x,
        dy
    ], 'conv3dBackpropFilterV2');
    const xStrides = (0, $i64bB.util).computeStrides(x.shape);
    const dyStrides = (0, $i64bB.util).computeStrides(dy.shape);
    const convInfo = (0, $i64bB.backend_util).computeConv3DInfo(x.shape, filterShape, strides, 1 /* dilations */ , pad);
    const strideDepth = convInfo.strideDepth;
    const strideHeight = convInfo.strideHeight;
    const strideWidth = convInfo.strideWidth;
    const filterDepth = convInfo.filterDepth;
    const filterHeight = convInfo.filterHeight;
    const filterWidth = convInfo.filterWidth;
    const dw = new (0, $i64bB.TensorBuffer)(convInfo.filterShape, 'float32');
    const dwValues = dw.values;
    const [dwS0, dwS1, dwS2, dwS3] = dw.strides;
    const dyValues = backend.data.get(dy.dataId).values;
    const [dyS0, dyS1, dyS2, dyS3] = dyStrides;
    const xValues = backend.data.get(x.dataId).values;
    const [xS0, xS1, xS2, xS3] = xStrides;
    const frontPad = convInfo.padInfo.front;
    const leftPad = convInfo.padInfo.left;
    const topPad = convInfo.padInfo.top;
    for(let wF = 0; wF < filterDepth; ++wF){
        const yFMin = Math.max(0, Math.ceil((frontPad - wF) / strideDepth));
        const yFMax = Math.min(convInfo.outDepth, (convInfo.inDepth + frontPad - wF) / strideDepth);
        const wOffset1 = wF * dwS0;
        for(let wR = 0; wR < filterHeight; ++wR){
            const yRMin = Math.max(0, Math.ceil((topPad - wR) / strideHeight));
            const yRMax = Math.min(convInfo.outHeight, (convInfo.inHeight + topPad - wR) / strideHeight);
            const wOffset2 = wR * dwS1 + wOffset1;
            for(let wC = 0; wC < filterWidth; ++wC){
                const yCMin = Math.max(0, Math.ceil((leftPad - wC) / strideWidth));
                const yCMax = Math.min(convInfo.outWidth, (convInfo.inWidth + leftPad - wC) / strideWidth);
                const wOffset3 = wC * dwS2 + wOffset2;
                for(let d1 = 0; d1 < convInfo.inChannels; ++d1){
                    const wOffset4 = d1 * dwS3 + wOffset3;
                    for(let d2 = 0; d2 < convInfo.outChannels; ++d2){
                        let dotProd = 0;
                        for(let b = 0; b < convInfo.batchSize; ++b){
                            const xOffset1 = b * xS0;
                            const yOffset1 = b * dyS0;
                            for(let yF = yFMin; yF < yFMax; ++yF){
                                const xF = wF + yF * strideDepth - frontPad;
                                const xOffset2 = xF * xS1 + xOffset1;
                                const yOffset2 = yF * dyS1 + yOffset1;
                                for(let yR = yRMin; yR < yRMax; ++yR){
                                    const xR = wR + yR * strideHeight - topPad;
                                    const xOffset3 = xR * xS2 + xOffset2;
                                    const yOffset3 = yR * dyS2 + yOffset2;
                                    for(let yC = yCMin; yC < yCMax; ++yC){
                                        const xC = wC + yC * strideWidth - leftPad;
                                        const xOffset4 = xC * xS3 + xOffset3;
                                        const yOffset4 = yC * dyS3 + yOffset3;
                                        dotProd += xValues[xOffset4 + d1] * dyValues[yOffset4 + d2];
                                    }
                                }
                            }
                        }
                        dwValues[wOffset4 + d2] = dotProd;
                    }
                }
            }
        }
    }
    return backend.makeTensorInfo(dw.shape, dw.dtype, dw.values);
}
const $b340a29664bf88e4$export$6dce9169640850fa = {
    kernelName: (0, $i64bB.Conv3DBackpropFilterV2),
    backendName: 'cpu',
    kernelFunc: $b340a29664bf88e4$export$b57760dc3101cea7
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");
function $496df5d9afb80a4e$export$ab31b884dc9f0971(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, filter: filter } = inputs;
    const { pad: pad, strides: strides, inputShape: inputShape } = attrs;
    (0, $csahy.assertNotComplex)([
        dy
    ], 'conv3dBackpropInputV2');
    const dyStrides = (0, $i64bB.util).computeStrides(dy.shape);
    const filterStrides = (0, $i64bB.util).computeStrides(filter.shape);
    const convInfo = (0, $i64bB.backend_util).computeConv3DInfo(inputShape, filter.shape, strides, 1 /* dilations */ , pad);
    const dx = new (0, $i64bB.TensorBuffer)(convInfo.inShape, 'float32');
    const dxValues = dx.values;
    const [dxS0, dxS1, dxS2, dxS3] = dx.strides;
    const dyValues = backend.data.get(dy.dataId).values;
    const [dyS0, dyS1, dyS2, dyS3] = dyStrides;
    const fltValues = backend.data.get(filter.dataId).values;
    const [fltS0, fltS1, fltS2, fltS3] = filterStrides;
    const { batchSize: batchSize, filterDepth: filterDepth, filterHeight: filterHeight, filterWidth: filterWidth, inChannels: inChannels, inDepth: inDepth, inHeight: inHeight, inWidth: inWidth, outChannels: outChannels, outDepth: outDepth, outHeight: outHeight, outWidth: outWidth, strideDepth: strideDepth, strideHeight: strideHeight, strideWidth: strideWidth } = convInfo;
    const frontPad = filterDepth - 1 - convInfo.padInfo.front;
    const topPad = filterHeight - 1 - convInfo.padInfo.top;
    const leftPad = filterWidth - 1 - convInfo.padInfo.left;
    for(let b = 0; b < batchSize; ++b){
        for(let d1 = 0; d1 < inChannels; ++d1)// Frames of depth
        for(let xF = 0; xF < inDepth; ++xF){
            const xFCorner = xF - frontPad;
            const xFMin = Math.max(0, Math.ceil(xFCorner / strideDepth));
            const yFMax = Math.min(outDepth, (filterDepth + xFCorner) / strideDepth);
            // Rows as per standard 2d matrix notation
            for(let xR = 0; xR < inHeight; ++xR){
                const xRCorner = xR - topPad;
                const xRMin = Math.max(0, Math.ceil(xRCorner / strideHeight));
                const yRMax = Math.min(outHeight, (filterHeight + xRCorner) / strideHeight);
                // Columns as per standard 2d matrix notation
                for(let xC = 0; xC < inWidth; ++xC){
                    const xCCorner = xC - leftPad;
                    const xCMin = Math.max(0, Math.ceil(xCCorner / strideWidth));
                    const yCMax = Math.min(outWidth, (filterWidth + xCCorner) / strideWidth);
                    let dotProd = 0;
                    for(let yF = xFMin; yF < yFMax; ++yF){
                        const wF = yF * strideDepth - xFCorner;
                        for(let yR = xRMin; yR < yRMax; ++yR){
                            const wR = yR * strideHeight - xRCorner;
                            for(let yC = xCMin; yC < yCMax; ++yC){
                                const wC = yC * strideWidth - xCCorner;
                                const dyOffset = dyS0 * b + dyS1 * yF + dyS2 * yR + dyS3 * yC;
                                const fltOffset = fltS0 * (filterDepth - 1 - wF) + fltS1 * (filterHeight - 1 - wR) + fltS2 * (filterWidth - 1 - wC) + fltS3 * d1;
                                for(let d2 = 0; d2 < outChannels; ++d2){
                                    const pixel = dyValues[dyOffset + d2];
                                    const weight = fltValues[fltOffset + d2];
                                    dotProd += pixel * weight;
                                }
                            }
                        }
                    }
                    dxValues[dxS0 * b + dxS1 * xF + dxS2 * xR + dxS3 * xC + d1] = dotProd;
                }
            }
        }
    }
    return backend.makeTensorInfo(dx.shape, dx.dtype, dx.values);
}
const $496df5d9afb80a4e$export$40ece1caaaf084b2 = {
    kernelName: (0, $i64bB.Conv3DBackpropInputV2),
    backendName: 'cpu',
    kernelFunc: $496df5d9afb80a4e$export$ab31b884dc9f0971
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $l6afd = parcelRequire("l6afd");
const $2fe16efd3eb6e9a3$export$50d414a77b60d802 = (0, $l6afd.unaryKernelFunc)((0, $i64bB.Cos), (xi)=>Math.cos(xi));
const $2fe16efd3eb6e9a3$export$ff099a1da5235a7e = {
    kernelName: (0, $i64bB.Cos),
    backendName: 'cpu',
    kernelFunc: $2fe16efd3eb6e9a3$export$50d414a77b60d802
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $l6afd = parcelRequire("l6afd");
const $b1da2977c365559b$export$2e2fd1ad24e4d350 = (0, $l6afd.unaryKernelFunc)((0, $i64bB.Cosh), (xi)=>Math.cosh(xi));
const $b1da2977c365559b$export$c5824052b09ba0ed = {
    kernelName: (0, $i64bB.Cosh),
    backendName: 'cpu',
    kernelFunc: $b1da2977c365559b$export$2e2fd1ad24e4d350
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
function $58d1da7fb0ce0e2f$export$6f0f0090e1f6cd3c(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { image: image, boxes: boxes, boxInd: boxInd } = inputs;
    const { cropSize: cropSize, method: method, extrapolationValue: extrapolationValue } = attrs;
    const [batch, imageHeight, imageWidth, numChannels] = image.shape;
    const numBoxes = boxes.shape[0];
    const [cropHeight, cropWidth] = cropSize;
    const output = (0, $i64bB.buffer)([
        numBoxes,
        cropHeight,
        cropWidth,
        numChannels
    ], 'float32');
    const boxVals = backend.data.get(boxes.dataId).values;
    const boxIndVals = backend.data.get(boxInd.dataId).values;
    const imageVals = backend.data.get(image.dataId).values;
    const inStride = (0, $i64bB.util).computeStrides(image.shape); // to calculate flat indexes into image
    const outStride = (0, $i64bB.util).computeStrides(output.shape); // to calculate flat indexes into output
    // Reference implementation
    // tslint:disable-next-line:max-line-length
    // https://github.com/tensorflow/tensorflow/blob/master/tensorflow/core/kernels/crop_and_resize_op.cc
    for(let b = 0; b < numBoxes; b++){
        const startInd = b * 4;
        const y1 = boxVals[startInd];
        const x1 = boxVals[startInd + 1];
        const y2 = boxVals[startInd + 2];
        const x2 = boxVals[startInd + 3];
        const bInd = boxIndVals[b];
        if (bInd >= batch) continue;
        const heightScale = cropHeight > 1 ? (y2 - y1) * (imageHeight - 1) / (cropHeight - 1) : 0;
        const widthScale = cropWidth > 1 ? (x2 - x1) * (imageWidth - 1) / (cropWidth - 1) : 0;
        for(let y = 0; y < cropHeight; y++){
            const yInd = cropHeight > 1 ? y1 * (imageHeight - 1) + y * heightScale : 0.5 * (y1 + y2) * (imageHeight - 1);
            if (yInd < 0 || yInd > imageHeight - 1) {
                for(let x = 0; x < cropWidth; x++)for(let c = 0; c < numChannels; c++){
                    const ind = c + x * outStride[2] + y * outStride[1] + b * outStride[0];
                    output.values[ind] = extrapolationValue;
                }
                continue;
            }
            if (method === 'bilinear') {
                const topInd = Math.floor(yInd);
                const bottomInd = Math.ceil(yInd);
                const yLerp = yInd - topInd;
                for(let x = 0; x < cropWidth; x++){
                    const xInd = cropWidth > 1 ? x1 * (imageWidth - 1) + x * widthScale : 0.5 * (x1 + x2) * (imageWidth - 1);
                    if (xInd < 0 || xInd > imageWidth - 1) {
                        for(let c = 0; c < numChannels; c++){
                            const ind = c + x * outStride[2] + y * outStride[1] + b * outStride[0];
                            output.values[ind] = extrapolationValue;
                        }
                        continue;
                    }
                    const leftInd = Math.floor(xInd);
                    const rightInd = Math.ceil(xInd);
                    const xLerp = xInd - leftInd;
                    for(let c = 0; c < numChannels; c++){
                        let ind = c + leftInd * inStride[2] + topInd * inStride[1] + bInd * inStride[0];
                        const topLeft = imageVals[ind];
                        ind = c + rightInd * inStride[2] + topInd * inStride[1] + bInd * inStride[0];
                        const topRight = imageVals[ind];
                        ind = c + leftInd * inStride[2] + bottomInd * inStride[1] + bInd * inStride[0];
                        const bottomLeft = imageVals[ind];
                        ind = c + rightInd * inStride[2] + bottomInd * inStride[1] + bInd * inStride[0];
                        const bottomRight = imageVals[ind];
                        const top = topLeft + (topRight - topLeft) * xLerp;
                        const bottom = bottomLeft + (bottomRight - bottomLeft) * xLerp;
                        ind = c + x * outStride[2] + y * outStride[1] + b * outStride[0];
                        output.values[ind] = top + (bottom - top) * yLerp;
                    }
                }
            } else for(let x = 0; x < cropWidth; ++x){
                const xInd = cropWidth > 1 ? x1 * (imageWidth - 1) + x * widthScale : 0.5 * (x1 + x2) * (imageWidth - 1);
                if (xInd < 0 || xInd > imageWidth - 1) {
                    for(let c = 0; c < numChannels; c++){
                        const ind = c + x * outStride[2] + y * outStride[1] + b * outStride[0];
                        output.values[ind] = extrapolationValue;
                    }
                    continue;
                }
                const closestX = Math.round(xInd);
                const closestY = Math.round(yInd);
                for(let c = 0; c < numChannels; c++){
                    const inInd = c + closestX * inStride[2] + closestY * inStride[1] + bInd * inStride[0];
                    const outInd = c + x * outStride[2] + y * outStride[1] + b * outStride[0];
                    output.values[outInd] = imageVals[inInd];
                }
            }
        }
    }
    return backend.makeTensorInfo(output.shape, output.dtype, output.values);
}
const $58d1da7fb0ce0e2f$export$f7086edcf0050c7f = {
    kernelName: (0, $i64bB.CropAndResize),
    backendName: 'cpu',
    kernelFunc: $58d1da7fb0ce0e2f$export$6f0f0090e1f6cd3c
};


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");

var $EOTYn = parcelRequire("EOTYn");
function $2b7776615377f1a7$export$dc7513e907e94b8d(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, exclusive: exclusive, reverse: reverse } = attrs;
    (0, $csahy.assertNotComplex)(x, 'cumprod');
    const permutation = (0, $i64bB.backend_util).getAxesPermutation([
        axis
    ], x.shape.length);
    let $x = x;
    if (permutation != null) $x = (0, $EOTYn.transpose)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            perm: permutation
        }
    });
    const permutedAxis = (0, $i64bB.backend_util).getInnerMostAxes(1, x.shape.length)[0];
    if (permutedAxis !== $x.shape.length - 1) throw new Error(`backend.cumprod in CPU expects an inner-most ` + `axis=${$x.shape.length - 1} but got axis=${permutedAxis}`);
    const resultDtype = (0, $i64bB.upcastType)($x.dtype, 'int32');
    const vals = (0, $i64bB.util).makeOnesTypedArray((0, $i64bB.util).sizeFromShape($x.shape), resultDtype);
    const aVals = backend.data.get($x.dataId).values;
    const finalDim = $x.shape[$x.shape.length - 1];
    const indexAdjuster = reverse ? (i, j)=>i + finalDim - j - 1 : (i, j)=>i + j;
    for(let i = 0; i < aVals.length; i += finalDim)for(let j = 0; j < finalDim; j++){
        const idx = indexAdjuster(i, j);
        if (j === 0) vals[idx] = exclusive ? 1 : aVals[idx];
        else {
            const prevIdx = indexAdjuster(i, j - 1);
            vals[idx] = exclusive ? aVals[prevIdx] * vals[prevIdx] : aVals[idx] * vals[prevIdx];
        }
    }
    const result = backend.makeTensorInfo($x.shape, resultDtype, vals);
    if (permutation != null) {
        const reversePermutation = (0, $i64bB.backend_util).getUndoAxesPermutation(permutation);
        const reverseTransposedResult = (0, $EOTYn.transpose)({
            inputs: {
                x: result
            },
            backend: backend,
            attrs: {
                perm: reversePermutation
            }
        });
        backend.disposeIntermediateTensorInfo(result);
        backend.disposeIntermediateTensorInfo($x);
        return reverseTransposedResult;
    }
    return result;
}
const $2b7776615377f1a7$export$db50d81ed60c5a35 = {
    kernelName: (0, $i64bB.Cumprod),
    backendName: 'cpu',
    kernelFunc: $2b7776615377f1a7$export$dc7513e907e94b8d
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");

var $EOTYn = parcelRequire("EOTYn");
function $c183c106eb8bd9c9$export$71990b1e1c4912fe(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, exclusive: exclusive, reverse: reverse } = attrs;
    (0, $csahy.assertNotComplex)(x, 'cumsum');
    const permutation = (0, $i64bB.backend_util).getAxesPermutation([
        axis
    ], x.shape.length);
    let $x = x;
    if (permutation != null) $x = (0, $EOTYn.transpose)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            perm: permutation
        }
    });
    const permutedAxis = (0, $i64bB.backend_util).getInnerMostAxes(1, x.shape.length)[0];
    if (permutedAxis !== $x.shape.length - 1) throw new Error(`backend.cumsum in CPU expects an inner-most ` + `axis=${$x.shape.length - 1} but got axis=${permutedAxis}`);
    const resultDtype = (0, $i64bB.upcastType)($x.dtype, 'int32');
    const vals = (0, $i64bB.util).makeZerosTypedArray((0, $i64bB.util).sizeFromShape($x.shape), resultDtype);
    const aVals = backend.data.get($x.dataId).values;
    const finalDim = $x.shape[$x.shape.length - 1];
    const indexAdjuster = reverse ? (i, j)=>i + finalDim - j - 1 : (i, j)=>i + j;
    for(let i = 0; i < aVals.length; i += finalDim)for(let j = 0; j < finalDim; j++){
        const idx = indexAdjuster(i, j);
        if (j === 0) vals[idx] = exclusive ? 0 : aVals[idx];
        else {
            const prevIdx = indexAdjuster(i, j - 1);
            vals[idx] = exclusive ? aVals[prevIdx] + vals[prevIdx] : aVals[idx] + vals[prevIdx];
        }
    }
    const result = backend.makeTensorInfo($x.shape, resultDtype, vals);
    if (permutation != null) {
        const reversePermutation = (0, $i64bB.backend_util).getUndoAxesPermutation(permutation);
        const reverseTransposedResult = (0, $EOTYn.transpose)({
            inputs: {
                x: result
            },
            backend: backend,
            attrs: {
                perm: reversePermutation
            }
        });
        backend.disposeIntermediateTensorInfo(result);
        backend.disposeIntermediateTensorInfo($x);
        return reverseTransposedResult;
    }
    return result;
}
const $c183c106eb8bd9c9$export$2f6196f3316e7ed2 = {
    kernelName: (0, $i64bB.Cumsum),
    backendName: 'cpu',
    kernelFunc: $c183c106eb8bd9c9$export$71990b1e1c4912fe
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $34gHf = parcelRequire("34gHf");
function $ae0ec50f8ecb375d$export$436934e6cf1946f1(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, weights: weights } = inputs;
    const { size: size, binaryOutput: binaryOutput } = attrs;
    if (x.shape.length === 1) {
        const xVals = backend.data.get(x.dataId).values;
        const weightsVals = backend.data.get(weights.dataId).values;
        const outVals = (0, $34gHf.bincountImpl)(xVals, weightsVals, weights.dtype, weights.shape, size);
        return backend.makeTensorInfo([
            size
        ], weights.dtype, outVals);
    } else if (x.shape.length === 2) {
        const xBuf = backend.bufferSync(x);
        const weightsBuf = backend.bufferSync(weights);
        const outBuf = (0, $34gHf.bincountReduceImpl)(xBuf, weightsBuf, size, binaryOutput);
        return backend.makeTensorInfo(outBuf.shape, weights.dtype, outBuf.values);
    }
    throw new Error(`Error in denseBincount: input must be at most rank 2, but got rank` + `${x.shape.length}.`);
}
const $ae0ec50f8ecb375d$export$88ba267b84334692 = {
    kernelName: (0, $i64bB.DenseBincount),
    backendName: 'cpu',
    kernelFunc: $ae0ec50f8ecb375d$export$436934e6cf1946f1
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
function $9b9ad46d1ca8b599$export$3b50daec0f185f12(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { blockSize: blockSize, dataFormat: dataFormat } = attrs;
    (0, $i64bB.util).assert(dataFormat === 'NHWC', ()=>`Only NHWC dataFormat supported on CPU for depthToSpace. Got ${dataFormat}`);
    const batchSize = x.shape[0];
    const inputHeight = x.shape[1];
    const inputWidth = x.shape[2];
    const inputDepth = x.shape[3];
    const outputHeight = inputHeight * blockSize;
    const outputWidth = inputWidth * blockSize;
    const outputDepth = inputDepth / (blockSize * blockSize);
    const xValues = backend.data.get(x.dataId).values;
    const result = new Float32Array(batchSize * outputHeight * outputWidth * outputDepth);
    let outputIdx = 0;
    for(let b = 0; b < batchSize; ++b)for(let h = 0; h < outputHeight; ++h){
        const inH = Math.floor(h / blockSize);
        const offsetH = h % blockSize;
        for(let w = 0; w < outputWidth; ++w){
            const inW = Math.floor(w / blockSize);
            const offsetW = w % blockSize;
            const offsetD = (offsetH * blockSize + offsetW) * outputDepth;
            for(let d = 0; d < outputDepth; ++d){
                const inD = d + offsetD;
                const inputIdx = inD + inputDepth * (inW + inputWidth * (inH + inputHeight * b));
                result[outputIdx++] = xValues[inputIdx];
            }
        }
    }
    return backend.makeTensorInfo([
        batchSize,
        outputHeight,
        outputWidth,
        outputDepth
    ], x.dtype, result);
}
const $9b9ad46d1ca8b599$export$9c5b88dcb1d2008b = {
    kernelName: (0, $i64bB.DepthToSpace),
    backendName: 'cpu',
    kernelFunc: $9b9ad46d1ca8b599$export$3b50daec0f185f12
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");
function $6a85a496ede50ffd$export$14e793fe8822afd1(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter } = inputs;
    const { strides: strides, pad: pad, dilations: dilations, dimRoundingMode: dimRoundingMode } = attrs;
    (0, $csahy.assertNotComplex)([
        x,
        filter
    ], 'depthwiseConv2DNative');
    const xStrides = (0, $i64bB.util).computeStrides(x.shape);
    const filterStrides = (0, $i64bB.util).computeStrides(filter.shape);
    let $dilations = dilations;
    if ($dilations == null) $dilations = [
        1,
        1
    ];
    (0, $i64bB.util).assert((0, $i64bB.backend_util).eitherStridesOrDilationsAreOne(strides, $dilations), ()=>'Error in depthwiseConv2d: Either strides or dilations must be ' + `1. Got strides ${strides} and dilations '${$dilations}'`);
    const convInfo = (0, $i64bB.backend_util).computeConv2DInfo(x.shape, filter.shape, strides, $dilations, pad, dimRoundingMode, true);
    const { filterHeight: filterHeight, filterWidth: filterWidth, dilationHeight: dilationHeight, dilationWidth: dilationWidth, padInfo: padInfo } = convInfo;
    const padLeft = padInfo.left;
    const padTop = padInfo.top;
    const chMul = convInfo.outChannels / convInfo.inChannels;
    const y = new (0, $i64bB.TensorBuffer)(convInfo.outShape, x.dtype);
    const xVals = backend.data.get(x.dataId).values;
    const wVals = backend.data.get(filter.dataId).values;
    const yVals = y.values;
    for(let b = 0; b < convInfo.batchSize; ++b){
        const xOffset1 = b * xStrides[0];
        const yOffset1 = b * y.strides[0];
        for(let yR = 0; yR < convInfo.outHeight; ++yR){
            const yOffset2 = yOffset1 + yR * y.strides[1];
            const xRCorner = yR * convInfo.strideHeight - padTop;
            for(let wR = 0; wR < filterHeight; ++wR){
                const xR = xRCorner + wR * dilationHeight;
                if (xR < 0 || xR >= convInfo.inHeight) continue;
                const wOffset1 = wR * filterStrides[0];
                const xOffset2 = xOffset1 + xR * xStrides[1];
                for(let yC = 0; yC < convInfo.outWidth; ++yC){
                    const yOffset3 = yOffset2 + yC * y.strides[2];
                    const xCCorner = yC * convInfo.strideWidth - padLeft;
                    for(let wC = 0; wC < filterWidth; ++wC){
                        const xC = xCCorner + wC * dilationWidth;
                        if (xC < 0 || xC >= convInfo.inWidth) continue;
                        const wOffset2 = wOffset1 + wC * filterStrides[1];
                        const xOffset3 = xOffset2 + xC * convInfo.inChannels;
                        let yOffset4 = yOffset3;
                        let wOffset3 = wOffset2;
                        for(let d1 = 0; d1 < convInfo.inChannels; ++d1){
                            const xVal = xVals[xOffset3 + d1];
                            for(let q = 0; q < chMul; ++q)yVals[yOffset4 + q] += xVal * wVals[wOffset3 + q];
                            yOffset4 += chMul;
                            wOffset3 += chMul;
                        }
                    }
                }
            }
        }
    }
    return backend.makeTensorInfo(y.shape, y.dtype, y.values);
}
const $6a85a496ede50ffd$export$240667804b7c390e = {
    kernelName: (0, $i64bB.DepthwiseConv2dNative),
    backendName: 'cpu',
    kernelFunc: $6a85a496ede50ffd$export$14e793fe8822afd1
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");
function $7cedee963cdb4153$export$cc0ae65e9edc7e1a(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, dy: dy } = inputs;
    const { strides: strides, dilations: dilations, pad: pad, dimRoundingMode: dimRoundingMode, filterShape: filterShape } = attrs;
    (0, $csahy.assertNotComplex)([
        x,
        dy
    ], 'depthwiseConv2dNativeBackpropFilter');
    const convInfo = (0, $i64bB.backend_util).computeConv2DInfo(x.shape, filterShape, strides, dilations, pad, dimRoundingMode, true);
    const { strideHeight: strideHeight, strideWidth: strideWidth, filterHeight: filterHeight, filterWidth: filterWidth } = convInfo;
    const dW = new (0, $i64bB.TensorBuffer)(convInfo.filterShape, 'float32');
    const leftPad = convInfo.padInfo.left;
    const topPad = convInfo.padInfo.top;
    const chMul = convInfo.outChannels / convInfo.inChannels;
    const xVals = backend.data.get(x.dataId).values;
    const xBuf = new (0, $i64bB.TensorBuffer)(x.shape, x.dtype, xVals);
    const dyVals = backend.data.get(dy.dataId).values;
    const dyBuf = new (0, $i64bB.TensorBuffer)(dy.shape, dy.dtype, dyVals);
    for(let wR = 0; wR < filterHeight; ++wR){
        const yRMin = Math.max(0, Math.ceil((topPad - wR) / strideHeight));
        const yRMax = Math.min(convInfo.outHeight, (convInfo.inHeight + topPad - wR) / strideHeight);
        for(let wC = 0; wC < filterWidth; ++wC){
            const yCMin = Math.max(0, Math.ceil((leftPad - wC) / strideWidth));
            const yCMax = Math.min(convInfo.outWidth, (convInfo.inWidth + leftPad - wC) / strideWidth);
            for(let d2 = 0; d2 < convInfo.outChannels; ++d2){
                const d1 = Math.trunc(d2 / chMul);
                const dm = d2 % chMul;
                let dotProd = 0;
                for(let b = 0; b < convInfo.batchSize; ++b)for(let yR = yRMin; yR < yRMax; ++yR){
                    const xR = wR + yR * strideHeight - topPad;
                    for(let yC = yCMin; yC < yCMax; ++yC){
                        const xC = wC + yC * strideWidth - leftPad;
                        dotProd += xBuf.get(b, xR, xC, d1) * dyBuf.get(b, yR, yC, d2);
                    }
                }
                dW.set(dotProd, wR, wC, d1, dm);
            }
        }
    }
    return backend.makeTensorInfo(dW.shape, dW.dtype, dW.values);
}
const $7cedee963cdb4153$export$30bc0ac3775583fc = {
    kernelName: (0, $i64bB.DepthwiseConv2dNativeBackpropFilter),
    backendName: 'cpu',
    kernelFunc: $7cedee963cdb4153$export$cc0ae65e9edc7e1a
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");
function $9f3a7c95dbedc6ea$export$37e2ab95a4a4c24b(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, filter: filter } = inputs;
    const { strides: strides, dilations: dilations, pad: pad, dimRoundingMode: dimRoundingMode, inputShape: inputShape } = attrs;
    (0, $csahy.assertNotComplex)([
        dy,
        filter
    ], 'depthwiseConv2DNativeBackpropInput');
    const dyStrides = (0, $i64bB.util).computeStrides(dy.shape);
    const filterStrides = (0, $i64bB.util).computeStrides(filter.shape);
    const convInfo = (0, $i64bB.backend_util).computeConv2DInfo(inputShape, filter.shape, strides, dilations, pad, dimRoundingMode, true);
    const dx = new (0, $i64bB.TensorBuffer)(convInfo.inShape, 'float32');
    const dxValues = dx.values;
    const [dxS0, dxS1, dxS2] = dx.strides;
    const dyValues = backend.data.get(dy.dataId).values;
    const [dyS0, dyS1, dyS2] = dyStrides;
    const fltValues = backend.data.get(filter.dataId).values;
    const [fltS0, fltS1, fltS2] = filterStrides;
    const { batchSize: batchSize, filterHeight: filterHeight, filterWidth: filterWidth, inChannels: inChannels, inHeight: inHeight, inWidth: inWidth, outChannels: outChannels, outHeight: outHeight, outWidth: outWidth, strideHeight: strideHeight, strideWidth: strideWidth } = convInfo;
    const topPad = filterHeight - 1 - convInfo.padInfo.top;
    const leftPad = filterWidth - 1 - convInfo.padInfo.left;
    const chMul = outChannels / inChannels;
    for(let b = 0; b < batchSize; ++b){
        for(let d1 = 0; d1 < inChannels; ++d1)for(let xR = 0; xR < inHeight; ++xR){
            const xRCorner = xR - topPad;
            const xRMin = Math.max(0, Math.ceil(xRCorner / strideHeight));
            const yRMax = Math.min(outHeight, (filterHeight + xRCorner) / strideHeight);
            for(let xC = 0; xC < inWidth; ++xC){
                const xCCorner = xC - leftPad;
                const xCMin = Math.max(0, Math.ceil(xCCorner / strideWidth));
                const yCMax = Math.min(outWidth, (filterWidth + xCCorner) / strideWidth);
                let dotProd = 0;
                for(let yR = xRMin; yR < yRMax; ++yR){
                    const wR = yR * strideHeight - xRCorner;
                    for(let yC = xCMin; yC < yCMax; ++yC){
                        const wC = yC * strideWidth - xCCorner;
                        const dyOffset = dyS0 * b + dyS1 * yR + dyS2 * yC;
                        const fltOffset = fltS0 * (filterHeight - 1 - wR) + fltS1 * (filterWidth - 1 - wC) + fltS2 * d1;
                        for(let dm = 0; dm < chMul; ++dm){
                            const d2 = d1 * chMul + dm;
                            const pixel = dyValues[dyOffset + d2];
                            const weight = fltValues[fltOffset + dm];
                            dotProd += pixel * weight;
                        }
                    }
                }
                dxValues[dxS0 * b + dxS1 * xR + dxS2 * xC + d1] = dotProd;
            }
        }
    }
    return backend.makeTensorInfo(dx.shape, dx.dtype, dx.values);
}
const $9f3a7c95dbedc6ea$export$55d12409e744bebe = {
    kernelName: (0, $i64bB.DepthwiseConv2dNativeBackpropInput),
    backendName: 'cpu',
    kernelFunc: $9f3a7c95dbedc6ea$export$37e2ab95a4a4c24b
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
function $5a545717cb4130f7$export$c042e7c2f59bc046(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    const xSize = (0, $i64bB.util).sizeFromShape(x.shape);
    const xVals = backend.data.get(x.dataId).values;
    const outBuf = (0, $i64bB.buffer)([
        xSize,
        xSize
    ], x.dtype);
    const vals = outBuf.values;
    for(let i = 0; i < xVals.length; i++)vals[i * xSize + i] = xVals[i];
    const outShape = [
        ...x.shape,
        ...x.shape
    ];
    return backend.makeTensorInfo(outShape, outBuf.dtype, outBuf.values);
}
const $5a545717cb4130f7$export$56dc5d812a22748f = {
    kernelName: (0, $i64bB.Diag),
    backendName: 'cpu',
    kernelFunc: $5a545717cb4130f7$export$c042e7c2f59bc046
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
const $ce5997a72f98f884$export$36d3c11f61a8891a = {
    kernelName: (0, $i64bB.Dilation2D),
    backendName: 'cpu',
    kernelFunc: ({ inputs: inputs, backend: backend, attrs: attrs })=>{
        const { x: x, filter: filter } = inputs;
        const { strides: strides, pad: pad, dilations: dilations } = attrs;
        const cpuBackend = backend;
        const xVals = cpuBackend.data.get(x.dataId).values;
        const xRank = x.shape.length;
        const filterVals = cpuBackend.data.get(filter.dataId).values;
        const filterRank = filter.shape.length;
        const { batchSize: batchSize, inHeight: inHeight, inWidth: inWidth, inChannels: inChannels, outHeight: outHeight, outWidth: outWidth, padInfo: padInfo, strideHeight: strideHeight, strideWidth: strideWidth, filterHeight: filterHeight, filterWidth: filterWidth, dilationHeight: dilationHeight, dilationWidth: dilationWidth, outShape: outShape } = (0, $i64bB.backend_util).computeDilation2DInfo(x.shape, filter.shape, strides, pad, 'NHWC' /* dataFormat */ , dilations);
        const outSize = (0, $i64bB.util).sizeFromShape(outShape);
        const outRank = outShape.length;
        const outputVals = (0, $i64bB.util).getArrayFromDType(x.dtype, outSize);
        // Upsampling the input by fill in `dilation size - 1` values between each
        // input value.
        // This implementation follows the TF c++ implementation:
        // https://github.com/tensorflow/tensorflow/blob/d9a3a849edc198e90172bc58eb293de457f9d986/tensorflow/core/kernels/dilation_ops.cc
        for(let b = 0; b < batchSize; ++b)for(let hOut = 0; hOut < outHeight; ++hOut){
            const hBeg = hOut * strideHeight - padInfo.top;
            for(let wOut = 0; wOut < outWidth; ++wOut){
                const wBeg = wOut * strideWidth - padInfo.left;
                for(let d = 0; d < inChannels; ++d){
                    let curVal = Number.MIN_SAFE_INTEGER;
                    for(let h = 0; h < filterHeight; ++h){
                        const hIn = hBeg + h * dilationHeight;
                        if (hIn >= 0 && hIn < inHeight) for(let w = 0; w < filterWidth; ++w){
                            const wIn = wBeg + w * dilationWidth;
                            if (wIn >= 0 && wIn < inWidth) {
                                const xIndex = (0, $i64bB.util).locToIndex([
                                    b,
                                    hIn,
                                    wIn,
                                    d
                                ], xRank, (0, $i64bB.util).computeStrides(x.shape));
                                const filterIndex = (0, $i64bB.util).locToIndex([
                                    h,
                                    w,
                                    d
                                ], filterRank, (0, $i64bB.util).computeStrides(filter.shape));
                                const val = xVals[xIndex] + filterVals[filterIndex];
                                if (val > curVal) curVal = val;
                            }
                        }
                    }
                    const outputIndex = (0, $i64bB.util).locToIndex([
                        b,
                        hOut,
                        wOut,
                        d
                    ], outRank, (0, $i64bB.util).computeStrides(outShape));
                    outputVals[outputIndex] = curVal;
                }
            }
        }
        const dataId = cpuBackend.write((0, $i64bB.util).toTypedArray(outputVals, x.dtype), outShape, x.dtype);
        return {
            dataId: dataId,
            shape: outShape,
            dtype: x.dtype
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
const $e3a2dd483556a94c$export$cf83abe0e8c87ce8 = {
    kernelName: (0, $i64bB.Dilation2DBackpropFilter),
    backendName: 'cpu',
    kernelFunc: ({ inputs: inputs, backend: backend, attrs: attrs })=>{
        const { x: x, filter: filter, dy: dy } = inputs;
        const { strides: strides, pad: pad, dilations: dilations } = attrs;
        const cpuBackend = backend;
        const $x = (0, $i64bB.util).toNestedArray(x.shape, cpuBackend.data.get(x.dataId).values);
        const $filter = (0, $i64bB.util).toNestedArray(filter.shape, cpuBackend.data.get(filter.dataId).values);
        const { batchSize: batchSize, inHeight: inHeight, inWidth: inWidth, inChannels: inChannels, outHeight: outHeight, outWidth: outWidth, padInfo: padInfo, strideHeight: strideHeight, strideWidth: strideWidth, filterHeight: filterHeight, filterWidth: filterWidth, dilationHeight: dilationHeight, dilationWidth: dilationWidth, outShape: outShape } = (0, $i64bB.backend_util).computeDilation2DInfo(x.shape, filter.shape, strides, pad, 'NHWC' /* dataFormat */ , dilations);
        (0, $i64bB.util).assert(dy.rank === outShape.length, ()=>`Error in ${0, $i64bB.Dilation2DBackpropFilter}, dy ` + `must have the same rank as output ${outShape.length}, but got ` + `${dy.rank}`);
        const $dy = (0, $i64bB.util).toNestedArray(outShape, cpuBackend.data.get(dy.dataId).values);
        // The computed filter gradients has the same dimensions as the filter:
        // [filterHeight, filterWidth, depth]
        const gradients = (0, $i64bB.util).makeZerosNestedTypedArray(filter.shape, filter.dtype);
        // In the case of multiple argmax branches, we only back-propagate along the
        // last branch, i.e., the one with largest value of `h * filter_cols + w`,
        // similarly to the max-pooling backward routines.
        // This implementation follows the TF c++ implementation:
        // https://github.com/tensorflow/tensorflow/blob/d9a3a849edc198e90172bc58eb293de457f9d986/tensorflow/core/kernels/dilation_ops.cc
        for(let b = 0; b < batchSize; ++b)for(let hOut = 0; hOut < outHeight; ++hOut){
            const hBeg = hOut * strideHeight - padInfo.top;
            for(let wOut = 0; wOut < outWidth; ++wOut){
                const wBeg = wOut * strideWidth - padInfo.left;
                for(let d = 0; d < inChannels; ++d){
                    let curVal = Number.MIN_SAFE_INTEGER;
                    let hMax = 0;
                    let wMax = 0;
                    for(let h = 0; h < filterHeight; ++h){
                        const hIn = hBeg + h * dilationHeight;
                        if (hIn >= 0 && hIn < inHeight) for(let w = 0; w < filterWidth; ++w){
                            const wIn = wBeg + w * dilationWidth;
                            if (wIn >= 0 && wIn < inWidth) {
                                const val = $x[b][hIn][wIn][d] + $filter[h][w][d];
                                if (val > curVal) {
                                    curVal = val;
                                    hMax = h;
                                    wMax = w;
                                }
                            }
                        }
                    }
                    gradients[hMax][wMax][d] += $dy[b][hOut][wOut][d];
                }
            }
        }
        const dataId = cpuBackend.write((0, $i64bB.util).toTypedArray(gradients, x.dtype), filter.shape, filter.dtype);
        return {
            dataId: dataId,
            shape: filter.shape,
            dtype: filter.dtype
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
const $2298b328a5a5f387$export$42e4451417dc5ea0 = {
    kernelName: (0, $i64bB.Dilation2DBackpropInput),
    backendName: 'cpu',
    kernelFunc: ({ inputs: inputs, backend: backend, attrs: attrs })=>{
        const { x: x, filter: filter, dy: dy } = inputs;
        const { strides: strides, pad: pad, dilations: dilations } = attrs;
        const cpuBackend = backend;
        const $x = (0, $i64bB.util).toNestedArray(x.shape, cpuBackend.data.get(x.dataId).values);
        const $filter = (0, $i64bB.util).toNestedArray(filter.shape, cpuBackend.data.get(filter.dataId).values);
        const { batchSize: batchSize, inHeight: inHeight, inWidth: inWidth, inChannels: inChannels, outHeight: outHeight, outWidth: outWidth, padInfo: padInfo, strideHeight: strideHeight, strideWidth: strideWidth, filterHeight: filterHeight, filterWidth: filterWidth, dilationHeight: dilationHeight, dilationWidth: dilationWidth, outShape: outShape } = (0, $i64bB.backend_util).computeDilation2DInfo(x.shape, filter.shape, strides, pad, 'NHWC' /* dataFormat */ , dilations);
        (0, $i64bB.util).assert(dy.rank === outShape.length, ()=>`Error in ${0, $i64bB.Dilation2DBackpropInput}, dy ` + `must have the same rank as output ${outShape.length}, but got ` + `${dy.rank}`);
        const $dy = (0, $i64bB.util).toNestedArray(outShape, cpuBackend.data.get(dy.dataId).values);
        // The computed gradients has the same dimensions as the input:
        // [batch, inputHeight, inputCols, inChannel]
        const gradients = (0, $i64bB.util).makeZerosNestedTypedArray(x.shape, x.dtype);
        // In the case of multiple argmax branches, we only back-propagate along the
        // last branch, i.e., the one with largest value of `h * filter_cols + w`,
        // similarly to the max-pooling backward routines.
        // This implementation follows the TF c++ implementation:
        // https://github.com/tensorflow/tensorflow/blob/d9a3a849edc198e90172bc58eb293de457f9d986/tensorflow/core/kernels/dilation_ops.cc
        for(let b = 0; b < batchSize; ++b)for(let hOut = 0; hOut < outHeight; ++hOut){
            const hBeg = hOut * strideHeight - padInfo.top;
            for(let wOut = 0; wOut < outWidth; ++wOut){
                const wBeg = wOut * strideWidth - padInfo.left;
                for(let d = 0; d < inChannels; ++d){
                    let curVal = Number.MIN_SAFE_INTEGER;
                    let hInMax = hBeg < 0 ? 0 : hBeg;
                    let wInMax = wBeg < 0 ? 0 : wBeg;
                    for(let h = 0; h < filterHeight; ++h){
                        const hIn = hBeg + h * dilationHeight;
                        if (hIn >= 0 && hIn < inHeight) for(let w = 0; w < filterWidth; ++w){
                            const wIn = wBeg + w * dilationWidth;
                            if (wIn >= 0 && wIn < inWidth) {
                                const val = $x[b][hIn][wIn][d] + $filter[h][w][d];
                                if (val > curVal) {
                                    curVal = val;
                                    hInMax = hIn;
                                    wInMax = wIn;
                                }
                            }
                        }
                    }
                    gradients[b][hInMax][wInMax][d] += $dy[b][hOut][wOut][d];
                }
            }
        }
        const dataId = cpuBackend.write((0, $i64bB.util).toTypedArray(gradients, x.dtype), x.shape, x.dtype);
        return {
            dataId: dataId,
            shape: x.shape,
            dtype: x.dtype
        };
    }
};


/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
function $9f27439c9338b537$export$e529deb2bfd496dc(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { image: image } = inputs;
    const { canvas: canvas, options: options } = attrs;
    const { contextOptions: contextOptions, imageOptions: imageOptions } = options || {};
    const alpha = (imageOptions === null || imageOptions === void 0 ? void 0 : imageOptions.alpha) || 1;
    const contextType = (contextOptions === null || contextOptions === void 0 ? void 0 : contextOptions.contextType) || '2d';
    if (contextType !== '2d') throw new Error(`Context type ${contextOptions.contextType} is not supported by the CPU backend.`);
    const ctx = canvas.getContext(contextType, (contextOptions === null || contextOptions === void 0 ? void 0 : contextOptions.contextAttributes) || {});
    if (ctx == null) throw new Error(`Could not get the context with ${contextType} type.`);
    const [height, width] = image.shape.slice(0, 2);
    const depth = image.shape.length === 2 ? 1 : image.shape[2];
    const data = backend.data.get(image.dataId).values;
    const multiplier = image.dtype === 'float32' ? 255 : 1;
    const bytes = new Uint8ClampedArray(width * height * 4);
    for(let i = 0; i < height * width; ++i){
        const rgba = [
            0,
            0,
            0,
            255 * alpha
        ];
        for(let d = 0; d < depth; d++){
            const value = data[i * depth + d];
            if (image.dtype === 'float32') {
                if (value < 0 || value > 1) throw new Error(`Tensor values for a float32 Tensor must be in the ` + `range [0 - 1] but encountered ${value}.`);
            } else if (image.dtype === 'int32') {
                if (value < 0 || value > 255) throw new Error(`Tensor values for a int32 Tensor must be in the ` + `range [0 - 255] but encountered ${value}.`);
            }
            if (depth === 1) {
                rgba[0] = value * multiplier;
                rgba[1] = value * multiplier;
                rgba[2] = value * multiplier;
            } else rgba[d] = value * multiplier;
        }
        const j = i * 4;
        bytes[j + 0] = Math.round(rgba[0]);
        bytes[j + 1] = Math.round(rgba[1]);
        bytes[j + 2] = Math.round(rgba[2]);
        bytes[j + 3] = Math.round(rgba[3]);
    }
    canvas.width = width;
    canvas.height = height;
    const imageData = new ImageData(bytes, width, height);
    ctx.putImageData(imageData, 0, 0);
    return image;
}
const $9f27439c9338b537$export$917213cafa72964b = {
    kernelName: (0, $i64bB.Draw),
    backendName: 'cpu',
    kernelFunc: $9f27439c9338b537$export$e529deb2bfd496dc
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $gQOIy = parcelRequire("gQOIy");

/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");

var $3THkf = parcelRequire("3THkf");

var $7LLjQ = parcelRequire("7LLjQ");

var $lcqBv = parcelRequire("lcqBv");


var $EOTYn = parcelRequire("EOTYn");
function $81f3b02b80a24eb0$export$8a63f25cc62965f1(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    (0, $csahy.assertNotComplex)(x, 'sum');
    let $x;
    if (x.dtype === 'bool') $x = (0, $7LLjQ.cast)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            dtype: 'int32'
        }
    });
    else $x = (0, $lcqBv.identity)({
        inputs: {
            x: x
        },
        backend: backend
    });
    const xRank = $x.shape.length;
    const axes = (0, $i64bB.util).parseAxisParam(axis, $x.shape);
    const permutation = (0, $i64bB.backend_util).getAxesPermutation(axes, xRank);
    let reductionAxes = axes;
    let permutedX = $x;
    if (permutation != null) {
        permutedX = (0, $EOTYn.transpose)({
            inputs: {
                x: $x
            },
            backend: backend,
            attrs: {
                perm: permutation
            }
        });
        reductionAxes = (0, $i64bB.backend_util).getInnerMostAxes(reductionAxes.length, xRank);
    }
    (0, $i64bB.backend_util).assertAxesAreInnerMostDims('sum', reductionAxes, permutedX.shape.length);
    const [outShape, reduceShape] = (0, $i64bB.backend_util).computeOutAndReduceShapes(permutedX.shape, reductionAxes);
    const resultDtype = (0, $i64bB.backend_util).upcastType(permutedX.dtype, 'int32');
    let result = (0, $3THkf.zeros)(backend, outShape, resultDtype);
    const reduceSize = (0, $i64bB.util).sizeFromShape(reduceShape);
    const vals = backend.data.get(result.dataId).values;
    const aVals = backend.data.get(permutedX.dataId).values;
    for(let i = 0; i < vals.length; ++i){
        const offset = i * reduceSize;
        let sum = 0;
        for(let j = 0; j < reduceSize; ++j)sum += aVals[offset + j];
        vals[i] = sum;
    }
    if (keepDims) {
        const newShape = (0, $i64bB.backend_util).expandShapeToKeepDim(result.shape, axes);
        const oldResult = result;
        result = (0, $abec025db4e7e093$export$9eaad88cf88cee2b)({
            inputs: {
                x: result
            },
            backend: backend,
            attrs: {
                shape: newShape
            }
        });
        backend.disposeIntermediateTensorInfo(oldResult);
    }
    backend.disposeIntermediateTensorInfo($x);
    if (permutation != null) backend.disposeIntermediateTensorInfo(permutedX);
    return result;
}
const $81f3b02b80a24eb0$export$47edea402251c258 = {
    kernelName: (0, $i64bB.Sum),
    backendName: 'cpu',
    kernelFunc: $81f3b02b80a24eb0$export$8a63f25cc62965f1
};



var $EOTYn = parcelRequire("EOTYn");
function $759eb846f36195b3$export$27265e7daac5c403(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { equation: equation } = attrs;
    const tensors = inputs;
    const { allDims: allDims, summedDims: summedDims, idDims: idDims } = (0, $i64bB.backend_util).decodeEinsumEquation(equation, tensors.length);
    (0, $i64bB.backend_util).checkEinsumDimSizes(allDims.length, idDims, tensors);
    const { path: path, steps: steps } = (0, $i64bB.backend_util).getEinsumComputePath(summedDims, idDims);
    const nSteps = steps.length;
    let out = null;
    let numDimsRemaining = allDims.length;
    const tensorsToDispose = [];
    for(let i = 0; i < nSteps; ++i){
        for (const idTerm of steps[i]){
            const { permutationIndices: perm, expandDims: dimsToExpand } = (0, $i64bB.backend_util).getEinsumPermutation(numDimsRemaining, idDims[idTerm]);
            let x;
            if ((0, $i64bB.backend_util).isIdentityPermutation(perm)) x = tensors[idTerm];
            else {
                x = (0, $EOTYn.transpose)({
                    inputs: {
                        x: tensors[idTerm]
                    },
                    backend: backend,
                    attrs: {
                        perm: perm
                    }
                });
                tensorsToDispose.push(x);
            }
            const targetShape = x.shape.slice();
            for(let k = 0; k < dimsToExpand.length; ++k)targetShape.splice(dimsToExpand[k], 0, 1);
            if (!(0, $i64bB.util).arraysEqual(x.shape, targetShape)) {
                x = (0, $abec025db4e7e093$export$9eaad88cf88cee2b)({
                    inputs: {
                        x: x
                    },
                    backend: backend,
                    attrs: {
                        shape: targetShape
                    }
                });
                tensorsToDispose.push(x);
            }
            if (out === null) out = x;
            else {
                // tslint:disable-next-line: no-unnecessary-type-assertion
                out = (0, $gQOIy.multiply)({
                    inputs: {
                        a: x,
                        b: out
                    },
                    backend: backend
                });
                tensorsToDispose.push(out);
            }
        }
        if (i < nSteps - 1) {
            if (path[i] >= 0) {
                out = (0, $81f3b02b80a24eb0$export$8a63f25cc62965f1)({
                    inputs: {
                        x: out
                    },
                    backend: backend,
                    attrs: {
                        axis: path[i] - (allDims.length - numDimsRemaining),
                        keepDims: false
                    }
                });
                tensorsToDispose.push(out);
            }
            numDimsRemaining--;
        }
    }
    // Clean up intermediate tensors.
    for (const tensorInfo of tensorsToDispose){
        if (tensorInfo === out) continue;
        backend.disposeIntermediateTensorInfo(tensorInfo);
    }
    return out;
}
const $759eb846f36195b3$export$40bbf341885a23b7 = {
    kernelName: (0, $i64bB.Einsum),
    backendName: 'cpu',
    kernelFunc: $759eb846f36195b3$export$27265e7daac5c403
};



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");
function $16517782b7faebb3$export$a346244024505ff9(args) {
    const { inputs: inputs, backend: backend } = args;
    const { dy: dy, y: y } = inputs;
    (0, $csahy.assertNotComplex)([
        dy,
        y
    ], 'eluGrad');
    const resultValues = new Float32Array((0, $i64bB.util).sizeFromShape(y.shape));
    const values = backend.data.get(y.dataId).values;
    const dyValues = backend.data.get(dy.dataId).values;
    for(let i = 0; i < values.length; ++i){
        const v = values[i];
        if (v >= 0) resultValues[i] = dyValues[i];
        else resultValues[i] = dyValues[i] * (v + 1);
    }
    return backend.makeTensorInfo(y.shape, 'float32', resultValues);
}
const $16517782b7faebb3$export$59bb07dd04647a1d = {
    kernelName: (0, $i64bB.EluGrad),
    backendName: 'cpu',
    kernelFunc: $16517782b7faebb3$export$a346244024505ff9
};



var $diO4l = parcelRequire("diO4l");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $l6afd = parcelRequire("l6afd");
const $edff38cc088851e0$var$p = (0, $i64bB.backend_util).ERF_P;
const $edff38cc088851e0$var$a1 = (0, $i64bB.backend_util).ERF_A1;
const $edff38cc088851e0$var$a2 = (0, $i64bB.backend_util).ERF_A2;
const $edff38cc088851e0$var$a3 = (0, $i64bB.backend_util).ERF_A3;
const $edff38cc088851e0$var$a4 = (0, $i64bB.backend_util).ERF_A4;
const $edff38cc088851e0$var$a5 = (0, $i64bB.backend_util).ERF_A5;
const $edff38cc088851e0$export$d3896f355fc09423 = (0, $l6afd.unaryKernelFunc)((0, $i64bB.Erf), (xi)=>{
    const sign = Math.sign(xi);
    const v = Math.abs(xi);
    const t = 1.0 / (1.0 + $edff38cc088851e0$var$p * v);
    return sign * (1.0 - (((($edff38cc088851e0$var$a5 * t + $edff38cc088851e0$var$a4) * t + $edff38cc088851e0$var$a3) * t + $edff38cc088851e0$var$a2) * t + $edff38cc088851e0$var$a1) * t * Math.exp(-v * v));
});
const $edff38cc088851e0$export$d044ffef16079bd = {
    kernelName: (0, $i64bB.Erf),
    backendName: 'cpu',
    kernelFunc: $edff38cc088851e0$export$d3896f355fc09423
};



var $2ANRn = parcelRequire("2ANRn");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

function $0b6b0257239c58c8$export$d660d8ed21f46635(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { input: input } = inputs;
    const { dim: dim } = attrs;
    const inputRank = input.shape.length;
    const newShape = input.shape.slice();
    let $dim = dim;
    if (dim < 0) {
        // Negative value is counted from the tail of rank.
        (0, $i64bB.util).assert(-(inputRank + 1) <= dim, ()=>`Axis must be in the interval [${-(inputRank + 1)}, ${inputRank}]`);
        $dim = inputRank + dim + 1;
    }
    newShape.splice($dim, 0, 1);
    return (0, $abec025db4e7e093$export$9eaad88cf88cee2b)({
        inputs: {
            x: input
        },
        backend: backend,
        attrs: {
            shape: newShape
        }
    });
}
const $0b6b0257239c58c8$export$86341ba0ce5d8e60 = {
    kernelName: (0, $i64bB.ExpandDims),
    backendName: 'cpu',
    kernelFunc: $0b6b0257239c58c8$export$d660d8ed21f46635
};



var $jqUkN = parcelRequire("jqUkN");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $e8yCG = parcelRequire("e8yCG");

var $bwMVz = parcelRequire("bwMVz");


var $lcqBv = parcelRequire("lcqBv");


var $gQOIy = parcelRequire("gQOIy");

var $linqd = parcelRequire("linqd");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $jQJ39 = parcelRequire("jQJ39");

var $kgSwn = parcelRequire("kgSwn");
const $fcdf7b6c6c29ead5$export$967709f6160bacde = (0, $jQJ39.createSimpleBinaryKernelImpl)((a, b)=>a / b);
const $fcdf7b6c6c29ead5$export$159d9494db57879b = (0, $kgSwn.binaryKernelFunc)((0, $i64bB.RealDiv), $fcdf7b6c6c29ead5$export$967709f6160bacde);
const $fcdf7b6c6c29ead5$export$15c5d6176b30b9a6 = {
    kernelName: (0, $i64bB.RealDiv),
    backendName: 'cpu',
    kernelFunc: $fcdf7b6c6c29ead5$export$159d9494db57879b
};



var $aYBRE = parcelRequire("aYBRE");

var $aT9VE = parcelRequire("aT9VE");
function $6583c1bdfd85c056$export$3f1645f616cf26f8(input, inverse, cpuBackend) {
    const inputShape = input.shape;
    const batch = inputShape[0];
    const innerDim = inputShape[1];
    const inputVals = cpuBackend.data.get(input.dataId);
    const real2D = inputVals.complexTensorInfos.real;
    const imag2D = inputVals.complexTensorInfos.imag;
    // Collects real and imaginary values separately.
    const resultShape = [
        batch,
        innerDim
    ];
    const resultSize = (0, $i64bB.util).sizeFromShape(resultShape);
    const resultReal = (0, $i64bB.util).getTypedArrayFromDType('float32', resultSize);
    const resultImag = (0, $i64bB.util).getTypedArrayFromDType('float32', resultSize);
    for(let b = 0; b < batch; b++){
        // TODO: Support slice ops for complex type.
        const r = (0, $aYBRE.slice)({
            inputs: {
                x: real2D
            },
            backend: cpuBackend,
            attrs: {
                begin: [
                    b,
                    0
                ],
                size: [
                    1,
                    innerDim
                ]
            }
        });
        const i = (0, $aYBRE.slice)({
            inputs: {
                x: imag2D
            },
            backend: cpuBackend,
            attrs: {
                begin: [
                    b,
                    0
                ],
                size: [
                    1,
                    innerDim
                ]
            }
        });
        const input = (0, $bwMVz.complex)({
            inputs: {
                real: r,
                imag: i
            },
            backend: cpuBackend
        });
        // Run FFT by batch element.
        const { real: real, imag: imag } = $6583c1bdfd85c056$export$75d3742a7578721e(input, inverse, cpuBackend);
        const res = (0, $i64bB.backend_util).mergeRealAndImagArrays(real, imag);
        for(let d = 0; d < innerDim; d++){
            const c = (0, $i64bB.backend_util).getComplexWithIndex(res, d);
            resultReal[b * innerDim + d] = c.real;
            resultImag[b * innerDim + d] = c.imag;
        }
        cpuBackend.disposeIntermediateTensorInfo(r);
        cpuBackend.disposeIntermediateTensorInfo(i);
        cpuBackend.disposeIntermediateTensorInfo(input);
    }
    const $realInfo = cpuBackend.makeTensorInfo(resultShape, 'float32', resultReal);
    const $imagInfo = cpuBackend.makeTensorInfo(resultShape, 'float32', resultImag);
    const result = (0, $bwMVz.complex)({
        inputs: {
            real: $realInfo,
            imag: $imagInfo
        },
        backend: cpuBackend
    });
    cpuBackend.disposeIntermediateTensorInfo($realInfo);
    cpuBackend.disposeIntermediateTensorInfo($imagInfo);
    return result;
}
function $6583c1bdfd85c056$export$75d3742a7578721e(input, inverse, cpuBackend) {
    const inputSize = (0, $i64bB.util).sizeFromShape(input.shape);
    const inputVals = cpuBackend.data.get(input.dataId);
    const realVals = cpuBackend.data.get(inputVals.complexTensorInfos.real.dataId).values;
    const imagVals = cpuBackend.data.get(inputVals.complexTensorInfos.imag.dataId).values;
    if ($6583c1bdfd85c056$var$isExponentOf2(inputSize)) {
        const result = $6583c1bdfd85c056$var$fftRadix2(realVals, imagVals, inputSize, inverse, cpuBackend);
        const resultShape = [
            input.shape[0],
            input.shape[1]
        ];
        if (inverse) {
            const realInfo = cpuBackend.makeTensorInfo(resultShape, 'float32', result.real);
            const imagInfo = cpuBackend.makeTensorInfo(resultShape, 'float32', result.imag);
            const sizeInfo = cpuBackend.makeTensorInfo([], 'float32', (0, $i64bB.util).createScalarValue(inputSize, 'float32'));
            const sizeInfoCopy = (0, $lcqBv.identity)({
                inputs: {
                    x: sizeInfo
                },
                backend: cpuBackend
            });
            const divRealInfo = (0, $fcdf7b6c6c29ead5$export$15c5d6176b30b9a6).kernelFunc({
                inputs: {
                    a: realInfo,
                    b: sizeInfo
                },
                backend: cpuBackend
            });
            const divImagInfo = (0, $fcdf7b6c6c29ead5$export$15c5d6176b30b9a6).kernelFunc({
                inputs: {
                    a: imagInfo,
                    b: sizeInfoCopy
                },
                backend: cpuBackend
            });
            const divRealVals = cpuBackend.data.get(divRealInfo.dataId).values;
            const divImagVals = cpuBackend.data.get(divImagInfo.dataId).values;
            cpuBackend.disposeIntermediateTensorInfo(realInfo);
            cpuBackend.disposeIntermediateTensorInfo(imagInfo);
            cpuBackend.disposeIntermediateTensorInfo(sizeInfo);
            cpuBackend.disposeIntermediateTensorInfo(sizeInfoCopy);
            cpuBackend.disposeIntermediateTensorInfo(divRealInfo);
            cpuBackend.disposeIntermediateTensorInfo(divImagInfo);
            return {
                real: divRealVals,
                imag: divImagVals
            };
        }
        return result;
    } else {
        const data = (0, $i64bB.backend_util).mergeRealAndImagArrays(realVals, imagVals);
        const rawOutput = $6583c1bdfd85c056$var$fourierTransformByMatmul(data, inputSize, inverse);
        return (0, $i64bB.backend_util).splitRealAndImagArrays(rawOutput);
    }
}
function $6583c1bdfd85c056$var$isExponentOf2(size) {
    return (size & size - 1) === 0;
}
// FFT using Cooley-Tukey algorithm on radix 2 dimensional input.
function $6583c1bdfd85c056$var$fftRadix2(realVals, imagVals, size, inverse, cpuBackend) {
    if (size === 1) return {
        real: realVals,
        imag: imagVals
    };
    const data = (0, $i64bB.backend_util).mergeRealAndImagArrays(realVals, imagVals);
    const half = size / 2;
    const evenComplex = (0, $i64bB.backend_util).complexWithEvenIndex(data);
    const evenRealVals = evenComplex.real;
    const evenImagVals = evenComplex.imag;
    const evenShape = [
        evenRealVals.length
    ];
    const evenRealInfo = cpuBackend.makeTensorInfo(evenShape, 'float32', evenRealVals);
    const evenImagInfo = cpuBackend.makeTensorInfo(evenShape, 'float32', evenImagVals);
    const evenTensorInfo = (0, $bwMVz.complex)({
        inputs: {
            real: evenRealInfo,
            imag: evenImagInfo
        },
        backend: cpuBackend
    });
    const oddComplex = (0, $i64bB.backend_util).complexWithOddIndex(data);
    const oddRealVals = oddComplex.real;
    const oddImagVals = oddComplex.imag;
    const oddShape = [
        oddRealVals.length
    ];
    const oddRealInfo = cpuBackend.makeTensorInfo(oddShape, 'float32', oddRealVals);
    const oddImagInfo = cpuBackend.makeTensorInfo(oddShape, 'float32', oddImagVals);
    const oddTensorInfo = (0, $bwMVz.complex)({
        inputs: {
            real: oddRealInfo,
            imag: oddImagInfo
        },
        backend: cpuBackend
    });
    // Recursive call for half part of original input.
    const $evenComplex = $6583c1bdfd85c056$var$fftRadix2(evenRealVals, evenImagVals, half, inverse, cpuBackend);
    const $evenRealVals = $evenComplex.real;
    const $evenImagVals = $evenComplex.imag;
    const $evenShape = [
        $evenRealVals.length
    ];
    const $evenRealInfo = cpuBackend.makeTensorInfo($evenShape, 'float32', $evenRealVals);
    const $evenImagInfo = cpuBackend.makeTensorInfo($evenShape, 'float32', $evenImagVals);
    const $evenTensorInfo = (0, $bwMVz.complex)({
        inputs: {
            real: $evenRealInfo,
            imag: $evenImagInfo
        },
        backend: cpuBackend
    });
    const $oddComplex = $6583c1bdfd85c056$var$fftRadix2(oddRealVals, oddImagVals, half, inverse, cpuBackend);
    const $oddRealVals = $oddComplex.real;
    const $oddImagVals = $oddComplex.imag;
    const $oddShape = [
        $oddRealVals.length
    ];
    const $oddRealInfo = cpuBackend.makeTensorInfo($oddShape, 'float32', $oddRealVals);
    const $oddImagInfo = cpuBackend.makeTensorInfo($oddShape, 'float32', $oddImagVals);
    const $oddTensorInfo = (0, $bwMVz.complex)({
        inputs: {
            real: $oddRealInfo,
            imag: $oddImagInfo
        },
        backend: cpuBackend
    });
    const e = (0, $i64bB.backend_util).exponents(size, inverse);
    const eShape = [
        e.real.length
    ];
    const eRealInfo = cpuBackend.makeTensorInfo(eShape, 'float32', e.real);
    const eImagInfo = cpuBackend.makeTensorInfo(eShape, 'float32', e.imag);
    const complexInfo = (0, $bwMVz.complex)({
        inputs: {
            real: eRealInfo,
            imag: eImagInfo
        },
        backend: cpuBackend
    });
    const exponentInfo = (0, $gQOIy.multiply)({
        inputs: {
            a: complexInfo,
            b: $oddTensorInfo
        },
        backend: cpuBackend
    });
    const addPart = (0, $e8yCG.add)({
        inputs: {
            a: $evenTensorInfo,
            b: exponentInfo
        },
        backend: cpuBackend
    });
    const subPart = (0, $aT9VE.sub)({
        inputs: {
            a: $evenTensorInfo,
            b: exponentInfo
        },
        backend: cpuBackend
    });
    const addPartReal = (0, $linqd.real)({
        inputs: {
            input: addPart
        },
        backend: cpuBackend
    });
    const subPartReal = (0, $linqd.real)({
        inputs: {
            input: subPart
        },
        backend: cpuBackend
    });
    const addPartImag = (0, $235b2b9db5d2b70b$export$d78fab5778ab392b)({
        inputs: {
            input: addPart
        },
        backend: cpuBackend
    });
    const subPartImag = (0, $235b2b9db5d2b70b$export$d78fab5778ab392b)({
        inputs: {
            input: subPart
        },
        backend: cpuBackend
    });
    const $real = (0, $3284dfd9bccede0e$export$ee1b3e54f0441b22)({
        inputs: [
            addPartReal,
            subPartReal
        ],
        backend: cpuBackend,
        attrs: {
            axis: 0
        }
    });
    const $imag = (0, $3284dfd9bccede0e$export$ee1b3e54f0441b22)({
        inputs: [
            addPartImag,
            subPartImag
        ],
        backend: cpuBackend,
        attrs: {
            axis: 0
        }
    });
    const $realVals = cpuBackend.data.get($real.dataId).values;
    const $imagVals = cpuBackend.data.get($imag.dataId).values;
    cpuBackend.disposeIntermediateTensorInfo(evenRealInfo);
    cpuBackend.disposeIntermediateTensorInfo(evenImagInfo);
    cpuBackend.disposeIntermediateTensorInfo(evenTensorInfo);
    cpuBackend.disposeIntermediateTensorInfo(oddRealInfo);
    cpuBackend.disposeIntermediateTensorInfo(oddImagInfo);
    cpuBackend.disposeIntermediateTensorInfo(oddTensorInfo);
    cpuBackend.disposeIntermediateTensorInfo($evenRealInfo);
    cpuBackend.disposeIntermediateTensorInfo($evenImagInfo);
    cpuBackend.disposeIntermediateTensorInfo($evenTensorInfo);
    cpuBackend.disposeIntermediateTensorInfo($oddRealInfo);
    cpuBackend.disposeIntermediateTensorInfo($oddImagInfo);
    cpuBackend.disposeIntermediateTensorInfo($oddTensorInfo);
    cpuBackend.disposeIntermediateTensorInfo(eRealInfo);
    cpuBackend.disposeIntermediateTensorInfo(eImagInfo);
    cpuBackend.disposeIntermediateTensorInfo(complexInfo);
    cpuBackend.disposeIntermediateTensorInfo(exponentInfo);
    cpuBackend.disposeIntermediateTensorInfo(addPart);
    cpuBackend.disposeIntermediateTensorInfo(subPart);
    cpuBackend.disposeIntermediateTensorInfo(addPartReal);
    cpuBackend.disposeIntermediateTensorInfo(addPartImag);
    cpuBackend.disposeIntermediateTensorInfo(subPartReal);
    cpuBackend.disposeIntermediateTensorInfo(subPartImag);
    cpuBackend.disposeIntermediateTensorInfo($real);
    cpuBackend.disposeIntermediateTensorInfo($imag);
    return {
        real: $realVals,
        imag: $imagVals
    };
}
// Calculate fourier transform by multplying sinusoid matrix.
function $6583c1bdfd85c056$var$fourierTransformByMatmul(data, size, inverse) {
    const ret = new Float32Array(size * 2);
    // TODO: Use matmul instead once it supports complex64 type.
    for(let r = 0; r < size; r++){
        let real = 0.0;
        let imag = 0.0;
        for(let c = 0; c < size; c++){
            const e = (0, $i64bB.backend_util).exponent(r * c, size, inverse);
            const term = (0, $i64bB.backend_util).getComplexWithIndex(data, c);
            real += term.real * e.real - term.imag * e.imag;
            imag += term.real * e.imag + term.imag * e.real;
        }
        if (inverse) {
            real /= size;
            imag /= size;
        }
        (0, $i64bB.backend_util).assignToTypedArray(ret, real, imag, r);
    }
    return ret;
}



function $77ce7c1b5ddb5067$export$a535ef183b6128fa(args) {
    const { inputs: inputs, backend: backend } = args;
    const { input: input } = inputs;
    const inputSize = (0, $i64bB.util).sizeFromShape(input.shape);
    // Collapse all outer dimensions to a single batch dimension.
    const innerDimensionSize = input.shape[input.shape.length - 1];
    const batch = inputSize / innerDimensionSize;
    const input2D = (0, $abec025db4e7e093$export$9eaad88cf88cee2b)({
        inputs: {
            x: input
        },
        backend: backend,
        attrs: {
            shape: [
                batch,
                innerDimensionSize
            ]
        }
    });
    const result = (0, $6583c1bdfd85c056$export$3f1645f616cf26f8)(input2D, false, backend);
    const resultReshaped = (0, $abec025db4e7e093$export$9eaad88cf88cee2b)({
        inputs: {
            x: result
        },
        backend: backend,
        attrs: {
            shape: input.shape
        }
    });
    backend.disposeIntermediateTensorInfo(input2D);
    backend.disposeIntermediateTensorInfo(result);
    return resultReshaped;
}
const $77ce7c1b5ddb5067$export$a4d564e380763c78 = {
    kernelName: (0, $i64bB.FFT),
    backendName: 'cpu',
    kernelFunc: $77ce7c1b5ddb5067$export$a535ef183b6128fa
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
function $bdf4b57d5da6d47b$export$9563e054e6f787fb(args) {
    const { backend: backend, attrs: attrs } = args;
    const { shape: shape, value: value, dtype: dtype } = attrs;
    const $dtype = dtype || (0, $i64bB.util).inferDtype(value);
    const values = (0, $i64bB.util).getArrayFromDType($dtype, (0, $i64bB.util).sizeFromShape(shape));
    $bdf4b57d5da6d47b$var$fillValues(values, value, $dtype);
    return backend.makeTensorInfo(shape, $dtype, values);
}
const $bdf4b57d5da6d47b$export$c953bf474b2bde62 = {
    kernelName: (0, $i64bB.Fill),
    backendName: 'cpu',
    kernelFunc: $bdf4b57d5da6d47b$export$9563e054e6f787fb
};
function $bdf4b57d5da6d47b$var$fillValues(values, value, dtype) {
    if (dtype === 'string') values.fill(value);
    else values.fill(value);
}


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
const $fbd52558676e3b9b$export$c9ec83cb23304466 = {
    kernelName: (0, $i64bB.FlipLeftRight),
    backendName: 'cpu',
    kernelFunc: ({ inputs: inputs, attrs: attrs, backend: backend })=>{
        const { image: image } = inputs;
        const cpuBackend = backend;
        const output = (0, $i64bB.util).getTypedArrayFromDType(image.dtype, (0, $i64bB.util).sizeFromShape(image.shape));
        const [batch, imageHeight, imageWidth, numChannels] = image.shape;
        const imageVals = cpuBackend.data.get(image.dataId).values;
        for(let batchIdx = 0; batchIdx < batch; batchIdx++){
            const batchOffset = batchIdx * imageWidth * imageHeight * numChannels;
            for(let row = 0; row < imageHeight; row++){
                const rowOffset = row * (imageWidth * numChannels);
                for(let col = 0; col < imageWidth; col++){
                    const colOffset = col * numChannels;
                    for(let channel = 0; channel < numChannels; channel++){
                        const coordX = Math.round(imageWidth - col - 1);
                        const outIdx = batchOffset + rowOffset + colOffset + channel;
                        let outputValue = imageVals[outIdx];
                        // If the coordinate position falls within the image boundaries...
                        if (coordX >= 0 && coordX < imageWidth) {
                            // set the output to the image value at the coordinate position.
                            const rotatedColOffset = coordX * numChannels;
                            const imageIdx = batchOffset + rowOffset + rotatedColOffset + channel;
                            outputValue = imageVals[imageIdx];
                        }
                        output[outIdx] = outputValue;
                    }
                }
            }
        }
        const dataId = cpuBackend.write(output, image.shape, image.dtype);
        return {
            dataId: dataId,
            shape: image.shape,
            dtype: image.dtype
        };
    }
};



var $Jvx9v = parcelRequire("Jvx9v");

var $hj1kT = parcelRequire("hj1kT");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


var $e8yCG = parcelRequire("e8yCG");


function $b6afd83b60286675$export$8db45c19fd28b6b8(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter, bias: bias, preluActivationWeights: preluActivationWeights } = inputs;
    const { strides: strides, pad: pad, dataFormat: dataFormat, dilations: dilations, dimRoundingMode: dimRoundingMode, activation: activation, leakyreluAlpha: leakyreluAlpha } = attrs;
    let result = (0, $33872f5c298aaa1e$export$5a2ce5b05041d9e4)({
        inputs: {
            x: x,
            filter: filter
        },
        backend: backend,
        attrs: {
            strides: strides,
            pad: pad,
            dataFormat: dataFormat,
            dilations: dilations,
            dimRoundingMode: dimRoundingMode
        }
    });
    if (bias) {
        const resultOld = result;
        // For NCHW format, if bias is a 1-D tensor, it is supposed to be aligned
        // to the channel of the conv2d's result; if the bias is a scalar, the
        // bias_add is computed as if the bias was broadcasted to the shape of the
        // conv2d's result.
        if (dataFormat === 'NCHW' && bias.shape.length === 1 && bias.shape[0] !== 1) {
            const reshapedBias = (0, $abec025db4e7e093$export$9eaad88cf88cee2b)({
                inputs: {
                    x: bias
                },
                backend: backend,
                attrs: {
                    shape: [
                        bias.shape[0],
                        1,
                        1
                    ]
                }
            });
            result = (0, $e8yCG.add)({
                inputs: {
                    a: result,
                    b: reshapedBias
                },
                backend: backend
            });
            backend.disposeIntermediateTensorInfo(reshapedBias);
        } else // This condition handles NHWC and NCHW (scalar case). The only other case
        // for NCHW (1D case) is handled above.
        result = (0, $e8yCG.add)({
            inputs: {
                a: result,
                b: bias
            },
            backend: backend
        });
        backend.disposeIntermediateTensorInfo(resultOld);
    }
    if (activation) {
        const resultOld = result;
        // For NCHW format, if PReLu activation weights is a 1-D tensor, it is
        // supposed to be aligned with the channel of the conv2d's result. For other
        // cases, whether NCHW or NHWC data format, the conv2d result is
        // already aligned with the activation weights.
        if (dataFormat === 'NCHW' && activation === 'prelu' && preluActivationWeights.shape.length === 1 && preluActivationWeights.shape[0] !== 1) {
            const reshapedAlpha = (0, $abec025db4e7e093$export$9eaad88cf88cee2b)({
                inputs: {
                    x: preluActivationWeights
                },
                backend: backend,
                attrs: {
                    shape: [
                        preluActivationWeights.shape[0],
                        1,
                        1
                    ]
                }
            });
            result = (0, $2e3684d349b4bf60$export$a0f250a2ba84196)(backend, result, activation, reshapedAlpha, leakyreluAlpha);
            backend.disposeIntermediateTensorInfo(reshapedAlpha);
        } else result = (0, $2e3684d349b4bf60$export$a0f250a2ba84196)(backend, result, activation, preluActivationWeights, leakyreluAlpha);
        backend.disposeIntermediateTensorInfo(resultOld);
    }
    return result;
}
const $b6afd83b60286675$export$5b64efa829ddf94e = {
    kernelName: (0, $i64bB.FusedConv2D),
    backendName: 'cpu',
    kernelFunc: $b6afd83b60286675$export$8db45c19fd28b6b8
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


var $e8yCG = parcelRequire("e8yCG");

function $a9847ceda5fe8a2b$export$d61de7729228094b(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter, bias: bias, preluActivationWeights: preluActivationWeights } = inputs;
    const { strides: strides, pad: pad, dataFormat: dataFormat, dilations: dilations, dimRoundingMode: dimRoundingMode, activation: activation, leakyreluAlpha: leakyreluAlpha } = attrs;
    let result = (0, $6a85a496ede50ffd$export$14e793fe8822afd1)({
        inputs: {
            x: x,
            filter: filter
        },
        backend: backend,
        attrs: {
            strides: strides,
            pad: pad,
            dataFormat: dataFormat,
            dilations: dilations,
            dimRoundingMode: dimRoundingMode
        }
    });
    if (bias) {
        const oldResult = result;
        result = (0, $e8yCG.add)({
            inputs: {
                a: result,
                b: bias
            },
            backend: backend
        });
        backend.disposeIntermediateTensorInfo(oldResult);
    }
    if (activation) {
        const oldResult = result;
        result = (0, $2e3684d349b4bf60$export$a0f250a2ba84196)(backend, result, activation, preluActivationWeights, leakyreluAlpha);
        backend.disposeIntermediateTensorInfo(oldResult);
    }
    return result;
}
const $a9847ceda5fe8a2b$export$58481cc3409b412c = {
    kernelName: (0, $i64bB.FusedDepthwiseConv2D),
    backendName: 'cpu',
    kernelFunc: $a9847ceda5fe8a2b$export$d61de7729228094b
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $cC9SN = parcelRequire("cC9SN");
function $a06520e232579790$export$3c586830e482d2b9(args) {
    const { inputs: inputs, backend: backend } = args;
    const { params: params, indices: indices } = inputs;
    const paramsSize = (0, $i64bB.util).sizeFromShape(params.shape);
    const indicesShape = indices.shape;
    const sliceRank = indicesShape[indicesShape.length - 1];
    const [resultShape, numSlices, sliceSize, strides] = (0, $i64bB.backend_util).prepareAndValidate(params, indices);
    if (numSlices === 0) return backend.makeTensorInfo(resultShape, params.dtype, []);
    const indicesData = backend.data.get(indices.dataId).values;
    const paramsBuf = backend.bufferSync(params);
    const outBuf = (0, $cC9SN.gatherNdImpl)(indicesData, paramsBuf, params.dtype, numSlices, sliceRank, sliceSize, strides, params.shape, paramsSize);
    return backend.makeTensorInfo(resultShape, params.dtype, outBuf.values);
}
const $a06520e232579790$export$d9700eb1c7f5c969 = {
    kernelName: (0, $i64bB.GatherNd),
    backendName: 'cpu',
    kernelFunc: $a06520e232579790$export$3c586830e482d2b9
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");

var $hNUKd = parcelRequire("hNUKd");

function $7ed7af8bd9715f59$export$3d75b4295ded9925(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, indices: indices } = inputs;
    const { axis: axis, batchDims: batchDims } = attrs;
    (0, $csahy.assertNotComplex)([
        x,
        indices
    ], 'gatherV2');
    // Throw error when any index is out of bound.
    const parsedAxis = (0, $i64bB.util).parseAxisParam(axis, x.shape)[0];
    const indicesVals = backend.data.get(indices.dataId).values;
    const axisDim = x.shape[parsedAxis];
    for(let i = 0; i < indicesVals.length; ++i){
        const index = indicesVals[i];
        (0, $i64bB.util).assert(index <= axisDim - 1 && index >= 0, ()=>`GatherV2: the index value ${index} is not in [0, ${axisDim - 1}]`);
    }
    let $batchDims = batchDims;
    if (batchDims == null) $batchDims = 0;
    const indicesSize = (0, $i64bB.util).sizeFromShape(indices.shape);
    const shapeInfo = (0, $i64bB.backend_util).segment_util.collectGatherOpShapeInfo(x, indices, parsedAxis, $batchDims);
    const flattenX = (0, $abec025db4e7e093$export$9eaad88cf88cee2b)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            shape: [
                shapeInfo.batchSize,
                shapeInfo.outerSize,
                shapeInfo.dimSize,
                shapeInfo.sliceSize
            ]
        }
    });
    const flattenIndex = (0, $abec025db4e7e093$export$9eaad88cf88cee2b)({
        inputs: {
            x: indices
        },
        backend: backend,
        attrs: {
            shape: [
                shapeInfo.batchSize,
                indicesSize / shapeInfo.batchSize
            ]
        }
    });
    const flattenOutputShape = [
        shapeInfo.batchSize,
        shapeInfo.outerSize,
        indicesSize / shapeInfo.batchSize,
        shapeInfo.sliceSize
    ];
    const indicesBuf = backend.bufferSync(flattenIndex);
    const xBuf = backend.bufferSync(flattenX);
    const outBuf = (0, $hNUKd.gatherV2Impl)(xBuf, indicesBuf, flattenOutputShape);
    backend.disposeIntermediateTensorInfo(flattenX);
    backend.disposeIntermediateTensorInfo(flattenIndex);
    return backend.makeTensorInfo(shapeInfo.outputShape, outBuf.dtype, outBuf.values);
}
const $7ed7af8bd9715f59$export$b1bd3139c91d8765 = {
    kernelName: (0, $i64bB.GatherV2),
    backendName: 'cpu',
    kernelFunc: $7ed7af8bd9715f59$export$3d75b4295ded9925
};



var $2Apjw = parcelRequire("2Apjw");

var $9yHtq = parcelRequire("9yHtq");

var $lcqBv = parcelRequire("lcqBv");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


function $3b641a0bf3018f44$export$776649b0bf8ce1fd(args) {
    const { inputs: inputs, backend: backend } = args;
    const { input: input } = inputs;
    const inputSize = (0, $i64bB.util).sizeFromShape(input.shape);
    // Collapse all outer dimensions to a single batch dimension.
    const innerDimensionSize = input.shape[input.shape.length - 1];
    const batch = inputSize / innerDimensionSize;
    const input2D = (0, $abec025db4e7e093$export$9eaad88cf88cee2b)({
        inputs: {
            x: input
        },
        backend: backend,
        attrs: {
            shape: [
                batch,
                innerDimensionSize
            ]
        }
    });
    const result = (0, $6583c1bdfd85c056$export$3f1645f616cf26f8)(input2D, true, backend);
    const resultReshaped = (0, $abec025db4e7e093$export$9eaad88cf88cee2b)({
        inputs: {
            x: result
        },
        backend: backend,
        attrs: {
            shape: input.shape
        }
    });
    backend.disposeIntermediateTensorInfo(input2D);
    backend.disposeIntermediateTensorInfo(result);
    return resultReshaped;
}
const $3b641a0bf3018f44$export$dc267425bf21b465 = {
    kernelName: (0, $i64bB.IFFT),
    backendName: 'cpu',
    kernelFunc: $3b641a0bf3018f44$export$776649b0bf8ce1fd
};



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $l6afd = parcelRequire("l6afd");
const $11497eb05465f370$export$65f0b13f2f82375a = (0, $l6afd.unaryKernelFunc)((0, $i64bB.IsFinite), (xi)=>Number.isFinite(xi) ? 1 : 0, 'bool');
const $11497eb05465f370$export$4d45c8f7b9ffdaf1 = {
    kernelName: (0, $i64bB.IsFinite),
    backendName: 'cpu',
    kernelFunc: $11497eb05465f370$export$65f0b13f2f82375a
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $l6afd = parcelRequire("l6afd");
const $c0416a3848ef67c2$export$e5d3415c656f7096 = (0, $l6afd.unaryKernelFunc)((0, $i64bB.IsInf), (xi)=>Math.abs(xi) === Infinity ? 1 : 0, 'bool');
const $c0416a3848ef67c2$export$bc383b82282e9b5a = {
    kernelName: (0, $i64bB.IsInf),
    backendName: 'cpu',
    kernelFunc: $c0416a3848ef67c2$export$e5d3415c656f7096
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $l6afd = parcelRequire("l6afd");
const $bb3401b9dd825cdd$export$c9f5652083b8129d = (0, $l6afd.unaryKernelFunc)((0, $i64bB.IsNan), (xi)=>Number.isNaN(xi) ? 1 : 0, 'bool');
const $bb3401b9dd825cdd$export$d58ff790c765c1f0 = {
    kernelName: (0, $i64bB.IsNan),
    backendName: 'cpu',
    kernelFunc: $bb3401b9dd825cdd$export$c9f5652083b8129d
};




var $jJNGT = parcelRequire("jJNGT");

var $bwE16 = parcelRequire("bwE16");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $6U5ue = parcelRequire("6U5ue");
function $122cc50bc128045c$export$865a19adce4d7a46(args) {
    const { backend: backend, attrs: attrs } = args;
    const { start: start, stop: stop, num: num } = attrs;
    const outVals = (0, $6U5ue.linSpaceImpl)(start, stop, num);
    return backend.makeTensorInfo([
        outVals.length
    ], 'float32', outVals);
}
const $122cc50bc128045c$export$46b96f742c70959b = {
    kernelName: (0, $i64bB.LinSpace),
    backendName: 'cpu',
    kernelFunc: $122cc50bc128045c$export$865a19adce4d7a46
};



var $2La7K = parcelRequire("2La7K");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $l6afd = parcelRequire("l6afd");
const $ee3c26bd1169e7e2$export$144dcf16adfb9698 = (0, $l6afd.unaryKernelFunc)((0, $i64bB.Log1p), (xi)=>Math.log1p(xi));
const $ee3c26bd1169e7e2$export$c458b9e5ba980198 = {
    kernelName: (0, $i64bB.Log1p),
    backendName: 'cpu',
    kernelFunc: $ee3c26bd1169e7e2$export$144dcf16adfb9698
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $jQJ39 = parcelRequire("jQJ39");

var $kgSwn = parcelRequire("kgSwn");
const $056738b846498d67$export$e75adbe8a6aa8c40 = (0, $jQJ39.createSimpleBinaryKernelImpl)((a, b)=>a && b);
const $056738b846498d67$export$db5dd0ef9d505f = (0, $kgSwn.binaryKernelFunc)((0, $i64bB.LogicalAnd), $056738b846498d67$export$e75adbe8a6aa8c40, null, 'bool');
const $056738b846498d67$export$257f1e82e69113fb = {
    kernelName: (0, $i64bB.LogicalAnd),
    backendName: 'cpu',
    kernelFunc: $056738b846498d67$export$db5dd0ef9d505f
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $l6afd = parcelRequire("l6afd");
const $bb112960a25f6f59$export$c836ff7b605b1617 = (0, $l6afd.unaryKernelFunc)((0, $i64bB.LogicalNot), (xi)=>xi ? 0 : 1, 'bool');
const $bb112960a25f6f59$export$68e2dd0840056271 = {
    kernelName: (0, $i64bB.LogicalNot),
    backendName: 'cpu',
    kernelFunc: $bb112960a25f6f59$export$c836ff7b605b1617
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $jQJ39 = parcelRequire("jQJ39");

var $kgSwn = parcelRequire("kgSwn");
const $5174880ee5e49c61$export$9b10f32fda33cd6f = (0, $jQJ39.createSimpleBinaryKernelImpl)((a, b)=>a || b);
const $5174880ee5e49c61$export$e2a73975983cadd8 = (0, $kgSwn.binaryKernelFunc)((0, $i64bB.LogicalOr), $5174880ee5e49c61$export$9b10f32fda33cd6f, null, 'bool');
const $5174880ee5e49c61$export$ce04b6546987ef43 = {
    kernelName: (0, $i64bB.LogicalOr),
    backendName: 'cpu',
    kernelFunc: $5174880ee5e49c61$export$e2a73975983cadd8
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");
function $5fb5287420fc28a8$export$ac78e832c121c629(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { depthRadius: depthRadius, bias: bias, alpha: alpha, beta: beta } = attrs;
    (0, $csahy.assertNotComplex)(x, 'LRN');
    const channels = x.shape[3];
    const maxD = channels - 1;
    const xValues = backend.data.get(x.dataId).values;
    const size = (0, $i64bB.util).sizeFromShape(x.shape);
    const result = new Float32Array(size);
    function sumAcrossChannels(offset) {
        const currentChannel = offset % channels;
        let beginSumOffset = offset - currentChannel + Math.max(0, currentChannel - depthRadius);
        const endSumOffset = offset - currentChannel + Math.min(currentChannel + depthRadius, maxD);
        let sum = 0.0;
        for(; beginSumOffset <= endSumOffset; beginSumOffset++){
            const z = xValues[beginSumOffset];
            sum += z * z;
        }
        return sum;
    }
    for(let offset = 0; offset < size; offset++){
        const sum = sumAcrossChannels(offset);
        const val = xValues[offset] * Math.pow(bias + alpha * sum, -beta);
        result[offset] = val;
    }
    return backend.makeTensorInfo(x.shape, x.dtype, result);
}
const $5fb5287420fc28a8$export$6fb124d5a6994734 = {
    kernelName: (0, $i64bB.LRN),
    backendName: 'cpu',
    kernelFunc: $5fb5287420fc28a8$export$ac78e832c121c629
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");
function $23cd881c4c246ca0$export$c4c981cfebdcf90(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, y: y, dy: dy } = inputs;
    const { depthRadius: depthRadius, bias: bias, alpha: alpha, beta: beta } = attrs;
    (0, $csahy.assertNotComplex)(dy, 'LRNGrad');
    const dySize = (0, $i64bB.util).sizeFromShape(dy.shape);
    const channels = dy.shape[3];
    const dyValues = backend.data.get(dy.dataId).values;
    const xValues = backend.data.get(x.dataId).values;
    const yValues = backend.data.get(y.dataId).values;
    const result = new Float32Array(dySize);
    const size = dySize;
    for(let offset = 0; offset < size; offset++){
        const currentChannel = offset % channels;
        const depthBegin = offset - currentChannel + Math.max(0, currentChannel - depthRadius);
        const depthEnd = offset - currentChannel + Math.min(channels, currentChannel + depthRadius + 1);
        let norm = 0;
        for(let k = depthBegin; k < depthEnd; k++)norm += Math.pow(xValues[k], 2);
        norm = alpha * norm + bias;
        for(let k = depthBegin; k < depthEnd; k++){
            let dyi = -2 * alpha * beta * xValues[k] * yValues[offset] / norm;
            if (offset === k) dyi += Math.pow(norm, -beta);
            dyi *= dyValues[offset];
            result[k] += dyi;
        }
    }
    return backend.makeTensorInfo(dy.shape, x.dtype, result);
}
const $23cd881c4c246ca0$export$99a62fc039d7aca0 = {
    kernelName: (0, $i64bB.LRNGrad),
    backendName: 'cpu',
    kernelFunc: $23cd881c4c246ca0$export$c4c981cfebdcf90
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");

var $cjSsc = parcelRequire("cjSsc");

var $4m8st = parcelRequire("4m8st");
function $58aa85413e381680$export$8960430cfd85939f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { reductionIndices: reductionIndices, keepDims: keepDims } = attrs;
    const cpuBackend = backend;
    let xShape = x.shape;
    const xRank = xShape.length;
    const origAxes = (0, $i64bB.util).parseAxisParam(reductionIndices, xShape);
    let axes = origAxes;
    const permutedAxes = (0, $i64bB.backend_util).getAxesPermutation(axes, xRank);
    let xVals = cpuBackend.data.get(x.dataId).values;
    if (permutedAxes != null) {
        const newShape = new Array(xRank);
        for(let i = 0; i < newShape.length; i++)newShape[i] = xShape[permutedAxes[i]];
        xVals = (0, $4m8st.transposeImpl)(xVals, xShape, x.dtype, permutedAxes, newShape);
        axes = (0, $i64bB.backend_util).getInnerMostAxes(axes.length, xRank);
        xShape = newShape;
    }
    (0, $csahy.assertNotComplex)(x, 'max');
    (0, $i64bB.backend_util).assertAxesAreInnerMostDims('max', axes, xRank);
    const [maxOutShape, reduceShape] = (0, $i64bB.backend_util).computeOutAndReduceShapes(xShape, axes);
    const reduceSize = (0, $i64bB.util).sizeFromShape(reduceShape);
    const result = (0, $cjSsc.maxImpl)(xVals, reduceSize, maxOutShape, x.dtype);
    const dataId = cpuBackend.write(result, maxOutShape, x.dtype);
    let outShape = maxOutShape;
    if (keepDims) {
        // reshape
        const newShape = (0, $i64bB.backend_util).expandShapeToKeepDim(maxOutShape, origAxes);
        outShape = newShape;
    }
    return {
        dataId: dataId,
        shape: outShape,
        dtype: x.dtype
    };
}
const $58aa85413e381680$export$7d79147246e312bb = {
    kernelName: (0, $i64bB.Max),
    backendName: 'cpu',
    kernelFunc: $58aa85413e381680$export$8960430cfd85939f
};



var $IzL7H = parcelRequire("IzL7H");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");


var $lcqBv = parcelRequire("lcqBv");
function $e2748a173d2f1c22$export$e4aadcf115842782(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    (0, $csahy.assertNotComplex)(x, 'maxPool');
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    const dilations = 1;
    (0, $i64bB.util).assert((0, $i64bB.backend_util).eitherStridesOrDilationsAreOne(strides, dilations), ()=>'Error in maxPool: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    const convInfo = (0, $i64bB.backend_util).computePool2DInfo(x.shape, filterSize, strides, dilations, pad, dimRoundingMode);
    let res;
    if (convInfo.filterWidth === 1 && convInfo.filterHeight === 1 && (0, $i64bB.util).arraysEqual(convInfo.inShape, convInfo.outShape)) res = (0, $lcqBv.identity)({
        inputs: {
            x: x
        },
        backend: backend
    });
    else {
        const xValues = backend.data.get(x.dataId).values;
        const strides = (0, $i64bB.util).computeStrides(x.shape);
        const buffer = (0, $e9280844b6abe1d7$export$7a0e2789ec54f0db)(xValues, x.shape, x.dtype, strides, convInfo, 'max');
        res = backend.makeTensorInfo(convInfo.outShape, x.dtype, buffer.values);
    }
    return res;
}
const $e2748a173d2f1c22$export$45c8263b38f19e33 = {
    kernelName: (0, $i64bB.MaxPool),
    backendName: 'cpu',
    kernelFunc: $e2748a173d2f1c22$export$e4aadcf115842782
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");

function $ca717d02dc939f15$export$bf5a4705068838e7(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode, dataFormat: dataFormat } = attrs;
    (0, $csahy.assertNotComplex)(x, 'maxPool3d');
    const convInfo = (0, $i64bB.backend_util).computePool3DInfo(x.shape, filterSize, strides, 1 /* dilations */ , pad, dimRoundingMode, dataFormat);
    const xValues = backend.data.get(x.dataId).values;
    const outBuf = (0, $e9280844b6abe1d7$export$3712ebf21d29ff82)(xValues, x.shape, x.dtype, (0, $i64bB.util).computeStrides(x.shape), convInfo, 'max');
    return backend.makeTensorInfo(outBuf.shape, 'float32', outBuf.values);
}
const $ca717d02dc939f15$export$91a8fc5da39ec855 = {
    kernelName: (0, $i64bB.MaxPool3D),
    backendName: 'cpu',
    kernelFunc: $ca717d02dc939f15$export$bf5a4705068838e7
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");

function $00fa40be13b7a7ae$export$e68b9bef571dd4ea(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, input: input } = inputs;
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    (0, $csahy.assertNotComplex)([
        dy,
        input
    ], 'maxPool3DGrad');
    const convInfo = (0, $i64bB.backend_util).computePool3DInfo(input.shape, filterSize, strides, 1 /* dilations */ , pad, dimRoundingMode);
    const inputBuf = backend.bufferSync(input);
    const maxPosBuf = (0, $e9280844b6abe1d7$export$e389a84eda2bb69e)(inputBuf, convInfo);
    const strideDepth = convInfo.strideDepth;
    const strideHeight = convInfo.strideHeight;
    const strideWidth = convInfo.strideWidth;
    const dilationDepth = convInfo.dilationDepth;
    const dilationHeight = convInfo.dilationHeight;
    const dilationWidth = convInfo.dilationWidth;
    const effectiveFilterDepth = convInfo.effectiveFilterDepth;
    const effectiveFilterHeight = convInfo.effectiveFilterHeight;
    const effectiveFilterWidth = convInfo.effectiveFilterWidth;
    const padFront = effectiveFilterDepth - 1 - convInfo.padInfo.front;
    const padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
    const padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
    const dx = (0, $i64bB.buffer)(input.shape, 'float32');
    const dyBuf = backend.bufferSync(dy);
    for(let batch = 0; batch < convInfo.batchSize; ++batch){
        for(let channel = 0; channel < convInfo.inChannels; ++channel)for(let dxDepth = 0; dxDepth < convInfo.inDepth; ++dxDepth){
            for(let dxRow = 0; dxRow < convInfo.inHeight; ++dxRow)for(let dxCol = 0; dxCol < convInfo.inWidth; ++dxCol){
                // Shader code begins
                const dyDepthCorner = dxDepth - padFront;
                const dyRowCorner = dxRow - padTop;
                const dyColCorner = dxCol - padLeft;
                let dotProd = 0;
                for(let wDepth = 0; wDepth < effectiveFilterDepth; wDepth += dilationDepth){
                    const dyDepth = (dyDepthCorner + wDepth) / strideDepth;
                    if (dyDepth < 0 || dyDepth >= convInfo.outDepth || Math.floor(dyDepth) !== dyDepth) continue;
                    for(let wRow = 0; wRow < effectiveFilterHeight; wRow += dilationHeight){
                        const dyRow = (dyRowCorner + wRow) / strideHeight;
                        if (dyRow < 0 || dyRow >= convInfo.outHeight || Math.floor(dyRow) !== dyRow) continue;
                        for(let wCol = 0; wCol < effectiveFilterWidth; wCol += dilationWidth){
                            const dyCol = (dyColCorner + wCol) / strideWidth;
                            if (dyCol < 0 || dyCol >= convInfo.outWidth || Math.floor(dyCol) !== dyCol) continue;
                            const maxPos = effectiveFilterDepth * effectiveFilterHeight * effectiveFilterWidth - 1 - maxPosBuf.get(batch, dyDepth, dyRow, dyCol, channel);
                            const curPos = wDepth * effectiveFilterHeight * effectiveFilterWidth + wRow * effectiveFilterWidth + wCol;
                            const mask = maxPos === curPos ? 1 : 0;
                            if (mask === 0) continue;
                            const pixel = dyBuf.get(batch, dyDepth, dyRow, dyCol, channel);
                            dotProd += pixel * mask;
                        }
                    }
                }
                dx.set(dotProd, batch, dxDepth, dxRow, dxCol, channel);
            }
        }
    }
    return backend.makeTensorInfo(dx.shape, dx.dtype, dx.values);
}
const $00fa40be13b7a7ae$export$5201426bb10bd5eb = {
    kernelName: (0, $i64bB.MaxPool3DGrad),
    backendName: 'cpu',
    kernelFunc: $00fa40be13b7a7ae$export$e68b9bef571dd4ea
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");

function $3517385ef9fb6fed$export$85dfd1121f049514(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, input: input, output: output } = inputs;
    const x = input;
    (0, $csahy.assertNotComplex)([
        input,
        output
    ], 'maxPoolGrad');
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    const convInfo = (0, $i64bB.backend_util).computePool2DInfo(x.shape, filterSize, strides, 1 /* dilations */ , pad, dimRoundingMode);
    const xValues = backend.data.get(x.dataId).values;
    const maxPosBuf = (0, $i64bB.buffer)(convInfo.outShape, x.dtype, (0, $e9280844b6abe1d7$export$60b78444d0fe518d)(xValues, x.shape, x.dtype, convInfo).values);
    const strideHeight = convInfo.strideHeight;
    const strideWidth = convInfo.strideWidth;
    const dilationHeight = convInfo.dilationHeight;
    const dilationWidth = convInfo.dilationWidth;
    const effectiveFilterHeight = convInfo.effectiveFilterHeight;
    const effectiveFilterWidth = convInfo.effectiveFilterWidth;
    const padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
    const padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
    const dx = (0, $i64bB.buffer)(x.shape, 'float32');
    const dyData = backend.data.get(dy.dataId).values;
    const dyBuf = (0, $i64bB.buffer)(dy.shape, 'float32', dyData);
    for(let b = 0; b < convInfo.batchSize; ++b)for(let d = 0; d < convInfo.inChannels; ++d){
        for(let dxR = 0; dxR < convInfo.inHeight; ++dxR)for(let dxC = 0; dxC < convInfo.inWidth; ++dxC){
            // Shader code begins.
            const dyRCorner = dxR - padTop;
            const dyCCorner = dxC - padLeft;
            let dotProd = 0;
            for(let wR = 0; wR < effectiveFilterHeight; wR += dilationHeight){
                const dyR = (dyRCorner + wR) / strideHeight;
                if (dyR < 0 || dyR >= convInfo.outHeight || Math.floor(dyR) !== dyR) continue;
                for(let wC = 0; wC < effectiveFilterWidth; wC += dilationWidth){
                    const dyC = (dyCCorner + wC) / strideWidth;
                    if (dyC < 0 || dyC >= convInfo.outWidth || Math.floor(dyC) !== dyC) continue;
                    const maxPos = effectiveFilterHeight * effectiveFilterWidth - 1 - maxPosBuf.get(b, dyR, dyC, d);
                    const curPos = wR * effectiveFilterWidth + wC;
                    const mask = maxPos === curPos ? 1 : 0;
                    if (mask === 0) continue;
                    const pixel = dyBuf.get(b, dyR, dyC, d);
                    dotProd += pixel * mask;
                }
            }
            dx.set(dotProd, b, dxR, dxC, d);
        }
    }
    return backend.makeTensorInfo(dx.shape, dx.dtype, dx.values);
}
const $3517385ef9fb6fed$export$e01a7f8dbee29127 = {
    kernelName: (0, $i64bB.MaxPoolGrad),
    backendName: 'cpu',
    kernelFunc: $3517385ef9fb6fed$export$85dfd1121f049514
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

function $290792cb3491143b$export$3cc34964a47e7a3f(xValues, xShape, dtype, includeBatchInIndex, convInfo) {
    const strides = (0, $i64bB.util).computeStrides(xShape);
    const maxPools = (0, $e9280844b6abe1d7$export$7a0e2789ec54f0db)(xValues, xShape, dtype, strides, convInfo, 'max');
    const maxPositions = (0, $e9280844b6abe1d7$export$60b78444d0fe518d)(xValues, xShape, dtype, convInfo, true, includeBatchInIndex);
    return [
        maxPools.values,
        maxPositions.values
    ];
}


const $3b3bd6ffa8f2b85e$export$a069ee2247a7d1ce = {
    kernelName: (0, $i64bB.MaxPoolWithArgmax),
    backendName: 'cpu',
    kernelFunc: ({ inputs: inputs, attrs: attrs, backend: backend })=>{
        const { x: x } = inputs;
        const { filterSize: filterSize, strides: strides, pad: pad, includeBatchInIndex: includeBatchInIndex } = attrs;
        const cpuBackend = backend;
        (0, $csahy.assertNotComplex)(x, 'MaxPoolWithArgmax');
        const values = cpuBackend.data.get(x.dataId).values;
        const convInfo = (0, $i64bB.backend_util).computePool2DInfo(x.shape, filterSize, strides, [
            1,
            1
        ], pad);
        const [pooled, indexes] = (0, $290792cb3491143b$export$3cc34964a47e7a3f)(values, x.shape, x.dtype, includeBatchInIndex, convInfo);
        const pooledDataId = cpuBackend.write(pooled, convInfo.outShape, x.dtype);
        const indexesDataId = cpuBackend.write(indexes, convInfo.outShape, x.dtype);
        return [
            {
                dataId: pooledDataId,
                shape: convInfo.outShape,
                dtype: x.dtype
            },
            {
                dataId: indexesDataId,
                shape: convInfo.outShape,
                dtype: 'int32'
            }
        ];
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $7LLjQ = parcelRequire("7LLjQ");


function $b07629fe4b620241$export$1ce691f85baaa52(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    const axes = (0, $i64bB.util).parseAxisParam(axis, x.shape);
    const shapes = (0, $i64bB.backend_util).computeOutAndReduceShapes(x.shape, axes);
    const reduceShape = shapes[1];
    const reduceSize = (0, $i64bB.util).sizeFromShape(reduceShape);
    const toDispose = [];
    const reduceSizeScalar = backend.makeTensorInfo([], 'float32', new Float32Array([
        reduceSize
    ]));
    toDispose.push(reduceSizeScalar);
    const $x = (0, $7LLjQ.cast)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            dtype: 'float32'
        }
    });
    toDispose.push($x);
    const res = (0, $fcdf7b6c6c29ead5$export$159d9494db57879b)({
        inputs: {
            a: $x,
            b: reduceSizeScalar
        },
        backend: backend
    });
    toDispose.push(res);
    const result = (0, $81f3b02b80a24eb0$export$8a63f25cc62965f1)({
        inputs: {
            x: res
        },
        backend: backend,
        attrs: {
            axis: axis,
            keepDims: keepDims
        }
    });
    toDispose.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return result;
}
const $b07629fe4b620241$export$b934af0ccd0cdbe1 = {
    kernelName: (0, $i64bB.Mean),
    backendName: 'cpu',
    kernelFunc: $b07629fe4b620241$export$1ce691f85baaa52
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");


var $EOTYn = parcelRequire("EOTYn");
function $607dca927c5b7886$export$96ec731ed4dcb222(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    (0, $csahy.assertNotComplex)(x, 'min');
    const origAxes = (0, $i64bB.util).parseAxisParam(axis, x.shape);
    let axes = origAxes;
    const permutedAxes = (0, $i64bB.backend_util).getAxesPermutation(axes, x.shape.length);
    let $x = x;
    if (permutedAxes != null) {
        $x = (0, $EOTYn.transpose)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutedAxes
            }
        });
        axes = (0, $i64bB.backend_util).getInnerMostAxes(axes.length, x.shape.length);
    }
    (0, $i64bB.backend_util).assertAxesAreInnerMostDims('min', axes, $x.shape.length);
    const [outShape, reduceShape] = (0, $i64bB.backend_util).computeOutAndReduceShapes($x.shape, axes);
    const reduceSize = (0, $i64bB.util).sizeFromShape(reduceShape);
    const vals = (0, $i64bB.util).makeZerosTypedArray((0, $i64bB.util).sizeFromShape(outShape), $x.dtype);
    const aVals = backend.data.get($x.dataId).values;
    for(let i = 0; i < vals.length; ++i){
        const offset = i * reduceSize;
        let min = aVals[offset];
        for(let j = 0; j < reduceSize; ++j){
            const value = aVals[offset + j];
            if (Number.isNaN(value) || value < min) min = value;
        }
        vals[i] = min;
    }
    if (permutedAxes != null) backend.disposeIntermediateTensorInfo($x);
    const result = backend.makeTensorInfo(outShape, $x.dtype, vals);
    if (keepDims) {
        const expandedShape = (0, $i64bB.backend_util).expandShapeToKeepDim(outShape, origAxes);
        const reshapedResult = (0, $abec025db4e7e093$export$9eaad88cf88cee2b)({
            inputs: {
                x: result
            },
            backend: backend,
            attrs: {
                shape: expandedShape
            }
        });
        backend.disposeIntermediateTensorInfo(result);
        return reshapedResult;
    }
    return result;
}
const $607dca927c5b7886$export$3cd9f9a31b38cf18 = {
    kernelName: (0, $i64bB.Min),
    backendName: 'cpu',
    kernelFunc: $607dca927c5b7886$export$96ec731ed4dcb222
};



var $g7Z3x = parcelRequire("g7Z3x");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");
function $52a1408aeb9b50a1$export$c0b11600e90b86ae(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { paddings: paddings, mode: mode } = attrs;
    (0, $csahy.assertNotComplex)(x, 'mirrorPad');
    const outShape = paddings.map((p, i)=>p[0] + x.shape[i] + p[1]);
    const start = paddings.map((p)=>p[0]);
    const end = paddings.map((p, i)=>p[0] + x.shape[i]);
    const offset = mode === 'reflect' ? 0 : 1;
    const xVals = backend.data.get(x.dataId).values;
    const xRank = x.shape.length;
    const xStrides = (0, $i64bB.util).computeStrides(x.shape);
    const resultSize = (0, $i64bB.util).sizeFromShape(outShape);
    const resultRank = outShape.length;
    const resultStrides = (0, $i64bB.util).computeStrides(outShape);
    const resVals = (0, $i64bB.util).getTypedArrayFromDType(x.dtype, resultSize);
    for(let i = 0; i < resultSize; i++){
        let coords = (0, $i64bB.util).indexToLoc(i, resultRank, resultStrides);
        for(let i = 0; i < resultRank; i++){
            if (coords[i] < start[i]) coords[i] = start[i] * 2 - coords[i] - offset;
            else if (coords[i] >= end[i]) coords[i] = (end[i] - 1) * 2 - coords[i] + offset;
        }
        coords = coords.map((c, i)=>c - start[i]);
        const inIndex = (0, $i64bB.util).locToIndex(coords, xRank, xStrides);
        resVals[i] = xVals[inIndex];
    }
    const outId = backend.write(resVals, outShape, x.dtype);
    return {
        dataId: outId,
        shape: outShape,
        dtype: x.dtype
    };
}
const $52a1408aeb9b50a1$export$2cfd6c6c7daeb5fc = {
    kernelName: (0, $i64bB.MirrorPad),
    backendName: 'cpu',
    kernelFunc: $52a1408aeb9b50a1$export$c0b11600e90b86ae
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $jQJ39 = parcelRequire("jQJ39");

var $kgSwn = parcelRequire("kgSwn");
const $3fc24f552a0915ee$export$fc31b6ef8ca4db11 = (0, $jQJ39.createSimpleBinaryKernelImpl)((aValue, bValue)=>{
    const rem = aValue % bValue;
    if (aValue < 0 && bValue < 0 || aValue >= 0 && bValue >= 0) return rem;
    else return (rem + bValue) % bValue;
});
const $3fc24f552a0915ee$export$842a2cf37af977e1 = (0, $kgSwn.binaryKernelFunc)((0, $i64bB.Mod), $3fc24f552a0915ee$export$fc31b6ef8ca4db11);
const $3fc24f552a0915ee$export$9037685a81180a9c = {
    kernelName: (0, $i64bB.Mod),
    backendName: 'cpu',
    kernelFunc: $3fc24f552a0915ee$export$842a2cf37af977e1
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $3mnBW = parcelRequire("3mnBW");

var $csahy = parcelRequire("csahy");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $2ANRn = parcelRequire("2ANRn");




var $aT9VE = parcelRequire("aT9VE");

function $de7b841569048a6d$export$e008137e76238601(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { logits: logits } = inputs;
    const { dim: dim } = attrs;
    const logitsRank = logits.shape.length;
    let $dim = dim;
    if ($dim === -1) $dim = logitsRank - 1;
    if ($dim !== logitsRank - 1) throw Error('Softmax along a non-last dimension is not yet supported. ' + `Logits was rank ${logitsRank} and dim was ${$dim}`);
    const axes = (0, $i64bB.util).parseAxisParam([
        $dim
    ], logits.shape);
    const maxLogit = (0, $58aa85413e381680$export$8960430cfd85939f)({
        inputs: {
            x: logits
        },
        backend: backend,
        attrs: {
            reductionIndices: axes,
            keepDims: false
        }
    });
    const expandedShape = (0, $i64bB.backend_util).expandShapeToKeepDim(maxLogit.shape, axes);
    const maxLogitReshaped = (0, $abec025db4e7e093$export$9eaad88cf88cee2b)({
        inputs: {
            x: maxLogit
        },
        backend: backend,
        attrs: {
            shape: expandedShape
        }
    });
    const a = (0, $aT9VE.sub)({
        inputs: {
            a: logits,
            b: maxLogitReshaped
        },
        backend: backend
    });
    const b = (0, $2ANRn.exp)({
        inputs: {
            x: a
        },
        backend: backend
    });
    const sumExp = (0, $81f3b02b80a24eb0$export$8a63f25cc62965f1)({
        inputs: {
            x: b
        },
        backend: backend,
        attrs: {
            axis: axes,
            keepDims: false
        }
    });
    const sumReshaped = (0, $abec025db4e7e093$export$9eaad88cf88cee2b)({
        inputs: {
            x: sumExp
        },
        backend: backend,
        attrs: {
            shape: expandedShape
        }
    });
    const result = (0, $fcdf7b6c6c29ead5$export$159d9494db57879b)({
        inputs: {
            a: b,
            b: sumReshaped
        },
        backend: backend
    });
    backend.disposeIntermediateTensorInfo(maxLogit);
    backend.disposeIntermediateTensorInfo(maxLogitReshaped);
    backend.disposeIntermediateTensorInfo(a);
    backend.disposeIntermediateTensorInfo(b);
    backend.disposeIntermediateTensorInfo(sumExp);
    backend.disposeIntermediateTensorInfo(sumReshaped);
    return result;
}
const $de7b841569048a6d$export$c022691f23e2ee69 = {
    kernelName: (0, $i64bB.Softmax),
    backendName: 'cpu',
    kernelFunc: $de7b841569048a6d$export$e008137e76238601
};


function $8f79578744798103$export$f4d580f3101a1c7e(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { logits: logits } = inputs;
    const { numSamples: numSamples, seed: seed, normalized: normalized } = attrs;
    (0, $csahy.assertNotComplex)(logits, 'multinomial');
    const probabilities = normalized ? logits : (0, $de7b841569048a6d$export$e008137e76238601)({
        inputs: {
            logits: logits
        },
        backend: backend,
        attrs: {
            dim: -1
        }
    });
    const batchSize = probabilities.shape[0];
    const numEvents = probabilities.shape[1];
    const probVals = backend.data.get(probabilities.dataId).values;
    const resShape = [
        batchSize,
        numSamples
    ];
    const resVals = (0, $i64bB.util).makeZerosTypedArray((0, $i64bB.util).sizeFromShape(resShape), 'int32');
    for(let b = 0; b < batchSize; ++b){
        const offset = b * numEvents;
        // The cdf won't include the last event. It will be implicit if no other
        // event happened.
        const cdf = new Float32Array(numEvents - 1);
        cdf[0] = probVals[offset];
        for(let event = 1; event < cdf.length; ++event)cdf[event] = cdf[event - 1] + probVals[offset + event];
        const random = $3mnBW.alea(seed.toString());
        const outOffset = b * numSamples;
        for(let sampleId = 0; sampleId < numSamples; ++sampleId){
            const r = random();
            // Assume last event happened by default.
            resVals[outOffset + sampleId] = cdf.length;
            for(let event = 0; event < cdf.length; event++)if (r < cdf[event]) {
                resVals[outOffset + sampleId] = event;
                break;
            }
        }
    }
    if (!normalized) backend.disposeIntermediateTensorInfo(probabilities);
    return backend.makeTensorInfo(resShape, 'int32', resVals);
}
const $8f79578744798103$export$ad960e364767f0e2 = {
    kernelName: (0, $i64bB.Multinomial),
    backendName: 'cpu',
    kernelFunc: $8f79578744798103$export$f4d580f3101a1c7e
};



var $gQOIy = parcelRequire("gQOIy");

var $9NYY4 = parcelRequire("9NYY4");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");
const $f4ff792a02508805$var$nonMaxSuppressionV3Impl = (0, $i64bB.kernel_impls).nonMaxSuppressionV3Impl;
function $f4ff792a02508805$export$8917e4bf7f7f5d42(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { boxes: boxes, scores: scores } = inputs;
    const { maxOutputSize: maxOutputSize, iouThreshold: iouThreshold, scoreThreshold: scoreThreshold } = attrs;
    (0, $csahy.assertNotComplex)(boxes, 'NonMaxSuppression');
    const boxesVals = backend.data.get(boxes.dataId).values;
    const scoresVals = backend.data.get(scores.dataId).values;
    const { selectedIndices: selectedIndices } = $f4ff792a02508805$var$nonMaxSuppressionV3Impl(boxesVals, scoresVals, maxOutputSize, iouThreshold, scoreThreshold);
    return backend.makeTensorInfo([
        selectedIndices.length
    ], 'int32', new Int32Array(selectedIndices));
}
const $f4ff792a02508805$export$549561cd158f260a = {
    kernelName: (0, $i64bB.NonMaxSuppressionV3),
    backendName: 'cpu',
    kernelFunc: $f4ff792a02508805$export$8917e4bf7f7f5d42
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");
const $a696c23123d1a1c6$var$nonMaxSuppressionV4Impl = (0, $i64bB.kernel_impls).nonMaxSuppressionV4Impl;
function $a696c23123d1a1c6$export$ad519bdebe8f4dcf(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { boxes: boxes, scores: scores } = inputs;
    const { maxOutputSize: maxOutputSize, iouThreshold: iouThreshold, scoreThreshold: scoreThreshold, padToMaxOutputSize: padToMaxOutputSize } = attrs;
    (0, $csahy.assertNotComplex)(boxes, 'NonMaxSuppressionPadded');
    const boxesVals = backend.data.get(boxes.dataId).values;
    const scoresVals = backend.data.get(scores.dataId).values;
    const { selectedIndices: selectedIndices, validOutputs: validOutputs } = $a696c23123d1a1c6$var$nonMaxSuppressionV4Impl(boxesVals, scoresVals, maxOutputSize, iouThreshold, scoreThreshold, padToMaxOutputSize);
    return [
        backend.makeTensorInfo([
            selectedIndices.length
        ], 'int32', new Int32Array(selectedIndices)),
        backend.makeTensorInfo([], 'int32', new Int32Array([
            validOutputs
        ]))
    ];
}
const $a696c23123d1a1c6$export$906b8fb32c570e9d = {
    kernelName: (0, $i64bB.NonMaxSuppressionV4),
    backendName: 'cpu',
    kernelFunc: $a696c23123d1a1c6$export$ad519bdebe8f4dcf
};


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");
const $24b5d40d5edfce43$var$nonMaxSuppressionV5Impl = (0, $i64bB.kernel_impls).nonMaxSuppressionV5Impl;
function $24b5d40d5edfce43$export$49e389fdbe01a534(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { boxes: boxes, scores: scores } = inputs;
    const { maxOutputSize: maxOutputSize, iouThreshold: iouThreshold, scoreThreshold: scoreThreshold, softNmsSigma: softNmsSigma } = attrs;
    (0, $csahy.assertNotComplex)(boxes, 'NonMaxSuppressionWithScore');
    const boxesVals = backend.data.get(boxes.dataId).values;
    const scoresVals = backend.data.get(scores.dataId).values;
    const maxOutputSizeVal = maxOutputSize;
    const iouThresholdVal = iouThreshold;
    const scoreThresholdVal = scoreThreshold;
    const softNmsSigmaVal = softNmsSigma;
    const { selectedIndices: selectedIndices, selectedScores: selectedScores } = $24b5d40d5edfce43$var$nonMaxSuppressionV5Impl(boxesVals, scoresVals, maxOutputSizeVal, iouThresholdVal, scoreThresholdVal, softNmsSigmaVal);
    return [
        backend.makeTensorInfo([
            selectedIndices.length
        ], 'int32', new Int32Array(selectedIndices)),
        backend.makeTensorInfo([
            selectedScores.length
        ], 'float32', new Float32Array(selectedScores))
    ];
}
const $24b5d40d5edfce43$export$4c00b682f309701d = {
    kernelName: (0, $i64bB.NonMaxSuppressionV5),
    backendName: 'cpu',
    kernelFunc: $24b5d40d5edfce43$export$49e389fdbe01a534
};



var $QHoEG = parcelRequire("QHoEG");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");
function $44f905ed69e018a1$export$341b5490a776d041(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { indices: indices } = inputs;
    const { dtype: dtype, depth: depth, onValue: onValue, offValue: offValue } = attrs;
    (0, $csahy.assertNotComplex)(indices, 'oneHot');
    const indicesSize = (0, $i64bB.util).sizeFromShape(indices.shape);
    const res = new Float32Array(indicesSize * depth);
    res.fill(offValue);
    const indicesVal = backend.data.get(indices.dataId).values;
    for(let event = 0; event < indicesSize; ++event)if (indicesVal[event] >= 0 && indicesVal[event] < depth) res[event * depth + indicesVal[event]] = onValue;
    return backend.makeTensorInfo([
        ...indices.shape,
        depth
    ], dtype, res);
}
const $44f905ed69e018a1$export$dde5645b472b80b2 = {
    kernelName: (0, $i64bB.OneHot),
    backendName: 'cpu',
    kernelFunc: $44f905ed69e018a1$export$341b5490a776d041
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $bwMVz = parcelRequire("bwMVz");



var $linqd = parcelRequire("linqd");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $bwMVz = parcelRequire("bwMVz");



var $linqd = parcelRequire("linqd");
function $d17f130fbd54f8ad$export$cb1f824e7733584d(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    if (x.dtype === 'string') throw new Error('zerosLike is not supported for string tensors');
    else if (x.dtype === 'complex64') {
        const realPart = (0, $linqd.real)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const r = $d17f130fbd54f8ad$export$cb1f824e7733584d({
            inputs: {
                x: realPart
            },
            backend: backend
        });
        const imagPart = (0, $235b2b9db5d2b70b$export$d78fab5778ab392b)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const i = $d17f130fbd54f8ad$export$cb1f824e7733584d({
            inputs: {
                x: imagPart
            },
            backend: backend
        });
        const result = (0, $bwMVz.complex)({
            inputs: {
                real: r,
                imag: i
            },
            backend: backend
        });
        backend.disposeIntermediateTensorInfo(realPart);
        backend.disposeIntermediateTensorInfo(r);
        backend.disposeIntermediateTensorInfo(imagPart);
        backend.disposeIntermediateTensorInfo(i);
        return result;
    } else return (0, $bdf4b57d5da6d47b$export$9563e054e6f787fb)({
        backend: backend,
        attrs: {
            shape: x.shape,
            value: 0,
            dtype: x.dtype
        }
    });
}
const $d17f130fbd54f8ad$export$15368df05c479e41 = {
    kernelName: (0, $i64bB.ZerosLike),
    backendName: 'cpu',
    kernelFunc: $d17f130fbd54f8ad$export$cb1f824e7733584d
};


function $3c4b1991b10ffa22$export$fb6afd6214fee9e9(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    if (x.dtype === 'string') throw new Error('onesLike is not supported for string tensors');
    else if (x.dtype === 'complex64') {
        const realPart = (0, $linqd.real)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const r = $3c4b1991b10ffa22$export$fb6afd6214fee9e9({
            inputs: {
                x: realPart
            },
            backend: backend
        });
        const imagPart = (0, $235b2b9db5d2b70b$export$d78fab5778ab392b)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const i = (0, $d17f130fbd54f8ad$export$cb1f824e7733584d)({
            inputs: {
                x: imagPart
            },
            backend: backend
        });
        const result = (0, $bwMVz.complex)({
            inputs: {
                real: r,
                imag: i
            },
            backend: backend
        });
        backend.disposeIntermediateTensorInfo(realPart);
        backend.disposeIntermediateTensorInfo(r);
        backend.disposeIntermediateTensorInfo(imagPart);
        backend.disposeIntermediateTensorInfo(i);
        return result;
    } else return (0, $bdf4b57d5da6d47b$export$9563e054e6f787fb)({
        backend: backend,
        attrs: {
            shape: x.shape,
            value: 1,
            dtype: x.dtype
        }
    });
}
const $3c4b1991b10ffa22$export$d8d7015eb6ab37d0 = {
    kernelName: (0, $i64bB.OnesLike),
    backendName: 'cpu',
    kernelFunc: $3c4b1991b10ffa22$export$fb6afd6214fee9e9
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


function $d179715647152c30$export$2a703dbb0cb35339(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { axis: axis } = attrs;
    if (inputs.length === 1) return (0, $0b6b0257239c58c8$export$d660d8ed21f46635)({
        inputs: {
            input: inputs[0]
        },
        backend: backend,
        attrs: {
            dim: axis
        }
    });
    const shape = inputs[0].shape;
    const dtype = inputs[0].dtype;
    inputs.forEach((t)=>{
        (0, $i64bB.util).assertShapesMatch(shape, t.shape, 'All tensors passed to stack must have matching shapes');
        (0, $i64bB.util).assert(dtype === t.dtype, ()=>'All tensors passed to stack must have matching dtypes');
    });
    const intermediateTensorInfos = [];
    const expandedTensors = inputs.map((t)=>{
        const expandedT = (0, $0b6b0257239c58c8$export$d660d8ed21f46635)({
            inputs: {
                input: t
            },
            backend: backend,
            attrs: {
                dim: axis
            }
        });
        intermediateTensorInfos.push(expandedT);
        return expandedT;
    });
    const result = (0, $3284dfd9bccede0e$export$ee1b3e54f0441b22)({
        inputs: expandedTensors,
        backend: backend,
        attrs: {
            axis: axis
        }
    });
    intermediateTensorInfos.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return result;
}
const $d179715647152c30$export$1645fa8803aa1f86 = {
    kernelName: (0, $i64bB.Pack),
    backendName: 'cpu',
    kernelFunc: $d179715647152c30$export$2a703dbb0cb35339
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");
function $13bfb533800aba7e$export$f676d6ad4f38bb89(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { paddings: paddings, constantValue: constantValue } = attrs;
    (0, $csahy.assertNotComplex)(x, 'pad');
    const outShape = paddings.map((p, i)=>p[0] + x.shape[i] + p[1]);
    const start = paddings.map((p)=>p[0]);
    const xVals = backend.data.get(x.dataId).values;
    const xSize = (0, $i64bB.util).sizeFromShape(x.shape);
    const xRank = x.shape.length;
    const xStrides = (0, $i64bB.util).computeStrides(x.shape);
    const resultSize = (0, $i64bB.util).sizeFromShape(outShape);
    const resultRank = outShape.length;
    const resultStrides = (0, $i64bB.util).computeStrides(outShape);
    const resVals = (0, $i64bB.util).getTypedArrayFromDType(x.dtype, resultSize);
    if (constantValue !== 0) resVals.fill(constantValue);
    for(let i = 0; i < xSize; i++){
        const coords = (0, $i64bB.util).indexToLoc(i, xRank, xStrides);
        const outCoords = coords.map((c, i)=>c + start[i]);
        const outIndex = (0, $i64bB.util).locToIndex(outCoords, resultRank, resultStrides);
        resVals[outIndex] = xVals[i];
    }
    const outId = backend.write(resVals, outShape, x.dtype);
    return {
        dataId: outId,
        shape: outShape,
        dtype: x.dtype
    };
}
const $13bfb533800aba7e$export$b0317e720bfd61fc = {
    kernelName: (0, $i64bB.PadV2),
    backendName: 'cpu',
    kernelFunc: $13bfb533800aba7e$export$f676d6ad4f38bb89
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $jQJ39 = parcelRequire("jQJ39");

var $kgSwn = parcelRequire("kgSwn");
const $e36d36d9ca93da24$export$92051c71bb41bd8a = (0, $jQJ39.createSimpleBinaryKernelImpl)((a, b)=>Math.pow(a, b));
const $e36d36d9ca93da24$export$9c297f60e22e3389 = (0, $kgSwn.binaryKernelFunc)((0, $i64bB.Pow), $e36d36d9ca93da24$export$92051c71bb41bd8a);
const $e36d36d9ca93da24$export$b823d49786719761 = {
    kernelName: (0, $i64bB.Pow),
    backendName: 'cpu',
    kernelFunc: $e36d36d9ca93da24$export$9c297f60e22e3389
};




var $86TES = parcelRequire("86TES");
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $4hb6Q = parcelRequire("4hb6Q");
function $47bd6afe6165e2de$export$e7118f605df251dd(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { paramsNestedSplits: paramsNestedSplits, paramsDenseValues: paramsDenseValues, indices: indices } = inputs;
    const { outputRaggedRank: outputRaggedRank } = attrs;
    const $paramsNestedSplits = paramsNestedSplits.map((t)=>backend.data.get(t.dataId).values);
    const $paramsNestedSplitsShapes = paramsNestedSplits.map((t)=>t.shape);
    const $paramsDenseValues = backend.data.get(paramsDenseValues.dataId).values;
    const $indices = backend.data.get(indices.dataId).values;
    const [outputNestedSplits, outputDenseValues, outputDenseValuesShape] = (0, $4hb6Q.raggedGatherImpl)($paramsNestedSplits, $paramsNestedSplitsShapes, $paramsDenseValues, paramsDenseValues.shape, paramsDenseValues.dtype, $indices, indices.shape, outputRaggedRank);
    const outputNestedSplitsTensors = outputNestedSplits.map((splits)=>backend.makeTensorInfo([
            splits.length
        ], 'int32', splits));
    const outputDenseValuesTensor = backend.makeTensorInfo(outputDenseValuesShape, paramsDenseValues.dtype, outputDenseValues);
    return outputNestedSplitsTensors.concat([
        outputDenseValuesTensor
    ]);
}
const $47bd6afe6165e2de$export$cebb8a7d5932c7e8 = {
    kernelName: (0, $i64bB.RaggedGather),
    backendName: 'cpu',
    kernelFunc: $47bd6afe6165e2de$export$e7118f605df251dd
};


/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $2uK9D = parcelRequire("2uK9D");
function $7060501ccfc71f65$export$a173be400c6762b5(args) {
    const { inputs: inputs, backend: backend } = args;
    const { starts: starts, limits: limits, deltas: deltas } = inputs;
    const $starts = backend.data.get(starts.dataId).values;
    const $limits = backend.data.get(limits.dataId).values;
    const $deltas = backend.data.get(deltas.dataId).values;
    const [rtNestedSplitsData, rtDenseValuesData] = (0, $2uK9D.raggedRangeImpl)($starts, starts.shape, starts.dtype, $limits, limits.shape, $deltas, deltas.shape);
    const rtNestedSplits = backend.makeTensorInfo([
        rtNestedSplitsData.length
    ], 'int32', rtNestedSplitsData);
    const rtDenseValues = backend.makeTensorInfo([
        rtDenseValuesData.length
    ], starts.dtype, rtDenseValuesData);
    return [
        rtNestedSplits,
        rtDenseValues
    ];
}
const $7060501ccfc71f65$export$91ddd62a193b9401 = {
    kernelName: (0, $i64bB.RaggedRange),
    backendName: 'cpu',
    kernelFunc: $7060501ccfc71f65$export$a173be400c6762b5
};


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $6AvWp = parcelRequire("6AvWp");
function $98d97a53a03299e7$export$621e390307cbbaa1(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { shape: shape, values: values, defaultValue: defaultValue, rowPartitionTensors: rowPartitionTensors } = inputs;
    const { rowPartitionTypes: rowPartitionTypes } = attrs;
    const $shape = backend.data.get(shape.dataId).values;
    const $values = backend.data.get(values.dataId).values;
    const $defaultValue = backend.data.get(defaultValue.dataId).values;
    const $rowPartitionValues = rowPartitionTensors.map((t)=>backend.data.get(t.dataId).values);
    const rowPartitionValuesShapes = rowPartitionTensors.map((t)=>t.shape);
    const [outputShape, output] = (0, $6AvWp.raggedTensorToTensorImpl)($shape, shape.shape, $values, values.shape, values.dtype, $defaultValue, defaultValue.shape, $rowPartitionValues, rowPartitionValuesShapes, rowPartitionTypes);
    return backend.makeTensorInfo(outputShape, values.dtype, output);
}
const $98d97a53a03299e7$export$792f441e33dcdf26 = {
    kernelName: (0, $i64bB.RaggedTensorToTensor),
    backendName: 'cpu',
    kernelFunc: $98d97a53a03299e7$export$621e390307cbbaa1
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $caGrw = parcelRequire("caGrw");
function $2671920d83c701bb$export$d02631cccf789723(args) {
    const { backend: backend, attrs: attrs } = args;
    const { start: start, stop: stop, dtype: dtype, step: step } = attrs;
    const values = (0, $caGrw.rangeImpl)(start, stop, step, dtype);
    return backend.makeTensorInfo([
        values.length
    ], dtype, values);
}
const $2671920d83c701bb$export$361c4075706e31c2 = {
    kernelName: (0, $i64bB.Range),
    backendName: 'cpu',
    kernelFunc: $2671920d83c701bb$export$d02631cccf789723
};



var $linqd = parcelRequire("linqd");

/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $l6afd = parcelRequire("l6afd");
const $981426d1e647fa0c$export$163bc8c839a1ac04 = (0, $l6afd.unaryKernelFunc)((0, $i64bB.Reciprocal), (xi)=>1 / xi);
const $981426d1e647fa0c$export$412a6b66203fdf72 = {
    kernelName: (0, $i64bB.Reciprocal),
    backendName: 'cpu',
    kernelFunc: $981426d1e647fa0c$export$163bc8c839a1ac04
};





/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");
function $710bd27f18995ad8$export$1f1cbc7da93d06a0(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { images: images } = inputs;
    const { alignCorners: alignCorners, halfPixelCenters: halfPixelCenters, size: size } = attrs;
    (0, $csahy.assertNotComplex)(images, 'resizeBilinear');
    const imagesStrides = (0, $i64bB.util).computeStrides(images.shape);
    const [newHeight, newWidth] = size;
    const [batch, oldHeight, oldWidth, numChannels] = images.shape;
    const xValues = backend.data.get(images.dataId).values;
    const result = new Float32Array((0, $i64bB.util).sizeFromShape([
        batch,
        newHeight,
        newWidth,
        numChannels
    ]));
    const effectiveInputSize = [
        alignCorners && newHeight > 1 ? oldHeight - 1 : oldHeight,
        alignCorners && newWidth > 1 ? oldWidth - 1 : oldWidth
    ];
    const effectiveOutputSize = [
        alignCorners && newHeight > 1 ? newHeight - 1 : newHeight,
        alignCorners && newWidth > 1 ? newWidth - 1 : newWidth
    ];
    let outputIdx = 0;
    const effectiveRowSizeRatio = effectiveInputSize[0] / effectiveOutputSize[0];
    const effectiveColSizeRatio = effectiveInputSize[1] / effectiveOutputSize[1];
    for(let b = 0; b < batch; b++)for(let r = 0; r < newHeight; r++){
        let sourceFracRow;
        if (halfPixelCenters) sourceFracRow = effectiveRowSizeRatio * (r + 0.5) - 0.5;
        else sourceFracRow = effectiveRowSizeRatio * r;
        const sourceRowFloor = Math.max(0, Math.floor(sourceFracRow));
        const rowFrac = sourceFracRow - sourceRowFloor;
        const sourceRowCeil = Math.min(oldHeight - 1, Math.ceil(sourceFracRow));
        const topRowOffset = b * imagesStrides[0] + sourceRowFloor * imagesStrides[1];
        const botRowOffset = b * imagesStrides[0] + sourceRowCeil * imagesStrides[1];
        for(let c = 0; c < newWidth; c++){
            let sourceFracCol;
            if (halfPixelCenters) sourceFracCol = effectiveColSizeRatio * (c + 0.5) - 0.5;
            else sourceFracCol = effectiveColSizeRatio * c;
            const sourceColFloor = Math.max(0, Math.floor(sourceFracCol));
            const colFrac = sourceFracCol - sourceColFloor;
            const sourceColCeil = Math.min(oldWidth - 1, Math.ceil(sourceFracCol));
            const topLeftOffest = topRowOffset + sourceColFloor * imagesStrides[2];
            const botLeftOffset = botRowOffset + sourceColFloor * imagesStrides[2];
            const topRightOffset = topRowOffset + sourceColCeil * imagesStrides[2];
            const botRightOffest = botRowOffset + sourceColCeil * imagesStrides[2];
            for(let d = 0; d < numChannels; d++){
                // Begin shader.
                // Compute the fractional index of the source.
                const topLeft = xValues[topLeftOffest + d];
                const bottomLeft = xValues[botLeftOffset + d];
                const topRight = xValues[topRightOffset + d];
                const bottomRight = xValues[botRightOffest + d];
                const top = topLeft + (topRight - topLeft) * colFrac;
                const bottom = bottomLeft + (bottomRight - bottomLeft) * colFrac;
                const newValue = top + (bottom - top) * rowFrac;
                result[outputIdx++] = newValue;
            }
        }
    }
    return backend.makeTensorInfo([
        batch,
        newHeight,
        newWidth,
        numChannels
    ], 'float32', result);
}
const $710bd27f18995ad8$export$a37a56137abc1357 = {
    kernelName: (0, $i64bB.ResizeBilinear),
    backendName: 'cpu',
    kernelFunc: $710bd27f18995ad8$export$1f1cbc7da93d06a0
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");
function $ed793dce20bde8c7$export$8899506794ec394(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { images: images, dy: dy } = inputs;
    const { alignCorners: alignCorners } = attrs;
    (0, $csahy.assertNotComplex)([
        dy,
        images
    ], 'resizeBilinearGrad');
    const imagesStrides = (0, $i64bB.util).computeStrides(images.shape);
    const [batch, xHeight, xWidth, depth] = images.shape;
    const [, yHeight, yWidth] = dy.shape;
    const output = new Float32Array(batch * xHeight * xWidth * depth);
    // In the backwards pass, we want to find the pixels that were generated
    // for each pixel in the input image the forward pass and add the
    // corresponding coefficient from dy to the gradient (with some
    // interpolation).
    const effectiveXSize = [
        alignCorners && yHeight > 1 ? xHeight - 1 : xHeight,
        alignCorners && yWidth > 1 ? xWidth - 1 : xWidth
    ];
    const effectiveYSize = [
        alignCorners && yHeight > 1 ? yHeight - 1 : yHeight,
        alignCorners && yWidth > 1 ? yWidth - 1 : yWidth
    ];
    const heightScale = effectiveXSize[0] / effectiveYSize[0];
    const widthScale = effectiveXSize[1] / effectiveYSize[1];
    // Reference implementation
    // tslint:disable-next-line:max-line-length
    // https://github.com/tensorflow/tensorflow/blob/3039375c86a5bbc9610c7725dcaa95d635f87ba2/tensorflow/core/kernels/resize_bilinear_op.cc#L275
    const dyValues = backend.data.get(dy.dataId).values;
    let offset = 0;
    for(let b = 0; b < batch; b++){
        const bOffset = b * imagesStrides[0];
        for(let r = 0; r < yHeight; r++){
            const dxR = r * heightScale;
            const topDxRIndex = Math.floor(dxR);
            const bottomDxRIndex = Math.min(Math.ceil(dxR), xHeight - 1);
            const topDxROffset = bOffset + topDxRIndex * imagesStrides[1];
            const bottomDxROffset = bOffset + bottomDxRIndex * imagesStrides[1];
            const dxRLerp = dxR - topDxRIndex;
            const inverseDxRLerp = 1.0 - dxRLerp;
            for(let c = 0; c < yWidth; c++){
                const dxC = c * widthScale;
                const leftDxCIndex = Math.floor(dxC);
                const rightDxCIndex = Math.min(Math.ceil(dxC), xWidth - 1);
                const dxCLerp = dxC - leftDxCIndex;
                const inverseDxCLerp = 1.0 - dxCLerp;
                const topLeftRCOffset = topDxROffset + leftDxCIndex * imagesStrides[2];
                const topRightRCOffset = topDxROffset + rightDxCIndex * imagesStrides[2];
                const bottomLeftRCOffset = bottomDxROffset + leftDxCIndex * imagesStrides[2];
                const bottomRightRCOffset = bottomDxROffset + rightDxCIndex * imagesStrides[2];
                const inverseDxRLerpTimesInverseDxCLerp = inverseDxRLerp * inverseDxCLerp;
                const inverseDxRLerpTimesDxCLerp = inverseDxRLerp * dxCLerp;
                const dxRLerpTimesInverseDxCLerp = dxRLerp * inverseDxCLerp;
                const dxRLerpTimesDxCLerp = dxRLerp * dxCLerp;
                for(let d = 0; d < depth; d++){
                    const dyVal = dyValues[offset++];
                    output[topLeftRCOffset + d] += dyVal * inverseDxRLerpTimesInverseDxCLerp;
                    output[topRightRCOffset + d] += dyVal * inverseDxRLerpTimesDxCLerp;
                    output[bottomLeftRCOffset + d] += dyVal * dxRLerpTimesInverseDxCLerp;
                    output[bottomRightRCOffset + d] += dyVal * dxRLerpTimesDxCLerp;
                }
            }
        }
    }
    return backend.makeTensorInfo([
        batch,
        xWidth,
        xHeight,
        depth
    ], 'float32', output);
}
const $ed793dce20bde8c7$export$51f84ca614e84763 = {
    kernelName: (0, $i64bB.ResizeBilinearGrad),
    backendName: 'cpu',
    kernelFunc: $ed793dce20bde8c7$export$8899506794ec394
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");
function $875d50731a97d18d$export$74a902ae74ac2560(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { images: images } = inputs;
    const { alignCorners: alignCorners, halfPixelCenters: halfPixelCenters, size: size } = attrs;
    (0, $csahy.assertNotComplex)(images, 'resizeNearestNeighbor');
    const imagesStrides = (0, $i64bB.util).computeStrides(images.shape);
    const [newHeight, newWidth] = size;
    const [batch, oldHeight, oldWidth, numChannels] = images.shape;
    const xValues = backend.data.get(images.dataId).values;
    const output = new Float32Array(batch * newHeight * newWidth * numChannels);
    const effectiveInputSize = [
        alignCorners && newHeight > 1 ? oldHeight - 1 : oldHeight,
        alignCorners && newWidth > 1 ? oldWidth - 1 : oldWidth
    ];
    const effectiveOutputSize = [
        alignCorners && newHeight > 1 ? newHeight - 1 : newHeight,
        alignCorners && newWidth > 1 ? newWidth - 1 : newWidth
    ];
    const effectiveRowSizeRatio = effectiveInputSize[0] / effectiveOutputSize[0];
    const effectiveColSizeRatio = effectiveInputSize[1] / effectiveOutputSize[1];
    let outputOffset = 0;
    for(let b = 0; b < batch; b++){
        const batchOffset = b * imagesStrides[0];
        for(let r = 0; r < newHeight; r++){
            const sourceFracRow = halfPixelCenters ? effectiveRowSizeRatio * (r + 0.5) : effectiveRowSizeRatio * r;
            let sourceNearestRow = Math.min(oldHeight - 1, alignCorners ? Math.round(sourceFracRow) : Math.floor(sourceFracRow));
            if (halfPixelCenters) sourceNearestRow = Math.max(0, sourceNearestRow);
            const rowOffset = batchOffset + sourceNearestRow * imagesStrides[1];
            for(let c = 0; c < newWidth; c++){
                const sourceFracCol = halfPixelCenters ? effectiveColSizeRatio * (c + 0.5) : effectiveColSizeRatio * c;
                let sourceNearestCol = Math.min(oldWidth - 1, alignCorners ? Math.round(sourceFracCol) : Math.floor(sourceFracCol));
                if (halfPixelCenters) sourceNearestCol = Math.max(0, sourceNearestCol);
                const colOffset = rowOffset + sourceNearestCol * imagesStrides[2];
                for(let d = 0; d < numChannels; d++){
                    // Begin shader.
                    // Compute the fractional index of the source.
                    const newVal = xValues[colOffset + d];
                    output[outputOffset++] = newVal;
                }
            }
        }
    }
    return backend.makeTensorInfo([
        batch,
        newHeight,
        newWidth,
        numChannels
    ], images.dtype, output);
}
const $875d50731a97d18d$export$2b6a92caba113b89 = {
    kernelName: (0, $i64bB.ResizeNearestNeighbor),
    backendName: 'cpu',
    kernelFunc: $875d50731a97d18d$export$74a902ae74ac2560
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");
function $689d299d6f52112b$export$2b75795f158f1b18(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { images: images, dy: dy } = inputs;
    const { alignCorners: alignCorners } = attrs;
    (0, $csahy.assertNotComplex)([
        dy,
        images
    ], 'resizeNearestNeighborGrad');
    const imagesStrides = (0, $i64bB.util).computeStrides(images.shape);
    const dyStrides = (0, $i64bB.util).computeStrides(dy.shape);
    const [batch, xHeight, xWidth, depth] = images.shape;
    const [, yHeight, yWidth] = dy.shape;
    const output = new Float32Array(batch * xHeight * xWidth * depth);
    const dyValues = backend.data.get(dy.dataId).values;
    // In the backwards pass, we want to find the pixels that were generated
    // for each pixel in the input image the forward pass
    const effectiveXSize = [
        alignCorners && yHeight > 1 ? xHeight - 1 : xHeight,
        alignCorners && yWidth > 1 ? xWidth - 1 : xWidth
    ];
    const effectiveYSize = [
        alignCorners && yHeight > 1 ? yHeight - 1 : yHeight,
        alignCorners && yWidth > 1 ? yWidth - 1 : yWidth
    ];
    const heightScale = effectiveXSize[0] / effectiveYSize[0];
    const widthScale = effectiveXSize[1] / effectiveYSize[1];
    const invHeightScale = 1 / heightScale;
    const invWidthScale = 1 / widthScale;
    // This defines the size of the window of values around a particular
    // index in dy that we want to search for contributions to dx.
    const winHeight = Math.ceil(invHeightScale) * 2 + 2;
    const winWidth = Math.ceil(invWidthScale) * 2 + 2;
    // Loop over the output space.
    for(let b = 0; b < batch; b++){
        const batchOffset = b * imagesStrides[0];
        for(let r = 0; r < xHeight; r++){
            const rowOffset = batchOffset + r * imagesStrides[1];
            // Compute bounds for where in dy we will look
            const startRLerp = Math.floor(r * invHeightScale);
            const startDyR = Math.floor(startRLerp - winHeight / 2);
            for(let c = 0; c < xWidth; c++){
                const colOffset = rowOffset + c * imagesStrides[2];
                // Compute bounds for where in dy we will look
                const startCLerp = Math.floor(c * invWidthScale);
                const startDyC = Math.floor(startCLerp - winWidth / 2);
                for(let d = 0; d < depth; d++){
                    let accum = 0;
                    // loop over dy
                    for(let dyRIndex = 0; dyRIndex < winHeight; dyRIndex++){
                        const dyR = dyRIndex + startDyR;
                        // Guard against the window exceeding the bounds of dy
                        if (dyR < 0 || dyR >= yHeight) continue;
                        const dyROffset = batchOffset + dyR * dyStrides[1];
                        const sourceFracRow = dyR * heightScale;
                        const sourceNearestRow = Math.min(xHeight - 1, alignCorners ? Math.round(sourceFracRow) : Math.floor(sourceFracRow));
                        if (r !== sourceNearestRow) continue;
                        for(let dyCIndex = 0; dyCIndex < winWidth; dyCIndex++){
                            const dyC = dyCIndex + startDyC;
                            // Guard against the window exceeding the bounds of dy
                            if (dyC < 0 || dyC >= yWidth) continue;
                            const dyCOffset = dyROffset + dyC * dyStrides[2];
                            const sourceFracCol = dyC * widthScale;
                            const sourceNearestCol = Math.min(xWidth - 1, alignCorners ? Math.round(sourceFracCol) : Math.floor(sourceFracCol));
                            if (c === sourceNearestCol) accum += dyValues[dyCOffset + d];
                        }
                    }
                    output[colOffset + d] = accum;
                }
            }
        }
    }
    return backend.makeTensorInfo(images.shape, images.dtype, output);
}
const $689d299d6f52112b$export$2b08d810b5090fe1 = {
    kernelName: (0, $i64bB.ResizeNearestNeighborGrad),
    backendName: 'cpu',
    kernelFunc: $689d299d6f52112b$export$2b75795f158f1b18
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");

var $lcqBv = parcelRequire("lcqBv");
function $ee67674342f7db4c$export$66c1ae025e96b4bc(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { dims: dims } = attrs;
    (0, $csahy.assertNotComplex)(x, 'reverse');
    const xRank = x.shape.length;
    const $dims = (0, $i64bB.util).parseAxisParam(dims, x.shape);
    if (xRank === 0) return (0, $lcqBv.identity)({
        inputs: {
            x: x
        },
        backend: backend
    });
    const outBuf = new (0, $i64bB.TensorBuffer)(x.shape, x.dtype);
    const xBuf = backend.bufferSync(x);
    for(let i = 0; i < outBuf.size; i++){
        const outLoc = outBuf.indexToLoc(i);
        const inLoc = outLoc.slice();
        $dims.forEach((d)=>inLoc[d] = x.shape[d] - 1 - inLoc[d]);
        outBuf.set(xBuf.get(...inLoc), ...outLoc);
    }
    return backend.makeTensorInfo(outBuf.shape, outBuf.dtype, outBuf.values);
}
const $ee67674342f7db4c$export$cab6a4e8d2ed8e8d = {
    kernelName: (0, $i64bB.Reverse),
    backendName: 'cpu',
    kernelFunc: $ee67674342f7db4c$export$66c1ae025e96b4bc
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
const $3dc2d66652355d94$export$44ba8c83417ab668 = {
    kernelName: (0, $i64bB.RotateWithOffset),
    backendName: 'cpu',
    kernelFunc: ({ inputs: inputs, attrs: attrs, backend: backend })=>{
        const { image: image } = inputs;
        const { radians: radians, fillValue: fillValue, center: center } = attrs;
        const cpuBackend = backend;
        const output = (0, $i64bB.util).getTypedArrayFromDType(image.dtype, (0, $i64bB.util).sizeFromShape(image.shape));
        const [batch, imageHeight, imageWidth, numChannels] = image.shape;
        const [centerX, centerY] = (0, $i64bB.backend_util).getImageCenter(center, imageHeight, imageWidth);
        const fullOpacityValue = 255;
        const sinFactor = Math.sin(radians);
        const cosFactor = Math.cos(radians);
        const imageVals = cpuBackend.data.get(image.dataId).values;
        for(let batchIdx = 0; batchIdx < batch; batchIdx++){
            const batchOffset = batchIdx * imageWidth * imageHeight * numChannels;
            for(let row = 0; row < imageHeight; row++){
                const rowOffset = row * (imageWidth * numChannels);
                for(let col = 0; col < imageWidth; col++){
                    const colOffset = col * numChannels;
                    for(let channel = 0; channel < numChannels; channel++){
                        const coords = [
                            batch,
                            row,
                            col,
                            channel
                        ];
                        const x = coords[2];
                        const y = coords[1];
                        // coordX/coordY are the result of rotating and translating x/y.
                        let coordX = (x - centerX) * cosFactor - (y - centerY) * sinFactor;
                        let coordY = (x - centerX) * sinFactor + (y - centerY) * cosFactor;
                        coordX = Math.round(coordX + centerX);
                        coordY = Math.round(coordY + centerY);
                        let outputValue = fillValue;
                        if (typeof fillValue !== 'number') {
                            if (channel === 3) outputValue = fullOpacityValue;
                            else outputValue = fillValue[channel];
                        }
                        // If the coordinate position falls within the image boundaries...
                        if (coordX >= 0 && coordX < imageWidth && coordY >= 0 && coordY < imageHeight) {
                            // set the output to the image value at the coordinate position.
                            const rotatedRowOffset = coordY * (imageWidth * numChannels);
                            const rotatedColOffset = coordX * numChannels;
                            const imageIdx = batchOffset + rotatedRowOffset + rotatedColOffset + channel;
                            outputValue = imageVals[imageIdx];
                        }
                        const outIdx = batchOffset + rowOffset + colOffset + channel;
                        output[outIdx] = outputValue;
                    }
                }
            }
        }
        const dataId = cpuBackend.write(output, image.shape, image.dtype);
        return {
            dataId: dataId,
            shape: image.shape,
            dtype: image.dtype
        };
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $l6afd = parcelRequire("l6afd");
const $753e2a9e9d924dd2$export$2077e0241d6afd3c = (0, $l6afd.unaryKernelFunc)((0, $i64bB.Round), (xi)=>{
    // The algorithm is based on banker's rounding.
    const base = Math.floor(xi);
    if (xi - base < 0.5) return Math.floor(xi);
    else if (xi - base > 0.5) return Math.ceil(xi);
    else {
        if (base % 2.0 === 0.0) return base;
        else return base + 1.0;
    }
});
const $753e2a9e9d924dd2$export$6c09e3291f636503 = {
    kernelName: (0, $i64bB.Round),
    backendName: 'cpu',
    kernelFunc: $753e2a9e9d924dd2$export$2077e0241d6afd3c
};



var $GbeHD = parcelRequire("GbeHD");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $YcuAy = parcelRequire("YcuAy");
function $db0ec83ab150be86$export$b6f42038a536d877(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { indices: indices, updates: updates } = inputs;
    const { shape: shape } = attrs;
    const { sliceRank: sliceRank, numUpdates: numUpdates, sliceSize: sliceSize, strides: strides, outputSize: outputSize } = (0, $i64bB.backend_util).calculateShapes(updates, indices, shape);
    const sumDupeIndices = true;
    const indicesBuf = backend.bufferSync(indices);
    const updatesBuf = backend.bufferSync(updates);
    const outBuf = (0, $YcuAy.scatterImpl)(indicesBuf, updatesBuf, shape, outputSize, sliceSize, numUpdates, sliceRank, strides, 0 /* defaultValue */ , sumDupeIndices);
    return backend.makeTensorInfo(shape, outBuf.dtype, outBuf.values);
}
const $db0ec83ab150be86$export$573371744f044f5 = {
    kernelName: (0, $i64bB.ScatterNd),
    backendName: 'cpu',
    kernelFunc: $db0ec83ab150be86$export$b6f42038a536d877
};


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
function $da1f1b4921c9d8a4$var$lowerBound(array, value) {
    let left = 0;
    let right = array.length;
    let mid = 0;
    while(left < right){
        mid = Math.floor((left + right) / 2);
        if (array[mid] < value) left = mid + 1;
        else right = mid;
    }
    return right;
}
function $da1f1b4921c9d8a4$var$upperBound(array, value) {
    let left = 0;
    let right = array.length;
    let mid = 0;
    while(left < right){
        mid = Math.floor((left + right) / 2);
        if (array[mid] <= value) left = mid + 1;
        else right = mid;
    }
    return right;
}
function $da1f1b4921c9d8a4$export$dbd5299c7ff33b30(sortedInputs, values, batchSize, numInputs, numValues, side) {
    const output = (0, $i64bB.util).getArrayFromDType('int32', batchSize * numValues);
    for(let b = 0; b < batchSize; ++b){
        const sortedInputsSlice = sortedInputs.slice(b * numInputs, (b + 1) * numInputs);
        const outputOffset = b * numValues;
        for(let i = 0; i < numValues; ++i)output[outputOffset + i] = side === 'left' ? $da1f1b4921c9d8a4$var$lowerBound(sortedInputsSlice, values[i + outputOffset]) : $da1f1b4921c9d8a4$var$upperBound(sortedInputsSlice, values[i + outputOffset]);
    }
    return output;
}


function $458e2d8d2874e7ed$export$56fad8d65b0adbdd(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { sortedSequence: sortedSequence, values: values } = inputs;
    const { side: side } = attrs;
    const $sortedSequence = backend.data.get(sortedSequence.dataId).values;
    const $values = backend.data.get(values.dataId).values;
    const output = (0, $da1f1b4921c9d8a4$export$dbd5299c7ff33b30)($sortedSequence, $values, sortedSequence.shape[0], sortedSequence.shape[1], values.shape[1], side);
    return backend.makeTensorInfo(values.shape, 'int32', output);
}
const $458e2d8d2874e7ed$export$4b437b1a1aa6472f = {
    kernelName: (0, $i64bB.SearchSorted),
    backendName: 'cpu',
    kernelFunc: $458e2d8d2874e7ed$export$56fad8d65b0adbdd
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");
function $b56f03df723757c7$export$2e6c959c16ff56b8(args) {
    const { inputs: inputs, backend: backend } = args;
    const { condition: condition, t: t, e: e } = inputs;
    (0, $csahy.assertNotComplex)([
        condition,
        t,
        e
    ], 'select');
    const conditionRank = condition.shape.length;
    const values = backend.data.get(condition.dataId).values;
    const tValues = backend.data.get(t.dataId).values;
    const eValues = backend.data.get(e.dataId).values;
    const resultDtype = (0, $i64bB.upcastType)(t.dtype, e.dtype);
    const newValues = (0, $i64bB.util).makeZerosTypedArray((0, $i64bB.util).sizeFromShape(t.shape), resultDtype);
    let index = 0;
    const offset = conditionRank === 0 || conditionRank > 1 || t.shape.length === 1 ? 1 : (0, $i64bB.util).sizeFromShape(t.shape.slice(1));
    for(let i = 0; i < values.length; i++){
        for(let j = 0; j < offset; j++)if (values[i] === 1) newValues[index++] = tValues[i];
        else newValues[index++] = eValues[i];
    }
    return backend.makeTensorInfo(t.shape, resultDtype, newValues);
}
const $b56f03df723757c7$export$7ff911e710ee72fc = {
    kernelName: (0, $i64bB.Select),
    backendName: 'cpu',
    kernelFunc: $b56f03df723757c7$export$2e6c959c16ff56b8
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $l6afd = parcelRequire("l6afd");
const $2a2e616f33963128$var$scaleAlpha = (0, $i64bB.backend_util).SELU_SCALEALPHA;
const $2a2e616f33963128$var$scale = (0, $i64bB.backend_util).SELU_SCALE;
const $2a2e616f33963128$export$a5f8240d9e99b438 = (0, $l6afd.unaryKernelFunc)((0, $i64bB.Selu), (xi)=>{
    if (xi >= 0) return $2a2e616f33963128$var$scale * xi;
    else return $2a2e616f33963128$var$scaleAlpha * (Math.exp(xi) - 1);
});
const $2a2e616f33963128$export$8afc8558705c1a39 = {
    kernelName: (0, $i64bB.Selu),
    backendName: 'cpu',
    kernelFunc: $2a2e616f33963128$export$a5f8240d9e99b438
};



var $dMdBj = parcelRequire("dMdBj");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $l6afd = parcelRequire("l6afd");
const $736c054017f2c822$export$c5552dfdbc7cec71 = (0, $l6afd.unaryKernelFunc)((0, $i64bB.Sign), (xi)=>{
    if (xi < 0) return -1;
    else if (xi > 0) return 1;
    else return 0;
});
const $736c054017f2c822$export$9c0fb3eb2124ceb7 = {
    kernelName: (0, $i64bB.Sign),
    backendName: 'cpu',
    kernelFunc: $736c054017f2c822$export$c5552dfdbc7cec71
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $l6afd = parcelRequire("l6afd");
const $9dde46fa3f6ed86e$export$5de3937cb4b592ed = (0, $l6afd.unaryKernelFunc)((0, $i64bB.Sin), (xi)=>Math.sin(xi));
const $9dde46fa3f6ed86e$export$d993ec4e5c253b66 = {
    kernelName: (0, $i64bB.Sin),
    backendName: 'cpu',
    kernelFunc: $9dde46fa3f6ed86e$export$5de3937cb4b592ed
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $l6afd = parcelRequire("l6afd");
const $1c4439d8070292f4$export$545004b505d7c555 = (0, $l6afd.unaryKernelFunc)((0, $i64bB.Sinh), (xi)=>Math.sinh(xi));
const $1c4439d8070292f4$export$b92766b47f18ac85 = {
    kernelName: (0, $i64bB.Sinh),
    backendName: 'cpu',
    kernelFunc: $1c4439d8070292f4$export$545004b505d7c555
};



var $aYBRE = parcelRequire("aYBRE");

/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $l6afd = parcelRequire("l6afd");
// mirrors the implementation of tf.nn.softplus: https://goo.gl/vkcvwX
// epsilon is the difference between 1.0 and the next representable float.
// For a single precision 32 bit float this should be 2^-23, see:
// https://math.byu.edu/~schow/work/IEEEFloatingPoint.htm
const $f3c31fdd8d5dc76c$var$epsilon = 1.1920928955078125e-7;
const $f3c31fdd8d5dc76c$var$threshold = Math.log($f3c31fdd8d5dc76c$var$epsilon) + 2.0;
const $f3c31fdd8d5dc76c$export$76aa560a8c2b0055 = (0, $l6afd.unaryKernelFunc)((0, $i64bB.Softplus), (xi)=>{
    // Value above which exp(x) may overflow, but softplus(x) == x
    // is within machine epsilon.
    const tooLarge = xi > -$f3c31fdd8d5dc76c$var$threshold;
    // Value below which exp(x) may underflow, but softplus(x) == exp(x)
    // is within machine epsilon.
    const tooSmall = xi < $f3c31fdd8d5dc76c$var$threshold;
    const expX = Math.exp(xi);
    let result;
    if (tooSmall) result = expX;
    else if (tooLarge) result = xi;
    else result = Math.log(1.0 + expX);
    return result;
});
const $f3c31fdd8d5dc76c$export$d9bcfe553d12d9e3 = {
    kernelName: (0, $i64bB.Softplus),
    backendName: 'cpu',
    kernelFunc: $f3c31fdd8d5dc76c$export$76aa560a8c2b0055
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");



var $EOTYn = parcelRequire("EOTYn");
function $3ce545c737188b0f$export$effb9d7cae92012f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { blockShape: blockShape, paddings: paddings } = attrs;
    (0, $csahy.assertNotComplex)([
        x
    ], 'spaceToBatchND');
    const prod = (0, $i64bB.util).sizeFromShape(blockShape);
    const completePaddings = [
        [
            0,
            0
        ]
    ];
    completePaddings.push(...paddings);
    for(let i = 1 + blockShape.length; i < x.shape.length; ++i)completePaddings.push([
        0,
        0
    ]);
    const paddedX = (0, $13bfb533800aba7e$export$b0317e720bfd61fc).kernelFunc({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            paddings: completePaddings,
            constantValue: 0
        }
    });
    const reshapedPaddedShape = (0, $i64bB.backend_util).getReshaped(paddedX.shape, blockShape, prod, false);
    const permutedReshapedPaddedPermutation = (0, $i64bB.backend_util).getPermuted(reshapedPaddedShape.length, blockShape.length, false);
    const flattenShape = (0, $i64bB.backend_util).getReshapedPermuted(paddedX.shape, blockShape, prod, false);
    const reshapeInputs = {
        x: paddedX
    };
    const reshapeAttrs = {
        shape: reshapedPaddedShape
    };
    const paddedXReshaped = (0, $abec025db4e7e093$export$9eaad88cf88cee2b)({
        inputs: reshapeInputs,
        backend: backend,
        attrs: reshapeAttrs
    });
    const transposeInputs = {
        x: paddedXReshaped
    };
    const transposeAttrs = {
        perm: permutedReshapedPaddedPermutation
    };
    const paddedXT = (0, $EOTYn.transpose)({
        inputs: transposeInputs,
        backend: backend,
        attrs: transposeAttrs
    });
    const resultReshapeInputs = {
        x: paddedXT
    };
    const resultReshapeAttrs = {
        shape: flattenShape
    };
    const result = (0, $abec025db4e7e093$export$9eaad88cf88cee2b)({
        inputs: resultReshapeInputs,
        backend: backend,
        attrs: resultReshapeAttrs
    });
    backend.disposeIntermediateTensorInfo(paddedX);
    backend.disposeIntermediateTensorInfo(paddedXReshaped);
    backend.disposeIntermediateTensorInfo(paddedXT);
    return result;
}
const $3ce545c737188b0f$export$2f85417863d2050b = {
    kernelName: (0, $i64bB.SpaceToBatchND),
    backendName: 'cpu',
    kernelFunc: $3ce545c737188b0f$export$effb9d7cae92012f
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $dkwAe = parcelRequire("dkwAe");
function $c243d83383333266$export$c82a1904a15b5028(args) {
    const { inputs: inputs, backend: backend } = args;
    const { indices: indices, values: values, denseShape: denseShape, defaultValue: defaultValue } = inputs;
    if (denseShape.shape.length !== 1) throw new Error(`Dense shape must be a vector, saw:
        ${denseShape.shape}`);
    if (indices.shape.length !== 2) throw new Error(`Indices must be a matrix, saw:
        ${indices.shape}`);
    if (values.shape.length !== 1) throw new Error(`Values must be a vector, saw:
        ${values.shape}`);
    if (defaultValue.shape.length !== 0) throw new Error(`Default value must be a scalar, saw:
        ${defaultValue.shape}`);
    const $indices = backend.data.get(indices.dataId).values;
    const $values = backend.data.get(values.dataId).values;
    const $denseShape = backend.data.get(denseShape.dataId).values;
    const $defaultValue = backend.data.get(defaultValue.dataId).values[0];
    const [outputIndices, outputIndicesShape, outputValues, emptyRowIndicator, reverseIndexMap] = (0, $dkwAe.sparseFillEmptyRowsImpl)($indices, indices.shape, indices.dtype, $values, values.dtype, $denseShape, $defaultValue);
    return [
        backend.makeTensorInfo(outputIndicesShape, indices.dtype, outputIndices),
        backend.makeTensorInfo([
            outputIndicesShape[0]
        ], values.dtype, outputValues),
        backend.makeTensorInfo([
            emptyRowIndicator.length
        ], 'bool', new Uint8Array(emptyRowIndicator.map((value)=>Number(value)))),
        backend.makeTensorInfo([
            reverseIndexMap.length
        ], indices.dtype, new Int32Array(reverseIndexMap))
    ];
}
const $c243d83383333266$export$818286c593224d1a = {
    kernelName: (0, $i64bB.SparseFillEmptyRows),
    backendName: 'cpu',
    kernelFunc: $c243d83383333266$export$c82a1904a15b5028
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $9VxEX = parcelRequire("9VxEX");
function $482d46c5d8b3e9ae$export$1408c45865e11fc6(args) {
    const { inputs: inputs, backend: backend } = args;
    const { inputIndices: inputIndices, inputShape: inputShape, newShape: newShape } = inputs;
    if (inputIndices.shape.length !== 2) throw new Error(`Input indices should be a matrix but received shape
        ${inputIndices.shape}`);
    if (inputShape.shape.length !== 1) throw new Error(`Input shape should be a vector but received shape
        ${inputShape.shape}`);
    if (newShape.shape.length !== 1) throw new Error(`Target shape should be a vector but received shape ${newShape.shape}`);
    const $inputShape = Array.from(backend.data.get(inputShape.dataId).values);
    const $inputIndices = backend.data.get(inputIndices.dataId).values;
    const targetShape = Array.from(backend.data.get(newShape.dataId).values);
    const [newIndices, indicesShape, outputShape] = (0, $9VxEX.sparseReshapeImpl)($inputIndices, inputIndices.shape, inputIndices.dtype, $inputShape, targetShape);
    return [
        backend.makeTensorInfo(indicesShape, inputIndices.dtype, newIndices),
        backend.makeTensorInfo([
            outputShape.length
        ], newShape.dtype, new Int32Array(outputShape))
    ];
}
const $482d46c5d8b3e9ae$export$eb106efc10374803 = {
    kernelName: (0, $i64bB.SparseReshape),
    backendName: 'cpu',
    kernelFunc: $482d46c5d8b3e9ae$export$1408c45865e11fc6
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $8ENVF = parcelRequire("8ENVF");
function $a51aa4776ba67347$export$dbc0c9096869d04e(args) {
    const { inputs: inputs, backend: backend } = args;
    const { data: data, indices: indices, segmentIds: segmentIds } = inputs;
    if (data.shape.length < 1) throw new Error(`Data should be at least 1 dimensional but received scalar`);
    if (indices.shape.length !== 1) throw new Error(`Indices should be a vector but received shape
          ${indices.shape}`);
    if (segmentIds.shape.length !== 1) throw new Error(`Segment ids should be a vector but received shape
          ${segmentIds.shape}`);
    if (indices.shape[0] !== segmentIds.shape[0]) throw new Error(`segmentIds and indices should have same size.`);
    const $data = backend.data.get(data.dataId).values;
    const $indices = backend.data.get(indices.dataId).values;
    const $segmentIds = backend.data.get(segmentIds.dataId).values;
    const [outputData, outputDataShape] = (0, $8ENVF.sparseSegmentReductionImpl)($data, data.shape, data.dtype, $indices, $segmentIds, true);
    return backend.makeTensorInfo(outputDataShape, data.dtype, outputData);
}
const $a51aa4776ba67347$export$51e7224ae14d7f78 = {
    kernelName: (0, $i64bB.SparseSegmentMean),
    backendName: 'cpu',
    kernelFunc: $a51aa4776ba67347$export$dbc0c9096869d04e
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $8ENVF = parcelRequire("8ENVF");
function $f55251d4b2187fa4$export$2255ce53fc777865(args) {
    const { inputs: inputs, backend: backend } = args;
    const { data: data, indices: indices, segmentIds: segmentIds } = inputs;
    if (data.shape.length < 1) throw new Error(`Data should be at least 1 dimensional but received scalar`);
    if (indices.shape.length !== 1) throw new Error(`Indices should be a vector but received shape
         ${indices.shape}`);
    if (segmentIds.shape.length !== 1) throw new Error(`Segment ids should be a vector but received shape
         ${segmentIds.shape}`);
    if (indices.shape[0] !== segmentIds.shape[0]) throw new Error(`segmentIds and indices should have same size.`);
    const $data = backend.data.get(data.dataId).values;
    const $indices = backend.data.get(indices.dataId).values;
    const $segmentIds = backend.data.get(segmentIds.dataId).values;
    const [outputData, outputDataShape] = (0, $8ENVF.sparseSegmentReductionImpl)($data, data.shape, data.dtype, $indices, $segmentIds);
    return backend.makeTensorInfo(outputDataShape, data.dtype, outputData);
}
const $f55251d4b2187fa4$export$73fa0270f28b9555 = {
    kernelName: (0, $i64bB.SparseSegmentSum),
    backendName: 'cpu',
    kernelFunc: $f55251d4b2187fa4$export$2255ce53fc777865
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $YcuAy = parcelRequire("YcuAy");
function $1436facfc2e176db$export$1be4b823dd1a3080(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { sparseIndices: sparseIndices, sparseValues: sparseValues, defaultValue: defaultValue } = inputs;
    const { outputShape: outputShape } = attrs;
    const { sliceRank: sliceRank, numUpdates: numUpdates, sliceSize: sliceSize, strides: strides, outputSize: outputSize } = (0, $i64bB.backend_util).calculateShapes(sparseValues, sparseIndices, outputShape);
    const sumDupeIndices = false;
    const indicesBuf = backend.bufferSync(sparseIndices);
    let outBuf;
    switch(sparseValues.dtype){
        case 'bool':
            {
                const updatesBuf = backend.bufferSync(sparseValues);
                const $defaultValue = Boolean(backend.data.get(defaultValue.dataId).values[0]);
                outBuf = (0, $YcuAy.scatterImpl)(indicesBuf, updatesBuf, outputShape, outputSize, sliceSize, numUpdates, sliceRank, strides, $defaultValue, sumDupeIndices);
                break;
            }
        case 'float32':
            {
                const updatesBuf = backend.bufferSync(sparseValues);
                const $defaultValue = backend.data.get(defaultValue.dataId).values[0];
                outBuf = (0, $YcuAy.scatterImpl)(indicesBuf, updatesBuf, outputShape, outputSize, sliceSize, numUpdates, sliceRank, strides, $defaultValue, sumDupeIndices);
                break;
            }
        case 'int32':
            {
                const updatesBuf = backend.bufferSync(sparseValues);
                const $defaultValue = backend.data.get(defaultValue.dataId).values[0];
                outBuf = (0, $YcuAy.scatterImpl)(indicesBuf, updatesBuf, outputShape, outputSize, sliceSize, numUpdates, sliceRank, strides, $defaultValue, sumDupeIndices);
                break;
            }
        case 'string':
            {
                const updatesBuf = backend.bufferSync(sparseValues);
                const $defaultValue = (0, $i64bB.util).decodeString(backend.data.get(defaultValue.dataId).values[0]);
                outBuf = (0, $YcuAy.scatterImpl)(indicesBuf, updatesBuf, outputShape, outputSize, sliceSize, numUpdates, sliceRank, strides, $defaultValue, sumDupeIndices);
                break;
            }
        default:
            throw new Error(`Unsupported type ${sparseValues.dtype}`);
    }
    return backend.makeTensorInfo(outputShape, outBuf.dtype, outBuf.values);
}
const $1436facfc2e176db$export$7bc088f8ad44ef99 = {
    kernelName: (0, $i64bB.SparseToDense),
    backendName: 'cpu',
    kernelFunc: $1436facfc2e176db$export$1be4b823dd1a3080
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $aYBRE = parcelRequire("aYBRE");
function $9375987d2a00708c$export$c0085d48b0a75d8f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { numOrSizeSplits: numOrSizeSplits, axis: axis } = attrs;
    const $axis = (0, $i64bB.util).parseAxisParam(axis, x.shape)[0];
    const splitSizes = (0, $i64bB.backend_util).prepareSplitSize(x, numOrSizeSplits, $axis);
    const begin = new Array(x.shape.length).fill(0);
    const size = x.shape.slice();
    return splitSizes.map((s)=>{
        const sliceSize = [
            ...size
        ];
        sliceSize[$axis] = s;
        const sliceT = (0, $aYBRE.slice)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                begin: begin,
                size: sliceSize
            }
        });
        begin[$axis] += s;
        return sliceT;
    });
}
const $9375987d2a00708c$export$317be24be3af9ea0 = {
    kernelName: (0, $i64bB.SplitV),
    backendName: 'cpu',
    kernelFunc: $9375987d2a00708c$export$c0085d48b0a75d8f
};



var $2a43t = parcelRequire("2a43t");
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");
const $5a8ac69b1a7144d0$export$7c77bece4d51efc4 = {
    kernelName: (0, $i64bB.Square),
    backendName: 'cpu',
    kernelFunc: ({ inputs: inputs, backend: backend })=>{
        const { x: x } = inputs;
        const cpuBackend = backend;
        (0, $csahy.assertNotComplex)(x, 'square');
        const values = cpuBackend.data.get(x.dataId).values;
        const newValues = new Float32Array(values.length);
        for(let i = 0; i < values.length; ++i){
            const value = values[i];
            newValues[i] = value * value;
        }
        const dataId = cpuBackend.write(newValues, x.shape, x.dtype);
        return {
            dataId: dataId,
            shape: x.shape,
            dtype: x.dtype
        };
    }
};



var $4QLZo = parcelRequire("4QLZo");

var $hRUGg = parcelRequire("hRUGg");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $l6afd = parcelRequire("l6afd");
const $fc9ede3899fe8565$export$35d34bc0ed591a92 = (0, $l6afd.unaryKernelFunc)((0, $i64bB.Step), (xi, attrs)=>{
    const stepAttrs = attrs;
    if (isNaN(xi)) return NaN;
    else return xi > 0 ? 1 : stepAttrs.alpha;
});
const $fc9ede3899fe8565$export$c42ffaf52eb2647 = {
    kernelName: (0, $i64bB.Step),
    backendName: 'cpu',
    kernelFunc: $fc9ede3899fe8565$export$35d34bc0ed591a92
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");


var $aYBRE = parcelRequire("aYBRE");

var $6Syfk = parcelRequire("6Syfk");
function $aa510b8b1a9fefdb$export$4ae57224f3b0605c(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { begin: begin, end: end, strides: strides, beginMask: beginMask, endMask: endMask, ellipsisMask: ellipsisMask, newAxisMask: newAxisMask, shrinkAxisMask: shrinkAxisMask } = attrs;
    (0, $csahy.assertNotComplex)(x, 'stridedSlice');
    const { finalShapeSparse: finalShapeSparse, finalShape: finalShape, isIdentity: isIdentity, sliceDim0: sliceDim0, isSimpleSlice: isSimpleSlice, begin: $begin, end: $end, strides: $strides } = (0, $i64bB.slice_util).sliceInfo(x.shape, begin, end, strides, beginMask, endMask, ellipsisMask, newAxisMask, shrinkAxisMask);
    let result;
    // ref:
    // https://github.com/tensorflow/tensorflow/blob/master/tensorflow/core/kernels/strided_slice_op.cc
    if (isIdentity) // Optimization #1, slice is a no-op plus reshape
    result = (0, $abec025db4e7e093$export$9eaad88cf88cee2b)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            shape: finalShape
        }
    });
    else if (sliceDim0 || isSimpleSlice) {
        // Optimization #2, slice is memory contiguous (only occurs in dim 0)
        (0, $i64bB.util).assert(x.shape.length >= 1, ()=>`Input must have rank at least 1, got: ${x.shape.length}`);
        const size = (0, $i64bB.slice_util).computeOutShape($begin, $end, $strides);
        // To tolerate begin[0] > end[0] (a 0-output slice), we min(begin, end).
        const sliced = (0, $aYBRE.slice)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                begin: $begin,
                size: size
            }
        });
        result = (0, $abec025db4e7e093$export$9eaad88cf88cee2b)({
            inputs: {
                x: sliced
            },
            backend: backend,
            attrs: {
                shape: finalShape
            }
        });
        backend.disposeIntermediateTensorInfo(sliced);
    } else {
        const xBuf = backend.bufferSync(x);
        const outBuf = (0, $6Syfk.stridedSliceImpl)(finalShapeSparse, xBuf, $strides, $begin);
        result = backend.makeTensorInfo(finalShape, outBuf.dtype, outBuf.values);
    }
    return result;
}
const $aa510b8b1a9fefdb$export$81773633114187bd = {
    kernelName: (0, $i64bB.StridedSlice),
    backendName: 'cpu',
    kernelFunc: $aa510b8b1a9fefdb$export$4ae57224f3b0605c
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $fopkM = parcelRequire("fopkM");
function $7a7ddc64c1997f40$export$3490514dcc63b044(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { separator: separator, nGramWidths: nGramWidths, leftPad: leftPad, rightPad: rightPad, padWidth: padWidth, preserveShortSequences: preserveShortSequences } = attrs;
    const { data: data, dataSplits: dataSplits } = inputs;
    const $data = backend.data.get(data.dataId).values;
    const $dataSplits = backend.data.get(dataSplits.dataId).values;
    const [nGrams, nGramsSplits] = (0, $fopkM.stringNGramsImpl)($data, $dataSplits, separator, nGramWidths, leftPad, rightPad, padWidth, preserveShortSequences);
    return [
        backend.makeTensorInfo([
            nGrams.length
        ], 'string', nGrams),
        backend.makeTensorInfo(dataSplits.shape, 'int32', nGramsSplits)
    ];
}
const $7a7ddc64c1997f40$export$35e13284eed34c22 = {
    kernelName: (0, $i64bB.StringNGrams),
    backendName: 'cpu',
    kernelFunc: $7a7ddc64c1997f40$export$3490514dcc63b044
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $5xLgA = parcelRequire("5xLgA");
function $636664dcd843ab75$export$aa7f8babb17e7672(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { skipEmpty: skipEmpty } = attrs;
    const { input: input, delimiter: delimiter } = inputs;
    if (input.dtype !== 'string') throw new Error('Input must be of datatype string');
    if (input.shape.length !== 1) throw new Error(`Input must be a vector, got shape: ${input.shape}`);
    if (delimiter.shape.length !== 0) throw new Error(`Delimiter must be a scalar, got shape: ${delimiter.shape}`);
    const $input = backend.data.get(input.dataId).values;
    const $delimiter = backend.data.get(delimiter.dataId).values[0];
    const [indices, values, shape] = (0, $5xLgA.stringSplitImpl)($input, $delimiter, skipEmpty);
    const outputSize = values.length;
    return [
        backend.makeTensorInfo([
            outputSize,
            2
        ], 'int32', indices),
        backend.makeTensorInfo([
            outputSize
        ], 'string', values),
        backend.makeTensorInfo([
            2
        ], 'int32', new Int32Array(shape))
    ];
}
const $636664dcd843ab75$export$c51cbbd627a96532 = {
    kernelName: (0, $i64bB.StringSplit),
    backendName: 'cpu',
    kernelFunc: $636664dcd843ab75$export$aa7f8babb17e7672
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $cWacD = parcelRequire("cWacD");
function $9bbac82dfb7e21b5$export$6195616d6fd0c848(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { numBuckets: numBuckets } = attrs;
    const { input: input } = inputs;
    if (input.dtype !== 'string') throw new Error('Input must be of datatype string');
    if (numBuckets <= 0) throw new Error(`Number of buckets must be at least 1`);
    const $input = backend.data.get(input.dataId).values;
    const output = (0, $cWacD.stringToHashBucketFastImpl)($input, numBuckets);
    return backend.makeTensorInfo(input.shape, 'int32', output);
}
const $9bbac82dfb7e21b5$export$a88a78b2b233f507 = {
    kernelName: (0, $i64bB.StringToHashBucketFast),
    backendName: 'cpu',
    kernelFunc: $9bbac82dfb7e21b5$export$6195616d6fd0c848
};



var $aT9VE = parcelRequire("aT9VE");

/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $l6afd = parcelRequire("l6afd");
const $355a87237ac9d0fd$export$fcdd3b0b3246a325 = (0, $l6afd.unaryKernelFunc)((0, $i64bB.Tan), (xi)=>Math.tan(xi));
const $355a87237ac9d0fd$export$97648844df7611f3 = {
    kernelName: (0, $i64bB.Tan),
    backendName: 'cpu',
    kernelFunc: $355a87237ac9d0fd$export$fcdd3b0b3246a325
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $l6afd = parcelRequire("l6afd");
const $26f4c37aceea00f2$export$7128670e45beef9a = (0, $l6afd.unaryKernelFunc)((0, $i64bB.Tanh), (xi)=>Math.tanh(xi));
const $26f4c37aceea00f2$export$a2fc7de1a1e4eee0 = {
    kernelName: (0, $i64bB.Tanh),
    backendName: 'cpu',
    kernelFunc: $26f4c37aceea00f2$export$7128670e45beef9a
};


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $YcuAy = parcelRequire("YcuAy");
function $ad5df25f6a7881cc$export$d3ac02769385eb36(args) {
    const { inputs: inputs, backend: backend } = args;
    const { tensor: tensor, indices: indices, updates: updates } = inputs;
    const { sliceRank: sliceRank, numUpdates: numUpdates, sliceSize: sliceSize, strides: strides, outputSize: outputSize } = (0, $i64bB.backend_util).calculateShapes(updates, indices, tensor.shape);
    const sumDupeIndices = false;
    const indicesBuf = backend.bufferSync(indices);
    const updatesBuf = backend.bufferSync(updates);
    const tensorBuf = backend.bufferSync(tensor);
    const outBuf = (0, $YcuAy.scatterImpl)(indicesBuf, updatesBuf, tensor.shape, outputSize, sliceSize, numUpdates, sliceRank, strides, tensorBuf, sumDupeIndices);
    return backend.makeTensorInfo(tensor.shape, outBuf.dtype, outBuf.values);
}
const $ad5df25f6a7881cc$export$2819813ce8339b64 = {
    kernelName: (0, $i64bB.TensorScatterUpdate),
    backendName: 'cpu',
    kernelFunc: $ad5df25f6a7881cc$export$d3ac02769385eb36
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");

var $bzU8O = parcelRequire("bzU8O");
function $1540c7dcb955050c$export$3c17558da18e4d75(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { reps: reps } = attrs;
    (0, $csahy.assertNotComplex)(x, 'tile');
    const outBuf = (0, $bzU8O.tileImpl)(backend.bufferSync(x), reps);
    return backend.makeTensorInfo(outBuf.shape, outBuf.dtype, outBuf.values);
}
const $1540c7dcb955050c$export$a5a9f8050ba7f41e = {
    kernelName: (0, $i64bB.Tile),
    backendName: 'cpu',
    kernelFunc: $1540c7dcb955050c$export$3c17558da18e4d75
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");

var $8tNzN = parcelRequire("8tNzN");
function $4871f991199a1256$export$7e641efc73a2d81(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { k: k, sorted: sorted } = attrs;
    (0, $csahy.assertNotComplex)(x, 'topk');
    const xVals = backend.data.get(x.dataId).values;
    const [allTopKVals, allTopKIndices] = (0, $8tNzN.topKImpl)(xVals, x.shape, x.dtype, k, sorted);
    return [
        backend.makeTensorInfo(allTopKVals.shape, allTopKVals.dtype, allTopKVals.values),
        backend.makeTensorInfo(allTopKIndices.shape, allTopKIndices.dtype, allTopKIndices.values)
    ];
}
const $4871f991199a1256$export$cffaee31213314ce = {
    kernelName: (0, $i64bB.TopK),
    backendName: 'cpu',
    kernelFunc: $4871f991199a1256$export$7e641efc73a2d81
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
function $ef9830f1a35dd770$export$51186ad6e864892a(args) {
    const { inputs: inputs, attrs: attrs, backend: backend } = args;
    const { image: image, transforms: transforms } = inputs;
    const { interpolation: interpolation, fillMode: fillMode, fillValue: fillValue, outputShape: outputShape } = attrs;
    const [batch, imageHeight, imageWidth, numChannels] = image.shape;
    const [outHeight, outWidth] = outputShape != null ? outputShape : [
        imageHeight,
        imageWidth
    ];
    const outShape = [
        batch,
        outHeight,
        outWidth,
        numChannels
    ];
    const inStrides = (0, $i64bB.util).computeStrides(image.shape);
    const batchInStride = inStrides[0];
    const rowInStride = inStrides[1];
    const colInStride = inStrides[2];
    const outStrides = (0, $i64bB.util).computeStrides(outShape);
    const batchOutStride = outStrides[0];
    const rowOutStride = outStrides[1];
    const colOutStride = outStrides[2];
    const outVals = (0, $i64bB.util).getTypedArrayFromDType(image.dtype, (0, $i64bB.util).sizeFromShape(outShape));
    outVals.fill(fillValue);
    const imageVals = backend.data.get(image.dataId).values;
    const transformVals = backend.data.get(transforms.dataId).values;
    // Ref TF implementation:
    // https://github.com/tensorflow/tensorflow/blob/master/tensorflow/core/kernels/image/image_ops.h
    for(let b = 0; b < batch; ++b){
        const transform = transforms.shape[0] === 1 ? transformVals : transformVals.subarray(b * 8, b * 8 + 8);
        for(let outY = 0; outY < outHeight; ++outY){
            for(let outX = 0; outX < outWidth; ++outX)for(let channel = 0; channel < numChannels; ++channel){
                let val;
                const projection = transform[6] * outX + transform[7] * outY + 1;
                if (projection === 0) continue;
                const inX = (transform[0] * outX + transform[1] * outY + transform[2]) / projection;
                const inY = (transform[3] * outX + transform[4] * outY + transform[5]) / projection;
                const x = $ef9830f1a35dd770$var$mapCoord(inX, imageWidth, fillMode);
                const y = $ef9830f1a35dd770$var$mapCoord(inY, imageHeight, fillMode);
                switch(interpolation){
                    case 'nearest':
                        val = $ef9830f1a35dd770$var$nearestInterpolation(imageVals, imageHeight, imageWidth, batchInStride, rowInStride, colInStride, b, y, x, channel, fillValue);
                        break;
                    case 'bilinear':
                        val = $ef9830f1a35dd770$var$bilinearInterpolation(imageVals, imageHeight, imageWidth, batchInStride, rowInStride, colInStride, b, y, x, channel, fillValue);
                        break;
                    default:
                        throw new Error(`Error in Transform: Expect 'nearest' or ` + `'bilinear', but got ${interpolation}`);
                }
                const ind = b * batchOutStride + outY * rowOutStride + outX * colOutStride + channel;
                outVals[ind] = val;
            }
        }
        return backend.makeTensorInfo(outShape, image.dtype, outVals);
    }
    const dataId = backend.write(outVals, outShape, image.dtype);
    return {
        dataId: dataId,
        shape: image.shape,
        dtype: image.dtype
    };
}
const $ef9830f1a35dd770$export$1c7a3de6335954ed = {
    kernelName: (0, $i64bB.Transform),
    backendName: 'cpu',
    kernelFunc: $ef9830f1a35dd770$export$51186ad6e864892a
};
function $ef9830f1a35dd770$var$mapCoord(outCoord, len, mode) {
    switch(mode){
        case 'reflect':
            return $ef9830f1a35dd770$var$mapCoordReflect(outCoord, len);
        case 'wrap':
            return $ef9830f1a35dd770$var$mapCoordWrap(outCoord, len);
        case 'nearest':
            return $ef9830f1a35dd770$var$mapCoordNearest(outCoord, len);
        case 'constant':
        default:
            return $ef9830f1a35dd770$var$mapCoordConstant(outCoord, len);
    }
}
function $ef9830f1a35dd770$var$mapCoordReflect(outCoord, len) {
    // Reflect [abcd] to [dcba|abcd|dcba].
    let inCoord = outCoord;
    if (inCoord < 0) {
        if (len <= 1) inCoord = 0;
        else {
            const sz2 = 2 * len;
            if (inCoord < sz2) inCoord = sz2 * Math.trunc(-inCoord / sz2) + inCoord;
            inCoord = inCoord < -len ? inCoord + sz2 : -inCoord - 1;
        }
    } else if (inCoord > len - 1) {
        if (len <= 1) inCoord = 0;
        else {
            const sz2 = 2 * len;
            inCoord -= sz2 * Math.trunc(inCoord / sz2);
            if (inCoord >= len) inCoord = sz2 - inCoord - 1;
        }
    }
    // clamp is necessary because when outCoord = 3.5 and len = 4,
    // inCoord = 3.5 and will be rounded to 4 in nearest interpolation.
    return (0, $i64bB.util).clamp(0, inCoord, len - 1);
}
function $ef9830f1a35dd770$var$mapCoordWrap(outCoord, len) {
    // Wrap [abcd] to [abcd|abcd|abcd].
    let inCoord = outCoord;
    if (inCoord < 0) {
        if (len <= 1) inCoord = 0;
        else {
            const sz = len - 1;
            inCoord += len * (Math.trunc(-inCoord / sz) + 1);
        }
    } else if (inCoord > len - 1) {
        if (len <= 1) inCoord = 0;
        else {
            const sz = len - 1;
            inCoord -= len * Math.trunc(inCoord / sz);
        }
    }
    // clamp is necessary because when outCoord = -0.5 and len = 4,
    // inCoord = 3.5 and will be rounded to 4 in nearest interpolation.
    return (0, $i64bB.util).clamp(0, inCoord, len - 1);
}
function $ef9830f1a35dd770$var$mapCoordConstant(outCoord, len) {
    return outCoord;
}
function $ef9830f1a35dd770$var$mapCoordNearest(outCoord, len) {
    return (0, $i64bB.util).clamp(0, outCoord, len - 1);
}
function $ef9830f1a35dd770$var$readWithFillValue(imageVals, imageHeight, imageWidth, batchStride, rowStride, colStride, batch, y, x, channel, fillValue) {
    const ind = batch * batchStride + y * rowStride + x * colStride + channel;
    if (0 <= y && y < imageHeight && 0 <= x && x < imageWidth) return imageVals[ind];
    else return fillValue;
}
function $ef9830f1a35dd770$var$nearestInterpolation(imageVals, imageHeight, imageWidth, batchStride, rowStride, colStride, batch, y, x, channel, fillValue) {
    const $y = Math.round(y);
    const $x = Math.round(x);
    return $ef9830f1a35dd770$var$readWithFillValue(imageVals, imageHeight, imageWidth, batchStride, rowStride, colStride, batch, $y, $x, channel, fillValue);
}
function $ef9830f1a35dd770$var$bilinearInterpolation(imageVals, imageHeight, imageWidth, batchStride, rowStride, colStride, batch, y, x, channel, fillValue) {
    const yFloor = Math.floor(y);
    const xFloor = Math.floor(x);
    const yCeil = yFloor + 1;
    const xCeil = xFloor + 1;
    // f(x, yFloor) = (xCeil - x) / (xCeil - xFloor) * f(xFloor, yFloor)
    //               + (x - xFloor) / (xCeil - xFloor) * f(xCeil, yFloor)
    const valueYFloor = (xCeil - x) * $ef9830f1a35dd770$var$readWithFillValue(imageVals, imageHeight, imageWidth, batchStride, rowStride, colStride, batch, yFloor, xFloor, channel, fillValue) + (x - xFloor) * $ef9830f1a35dd770$var$readWithFillValue(imageVals, imageHeight, imageWidth, batchStride, rowStride, colStride, batch, yFloor, xCeil, channel, fillValue);
    // f(x, yCeil) = (xCeil - x) / (xCeil - xFloor) * f(xFloor, yCeil)
    //             + (x - xFloor) / (xCeil - xFloor) * f(xCeil, yCeil)
    const valueYCeil = (xCeil - x) * $ef9830f1a35dd770$var$readWithFillValue(imageVals, imageHeight, imageWidth, batchStride, rowStride, colStride, batch, yCeil, xFloor, channel, fillValue) + (x - xFloor) * $ef9830f1a35dd770$var$readWithFillValue(imageVals, imageHeight, imageWidth, batchStride, rowStride, colStride, batch, yCeil, xCeil, channel, fillValue);
    // f(x, y) = (yCeil - y) / (yCeil - yFloor) * f(x, yFloor)
    //         + (y - yFloor) / (yCeil - yFloor) * f(x, yCeil)
    return (yCeil - y) * valueYFloor + (y - yFloor) * valueYCeil;
}



var $EOTYn = parcelRequire("EOTYn");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");

var $fjkAl = parcelRequire("fjkAl");
function $8dfa572c1ff0579f$export$7a5d5c156e7dc406(args) {
    const { inputs: inputs, attrs: attrs, backend: backend } = args;
    const { axis: axis } = attrs;
    const { x: x } = inputs;
    (0, $csahy.assertNotComplex)(x, 'unique');
    const values = backend.data.get(x.dataId).values;
    const { outputValues: outputValues, outputShape: outputShape, indices: indices } = (0, $fjkAl.uniqueImpl)(values, axis, x.shape, x.dtype);
    return [
        backend.makeTensorInfo(outputShape, x.dtype, outputValues),
        backend.makeTensorInfo([
            indices.length
        ], 'int32', indices)
    ];
}
const $8dfa572c1ff0579f$export$78cd70dcd092910e = {
    kernelName: (0, $i64bB.Unique),
    backendName: 'cpu',
    kernelFunc: $8dfa572c1ff0579f$export$7a5d5c156e7dc406
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


var $aYBRE = parcelRequire("aYBRE");
function $ae53f289fee9ec8b$export$417857010dc9287f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { value: value } = inputs;
    let { axis: axis } = attrs;
    if (axis < 0) axis += value.shape.length;
    const valueRank = value.shape.length;
    const num = value.shape[axis];
    const outShape = new Array(valueRank - 1);
    let outIndex = 0;
    for(let i = 0; i < valueRank; i++)if (i !== axis) outShape[outIndex++] = value.shape[i];
    const begin = new Array(valueRank).fill(0);
    const size = value.shape.slice();
    size[axis] = 1;
    const res = new Array(num);
    for(let i = 0; i < res.length; i++){
        begin[axis] = i;
        const tempRes = (0, $aYBRE.slice)({
            inputs: {
                x: value
            },
            backend: backend,
            attrs: {
                begin: begin,
                size: size
            }
        });
        res[i] = (0, $abec025db4e7e093$export$9eaad88cf88cee2b)({
            inputs: {
                x: tempRes
            },
            backend: backend,
            attrs: {
                shape: outShape
            }
        });
        backend.disposeIntermediateTensorInfo(tempRes);
    }
    return res;
}
const $ae53f289fee9ec8b$export$d06292128cae50d6 = {
    kernelName: (0, $i64bB.Unpack),
    backendName: 'cpu',
    kernelFunc: $ae53f289fee9ec8b$export$417857010dc9287f
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $csahy = parcelRequire("csahy");

var $7LLjQ = parcelRequire("7LLjQ");

var $diO4l = parcelRequire("diO4l");


var $gQOIy = parcelRequire("gQOIy");


function $4467766cacfe86bc$export$ba7c4d144d85a309(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, segmentIds: segmentIds } = inputs;
    const { numSegments: numSegments } = attrs;
    (0, $csahy.assertNotComplex)(x, 'unsortedSegmentSum');
    const xRank = x.shape.length;
    const segmentIdsRank = segmentIds.shape.length;
    const res = [];
    const intermediates = [];
    // Reshape the segment id's so that they can be broadcast with
    // x. The new shape should be [segmentIds.shape, 1, ..., 1]
    const numIters = xRank - segmentIdsRank;
    let $segmentIds = segmentIds;
    for(let i = 0; i < numIters; ++i){
        const expanded = (0, $0b6b0257239c58c8$export$d660d8ed21f46635)({
            inputs: {
                input: $segmentIds
            },
            backend: backend,
            attrs: {
                dim: i + 1
            }
        });
        $segmentIds = expanded;
        intermediates.push(expanded);
    }
    for(let i = 0; i < numSegments; ++i){
        const scalarValue = (0, $i64bB.util).createScalarValue(i, 'int32');
        const segmentId = backend.makeTensorInfo([], 'int32', scalarValue);
        const mask = (0, $diO4l.equal)({
            inputs: {
                a: segmentId,
                b: $segmentIds
            },
            backend: backend
        });
        const maskCasted = (0, $7LLjQ.cast)({
            inputs: {
                x: mask
            },
            backend: backend,
            attrs: {
                dtype: 'float32'
            }
        });
        const mul = (0, $gQOIy.multiply)({
            inputs: {
                a: maskCasted,
                b: x
            },
            backend: backend
        });
        const sumTensorInfo = (0, $81f3b02b80a24eb0$export$8a63f25cc62965f1)({
            inputs: {
                x: mul
            },
            backend: backend,
            attrs: {
                axis: 0,
                keepDims: false
            }
        });
        res.push(sumTensorInfo);
        intermediates.push(segmentId);
        intermediates.push(mask);
        intermediates.push(maskCasted);
        intermediates.push(mul);
        intermediates.push(sumTensorInfo);
    }
    const result = (0, $d179715647152c30$export$2a703dbb0cb35339)({
        inputs: res,
        backend: backend,
        attrs: {
            axis: 0
        }
    });
    intermediates.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return result;
}
const $4467766cacfe86bc$export$71e3626a4ca29968 = {
    kernelName: (0, $i64bB.UnsortedSegmentSum),
    backendName: 'cpu',
    kernelFunc: $4467766cacfe86bc$export$ba7c4d144d85a309
};



// List all kernel configs here
const $d18ee08f3a490ea5$var$kernelConfigs = [
    (0, $b14ccf0770109385$export$f70d36da1c218f84),
    (0, $ep8sG.absConfig),
    (0, $8ab22af32e0a4a26$export$255826ca70737275),
    (0, $2c892ef40794bb4b$export$3f520b71a56c9e70),
    (0, $e8yCG.addConfig),
    (0, $b425d90a3aee84b9$export$ff8000bc6f0313e1),
    (0, $677649d6815f7b0d$export$4e3f081eb1a330fa),
    (0, $f73b719f10282e8f$export$1a8ff634f2df3da6),
    (0, $5eaa7ab354e6d455$export$ec7419fc9ad0069e),
    (0, $f80ee889f51b6cc0$export$21836a5e5fa09eb4),
    (0, $def28fc1ddfc81e6$export$de5cb0ef95dd6700),
    (0, $b64917d0bfd8937f$export$20d424616c76166),
    (0, $b1539910302f7e24$export$159d632e3ff13624),
    (0, $68efd56ecaa2a8cc$export$c53c7ab019edb8a0),
    (0, $4cde3dd073a9865a$export$e9ce1ba75fc9b746),
    (0, $294b48d57f4be026$export$6c901824a23e6150),
    (0, $05891176cdea595d$export$5a9c81d240244392),
    (0, $39b08ff2cf4451c5$export$1eeb8780807d0508),
    (0, $44da085f019c43ff$export$ac3f8709351ab225),
    (0, $1f35b9edc36b4c50$export$d0dd993198185538),
    (0, $bebb632d95232ffb$export$df2dc5c7a755e418),
    (0, $ff970e8b72618187$export$44e08e19f97e5513),
    (0, $a5ee11d42e3cdab3$export$af9f0093738840fb),
    (0, $eYl2h.bitwiseAndConfig),
    (0, $7ea71d038e9fa638$export$8f7b2ec0c6f08fb2),
    (0, $7LLjQ.castConfig),
    (0, $bs8Xr.ceilConfig),
    (0, $c5d6f1913dfc8e32$export$f7ee8f07ce0ff4e1),
    (0, $bwMVz.complexConfig),
    (0, $87d587b356a80841$export$a4817d2978acc054),
    (0, $3284dfd9bccede0e$export$c8cf96dae25282e5),
    (0, $33872f5c298aaa1e$export$4a39bf13b4378042),
    (0, $dade238f5679ecff$export$7a95f55d2d2e7d24),
    (0, $722475b93e7c95c1$export$19bbc19fff1ed26f),
    (0, $b58c6a43c853326f$export$1fe590fda0829040),
    (0, $b340a29664bf88e4$export$6dce9169640850fa),
    (0, $496df5d9afb80a4e$export$40ece1caaaf084b2),
    (0, $2fe16efd3eb6e9a3$export$ff099a1da5235a7e),
    (0, $b1da2977c365559b$export$c5824052b09ba0ed),
    (0, $58d1da7fb0ce0e2f$export$f7086edcf0050c7f),
    (0, $2b7776615377f1a7$export$db50d81ed60c5a35),
    (0, $c183c106eb8bd9c9$export$2f6196f3316e7ed2),
    (0, $ae0ec50f8ecb375d$export$88ba267b84334692),
    (0, $9b9ad46d1ca8b599$export$9c5b88dcb1d2008b),
    (0, $6a85a496ede50ffd$export$240667804b7c390e),
    (0, $7cedee963cdb4153$export$30bc0ac3775583fc),
    (0, $9f3a7c95dbedc6ea$export$55d12409e744bebe),
    (0, $5a545717cb4130f7$export$56dc5d812a22748f),
    (0, $ce5997a72f98f884$export$36d3c11f61a8891a),
    (0, $e3a2dd483556a94c$export$cf83abe0e8c87ce8),
    (0, $2298b328a5a5f387$export$42e4451417dc5ea0),
    (0, $9f27439c9338b537$export$917213cafa72964b),
    (0, $759eb846f36195b3$export$40bbf341885a23b7),
    (0, $4be447923eb31a08$export$b990686634ee3cce),
    (0, $16517782b7faebb3$export$59bb07dd04647a1d),
    (0, $diO4l.equalConfig),
    (0, $edff38cc088851e0$export$d044ffef16079bd),
    (0, $2ANRn.expConfig),
    (0, $0b6b0257239c58c8$export$86341ba0ce5d8e60),
    (0, $jqUkN.expm1Config),
    (0, $77ce7c1b5ddb5067$export$a4d564e380763c78),
    (0, $bdf4b57d5da6d47b$export$c953bf474b2bde62),
    (0, $fbd52558676e3b9b$export$c9ec83cb23304466),
    (0, $Jvx9v.floorConfig),
    (0, $hj1kT.floorDivConfig),
    (0, $b6afd83b60286675$export$5b64efa829ddf94e),
    (0, $a9847ceda5fe8a2b$export$58481cc3409b412c),
    (0, $a06520e232579790$export$d9700eb1c7f5c969),
    (0, $7ed7af8bd9715f59$export$b1bd3139c91d8765),
    (0, $2Apjw.greaterConfig),
    (0, $9yHtq.greaterEqualConfig),
    (0, $lcqBv.identityConfig),
    (0, $3b641a0bf3018f44$export$dc267425bf21b465),
    (0, $235b2b9db5d2b70b$export$ddfc128c2801add7),
    (0, $11497eb05465f370$export$4d45c8f7b9ffdaf1),
    (0, $c0416a3848ef67c2$export$bc383b82282e9b5a),
    (0, $bb3401b9dd825cdd$export$d58ff790c765c1f0),
    (0, $81269e84b542f8c3$export$aa04ab963fdf437f),
    (0, $jJNGT.lessConfig),
    (0, $bwE16.lessEqualConfig),
    (0, $122cc50bc128045c$export$46b96f742c70959b),
    (0, $2La7K.logConfig),
    (0, $ee3c26bd1169e7e2$export$c458b9e5ba980198),
    (0, $056738b846498d67$export$257f1e82e69113fb),
    (0, $bb112960a25f6f59$export$68e2dd0840056271),
    (0, $5174880ee5e49c61$export$ce04b6546987ef43),
    (0, $5fb5287420fc28a8$export$6fb124d5a6994734),
    (0, $23cd881c4c246ca0$export$99a62fc039d7aca0),
    (0, $58aa85413e381680$export$7d79147246e312bb),
    (0, $IzL7H.maximumConfig),
    (0, $e2748a173d2f1c22$export$45c8263b38f19e33),
    (0, $ca717d02dc939f15$export$91a8fc5da39ec855),
    (0, $00fa40be13b7a7ae$export$5201426bb10bd5eb),
    (0, $3517385ef9fb6fed$export$e01a7f8dbee29127),
    (0, $3b3bd6ffa8f2b85e$export$a069ee2247a7d1ce),
    (0, $b07629fe4b620241$export$b934af0ccd0cdbe1),
    (0, $607dca927c5b7886$export$3cd9f9a31b38cf18),
    (0, $g7Z3x.minimumConfig),
    (0, $52a1408aeb9b50a1$export$2cfd6c6c7daeb5fc),
    (0, $3fc24f552a0915ee$export$9037685a81180a9c),
    (0, $8f79578744798103$export$ad960e364767f0e2),
    (0, $gQOIy.multiplyConfig),
    (0, $9NYY4.negConfig),
    (0, $f4ff792a02508805$export$549561cd158f260a),
    (0, $a696c23123d1a1c6$export$906b8fb32c570e9d),
    (0, $24b5d40d5edfce43$export$4c00b682f309701d),
    (0, $QHoEG.notEqualConfig),
    (0, $44f905ed69e018a1$export$dde5645b472b80b2),
    (0, $3c4b1991b10ffa22$export$d8d7015eb6ab37d0),
    (0, $d179715647152c30$export$1645fa8803aa1f86),
    (0, $13bfb533800aba7e$export$b0317e720bfd61fc),
    (0, $e36d36d9ca93da24$export$b823d49786719761),
    (0, $773ba90ab8dc0ec9$export$a5c4a9b694579636),
    (0, $86TES.prodConfig),
    (0, $47bd6afe6165e2de$export$cebb8a7d5932c7e8),
    (0, $7060501ccfc71f65$export$91ddd62a193b9401),
    (0, $98d97a53a03299e7$export$792f441e33dcdf26),
    (0, $2671920d83c701bb$export$361c4075706e31c2),
    (0, $linqd.realConfig),
    (0, $fcdf7b6c6c29ead5$export$15c5d6176b30b9a6),
    (0, $981426d1e647fa0c$export$412a6b66203fdf72),
    (0, $7f66a4e69afa64f7$export$731f9199bde068eb),
    (0, $5ac347e14aab137b$export$92c30890ad649d53),
    (0, $abec025db4e7e093$export$cfa02e698602aca2),
    (0, $710bd27f18995ad8$export$a37a56137abc1357),
    (0, $ed793dce20bde8c7$export$51f84ca614e84763),
    (0, $875d50731a97d18d$export$2b6a92caba113b89),
    (0, $689d299d6f52112b$export$2b08d810b5090fe1),
    (0, $ee67674342f7db4c$export$cab6a4e8d2ed8e8d),
    (0, $3dc2d66652355d94$export$44ba8c83417ab668),
    (0, $753e2a9e9d924dd2$export$6c09e3291f636503),
    (0, $GbeHD.rsqrtConfig),
    (0, $db0ec83ab150be86$export$573371744f044f5),
    (0, $458e2d8d2874e7ed$export$4b437b1a1aa6472f),
    (0, $b56f03df723757c7$export$7ff911e710ee72fc),
    (0, $2a2e616f33963128$export$8afc8558705c1a39),
    (0, $dMdBj.sigmoidConfig),
    (0, $736c054017f2c822$export$9c0fb3eb2124ceb7),
    (0, $9dde46fa3f6ed86e$export$d993ec4e5c253b66),
    (0, $1c4439d8070292f4$export$b92766b47f18ac85),
    (0, $aYBRE.sliceConfig),
    (0, $de7b841569048a6d$export$c022691f23e2ee69),
    (0, $f3c31fdd8d5dc76c$export$d9bcfe553d12d9e3),
    (0, $3ce545c737188b0f$export$2f85417863d2050b),
    (0, $c243d83383333266$export$818286c593224d1a),
    (0, $482d46c5d8b3e9ae$export$eb106efc10374803),
    (0, $a51aa4776ba67347$export$51e7224ae14d7f78),
    (0, $f55251d4b2187fa4$export$73fa0270f28b9555),
    (0, $1436facfc2e176db$export$7bc088f8ad44ef99),
    (0, $9375987d2a00708c$export$317be24be3af9ea0),
    (0, $2a43t.sqrtConfig),
    (0, $5a8ac69b1a7144d0$export$7c77bece4d51efc4),
    (0, $4QLZo.squaredDifferenceConfig),
    (0, $hRUGg.staticRegexReplaceConfig),
    (0, $fc9ede3899fe8565$export$c42ffaf52eb2647),
    (0, $aa510b8b1a9fefdb$export$81773633114187bd),
    (0, $7a7ddc64c1997f40$export$35e13284eed34c22),
    (0, $636664dcd843ab75$export$c51cbbd627a96532),
    (0, $9bbac82dfb7e21b5$export$a88a78b2b233f507),
    (0, $aT9VE.subConfig),
    (0, $81f3b02b80a24eb0$export$47edea402251c258),
    (0, $355a87237ac9d0fd$export$97648844df7611f3),
    (0, $26f4c37aceea00f2$export$a2fc7de1a1e4eee0),
    (0, $ad5df25f6a7881cc$export$2819813ce8339b64),
    (0, $1540c7dcb955050c$export$a5a9f8050ba7f41e),
    (0, $4871f991199a1256$export$cffaee31213314ce),
    (0, $ef9830f1a35dd770$export$1c7a3de6335954ed),
    (0, $EOTYn.transposeConfig),
    (0, $8dfa572c1ff0579f$export$78cd70dcd092910e),
    (0, $ae53f289fee9ec8b$export$d06292128cae50d6),
    (0, $4467766cacfe86bc$export$71e3626a4ca29968),
    (0, $d17f130fbd54f8ad$export$15368df05c479e41)
];
for (const kernelConfig of $d18ee08f3a490ea5$var$kernelConfigs)(0, $i64bB.registerKernel)(kernelConfig);




/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // All exports from this package should be in base.
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // base.ts is the webgl backend without auto kernel registration.

var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Import webgl flags.
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
const $49455ae585dac16a$var$contexts = {};
const $49455ae585dac16a$var$WEBGL_ATTRIBUTES = {
    alpha: false,
    antialias: false,
    premultipliedAlpha: false,
    preserveDrawingBuffer: false,
    depth: false,
    stencil: false,
    failIfMajorPerformanceCaveat: true
};
function $49455ae585dac16a$export$c5302deff3a07920(webGLVersion) {
    delete $49455ae585dac16a$var$contexts[webGLVersion];
}
function $49455ae585dac16a$export$4b8d5e1525955c68(webGLVersion, gl) {
    $49455ae585dac16a$var$contexts[webGLVersion] = gl;
}
function $49455ae585dac16a$export$c7a808a518b9a146(webGLVersion, customCanvas) {
    if (!(webGLVersion in $49455ae585dac16a$var$contexts) || customCanvas != null) {
        const newCtx = $49455ae585dac16a$var$getWebGLRenderingContext(webGLVersion, customCanvas);
        if (newCtx !== null) $49455ae585dac16a$var$contexts[webGLVersion] = newCtx;
        else {
            console.log('Could not get context for WebGL version', webGLVersion);
            return null;
        }
    }
    const gl = $49455ae585dac16a$var$contexts[webGLVersion];
    if (gl == null || gl.isContextLost()) {
        delete $49455ae585dac16a$var$contexts[webGLVersion];
        return $49455ae585dac16a$export$c7a808a518b9a146(webGLVersion);
    }
    gl.disable(gl.DEPTH_TEST);
    gl.disable(gl.STENCIL_TEST);
    gl.disable(gl.BLEND);
    gl.disable(gl.DITHER);
    gl.disable(gl.POLYGON_OFFSET_FILL);
    gl.disable(gl.SAMPLE_COVERAGE);
    gl.enable(gl.SCISSOR_TEST);
    gl.enable(gl.CULL_FACE);
    gl.cullFace(gl.BACK);
    return $49455ae585dac16a$var$contexts[webGLVersion];
}
function $49455ae585dac16a$var$createCanvas(webGLVersion) {
    // Use canvas element for Safari, since its offscreen canvas does not support
    // fencing.
    if (!(0, $i64bB.env)().getBool('IS_SAFARI') && typeof OffscreenCanvas !== 'undefined' && webGLVersion === 2) return new OffscreenCanvas(300, 150);
    else if (typeof document !== 'undefined') return document.createElement('canvas');
    else throw new Error('Cannot create a canvas in this context');
}
function $49455ae585dac16a$var$getWebGLRenderingContext(webGLVersion, customCanvas) {
    if (webGLVersion !== 1 && webGLVersion !== 2) throw new Error('Cannot get WebGL rendering context, WebGL is disabled.');
    const canvas = customCanvas == null ? $49455ae585dac16a$var$createCanvas(webGLVersion) : customCanvas;
    canvas.addEventListener('webglcontextlost', (ev)=>{
        ev.preventDefault();
        delete $49455ae585dac16a$var$contexts[webGLVersion];
    }, false);
    if ((0, $i64bB.env)().getBool('SOFTWARE_WEBGL_ENABLED')) $49455ae585dac16a$var$WEBGL_ATTRIBUTES.failIfMajorPerformanceCaveat = false;
    if (webGLVersion === 1) return(// tslint:disable-next-line
    canvas.getContext('webgl', $49455ae585dac16a$var$WEBGL_ATTRIBUTES) || canvas.getContext('experimental-webgl', $49455ae585dac16a$var$WEBGL_ATTRIBUTES));
    return canvas.getContext('webgl2', $49455ae585dac16a$var$WEBGL_ATTRIBUTES);
}


/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
var $c7d2caaa716d42d2$export$81d5c79efa1086f2;
(function(PackingScheme) {
    /**
     * All values in a single texel are densely packed without any constraints.
     *
     * This is how the shader encodes a tensor with shape = [2, 3, 4]
     * (indices are [batch, row, col]).
     *
     * 000|001   010|011   020|021
     * -------   -------   -------
     * 002|003   012|013   022|023
     *
     * 100|101   110|111   120|121
     * -------   -------   -------
     * 102|103   112|113   122|123
     *
     */ PackingScheme[PackingScheme["DENSE"] = 0] = "DENSE";
    /**
     * Single texels contain only values from the same batch, and from adjacent
     * rows and columns.
     *
     * This is how the shader encodes a tensor with shape = [2, 3, 5]
     * (indices are [batch, row, col]).
     *
     * 000|001   002|003   004|xxx   020|021   022|023   024|xxx
     * -------   -------   -------   -------   -------   -------
     * 010|011   012|013   014|xxx   xxx|xxx   xxx|xxx   xxx|xxx
     *
     * 100|101   102|103   104|xxx   120|121   122|123   124|xxx
     * -------   -------   -------   -------   -------   -------
     * 110|111   112|113   114|xxx   xxx|xxx   xxx|xxx   xxx|xxx
     *
     */ PackingScheme[PackingScheme["SHARED_BATCH"] = 1] = "SHARED_BATCH";
})($c7d2caaa716d42d2$export$81d5c79efa1086f2 || ($c7d2caaa716d42d2$export$81d5c79efa1086f2 = {}));
var $c7d2caaa716d42d2$export$6bf4bd1b6beb0bfd;
(function(TextureUsage) {
    TextureUsage[TextureUsage["RENDER"] = 0] = "RENDER";
    TextureUsage[TextureUsage["UPLOAD"] = 1] = "UPLOAD";
    TextureUsage[TextureUsage["PIXELS"] = 2] = "PIXELS";
    TextureUsage[TextureUsage["DOWNLOAD"] = 3] = "DOWNLOAD";
})($c7d2caaa716d42d2$export$6bf4bd1b6beb0bfd || ($c7d2caaa716d42d2$export$6bf4bd1b6beb0bfd = {}));
var $c7d2caaa716d42d2$export$bde70ab3692e385c;
(function(PhysicalTextureType) {
    PhysicalTextureType[PhysicalTextureType["UNPACKED_FLOAT16"] = 0] = "UNPACKED_FLOAT16";
    PhysicalTextureType[PhysicalTextureType["UNPACKED_FLOAT32"] = 1] = "UNPACKED_FLOAT32";
    PhysicalTextureType[PhysicalTextureType["PACKED_4X1_UNSIGNED_BYTE"] = 2] = "PACKED_4X1_UNSIGNED_BYTE";
    PhysicalTextureType[PhysicalTextureType["PACKED_2X2_FLOAT32"] = 3] = "PACKED_2X2_FLOAT32";
    PhysicalTextureType[PhysicalTextureType["PACKED_2X2_FLOAT16"] = 4] = "PACKED_2X2_FLOAT16";
})($c7d2caaa716d42d2$export$bde70ab3692e385c || ($c7d2caaa716d42d2$export$bde70ab3692e385c = {}));
function $c7d2caaa716d42d2$export$95fb8493b25f77a4(rows, columns) {
    return [
        columns,
        rows
    ];
}
function $c7d2caaa716d42d2$export$9427543edb6e188a(matrixSize, channelsPerTexture) {
    return matrixSize * channelsPerTexture;
}
function $c7d2caaa716d42d2$export$bb1043669f490840(rows, columns) {
    return [
        columns * 4,
        rows
    ];
}
function $c7d2caaa716d42d2$export$2cc7cc972aa2533d(shape) {
    const size = (0, $i64bB.util).sizeFromShape(shape);
    const texelsNeeded = Math.ceil(size / 4);
    return (0, $i64bB.util).sizeToSquarishShape(texelsNeeded);
}
function $c7d2caaa716d42d2$export$4c2d3be5c837367c(unpackedSize, channelsPerTexture) {
    if (unpackedSize % channelsPerTexture !== 0) throw new Error(`unpackedSize (${unpackedSize}) must be a multiple of ` + `${channelsPerTexture}`);
    return unpackedSize / channelsPerTexture;
}
function $c7d2caaa716d42d2$export$ccf59730cad262bd(unpackedArray, matrix, channels) {
    const requiredSize = unpackedArray.length * channels / 4;
    if (matrix.length < requiredSize) throw new Error(`matrix length (${matrix.length}) must be >= ${requiredSize}`);
    let dst = 0;
    for(let src = 0; src < unpackedArray.length; src += 4)for(let c = 0; c < channels; c++)matrix[dst++] = unpackedArray[src + c];
}
function $c7d2caaa716d42d2$export$2754e02fa98f5582(rows, columns) {
    return [
        Math.max(1, Math.ceil(columns / 2)),
        Math.max(1, Math.ceil(rows / 2))
    ];
}
function $c7d2caaa716d42d2$export$12d4e412f879b1d4(rows, columns) {
    const [w, h] = $c7d2caaa716d42d2$export$2754e02fa98f5582(rows, columns);
    return w * h * 4;
}
function $c7d2caaa716d42d2$export$129d92ae6e74c416(// tslint:disable-next-line:no-any
gl, textureHalfFloatExtension) {
    // tslint:disable-next-line:no-any
    const glany = gl;
    let internalFormatFloat;
    let internalFormatHalfFloat;
    let internalFormatPackedHalfFloat;
    let internalFormatPackedFloat;
    let textureFormatFloat;
    let downloadTextureFormat;
    let downloadUnpackNumChannels;
    let defaultNumChannels;
    let textureTypeHalfFloat;
    let textureTypeFloat;
    if ((0, $i64bB.env)().getNumber('WEBGL_VERSION') === 2) {
        internalFormatFloat = glany.R32F;
        internalFormatHalfFloat = glany.R16F;
        internalFormatPackedHalfFloat = glany.RGBA16F;
        internalFormatPackedFloat = glany.RGBA32F;
        textureFormatFloat = glany.RED;
        downloadUnpackNumChannels = 4;
        defaultNumChannels = 1;
        textureTypeHalfFloat = glany.HALF_FLOAT;
        textureTypeFloat = glany.FLOAT;
        downloadTextureFormat = glany.RGBA8;
    } else {
        internalFormatFloat = gl.RGBA;
        internalFormatHalfFloat = gl.RGBA;
        internalFormatPackedHalfFloat = gl.RGBA;
        internalFormatPackedFloat = glany.RGBA;
        textureFormatFloat = gl.RGBA;
        downloadUnpackNumChannels = 4;
        defaultNumChannels = 4;
        textureTypeHalfFloat = textureHalfFloatExtension != null ? textureHalfFloatExtension.HALF_FLOAT_OES : null;
        textureTypeFloat = gl.FLOAT;
        downloadTextureFormat = gl.RGBA;
    }
    return {
        internalFormatFloat: internalFormatFloat,
        internalFormatHalfFloat: internalFormatHalfFloat,
        internalFormatPackedHalfFloat: internalFormatPackedHalfFloat,
        internalFormatPackedFloat: internalFormatPackedFloat,
        textureFormatFloat: textureFormatFloat,
        downloadTextureFormat: downloadTextureFormat,
        downloadUnpackNumChannels: downloadUnpackNumChannels,
        defaultNumChannels: defaultNumChannels,
        textureTypeHalfFloat: textureTypeHalfFloat,
        textureTypeFloat: textureTypeFloat
    };
}


function $03fc80a4a4cef09e$export$7642ac97981532b8(gl, func) {
    const returnValue = func();
    if ((0, $i64bB.env)().getBool('DEBUG')) $03fc80a4a4cef09e$var$checkWebGLError(gl);
    return returnValue;
}
function $03fc80a4a4cef09e$var$checkWebGLError(gl) {
    const error = gl.getError();
    if (error !== gl.NO_ERROR) throw new Error('WebGL Error: ' + $03fc80a4a4cef09e$export$ee3c7ff80964e13e(gl, error));
}
// https://en.wikipedia.org/wiki/Half-precision_floating-point_format
const $03fc80a4a4cef09e$var$MIN_FLOAT16 = 5.96e-8;
const $03fc80a4a4cef09e$var$MAX_FLOAT16 = 65504;
function $03fc80a4a4cef09e$export$829768a5b7625879(num) {
    if ((0, $i64bB.env)().getBool('WEBGL_RENDER_FLOAT32_ENABLED') || num === 0 || $03fc80a4a4cef09e$var$MIN_FLOAT16 < Math.abs(num) && Math.abs(num) < $03fc80a4a4cef09e$var$MAX_FLOAT16) return true;
    return false;
}
function $03fc80a4a4cef09e$export$ee3c7ff80964e13e(gl, status) {
    switch(status){
        case gl.NO_ERROR:
            return 'NO_ERROR';
        case gl.INVALID_ENUM:
            return 'INVALID_ENUM';
        case gl.INVALID_VALUE:
            return 'INVALID_VALUE';
        case gl.INVALID_OPERATION:
            return 'INVALID_OPERATION';
        case gl.INVALID_FRAMEBUFFER_OPERATION:
            return 'INVALID_FRAMEBUFFER_OPERATION';
        case gl.OUT_OF_MEMORY:
            return 'OUT_OF_MEMORY';
        case gl.CONTEXT_LOST_WEBGL:
            return 'CONTEXT_LOST_WEBGL';
        default:
            return `Unknown error code ${status}`;
    }
}
function $03fc80a4a4cef09e$export$3a5e7a891790a26c(gl, extensionName) {
    return $03fc80a4a4cef09e$var$throwIfNull(gl, ()=>gl.getExtension(extensionName), 'Extension "' + extensionName + '" not supported on this browser.');
}
function $03fc80a4a4cef09e$export$4ca6704ce1875929(gl, vertexShaderSource) {
    const vertexShader = $03fc80a4a4cef09e$var$throwIfNull(gl, ()=>gl.createShader(gl.VERTEX_SHADER), 'Unable to create vertex WebGLShader.');
    $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.shaderSource(vertexShader, vertexShaderSource));
    $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.compileShader(vertexShader));
    if (gl.getShaderParameter(vertexShader, gl.COMPILE_STATUS) === false) {
        console.log(gl.getShaderInfoLog(vertexShader));
        throw new Error('Failed to compile vertex shader.');
    }
    return vertexShader;
}
function $03fc80a4a4cef09e$export$a8ab0e04b20572c0(gl, fragmentShaderSource) {
    const fragmentShader = $03fc80a4a4cef09e$var$throwIfNull(gl, ()=>gl.createShader(gl.FRAGMENT_SHADER), 'Unable to create fragment WebGLShader.');
    $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.shaderSource(fragmentShader, fragmentShaderSource));
    $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.compileShader(fragmentShader));
    if ((0, $i64bB.env)().get('ENGINE_COMPILE_ONLY')) return fragmentShader;
    if (gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS) === false) {
        $03fc80a4a4cef09e$export$f7b23987b58d218(fragmentShaderSource, gl.getShaderInfoLog(fragmentShader));
        throw new Error('Failed to compile fragment shader.');
    }
    return fragmentShader;
}
const $03fc80a4a4cef09e$var$lineNumberRegex = /ERROR: [0-9]+:([0-9]+):/g;
function $03fc80a4a4cef09e$export$f7b23987b58d218(shaderSource, shaderInfoLog) {
    const lineNumberRegexResult = $03fc80a4a4cef09e$var$lineNumberRegex.exec(shaderInfoLog);
    if (lineNumberRegexResult == null) {
        console.log(`Couldn't parse line number in error: ${shaderInfoLog}`);
        console.log(shaderSource);
        return;
    }
    const lineNumber = +lineNumberRegexResult[1];
    const shaderLines = shaderSource.split('\n');
    const pad = shaderLines.length.toString().length + 2;
    const linesWithLineNumbers = shaderLines.map((line, lineNumber)=>(0, $i64bB.util).rightPad((lineNumber + 1).toString(), pad) + line);
    let maxLineLength = 0;
    for(let i = 0; i < linesWithLineNumbers.length; i++)maxLineLength = Math.max(linesWithLineNumbers[i].length, maxLineLength);
    const beforeErrorLines = linesWithLineNumbers.slice(0, lineNumber - 1);
    const errorLine = linesWithLineNumbers.slice(lineNumber - 1, lineNumber);
    const afterErrorLines = linesWithLineNumbers.slice(lineNumber);
    console.log(beforeErrorLines.join('\n'));
    console.log(shaderInfoLog.split('\n')[0]);
    console.log(`%c ${(0, $i64bB.util).rightPad(errorLine[0], maxLineLength)}`, 'border:1px solid red; background-color:#e3d2d2; color:#a61717');
    console.log(afterErrorLines.join('\n'));
}
function $03fc80a4a4cef09e$export$327d24a04cd0dc17(gl) {
    return $03fc80a4a4cef09e$var$throwIfNull(gl, ()=>gl.createProgram(), 'Unable to create WebGLProgram.');
}
function $03fc80a4a4cef09e$export$d879afae78b531a5(gl, program) {
    $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.linkProgram(program));
    if ((0, $i64bB.env)().get('ENGINE_COMPILE_ONLY')) return;
    if (gl.getProgramParameter(program, gl.LINK_STATUS) === false) {
        console.log(gl.getProgramInfoLog(program));
        throw new Error('Failed to link vertex and fragment shaders.');
    }
}
function $03fc80a4a4cef09e$export$e2dfaf93681cde16(gl, program) {
    $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.validateProgram(program));
    if (gl.getProgramParameter(program, gl.VALIDATE_STATUS) === false) {
        console.log(gl.getProgramInfoLog(program));
        throw new Error('Shader program validation failed.');
    }
}
function $03fc80a4a4cef09e$export$3871e1d1e28ac6cb(gl, data) {
    const buffer = $03fc80a4a4cef09e$var$throwIfNull(gl, ()=>gl.createBuffer(), 'Unable to create WebGLBuffer');
    $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.bindBuffer(gl.ARRAY_BUFFER, buffer));
    $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.bufferData(gl.ARRAY_BUFFER, data, gl.STATIC_DRAW));
    return buffer;
}
function $03fc80a4a4cef09e$export$f9b26b97ca2b25e9(gl, data) {
    const buffer = $03fc80a4a4cef09e$var$throwIfNull(gl, ()=>gl.createBuffer(), 'Unable to create WebGLBuffer');
    $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, buffer));
    $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, data, gl.STATIC_DRAW));
    return buffer;
}
function $03fc80a4a4cef09e$export$45c2ce5fe87dcf0f() {
    if ((0, $i64bB.env)().getNumber('WEBGL_VERSION') === 2) return 1;
    return 4;
}
function $03fc80a4a4cef09e$export$37b981a8c575f415(gl) {
    return $03fc80a4a4cef09e$var$throwIfNull(gl, ()=>gl.createTexture(), 'Unable to create WebGLTexture.');
}
function $03fc80a4a4cef09e$export$3543950a45505554(width, height) {
    const maxTextureSize = (0, $i64bB.env)().getNumber('WEBGL_MAX_TEXTURE_SIZE');
    if (width <= 0 || height <= 0) {
        const requested = `[${width}x${height}]`;
        throw new Error('Requested texture size ' + requested + ' is invalid.');
    }
    if (width > maxTextureSize || height > maxTextureSize) {
        const requested = `[${width}x${height}]`;
        const max = `[${maxTextureSize}x${maxTextureSize}]`;
        throw new Error('Requested texture size ' + requested + ' greater than WebGL maximum on this browser / GPU ' + max + '.');
    }
}
function $03fc80a4a4cef09e$export$366d1e3e32f5a700(gl) {
    return $03fc80a4a4cef09e$var$throwIfNull(gl, ()=>gl.createFramebuffer(), 'Unable to create WebGLFramebuffer.');
}
function $03fc80a4a4cef09e$export$4c858b3c953a013f(gl, program, attribute, buffer, arrayEntriesPerItem, itemStrideInBytes, itemOffsetInBytes) {
    const loc = gl.getAttribLocation(program, attribute);
    if (loc === -1) // The GPU compiler decided to strip out this attribute because it's unused,
    // thus no need to bind.
    return false;
    $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.bindBuffer(gl.ARRAY_BUFFER, buffer));
    $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.vertexAttribPointer(loc, arrayEntriesPerItem, gl.FLOAT, false, itemStrideInBytes, itemOffsetInBytes));
    $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.enableVertexAttribArray(loc));
    return true;
}
function $03fc80a4a4cef09e$export$520907fe7b2c7a2d(gl, texture, textureUnit) {
    $03fc80a4a4cef09e$var$validateTextureUnit(gl, textureUnit);
    $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.activeTexture(gl.TEXTURE0 + textureUnit));
    $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.bindTexture(gl.TEXTURE_2D, texture));
}
function $03fc80a4a4cef09e$export$9bed01c46f4769b6(gl, textureUnit) {
    $03fc80a4a4cef09e$var$validateTextureUnit(gl, textureUnit);
    $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.activeTexture(gl.TEXTURE0 + textureUnit));
    $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.bindTexture(gl.TEXTURE_2D, null));
}
function $03fc80a4a4cef09e$export$748cafa2cdf50d8(gl, program, uniformName) {
    return $03fc80a4a4cef09e$var$throwIfNull(gl, ()=>gl.getUniformLocation(program, uniformName), 'uniform "' + uniformName + '" not present in program.');
}
function $03fc80a4a4cef09e$export$d27256445dd7e8dd(gl, program, uniformName) {
    return gl.getUniformLocation(program, uniformName);
}
function $03fc80a4a4cef09e$export$f9ffd997f3c8b98f(gl, texture, uniformSamplerLocation, textureUnit) {
    $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>$03fc80a4a4cef09e$export$520907fe7b2c7a2d(gl, texture, textureUnit));
    $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.uniform1i(uniformSamplerLocation, textureUnit));
}
function $03fc80a4a4cef09e$export$2e43f6b5d575e241(gl) {
    $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.bindFramebuffer(gl.FRAMEBUFFER, null));
    $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.viewport(0, 0, gl.canvas.width, gl.canvas.height));
    $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.scissor(0, 0, gl.canvas.width, gl.canvas.height));
}
function $03fc80a4a4cef09e$export$4e154f0d71f19013(gl, texture, framebuffer) {
    $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer));
    $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0));
}
function $03fc80a4a4cef09e$export$d3c809959a3c24fa(gl, framebuffer) {
    $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer));
    $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, null, 0));
}
function $03fc80a4a4cef09e$export$ca09b577525e6519(gl) {
    const status = gl.checkFramebufferStatus(gl.FRAMEBUFFER);
    if (status !== gl.FRAMEBUFFER_COMPLETE) throw new Error('Error binding framebuffer: ' + $03fc80a4a4cef09e$export$851c7fde035f5bf6(gl, status));
}
function $03fc80a4a4cef09e$export$851c7fde035f5bf6(gl, status) {
    switch(status){
        case gl.FRAMEBUFFER_INCOMPLETE_ATTACHMENT:
            return 'FRAMEBUFFER_INCOMPLETE_ATTACHMENT';
        case gl.FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT:
            return 'FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT';
        case gl.FRAMEBUFFER_INCOMPLETE_DIMENSIONS:
            return 'FRAMEBUFFER_INCOMPLETE_DIMENSIONS';
        case gl.FRAMEBUFFER_UNSUPPORTED:
            return 'FRAMEBUFFER_UNSUPPORTED';
        default:
            return `unknown error ${status}`;
    }
}
function $03fc80a4a4cef09e$var$throwIfNull(gl, returnTOrNull, failureMessage) {
    const tOrNull = $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>returnTOrNull());
    if (tOrNull == null) throw new Error(failureMessage);
    return tOrNull;
}
function $03fc80a4a4cef09e$var$validateTextureUnit(gl, textureUnit) {
    const maxTextureUnit = gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS - 1;
    const glTextureUnit = textureUnit + gl.TEXTURE0;
    if (glTextureUnit < gl.TEXTURE0 || glTextureUnit > maxTextureUnit) {
        const textureUnitRange = `[gl.TEXTURE0, gl.TEXTURE${maxTextureUnit}]`;
        throw new Error(`textureUnit must be in ${textureUnitRange}.`);
    }
}
function $03fc80a4a4cef09e$export$4dfd7bc0667970e0(shape, dimsToSkip = 2) {
    return (0, $i64bB.util).sizeFromShape(shape.slice(0, shape.length - dimsToSkip));
}
function $03fc80a4a4cef09e$export$e8f6c350b57b8270(shape) {
    if (shape.length === 0) throw Error('Cannot get rows and columns of an empty shape array.');
    return [
        shape.length > 1 ? shape[shape.length - 2] : 1,
        shape[shape.length - 1]
    ];
}
function $03fc80a4a4cef09e$export$f944c0101b593a79(shape) {
    let shapeAs3D = [
        1,
        1,
        1
    ];
    const isScalar = shape.length === 0 || shape.length === 1 && shape[0] === 1;
    if (!isScalar) shapeAs3D = [
        $03fc80a4a4cef09e$export$4dfd7bc0667970e0(shape),
        ...$03fc80a4a4cef09e$export$e8f6c350b57b8270(shape)
    ];
    return shapeAs3D;
}
function $03fc80a4a4cef09e$export$80bf57c6927be1d9(logShape, isPacked = false) {
    let maxTexSize = (0, $i64bB.env)().getNumber('WEBGL_MAX_TEXTURE_SIZE');
    let maxSizeForNarrowTex = (0, $i64bB.env)().getNumber('WEBGL_MAX_SIZE_FOR_NARROW_TEXTURE');
    if (maxSizeForNarrowTex === Infinity && (0, $i64bB.env)().getBool('WEBGL_AUTO_SQUARIFY_NARROW_TEXTURE_SHAPE')) maxSizeForNarrowTex = maxTexSize / 2;
    if (isPacked) {
        maxTexSize = maxTexSize * 2;
        maxSizeForNarrowTex = maxSizeForNarrowTex * 2;
        // This logic ensures we accurately count the number of packed texels needed
        // to accommodate the tensor. We can only pack values in the same texel if
        // they are from adjacent pairs of rows/cols within the same batch. So if a
        // tensor has 3 rows, we pretend it has 4 rows in order to account for the
        // fact that the texels containing the third row are half empty.
        logShape = logShape.map((d, i)=>i >= logShape.length - 2 ? (0, $i64bB.util).nearestLargerEven(logShape[i]) : logShape[i]);
        // Packed texture height is at least 2 (the channel height of a single
        // texel).
        if (logShape.length === 1) logShape = [
            2,
            logShape[0]
        ];
    }
    // If logical shape is 2, we don't squeeze, since we want to match physical.
    if (logShape.length !== 2) {
        const squeezeResult = (0, $i64bB.util).squeezeShape(logShape);
        logShape = squeezeResult.newShape;
    }
    let size = (0, $i64bB.util).sizeFromShape(logShape);
    let textureShape = null;
    if (logShape.length <= 1 && size <= maxTexSize) textureShape = [
        1,
        size
    ];
    else if (logShape.length === 2 && logShape[0] <= maxTexSize && logShape[1] <= maxTexSize) textureShape = logShape;
    else if (logShape.length === 3 && logShape[0] * logShape[1] <= maxTexSize && logShape[2] <= maxTexSize) textureShape = [
        logShape[0] * logShape[1],
        logShape[2]
    ];
    else if (logShape.length === 3 && logShape[0] <= maxTexSize && logShape[1] * logShape[2] <= maxTexSize) textureShape = [
        logShape[0],
        logShape[1] * logShape[2]
    ];
    else if (logShape.length === 4 && logShape[0] * logShape[1] * logShape[2] <= maxTexSize && logShape[3] <= maxTexSize) textureShape = [
        logShape[0] * logShape[1] * logShape[2],
        logShape[3]
    ];
    else if (logShape.length === 4 && logShape[0] <= maxTexSize && logShape[1] * logShape[2] * logShape[3] <= maxTexSize) textureShape = [
        logShape[0],
        logShape[1] * logShape[2] * logShape[3]
    ];
    // true if one edge length is 1 (1 or 2, if packed), while another edge
    // length exceeds maxSizeForNarrowTex.
    const isLongNarrowTex = textureShape != null && Math.max(...textureShape) > maxSizeForNarrowTex && Math.min(...textureShape) <= (isPacked ? 2 : 1) && Math.min(...textureShape) > 0;
    if (textureShape == null || isLongNarrowTex) {
        if (isPacked) {
            // For packed textures size equals the number of channels required to
            // accommodate the texture data. However in order to squarify such that
            // inner dimensions stay even, we rewrite size to equal the number of
            // texels. Then in the return statement we rehydrate the squarified
            // dimensions to channel units.
            const batchDim = $03fc80a4a4cef09e$export$4dfd7bc0667970e0(logShape);
            let rows = 2, cols = 2;
            if (logShape.length) [rows, cols] = $03fc80a4a4cef09e$export$e8f6c350b57b8270(logShape);
            size = batchDim * (rows / 2) * (cols / 2);
            textureShape = (0, $i64bB.util).sizeToSquarishShape(size).map((d)=>d * 2);
        } else textureShape = (0, $i64bB.util).sizeToSquarishShape(size);
    }
    return textureShape;
}
function $03fc80a4a4cef09e$var$isEven(n) {
    return n % 2 === 0;
}
function $03fc80a4a4cef09e$export$951b388203a0422d(shape1, shape2) {
    shape1 = shape1.slice(-2);
    shape2 = shape2.slice(-2);
    if ((0, $i64bB.util).arraysEqual(shape1, shape2)) return true;
    if (!shape1.length || !shape2.length) return true;
    if (shape1[0] === 0 || shape1[1] === 0 || shape2[0] === 0 || shape2[1] === 0) return true;
    if (shape1.length !== shape2.length) {
        const shape1Cols = shape1[shape1.length - 1];
        const shape2Cols = shape2[shape2.length - 1];
        if (shape1Cols === shape2Cols) return true;
        if ($03fc80a4a4cef09e$var$isEven(shape1Cols) && $03fc80a4a4cef09e$var$isEven(shape2Cols) && (shape1[0] === 1 || shape2[0] === 1)) return true;
    }
    return shape1[1] === shape2[1] && $03fc80a4a4cef09e$var$isEven(shape1[0]) && $03fc80a4a4cef09e$var$isEven(shape2[0]);
}
// We cache webgl params because the environment gets reset between
// unit tests and we don't want to constantly query the WebGLContext for
// MAX_TEXTURE_SIZE.
let $03fc80a4a4cef09e$var$MAX_TEXTURE_SIZE;
let $03fc80a4a4cef09e$var$MAX_TEXTURES_IN_SHADER;
function $03fc80a4a4cef09e$export$9dbf32263e41ec5(webGLVersion) {
    if ($03fc80a4a4cef09e$var$MAX_TEXTURE_SIZE == null) {
        const gl = (0, $49455ae585dac16a$export$c7a808a518b9a146)(webGLVersion);
        $03fc80a4a4cef09e$var$MAX_TEXTURE_SIZE = gl.getParameter(gl.MAX_TEXTURE_SIZE);
    }
    return $03fc80a4a4cef09e$var$MAX_TEXTURE_SIZE;
}
function $03fc80a4a4cef09e$export$3bb3363a1d77ce11() {
    $03fc80a4a4cef09e$var$MAX_TEXTURE_SIZE = null;
}
function $03fc80a4a4cef09e$export$295b7d11bb89e671() {
    $03fc80a4a4cef09e$var$MAX_TEXTURES_IN_SHADER = null;
}
function $03fc80a4a4cef09e$export$ce91baf6aebded89(webGLVersion) {
    if ($03fc80a4a4cef09e$var$MAX_TEXTURES_IN_SHADER == null) {
        const gl = (0, $49455ae585dac16a$export$c7a808a518b9a146)(webGLVersion);
        $03fc80a4a4cef09e$var$MAX_TEXTURES_IN_SHADER = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
    }
    // We cap at 16 to avoid spurious runtime "memory exhausted" error.
    return Math.min(16, $03fc80a4a4cef09e$var$MAX_TEXTURES_IN_SHADER);
}
function $03fc80a4a4cef09e$export$8a49d28f4bb7b8a0(webGLVersion) {
    if (webGLVersion === 0) return 0;
    let queryTimerVersion;
    const gl = (0, $49455ae585dac16a$export$c7a808a518b9a146)(webGLVersion);
    if ($03fc80a4a4cef09e$export$4f402f57c05c9ec3(gl, 'EXT_disjoint_timer_query_webgl2') && webGLVersion === 2) queryTimerVersion = 2;
    else if ($03fc80a4a4cef09e$export$4f402f57c05c9ec3(gl, 'EXT_disjoint_timer_query')) queryTimerVersion = 1;
    else queryTimerVersion = 0;
    return queryTimerVersion;
}
function $03fc80a4a4cef09e$export$4f402f57c05c9ec3(gl, extensionName) {
    const ext = gl.getExtension(extensionName);
    return ext != null;
}
function $03fc80a4a4cef09e$export$9232c111e2230c00(webGLVersion) {
    try {
        const gl = (0, $49455ae585dac16a$export$c7a808a518b9a146)(webGLVersion);
        if (gl != null) return true;
    } catch (e) {
        console.log('Error when getting WebGL context: ', e);
        return false;
    }
    return false;
}
function $03fc80a4a4cef09e$export$d571cb60e9b5ec74(webGLVersion) {
    if (webGLVersion === 0) return false;
    const gl = (0, $49455ae585dac16a$export$c7a808a518b9a146)(webGLVersion);
    if (webGLVersion === 1) {
        if (!$03fc80a4a4cef09e$export$4f402f57c05c9ec3(gl, 'OES_texture_float')) return false;
    } else {
        if (!$03fc80a4a4cef09e$export$4f402f57c05c9ec3(gl, 'EXT_color_buffer_float')) return false;
    }
    const isFrameBufferComplete = $03fc80a4a4cef09e$var$createFloatTextureAndBindToFramebuffer(gl);
    return isFrameBufferComplete;
}
function $03fc80a4a4cef09e$export$9cd61c8662dbbc66(webGLVersion) {
    if (webGLVersion === 0) return false;
    const gl = (0, $49455ae585dac16a$export$c7a808a518b9a146)(webGLVersion);
    if (webGLVersion === 1) {
        if (!$03fc80a4a4cef09e$export$4f402f57c05c9ec3(gl, 'OES_texture_float')) return false;
        if (!$03fc80a4a4cef09e$export$4f402f57c05c9ec3(gl, 'WEBGL_color_buffer_float')) return false;
    } else {
        if ($03fc80a4a4cef09e$export$4f402f57c05c9ec3(gl, 'EXT_color_buffer_float')) return $03fc80a4a4cef09e$var$createFloatTextureAndBindToFramebuffer(gl);
        const COLOR_BUFFER_HALF_FLOAT = 'EXT_color_buffer_half_float';
        if ($03fc80a4a4cef09e$export$4f402f57c05c9ec3(gl, COLOR_BUFFER_HALF_FLOAT)) {
            const textureHalfFloatExtension = gl.getExtension(COLOR_BUFFER_HALF_FLOAT);
            return $03fc80a4a4cef09e$var$createHalfFloatTextureAndBindToFramebuffer(gl, textureHalfFloatExtension);
        }
        return false;
    }
    const isFrameBufferComplete = $03fc80a4a4cef09e$var$createFloatTextureAndBindToFramebuffer(gl);
    return isFrameBufferComplete;
}
function $03fc80a4a4cef09e$var$createFloatTextureAndBindToFramebuffer(gl) {
    const texConfig = (0, $c7d2caaa716d42d2$export$129d92ae6e74c416)(gl);
    const texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, texture);
    const width = 1;
    const height = 1;
    gl.texImage2D(gl.TEXTURE_2D, 0, texConfig.internalFormatFloat, width, height, 0, texConfig.textureFormatFloat, texConfig.textureTypeFloat, null);
    const frameBuffer = gl.createFramebuffer();
    gl.bindFramebuffer(gl.FRAMEBUFFER, frameBuffer);
    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);
    const isFrameBufferComplete = gl.checkFramebufferStatus(gl.FRAMEBUFFER) === gl.FRAMEBUFFER_COMPLETE;
    gl.bindTexture(gl.TEXTURE_2D, null);
    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
    gl.deleteTexture(texture);
    gl.deleteFramebuffer(frameBuffer);
    return isFrameBufferComplete;
}
function $03fc80a4a4cef09e$var$createHalfFloatTextureAndBindToFramebuffer(// tslint:disable-next-line:no-any
gl, textureHalfFloatExtension) {
    const texConfig = (0, $c7d2caaa716d42d2$export$129d92ae6e74c416)(gl, textureHalfFloatExtension);
    const texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, texture);
    const width = 1;
    const height = 1;
    gl.texImage2D(gl.TEXTURE_2D, 0, texConfig.internalFormatHalfFloat, width, height, 0, texConfig.textureFormatFloat, texConfig.textureTypeHalfFloat, null);
    const frameBuffer = gl.createFramebuffer();
    gl.bindFramebuffer(gl.FRAMEBUFFER, frameBuffer);
    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);
    const isFrameBufferComplete = gl.checkFramebufferStatus(gl.FRAMEBUFFER) === gl.FRAMEBUFFER_COMPLETE;
    gl.bindTexture(gl.TEXTURE_2D, null);
    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
    gl.deleteTexture(texture);
    gl.deleteFramebuffer(frameBuffer);
    return isFrameBufferComplete;
}
function $03fc80a4a4cef09e$export$77efcdc20b17e5f2(webGLVersion) {
    if (webGLVersion !== 2) return false;
    const gl = (0, $49455ae585dac16a$export$c7a808a518b9a146)(webGLVersion);
    // tslint:disable-next-line:no-any
    const isEnabled = gl.fenceSync != null;
    return isEnabled;
}
function $03fc80a4a4cef09e$export$1412c17b2531581a(tensor, opName) {
    if (!Array.isArray(tensor)) tensor = [
        tensor
    ];
    tensor.forEach((t)=>{
        if (t != null) (0, $i64bB.util).assert(t.dtype !== 'complex64', ()=>`${opName} does not support complex64 tensors ` + 'in the WebGL backend.');
    });
}


const $24148a3b20d2a21a$var$ENV = (0, $i64bB.env)();
/**
 * This file contains WebGL-specific flag registrations.
 */ /**
 * True if WebGL is supported.
 */ $24148a3b20d2a21a$var$ENV.registerFlag('HAS_WEBGL', ()=>$24148a3b20d2a21a$var$ENV.getNumber('WEBGL_VERSION') > 0);
/** 0: No WebGL, 1: WebGL 1.0, 2: WebGL 2.0. */ $24148a3b20d2a21a$var$ENV.registerFlag('WEBGL_VERSION', ()=>{
    if ((0, $03fc80a4a4cef09e$export$9232c111e2230c00)(2)) return 2;
    else if ((0, $03fc80a4a4cef09e$export$9232c111e2230c00)(1)) return 1;
    return 0;
});
/** Whether to check for numerical representation problems. */ $24148a3b20d2a21a$var$ENV.registerFlag('WEBGL_CHECK_NUMERICAL_PROBLEMS', ()=>false);
$24148a3b20d2a21a$var$ENV.registerFlag('WEBGL_BUFFER_SUPPORTED', ()=>$24148a3b20d2a21a$var$ENV.get('WEBGL_VERSION') === 2);
/** Whether the WebGL backend will sometimes forward ops to the CPU. */ $24148a3b20d2a21a$var$ENV.registerFlag('WEBGL_CPU_FORWARD', ()=>true);
/** Whether the WebGL backend will always use f16 textures for rendering. */ $24148a3b20d2a21a$var$ENV.registerFlag('WEBGL_FORCE_F16_TEXTURES', ()=>false);
/** Whether to turn all packing related flags on. */ $24148a3b20d2a21a$var$ENV.registerFlag('WEBGL_PACK', ()=>$24148a3b20d2a21a$var$ENV.getBool('HAS_WEBGL'));
/** Whether we will pack the batchnormalization op. */ $24148a3b20d2a21a$var$ENV.registerFlag('WEBGL_PACK_NORMALIZATION', ()=>$24148a3b20d2a21a$var$ENV.getBool('WEBGL_PACK'));
/** Whether we will pack the clip op. */ $24148a3b20d2a21a$var$ENV.registerFlag('WEBGL_PACK_CLIP', ()=>$24148a3b20d2a21a$var$ENV.getBool('WEBGL_PACK'));
/** Whether we will pack the depthwise conv op. */ $24148a3b20d2a21a$var$ENV.registerFlag('WEBGL_PACK_DEPTHWISECONV', ()=>$24148a3b20d2a21a$var$ENV.getBool('WEBGL_PACK'));
/** Whether we will pack binary ops. */ $24148a3b20d2a21a$var$ENV.registerFlag('WEBGL_PACK_BINARY_OPERATIONS', ()=>$24148a3b20d2a21a$var$ENV.getBool('WEBGL_PACK'));
/** Whether we will pack unary ops. */ $24148a3b20d2a21a$var$ENV.registerFlag('WEBGL_PACK_UNARY_OPERATIONS', ()=>$24148a3b20d2a21a$var$ENV.getBool('WEBGL_PACK'));
/** Whether we will pack array ops. */ $24148a3b20d2a21a$var$ENV.registerFlag('WEBGL_PACK_ARRAY_OPERATIONS', ()=>$24148a3b20d2a21a$var$ENV.getBool('WEBGL_PACK'));
/** Whether we will pack image ops. */ $24148a3b20d2a21a$var$ENV.registerFlag('WEBGL_PACK_IMAGE_OPERATIONS', ()=>$24148a3b20d2a21a$var$ENV.getBool('WEBGL_PACK'));
/** Whether we will pack reduce ops. */ $24148a3b20d2a21a$var$ENV.registerFlag('WEBGL_PACK_REDUCE', ()=>$24148a3b20d2a21a$var$ENV.getBool('WEBGL_PACK'));
/** Whether packed WebGL kernels lazily unpack their outputs. */ $24148a3b20d2a21a$var$ENV.registerFlag('WEBGL_LAZILY_UNPACK', ()=>$24148a3b20d2a21a$var$ENV.getBool('WEBGL_PACK'));
/** Whether we will use the im2col algorithm to speed up convolutions. */ $24148a3b20d2a21a$var$ENV.registerFlag('WEBGL_CONV_IM2COL', ()=>$24148a3b20d2a21a$var$ENV.getBool('WEBGL_PACK'));
/** Whether we will pack conv2dTranspose op. */ $24148a3b20d2a21a$var$ENV.registerFlag('WEBGL_PACK_CONV2DTRANSPOSE', ()=>$24148a3b20d2a21a$var$ENV.getBool('WEBGL_PACK'));
/** The maximum texture dimension. */ $24148a3b20d2a21a$var$ENV.registerFlag('WEBGL_MAX_TEXTURE_SIZE', ()=>(0, $03fc80a4a4cef09e$export$9dbf32263e41ec5)($24148a3b20d2a21a$var$ENV.getNumber('WEBGL_VERSION')));
/** The maximum texture dimension. */ $24148a3b20d2a21a$var$ENV.registerFlag('WEBGL_MAX_TEXTURES_IN_SHADER', ()=>(0, $03fc80a4a4cef09e$export$ce91baf6aebded89)($24148a3b20d2a21a$var$ENV.getNumber('WEBGL_VERSION')));
/**
 * The disjoint_query_timer extension version.
 * 0: disabled, 1: EXT_disjoint_timer_query, 2:
 * EXT_disjoint_timer_query_webgl2.
 * In Firefox with WebGL 2.0,
 * EXT_disjoint_timer_query_webgl2 is not available, so we must use the
 * WebGL 1.0 extension.
 */ $24148a3b20d2a21a$var$ENV.registerFlag('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION', ()=>{
    const webGLVersion = $24148a3b20d2a21a$var$ENV.getNumber('WEBGL_VERSION');
    if (webGLVersion === 0) return 0;
    return (0, $03fc80a4a4cef09e$export$8a49d28f4bb7b8a0)(webGLVersion);
});
/**
 * Whether the timer object from the disjoint_query_timer extension gives
 * timing information that is reliable.
 */ $24148a3b20d2a21a$var$ENV.registerFlag('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE', ()=>$24148a3b20d2a21a$var$ENV.getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION') > 0 && !(0, $i64bB.device_util).isMobile());
/**
 * Whether the device is physically capable of rendering to float32 textures.
 */ $24148a3b20d2a21a$var$ENV.registerFlag('WEBGL_RENDER_FLOAT32_CAPABLE', ()=>(0, $03fc80a4a4cef09e$export$d571cb60e9b5ec74)($24148a3b20d2a21a$var$ENV.getNumber('WEBGL_VERSION')));
/**
 * Whether rendering to float32 textures is enabled. If disabled, renders to
 * float16 textures.
 */ $24148a3b20d2a21a$var$ENV.registerFlag('WEBGL_RENDER_FLOAT32_ENABLED', ()=>{
    return $24148a3b20d2a21a$var$ENV.getBool('WEBGL_FORCE_F16_TEXTURES') ? false : $24148a3b20d2a21a$var$ENV.getBool('WEBGL_RENDER_FLOAT32_CAPABLE');
});
/**
 * Whether downloading float textures is enabled (16 or 32 bit). If disabled,
 * uses IEEE 754 encoding of the float32 values to 4 uint8 when downloading.
 */ $24148a3b20d2a21a$var$ENV.registerFlag('WEBGL_DOWNLOAD_FLOAT_ENABLED', ()=>(0, $03fc80a4a4cef09e$export$9cd61c8662dbbc66)($24148a3b20d2a21a$var$ENV.getNumber('WEBGL_VERSION')));
/** Whether the fence API is available. */ $24148a3b20d2a21a$var$ENV.registerFlag('WEBGL_FENCE_API_ENABLED', ()=>(0, $03fc80a4a4cef09e$export$77efcdc20b17e5f2)($24148a3b20d2a21a$var$ENV.getNumber('WEBGL_VERSION')));
/**
 * Tensors with size <= than this will be uploaded as uniforms, not textures.
 */ $24148a3b20d2a21a$var$ENV.registerFlag('WEBGL_SIZE_UPLOAD_UNIFORM', ()=>{
    // Use uniform uploads only when 32bit floats are supported. In
    // 16bit
    // environments there are problems with comparing a 16bit texture value
    // with a 32bit uniform value.
    const useUniforms = $24148a3b20d2a21a$var$ENV.getBool('WEBGL_RENDER_FLOAT32_ENABLED');
    return useUniforms ? 4 : 0;
});
/**
 * If the total number of bytes allocated on the GPU is greater than this
 * number, we will aggressively delete textures upon disposal with
 * gl.deleteMatrixTexture, rather than making them available for reuse.
 *
 * Default value -1 indicates that we will never aggressively delete textures.
 */ $24148a3b20d2a21a$var$ENV.registerFlag('WEBGL_DELETE_TEXTURE_THRESHOLD', ()=>{
    return -1;
}, (threshold)=>{
    if (!(typeof threshold === 'number')) throw new Error('WEBGL_DELETE_TEXTURE_THRESHOLD must be a number but ' + `got ${threshold}.`);
    if (threshold < 0 && threshold !== -1) throw new Error(`WEBGL_DELETE_TEXTURE_THRESHOLD must be -1 (indicating never ` + `delete) or at least 0, but got ${threshold}.`);
});
/**
 * Trigger a manual GL command flush if the threshold of time has passed since
 * previous Kernel execution. This can be useful for Andorid device where GL
 * command flush are delayed un til the end of javascript task. This value is
 * measured in millisecond. Typically you want to set this value to close to 1.
 *
 * Default value 1 for mobile chrome, and -1 for rest cases. -1 indicates that
 * we will not enforce manual flush and depend on system default flush schedule.
 */ $24148a3b20d2a21a$var$ENV.registerFlag('WEBGL_FLUSH_THRESHOLD', ()=>{
    return (0, $i64bB.device_util).isMobile() ? 1 : -1;
}, (threshold)=>{
    if (!(typeof threshold === 'number')) throw new Error('WEBGL_FLUSH_THRESHOLD must be a number but got ' + `${threshold}.`);
    if (threshold < 0 && threshold !== -1) throw new Error(`WEBGL_FLUSH_THRESHOLD must be -1 (indicating never ` + `manual flush) or at least 0, but got ${threshold}.`);
});
/**
 * Threshold for input tensor size that determines whether WebGL backend will
 * delegate computation to CPU.
 *
 * Default value is 128.
 */ $24148a3b20d2a21a$var$ENV.registerFlag('CPU_HANDOFF_SIZE_THRESHOLD', ()=>128);
/** Whether we will use shapes uniforms. */ $24148a3b20d2a21a$var$ENV.registerFlag('WEBGL_USE_SHAPES_UNIFORMS', ()=>false);
/**
 * Threshold for last dimension of input tensor that determines whether
 * WebGL backend for the Top K op will delegate computation to CPU. If input
 * is smaller than threshold then CPU will be used
 *
 * Default value is 100000.
 */ $24148a3b20d2a21a$var$ENV.registerFlag('TOPK_LAST_DIM_CPU_HANDOFF_SIZE_THRESHOLD', ()=>100000);
/**
 * Threshold for K that determines whether
 * WebGL backend for the Top K op will delegate computation to CPU. If k
 * is larger than threshold then CPU will be used
 *
 * Default value is 128.
 */ $24148a3b20d2a21a$var$ENV.registerFlag('TOPK_K_CPU_HANDOFF_THRESHOLD', ()=>128);
/** Whether we will use the experimental conv op. */ $24148a3b20d2a21a$var$ENV.registerFlag('WEBGL_EXP_CONV', ()=>false);
/**
 * If the device performance is low or if no hardware GPU is available, whether
 * software WebGL will be used.
 */ $24148a3b20d2a21a$var$ENV.registerFlag('SOFTWARE_WEBGL_ENABLED', ()=>$24148a3b20d2a21a$var$ENV.getBool('IS_TEST'));
/**
 * For narrow texture (physical height or physical width is 1), if the length of
 * any texture edges exceed the threshold, the texture will be reshaped to be
 * more squarish.
 *
 * This flag is used to help some GPUs that could not provide correct
 * interpolations for long skinny triangles. We found Mali GPU probably has this
 * problem: https://github.com/tensorflow/tfjs/issues/6775.
 */ $24148a3b20d2a21a$var$ENV.registerFlag('WEBGL_MAX_SIZE_FOR_NARROW_TEXTURE', ()=>Infinity);
/**
 * If the flag is set to true, the max size of the narrow texture will be auto
 * computed and it will be considerred as a threshold to reshape the narrow
 * texture to be more squarish.
 *
 * This flag is used to help some GPUs that could not provide correct
 * interpolations for long skinny triangles. We found Mali GPU probably has this
 * problem: https://github.com/tensorflow/tfjs/issues/6775.
 */ $24148a3b20d2a21a$var$ENV.registerFlag('WEBGL_AUTO_SQUARIFY_NARROW_TEXTURE_SHAPE', ()=>false);
/**
 * Whether to use the customized isnan. It's only useful for webgl2 since webgl1
 * doesn't have the builtin isnan.
 */ $24148a3b20d2a21a$var$ENV.registerFlag('WEBGL2_ISNAN_CUSTOM', ()=>false);
/** Experimental flag, whether enter compile only phase. */ $24148a3b20d2a21a$var$ENV.registerFlag('ENGINE_COMPILE_ONLY', ()=>false);



var $i64bB = parcelRequire("i64bB");

/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
function $29bc34f3341b4730$export$3ebf4a18d6319f7a() {
    let version;
    let attribute;
    let varyingVs;
    let varyingFs;
    let texture2D;
    let output;
    let defineOutput;
    let defineSpecialNaN;
    let defineSpecialInf;
    let defineRound;
    if ((0, $i64bB.env)().getNumber('WEBGL_VERSION') === 2) {
        version = '#version 300 es';
        attribute = 'in';
        varyingVs = 'out';
        varyingFs = 'in';
        texture2D = 'texture';
        output = 'outputColor';
        defineOutput = 'out vec4 outputColor;';
        // Use custom isnan definition to work across differences between
        // implementations on various platforms. While this should happen in ANGLE
        // we still see differences between android and windows (on chrome) when
        // using isnan directly. Since WebGL2 supports uint type and
        // floatBitsToUinT built-in function, we could implment isnan following
        // IEEE 754 rules.
        // NaN defination in IEEE 754-1985 is :
        //   - sign = either 0 or 1.
        //   - biased exponent = all 1 bits.
        //   - fraction = anything except all 0 bits (since all 0 bits represents
        //   infinity).
        // https://en.wikipedia.org/wiki/IEEE_754-1985#Representation_of_non-numbers
        defineSpecialNaN = (0, $i64bB.env)().getBool('WEBGL2_ISNAN_CUSTOM') ? `
      bool isnan_custom(float val) {
        uint floatToUint = floatBitsToUint(val);
        return (floatToUint & 0x7fffffffu) > 0x7f800000u;
      }

      bvec4 isnan_custom(vec4 val) {
        return bvec4(isnan_custom(val.x),
          isnan_custom(val.y), isnan_custom(val.z), isnan_custom(val.w));
      }

      #define isnan(value) isnan_custom(value)
    ` : '';
        // In webgl 2 we do not need to specify a custom isinf so there is no
        // need for a special INFINITY constant.
        defineSpecialInf = ``;
        defineRound = `
      #define round(value) newRound(value)
      int newRound(float value) {
        return int(floor(value + 0.5));
      }

      ivec4 newRound(vec4 value) {
        return ivec4(floor(value + vec4(0.5)));
      }
    `;
    } else {
        version = '';
        attribute = 'attribute';
        varyingVs = 'varying';
        varyingFs = 'varying';
        texture2D = 'texture2D';
        output = 'gl_FragColor';
        defineOutput = '';
        // WebGL1 has no built in isnan so we define one here.
        defineSpecialNaN = `
      #define isnan(value) isnan_custom(value)
      bool isnan_custom(float val) {
        return (val > 0. || val < 1. || val == 0.) ? false : true;
      }
      bvec4 isnan_custom(vec4 val) {
        return bvec4(isnan(val.x), isnan(val.y), isnan(val.z), isnan(val.w));
      }
    `;
        defineSpecialInf = `
      uniform float INFINITY;

      bool isinf(float val) {
        return abs(val) == INFINITY;
      }
      bvec4 isinf(vec4 val) {
        return equal(abs(val), vec4(INFINITY));
      }
    `;
        defineRound = `
      int round(float value) {
        return int(floor(value + 0.5));
      }

      ivec4 round(vec4 value) {
        return ivec4(floor(value + vec4(0.5)));
      }
    `;
    }
    return {
        version: version,
        attribute: attribute,
        varyingVs: varyingVs,
        varyingFs: varyingFs,
        texture2D: texture2D,
        output: output,
        defineOutput: defineOutput,
        defineSpecialNaN: defineSpecialNaN,
        defineSpecialInf: defineSpecialInf,
        defineRound: defineRound
    };
}


/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Please make sure the shaker key in makeShaderKey in gpgpu_math.ts is well
// mapped if any shader source code is changed in this file.

var $i64bB = parcelRequire("i64bB");

/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
function $30e89c7e4234424e$export$53c37f67510642ce(coords, shape, index = 'index') {
    const strides = (0, $i64bB.util).computeStrides(shape);
    return strides.map((stride, i)=>{
        const line1 = `int ${coords[i]} = ${index} / ${stride}`;
        const line2 = i === strides.length - 1 ? `int ${coords[i + 1]} = ${index} - ${coords[i]} * ${stride}` : `index -= ${coords[i]} * ${stride}`;
        return `${line1}; ${line2};`;
    }).join('');
}
function $30e89c7e4234424e$export$ae684ebb20c3e80c(coords, shape, index = 'index') {
    const strides = (0, $i64bB.util).computeStrides(shape);
    return strides.map((_, i)=>{
        const line1 = `int ${coords[i]} = ${index} / outShapeStrides[${i}]`;
        const line2 = i === strides.length - 1 ? `int ${coords[i + 1]} = ${index} - ${coords[i]} * outShapeStrides[${i}]` : `index -= ${coords[i]} * outShapeStrides[${i}]`;
        return `${line1}; ${line2};`;
    }).join('');
}
// Produces GLSL code that computes strides.
function $30e89c7e4234424e$var$symbolicallyComputeStrides(indicesArr, variableName) {
    const numCoords = indicesArr.length;
    const shape = indicesArr.map((d)=>`${variableName}[${d}]`);
    const strides = new Array(numCoords - 1);
    strides[numCoords - 2] = shape[numCoords - 1];
    for(let i = numCoords - 3; i >= 0; --i)strides[i] = `(${strides[i + 1]} * ${shape[i + 1]})`;
    return strides;
}
function $30e89c7e4234424e$export$a1b266196cc2d8ea(coords, variableName, index = 'index') {
    const indicesArray = coords.map((_, i)=>i);
    const strides = $30e89c7e4234424e$var$symbolicallyComputeStrides(indicesArray, variableName);
    return strides.map((_, i)=>{
        const line1 = `int ${coords[i]} = ${index} / ${strides[i]}`;
        const line2 = i === strides.length - 1 ? `int ${coords[i + 1]} = ${index} - ${coords[i]} * ${strides[i]}` : `index -= ${coords[i]} * ${strides[i]}`;
        return `${line1}; ${line2};`;
    }).join('');
}
function $30e89c7e4234424e$var$buildVec(x) {
    if (x.length === 1) return `${x[0]}`;
    return `vec${x.length}(${x.join(',')})`;
}
function $30e89c7e4234424e$export$fe4cd89a7b9cb48b(x, y) {
    if (x.length !== y.length) throw new Error(`Vectors to be dotted must be of the same length -` + `got ${x.length} and ${y.length}`);
    const slices = [];
    const nearestVec4 = Math.floor(x.length / 4);
    const nearestVec4Remainder = x.length % 4;
    for(let i = 0; i < nearestVec4; i++){
        const xSlice = x.slice(i * 4, i * 4 + 4);
        const ySlice = y.slice(i * 4, i * 4 + 4);
        slices.push(`${$30e89c7e4234424e$var$buildVec(xSlice)}, ${$30e89c7e4234424e$var$buildVec(ySlice)}`);
    }
    if (nearestVec4Remainder !== 0) {
        let xSlice = x.slice(nearestVec4 * 4);
        let ySlice = y.slice(nearestVec4 * 4);
        if (xSlice.length === 1) {
            xSlice = xSlice.map((d)=>`float(${d})`);
            ySlice = ySlice.map((d)=>`float(${d})`);
        }
        slices.push(`${$30e89c7e4234424e$var$buildVec(xSlice)}, ${$30e89c7e4234424e$var$buildVec(ySlice)}`);
    }
    return slices.map((d, i)=>`dot(${d})`).join('+');
}
function $30e89c7e4234424e$export$4c68558c71205a01(shape) {
    const strides = (0, $i64bB.util).computeStrides(shape).map((d)=>d.toString());
    return `
  int getFlatIndex(ivec3 coords) {
    return coords.x * ${strides[0]} + coords.y * ${strides[1]} + coords.z;
  }
`;
}
function $30e89c7e4234424e$export$4ec1e3f6361de451() {
    return `
  int getFlatIndex(ivec3 coords) {
    return coords.x * outShapeStrides[0] + coords.y * outShapeStrides[1] + coords.z;
  }
`;
}
const $30e89c7e4234424e$export$2ac12a308a563905 = `
  const float FLOAT_MAX = 1.70141184e38;
  const float FLOAT_MIN = 1.17549435e-38;

  lowp vec4 encode_float(highp float v) {
    if (isnan(v)) {
      return vec4(255, 255, 255, 255);
    }

    highp float av = abs(v);

    if(av < FLOAT_MIN) {
      return vec4(0.0, 0.0, 0.0, 0.0);
    } else if(v > FLOAT_MAX) {
      return vec4(0.0, 0.0, 128.0, 127.0) / 255.0;
    } else if(v < -FLOAT_MAX) {
      return vec4(0.0, 0.0,  128.0, 255.0) / 255.0;
    }

    highp vec4 c = vec4(0,0,0,0);

    highp float e = floor(log2(av));
    highp float m = exp2(fract(log2(av))) - 1.0;

    c[2] = floor(128.0 * m);
    m -= c[2] / 128.0;
    c[1] = floor(32768.0 * m);
    m -= c[1] / 32768.0;
    c[0] = floor(8388608.0 * m);

    highp float ebias = e + 127.0;
    c[3] = floor(ebias / 2.0);
    ebias -= c[3] * 2.0;
    c[2] += floor(ebias) * 128.0;

    c[3] += 128.0 * step(0.0, -v);

    return c / 255.0;
  }
`;


const { getBroadcastDims: $ba2c54ffbda39e8e$var$getBroadcastDims } = (0, $i64bB.backend_util);
function $ba2c54ffbda39e8e$export$37f33ba844563dd2(inputsInfo, outputShape, program) {
    const prefixSnippets = [];
    inputsInfo.forEach((x)=>{
        const size = (0, $i64bB.util).sizeFromShape(x.shapeInfo.logicalShape);
        // Snippet when we decided to upload the values as uniform.
        if (x.shapeInfo.isUniform) prefixSnippets.push(`uniform float ${x.name}${size > 1 ? `[${size}]` : ''};`);
        else {
            prefixSnippets.push(`uniform sampler2D ${x.name};`);
            prefixSnippets.push(`uniform int offset${x.name};`);
        }
        if (program.enableShapeUniforms) {
            const { uniformShape: uniformShape } = $ba2c54ffbda39e8e$export$19e35a0844e29cf9(program.packedInputs, x.shapeInfo.logicalShape, x.shapeInfo.texShape);
            switch(uniformShape.length){
                case 1:
                    prefixSnippets.push(`uniform int ${x.name}Shape;`);
                    break;
                case 2:
                    prefixSnippets.push(`uniform ivec2 ${x.name}Shape;`);
                    break;
                case 3:
                    prefixSnippets.push(`uniform ivec3 ${x.name}Shape;`);
                    break;
                case 4:
                    prefixSnippets.push(`uniform ivec4 ${x.name}Shape;`);
                    break;
                default:
                    break;
            }
            prefixSnippets.push(`uniform ivec2 ${x.name}TexShape;`);
        }
    });
    if (program.enableShapeUniforms) {
        switch(outputShape.logicalShape.length){
            case 1:
                prefixSnippets.push(`uniform int outShape;`);
                break;
            case 2:
                prefixSnippets.push(`uniform ivec2 outShape;`);
                prefixSnippets.push(`uniform int outShapeStrides;`);
                break;
            case 3:
                prefixSnippets.push(`uniform ivec3 outShape;`);
                prefixSnippets.push(`uniform ivec2 outShapeStrides;`);
                break;
            case 4:
                prefixSnippets.push(`uniform ivec4 outShape;`);
                prefixSnippets.push(`uniform ivec3 outShapeStrides;`);
                break;
            default:
                break;
        }
        prefixSnippets.push(`uniform ivec2 outTexShape;`);
    }
    if (program.customUniforms) program.customUniforms.forEach((d)=>{
        prefixSnippets.push(`uniform ${d.type} ${d.name}${d.arrayIndex ? `[${d.arrayIndex}]` : ''};`);
    });
    const inputPrefixSnippet = prefixSnippets.join('\n');
    const inputSamplingSnippet = inputsInfo.map((x)=>$ba2c54ffbda39e8e$var$getInputSamplingSnippet(x, outputShape, program.packedInputs, program.enableShapeUniforms)).join('\n');
    const outTexShape = outputShape.texShape;
    const glsl = (0, $29bc34f3341b4730$export$3ebf4a18d6319f7a)();
    const floatTextureSampleSnippet = $ba2c54ffbda39e8e$var$getFloatTextureSampleSnippet(glsl);
    let outputSamplingSnippet;
    let floatTextureSetOutputSnippet;
    let shaderPrefix = $ba2c54ffbda39e8e$var$getShaderPrefix(glsl);
    if (outputShape.isPacked) {
        outputSamplingSnippet = $ba2c54ffbda39e8e$var$getPackedOutputSamplingSnippet(outputShape.logicalShape, outTexShape, program.enableShapeUniforms);
        floatTextureSetOutputSnippet = $ba2c54ffbda39e8e$var$getFloatTextureSetRGBASnippet(glsl);
    } else {
        outputSamplingSnippet = $ba2c54ffbda39e8e$var$getOutputSamplingSnippet(outputShape.logicalShape, outTexShape, program.enableShapeUniforms);
        floatTextureSetOutputSnippet = $ba2c54ffbda39e8e$var$getFloatTextureSetRSnippet(glsl);
    }
    if (program.packedInputs) shaderPrefix += $ba2c54ffbda39e8e$var$SHADER_PACKED_PREFIX;
    const source = [
        shaderPrefix,
        floatTextureSampleSnippet,
        floatTextureSetOutputSnippet,
        inputPrefixSnippet,
        outputSamplingSnippet,
        inputSamplingSnippet,
        program.userCode
    ].join('\n');
    return source;
}
function $ba2c54ffbda39e8e$var$getSamplerFromInInfo(inInfo, enableShapeUniforms = false) {
    const shape = inInfo.shapeInfo.logicalShape;
    switch(shape.length){
        case 0:
            return $ba2c54ffbda39e8e$var$getSamplerScalar(inInfo, enableShapeUniforms);
        case 1:
            return $ba2c54ffbda39e8e$var$getSampler1D(inInfo, enableShapeUniforms);
        case 2:
            return $ba2c54ffbda39e8e$var$getSampler2D(inInfo, enableShapeUniforms);
        case 3:
            return $ba2c54ffbda39e8e$var$getSampler3D(inInfo, enableShapeUniforms);
        case 4:
            return $ba2c54ffbda39e8e$var$getSampler4D(inInfo, enableShapeUniforms);
        case 5:
            return $ba2c54ffbda39e8e$var$getSampler5D(inInfo);
        case 6:
            return $ba2c54ffbda39e8e$var$getSampler6D(inInfo);
        default:
            throw new Error(`${shape.length}-D input sampling` + ` is not yet supported`);
    }
}
function $ba2c54ffbda39e8e$var$getPackedSamplerFromInInfo(inInfo, enableShapeUniforms) {
    const shape = inInfo.shapeInfo.logicalShape;
    switch(shape.length){
        case 0:
            return $ba2c54ffbda39e8e$var$getPackedSamplerScalar(inInfo);
        case 1:
            return $ba2c54ffbda39e8e$var$getPackedSampler1D(inInfo, enableShapeUniforms);
        case 2:
            return $ba2c54ffbda39e8e$var$getPackedSampler2D(inInfo, enableShapeUniforms);
        case 3:
            return $ba2c54ffbda39e8e$var$getPackedSampler3D(inInfo, enableShapeUniforms);
        default:
            return $ba2c54ffbda39e8e$var$getPackedSamplerND(inInfo, enableShapeUniforms);
    }
}
function $ba2c54ffbda39e8e$var$getInputSamplingSnippet(inInfo, outShapeInfo, usesPackedTextures = false, enableShapeUniforms) {
    let res = '';
    if (usesPackedTextures) res += $ba2c54ffbda39e8e$var$getPackedSamplerFromInInfo(inInfo, enableShapeUniforms);
    else res += $ba2c54ffbda39e8e$var$getSamplerFromInInfo(inInfo, enableShapeUniforms);
    const inShape = inInfo.shapeInfo.logicalShape;
    const outShape = outShapeInfo.logicalShape;
    if (inShape.length <= outShape.length) {
        if (usesPackedTextures) res += $ba2c54ffbda39e8e$var$getPackedSamplerAtOutputCoords(inInfo, outShapeInfo);
        else res += $ba2c54ffbda39e8e$var$getSamplerAtOutputCoords(inInfo, outShapeInfo);
    }
    return res;
}
function $ba2c54ffbda39e8e$var$getPackedOutputSamplingSnippet(outShape, outTexShape, enableShapeUniforms) {
    switch(outShape.length){
        case 0:
            return $ba2c54ffbda39e8e$var$getOutputScalarCoords();
        case 1:
            return $ba2c54ffbda39e8e$var$getOutputPacked1DCoords(outShape, outTexShape, enableShapeUniforms);
        case 2:
            return $ba2c54ffbda39e8e$var$getOutputPacked2DCoords(outShape, outTexShape, enableShapeUniforms);
        case 3:
            return $ba2c54ffbda39e8e$var$getOutputPacked3DCoords(outShape, outTexShape, enableShapeUniforms);
        default:
            return $ba2c54ffbda39e8e$var$getOutputPackedNDCoords(outShape, outTexShape, enableShapeUniforms);
    }
}
function $ba2c54ffbda39e8e$var$getOutputSamplingSnippet(outShape, outTexShape, enableShapeUniforms) {
    switch(outShape.length){
        case 0:
            return $ba2c54ffbda39e8e$var$getOutputScalarCoords();
        case 1:
            return $ba2c54ffbda39e8e$var$getOutput1DCoords(outShape, outTexShape, enableShapeUniforms);
        case 2:
            return $ba2c54ffbda39e8e$var$getOutput2DCoords(outShape, outTexShape, enableShapeUniforms);
        case 3:
            return $ba2c54ffbda39e8e$var$getOutput3DCoords(outShape, outTexShape, enableShapeUniforms);
        case 4:
            return $ba2c54ffbda39e8e$var$getOutput4DCoords(outShape, outTexShape, enableShapeUniforms);
        case 5:
            return $ba2c54ffbda39e8e$var$getOutput5DCoords(outShape, outTexShape);
        case 6:
            return $ba2c54ffbda39e8e$var$getOutput6DCoords(outShape, outTexShape);
        default:
            throw new Error(`${outShape.length}-D output sampling is not yet supported`);
    }
}
function $ba2c54ffbda39e8e$var$getFloatTextureSampleSnippet(glsl) {
    return `
    float sampleTexture(sampler2D textureSampler, vec2 uv) {
      return ${glsl.texture2D}(textureSampler, uv).r;
    }
  `;
}
function $ba2c54ffbda39e8e$var$getFloatTextureSetRSnippet(glsl) {
    return `
    void setOutput(float val) {
      ${glsl.output} = vec4(val, 0, 0, 0);
    }
  `;
}
function $ba2c54ffbda39e8e$var$getFloatTextureSetRGBASnippet(glsl) {
    return `
    void setOutput(vec4 val) {
      ${glsl.output} = val;
    }
  `;
}
function $ba2c54ffbda39e8e$var$getShaderPrefix(glsl) {
    const SHADER_PREFIX = `${glsl.version}
    precision highp float;
    precision highp int;
    precision highp sampler2D;
    ${glsl.varyingFs} vec2 resultUV;
    ${glsl.defineOutput}
    const vec2 halfCR = vec2(0.5, 0.5);

    struct ivec5
    {
      int x;
      int y;
      int z;
      int w;
      int u;
    };

    struct ivec6
    {
      int x;
      int y;
      int z;
      int w;
      int u;
      int v;
    };

    uniform float NAN;
    ${glsl.defineSpecialNaN}
    ${glsl.defineSpecialInf}
    ${glsl.defineRound}

    int imod(int x, int y) {
      return x - y * (x / y);
    }

    int idiv(int a, int b, float sign) {
      int res = a / b;
      int mod = imod(a, b);
      if (sign < 0. && mod != 0) {
        res -= 1;
      }
      return res;
    }

    //Based on the work of Dave Hoskins
    //https://www.shadertoy.com/view/4djSRW
    #define HASHSCALE1 443.8975
    float random(float seed){
      vec2 p = resultUV * seed;
      vec3 p3  = fract(vec3(p.xyx) * HASHSCALE1);
      p3 += dot(p3, p3.yzx + 19.19);
      return fract((p3.x + p3.y) * p3.z);
    }

    ${$ba2c54ffbda39e8e$var$SAMPLE_1D_SNIPPET}
    ${$ba2c54ffbda39e8e$var$SAMPLE_2D_SNIPPET}
    ${$ba2c54ffbda39e8e$var$SAMPLE_3D_SNIPPET}
  `;
    return SHADER_PREFIX;
}
const $ba2c54ffbda39e8e$var$SAMPLE_1D_SNIPPET = `
vec2 uvFromFlat(int texNumR, int texNumC, int index) {
  int texR = index / texNumC;
  int texC = index - texR * texNumC;
  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);
}
vec2 packedUVfrom1D(int texNumR, int texNumC, int index) {
  int texelIndex = index / 2;
  int texR = texelIndex / texNumC;
  int texC = texelIndex - texR * texNumC;
  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);
}
`;
const $ba2c54ffbda39e8e$var$SAMPLE_2D_SNIPPET = `
vec2 packedUVfrom2D(int texelsInLogicalRow, int texNumR,
  int texNumC, int row, int col) {
  int texelIndex = (row / 2) * texelsInLogicalRow + (col / 2);
  int texR = texelIndex / texNumC;
  int texC = texelIndex - texR * texNumC;
  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);
}
`;
const $ba2c54ffbda39e8e$var$SAMPLE_3D_SNIPPET = `
vec2 packedUVfrom3D(int texNumR, int texNumC,
    int texelsInBatch, int texelsInLogicalRow, int b,
    int row, int col) {
  int index = b * texelsInBatch + (row / 2) * texelsInLogicalRow + (col / 2);
  int texR = index / texNumC;
  int texC = index - texR * texNumC;
  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);
}
`;
const $ba2c54ffbda39e8e$var$SHADER_PACKED_PREFIX = `
  float getChannel(vec4 frag, vec2 innerDims) {
    vec2 modCoord = mod(innerDims, 2.);
    return modCoord.x == 0. ?
      (modCoord.y == 0. ? frag.r : frag.g) :
      (modCoord.y == 0. ? frag.b : frag.a);
  }
  float getChannel(vec4 frag, int dim) {
    float modCoord = mod(float(dim), 2.);
    return modCoord == 0. ? frag.r : frag.g;
  }
`;
function $ba2c54ffbda39e8e$var$getOutputScalarCoords() {
    return `
    int getOutputCoords() {
      return 0;
    }
  `;
}
function $ba2c54ffbda39e8e$var$getOutputPacked1DCoords(shape, texShape, enableShapeUniforms) {
    const packedTexShape = [
        Math.ceil(texShape[0] / 2),
        Math.ceil(texShape[1] / 2)
    ];
    if (packedTexShape[0] === 1) {
        if (enableShapeUniforms) return `
      int getOutputCoords() {
        return 2 * int(resultUV.x * ceil(float(outTexShape[1]) / 2.0));
      }
    `;
        return `
      int getOutputCoords() {
        return 2 * int(resultUV.x * ${packedTexShape[1]}.0);
      }
    `;
    }
    if (packedTexShape[1] === 1) {
        if (enableShapeUniforms) return `
      int getOutputCoords() {
        return 2 * int(resultUV.y * ceil(float(outTexShape[0]) / 2.0));
      }
    `;
        return `
      int getOutputCoords() {
        return 2 * int(resultUV.y * ${packedTexShape[0]}.0);
      }
    `;
    }
    if (enableShapeUniforms) return `
    int getOutputCoords() {
      ivec2 packedTexShape = ivec2(ceil(float(outTexShape[0]) / 2.0), ceil(float(outTexShape[1]) / 2.0));
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(packedTexShape[0], packedTexShape[1]));
      return 2 * (resTexRC.x * packedTexShape[1] + resTexRC.y);
    }
  `;
    return `
    int getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(${packedTexShape[0]}, ${packedTexShape[1]}));
      return 2 * (resTexRC.x * ${packedTexShape[1]} + resTexRC.y);
    }
  `;
}
function $ba2c54ffbda39e8e$var$getOutput1DCoords(shape, texShape, enableShapeUniforms) {
    if (texShape[0] === 1) {
        if (enableShapeUniforms) return `
      int getOutputCoords() {
        return int(resultUV.x * float(outTexShape[1]));
      }
    `;
        return `
      int getOutputCoords() {
        return int(resultUV.x * ${texShape[1]}.0);
      }
    `;
    }
    if (texShape[1] === 1) {
        if (enableShapeUniforms) return `
      int getOutputCoords() {
        return int(resultUV.y * float(outTexShape[0]));
      }
    `;
        return `
      int getOutputCoords() {
        return int(resultUV.y * ${texShape[0]}.0);
      }
    `;
    }
    if (enableShapeUniforms) return `
    int getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(outTexShape[0], outTexShape[1]));
      return resTexRC.x * outTexShape[1] + resTexRC.y;
    }
  `;
    return `
    int getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(${texShape[0]}, ${texShape[1]}));
      return resTexRC.x * ${texShape[1]} + resTexRC.y;
    }
  `;
}
function $ba2c54ffbda39e8e$var$getOutputPacked3DCoords(shape, texShape, enableShapeUniforms) {
    if (enableShapeUniforms) return `
    ivec3 getOutputCoords() {
      ivec2 packedTexShape = ivec2(ceil(float(outTexShape[0]) / 2.0), ceil(float(outTexShape[1]) / 2.0));
      int texelsInLogicalRow = int(ceil(float(outShape[2]) / 2.0));
      int texelsInBatch = texelsInLogicalRow * int(ceil(float(outShape[1]) / 2.0));
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(packedTexShape[0], packedTexShape[1]));
      int index = resTexRC.x * packedTexShape[1] + resTexRC.y;

      int b = index / texelsInBatch;
      index -= b * texelsInBatch;

      int r = 2 * (index / texelsInLogicalRow);
      int c = imod(index, texelsInLogicalRow) * 2;

      return ivec3(b, r, c);
    }
  `;
    const packedTexShape = [
        Math.ceil(texShape[0] / 2),
        Math.ceil(texShape[1] / 2)
    ];
    const texelsInLogicalRow = Math.ceil(shape[2] / 2);
    const texelsInBatch = texelsInLogicalRow * Math.ceil(shape[1] / 2);
    return `
    ivec3 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(${packedTexShape[0]}, ${packedTexShape[1]}));
      int index = resTexRC.x * ${packedTexShape[1]} + resTexRC.y;

      int b = index / ${texelsInBatch};
      index -= b * ${texelsInBatch};

      int r = 2 * (index / ${texelsInLogicalRow});
      int c = imod(index, ${texelsInLogicalRow}) * 2;

      return ivec3(b, r, c);
    }
  `;
}
function $ba2c54ffbda39e8e$var$getOutput3DCoords(shape, texShape, enableShapeUniforms) {
    if (enableShapeUniforms) {
        const coordsFromIndexSnippet = $30e89c7e4234424e$export$ae684ebb20c3e80c([
            'r',
            'c',
            'd'
        ], shape);
        return `
  ivec3 getOutputCoords() {
    ivec2 resTexRC = ivec2(resultUV.yx *
                           vec2(outTexShape[0], outTexShape[1]));
    int index = resTexRC.x * outTexShape[1] + resTexRC.y;
    ${coordsFromIndexSnippet}
    return ivec3(r, c, d);
  }
`;
    }
    const coordsFromIndexSnippet = $30e89c7e4234424e$export$53c37f67510642ce([
        'r',
        'c',
        'd'
    ], shape);
    return `
    ivec3 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(${texShape[0]}, ${texShape[1]}));
      int index = resTexRC.x * ${texShape[1]} + resTexRC.y;
      ${coordsFromIndexSnippet}
      return ivec3(r, c, d);
    }
  `;
}
function $ba2c54ffbda39e8e$var$getOutputPackedNDCoords(shape, texShape, enableShapeUniforms) {
    if (enableShapeUniforms) // TODO: support 5d and 6d
    return `
    ivec4 getOutputCoords() {
      ivec2 packedTexShape = ivec2(ceil(float(outTexShape[0]) / 2.0), ceil(float(outTexShape[1]) / 2.0));
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(packedTexShape[0], packedTexShape[1]));
      int index = resTexRC.x * packedTexShape[1] + resTexRC.y;

      int texelsInLogicalRow = int(ceil(float(outShape[3]) / 2.0));
      int texelsInBatch = texelsInLogicalRow * int(ceil(float(outShape[2]) / 2.0));
      int texelsInBatchN = texelsInBatch * outShape[1];

      int b2 = index / texelsInBatchN;
      index -= b2 * texelsInBatchN;

      int b = index / texelsInBatch;
      index -= b * texelsInBatch;

      int r = 2 * (index / texelsInLogicalRow);
      int c = imod(index, texelsInLogicalRow) * 2;

      return ivec4(b2, b, r, c);
    }
  `;
    const packedTexShape = [
        Math.ceil(texShape[0] / 2),
        Math.ceil(texShape[1] / 2)
    ];
    const texelsInLogicalRow = Math.ceil(shape[shape.length - 1] / 2);
    const texelsInBatch = texelsInLogicalRow * Math.ceil(shape[shape.length - 2] / 2);
    let texelsInBatchN = texelsInBatch;
    let batches = ``;
    let coords = 'b, r, c';
    for(let b = 2; b < shape.length - 1; b++){
        texelsInBatchN *= shape[shape.length - b - 1];
        batches = `
      int b${b} = index / ${texelsInBatchN};
      index -= b${b} * ${texelsInBatchN};
    ` + batches;
        coords = `b${b}, ` + coords;
    }
    return `
    ivec${shape.length} getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(${packedTexShape[0]}, ${packedTexShape[1]}));
      int index = resTexRC.x * ${packedTexShape[1]} + resTexRC.y;

      ${batches}

      int b = index / ${texelsInBatch};
      index -= b * ${texelsInBatch};

      int r = 2 * (index / ${texelsInLogicalRow});
      int c = imod(index, ${texelsInLogicalRow}) * 2;

      return ivec${shape.length}(${coords});
    }
  `;
}
function $ba2c54ffbda39e8e$var$getOutput4DCoords(shape, texShape, enableShapeUniforms) {
    if (enableShapeUniforms) {
        const coordsFromIndexSnippet = $30e89c7e4234424e$export$ae684ebb20c3e80c([
            'r',
            'c',
            'd',
            'd2'
        ], shape);
        return `
    ivec4 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
        vec2(outTexShape[0], outTexShape[1]));
      int index = resTexRC.x * outTexShape[1] + resTexRC.y;
      ${coordsFromIndexSnippet}
      return ivec4(r, c, d, d2);
    }
  `;
    }
    const coordsFromIndexSnippet = $30e89c7e4234424e$export$53c37f67510642ce([
        'r',
        'c',
        'd',
        'd2'
    ], shape);
    return `
    ivec4 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
        vec2(${texShape[0]}, ${texShape[1]}));
      int index = resTexRC.x * ${texShape[1]} + resTexRC.y;
      ${coordsFromIndexSnippet}
      return ivec4(r, c, d, d2);
    }
  `;
}
function $ba2c54ffbda39e8e$var$getOutput5DCoords(shape, texShape) {
    const coordsFromIndexSnippet = $30e89c7e4234424e$export$53c37f67510642ce([
        'r',
        'c',
        'd',
        'd2',
        'd3'
    ], shape);
    return `
    ivec5 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx * vec2(${texShape[0]},
                             ${texShape[1]}));

      int index = resTexRC.x * ${texShape[1]} + resTexRC.y;

      ${coordsFromIndexSnippet}

      ivec5 outShape = ivec5(r, c, d, d2, d3);
      return outShape;
    }
  `;
}
function $ba2c54ffbda39e8e$var$getOutput6DCoords(shape, texShape) {
    const coordsFromIndexSnippet = $30e89c7e4234424e$export$53c37f67510642ce([
        'r',
        'c',
        'd',
        'd2',
        'd3',
        'd4'
    ], shape);
    return `
    ivec6 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
        vec2(${texShape[0]}, ${texShape[1]}));
      int index = resTexRC.x * ${texShape[1]} + resTexRC.y;

      ${coordsFromIndexSnippet}

      ivec6 result = ivec6(r, c, d, d2, d3, d4);
      return result;
    }
  `;
}
function $ba2c54ffbda39e8e$var$getOutputPacked2DCoords(shape, texShape, enableShapeUniforms) {
    const packedTexShape = [
        Math.ceil(texShape[0] / 2),
        Math.ceil(texShape[1] / 2)
    ];
    if ((0, $i64bB.util).arraysEqual(shape, texShape)) {
        if (enableShapeUniforms) return `
      ivec2 getOutputCoords() {
        ivec2 packedTexShape = ivec2(ceil(float(outTexShape[0]) / 2.0), ceil(float(outTexShape[1]) / 2.0));
        return 2 * ivec2(resultUV.yx * vec2(packedTexShape[0], packedTexShape[1]));
      }
    `;
        return `
      ivec2 getOutputCoords() {
        return 2 * ivec2(resultUV.yx * vec2(${packedTexShape[0]}, ${packedTexShape[1]}));
      }
    `;
    }
    // texels needed to accommodate a logical row
    const texelsInLogicalRow = Math.ceil(shape[1] / 2);
    /**
     * getOutputCoords
     *
     * resTexRC: The rows and columns of the texels. If you move over one
     * texel to the right in the packed texture, you are moving over one column
     * (not two).
     *
     * index: The texel index
     */ if (enableShapeUniforms) return `
    ivec2 getOutputCoords() {
      ivec2 packedTexShape = ivec2(ceil(float(outTexShape[0]) / 2.0), ceil(float(outTexShape[1]) / 2.0));
      int texelsInLogicalRow = int(ceil(float(outShape[1]) / 2.0));
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(packedTexShape[0], packedTexShape[1]));

      int index = resTexRC.x * packedTexShape[1] + resTexRC.y;
      int r = 2 * (index / texelsInLogicalRow);
      int c = imod(index, texelsInLogicalRow) * 2;

      return ivec2(r, c);
    }
  `;
    return `
    ivec2 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(${packedTexShape[0]}, ${packedTexShape[1]}));

      int index = resTexRC.x * ${packedTexShape[1]} + resTexRC.y;
      int r = 2 * (index / ${texelsInLogicalRow});
      int c = imod(index, ${texelsInLogicalRow}) * 2;

      return ivec2(r, c);
    }
  `;
}
function $ba2c54ffbda39e8e$var$getOutput2DCoords(shape, texShape, enableShapeUniforms) {
    if ((0, $i64bB.util).arraysEqual(shape, texShape)) {
        if (enableShapeUniforms) return `
      ivec2 getOutputCoords() {
        return ivec2(resultUV.yx * vec2(outTexShape[0], outTexShape[1]));
      }
    `;
        return `
      ivec2 getOutputCoords() {
        return ivec2(resultUV.yx * vec2(${texShape[0]}, ${texShape[1]}));
      }
    `;
    }
    if (shape[1] === 1) {
        if (enableShapeUniforms) return `
      ivec2 getOutputCoords() {
        ivec2 resTexRC = ivec2(resultUV.yx *
                               vec2(outTexShape[0], outTexShape[1]));
        int index = resTexRC.x * outTexShape[1] + resTexRC.y;
        return ivec2(index, 0);
      }
    `;
        return `
      ivec2 getOutputCoords() {
        ivec2 resTexRC = ivec2(resultUV.yx *
                               vec2(${texShape[0]}, ${texShape[1]}));
        int index = resTexRC.x * ${texShape[1]} + resTexRC.y;
        return ivec2(index, 0);
      }
    `;
    }
    if (shape[0] === 1) {
        if (enableShapeUniforms) return `
      ivec2 getOutputCoords() {
        ivec2 resTexRC = ivec2(resultUV.yx *
                               vec2(outTexShape[0], outTexShape[1]));
        int index = resTexRC.x * outTexShape[1] + resTexRC.y;
        return ivec2(0, index);
      }
    `;
        return `
      ivec2 getOutputCoords() {
        ivec2 resTexRC = ivec2(resultUV.yx *
                               vec2(${texShape[0]}, ${texShape[1]}));
        int index = resTexRC.x * ${texShape[1]} + resTexRC.y;
        return ivec2(0, index);
      }
    `;
    }
    if (enableShapeUniforms) return `
    ivec2 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(outTexShape[0], outTexShape[1]));
      int index = resTexRC.x * outTexShape[1] + resTexRC.y;
      int r = index / outShape[1];
      int c = index - r * outShape[1];
      return ivec2(r, c);
    }
  `;
    return `
    ivec2 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(${texShape[0]}, ${texShape[1]}));
      int index = resTexRC.x * ${texShape[1]} + resTexRC.y;
      int r = index / ${shape[1]};
      int c = index - r * ${shape[1]};
      return ivec2(r, c);
    }
  `;
}
function $ba2c54ffbda39e8e$var$getFlatOffsetUniformName(texName) {
    return `offset${texName}`;
}
function $ba2c54ffbda39e8e$var$getPackedSamplerScalar(inputInfo) {
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    const glsl = (0, $29bc34f3341b4730$export$3ebf4a18d6319f7a)();
    return `
    vec4 ${funcName}() {
      return ${glsl.texture2D}(${texName}, halfCR);
    }
  `;
}
function $ba2c54ffbda39e8e$var$getSamplerScalar(inputInfo, enableShapeUniforms) {
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    if (inputInfo.shapeInfo.isUniform) return `float ${funcName}() {return ${texName};}`;
    const [texNumR, texNumC] = inputInfo.shapeInfo.texShape;
    if (texNumR === 1 && texNumC === 1) return `
      float ${funcName}() {
        return sampleTexture(${texName}, halfCR);
      }
    `;
    const offset = $ba2c54ffbda39e8e$var$getFlatOffsetUniformName(texName);
    if (enableShapeUniforms) return `
    float ${funcName}() {
      vec2 uv = uvFromFlat(${texName}TexShape[0], ${texName}TexShape[1], ${offset});
      return sampleTexture(${texName}, uv);
    }
  `;
    const [tNumR, tNumC] = inputInfo.shapeInfo.texShape;
    return `
    float ${funcName}() {
      vec2 uv = uvFromFlat(${tNumR}, ${tNumC}, ${offset});
      return sampleTexture(${texName}, uv);
    }
  `;
}
function $ba2c54ffbda39e8e$var$getPackedSampler1D(inputInfo, enableShapeUniforms) {
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    const texShape = inputInfo.shapeInfo.texShape;
    const glsl = (0, $29bc34f3341b4730$export$3ebf4a18d6319f7a)();
    if (enableShapeUniforms) return `
    vec4 ${funcName}(int index) {
      ivec2 packedTexShape = ivec2(ceil(float(${texName}TexShape[0]) / 2.0), ceil(float(${texName}TexShape[1]) / 2.0));
      vec2 uv = packedUVfrom1D(
        packedTexShape[0], packedTexShape[1], index);
      return ${glsl.texture2D}(${texName}, uv);
    }
  `;
    const packedTexShape = [
        Math.ceil(texShape[0] / 2),
        Math.ceil(texShape[1] / 2)
    ];
    return `
    vec4 ${funcName}(int index) {
      vec2 uv = packedUVfrom1D(
        ${packedTexShape[0]}, ${packedTexShape[1]}, index);
      return ${glsl.texture2D}(${texName}, uv);
    }
  `;
}
function $ba2c54ffbda39e8e$var$getSampler1D(inputInfo, enableShapeUniforms) {
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    if (inputInfo.shapeInfo.isUniform) // Uniform arrays will be less than 65505 (no risk of float16 overflow).
    return `
      float ${funcName}(int index) {
        ${$ba2c54ffbda39e8e$var$getUniformSampler(inputInfo)}
      }
    `;
    const texShape = inputInfo.shapeInfo.texShape;
    const tNumR = texShape[0];
    const tNumC = texShape[1];
    if (tNumC === 1 && tNumR === 1) return `
      float ${funcName}(int index) {
        return sampleTexture(${texName}, halfCR);
      }
    `;
    const offset = $ba2c54ffbda39e8e$var$getFlatOffsetUniformName(texName);
    if (tNumC === 1) {
        if (enableShapeUniforms) return `
      float ${funcName}(int index) {
        vec2 uv = vec2(0.5, (float(index + ${offset}) + 0.5) / float(${texName}TexShape[0]));
        return sampleTexture(${texName}, uv);
      }
    `;
        return `
      float ${funcName}(int index) {
        vec2 uv = vec2(0.5, (float(index + ${offset}) + 0.5) / ${tNumR}.0);
        return sampleTexture(${texName}, uv);
      }
    `;
    }
    if (tNumR === 1) {
        if (enableShapeUniforms) return `
      float ${funcName}(int index) {
        vec2 uv = vec2((float(index + ${offset}) + 0.5) / float(${texName}TexShape[1]), 0.5);
        return sampleTexture(${texName}, uv);
      }
    `;
        return `
      float ${funcName}(int index) {
        vec2 uv = vec2((float(index + ${offset}) + 0.5) / ${tNumC}.0, 0.5);
        return sampleTexture(${texName}, uv);
      }
    `;
    }
    if (enableShapeUniforms) return `
    float ${funcName}(int index) {
      vec2 uv = uvFromFlat(${texName}TexShape[0], ${texName}TexShape[1], index + ${offset});
      return sampleTexture(${texName}, uv);
    }
  `;
    return `
    float ${funcName}(int index) {
      vec2 uv = uvFromFlat(${tNumR}, ${tNumC}, index + ${offset});
      return sampleTexture(${texName}, uv);
    }
  `;
}
function $ba2c54ffbda39e8e$var$getPackedSampler2D(inputInfo, enableShapeUniforms) {
    const shape = inputInfo.shapeInfo.logicalShape;
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    const texShape = inputInfo.shapeInfo.texShape;
    const texNumR = texShape[0];
    const texNumC = texShape[1];
    const glsl = (0, $29bc34f3341b4730$export$3ebf4a18d6319f7a)();
    if (texShape != null && (0, $i64bB.util).arraysEqual(shape, texShape)) {
        if (enableShapeUniforms) return `
      vec4 ${funcName}(int row, int col) {
        vec2 uv = (vec2(col, row) + halfCR) / vec2(${texName}TexShape[1], ${texName}TexShape[0]);

        return ${glsl.texture2D}(${texName}, uv);
      }
    `;
        return `
      vec4 ${funcName}(int row, int col) {
        vec2 uv = (vec2(col, row) + halfCR) / vec2(${texNumC}.0, ${texNumR}.0);

        return ${glsl.texture2D}(${texName}, uv);
      }
    `;
    }
    if (enableShapeUniforms) return `
    vec4 ${funcName}(int row, int col) {
      ivec2 packedTexShape = ivec2(ceil(float(${texName}TexShape[0]) / 2.0), ceil(float(${texName}TexShape[1]) / 2.0));
      int valuesPerRow = int(ceil(float(${texName}Shape[1]) / 2.0));
      vec2 uv = packedUVfrom2D(valuesPerRow, packedTexShape[0], packedTexShape[1], row, col);
      return ${glsl.texture2D}(${texName}, uv);
    }
  `;
    const packedTexShape = [
        Math.ceil(texShape[0] / 2),
        Math.ceil(texShape[1] / 2)
    ];
    const valuesPerRow = Math.ceil(shape[1] / 2);
    return `
    vec4 ${funcName}(int row, int col) {
      vec2 uv = packedUVfrom2D(${valuesPerRow}, ${packedTexShape[0]}, ${packedTexShape[1]}, row, col);
      return ${glsl.texture2D}(${texName}, uv);
    }
  `;
}
function $ba2c54ffbda39e8e$var$getSampler2D(inputInfo, enableShapeUniforms) {
    const shape = inputInfo.shapeInfo.logicalShape;
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    const texShape = inputInfo.shapeInfo.texShape;
    if (texShape != null && (0, $i64bB.util).arraysEqual(shape, texShape)) {
        if (enableShapeUniforms) return `
      float ${funcName}(int row, int col) {
        vec2 uv = (vec2(col, row) + halfCR) / vec2(${texName}TexShape[1], ${texName}TexShape[0]);
        return sampleTexture(${texName}, uv);
      }
    `;
        const texNumR = texShape[0];
        const texNumC = texShape[1];
        return `
    float ${funcName}(int row, int col) {
      vec2 uv = (vec2(col, row) + halfCR) / vec2(${texNumC}.0, ${texNumR}.0);
      return sampleTexture(${texName}, uv);
    }
  `;
    }
    const { newShape: newShape, keptDims: keptDims } = (0, $i64bB.util).squeezeShape(shape);
    const squeezedShape = newShape;
    if (squeezedShape.length < shape.length) {
        const newInputInfo = $ba2c54ffbda39e8e$export$5d06d3f48295bf13(inputInfo, squeezedShape);
        const params = [
            'row',
            'col'
        ];
        return `
      ${$ba2c54ffbda39e8e$var$getSamplerFromInInfo(newInputInfo, enableShapeUniforms)}
      float ${funcName}(int row, int col) {
        return ${funcName}(${$ba2c54ffbda39e8e$var$getSqueezedParams(params, keptDims)});
      }
    `;
    }
    if (inputInfo.shapeInfo.isUniform) // Uniform arrays will be less than 65505 (no risk of float16 overflow).
    return `
      float ${funcName}(int row, int col) {
        int index = round(dot(vec2(row, col), vec2(${shape[1]}, 1)));
        ${$ba2c54ffbda39e8e$var$getUniformSampler(inputInfo)}
      }
    `;
    const texNumR = texShape[0];
    const texNumC = texShape[1];
    const offset = $ba2c54ffbda39e8e$var$getFlatOffsetUniformName(texName);
    if (texNumC === 1) {
        // index is used directly as physical (no risk of float16 overflow).
        if (enableShapeUniforms) return `
      float ${funcName}(int row, int col) {
        float index = dot(vec3(row, col, ${offset}), vec3(${texName}Shape[1], 1, 1));
        vec2 uv = vec2(0.5, (index + 0.5) / float(${texName}TexShape[0]));
        return sampleTexture(${texName}, uv);
      }
    `;
        return `
    float ${funcName}(int row, int col) {
      float index = dot(vec3(row, col, ${offset}), vec3(${shape[1]}, 1, 1));
      vec2 uv = vec2(0.5, (index + 0.5) / ${texNumR}.0);
      return sampleTexture(${texName}, uv);
    }
  `;
    }
    if (texNumR === 1) {
        // index is used directly as physical (no risk of float16 overflow).
        if (enableShapeUniforms) return `
      float ${funcName}(int row, int col) {
        float index = dot(vec3(row, col, ${offset}), vec3(${texName}Shape[1], 1, 1));
        vec2 uv = vec2((index + 0.5) / float(${texName}TexShape[1]), 0.5);
        return sampleTexture(${texName}, uv);
      }
    `;
        return `
    float ${funcName}(int row, int col) {
      float index = dot(vec3(row, col, ${offset}), vec3(${shape[1]}, 1, 1));
      vec2 uv = vec2((index + 0.5) / ${texNumC}.0, 0.5);
      return sampleTexture(${texName}, uv);
    }
  `;
    }
    if (enableShapeUniforms) return `
      float ${funcName}(int row, int col) {
        // Explicitly use integer operations as dot() only works on floats.
        int index = row * ${texName}Shape[1] + col + ${offset};
        vec2 uv = uvFromFlat(${texName}TexShape[0], ${texName}TexShape[1], index);
        return sampleTexture(${texName}, uv);
      }
    `;
    return `
  float ${funcName}(int row, int col) {
    // Explicitly use integer operations as dot() only works on floats.
    int index = row * ${shape[1]} + col + ${offset};
    vec2 uv = uvFromFlat(${texNumR}, ${texNumC}, index);
    return sampleTexture(${texName}, uv);
  }
`;
}
function $ba2c54ffbda39e8e$var$getPackedSampler3D(inputInfo, enableShapeUniforms) {
    const shape = inputInfo.shapeInfo.logicalShape;
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    const texShape = inputInfo.shapeInfo.texShape;
    const packedTexShape = [
        Math.ceil(texShape[0] / 2),
        Math.ceil(texShape[1] / 2)
    ];
    if (shape[0] === 1) {
        const squeezedShape = shape.slice(1);
        const keptDims = [
            1,
            2
        ];
        const newInputInfo = $ba2c54ffbda39e8e$export$5d06d3f48295bf13(inputInfo, squeezedShape);
        const params = [
            'b',
            'row',
            'col'
        ];
        return `
        ${$ba2c54ffbda39e8e$var$getPackedSamplerFromInInfo(newInputInfo, enableShapeUniforms)}
        vec4 ${funcName}(int b, int row, int col) {
          return ${funcName}(${$ba2c54ffbda39e8e$var$getSqueezedParams(params, keptDims)});
        }
      `;
    }
    const glsl = (0, $29bc34f3341b4730$export$3ebf4a18d6319f7a)();
    if (enableShapeUniforms) return `
    vec4 ${funcName}(int b, int row, int col) {
      ivec2 packedTexShape = ivec2(ceil(float(${texName}TexShape[0]) / 2.0), ceil(float(${texName}TexShape[1]) / 2.0));
      int valuesPerRow = int(ceil(float(${texName}Shape[2]) / 2.0));
      int texelsInBatch = valuesPerRow * int(ceil(float(${texName}Shape[1]) / 2.0));
      vec2 uv = packedUVfrom3D(
        packedTexShape[0], packedTexShape[1], texelsInBatch, valuesPerRow, b, row, col);
      return ${glsl.texture2D}(${texName}, uv);
    }
  `;
    const texNumR = packedTexShape[0];
    const texNumC = packedTexShape[1];
    const valuesPerRow = Math.ceil(shape[2] / 2);
    const texelsInBatch = valuesPerRow * Math.ceil(shape[1] / 2);
    return `
    vec4 ${funcName}(int b, int row, int col) {
      vec2 uv = packedUVfrom3D(
        ${texNumR}, ${texNumC}, ${texelsInBatch}, ${valuesPerRow}, b, row, col);
      return ${glsl.texture2D}(${texName}, uv);
    }
  `;
}
function $ba2c54ffbda39e8e$var$getSampler3D(inputInfo, enableShapeUniforms) {
    const shape = inputInfo.shapeInfo.logicalShape;
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    const stride0 = shape[1] * shape[2];
    const stride1 = shape[2];
    const { newShape: newShape, keptDims: keptDims } = (0, $i64bB.util).squeezeShape(shape);
    const squeezedShape = newShape;
    if (squeezedShape.length < shape.length) {
        const newInputInfo = $ba2c54ffbda39e8e$export$5d06d3f48295bf13(inputInfo, squeezedShape);
        const params = [
            'row',
            'col',
            'depth'
        ];
        return `
        ${$ba2c54ffbda39e8e$var$getSamplerFromInInfo(newInputInfo, enableShapeUniforms)}
        float ${funcName}(int row, int col, int depth) {
          return ${funcName}(${$ba2c54ffbda39e8e$var$getSqueezedParams(params, keptDims)});
        }
      `;
    }
    if (inputInfo.shapeInfo.isUniform) // Uniform arrays will be less than 65505 (no risk of float16 overflow).
    return `
      float ${funcName}(int row, int col, int depth) {
        int index = round(dot(vec3(row, col, depth),
                          vec3(${stride0}, ${stride1}, 1)));
        ${$ba2c54ffbda39e8e$var$getUniformSampler(inputInfo)}
      }
    `;
    const texShape = inputInfo.shapeInfo.texShape;
    const texNumR = texShape[0];
    const texNumC = texShape[1];
    const flatOffset = inputInfo.shapeInfo.flatOffset;
    if (texNumC === stride0 && flatOffset == null) {
        // texC is used directly as physical (no risk of float16 overflow).
        if (enableShapeUniforms) return `
      float ${funcName}(int row, int col, int depth) {
        int stride1 = ${texName}Shape[2];
        float texR = float(row);
        float texC = dot(vec2(col, depth), vec2(stride1, 1));
        vec2 uv = (vec2(texC, texR) + halfCR) /
                   vec2(${texName}TexShape[1], ${texName}TexShape[0]);
        return sampleTexture(${texName}, uv);
      }
    `;
        return `
        float ${funcName}(int row, int col, int depth) {
          float texR = float(row);
          float texC = dot(vec2(col, depth), vec2(${stride1}, 1));
          vec2 uv = (vec2(texC, texR) + halfCR) /
                     vec2(${texNumC}.0, ${texNumR}.0);
          return sampleTexture(${texName}, uv);
        }
      `;
    }
    if (texNumC === stride1 && flatOffset == null) {
        // texR is used directly as physical (no risk of float16 overflow).
        if (enableShapeUniforms) return `
      float ${funcName}(int row, int col, int depth) {
        float texR = dot(vec2(row, col), vec2(${texName}Shape[1], 1));
        float texC = float(depth);
        vec2 uv = (vec2(texC, texR) + halfCR) / vec2(${texName}TexShape[1], ${texName}TexShape[0]);
        return sampleTexture(${texName}, uv);
      }
    `;
        return `
    float ${funcName}(int row, int col, int depth) {
      float texR = dot(vec2(row, col), vec2(${shape[1]}, 1));
      float texC = float(depth);
      vec2 uv = (vec2(texC, texR) + halfCR) / vec2(${texNumC}.0, ${texNumR}.0);
      return sampleTexture(${texName}, uv);
    }
  `;
    }
    const offset = $ba2c54ffbda39e8e$var$getFlatOffsetUniformName(texName);
    if (enableShapeUniforms) return `
    float ${funcName}(int row, int col, int depth) {
      // Explicitly use integer operations as dot() only works on floats.
      int stride0 = ${texName}Shape[1] * ${texName}Shape[2];
      int stride1 = ${texName}Shape[2];
      int index = row * stride0 + col * stride1 + depth + ${offset};
      vec2 uv = uvFromFlat(${texName}TexShape[0], ${texName}TexShape[1], index);
      return sampleTexture(${texName}, uv);
    }
    `;
    return `
      float ${funcName}(int row, int col, int depth) {
        // Explicitly use integer operations as dot() only works on floats.
        int index = row * ${stride0} + col * ${stride1} + depth + ${offset};
        vec2 uv = uvFromFlat(${texNumR}, ${texNumC}, index);
        return sampleTexture(${texName}, uv);
      }
  `;
}
function $ba2c54ffbda39e8e$var$getPackedSamplerND(inputInfo, enableShapeUniforms) {
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    const glsl = (0, $29bc34f3341b4730$export$3ebf4a18d6319f7a)();
    if (enableShapeUniforms) // TODO: support 5d and 6d
    return `
    vec4 ${funcName}(int b2, int b, int row, int col) {
      int valuesPerRow = int(ceil(float(${texName}Shape[3]) / 2.0));
      int texelsInBatch = valuesPerRow * int(ceil(float(${texName}Shape[2]) / 2.0));
      int index = b * texelsInBatch + (row / 2) * valuesPerRow + (col / 2);
      texelsInBatch *= ${texName}Shape[1];
      index = b2 * texelsInBatch + index;
      ivec2 packedTexShape = ivec2(ceil(float(${texName}TexShape[0]) / 2.0), ceil(float(${texName}TexShape[1]) / 2.0));
      int texR = index / packedTexShape[1];
      int texC = index - texR * packedTexShape[1];
      vec2 uv = (vec2(texC, texR) + halfCR) / vec2(packedTexShape[1], packedTexShape[0]); return ${glsl.texture2D}(${texName}, uv);
    }
  `;
    const shape = inputInfo.shapeInfo.logicalShape;
    const rank = shape.length;
    const texShape = inputInfo.shapeInfo.texShape;
    const packedTexShape = [
        Math.ceil(texShape[0] / 2),
        Math.ceil(texShape[1] / 2)
    ];
    const texNumR = packedTexShape[0];
    const texNumC = packedTexShape[1];
    const valuesPerRow = Math.ceil(shape[rank - 1] / 2);
    let texelsInBatch = valuesPerRow * Math.ceil(shape[rank - 2] / 2);
    let params = `int b, int row, int col`;
    let index = `b * ${texelsInBatch} + (row / 2) * ${valuesPerRow} + (col / 2)`;
    for(let b = 2; b < rank - 1; b++){
        params = `int b${b}, ` + params;
        texelsInBatch *= shape[rank - b - 1];
        index = `b${b} * ${texelsInBatch} + ` + index;
    }
    return `
    vec4 ${funcName}(${params}) {
      int index = ${index};
      int texR = index / ${texNumC};
      int texC = index - texR * ${texNumC};
      vec2 uv = (vec2(texC, texR) + halfCR) / vec2(${texNumC}, ${texNumR});
      return ${glsl.texture2D}(${texName}, uv);
    }
  `;
}
function $ba2c54ffbda39e8e$var$getSampler4D(inputInfo, enableShapeUniforms) {
    const shape = inputInfo.shapeInfo.logicalShape;
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    const stride2 = shape[3];
    const stride1 = shape[2] * stride2;
    const stride0 = shape[1] * stride1;
    const { newShape: newShape, keptDims: keptDims } = (0, $i64bB.util).squeezeShape(shape);
    if (newShape.length < shape.length) {
        const newInputInfo = $ba2c54ffbda39e8e$export$5d06d3f48295bf13(inputInfo, newShape);
        const params = [
            'row',
            'col',
            'depth',
            'depth2'
        ];
        return `
      ${$ba2c54ffbda39e8e$var$getSamplerFromInInfo(newInputInfo, enableShapeUniforms)}
      float ${funcName}(int row, int col, int depth, int depth2) {
        return ${funcName}(${$ba2c54ffbda39e8e$var$getSqueezedParams(params, keptDims)});
      }
    `;
    }
    if (inputInfo.shapeInfo.isUniform) // Uniform arrays will be less than 65505 (no risk of float16 overflow).
    return `
      float ${funcName}(int row, int col, int depth, int depth2) {
        int index = round(dot(vec4(row, col, depth, depth2),
                          vec4(${stride0}, ${stride1}, ${stride2}, 1)));
        ${$ba2c54ffbda39e8e$var$getUniformSampler(inputInfo)}
      }
    `;
    const flatOffset = inputInfo.shapeInfo.flatOffset;
    const texShape = inputInfo.shapeInfo.texShape;
    const texNumR = texShape[0];
    const texNumC = texShape[1];
    const stride2Str = `int stride2 = ${texName}Shape[3];`;
    const stride1Str = `int stride1 = ${texName}Shape[2] * stride2;`;
    const stride0Str = `int stride0 = ${texName}Shape[1] * stride1;`;
    if (texNumC === stride0 && flatOffset == null) {
        // texC is used directly as physical (no risk of float16 overflow).
        if (enableShapeUniforms) return `
      float ${funcName}(int row, int col, int depth, int depth2) {
        ${stride2Str}
        ${stride1Str}
        float texR = float(row);
        float texC =
            dot(vec3(col, depth, depth2),
                vec3(stride1, stride2, 1));
        vec2 uv = (vec2(texC, texR) + halfCR) /
                   vec2(${texName}TexShape[1], ${texName}TexShape[0]);
        return sampleTexture(${texName}, uv);
      }
    `;
        return `
      float ${funcName}(int row, int col, int depth, int depth2) {
        float texR = float(row);
        float texC =
            dot(vec3(col, depth, depth2),
                vec3(${stride1}, ${stride2}, 1));
        vec2 uv = (vec2(texC, texR) + halfCR) /
                   vec2(${texNumC}.0, ${texNumR}.0);
        return sampleTexture(${texName}, uv);
      }
    `;
    }
    if (texNumC === stride2 && flatOffset == null) {
        // texR is used directly as physical (no risk of float16 overflow).
        if (enableShapeUniforms) return `
      float ${funcName}(int row, int col, int depth, int depth2) {
        float texR = dot(vec3(row, col, depth),
                         vec3(${texName}Shape[1] * ${texName}Shape[2], ${texName}Shape[2], 1));
        float texC = float(depth2);
        vec2 uv = (vec2(texC, texR) + halfCR) /
                  vec2(${texName}TexShape[1], ${texName}TexShape[0]);
        return sampleTexture(${texName}, uv);
      }
    `;
        return `
      float ${funcName}(int row, int col, int depth, int depth2) {
        float texR = dot(vec3(row, col, depth),
                         vec3(${shape[1] * shape[2]}, ${shape[2]}, 1));
        float texC = float(depth2);
        vec2 uv = (vec2(texC, texR) + halfCR) /
                  vec2(${texNumC}.0, ${texNumR}.0);
        return sampleTexture(${texName}, uv);
      }
    `;
    }
    const offset = $ba2c54ffbda39e8e$var$getFlatOffsetUniformName(texName);
    if (enableShapeUniforms) return `
    float ${funcName}(int row, int col, int depth, int depth2) {
      // Explicitly use integer operations as dot() only works on floats.
      ${stride2Str}
      ${stride1Str}
      ${stride0Str}
      int index = row * stride0 + col * stride1 +
          depth * stride2 + depth2;
      vec2 uv = uvFromFlat(${texName}TexShape[0], ${texName}TexShape[1], index + ${offset});
      return sampleTexture(${texName}, uv);
    }
  `;
    return `
    float ${funcName}(int row, int col, int depth, int depth2) {
      // Explicitly use integer operations as dot() only works on floats.
      int index = row * ${stride0} + col * ${stride1} +
          depth * ${stride2} + depth2;
      vec2 uv = uvFromFlat(${texNumR}, ${texNumC}, index + ${offset});
      return sampleTexture(${texName}, uv);
    }
  `;
}
function $ba2c54ffbda39e8e$var$getSampler5D(inputInfo) {
    const shape = inputInfo.shapeInfo.logicalShape;
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    const stride3 = shape[4];
    const stride2 = shape[3] * stride3;
    const stride1 = shape[2] * stride2;
    const stride0 = shape[1] * stride1;
    const { newShape: newShape, keptDims: keptDims } = (0, $i64bB.util).squeezeShape(shape);
    if (newShape.length < shape.length) {
        const newInputInfo = $ba2c54ffbda39e8e$export$5d06d3f48295bf13(inputInfo, newShape);
        const params = [
            'row',
            'col',
            'depth',
            'depth2',
            'depth3'
        ];
        return `
      ${$ba2c54ffbda39e8e$var$getSamplerFromInInfo(newInputInfo)}
      float ${funcName}(int row, int col, int depth, int depth2, int depth3) {
        return ${funcName}(${$ba2c54ffbda39e8e$var$getSqueezedParams(params, keptDims)});
      }
    `;
    }
    if (inputInfo.shapeInfo.isUniform) // Uniform arrays will be less than 65505 (no risk of float16 overflow).
    return `
      float ${funcName}(int row, int col, int depth, int depth2, int depth3) {
        float index = dot(
          vec4(row, col, depth, depth2),
          vec4(${stride0}, ${stride1}, ${stride2}, ${stride3})) +
          depth3;
        ${$ba2c54ffbda39e8e$var$getUniformSampler(inputInfo)}
      }
    `;
    const flatOffset = inputInfo.shapeInfo.flatOffset;
    const texShape = inputInfo.shapeInfo.texShape;
    const texNumR = texShape[0];
    const texNumC = texShape[1];
    if (texNumC === stride0 && flatOffset == null) // texC is used directly as physical (no risk of float16 overflow).
    return `
      float ${funcName}(int row, int col, int depth, int depth2, int depth3) {
        int texR = row;
        float texC = dot(vec4(col, depth, depth2, depth3),
                         vec4(${stride1}, ${stride2}, ${stride3}, 1));
        vec2 uv = (vec2(texC, texR) + halfCR) /
                   vec2(${texNumC}.0, ${texNumR}.0);
        return sampleTexture(${texName}, uv);
      }
    `;
    if (texNumC === stride3 && flatOffset == null) // texR is used directly as physical (no risk of float16 overflow).
    return `
      float ${funcName}(int row, int col, int depth, int depth2, int depth3) {
        float texR = dot(
          vec4(row, col, depth, depth2),
          vec4(${shape[1] * shape[2] * shape[3]},
               ${shape[2] * shape[3]}, ${shape[3]}, 1));
        int texC = depth3;
        vec2 uv = (vec2(texC, texR) + halfCR) /
                  vec2(${texNumC}.0, ${texNumR}.0);
        return sampleTexture(${texName}, uv);
      }
    `;
    const offset = $ba2c54ffbda39e8e$var$getFlatOffsetUniformName(texName);
    return `
    float ${funcName}(int row, int col, int depth, int depth2, int depth3) {
      // Explicitly use integer operations as dot() only works on floats.
      int index = row * ${stride0} + col * ${stride1} + depth * ${stride2} +
          depth2 * ${stride3} + depth3 + ${offset};
      vec2 uv = uvFromFlat(${texNumR}, ${texNumC}, index);
      return sampleTexture(${texName}, uv);
    }
  `;
}
function $ba2c54ffbda39e8e$var$getSampler6D(inputInfo) {
    const shape = inputInfo.shapeInfo.logicalShape;
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    const { newShape: newShape, keptDims: keptDims } = (0, $i64bB.util).squeezeShape(shape);
    if (newShape.length < shape.length) {
        const newInputInfo = $ba2c54ffbda39e8e$export$5d06d3f48295bf13(inputInfo, newShape);
        const params = [
            'row',
            'col',
            'depth',
            'depth2',
            'depth3',
            'depth4'
        ];
        return `
      ${$ba2c54ffbda39e8e$var$getSamplerFromInInfo(newInputInfo)}
      float ${funcName}(int row, int col, int depth,
                    int depth2, int depth3, int depth4) {
        return ${funcName}(${$ba2c54ffbda39e8e$var$getSqueezedParams(params, keptDims)});
      }
    `;
    }
    const stride4 = shape[5];
    const stride3 = shape[4] * stride4;
    const stride2 = shape[3] * stride3;
    const stride1 = shape[2] * stride2;
    const stride0 = shape[1] * stride1;
    if (inputInfo.shapeInfo.isUniform) // Uniform arrays will be less than 65505 (no risk of float16 overflow).
    return `
      float ${funcName}(int row, int col, int depth,
                  int depth2, int depth3, int depth4) {
        int index = round(dot(
          vec4(row, col, depth, depth2),
          vec4(${stride0}, ${stride1}, ${stride2}, ${stride3})) +
          dot(
            vec2(depth3, depth4),
            vec2(${stride4}, 1)));
        ${$ba2c54ffbda39e8e$var$getUniformSampler(inputInfo)}
      }
    `;
    const flatOffset = inputInfo.shapeInfo.flatOffset;
    const texShape = inputInfo.shapeInfo.texShape;
    const texNumR = texShape[0];
    const texNumC = texShape[1];
    if (texNumC === stride0 && flatOffset == null) // texC is used directly as physical (no risk of float16 overflow).
    return `
      float ${funcName}(int row, int col, int depth,
                    int depth2, int depth3, int depth4) {
        int texR = row;
        float texC = dot(vec4(col, depth, depth2, depth3),
          vec4(${stride1}, ${stride2}, ${stride3}, ${stride4})) +
               float(depth4);
        vec2 uv = (vec2(texC, texR) + halfCR) /
                   vec2(${texNumC}.0, ${texNumR}.0);
        return sampleTexture(${texName}, uv);
      }
    `;
    if (texNumC === stride4 && flatOffset == null) // texR is used directly as physical (no risk of float16 overflow).
    return `
      float ${funcName}(int row, int col, int depth,
                    int depth2, int depth3, int depth4) {
        float texR = dot(vec4(row, col, depth, depth2),
          vec4(${shape[1] * shape[2] * shape[3] * shape[4]},
               ${shape[2] * shape[3] * shape[4]},
               ${shape[3] * shape[4]},
               ${shape[4]})) + float(depth3);
        int texC = depth4;
        vec2 uv = (vec2(texC, texR) + halfCR) /
                  vec2(${texNumC}.0, ${texNumR}.0);
        return sampleTexture(${texName}, uv);
      }
    `;
    const offset = $ba2c54ffbda39e8e$var$getFlatOffsetUniformName(texName);
    return `
    float ${funcName}(int row, int col, int depth,
                  int depth2, int depth3, int depth4) {
      // Explicitly use integer operations as dot() only works on floats.
      int index = row * ${stride0} + col * ${stride1} + depth * ${stride2} +
          depth2 * ${stride3} + depth3 * ${stride4} + depth4 + ${offset};
      vec2 uv = uvFromFlat(${texNumR}, ${texNumC}, index);
      return sampleTexture(${texName}, uv);
    }
  `;
}
function $ba2c54ffbda39e8e$var$getUniformSampler(inputInfo) {
    const texName = inputInfo.name;
    const inSize = (0, $i64bB.util).sizeFromShape(inputInfo.shapeInfo.logicalShape);
    if (inSize < 2) return `return ${texName};`;
    return `
    for (int i = 0; i < ${inSize}; i++) {
      if (i == index) {
        return ${texName}[i];
      }
    }
  `;
}
function $ba2c54ffbda39e8e$var$getPackedSamplerAtOutputCoords(inputInfo, outShapeInfo) {
    const texName = inputInfo.name;
    const texFuncSnippet = texName.charAt(0).toUpperCase() + texName.slice(1);
    const funcName = 'get' + texFuncSnippet + 'AtOutCoords';
    const inRank = inputInfo.shapeInfo.logicalShape.length;
    const outRank = outShapeInfo.logicalShape.length;
    const broadcastDims = $ba2c54ffbda39e8e$var$getBroadcastDims(inputInfo.shapeInfo.logicalShape, outShapeInfo.logicalShape);
    const type = $ba2c54ffbda39e8e$export$859efd105c10c755(outRank);
    const rankDiff = outRank - inRank;
    let coordsSnippet;
    const fields = [
        'x',
        'y',
        'z',
        'w',
        'u',
        'v'
    ];
    if (inRank === 0) coordsSnippet = '';
    else if (outRank < 2 && broadcastDims.length >= 1) coordsSnippet = 'coords = 0;';
    else coordsSnippet = broadcastDims.map((d)=>`coords.${fields[d + rankDiff]} = 0;`).join('\n');
    let unpackedCoordsSnippet = '';
    if (outRank < 2 && inRank > 0) unpackedCoordsSnippet = 'coords';
    else unpackedCoordsSnippet = inputInfo.shapeInfo.logicalShape.map((s, i)=>`coords.${fields[i + rankDiff]}`).join(', ');
    let output = `return outputValue;`;
    const inSize = (0, $i64bB.util).sizeFromShape(inputInfo.shapeInfo.logicalShape);
    const isInputScalar = inSize === 1;
    const outSize = (0, $i64bB.util).sizeFromShape(outShapeInfo.logicalShape);
    const isOutputScalar = outSize === 1;
    if (inRank === 1 && !isInputScalar && !isOutputScalar) output = `
      return vec4(outputValue.xy, outputValue.xy);
    `;
    else if (isInputScalar && !isOutputScalar) {
        if (outRank === 1) output = `
        return vec4(outputValue.x, outputValue.x, 0., 0.);
      `;
        else output = `
        return vec4(outputValue.x);
      `;
    } else if (broadcastDims.length) {
        const rows = inRank - 2;
        const cols = inRank - 1;
        if (broadcastDims.indexOf(rows) > -1 && broadcastDims.indexOf(cols) > -1) output = `return vec4(outputValue.x);`;
        else if (broadcastDims.indexOf(rows) > -1) output = `return vec4(outputValue.x, outputValue.y, ` + `outputValue.x, outputValue.y);`;
        else if (broadcastDims.indexOf(cols) > -1) output = `return vec4(outputValue.xx, outputValue.zz);`;
    }
    return `
    vec4 ${funcName}() {
      ${type} coords = getOutputCoords();
      ${coordsSnippet}
      vec4 outputValue = get${texFuncSnippet}(${unpackedCoordsSnippet});
      ${output}
    }
  `;
}
function $ba2c54ffbda39e8e$var$getSamplerAtOutputCoords(inputInfo, outShapeInfo) {
    const texName = inputInfo.name;
    const texFuncSnippet = texName.charAt(0).toUpperCase() + texName.slice(1);
    const funcName = 'get' + texFuncSnippet + 'AtOutCoords';
    const outTexShape = outShapeInfo.texShape;
    const inTexShape = inputInfo.shapeInfo.texShape;
    const inRank = inputInfo.shapeInfo.logicalShape.length;
    const outRank = outShapeInfo.logicalShape.length;
    if (!inputInfo.shapeInfo.isUniform && inRank === outRank && inputInfo.shapeInfo.flatOffset == null && (0, $i64bB.util).arraysEqual(inTexShape, outTexShape)) return `
      float ${funcName}() {
        return sampleTexture(${texName}, resultUV);
      }
    `;
    const type = $ba2c54ffbda39e8e$export$859efd105c10c755(outRank);
    const broadcastDims = $ba2c54ffbda39e8e$var$getBroadcastDims(inputInfo.shapeInfo.logicalShape, outShapeInfo.logicalShape);
    const rankDiff = outRank - inRank;
    let coordsSnippet;
    const fields = [
        'x',
        'y',
        'z',
        'w',
        'u',
        'v'
    ];
    if (inRank === 0) coordsSnippet = '';
    else if (outRank < 2 && broadcastDims.length >= 1) coordsSnippet = 'coords = 0;';
    else coordsSnippet = broadcastDims.map((d)=>`coords.${fields[d + rankDiff]} = 0;`).join('\n');
    let unpackedCoordsSnippet = '';
    if (outRank < 2 && inRank > 0) unpackedCoordsSnippet = 'coords';
    else unpackedCoordsSnippet = inputInfo.shapeInfo.logicalShape.map((s, i)=>`coords.${fields[i + rankDiff]}`).join(', ');
    return `
    float ${funcName}() {
      ${type} coords = getOutputCoords();
      ${coordsSnippet}
      return get${texFuncSnippet}(${unpackedCoordsSnippet});
    }
  `;
}
function $ba2c54ffbda39e8e$export$859efd105c10c755(rank) {
    if (rank <= 1) return 'int';
    else if (rank === 2) return 'ivec2';
    else if (rank === 3) return 'ivec3';
    else if (rank === 4) return 'ivec4';
    else if (rank === 5) return 'ivec5';
    else if (rank === 6) return 'ivec6';
    else throw Error(`GPU for rank ${rank} is not yet supported`);
}
function $ba2c54ffbda39e8e$export$19e35a0844e29cf9(isPacked, shape, texShape) {
    const { newShape: newShape, keptDims: keptDims } = (0, $i64bB.util).squeezeShape(shape);
    const rank = shape.length;
    const useSqueezePackedShape = isPacked && rank === 3 && shape[0] === 1;
    const squeezeShape = useSqueezePackedShape ? shape.slice(1) : newShape;
    const useSqueezeShape = !isPacked && rank > 1 && !(0, $i64bB.util).arraysEqual(shape, texShape) && newShape.length < rank || useSqueezePackedShape;
    const uniformShape = useSqueezeShape ? squeezeShape : shape;
    return {
        useSqueezeShape: useSqueezeShape,
        uniformShape: uniformShape,
        keptDims: keptDims
    };
}
function $ba2c54ffbda39e8e$export$5d06d3f48295bf13(inInfo, squeezedShape) {
    // Deep copy.
    const newInputInfo = JSON.parse(JSON.stringify(inInfo));
    newInputInfo.shapeInfo.logicalShape = squeezedShape;
    return newInputInfo;
}
function $ba2c54ffbda39e8e$var$getSqueezedParams(params, keptDims) {
    return keptDims.map((d)=>params[d]).join(', ');
}



function $8c928040c80f573b$export$5ca2cb6073dd12df(gpgpu, program, inputs, output) {
    const inputInfos = inputs.map((input, i)=>{
        const shapeInfo = {
            logicalShape: input.shape,
            texShape: input.isUniform ? null : input.texData.texShape,
            isUniform: input.isUniform,
            isPacked: input.isUniform ? false : input.texData.isPacked,
            flatOffset: null
        };
        if (input.texData != null && input.texData.slice != null && input.texData.slice.flatOffset > 0) shapeInfo.flatOffset = input.texData.slice.flatOffset;
        return {
            name: program.variableNames[i],
            shapeInfo: shapeInfo
        };
    });
    const inShapeInfos = inputInfos.map((x)=>x.shapeInfo);
    const outShapeInfo = {
        logicalShape: output.shape,
        texShape: output.texData.texShape,
        isUniform: false,
        isPacked: output.texData.isPacked,
        flatOffset: null
    };
    const source = $ba2c54ffbda39e8e$export$37f33ba844563dd2(inputInfos, outShapeInfo, program);
    const fragmentShader = (0, $03fc80a4a4cef09e$export$a8ab0e04b20572c0)(gpgpu.gl, source);
    const webGLProgram = gpgpu.createProgram(fragmentShader);
    if (!(0, $i64bB.env)().get('ENGINE_COMPILE_ONLY')) {
        gpgpu.buildVao(webGLProgram);
        return Object.assign({
            program: program,
            fragmentShader: fragmentShader,
            source: source,
            webGLProgram: webGLProgram,
            inShapeInfos: inShapeInfos,
            outShapeInfo: outShapeInfo
        }, $8c928040c80f573b$export$d421ceceafba9cc0(gpgpu, program, webGLProgram));
    } else return {
        program: program,
        fragmentShader: fragmentShader,
        source: source,
        webGLProgram: webGLProgram,
        inShapeInfos: inShapeInfos,
        outShapeInfo: outShapeInfo,
        variablesLocations: null,
        customUniformLocations: null,
        infLoc: null,
        nanLoc: null,
        outShapeLocation: null,
        outShapeStridesLocation: null,
        outTexShapeLocation: null
    };
}
function $8c928040c80f573b$export$d421ceceafba9cc0(gpgpu, program, webGLProgram) {
    const variablesLocations = [];
    const customUniformLocations = [];
    let outShapeLocation;
    let outTexShapeLocation;
    let outShapeStridesLocation;
    let infLoc = null;
    let nanLoc = null;
    // Add special uniforms (NAN, INFINITY)
    nanLoc = gpgpu.getUniformLocation(webGLProgram, 'NAN', false);
    if ((0, $i64bB.env)().getNumber('WEBGL_VERSION') === 1) infLoc = gpgpu.getUniformLocation(webGLProgram, 'INFINITY', false);
    // Add user-defined uniforms
    const shouldThrow = false;
    for (const varName of program.variableNames){
        const varLocs = {
            name: varName,
            uniform: gpgpu.getUniformLocation(webGLProgram, varName, shouldThrow),
            offset: gpgpu.getUniformLocation(webGLProgram, `offset${varName}`, shouldThrow)
        };
        if (program.enableShapeUniforms) {
            varLocs.shape = gpgpu.getUniformLocation(webGLProgram, `${varName}Shape`, shouldThrow);
            varLocs.texShape = gpgpu.getUniformLocation(webGLProgram, `${varName}TexShape`, shouldThrow);
        }
        variablesLocations.push(varLocs);
    }
    if (program.enableShapeUniforms) {
        outShapeLocation = gpgpu.getUniformLocation(webGLProgram, 'outShape', shouldThrow);
        outShapeStridesLocation = gpgpu.getUniformLocation(webGLProgram, 'outShapeStrides', shouldThrow);
        outTexShapeLocation = gpgpu.getUniformLocation(webGLProgram, 'outTexShape', shouldThrow);
    }
    if (program.customUniforms) for (const d of program.customUniforms)customUniformLocations.push(gpgpu.getUniformLocation(webGLProgram, d.name, shouldThrow));
    return {
        variablesLocations: variablesLocations,
        customUniformLocations: customUniformLocations,
        infLoc: infLoc,
        nanLoc: nanLoc,
        outShapeLocation: outShapeLocation,
        outShapeStridesLocation: outShapeStridesLocation,
        outTexShapeLocation: outTexShapeLocation
    };
}
function $8c928040c80f573b$var$validateBinaryAndProgram(shapeInfos, inputs) {
    if (shapeInfos.length !== inputs.length) throw Error(`Binary was compiled with ${shapeInfos.length} inputs, but ` + `was executed with ${inputs.length} inputs`);
    shapeInfos.forEach((s, i)=>{
        const shapeA = s.logicalShape;
        const input = inputs[i];
        const shapeB = input.shape;
        if (!(0, $i64bB.util).arraysEqual(shapeA, shapeB)) throw Error(`Binary was compiled with different shapes than ` + `the current args. Shapes ${shapeA} and ${shapeB} must match`);
        // The input is uploaded as uniform.
        if (s.isUniform && input.isUniform) return;
        const texShapeA = s.texShape;
        const texShapeB = input.isUniform ? null : input.texData.texShape;
        if (!(0, $i64bB.util).arraysEqual(texShapeA, texShapeB)) throw Error(`Binary was compiled with different texture shapes than the` + ` current args. Shape ${texShapeA} and ${texShapeB} must match`);
    });
}
function $8c928040c80f573b$export$4e01d2c5eea12ae3(gpgpu, binary, inputs, output, customUniformValues) {
    if (!binary.program.enableShapeUniforms) {
        $8c928040c80f573b$var$validateBinaryAndProgram(binary.inShapeInfos, inputs);
        $8c928040c80f573b$var$validateBinaryAndProgram([
            binary.outShapeInfo
        ], [
            output
        ]);
    }
    const outTex = output.texData.texture;
    const outTexShape = output.texData.texShape;
    if (output.texData.isPacked) gpgpu.setOutputPackedMatrixTexture(outTex.texture, outTexShape[0], outTexShape[1]);
    else gpgpu.setOutputMatrixTexture(outTex.texture, outTexShape[0], outTexShape[1]);
    gpgpu.setProgram(binary.webGLProgram);
    gpgpu.bindVertexArray(binary.webGLProgram.vao);
    // Set special uniforms (NAN, INFINITY)
    if ((0, $i64bB.env)().getNumber('WEBGL_VERSION') === 1) {
        if (binary.infLoc !== null) gpgpu.gl.uniform1f(binary.infLoc, Infinity);
    }
    if (binary.nanLoc !== null) gpgpu.gl.uniform1f(binary.nanLoc, NaN);
    // Set user-defined inputs
    for(let i = 0; i < inputs.length; ++i){
        const input = inputs[i];
        const { uniform: varLoc, offset: varOffsetLoc, shape: varShapeLoc, texShape: varTexShapeLoc } = binary.variablesLocations[i];
        if (varShapeLoc) {
            const { uniformShape: uniformShape } = $ba2c54ffbda39e8e$export$19e35a0844e29cf9(binary.program.packedInputs, input.shape, input.texData.texShape);
            switch(uniformShape.length){
                case 1:
                    gpgpu.gl.uniform1iv(varShapeLoc, new Int32Array(uniformShape));
                    break;
                case 2:
                    gpgpu.gl.uniform2iv(varShapeLoc, new Int32Array(uniformShape));
                    break;
                case 3:
                    gpgpu.gl.uniform3iv(varShapeLoc, new Int32Array(uniformShape));
                    break;
                case 4:
                    gpgpu.gl.uniform4iv(varShapeLoc, new Int32Array(uniformShape));
                    break;
                default:
                    break;
            }
        }
        if (varTexShapeLoc) gpgpu.gl.uniform2i(varTexShapeLoc, input.texData.texShape[0], input.texData.texShape[1]);
        if (varLoc == null) continue;
        if (input.isUniform) {
            // Upload the values of the tensor as uniform.
            if ((0, $i64bB.util).sizeFromShape(input.shape) < 2) gpgpu.gl.uniform1f(varLoc, input.uniformValues[0]);
            else {
                let vals = input.uniformValues;
                if (!(vals instanceof Float32Array)) vals = new Float32Array(vals);
                gpgpu.gl.uniform1fv(varLoc, vals);
            }
            continue;
        }
        // If the input was sliced, upload the flat offset index.
        if (input.texData.slice != null && varOffsetLoc != null) gpgpu.gl.uniform1i(varOffsetLoc, input.texData.slice.flatOffset);
        gpgpu.setInputMatrixTexture(input.texData.texture.texture, varLoc, i);
    }
    const outShapeLoc = binary.outShapeLocation;
    if (outShapeLoc) switch(output.shape.length){
        case 1:
            gpgpu.gl.uniform1iv(outShapeLoc, new Int32Array(output.shape));
            break;
        case 2:
            gpgpu.gl.uniform2iv(outShapeLoc, new Int32Array(output.shape));
            break;
        case 3:
            gpgpu.gl.uniform3iv(outShapeLoc, new Int32Array(output.shape));
            break;
        case 4:
            gpgpu.gl.uniform4iv(outShapeLoc, new Int32Array(output.shape));
            break;
        default:
            break;
    }
    if (binary.outShapeStridesLocation) {
        const strides = (0, $i64bB.util).computeStrides(output.shape);
        switch(output.shape.length){
            case 2:
                gpgpu.gl.uniform1iv(binary.outShapeStridesLocation, new Int32Array(strides));
                break;
            case 3:
                gpgpu.gl.uniform2iv(binary.outShapeStridesLocation, new Int32Array(strides));
                break;
            case 4:
                gpgpu.gl.uniform3iv(binary.outShapeStridesLocation, new Int32Array(strides));
                break;
            default:
                break;
        }
    }
    if (binary.outTexShapeLocation) gpgpu.gl.uniform2i(binary.outTexShapeLocation, output.texData.texShape[0], output.texData.texShape[1]);
    if (binary.program.customUniforms && customUniformValues) for(let i = 0; i < binary.program.customUniforms.length; ++i){
        const d = binary.program.customUniforms[i];
        const customLoc = binary.customUniformLocations[i];
        const customValue = customUniformValues[i];
        if (d.type === 'float') gpgpu.gl.uniform1fv(customLoc, customValue);
        else if (d.type === 'vec2') gpgpu.gl.uniform2fv(customLoc, customValue);
        else if (d.type === 'vec3') gpgpu.gl.uniform3fv(customLoc, customValue);
        else if (d.type === 'vec4') gpgpu.gl.uniform4fv(customLoc, customValue);
        else if (d.type === 'int') gpgpu.gl.uniform1iv(customLoc, customValue);
        else if (d.type === 'ivec2') gpgpu.gl.uniform2iv(customLoc, customValue);
        else if (d.type === 'ivec3') gpgpu.gl.uniform3iv(customLoc, customValue);
        else if (d.type === 'ivec4') gpgpu.gl.uniform4iv(customLoc, customValue);
        else throw Error(`uniform type ${d.type} is not supported yet.`);
    }
    gpgpu.executeProgram();
}
function $8c928040c80f573b$export$2a17a6d53fe6f5d9(program, inputs, output) {
    let keyInputs = '';
    inputs.concat(output).forEach((x)=>{
        const hasOffset = x.texData != null && x.texData.slice != null && x.texData.slice.flatOffset > 0;
        // TODO: Remove the condition of !x.isUniform.
        if (program.enableShapeUniforms && !x.isUniform) {
            const xTexShape = x.texData.texShape;
            const { useSqueezeShape: useSqueezeShape, uniformShape: uniformShape, keptDims: keptDims } = $ba2c54ffbda39e8e$export$19e35a0844e29cf9(program.packedInputs, x.shape, xTexShape);
            let rank1 = '', rank2 = '', rank34 = '';
            if (uniformShape.length === 1 && program.packedInputs) {
                const packedTexShape = [
                    Math.ceil(xTexShape[0] / 2),
                    Math.ceil(xTexShape[1] / 2)
                ];
                rank1 = `${packedTexShape[0] > 1}_${packedTexShape[1] > 1}`;
            } else if (uniformShape.length === 2 && !program.packedInputs) rank2 = `${uniformShape[0] > 1}_${uniformShape[1] > 1}`;
            else if (uniformShape.length > 2 && !program.packedInputs) {
                const strides = (0, $i64bB.util).computeStrides(uniformShape);
                rank34 = `${strides[0] === xTexShape[1]}_${strides[strides.length - 1] === xTexShape[1]}`;
            }
            const xRank = x.shape.length;
            const isLogicalShapTexShapeEqual = uniformShape.length === 2 && (0, $i64bB.util).arraysEqual(x.shape, xTexShape);
            const isScalar = (0, $i64bB.util).sizeFromShape(x.shape) === 1;
            const broadcastDims = (0, $i64bB.backend_util).getBroadcastDims(x.shape, output.shape);
            const isInOutTexShapeEqual = !program.packedInputs && xRank === output.shape.length && (0, $i64bB.util).arraysEqual(xTexShape, output.texData.texShape);
            const isTexShapeGreaterThanOne = program.packedInputs || uniformShape.length > 2 ? '' : `${xTexShape[0] > 1}_${xTexShape[1] > 1}`;
            // These key components are needed due to shader_compiler is embedding
            // them in the shader.
            // |xRank| is used to determine the coords length. See
            // get[Packed]SamplerAtOutputCoords.
            // |isInOutTexShapeEqual| is used to determine whether going to an
            // optimization path in getSamplerAtOutputCoords.
            // |useSqueezeShape| is extracted from squeezeInputInfo of
            // getSampler[2|3|4]D/getPackedSampler3D.
            // |isScalar| is extracted from isInputScalar/isOutputScalar in
            // getPackedSamplerAtOutputCoords.
            // |broadcastDims| is extracted from get[Packed]SamplerAtOutputCoords.
            // |isLogicalShapTexShapeEqual| is used in
            // getOutput[Packed]2DCoords/get[Packed]Sampler2D.
            // |rank1| is used in getOutputPacked1DCoords.
            // |rank2| is used in getOutput2DCoords.
            // |rank34| is used in getSampler3D/getSampler4D.
            // |isTexShapeGreaterThanOne| are used in
            // getSampler[Scalar|1D|2D]/getOutput1DCoords.
            keyInputs += `${xRank}_${isInOutTexShapeEqual}_${useSqueezeShape ? keptDims : ''}_${uniformShape.length}_${isScalar}_${broadcastDims}_${isLogicalShapTexShapeEqual}_${rank1}_${rank2}_${rank34}_${isTexShapeGreaterThanOne}_${hasOffset}`;
        } else {
            const texShape = x.isUniform ? 'uniform' : x.texData.texShape;
            keyInputs += `${x.shape}_${texShape}_${hasOffset}`;
        }
    });
    const keyUserCode = program.userCode;
    let key = program.constructor.name;
    // Fast string concat. See https://jsperf.com/string-concatenation/14.
    key += '_' + keyInputs + '_' + keyUserCode + `${(0, $i64bB.env)().getNumber('WEBGL_VERSION')}`;
    return key;
}
function $8c928040c80f573b$export$5acc770fc06a0138(rank) {
    // TODO: Remove the limitaion of rank <= 4.
    return (0, $i64bB.env)().getBool('WEBGL_USE_SHAPES_UNIFORMS') && rank <= 4;
}




class $10aa3719489b95a5$export$f6ee51c6efbee026 {
    constructor(outputShape){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = false;
        this.packedOutput = true;
        this.outPackingScheme = (0, $c7d2caaa716d42d2$export$81d5c79efa1086f2).DENSE;
        this.customUniforms = [
            {
                name: 'texShape',
                type: 'ivec2'
            }
        ];
        const glsl = (0, $29bc34f3341b4730$export$3ebf4a18d6319f7a)();
        this.outputShape = outputShape;
        this.enableShapeUniforms = (0, $8c928040c80f573b$export$5acc770fc06a0138)(this.outputShape.length);
        this.userCode = `
      ivec3 outCoordsFromFlatIndex(int index) {
        ${this.enableShapeUniforms ? $30e89c7e4234424e$export$ae684ebb20c3e80c([
            'r',
            'c',
            'd'
        ], outputShape) : $30e89c7e4234424e$export$53c37f67510642ce([
            'r',
            'c',
            'd'
        ], outputShape)}
        return ivec3(r, c, d);
      }

      void main() {
        ivec2 resTexRC = ivec2(resultUV.yx * vec2(texShape[0], texShape[1]));
        int index = 4 * (resTexRC.x * texShape[1] + resTexRC.y);

        vec4 result = vec4(0.);

        for (int i=0; i<4; i++) {
          int flatIndex = index + i;
          ivec3 rc = outCoordsFromFlatIndex(flatIndex);
          result[i] = getA(rc.x, rc.y, rc.z);
        }

        ${glsl.output} = result;
      }
    `;
    }
}


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



class $76c4e43b08dbd9e1$export$4434db41c70879cb {
    constructor(outputShape){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.outPackingScheme = (0, $c7d2caaa716d42d2$export$81d5c79efa1086f2).DENSE;
        this.customUniforms = [
            {
                name: 'texShape',
                type: 'ivec2'
            }
        ];
        const glsl = (0, $29bc34f3341b4730$export$3ebf4a18d6319f7a)();
        this.outputShape = outputShape;
        this.enableShapeUniforms = (0, $8c928040c80f573b$export$5acc770fc06a0138)(this.outputShape.length);
        this.userCode = `
      ivec3 outCoordsFromFlatIndex(int index) {
        ${this.enableShapeUniforms ? $30e89c7e4234424e$export$ae684ebb20c3e80c([
            'r',
            'c',
            'd'
        ], outputShape) : $30e89c7e4234424e$export$53c37f67510642ce([
            'r',
            'c',
            'd'
        ], outputShape)}
        return ivec3(r, c, d);
      }

      void main() {
        ivec2 resTexRC = ivec2(resultUV.yx * vec2(texShape[0], texShape[1]));
        int index = 4 * (resTexRC.x * texShape[1] + resTexRC.y);

        vec4 result = vec4(0.);

        for (int i=0; i<4; i++) {
          int flatIndex = index + i;
          ivec3 rc = outCoordsFromFlatIndex(flatIndex);
          result[i] = getChannel(getA(rc.x, rc.y, rc.z), vec2(rc.y, rc.z));
        }

        ${glsl.output} = result;
      }
    `;
    }
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


class $ef6f5336bc8e6fb9$export$dae4f112167b5aac {
    constructor(outputShape){
        this.variableNames = [
            'A'
        ];
        this.outTexUsage = (0, $c7d2caaa716d42d2$export$6bf4bd1b6beb0bfd).DOWNLOAD;
        const glsl = (0, $29bc34f3341b4730$export$3ebf4a18d6319f7a)();
        this.outputShape = outputShape;
        this.userCode = `
      ${0, $30e89c7e4234424e$export$2ac12a308a563905}

      void main() {
        float x = getAAtOutCoords();
        ${glsl.output} = encode_float(x);
      }
    `;
    }
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


class $ea89275acc06be2c$export$97e262e8a4818e2e {
    constructor(outputShape){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = false;
        this.outTexUsage = (0, $c7d2caaa716d42d2$export$6bf4bd1b6beb0bfd).DOWNLOAD;
        const glsl = (0, $29bc34f3341b4730$export$3ebf4a18d6319f7a)();
        this.outputShape = outputShape;
        this.userCode = `
      ${0, $30e89c7e4234424e$export$2ac12a308a563905}

      void main() {
        ivec3 coords = getOutputCoords();
        float x = getChannel(getAAtOutCoords(), vec2(coords.y, coords.z));
        ${glsl.output} = encode_float(x);
      }
    `;
    }
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $b2c960dec54ec6b8$var$CHANNEL_CHAR_TO_INDEX_MAP = {
    'R': 0,
    'G': 1,
    'B': 2,
    'A': 3
};
class $b2c960dec54ec6b8$export$b2e063313033aeab {
    constructor(outputShape, inputIsUnsignedByte = false, usedChannels = 'RGBA'){
        this.variableNames = [
            'A'
        ];
        this.customUniforms = [
            {
                name: 'texShape',
                type: 'ivec2'
            }
        ];
        const glsl = (0, $29bc34f3341b4730$export$3ebf4a18d6319f7a)();
        this.outputShape = outputShape;
        this.enableShapeUniforms = (0, $8c928040c80f573b$export$5acc770fc06a0138)(this.outputShape.length);
        let output = `result`;
        if (inputIsUnsignedByte) output = `floor(result * 255. + 0.5)`;
        let mainLoop = '';
        for(let usedChannelIndex = 0; usedChannelIndex < usedChannels.length; usedChannelIndex++){
            const curChannel = usedChannels[usedChannelIndex];
            mainLoop += `
          if(offset == ${usedChannelIndex}) {
            result = values[${$b2c960dec54ec6b8$var$CHANNEL_CHAR_TO_INDEX_MAP[curChannel]}];
          }`;
        }
        this.userCode = `
      ${this.enableShapeUniforms ? $30e89c7e4234424e$export$4ec1e3f6361de451() : $30e89c7e4234424e$export$4c68558c71205a01(outputShape)}

      void main() {
        ivec3 coords = getOutputCoords();
        int flatIndex = getFlatIndex(coords);
        float result = 0.;
        int offset = imod(flatIndex, ${usedChannels.length});

        flatIndex = idiv(flatIndex, ${usedChannels.length}, 1.);

        int r = flatIndex / texShape[1];
        if (r < texShape[0]) {
          int c = imod(flatIndex, texShape[1]);
          vec2 uv = (vec2(c, r) + halfCR) / vec2(texShape[1], texShape[0]);
          vec4 values = ${glsl.texture2D}(A, uv);
          ${mainLoop}
        }
        ${glsl.output} = vec4(${output}, 0., 0., 0.);
      }
    `;
    }
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


class $a94ed549409f1196$export$3b3e6b1f67c8c4d5 {
    constructor(outputShape, inputIsUnsignedByte = false){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = false;
        this.packedOutput = true;
        this.customUniforms = [
            {
                name: 'texShape',
                type: 'ivec2'
            }
        ];
        const glsl = (0, $29bc34f3341b4730$export$3ebf4a18d6319f7a)();
        this.outputShape = outputShape;
        this.enableShapeUniforms = (0, $8c928040c80f573b$export$5acc770fc06a0138)(this.outputShape.length);
        let mainLoop = '';
        let output = 'result';
        if (inputIsUnsignedByte) output = 'floor(result * 255. + 0.5)';
        for(let row = 0; row <= 1; row++)for(let col = 0; col <= 1; col++){
            const channel = row * 2 + col;
            mainLoop += `
          localCoords = coords;
          if(localCoords[2] + ${col} < ${this.enableShapeUniforms ? 'outShape[2]' : `${outputShape[2]}`}) {
          localCoords[2] += ${col};
          if (localCoords[1] + ${row} < ${this.enableShapeUniforms ? 'outShape[1]' : `${outputShape[1]}`}) {
            localCoords[1] += ${row};

            flatIndex = getFlatIndex(localCoords);
            offset = imod(flatIndex, 4);

            flatIndex = idiv(flatIndex, 4, 1.);

            int r = flatIndex / texShape[1];
            int c = imod(flatIndex, texShape[1]);
            vec2 uv = (vec2(c, r) + halfCR) / vec2(texShape[1], texShape[0]);
            values = ${glsl.texture2D}(A, uv);

            if (offset == 0) {
              result[${channel}] = values[0];
            } else if (offset == 1) {
              result[${channel}] = values[1];
            } else if (offset == 2) {
              result[${channel}] = values[2];
            } else {
              result[${channel}] = values[3];
            }
          }
        }
        `;
        }
        this.userCode = `
        ${this.enableShapeUniforms ? $30e89c7e4234424e$export$4ec1e3f6361de451() : $30e89c7e4234424e$export$4c68558c71205a01(outputShape)}

        void main() {
          ivec3 coords = getOutputCoords();

          vec4 result = vec4(0.);
          int flatIndex, r, c, offset;
          ivec3 localCoords;
          vec2 uv;
          vec4 values;

          ${mainLoop}

          ${glsl.output} = ${output};
        }
    `;
    }
}


/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");



function $e534681c41547152$export$4ca6704ce1875929(gl) {
    const glsl = (0, $29bc34f3341b4730$export$3ebf4a18d6319f7a)();
    const vertexShaderSource = `${glsl.version}
    precision highp float;
    ${glsl.attribute} vec3 clipSpacePos;
    ${glsl.attribute} vec2 uv;
    ${glsl.varyingVs} vec2 resultUV;

    void main() {
      gl_Position = vec4(clipSpacePos, 1);
      resultUV = uv;
    }`;
    return $03fc80a4a4cef09e$export$4ca6704ce1875929(gl, vertexShaderSource);
}
function $e534681c41547152$export$8ddd35f9c5bd5634(gl) {
    // [x y z u v] * [upper-left, lower-left, upper-right, lower-right]
    const vertexArray = new Float32Array([
        -1,
        1,
        0,
        0,
        1,
        -1,
        -1,
        0,
        0,
        0,
        1,
        1,
        0,
        1,
        1,
        1,
        -1,
        0,
        1,
        0
    ]);
    return $03fc80a4a4cef09e$export$3871e1d1e28ac6cb(gl, vertexArray);
}
function $e534681c41547152$export$2be7df49658092d0(gl) {
    // OpenGL (and WebGL) have "CCW == front" winding
    const triangleVertexIndices = new Uint16Array([
        0,
        1,
        2,
        2,
        1,
        3
    ]);
    return $03fc80a4a4cef09e$export$f9b26b97ca2b25e9(gl, triangleVertexIndices);
}
function $e534681c41547152$var$createAndConfigureTexture(gl, width, height, internalFormat, textureFormat, textureType) {
    $03fc80a4a4cef09e$export$3543950a45505554(width, height);
    const texture = $03fc80a4a4cef09e$export$37b981a8c575f415(gl);
    const tex2d = gl.TEXTURE_2D;
    $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.bindTexture(tex2d, texture));
    $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.texParameteri(tex2d, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE));
    $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.texParameteri(tex2d, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE));
    $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.texParameteri(tex2d, gl.TEXTURE_MIN_FILTER, gl.NEAREST));
    $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.texParameteri(tex2d, gl.TEXTURE_MAG_FILTER, gl.NEAREST));
    if ((0, $i64bB.env)().getNumber('WEBGL_VERSION') === 1) $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.texImage2D(tex2d, 0, internalFormat, width, height, 0, textureFormat, textureType, null));
    else $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.texStorage2D(tex2d, 1, internalFormat, width, height));
    $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.bindTexture(gl.TEXTURE_2D, null));
    return {
        texture: texture,
        texShape: [
            height,
            width
        ]
    };
}
function $e534681c41547152$export$46e83db9ed4a55ec(textureConfig) {
    return textureConfig.internalFormatFloat;
}
function $e534681c41547152$export$b6545ebc87bceaba(gl, rows, columns, textureConfig) {
    const [width, height] = $c7d2caaa716d42d2$export$95fb8493b25f77a4(rows, columns);
    return $e534681c41547152$var$createAndConfigureTexture(gl, width, height, $e534681c41547152$export$46e83db9ed4a55ec(textureConfig), textureConfig.textureFormatFloat, gl.FLOAT);
}
function $e534681c41547152$export$c3c5df7eccaed480(textureConfig) {
    return textureConfig.internalFormatHalfFloat;
}
function $e534681c41547152$export$3e231b7a052616c2(gl, rows, columns, textureConfig) {
    const [width, height] = $c7d2caaa716d42d2$export$95fb8493b25f77a4(rows, columns);
    return $e534681c41547152$var$createAndConfigureTexture(gl, width, height, $e534681c41547152$export$c3c5df7eccaed480(textureConfig), textureConfig.textureFormatFloat, textureConfig.textureTypeHalfFloat);
}
function $e534681c41547152$export$ed62004e3546feef(textureConfig) {
    return textureConfig.downloadTextureFormat;
}
function $e534681c41547152$export$23456bef7917c292(gl, rows, columns, textureConfig) {
    const [width, height] = $c7d2caaa716d42d2$export$95fb8493b25f77a4(rows, columns);
    return $e534681c41547152$var$createAndConfigureTexture(gl, width, height, $e534681c41547152$export$ed62004e3546feef(textureConfig), gl.RGBA, gl.UNSIGNED_BYTE);
}
function $e534681c41547152$export$dcae4a9709a9d6(textureConfig) {
    return textureConfig.internalFormatPackedFloat;
}
function $e534681c41547152$export$9edab265a05c8d3a(gl, rows, columns, textureConfig) {
    const [width, height] = $c7d2caaa716d42d2$export$2754e02fa98f5582(rows, columns);
    return $e534681c41547152$var$createAndConfigureTexture(gl, width, height, $e534681c41547152$export$dcae4a9709a9d6(textureConfig), gl.RGBA, gl.FLOAT);
}
function $e534681c41547152$export$9b8d6c2b6b2037b0(textureConfig) {
    return textureConfig.internalFormatPackedHalfFloat;
}
function $e534681c41547152$export$9c51ae7c3160b50c(gl, rows, columns, textureConfig) {
    const [width, height] = $c7d2caaa716d42d2$export$2754e02fa98f5582(rows, columns);
    return $e534681c41547152$var$createAndConfigureTexture(gl, width, height, $e534681c41547152$export$9b8d6c2b6b2037b0(textureConfig), gl.RGBA, textureConfig.textureTypeHalfFloat);
}
function $e534681c41547152$export$9080d84e4e2d38c9(gl, program, vertexBuffer) {
    const posOffset = 0; // x is the first buffer element
    const uvOffset = 12; // uv comes after [x y z]
    const stride = 20; // xyz + uv, each entry is 4-byte float.
    $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.bindBuffer(gl.ARRAY_BUFFER, vertexBuffer));
    const success = $03fc80a4a4cef09e$export$4c858b3c953a013f(gl, program, 'clipSpacePos', vertexBuffer, 3, stride, posOffset);
    return success && $03fc80a4a4cef09e$export$4c858b3c953a013f(gl, program, 'uv', vertexBuffer, 2, stride, uvOffset);
}
function $e534681c41547152$export$fe948dd2858cae63(gl, texture, width, height, data, textureConfig) {
    $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.bindTexture(gl.TEXTURE_2D, texture));
    let dataForUpload, texelDataType, internalFormat;
    if (data instanceof Uint8Array) {
        dataForUpload = new Uint8Array(width * height * 4);
        texelDataType = gl.UNSIGNED_BYTE;
        internalFormat = gl.RGBA;
    } else {
        dataForUpload = new Float32Array(width * height * 4);
        texelDataType = gl.FLOAT;
        internalFormat = textureConfig.internalFormatPackedFloat;
    }
    dataForUpload.set(data);
    if ((0, $i64bB.env)().getNumber('WEBGL_VERSION') === 2) $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, width, height, gl.RGBA, texelDataType, dataForUpload));
    else $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.texImage2D(gl.TEXTURE_2D, 0, internalFormat, width, height, 0, gl.RGBA, texelDataType, dataForUpload));
    $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.bindTexture(gl.TEXTURE_2D, null));
}
function $e534681c41547152$export$2d42c33b8625a8d7(gl, texture, pixels) {
    $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.bindTexture(gl.TEXTURE_2D, texture));
    if (pixels.data instanceof Uint8Array) {
        if ((0, $i64bB.env)().getNumber('WEBGL_VERSION') === 2) $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, pixels.width, pixels.height, gl.RGBA, gl.UNSIGNED_BYTE, pixels.data));
        else $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, pixels.width, pixels.height, 0, gl.RGBA, gl.UNSIGNED_BYTE, pixels.data));
    } else if ((0, $i64bB.env)().getNumber('WEBGL_VERSION') === 2) $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, gl.RGBA, gl.UNSIGNED_BYTE, pixels));
    else $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, pixels));
    $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.bindTexture(gl.TEXTURE_2D, null));
}
function $e534681c41547152$export$2983fc3c819070e9(gl2, rows, columns, textureConfig) {
    // Create and bind the buffer.
    const buffer = gl2.createBuffer();
    $03fc80a4a4cef09e$export$7642ac97981532b8(gl2, ()=>gl2.bindBuffer(gl2.PIXEL_PACK_BUFFER, buffer));
    // Initialize the buffer to the size of the texture in bytes.
    const bytesPerFloat = 4;
    const valuesPerTexel = 4;
    const bufferSizeBytes = bytesPerFloat * valuesPerTexel * rows * columns;
    $03fc80a4a4cef09e$export$7642ac97981532b8(gl2, ()=>gl2.bufferData(gl2.PIXEL_PACK_BUFFER, bufferSizeBytes, gl2.STREAM_READ));
    // Enqueue a command on the GPU command queue to copy of texture into the
    // buffer.
    $03fc80a4a4cef09e$export$7642ac97981532b8(gl2, ()=>gl2.readPixels(0, 0, columns, rows, gl2.RGBA, gl2.FLOAT, 0));
    $03fc80a4a4cef09e$export$7642ac97981532b8(gl2, ()=>gl2.bindBuffer(gl2.PIXEL_PACK_BUFFER, null));
    return buffer;
}
function $e534681c41547152$export$3d2780ea6b3027ca(gl, buffer, size) {
    const gl2 = gl;
    const downloadTarget = new Float32Array(size);
    gl2.bindBuffer(gl2.PIXEL_PACK_BUFFER, buffer);
    gl2.getBufferSubData(gl2.PIXEL_PACK_BUFFER, 0, downloadTarget);
    gl2.bindBuffer(gl2.PIXEL_PACK_BUFFER, null);
    return downloadTarget;
}
function $e534681c41547152$export$6bc5a1ce24b8dc6c(gl, rows, columns, textureConfig) {
    const [w, h] = $c7d2caaa716d42d2$export$95fb8493b25f77a4(rows, columns);
    const numChannels = 4;
    const downloadTarget = new Uint8Array($c7d2caaa716d42d2$export$9427543edb6e188a(rows * columns, numChannels));
    $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.readPixels(0, 0, w, h, textureConfig.downloadTextureFormat, gl.UNSIGNED_BYTE, downloadTarget));
    // By wrapping the buffer in a Float32Array, we use native browser IEEE 754
    // decoding of the 4 bytes that back each 32 bit float.
    return new Float32Array(downloadTarget.buffer);
}
function $e534681c41547152$export$4fe1bc4caaf85c22(gl, buffer, batch, rows, cols, physicalRows, physicalCols, textureConfig) {
    const gl2 = gl;
    const downloadTarget = new Float32Array($c7d2caaa716d42d2$export$12d4e412f879b1d4(physicalRows, physicalCols));
    gl2.bindBuffer(gl2.PIXEL_PACK_BUFFER, buffer);
    gl2.getBufferSubData(gl2.PIXEL_PACK_BUFFER, 0, downloadTarget);
    gl2.bindBuffer(gl2.PIXEL_PACK_BUFFER, null);
    return downloadTarget;
}
function $e534681c41547152$export$7287c6a301610ce2(gl, physicalRows, physicalCols) {
    const packedRGBA = new Float32Array(physicalRows * physicalCols * 4);
    $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.readPixels(0, 0, physicalCols, physicalRows, gl.RGBA, gl.FLOAT, packedRGBA));
    return packedRGBA;
}




class $f5ed9b9a408ee659$export$fa7a74a0ce382ac5 {
    constructor(gl){
        this.outputTexture = null;
        this.program = null;
        this.disposed = false;
        this.itemsToPoll = [];
        const glVersion = (0, $i64bB.env)().getNumber('WEBGL_VERSION');
        if (gl != null) {
            this.gl = gl;
            (0, $49455ae585dac16a$export$4b8d5e1525955c68)(glVersion, gl);
        } else this.gl = (0, $49455ae585dac16a$export$c7a808a518b9a146)(glVersion);
        gl = this.gl;
        if ((0, $i64bB.env)().getNumber('WEBGL_VERSION') === 2) {
            const gl2 = gl;
            this.createVertexArray = ()=>{
                return $03fc80a4a4cef09e$export$7642ac97981532b8(gl2, ()=>gl2.createVertexArray());
            };
            this.bindVertexArray = (vao)=>{
                return $03fc80a4a4cef09e$export$7642ac97981532b8(gl2, ()=>gl2.bindVertexArray(vao));
            };
            this.deleteVertexArray = (vao)=>{
                return $03fc80a4a4cef09e$export$7642ac97981532b8(gl2, ()=>gl2.deleteVertexArray(vao));
            };
            this.getVertexArray = ()=>{
                return $03fc80a4a4cef09e$export$7642ac97981532b8(gl2, ()=>gl2.getParameter(gl2.VERTEX_ARRAY_BINDING));
            };
        } else if (gl != null) {
            const ext = gl.getExtension('OES_vertex_array_object');
            if (ext == null) throw new Error("All WebGL1 implementations are expected to offer OES_vertex_array_object.");
            this.createVertexArray = ()=>{
                return $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>ext.createVertexArrayOES());
            };
            this.bindVertexArray = (vao)=>{
                return $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>ext.bindVertexArrayOES(vao));
            };
            this.deleteVertexArray = (vao)=>{
                return $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>ext.deleteVertexArrayOES(vao));
            };
            this.getVertexArray = ()=>{
                return $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.getParameter(ext.VERTEX_ARRAY_BINDING_OES));
            };
        }
        // WebGL 2.0 enables texture floats without an extension.
        let COLOR_BUFFER_FLOAT = 'WEBGL_color_buffer_float';
        const COLOR_BUFFER_HALF_FLOAT = 'EXT_color_buffer_half_float';
        this.parallelCompilationExtension = this.gl.getExtension('KHR_parallel_shader_compile');
        if ((0, $i64bB.env)().getNumber('WEBGL_VERSION') === 1) {
            const TEXTURE_FLOAT = 'OES_texture_float';
            const TEXTURE_HALF_FLOAT = 'OES_texture_half_float';
            this.textureFloatExtension = $03fc80a4a4cef09e$export$3a5e7a891790a26c(this.gl, TEXTURE_FLOAT);
            if ($03fc80a4a4cef09e$export$4f402f57c05c9ec3(this.gl, TEXTURE_HALF_FLOAT)) this.textureHalfFloatExtension = $03fc80a4a4cef09e$export$3a5e7a891790a26c(this.gl, TEXTURE_HALF_FLOAT);
            else if ((0, $i64bB.env)().get('WEBGL_FORCE_F16_TEXTURES')) throw new Error("GL context does not support half float textures, yet the environment flag WEBGL_FORCE_F16_TEXTURES is set to true.");
            this.colorBufferFloatExtension = this.gl.getExtension(COLOR_BUFFER_FLOAT);
            if ($03fc80a4a4cef09e$export$4f402f57c05c9ec3(this.gl, COLOR_BUFFER_HALF_FLOAT)) this.colorBufferHalfFloatExtension = $03fc80a4a4cef09e$export$3a5e7a891790a26c(this.gl, COLOR_BUFFER_HALF_FLOAT);
            else if ((0, $i64bB.env)().get('WEBGL_FORCE_F16_TEXTURES')) throw new Error("GL context does not support color renderable half floats, yet the environment flag WEBGL_FORCE_F16_TEXTURES is set to true.");
        } else {
            COLOR_BUFFER_FLOAT = 'EXT_color_buffer_float';
            if ($03fc80a4a4cef09e$export$4f402f57c05c9ec3(this.gl, COLOR_BUFFER_FLOAT)) this.colorBufferFloatExtension = this.gl.getExtension(COLOR_BUFFER_FLOAT);
            else if ($03fc80a4a4cef09e$export$4f402f57c05c9ec3(this.gl, COLOR_BUFFER_HALF_FLOAT)) this.colorBufferHalfFloatExtension = this.gl.getExtension(COLOR_BUFFER_HALF_FLOAT);
            else throw new Error('GL context does not support color renderable floats');
        }
        this.vertexBuffer = $e534681c41547152$export$8ddd35f9c5bd5634(this.gl);
        this.indexBuffer = $e534681c41547152$export$2be7df49658092d0(this.gl);
        this.framebuffer = $03fc80a4a4cef09e$export$366d1e3e32f5a700(this.gl);
        this.textureConfig = $c7d2caaa716d42d2$export$129d92ae6e74c416(this.gl, this.textureHalfFloatExtension);
    }
    get debug() {
        return (0, $i64bB.env)().getBool('DEBUG');
    }
    dispose() {
        if (this.disposed) return;
        if (this.program != null) console.warn("Disposing a GPGPUContext that still has a bound WebGLProgram. This is probably a resource leak, delete the program with GPGPUContext.deleteProgram before disposing.");
        if (this.outputTexture != null) console.warn("Disposing a GPGPUContext that still has a bound output matrix texture.  This is probably a resource leak, delete the output matrix texture with GPGPUContext.deleteMatrixTexture before disposing.");
        const gl = this.gl;
        $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.finish());
        $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.bindFramebuffer(gl.FRAMEBUFFER, null));
        $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.deleteFramebuffer(this.framebuffer));
        $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.bindBuffer(gl.ARRAY_BUFFER, null));
        $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null));
        $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.deleteBuffer(this.indexBuffer));
        this.disposed = true;
    }
    createFloat32MatrixTexture(rows, columns) {
        this.throwIfDisposed();
        return $e534681c41547152$export$b6545ebc87bceaba(this.gl, rows, columns, this.textureConfig);
    }
    createFloat16MatrixTexture(rows, columns) {
        this.throwIfDisposed();
        return $e534681c41547152$export$3e231b7a052616c2(this.gl, rows, columns, this.textureConfig);
    }
    createUnsignedBytesMatrixTexture(rows, columns) {
        this.throwIfDisposed();
        return $e534681c41547152$export$23456bef7917c292(this.gl, rows, columns, this.textureConfig);
    }
    uploadPixelDataToTexture(texture, pixels) {
        this.throwIfDisposed();
        $e534681c41547152$export$2d42c33b8625a8d7(this.gl, texture, pixels);
    }
    uploadDenseMatrixToTexture(texture, width, height, data) {
        this.throwIfDisposed();
        $e534681c41547152$export$fe948dd2858cae63(this.gl, texture, width, height, data, this.textureConfig);
    }
    createFloat16PackedMatrixTexture(rows, columns) {
        this.throwIfDisposed();
        return $e534681c41547152$export$9c51ae7c3160b50c(this.gl, rows, columns, this.textureConfig);
    }
    createPackedMatrixTexture(rows, columns) {
        this.throwIfDisposed();
        return $e534681c41547152$export$9edab265a05c8d3a(this.gl, rows, columns, this.textureConfig);
    }
    deleteMatrixTexture(texture) {
        this.throwIfDisposed();
        if (this.outputTexture === texture) {
            $03fc80a4a4cef09e$export$d3c809959a3c24fa(this.gl, this.framebuffer);
            this.outputTexture = null;
        }
        $03fc80a4a4cef09e$export$7642ac97981532b8(this.gl, ()=>this.gl.deleteTexture(texture));
    }
    downloadByteEncodedFloatMatrixFromOutputTexture(texture, rows, columns) {
        return this.downloadMatrixDriver(texture, ()=>$e534681c41547152$export$6bc5a1ce24b8dc6c(this.gl, rows, columns, this.textureConfig));
    }
    downloadPackedMatrixFromBuffer(buffer, batch, rows, columns, physicalRows, physicalCols) {
        return $e534681c41547152$export$4fe1bc4caaf85c22(this.gl, buffer, batch, rows, columns, physicalRows, physicalCols, this.textureConfig);
    }
    downloadFloat32MatrixFromBuffer(buffer, size) {
        return $e534681c41547152$export$3d2780ea6b3027ca(this.gl, buffer, size);
    }
    createBufferFromTexture(texture, rows, columns) {
        this.bindTextureToFrameBuffer(texture);
        const result = $e534681c41547152$export$2983fc3c819070e9(this.gl, rows, columns, this.textureConfig);
        this.unbindTextureToFrameBuffer();
        return result;
    }
    createAndWaitForFence() {
        const fenceContext = this.createFence(this.gl);
        return this.pollFence(fenceContext);
    }
    createFence(gl) {
        let query;
        let isFencePassed;
        if ((0, $i64bB.env)().getBool('WEBGL_FENCE_API_ENABLED')) {
            const gl2 = gl;
            const sync = gl2.fenceSync(gl2.SYNC_GPU_COMMANDS_COMPLETE, 0);
            gl.flush();
            isFencePassed = ()=>{
                const status = gl2.clientWaitSync(sync, 0, 0);
                return status === gl2.ALREADY_SIGNALED || status === gl2.CONDITION_SATISFIED;
            };
            query = sync;
        } else if ((0, $i64bB.env)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION') > 0) {
            query = this.beginQuery();
            this.endQuery();
            isFencePassed = ()=>this.isQueryAvailable(query, (0, $i64bB.env)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION'));
        } else // If we have no way to fence, return true immediately. This will fire in
        // WebGL 1.0 when there is no disjoint query timer. In this case, because
        // the fence passes immediately, we'll immediately ask for a download of
        // the texture, which will cause the UI thread to hang.
        isFencePassed = ()=>true;
        return {
            query: query,
            isFencePassed: isFencePassed
        };
    }
    downloadMatrixFromPackedTexture(texture, physicalRows, physicalCols) {
        return this.downloadMatrixDriver(texture, ()=>$e534681c41547152$export$7287c6a301610ce2(this.gl, physicalRows, physicalCols));
    }
    createProgram(fragmentShader) {
        this.throwIfDisposed();
        const gl = this.gl;
        if (this.vertexShader == null) this.vertexShader = $e534681c41547152$export$4ca6704ce1875929(gl);
        const program = $03fc80a4a4cef09e$export$327d24a04cd0dc17(gl);
        $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.attachShader(program, this.vertexShader));
        $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.attachShader(program, fragmentShader));
        $03fc80a4a4cef09e$export$d879afae78b531a5(gl, program);
        const program2 = Object.assign(program, {
            vao: this.createVertexArray()
        });
        if (this.debug) $03fc80a4a4cef09e$export$e2dfaf93681cde16(gl, program2);
        return program2;
    }
    buildVao(program) {
        this.setProgram(program);
        this.bindVertexArray(program.vao);
        const gl = this.gl;
        // Bind index buffer, and vertex buffers based on program attrib
        // locations.
        $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.indexBuffer));
        $e534681c41547152$export$9080d84e4e2d38c9(gl, program, this.vertexBuffer);
    }
    deleteProgram(program) {
        this.throwIfDisposed();
        if (program === this.program) this.program = null;
        if (program != null) {
            $03fc80a4a4cef09e$export$7642ac97981532b8(this.gl, ()=>this.gl.deleteProgram(program));
            this.deleteVertexArray(program.vao);
        }
    }
    setProgram(program) {
        this.throwIfDisposed();
        this.program = program;
        if (this.program != null) {
            if (this.debug) $03fc80a4a4cef09e$export$e2dfaf93681cde16(this.gl, this.program);
        }
        $03fc80a4a4cef09e$export$7642ac97981532b8(this.gl, ()=>this.gl.useProgram(program));
    }
    getUniformLocation(program, uniformName, shouldThrow = true) {
        this.throwIfDisposed();
        if (shouldThrow) return $03fc80a4a4cef09e$export$748cafa2cdf50d8(this.gl, program, uniformName);
        else return $03fc80a4a4cef09e$export$d27256445dd7e8dd(this.gl, program, uniformName);
    }
    getAttributeLocation(program, attribute) {
        this.throwIfDisposed();
        return $03fc80a4a4cef09e$export$7642ac97981532b8(this.gl, ()=>this.gl.getAttribLocation(program, attribute));
    }
    getUniformLocationNoThrow(program, uniformName) {
        this.throwIfDisposed();
        return this.gl.getUniformLocation(program, uniformName);
    }
    setInputMatrixTexture(inputMatrixTexture, uniformLocation, textureUnit) {
        this.throwIfDisposed();
        this.throwIfNoProgram();
        $03fc80a4a4cef09e$export$f9ffd997f3c8b98f(this.gl, inputMatrixTexture, uniformLocation, textureUnit);
    }
    setOutputMatrixTexture(outputMatrixTexture, rows, columns) {
        this.setOutputMatrixTextureDriver(outputMatrixTexture, columns, rows);
    }
    setOutputPackedMatrixTexture(outputPackedMatrixTexture, rows, columns) {
        this.throwIfDisposed();
        const [width, height] = $c7d2caaa716d42d2$export$2754e02fa98f5582(rows, columns);
        this.setOutputMatrixTextureDriver(outputPackedMatrixTexture, width, height);
    }
    setOutputMatrixWriteRegion(startRow, numRows, startColumn, numColumns) {
        this.setOutputMatrixWriteRegionDriver(startColumn, startRow, numColumns, numRows);
    }
    setOutputPackedMatrixWriteRegion(startRow, numRows, startColumn, numColumns) {
        throw new Error('setOutputPackedMatrixWriteRegion not implemented.');
    }
    debugValidate() {
        if (this.program != null) $03fc80a4a4cef09e$export$e2dfaf93681cde16(this.gl, this.program);
        $03fc80a4a4cef09e$export$ca09b577525e6519(this.gl);
    }
    executeProgram() {
        this.throwIfDisposed();
        this.throwIfNoProgram();
        const gl = this.gl;
        if (this.debug) {
            const boundVao = this.getVertexArray();
            console.assert(boundVao === this.program.vao, 'VAO changed between setProgram and executeProgram!');
            this.debugValidate();
        }
        $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.drawElements(gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0));
    }
    blockUntilAllProgramsCompleted() {
        this.throwIfDisposed();
        $03fc80a4a4cef09e$export$7642ac97981532b8(this.gl, ()=>this.gl.finish());
    }
    getQueryTimerExtension() {
        if (this.disjointQueryTimerExtension == null) this.disjointQueryTimerExtension = $03fc80a4a4cef09e$export$3a5e7a891790a26c(this.gl, (0, $i64bB.env)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION') === 2 ? 'EXT_disjoint_timer_query_webgl2' : 'EXT_disjoint_timer_query');
        return this.disjointQueryTimerExtension;
    }
    getQueryTimerExtensionWebGL2() {
        return this.getQueryTimerExtension();
    }
    getQueryTimerExtensionWebGL1() {
        return this.getQueryTimerExtension();
    }
    beginQuery() {
        if ((0, $i64bB.env)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION') === 2) {
            const gl2 = this.gl;
            const ext = this.getQueryTimerExtensionWebGL2();
            const query = gl2.createQuery();
            gl2.beginQuery(ext.TIME_ELAPSED_EXT, query);
            return query;
        }
        const ext = this.getQueryTimerExtensionWebGL1();
        const query = ext.createQueryEXT();
        ext.beginQueryEXT(ext.TIME_ELAPSED_EXT, query);
        return query;
    }
    endQuery() {
        if ((0, $i64bB.env)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION') === 2) {
            const gl2 = this.gl;
            const ext = this.getQueryTimerExtensionWebGL2();
            gl2.endQuery(ext.TIME_ELAPSED_EXT);
            return;
        }
        const ext = this.getQueryTimerExtensionWebGL1();
        ext.endQueryEXT(ext.TIME_ELAPSED_EXT);
    }
    async waitForQueryAndGetTime(query) {
        await (0, $i64bB.util).repeatedTry(()=>this.disposed || // while testing contexts are created / disposed
            // in rapid succession, so without this check we
            // may poll for the query timer indefinitely
            this.isQueryAvailable(query, (0, $i64bB.env)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION')));
        return this.getQueryTime(query, (0, $i64bB.env)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION'));
    }
    getQueryTime(query, queryTimerVersion) {
        if (queryTimerVersion === 0) return null;
        if (queryTimerVersion === 2) {
            const gl2 = this.gl;
            const timeElapsedNanos = gl2.getQueryParameter(query, gl2.QUERY_RESULT);
            // Return milliseconds.
            return timeElapsedNanos / 1000000;
        } else {
            const ext = this.getQueryTimerExtensionWebGL1();
            const timeElapsedNanos = ext.getQueryObjectEXT(query, ext.QUERY_RESULT_EXT);
            // Return milliseconds.
            return timeElapsedNanos / 1000000;
        }
    }
    isQueryAvailable(query, queryTimerVersion) {
        if (queryTimerVersion === 0) return true;
        if (queryTimerVersion === 2) {
            const gl2 = this.gl;
            const ext = this.getQueryTimerExtensionWebGL2();
            const available = gl2.getQueryParameter(query, gl2.QUERY_RESULT_AVAILABLE);
            if (this.disjoint == null) this.disjoint = this.gl.getParameter(ext.GPU_DISJOINT_EXT);
            return available && !this.disjoint;
        } else {
            const ext = this.getQueryTimerExtensionWebGL1();
            const available = ext.getQueryObjectEXT(query, ext.QUERY_RESULT_AVAILABLE_EXT);
            if (this.disjoint == null) this.disjoint = this.gl.getParameter(ext.GPU_DISJOINT_EXT);
            return available && !this.disjoint;
        }
    }
    pollFence(fenceContext) {
        return new Promise((resolve)=>{
            this.addItemToPoll(()=>fenceContext.isFencePassed(), ()=>resolve());
        });
    }
    pollItems() {
        // Find the last query that has finished.
        const index = $f5ed9b9a408ee659$export$4a09b41294052731(this.itemsToPoll.map((x)=>x.isDoneFn));
        for(let i = 0; i <= index; ++i){
            const { resolveFn: resolveFn } = this.itemsToPoll[i];
            resolveFn();
        }
        this.itemsToPoll = this.itemsToPoll.slice(index + 1);
    }
    addItemToPoll(isDoneFn, resolveFn) {
        this.itemsToPoll.push({
            isDoneFn: isDoneFn,
            resolveFn: resolveFn
        });
        if (this.itemsToPoll.length > 1) // We already have a running loop that polls.
        return;
        // Start a new loop that polls.
        let scheduleFn = undefined;
        if ('setTimeoutCustom' in (0, $i64bB.env)().platform) scheduleFn = (0, $i64bB.env)().platform.setTimeoutCustom.bind((0, $i64bB.env)().platform);
        (0, $i64bB.util).repeatedTry(()=>{
            this.pollItems();
            // End the loop if no more items to poll.
            return this.itemsToPoll.length === 0;
        }, ()=>0, null, scheduleFn);
    }
    bindTextureToFrameBuffer(texture) {
        this.throwIfDisposed();
        $03fc80a4a4cef09e$export$4e154f0d71f19013(this.gl, texture, this.framebuffer);
        if (this.debug) $03fc80a4a4cef09e$export$ca09b577525e6519(this.gl);
    }
    unbindTextureToFrameBuffer() {
        if (this.outputTexture != null) {
            $03fc80a4a4cef09e$export$4e154f0d71f19013(this.gl, this.outputTexture, this.framebuffer);
            if (this.debug) $03fc80a4a4cef09e$export$ca09b577525e6519(this.gl);
        } else $03fc80a4a4cef09e$export$d3c809959a3c24fa(this.gl, this.framebuffer);
    }
    downloadMatrixDriver(texture, downloadAndDecode) {
        this.bindTextureToFrameBuffer(texture);
        const result = downloadAndDecode();
        this.unbindTextureToFrameBuffer();
        return result;
    }
    setOutputMatrixTextureDriver(outputMatrixTextureMaybePacked, width, height) {
        this.throwIfDisposed();
        const gl = this.gl;
        $03fc80a4a4cef09e$export$4e154f0d71f19013(gl, outputMatrixTextureMaybePacked, this.framebuffer);
        if (this.debug) $03fc80a4a4cef09e$export$ca09b577525e6519(gl);
        this.outputTexture = outputMatrixTextureMaybePacked;
        $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.viewport(0, 0, width, height));
        $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.scissor(0, 0, width, height));
    }
    setOutputMatrixWriteRegionDriver(x, y, width, height) {
        this.throwIfDisposed();
        $03fc80a4a4cef09e$export$7642ac97981532b8(this.gl, ()=>this.gl.scissor(x, y, width, height));
    }
    throwIfDisposed() {
        if (this.disposed) throw new Error('Attempted to use disposed GPGPUContext.');
    }
    throwIfNoProgram() {
        if (this.program == null) throw new Error('No GPU program is currently set.');
    }
}
function $f5ed9b9a408ee659$export$4a09b41294052731(arr) {
    let i = 0;
    for(; i < arr.length; ++i){
        const isDone = arr[i]();
        if (!isDone) break;
    }
    return i - 1;
}



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Import shared functionality from tfjs-backend-cpu without triggering
// side effects.
// tslint:disable-next-line: no-imports-from-dist

var $9nCi0 = parcelRequire("9nCi0");
const { addImpl: $377486a788efd20b$export$c7f405723b4a93e7, bincountImpl: $377486a788efd20b$export$566def819e5d4601, bincountReduceImpl: $377486a788efd20b$export$447b89266e53682e, bitwiseAndImpl: $377486a788efd20b$export$b9ea48282fa3ef20, castImpl: $377486a788efd20b$export$babf602309dd6292, ceilImpl: $377486a788efd20b$export$bb3ce81256fe261b, concatImpl: $377486a788efd20b$export$95e7342d25849d64, equalImpl: $377486a788efd20b$export$13d1298222b29d06, expImpl: $377486a788efd20b$export$f72e179c9610cb8c, expm1Impl: $377486a788efd20b$export$5903785c29f035f5, floorImpl: $377486a788efd20b$export$195a28e6add8ab7e, gatherNdImpl: $377486a788efd20b$export$e3196a12dce24214, gatherV2Impl: $377486a788efd20b$export$cffe0fde89e98de6, greaterImpl: $377486a788efd20b$export$eabb8927944259dd, greaterEqualImpl: $377486a788efd20b$export$a3d2e203d979d298, lessImpl: $377486a788efd20b$export$74c893b3c5e74e60, lessEqualImpl: $377486a788efd20b$export$6d1533a3ea9565f, linSpaceImpl: $377486a788efd20b$export$c86a2be8970d7a7d, logImpl: $377486a788efd20b$export$e88dde64a338f813, maxImpl: $377486a788efd20b$export$a94164c9f637858e, maximumImpl: $377486a788efd20b$export$b3afdc53a543e175, minimumImpl: $377486a788efd20b$export$1f01be3f637863fa, multiplyImpl: $377486a788efd20b$export$598d1d66b05a298f, negImpl: $377486a788efd20b$export$1cbcde7624effb15, notEqualImpl: $377486a788efd20b$export$b91372753635df24, prodImpl: $377486a788efd20b$export$2d654219115cec80, raggedGatherImpl: $377486a788efd20b$export$7cf38d50772f4bbc, raggedRangeImpl: $377486a788efd20b$export$46d9d0942af5d1c2, raggedTensorToTensorImpl: $377486a788efd20b$export$b3c4ab635ddc431f, rangeImpl: $377486a788efd20b$export$fbee6deed7e76443, rsqrtImpl: $377486a788efd20b$export$431ccb02913a1aee, scatterImpl: $377486a788efd20b$export$2295c910080b5ca7, sigmoidImpl: $377486a788efd20b$export$9b816377c2ca1f1f, simpleAbsImpl: $377486a788efd20b$export$d7efa3585619eabe, sliceImpl: $377486a788efd20b$export$45812d0d8578899, sparseFillEmptyRowsImpl: $377486a788efd20b$export$6cee5fb970d08428, sparseReshapeImpl: $377486a788efd20b$export$d17b3360054ff370, sparseSegmentReductionImpl: $377486a788efd20b$export$a503222c03b33888, sqrtImpl: $377486a788efd20b$export$548a22b20eeaf85b, staticRegexReplaceImpl: $377486a788efd20b$export$b3e893e48b8d1e39, stridedSliceImpl: $377486a788efd20b$export$efd4e188e5de0188, stringNGramsImpl: $377486a788efd20b$export$bb9e83cb65884ef3, stringSplitImpl: $377486a788efd20b$export$bb4b4a9a1db97dea, stringToHashBucketFastImpl: $377486a788efd20b$export$d7d8a9bba3df6e63, subImpl: $377486a788efd20b$export$be7474e96b733333, tileImpl: $377486a788efd20b$export$349e02a266ab3131, topKImpl: $377486a788efd20b$export$cc4aa6851cf96e2b, transposeImpl: $377486a788efd20b$export$a0105d4a7143676c, uniqueImpl: $377486a788efd20b$export$c417de669ad2e148 } = $9nCi0;


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $30912e1180ed417f$export$a7c2113d79df2971(name, rank) {
    return [
        'x',
        'y',
        'z',
        'w',
        'u',
        'v'
    ].slice(0, rank).map((d)=>`${name}.${d}`);
}
function $30912e1180ed417f$export$7a4d1d0d17b69972(name, rank) {
    if (rank === 1) return [
        name
    ];
    return $30912e1180ed417f$export$a7c2113d79df2971(name, rank);
}
function $30912e1180ed417f$export$8f96407d418c6727(rank, dims) {
    if (rank === 1) return 'rc';
    let coords = '';
    for(let i = 0; i < rank; i++){
        coords += dims[i];
        if (i < rank - 1) coords += ',';
    }
    return coords;
}



class $1a35e3fb33e208e0$export$5ebf74a9a135ce1d {
    constructor(outputShape){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = false;
        this.packedOutput = true;
        // Only input / output 3D tensors.
        this.outputShape = outputShape;
        this.rank = outputShape.length;
        this.enableShapeUniforms = (0, $8c928040c80f573b$export$5acc770fc06a0138)(this.outputShape.length);
        if (this.rank === 0) this.userCode = `
        void main() {
          setOutput(vec4(getA(), 0., 0., 0.));
        }
      `;
        else {
            const channels = (0, $30912e1180ed417f$export$7a4d1d0d17b69972)('rc', this.rank);
            const dtype = (0, $ba2c54ffbda39e8e$export$859efd105c10c755)(this.rank);
            const outOfBoundsCondition = this.getOutOfBoundsCondition(channels);
            const setup = this.getSetup(channels);
            const output = this.getOutput(channels);
            this.userCode = `
        void main() {
          ${dtype} rc = getOutputCoords();

          if(${outOfBoundsCondition}) {
            setOutput(vec4(0));
          } else {
            ${setup}

            setOutput(vec4(${output}));
          }
        }
      `;
        }
    }
    getSourceCoordsArr(dims) {
        const coords = [];
        for(let row = 0; row <= 1; row++)for(let col = 0; col <= 1; col++){
            let coord = `${row === 0 ? 'r' : 'rp1'}, ${col === 0 ? 'c' : 'cp1'}`;
            for(let d = 2; d < this.rank; d++)coord = `${dims[dims.length - 1 - d]},` + coord;
            coords.push(coord);
        }
        return coords;
    }
    getOutOfBoundsCondition(dims) {
        if (this.rank === 1) return `rc > ${this.enableShapeUniforms ? 'outShape' : this.outputShape[0]}`;
        let cond = '';
        for(let i = this.rank - 2; i < this.rank; i++){
            cond += `${dims[i]} >= ${this.enableShapeUniforms ? `outShape[${i}]` : this.outputShape[i]}`;
            if (i < this.rank - 1) cond += '||';
        }
        return cond;
    }
    getSetup(dims) {
        if (this.rank === 1) return '';
        const innerDims = dims.slice(-2);
        const col = this.enableShapeUniforms ? `outShape[${this.rank} - 1]` : this.outputShape[this.rank - 1];
        const row = this.enableShapeUniforms ? `outShape[${this.rank} - 2]` : this.outputShape[this.rank - 2];
        return `
      int r = ${innerDims[0]};
      int c = ${innerDims[1]};
      int rp1 = r + 1;
      int cp1 = c + 1;

      bool cEdge = cp1 >= ${col};
      bool rEdge = rp1 >= ${row};
    `;
    }
    getOutput(dims) {
        const sourceCoords = this.getSourceCoordsArr(dims);
        if (this.rank === 1) {
            const outShape = this.enableShapeUniforms ? 'outShape' : this.outputShape[0];
            return `getA(rc), (rc + 1 >= ${outShape} ? 0. : getA(rc + 1)), 0, 0`;
        }
        return `getA(${sourceCoords[0]}),
            cEdge ? 0. : getA(${sourceCoords[1]}),
            rEdge ? 0. : getA(${sourceCoords[2]}),
            rEdge || cEdge ? 0. : getA(${sourceCoords[3]})`;
    }
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $49ff511a513b21e1$export$ce249f6fedcc44de {
    constructor(outputShape, inputShape){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.customUniforms = [
            {
                name: 'inputShape',
                type: 'ivec3'
            }
        ];
        this.outputShape = outputShape;
        this.enableShapeUniforms = (0, $8c928040c80f573b$export$5acc770fc06a0138)(this.outputShape.length);
        let mainLoop = ``;
        for(let i = 0; i < 4; i++){
            let thisRC = `thisRC = rc;`;
            if (i % 2 === 1) thisRC += `thisRC.z += 1;`;
            if (i > 1) thisRC += `thisRC.y += 1;`;
            mainLoop += `
        ${thisRC}
        ${i > 0 ? `if(thisRC.y < rows && thisRC.z < cols){` : ''}
          int flatIndex = getFlatIndex(thisRC);

          ivec3 inputRC = inputCoordsFromReshapedOutCoords(flatIndex);
          vec2 inputRCInnerDims = vec2(float(inputRC.y),float(inputRC.z));

          result[${i}] =
            getChannel(getA(inputRC.x, inputRC.y, inputRC.z), inputRCInnerDims);
        ${i > 0 ? '}' : ''}
      `;
        }
        this.userCode = `
      ${$49ff511a513b21e1$var$getReshapedInputCoords(inputShape, this.enableShapeUniforms)}
      ${this.enableShapeUniforms ? $30e89c7e4234424e$export$4ec1e3f6361de451() : $30e89c7e4234424e$export$4c68558c71205a01(outputShape)}

      void main() {
        ivec3 rc = getOutputCoords();

        vec4 result = vec4(0.);

        ivec3 thisRC;
        int rows = ${this.enableShapeUniforms ? 'outShape[1]' : outputShape[1]};
        int cols = ${this.enableShapeUniforms ? 'outShape[2]' : outputShape[2]};

        ${mainLoop}

        setOutput(result);
      }
    `;
    }
}
function $49ff511a513b21e1$var$getReshapedInputCoords(shape, enableShapeUniforms) {
    const coordsFromIndexSnippet = enableShapeUniforms ? $30e89c7e4234424e$export$a1b266196cc2d8ea([
        'r',
        'c',
        'd'
    ], 'inputShape') : $30e89c7e4234424e$export$53c37f67510642ce([
        'r',
        'c',
        'd'
    ], shape);
    return `
    ivec3 inputCoordsFromReshapedOutCoords(int index) {
      ${coordsFromIndexSnippet}
      return ivec3(r, c, d);
    }
  `;
}



/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


class $869b84076dcb3622$export$337f59f8fd79d24f {
    constructor(gpgpu){
        this.gpgpu = gpgpu;
        this.numUsedTextures = 0;
        this.numFreeTextures = 0;
        this._numBytesAllocated = 0;
        // Number of bytes that have been allocated and available for reuse.
        this._numBytesFree = 0;
        this.freeTextures = {};
        this.usedTextures = {};
        this.logEnabled = false;
    }
    acquireTexture(shapeRC, usage, isPacked) {
        const physicalTexType = $869b84076dcb3622$var$getPhysicalFromLogicalTextureType(usage, isPacked);
        const shapeKey = $869b84076dcb3622$var$getKeyFromTextureShape(shapeRC, physicalTexType, isPacked);
        if (!(shapeKey in this.freeTextures)) this.freeTextures[shapeKey] = [];
        if (!(shapeKey in this.usedTextures)) this.usedTextures[shapeKey] = [];
        const texBytes = $869b84076dcb3622$export$66c19e55ce03e099(shapeRC, physicalTexType, this.gpgpu.gl, this.gpgpu.textureConfig, isPacked);
        if (this.freeTextures[shapeKey].length > 0) {
            this.numFreeTextures--;
            this.numUsedTextures++;
            this._numBytesFree -= texBytes;
            this.log();
            const newTexture = this.freeTextures[shapeKey].pop();
            this.usedTextures[shapeKey].push(newTexture);
            return newTexture;
        }
        let newTexture;
        if (physicalTexType === (0, $c7d2caaa716d42d2$export$bde70ab3692e385c).PACKED_2X2_FLOAT32) newTexture = this.gpgpu.createPackedMatrixTexture(shapeRC[0], shapeRC[1]);
        else if (physicalTexType === (0, $c7d2caaa716d42d2$export$bde70ab3692e385c).PACKED_2X2_FLOAT16) newTexture = this.gpgpu.createFloat16PackedMatrixTexture(shapeRC[0], shapeRC[1]);
        else if (physicalTexType === (0, $c7d2caaa716d42d2$export$bde70ab3692e385c).UNPACKED_FLOAT32) newTexture = this.gpgpu.createFloat32MatrixTexture(shapeRC[0], shapeRC[1]);
        else if (physicalTexType === (0, $c7d2caaa716d42d2$export$bde70ab3692e385c).UNPACKED_FLOAT16) newTexture = this.gpgpu.createFloat16MatrixTexture(shapeRC[0], shapeRC[1]);
        else if (physicalTexType === (0, $c7d2caaa716d42d2$export$bde70ab3692e385c).PACKED_4X1_UNSIGNED_BYTE) newTexture = this.gpgpu.createUnsignedBytesMatrixTexture(shapeRC[0], shapeRC[1]);
        this.usedTextures[shapeKey].push(newTexture);
        this.numUsedTextures++;
        this._numBytesAllocated += texBytes;
        this.log();
        return newTexture;
    }
    releaseTexture(texture, shape, logicalTexType, isPacked) {
        if (this.freeTextures == null) // Already disposed.
        return;
        const physicalTexType = $869b84076dcb3622$var$getPhysicalFromLogicalTextureType(logicalTexType, isPacked);
        const shapeKey = $869b84076dcb3622$var$getKeyFromTextureShape(shape, physicalTexType, isPacked);
        if (!(shapeKey in this.freeTextures)) this.freeTextures[shapeKey] = [];
        const texBytes = $869b84076dcb3622$export$66c19e55ce03e099(shape, physicalTexType, this.gpgpu.gl, this.gpgpu.textureConfig, isPacked);
        const deleteTexThreshold = (0, $i64bB.env)().getNumber('WEBGL_DELETE_TEXTURE_THRESHOLD');
        if (deleteTexThreshold !== -1 && this._numBytesAllocated > deleteTexThreshold) {
            this.gpgpu.deleteMatrixTexture(texture.texture);
            this._numBytesAllocated -= texBytes;
        } else {
            this.freeTextures[shapeKey].push(texture);
            this.numFreeTextures++;
            this._numBytesFree += texBytes;
        }
        this.numUsedTextures--;
        const texList = this.usedTextures[shapeKey];
        const texIndex = texList && texList.indexOf(texture);
        if (texIndex == null || texIndex < 0) throw new Error("Cannot release a texture that was never provided by this texture manager");
        texList[texIndex] = texList[texList.length - 1];
        texList.pop();
        this.log();
    }
    log() {
        if (!this.logEnabled) return;
        const total = this.numFreeTextures + this.numUsedTextures;
        console.log('Free/Used', `${this.numFreeTextures} / ${this.numUsedTextures}`, `(${total})`);
        const freeRatio = this._numBytesFree / this._numBytesAllocated;
        console.log(`Bytes allocated: ${this._numBytesAllocated}`);
        console.log(`Bytes unused: ${this._numBytesFree} (${Math.round(100 * freeRatio)}%)`);
    }
    get numBytesAllocated() {
        return this._numBytesAllocated;
    }
    get numBytesFree() {
        return this._numBytesFree;
    }
    getNumUsedTextures() {
        return this.numUsedTextures;
    }
    getNumFreeTextures() {
        return this.numFreeTextures;
    }
    dispose() {
        if (this.freeTextures == null) // Already disposed.
        return;
        for(const texShape in this.freeTextures)this.freeTextures[texShape].forEach((tex)=>{
            this.gpgpu.deleteMatrixTexture(tex.texture);
        });
        for(const texShape in this.usedTextures)this.usedTextures[texShape].forEach((tex)=>{
            this.gpgpu.deleteMatrixTexture(tex.texture);
        });
        // TODO: Assign non-null value (empty object) to textures after disposed.
        this.freeTextures = null;
        this.usedTextures = null;
        this.numUsedTextures = 0;
        this.numFreeTextures = 0;
        this._numBytesAllocated = 0;
        this._numBytesFree = 0;
    }
}
function $869b84076dcb3622$var$numBytesForInternalFormat(gl, internalFormat) {
    // tslint:disable-next-line:no-any
    const glany = gl;
    if (internalFormat === glany.R32F) return 4;
    else if (internalFormat === glany.R16F) return 2;
    else if (internalFormat === glany.RGBA32F) return 16;
    else if (internalFormat === gl.RGBA) return 16;
    else if (internalFormat === glany.RGBA16F) return 8;
    else if (internalFormat === glany.RGBA8) return 4;
    throw new Error(`Unknown internal format ${internalFormat}`);
}
function $869b84076dcb3622$export$66c19e55ce03e099(shape, physicalTexType, gl, textureConfig, isPacked) {
    // It is not possible to infer packed status from the texture type because
    // depending on the textureConfig, different  texture types may resolve to the
    // same internal format (e.g. in WebGL1, the internal format for
    // UNPACKED_FLOAT16 textures is gl.RGBA). Therefore we pass in `isPacked`
    // explicitly.
    const internalFormat = $869b84076dcb3622$var$internalFormatForPhysicalTexType(physicalTexType, textureConfig);
    let numElements;
    if (isPacked) {
        const [packedWidth, packedHeight] = (0, $c7d2caaa716d42d2$export$2754e02fa98f5582)(shape[0], shape[1]);
        numElements = packedWidth * packedHeight;
    } else {
        const [width, height] = (0, $c7d2caaa716d42d2$export$95fb8493b25f77a4)(shape[0], shape[1]);
        numElements = width * height;
    }
    const bytesPerElement = $869b84076dcb3622$var$numBytesForInternalFormat(gl, internalFormat);
    return numElements * bytesPerElement;
}
function $869b84076dcb3622$var$internalFormatForPhysicalTexType(physicalTexType, textureConfig) {
    switch(physicalTexType){
        case (0, $c7d2caaa716d42d2$export$bde70ab3692e385c).PACKED_2X2_FLOAT32:
            return (0, $e534681c41547152$export$dcae4a9709a9d6)(textureConfig);
        case (0, $c7d2caaa716d42d2$export$bde70ab3692e385c).PACKED_2X2_FLOAT16:
            return (0, $e534681c41547152$export$9b8d6c2b6b2037b0)(textureConfig);
        case (0, $c7d2caaa716d42d2$export$bde70ab3692e385c).UNPACKED_FLOAT32:
            return (0, $e534681c41547152$export$46e83db9ed4a55ec)(textureConfig);
        case (0, $c7d2caaa716d42d2$export$bde70ab3692e385c).UNPACKED_FLOAT16:
            return (0, $e534681c41547152$export$c3c5df7eccaed480)(textureConfig);
        case (0, $c7d2caaa716d42d2$export$bde70ab3692e385c).PACKED_4X1_UNSIGNED_BYTE:
            return (0, $e534681c41547152$export$ed62004e3546feef)(textureConfig);
        default:
            throw new Error(`Unknown physical texture type ${physicalTexType}`);
    }
}
function $869b84076dcb3622$var$getPhysicalTextureForRendering(isPacked) {
    if ((0, $i64bB.env)().getBool('WEBGL_RENDER_FLOAT32_ENABLED')) {
        if (isPacked) return (0, $c7d2caaa716d42d2$export$bde70ab3692e385c).PACKED_2X2_FLOAT32;
        return (0, $c7d2caaa716d42d2$export$bde70ab3692e385c).UNPACKED_FLOAT32;
    }
    if (isPacked) return (0, $c7d2caaa716d42d2$export$bde70ab3692e385c).PACKED_2X2_FLOAT16;
    return (0, $c7d2caaa716d42d2$export$bde70ab3692e385c).UNPACKED_FLOAT16;
}
function $869b84076dcb3622$var$getPhysicalFromLogicalTextureType(logicalTexType, isPacked) {
    if (logicalTexType === (0, $c7d2caaa716d42d2$export$6bf4bd1b6beb0bfd).UPLOAD) return (0, $c7d2caaa716d42d2$export$bde70ab3692e385c).PACKED_2X2_FLOAT32;
    else if (logicalTexType === (0, $c7d2caaa716d42d2$export$6bf4bd1b6beb0bfd).RENDER || logicalTexType == null) return $869b84076dcb3622$var$getPhysicalTextureForRendering(isPacked);
    else if (logicalTexType === (0, $c7d2caaa716d42d2$export$6bf4bd1b6beb0bfd).DOWNLOAD || logicalTexType === (0, $c7d2caaa716d42d2$export$6bf4bd1b6beb0bfd).PIXELS) return (0, $c7d2caaa716d42d2$export$bde70ab3692e385c).PACKED_4X1_UNSIGNED_BYTE;
    throw new Error(`Unknown logical texture type ${logicalTexType}`);
}
function $869b84076dcb3622$var$getKeyFromTextureShape(shapeRowsCol, physicalTexType, isPacked) {
    return `${shapeRowsCol[0]}_${shapeRowsCol[1]}_${physicalTexType}_${isPacked}`;
}


/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
class $d607b1799b79a159$export$f93811a5a466fd42 {
    constructor(aShape, opSnippet){
        this.variableNames = [
            'A'
        ];
        this.outputShape = aShape;
        this.enableShapeUniforms = (0, $8c928040c80f573b$export$5acc770fc06a0138)(this.outputShape.length);
        this.userCode = `
      float unaryOperation(float x) {
        ${opSnippet}
      }

      void main() {
        float x = getAAtOutCoords();
        float y = unaryOperation(x);

        setOutput(y);
      }
    `;
    }
}
const $d607b1799b79a159$export$39f0cca2b63399f6 = `if (isnan(x)) return x;`;
const $d607b1799b79a159$export$8244104593af74a6 = `return x;`;
const $d607b1799b79a159$export$3f020f6dcff67a1b = `return abs(x);`;
function $d607b1799b79a159$export$8a2ed3f7f077984e(alpha = 0.0) {
    return $d607b1799b79a159$export$39f0cca2b63399f6 + `
    return x > 0.0 ? 1.0 : float(${alpha});
  `;
}
const $d607b1799b79a159$export$945a5ccf96adb3b2 = `return (x >= 0.0) ? x : (exp(x) - 1.0);`;
const $d607b1799b79a159$export$27041fe53e1ee6da = $d607b1799b79a159$export$39f0cca2b63399f6 + `
  return (x < 0.0) ? 0.0 : x;
`;
const $d607b1799b79a159$export$94bf29e9c85fc840 = $d607b1799b79a159$export$39f0cca2b63399f6 + `
  return (x < 0.0) ? 0.0 : min(6.0, x);
`;
const $d607b1799b79a159$export$c07b68c109124fe2 = 'return x;';
const $d607b1799b79a159$export$f95dbffd98d0457a = `return 1.0 / (1.0 + exp(-1.0 * x));`;


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
const $d654f6ab3c8e3848$export$8244104593af74a6 = `return x;`;
const $d654f6ab3c8e3848$export$945a5ccf96adb3b2 = `
  vec4 result;

  result.r = (x.r >= 0.0) ? x.r : (exp(x.r) - 1.0);
  result.g = (x.g >= 0.0) ? x.g : (exp(x.g) - 1.0);
  result.b = (x.b >= 0.0) ? x.b : (exp(x.b) - 1.0);
  result.a = (x.a >= 0.0) ? x.a : (exp(x.a) - 1.0);

  return result;
`;
const $d654f6ab3c8e3848$export$27041fe53e1ee6da = `
  vec4 result = x * vec4(greaterThanEqual(x, vec4(0.0)));
  bvec4 isNaN = isnan(x);

  result.r = isNaN.r ? x.r : result.r;
  result.g = isNaN.g ? x.g : result.g;
  result.b = isNaN.b ? x.b : result.b;
  result.a = isNaN.a ? x.a : result.a;

  return result;
`;
const $d654f6ab3c8e3848$export$94bf29e9c85fc840 = `
  vec4 result = min(x, vec4(6.)) * vec4(greaterThanEqual(x, vec4(0.0)));
  bvec4 isNaN = isnan(x);

  result.r = isNaN.r ? x.r : result.r;
  result.g = isNaN.g ? x.g : result.g;
  result.b = isNaN.b ? x.b : result.b;
  result.a = isNaN.a ? x.a : result.a;

  return result;
`;
const $d654f6ab3c8e3848$export$f95dbffd98d0457a = `return 1.0 / (1.0 + exp(-1.0 * x));`;
class $d654f6ab3c8e3848$export$4d8daca4f85ed73d {
    constructor(aShape, opSnippet){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.outputShape = aShape;
        this.enableShapeUniforms = (0, $8c928040c80f573b$export$5acc770fc06a0138)(this.outputShape.length);
        this.userCode = `
      vec4 unaryOperation(vec4 x) {
        ${opSnippet}
      }

      void main() {
        vec4 x = getAAtOutCoords();
        vec4 y = unaryOperation(x);

        setOutput(y);
      }
    `;
    }
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


class $9c6c28e2ef14ed15$export$c457dd67217cb5eb {
    constructor(outputShape){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = false;
        this.outputShape = outputShape;
        this.enableShapeUniforms = (0, $8c928040c80f573b$export$5acc770fc06a0138)(this.outputShape.length);
        const rank = outputShape.length;
        const channels = (0, $30912e1180ed417f$export$7a4d1d0d17b69972)('rc', rank);
        const dtype = (0, $ba2c54ffbda39e8e$export$859efd105c10c755)(rank);
        const sourceCoords = (0, $30912e1180ed417f$export$8f96407d418c6727)(rank, channels);
        const innerDims = channels.slice(-2);
        const coords = rank <= 1 ? 'rc' : `vec2(${innerDims.join(',')})`;
        this.userCode = `
      void main() {
        ${dtype} rc = getOutputCoords();
        vec4 packedInput = getA(${sourceCoords});

        setOutput(getChannel(packedInput, ${coords}));
      }
    `;
    }
}



const $adffed7dd773b353$var$whereImpl = (0, $i64bB.kernel_impls).whereImpl;
const $adffed7dd773b353$export$76e53a66c52b6d4d = 1e-7;
const $adffed7dd773b353$export$49716d145771e6a2 = 1e-4;
const $adffed7dd773b353$var$binaryCaches = {};
function $adffed7dd773b353$export$5863a14c5c829662(webGLVersion) {
    if (webGLVersion in $adffed7dd773b353$var$binaryCaches) return $adffed7dd773b353$var$binaryCaches[webGLVersion];
    $adffed7dd773b353$var$binaryCaches[webGLVersion] = {};
    return $adffed7dd773b353$var$binaryCaches[webGLVersion];
}
// Empirically determined constant used to determine size threshold for handing
// off execution to the CPU.
const $adffed7dd773b353$var$CPU_HANDOFF_SIZE_THRESHOLD = (0, $i64bB.env)().getNumber('CPU_HANDOFF_SIZE_THRESHOLD');
// Empirically determined constant used to decide the number of MB on GPU
// before we warn about high memory use. The MB are this constant * screen area
// * dpi / 1024 / 1024.
const $adffed7dd773b353$var$BEFORE_PAGING_CONSTANT = 600;
function $adffed7dd773b353$var$numMBBeforeWarning() {
    if ((0, $i64bB.env)().global.screen == null) return 1024; // 1 GB.
    return (0, $i64bB.env)().global.screen.height * (0, $i64bB.env)().global.screen.width * window.devicePixelRatio * $adffed7dd773b353$var$BEFORE_PAGING_CONSTANT / 1024 / 1024;
}
class $adffed7dd773b353$export$33567d88bc7c6249 extends (0, $i64bB.KernelBackend) {
    nextDataId() {
        return $adffed7dd773b353$export$33567d88bc7c6249.nextDataId++;
    }
    constructor(gpuResource){
        super();
        // Maps data ids that have a pending read operation, to list of subscribers.
        this.pendingRead = new WeakMap();
        // List of data ids that are scheduled for disposal, but are waiting on a
        // pending read operation.
        this.pendingDisposal = new WeakSet();
        // Used to count the number of 'shallow' sliced tensors that point to the
        // same data id.
        this.dataRefCount = new WeakMap();
        this.numBytesInGPU = 0;
        // Accumulated time spent (including blocking) in uploading data to webgl.
        this.uploadWaitMs = 0;
        // Accumulated time spent (including blocking in downloading data from webgl.
        this.downloadWaitMs = 0;
        // record the last manual GL Flush time.
        this.lastGlFlushTime = 0;
        this.warnedAboutMemory = false;
        this.pendingDeletes = 0;
        this.disposed = false;
        if (!(0, $i64bB.env)().getBool('HAS_WEBGL')) throw new Error('WebGL is not supported on this device');
        let newGPGPU;
        if (gpuResource != null) {
            if (gpuResource instanceof (0, $f5ed9b9a408ee659$export$fa7a74a0ce382ac5)) newGPGPU = gpuResource;
            else {
                const gl = (0, $49455ae585dac16a$export$c7a808a518b9a146)((0, $i64bB.env)().getNumber('WEBGL_VERSION'), gpuResource);
                newGPGPU = new (0, $f5ed9b9a408ee659$export$fa7a74a0ce382ac5)(gl);
            }
            this.binaryCache = {};
            this.gpgpuCreatedLocally = false;
        } else {
            const gl = (0, $49455ae585dac16a$export$c7a808a518b9a146)((0, $i64bB.env)().getNumber('WEBGL_VERSION'));
            newGPGPU = new (0, $f5ed9b9a408ee659$export$fa7a74a0ce382ac5)(gl);
            this.binaryCache = $adffed7dd773b353$export$5863a14c5c829662((0, $i64bB.env)().getNumber('WEBGL_VERSION'));
            this.gpgpuCreatedLocally = true;
        }
        this.gpgpu = newGPGPU;
        this.canvas = this.gpgpu.gl.canvas;
        this.textureManager = new (0, $869b84076dcb3622$export$337f59f8fd79d24f)(this.gpgpu);
        this.numMBBeforeWarning = $adffed7dd773b353$var$numMBBeforeWarning();
        this.texData = new (0, $i64bB.DataStorage)(this, (0, $i64bB.engine)());
    }
    numDataIds() {
        return this.texData.numDataIds() - this.pendingDeletes;
    }
    // Writes a new entry to the data store with a WebGL texture, and registers it
    // to the texture manager.
    writeTexture(texture, shape, dtype, texHeight, texWidth, channels) {
        // Temporarily create an tensor info to make the texture compatible with
        // the runWebGLProgram's input.
        const input = this.makeTensorInfo(shape, dtype);
        const inData = this.texData.get(input.dataId);
        // Even though the input texture could be unpacked or dense packed, it is
        // always considered as unpacked for EncodeMatrixProgram.
        inData.isPacked = false;
        // Bind texture to the input tensor.
        inData.texture = {
            texture: texture,
            texShape: [
                texHeight,
                texWidth
            ]
        };
        inData.texShape = [
            texHeight,
            texWidth
        ];
        const shapeAs3D = $03fc80a4a4cef09e$export$f944c0101b593a79(shape);
        const program = new (0, $b2c960dec54ec6b8$export$b2e063313033aeab)(shapeAs3D, false, channels);
        const output = this.runWebGLProgram(program, [
            input
        ], dtype, [
            [
                texHeight,
                texWidth
            ]
        ]);
        output.shape = shape;
        // Unbind the texture from the input tensor to avoid the texture being
        // released.
        inData.texture = null;
        this.disposeIntermediateTensorInfo(input);
        return output.dataId;
    }
    write(values, shape, dtype) {
        if ((0, $i64bB.env)().getBool('WEBGL_CHECK_NUMERICAL_PROBLEMS') || (0, $i64bB.env)().getBool('DEBUG')) this.checkNumericalProblems(values);
        if (dtype === 'complex64' && values != null) throw new Error(`Cannot write to a complex64 dtype. ` + `Please use tf.complex(real, imag).`);
        const dataId = {
            id: this.nextDataId()
        };
        this.texData.set(dataId, {
            shape: shape,
            dtype: dtype,
            values: values,
            usage: (0, $c7d2caaa716d42d2$export$6bf4bd1b6beb0bfd).UPLOAD,
            refCount: 1
        });
        return dataId;
    }
    /** Return refCount of a `TensorData`. */ refCount(dataId) {
        if (this.texData.has(dataId)) {
            const tensorData = this.texData.get(dataId);
            return tensorData.refCount;
        }
        return 0;
    }
    /** Increase refCount of a `TextureData`. */ incRef(dataId) {
        const texData = this.texData.get(dataId);
        texData.refCount++;
    }
    /** Decrease refCount of a `TextureData`. */ decRef(dataId) {
        if (this.texData.has(dataId)) {
            const texData = this.texData.get(dataId);
            texData.refCount--;
        }
    }
    move(dataId, values, shape, dtype, refCount) {
        if ((0, $i64bB.env)().getBool('DEBUG')) this.checkNumericalProblems(values);
        if (dtype === 'complex64') throw new Error(`Cannot write to a complex64 dtype. ` + `Please use tf.complex(real, imag).`);
        this.texData.set(dataId, {
            shape: shape,
            dtype: dtype,
            values: values,
            usage: (0, $c7d2caaa716d42d2$export$6bf4bd1b6beb0bfd).UPLOAD,
            refCount: refCount
        });
    }
    disposeIntermediateTensorInfo(tensorInfo) {
        this.disposeData(tensorInfo.dataId);
    }
    readSync(dataId) {
        const texData = this.texData.get(dataId);
        const { values: values, dtype: dtype, complexTensorInfos: complexTensorInfos, slice: slice, shape: shape, isPacked: isPacked } = texData;
        // The presence of `slice` indicates this tensor is a shallow slice of a
        // different tensor, and is using that original tensor's texture. Run
        // `clone` in order to copy that texture and read from it.
        if (slice != null) {
            let program;
            if (isPacked) program = new (0, $d654f6ab3c8e3848$export$4d8daca4f85ed73d)(shape, $d607b1799b79a159$export$c07b68c109124fe2);
            else program = new (0, $d607b1799b79a159$export$f93811a5a466fd42)(shape, $d607b1799b79a159$export$c07b68c109124fe2);
            const res = this.runWebGLProgram(program, [
                {
                    dataId: dataId,
                    shape: shape,
                    dtype: dtype
                }
            ], dtype);
            const data = this.readSync(res.dataId);
            this.disposeIntermediateTensorInfo(res);
            return data;
        }
        if (values != null) return this.convertAndCacheOnCPU(dataId);
        if (dtype === 'string') return values;
        const shouldTimeProgram = this.activeTimers != null;
        let start;
        if (shouldTimeProgram) start = (0, $i64bB.util).now();
        let result;
        if (dtype === 'complex64') {
            const realValues = this.readSync(complexTensorInfos.real.dataId);
            const imagValues = this.readSync(complexTensorInfos.imag.dataId);
            result = (0, $i64bB.backend_util).mergeRealAndImagArrays(realValues, imagValues);
        } else result = this.getValuesFromTexture(dataId);
        if (shouldTimeProgram) this.downloadWaitMs += (0, $i64bB.util).now() - start;
        return this.convertAndCacheOnCPU(dataId, result);
    }
    async read(dataId) {
        if (this.pendingRead.has(dataId)) {
            const subscribers = this.pendingRead.get(dataId);
            return new Promise((resolve)=>subscribers.push(resolve));
        }
        const texData = this.texData.get(dataId);
        const { values: values, shape: shape, slice: slice, dtype: dtype, complexTensorInfos: complexTensorInfos, isPacked: isPacked } = texData;
        // The presence of `slice` indicates this tensor is a shallow slice of a
        // different tensor, and is using that original tensor's texture. Run
        // `clone` in order to copy that texture and read from it.
        if (slice != null) {
            let program;
            if (isPacked) program = new (0, $d654f6ab3c8e3848$export$4d8daca4f85ed73d)(shape, $d607b1799b79a159$export$c07b68c109124fe2);
            else program = new (0, $d607b1799b79a159$export$f93811a5a466fd42)(shape, $d607b1799b79a159$export$c07b68c109124fe2);
            const res = this.runWebGLProgram(program, [
                {
                    dataId: dataId,
                    shape: shape,
                    dtype: dtype
                }
            ], dtype);
            const data = this.read(res.dataId);
            this.disposeIntermediateTensorInfo(res);
            return data;
        }
        if (values != null) return this.convertAndCacheOnCPU(dataId);
        if ((0, $i64bB.env)().getBool('DEBUG')) {
            // getBool('WEBGL_DOWNLOAD_FLOAT_ENABLED') caused a blocking GPU call.
            // For performance reason, only check it for debugging. In production,
            // it doesn't handle this use case anyway, so behavior is not changed.
            if (!(0, $i64bB.env)().getBool('WEBGL_DOWNLOAD_FLOAT_ENABLED') && (0, $i64bB.env)().getNumber('WEBGL_VERSION') === 2) throw new Error(`tensor.data() with WEBGL_DOWNLOAD_FLOAT_ENABLED=false and ` + `WEBGL_VERSION=2 not yet supported.`);
        }
        let buffer = null;
        let tmpDownloadTarget;
        if (dtype !== 'complex64' && (0, $i64bB.env)().get('WEBGL_BUFFER_SUPPORTED')) {
            // Possibly copy the texture into a buffer before inserting a fence.
            tmpDownloadTarget = this.decode(dataId);
            const tmpData = this.texData.get(tmpDownloadTarget.dataId);
            buffer = this.gpgpu.createBufferFromTexture(tmpData.texture.texture, ...$c7d2caaa716d42d2$export$2cc7cc972aa2533d(shape));
        }
        this.pendingRead.set(dataId, []);
        if (dtype !== 'complex64') // Create a fence and wait for it to resolve.
        await this.gpgpu.createAndWaitForFence();
        // Download the values from the GPU.
        let vals;
        if (dtype === 'complex64') {
            const ps = await Promise.all([
                this.read(complexTensorInfos.real.dataId),
                this.read(complexTensorInfos.imag.dataId)
            ]);
            const realValues = ps[0];
            const imagValues = ps[1];
            vals = (0, $i64bB.backend_util).mergeRealAndImagArrays(realValues, imagValues);
        } else if (buffer == null) vals = this.getValuesFromTexture(dataId);
        else {
            const size = (0, $i64bB.util).sizeFromShape(shape);
            vals = this.gpgpu.downloadFloat32MatrixFromBuffer(buffer, size);
        }
        if (tmpDownloadTarget != null) this.disposeIntermediateTensorInfo(tmpDownloadTarget);
        if (buffer != null) {
            const gl = this.gpgpu.gl;
            $03fc80a4a4cef09e$export$7642ac97981532b8(gl, ()=>gl.deleteBuffer(buffer));
        }
        const dTypeVals = this.convertAndCacheOnCPU(dataId, vals);
        const subscribers = this.pendingRead.get(dataId);
        this.pendingRead.delete(dataId);
        // Notify all pending reads.
        subscribers.forEach((resolve)=>resolve(dTypeVals));
        if (this.pendingDisposal.has(dataId)) {
            this.pendingDisposal.delete(dataId);
            if (this.disposeData(dataId)) (0, $i64bB.engine)().removeDataId(dataId, this);
            this.pendingDeletes--;
        }
        return dTypeVals;
    }
    /**
     * Read tensor to a new texture that is densely packed for ease of use.
     * @param dataId The source tensor.
     * @param options
     *     customTexShape: Optional. If set, will use the user defined texture
     *     shape to create the texture.
     */ readToGPU(dataId, options = {}) {
        const texData = this.texData.get(dataId);
        const { values: values, shape: shape, slice: slice, dtype: dtype, isPacked: isPacked, texture: texture } = texData;
        if (dtype === 'complex64') throw new Error('Does not support reading texture for complex64 dtype.');
        // The presence of `slice` indicates this tensor is a shallow slice of a
        // different tensor, and is using that original tensor's texture. Run
        // `clone` in order to copy that texture and read from it.
        if (slice != null) {
            let program;
            if (isPacked) program = new (0, $d654f6ab3c8e3848$export$4d8daca4f85ed73d)(shape, $d607b1799b79a159$export$c07b68c109124fe2);
            else program = new (0, $d607b1799b79a159$export$f93811a5a466fd42)(shape, $d607b1799b79a159$export$c07b68c109124fe2);
            const res = this.runWebGLProgram(program, [
                {
                    dataId: dataId,
                    shape: shape,
                    dtype: dtype
                }
            ], dtype);
            const gpuResouorce = this.readToGPU(res, options);
            this.disposeIntermediateTensorInfo(res);
            return gpuResouorce;
        }
        if (texture == null) {
            if (values != null) throw new Error('Data is not on GPU but on CPU.');
            else throw new Error('There is no data on GPU or CPU.');
        }
        // Decode the texture so that it is stored densely (using four channels).
        const tmpTarget = this.decode(dataId, options.customTexShape);
        // Make engine track this tensor, so that we can dispose it later.
        const tensorRef = (0, $i64bB.engine)().makeTensorFromTensorInfo(tmpTarget);
        const tmpData = this.texData.get(tmpTarget.dataId);
        return Object.assign({
            tensorRef: tensorRef
        }, tmpData.texture);
    }
    bufferSync(t) {
        const data = this.readSync(t.dataId);
        if (t.dtype === 'string') try {
            // Decode the bytes into string.
            const strings = data.map((d)=>(0, $i64bB.util).decodeString(d));
            return (0, $i64bB.buffer)(t.shape, t.dtype, strings);
        } catch (_a) {
            throw new Error('Failed to decode encoded string bytes into utf-8');
        }
        return (0, $i64bB.buffer)(t.shape, t.dtype, data);
    }
    checkNumericalProblems(values) {
        if (values == null) return;
        for(let i = 0; i < values.length; i++){
            const num = values[i];
            if (!$03fc80a4a4cef09e$export$829768a5b7625879(num)) {
                if ((0, $i64bB.env)().getBool('WEBGL_RENDER_FLOAT32_CAPABLE')) throw Error(`The value ${num} cannot be represented with your ` + `current settings. Consider enabling float32 rendering: ` + `'tf.env().set('WEBGL_RENDER_FLOAT32_ENABLED', true);'`);
                throw Error(`The value ${num} cannot be represented on this device.`);
            }
        }
    }
    getValuesFromTexture(dataId) {
        const { shape: shape, dtype: dtype, isPacked: isPacked } = this.texData.get(dataId);
        const size = (0, $i64bB.util).sizeFromShape(shape);
        if ((0, $i64bB.env)().getBool('WEBGL_DOWNLOAD_FLOAT_ENABLED')) {
            const tmpTarget = this.decode(dataId);
            const tmpData = this.texData.get(tmpTarget.dataId);
            const vals = this.gpgpu.downloadMatrixFromPackedTexture(tmpData.texture.texture, ...$c7d2caaa716d42d2$export$2cc7cc972aa2533d(shape)).subarray(0, size);
            this.disposeIntermediateTensorInfo(tmpTarget);
            return vals;
        }
        const shouldUsePackedProgram = (0, $i64bB.env)().getBool('WEBGL_PACK') && isPacked === true;
        const outputShape = shouldUsePackedProgram ? $03fc80a4a4cef09e$export$f944c0101b593a79(shape) : shape;
        const program = shouldUsePackedProgram ? new (0, $ea89275acc06be2c$export$97e262e8a4818e2e)(outputShape) : new (0, $ef6f5336bc8e6fb9$export$dae4f112167b5aac)(outputShape);
        const output = this.runWebGLProgram(program, [
            {
                shape: outputShape,
                dtype: dtype,
                dataId: dataId
            }
        ], 'float32');
        const tmpData = this.texData.get(output.dataId);
        const vals = this.gpgpu.downloadByteEncodedFloatMatrixFromOutputTexture(tmpData.texture.texture, tmpData.texShape[0], tmpData.texShape[1]).subarray(0, size);
        this.disposeIntermediateTensorInfo(output);
        return vals;
    }
    timerAvailable() {
        return (0, $i64bB.env)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE') > 0;
    }
    time(f) {
        const oldActiveTimers = this.activeTimers;
        const newActiveTimers = [];
        let outerMostTime = false;
        if (this.programTimersStack == null) {
            this.programTimersStack = newActiveTimers;
            outerMostTime = true;
        } else this.activeTimers.push(newActiveTimers);
        this.activeTimers = newActiveTimers;
        f();
        // needing to split these up because util.flatten only accepts certain types
        const flattenedActiveTimerQueries = (0, $i64bB.util).flatten(this.activeTimers.map((d)=>d.query)).filter((d)=>d != null);
        const flattenedActiveTimerNames = (0, $i64bB.util).flatten(this.activeTimers.map((d)=>d.name)).filter((d)=>d != null);
        this.activeTimers = oldActiveTimers;
        if (outerMostTime) this.programTimersStack = null;
        const res = {
            uploadWaitMs: this.uploadWaitMs,
            downloadWaitMs: this.downloadWaitMs,
            kernelMs: null,
            wallMs: null // will be filled by the engine
        };
        return (async ()=>{
            if ((0, $i64bB.env)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE') > 0) {
                const kernelMs = await Promise.all(flattenedActiveTimerQueries);
                res['kernelMs'] = (0, $i64bB.util).sum(kernelMs);
                res['getExtraProfileInfo'] = ()=>kernelMs.map((d, i)=>({
                            name: flattenedActiveTimerNames[i],
                            ms: d
                        })).map((d)=>`${d.name}: ${d.ms}`).join(', ');
            } else res['kernelMs'] = {
                error: 'WebGL query timers are not supported in this environment.'
            };
            this.uploadWaitMs = 0;
            this.downloadWaitMs = 0;
            return res;
        })();
    }
    memory() {
        return {
            unreliable: false,
            numBytesInGPU: this.numBytesInGPU,
            numBytesInGPUAllocated: this.textureManager.numBytesAllocated,
            numBytesInGPUFree: this.textureManager.numBytesFree
        };
    }
    startTimer() {
        if ((0, $i64bB.env)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE') > 0) return this.gpgpu.beginQuery();
        return {
            startMs: (0, $i64bB.util).now(),
            endMs: null
        };
    }
    endTimer(query) {
        if ((0, $i64bB.env)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE') > 0) {
            this.gpgpu.endQuery();
            return query;
        }
        query.endMs = (0, $i64bB.util).now();
        return query;
    }
    async getQueryTime(query) {
        if ((0, $i64bB.env)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE') > 0) return this.gpgpu.waitForQueryAndGetTime(query);
        const timerQuery = query;
        return timerQuery.endMs - timerQuery.startMs;
    }
    /**
     * Decrease the RefCount on the dataId and dispose the memory if the dataId
     * has 0 refCount. If there are pending read on the data, the disposal would
     * added to the pending delete queue. Return true if the dataId is removed
     * from backend or the backend does not contain the dataId, false if the
     * dataId is not removed. Memory may or may not be released even when dataId
     * is removed, which also depends on dataRefCount, see `releaseGPU`.
     * @param dataId
     * @oaram force Optional, remove the data regardless of refCount
     */ disposeData(dataId, force = false) {
        if (this.pendingDisposal.has(dataId)) return false;
        // No-op if already disposed.
        if (!this.texData.has(dataId)) return true;
        // if force flag is set, change refCount to 0, this would ensure disposal
        // when added to the pendingDisposal queue. Memory may or may not be
        // released, which also depends on dataRefCount, see `releaseGPU`.
        if (force) this.texData.get(dataId).refCount = 0;
        else this.texData.get(dataId).refCount--;
        if (!force && this.texData.get(dataId).refCount > 0) return false;
        if (this.pendingRead.has(dataId)) {
            this.pendingDisposal.add(dataId);
            this.pendingDeletes++;
            return false;
        }
        this.releaseGPUData(dataId);
        const { complexTensorInfos: complexTensorInfos } = this.texData.get(dataId);
        if (complexTensorInfos != null) {
            this.disposeData(complexTensorInfos.real.dataId, force);
            this.disposeData(complexTensorInfos.imag.dataId, force);
        }
        this.texData.delete(dataId);
        return true;
    }
    releaseGPUData(dataId) {
        const { texture: texture, dtype: dtype, texShape: texShape, usage: usage, isPacked: isPacked, slice: slice } = this.texData.get(dataId);
        const key = slice && slice.origDataId || dataId;
        const refCount = this.dataRefCount.get(key);
        if (refCount > 1) this.dataRefCount.set(key, refCount - 1);
        else {
            this.dataRefCount.delete(key);
            if (texture != null) {
                this.numBytesInGPU -= this.computeBytes(texShape, dtype);
                this.textureManager.releaseTexture(texture, texShape, usage, isPacked);
            }
        }
        const texData = this.texData.get(dataId);
        texData.texture = null;
        texData.texShape = null;
        texData.isPacked = false;
        texData.slice = null;
    }
    getTexture(dataId) {
        this.uploadToGPU(dataId);
        return this.texData.get(dataId).texture.texture;
    }
    /**
     * Returns internal information for the specific data bucket. Used in unit
     * tests.
     */ getDataInfo(dataId) {
        return this.texData.get(dataId);
    }
    /*
    Tests whether all the inputs to an op are small and on the CPU. This heuristic
    determines when it would be faster to execute a kernel on the CPU. WebGL
    kernels opt into running this check and forwarding when appropriate.
    TODO(https://github.com/tensorflow/tfjs/issues/872): Develop a more
    sustainable strategy for optimizing backend execution of ops.
     */ shouldExecuteOnCPU(inputs, sizeThreshold = $adffed7dd773b353$var$CPU_HANDOFF_SIZE_THRESHOLD) {
        return (0, $i64bB.env)().getBool('WEBGL_CPU_FORWARD') && inputs.every((input)=>this.texData.get(input.dataId).texture == null && (0, $i64bB.util).sizeFromShape(input.shape) < sizeThreshold);
    }
    getGPGPUContext() {
        return this.gpgpu;
    }
    where(condition) {
        (0, $i64bB.backend_util).warn("tf.where() in webgl locks the UI thread. Call tf.whereAsync() instead");
        const condVals = condition.dataSync();
        return $adffed7dd773b353$var$whereImpl(condition.shape, condVals);
    }
    packedUnaryOp(x, op, dtype) {
        const program = new (0, $d654f6ab3c8e3848$export$4d8daca4f85ed73d)(x.shape, op);
        const outInfo = this.compileAndRun(program, [
            x
        ], dtype);
        return (0, $i64bB.engine)().makeTensorFromTensorInfo(outInfo);
    }
    // TODO(msoulanille) remove this once the backend has been modularized
    // a copy is needed here to break a circular dependency.
    // Also remove the op from unary_op.
    abs(x) {
        // TODO: handle cases when x is complex.
        if (this.shouldExecuteOnCPU([
            x
        ]) && x.dtype !== 'complex64') {
            const outValues = (0, $377486a788efd20b$export$d7efa3585619eabe)(this.texData.get(x.dataId).values);
            return this.makeOutput(x.shape, x.dtype, outValues);
        }
        if ((0, $i64bB.env)().getBool('WEBGL_PACK_UNARY_OPERATIONS')) return this.packedUnaryOp(x, $d607b1799b79a159$export$3f020f6dcff67a1b, x.dtype);
        const program = new (0, $d607b1799b79a159$export$f93811a5a466fd42)(x.shape, $d607b1799b79a159$export$3f020f6dcff67a1b);
        const outInfo = this.compileAndRun(program, [
            x
        ]);
        return (0, $i64bB.engine)().makeTensorFromTensorInfo(outInfo);
    }
    makeTensorInfo(shape, dtype, values) {
        let dataId;
        if (dtype === 'string' && values != null && values.length > 0 && (0, $i64bB.util).isString(values[0])) {
            const encodedValues = values.map((d)=>(0, $i64bB.util).encodeString(d));
            dataId = this.write(encodedValues, shape, dtype);
        } else dataId = this.write(values, shape, dtype);
        this.texData.get(dataId).usage = null;
        return {
            dataId: dataId,
            shape: shape,
            dtype: dtype
        };
    }
    makeOutput(shape, dtype, values) {
        return (0, $i64bB.engine)().makeTensorFromTensorInfo(this.makeTensorInfo(shape, dtype, values), this);
    }
    unpackTensor(input) {
        const program = new (0, $9c6c28e2ef14ed15$export$c457dd67217cb5eb)(input.shape);
        return this.runWebGLProgram(program, [
            input
        ], input.dtype);
    }
    packTensor(input) {
        const program = new (0, $1a35e3fb33e208e0$export$5ebf74a9a135ce1d)(input.shape);
        const preventEagerUnpackingOutput = true;
        return this.runWebGLProgram(program, [
            input
        ], input.dtype, null, preventEagerUnpackingOutput);
    }
    packedReshape(input, afterShape) {
        const input3DShape = [
            $03fc80a4a4cef09e$export$4dfd7bc0667970e0(input.shape),
            ...$03fc80a4a4cef09e$export$e8f6c350b57b8270(input.shape)
        ];
        const input3D = {
            dtype: input.dtype,
            shape: input3DShape,
            dataId: input.dataId
        };
        const afterShapeAs3D = [
            $03fc80a4a4cef09e$export$4dfd7bc0667970e0(afterShape),
            ...$03fc80a4a4cef09e$export$e8f6c350b57b8270(afterShape)
        ];
        const program = new (0, $49ff511a513b21e1$export$ce249f6fedcc44de)(afterShapeAs3D, input3DShape);
        const preventEagerUnpackingOfOutput = true;
        const customValues = [
            input3DShape
        ];
        const output = this.runWebGLProgram(program, [
            input3D
        ], input.dtype, customValues, preventEagerUnpackingOfOutput);
        return {
            dataId: output.dataId,
            shape: afterShape,
            dtype: output.dtype
        };
    }
    decode(dataId, customTexShape) {
        const texData = this.texData.get(dataId);
        const { isPacked: isPacked, shape: shape, dtype: dtype } = texData;
        if (customTexShape != null) {
            const size = (0, $i64bB.util).sizeFromShape(shape);
            const texSize = customTexShape[0] * customTexShape[1] * 4;
            (0, $i64bB.util).assert(size <= texSize, ()=>"customTexShape is too small. Row * Column * 4 should be equal or larger than the size of the tensor data.");
        }
        const shapeAs3D = $03fc80a4a4cef09e$export$f944c0101b593a79(shape);
        let program;
        if (isPacked) program = new (0, $76c4e43b08dbd9e1$export$4434db41c70879cb)(shapeAs3D);
        else program = new (0, $10aa3719489b95a5$export$f6ee51c6efbee026)(shapeAs3D);
        const preventEagerUnpackingOfOutput = true;
        const customValues = [
            customTexShape != null ? customTexShape : $c7d2caaa716d42d2$export$2cc7cc972aa2533d(shapeAs3D)
        ];
        const out = this.runWebGLProgram(program, [
            {
                shape: shapeAs3D,
                dtype: dtype,
                dataId: dataId
            }
        ], dtype, customValues, preventEagerUnpackingOfOutput, customTexShape);
        return {
            dtype: dtype,
            shape: shape,
            dataId: out.dataId
        };
    }
    runWebGLProgram(program, inputs, outputDtype, customUniformValues, preventEagerUnpackingOfOutput = false, customTexShape) {
        const output = this.makeTensorInfo(program.outputShape, outputDtype);
        const outData = this.texData.get(output.dataId);
        if (program.packedOutput) outData.isPacked = true;
        if (program.outPackingScheme === $c7d2caaa716d42d2$export$81d5c79efa1086f2.DENSE) {
            const texelShape = customTexShape != null ? customTexShape : $c7d2caaa716d42d2$export$2cc7cc972aa2533d(program.outputShape);
            // For a densely packed output, we explicitly set texShape
            // so it doesn't get assigned later according to our typical packing
            // scheme wherein a single texel can only contain values from adjacent
            // rows/cols.
            outData.texShape = texelShape.map((d)=>d * 2);
        }
        if (program.outTexUsage != null) outData.usage = program.outTexUsage;
        if ((0, $i64bB.util).sizeFromShape(output.shape) === 0) {
            // Short-circuit the computation since the result is empty (has 0 in its
            // shape).
            outData.values = (0, $i64bB.util).getTypedArrayFromDType(output.dtype, 0);
            return output;
        }
        const dataToDispose = [];
        const inputsData = inputs.map((input)=>{
            if (input.dtype === 'complex64') throw new Error(`GPGPUProgram does not support complex64 input. For complex64 ` + `dtypes, please separate the program into real and imaginary ` + `parts.`);
            let texData = this.texData.get(input.dataId);
            if (texData.texture == null) {
                if (!program.packedInputs && (0, $i64bB.util).sizeFromShape(input.shape) <= (0, $i64bB.env)().getNumber('WEBGL_SIZE_UPLOAD_UNIFORM')) // Upload small tensors that live on the CPU as uniforms, not as
                // textures. Do this only when the environment supports 32bit floats
                // due to problems when comparing 16bit floats with 32bit floats.
                // TODO(https://github.com/tensorflow/tfjs/issues/821): Make it
                // possible for packed shaders to sample from uniforms.
                return {
                    shape: input.shape,
                    texData: null,
                    isUniform: true,
                    uniformValues: texData.values
                };
                // This ensures that if a packed program's inputs have not yet been
                // uploaded to the GPU, they get uploaded as packed right off the bat.
                if (program.packedInputs) {
                    texData.isPacked = true;
                    texData.shape = input.shape;
                }
            }
            this.uploadToGPU(input.dataId);
            if (!!texData.isPacked !== !!program.packedInputs) {
                input = texData.isPacked ? this.unpackTensor(input) : this.packTensor(input);
                dataToDispose.push(input);
                texData = this.texData.get(input.dataId);
            } else if (texData.isPacked && !$03fc80a4a4cef09e$export$951b388203a0422d(texData.shape, input.shape)) {
                // This is a special case where a texture exists for a tensor
                // but the shapes are incompatible (due to packing constraints) because
                // the tensor did not have a chance to go through the packed reshape
                // shader. This only happens when we reshape the *same* tensor to form
                // *distinct* inputs to an op, e.g. dotting a vector with itself. This
                // case will disappear once packed uploading is the default.
                const savedInput = input;
                const targetShape = input.shape;
                input.shape = texData.shape;
                input = this.packedReshape(input, targetShape);
                dataToDispose.push(input);
                texData = this.texData.get(input.dataId);
                savedInput.shape = targetShape;
            }
            return {
                shape: input.shape,
                texData: texData,
                isUniform: false
            };
        });
        this.uploadToGPU(output.dataId);
        const outputData = {
            shape: output.shape,
            texData: outData,
            isUniform: false
        };
        const key = $8c928040c80f573b$export$2a17a6d53fe6f5d9(program, inputsData, outputData);
        const binary = this.getAndSaveBinary(key, ()=>{
            return $8c928040c80f573b$export$5ca2cb6073dd12df(this.gpgpu, program, inputsData, outputData);
        });
        const shouldTimeProgram = this.activeTimers != null;
        let query;
        if (shouldTimeProgram) query = this.startTimer();
        if (!(0, $i64bB.env)().get('ENGINE_COMPILE_ONLY')) $8c928040c80f573b$export$4e01d2c5eea12ae3(this.gpgpu, binary, inputsData, outputData, customUniformValues);
        dataToDispose.forEach((info)=>this.disposeIntermediateTensorInfo(info));
        if (shouldTimeProgram) {
            query = this.endTimer(query);
            this.activeTimers.push({
                name: program.constructor.name,
                query: this.getQueryTime(query)
            });
        }
        const glFlushThreshold = (0, $i64bB.env)().getNumber('WEBGL_FLUSH_THRESHOLD');
        // Manually GL flush requested
        if (glFlushThreshold > 0) {
            const time = (0, $i64bB.util).now();
            if (time - this.lastGlFlushTime > glFlushThreshold) {
                this.gpgpu.gl.flush();
                this.lastGlFlushTime = time;
            }
        }
        if (!(0, $i64bB.env)().getBool('WEBGL_LAZILY_UNPACK') && outData.isPacked && preventEagerUnpackingOfOutput === false) {
            const unpacked = this.unpackTensor(output);
            this.disposeIntermediateTensorInfo(output);
            return unpacked;
        }
        return output;
    }
    compileAndRun(program, inputs, outputDtype, customUniformValues, preventEagerUnpackingOfOutput = false) {
        outputDtype = outputDtype || inputs[0].dtype;
        const outInfo = this.runWebGLProgram(program, inputs, outputDtype, customUniformValues, preventEagerUnpackingOfOutput);
        return outInfo;
    }
    getAndSaveBinary(key, getBinary) {
        if (!(key in this.binaryCache)) this.binaryCache[key] = getBinary();
        return this.binaryCache[key];
    }
    getTextureManager() {
        return this.textureManager;
    }
    dispose() {
        if (this.disposed) return;
        // Avoid disposing the compiled webgl programs during unit testing because
        // it slows down test execution.
        if (!(0, $i64bB.env)().getBool('IS_TEST')) {
            const allKeys = Object.keys(this.binaryCache);
            allKeys.forEach((key)=>{
                this.gpgpu.deleteProgram(this.binaryCache[key].webGLProgram);
                delete this.binaryCache[key];
            });
        }
        this.textureManager.dispose();
        if (this.canvas != null && typeof HTMLCanvasElement !== 'undefined' && this.canvas instanceof HTMLCanvasElement) this.canvas.remove();
        else this.canvas = null;
        if (this.gpgpuCreatedLocally) {
            this.gpgpu.program = null;
            this.gpgpu.dispose();
        }
        this.disposed = true;
    }
    floatPrecision() {
        if (this.floatPrecisionValue == null) this.floatPrecisionValue = (0, $i64bB.tidy)(()=>{
            if (!(0, $i64bB.env)().get('WEBGL_RENDER_FLOAT32_ENABLED')) {
                // Momentarily switching DEBUG flag to false so we don't throw an
                // error trying to upload a small value.
                const debugFlag = (0, $i64bB.env)().getBool('DEBUG');
                (0, $i64bB.env)().set('DEBUG', false);
                const underflowCheckValue = this.abs((0, $i64bB.scalar)(1e-8)).dataSync()[0];
                (0, $i64bB.env)().set('DEBUG', debugFlag);
                if (underflowCheckValue > 0) return 32;
            }
            return 16;
        });
        return this.floatPrecisionValue;
    }
    /** Returns the smallest representable number.  */ epsilon() {
        return this.floatPrecision() === 32 ? $adffed7dd773b353$export$76e53a66c52b6d4d : $adffed7dd773b353$export$49716d145771e6a2;
    }
    uploadToGPU(dataId) {
        const texData = this.texData.get(dataId);
        const { shape: shape, dtype: dtype, values: values, texture: texture, usage: usage, isPacked: isPacked } = texData;
        if (texture != null) // Array is already on GPU. No-op.
        return;
        const shouldTimeProgram = this.activeTimers != null;
        let start;
        if (shouldTimeProgram) start = (0, $i64bB.util).now();
        let texShape = texData.texShape;
        if (texShape == null) {
            // This texShape may not be the final texture shape. For packed or dense
            // textures, the texShape will be changed when textures are created.
            texShape = $03fc80a4a4cef09e$export$80bf57c6927be1d9(shape, isPacked);
            texData.texShape = texShape;
        }
        if (values != null) {
            const shapeAs3D = $03fc80a4a4cef09e$export$f944c0101b593a79(shape);
            let program;
            let width = texShape[1], height = texShape[0];
            const isByteArray = values instanceof Uint8Array || values instanceof Uint8ClampedArray;
            // texture for float array is PhysicalTextureType.PACKED_2X2_FLOAT32, we
            // need to make sure the upload uses the same packed size
            if (isPacked || !isByteArray) [width, height] = $c7d2caaa716d42d2$export$2754e02fa98f5582(texShape[0], texShape[1]);
            if (isPacked) program = new (0, $a94ed549409f1196$export$3b3e6b1f67c8c4d5)(shapeAs3D, isByteArray);
            else program = new (0, $b2c960dec54ec6b8$export$b2e063313033aeab)(shapeAs3D, isByteArray);
            // TexShape for float array needs to be the original shape, which byte
            // array needs to be packed size. This allow the data upload shape to be
            // matched with texture creation logic.
            const tempDenseInputTexShape = isByteArray ? [
                height,
                width
            ] : texShape;
            const tempDenseInputHandle = this.makeTensorInfo(tempDenseInputTexShape, dtype);
            const tempDenseInputTexData = this.texData.get(tempDenseInputHandle.dataId);
            if (isByteArray) tempDenseInputTexData.usage = (0, $c7d2caaa716d42d2$export$6bf4bd1b6beb0bfd).PIXELS;
            else tempDenseInputTexData.usage = (0, $c7d2caaa716d42d2$export$6bf4bd1b6beb0bfd).UPLOAD;
            tempDenseInputTexData.texShape = tempDenseInputTexShape;
            this.gpgpu.uploadDenseMatrixToTexture(this.getTexture(tempDenseInputHandle.dataId), width, height, values);
            const customValues = [
                [
                    height,
                    width
                ]
            ];
            // We want the output to remain packed regardless of the value of
            // WEBGL_PACK.
            const preventEagerUnpacking = true;
            const encodedOutputTarget = this.runWebGLProgram(program, [
                tempDenseInputHandle
            ], dtype, customValues, preventEagerUnpacking);
            // Have the original texture assume the identity of the encoded output.
            const outputTexData = this.texData.get(encodedOutputTarget.dataId);
            texData.texShape = outputTexData.texShape;
            texData.isPacked = outputTexData.isPacked;
            texData.usage = outputTexData.usage;
            if (!(0, $i64bB.env)().get('ENGINE_COMPILE_ONLY')) {
                texData.texture = outputTexData.texture;
                // Once uploaded, don't store the values on cpu.
                texData.values = null;
                this.texData.delete(encodedOutputTarget.dataId);
            } else this.disposeData(encodedOutputTarget.dataId);
            this.disposeIntermediateTensorInfo(tempDenseInputHandle);
            if (shouldTimeProgram) this.uploadWaitMs += (0, $i64bB.util).now() - start;
        } else {
            const newTexture = this.acquireTexture(texShape, usage, dtype, isPacked);
            texData.texture = newTexture;
        }
    }
    convertAndCacheOnCPU(dataId, float32Values) {
        const texData = this.texData.get(dataId);
        const { dtype: dtype } = texData;
        if (float32Values != null) texData.values = $adffed7dd773b353$var$float32ToTypedArray(float32Values, dtype);
        return texData.values;
    }
    acquireTexture(texShape, texType, dtype, isPacked) {
        this.numBytesInGPU += this.computeBytes(texShape, dtype);
        if (!this.warnedAboutMemory && this.numBytesInGPU > this.numMBBeforeWarning * 1048576) {
            const mb = (this.numBytesInGPU / 1024 / 1024).toFixed(2);
            this.warnedAboutMemory = true;
            console.warn(`High memory usage in GPU: ${mb} MB, ` + `most likely due to a memory leak`);
        }
        return this.textureManager.acquireTexture(texShape, texType, isPacked);
    }
    computeBytes(shape, dtype) {
        return shape[0] * shape[1] * (0, $i64bB.util).bytesPerElement(dtype);
    }
    checkCompileCompletion() {
        for (const [, binary] of Object.entries(this.binaryCache))this.checkCompletion_(binary);
    }
    async checkCompileCompletionAsync() {
        const ps = [];
        if (this.gpgpu.parallelCompilationExtension) {
            for (const [, binary] of Object.entries(this.binaryCache))ps.push(this.checkCompletionAsync_(binary));
            return Promise.all(ps);
        } else {
            for (const [, binary] of Object.entries(this.binaryCache)){
                const p = new Promise((resolve)=>{
                    try {
                        this.checkCompletion_(binary);
                        resolve(true);
                    } catch (error) {
                        throw error;
                    }
                });
                ps.push(p);
            }
            return Promise.all(ps);
        }
    }
    async checkCompletionAsync_(binary) {
        if (this.gpgpu.gl.getProgramParameter(binary.webGLProgram, this.gpgpu.parallelCompilationExtension.COMPLETION_STATUS_KHR)) return this.checkCompletion_(binary);
        else {
            await (0, $i64bB.nextFrame)();
            return this.checkCompletionAsync_(binary);
        }
    }
    checkCompletion_(binary) {
        if (this.gpgpu.gl.getProgramParameter(binary.webGLProgram, this.gpgpu.gl.LINK_STATUS) === false) {
            console.log(this.gpgpu.gl.getProgramInfoLog(binary.webGLProgram));
            if (this.gpgpu.gl.getShaderParameter(binary.fragmentShader, this.gpgpu.gl.COMPILE_STATUS) === false) {
                $03fc80a4a4cef09e$export$f7b23987b58d218(binary.source, this.gpgpu.gl.getShaderInfoLog(binary.fragmentShader));
                throw new Error('Failed to compile fragment shader.');
            }
            throw new Error('Failed to link vertex and fragment shaders.');
        }
        return true;
    }
    getUniformLocations() {
        for (const binary of Object.values(this.binaryCache)){
            // TODO: Iterating through all binaries to build VAOs is supposed to be in
            // a seperate function, like 'setVaos'. However, to avoid breaking changes
            // for the users using parallel compile feature now, buildVao is silently
            // added here.
            this.gpgpu.buildVao(binary.webGLProgram);
            const { variablesLocations: variablesLocations, customUniformLocations: customUniformLocations, infLoc: infLoc, nanLoc: nanLoc, outShapeLocation: outShapeLocation, outShapeStridesLocation: outShapeStridesLocation, outTexShapeLocation: outTexShapeLocation } = (0, $8c928040c80f573b$export$d421ceceafba9cc0)(this.gpgpu, binary.program, binary.webGLProgram);
            binary.variablesLocations = variablesLocations;
            binary.customUniformLocations = customUniformLocations;
            binary.infLoc = infLoc;
            binary.nanLoc = nanLoc;
            binary.outShapeLocation = outShapeLocation;
            binary.outShapeStridesLocation = outShapeStridesLocation;
            binary.outTexShapeLocation = outTexShapeLocation;
        }
    }
    /**
     * Create a TF.js tensor out of an existing WebGL texture. A new texture will
     * be created.
     */ createTensorFromGPUData(values, shape, dtype) {
        values.channels = values.channels || 'RGBA';
        const { texture: texture, height: height, width: width, channels: channels } = values;
        const backend = (0, $i64bB.engine)().backend;
        // Have to throw an error, otherwise WebGL just warns and returns wrong
        // values.
        if (!backend.gpgpu.gl.isTexture(texture)) throw new Error(`The texture is invalid. Also, please make sure the texture and ` + `the TFJS WebGL backend are using the same canvas. If you want to ` + `use your own custom canvas, you have to create and use the custom ` + `TFJS WebGL backend created from the canvas through ` + `'new tf.MathBackendWebGL(customCanvas)'.`);
        const dataId = backend.writeTexture(texture, shape, dtype, height, width, channels);
        return (0, $i64bB.engine)().makeTensorFromDataId(dataId, shape, dtype, backend);
    }
}
$adffed7dd773b353$export$33567d88bc7c6249.nextDataId = 0;
function $adffed7dd773b353$var$float32ToTypedArray(a, dtype) {
    if (dtype === 'float32' || dtype === 'complex64') return a;
    else if (dtype === 'int32' || dtype === 'bool') {
        const result = dtype === 'int32' ? new Int32Array(a.length) : new Uint8Array(a.length);
        for(let i = 0; i < result.length; ++i)result[i] = Math.round(a[i]);
        return result;
    } else throw new Error(`Unknown dtype ${dtype}`);
}


/** @license See the LICENSE file. */ // This code is auto-generated, do not modify this file!
const $93bc77f288d060bd$export$83d89fbfd8236492 = '4.22.0';


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");





function $1f93eece33a575fd$export$3f638ed94e6c5baa() {
    (0, $i64bB.env)().set('WEBGL_FORCE_F16_TEXTURES', true);
}


if ((0, $i64bB.device_util).isBrowser()) (0, $i64bB.registerBackend)('webgl', ()=>new (0, $adffed7dd773b353$export$33567d88bc7c6249)(), 2 /* priority */ );
const $20e7a8b8c34920fb$export$d55298c9efc5ed14 = {
    forceHalfFloat: $1f93eece33a575fd$export$3f638ed94e6c5baa
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

const $a3544edc66d558ba$export$39f0cca2b63399f6 = `
  if (isnan(a)) return a;
  if (isnan(b)) return b;
`;
const $a3544edc66d558ba$export$1e6d79ff8c3b3c83 = 'return (a - b) * (a - b);';
class $a3544edc66d558ba$export$9045e9161086790b {
    constructor(op, aShape, bShape){
        this.variableNames = [
            'A',
            'B'
        ];
        this.outputShape = (0, $i64bB.backend_util).assertAndGetBroadcastShape(aShape, bShape);
        this.enableShapeUniforms = (0, $8c928040c80f573b$export$5acc770fc06a0138)(this.outputShape.length);
        this.userCode = `
      float binaryOperation(float a, float b) {
        ${op}
      }

      void main() {
        float a = getAAtOutCoords();
        float b = getBAtOutCoords();
        setOutput(binaryOperation(a, b));
      }
    `;
    }
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");



const $1b00798c48aa5c1a$export$2b4d5cee4bd7b2dd = `
  result.r = isNaN.r ? NAN : result.r;
  result.g = isNaN.g ? NAN : result.g;
  result.b = isNaN.b ? NAN : result.b;
  result.a = isNaN.a ? NAN : result.a;
`;
const $1b00798c48aa5c1a$export$54f9164222714c69 = `
  vec4 bGTEZero = vec4(greaterThanEqual(b, vec4(0.)));
  return (bGTEZero * a) + ((vec4(1.0) - bGTEZero) * (a * (b + vec4(1.0))));
`;
const $1b00798c48aa5c1a$export$fd75136f014548e = `
  return vec4(notEqual(a, b));
`;
class $1b00798c48aa5c1a$export$7ef3bdc75c177be0 {
    constructor(op, aShape, bShape, checkOutOfBounds = false){
        this.variableNames = [
            'A',
            'B'
        ];
        this.supportsBroadcasting = true;
        this.packedInputs = true;
        this.packedOutput = true;
        this.outputShape = (0, $i64bB.backend_util).assertAndGetBroadcastShape(aShape, bShape);
        const rank = this.outputShape.length;
        this.enableShapeUniforms = (0, $8c928040c80f573b$export$5acc770fc06a0138)(rank);
        let checkOutOfBoundsString = '';
        if (checkOutOfBounds) {
            if (rank === 0 || (0, $i64bB.util).sizeFromShape(this.outputShape) === 1) checkOutOfBoundsString = `
          result.y = 0.;
          result.z = 0.;
          result.w = 0.;
        `;
            else {
                const dtype = (0, $ba2c54ffbda39e8e$export$859efd105c10c755)(rank);
                checkOutOfBoundsString = `
          ${dtype} coords = getOutputCoords();
        `;
                if (rank === 1) {
                    if (this.enableShapeUniforms) checkOutOfBoundsString += `
            result.y = (coords + 1) >= outShape ? 0. : result.y;
            result.z = 0.;
            result.w = 0.;
          `;
                    else checkOutOfBoundsString += `
            result.y = (coords + 1) >= ${this.outputShape[0]} ? 0. : result.y;
            result.z = 0.;
            result.w = 0.;
          `;
                } else {
                    const channels = (0, $30912e1180ed417f$export$7a4d1d0d17b69972)('coords', rank);
                    if (this.enableShapeUniforms) checkOutOfBoundsString += `
            bool nextRowOutOfBounds =
              (${channels[rank - 2]} + 1) >= outShape[${rank} - 2];
            bool nextColOutOfBounds =
              (${channels[rank - 1]} + 1) >= outShape[${rank} - 1];
            result.y = nextColOutOfBounds ? 0. : result.y;
            result.z = nextRowOutOfBounds ? 0. : result.z;
            result.w = nextColOutOfBounds || nextRowOutOfBounds ? 0. : result.w;
          `;
                    else checkOutOfBoundsString += `
            bool nextRowOutOfBounds =
              (${channels[rank - 2]} + 1) >= ${this.outputShape[rank - 2]};
            bool nextColOutOfBounds =
              (${channels[rank - 1]} + 1) >= ${this.outputShape[rank - 1]};
            result.y = nextColOutOfBounds ? 0. : result.y;
            result.z = nextRowOutOfBounds ? 0. : result.z;
            result.w = nextColOutOfBounds || nextRowOutOfBounds ? 0. : result.w;
          `;
                }
            }
        }
        this.userCode = `
      vec4 binaryOperation(vec4 a, vec4 b) {
        ${op}
      }

      void main() {
        vec4 a = getAAtOutCoords();
        vec4 b = getBAtOutCoords();

        vec4 result = binaryOperation(a, b);
        ${checkOutOfBoundsString}

        setOutput(result);
      }
    `;
    }
}


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
function $2b13f312c76ad9c3$export$f0954fd7d5368655(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    backend.incRef(x.dataId);
    return {
        dataId: x.dataId,
        shape: x.shape,
        dtype: x.dtype
    };
}
const $2b13f312c76ad9c3$export$c426d3942537ad84 = {
    kernelName: (0, $i64bB.Identity),
    backendName: 'webgl',
    kernelFunc: $2b13f312c76ad9c3$export$f0954fd7d5368655
};


function $f23c2381cb68ff19$export$83a0e34f1302825b(args) {
    const { inputs: inputs, backend: backend } = args;
    const { real: real, imag: imag } = inputs;
    const complexInfo = backend.makeTensorInfo(real.shape, 'complex64');
    const complex = backend.texData.get(complexInfo.dataId);
    const realTensorInfo = (0, $2b13f312c76ad9c3$export$f0954fd7d5368655)({
        inputs: {
            x: real
        },
        backend: backend
    });
    const imagTensorInfo = (0, $2b13f312c76ad9c3$export$f0954fd7d5368655)({
        inputs: {
            x: imag
        },
        backend: backend
    });
    complex.complexTensorInfos = {
        real: realTensorInfo,
        imag: imagTensorInfo
    };
    return complexInfo;
}
const $f23c2381cb68ff19$export$67917f7910d27fd8 = {
    kernelName: (0, $i64bB.Complex),
    backendName: 'webgl',
    kernelFunc: $f23c2381cb68ff19$export$83a0e34f1302825b
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


const $442fcb85a2be5920$export$92ed4431d8daa517 = `return (a < 0.) ? b * a : a;`;
const $442fcb85a2be5920$export$e86410c26dcc9bb1 = `
  vec4 aLessThanZero = vec4(lessThan(a, vec4(0.)));
  return (aLessThanZero * (b * a)) + ((vec4(1.0) - aLessThanZero) * a);
`;
function $442fcb85a2be5920$export$23a860e40a2c6b61(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { alpha: alpha } = attrs;
    const $alpha = backend.makeTensorInfo([], 'float32', (0, $i64bB.util).createScalarValue(alpha, 'float32'));
    const program = (0, $i64bB.env)().getBool('WEBGL_PACK_BINARY_OPERATIONS') ? new (0, $1b00798c48aa5c1a$export$7ef3bdc75c177be0)($442fcb85a2be5920$export$e86410c26dcc9bb1, x.shape, $alpha.shape) : new (0, $a3544edc66d558ba$export$9045e9161086790b)($442fcb85a2be5920$export$92ed4431d8daa517, x.shape, $alpha.shape);
    const result = backend.runWebGLProgram(program, [
        x,
        $alpha
    ], 'float32');
    backend.disposeIntermediateTensorInfo($alpha);
    return result;
}
const $442fcb85a2be5920$export$aa04ab963fdf437f = {
    kernelName: (0, $i64bB.LeakyRelu),
    backendName: 'webgl',
    kernelFunc: $442fcb85a2be5920$export$23a860e40a2c6b61
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


const $d02b300568754543$export$97f8593018a4b737 = `return (a < 0.) ? b * a : a;`;
const $d02b300568754543$export$4cc182bd80c9848a = `
  vec4 aLessThanZero = vec4(lessThan(a, vec4(0.)));
  return (aLessThanZero * (b * a)) + ((vec4(1.0) - aLessThanZero) * a);
`;
function $d02b300568754543$export$5882f235222e6729(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x, alpha: alpha } = inputs;
    const program = (0, $i64bB.env)().getBool('WEBGL_PACK_BINARY_OPERATIONS') ? new (0, $1b00798c48aa5c1a$export$7ef3bdc75c177be0)($d02b300568754543$export$4cc182bd80c9848a, x.shape, alpha.shape) : new (0, $a3544edc66d558ba$export$9045e9161086790b)($d02b300568754543$export$97f8593018a4b737, x.shape, alpha.shape);
    return backend.runWebGLProgram(program, [
        x,
        alpha
    ], 'float32');
}
const $d02b300568754543$export$a5c4a9b694579636 = {
    kernelName: (0, $i64bB.Prelu),
    backendName: 'webgl',
    kernelFunc: $d02b300568754543$export$5882f235222e6729
};




const $2e65282075da2b30$export$bf39b1cb254b6187 = `if (isnan(x)) return x;`;
function $2e65282075da2b30$export$ba4daf5748026fba({ opSnippet: opSnippet, packedOpSnippet: packedOpSnippet, cpuKernelImpl: cpuKernelImpl, dtype: dtype }) {
    return ({ inputs: inputs, backend: backend })=>{
        const { x: x } = inputs;
        const webglBackend = backend;
        const $dtype = dtype || x.dtype;
        if (webglBackend.shouldExecuteOnCPU([
            x
        ]) && cpuKernelImpl != null) {
            const xData = webglBackend.texData.get(x.dataId);
            const outValues = cpuKernelImpl(xData.values, $dtype);
            return webglBackend.makeTensorInfo(x.shape, $dtype, outValues);
        }
        const shouldUsePackedProgram = (0, $i64bB.env)().getBool('WEBGL_PACK_UNARY_OPERATIONS') && packedOpSnippet != null;
        let program;
        if (shouldUsePackedProgram) program = new (0, $d654f6ab3c8e3848$export$4d8daca4f85ed73d)(x.shape, packedOpSnippet);
        else program = new (0, $d607b1799b79a159$export$f93811a5a466fd42)(x.shape, opSnippet);
        return webglBackend.runWebGLProgram(program, [
            x
        ], $dtype);
    };
}
function $2e65282075da2b30$export$29353c66e70e3e16({ opSnippet: opSnippet, packedOpSnippet: packedOpSnippet, checkOutOfBounds: checkOutOfBounds = false, supportsComplex: supportsComplex = false, cpuKernelImpl: cpuKernelImpl, dtype: dtype }) {
    return ({ inputs: inputs, backend: backend })=>{
        const { a: a, b: b } = inputs;
        const webglBackend = backend;
        if (supportsComplex && a.dtype === 'complex64') {
            const aData = webglBackend.texData.get(a.dataId);
            const bData = webglBackend.texData.get(b.dataId);
            const [real, imag] = [
                [
                    aData.complexTensorInfos.real,
                    bData.complexTensorInfos.real
                ],
                [
                    aData.complexTensorInfos.imag,
                    bData.complexTensorInfos.imag
                ]
            ].map((complexParts)=>{
                const [aPart, bPart] = complexParts;
                const aHandle = {
                    dataId: aPart.dataId,
                    dtype: aPart.dtype,
                    shape: a.shape
                };
                const bHandle = {
                    dataId: bPart.dataId,
                    dtype: bPart.dtype,
                    shape: b.shape
                };
                const program = new (0, $a3544edc66d558ba$export$9045e9161086790b)(opSnippet, a.shape, b.shape);
                return webglBackend.runWebGLProgram(program, [
                    aHandle,
                    bHandle
                ], (0, $i64bB.upcastType)(aPart.dtype, bPart.dtype));
            });
            const complexOutput = (0, $f23c2381cb68ff19$export$83a0e34f1302825b)({
                inputs: {
                    real: real,
                    imag: imag
                },
                backend: webglBackend
            });
            webglBackend.disposeIntermediateTensorInfo(real);
            webglBackend.disposeIntermediateTensorInfo(imag);
            // TODO(annxingyuan): Implement CPU forwarding for complex inputs.
            return complexOutput;
        }
        const $dtype = dtype || (0, $i64bB.upcastType)(a.dtype, b.dtype);
        if ((a.dtype === 'string' || b.dtype === 'string' || webglBackend.shouldExecuteOnCPU([
            a,
            b
        ])) && cpuKernelImpl != null) {
            const aVals = webglBackend.texData.get(a.dataId).values;
            const bVals = webglBackend.texData.get(b.dataId).values;
            const decodedAVals = a.dtype === 'string' ? // tslint:disable-next-line: no-any
            (0, $i64bB.backend_util).fromUint8ToStringArray(aVals) : aVals;
            const decodedBVals = a.dtype === 'string' ? // tslint:disable-next-line: no-any
            (0, $i64bB.backend_util).fromUint8ToStringArray(bVals) : bVals;
            const [outValues, outShape] = cpuKernelImpl(a.shape, b.shape, decodedAVals, decodedBVals, $dtype);
            const out = webglBackend.makeTensorInfo(outShape, $dtype);
            const outData = webglBackend.texData.get(out.dataId);
            outData.values = outValues;
            return out;
        }
        const shouldUsePackedProgram = (0, $i64bB.env)().getBool('WEBGL_PACK_BINARY_OPERATIONS') && packedOpSnippet != null;
        let program;
        if (shouldUsePackedProgram) program = new (0, $1b00798c48aa5c1a$export$7ef3bdc75c177be0)(packedOpSnippet, a.shape, b.shape, checkOutOfBounds);
        else program = new (0, $a3544edc66d558ba$export$9045e9161086790b)(opSnippet, a.shape, b.shape);
        return webglBackend.runWebGLProgram(program, [
            a,
            b
        ], $dtype);
    };
}
function $2e65282075da2b30$export$445d43a4039ec7b7(activation, packed = false) {
    if (activation === 'linear') {
        if (packed) return $d654f6ab3c8e3848$export$8244104593af74a6;
        return $d607b1799b79a159$export$8244104593af74a6;
    } else if (activation === 'relu') {
        if (packed) return $d654f6ab3c8e3848$export$27041fe53e1ee6da;
        return $d607b1799b79a159$export$27041fe53e1ee6da;
    } else if (activation === 'elu') {
        if (packed) return $d654f6ab3c8e3848$export$945a5ccf96adb3b2;
        return $d607b1799b79a159$export$945a5ccf96adb3b2;
    } else if (activation === 'relu6') {
        if (packed) return $d654f6ab3c8e3848$export$94bf29e9c85fc840;
        return $d607b1799b79a159$export$94bf29e9c85fc840;
    } else if (activation === 'prelu') {
        if (packed) return 0, $d02b300568754543$export$4cc182bd80c9848a;
        return 0, $d02b300568754543$export$97f8593018a4b737;
    } else if (activation === 'leakyrelu') {
        if (packed) return 0, $442fcb85a2be5920$export$e86410c26dcc9bb1;
        return 0, $442fcb85a2be5920$export$92ed4431d8daa517;
    } else if (activation === 'sigmoid') {
        if (packed) return $d654f6ab3c8e3848$export$f95dbffd98d0457a;
        return $d607b1799b79a159$export$f95dbffd98d0457a;
    }
    throw new Error(`Activation ${activation} has not been implemented for the WebGL backend.`);
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
class $d5205fbded8933ee$export$21e5f112101779d8 {
    constructor(aShape, bShape, outputShape, transposeA = false, transposeB = false, addBias = false, activation = null, hasPreluActivation = false, hasLeakyreluActivation = false){
        this.variableNames = [
            'matrixA',
            'matrixB'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.outputShape = outputShape;
        this.enableShapeUniforms = (0, $8c928040c80f573b$export$5acc770fc06a0138)(this.outputShape.length);
        const sharedDim = transposeA ? aShape[1] : aShape[2];
        const sharedDimensionPacked = Math.ceil(sharedDim / 2);
        const aSample = transposeA ? 'i * 2, rc.y' : 'rc.y, i * 2';
        const bSample = transposeB ? 'rc.z, i * 2' : 'i * 2, rc.z';
        const aSwizzle = transposeA ? [
            'a.xxyy',
            'a.zzww'
        ] : [
            'a.xxzz',
            'a.yyww'
        ];
        const bSwizzle = transposeB ? [
            'b.xzxz',
            'b.ywyw'
        ] : [
            'b.xyxy',
            'b.zwzw'
        ];
        let activationSnippet = '', applyActivationSnippet = '';
        if (activation) {
            if (hasPreluActivation) activationSnippet = `vec4 activation(vec4 a) {
          vec4 b = getPreluActivationWeightsAtOutCoords();
          ${activation}
        }`;
            else if (hasLeakyreluActivation) activationSnippet = `vec4 activation(vec4 a) {
          vec4 b = getLeakyreluAlphaAtOutCoords();
          ${activation}
        }`;
            else activationSnippet = `vec4 activation(vec4 x) {
          ${activation}
        }`;
            applyActivationSnippet = `result = activation(result);`;
        }
        const addBiasSnippet = addBias ? 'result += getBiasAtOutCoords();' : '';
        if (addBias) this.variableNames.push('bias');
        if (hasPreluActivation) this.variableNames.push('preluActivationWeights');
        if (hasLeakyreluActivation) this.variableNames.push('leakyreluAlpha');
        let batchASnippet = 'rc.x';
        let batchBSnippet = 'rc.x';
        if (aShape[0] < bShape[0]) batchASnippet = `imod(rc.x, ${aShape[0]})`;
        else if (bShape[0] < aShape[0]) batchBSnippet = `imod(rc.x, ${bShape[0]})`;
        this.userCode = `
      ${activationSnippet}
      // Don't use uniform for sharedDimensionPacked for performance.
      const float sharedDimension = ${sharedDimensionPacked}.0;

      vec4 dot2x2ARowBCol(ivec3 rc) {
        vec4 result = vec4(0);
        int batchA = ${batchASnippet};
        int batchB = ${batchBSnippet};
        for (int i = 0; i < ${sharedDimensionPacked}; i++) {
          vec4 a = getMatrixA(batchA, ${aSample});
          vec4 b = getMatrixB(batchB, ${bSample});

          // These swizzled products need to be separately added.
          // See: https://github.com/tensorflow/tfjs/issues/1735
          result += (${aSwizzle[0]} * ${bSwizzle[0]});
          result += (${aSwizzle[1]} * ${bSwizzle[1]});
        }
        return result;
      }

      void main() {
        ivec3 rc = getOutputCoords();
        vec4 result = dot2x2ARowBCol(rc);

        ${addBiasSnippet}

        ${applyActivationSnippet}

        setOutput(result);
      }
    `;
    }
}


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
const $9e71b5f78a9d6544$export$51b2b2579375d8b0 = {
    REAL: 'return areal * breal - aimag * bimag;',
    IMAG: 'return areal * bimag + aimag * breal;'
};
class $9e71b5f78a9d6544$export$d4e4851a08b0c91 {
    constructor(op, aShape, bShape){
        this.variableNames = [
            'AReal',
            'AImag',
            'BReal',
            'BImag'
        ];
        this.outputShape = (0, $i64bB.backend_util).assertAndGetBroadcastShape(aShape, bShape);
        this.userCode = `
      float binaryOpComplex(
          float areal, float aimag, float breal, float bimag) {
        ${op}
      }

      void main() {
        float areal = getARealAtOutCoords();
        float aimag = getAImagAtOutCoords();
        float breal = getBRealAtOutCoords();
        float bimag = getBImagAtOutCoords();
        setOutput(binaryOpComplex(areal, aimag, breal, bimag));
      }
    `;
    }
}






const $14ecc88d5b9c3d28$var$MUL = 'return a * b;';
function $14ecc88d5b9c3d28$export$2060d2db72cce88f(args) {
    const { inputs: inputs, backend: backend } = args;
    const { a: a, b: b } = inputs;
    const dtype = (0, $i64bB.backend_util).upcastType(a.dtype, b.dtype);
    if (a.dtype === 'complex64') {
        const aData = backend.texData.get(a.dataId);
        const bData = backend.texData.get(b.dataId);
        const realProgram = new (0, $9e71b5f78a9d6544$export$d4e4851a08b0c91)($9e71b5f78a9d6544$export$51b2b2579375d8b0.REAL, a.shape, b.shape);
        const imagProgram = new (0, $9e71b5f78a9d6544$export$d4e4851a08b0c91)($9e71b5f78a9d6544$export$51b2b2579375d8b0.IMAG, a.shape, b.shape);
        const inputs = [
            {
                dataId: aData.complexTensorInfos.real.dataId,
                dtype: aData.complexTensorInfos.real.dtype,
                shape: a.shape
            },
            {
                dataId: aData.complexTensorInfos.imag.dataId,
                dtype: aData.complexTensorInfos.imag.dtype,
                shape: a.shape
            },
            {
                dataId: bData.complexTensorInfos.real.dataId,
                dtype: bData.complexTensorInfos.real.dtype,
                shape: b.shape
            },
            {
                dataId: bData.complexTensorInfos.imag.dataId,
                dtype: bData.complexTensorInfos.imag.dtype,
                shape: b.shape
            }
        ];
        const realPart = backend.runWebGLProgram(realProgram, inputs, 'float32');
        const imagPart = backend.runWebGLProgram(imagProgram, inputs, 'float32');
        const complexOutput = (0, $f23c2381cb68ff19$export$83a0e34f1302825b)({
            inputs: {
                real: realPart,
                imag: imagPart
            },
            backend: backend
        });
        backend.disposeIntermediateTensorInfo(realPart);
        backend.disposeIntermediateTensorInfo(imagPart);
        // TODO(annxingyuan): CPU forwarding for complex inputs.
        return complexOutput;
    }
    if (backend.shouldExecuteOnCPU([
        a,
        b
    ])) {
        const aData = backend.texData.get(a.dataId);
        const bData = backend.texData.get(b.dataId);
        const [outValues, outShape] = (0, $377486a788efd20b$export$598d1d66b05a298f)(a.shape, b.shape, aData.values, bData.values, dtype);
        const out = backend.makeTensorInfo(outShape, dtype);
        const outData = backend.texData.get(out.dataId);
        outData.values = outValues;
        return out;
    }
    let program;
    if ((0, $i64bB.env)().getBool('WEBGL_PACK_BINARY_OPERATIONS')) program = new (0, $1b00798c48aa5c1a$export$7ef3bdc75c177be0)($14ecc88d5b9c3d28$var$MUL, a.shape, b.shape);
    else program = new (0, $a3544edc66d558ba$export$9045e9161086790b)($14ecc88d5b9c3d28$var$MUL, a.shape, b.shape);
    return backend.runWebGLProgram(program, [
        a,
        b
    ], dtype);
}
const $14ecc88d5b9c3d28$export$745576778aafee88 = {
    kernelName: (0, $i64bB.Multiply),
    backendName: 'webgl',
    kernelFunc: $14ecc88d5b9c3d28$export$2060d2db72cce88f
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $b3d1cbb0158d1a0b$export$2ae2c9dd4c61df98(input, afterShape, backend) {
    const input3DShape = [
        (0, $03fc80a4a4cef09e$export$4dfd7bc0667970e0)(input.shape),
        ...(0, $03fc80a4a4cef09e$export$e8f6c350b57b8270)(input.shape)
    ];
    const input3D = {
        dtype: input.dtype,
        shape: input3DShape,
        dataId: input.dataId
    };
    const afterShapeAs3D = [
        (0, $03fc80a4a4cef09e$export$4dfd7bc0667970e0)(afterShape),
        ...(0, $03fc80a4a4cef09e$export$e8f6c350b57b8270)(afterShape)
    ];
    const program = new (0, $49ff511a513b21e1$export$ce249f6fedcc44de)(afterShapeAs3D, input3DShape);
    const preventEagerUnpackingOfOutput = true;
    const customValues = [
        input3DShape
    ];
    const output = backend.runWebGLProgram(program, [
        input3D
    ], input.dtype, customValues, preventEagerUnpackingOfOutput);
    return {
        dataId: output.dataId,
        shape: afterShape,
        dtype: output.dtype
    };
}



function $6e79ac71d9dab042$export$9eaad88cf88cee2b(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { shape: shape } = attrs;
    const webglBackend = backend;
    const xSize = (0, $i64bB.util).sizeFromShape(x.shape);
    const $shape = (0, $i64bB.util).inferFromImplicitShape(shape, xSize);
    const $xSize = (0, $i64bB.util).sizeFromShape($shape);
    (0, $i64bB.util).assert(xSize === $xSize, ()=>`The new shape (${$shape}) has ${$xSize} elements and the old ` + `shape (${x.shape}) has ${xSize} elements. The new shape and old ` + `shape must have the same number of elements.`);
    const xTexData = webglBackend.texData.get(x.dataId);
    if (xTexData.isPacked && !(0, $03fc80a4a4cef09e$export$951b388203a0422d)(x.shape, $shape) && !(xTexData.texture !== null && (0, $03fc80a4a4cef09e$export$951b388203a0422d)(xTexData.shape, $shape))) return (0, $b3d1cbb0158d1a0b$export$2ae2c9dd4c61df98)(x, $shape, webglBackend);
    webglBackend.incRef(x.dataId);
    return {
        dataId: x.dataId,
        shape: $shape,
        dtype: x.dtype
    };
}
const $6e79ac71d9dab042$export$cfa02e698602aca2 = {
    kernelName: (0, $i64bB.Reshape),
    backendName: 'webgl',
    kernelFunc: $6e79ac71d9dab042$export$9eaad88cf88cee2b
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
class $2b9786cf8c0c3ea1$export$a1460fd06abdca4 {
    constructor(reduceInfo, divisor){
        this.variableNames = [
            'x'
        ];
        const { windowSize: windowSize, batchSize: batchSize, inSize: inSize, outSize: outSize } = reduceInfo;
        this.outputShape = [
            batchSize,
            outSize
        ];
        const windowSizeNearestVec4 = Math.floor(windowSize / 4) * 4;
        const windowSizeVec4Remainder = windowSize % 4;
        let updateSnippet = `sumValue += dot(values, ones);`;
        if (divisor != null) {
            const denominator = 1 / divisor;
            updateSnippet = `sumValue += dot(values * ${(0, $i64bB.util).isInt(denominator) ? denominator.toPrecision(2) : denominator}, ones);`;
        }
        let checkOutOfBounds = '';
        if (inSize % windowSize > 0) checkOutOfBounds = `
        if (inIdx < 0 || inIdx >= ${inSize}) {
          return 0.0;
        }
      `;
        this.userCode = `
      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);

      float getValue(int batch, int inIdx) {
        ${checkOutOfBounds}
        return getX(batch, inIdx);
      }

      void main() {
        ivec2 coords = getOutputCoords();
        int batch = coords[0];
        int outIdx = coords[1];
        int inOffset = outIdx * ${windowSize};

        float sumValue = 0.0;

        for (int i = 0; i < ${windowSizeNearestVec4}; i += 4) {
          int inIdx = inOffset + i;
          vec4 values = vec4(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            getValue(batch, inIdx + 2),
            getValue(batch, inIdx + 3)
          );

          ${updateSnippet}
        }

        int inIdx = inOffset + ${windowSizeNearestVec4};
        if (${windowSizeVec4Remainder === 1}) {
          vec4 values = vec4(getValue(batch, inIdx), 0.0, 0.0, 0.0);

          ${updateSnippet}
        } else if (${windowSizeVec4Remainder === 2}) {
          vec4 values = vec4(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1), 0.0, 0.0);

          ${updateSnippet}
        } else if (${windowSizeVec4Remainder === 3}) {
          vec4 values = vec4(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            getValue(batch, inIdx + 2), 0.0);

          ${updateSnippet}
        }
        setOutput(sumValue);
      }
    `;
    }
}


/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $e14060707aa31438$export$14f07173aed228a5 {
    constructor(reduceInfo, reduceType){
        this.variableNames = [
            'x'
        ];
        const { windowSize: windowSize, batchSize: batchSize, inSize: inSize, outSize: outSize } = reduceInfo;
        this.outputShape = [
            batchSize,
            outSize
        ];
        let initializationValue = '0.0';
        let compareOp = ``;
        if (reduceType === 'prod') initializationValue = '1.0';
        else if (reduceType === 'min') {
            // WebGL on Firefox Linux can't compile 1/0 so we do 1/eps.
            initializationValue = '1.0 / 1e-20';
            compareOp = `min`;
        } else if (reduceType === 'max') {
            // WebGL on Firefox Linux can't compile 1/0 so we do 1/eps.
            initializationValue = '-1.0 / 1e-20';
            compareOp = `max`;
        }
        let returnValue = `${reduceType}(${reduceType}(${reduceType}(` + 'minMaxValue[0], minMaxValue[1]), minMaxValue[2]), minMaxValue[3])';
        if (reduceType === 'sum') returnValue = `sumValue`;
        else if (reduceType === 'prod') returnValue = `prodValue`;
        else if (reduceType === 'all') returnValue = `allValue`;
        else if (reduceType === 'any') returnValue = `anyValue`;
        const windowSizeNearestVec4 = Math.floor(windowSize / 4) * 4;
        const windowSizeVec4Remainder = windowSize % 4;
        let updateSnippet = `
      if (${reduceType === 'sum'}) {
        sumValue += dot(values, ones);
      } else if (${reduceType === 'prod'}) {
        vec2 tmp = vec2(values[0], values[1]) * vec2(values[2], values[3]);
        prodValue *= tmp[0] * tmp[1];
      } else {
        minMaxValue = ${compareOp}(values, minMaxValue);
        if (${reduceType === 'min'} || ${reduceType === 'max'}) {
          minMaxValue = ${compareOp}(values, minMaxValue);
          bvec4 isNaN = isnan(values);
          if (isNaN.r || isNaN.g || isNaN.b || isNaN.a) {
            minMaxValue = vec4(NAN);
          }
        }
      }
    `;
        let vecType = `vec4`;
        if (reduceType === 'all') {
            initializationValue = '1.0';
            updateSnippet = `
        bool reducedAllValue = all(values);
        float floatedReducedAllValue = float(reducedAllValue);
        allValue = float(allValue >= 1.0 && floatedReducedAllValue >= 1.0);
      `;
            vecType = `bvec4`;
        } else if (reduceType === 'any') {
            initializationValue = '0.0';
            updateSnippet = `
        bool reducedAnyValue = any(values);
        float floatedReducedAnyValue = float(reducedAnyValue);
        anyValue = float(anyValue >= 1.0 || floatedReducedAnyValue >= 1.0);
      `;
            vecType = `bvec4`;
        }
        let checkOutOfBounds = '';
        if (inSize % windowSize > 0) checkOutOfBounds = `
        if (inIdx < 0 || inIdx >= ${inSize}) {
          return initializationValue;
        }
      `;
        this.userCode = `
      const float initializationValue = ${initializationValue};
      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);

      float getValue(int batch, int inIdx) {
        ${checkOutOfBounds}
        return getX(batch, inIdx);
      }

      void main() {
        ivec2 coords = getOutputCoords();
        int batch = coords[0];
        int outIdx = coords[1];
        int inOffset = outIdx * ${windowSize};

        vec4 minMaxValue = vec4(${initializationValue});
        float prodValue = 1.0;
        float sumValue = 0.0;
        float allValue = 1.0;
        float anyValue = 0.0;

        for (int i = 0; i < ${windowSizeNearestVec4}; i += 4) {
          int inIdx = inOffset + i;
          ${vecType} values = ${vecType}(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            getValue(batch, inIdx + 2),
            getValue(batch, inIdx + 3)
          );

          ${updateSnippet}
        }

        int inIdx = inOffset + ${windowSizeNearestVec4};
        if (${windowSizeVec4Remainder === 1}) {
          ${vecType} values = ${vecType}(
            getValue(batch, inIdx),
            initializationValue,
            initializationValue,
            initializationValue
          );

          ${updateSnippet}
        } else if (${windowSizeVec4Remainder === 2}) {
          ${vecType} values = ${vecType}(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            initializationValue,
            initializationValue
          );

          ${updateSnippet}
        } else if (${windowSizeVec4Remainder === 3}) {
          ${vecType} values = ${vecType}(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            getValue(batch, inIdx + 2),
            initializationValue
          );

          ${updateSnippet}
        }
        setOutput(${returnValue});
      }
    `;
    }
}


// Returns an array of configuration objects that describe each stage of the
// reduction.
function $8c1b6ed50cb28ef5$var$getReductionStages(inShape) {
    const stages = [];
    while(stages.length === 0 || stages[stages.length - 1].outSize !== 1){
        const outSize = stages.length ? stages[stages.length - 1].outSize : inShape[1];
        const windowSize = (0, $i64bB.backend_util).computeOptimalWindowSize(outSize);
        stages.push({
            inSize: outSize,
            windowSize: windowSize,
            outSize: Math.ceil(outSize / windowSize)
        });
    }
    return stages;
}
function $8c1b6ed50cb28ef5$export$533b26079ad0b4b(x, dtype, reductionType, backend) {
    const reductionStages = $8c1b6ed50cb28ef5$var$getReductionStages(x.shape);
    let result = x;
    for(let i = 0; i < reductionStages.length; i++){
        const { inSize: inSize, windowSize: windowSize, outSize: outSize } = reductionStages[i];
        let program;
        let previousResult;
        if (reductionType === 'mean') program = i === 0 ? new (0, $2b9786cf8c0c3ea1$export$a1460fd06abdca4)({
            windowSize: windowSize,
            inSize: inSize,
            batchSize: x.shape[0],
            outSize: outSize
        }, inSize) : new (0, $2b9786cf8c0c3ea1$export$a1460fd06abdca4)({
            windowSize: windowSize,
            inSize: inSize,
            batchSize: x.shape[0],
            outSize: outSize
        });
        else program = new (0, $e14060707aa31438$export$14f07173aed228a5)({
            windowSize: windowSize,
            inSize: inSize,
            batchSize: x.shape[0],
            outSize: outSize
        }, reductionType);
        previousResult = result;
        result = backend.runWebGLProgram(program, [
            result
        ], dtype);
        if (previousResult.dataId !== x.dataId) backend.disposeIntermediateTensorInfo(previousResult);
    }
    return result;
}



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
class $ce78539e1ffbd289$export$e48ac6bd7e0ddfac {
    constructor(aShape, newDim){
        this.variableNames = [
            'A'
        ];
        const outputShape = new Array(aShape.length);
        for(let i = 0; i < outputShape.length; i++)outputShape[i] = aShape[newDim[i]];
        this.outputShape = outputShape;
        this.rank = outputShape.length;
        const dtype = (0, $ba2c54ffbda39e8e$export$859efd105c10c755)(this.rank);
        const switched = $ce78539e1ffbd289$var$getSwitchedCoords(newDim);
        this.userCode = `
    void main() {
      ${dtype} resRC = getOutputCoords();
      setOutput(getA(${switched}));
    }
    `;
    }
}
function $ce78539e1ffbd289$var$getSwitchedCoords(newDim) {
    const rank = newDim.length;
    if (rank > 6) throw Error(`Transpose for rank ${rank} is not yet supported`);
    const originalOrder = [
        'resRC.x',
        'resRC.y',
        'resRC.z',
        'resRC.w',
        'resRC.u',
        'resRC.v'
    ];
    const switchedCoords = new Array(rank);
    for(let i = 0; i < newDim.length; i++)switchedCoords[newDim[i]] = originalOrder[i];
    return switchedCoords.join();
}


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $92ef2299ab095930$export$4daa0c968248fb58 {
    constructor(aShape, newDim){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        const outputShape = new Array(aShape.length);
        for(let i = 0; i < outputShape.length; i++)outputShape[i] = aShape[newDim[i]];
        this.outputShape = outputShape;
        this.rank = outputShape.length;
        if (this.rank > 6) throw Error(`Packed transpose for rank ${this.rank} is not yet supported.`);
        const dtype = (0, $ba2c54ffbda39e8e$export$859efd105c10c755)(this.rank);
        const outputOrder = (0, $30912e1180ed417f$export$a7c2113d79df2971)('rc', this.rank);
        const switchedOrder = new Array(this.rank);
        for(let i = 0; i < newDim.length; i++)switchedOrder[newDim[i]] = outputOrder[i];
        const innerDims = `vec2(${switchedOrder.slice(-2).join()})`;
        const nextColumn = `++${outputOrder[this.rank - 1]} < ${outputShape[this.rank - 1]}`;
        const getc = `getChannel(getA(${switchedOrder.join()}), ${innerDims})`;
        this.userCode = `
    void main() {
      ${dtype} rc = getOutputCoords();
      vec4 result = vec4(0.);
      result[0] = ${getc};
      if(${nextColumn}) {
        result[1] = ${getc};
      }
      --${outputOrder[this.rank - 1]};
      if(++${outputOrder[this.rank - 2]} < ${outputShape[this.rank - 2]}) {
        result[2] = ${getc};
        if(${nextColumn}) {
          result[3] = ${getc};
        }
      }
      setOutput(result);
    }
    `;
    }
}


function $3fdf015ef273b3f6$export$986b9e65182e08d(x, perm, backend) {
    const program = (0, $i64bB.env)().getBool('WEBGL_PACK_ARRAY_OPERATIONS') ? new (0, $92ef2299ab095930$export$4daa0c968248fb58)(x.shape, perm) : new (0, $ce78539e1ffbd289$export$e48ac6bd7e0ddfac)(x.shape, perm);
    return backend.runWebGLProgram(program, [
        x
    ], x.dtype);
}


function $c410aece0a9faeac$export$c29f6d05a9b60dfa(x, axis, keepDims, backend) {
    const reductionIndices = axis;
    const xRank = x.shape.length;
    const origAxes = (0, $i64bB.util).parseAxisParam(reductionIndices, x.shape);
    let axes = origAxes;
    const permutedAxes = (0, $i64bB.backend_util).getAxesPermutation(axes, xRank);
    const sumInputIsTransposed = permutedAxes != null;
    let sumInput = x;
    if (sumInputIsTransposed) {
        sumInput = (0, $3fdf015ef273b3f6$export$986b9e65182e08d)(x, permutedAxes, backend);
        axes = (0, $i64bB.backend_util).getInnerMostAxes(axes.length, xRank);
    }
    (0, $i64bB.backend_util).assertAxesAreInnerMostDims('sum', axes, xRank);
    const [sumOutShape, reduceShape] = (0, $i64bB.backend_util).computeOutAndReduceShapes(sumInput.shape, axes);
    let outShape = sumOutShape;
    if (keepDims) // rather than reshape at the end, set the target shape here.
    outShape = (0, $i64bB.backend_util).expandShapeToKeepDim(sumOutShape, origAxes);
    const inSize = (0, $i64bB.util).sizeFromShape(reduceShape);
    const xSize = (0, $i64bB.util).sizeFromShape(x.shape);
    const batchSize = xSize / inSize;
    const reshapedInput = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: sumInput
        },
        attrs: {
            shape: [
                batchSize,
                inSize
            ]
        },
        backend: backend
    });
    const outType = (0, $i64bB.sumOutType)(x.dtype);
    const reduced = (0, $8c1b6ed50cb28ef5$export$533b26079ad0b4b)(reshapedInput, outType, 'sum', backend);
    const out = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: reduced
        },
        attrs: {
            shape: outShape
        },
        backend: backend
    });
    backend.disposeIntermediateTensorInfo(reshapedInput);
    backend.disposeIntermediateTensorInfo(reduced);
    if (sumInputIsTransposed) backend.disposeIntermediateTensorInfo(sumInput);
    return out;
}


function $579f4cd1cc49add3$export$8a63f25cc62965f1(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    return (0, $c410aece0a9faeac$export$c29f6d05a9b60dfa)(x, axis, keepDims, backend);
}
const $579f4cd1cc49add3$export$47edea402251c258 = {
    kernelName: (0, $i64bB.Sum),
    backendName: 'webgl',
    kernelFunc: $579f4cd1cc49add3$export$8a63f25cc62965f1
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

function $6cab078553124169$export$9cb09a71b7d66923(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { perm: perm } = attrs;
    const webglBackend = backend;
    const xRank = x.shape.length;
    const newShape = new Array(xRank);
    for(let i = 0; i < newShape.length; i++)newShape[i] = x.shape[perm[i]];
    let out;
    if (webglBackend.shouldExecuteOnCPU([
        x
    ])) {
        const xTexData = webglBackend.texData.get(x.dataId);
        const values = xTexData.values;
        const outValues = (0, $377486a788efd20b$export$a0105d4a7143676c)(values, x.shape, x.dtype, perm, newShape);
        out = webglBackend.makeTensorInfo(newShape, x.dtype);
        const outData = webglBackend.texData.get(out.dataId);
        outData.values = outValues;
    } else out = (0, $3fdf015ef273b3f6$export$986b9e65182e08d)(x, perm, webglBackend);
    return out;
}
const $6cab078553124169$export$895a002a39b774be = {
    kernelName: (0, $i64bB.Transpose),
    backendName: 'webgl',
    kernelFunc: $6cab078553124169$export$9cb09a71b7d66923
};


const $400586318c9d65f3$export$42c1ddb439199e73 = 1000;
function $400586318c9d65f3$export$d524d65e88e1168b({ a: a, b: b, transposeA: transposeA, transposeB: transposeB, backend: backend, bias: bias = null, preluActivationWeights: preluActivationWeights = null, leakyreluAlpha: leakyreluAlpha = 0, activation: activation = null }) {
    const aRank = a.shape.length;
    const bRank = b.shape.length;
    const innerShapeA = transposeA ? a.shape[aRank - 2] : a.shape[aRank - 1];
    const innerShapeB = transposeB ? b.shape[bRank - 1] : b.shape[bRank - 2];
    const outerShapeA = transposeA ? a.shape[aRank - 1] : a.shape[aRank - 2];
    const outerShapeB = transposeB ? b.shape[bRank - 2] : b.shape[bRank - 1];
    const outerDimsA = a.shape.slice(0, -2);
    const outerDimsB = b.shape.slice(0, -2);
    const batchDimA = (0, $i64bB.util).sizeFromShape(outerDimsA);
    const batchDimB = (0, $i64bB.util).sizeFromShape(outerDimsB);
    const outShapeOuterDims = (0, $i64bB.broadcast_util).assertAndGetBroadcastShape(a.shape.slice(0, -2), b.shape.slice(0, -2));
    const outShape = outShapeOuterDims.concat([
        outerShapeA,
        outerShapeB
    ]);
    (0, $i64bB.util).assert(innerShapeA === innerShapeB, ()=>`Error in matMul: inner shapes (${innerShapeA}) and (` + `${innerShapeB}) of Tensors with shapes ${a.shape} and ` + `${b.shape} and transposeA=${transposeA}` + ` and transposeB=${transposeB} must match.`);
    const a3dShape = transposeA ? [
        batchDimA,
        innerShapeA,
        outerShapeA
    ] : [
        batchDimA,
        outerShapeA,
        innerShapeA
    ];
    const b3dShape = transposeB ? [
        batchDimB,
        outerShapeB,
        innerShapeB
    ] : [
        batchDimB,
        innerShapeB,
        outerShapeB
    ];
    // The rest of the implementation is designed to operate on rank-3 tensors
    const a3d = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: a
        },
        backend: backend,
        attrs: {
            shape: a3dShape
        }
    });
    const b3d = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: b
        },
        backend: backend,
        attrs: {
            shape: b3dShape
        }
    });
    const intermediates = [
        a3d,
        b3d
    ];
    const batchDim = Math.max(batchDimA, batchDimB);
    const sharedDim = transposeA ? a3d.shape[1] : a3d.shape[2];
    const hasBias = bias != null;
    const hasPreluActivationWeights = preluActivationWeights != null;
    const hasLeakyreluAlpha = activation === 'leakyrelu';
    const fusedActivation = activation != null ? (0, $2e65282075da2b30$export$445d43a4039ec7b7)(activation, true) : null;
    const containsFusedOps = hasBias || hasPreluActivationWeights || hasLeakyreluAlpha || fusedActivation != null;
    let out;
    // Since the matrices are vectors, it is faster to call mul().sum()
    // because sum() is O(sqrt(N)) due to divide-and-conquer.
    if ((outerShapeA === 1 || outerShapeB === 1) && sharedDim > $400586318c9d65f3$export$42c1ddb439199e73 && containsFusedOps === false) {
        let aVec = a3d;
        let bVec = b3d;
        if (transposeA) {
            aVec = (0, $6cab078553124169$export$9cb09a71b7d66923)({
                inputs: {
                    x: a3d
                },
                backend: backend,
                attrs: {
                    perm: [
                        0,
                        2,
                        1
                    ]
                }
            });
            intermediates.push(aVec);
        }
        if (transposeB) {
            bVec = (0, $6cab078553124169$export$9cb09a71b7d66923)({
                inputs: {
                    x: b3d
                },
                backend: backend,
                attrs: {
                    perm: [
                        0,
                        2,
                        1
                    ]
                }
            });
            intermediates.push(bVec);
        }
        const shouldReshapeA = outerShapeB !== 1;
        const shouldReshapeB = outerShapeB === 1;
        let aVec3d = aVec;
        if (shouldReshapeA) {
            aVec3d = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
                inputs: {
                    x: aVec
                },
                backend: backend,
                attrs: {
                    shape: [
                        batchDim,
                        sharedDim,
                        1
                    ]
                }
            });
            intermediates.push(aVec3d);
        }
        const axis = outerShapeB === 1 ? 2 : 1;
        let bVec3d = bVec;
        if (shouldReshapeB) {
            bVec3d = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
                inputs: {
                    x: bVec
                },
                backend: backend,
                attrs: {
                    shape: [
                        batchDim,
                        1,
                        sharedDim
                    ]
                }
            });
            intermediates.push(bVec3d);
        }
        const product = (0, $14ecc88d5b9c3d28$export$2060d2db72cce88f)({
            inputs: {
                a: aVec3d,
                b: bVec3d
            },
            backend: backend
        });
        out = (0, $579f4cd1cc49add3$export$8a63f25cc62965f1)({
            inputs: {
                x: product
            },
            backend: backend,
            attrs: {
                axis: axis,
                keepDims: true
            }
        });
        intermediates.push(product);
    } else {
        const dtype = (0, $i64bB.upcastType)(a.dtype, b.dtype);
        const program = new (0, $d5205fbded8933ee$export$21e5f112101779d8)(a3dShape, b3dShape, [
            batchDim,
            outerShapeA,
            outerShapeB
        ], transposeA, transposeB, hasBias, fusedActivation, hasPreluActivationWeights, hasLeakyreluAlpha);
        const inputs = [
            a3d,
            b3d
        ];
        if (bias != null) inputs.push(bias);
        if (hasPreluActivationWeights) inputs.push(preluActivationWeights);
        if (hasLeakyreluAlpha) {
            const $leakyreluAlpha = backend.makeTensorInfo([], 'float32', (0, $i64bB.util).createScalarValue(leakyreluAlpha, 'float32'));
            inputs.push($leakyreluAlpha);
            intermediates.push($leakyreluAlpha);
        }
        out = backend.runWebGLProgram(program, inputs, dtype);
    }
    const outReshaped = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: out
        },
        backend: backend,
        attrs: {
            shape: outShape
        }
    });
    intermediates.push(out);
    for (const i of intermediates)backend.disposeIntermediateTensorInfo(i);
    return outReshaped;
}


function $2a7a93337843b2bb$export$d86ca0bbe0236889(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { a: a, b: b, bias: bias, preluActivationWeights: preluActivationWeights } = inputs;
    const { transposeA: transposeA, transposeB: transposeB, activation: activation, leakyreluAlpha: leakyreluAlpha } = attrs;
    return (0, $400586318c9d65f3$export$d524d65e88e1168b)({
        a: a,
        b: b,
        transposeA: transposeA,
        transposeB: transposeB,
        backend: backend,
        bias: bias,
        preluActivationWeights: preluActivationWeights,
        leakyreluAlpha: leakyreluAlpha,
        activation: activation
    });
}
const $2a7a93337843b2bb$export$f70d36da1c218f84 = {
    kernelName: (0, $i64bB._FusedMatMul),
    backendName: 'webgl',
    kernelFunc: $2a7a93337843b2bb$export$d86ca0bbe0236889
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");



const $d0fa4de08a37af90$var$ABS = `return abs(x);`;
function $d0fa4de08a37af90$export$2335f513bbd82c6d(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    // TODO: handle cases when x is complex. Once the cpu implementation
    // can handle complex values, refactor to use unaryKernelFunc.
    if (backend.shouldExecuteOnCPU([
        x
    ]) && x.dtype !== 'complex64') {
        const xData = backend.texData.get(x.dataId);
        const outValues = (0, $377486a788efd20b$export$d7efa3585619eabe)(xData.values);
        return backend.makeTensorInfo(x.shape, x.dtype, outValues);
    }
    let program;
    if ((0, $i64bB.env)().getBool('WEBGL_PACK_UNARY_OPERATIONS')) program = new (0, $d654f6ab3c8e3848$export$4d8daca4f85ed73d)(x.shape, $d0fa4de08a37af90$var$ABS);
    else program = new (0, $d607b1799b79a159$export$f93811a5a466fd42)(x.shape, $d0fa4de08a37af90$var$ABS);
    return backend.runWebGLProgram(program, [
        x
    ], x.dtype);
}
const $d0fa4de08a37af90$export$d66f48648b9d5ec7 = {
    kernelName: (0, $i64bB.Abs),
    backendName: 'webgl',
    kernelFunc: $d0fa4de08a37af90$export$2335f513bbd82c6d
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


const $8a8ab7765d71f855$var$ACOS = (0, $d607b1799b79a159$export$39f0cca2b63399f6) + `
  if (abs(x) > 1.) {
    return NAN;
  }
  return acos(x);
`;
const $8a8ab7765d71f855$export$fd6306be3fde5b04 = (0, $2e65282075da2b30$export$ba4daf5748026fba)({
    opSnippet: $8a8ab7765d71f855$var$ACOS
});
const $8a8ab7765d71f855$export$255826ca70737275 = {
    kernelName: (0, $i64bB.Acos),
    backendName: 'webgl',
    kernelFunc: $8a8ab7765d71f855$export$fd6306be3fde5b04
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


const $3ca6396ddc5af6e7$var$ACOSH = (0, $d607b1799b79a159$export$39f0cca2b63399f6) + `
  if (x < 1.0) return NAN;
return log(x + sqrt(x * x - 1.0));`;
const $3ca6396ddc5af6e7$export$b26caf0f29211d08 = (0, $2e65282075da2b30$export$ba4daf5748026fba)({
    opSnippet: $3ca6396ddc5af6e7$var$ACOSH
});
const $3ca6396ddc5af6e7$export$3f520b71a56c9e70 = {
    kernelName: (0, $i64bB.Acosh),
    backendName: 'webgl',
    kernelFunc: $3ca6396ddc5af6e7$export$b26caf0f29211d08
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


const $f8bb1e7111872926$var$ADD = 'return a + b;';
const $f8bb1e7111872926$export$d50bf7e4980f70a9 = (0, $2e65282075da2b30$export$29353c66e70e3e16)({
    opSnippet: $f8bb1e7111872926$var$ADD,
    packedOpSnippet: $f8bb1e7111872926$var$ADD,
    supportsComplex: true,
    cpuKernelImpl: (0, $377486a788efd20b$export$c7f405723b4a93e7)
});
const $f8bb1e7111872926$export$b1f3a580afb68e4c = {
    kernelName: (0, $i64bB.Add),
    backendName: 'webgl',
    kernelFunc: $f8bb1e7111872926$export$d50bf7e4980f70a9
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $98f4a305e577731b$export$9d269fc8eb4783d5 {
    constructor(outputShape, shapes){
        this.outputShape = [];
        this.outputShape = outputShape;
        this.variableNames = shapes.map((_, i)=>`T${i}`);
        const snippets = [];
        // Get target elements from every input tensor.
        this.variableNames.forEach((variable)=>{
            snippets.push(`float v${variable} = get${variable}AtOutCoords();`);
        });
        // Calculate the sum of all elements.
        const operation = this.variableNames.map((variable)=>{
            return `v${variable}`;
        }).join(' + ');
        this.userCode = `
      void main() {
        ${snippets.join('\n        ')}

        float result = ${operation};
        setOutput(result);
      }
    `;
    }
}


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $5e2048779572efff$export$156b01c0aab97d90 {
    constructor(outputShape, shapes){
        this.outputShape = [];
        this.packedInputs = true;
        this.packedOutput = true;
        this.outputShape = outputShape;
        this.variableNames = shapes.map((_, i)=>`T${i}`);
        const snippets = [];
        // Get target elements from every input tensor.
        this.variableNames.forEach((variable)=>{
            snippets.push(`vec4 v${variable} = get${variable}AtOutCoords();`);
        });
        // Calculate the sum of all elements.
        const operation = this.variableNames.map((variable)=>{
            return `v${variable}`;
        }).join(' + ');
        this.userCode = `
      void main() {
        ${snippets.join('\n        ')}

        vec4 result = ${operation};
        setOutput(result);
      }
    `;
    }
}



function $dda9f85674249e4f$export$37b75d0026f96b8d(args) {
    const { inputs: inputs, backend: backend } = args;
    const tensors = inputs;
    if (tensors.length === 1) return (0, $2b13f312c76ad9c3$export$f0954fd7d5368655)({
        inputs: {
            x: tensors[0]
        },
        backend: backend
    });
    // Limit the number of uploaded textures for optimization.
    if (tensors.length > (0, $i64bB.env)().getNumber('WEBGL_MAX_TEXTURES_IN_SHADER')) {
        const midIndex = Math.floor(tensors.length / 2);
        const leftSide = $dda9f85674249e4f$export$37b75d0026f96b8d({
            inputs: tensors.slice(0, midIndex),
            backend: backend
        });
        const rightSide = $dda9f85674249e4f$export$37b75d0026f96b8d({
            inputs: tensors.slice(midIndex),
            backend: backend
        });
        return $dda9f85674249e4f$export$37b75d0026f96b8d({
            inputs: [
                leftSide,
                rightSide
            ],
            backend: backend
        });
    }
    const dtype = tensors.map((t)=>t.dtype).reduce((d1, d2)=>(0, $i64bB.upcastType)(d1, d2));
    const shapes = tensors.map((t)=>t.shape);
    // We can make sure shapes are identical in op level.
    const usePackedOp = (0, $i64bB.env)().getBool('WEBGL_PACK');
    const program = usePackedOp ? new (0, $5e2048779572efff$export$156b01c0aab97d90)(tensors[0].shape, shapes) : new (0, $98f4a305e577731b$export$9d269fc8eb4783d5)(tensors[0].shape, shapes);
    return backend.runWebGLProgram(program, tensors, dtype);
}
const $dda9f85674249e4f$export$ff8000bc6f0313e1 = {
    kernelName: (0, $i64bB.AddN),
    backendName: 'webgl',
    kernelFunc: $dda9f85674249e4f$export$37b75d0026f96b8d
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");



function $c337b9c2f734e218$export$84bf76cd7afc7469(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    const xRank = x.shape.length;
    const origAxes = (0, $i64bB.util).parseAxisParam(axis, x.shape);
    let axes = origAxes;
    const permutedAxes = (0, $i64bB.backend_util).getAxesPermutation(axes, xRank);
    let permutedX = x;
    if (permutedAxes != null) {
        permutedX = (0, $6cab078553124169$export$9cb09a71b7d66923)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutedAxes
            }
        });
        axes = (0, $i64bB.backend_util).getInnerMostAxes(axes.length, xRank);
    }
    (0, $i64bB.backend_util).assertAxesAreInnerMostDims('all', axes, xRank);
    const [outShape, reduceShape] = (0, $i64bB.backend_util).computeOutAndReduceShapes(permutedX.shape, axes);
    const inSize = (0, $i64bB.util).sizeFromShape(reduceShape);
    const a2D = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: permutedX
        },
        backend: backend,
        attrs: {
            shape: [
                -1,
                inSize
            ]
        }
    });
    const reduced = (0, $8c1b6ed50cb28ef5$export$533b26079ad0b4b)(a2D, a2D.dtype, 'all', backend);
    let res;
    if (keepDims) {
        const newShape = (0, $i64bB.backend_util).expandShapeToKeepDim(outShape, origAxes);
        res = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
            inputs: {
                x: reduced
            },
            backend: backend,
            attrs: {
                shape: newShape
            }
        });
    } else res = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: reduced
        },
        backend: backend,
        attrs: {
            shape: outShape
        }
    });
    backend.disposeIntermediateTensorInfo(a2D);
    backend.disposeIntermediateTensorInfo(reduced);
    if (permutedAxes != null) backend.disposeIntermediateTensorInfo(permutedX);
    return res;
}
const $c337b9c2f734e218$export$4e3f081eb1a330fa = {
    kernelName: (0, $i64bB.All),
    backendName: 'webgl',
    kernelFunc: $c337b9c2f734e218$export$84bf76cd7afc7469
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");



function $e675eb466b36fc13$export$4154a199d7d90455(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    const xRank = x.shape.length;
    const origAxes = (0, $i64bB.util).parseAxisParam(axis, x.shape);
    let axes = origAxes;
    const permutedAxes = (0, $i64bB.backend_util).getAxesPermutation(axes, xRank);
    let permutedX = x;
    if (permutedAxes != null) {
        permutedX = (0, $6cab078553124169$export$9cb09a71b7d66923)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutedAxes
            }
        });
        axes = (0, $i64bB.backend_util).getInnerMostAxes(axes.length, xRank);
    }
    (0, $i64bB.backend_util).assertAxesAreInnerMostDims('any', axes, xRank);
    const [outShape, reduceShape] = (0, $i64bB.backend_util).computeOutAndReduceShapes(permutedX.shape, axes);
    const inSize = (0, $i64bB.util).sizeFromShape(reduceShape);
    const a2D = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: permutedX
        },
        backend: backend,
        attrs: {
            shape: [
                -1,
                inSize
            ]
        }
    });
    const reduced = (0, $8c1b6ed50cb28ef5$export$533b26079ad0b4b)(a2D, a2D.dtype, 'any', backend);
    let res;
    if (keepDims) {
        const newShape = (0, $i64bB.backend_util).expandShapeToKeepDim(outShape, origAxes);
        res = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
            inputs: {
                x: reduced
            },
            backend: backend,
            attrs: {
                shape: newShape
            }
        });
    } else res = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: reduced
        },
        backend: backend,
        attrs: {
            shape: outShape
        }
    });
    backend.disposeIntermediateTensorInfo(a2D);
    backend.disposeIntermediateTensorInfo(reduced);
    if (permutedAxes != null) backend.disposeIntermediateTensorInfo(permutedX);
    return res;
}
const $e675eb466b36fc13$export$1a8ff634f2df3da6 = {
    kernelName: (0, $i64bB.Any),
    backendName: 'webgl',
    kernelFunc: $e675eb466b36fc13$export$4154a199d7d90455
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $eaec95bfdfa4eb92$export$7fa5759722b57eba {
    constructor(reduceInfo, op, firstPass){
        this.variableNames = [
            'A'
        ];
        const { windowSize: windowSize, batchSize: batchSize, outSize: outSize } = reduceInfo;
        if (!firstPass) this.variableNames.push('bestIndicesA');
        this.outputShape = [
            batchSize,
            outSize
        ];
        const compOp = op === 'max' ? '>' : '<';
        const indexSnippet = firstPass ? 'inOffset + i;' : 'round(getBestIndicesA(batch, inOffset + i));';
        this.userCode = `
      void main() {
        ivec2 coords = getOutputCoords();
        int batch = coords[0];
        int outIdx = coords[1];
        int inOffset = outIdx * ${windowSize};

        int bestIndex = inOffset;
        float bestValue = getA(batch, bestIndex);

        for (int i = 0; i < ${windowSize}; i++) {
          int inIdx = ${indexSnippet};
          float candidate = getA(batch, inIdx);
          if (candidate ${compOp} bestValue) {
            bestValue = candidate;
            bestIndex = inIdx;
          }
        }
        setOutput(float(bestIndex));
      }
    `;
    }
}


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


class $cf43be5522e03c45$export$6b02cde2348cc418 {
    constructor(shape, windowSize, op, firstPass){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        (0, $i64bB.util).assert(shape.length > 2, ()=>`Packed arg${op.charAt(0).toUpperCase() + op.slice(1)} supports only inputs with rank above 2.`);
        const inSize = shape[shape.length - 1];
        const outSize = Math.ceil(inSize / windowSize);
        this.outputShape = shape.slice(0, -1);
        if (outSize > 1) this.outputShape.push(outSize);
        if (!firstPass) this.variableNames.push('bestIndicesA');
        const outShape = this.outputShape;
        const rank = outShape.length;
        const dtype = (0, $ba2c54ffbda39e8e$export$859efd105c10c755)(rank);
        const coords = (0, $30912e1180ed417f$export$7a4d1d0d17b69972)('coords', rank);
        let sourceLocSetup;
        let sourceRank;
        if (outSize === 1) {
            sourceRank = rank + 1;
            const sourceLocDType = (0, $ba2c54ffbda39e8e$export$859efd105c10c755)(sourceRank);
            sourceLocSetup = `
        ${sourceLocDType} sourceLocR = ${sourceLocDType}(${coords.join()}, 0);
        ++${coords[rank - 1]};
        ${sourceLocDType} sourceLocG = ${sourceLocDType}(${coords.join()}, 0);
        ++${coords[rank - 2]};
        ${sourceLocDType} sourceLocA = ${sourceLocDType}(${coords.join()}, 0);
        --${coords[rank - 1]};
        ${sourceLocDType} sourceLocB = ${sourceLocDType}(${coords.join()}, 0);
        --${coords[rank - 2]};`;
        } else {
            sourceRank = rank;
            sourceLocSetup = `
        ${dtype} sourceLocR = coords;
        ++${coords[rank - 1]};
        ${dtype} sourceLocG = coords;
        ++${coords[rank - 2]};
        ${dtype} sourceLocA = coords;
        --${coords[rank - 1]};
        ${dtype} sourceLocB = coords;
        --${coords[rank - 2]};`;
        }
        const channels = [
            'x',
            'y',
            'z',
            'w',
            'u',
            'v'
        ].slice(0, sourceRank);
        const inChannel = '.' + channels[sourceRank - 1]; // e.g. ".b" for rank 3.
        const intChannels = channels.map((x)=>'int ' + x);
        const srcRCoords = (0, $30912e1180ed417f$export$7a4d1d0d17b69972)('sourceLocR', sourceRank - 1).concat('inIdx.r');
        const srcGCoords = (0, $30912e1180ed417f$export$7a4d1d0d17b69972)('sourceLocG', sourceRank - 1).concat('inIdx.g');
        const srcBCoords = (0, $30912e1180ed417f$export$7a4d1d0d17b69972)('sourceLocB', sourceRank - 1).concat('inIdx.b');
        const srcACoords = (0, $30912e1180ed417f$export$7a4d1d0d17b69972)('sourceLocA', sourceRank - 1).concat('inIdx.a');
        const compOp = op === 'max' ? 'greaterThan' : 'lessThan';
        const fetchCandidateIdx = firstPass ? '' : `
          inIdx = round(vec4(getBestIndicesAChannel(${srcRCoords.join()}),
                             getBestIndicesAChannel(${srcGCoords.join()}),
                             getBestIndicesAChannel(${srcBCoords.join()}),
                             getBestIndicesAChannel(${srcACoords.join()})));`;
        const fetchValue = `vec4(
            getAChannel(${srcRCoords.join()}),
            hasNextCol ? getAChannel(${srcGCoords.join()}) : 0.,
            hasNextRow ? getAChannel(${srcBCoords.join()}) : 0.,
            hasNextRow && hasNextCol ? getAChannel(${srcACoords.join()}) : 0.)`;
        const getBestIndicesAChannelSnippet = firstPass ? '' : `
      float getBestIndicesAChannel(${intChannels.join()}) {
        return getChannel(getBestIndicesA(${channels.join()}),
                                          vec2(${channels.slice(-2).join()}));
      }`;
        this.userCode = `
      float getAChannel(${intChannels.join()}) {
        return getChannel(getA(${channels.join()}),
                               vec2(${channels.slice(-2).join()}));
      }
      ${getBestIndicesAChannelSnippet}
      void main() {
        ${dtype} coords = getOutputCoords();
        bool hasNextCol = ${coords[rank - 1]} < ${outShape[rank - 1] - 1};
        bool hasNextRow = ${coords[rank - 2]} < ${outShape[rank - 2] - 1};
        ${sourceLocSetup}
        ivec4 srcIdx = ivec4(sourceLocR${inChannel}, sourceLocG${inChannel},
          sourceLocB${inChannel}, sourceLocA${inChannel}) * ${windowSize};
        ivec4 inIdx = srcIdx;
        vec4 bestIndex = vec4(inIdx);
        vec4 bestValue = ${fetchValue};

        for (int i = 0; i < ${windowSize}; i++) {
          inIdx = srcIdx;
          ${fetchCandidateIdx}
          vec4 candidate = ${fetchValue};
          bvec4 nan = isnan(candidate);
          bvec4 replace = bvec4(
            vec4(${compOp}(candidate, bestValue)) * (vec4(1.0) - vec4(nan)));

          bestValue = vec4(replace.x  ? candidate.x : bestValue.x,
                           replace.y  ? candidate.y : bestValue.y,
                           replace.z  ? candidate.z : bestValue.z,
                           replace.w  ? candidate.w : bestValue.w);
          bestIndex = mix(bestIndex, vec4(inIdx), vec4(replace));
          srcIdx++;
        }
        setOutput(bestIndex);
      }
    `;
    }
}



function $0b3e4ef88741bbe9$var$argReduce(backend, x, reduceType, bestIndicesA = null) {
    let batchSize = x.shape[0];
    let inSize = x.shape[1];
    if (bestIndicesA != null) {
        batchSize = bestIndicesA.shape[0];
        inSize = bestIndicesA.shape[1];
    }
    const windowSize = (0, $i64bB.backend_util).computeOptimalWindowSize(inSize);
    const reduceInfo = {
        windowSize: windowSize,
        inSize: inSize,
        batchSize: batchSize,
        outSize: Math.ceil(inSize / windowSize)
    };
    const program = new (0, $eaec95bfdfa4eb92$export$7fa5759722b57eba)(reduceInfo, reduceType, bestIndicesA == null);
    const inputs = [
        x
    ];
    if (bestIndicesA != null) inputs.push(bestIndicesA);
    const output = backend.runWebGLProgram(program, inputs, 'int32');
    // No need to run another GPGPU program.
    if (output.shape[1] === 1) return output;
    const result = $0b3e4ef88741bbe9$var$argReduce(backend, x, reduceType, output);
    backend.disposeIntermediateTensorInfo(output);
    return result;
}
function $0b3e4ef88741bbe9$var$argReducePacked(backend, x, reduceType, bestIndicesA = null) {
    const inShape = bestIndicesA != null ? bestIndicesA.shape : x.shape;
    const inSize = inShape[inShape.length - 1];
    const windowSize = (0, $i64bB.backend_util).computeOptimalWindowSize(inSize);
    const program = new (0, $cf43be5522e03c45$export$6b02cde2348cc418)(inShape, windowSize, reduceType, bestIndicesA == null);
    const inputs = bestIndicesA == null ? [
        x
    ] : [
        x,
        bestIndicesA
    ];
    const output = backend.runWebGLProgram(program, inputs, 'int32');
    if (output.shape.length === x.shape.length) {
        const result = $0b3e4ef88741bbe9$var$argReducePacked(backend, x, reduceType, output);
        backend.disposeIntermediateTensorInfo(output);
        return result;
    }
    return output;
}
function $0b3e4ef88741bbe9$export$63dee7a356b9210b(backend, x, axis, reduceType) {
    const axes = [
        axis
    ];
    (0, $i64bB.backend_util).assertAxesAreInnerMostDims('arg' + reduceType.charAt(0).toUpperCase() + reduceType.slice(1), axes, x.shape.length);
    if (!(0, $i64bB.env)().getBool('WEBGL_PACK_REDUCE') || x.shape.length <= 2) {
        const intermediateTensorInfos = [];
        // Eagerly unpack x input since it is passed in to all the shaders which
        // require unpacked inputs.
        const xtexData = backend.texData.get(x.dataId);
        const xIsPacked = xtexData !== null && xtexData.isPacked;
        let xUnPacked = x;
        if (xIsPacked) {
            xUnPacked = backend.unpackTensor(x);
            intermediateTensorInfos.push(xUnPacked);
        }
        const [outShape, reduceShape] = (0, $i64bB.backend_util).computeOutAndReduceShapes(xUnPacked.shape, axes);
        const inSize = (0, $i64bB.util).sizeFromShape(reduceShape);
        const a2D = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
            inputs: {
                x: xUnPacked
            },
            backend: backend,
            attrs: {
                shape: [
                    -1,
                    inSize
                ]
            }
        });
        intermediateTensorInfos.push(a2D);
        const reduced = $0b3e4ef88741bbe9$var$argReduce(backend, a2D, reduceType);
        intermediateTensorInfos.push(reduced);
        const reshaped = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
            inputs: {
                x: reduced
            },
            backend: backend,
            attrs: {
                shape: outShape
            }
        });
        intermediateTensorInfos.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
        return reshaped;
    }
    return $0b3e4ef88741bbe9$var$argReducePacked(backend, x, reduceType);
}



function $68d2329c08364cbd$export$7980a683c1b852b4(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis } = attrs;
    let axes = (0, $i64bB.util).parseAxisParam(axis, x.shape);
    const permutedAxes = (0, $i64bB.backend_util).getAxesPermutation(axes, x.shape.length);
    let $x = x;
    const intermediateTensorInfos = [];
    if (permutedAxes != null) {
        $x = (0, $6cab078553124169$export$9cb09a71b7d66923)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutedAxes
            }
        });
        intermediateTensorInfos.push($x);
        axes = (0, $i64bB.backend_util).getInnerMostAxes(axes.length, $x.shape.length);
    }
    (0, $i64bB.backend_util).assertAxesAreInnerMostDims('argMax', [
        axes[0]
    ], $x.shape.length);
    const out = (0, $0b3e4ef88741bbe9$export$63dee7a356b9210b)(backend, $x, axes[0], 'max');
    intermediateTensorInfos.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return out;
}
const $68d2329c08364cbd$export$ec7419fc9ad0069e = {
    kernelName: (0, $i64bB.ArgMax),
    backendName: 'webgl',
    kernelFunc: $68d2329c08364cbd$export$7980a683c1b852b4
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


function $45e40558cf021cec$export$ec99a91cddfb29a2(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis } = attrs;
    let axes = (0, $i64bB.util).parseAxisParam(axis, x.shape);
    const permutedAxes = (0, $i64bB.backend_util).getAxesPermutation(axes, x.shape.length);
    let $x = x;
    const intermediateTensorInfos = [];
    if (permutedAxes != null) {
        $x = (0, $6cab078553124169$export$9cb09a71b7d66923)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutedAxes
            }
        });
        intermediateTensorInfos.push($x);
        axes = (0, $i64bB.backend_util).getInnerMostAxes(axes.length, $x.shape.length);
    }
    (0, $i64bB.backend_util).assertAxesAreInnerMostDims('argMin', [
        axes[0]
    ], $x.shape.length);
    const out = (0, $0b3e4ef88741bbe9$export$63dee7a356b9210b)(backend, $x, axes[0], 'min');
    intermediateTensorInfos.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return out;
}
const $45e40558cf021cec$export$21836a5e5fa09eb4 = {
    kernelName: (0, $i64bB.ArgMin),
    backendName: 'webgl',
    kernelFunc: $45e40558cf021cec$export$ec99a91cddfb29a2
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


const $67101c5a52055102$var$ASIN = (0, $d607b1799b79a159$export$39f0cca2b63399f6) + `
  if (abs(x) > 1.) {
    return NAN;
  }
  return asin(x);
`;
const $67101c5a52055102$export$41726bdb1fc63f = (0, $2e65282075da2b30$export$ba4daf5748026fba)({
    opSnippet: $67101c5a52055102$var$ASIN
});
const $67101c5a52055102$export$de5cb0ef95dd6700 = {
    kernelName: (0, $i64bB.Asin),
    backendName: 'webgl',
    kernelFunc: $67101c5a52055102$export$41726bdb1fc63f
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


const $4372eb63392d2d83$var$ASINH = (0, $d607b1799b79a159$export$39f0cca2b63399f6) + `return log(x + sqrt(x * x + 1.0));`;
const $4372eb63392d2d83$export$839d8a01b6af4fc0 = (0, $2e65282075da2b30$export$ba4daf5748026fba)({
    opSnippet: $4372eb63392d2d83$var$ASINH
});
const $4372eb63392d2d83$export$20d424616c76166 = {
    kernelName: (0, $i64bB.Asinh),
    backendName: 'webgl',
    kernelFunc: $4372eb63392d2d83$export$839d8a01b6af4fc0
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


const $e21a181ab3eb5f8b$var$ATAN = (0, $d607b1799b79a159$export$39f0cca2b63399f6) + `
  return atan(x);
`;
const $e21a181ab3eb5f8b$export$628dc4eed22b0fbd = (0, $2e65282075da2b30$export$ba4daf5748026fba)({
    opSnippet: $e21a181ab3eb5f8b$var$ATAN
});
const $e21a181ab3eb5f8b$export$159d632e3ff13624 = {
    kernelName: (0, $i64bB.Atan),
    backendName: 'webgl',
    kernelFunc: $e21a181ab3eb5f8b$export$628dc4eed22b0fbd
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");



const $3d001d64672abbe9$var$ATAN2 = (0, $a3544edc66d558ba$export$39f0cca2b63399f6) + `
  return atan(a, b);
`;
const $3d001d64672abbe9$var$ATAN2_PACKED = `
  vec4 result = atan(a, b);
  bvec4 isNaNA = isnan(a);
  bvec4 isNaNB = isnan(b);
  bvec4 isNaN = bvec4(isNaNA.x || isNaNB.x, isNaNA.y || isNaNB.y, isNaNA.z || isNaNB.z, isNaNA.w || isNaNB.w);
  ` + (0, $1b00798c48aa5c1a$export$2b4d5cee4bd7b2dd) + `
  return result;
`;
const $3d001d64672abbe9$export$b8b770ee6a0d9760 = (0, $2e65282075da2b30$export$29353c66e70e3e16)({
    opSnippet: $3d001d64672abbe9$var$ATAN2,
    packedOpSnippet: $3d001d64672abbe9$var$ATAN2_PACKED
});
const $3d001d64672abbe9$export$c53c7ab019edb8a0 = {
    kernelName: (0, $i64bB.Atan2),
    backendName: 'webgl',
    kernelFunc: $3d001d64672abbe9$export$b8b770ee6a0d9760
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


const $07f6172ea9c55cba$var$ATANH = (0, $d607b1799b79a159$export$39f0cca2b63399f6) + `
  if ((x < -1.0) || (x > 1.0)) return NAN;
return (log(1.0 + x) - log(1.0 - x)) / 2.0;`;
const $07f6172ea9c55cba$export$21ea955025ceb08b = (0, $2e65282075da2b30$export$ba4daf5748026fba)({
    opSnippet: $07f6172ea9c55cba$var$ATANH
});
const $07f6172ea9c55cba$export$e9ce1ba75fc9b746 = {
    kernelName: (0, $i64bB.Atanh),
    backendName: 'webgl',
    kernelFunc: $07f6172ea9c55cba$export$21ea955025ceb08b
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $61fdd45f941bfa6f$export$ddaa65439647a5ac {
    constructor(convInfo, poolType, computePositions, flattenPositions = false, includeBatchInIndex = false){
        this.variableNames = [
            'x'
        ];
        if (poolType === 'avg' && computePositions) throw new Error('Cannot compute positions for average pool.');
        const filterWidth = convInfo.filterWidth;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const dilationHeight = convInfo.dilationHeight;
        const dilationWidth = convInfo.dilationWidth;
        const effectiveFilterHeight = convInfo.effectiveFilterHeight;
        const effectiveFilterWidth = convInfo.effectiveFilterWidth;
        const padTop = convInfo.padInfo.top;
        const padLeft = convInfo.padInfo.left;
        this.outputShape = convInfo.outShape;
        const isAvgPool = poolType === 'avg';
        const batchFlattenPositionStr = `((batch  * ${convInfo.inHeight} + xR) * ${convInfo.inWidth} + xC) * ${convInfo.inChannels} + d`;
        const flattenPositionStr = `(xR * ${convInfo.inWidth} + xC) * ${convInfo.inChannels} + d`;
        let initializationValue = '0.0';
        if (!isAvgPool) // WebGL on Firefox Linux can't compile 1/0 so we do 1/eps.
        initializationValue = '-1.0 / 1e-20';
        if (computePositions) {
            const compareOp = '>=';
            this.userCode = `
        const ivec2 strides = ivec2(${strideHeight}, ${strideWidth});
        const ivec2 pads = ivec2(${padTop}, ${padLeft});

        void main() {
          ivec4 coords = getOutputCoords();
          int batch = coords[0];
          int d = coords[3];

          ivec2 xRCCorner = coords.yz * strides - pads;
          int xRCorner = xRCCorner.x;
          int xCCorner = xRCCorner.y;

          // max/min x(?, ?, d) to get y(yR, yC, d).
          // ? = to be determined
          float minMaxValue = 0.0;
          float minMaxValueFound = 0.0;
          int minMaxPosition = 0;
          float avgValue = 0.0;

          for (int wR = 0; wR < ${effectiveFilterHeight};
              wR += ${dilationHeight}) {
            int xR = xRCorner + wR;

            if (xR < 0 || xR >= ${convInfo.inHeight}) {
              continue;
            }

            for (int wC = 0; wC < ${effectiveFilterWidth};
                wC += ${dilationWidth}) {
              int xC = xCCorner + wC;

              if (xC < 0 || xC >= ${convInfo.inWidth}) {
                continue;
              }

              float value = getX(batch, xR, xC, d);

              // If a min / max value has already been found, use it. If not,
              // use the current value.
              float currMinMaxValue = mix(
                  value, minMaxValue, minMaxValueFound);
              if (value ${compareOp} currMinMaxValue) {
                minMaxValue = value;
                minMaxValueFound = 1.0;
                minMaxPosition = ${flattenPositions ? includeBatchInIndex ? batchFlattenPositionStr : flattenPositionStr : `wR * ${effectiveFilterWidth} + wC`};
              }
            }
          }
          setOutput(float(minMaxPosition));
        }
      `;
            return;
        }
        const compareOp = 'max';
        let returnValue = `${poolType}(${poolType}(${poolType}(` + 'minMaxValue[0], minMaxValue[1]), minMaxValue[2]), minMaxValue[3])';
        if (poolType === 'avg') returnValue = `avgValue / max(count, 1.0)`;
        const filterWidthNearestVec4 = Math.floor(filterWidth / 4) * 4;
        const filterWidthVec4Remainder = filterWidth % 4;
        const updateSnippet = `
      if (${isAvgPool}) {
        avgValue += dot(values, ones);
      } else {
        minMaxValue = ${compareOp}(values, minMaxValue);
      }
    `;
        this.userCode = `
      const ivec2 strides = ivec2(${strideHeight}, ${strideWidth});
      const ivec2 pads = ivec2(${padTop}, ${padLeft});
      const float initializationValue = ${initializationValue};
      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);

      float count = 0.0;

      float getValue(int batch, int xR, int xC, int d) {
        if (xC < 0 || xC >= ${convInfo.inWidth}) {
          return initializationValue;
        }
        count += 1.0;
        return getX(batch, xR, xC, d);
      }

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords[0];
        int d = coords[3];

        ivec2 xRCCorner = coords.yz * strides - pads;
        int xRCorner = xRCCorner.x;
        int xCCorner = xRCCorner.y;

        // max/min x(?, ?, d) to get y(yR, yC, d).
        // ? = to be determined
        vec4 minMaxValue = vec4(${initializationValue});
        float avgValue = 0.0;
        count = 0.0;

        for (int wR = 0; wR < ${effectiveFilterHeight};
            wR += ${dilationHeight}) {
          int xR = xRCorner + wR;

          if (xR < 0 || xR >= ${convInfo.inHeight}) {
            continue;
          }

          for (int wC = 0; wC < ${filterWidthNearestVec4}; wC += 4) {
            int xC = xCCorner + wC * ${dilationWidth};

            vec4 values = vec4(
              getValue(batch, xR, xC, d),
              getValue(batch, xR, xC + ${dilationWidth}, d),
              getValue(batch, xR, xC + 2 * ${dilationWidth}, d),
              getValue(batch, xR, xC + 3 * ${dilationWidth}, d)
            );

            ${updateSnippet}
          }

          int xC = xCCorner + ${filterWidthNearestVec4};
          if (${filterWidthVec4Remainder === 1}) {
            vec4 values = vec4(
              getValue(batch, xR, xC, d),
              initializationValue,
              initializationValue,
              initializationValue
            );

            ${updateSnippet}
          } else if (${filterWidthVec4Remainder === 2}) {
            vec4 values = vec4(
              getValue(batch, xR, xC, d),
              getValue(batch, xR, xC + ${dilationWidth}, d),
              initializationValue,
              initializationValue
            );

            ${updateSnippet}
          } else if (${filterWidthVec4Remainder === 3}) {
            vec4 values = vec4(
              getValue(batch, xR, xC, d),
              getValue(batch, xR, xC + ${dilationWidth}, d),
              getValue(batch, xR, xC + 2 * ${dilationWidth}, d),
              initializationValue
            );

            ${updateSnippet}
          }
        }
        setOutput(${returnValue});
      }
    `;
    }
}
class $61fdd45f941bfa6f$export$a835a97097fdbb0f {
    constructor(convInfo, poolType, computePositions, flattenPositions = false, includeBatchInIndex = false){
        this.variableNames = [
            'x'
        ];
        if (poolType === 'avg' && computePositions) throw new Error('Cannot compute positions for average pool.');
        const filterWidth = convInfo.filterWidth;
        const strideDepth = convInfo.strideDepth;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const dilationDepth = convInfo.dilationDepth;
        const dilationHeight = convInfo.dilationHeight;
        const dilationWidth = convInfo.dilationWidth;
        const effectiveFilterDepth = convInfo.effectiveFilterDepth;
        const effectiveFilterHeight = convInfo.effectiveFilterHeight;
        const effectiveFilterWidth = convInfo.effectiveFilterWidth;
        const padFront = convInfo.padInfo.front;
        const padTop = convInfo.padInfo.top;
        const padLeft = convInfo.padInfo.left;
        this.outputShape = convInfo.outShape;
        const isAvgPool = poolType === 'avg';
        let initializationValue = '0.0';
        if (!isAvgPool) // WebGL on Firefox Linux can't compile 1/0 so we do 1/eps.
        initializationValue = '-1.0 / 1e-20';
        if (computePositions) {
            const compareOp = '>=';
            this.userCode = `
        const ivec3 strides =
            ivec3(${strideDepth}, ${strideHeight}, ${strideWidth});
        const ivec3 pads = ivec3(${padFront}, ${padTop}, ${padLeft});

        void main() {
          ivec5 coords = getOutputCoords();
          int batch = coords.x;
          int ch = coords.u;

          ivec3 xCorner = ivec3(coords.y, coords.z, coords.w) * strides - pads;
          int xDCorner = xCorner.x;
          int xRCorner = xCorner.y;
          int xCCorner = xCorner.z;

          // max/min x(?, ?, ?, ch) to get y(yD, yR, yC, ch).
          // ? = to be determined
          float minMaxValue = 0.0;
          float minMaxValueFound = 0.0;
          int minMaxPosition = 0;

          for (int wD = 0; wD < ${effectiveFilterDepth};
              wD += ${dilationDepth}) {
            int xD = xDCorner + wD;

            if (xD < 0 || xD >= ${convInfo.inDepth}) {
              continue;
            }

            for (int wR = 0; wR < ${effectiveFilterHeight};
                wR += ${dilationHeight}) {
              int xR = xRCorner + wR;

              if (xR < 0 || xR >= ${convInfo.inHeight}) {
                continue;
              }

              for (int wC = 0; wC < ${effectiveFilterWidth};
                  wC += ${dilationWidth}) {
                int xC = xCCorner + wC;

                if (xC < 0 || xC >= ${convInfo.inWidth}) {
                  continue;
                }

                float value = getX(batch, xD, xR, xC, ch);

                // If a min / max value has already been found, use it. If not,
                // use the current value.
                float currMinMaxValue = mix(
                    value, minMaxValue, minMaxValueFound);
                if (value ${compareOp} currMinMaxValue) {
                  minMaxValue = value;
                  minMaxValueFound = 1.0;
                  minMaxPosition = ${flattenPositions ? includeBatchInIndex ? `(((batch * ${convInfo.inDepth} + xD) * ${convInfo.inHeight} + xR) * ${convInfo.inWidth} + xC) * ${convInfo.inChannels} + ch` : `((xD * ${convInfo.inHeight} + xR) * ${convInfo.inWidth} + xC) * ${convInfo.inChannels} + ch` : `wD * ${effectiveFilterHeight} * ${effectiveFilterWidth} +
                      wR * ${effectiveFilterWidth} + wC`};
                }
              }
            }
          }
          setOutput(float(minMaxPosition));
        }
      `;
            return;
        }
        const compareOp = 'max';
        let returnValue = `${poolType}(${poolType}(${poolType}(` + 'minMaxValue[0], minMaxValue[1]), minMaxValue[2]), minMaxValue[3])';
        if (poolType === 'avg') // Use `max(count, 1.0)` instead of `count` in case count === 0.0.
        // If count === 0.0, `avgValue` is always 0.0 and we change `count`'s
        // value to avoid dividing zero.
        returnValue = `avgValue / max(count, 1.0)`;
        const filterWidthNearestVec4 = Math.floor(filterWidth / 4) * 4;
        const filterWidthVec4Remainder = filterWidth % 4;
        const updateSnippet = `
      if (${isAvgPool}) {
        avgValue += dot(values, ones);
      } else {
        minMaxValue = ${compareOp}(values, minMaxValue);
      }
    `;
        this.userCode = `
      const ivec3 strides =
        ivec3(${strideDepth}, ${strideHeight}, ${strideWidth});
      const ivec3 pads = ivec3(${padFront}, ${padTop}, ${padLeft});
      const float initializationValue = ${initializationValue};
      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);

      float count = 0.0;

      float getValue(int batch, int xD, int xR, int xC, int ch) {
        if (xC < 0 || xC >= ${convInfo.inWidth}) {
          return initializationValue;
        }
        count += 1.0;
        return getX(batch, xD, xR, xC, ch);
      }

      void main() {
        ivec5 coords = getOutputCoords();
        int batch = coords.x;
        int ch = coords.u;

        ivec3 xCorner = ivec3(coords.y, coords.z, coords.w) * strides - pads;
        int xDCorner = xCorner.x;
        int xRCorner = xCorner.y;
        int xCCorner = xCorner.z;

        // max/min x(?, ?, ?, d) to get y(yD, yR, yC, ch).
        // ? = to be determined
        vec4 minMaxValue = vec4(${initializationValue});
        float avgValue = 0.0;
        count = 0.0;

        for (int wD = 0; wD < ${effectiveFilterDepth};
            wD += ${dilationDepth}) {
          int xD = xDCorner + wD;

          if (xD < 0 || xD >= ${convInfo.inDepth}) {
            continue;
          }

          for (int wR = 0; wR < ${effectiveFilterHeight};
            wR += ${dilationHeight}) {
            int xR = xRCorner + wR;

            if (xR < 0 || xR >= ${convInfo.inHeight}) {
              continue;
            }

            for (int wC = 0; wC < ${filterWidthNearestVec4}; wC += 4) {
              int xC = xCCorner + wC * ${dilationWidth};

              vec4 values = vec4(
                getValue(batch, xD, xR, xC, ch),
                getValue(batch, xD, xR, xC + ${dilationWidth}, ch),
                getValue(batch, xD, xR, xC + 2 * ${dilationWidth}, ch),
                getValue(batch, xD, xR, xC + 3 * ${dilationWidth}, ch)
              );

              ${updateSnippet}
            }

            int xC = xCCorner + ${filterWidthNearestVec4};
            if (${filterWidthVec4Remainder === 1}) {
              vec4 values = vec4(
                getValue(batch, xD, xR, xC, ch),
                initializationValue,
                initializationValue,
                initializationValue
              );

              ${updateSnippet}
            } else if (${filterWidthVec4Remainder === 2}) {
              vec4 values = vec4(
                getValue(batch, xD, xR, xC, ch),
                getValue(batch, xD, xR, xC + ${dilationWidth}, ch),
                initializationValue,
                initializationValue
              );

              ${updateSnippet}
            } else if (${filterWidthVec4Remainder === 3}) {
              vec4 values = vec4(
                getValue(batch, xD, xR, xC, ch),
                getValue(batch, xD, xR, xC + ${dilationWidth}, ch),
                getValue(batch, xD, xR, xC + 2 * ${dilationWidth}, ch),
                initializationValue
              );

              ${updateSnippet}
            }
          }
        }
        setOutput(${returnValue});
      }
    `;
    }
}




function $896cba4644372bbe$export$d5c65a2abd3d97dc(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    (0, $03fc80a4a4cef09e$export$1412c17b2531581a)(x, 'avgPool');
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    const dilations = 1;
    (0, $i64bB.util).assert((0, $i64bB.backend_util).eitherStridesOrDilationsAreOne(strides, dilations), ()=>'Error in avgPool: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    const convInfo = (0, $i64bB.backend_util).computePool2DInfo(x.shape, filterSize, strides, dilations, pad, dimRoundingMode);
    if (convInfo.filterWidth === 1 && convInfo.filterHeight === 1 && (0, $i64bB.util).arraysEqual(convInfo.inShape, convInfo.outShape)) return (0, $2b13f312c76ad9c3$export$f0954fd7d5368655)({
        inputs: {
            x: x
        },
        backend: backend
    });
    const avgPoolProgram = new (0, $61fdd45f941bfa6f$export$ddaa65439647a5ac)(convInfo, 'avg', false);
    return backend.runWebGLProgram(avgPoolProgram, [
        x
    ], 'float32');
}
const $896cba4644372bbe$export$6c901824a23e6150 = {
    kernelName: (0, $i64bB.AvgPool),
    backendName: 'webgl',
    kernelFunc: $896cba4644372bbe$export$d5c65a2abd3d97dc
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

function $424aa4ac34c4d8fe$export$8e92f7d23b27f144(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode, dataFormat: dataFormat } = attrs;
    const dilations = [
        1,
        1,
        1
    ];
    const convInfo = (0, $i64bB.backend_util).computePool3DInfo(x.shape, filterSize, strides, dilations, pad, dimRoundingMode, dataFormat);
    const avgPoolProgram = new (0, $61fdd45f941bfa6f$export$a835a97097fdbb0f)(convInfo, 'avg', false);
    return backend.runWebGLProgram(avgPoolProgram, [
        x
    ], 'float32');
}
const $424aa4ac34c4d8fe$export$5a9c81d240244392 = {
    kernelName: (0, $i64bB.AvgPool3D),
    backendName: 'webgl',
    kernelFunc: $424aa4ac34c4d8fe$export$8e92f7d23b27f144
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $44784ecc85966d51$export$5dc4ec478e6759de {
    constructor(convInfo){
        this.variableNames = [
            'dy'
        ];
        this.outputShape = convInfo.inShape;
        const filterHeight = convInfo.filterHeight;
        const filterWidth = convInfo.filterWidth;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const dilationHeight = convInfo.dilationHeight;
        const dilationWidth = convInfo.dilationWidth;
        const effectiveFilterHeight = convInfo.effectiveFilterHeight;
        const effectiveFilterWidth = convInfo.effectiveFilterWidth;
        const padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
        const padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
        const avgMultiplier = 1 / (filterHeight * filterWidth);
        this.userCode = `
      const ivec2 pads = ivec2(${padTop}, ${padLeft});
      const float avgMultiplier = float(${avgMultiplier});

      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];

        ivec2 dyRCCorner = coords.yz - pads;
        int dyRCorner = dyRCCorner.x;
        int dyCCorner = dyRCCorner.y;

        // Convolve dy(?, ?, d) with pos mask(:, :, d) to get dx(xR, xC, d).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;
        for (int wR = 0; wR < ${effectiveFilterHeight};
            wR += ${dilationHeight}) {
          float dyR = float(dyRCorner + wR) / ${strideHeight}.0;

          if (dyR < 0.0 || dyR >= ${convInfo.outHeight}.0 || fract(dyR) > 0.0) {
            continue;
          }
          int idyR = int(dyR);

          for (int wC = 0; wC < ${effectiveFilterWidth};
            wC+= ${dilationWidth}) {
            float dyC = float(dyCCorner + wC) / ${strideWidth}.0;

            if (dyC < 0.0 || dyC >= ${convInfo.outWidth}.0 ||
                fract(dyC) > 0.0) {
              continue;
            }
            int idyC = int(dyC);

            float dyValue = getDy(b, idyR, idyC, d);

            dotProd += dyValue * avgMultiplier;
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}
class $44784ecc85966d51$export$f166702869bc274f {
    constructor(convInfo){
        this.variableNames = [
            'dy'
        ];
        this.outputShape = convInfo.inShape;
        const filterDepth = convInfo.filterDepth;
        const filterHeight = convInfo.filterHeight;
        const filterWidth = convInfo.filterWidth;
        const strideDepth = convInfo.strideDepth;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const dilationDepth = convInfo.dilationDepth;
        const dilationHeight = convInfo.dilationHeight;
        const dilationWidth = convInfo.dilationWidth;
        const effectiveFilterDepth = convInfo.effectiveFilterDepth;
        const effectiveFilterHeight = convInfo.effectiveFilterHeight;
        const effectiveFilterWidth = convInfo.effectiveFilterWidth;
        const padFront = effectiveFilterDepth - 1 - convInfo.padInfo.front;
        const padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
        const padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
        const avgMultiplier = 1 / (filterDepth * filterHeight * filterWidth);
        this.userCode = `
      const ivec3 pads = ivec3(${padFront}, ${padTop}, ${padLeft});
      const float avgMultiplier = float(${avgMultiplier});

      void main() {
        ivec5 coords = getOutputCoords();
        int batch = coords.x;
        int ch = coords.u;

        ivec3 dyCorner = ivec3(coords.y, coords.z, coords.w) - pads;
        int dyDCorner = dyCorner.x;
        int dyRCorner = dyCorner.y;
        int dyCCorner = dyCorner.z;

        // Convolve dy(?, ?, ?, d) with pos mask(:, :, :, ch) to get
        // dx(xD, xR, xC, ch).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;

        for (int wD = 0; wD < ${effectiveFilterDepth};
            wD += ${dilationDepth}) {
          float dyD = float(dyDCorner + wD) / ${strideDepth}.0;

          if (dyD < 0.0 || dyD >= ${convInfo.outDepth}.0 || fract(dyD) > 0.0) {
            continue;
          }
          int idyD = int(dyD);

          for (int wR = 0; wR < ${effectiveFilterHeight};
              wR += ${dilationHeight}) {
            float dyR = float(dyRCorner + wR) / ${strideHeight}.0;

            if (dyR < 0.0 || dyR >= ${convInfo.outHeight}.0 ||
                fract(dyR) > 0.0) {
              continue;
            }
            int idyR = int(dyR);

            for (int wC = 0; wC < ${effectiveFilterWidth};
                wC += ${dilationWidth}) {
              float dyC = float(dyCCorner + wC) / ${strideWidth}.0;

              if (dyC < 0.0 || dyC >= ${convInfo.outWidth}.0 ||
                  fract(dyC) > 0.0) {
                continue;
              }
              int idyC = int(dyC);

              float dyValue = getDy(batch, idyD, idyR, idyC, ch);

              dotProd += dyValue * avgMultiplier;
            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}


function $7d7e351f6798b687$export$798cb4034e996ff4(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, input: input } = inputs;
    const x = input;
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    const dilations = [
        1,
        1,
        1
    ];
    const convInfo = (0, $i64bB.backend_util).computePool3DInfo(x.shape, filterSize, strides, dilations, pad, dimRoundingMode);
    const avgPoolBackpropProgram = new (0, $44784ecc85966d51$export$f166702869bc274f)(convInfo);
    return backend.runWebGLProgram(avgPoolBackpropProgram, [
        dy
    ], x.dtype);
}
const $7d7e351f6798b687$export$1eeb8780807d0508 = {
    kernelName: (0, $i64bB.AvgPool3DGrad),
    backendName: 'webgl',
    kernelFunc: $7d7e351f6798b687$export$798cb4034e996ff4
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


function $301cf15fac264e3e$export$2f098171d1c79aea(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, input: input } = inputs;
    const x = input;
    (0, $03fc80a4a4cef09e$export$1412c17b2531581a)([
        dy,
        input
    ], 'avgPoolGrad');
    const { filterSize: filterSize, strides: strides, pad: pad } = attrs;
    const convInfo = (0, $i64bB.backend_util).computePool2DInfo(x.shape, filterSize, strides, 1 /* dilations */ , pad);
    const avgPoolBackpropProgram = new (0, $44784ecc85966d51$export$5dc4ec478e6759de)(convInfo);
    return backend.runWebGLProgram(avgPoolBackpropProgram, [
        dy
    ], x.dtype);
}
const $301cf15fac264e3e$export$ac3f8709351ab225 = {
    kernelName: (0, $i64bB.AvgPoolGrad),
    backendName: 'webgl',
    kernelFunc: $301cf15fac264e3e$export$2f098171d1c79aea
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

function $0d7807b255cc9584$export$8f97894b482227f0(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { a: a, b: b } = inputs;
    const { transposeA: transposeA, transposeB: transposeB } = attrs;
    return (0, $400586318c9d65f3$export$d524d65e88e1168b)({
        a: a,
        b: b,
        transposeA: transposeA,
        transposeB: transposeB,
        backend: backend
    });
}
const $0d7807b255cc9584$export$d0dd993198185538 = {
    kernelName: (0, $i64bB.BatchMatMul),
    backendName: 'webgl',
    kernelFunc: $0d7807b255cc9584$export$8f97894b482227f0
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
class $0fd24db5c5372a9d$export$bd15a4172044baef {
    constructor(xShape, meanShape, varianceShape, offsetShape, scaleShape, varianceEpsilon){
        this.outputShape = [];
        this.variableNames = [
            'x',
            'mean',
            'variance'
        ];
        (0, $i64bB.backend_util).assertAndGetBroadcastShape(xShape, meanShape);
        (0, $i64bB.backend_util).assertAndGetBroadcastShape(xShape, varianceShape);
        let offsetSnippet = '0.0';
        if (offsetShape != null) {
            (0, $i64bB.backend_util).assertAndGetBroadcastShape(xShape, offsetShape);
            this.variableNames.push('offset');
            offsetSnippet = 'getOffsetAtOutCoords()';
        }
        let scaleSnippet = '1.0';
        if (scaleShape != null) {
            (0, $i64bB.backend_util).assertAndGetBroadcastShape(xShape, scaleShape);
            this.variableNames.push('scale');
            scaleSnippet = 'getScaleAtOutCoords()';
        }
        this.outputShape = xShape;
        this.userCode = `
      void main() {
        float x = getXAtOutCoords();
        float mean = getMeanAtOutCoords();
        float variance = getVarianceAtOutCoords();
        float offset = ${offsetSnippet};
        float scale = ${scaleSnippet};
        float inv = scale * inversesqrt(variance + float(${varianceEpsilon}));
        setOutput(dot(vec3(x, -mean, offset), vec3(inv, inv, 1)));
      }
    `;
    }
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
class $b8d451f9a1326d83$export$cfdd4076f282cff6 {
    constructor(xShape, meanShape, varianceShape, offsetShape, scaleShape, varianceEpsilon){
        this.packedInputs = true;
        this.packedOutput = true;
        this.variableNames = [
            'x',
            'mean',
            'variance'
        ];
        (0, $i64bB.backend_util).assertAndGetBroadcastShape(xShape, meanShape);
        (0, $i64bB.backend_util).assertAndGetBroadcastShape(xShape, varianceShape);
        let offsetSnippet = 'vec4(0.0)';
        if (offsetShape != null) {
            (0, $i64bB.backend_util).assertAndGetBroadcastShape(xShape, offsetShape);
            this.variableNames.push('offset');
            offsetSnippet = 'getOffsetAtOutCoords()';
        }
        let scaleSnippet = 'vec4(1.0)';
        if (scaleShape != null) {
            (0, $i64bB.backend_util).assertAndGetBroadcastShape(xShape, scaleShape);
            this.variableNames.push('scale');
            scaleSnippet = 'getScaleAtOutCoords()';
        }
        this.outputShape = xShape;
        this.userCode = `
      void main() {
        vec4 offset = ${offsetSnippet};
        vec4 scale = ${scaleSnippet};

        vec4 x = getXAtOutCoords();
        vec4 mean = getMeanAtOutCoords();
        vec4 variance = getVarianceAtOutCoords();

        vec4 inv = scale * inversesqrt(variance + vec4(${varianceEpsilon}));

        setOutput((x - mean) * inv + offset);
      }
    `;
    }
}


const $07d4496ea817584e$export$8ea8088e6d0cdd02 = ({ inputs: inputs, backend: backend, attrs: attrs })=>{
    const { x: x, mean: mean, variance: variance, offset: offset, scale: scale } = inputs;
    (0, $i64bB.util).assert(mean.shape.length === variance.shape.length, ()=>"Batch normalization gradient requires mean and variance to have equal ranks.");
    (0, $i64bB.util).assert(offset == null || mean.shape.length === offset.shape.length, ()=>"Batch normalization gradient requires mean and offset to have equal ranks.");
    (0, $i64bB.util).assert(scale == null || mean.shape.length === scale.shape.length, ()=>"Batch normalization gradient requires mean and scale to have equal ranks.");
    let { varianceEpsilon: varianceEpsilon } = attrs;
    if (varianceEpsilon == null) varianceEpsilon = 0.001;
    const finalInputs = [
        x,
        mean,
        variance
    ];
    let offsetShape = null;
    if (offset != null) {
        offsetShape = offset.shape;
        finalInputs.push(offset);
    }
    let scaleShape = null;
    if (scale != null) {
        scaleShape = scale.shape;
        finalInputs.push(scale);
    }
    const program = (0, $i64bB.env)().getBool('WEBGL_PACK_NORMALIZATION') ? new (0, $b8d451f9a1326d83$export$cfdd4076f282cff6)(x.shape, mean.shape, variance.shape, offsetShape, scaleShape, varianceEpsilon) : new (0, $0fd24db5c5372a9d$export$bd15a4172044baef)(x.shape, mean.shape, variance.shape, offsetShape, scaleShape, varianceEpsilon);
    const output = backend.runWebGLProgram(program, finalInputs, finalInputs[0].dtype);
    return output;
};
const $07d4496ea817584e$export$df2dc5c7a755e418 = {
    kernelName: (0, $i64bB.FusedBatchNorm),
    backendName: 'webgl',
    kernelFunc: $07d4496ea817584e$export$8ea8088e6d0cdd02
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
class $a8de9a814b8fcdbe$export$ef8bf52bc4951c85 {
    constructor(destSize){
        this.variableNames = [
            'source'
        ];
        this.outputShape = destSize;
        this.rank = destSize.length;
        const dtype = (0, $ba2c54ffbda39e8e$export$859efd105c10c755)(this.rank);
        this.customUniforms = [
            {
                name: 'start',
                arrayIndex: this.rank,
                type: 'int'
            }
        ];
        const sourceCoords = $a8de9a814b8fcdbe$var$getCoords(this.rank);
        let body;
        const coordSum = destSize.map((_, i)=>{
            return `sourceLoc.${$a8de9a814b8fcdbe$var$coords[i]} = start[${i}] + coords.${$a8de9a814b8fcdbe$var$coords[i]};`;
        });
        body = `
        ${dtype} sourceLoc;
        ${dtype} coords = getOutputCoords();
        ${coordSum.join('\n')}
      `;
        this.userCode = `
      void main() {
        ${body}
        setOutput(getSource(${sourceCoords}));
      }
    `;
    }
}
const $a8de9a814b8fcdbe$var$coords = [
    'x',
    'y',
    'z',
    'w',
    'u',
    'v'
];
function $a8de9a814b8fcdbe$var$getCoords(rank) {
    if (rank === 1) return 'sourceLoc';
    else if (rank <= 6) return $a8de9a814b8fcdbe$var$coords.slice(0, rank).map((x)=>'sourceLoc.' + x).join(',');
    else throw Error(`Slicing for rank ${rank} is not yet supported`);
}


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $d8e8bb0c0514779d$export$a6c6101de259f77 {
    constructor(destSize){
        this.variableNames = [
            'source'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.outputShape = destSize;
        this.rank = destSize.length;
        this.customUniforms = [
            {
                name: 'start',
                arrayIndex: this.rank,
                type: 'int'
            }
        ];
        const dtype = (0, $ba2c54ffbda39e8e$export$859efd105c10c755)(this.rank);
        const coords = (0, $30912e1180ed417f$export$7a4d1d0d17b69972)('coords', this.rank);
        const sourceLoc = (0, $30912e1180ed417f$export$7a4d1d0d17b69972)('sourceLoc', this.rank);
        const innerDims = this.rank === 1 ? 'sourceLoc' : `vec2(${sourceLoc.slice(-2).join()})`;
        const getChannel = `getChannel(getSource(${sourceLoc.join()}), ${innerDims})`;
        const upperRow = `
      result.x = ${getChannel};
      if (++${coords[this.rank - 1]} < ${destSize[this.rank - 1]}) {
        ++${sourceLoc[this.rank - 1]};
        result.y = ${getChannel};
        --${sourceLoc[this.rank - 1]};
      }
    `;
        const lowerRow = this.rank === 1 ? '' : `
      --${coords[this.rank - 1]};
      if (++${coords[this.rank - 2]} < ${destSize[this.rank - 2]}) {
        ++${sourceLoc[this.rank - 2]};
        result.z = ${getChannel};
        if (++${coords[this.rank - 1]} < ${destSize[this.rank - 1]}) {
          ++${sourceLoc[this.rank - 1]};
          result.w = ${getChannel};
        }
      }
    `;
        const sourceLocSetup = this.rank <= 4 ? `sourceLoc = coords +
            ${dtype}(${destSize.map((_, i)=>`start[${i}]`).join()});` : destSize.map((_, i)=>`${sourceLoc[i]} = ${coords[i]} + start[${i}];`).join('\n');
        this.userCode = `
      void main() {
        ${dtype} coords = getOutputCoords();
        ${dtype} sourceLoc;
        ${sourceLocSetup}
        vec4 result = vec4(0.);
        ${upperRow}
        ${lowerRow}
        setOutput(result);
      }
    `;
    }
}


function $c4b4f5c2e7e1b97a$var$shallowSlice(x, begin, size, backend) {
    const xTexData = backend.texData.get(x.dataId);
    const t = backend.makeTensorInfo(size, x.dtype);
    const newTexData = backend.texData.get(t.dataId);
    // Copy texture data from the original tensor.
    Object.assign(newTexData, xTexData);
    newTexData.refCount = 1;
    newTexData.shape = size;
    newTexData.dtype = x.dtype;
    let flatOffset = (0, $i64bB.slice_util).computeFlatOffset(begin, (0, $i64bB.util).computeStrides(x.shape));
    if (xTexData.slice) // We are slicing an already sliced tensor, so we have to accumulate
    // the offset.
    flatOffset += xTexData.slice.flatOffset;
    newTexData.slice = {
        flatOffset: flatOffset,
        // Point to the original dataId, which is used to do ref counting.
        origDataId: xTexData.slice && xTexData.slice.origDataId || x.dataId
    };
    // Increase the ref count for that data bucket.
    const refCount = backend.dataRefCount.get(newTexData.slice.origDataId) || 1;
    backend.dataRefCount.set(newTexData.slice.origDataId, refCount + 1);
    return t;
}
function $c4b4f5c2e7e1b97a$export$58adb3bec8346d0f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { begin: begin, size: size } = attrs;
    const [$begin, $size] = (0, $i64bB.slice_util).parseSliceParams(x, begin, size);
    (0, $i64bB.slice_util).assertParamsValid(x, $begin, $size);
    if ((0, $i64bB.util).sizeFromShape($size) === 0) return backend.makeTensorInfo($size, x.dtype, []);
    // Run on cpu if dtype is string. For string, the backend represents it
    // as Uint8Array[], where each Uint8Array is a character. Given that the
    // computation is only on the outer array, uploading the whole data onto
    // gpu is wasteful. Also, currently webgl doesn't have a design to
    // upload and retrieve Uint8Array[] between cpu and gpu. Therefore, we
    // just run the kernel on cpu if dtype is string.
    if (backend.shouldExecuteOnCPU([
        x
    ]) || x.dtype === 'string') {
        const xTexData = backend.texData.get(x.dataId);
        const outValues = (0, $377486a788efd20b$export$45812d0d8578899)(xTexData.values, $begin, $size, x.shape, x.dtype);
        return backend.makeTensorInfo($size, x.dtype, outValues);
    }
    const { isPacked: isPacked } = backend.texData.get(x.dataId);
    const isContinous = (0, $i64bB.slice_util).isSliceContinous(x.shape, $begin, $size);
    if (isPacked || !isContinous) {
        const program = (0, $i64bB.env)().getBool('WEBGL_PACK_ARRAY_OPERATIONS') ? new (0, $d8e8bb0c0514779d$export$a6c6101de259f77)($size) : new (0, $a8de9a814b8fcdbe$export$ef8bf52bc4951c85)($size);
        const customValues = [
            $begin
        ];
        return backend.runWebGLProgram(program, [
            x
        ], x.dtype, customValues);
    }
    backend.uploadToGPU(x.dataId);
    return $c4b4f5c2e7e1b97a$var$shallowSlice(x, $begin, $size, backend);
}
const $c4b4f5c2e7e1b97a$export$8d8a1e11dd2cc6c4 = {
    kernelName: (0, $i64bB.Slice),
    backendName: 'webgl',
    kernelFunc: $c4b4f5c2e7e1b97a$export$58adb3bec8346d0f
};



const $0e7ba385a90d21de$export$ea37d960c1808536 = (args)=>{
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { blockShape: blockShape, crops: crops } = attrs;
    (0, $i64bB.util).assert(x.shape.length <= 4, ()=>"batchToSpaceND for rank > 4 with a WebGL backend not implemented yet");
    const prod = blockShape.reduce((a, b)=>a * b);
    const reshaped = (0, $i64bB.backend_util).getReshaped(x.shape, blockShape, prod);
    const permuted = (0, $i64bB.backend_util).getPermuted(reshaped.length, blockShape.length);
    const reshapedPermuted = (0, $i64bB.backend_util).getReshapedPermuted(x.shape, blockShape, prod);
    const sliceBeginCoords = (0, $i64bB.backend_util).getSliceBeginCoords(crops, blockShape.length);
    const sliceSize = (0, $i64bB.backend_util).getSliceSize(reshapedPermuted, crops, blockShape.length);
    const toDispose = [];
    const reshapedIntermediate = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            shape: reshaped
        }
    });
    const transposedIntermediate = (0, $6cab078553124169$export$9cb09a71b7d66923)({
        inputs: {
            x: reshapedIntermediate
        },
        backend: backend,
        attrs: {
            perm: permuted
        }
    });
    const reshapedIntermediate2 = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: transposedIntermediate
        },
        backend: backend,
        attrs: {
            shape: reshapedPermuted
        }
    });
    const sliced = (0, $c4b4f5c2e7e1b97a$export$58adb3bec8346d0f)({
        inputs: {
            x: reshapedIntermediate2
        },
        backend: backend,
        attrs: {
            begin: sliceBeginCoords,
            size: sliceSize
        }
    });
    toDispose.push(reshapedIntermediate);
    toDispose.push(transposedIntermediate);
    toDispose.push(reshapedIntermediate2);
    toDispose.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return sliced;
};
const $0e7ba385a90d21de$export$44e08e19f97e5513 = {
    kernelName: (0, $i64bB.BatchToSpaceND),
    backendName: 'webgl',
    kernelFunc: $0e7ba385a90d21de$export$ea37d960c1808536
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

function $4059b2d79778b36c$export$7e474bab088ed182(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, weights: weights } = inputs;
    const { size: size } = attrs;
    const xVals = backend.readSync(x.dataId);
    const weightsVals = backend.readSync(weights.dataId);
    const outVals = (0, $377486a788efd20b$export$566def819e5d4601)(xVals, weightsVals, weights.dtype, weights.shape, size);
    return backend.makeTensorInfo([
        size
    ], weights.dtype, outVals);
}
const $4059b2d79778b36c$export$af9f0093738840fb = {
    kernelName: (0, $i64bB.Bincount),
    backendName: 'webgl',
    kernelFunc: $4059b2d79778b36c$export$7e474bab088ed182
};


/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");



const $c545ba0c343ec7d9$export$c4be938c09e5b0e3 = `
  int r = int(a.r) & int(b.r);
  int g = int(a.g) & int(b.g);
  int rb = int(a.b) & int(b.b);
  int ra = int(a.a) & int(b.a);
  return vec4(r, g, rb, ra);
`;
const $c545ba0c343ec7d9$export$798433bcbadf4947 = `
  return float(int(a.r) & int(b.r));
`;
function $c545ba0c343ec7d9$export$84529b0ad3b42cd1(args) {
    const { inputs: inputs, backend: backend } = args;
    const { a: a, b: b } = inputs;
    const shouldUsePackedProgram = (0, $i64bB.env)().getBool('WEBGL_PACK_BINARY_OPERATIONS');
    const versionNumber = (0, $i64bB.env)().getNumber('WEBGL_VERSION');
    // The type of a and b are ensured to be `int32` in core, therefore no need to
    // consider other type situations.
    if (backend.shouldExecuteOnCPU([
        a,
        b
    ]) || versionNumber === 1) {
        const aVals = backend.texData.get(a.dataId).values;
        const bVals = backend.texData.get(b.dataId).values;
        const [outValues, outShape] = (0, $377486a788efd20b$export$b9ea48282fa3ef20)(a.shape, b.shape, aVals, bVals, a.dtype);
        const out = backend.makeTensorInfo(outShape, a.dtype);
        const outData = backend.texData.get(out.dataId);
        outData.values = outValues;
        return out;
    }
    let program;
    if (shouldUsePackedProgram) program = new (0, $1b00798c48aa5c1a$export$7ef3bdc75c177be0)($c545ba0c343ec7d9$export$c4be938c09e5b0e3, a.shape, b.shape, false);
    else program = new (0, $a3544edc66d558ba$export$9045e9161086790b)($c545ba0c343ec7d9$export$798433bcbadf4947, a.shape, b.shape);
    return backend.runWebGLProgram(program, [
        a,
        b
    ], a.dtype);
}
const $c545ba0c343ec7d9$export$6d53927dafa38bf9 = {
    kernelName: (0, $i64bB.BitwiseAnd),
    backendName: 'webgl',
    kernelFunc: $c545ba0c343ec7d9$export$84529b0ad3b42cd1
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
function $ff697a7195ce28b0$export$d226d344aedce941(args) {
    const { inputs: inputs, backend: backend } = args;
    const { s0: s0, s1: s1 } = inputs;
    const s0Vals = backend.readSync(s0.dataId);
    const s1Vals = backend.readSync(s1.dataId);
    const broadcastShape = (0, $i64bB.backend_util).assertAndGetBroadcastShape(Array.from(s0Vals), Array.from(s1Vals));
    return backend.makeTensorInfo([
        broadcastShape.length
    ], 'int32', Int32Array.from(broadcastShape));
}
const $ff697a7195ce28b0$export$8f7b2ec0c6f08fb2 = {
    kernelName: (0, $i64bB.BroadcastArgs),
    backendName: 'webgl',
    kernelFunc: $ff697a7195ce28b0$export$d226d344aedce941
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


const $32100f910ecbf976$var$NOT_EQUAL = `return float(a != b);`;
const $32100f910ecbf976$export$53a6892c50694894 = (0, $2e65282075da2b30$export$29353c66e70e3e16)({
    opSnippet: $32100f910ecbf976$var$NOT_EQUAL,
    cpuKernelImpl: (0, $377486a788efd20b$export$b91372753635df24),
    dtype: 'bool'
});
const $32100f910ecbf976$export$d003d4d7e1500775 = {
    kernelName: (0, $i64bB.NotEqual),
    backendName: 'webgl',
    kernelFunc: $32100f910ecbf976$export$53a6892c50694894
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

function $3d07b56624286bfa$export$9fc57fb453bdbd67(args) {
    const { inputs: inputs, backend: backend } = args;
    const { input: input } = inputs;
    const inputData = backend.texData.get(input.dataId);
    return (0, $2b13f312c76ad9c3$export$f0954fd7d5368655)({
        inputs: {
            x: inputData.complexTensorInfos.real
        },
        backend: backend
    });
}
const $3d07b56624286bfa$export$4b7bce57557ae68b = {
    kernelName: (0, $i64bB.Real),
    backendName: 'webgl',
    kernelFunc: $3d07b56624286bfa$export$9fc57fb453bdbd67
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
const $b90204bfe8b0e1cd$var$TO_INT = `return float(int(x));`;
function $b90204bfe8b0e1cd$export$7d260a2a5f8bc19e(input, backend) {
    const program = new (0, $d607b1799b79a159$export$f93811a5a466fd42)(input.shape, $b90204bfe8b0e1cd$var$TO_INT);
    const output = backend.runWebGLProgram(program, [
        input
    ], 'int32');
    return {
        dataId: output.dataId,
        shape: output.shape,
        dtype: output.dtype
    };
}


function $e7854ff584c008b2$export$f2db7d5238e1d23f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { dtype: dtype } = attrs;
    // Casting to complex64.
    if (dtype === 'complex64') {
        if (x.dtype === 'complex64') return (0, $2b13f312c76ad9c3$export$f0954fd7d5368655)({
            inputs: {
                x: x
            },
            backend: backend
        });
        // TODO(annxingyuan): Import kernel function once zeros is modularized.
        const zerosTensor = $i64bB.zeros(x.shape);
        const floatX = $e7854ff584c008b2$export$f2db7d5238e1d23f({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                dtype: 'float32'
            }
        });
        const result = (0, $f23c2381cb68ff19$export$83a0e34f1302825b)({
            inputs: {
                real: floatX,
                imag: zerosTensor
            },
            backend: backend
        });
        zerosTensor.dispose();
        backend.disposeIntermediateTensorInfo(floatX);
        return result;
    }
    // Casting from complex64
    if (x.dtype === 'complex64') {
        const realPart = (0, $3d07b56624286bfa$export$9fc57fb453bdbd67)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const result = $e7854ff584c008b2$export$f2db7d5238e1d23f({
            inputs: {
                x: realPart
            },
            backend: backend,
            attrs: {
                dtype: dtype
            }
        });
        backend.disposeIntermediateTensorInfo(realPart);
        return result;
    }
    if (!(0, $i64bB.util).hasEncodingLoss(x.dtype, dtype)) {
        // We don't change the underlying data, since we cast to higher
        // precision.
        const result = (0, $2b13f312c76ad9c3$export$f0954fd7d5368655)({
            inputs: {
                x: x
            },
            backend: backend
        });
        return {
            dataId: result.dataId,
            shape: result.shape,
            dtype: dtype
        };
    }
    if (backend.shouldExecuteOnCPU([
        x
    ])) {
        const values = backend.texData.get(x.dataId).values;
        const [resultShape, resultType, resultData] = (0, $377486a788efd20b$export$babf602309dd6292)(values, x.shape, x.dtype, dtype);
        return backend.makeTensorInfo(resultShape, resultType, resultData);
    }
    if (dtype === 'int32') return (0, $b90204bfe8b0e1cd$export$7d260a2a5f8bc19e)(x, backend);
    if (dtype === 'bool') {
        const zerosTensorInfo = backend.makeTensorInfo([], 'bool', (0, $i64bB.util).getTypedArrayFromDType('bool', 1));
        const binaryInputs = {
            a: x,
            b: zerosTensorInfo
        };
        const result = (0, $32100f910ecbf976$export$53a6892c50694894)({
            inputs: binaryInputs,
            backend: backend
        });
        backend.disposeIntermediateTensorInfo(zerosTensorInfo);
        return result;
    }
    throw new Error(`Error in Cast: failed to cast ${x.dtype} to ${dtype}`);
}
const $e7854ff584c008b2$export$ac4d0f0f3927a8f3 = {
    kernelName: (0, $i64bB.Cast),
    backendName: 'webgl',
    kernelFunc: $e7854ff584c008b2$export$f2db7d5238e1d23f
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


const $b19701b33ab731bd$var$CEIL = `return ceil(x);`;
const $b19701b33ab731bd$export$803ce6b71a0a94b2 = (0, $2e65282075da2b30$export$ba4daf5748026fba)({
    opSnippet: $b19701b33ab731bd$var$CEIL,
    packedOpSnippet: $b19701b33ab731bd$var$CEIL,
    cpuKernelImpl: (0, $377486a788efd20b$export$bb3ce81256fe261b)
});
const $b19701b33ab731bd$export$df387212b1898306 = {
    kernelName: (0, $i64bB.Ceil),
    backendName: 'webgl',
    kernelFunc: $b19701b33ab731bd$export$803ce6b71a0a94b2
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $c345b5d55055ba97$export$ce48b7c79e7985d1 {
    constructor(aShape){
        this.variableNames = [
            'A'
        ];
        this.customUniforms = [
            {
                name: 'minVal',
                type: 'float'
            },
            {
                name: 'maxVal',
                type: 'float'
            }
        ];
        this.outputShape = aShape;
        this.userCode = `

      void main() {
        float value = getAAtOutCoords();
        if (isnan(value)) {
          setOutput(value);
          return;
        }

        setOutput(clamp(value, minVal, maxVal));
      }
    `;
    }
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $b155538cbc3cd34f$export$812909708a626d33 {
    constructor(aShape){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.customUniforms = [
            {
                name: 'minVal',
                type: 'float'
            },
            {
                name: 'maxVal',
                type: 'float'
            }
        ];
        this.outputShape = aShape;
        this.userCode = `
      void main() {
        vec4 value = getAAtOutCoords();

        if (any(isnan(value))) {
          setOutput(value);
          return;
        }

        setOutput(clamp(value, vec4(minVal), vec4(maxVal)));
      }
    `;
    }
}


function $1bd954b3a607232d$export$fa97baf70ad024c0(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { clipValueMin: clipValueMin, clipValueMax: clipValueMax } = attrs;
    let program;
    if ((0, $i64bB.env)().getBool('WEBGL_PACK_CLIP')) program = new (0, $b155538cbc3cd34f$export$812909708a626d33)(x.shape);
    else program = new (0, $c345b5d55055ba97$export$ce48b7c79e7985d1)(x.shape);
    const customValues = [
        [
            clipValueMin
        ],
        [
            clipValueMax
        ]
    ];
    return backend.runWebGLProgram(program, [
        x
    ], x.dtype, customValues);
}
const $1bd954b3a607232d$export$f7ee8f07ce0ff4e1 = {
    kernelName: (0, $i64bB.ClipByValue),
    backendName: 'webgl',
    kernelFunc: $1bd954b3a607232d$export$fa97baf70ad024c0
};



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $43027d5950b9fdad$export$d03dbc86862098f5 {
    constructor(shape){
        this.variableNames = [
            'real',
            'imag'
        ];
        this.outputShape = shape;
        this.userCode = `
      void main() {
        float re = abs(getRealAtOutCoords());
        float im = abs(getImagAtOutCoords());
        float mx = max(re, im);

        // sadly the length function in glsl is not underflow-safe
        // (at least not on Intel GPUs). So the safe solution is
        // to ensure underflow-safety in all cases.
        setOutput(
          mx == 0.0 ? 0.0 : mx * length(vec2(1, min(re, im)/mx))
        );
      }
    `;
    }
}


// Returns a TensorInfo with the complex shape and the dataId of the
// underlying part. We need to do this because a reshaped complex tensor is
// not reflected in its parts.
function $5602b12947b1b973$var$makeComplexComponentTensorInfo(complexTensor, complexPart) {
    return {
        dataId: complexPart.dataId,
        dtype: complexPart.dtype,
        shape: complexTensor.shape
    };
}
function $5602b12947b1b973$export$2837bc62566f8808(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    const xData = backend.texData.get(x.dataId);
    const program = new (0, $43027d5950b9fdad$export$d03dbc86862098f5)(x.shape);
    const programInputs = [
        $5602b12947b1b973$var$makeComplexComponentTensorInfo(x, xData.complexTensorInfos.real),
        $5602b12947b1b973$var$makeComplexComponentTensorInfo(x, xData.complexTensorInfos.imag)
    ];
    return backend.runWebGLProgram(program, programInputs, programInputs[0].dtype);
}
const $5602b12947b1b973$export$a4817d2978acc054 = {
    kernelName: (0, $i64bB.ComplexAbs),
    backendName: 'webgl',
    kernelFunc: $5602b12947b1b973$export$2837bc62566f8808
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
class $eab013fe02d98242$export$9059cb52ee2cb142 {
    // Concats 2d tensors along axis=1. See comments in MathBackendWebGL.concat().
    constructor(shapes){
        this.outputShape = [];
        this.outputShape = (0, $i64bB.backend_util).computeOutShape(shapes, 1 /* axis */ );
        this.variableNames = shapes.map((_, i)=>`T${i}`);
        const offsets = new Array(shapes.length - 1);
        offsets[0] = shapes[0][1];
        for(let i = 1; i < offsets.length; i++)offsets[i] = offsets[i - 1] + shapes[i][1];
        const snippets = [
            `if (yC < ${offsets[0]}) setOutput(getT0(yR, yC));`
        ];
        for(let i = 1; i < offsets.length; i++){
            const shift = offsets[i - 1];
            snippets.push(`else if (yC < ${offsets[i]}) ` + `setOutput(getT${i}(yR, yC-${shift}));`);
        }
        const lastIndex = offsets.length;
        const lastShift = offsets[offsets.length - 1];
        snippets.push(`else setOutput(getT${lastIndex}(yR, yC-${lastShift}));`);
        this.userCode = `
      void main() {
        ivec2 coords = getOutputCoords();
        int yR = coords.x;
        int yC = coords.y;

        ${snippets.join('\n        ')}
      }
    `;
    }
}


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


class $5957525ab6c69aa1$export$e91e551248cfdb97 {
    constructor(shapes, axis){
        this.packedInputs = true;
        this.packedOutput = true;
        this.outputShape = [];
        this.outputShape = (0, $i64bB.backend_util).computeOutShape(shapes, axis);
        const shape = this.outputShape;
        const rank = shape.length;
        const dtype = (0, $ba2c54ffbda39e8e$export$859efd105c10c755)(rank);
        const coords = (0, $30912e1180ed417f$export$7a4d1d0d17b69972)('coords', rank);
        const channels = [
            'x',
            'y',
            'z',
            'w',
            'u',
            'v'
        ].slice(0, rank);
        this.variableNames = shapes.map((_, i)=>`T${i}`);
        const offsets = new Array(shapes.length - 1);
        offsets[0] = shapes[0][axis];
        for(let i = 1; i < offsets.length; i++)offsets[i] = offsets[i - 1] + shapes[i][axis];
        const channel = channels[axis];
        const lastChannels = channels.slice(-2);
        const allChannels = channels.join();
        let getValueSnippet = `if (${channel} < ${offsets[0]}) {
        return getChannel(
            getT0(${allChannels}), vec2(${lastChannels.join()}));
        }`;
        for(let i = 1; i < offsets.length; i++){
            const shift = offsets[i - 1];
            // Note: the >= comparison below may seem unnecessary given the check
            // above but is needed to workaround branch execution issues on some
            // devices. It makes all the conditions exclusive without relying on
            // execution order.
            getValueSnippet += `
        if (${channel} < ${offsets[i]}  && ${channel} >= ${offsets[i - 1]}) {
          return getChannel(
            getT${i}(${$5957525ab6c69aa1$var$shiftedChannels(channels, channel, shift)}),
            vec2(${$5957525ab6c69aa1$var$shiftedChannels(lastChannels, channel, shift)}));
        }`;
        }
        const lastIndex = offsets.length;
        const shift = offsets[offsets.length - 1];
        getValueSnippet += `
        return getChannel(
          getT${lastIndex}(${$5957525ab6c69aa1$var$shiftedChannels(channels, channel, shift)}),
          vec2(${$5957525ab6c69aa1$var$shiftedChannels(lastChannels, channel, shift)}));`;
        this.userCode = `
      float getValue(${channels.map((x)=>'int ' + x)}) {
        ${getValueSnippet}
      }

      void main() {
        ${dtype} coords = getOutputCoords();
        vec4 result = vec4(getValue(${coords}), 0., 0., 0.);

        ${coords[rank - 1]} = ${coords[rank - 1]} + 1;
        if (${coords[rank - 1]} < ${shape[rank - 1]}) {
          result.g = getValue(${coords});
        }

        ${coords[rank - 2]} = ${coords[rank - 2]} + 1;
        if (${coords[rank - 2]} < ${shape[rank - 2]}) {
          result.a = getValue(${coords});
        }

        ${coords[rank - 1]} = ${coords[rank - 1]} - 1;
        if (${coords[rank - 2]} < ${shape[rank - 2]} &&
            ${coords[rank - 1]} < ${shape[rank - 1]}) {
          result.b = getValue(${coords});
        }
        setOutput(result);
      }
    `;
    }
}
/**
 * Return an expression for coordinates into a vector where a given channel
 * will be offset by [shift].
 *
 * @param channels the channels to consider
 * @param channel the channel we want shifted
 * @param shift  the amount to subtract from the channel.
 *
 * @returns a string of the form 'x, y-[shift], z' where any one channel can
 * have the shift applied.
 */ function $5957525ab6c69aa1$var$shiftedChannels(channels, channel, shift) {
    const channelIdx = channels.indexOf(channel);
    const res = channels.map((c, idx)=>{
        if (idx === channelIdx) return `${c} - ${shift}`;
        else return c;
    });
    return res.join();
}






/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

function $26faf84d87c54a60$export$d78fab5778ab392b(args) {
    const { inputs: inputs, backend: backend } = args;
    const { input: input } = inputs;
    const inputData = backend.texData.get(input.dataId);
    return (0, $2b13f312c76ad9c3$export$f0954fd7d5368655)({
        inputs: {
            x: inputData.complexTensorInfos.imag
        },
        backend: backend
    });
}
const $26faf84d87c54a60$export$ddfc128c2801add7 = {
    kernelName: (0, $i64bB.Imag),
    backendName: 'webgl',
    kernelFunc: $26faf84d87c54a60$export$d78fab5778ab392b
};




function $a15b9164ed3adc1f$export$777da59f594f497d(inputs, axis, backend) {
    const dtype = inputs[0].dtype;
    if (dtype === 'complex64') {
        const reals = inputs.map((t)=>(0, $3d07b56624286bfa$export$9fc57fb453bdbd67)({
                inputs: {
                    input: t
                },
                backend: backend
            }));
        const imags = inputs.map((t)=>(0, $26faf84d87c54a60$export$d78fab5778ab392b)({
                inputs: {
                    input: t
                },
                backend: backend
            }));
        const realConcated = $a15b9164ed3adc1f$export$777da59f594f497d(reals, axis, backend);
        const imagConcated = $a15b9164ed3adc1f$export$777da59f594f497d(imags, axis, backend);
        const result = (0, $f23c2381cb68ff19$export$83a0e34f1302825b)({
            inputs: {
                real: realConcated,
                imag: imagConcated
            },
            backend: backend
        });
        reals.forEach((r)=>backend.disposeIntermediateTensorInfo(r));
        imags.forEach((i)=>backend.disposeIntermediateTensorInfo(i));
        backend.disposeIntermediateTensorInfo(realConcated);
        backend.disposeIntermediateTensorInfo(imagConcated);
        return result;
    }
    let runOnCpu = backend.shouldExecuteOnCPU(inputs);
    // Run on cpu if dtype is string. For string, the backend represents it
    // as Uint8Array[], where each Uint8Array is a character. Given that the
    // computation is only on the outer array, uploading the whole data onto
    // gpu is wasteful. Also, currently webgl doesn't have a design to
    // upload and retrieve Uint8Array[] between cpu and gpu. Therefore, we
    // just run the kernel on cpu if dtype is string.
    if (dtype === 'string') runOnCpu = true;
    if (runOnCpu) {
        // Any concat of n-dimensional tensors across any axis can be reduced to
        // a concatenation of two-dimensional tensors across the axis 1 by first
        // partitioning the axes of the original tensors into those less than the
        // axis to be concatenated and the rest. Then reshape the tensors
        // into a two-dimensional tensor by collapsing these two sets of axes and
        // concatenate the resulting matrices across the axis 1, finally reshaping
        // the result to have the proper shape.
        const tensors2D = inputs.map((t)=>{
            const innerSize = (0, $i64bB.util).sizeFromShape(t.shape.slice(axis));
            const shape = [
                -1,
                innerSize
            ];
            return (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
                inputs: {
                    x: t
                },
                backend: backend,
                attrs: {
                    shape: shape
                }
            });
        });
        const inputsValShapes = tensors2D.map((t)=>{
            return {
                vals: backend.readSync(t.dataId),
                shape: t.shape
            };
        });
        // Concats 2d tensors along axis=1.
        const outShape = (0, $i64bB.backend_util).computeOutShape(tensors2D.map((t)=>t.shape), 1 /* axis */ );
        const simplyConcat = tensors2D[0].shape[0] === 1;
        const outVals = (0, $377486a788efd20b$export$95e7342d25849d64)(inputsValShapes, outShape, dtype, simplyConcat);
        const finalOutShape = (0, $i64bB.backend_util).computeOutShape(inputs.map((t)=>t.shape), axis);
        const outInfo = backend.makeTensorInfo(finalOutShape, dtype, outVals);
        tensors2D.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
        return outInfo;
    }
    // Keep only non-empty tensors (ignore tensors with 0 in their shape).
    const $inputs = inputs.filter((t)=>(0, $i64bB.util).sizeFromShape(t.shape) > 0);
    const shouldPack = (0, $i64bB.env)().getBool('WEBGL_PACK_ARRAY_OPERATIONS') && $inputs[0].shape.length > 1;
    if ($inputs.length === 1) {
        // Clone tensor.
        const program = shouldPack ? new (0, $d607b1799b79a159$export$f93811a5a466fd42)(inputs[0].shape, (0, $d607b1799b79a159$export$c07b68c109124fe2)) : new (0, $d654f6ab3c8e3848$export$4d8daca4f85ed73d)(inputs[0].shape, (0, $d607b1799b79a159$export$c07b68c109124fe2));
        return backend.runWebGLProgram(program, inputs, dtype);
    }
    const maxTexturesInShader = (0, $i64bB.env)().getNumber('WEBGL_MAX_TEXTURES_IN_SHADER');
    if ($inputs.length > maxTexturesInShader) {
        const reducedInputs = [];
        for(let i = 0; i < $inputs.length; i += maxTexturesInShader){
            const subArray = $inputs.slice(i, i + maxTexturesInShader);
            reducedInputs.push($a15b9164ed3adc1f$export$777da59f594f497d(subArray, axis, backend));
        }
        const result = $a15b9164ed3adc1f$export$777da59f594f497d(reducedInputs, axis, backend);
        for (const i of reducedInputs)backend.disposeIntermediateTensorInfo(i);
        return result;
    }
    if (shouldPack) {
        const program = new (0, $5957525ab6c69aa1$export$e91e551248cfdb97)($inputs.map((t)=>t.shape), axis);
        return backend.runWebGLProgram(program, $inputs, dtype);
    }
    const { tensors2D: tensors2D, outShape: outShape } = $a15b9164ed3adc1f$var$computeTensors2D($inputs, axis, backend);
    const program = new (0, $eab013fe02d98242$export$9059cb52ee2cb142)(tensors2D.map((t)=>t.shape));
    const result = backend.runWebGLProgram(program, tensors2D, dtype);
    tensors2D.forEach((r)=>backend.disposeIntermediateTensorInfo(r));
    const reshapedResult = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: result
        },
        attrs: {
            shape: outShape
        },
        backend: backend
    });
    backend.disposeIntermediateTensorInfo(result);
    return reshapedResult;
}
function $a15b9164ed3adc1f$var$computeTensors2D(inputs, axis, backend) {
    // Any concat of n-dimensional tensors across any axis can be reduced to
    // a concatenation of two-dimensional tensors across the axis 1 by first
    // partitioning the axes of the original tensors into those less than the
    // axis to be concatenated and the rest. Then reshape the tensors
    // into a two-dimensional tensor by collapsing these two sets of axes and
    // concatenate the resulting matrices across the axis 1, finally reshaping
    // the result to have the proper shape.
    const outShape = (0, $i64bB.backend_util).computeOutShape(inputs.map((t)=>t.shape), axis);
    const tensors2D = inputs.map((x)=>(0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
            inputs: {
                x: x
            },
            attrs: {
                shape: [
                    -1,
                    (0, $i64bB.util).sizeFromShape(x.shape.slice(axis))
                ]
            },
            backend: backend
        }));
    return {
        tensors2D: tensors2D,
        outShape: outShape
    };
}



function $c761d8b937eefeed$export$ee1b3e54f0441b22(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { axis: axis } = attrs;
    const $axis = (0, $i64bB.util).parseAxisParam(axis, inputs[0].shape)[0];
    const shapes = inputs.map((t)=>t.shape);
    (0, $i64bB.backend_util).assertParamsConsistent(shapes, $axis);
    const outShape = (0, $i64bB.backend_util).computeOutShape(inputs.map((t)=>t.shape), $axis);
    if ((0, $i64bB.util).sizeFromShape(outShape) === 0) return backend.makeTensorInfo(outShape, inputs[0].dtype, []);
    // Keep only non-empty tensors (ignore tensors with 0 in their shape).
    const $inputs = inputs.filter((t)=>(0, $i64bB.util).sizeFromShape(t.shape) > 0);
    if ($inputs.length === 1) return (0, $2b13f312c76ad9c3$export$f0954fd7d5368655)({
        inputs: {
            x: $inputs[0]
        },
        backend: backend
    });
    return (0, $a15b9164ed3adc1f$export$777da59f594f497d)($inputs, $axis, backend);
}
const $c761d8b937eefeed$export$c8cf96dae25282e5 = {
    kernelName: (0, $i64bB.Concat),
    backendName: 'webgl',
    kernelFunc: $c761d8b937eefeed$export$ee1b3e54f0441b22
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $65122774589fac9b$export$8dc36706147178e9 {
    constructor(convInfo, addBias = false, activation = null, hasPreluActivationWeights = false, hasLeakyreluAlpha = false){
        this.variableNames = [
            'x',
            'W'
        ];
        this.outputShape = convInfo.outShape;
        const padTop = convInfo.padInfo.top;
        const padLeft = convInfo.padInfo.left;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const dilationHeight = convInfo.dilationHeight;
        const dilationWidth = convInfo.dilationWidth;
        const filterHeight = convInfo.filterHeight;
        const filterWidth = convInfo.filterWidth;
        const inputDepthNearestVec4 = Math.floor(convInfo.inChannels / 4) * 4;
        const inputDepthVec4Remainder = convInfo.inChannels % 4;
        const isChannelsLast = convInfo.dataFormat === 'channelsLast';
        const rowDim = isChannelsLast ? 1 : 2;
        const colDim = isChannelsLast ? 2 : 3;
        const channelDim = isChannelsLast ? 3 : 1;
        let activationSnippet = '', applyActivationSnippet = '';
        if (activation) {
            if (hasPreluActivationWeights) activationSnippet = `float activation(float a) {
          float b = getPreluActivationWeightsAtOutCoords();
          ${activation}
        }`;
            else if (hasLeakyreluAlpha) activationSnippet = `float activation(float a) {
          float b = getLeakyreluAlphaAtOutCoords();
          ${activation}
        }`;
            else activationSnippet = `
          float activation(float x) {
            ${activation}
          }
        `;
            applyActivationSnippet = `result = activation(result);`;
        }
        const addBiasSnippet = addBias ? 'result += getBiasAtOutCoords();' : '';
        if (addBias) this.variableNames.push('bias');
        if (hasPreluActivationWeights) this.variableNames.push('preluActivationWeights');
        if (hasLeakyreluAlpha) this.variableNames.push('leakyreluAlpha');
        this.userCode = `
      ${activationSnippet}

      const ivec2 strides = ivec2(${strideHeight}, ${strideWidth});
      const ivec2 pads = ivec2(${padTop}, ${padLeft});

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords[0];
        int d2 = coords[${channelDim}];

        ivec2 xRCCorner =
            ivec2(coords[${rowDim}], coords[${colDim}]) * strides - pads;
        int xRCorner = xRCCorner.x;
        int xCCorner = xRCCorner.y;

        // Convolve x(?, ?, d1) with w(:, :, d1, d2) to get y(yR, yC, d2).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;
        for (int wR = 0; wR < ${filterHeight}; wR++) {
          int xR = xRCorner + wR * ${dilationHeight};

          if (xR < 0 || xR >= ${convInfo.inHeight}) {
            continue;
          }

          for (int wC = 0; wC < ${filterWidth}; wC++) {
            int xC = xCCorner + wC * ${dilationWidth};

            if (xC < 0 || xC >= ${convInfo.inWidth}) {
              continue;
            }

            for (int d1 = 0; d1 < ${inputDepthNearestVec4}; d1 += 4) {
              vec4 wValues = vec4(
                getW(wR, wC, d1, d2),
                getW(wR, wC, d1 + 1, d2),
                getW(wR, wC, d1 + 2, d2),
                getW(wR, wC, d1 + 3, d2)
              );

              if (${isChannelsLast}) {
                vec4 xValues = vec4(
                  getX(batch, xR, xC, d1),
                  getX(batch, xR, xC, d1 + 1),
                  getX(batch, xR, xC, d1 + 2),
                  getX(batch, xR, xC, d1 + 3)
                );
                dotProd += dot(xValues, wValues);
              } else {
                vec4 xValues = vec4(
                  getX(batch, d1, xR, xC),
                  getX(batch, d1 + 1, xR, xC),
                  getX(batch, d1 + 2, xR, xC),
                  getX(batch, d1 + 3, xR, xC)
                );
                dotProd += dot(xValues, wValues);
              }
            }

            if (${inputDepthVec4Remainder === 1}) {

              if (${isChannelsLast}) {
                dotProd +=
                    getX(batch, xR, xC, ${inputDepthNearestVec4}) *
                    getW(wR, wC, ${inputDepthNearestVec4}, d2);
              } else {
                dotProd +=
                    getX(batch, ${inputDepthNearestVec4}, xR, xC) *
                    getW(wR, wC, ${inputDepthNearestVec4}, d2);
              }

            } else if (${inputDepthVec4Remainder === 2}) {
              vec2 wValues = vec2(
                getW(wR, wC, ${inputDepthNearestVec4}, d2),
                getW(wR, wC, ${inputDepthNearestVec4} + 1, d2)
              );

              if (${isChannelsLast}) {
                vec2 xValues = vec2(
                  getX(batch, xR, xC, ${inputDepthNearestVec4}),
                  getX(batch, xR, xC, ${inputDepthNearestVec4} + 1)
                );
                dotProd += dot(xValues, wValues);
              } else {
                vec2 xValues = vec2(
                  getX(batch, ${inputDepthNearestVec4}, xR, xC),
                  getX(batch, ${inputDepthNearestVec4} + 1, xR, xC)
                );
                dotProd += dot(xValues, wValues);
              }

            } else if (${inputDepthVec4Remainder === 3}) {
              vec3 wValues = vec3(
                getW(wR, wC, ${inputDepthNearestVec4}, d2),
                getW(wR, wC, ${inputDepthNearestVec4} + 1, d2),
                getW(wR, wC, ${inputDepthNearestVec4} + 2, d2)
              );

              if (${isChannelsLast}) {
                vec3 xValues = vec3(
                  getX(batch, xR, xC, ${inputDepthNearestVec4}),
                  getX(batch, xR, xC, ${inputDepthNearestVec4} + 1),
                  getX(batch, xR, xC, ${inputDepthNearestVec4} + 2)
                );
                dotProd += dot(xValues, wValues);
              } else {
                vec3 xValues = vec3(
                  getX(batch, ${inputDepthNearestVec4}, xR, xC),
                  getX(batch, ${inputDepthNearestVec4} + 1, xR, xC),
                  getX(batch, ${inputDepthNearestVec4} + 2, xR, xC)
                );
                dotProd += dot(xValues, wValues);
              }

            }
          }
        }

        float result = dotProd;
        ${addBiasSnippet}
        ${applyActivationSnippet}
        setOutput(result);
      }
    `;
    }
}
class $65122774589fac9b$export$67aff94cf1ececaf {
    constructor(convInfo){
        this.variableNames = [
            'x',
            'W'
        ];
        this.outputShape = convInfo.outShape;
        const padFront = convInfo.padInfo.front;
        const padTop = convInfo.padInfo.top;
        const padLeft = convInfo.padInfo.left;
        const strideDepth = convInfo.strideDepth;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const dilationDepth = convInfo.dilationDepth;
        const dilationHeight = convInfo.dilationHeight;
        const dilationWidth = convInfo.dilationWidth;
        const filterDepth = convInfo.filterDepth;
        const filterHeight = convInfo.filterHeight;
        const filterWidth = convInfo.filterWidth;
        const inputDepthNearestVec4 = Math.floor(convInfo.inChannels / 4) * 4;
        const inputDepthVec4Remainder = convInfo.inChannels % 4;
        this.userCode = `
      const ivec3 strides = ivec3(${strideDepth}, ${strideHeight}, ${strideWidth});
      const ivec3 pads = ivec3(${padFront}, ${padTop}, ${padLeft});

      void main() {
        ivec5 coords = getOutputCoords();
        int batch = coords.x;
        int d2 = coords.u;

        ivec3 xFRCCorner = ivec3(coords.y, coords.z, coords.w) * strides - pads;
        int xFCorner = xFRCCorner.x;
        int xRCorner = xFRCCorner.y;
        int xCCorner = xFRCCorner.z;

        // Convolve x(?, ?, ?, d1) with w(:, :, :, d1, d2) to get
        // y(yF, yR, yC, d2). ? = to be determined. : = across all
        // values in that axis.
        float dotProd = 0.0;
        for (int wF = 0; wF < ${filterDepth}; wF++) {
          int xF = xFCorner + wF * ${dilationDepth};

          if (xF < 0 || xF >= ${convInfo.inDepth}) {
            continue;
          }

          for (int wR = 0; wR < ${filterHeight}; wR++) {
            int xR = xRCorner + wR * ${dilationHeight};

            if (xR < 0 || xR >= ${convInfo.inHeight}) {
              continue;
            }

            for (int wC = 0; wC < ${filterWidth}; wC++) {
              int xC = xCCorner + wC * ${dilationWidth};

              if (xC < 0 || xC >= ${convInfo.inWidth}) {
                continue;
              }

              for (int d1 = 0; d1 < ${inputDepthNearestVec4}; d1 += 4) {
                vec4 xValues = vec4(
                  getX(batch, xF, xR, xC, d1),
                  getX(batch, xF, xR, xC, d1 + 1),
                  getX(batch, xF, xR, xC, d1 + 2),
                  getX(batch, xF, xR, xC, d1 + 3)
                );
                vec4 wValues = vec4(
                  getW(wF, wR, wC, d1, d2),
                  getW(wF, wR, wC, d1 + 1, d2),
                  getW(wF, wR, wC, d1 + 2, d2),
                  getW(wF, wR, wC, d1 + 3, d2)
                );

                dotProd += dot(xValues, wValues);
              }

              if (${inputDepthVec4Remainder === 1}) {
                dotProd +=
                  getX(batch, xF, xR, xC, ${inputDepthNearestVec4}) *
                  getW(wF, wR, wC, ${inputDepthNearestVec4}, d2);
              } else if (${inputDepthVec4Remainder === 2}) {
                vec2 xValues = vec2(
                  getX(batch, xF, xR, xC, ${inputDepthNearestVec4}),
                  getX(batch, xF, xR, xC, ${inputDepthNearestVec4} + 1)
                );
                vec2 wValues = vec2(
                  getW(wF, wR, wC, ${inputDepthNearestVec4}, d2),
                  getW(wF, wR, wC, ${inputDepthNearestVec4} + 1, d2)
                );
                dotProd += dot(xValues, wValues);
              } else if (${inputDepthVec4Remainder === 3}) {
                vec3 xValues = vec3(
                  getX(batch, xF, xR, xC, ${inputDepthNearestVec4}),
                  getX(batch, xF, xR, xC, ${inputDepthNearestVec4} + 1),
                  getX(batch, xF, xR, xC, ${inputDepthNearestVec4} + 2)
                );
                vec3 wValues = vec3(
                  getW(wF, wR, wC, ${inputDepthNearestVec4}, d2),
                  getW(wF, wR, wC, ${inputDepthNearestVec4} + 1, d2),
                  getW(wF, wR, wC, ${inputDepthNearestVec4} + 2, d2)
                );
                dotProd += dot(xValues, wValues);
              }
            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

class $c9e97af83bddceba$export$20f35e9a79361289 {
    constructor(convInfo, addBias = false, activation = null, hasPreluActivation = false, hasLeakyReluAlpha = false){
        this.variableNames = [
            'x',
            'W'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.customUniforms = [
            {
                name: 'pads',
                type: 'ivec2'
            },
            {
                name: 'strides',
                type: 'ivec2'
            },
            {
                name: 'dilations',
                type: 'ivec2'
            },
            {
                name: 'inDims',
                type: 'ivec2'
            }
        ];
        this.outputShape = convInfo.outShape;
        this.enableShapeUniforms = (0, $8c928040c80f573b$export$5acc770fc06a0138)(this.outputShape.length);
        const padLeft = convInfo.padInfo.left;
        const strideWidth = convInfo.strideWidth;
        const dilationWidth = convInfo.dilationWidth;
        const filterHeight = convInfo.filterHeight;
        const filterWidth = convInfo.filterWidth;
        const texelsAcross = filterWidth;
        let mainLoop = `
       int xR; int xC; int xCOffset;
       vec4 wTexel; vec4 previous; vec4 final;`;
        for(let c = 0; c < filterWidth; c++)mainLoop += `
           vec4 xTexelC${c * 2};
           int xTexelC${c * 2}Ready;
           vec4 xTexelC${c * 2 + 1};
           int xTexelC${c * 2 + 1}Ready;
           vec4 xC${c};`;
        /**
         * This vectorized implementation works by gathering the values needed for
         * each output channel's dot product into vec4's and then multiplying them
         * all together (this happens in the final double for-loop below). Most of
         * the main loop consists of constructing these vec4's with the minimum
         * number of texture2D calls, which means making use of all four returned
         * values from a texture2D call at once.
         */ mainLoop += `
     for (int r = 0; r < ${filterHeight}; r++) {
      for (int d1 = 0; d1 < ${convInfo.inChannels}; d1 += 2) {
       `;
        for(let c = 0; c < filterWidth; c++)mainLoop += `
           xTexelC${c * 2} = vec4(0.0);
           xTexelC${c * 2}Ready = 0;
           xTexelC${c * 2 + 1} = vec4(0.0);
           xTexelC${c * 2 + 1}Ready = 0;
           xC${c} = vec4(0.0);`;
        mainLoop += `
         xR = xRCorner + r * dilations[0];
         if (xR >=0 && xR < inDims[0]) {
       `;
        for(let texelC = 0; texelC < (texelsAcross + 1) / 2; texelC++){
            const colIndex = texelC * 2;
            mainLoop += `
           xC = xCCorner + ${colIndex * dilationWidth};
           `;
            if (strideWidth === 1) {
                if (colIndex < filterWidth) {
                    // If padding is odd, the outer texels have to be composed.
                    if (padLeft % 2 === 1) {
                        // TODO: Ensure vec4 previous does not result in redundant sample,
                        // and avoid setting xTexelRC's that exceed the boundary in the
                        // first place rather than resetting them to vec4(0)).
                        // To compute xCOffset:
                        // - If padding is odd, we must add 1 to ensure we ask for an
                        // even-numbered row.
                        // - We subtract 2 to access the previous texel.
                        mainLoop += `
                 xCOffset = xC + 1;
                 if (xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex}Ready == 0) {
                   xTexelC${colIndex} = getX(batch, xR, xCOffset, d1);

                   // Need to manually clear unused channels in case
                   // we're reading from recycled texture.
                   if (xCOffset + 1 >= inDims[1]) {
                     xTexelC${colIndex}.zw = vec2(0.0);
                   }
                   xTexelC${colIndex}Ready = 1;
                 }
               `;
                        // This texel has been read in previous iteration if the dilation
                        // is 1.
                        if (dilationWidth === 1 && colIndex > 0) mainLoop += `
                 xC${colIndex} = vec4(xTexelC${colIndex - 2}.zw, xTexelC${colIndex}.xy);
                 `;
                        else mainLoop += `
                   xCOffset = xC + 1 - 2;

                   if (xCOffset >= 0 && xCOffset < inDims[1]) {
                     previous = getX(batch, xR, xCOffset, d1);

                     // Need to manually clear unused channels in case
                     // we're reading from recycled texture.
                     if (xCOffset + 1 >= inDims[1]) {
                       previous.zw = vec2(0.0);
                     }

                     xC${colIndex} = vec4(previous.zw, xTexelC${colIndex}.xy);
                   } else {
                     xC${colIndex} = vec4(0.0, 0.0, xTexelC${colIndex}.xy);
                   }
                   `;
                    } else // Padding is even, so xRC corresponds to a single texel.
                    mainLoop += `
                 if (xC >= 0 && xC < inDims[1] && xTexelC${colIndex}Ready == 0) {
                   xTexelC${colIndex} = getX(batch, xR, xC, d1);
                   if (xC + 1 >= inDims[1]) {
                     xTexelC${colIndex}.zw = vec2(0.0);
                   }
                   xTexelC${colIndex}Ready = 1;
                 }

                 xC${colIndex} = xTexelC${colIndex};
                 `;
                    if (colIndex + 1 < filterWidth) {
                        // If dilation is even, the second entry should match the first
                        // (either both are composed or both are single samples). But if
                        // dilation is odd, then the second entry should be the opposite
                        // of the first (if the first is composed, the second is a single
                        // sample, and vice versa.)
                        const nextTexelOffset = padLeft % 2 === 0 ? (0, $i64bB.util).nearestLargerEven(dilationWidth) : dilationWidth;
                        if (dilationWidth % 2 === 0 && padLeft % 2 === 1 || dilationWidth % 2 !== 0 && padLeft % 2 !== 1) {
                            mainLoop += `
                   xCOffset = xC + imod(pads[1], 2) + ${nextTexelOffset};

                   if (xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex + 1}Ready == 0) {
                     xTexelC${colIndex + 1} = getX(batch, xR, xCOffset, d1);

                     // Need to manually clear unused channels in case
                     // we're reading from recycled texture.
                     if (xCOffset + 1 >= inDims[1]) {
                       xTexelC${colIndex + 1}.zw = vec2(0.0);
                     }
                     xTexelC${colIndex + 1}Ready = 1;
                   }
                   `;
                            // If dilation > 1 then the xRC's will not be able to share any
                            // values, so each xRC will require two unique calls to getX.
                            if (dilationWidth > 1) mainLoop += `
                     xCOffset -= 2;
                     if (xCOffset >= 0 && xCOffset < inDims[1]) {
                      previous = getX(batch, xR, xCOffset, d1);
                      xC${colIndex + 1} = vec4(previous.zw, xTexelC${colIndex + 1}.xy);
                     } else {
                      xC${colIndex + 1} = vec4(0.0, 0.0, xTexelC${colIndex + 1}.xy);
                     }
                     `;
                            else mainLoop += `
                     xC${colIndex + 1} = vec4(xTexelC${colIndex}.zw, xTexelC${colIndex + 1}.xy);
                     `;
                        } else // If dilation is 1 and padding is odd, we have already read the
                        // texel when constructing the previous x value. Here we can
                        // simply skip the texture read.
                        if (nextTexelOffset === 1) mainLoop += `
                     xC${colIndex + 1} = xTexelC${colIndex};
                     `;
                        else mainLoop += `
                     xCOffset = xC + ${nextTexelOffset};

                     if (xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex + 1}Ready == 0) {
                       xTexelC${colIndex + 1} = getX(batch, xR, xCOffset, d1);
                       if (xCOffset + 1 >= inDims[1]) {
                         xTexelC${colIndex + 1}.zw = vec2(0.0);
                       }
                       xTexelC${colIndex + 1}Ready = 1;
                     }

                     xC${colIndex + 1} = xTexelC${colIndex + 1};
                     `;
                    }
                }
            } else if (colIndex < filterWidth) {
                // Depending on whether padLeft is even or odd, we want either the
                // xy or zw channels from X texels for xC${colIndex}. If padLeft is
                // even, xC${colIndex +1} is simply the zw channels of texels we've
                // already sampled. But if padLeft is odd, xC{$c + 1}.zw will
                // need to come from the xy channels of a new texel, hence the `
                // vec4
                // final` initialized below.
                if (padLeft % 2 === 1) {
                    mainLoop += `
                 xCOffset = xC + 1 - strides[1];
                 if(xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex}Ready == 0) {
                   xTexelC${colIndex} = getX(batch, xR, xCOffset, d1);
                   // Need to manually clear unused channels in case
                   // we're reading from recycled texture.
                   if (xCOffset + 1 >= inDims[1]) {
                     xTexelC${colIndex}.zw = vec2(0.0);
                   }
                   xTexelC${colIndex}Ready = 1;
                 }

                 if(xC + 1 >= 0 && xC + 1 < inDims[1] && xTexelC${colIndex + 1}Ready == 0) {
                   xTexelC${colIndex + 1} = getX(batch, xR, xC + 1, d1);
                   // Need to manually clear unused channels in case
                   // we're reading from recycled texture.
                   if (xC + 2 >= inDims[1]) {
                     xTexelC${colIndex + 1}.zw = vec2(0.0);
                   }
                   xTexelC${colIndex + 1}Ready = 1;
                 }

                 xC${colIndex} = vec4(xTexelC${colIndex}.zw, xTexelC${colIndex + 1}.zw);
               `;
                    if (colIndex + 1 < filterWidth) mainLoop += `
                   final = vec4(0.0);
                   xCOffset = xC + 1 + strides[1];
                   if(xCOffset >= 0 && xCOffset < inDims[1]) {
                     final = getX(batch, xR, xCOffset, d1);
                   }
                   xC${colIndex + 1} = vec4(xTexelC${colIndex + 1}.xy, final.xy);
                 `;
                } else {
                    mainLoop += `
                 if(xC >= 0 && xC < inDims[1] && xTexelC${colIndex}Ready == 0) {
                   xTexelC${colIndex} = getX(batch, xR, xC, d1);
                   if (xC + 1 >= inDims[1]) {
                     xTexelC${colIndex}.zw = vec2(0.0);
                   }
                   xTexelC${colIndex}Ready = 1;
                 }

                 xCOffset = xC + strides[1];
                 if(xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex + 1}Ready == 0) {
                   xTexelC${colIndex + 1} = getX(batch, xR, xCOffset, d1);
                   if (xCOffset + 1 >= inDims[1]) {
                     xTexelC${colIndex + 1}.zw = vec2(0.);
                   }
                   xTexelC${colIndex + 1}Ready = 1;
                 }

                 xC${colIndex} = vec4(
                   xTexelC${colIndex}.xy, xTexelC${colIndex + 1}.xy);
               `;
                    if (colIndex + 1 < filterWidth) mainLoop += `
                   xC${colIndex + 1} = vec4(xTexelC${colIndex}.zw, xTexelC${colIndex + 1}.zw);
                 `;
                }
            }
            // localize the dotProd accumulation within the loop, the theory is for
            // GPU with limited cache, accumulate sum across large amount of
            // veriables will cause lots of cache misses. (i.e. 5x5 filter will have
            // 50 variables)
            if (colIndex < filterWidth) {
                mainLoop += `
             wTexel = getW(r, ${colIndex}, d1, d2);
             dotProd += xC${colIndex}.xxzz * vec4(wTexel.xy, wTexel.xy);
             if(d1 + 1 < ${convInfo.inChannels}) {
               dotProd += xC${colIndex}.yyww * vec4(wTexel.zw, wTexel.zw);
             }
           `;
                if (colIndex + 1 < filterWidth) mainLoop += `
               wTexel = getW(r, ${colIndex + 1}, d1, d2);
               dotProd += xC${colIndex + 1}.xxzz * vec4(wTexel.xy, wTexel.xy);
               if(d1 + 1 < ${convInfo.inChannels}) {
                 dotProd += xC${colIndex + 1}.yyww * vec4(wTexel.zw, wTexel.zw);
               }
             `;
            }
        }
        mainLoop += `
     }
   `;
        mainLoop += `
     }
   `;
        mainLoop += `
     }
   `;
        let activationSnippet = '', applyActivationSnippet = '';
        if (activation) {
            if (hasPreluActivation) activationSnippet = `vec4 activation(vec4 a) {
           vec4 b = getPreluActivationWeightsAtOutCoords();
           ${activation}
         }`;
            else if (hasLeakyReluAlpha) activationSnippet = `vec4 activation(vec4 a) {
           vec4 b = getLeakyreluAlphaAtOutCoords();
           ${activation}
         }`;
            else activationSnippet = `vec4 activation(vec4 x) {
           ${activation}
         }`;
            applyActivationSnippet = `result = activation(result);`;
        }
        const addBiasSnippet = addBias ? 'result += getBiasAtOutCoords();' : '';
        if (addBias) this.variableNames.push('bias');
        if (hasPreluActivation) this.variableNames.push('preluActivationWeights');
        if (hasLeakyReluAlpha) this.variableNames.push('leakyreluAlpha');
        this.userCode = `
       ${activationSnippet}

       void main() {
         ivec4 coords = getOutputCoords();
         int batch = coords.x;
         ivec2 xRCCorner = coords.yz * strides - pads;
         int d2 = coords.w;
         int xRCorner = xRCCorner.x;
         int xCCorner = xRCCorner.y;

         //intialize dotProd with a small epsilon seems to reduce GPU accuracy loss.
         vec4 dotProd = vec4(0.000000000000001);

         ${mainLoop}

         vec4 result = dotProd - vec4(0.000000000000001);
         ${addBiasSnippet}
         ${applyActivationSnippet}
         setOutput(result);
       }
     `;
    }
}


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $fb8142274d36f923$export$d76a638e68b7f211 {
    constructor(outputShape, convInfo){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.customUniforms = [
            {
                name: 'inputShape',
                type: 'ivec4'
            },
            {
                name: 'pad',
                type: 'ivec2'
            },
            {
                name: 'stride',
                type: 'ivec2'
            },
            {
                name: 'dilation',
                type: 'ivec2'
            },
            {
                name: 'inChannels',
                type: 'int'
            },
            {
                name: 'itemsPerBlockRow',
                type: 'int'
            },
            {
                name: 'outWidth',
                type: 'int'
            }
        ];
        this.outputShape = outputShape;
        this.enableShapeUniforms = (0, $8c928040c80f573b$export$5acc770fc06a0138)(this.outputShape.length);
        const { dataFormat: dataFormat } = convInfo;
        const glsl = (0, $29bc34f3341b4730$export$3ebf4a18d6319f7a)();
        const isChannelsLast = dataFormat === 'channelsLast';
        const rowDim = isChannelsLast ? 1 : 2;
        const colDim = isChannelsLast ? 2 : 3;
        const boundsCheckingSnippet = this.enableShapeUniforms ? 'if(blockIndex < outShape[2] && pos < outShape[1]) {' : `if(blockIndex < ${outputShape[2]} && pos < ${outputShape[1]}) {`;
        let unrolled = ``;
        for(let row = 0; row <= 1; row++)for(let col = 0; col <= 1; col++)unrolled += `
          blockIndex = rc.z + ${col};
          pos = rc.y + ${row};

          ${boundsCheckingSnippet}
            offsetY = int(blockIndex / outWidth) * stride[0] - pad[0];
            d0 = offsetY + dilation[0] * (pos / itemsPerBlockRow);

            if(d0 < inputShape[${rowDim}] && d0 >= 0) {
              // Use custom imod instead mod. On Intel GPU, mod may generate
              // unexpected value.
              // https://github.com/tensorflow/tfjs/issues/5447
              offsetX = imod(blockIndex, outWidth) * stride[1] - pad[1];
              d1 = offsetX + dilation[1] * (imod(pos, itemsPerBlockRow) /
                  inChannels);

              if(d1 < inputShape[${colDim}] && d1 >= 0) {

                ch = imod(pos, inChannels);

                if (${isChannelsLast}) {
                  innerDims = vec2(d1, ch);
                  result[${row * 2 + col}] = getChannel(
                    getA(rc.x, d0, int(innerDims.x),
                    int(innerDims.y)), innerDims);
                } else {
                  innerDims = vec2(d0, d1);
                  result[${row * 2 + col}] = getChannel(
                    getA(rc.x, ch, int(innerDims.x),
                    int(innerDims.y)), innerDims);
                }
              }
            }
          }
        `;
        this.userCode = `
      void main() {
        ivec3 rc = getOutputCoords();

        vec4 result = vec4(0);

        int blockIndex, pos, offsetY, d0, offsetX, d1, ch;
        vec2 innerDims;

        ${unrolled}

        ${glsl.output} = result;
      }
    `;
    }
}








// Both conv2dByMatMul and conv2dWithIm2Row fuse height and width into one
// dimension to compute batchMatMul, so bias and activation weights are also
// supposed to fuse the two dimensions into one.
//
// This function computes the target shape for fusing height and width
// dimensions. Returning null means the shape is already compatible.
//
// Even though the bias is not supposed to be a 3-D or a 4-D (including
// batch) tensor and PReLU activiation weights is not supposed to be a 4-D
// tensor, we still need to support them, because we haven't disabled
// them for NHWC format.
// https://github.com/tensorflow/tfjs/blob/b53bd47e880367ae57493f0ea628abaf08db2d5d/tfjs-core/src/ops/fused/conv2d.ts#L181-L196
function $85dc903272166754$var$getShapeForBatchMatMul(shape, isChannelsLast) {
    const length = shape.length;
    if (length >= 3) return isChannelsLast ? [
        ...shape.slice(0, -3),
        shape[length - 3] * shape[length - 2],
        shape[length - 1]
    ] : [
        ...shape.slice(0, -3),
        shape[length - 3],
        shape[length - 2] * shape[length - 1]
    ];
    else if (!isChannelsLast && length === 1 && shape[0] > 1) return [
        shape[0],
        1
    ];
    else return null;
}
function $85dc903272166754$export$fe56ce0f8b4bfd45({ x: x, filter: filter, convInfo: convInfo, backend: backend, bias: bias = null, preluActivationWeights: preluActivationWeights = null, leakyreluAlpha: leakyreluAlpha = 0, activation: activation = null }) {
    // Reshapes conv2D input to 2D tensors, uses matMul and then reshape the
    // result from 2D to 4D.
    const xShape = x.shape;
    const xTexData = backend.texData.get(x.dataId);
    const sharedMatMulDim = convInfo.inChannels;
    const outerShapeX = xShape[0] * xShape[1] * xShape[2];
    const outerShapeFilter = convInfo.outChannels;
    const isChannelsLast = convInfo.dataFormat === 'channelsLast';
    const transposeA = false;
    const transposeB = false;
    let out;
    const intermediates = [];
    if (preluActivationWeights != null) {
        const targetShape = $85dc903272166754$var$getShapeForBatchMatMul(preluActivationWeights.shape, isChannelsLast);
        if (targetShape != null) {
            preluActivationWeights = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
                inputs: {
                    x: preluActivationWeights
                },
                backend: backend,
                attrs: {
                    shape: targetShape
                }
            });
            intermediates.push(preluActivationWeights);
        }
    }
    if (bias != null) {
        const targetShape = $85dc903272166754$var$getShapeForBatchMatMul(bias.shape, isChannelsLast);
        if (targetShape != null) {
            bias = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
                inputs: {
                    x: bias
                },
                backend: backend,
                attrs: {
                    shape: targetShape
                }
            });
            intermediates.push(bias);
        }
    }
    // TODO: Once reduction ops are packed, batchMatMul will always be packed
    // and we can remove this condition.
    const batchMatMulWillBeUnpacked = (outerShapeX === 1 || outerShapeFilter === 1) && sharedMatMulDim > (0, $400586318c9d65f3$export$42c1ddb439199e73);
    // The algorithm in the if condition assumes (1) the output will be packed,
    // (2) x is packed, (3) x isChannelsLast, (4)  x's packed texture is already
    // on GPU, (5) col is odd, (6) the width, height and inChannels are the same
    // for xTexData.shape and xShape.
    const canOptimize = !batchMatMulWillBeUnpacked && xTexData.isPacked && isChannelsLast && xTexData.texture != null && xShape[2] % 2 !== 0 && (0, $i64bB.util).arraysEqual(xTexData.shape.slice(-3), xShape.slice(-3));
    if (canOptimize) {
        // We avoid expensive packed 2x2 reshape by padding col count to next,
        // even number. When col is odd, the result of packed batchMatMul is
        // the same (has the same texture layout and and values in the texture) as
        // it is for next even col. We make the odd-cols tensor to look like
        // even-cols tensor before the operation and, after the batchMatMul,
        // fix the even-cols result to have odd number of cols.
        const targetShape = xShape[0] * xShape[1] * (xShape[2] + 1);
        const xReshaped = {
            dataId: x.dataId,
            shape: [
                1,
                targetShape,
                convInfo.inChannels
            ],
            dtype: x.dtype
        };
        // xTexData.shape gets referenced from GPGPUBinary.inShapeInfos.
        // Decrementing col count, after batchMatMul->...->compileProgram leads to
        // invalid col count within the reference in GPGPUBinary.inShapeInfos.
        // Alternative fix would be to provide a copy to GPGPUBinary.inShapeInfos
        // in compileProgram method, but that would affect compilation of all
        // programs - instead, provide a copy here, with even col count, before
        // calling batchMatMul->...->compileProgram and after that, the original
        // xTexData.shape is restored.
        const originalXTexDataShape = xTexData.shape;
        xTexData.shape = xTexData.shape.slice();
        xTexData.shape[xTexData.shape.length - 2]++;
        (0, $i64bB.util).assert($03fc80a4a4cef09e$export$951b388203a0422d(xTexData.shape, xReshaped.shape), ()=>`packed reshape ${xTexData.shape} to ${xReshaped.shape} isn't free`);
        const filterReshaped = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
            inputs: {
                x: filter
            },
            backend: backend,
            attrs: {
                shape: [
                    1,
                    convInfo.inChannels,
                    convInfo.outChannels
                ]
            }
        });
        intermediates.push(filterReshaped);
        const pointwiseConv = (0, $400586318c9d65f3$export$d524d65e88e1168b)({
            a: xReshaped,
            b: filterReshaped,
            backend: backend,
            transposeA: transposeA,
            transposeB: transposeB,
            bias: bias,
            activation: activation,
            preluActivationWeights: preluActivationWeights,
            leakyreluAlpha: leakyreluAlpha
        });
        const pointwiseConvTexData = backend.texData.get(pointwiseConv.dataId);
        (0, $i64bB.util).assert(pointwiseConvTexData.isPacked, ()=>'batchMatMul result is expected to be packed');
        // Restore the input shape to original.
        xTexData.shape = originalXTexDataShape;
        // Set the output shape - there is no need for expensive reshape as data
        // layout is already correct.
        pointwiseConvTexData.shape = convInfo.outShape;
        out = (0, $2b13f312c76ad9c3$export$f0954fd7d5368655)({
            inputs: {
                x: pointwiseConv
            },
            backend: backend
        });
        out.shape = convInfo.outShape;
        intermediates.push(pointwiseConv);
    } else {
        const numCols = convInfo.outHeight * convInfo.outWidth;
        const xReshaped = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                shape: isChannelsLast ? [
                    convInfo.batchSize,
                    numCols,
                    convInfo.inChannels
                ] : [
                    convInfo.batchSize,
                    convInfo.inChannels,
                    numCols
                ]
            }
        });
        const filterReshaped = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
            inputs: {
                x: filter
            },
            backend: backend,
            attrs: {
                shape: [
                    1,
                    convInfo.inChannels,
                    convInfo.outChannels
                ]
            }
        });
        const result = (0, $400586318c9d65f3$export$d524d65e88e1168b)({
            a: isChannelsLast ? xReshaped : filterReshaped,
            b: isChannelsLast ? filterReshaped : xReshaped,
            transposeA: !isChannelsLast,
            transposeB: transposeB,
            backend: backend,
            bias: bias,
            activation: activation,
            preluActivationWeights: preluActivationWeights,
            leakyreluAlpha: leakyreluAlpha
        });
        out = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
            inputs: {
                x: result
            },
            backend: backend,
            attrs: {
                shape: convInfo.outShape
            }
        });
        intermediates.push(xReshaped);
        intermediates.push(filterReshaped);
        intermediates.push(result);
    }
    for (const i of intermediates)backend.disposeIntermediateTensorInfo(i);
    return out;
}
function $85dc903272166754$export$65b699e5c77381b8({ x: x, filter: filter, convInfo: convInfo, backend: backend, bias: bias = null, preluActivationWeights: preluActivationWeights = null, leakyreluAlpha: leakyreluAlpha = 0, activation: activation = null }) {
    // Rearranges conv2d input so each block to be convolved over forms the
    // column of a new matrix with shape [filterWidth * filterHeight *
    // inChannels, outHeight * outWidth]. The filter is also rearranged so each
    // output channel forms a row of a new matrix with shape [outChannels,
    // filterWidth * filterHeight * inChannels]. The convolution is then
    // computed by multiplying these matrices and reshaping the result.
    const { filterWidth: filterWidth, filterHeight: filterHeight, inChannels: inChannels, outWidth: outWidth, outHeight: outHeight, dataFormat: dataFormat } = convInfo;
    const isChannelsLast = dataFormat === 'channelsLast';
    const sharedDim = filterWidth * filterHeight * inChannels;
    const numCols = outHeight * outWidth;
    const x2ColShape = [
        convInfo.batchSize,
        sharedDim,
        numCols
    ];
    const transposeA = true;
    const transposeB = false;
    const intermediates = [];
    if (preluActivationWeights != null) {
        const targetShape = $85dc903272166754$var$getShapeForBatchMatMul(preluActivationWeights.shape, isChannelsLast);
        if (targetShape != null) {
            preluActivationWeights = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
                inputs: {
                    x: preluActivationWeights
                },
                backend: backend,
                attrs: {
                    shape: targetShape
                }
            });
            intermediates.push(preluActivationWeights);
        }
    }
    if (bias != null) {
        const targetShape = $85dc903272166754$var$getShapeForBatchMatMul(bias.shape, isChannelsLast);
        if (targetShape != null) {
            bias = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
                inputs: {
                    x: bias
                },
                backend: backend,
                attrs: {
                    shape: targetShape
                }
            });
            intermediates.push(bias);
        }
    }
    const w2Row = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: filter
        },
        backend: backend,
        attrs: {
            shape: [
                1,
                sharedDim,
                (0, $i64bB.util).sizeFromShape(filter.shape) / sharedDim
            ]
        }
    });
    intermediates.push(w2Row);
    const im2ColProgram = new (0, $fb8142274d36f923$export$d76a638e68b7f211)(x2ColShape, convInfo);
    const customValues = [
        x.shape,
        [
            convInfo.padInfo.top,
            convInfo.padInfo.left
        ],
        [
            convInfo.strideHeight,
            convInfo.strideWidth
        ],
        [
            convInfo.dilationHeight,
            convInfo.dilationWidth
        ],
        [
            convInfo.inChannels
        ],
        [
            convInfo.filterWidth * convInfo.inChannels
        ],
        [
            convInfo.outWidth
        ]
    ];
    const im2Col = backend.runWebGLProgram(im2ColProgram, [
        x
    ], 'float32', customValues);
    const im2ColReshaped = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: im2Col
        },
        backend: backend,
        attrs: {
            shape: x2ColShape
        }
    });
    intermediates.push(im2Col);
    intermediates.push(im2ColReshaped);
    const hasBias = bias != null;
    const hasPreluActivationWeights = preluActivationWeights != null;
    const hasLeakyreluAlpha = activation === 'leakyrelu';
    const fusedActivation = activation ? (0, $2e65282075da2b30$export$445d43a4039ec7b7)(activation, true) : null;
    const matmulProgram = new (0, $d5205fbded8933ee$export$21e5f112101779d8)(isChannelsLast ? im2ColReshaped.shape : w2Row.shape, isChannelsLast ? w2Row.shape : im2ColReshaped.shape, isChannelsLast ? [
        convInfo.batchSize,
        numCols,
        convInfo.outChannels
    ] : [
        convInfo.batchSize,
        convInfo.outChannels,
        numCols
    ], transposeA, transposeB, hasBias, fusedActivation, hasPreluActivationWeights, hasLeakyreluAlpha);
    const inputs = isChannelsLast ? [
        im2ColReshaped,
        w2Row
    ] : [
        w2Row,
        im2ColReshaped
    ];
    if (bias) inputs.push(bias);
    if (hasPreluActivationWeights) inputs.push(preluActivationWeights);
    if (hasLeakyreluAlpha) {
        const $leakyreluAlpha = backend.makeTensorInfo([], 'float32', (0, $i64bB.util).createScalarValue(leakyreluAlpha, 'float32'));
        inputs.push($leakyreluAlpha);
        intermediates.push($leakyreluAlpha);
    }
    const product = backend.runWebGLProgram(matmulProgram, inputs, 'float32');
    const out = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: product
        },
        backend: backend,
        attrs: {
            shape: convInfo.outShape
        }
    });
    intermediates.push(product);
    for (const i of intermediates)backend.disposeIntermediateTensorInfo(i);
    return out;
}



function $99d9bdf968f11961$export$188f9215482e3db8(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter } = inputs;
    const { strides: strides, pad: pad, dataFormat: dataFormat, dilations: dilations, dimRoundingMode: dimRoundingMode } = attrs;
    const $dataFormat = (0, $i64bB.backend_util).convertConv2DDataFormat(dataFormat);
    const convInfo = (0, $i64bB.backend_util).computeConv2DInfo(x.shape, filter.shape, strides, dilations, pad, dimRoundingMode, false, $dataFormat);
    let out;
    if (convInfo.filterHeight === 1 && convInfo.filterWidth === 1 && convInfo.dilationHeight === 1 && convInfo.dilationWidth === 1 && convInfo.strideHeight === 1 && convInfo.strideWidth === 1 && (convInfo.padInfo.type === 'SAME' || convInfo.padInfo.type === 'VALID')) out = (0, $85dc903272166754$export$fe56ce0f8b4bfd45)({
        x: x,
        filter: filter,
        convInfo: convInfo,
        backend: backend
    });
    else if (convInfo.strideWidth <= 2 && $dataFormat === 'channelsLast' && (0, $i64bB.env)().getBool('WEBGL_EXP_CONV')) {
        const program = new (0, $c9e97af83bddceba$export$20f35e9a79361289)(convInfo);
        const customValues = [
            [
                convInfo.padInfo.top,
                convInfo.padInfo.left
            ],
            [
                convInfo.strideHeight,
                convInfo.strideWidth
            ],
            [
                convInfo.dilationHeight,
                convInfo.dilationWidth
            ],
            [
                convInfo.inHeight,
                convInfo.inWidth
            ]
        ];
        out = backend.runWebGLProgram(program, [
            x,
            filter
        ], 'float32', customValues);
    } else if ((0, $i64bB.env)().getBool('WEBGL_CONV_IM2COL')) out = (0, $85dc903272166754$export$65b699e5c77381b8)({
        x: x,
        filter: filter,
        convInfo: convInfo,
        backend: backend
    });
    else {
        const program = new (0, $65122774589fac9b$export$8dc36706147178e9)(convInfo);
        out = backend.runWebGLProgram(program, [
            x,
            filter
        ], 'float32');
    }
    const outReshaped = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: out
        },
        backend: backend,
        attrs: {
            shape: convInfo.outShape
        }
    });
    backend.disposeIntermediateTensorInfo(out);
    return outReshaped;
}
const $99d9bdf968f11961$export$4a39bf13b4378042 = {
    kernelName: (0, $i64bB.Conv2D),
    backendName: 'webgl',
    kernelFunc: $99d9bdf968f11961$export$188f9215482e3db8
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $9b4973ea46141bc5$export$1223560f67be2f2d {
    constructor(convInfo){
        this.variableNames = [
            'x',
            'dy'
        ];
        this.outputShape = convInfo.filterShape;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const padTop = convInfo.padInfo.top;
        const padLeft = convInfo.padInfo.left;
        const isChannelsLast = convInfo.dataFormat === 'channelsLast';
        this.userCode = `
      void main() {
        ivec4 coords = getOutputCoords();
        int wR = coords.x;
        int wC = coords.y;
        int d1 = coords.z;
        int d2 = coords.w;

        // Convolve x(?, ?, d1) with dy(:, :, d2) to get dw(wR, wC, d1, d2).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;

        for (int b = 0; b < ${convInfo.batchSize}; b++) {
          for (int yR = 0; yR < ${convInfo.outHeight}; yR++) {
            int xR = wR + yR * ${strideHeight} - ${padTop};

            if (xR < 0 || xR >= ${convInfo.inHeight}) {
              continue;
            }

            for (int yC = 0; yC < ${convInfo.outWidth}; yC++) {
              int xC = wC + yC * ${strideWidth} - ${padLeft};

              if (xC < 0 || xC >= ${convInfo.inWidth}) {
                continue;
              }

              ${isChannelsLast ? `float dyValue = getDy(b, yR, yC, d2);
              float xValue = getX(b, xR, xC, d1);
              dotProd += (xValue * dyValue);` : `float dyValue = getDy(b, d2, yR, yC);
              float xValue = getX(b, d1, xR, xC);
              dotProd += (xValue * dyValue);`}
            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}
class $9b4973ea46141bc5$export$5dc650171c0f6623 {
    constructor(convInfo){
        this.variableNames = [
            'dy',
            'W'
        ];
        this.outputShape = convInfo.inShape;
        const filterHeight = convInfo.filterHeight;
        const filterWidth = convInfo.filterWidth;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const isChannelsLast = convInfo.dataFormat === 'channelsLast';
        const padTop = filterHeight - 1 - convInfo.padInfo.top;
        const padLeft = filterWidth - 1 - convInfo.padInfo.left;
        const rowDim = isChannelsLast ? 1 : 2;
        const colDim = isChannelsLast ? 2 : 3;
        const channelDim = isChannelsLast ? 3 : 1;
        this.userCode = `
      const ivec2 pads = ivec2(${padTop}, ${padLeft});

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords[0];
        int d1 = coords[${channelDim}];

        ivec2 dyCorner = ivec2(coords[${rowDim}], coords[${colDim}]) - pads;
        int dyRCorner = dyCorner.x;
        int dyCCorner = dyCorner.y;

        // Convolve dy(?, ?, d2) with w(:, :, d1, d2) to compute dx(xR, xC, d1).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;
        for (int wR = 0; wR < ${filterHeight}; wR++) {
          float dyR = float(dyRCorner + wR) / ${strideHeight}.0;

          if (dyR < 0.0 || dyR >= ${convInfo.outHeight}.0 || fract(dyR) > 0.0) {
            continue;
          }
          int idyR = int(dyR);

          int wRPerm = ${filterHeight} - 1 - wR;

          for (int wC = 0; wC < ${filterWidth}; wC++) {
            float dyC = float(dyCCorner + wC) / ${strideWidth}.0;

            if (dyC < 0.0 || dyC >= ${convInfo.outWidth}.0 ||
                fract(dyC) > 0.0) {
              continue;
            }
            int idyC = int(dyC);

            int wCPerm = ${filterWidth} - 1 - wC;

            for (int d2 = 0; d2 < ${convInfo.outChannels}; d2++) {

              if (${isChannelsLast}) {
                float xValue = getDy(batch, idyR, idyC, d2);
                float wValue = getW(wRPerm, wCPerm, d1, d2);
                dotProd += xValue * wValue;
              } else {
                float xValue = getDy(batch, d2, idyR, idyC);
                float wValue = getW(wRPerm, wCPerm, d1, d2);
                dotProd += xValue * wValue;
              }

            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}
class $9b4973ea46141bc5$export$932d18866f409cf3 {
    constructor(convInfo){
        this.variableNames = [
            'x',
            'dy'
        ];
        this.outputShape = convInfo.filterShape;
        const strideDepth = convInfo.strideDepth;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const padFront = convInfo.padInfo.front;
        const padTop = convInfo.padInfo.top;
        const padLeft = convInfo.padInfo.left;
        this.userCode = `
      void main() {
        ivec5 coords = getOutputCoords();
        int wF = coords.x;
        int wR = coords.y;
        int wC = coords.z;
        int d1 = coords.w;
        int d2 = coords.u;

        float dotProd = 0.0;

        for (int b = 0; b < ${convInfo.batchSize}; b++) {
          for (int yF = 0; yF < ${convInfo.outDepth}; yF++) {
            int xF = wF + yF * ${strideDepth} - ${padFront};

            if (xF < 0 || xF >= ${convInfo.inDepth}) {
              continue;
            }

            for (int yR = 0; yR < ${convInfo.outHeight}; yR++) {
              int xR = wR + yR * ${strideHeight} - ${padTop};

              if (xR < 0 || xR >= ${convInfo.inHeight}) {
                continue;
              }

              for (int yC = 0; yC < ${convInfo.outWidth}; yC++) {
                int xC = wC + yC * ${strideWidth} - ${padLeft};

                if (xC < 0 || xC >= ${convInfo.inWidth}) {
                  continue;
                }

                float dyValue = getDy(b, yF, yR, yC, d2);
                float xValue = getX(b, xF, xR, xC, d1);
                dotProd += (xValue * dyValue);
              }
            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}
class $9b4973ea46141bc5$export$acda329ff653a25 {
    constructor(convInfo){
        this.variableNames = [
            'dy',
            'W'
        ];
        this.outputShape = convInfo.inShape;
        const filterDepth = convInfo.filterDepth;
        const filterHeight = convInfo.filterHeight;
        const filterWidth = convInfo.filterWidth;
        const strideDepth = convInfo.strideDepth;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const padFront = filterDepth - 1 - convInfo.padInfo.front;
        const padTop = filterHeight - 1 - convInfo.padInfo.top;
        const padLeft = filterWidth - 1 - convInfo.padInfo.left;
        this.userCode = `
      const ivec3 pads = ivec3(${padFront}, ${padTop}, ${padLeft});

      void main() {
        ivec5 coords = getOutputCoords();
        int batch = coords.x;
        int d1 = coords.u;


        ivec3 dyCorner = ivec3(coords.y, coords.z, coords.w) - pads;
        int dyFCorner = dyCorner.x;
        int dyRCorner = dyCorner.y;
        int dyCCorner = dyCorner.z;

        float dotProd = 0.0;
        for (int wF = 0; wF < ${filterDepth}; wF++) {
          float dyF = float(dyFCorner + wF) / ${strideDepth}.0;

          if (dyF < 0.0 || dyF >= ${convInfo.outDepth}.0 || fract(dyF) > 0.0) {
            continue;
          }
          int idyF = int(dyF);

          int wFPerm = ${filterDepth} - 1 - wF;

          for (int wR = 0; wR < ${filterHeight}; wR++) {
            float dyR = float(dyRCorner + wR) / ${strideHeight}.0;

            if (dyR < 0.0 || dyR >= ${convInfo.outHeight}.0 ||
              fract(dyR) > 0.0) {
              continue;
            }
            int idyR = int(dyR);

            int wRPerm = ${filterHeight} - 1 - wR;

            for (int wC = 0; wC < ${filterWidth}; wC++) {
              float dyC = float(dyCCorner + wC) / ${strideWidth}.0;

              if (dyC < 0.0 || dyC >= ${convInfo.outWidth}.0 ||
                  fract(dyC) > 0.0) {
                continue;
              }
              int idyC = int(dyC);

              int wCPerm = ${filterWidth} - 1 - wC;

              for (int d2 = 0; d2 < ${convInfo.outChannels}; d2++) {
                float xValue = getDy(batch, idyF, idyR, idyC, d2);
                float wValue = getW(wFPerm, wRPerm, wCPerm, d1, d2);
                dotProd += xValue * wValue;
              }
            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}


function $26c7888026485ba8$export$652a30c9379f3de7(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, dy: dy } = inputs;
    const { strides: strides, pad: pad, dataFormat: dataFormat, dimRoundingMode: dimRoundingMode, filterShape: filterShape } = attrs;
    const $dataFormat = (0, $i64bB.backend_util).convertConv2DDataFormat(dataFormat);
    const convInfo = (0, $i64bB.backend_util).computeConv2DInfo(x.shape, filterShape, strides, 1 /* dilations */ , pad, dimRoundingMode, false, $dataFormat);
    const program = new (0, $9b4973ea46141bc5$export$1223560f67be2f2d)(convInfo);
    return backend.runWebGLProgram(program, [
        x,
        dy
    ], 'float32');
}
const $26c7888026485ba8$export$7a95f55d2d2e7d24 = {
    kernelName: (0, $i64bB.Conv2DBackpropFilter),
    backendName: 'webgl',
    kernelFunc: $26c7888026485ba8$export$652a30c9379f3de7
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
class $098ca15ca73635ff$export$9ade432542e381ca {
    constructor(convInfo){
        this.variableNames = [
            'dy',
            'W'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.customUniforms = [
            {
                name: 'strides',
                type: 'vec2'
            }
        ];
        this.outputShape = convInfo.inShape;
        this.enableShapeUniforms = (0, $8c928040c80f573b$export$5acc770fc06a0138)(this.outputShape.length);
        const filterHeight = convInfo.filterHeight;
        const filterWidth = convInfo.filterWidth;
        const padTop = filterHeight - 1 - convInfo.padInfo.top;
        const padLeft = filterWidth - 1 - convInfo.padInfo.left;
        this.userCode = `
      const ivec2 pads = ivec2(${padTop}, ${padLeft});

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords[0];
        int d1 = coords[3];

        ivec2 dyCorner = ivec2(coords[1], coords[2]) - pads;
        int dyRCorner = dyCorner.x;
        int dyCCorner = dyCorner.y;

        vec4 result = vec4(0.);
        for (int wR = 0; wR < ${filterHeight}; wR++) {
          float dyR = float(dyRCorner + wR) / strides[0];
          if (dyR < 0.0 || dyR >= ${convInfo.outHeight}.0 || fract(dyR) > 0.0) {
            continue;
          }
          int idyR = int(dyR);
          int wRPerm = ${filterHeight} - 1 - wR;

          for (int wC = 0; wC < ${filterWidth}; wC++) {
            int wCPerm = ${filterWidth} - 1 - wC;

            float dyC = float(dyCCorner + wC) / strides[1];
            bool idyCVal = (dyC >= 0.0) && (dyC < ${convInfo.outWidth}.0)
              && (fract(dyC) == 0.0);
            int idyC = int(dyC);

            float dyC2 = float(dyCCorner + wC + 1) / strides[1];
            bool idyCVal2 = (dyC2 >= 0.0) && (dyC2 < ${convInfo.outWidth}.0)
              && (fract(dyC2) == 0.0);
            int idyC2 = int(dyC2);

            if (idyCVal && idyCVal2) {
              for (int d2 = 0; d2 < ${convInfo.outChannels}; d2 += 2) {
                vec4 wValue = getW(wRPerm, wCPerm, d1, d2);
                vec4 dySample = getDy(batch, idyR, idyC, d2);
                vec4 dySample2 = (idyC / 2 == idyC2 / 2) ?
                  dySample : getDy(batch, idyR, idyC2, d2);

                vec2 dyValue = mod(float(idyC), 2.) == 0. ?
                  dySample.xy : dySample.zw;
                result.xy += vec2(dot(dyValue, wValue.xy),
                  dot(dyValue, wValue.zw));

                dyValue = mod(float(idyC2), 2.) == 0. ?
                  dySample2.xy : dySample2.zw;
                result.zw += vec2(dot(dyValue, wValue.xy),
                  dot(dyValue, wValue.zw));
              }
            } else if (idyCVal) {
              for (int d2 = 0; d2 < ${convInfo.outChannels}; d2 += 2) {
                vec4 wValue = getW(wRPerm, wCPerm, d1, d2);
                vec4 dySample = getDy(batch, idyR, idyC, d2);
                vec2 dyValue = mod(float(idyC), 2.) == 0. ?
                  dySample.xy : dySample.zw;
                result.xy += vec2(dot(dyValue, wValue.xy),
                  dot(dyValue, wValue.zw));
              }
            } else if (idyCVal2) {
              for (int d2 = 0; d2 < ${convInfo.outChannels}; d2 += 2) {
                vec4 wValue = getW(wRPerm, wCPerm, d1, d2);
                vec4 dySample = getDy(batch, idyR, idyC2, d2);
                vec2 dyValue = mod(float(idyC2), 2.) == 0. ?
                  dySample.xy : dySample.zw;
                result.zw += vec2(dot(dyValue, wValue.xy),
                  dot(dyValue, wValue.zw));
              }
            }
          }
        }
        setOutput(result);
      }
    `;
    }
}


function $3f08c21d8204efd0$export$633310eed0c26e72(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, filter: filter } = inputs;
    const { inputShape: inputShape, strides: strides, pad: pad, dataFormat: dataFormat, dimRoundingMode: dimRoundingMode } = attrs;
    const $dataFormat = (0, $i64bB.backend_util).convertConv2DDataFormat(dataFormat);
    const convInfo = (0, $i64bB.backend_util).computeConv2DInfo(inputShape, filter.shape, strides, 1 /* dilations */ , pad, dimRoundingMode, false, $dataFormat);
    if ((0, $i64bB.env)().getBool('WEBGL_PACK_CONV2DTRANSPOSE') && $dataFormat === 'channelsLast') {
        const customValues = [
            [
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        ];
        const program = new (0, $098ca15ca73635ff$export$9ade432542e381ca)(convInfo);
        return backend.runWebGLProgram(program, [
            dy,
            filter
        ], 'float32', customValues);
    } else {
        const program = new (0, $9b4973ea46141bc5$export$5dc650171c0f6623)(convInfo);
        return backend.runWebGLProgram(program, [
            dy,
            filter
        ], 'float32');
    }
}
const $3f08c21d8204efd0$export$19bbc19fff1ed26f = {
    kernelName: (0, $i64bB.Conv2DBackpropInput),
    backendName: 'webgl',
    kernelFunc: $3f08c21d8204efd0$export$633310eed0c26e72
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

function $a1f837211cd242b8$export$1929932f31d07956(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter } = inputs;
    const { strides: strides, pad: pad, dilations: dilations } = attrs;
    const convInfo = (0, $i64bB.backend_util).computeConv3DInfo(x.shape, filter.shape, strides, dilations, pad);
    const program = new (0, $65122774589fac9b$export$67aff94cf1ececaf)(convInfo);
    return backend.runWebGLProgram(program, [
        x,
        filter
    ], 'float32');
}
const $a1f837211cd242b8$export$1fe590fda0829040 = {
    kernelName: (0, $i64bB.Conv3D),
    backendName: 'webgl',
    kernelFunc: $a1f837211cd242b8$export$1929932f31d07956
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

function $fdd940dd9e7b76d4$export$b57760dc3101cea7(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, dy: dy } = inputs;
    const { strides: strides, pad: pad, filterShape: filterShape } = attrs;
    const convInfo = (0, $i64bB.backend_util).computeConv3DInfo(x.shape, filterShape, strides, 1 /* dilations */ , pad);
    const program = new (0, $9b4973ea46141bc5$export$932d18866f409cf3)(convInfo);
    return backend.runWebGLProgram(program, [
        x,
        dy
    ], 'float32');
}
const $fdd940dd9e7b76d4$export$6dce9169640850fa = {
    kernelName: (0, $i64bB.Conv3DBackpropFilterV2),
    backendName: 'webgl',
    kernelFunc: $fdd940dd9e7b76d4$export$b57760dc3101cea7
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

function $0ff1dfa52085b1cf$export$deb6d1ca1fa2977b(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, filter: filter } = inputs;
    const { pad: pad, strides: strides, inputShape: inputShape } = attrs;
    const convInfo = (0, $i64bB.backend_util).computeConv3DInfo(inputShape, filter.shape, strides, 1 /* dilations */ , pad);
    const program = new (0, $9b4973ea46141bc5$export$acda329ff653a25)(convInfo);
    return backend.runWebGLProgram(program, [
        dy,
        filter
    ], 'float32');
}
const $0ff1dfa52085b1cf$export$cdcac766a3ef1744 = {
    kernelName: (0, $i64bB.Conv3DBackpropInputV2),
    backendName: 'webgl',
    kernelFunc: $0ff1dfa52085b1cf$export$deb6d1ca1fa2977b
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


const $5d30812f5875ff7d$var$COS = (0, $2e65282075da2b30$export$bf39b1cb254b6187) + `
  return cos(x);
`;
const $5d30812f5875ff7d$var$COS_PACKED = `
  vec4 result = cos(x);
  bvec4 isNaN = isnan(x);
  ${(0, $1b00798c48aa5c1a$export$2b4d5cee4bd7b2dd)}
  return result;
`;
const $5d30812f5875ff7d$export$50d414a77b60d802 = (0, $2e65282075da2b30$export$ba4daf5748026fba)({
    opSnippet: $5d30812f5875ff7d$var$COS,
    packedOpSnippet: $5d30812f5875ff7d$var$COS_PACKED
});
const $5d30812f5875ff7d$export$ff099a1da5235a7e = {
    kernelName: (0, $i64bB.Cos),
    backendName: 'webgl',
    kernelFunc: $5d30812f5875ff7d$export$50d414a77b60d802
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

const $c88a83e60aff56ce$var$COSH = `
  float e2x = exp(-x);
  return (e2x + 1.0 / e2x) / 2.0;
`;
const $c88a83e60aff56ce$export$2e2fd1ad24e4d350 = (0, $2e65282075da2b30$export$ba4daf5748026fba)({
    opSnippet: $c88a83e60aff56ce$var$COSH
});
const $c88a83e60aff56ce$export$c5824052b09ba0ed = {
    kernelName: (0, $i64bB.Cosh),
    backendName: 'webgl',
    kernelFunc: $c88a83e60aff56ce$export$2e2fd1ad24e4d350
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $8411046f0bc00450$export$c889a58f7ea63106 {
    constructor(imageShape, boxShape, cropSize, method, extrapolationValue){
        this.variableNames = [
            'Image',
            'Boxes',
            'BoxInd'
        ];
        this.outputShape = [];
        const [batch, imageHeight, imageWidth, depth] = imageShape;
        const [numBoxes] = boxShape;
        const [cropHeight, cropWidth] = cropSize;
        this.outputShape = [
            numBoxes,
            cropHeight,
            cropWidth,
            depth
        ];
        const methodId = method === 'bilinear' ? 1 : 0;
        const [inputHeightFloat, inputWidthFloat] = [
            `${imageHeight - 1}.0`,
            `${imageWidth - 1}.0`
        ];
        const [heightRatio, heightScale, inY] = cropHeight > 1 ? [
            `${(imageHeight - 1) / (cropHeight - 1)}`,
            '(y2-y1) * height_ratio',
            `y1*${inputHeightFloat} + float(y)*(height_scale)`
        ] : [
            '0.0',
            '0.0',
            `0.5 * (y1+y2) * ${inputHeightFloat}`
        ];
        const [widthRatio, widthScale, inX] = cropWidth > 1 ? [
            `${(imageWidth - 1) / (cropWidth - 1)}`,
            '(x2-x1) * width_ratio',
            `x1*${inputWidthFloat} + float(x)*(width_scale)`
        ] : [
            '0.0',
            '0.0',
            `0.5 * (x1+x2) * ${inputWidthFloat}`
        ];
        // Reference implementation
        // tslint:disable-next-line:max-line-length
        // https://github.com/tensorflow/tensorflow/blob/master/tensorflow/core/kernels/crop_and_resize_op_gpu.cu.cc
        this.userCode = `
      const float height_ratio = float(${heightRatio});
      const float width_ratio = float(${widthRatio});
      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int y = coords[1];
        int x = coords[2];
        int d = coords[3];

        // get box vals
        float y1 = getBoxes(b,0);
        float x1 = getBoxes(b,1);
        float y2 = getBoxes(b,2);
        float x2 = getBoxes(b,3);

        // get image in batch index
        int bInd = round(getBoxInd(b));
        if(bInd < 0 || bInd >= ${batch}) {
          return;
        }

        float height_scale = ${heightScale};
        float width_scale = ${widthScale};

        float in_y = ${inY};
        if( in_y < 0.0 || in_y > ${inputHeightFloat} ) {
          setOutput(float(${extrapolationValue}));
          return;
        }
        float in_x = ${inX};
        if( in_x < 0.0 || in_x > ${inputWidthFloat} ) {
          setOutput(float(${extrapolationValue}));
          return;
        }

        vec2 sourceFracIndexCR = vec2(in_x,in_y);
        if(${methodId} == 1) {
          // Compute the four integer indices.
          ivec2 sourceFloorCR = ivec2(sourceFracIndexCR);
          ivec2 sourceCeilCR = ivec2(ceil(sourceFracIndexCR));

          float topLeft = getImage(b, sourceFloorCR.y, sourceFloorCR.x, d);
          float bottomLeft = getImage(b, sourceCeilCR.y, sourceFloorCR.x, d);
          float topRight = getImage(b, sourceFloorCR.y, sourceCeilCR.x, d);
          float bottomRight = getImage(b, sourceCeilCR.y, sourceCeilCR.x, d);

          vec2 fracCR = sourceFracIndexCR - vec2(sourceFloorCR);

          float top = topLeft + (topRight - topLeft) * fracCR.x;
          float bottom = bottomLeft + (bottomRight - bottomLeft) * fracCR.x;
          float newValue = top + (bottom - top) * fracCR.y;
          setOutput(newValue);
        } else {
          // Compute the coordinators of nearest neighbor point.
          ivec2 sourceNearestCR = ivec2(floor(
            sourceFracIndexCR + vec2(0.5,0.5)));
          float newValue = getImage(b, sourceNearestCR.y, sourceNearestCR.x, d);
          setOutput(newValue);
        }
      }
    `;
    }
}


const $327b096734c2bb70$export$6f0f0090e1f6cd3c = (args)=>{
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { image: image, boxes: boxes, boxInd: boxInd } = inputs;
    const { cropSize: cropSize, method: method, extrapolationValue: extrapolationValue } = attrs;
    const program = new (0, $8411046f0bc00450$export$c889a58f7ea63106)(image.shape, boxes.shape, cropSize, method, extrapolationValue);
    return backend.runWebGLProgram(program, [
        image,
        boxes,
        boxInd
    ], 'float32');
};
const $327b096734c2bb70$export$f7086edcf0050c7f = {
    kernelName: (0, $i64bB.CropAndResize),
    backendName: 'webgl',
    kernelFunc: $327b096734c2bb70$export$6f0f0090e1f6cd3c
};


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

var $05253092f3fcd66e$export$5245168906ddd3d9;
(function(CumOpType) {
    CumOpType["Prod"] = "*";
    CumOpType["Sum"] = "+";
})($05253092f3fcd66e$export$5245168906ddd3d9 || ($05253092f3fcd66e$export$5245168906ddd3d9 = {}));
class $05253092f3fcd66e$export$6788a4605888e813 {
    constructor(op, outputShape, exclusive, reverse){
        this.op = op;
        this.outputShape = outputShape;
        this.variableNames = [
            'x'
        ];
        this.customUniforms = [
            {
                name: 'index',
                type: 'float'
            }
        ];
        const rank = this.outputShape.length;
        const initVal = this.op === $05253092f3fcd66e$export$5245168906ddd3d9.Prod ? '1.0' : '0.0';
        const val = exclusive ? initVal : `getX(${$05253092f3fcd66e$var$getCoords(rank, 'coords', this.op)})`;
        const length = this.outputShape[this.outputShape.length - 1];
        let condition = '';
        let idxString = '';
        // When exclusive is set, the cum op becomes roll op that copies the
        // value from the previous index based on the direction specified by the
        // reverse flag.
        if (exclusive) {
            condition = reverse ? `end != ${length - 1}` : 'end != 0';
            idxString = reverse ? 'end + 1' : 'end - 1';
        } else {
            condition = reverse ? `end + pow2 < ${length}` : 'end >= pow2';
            idxString = reverse ? 'end + pow2' : 'end - pow2';
        }
        this.userCode = `
      void main() {
        ${(0, $ba2c54ffbda39e8e$export$859efd105c10c755)(rank)} coords = getOutputCoords();
        int end = ${$05253092f3fcd66e$var$getFinalCoord(rank, 'coords', this.op)};
        float val = ${val};
        int pow2 = int(pow(2.0, index));
        if (${condition}) {
          int idx = ${idxString};
          ${$05253092f3fcd66e$var$getFinalCoord(rank, 'coords', this.op)} = idx;
          val ${this.op}= getX(${$05253092f3fcd66e$var$getCoords(rank, 'coords', this.op)});
        }
        setOutput(val);
      }
    `;
    }
}
function $05253092f3fcd66e$var$getCoords(rank, name, op) {
    if (rank === 1) return `${name}`;
    else if (rank === 2) return `${name}.x, ${name}.y`;
    else if (rank === 3) return `${name}.x, ${name}.y, ${name}.z`;
    else if (rank === 4) return `${name}.x, ${name}.y, ${name}.z, ${name}.w`;
    else throw new Error(`Cumulative ${op} for rank ${rank} is not yet supported`);
}
function $05253092f3fcd66e$var$getFinalCoord(rank, name, op) {
    if (rank === 1) return `${name}`;
    else if (rank === 2) return `${name}.y`;
    else if (rank === 3) return `${name}.z`;
    else if (rank === 4) return `${name}.w`;
    else throw new Error(`Cumulative ${op} for rank ${rank} is not yet supported`);
}


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");



function $8bdb5e4808ab578e$export$88973bdd32b5a724(op, x, backend, axis, exclusive, reverse) {
    const xRank = x.shape.length;
    const permutation = (0, $i64bB.backend_util).getAxesPermutation([
        axis
    ], xRank);
    let permutedX = x;
    if (permutation != null) permutedX = (0, $6cab078553124169$export$9cb09a71b7d66923)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            perm: permutation
        }
    });
    const permutedAxis = (0, $i64bB.backend_util).getInnerMostAxes(1, xRank)[0];
    if (permutedAxis !== xRank - 1) throw new Error(`WebGL cumprod shader expects an inner-most axis=${x.shape.length - 1} ` + `but got axis=${axis}`);
    const size = permutedX.shape[permutedAxis];
    let result = (0, $2b13f312c76ad9c3$export$f0954fd7d5368655)({
        inputs: {
            x: permutedX
        },
        backend: backend
    });
    // Use cum parallel algorithm, inspired by:
    // https://developer.nvidia.com/gpugems/gpugems3/part-vi-gpu-computing/chapter-39-parallel-prefix-sum-scan-cuda
    // Note: although the algorithm is called sum, it works for any associtative
    // operator with an identity.
    for(let i = 0; i <= Math.ceil(Math.log2(size)) - 1; i++){
        const program = new (0, $05253092f3fcd66e$export$6788a4605888e813)(op, permutedX.shape, false, reverse);
        const customValues = [
            [
                i
            ]
        ];
        const prevResult = result;
        result = backend.runWebGLProgram(program, [
            result
        ], result.dtype, customValues);
        backend.disposeIntermediateTensorInfo(prevResult);
    }
    // For exclusive cum, shift the end result in the direction of product or sum
    // and add 1 for product or 0 for sum to the front index.
    if (exclusive) {
        const program = new (0, $05253092f3fcd66e$export$6788a4605888e813)(op, permutedX.shape, exclusive, reverse);
        const prevResult = result;
        result = backend.runWebGLProgram(program, [
            result
        ], result.dtype);
        backend.disposeIntermediateTensorInfo(prevResult);
    }
    if (permutation != null) {
        const reversePermutation = (0, $i64bB.backend_util).getUndoAxesPermutation(permutation);
        const reverseTransposedResult = (0, $6cab078553124169$export$9cb09a71b7d66923)({
            inputs: {
                x: result
            },
            backend: backend,
            attrs: {
                perm: reversePermutation
            }
        });
        backend.disposeIntermediateTensorInfo(result);
        backend.disposeIntermediateTensorInfo(permutedX);
        return reverseTransposedResult;
    }
    return result;
}


function $95ccf3692624d814$export$dc7513e907e94b8d(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, exclusive: exclusive, reverse: reverse } = attrs;
    return (0, $8bdb5e4808ab578e$export$88973bdd32b5a724)((0, $05253092f3fcd66e$export$5245168906ddd3d9).Prod, x, backend, axis, exclusive, reverse);
}
const $95ccf3692624d814$export$db50d81ed60c5a35 = {
    kernelName: (0, $i64bB.Cumprod),
    backendName: 'webgl',
    kernelFunc: $95ccf3692624d814$export$dc7513e907e94b8d
};


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


function $e62976d7f9bb3deb$export$71990b1e1c4912fe(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, exclusive: exclusive, reverse: reverse } = attrs;
    return (0, $8bdb5e4808ab578e$export$88973bdd32b5a724)((0, $05253092f3fcd66e$export$5245168906ddd3d9).Sum, x, backend, axis, exclusive, reverse);
}
const $e62976d7f9bb3deb$export$2f6196f3316e7ed2 = {
    kernelName: (0, $i64bB.Cumsum),
    backendName: 'webgl',
    kernelFunc: $e62976d7f9bb3deb$export$71990b1e1c4912fe
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

function $26c3558c7225fa23$export$436934e6cf1946f1(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, weights: weights } = inputs;
    const { size: size, binaryOutput: binaryOutput } = attrs;
    if (x.shape.length === 1) {
        const xVals = backend.readSync(x.dataId);
        const weightsVals = backend.readSync(weights.dataId);
        const outVals = (0, $377486a788efd20b$export$566def819e5d4601)(xVals, weightsVals, weights.dtype, weights.shape, size);
        return backend.makeTensorInfo([
            size
        ], weights.dtype, outVals);
    } else if (x.shape.length === 2) {
        const xBuf = backend.bufferSync(x);
        const weightsBuf = backend.bufferSync(weights);
        const outBuf = (0, $377486a788efd20b$export$447b89266e53682e)(xBuf, weightsBuf, size, binaryOutput);
        return backend.makeTensorInfo(outBuf.shape, weights.dtype, outBuf.values);
    }
    throw new Error(`Error in denseBincount: input must be at most rank 2, but got rank` + `${x.shape.length}.`);
}
const $26c3558c7225fa23$export$88ba267b84334692 = {
    kernelName: (0, $i64bB.DenseBincount),
    backendName: 'webgl',
    kernelFunc: $26c3558c7225fa23$export$436934e6cf1946f1
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $9ff6f937beaea383$export$eb07f17369165f28 {
    constructor(outputShape, blockSize, dataFormat){
        this.variableNames = [
            'x'
        ];
        this.outputShape = [];
        this.outputShape = outputShape;
        this.blockSize = blockSize;
        this.dataFormat = dataFormat;
        this.userCode = `
    void main() {
      ivec4 coords = getOutputCoords();
      int b = coords[0];
      int h = ${this.getHeightCoordString()};
      int w = ${this.getWidthCoordString()};
      int d = ${this.getDepthCoordString()};

      int in_h = h / ${blockSize};
      int offset_h = imod(h, ${blockSize});
      int in_w = w / ${blockSize};
      int offset_w = imod(w, ${blockSize});
      int offset_d = (offset_h * ${blockSize} + offset_w) *
        ${this.getOutputDepthSize()};
      int in_d = d + offset_d;

      float result = ${this.getInputSamplingString()};
      setOutput(result);
    }
  `;
    }
    getHeightCoordString() {
        if (this.dataFormat === 'NHWC') return `coords[1]`;
        else return `coords[2]`;
    }
    getWidthCoordString() {
        if (this.dataFormat === 'NHWC') return `coords[2]`;
        else return `coords[3]`;
    }
    getDepthCoordString() {
        if (this.dataFormat === 'NHWC') return `coords[3]`;
        else return `coords[1]`;
    }
    getOutputDepthSize() {
        if (this.dataFormat === 'NHWC') return this.outputShape[3];
        else return this.outputShape[1];
    }
    getInputSamplingString() {
        if (this.dataFormat === 'NHWC') return `getX(b, in_h, in_w, in_d)`;
        else return `getX(b, in_d, in_h, in_w)`;
    }
}


function $00c79c2fddb4312a$export$3b50daec0f185f12(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { blockSize: blockSize, dataFormat: dataFormat } = attrs;
    const batchSize = x.shape[0];
    const inputHeight = dataFormat === 'NHWC' ? x.shape[1] : x.shape[2];
    const inputWidth = dataFormat === 'NHWC' ? x.shape[2] : x.shape[3];
    const inputDepth = dataFormat === 'NHWC' ? x.shape[3] : x.shape[1];
    const outputHeight = inputHeight * blockSize;
    const outputWidth = inputWidth * blockSize;
    const outputDepth = inputDepth / (blockSize * blockSize);
    const outputShape = dataFormat === 'NHWC' ? [
        batchSize,
        outputHeight,
        outputWidth,
        outputDepth
    ] : [
        batchSize,
        outputDepth,
        outputHeight,
        outputWidth
    ];
    const program = new (0, $9ff6f937beaea383$export$eb07f17369165f28)(outputShape, blockSize, dataFormat);
    return backend.runWebGLProgram(program, [
        x
    ], x.dtype);
}
const $00c79c2fddb4312a$export$9c5b88dcb1d2008b = {
    kernelName: (0, $i64bB.DepthToSpace),
    backendName: 'webgl',
    kernelFunc: $00c79c2fddb4312a$export$3b50daec0f185f12
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
class $65d096955c790267$export$4ead5a4ba22ede40 {
    constructor(convInfo, addBias = false, activation = null, hasPreluActivation = false, hasLeakyReluAlpha = false){
        this.variableNames = [
            'x',
            'W'
        ];
        this.customUniforms = [
            {
                name: 'pads',
                type: 'ivec2'
            },
            {
                name: 'strides',
                type: 'ivec2'
            },
            {
                name: 'dilations',
                type: 'ivec2'
            },
            {
                name: 'inDims',
                type: 'ivec2'
            }
        ];
        this.outputShape = convInfo.outShape;
        this.enableShapeUniforms = (0, $8c928040c80f573b$export$5acc770fc06a0138)(this.outputShape.length);
        const filterHeight = convInfo.filterHeight;
        const filterWidth = convInfo.filterWidth;
        const channelMul = convInfo.outChannels / convInfo.inChannels;
        let activationSnippet = '', applyActivationSnippet = '';
        if (activation) {
            if (hasPreluActivation) activationSnippet = `float activation(float a) {
          float b = getPreluActivationWeightsAtOutCoords();
          ${activation}
        }`;
            else if (hasLeakyReluAlpha) activationSnippet = `float activation(float a) {
          float b = getLeakyreluAlphaAtOutCoords();
          ${activation}
        }`;
            else activationSnippet = `
          float activation(float x) {
            ${activation}
          }
        `;
            applyActivationSnippet = `result = activation(result);`;
        }
        const addBiasSnippet = addBias ? 'result += getBiasAtOutCoords();' : '';
        if (addBias) this.variableNames.push('bias');
        if (hasPreluActivation) this.variableNames.push('preluActivationWeights');
        if (hasLeakyReluAlpha) this.variableNames.push('leakyreluAlpha');
        this.userCode = `
      ${activationSnippet}

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords.x;
        ivec2 xRCCorner = coords.yz * strides - pads;
        int d2 = coords.w;
        int d1 = d2 / ${channelMul};
        int q = d2 - d1 * ${channelMul};

        int xRCorner = xRCCorner.x;
        int xCCorner = xRCCorner.y;

        // Convolve x(?, ?, d1) with w(:, :, d1, q) to get y(yR, yC, d2).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;
        // TO DO(dsmilkov): Flatten the two for loops and vec4 the operations.
        for (int wR = 0; wR < ${filterHeight}; wR++) {
          int xR = xRCorner + wR * dilations[0];

          if (xR < 0 || xR >= inDims[0]) {
            continue;
          }

          for (int wC = 0; wC < ${filterWidth}; wC++) {
            int xC = xCCorner + wC * dilations[1];

            if (xC < 0 || xC >= inDims[1]) {
              continue;
            }

            float xVal = getX(batch, xR, xC, d1);
            float wVal = getW(wR, wC, d1, q);
            dotProd += xVal * wVal;
          }
        }

        float result = dotProd;
        ${addBiasSnippet}
        ${applyActivationSnippet}
        setOutput(result);
      }
    `;
    }
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

class $054208cd8d35acb6$export$acb9287627a2b170 {
    constructor(convInfo, addBias = false, activation = null, hasPreluActivation = false, hasLeakyReluAlpha = false){
        this.variableNames = [
            'x',
            'W'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.customUniforms = [
            {
                name: 'pads',
                type: 'ivec2'
            },
            {
                name: 'strides',
                type: 'ivec2'
            },
            {
                name: 'dilations',
                type: 'ivec2'
            },
            {
                name: 'inDims',
                type: 'ivec2'
            }
        ];
        this.outputShape = convInfo.outShape;
        this.enableShapeUniforms = (0, $8c928040c80f573b$export$5acc770fc06a0138)(this.outputShape.length);
        const channelMul = convInfo.outChannels / convInfo.inChannels;
        const padLeft = convInfo.padInfo.left;
        const strideWidth = convInfo.strideWidth;
        const dilationWidth = convInfo.dilationWidth;
        const filterHeight = convInfo.filterHeight;
        const filterWidth = convInfo.filterWidth;
        const texelsAcross = filterWidth;
        let mainLoop = `
      int xR; int xC; int xCOffset;
      vec4 wTexel; vec4 previous; vec4 final;`;
        for(let c = 0; c < filterWidth; c++)mainLoop += `
          vec4 xTexelC${c * 2};
          int xTexelC${c * 2}Ready;
          vec4 xTexelC${c * 2 + 1};
          int xTexelC${c * 2 + 1}Ready;
          vec4 xC${c};`;
        /**
         * This vectorized implementation works by gathering the values needed for
         * each output channel's dot product into vec4's and then multiplying them
         * all together (this happens in the final double for-loop below). Most of
         * the main loop consists of constructing these vec4's with the minimum
         * number of texture2D calls, which means making use of all four returned
         * values from a texture2D call at once.
         */ mainLoop += `
    for (int r = 0; r < ${filterHeight}; r++) {
      `;
        for(let c = 0; c < filterWidth; c++)mainLoop += `
          xTexelC${c * 2} = vec4(0.0);
          xTexelC${c * 2}Ready = 0;
          xTexelC${c * 2 + 1} = vec4(0.0);
          xTexelC${c * 2 + 1}Ready = 0;
          xC${c} = vec4(0.0);`;
        mainLoop += `
        xR = xRCorner + r * dilations[0];
        if (xR >=0 && xR < inDims[0]) {
      `;
        for(let texelC = 0; texelC < (texelsAcross + 1) / 2; texelC++){
            const colIndex = texelC * 2;
            mainLoop += `
          xC = xCCorner + ${colIndex * dilationWidth};
          `;
            if (strideWidth === 1) {
                if (colIndex < filterWidth) {
                    // If padding is odd, the outer texels have to be composed.
                    if (padLeft % 2 === 1) {
                        // TODO: Ensure vec4 previous does not result in redundant sample,
                        // and avoid setting xTexelRC's that exceed the boundary in the
                        // first place rather than resetting them to vec4(0)).
                        // To compute xCOffset:
                        // - If padding is odd, we must add 1 to ensure we ask for an
                        // even-numbered row.
                        // - We subtract 2 to access the previous texel.
                        mainLoop += `
                xCOffset = xC + 1;
                if (xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex}Ready == 0) {
                  xTexelC${colIndex} = getX(batch, xR, xCOffset, d1);

                  // Need to manually clear unused channels in case
                  // we're reading from recycled texture.
                  if (xCOffset + 1 >= inDims[1]) {
                    xTexelC${colIndex}.zw = vec2(0.0);
                  }
                  xTexelC${colIndex}Ready = 1;
                }
              `;
                        // This texel has been read in previous iteration if the dilation
                        // is 1.
                        if (dilationWidth === 1 && colIndex > 0) mainLoop += `
                xC${colIndex} = vec4(xTexelC${colIndex - 2}.zw, xTexelC${colIndex}.xy);
                `;
                        else mainLoop += `
                  xCOffset = xC + 1 - 2;

                  if (xCOffset >= 0 && xCOffset < inDims[1]) {
                    previous = getX(batch, xR, xCOffset, d1);

                    // Need to manually clear unused channels in case
                    // we're reading from recycled texture.
                    if (xCOffset + 1 >= inDims[1]) {
                      previous.zw = vec2(0.0);
                    }

                    xC${colIndex} = vec4(previous.zw, xTexelC${colIndex}.xy);
                  } else {
                    xC${colIndex} = vec4(0.0, 0.0, xTexelC${colIndex}.xy);
                  }
                  `;
                    } else // Padding is even, so xRC corresponds to a single texel.
                    mainLoop += `
                if (xC >= 0 && xC < inDims[1] && xTexelC${colIndex}Ready == 0) {
                  xTexelC${colIndex} = getX(batch, xR, xC, d1);
                  if (xC + 1 >= inDims[1]) {
                    xTexelC${colIndex}.zw = vec2(0.0);
                  }
                  xTexelC${colIndex}Ready = 1;
                }

                xC${colIndex} = xTexelC${colIndex};
                `;
                    if (colIndex + 1 < filterWidth) {
                        // If dilation is even, the second entry should match the first
                        // (either both are composed or both are single samples). But if
                        // dilation is odd, then the second entry should be the opposite
                        // of the first (if the first is composed, the second is a single
                        // sample, and vice versa.)
                        const nextTexelOffset = padLeft % 2 === 0 ? (0, $i64bB.util).nearestLargerEven(dilationWidth) : dilationWidth;
                        if (dilationWidth % 2 === 0 && padLeft % 2 === 1 || dilationWidth % 2 !== 0 && padLeft % 2 !== 1) {
                            mainLoop += `
                  xCOffset = xC + imod(pads[1], 2) + ${nextTexelOffset};

                  if (xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex + 1}Ready == 0) {
                    xTexelC${colIndex + 1} = getX(batch, xR, xCOffset, d1);

                    // Need to manually clear unused channels in case
                    // we're reading from recycled texture.
                    if (xCOffset + 1 >= inDims[1]) {
                      xTexelC${colIndex + 1}.zw = vec2(0.0);
                    }
                    xTexelC${colIndex + 1}Ready = 1;
                  }
                  `;
                            // If dilation > 1 then the xRC's will not be able to share any
                            // values, so each xRC will require two unique calls to getX.
                            if (dilationWidth > 1) mainLoop += `
                    xCOffset -= 2;
                    if (xCOffset >= 0 && xCOffset < inDims[1]) {
                     previous = getX(batch, xR, xCOffset, d1);
                     xC${colIndex + 1} = vec4(previous.zw, xTexelC${colIndex + 1}.xy);
                    } else {
                     xC${colIndex + 1} = vec4(0.0, 0.0, xTexelC${colIndex + 1}.xy);
                    }
                    `;
                            else mainLoop += `
                    xC${colIndex + 1} = vec4(xTexelC${colIndex}.zw, xTexelC${colIndex + 1}.xy);
                    `;
                        } else // If dilation is 1 and padding is odd, we have already read the
                        // texel when constructing the previous x value. Here we can
                        // simply skip the texture read.
                        if (nextTexelOffset === 1) mainLoop += `
                    xC${colIndex + 1} = xTexelC${colIndex};
                    `;
                        else mainLoop += `
                    xCOffset = xC + ${nextTexelOffset};

                    if (xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex + 1}Ready == 0) {
                      xTexelC${colIndex + 1} = getX(batch, xR, xCOffset, d1);
                      if (xCOffset + 1 >= inDims[1]) {
                        xTexelC${colIndex + 1}.zw = vec2(0.0);
                      }
                      xTexelC${colIndex + 1}Ready = 1;
                    }

                    xC${colIndex + 1} = xTexelC${colIndex + 1};
                    `;
                    }
                }
            } else if (colIndex < filterWidth) {
                // Depending on whether padLeft is even or odd, we want either the
                // xy or zw channels from X texels for xC${colIndex}. If padLeft is
                // even, xC${colIndex +1} is simply the zw channels of texels we've
                // already sampled. But if padLeft is odd, xC{$c + 1}.zw will
                // need to come from the xy channels of a new texel, hence the `
                // vec4
                // final` initialized below.
                if (padLeft % 2 === 1) {
                    mainLoop += `
                xCOffset = xC + 1 - strides[1];
                if(xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex}Ready == 0) {
                  xTexelC${colIndex} = getX(batch, xR, xCOffset, d1);
                  // Need to manually clear unused channels in case
                  // we're reading from recycled texture.
                  if (xCOffset + 1 >= inDims[1]) {
                    xTexelC${colIndex}.zw = vec2(0.0);
                  }
                  xTexelC${colIndex}Ready = 1;
                }

                if(xC + 1 >= 0 && xC + 1 < inDims[1] && xTexelC${colIndex + 1}Ready == 0) {
                  xTexelC${colIndex + 1} = getX(batch, xR, xC + 1, d1);
                  // Need to manually clear unused channels in case
                  // we're reading from recycled texture.
                  if (xC + 2 >= inDims[1]) {
                    xTexelC${colIndex + 1}.zw = vec2(0.0);
                  }
                  xTexelC${colIndex + 1}Ready = 1;
                }

                xC${colIndex} = vec4(xTexelC${colIndex}.zw, xTexelC${colIndex + 1}.zw);
              `;
                    if (colIndex + 1 < filterWidth) mainLoop += `
                  final = vec4(0.0);
                  xCOffset = xC + 1 + strides[1];
                  if(xCOffset >= 0 && xCOffset < inDims[1]) {
                    final = getX(batch, xR, xCOffset, d1);
                  }
                  xC${colIndex + 1} = vec4(xTexelC${colIndex + 1}.xy, final.xy);
                `;
                } else {
                    mainLoop += `
                if(xC >= 0 && xC < inDims[1] && xTexelC${colIndex}Ready == 0) {
                  xTexelC${colIndex} = getX(batch, xR, xC, d1);
                  if (xC + 1 >= inDims[1]) {
                    xTexelC${colIndex}.zw = vec2(0.0);
                  }
                  xTexelC${colIndex}Ready = 1;
                }

                xCOffset = xC + strides[1];
                if(xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex + 1}Ready == 0) {
                  xTexelC${colIndex + 1} = getX(batch, xR, xCOffset, d1);
                  if (xCOffset + 1 >= inDims[1]) {
                    xTexelC${colIndex + 1}.zw = vec2(0.);
                  }
                  xTexelC${colIndex + 1}Ready = 1;
                }

                xC${colIndex} = vec4(
                  xTexelC${colIndex}.xy, xTexelC${colIndex + 1}.xy);
              `;
                    if (colIndex + 1 < filterWidth) mainLoop += `
                  xC${colIndex + 1} = vec4(xTexelC${colIndex}.zw, xTexelC${colIndex + 1}.zw);
                `;
                }
            }
            // localize the dotProd accumulation within the loop, the theory is for
            // GPU with limited cache, accumulate sum across large amount of
            // veriables will cause lots of cache misses. (i.e. 5x5 filter will have
            // 50 variables)
            if (colIndex < filterWidth) {
                mainLoop += `
            wTexel = getW(r, ${colIndex}, d1, q);
            dotProd += xC${colIndex} * vec4(wTexel.xz, wTexel.xz);
          `;
                if (colIndex + 1 < filterWidth) mainLoop += `
              wTexel = getW(r, ${colIndex + 1}, d1, q);
              dotProd += xC${colIndex + 1} * vec4(wTexel.xz, wTexel.xz);
            `;
            }
        }
        mainLoop += `
    }
  `;
        mainLoop += `
      }
    `;
        let activationSnippet = '', applyActivationSnippet = '';
        if (activation) {
            if (hasPreluActivation) activationSnippet = `vec4 activation(vec4 a) {
          vec4 b = getPreluActivationWeightsAtOutCoords();
          ${activation}
        }`;
            else if (hasLeakyReluAlpha) activationSnippet = `vec4 activation(vec4 a) {
          vec4 b = getLeakyreluAlphaAtOutCoords();
          ${activation}
        }`;
            else activationSnippet = `vec4 activation(vec4 x) {
          ${activation}
        }`;
            applyActivationSnippet = `result = activation(result);`;
        }
        const addBiasSnippet = addBias ? 'result += getBiasAtOutCoords();' : '';
        if (addBias) this.variableNames.push('bias');
        if (hasPreluActivation) this.variableNames.push('preluActivationWeights');
        if (hasLeakyReluAlpha) this.variableNames.push('leakyreluAlpha');
        this.userCode = `
      ${activationSnippet}

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords.x;
        ivec2 xRCCorner = coords.yz * strides - pads;
        int d2 = coords.w;
        int d1 = d2 / ${channelMul};
        int q = d2 - d1 * ${channelMul};
        int xRCorner = xRCCorner.x;
        int xCCorner = xRCCorner.y;

        //intialize dotProd with a small epsilon seems to reduce GPU accuracy loss.
        vec4 dotProd = vec4(0.000000000000001);

        ${mainLoop}

        vec4 result = dotProd - vec4(0.000000000000001);
        ${addBiasSnippet}
        ${applyActivationSnippet}
        setOutput(result);
      }
    `;
    }
}


function $3dc6eb74e808d751$export$14e793fe8822afd1(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter } = inputs;
    const { strides: strides, pad: pad, dilations: dilations, dimRoundingMode: dimRoundingMode } = attrs;
    let $dilations = dilations;
    if ($dilations == null) $dilations = [
        1,
        1
    ];
    (0, $i64bB.util).assert((0, $i64bB.backend_util).eitherStridesOrDilationsAreOne(strides, $dilations), ()=>'Error in depthwiseConv2d: Either strides or dilations must be ' + `1. Got strides ${strides} and dilations '${$dilations}'`);
    const convInfo = (0, $i64bB.backend_util).computeConv2DInfo(x.shape, filter.shape, strides, $dilations, pad, dimRoundingMode, true);
    let program;
    if ((0, $i64bB.env)().getBool('WEBGL_PACK_DEPTHWISECONV') && convInfo.strideWidth <= 2 && convInfo.outChannels / convInfo.inChannels === 1) program = new (0, $054208cd8d35acb6$export$acb9287627a2b170)(convInfo);
    else program = new (0, $65d096955c790267$export$4ead5a4ba22ede40)(convInfo);
    const customValues = [
        [
            convInfo.padInfo.top,
            convInfo.padInfo.left
        ],
        [
            convInfo.strideHeight,
            convInfo.strideWidth
        ],
        [
            convInfo.dilationHeight,
            convInfo.dilationWidth
        ],
        [
            convInfo.inHeight,
            convInfo.inWidth
        ]
    ];
    return backend.runWebGLProgram(program, [
        x,
        filter
    ], 'float32', customValues);
}
const $3dc6eb74e808d751$export$240667804b7c390e = {
    kernelName: (0, $i64bB.DepthwiseConv2dNative),
    backendName: 'webgl',
    kernelFunc: $3dc6eb74e808d751$export$14e793fe8822afd1
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $171328e2149f6e3d$export$9f5b7866589daeae {
    constructor(convInfo){
        this.variableNames = [
            'x',
            'dy'
        ];
        this.outputShape = convInfo.filterShape;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const padTop = convInfo.padInfo.top;
        const padLeft = convInfo.padInfo.left;
        const channelMul = convInfo.outChannels / convInfo.inChannels;
        this.userCode = `
      void main() {
        ivec4 coords = getOutputCoords();
        int wR = coords.x;
        int wC = coords.y;
        int d1 = coords.z;
        int dm = coords.w;
        int d2 = d1 * ${channelMul} + dm;

        float dotProd = 0.0;

        // TO DO: Vec4 over the batch size
        for (int b = 0; b < ${convInfo.batchSize}; b++) {
          for (int yR = 0; yR < ${convInfo.outHeight}; yR++) {
            int xR = wR + yR * ${strideHeight} - ${padTop};

            if (xR < 0 || xR >= ${convInfo.inHeight}) {
              continue;
            }

            for (int yC = 0; yC < ${convInfo.outWidth}; yC++) {
              int xC = wC + yC * ${strideWidth} - ${padLeft};

              if (xC < 0 || xC >= ${convInfo.inWidth}) {
                continue;
              }

              float dyValue = getDy(b, yR, yC, d2);
              float xValue = getX(b, xR, xC, d1);
              dotProd += (xValue * dyValue);
            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}
class $171328e2149f6e3d$export$9b7e054f73b1374b {
    constructor(convInfo){
        this.variableNames = [
            'dy',
            'W'
        ];
        this.outputShape = convInfo.inShape;
        const filterHeight = convInfo.filterHeight;
        const filterWidth = convInfo.filterWidth;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const padTop = filterHeight - 1 - convInfo.padInfo.top;
        const padLeft = filterWidth - 1 - convInfo.padInfo.left;
        const channelMul = convInfo.outChannels / convInfo.inChannels;
        this.userCode = `
      const ivec2 pads = ivec2(${padTop}, ${padLeft});

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords[0];
        int d1 = coords[3];
        ivec2 dyCorner = coords.yz - pads;
        int dyRCorner = dyCorner.x;
        int dyCCorner = dyCorner.y;

        float dotProd = 0.0;

        for (int wR = 0; wR < ${filterHeight}; wR++) {
          float dyR = float(dyRCorner + wR) / ${strideHeight}.0;

          if (dyR < 0.0 || dyR >= ${convInfo.outHeight}.0 || fract(dyR) > 0.0) {
            continue;
          }
          int idyR = int(dyR);

          int wRPerm = ${filterHeight} - 1 - wR;

          for (int wC = 0; wC < ${filterWidth}; wC++) {
            float dyC = float(dyCCorner + wC) / ${strideWidth}.0;

            if (dyC < 0.0 || dyC >= ${convInfo.outWidth}.0 ||
                fract(dyC) > 0.0) {
              continue;
            }
            int idyC = int(dyC);

            int wCPerm = ${filterWidth} - 1 - wC;

            // TO DO: Vec4 over the channelMul
            for (int dm = 0; dm < ${channelMul}; dm++) {
              int d2 = d1 * ${channelMul} + dm;
              float xValue = getDy(batch, idyR, idyC, d2);
              float wValue = getW(wRPerm, wCPerm, d1, dm);
              dotProd += xValue * wValue;
            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}


function $25fb5d98fa7976fa$export$cc0ae65e9edc7e1a(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, dy: dy } = inputs;
    const { strides: strides, dilations: dilations, pad: pad, dimRoundingMode: dimRoundingMode, filterShape: filterShape } = attrs;
    const convInfo = (0, $i64bB.backend_util).computeConv2DInfo(x.shape, filterShape, strides, dilations, pad, dimRoundingMode, true);
    const program = new (0, $171328e2149f6e3d$export$9f5b7866589daeae)(convInfo);
    return backend.runWebGLProgram(program, [
        x,
        dy
    ], 'float32');
}
const $25fb5d98fa7976fa$export$30bc0ac3775583fc = {
    kernelName: (0, $i64bB.DepthwiseConv2dNativeBackpropFilter),
    backendName: 'webgl',
    kernelFunc: $25fb5d98fa7976fa$export$cc0ae65e9edc7e1a
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

function $3ce31c59b66b30c6$export$37e2ab95a4a4c24b(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, filter: filter } = inputs;
    const { strides: strides, dilations: dilations, pad: pad, dimRoundingMode: dimRoundingMode, inputShape: inputShape } = attrs;
    const convInfo = (0, $i64bB.backend_util).computeConv2DInfo(inputShape, filter.shape, strides, dilations, pad, dimRoundingMode, true);
    const program = new (0, $171328e2149f6e3d$export$9b7e054f73b1374b)(convInfo);
    return backend.runWebGLProgram(program, [
        dy,
        filter
    ], 'float32');
}
const $3ce31c59b66b30c6$export$55d12409e744bebe = {
    kernelName: (0, $i64bB.DepthwiseConv2dNativeBackpropInput),
    backendName: 'webgl',
    kernelFunc: $3ce31c59b66b30c6$export$37e2ab95a4a4c24b
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $a463f4d9dada8901$export$d3d3824ae4245092 {
    constructor(size){
        this.variableNames = [
            'X'
        ];
        this.outputShape = [
            size,
            size
        ];
        this.userCode = `
      void main() {
          ivec2 coords = getOutputCoords();
          float val = coords[0] == coords[1] ? getX(coords[0]) : 0.0;
          setOutput(val);
      }
    `;
    }
}



function $dfdbed2ad431d135$export$c042e7c2f59bc046(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    const outShape = [
        ...x.shape,
        ...x.shape
    ];
    const xSize = (0, $i64bB.util).sizeFromShape(x.shape);
    const flat = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            shape: [
                xSize
            ]
        }
    });
    const program = new (0, $a463f4d9dada8901$export$d3d3824ae4245092)(xSize);
    const res = backend.runWebGLProgram(program, [
        flat
    ], flat.dtype);
    const out = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: res
        },
        backend: backend,
        attrs: {
            shape: outShape
        }
    });
    backend.disposeIntermediateTensorInfo(flat);
    backend.disposeIntermediateTensorInfo(res);
    return out;
}
const $dfdbed2ad431d135$export$56dc5d812a22748f = {
    kernelName: (0, $i64bB.Diag),
    backendName: 'webgl',
    kernelFunc: $dfdbed2ad431d135$export$c042e7c2f59bc046
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $17b0c55d9efd598a$export$b3acfd0493b4c03e {
    constructor(convInfo){
        this.variableNames = [
            'x',
            'W'
        ];
        this.outputShape = convInfo.outShape;
        const { inHeight: inHeight, inWidth: inWidth, padInfo: padInfo, strideHeight: strideHeight, strideWidth: strideWidth, filterHeight: filterHeight, filterWidth: filterWidth, dilationHeight: dilationHeight, dilationWidth: dilationWidth } = convInfo;
        const { top: padTop, left: padLeft } = padInfo;
        this.userCode = `
      const ivec2 strides = ivec2(${strideHeight}, ${strideWidth});
      const ivec2 pads = ivec2(${padTop}, ${padLeft});
      const float neg_infinity = -3.4e38;

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords.x;
        int d1 = coords.w;
        ivec2 outTopLeftCorner =
            coords.yz * strides - pads;
        int hBeg = outTopLeftCorner.x;
        int wBeg = outTopLeftCorner.y;

        float curVal = neg_infinity;
        for (int h = 0; h < ${filterHeight}; h++) {
          int hIn = hBeg + h * ${dilationHeight};

          if (hIn >= 0 && hIn < ${inHeight}) {
            for (int w = 0; w < ${filterWidth}; w++) {
              int wIn = wBeg + w * ${dilationWidth};

              if (wIn >= 0 && wIn < ${inWidth}) {
                float xVal = getX(batch, hIn, wIn, d1);
                float wVal = getW(h, w, d1);

                float val = xVal + wVal;
                if (val > curVal) {
                  curVal = val;
                }
              }
            }
          }
        }

        float result = curVal;
        setOutput(result);
      }
    `;
    }
}



function $7f951b7ac7fc14fd$export$544ec6096a7ab30(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter } = inputs;
    const { strides: strides, pad: pad, dilations: dilations } = attrs;
    const convInfo = (0, $i64bB.backend_util).computeDilation2DInfo(x.shape, filter.shape, strides, pad, 'NHWC' /* dataFormat */ , dilations);
    let out;
    const program = new (0, $17b0c55d9efd598a$export$b3acfd0493b4c03e)(convInfo);
    out = backend.runWebGLProgram(program, [
        x,
        filter
    ], 'float32');
    const outReshaped = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: out
        },
        backend: backend,
        attrs: {
            shape: convInfo.outShape
        }
    });
    backend.disposeIntermediateTensorInfo(out);
    return outReshaped;
}
const $7f951b7ac7fc14fd$export$36d3c11f61a8891a = {
    kernelName: (0, $i64bB.Dilation2D),
    backendName: 'webgl',
    kernelFunc: $7f951b7ac7fc14fd$export$544ec6096a7ab30
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");




function $d152d30c63739394$export$27265e7daac5c403(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { equation: equation } = attrs;
    const tensors = inputs;
    const { allDims: allDims, summedDims: summedDims, idDims: idDims } = (0, $i64bB.backend_util).decodeEinsumEquation(equation, tensors.length);
    (0, $i64bB.backend_util).checkEinsumDimSizes(allDims.length, idDims, tensors);
    const { path: path, steps: steps } = (0, $i64bB.backend_util).getEinsumComputePath(summedDims, idDims);
    const nSteps = steps.length;
    let out = null;
    let numDimsRemaining = allDims.length;
    const tensorsToDispose = [];
    for(let i = 0; i < nSteps; ++i){
        for (const idTerm of steps[i]){
            const { permutationIndices: perm, expandDims: dimsToExpand } = (0, $i64bB.backend_util).getEinsumPermutation(numDimsRemaining, idDims[idTerm]);
            let x;
            if ((0, $i64bB.backend_util).isIdentityPermutation(perm)) x = tensors[idTerm];
            else {
                x = (0, $6cab078553124169$export$9cb09a71b7d66923)({
                    inputs: {
                        x: tensors[idTerm]
                    },
                    backend: backend,
                    attrs: {
                        perm: perm
                    }
                });
                tensorsToDispose.push(x);
            }
            const targetShape = x.shape.slice();
            for(let k = 0; k < dimsToExpand.length; ++k)targetShape.splice(dimsToExpand[k], 0, 1);
            if (!(0, $i64bB.util).arraysEqual(x.shape, targetShape)) {
                x = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
                    inputs: {
                        x: x
                    },
                    backend: backend,
                    attrs: {
                        shape: targetShape
                    }
                });
                tensorsToDispose.push(x);
            }
            if (out === null) out = x;
            else {
                // tslint:disable-next-line: no-unnecessary-type-assertion
                out = (0, $14ecc88d5b9c3d28$export$2060d2db72cce88f)({
                    inputs: {
                        a: x,
                        b: out
                    },
                    backend: backend
                });
                tensorsToDispose.push(out);
            }
        }
        if (i < nSteps - 1) {
            if (path[i] >= 0) {
                out = (0, $579f4cd1cc49add3$export$8a63f25cc62965f1)({
                    inputs: {
                        x: out
                    },
                    backend: backend,
                    attrs: {
                        axis: path[i] - (allDims.length - numDimsRemaining),
                        keepDims: false
                    }
                });
                tensorsToDispose.push(out);
            }
            numDimsRemaining--;
        }
    }
    // Clean up intermediate tensors.
    for (const tensorInfo of tensorsToDispose){
        if (tensorInfo === out) continue;
        backend.disposeIntermediateTensorInfo(tensorInfo);
    }
    return out;
}
const $d152d30c63739394$export$40bbf341885a23b7 = {
    kernelName: (0, $i64bB.Einsum),
    backendName: 'webgl',
    kernelFunc: $d152d30c63739394$export$27265e7daac5c403
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

const $9c8866d19b592f1b$var$ELU = `return (x >= 0.0) ? x : (exp(x) - 1.0);`;
const $9c8866d19b592f1b$var$ELU_PACKED = `
  vec4 result;

  result.r = (x.r >= 0.0) ? x.r : (exp(x.r) - 1.0);
  result.g = (x.g >= 0.0) ? x.g : (exp(x.g) - 1.0);
  result.b = (x.b >= 0.0) ? x.b : (exp(x.b) - 1.0);
  result.a = (x.a >= 0.0) ? x.a : (exp(x.a) - 1.0);

  return result;
`;
const $9c8866d19b592f1b$var$elu = (0, $2e65282075da2b30$export$ba4daf5748026fba)({
    opSnippet: $9c8866d19b592f1b$var$ELU,
    packedOpSnippet: $9c8866d19b592f1b$var$ELU_PACKED
});
const $9c8866d19b592f1b$export$b990686634ee3cce = {
    kernelName: (0, $i64bB.Elu),
    backendName: 'webgl',
    kernelFunc: $9c8866d19b592f1b$var$elu
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


const $4cae63a555950558$var$ELU_DER = `return (b >= 0.0) ? a : a * (b + 1.0);`;
const $4cae63a555950558$var$ELU_DER_PACKED = `
  vec4 bGTEZero = vec4(greaterThanEqual(b, vec4(0.)));
  return (bGTEZero * a) + ((vec4(1.0) - bGTEZero) * (a * (b + vec4(1.0))));
`;
const $4cae63a555950558$export$a346244024505ff9 = (args)=>{
    const { inputs: inputs, backend: backend } = args;
    const { dy: dy, y: y } = inputs;
    const program = (0, $i64bB.env)().getBool('WEBGL_PACK_BINARY_OPERATIONS') ? new (0, $1b00798c48aa5c1a$export$7ef3bdc75c177be0)($4cae63a555950558$var$ELU_DER_PACKED, dy.shape, y.shape) : new (0, $a3544edc66d558ba$export$9045e9161086790b)($4cae63a555950558$var$ELU_DER, dy.shape, y.shape);
    return backend.runWebGLProgram(program, [
        dy,
        y
    ], dy.dtype);
};
const $4cae63a555950558$export$59bb07dd04647a1d = {
    kernelName: (0, $i64bB.EluGrad),
    backendName: 'webgl',
    kernelFunc: $4cae63a555950558$export$a346244024505ff9
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


const $788ea5612f442218$var$PACKED_EQUAL = `
  return vec4(equal(a, b));
`;
const $788ea5612f442218$var$EQUAL = `return float(a == b);`;
const $788ea5612f442218$export$411ce8e5a71e3069 = (0, $2e65282075da2b30$export$29353c66e70e3e16)({
    opSnippet: $788ea5612f442218$var$EQUAL,
    packedOpSnippet: $788ea5612f442218$var$PACKED_EQUAL,
    dtype: 'bool',
    cpuKernelImpl: (0, $377486a788efd20b$export$13d1298222b29d06)
});
const $788ea5612f442218$export$3c8bc3d8ee318217 = {
    kernelName: (0, $i64bB.Equal),
    backendName: 'webgl',
    kernelFunc: $788ea5612f442218$export$411ce8e5a71e3069
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

const $c314644caa7f3634$var$ERF = `
  // Error function is calculated approximately with elementary function.
  // See "Handbook of Mathematical Functions with Formulas,
  // Graphs, and Mathematical Tables", Abramowitz and Stegun.
  float p = ${(0, $i64bB.backend_util).ERF_P};
  float a1 = ${(0, $i64bB.backend_util).ERF_A1};
  float a2 = ${(0, $i64bB.backend_util).ERF_A2};
  float a3 = ${(0, $i64bB.backend_util).ERF_A3};
  float a4 = ${(0, $i64bB.backend_util).ERF_A4};
  float a5 = ${(0, $i64bB.backend_util).ERF_A5};

  float sign = sign(x);
  x = abs(x);
  float t = 1.0 / (1.0 + p * x);
  return sign * (1.0 - (((((a5*t + a4)*t) + a3)*t + a2)*t + a1)*t*exp(-x*x));
`;
const $c314644caa7f3634$export$d3896f355fc09423 = (0, $2e65282075da2b30$export$ba4daf5748026fba)({
    opSnippet: $c314644caa7f3634$var$ERF
});
const $c314644caa7f3634$export$d044ffef16079bd = {
    kernelName: (0, $i64bB.Erf),
    backendName: 'webgl',
    kernelFunc: $c314644caa7f3634$export$d3896f355fc09423
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


const $f564a957992b7970$export$e17bfbab9ca97165 = (0, $2e65282075da2b30$export$bf39b1cb254b6187) + `
  return exp(x);
`;
const $f564a957992b7970$var$EXP_PACKED = `
  vec4 result = exp(x);
  bvec4 isNaN = isnan(x);
  result.r = isNaN.r ? x.r : result.r;
  result.g = isNaN.g ? x.g : result.g;
  result.b = isNaN.b ? x.b : result.b;
  result.a = isNaN.a ? x.a : result.a;

  return result;
`;
const $f564a957992b7970$export$b310ec824aaee37f = (0, $2e65282075da2b30$export$ba4daf5748026fba)({
    opSnippet: $f564a957992b7970$export$e17bfbab9ca97165,
    packedOpSnippet: $f564a957992b7970$var$EXP_PACKED,
    cpuKernelImpl: (0, $377486a788efd20b$export$f72e179c9610cb8c),
    dtype: 'float32'
});
const $f564a957992b7970$export$2fd7ea0fcf021f34 = {
    kernelName: (0, $i64bB.Exp),
    backendName: 'webgl',
    kernelFunc: $f564a957992b7970$export$b310ec824aaee37f
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

function $0d346f16979dfda2$export$d660d8ed21f46635(args) {
    const { inputs: inputs, attrs: attrs, backend: backend } = args;
    const { dim: dim } = attrs;
    const { input: input } = inputs;
    const inputRank = input.shape.length;
    const newShape = input.shape.slice();
    let $dim = dim;
    if (dim < 0) {
        // Negative value is counted from the tail of rank.
        (0, $i64bB.util).assert(-(inputRank + 1) <= dim, ()=>`Axis must be in the interval [${-(inputRank + 1)}, ${inputRank}]`);
        $dim = inputRank + dim + 1;
    }
    newShape.splice($dim, 0, 1);
    return (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: input
        },
        backend: backend,
        attrs: {
            shape: newShape
        }
    });
}
const $0d346f16979dfda2$export$86341ba0ce5d8e60 = {
    kernelName: (0, $i64bB.ExpandDims),
    backendName: 'webgl',
    kernelFunc: $0d346f16979dfda2$export$d660d8ed21f46635
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


const $c399b2eaa41286db$var$EXPM1 = `return exp(x) - 1.0;`;
const $c399b2eaa41286db$export$b6c0a80d46d3391d = (0, $2e65282075da2b30$export$ba4daf5748026fba)({
    opSnippet: $c399b2eaa41286db$var$EXPM1,
    packedOpSnippet: $c399b2eaa41286db$var$EXPM1,
    cpuKernelImpl: (0, $377486a788efd20b$export$5903785c29f035f5)
});
const $c399b2eaa41286db$export$16db8a08b36f938 = {
    kernelName: (0, $i64bB.Expm1),
    backendName: 'webgl',
    kernelFunc: $c399b2eaa41286db$export$b6c0a80d46d3391d
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $a91394764ead5c91$export$234ba885e3a114f6 {
    constructor(component, inputShape, inverse){
        this.variableNames = [
            'real',
            'imag'
        ];
        const innerDim = inputShape[1];
        this.outputShape = inputShape;
        const exponentMultiplierSnippet = inverse ? `2.0 * ${Math.PI}` : `-2.0 * ${Math.PI}`;
        const resultDenominator = inverse ? `${innerDim}.0` : '1.0';
        let opString;
        if (component === 'real') opString = 'return real * expR - imag * expI;';
        else if (component === 'imag') opString = 'return real * expI + imag * expR;';
        else throw new Error(`FFT component must be either "real" or "imag", got ${component}.`);
        this.userCode = `
      const float exponentMultiplier = ${exponentMultiplierSnippet};

      float unaryOpComplex(float real, float expR, float imag, float expI) {
        ${opString}
      }

      float mulMatDFT(int batch, int index) {
        float indexRatio = float(index) / float(${innerDim});
        float exponentMultiplierTimesIndexRatio =
            exponentMultiplier * indexRatio;

        float result = 0.0;

        for (int i = 0; i < ${innerDim}; i++) {
          // x = (-2|2 * PI / N) * index * i;
          float x = exponentMultiplierTimesIndexRatio * float(i);
          float expR = cos(x);
          float expI = sin(x);
          float real = getReal(batch, i);
          float imag = getImag(batch, i);

          result +=
              unaryOpComplex(real, expR, imag, expI) / ${resultDenominator};
        }

        return result;
      }

      void main() {
        ivec2 coords = getOutputCoords();
        setOutput(mulMatDFT(coords[0], coords[1]));
      }
    `;
    }
}




function $e726cfbb4c8c6f27$export$75d3742a7578721e(x, inverse, backend) {
    const xData = backend.texData.get(x.dataId);
    const inputSize = (0, $i64bB.util).sizeFromShape(x.shape);
    // Collapse all outer dimensions to a single batch dimension.
    const innerDimensionSize = x.shape[x.shape.length - 1];
    const batch = inputSize / innerDimensionSize;
    const input2D = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            shape: [
                batch,
                innerDimensionSize
            ]
        }
    });
    const xShape = input2D.shape;
    const realProgram = new (0, $a91394764ead5c91$export$234ba885e3a114f6)('real', xShape, inverse);
    const imagProgram = new (0, $a91394764ead5c91$export$234ba885e3a114f6)('imag', xShape, inverse);
    const inputs = [
        {
            dataId: xData.complexTensorInfos.real.dataId,
            dtype: xData.complexTensorInfos.real.dtype,
            shape: xShape
        },
        {
            dataId: xData.complexTensorInfos.imag.dataId,
            dtype: xData.complexTensorInfos.imag.dtype,
            shape: xShape
        }
    ];
    const realPart = backend.runWebGLProgram(realProgram, inputs, 'float32');
    const imagPart = backend.runWebGLProgram(imagProgram, inputs, 'float32');
    const complexOutput = (0, $f23c2381cb68ff19$export$83a0e34f1302825b)({
        inputs: {
            real: realPart,
            imag: imagPart
        },
        backend: backend
    });
    backend.disposeIntermediateTensorInfo(realPart);
    backend.disposeIntermediateTensorInfo(imagPart);
    const complexOutputReshaped = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: complexOutput
        },
        backend: backend,
        attrs: {
            shape: x.shape
        }
    });
    backend.disposeIntermediateTensorInfo(input2D);
    backend.disposeIntermediateTensorInfo(complexOutput);
    return complexOutputReshaped;
}


function $4597301918ebe5d9$export$a535ef183b6128fa(args) {
    const { inputs: inputs, backend: backend } = args;
    const { input: input } = inputs;
    return (0, $e726cfbb4c8c6f27$export$75d3742a7578721e)(input, false, backend);
}
const $4597301918ebe5d9$export$a4d564e380763c78 = {
    kernelName: (0, $i64bB.FFT),
    backendName: 'webgl',
    kernelFunc: $4597301918ebe5d9$export$a535ef183b6128fa
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $b96717f71b3ca381$export$758181b12323e997 {
    constructor(shape, value){
        this.outputShape = [];
        this.customUniforms = [
            {
                name: 'value',
                type: 'float'
            }
        ];
        this.variableNames = [
            'x'
        ];
        this.outputShape = shape;
        this.userCode = `
      void main() {
        // Input can be obtained from uniform value.
        setOutput(value);
      }
    `;
    }
}


function $248d06c44cbf77ee$export$9563e054e6f787fb(args) {
    const { backend: backend, attrs: attrs } = args;
    const { shape: shape, value: value } = attrs;
    let { dtype: dtype } = attrs;
    dtype = dtype || (0, $i64bB.util).inferDtype(value);
    if (dtype === 'string') {
        // String type should be handled in CPU memory.
        const values = (0, $i64bB.util).getArrayFromDType(dtype, (0, $i64bB.util).sizeFromShape(shape));
        values.fill(value);
        return backend.makeTensorInfo(shape, dtype, values);
    } else {
        const program = new (0, $b96717f71b3ca381$export$758181b12323e997)(shape, value);
        const customValues = [
            [
                value
            ]
        ];
        return backend.runWebGLProgram(program, [], dtype, customValues);
    }
}
const $248d06c44cbf77ee$export$c953bf474b2bde62 = {
    kernelName: (0, $i64bB.Fill),
    backendName: 'webgl',
    kernelFunc: $248d06c44cbf77ee$export$9563e054e6f787fb
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $252bc2969d4089fe$export$872622c1de722f28 {
    constructor(imageShape){
        this.variableNames = [
            'Image'
        ];
        this.outputShape = [];
        const imageWidth = imageShape[2];
        this.outputShape = imageShape;
        this.userCode = `
        void main() {
          ivec4 coords = getOutputCoords();
          int x = coords[2];

          int coordX = ${imageWidth} - x - 1;
          float outputValue;
          if(coordX >= 0 && coordX < ${imageWidth}) {
            outputValue = getImage(coords[0], coords[1], coordX, coords[3]);
          } else {
            outputValue = getImage(coords[0], coords[1], coords[2], coords[3]);
          }
          setOutput(outputValue);
        }
    `;
    }
}


const $ea3eeae1bf3305ed$export$c9ec83cb23304466 = {
    kernelName: (0, $i64bB.FlipLeftRight),
    backendName: 'webgl',
    kernelFunc: ({ inputs: inputs, backend: backend })=>{
        const { image: image } = inputs;
        const webglBackend = backend;
        const program = new (0, $252bc2969d4089fe$export$872622c1de722f28)(image.shape);
        const output = webglBackend.runWebGLProgram(program, [
            image
        ], image.dtype);
        return output;
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


const $24be6ac7d51ef330$var$FLOOR = `return floor(x);`;
const $24be6ac7d51ef330$export$a3fe094919f356fd = (0, $2e65282075da2b30$export$ba4daf5748026fba)({
    opSnippet: $24be6ac7d51ef330$var$FLOOR,
    packedOpSnippet: $24be6ac7d51ef330$var$FLOOR,
    cpuKernelImpl: (0, $377486a788efd20b$export$195a28e6add8ab7e)
});
const $24be6ac7d51ef330$export$7e9a0f96fa6bd01c = {
    kernelName: (0, $i64bB.Floor),
    backendName: 'webgl',
    kernelFunc: $24be6ac7d51ef330$export$a3fe094919f356fd
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

// We use native integer division to deal with floating point imprecision. Since
// we implement floor division and glsl implements truncated division, we
// correct for this by subtracting 1 from result when the result is negative and
// there is a remainder.
const $9fd7092a51fba04c$var$INT_DIV = `
  float s = sign(a) * sign(b);
  int ia = round(a);
  int ib = round(b);
  if (ib != 0) {
    // Windows (D3D) wants guaranteed non-zero int division at compile-time.
    return float(idiv(ia, ib, s));
  } else {
    return NAN;
  }
`;
const $9fd7092a51fba04c$var$INT_DIV_PACKED = `
  ivec4 ia = round(a);
  ivec4 ib = round(b);
  bvec4 cond = notEqual(ib, ivec4(0));
  ivec4 result = ivec4(0);
  vec4 s = sign(a) * sign(b);

  // Windows (D3D) wants guaranteed non-zero int division at compile-time.
  if (cond[0]) {
    result[0] = idiv(ia[0], ib[0], s[0]);
  }
  if (cond[1]) {
    result[1] = idiv(ia[1], ib[1], s[1]);
  }
  if (cond[2]) {
    result[2] = idiv(ia[2], ib[2], s[2]);
  }
  if (cond[3]) {
    result[3] = idiv(ia[3], ib[3], s[3]);
  }
  return vec4(result);
`;
const $9fd7092a51fba04c$export$112397bc52715a8 = (0, $2e65282075da2b30$export$29353c66e70e3e16)({
    opSnippet: $9fd7092a51fba04c$var$INT_DIV,
    packedOpSnippet: $9fd7092a51fba04c$var$INT_DIV_PACKED,
    dtype: 'int32'
});
const $9fd7092a51fba04c$export$7eac933a0c7fd37f = {
    kernelName: (0, $i64bB.FloorDiv),
    backendName: 'webgl',
    kernelFunc: $9fd7092a51fba04c$export$112397bc52715a8
};


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
class $a2f970a6ce5c2e84$export$7ffba7be7a218615 {
    constructor(outputShape){
        this.variableNames = [
            'A'
        ];
        const glsl = (0, $29bc34f3341b4730$export$3ebf4a18d6319f7a)();
        const [height, width] = outputShape;
        this.outputShape = outputShape;
        this.userCode = `
      void main() {
        ivec3 coords = getOutputCoords();
        int texR = coords[0];
        int texC = coords[1];
        int depth = coords[2];
        vec2 uv = (vec2(texC, texR) + halfCR) / vec2(${width}.0, ${height}.0);

        vec4 values = ${glsl.texture2D}(A, uv);
        float value;
        if (depth == 0) {
          value = values.r;
        } else if (depth == 1) {
          value = values.g;
        } else if (depth == 2) {
          value = values.b;
        } else if (depth == 3) {
          value = values.a;
        }

        setOutput(floor(value * 255.0 + 0.5));
      }
    `;
    }
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
class $c7b8f4e705589f2e$export$5f4cf05de268f9cf {
    constructor(outputShape){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = false;
        this.packedOutput = true;
        const glsl = (0, $29bc34f3341b4730$export$3ebf4a18d6319f7a)();
        const [height, width] = outputShape;
        this.outputShape = outputShape;
        this.userCode = `
      void main() {
        ivec3 coords = getOutputCoords();
        int texR = coords[0];
        int texC = coords[1];
        int depth = coords[2];

        vec4 result = vec4(0.);

        for(int row=0; row<=1; row++) {
          for(int col=0; col<=1; col++) {
            texC = coords[1] + row;
            depth = coords[2] + col;

            vec2 uv = (vec2(texC, texR) + halfCR) /
                       vec2(${width}.0, ${height}.0);
            vec4 values = ${glsl.texture2D}(A, uv);
            float value;
            if (depth == 0) {
              value = values.r;
            } else if (depth == 1) {
              value = values.g;
            } else if (depth == 2) {
              value = values.b;
            } else if (depth == 3) {
              value = values.a;
            }

            result[row * 2 + col] = floor(value * 255.0 + 0.5);
          }
        }

        ${glsl.output} = result;
      }
    `;
    }
}


const $584621bf945dd066$export$b22e14d614fc7178 = {
    kernelName: (0, $i64bB.FromPixels),
    backendName: 'webgl',
    kernelFunc: $584621bf945dd066$var$fromPixels
};
let $584621bf945dd066$var$fromPixels2DContext;
let $584621bf945dd066$var$willReadFrequently = (0, $i64bB.env)().getBool('CANVAS2D_WILL_READ_FREQUENTLY_FOR_GPU');
function $584621bf945dd066$var$fromPixels(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    let { pixels: pixels } = inputs;
    const { numChannels: numChannels } = attrs;
    const isVideo = typeof HTMLVideoElement !== 'undefined' && pixels instanceof HTMLVideoElement;
    const isImage = typeof HTMLImageElement !== 'undefined' && pixels instanceof HTMLImageElement;
    const [width, height] = isVideo ? [
        pixels.videoWidth,
        pixels.videoHeight
    ] : [
        pixels.width,
        pixels.height
    ];
    const texShape = [
        height,
        width
    ];
    const outShape = [
        height,
        width,
        numChannels
    ];
    if (isImage || isVideo) {
        const newWillReadFrequently = (0, $i64bB.env)().getBool('CANVAS2D_WILL_READ_FREQUENTLY_FOR_GPU');
        if ($584621bf945dd066$var$fromPixels2DContext == null || newWillReadFrequently !== $584621bf945dd066$var$willReadFrequently) {
            $584621bf945dd066$var$willReadFrequently = newWillReadFrequently;
            $584621bf945dd066$var$fromPixels2DContext = document.createElement('canvas').getContext('2d', {
                willReadFrequently: $584621bf945dd066$var$willReadFrequently
            });
        }
        $584621bf945dd066$var$fromPixels2DContext.canvas.width = width;
        $584621bf945dd066$var$fromPixels2DContext.canvas.height = height;
        $584621bf945dd066$var$fromPixels2DContext.drawImage(pixels, 0, 0, width, height);
        pixels = $584621bf945dd066$var$fromPixels2DContext.canvas;
    }
    const tempPixelHandle = backend.makeTensorInfo(texShape, 'int32');
    // This is a byte texture with pixels.
    backend.texData.get(tempPixelHandle.dataId).usage = (0, $c7d2caaa716d42d2$export$6bf4bd1b6beb0bfd).PIXELS;
    backend.gpgpu.uploadPixelDataToTexture(backend.getTexture(tempPixelHandle.dataId), pixels);
    const program = (0, $i64bB.env)().getBool('WEBGL_PACK') ? new (0, $c7b8f4e705589f2e$export$5f4cf05de268f9cf)(outShape) : new (0, $a2f970a6ce5c2e84$export$7ffba7be7a218615)(outShape);
    const res = backend.runWebGLProgram(program, [
        tempPixelHandle
    ], 'int32');
    backend.disposeData(tempPixelHandle.dataId);
    return res;
}


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");





function $c695c8cad511bf86$export$b4f4a900a93010a(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter, bias: bias, preluActivationWeights: preluActivationWeights } = inputs;
    const { strides: strides, pad: pad, dataFormat: dataFormat, dilations: dilations, dimRoundingMode: dimRoundingMode, activation: activation, leakyreluAlpha: leakyreluAlpha } = attrs;
    const $dataFormat = (0, $i64bB.backend_util).convertConv2DDataFormat(dataFormat);
    const convInfo = (0, $i64bB.backend_util).computeConv2DInfo(x.shape, filter.shape, strides, dilations, pad, dimRoundingMode, false, $dataFormat);
    let out;
    const intermediates = [];
    const hasBias = bias != null;
    const hasPreluActivationWeights = preluActivationWeights != null;
    const hasLeakyreluAlpha = activation === 'leakyrelu';
    const prepareInputs = ()=>{
        const inputs = [
            x,
            filter
        ];
        // If the input is a 1-D tensor, align it with the channels.
        //
        // For fusedConv2d, the inputs (x, W, bias, preluActivationWeights) are
        // supposed to be aligned with the dataFormat. The 4-D tensor inputs or
        // scalar inputs are originally aligned, but the 1-D tensor inputs are
        // supposed to be aligned with the channels (only bias and PReLU activation
        // weights could be a 1-D tensor).
        const alignInputWithDataFormat = (input, dataFormat)=>{
            if (dataFormat === 'NCHW' && input.shape.length === 1 && input.shape[0] !== 1) {
                const alignedInput = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
                    inputs: {
                        x: input
                    },
                    backend: backend,
                    attrs: {
                        shape: [
                            input.shape[0],
                            1,
                            1
                        ]
                    }
                });
                intermediates.push(alignedInput);
                return alignedInput;
            }
            return input;
        };
        if (hasBias) inputs.push(alignInputWithDataFormat(bias, dataFormat));
        if (hasPreluActivationWeights) inputs.push(alignInputWithDataFormat(preluActivationWeights, dataFormat));
        if (hasLeakyreluAlpha) {
            const $leakyreluAlpha = backend.makeTensorInfo([], 'float32', (0, $i64bB.util).createScalarValue(leakyreluAlpha, 'float32'));
            inputs.push($leakyreluAlpha);
            intermediates.push($leakyreluAlpha);
        }
        return inputs;
    };
    if (convInfo.filterHeight === 1 && convInfo.filterWidth === 1 && convInfo.dilationHeight === 1 && convInfo.dilationWidth === 1 && convInfo.strideHeight === 1 && convInfo.strideWidth === 1 && (convInfo.padInfo.type === 'SAME' || convInfo.padInfo.type === 'VALID')) out = (0, $85dc903272166754$export$fe56ce0f8b4bfd45)({
        x: x,
        filter: filter,
        convInfo: convInfo,
        backend: backend,
        bias: bias,
        activation: activation,
        preluActivationWeights: preluActivationWeights,
        leakyreluAlpha: leakyreluAlpha
    });
    else if (convInfo.strideWidth <= 2 && $dataFormat === 'channelsLast' && (0, $i64bB.env)().getBool('WEBGL_EXP_CONV')) {
        const fusedActivation = activation ? (0, $2e65282075da2b30$export$445d43a4039ec7b7)(activation, true) : null;
        const program = new (0, $c9e97af83bddceba$export$20f35e9a79361289)(convInfo, hasBias, fusedActivation, hasPreluActivationWeights, hasLeakyreluAlpha);
        const customValues = [
            [
                convInfo.padInfo.top,
                convInfo.padInfo.left
            ],
            [
                convInfo.strideHeight,
                convInfo.strideWidth
            ],
            [
                convInfo.dilationHeight,
                convInfo.dilationWidth
            ],
            [
                convInfo.inHeight,
                convInfo.inWidth
            ]
        ];
        const inputs = prepareInputs();
        out = backend.runWebGLProgram(program, inputs, 'float32', customValues);
    } else if ((0, $i64bB.env)().getBool('WEBGL_CONV_IM2COL')) out = (0, $85dc903272166754$export$65b699e5c77381b8)({
        x: x,
        filter: filter,
        convInfo: convInfo,
        backend: backend,
        bias: bias,
        activation: activation,
        preluActivationWeights: preluActivationWeights,
        leakyreluAlpha: leakyreluAlpha
    });
    else {
        const fusedActivation = activation ? (0, $2e65282075da2b30$export$445d43a4039ec7b7)(activation, false) : null;
        const program = new (0, $65122774589fac9b$export$8dc36706147178e9)(convInfo, hasBias, fusedActivation, hasPreluActivationWeights, hasLeakyreluAlpha);
        const inputs = prepareInputs();
        out = backend.runWebGLProgram(program, inputs, 'float32');
    }
    const outReshaped = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: out
        },
        backend: backend,
        attrs: {
            shape: convInfo.outShape
        }
    });
    intermediates.push(out);
    intermediates.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return outReshaped;
}
const $c695c8cad511bf86$export$5b64efa829ddf94e = {
    kernelName: (0, $i64bB.FusedConv2D),
    backendName: 'webgl',
    kernelFunc: $c695c8cad511bf86$export$b4f4a900a93010a
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");



function $aa836a252d269e1d$export$d61de7729228094b(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter, bias: bias, preluActivationWeights: preluActivationWeights } = inputs;
    const { strides: strides, pad: pad, dilations: dilations, dimRoundingMode: dimRoundingMode, activation: activation, leakyreluAlpha: leakyreluAlpha } = attrs;
    const intermediates = [];
    let $dilations = dilations;
    if ($dilations == null) $dilations = [
        1,
        1
    ];
    (0, $i64bB.util).assert((0, $i64bB.backend_util).eitherStridesOrDilationsAreOne(strides, $dilations), ()=>'Error in depthwiseConv2d: Either strides or dilations must be ' + `1. Got strides ${strides} and dilations '${$dilations}'`);
    const convInfo = (0, $i64bB.backend_util).computeConv2DInfo(x.shape, filter.shape, strides, $dilations, pad, dimRoundingMode, true);
    const shouldPackDepthwiseConv = (0, $i64bB.env)().getBool('WEBGL_PACK_DEPTHWISECONV') && convInfo.strideWidth <= 2 && convInfo.outChannels / convInfo.inChannels === 1;
    const fusedActivation = activation ? (0, $2e65282075da2b30$export$445d43a4039ec7b7)(activation, shouldPackDepthwiseConv) : null;
    const programInputs = [
        x,
        filter
    ];
    const hasBias = bias != null;
    const hasPreluActivationWeights = preluActivationWeights != null;
    const hasLeakyreluAlpha = activation === 'leakyrelu';
    if (hasBias) programInputs.push(bias);
    if (hasPreluActivationWeights) programInputs.push(preluActivationWeights);
    if (hasLeakyreluAlpha) {
        const $leakyreluAlpha = backend.makeTensorInfo([], 'float32', (0, $i64bB.util).createScalarValue(leakyreluAlpha, 'float32'));
        programInputs.push($leakyreluAlpha);
        intermediates.push($leakyreluAlpha);
    }
    let program;
    if (shouldPackDepthwiseConv) program = new (0, $054208cd8d35acb6$export$acb9287627a2b170)(convInfo, hasBias, fusedActivation, hasPreluActivationWeights, hasLeakyreluAlpha);
    else program = new (0, $65d096955c790267$export$4ead5a4ba22ede40)(convInfo, hasBias, fusedActivation, hasPreluActivationWeights, hasLeakyreluAlpha);
    const customValues = [
        [
            convInfo.padInfo.top,
            convInfo.padInfo.left
        ],
        [
            convInfo.strideHeight,
            convInfo.strideWidth
        ],
        [
            convInfo.dilationHeight,
            convInfo.dilationWidth
        ],
        [
            convInfo.inHeight,
            convInfo.inWidth
        ]
    ];
    const result = backend.runWebGLProgram(program, programInputs, 'float32', customValues);
    intermediates.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return result;
}
const $aa836a252d269e1d$export$58481cc3409b412c = {
    kernelName: (0, $i64bB.FusedDepthwiseConv2D),
    backendName: 'webgl',
    kernelFunc: $aa836a252d269e1d$export$d61de7729228094b
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

class $a0147c1cd3290912$export$ffd508d535a7dba1 {
    constructor(sliceDim, strides, shape, paramsShape){
        this.sliceDim = sliceDim;
        this.strides = strides;
        this.paramsShape = paramsShape;
        this.variableNames = [
            'x',
            'indices'
        ];
        this.outputShape = shape;
        const dtype = (0, $ba2c54ffbda39e8e$export$859efd105c10c755)(shape.length);
        let mainLoop = `
    int index;`;
        for(let j = 0; j < this.sliceDim; j++)mainLoop += `
          index = round(getIndices(coords[0], ${j}));
          out_of_bounds = out_of_bounds || index < 0;
          out_of_bounds = out_of_bounds || index >= ${this.paramsShape[j]};
          flattenIndex += index * ${this.strides[j]};`;
        this.userCode = `
         void main() {
          ${dtype} coords = getOutputCoords();
          int flattenIndex = 0;
          bool out_of_bounds = false;

          ${mainLoop}

          setOutput(out_of_bounds ? 0.0 : getX(flattenIndex, coords[1]));
        }
      `;
    }
}




function $4266c995ff3a7172$export$3c586830e482d2b9(args) {
    const { inputs: inputs, backend: backend } = args;
    const { params: params, indices: indices } = inputs;
    const indicesShape = indices.shape;
    const sliceRank = indicesShape[indicesShape.length - 1];
    const paramsSize = (0, $i64bB.util).sizeFromShape(params.shape);
    const [resultShape, numSlices, sliceSize, strides] = (0, $i64bB.backend_util).prepareAndValidate(params, indices);
    const flattenIndices = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: indices
        },
        backend: backend,
        attrs: {
            shape: [
                numSlices,
                sliceRank
            ]
        }
    });
    const flattenX = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: params
        },
        backend: backend,
        attrs: {
            shape: [
                (0, $i64bB.util).sizeFromShape(params.shape) / sliceSize,
                sliceSize
            ]
        }
    });
    if (backend.shouldExecuteOnCPU([
        params,
        indices
    ]) || params.dtype === 'string') {
        const indicesData = backend.readSync(indices.dataId);
        const paramsBuf = backend.bufferSync(params);
        const outValue = (0, $377486a788efd20b$export$e3196a12dce24214)(indicesData, paramsBuf, params.dtype, numSlices, sliceRank, sliceSize, strides, params.shape, paramsSize);
        return backend.makeTensorInfo(resultShape, params.dtype, outValue.values);
    }
    const program = new (0, $a0147c1cd3290912$export$ffd508d535a7dba1)(sliceRank, strides, [
        numSlices,
        sliceSize
    ], params.shape);
    const res = backend.runWebGLProgram(program, [
        flattenX,
        flattenIndices
    ], flattenX.dtype);
    const reshaped = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: res
        },
        backend: backend,
        attrs: {
            shape: resultShape
        }
    });
    backend.disposeIntermediateTensorInfo(flattenIndices);
    backend.disposeIntermediateTensorInfo(flattenX);
    backend.disposeIntermediateTensorInfo(res);
    return reshaped;
}
const $4266c995ff3a7172$export$d9700eb1c7f5c969 = {
    kernelName: (0, $i64bB.GatherNd),
    backendName: 'webgl',
    kernelFunc: $4266c995ff3a7172$export$3c586830e482d2b9
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
class $22dedc65b409d304$export$e8921930334c8ed5 {
    constructor(aShape, outputShape){
        this.variableNames = [
            'A',
            'indices'
        ];
        this.outputShape = outputShape;
        this.rank = outputShape.length;
        const dtype = (0, $ba2c54ffbda39e8e$export$859efd105c10c755)(this.rank);
        const sourceCoords = $22dedc65b409d304$var$getSourceCoords(aShape, 2);
        this.userCode = `
      void main() {
        ${dtype} resRC = getOutputCoords();
        int index = int(getIndices(resRC.x, resRC.z));
        float inBounds = (index >= 0) && (index < ${aShape[2]}) ? 1.0 : 0.0;
        setOutput(inBounds * getA(${sourceCoords}));
      }
    `;
    }
}
// The input and output are always flattened into rank 4 tensors.
function $22dedc65b409d304$var$getSourceCoords(aShape, axis) {
    const currentCoords = [
        'resRC.x',
        'resRC.y',
        'resRC.z',
        'resRC.w'
    ];
    const sourceCoords = [];
    for(let i = 0; i < aShape.length; i++)if (i === 2) sourceCoords.push('index');
    else sourceCoords.push(`${currentCoords[i]}`);
    return sourceCoords.join();
}




function $9675e221f7767bae$export$3d75b4295ded9925(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, indices: indices } = inputs;
    const { axis: axis, batchDims: batchDims } = attrs;
    const parsedAxis = (0, $i64bB.util).parseAxisParam(axis, x.shape)[0];
    if ((0, $i64bB.env)().get('DEBUG')) {
        // In debug mode, throw error when any index is out of bound.
        // Otherwise, just fill out of bounds with zeroes.
        const indicesVals = backend.readSync(indices.dataId);
        const axisDim = x.shape[parsedAxis];
        for(let i = 0; i < indicesVals.length; ++i){
            const index = indicesVals[i];
            (0, $i64bB.util).assert(index <= axisDim - 1 && index >= 0, ()=>`GatherV2: the index value ${index} is not in [0, ${axisDim - 1}]`);
        }
    }
    const shapeInfo = (0, $i64bB.backend_util).segment_util.collectGatherOpShapeInfo(x, indices, parsedAxis, batchDims);
    const indicesSize = (0, $i64bB.util).sizeFromShape(indices.shape);
    const toDispose = [];
    const flattenX = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            shape: [
                shapeInfo.batchSize,
                shapeInfo.outerSize,
                shapeInfo.dimSize,
                shapeInfo.sliceSize
            ]
        }
    });
    const flattenIndex = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: indices
        },
        backend: backend,
        attrs: {
            shape: [
                shapeInfo.batchSize,
                indicesSize / shapeInfo.batchSize
            ]
        }
    });
    toDispose.push(flattenX);
    toDispose.push(flattenIndex);
    const flattenOutputShape = [
        shapeInfo.batchSize,
        shapeInfo.outerSize,
        indicesSize / shapeInfo.batchSize,
        shapeInfo.sliceSize
    ];
    if (backend.shouldExecuteOnCPU([
        x,
        indices
    ]) || x.dtype === 'string') {
        const indicesBuf = backend.bufferSync(flattenIndex);
        const xBuf = backend.bufferSync(flattenX);
        const outBuf = (0, $377486a788efd20b$export$cffe0fde89e98de6)(xBuf, indicesBuf, flattenOutputShape);
        toDispose.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
        return backend.makeTensorInfo(shapeInfo.outputShape, outBuf.dtype, outBuf.values);
    }
    const program = new (0, $22dedc65b409d304$export$e8921930334c8ed5)(flattenX.shape, flattenOutputShape);
    const res = backend.runWebGLProgram(program, [
        flattenX,
        flattenIndex
    ], flattenX.dtype);
    toDispose.push(res);
    const reshaped = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: res
        },
        backend: backend,
        attrs: {
            shape: shapeInfo.outputShape
        }
    });
    toDispose.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return reshaped;
}
const $9675e221f7767bae$export$b1bd3139c91d8765 = {
    kernelName: (0, $i64bB.GatherV2),
    backendName: 'webgl',
    kernelFunc: $9675e221f7767bae$export$3d75b4295ded9925
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


const $d8ef954c91d00c6a$var$GREATER = `return float(a > b);`;
const $d8ef954c91d00c6a$var$GREATER_PACKED = `
  return vec4(greaterThan(a, b));
`;
const $d8ef954c91d00c6a$export$9dca161faaf6308b = (0, $2e65282075da2b30$export$29353c66e70e3e16)({
    opSnippet: $d8ef954c91d00c6a$var$GREATER,
    packedOpSnippet: $d8ef954c91d00c6a$var$GREATER_PACKED,
    cpuKernelImpl: (0, $377486a788efd20b$export$eabb8927944259dd),
    dtype: 'bool'
});
const $d8ef954c91d00c6a$export$8c4f7e92d92310f8 = {
    kernelName: (0, $i64bB.Greater),
    backendName: 'webgl',
    kernelFunc: $d8ef954c91d00c6a$export$9dca161faaf6308b
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


const $a87d5b64457a8833$var$GREATER_EQUAL = `return float(a >= b);`;
const $a87d5b64457a8833$var$GREATER_EQUAL_PACKED = `
  return vec4(greaterThanEqual(a, b));
`;
const $a87d5b64457a8833$export$c2fd4164cadc1fa2 = (0, $2e65282075da2b30$export$29353c66e70e3e16)({
    opSnippet: $a87d5b64457a8833$var$GREATER_EQUAL,
    packedOpSnippet: $a87d5b64457a8833$var$GREATER_EQUAL_PACKED,
    dtype: 'bool',
    cpuKernelImpl: (0, $377486a788efd20b$export$a3d2e203d979d298)
});
const $a87d5b64457a8833$export$7a6926f9fcac24ca = {
    kernelName: (0, $i64bB.GreaterEqual),
    backendName: 'webgl',
    kernelFunc: $a87d5b64457a8833$export$c2fd4164cadc1fa2
};



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

function $4efb69686add259c$export$776649b0bf8ce1fd(args) {
    const { inputs: inputs, backend: backend } = args;
    const { input: input } = inputs;
    return (0, $e726cfbb4c8c6f27$export$75d3742a7578721e)(input, true, backend);
}
const $4efb69686add259c$export$dc267425bf21b465 = {
    kernelName: (0, $i64bB.IFFT),
    backendName: 'webgl',
    kernelFunc: $4efb69686add259c$export$776649b0bf8ce1fd
};



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

const $ed8c7f06f282f5a1$var$IS_FINITE = `return float(!isnan(x) && !isinf(x));`;
const $ed8c7f06f282f5a1$export$65f0b13f2f82375a = (0, $2e65282075da2b30$export$ba4daf5748026fba)({
    opSnippet: $ed8c7f06f282f5a1$var$IS_FINITE,
    dtype: 'bool'
});
const $ed8c7f06f282f5a1$export$4d45c8f7b9ffdaf1 = {
    kernelName: (0, $i64bB.IsFinite),
    backendName: 'webgl',
    kernelFunc: $ed8c7f06f282f5a1$export$65f0b13f2f82375a
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

const $b7d8d8aa3e580525$var$IS_INF = `return float(isinf(x));`;
const $b7d8d8aa3e580525$export$e5d3415c656f7096 = (0, $2e65282075da2b30$export$ba4daf5748026fba)({
    opSnippet: $b7d8d8aa3e580525$var$IS_INF,
    dtype: 'bool'
});
const $b7d8d8aa3e580525$export$bc383b82282e9b5a = {
    kernelName: (0, $i64bB.IsInf),
    backendName: 'webgl',
    kernelFunc: $b7d8d8aa3e580525$export$e5d3415c656f7096
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

const $7165148d8787b3d0$var$IS_NAN = `return float(isnan(x));`;
const $7165148d8787b3d0$export$c9f5652083b8129d = (0, $2e65282075da2b30$export$ba4daf5748026fba)({
    opSnippet: $7165148d8787b3d0$var$IS_NAN,
    dtype: 'bool'
});
const $7165148d8787b3d0$export$d58ff790c765c1f0 = {
    kernelName: (0, $i64bB.IsNan),
    backendName: 'webgl',
    kernelFunc: $7165148d8787b3d0$export$c9f5652083b8129d
};



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


const $ac08ecf54857ad6b$var$LESS = `return float(a < b);`;
const $ac08ecf54857ad6b$var$LESS_PACKED = `
  return vec4(lessThan(a, b));
`;
const $ac08ecf54857ad6b$export$bb1a638da8ad190f = (0, $2e65282075da2b30$export$29353c66e70e3e16)({
    opSnippet: $ac08ecf54857ad6b$var$LESS,
    packedOpSnippet: $ac08ecf54857ad6b$var$LESS_PACKED,
    cpuKernelImpl: (0, $377486a788efd20b$export$74c893b3c5e74e60),
    dtype: 'bool'
});
const $ac08ecf54857ad6b$export$8d4530ce8b6ffc3c = {
    kernelName: (0, $i64bB.Less),
    backendName: 'webgl',
    kernelFunc: $ac08ecf54857ad6b$export$bb1a638da8ad190f
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


const $6f550f45598f64ef$export$8342242c3b80421d = `return float(a <= b);`;
const $6f550f45598f64ef$export$b12559c17f42d056 = `
  return vec4(lessThanEqual(a, b));
`;
const $6f550f45598f64ef$export$c24ad19a692bb92 = (0, $2e65282075da2b30$export$29353c66e70e3e16)({
    opSnippet: $6f550f45598f64ef$export$8342242c3b80421d,
    packedOpSnippet: $6f550f45598f64ef$export$b12559c17f42d056,
    cpuKernelImpl: (0, $377486a788efd20b$export$6d1533a3ea9565f),
    dtype: 'bool'
});
const $6f550f45598f64ef$export$9f26bd257393dd8 = {
    kernelName: (0, $i64bB.LessEqual),
    backendName: 'webgl',
    kernelFunc: $6f550f45598f64ef$export$c24ad19a692bb92
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

function $1675ed15c165f58f$export$865a19adce4d7a46(args) {
    const { backend: backend, attrs: attrs } = args;
    const { start: start, stop: stop, num: num } = attrs;
    // TODO: Use CPU implementation due to the precision problem in Safari.
    const outVals = (0, $377486a788efd20b$export$c86a2be8970d7a7d)(start, stop, num);
    return backend.makeTensorInfo([
        outVals.length
    ], 'float32', outVals);
}
const $1675ed15c165f58f$export$46b96f742c70959b = {
    kernelName: (0, $i64bB.LinSpace),
    backendName: 'webgl',
    kernelFunc: $1675ed15c165f58f$export$865a19adce4d7a46
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


// Windows chrome return 0 if the input is negative value. We will specifically
// return NaN if the input is 0 to solve compatiblity issue.
const $53e959040aa3f91a$var$LOG = (0, $2e65282075da2b30$export$bf39b1cb254b6187) + `
  return x < 0.0 ? 0./0. : log(x);
`;
const $53e959040aa3f91a$var$LOG_PACKED = `
  vec4 result = log(x);
  bvec4 isNaN = isnan(x);
  result.r = isNaN.r ? x.r : (x.r < 0.0 ? 0./0. : result.r);
  result.g = isNaN.g ? x.g : (x.g < 0.0 ? 0./0. : result.g);
  result.b = isNaN.b ? x.b : (x.b < 0.0 ? 0./0. : result.b);
  result.a = isNaN.a ? x.a : (x.a < 0.0 ? 0./0. : result.a);
  return result;
`;
const $53e959040aa3f91a$export$bef1f36f5486a6a3 = (0, $2e65282075da2b30$export$ba4daf5748026fba)({
    opSnippet: $53e959040aa3f91a$var$LOG,
    packedOpSnippet: $53e959040aa3f91a$var$LOG_PACKED,
    cpuKernelImpl: (0, $377486a788efd20b$export$e88dde64a338f813)
});
const $53e959040aa3f91a$export$a4ae1f00643ddd14 = {
    kernelName: (0, $i64bB.Log),
    backendName: 'webgl',
    kernelFunc: $53e959040aa3f91a$export$bef1f36f5486a6a3
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

const $a1abd1c31271db41$var$LOG1P = (0, $2e65282075da2b30$export$bf39b1cb254b6187) + `
  return log(1.0 + x);
`;
const $a1abd1c31271db41$export$144dcf16adfb9698 = (0, $2e65282075da2b30$export$ba4daf5748026fba)({
    opSnippet: $a1abd1c31271db41$var$LOG1P
});
const $a1abd1c31271db41$export$c458b9e5ba980198 = {
    kernelName: (0, $i64bB.Log1p),
    backendName: 'webgl',
    kernelFunc: $a1abd1c31271db41$export$144dcf16adfb9698
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

const $ebb2ba64f27ac58d$var$LOGICAL_AND = `return float(a >= 1.0 && b >= 1.0);`;
const $ebb2ba64f27ac58d$var$LOGICAL_AND_PACKED = `
  return vec4(
    vec4(greaterThanEqual(a, vec4(1.0))) *
    vec4(greaterThanEqual(b, vec4(1.0))));
`;
const $ebb2ba64f27ac58d$export$db5dd0ef9d505f = (0, $2e65282075da2b30$export$29353c66e70e3e16)({
    opSnippet: $ebb2ba64f27ac58d$var$LOGICAL_AND,
    packedOpSnippet: $ebb2ba64f27ac58d$var$LOGICAL_AND_PACKED,
    dtype: 'bool'
});
const $ebb2ba64f27ac58d$export$257f1e82e69113fb = {
    kernelName: (0, $i64bB.LogicalAnd),
    backendName: 'webgl',
    kernelFunc: $ebb2ba64f27ac58d$export$db5dd0ef9d505f
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

const $ecbbeb478d5c896c$var$LOGICAL_NOT = `return float(!(x >= 1.0));`;
const $ecbbeb478d5c896c$export$c836ff7b605b1617 = (0, $2e65282075da2b30$export$ba4daf5748026fba)({
    opSnippet: $ecbbeb478d5c896c$var$LOGICAL_NOT
});
const $ecbbeb478d5c896c$export$68e2dd0840056271 = {
    kernelName: (0, $i64bB.LogicalNot),
    backendName: 'webgl',
    kernelFunc: $ecbbeb478d5c896c$export$c836ff7b605b1617
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

const $7c5010a82846f235$var$LOGICAL_OR = `return float(a >= 1.0 || b >= 1.0);`;
const $7c5010a82846f235$var$LOGICAL_OR_PACKED = `
  return min(
    vec4(greaterThanEqual(a, vec4(1.0))) +
    vec4(greaterThanEqual(b, vec4(1.0))),
    vec4(1.0));
`;
const $7c5010a82846f235$export$e2a73975983cadd8 = (0, $2e65282075da2b30$export$29353c66e70e3e16)({
    opSnippet: $7c5010a82846f235$var$LOGICAL_OR,
    packedOpSnippet: $7c5010a82846f235$var$LOGICAL_OR_PACKED,
    dtype: 'bool'
});
const $7c5010a82846f235$export$ce04b6546987ef43 = {
    kernelName: (0, $i64bB.LogicalOr),
    backendName: 'webgl',
    kernelFunc: $7c5010a82846f235$export$e2a73975983cadd8
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $85ed9377682e1999$export$2214c2ca22968528 {
    constructor(xShape, radius, bias, alpha, beta){
        this.variableNames = [
            'x'
        ];
        this.outputShape = [];
        const rad = radius;
        const maxD = xShape[3] - 1;
        this.outputShape = xShape;
        // optimize pow(bias + alpha * sum, -beta)
        // src: https://github.com/tensorflow/tensorflow/..
        // blob/26033a1644a9c4a5fbe3170ab2e864b6a4ccd4ca/..
        // tensorflow/core/kernels/mkl_lrn_op.cc#L320
        let powOperator;
        const basis = `float(${bias}) + float(${alpha}) * sum`;
        if (beta === 0.5) powOperator = `inversesqrt(${basis})`;
        else if (beta === 1.0) powOperator = `1.0/(${basis})`;
        else powOperator = `exp(log(${basis}) * float(-${beta}));`;
        this.userCode = `
      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int r = coords[1];
        int c = coords[2];
        int d = coords[3];
        float x = getX(b, r, c, d);
        float sum = 0.0;
        for (int j = -${rad}; j <= ${rad}; j++) {
          int idx = d + j;
          if (idx >= 0 && idx <=  ${maxD}) {
            float z = getX(b, r, c, idx);
            sum += z * z;
          }
        }
        float val = x * ${powOperator};
        setOutput(val);
      }
    `;
    }
}


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $55ee2e06dce6c3a6$export$3942340f6b6d7fe9 {
    constructor(xShape, radius, bias, alpha, beta){
        this.variableNames = [
            'x'
        ];
        this.outputShape = [];
        this.packedInputs = true;
        this.packedOutput = true;
        const rad = radius;
        const maxD = xShape[3] - 1;
        this.outputShape = xShape;
        // optimize pow(bias + alpha * sum, -beta)
        // src: https://github.com/tensorflow/tensorflow/..
        // blob/26033a1644a9c4a5fbe3170ab2e864b6a4ccd4ca/..
        // tensorflow/core/kernels/mkl_lrn_op.cc#L320
        let powOperator;
        const basis = `float(${bias}) + float(${alpha}) * sum`;
        if (beta === 0.5) powOperator = `inversesqrt(${basis})`;
        else if (beta === 1.0) powOperator = `1.0/(${basis})`;
        else powOperator = `exp(log(${basis}) * float(-${beta}));`;
        this.userCode = `
      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords.x;
        int r = coords.y;
        int c = coords.z;
        int d = coords.w;

        bool hasNextCol = d < ${this.outputShape[3]};
        bool hasNextRow = c < ${this.outputShape[2]};

        vec4 sum = vec4(0.);
        vec4 xFragAtOutputCoords = getX(b, r, c, d);

        vec4 xAtOutputCoords = vec4(
          getChannel(xFragAtOutputCoords, vec2(c, d)),
          hasNextCol ?
            getChannel(xFragAtOutputCoords, vec2(c, d + 1)) : 0.0,
          hasNextRow ?
            getChannel(xFragAtOutputCoords , vec2(c + 1, d)) : 0.0,
          (hasNextRow && hasNextCol) ?
            getChannel(xFragAtOutputCoords, vec2(c + 1, d + 1)) : 0.0
        );

        int firstChannel = d - ${rad};
        vec2 cache = vec2(0.);
        if(firstChannel >= 0){
          vec4 firstChannelFrag = getX(b, r, c, firstChannel);
          cache.x = getChannel(firstChannelFrag, vec2(c, firstChannel));
            if(hasNextRow){
              cache.y = getChannel(firstChannelFrag, vec2(c + 1, firstChannel));
            }
        }

        ivec2 depth = ivec2(d, d + 1);
        for (int j = - ${rad}; j <= ${rad}; j++) {
          ivec2 idx = depth + j;
          bvec2 aboveLowerBound = greaterThanEqual(idx, ivec2(0));
          bvec2 belowUpperBound = lessThanEqual(idx, ivec2(${maxD}));

          bool depthInRange = aboveLowerBound.x && belowUpperBound.x;
          bool depthPlusOneInRange = aboveLowerBound.y && belowUpperBound.y;

          if(depthInRange || depthPlusOneInRange){
            vec4 z = vec4(0.);
            vec4 xFragAtCurrentDepth;
            z.xz = cache.xy;
            if(depthPlusOneInRange && hasNextCol){
              xFragAtCurrentDepth = idx.y != d ?
                getX(b, r, c, idx.y) : xFragAtOutputCoords;
              z.y = getChannel(xFragAtCurrentDepth, vec2(c, idx.y));
              if(hasNextRow){
                z.w = getChannel(xFragAtCurrentDepth, vec2(c + 1, idx.y));
              }
            }
            cache.xy = z.yw;
            sum += z * z;
          }
        }
        vec4 result = xAtOutputCoords * ${powOperator};
        setOutput(result);
      }
    `;
    }
}


const $dc1573362b66fa9e$export$4e4a7896ae51c2f1 = (args)=>{
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { depthRadius: depthRadius, bias: bias, alpha: alpha, beta: beta } = attrs;
    const program = (0, $i64bB.env)().getBool('WEBGL_PACK_NORMALIZATION') ? new (0, $55ee2e06dce6c3a6$export$3942340f6b6d7fe9)(x.shape, depthRadius, bias, alpha, beta) : new (0, $85ed9377682e1999$export$2214c2ca22968528)(x.shape, depthRadius, bias, alpha, beta);
    return backend.runWebGLProgram(program, [
        x
    ], x.dtype);
};
const $dc1573362b66fa9e$export$6fb124d5a6994734 = {
    kernelName: (0, $i64bB.LRN),
    backendName: 'webgl',
    kernelFunc: $dc1573362b66fa9e$export$4e4a7896ae51c2f1
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $07ea223b0e8ec437$export$f121c71e68d75e {
    constructor(inputShape, depthRadius, bias, alpha, beta){
        this.variableNames = [
            'inputImage',
            'outputImage',
            'dy'
        ];
        this.outputShape = [];
        this.outputShape = inputShape;
        this.depth = inputShape[3];
        this.depthRadius = depthRadius;
        this.bias = bias;
        this.alpha = alpha;
        this.beta = beta;
        this.userCode = `
      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int r = coords[1];
        int c = coords[2];

        float result = 0.0;
        for (int d = 0; d < ${this.depth}; ++d) {
          int depthBegin = int(max(0.0, float(d - ${depthRadius})));
          int depthEnd = int(min(float(${this.depth}),
              float(d + ${depthRadius} + 1)));

          const int MIN_DEPTH_BEGIN = 0;
          const int MAX_DEPTH_END = ${this.depth};

          float norm = 0.0;
          for (int k = MIN_DEPTH_BEGIN; k < MAX_DEPTH_END; ++k) {
            if (k < depthBegin){
              continue;
            }
            else if (k >= depthBegin && k < depthEnd) {
              norm += getInputImage(b, r, c, k) * getInputImage(b, r, c, k);
            }
            else {
              break;
            }
          }

          norm = float(${alpha}) * norm + float(${bias});

          for(int k = MIN_DEPTH_BEGIN; k < MAX_DEPTH_END; ++k){
            if (k < depthBegin){
              continue;
            }
            else if (k >= depthBegin && k < depthEnd){
              float dyi = -2.0 * float(${alpha})
                * float(${beta})
                * getInputImage(b, r, c, k) * getOutputImage(b, r, c, d)
                / norm;
              if (k == d) {
                dyi += pow(norm, -1.0 * ${beta});
              }
              if (k == coords[3]) {
                dyi *= getDy(b, r, c, d);
                result += dyi;
              }
            }
            else {
              break;
            }
          }
      }
      setOutput(result);
      }
    `;
    }
}


const $b71b311e76fffe49$export$c1529e4348811bb5 = (args)=>{
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, y: y, dy: dy } = inputs;
    const { depthRadius: depthRadius, bias: bias, alpha: alpha, beta: beta } = attrs;
    const program = new (0, $07ea223b0e8ec437$export$f121c71e68d75e)(x.shape, depthRadius, bias, alpha, beta);
    return backend.runWebGLProgram(program, [
        x,
        y,
        dy
    ], x.dtype);
};
const $b71b311e76fffe49$export$99a62fc039d7aca0 = {
    kernelName: (0, $i64bB.LRNGrad),
    backendName: 'webgl',
    kernelFunc: $b71b311e76fffe49$export$c1529e4348811bb5
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


function $e240be1e6681ce8d$export$23c9b99bdac85be0(x, reduceShape, outShape, backend) {
    const inSize = (0, $i64bB.util).sizeFromShape(reduceShape);
    const xSize = (0, $i64bB.util).sizeFromShape(x.shape);
    const batchSize = xSize / inSize;
    const reshapedInput = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: x
        },
        attrs: {
            shape: [
                batchSize,
                inSize
            ]
        },
        backend: backend
    });
    const reduced = (0, $8c1b6ed50cb28ef5$export$533b26079ad0b4b)(reshapedInput, x.dtype, 'max', backend);
    const reshapedOutput = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: reduced
        },
        attrs: {
            shape: outShape
        },
        backend: backend
    });
    backend.disposeIntermediateTensorInfo(reshapedInput);
    backend.disposeIntermediateTensorInfo(reduced);
    return reshapedOutput;
}



function $732f8dce2eff8c69$export$8960430cfd85939f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { reductionIndices: reductionIndices, keepDims: keepDims } = attrs;
    const xRank = x.shape.length;
    const origAxes = (0, $i64bB.util).parseAxisParam(reductionIndices, x.shape);
    let axes = origAxes;
    const permutedAxes = (0, $i64bB.backend_util).getAxesPermutation(axes, xRank);
    const maxInputIsTransposed = permutedAxes != null;
    const shouldExecuteOnCPU = backend.shouldExecuteOnCPU([
        x
    ]);
    let maxInput = x;
    if (maxInputIsTransposed) {
        if (shouldExecuteOnCPU) {
            const xTexData = backend.texData.get(maxInput.dataId);
            const values = xTexData.values;
            const newShape = new Array(xRank);
            for(let i = 0; i < newShape.length; i++)newShape[i] = x.shape[permutedAxes[i]];
            const maxInputValues = (0, $377486a788efd20b$export$a0105d4a7143676c)(values, x.shape, x.dtype, permutedAxes, newShape);
            maxInput = backend.makeTensorInfo(newShape, x.dtype);
            const maxInputData = backend.texData.get(maxInput.dataId);
            maxInputData.values = maxInputValues;
        } else maxInput = (0, $3fdf015ef273b3f6$export$986b9e65182e08d)(x, permutedAxes, backend);
        axes = (0, $i64bB.backend_util).getInnerMostAxes(axes.length, xRank);
    }
    (0, $i64bB.backend_util).assertAxesAreInnerMostDims('max', axes, xRank);
    const [maxOutShape, reduceShape] = (0, $i64bB.backend_util).computeOutAndReduceShapes(maxInput.shape, axes);
    let outShape = maxOutShape;
    if (keepDims) // rather than reshape at the end, set the target shape here.
    outShape = (0, $i64bB.backend_util).expandShapeToKeepDim(maxOutShape, origAxes);
    let out;
    if (shouldExecuteOnCPU) {
        const xTexData = backend.texData.get(maxInput.dataId);
        const values = xTexData.values;
        const outValues = (0, $377486a788efd20b$export$a94164c9f637858e)(values, (0, $i64bB.util).sizeFromShape(reduceShape), outShape, x.dtype);
        out = backend.makeTensorInfo(outShape, x.dtype);
        const outData = backend.texData.get(out.dataId);
        outData.values = outValues;
    } else out = (0, $e240be1e6681ce8d$export$23c9b99bdac85be0)(maxInput, reduceShape, outShape, backend);
    if (maxInputIsTransposed) backend.disposeIntermediateTensorInfo(maxInput);
    return out;
}
const $732f8dce2eff8c69$export$7d79147246e312bb = {
    kernelName: (0, $i64bB.Max),
    backendName: 'webgl',
    kernelFunc: $732f8dce2eff8c69$export$8960430cfd85939f
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");




const $937eb548d92b33db$var$MAXIMUM = (0, $a3544edc66d558ba$export$39f0cca2b63399f6) + `
  return max(a, b);
`;
const $937eb548d92b33db$var$MAXIMUM_PACKED = `
  vec4 result = vec4(max(a, b));
  bvec4 isNaNA = isnan(a);
  bvec4 isNaNB = isnan(b);
  bvec4 isNaN = bvec4(isNaNA.x || isNaNB.x, isNaNA.y || isNaNB.y, isNaNA.z || isNaNB.z, isNaNA.w || isNaNB.w);
  ` + (0, $1b00798c48aa5c1a$export$2b4d5cee4bd7b2dd) + `
  return result;
`;
const $937eb548d92b33db$export$b25e0be55f42c9a = (0, $2e65282075da2b30$export$29353c66e70e3e16)({
    opSnippet: $937eb548d92b33db$var$MAXIMUM,
    packedOpSnippet: $937eb548d92b33db$var$MAXIMUM_PACKED,
    cpuKernelImpl: (0, $377486a788efd20b$export$b3afdc53a543e175)
});
const $937eb548d92b33db$export$45b97bdc342e72a2 = {
    kernelName: (0, $i64bB.Maximum),
    backendName: 'webgl',
    kernelFunc: $937eb548d92b33db$export$b25e0be55f42c9a
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");



function $14a0076dde30b024$export$e4aadcf115842782(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    (0, $03fc80a4a4cef09e$export$1412c17b2531581a)(x, 'maxPool');
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    const dilations = 1;
    (0, $i64bB.util).assert((0, $i64bB.backend_util).eitherStridesOrDilationsAreOne(strides, dilations), ()=>'Error in maxPool: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    const convInfo = (0, $i64bB.backend_util).computePool2DInfo(x.shape, filterSize, strides, dilations, pad, dimRoundingMode);
    if (convInfo.filterWidth === 1 && convInfo.filterHeight === 1 && (0, $i64bB.util).arraysEqual(convInfo.inShape, convInfo.outShape)) return (0, $2b13f312c76ad9c3$export$f0954fd7d5368655)({
        inputs: {
            x: x
        },
        backend: backend
    });
    const maxPoolProgram = new (0, $61fdd45f941bfa6f$export$ddaa65439647a5ac)(convInfo, 'max', false);
    return backend.runWebGLProgram(maxPoolProgram, [
        x
    ], x.dtype);
}
const $14a0076dde30b024$export$45c8263b38f19e33 = {
    kernelName: (0, $i64bB.MaxPool),
    backendName: 'webgl',
    kernelFunc: $14a0076dde30b024$export$e4aadcf115842782
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

function $34f80b63f5f4d6ad$export$822a6e53be1125f9(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { filterSize: filterSize, strides: strides, pad: pad, dataFormat: dataFormat, dimRoundingMode: dimRoundingMode } = attrs;
    const dilations = [
        1,
        1,
        1
    ];
    const convInfo = (0, $i64bB.backend_util).computePool3DInfo(x.shape, filterSize, strides, dilations, pad, dimRoundingMode, dataFormat);
    const maxPoolProgram = new (0, $61fdd45f941bfa6f$export$a835a97097fdbb0f)(convInfo, 'max', false);
    return backend.runWebGLProgram(maxPoolProgram, [
        x
    ], x.dtype);
}
const $34f80b63f5f4d6ad$export$91a8fc5da39ec855 = {
    kernelName: (0, $i64bB.MaxPool3D),
    backendName: 'webgl',
    kernelFunc: $34f80b63f5f4d6ad$export$822a6e53be1125f9
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $0142bb2b0864c09a$export$ab6144ed51884dd {
    constructor(convInfo){
        this.variableNames = [
            'dy',
            'maxPos'
        ];
        this.outputShape = convInfo.inShape;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const dilationHeight = convInfo.dilationHeight;
        const effectiveFilterHeight = convInfo.effectiveFilterHeight;
        const effectiveFilterWidth = convInfo.effectiveFilterWidth;
        const padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
        const padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
        const lastIndex = effectiveFilterHeight * effectiveFilterWidth - 1;
        this.userCode = `
      const ivec2 pads = ivec2(${padTop}, ${padLeft});

      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];

        ivec2 dyRCCorner = coords.yz - pads;
        int dyRCorner = dyRCCorner.x;
        int dyCCorner = dyRCCorner.y;

        // Convolve dy(?, ?, d) with pos mask(:, :, d) to get dx(xR, xC, d).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;
        for (int wR = 0; wR < ${effectiveFilterHeight};
          wR += ${dilationHeight}) {
          float dyR = float(dyRCorner + wR) / ${strideHeight}.0;

          if (dyR < 0.0 || dyR >= ${convInfo.outHeight}.0 || fract(dyR) > 0.0) {
            continue;
          }
          int idyR = int(dyR);

          for (int wC = 0; wC < ${effectiveFilterWidth}; wC++) {
            float dyC = float(dyCCorner + wC) / ${strideWidth}.0;

            if (dyC < 0.0 || dyC >= ${convInfo.outWidth}.0 ||
                fract(dyC) > 0.0) {
              continue;
            }
            int idyC = int(dyC);

            float dyValue = getDy(b, idyR, idyC, d);
            int maxPosValue = ${lastIndex} - int(getMaxPos(b, idyR, idyC, d));

            // Get the current value, check it against the value from the
            // position matrix.
            int curPosValue = wR * ${effectiveFilterWidth} + wC;
            float mask = float(maxPosValue == curPosValue ? 1.0 : 0.0);

            dotProd += dyValue * mask;
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}
class $0142bb2b0864c09a$export$ae61ae287bf9d719 {
    constructor(convInfo){
        this.variableNames = [
            'dy',
            'maxPos'
        ];
        this.outputShape = convInfo.inShape;
        const strideDepth = convInfo.strideDepth;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const dilationDepth = convInfo.dilationDepth;
        const dilationHeight = convInfo.dilationHeight;
        const dilationWidth = convInfo.dilationWidth;
        const effectiveFilterDepth = convInfo.effectiveFilterDepth;
        const effectiveFilterHeight = convInfo.effectiveFilterHeight;
        const effectiveFilterWidth = convInfo.effectiveFilterWidth;
        const padFront = effectiveFilterDepth - 1 - convInfo.padInfo.front;
        const padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
        const padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
        const lastIndex = effectiveFilterDepth * effectiveFilterHeight * effectiveFilterWidth - 1;
        this.userCode = `
      const ivec3 pads = ivec3(${padFront}, ${padTop}, ${padLeft});

      void main() {
        ivec5 coords = getOutputCoords();
        int batch = coords.x;
        int ch = coords.u;

        ivec3 dyCorner = ivec3(coords.y, coords.z, coords.w) - pads;
        int dyDCorner = dyCorner.x;
        int dyRCorner = dyCorner.y;
        int dyCCorner = dyCorner.z;

        // Convolve dy(?, ?, ?, ch) with pos mask(:, :, :, d) to get
        // dx(xD, xR, xC, ch).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;

        for (int wD = 0; wD < ${effectiveFilterDepth};
           wD += ${dilationDepth}) {
          float dyD = float(dyDCorner + wD) / ${strideDepth}.0;

          if (dyD < 0.0 || dyD >= ${convInfo.outDepth}.0 || fract(dyD) > 0.0) {
            continue;
          }
          int idyD = int(dyD);

          for (int wR = 0; wR < ${effectiveFilterHeight};
              wR += ${dilationHeight}) {
            float dyR = float(dyRCorner + wR) / ${strideHeight}.0;

            if (dyR < 0.0 || dyR >= ${convInfo.outHeight}.0 ||
                fract(dyR) > 0.0) {
              continue;
            }
            int idyR = int(dyR);

            for (int wC = 0; wC < ${effectiveFilterWidth};
                wC += ${dilationWidth}) {
              float dyC = float(dyCCorner + wC) / ${strideWidth}.0;

              if (dyC < 0.0 || dyC >= ${convInfo.outWidth}.0 ||
                  fract(dyC) > 0.0) {
                continue;
              }
              int idyC = int(dyC);

              float dyValue = getDy(batch, idyD, idyR, idyC, ch);
              int maxPosValue = ${lastIndex} -
                  int(getMaxPos(batch, idyD, idyR, idyC, ch));

              // Get the current value, check it against the value from the
              // position matrix.
              int curPosValue =
                  wD * ${effectiveFilterHeight} * ${effectiveFilterWidth} +
                  wR * ${effectiveFilterWidth} + wC;
              float mask = float(maxPosValue == curPosValue ? 1.0 : 0.0);

              dotProd += dyValue * mask;
            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}



function $63a48a37371a55dd$export$e68b9bef571dd4ea(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, input: input } = inputs;
    const x = input;
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    const dilations = [
        1,
        1,
        1
    ];
    const convInfo = (0, $i64bB.backend_util).computePool3DInfo(x.shape, filterSize, strides, dilations, pad, dimRoundingMode);
    const maxPool3dPositionsProgram = new (0, $61fdd45f941bfa6f$export$a835a97097fdbb0f)(convInfo, 'max', true);
    const maxPool3dPositions = backend.runWebGLProgram(maxPool3dPositionsProgram, [
        x
    ], x.dtype);
    const maxPoolBackpropProgram = new (0, $0142bb2b0864c09a$export$ae61ae287bf9d719)(convInfo);
    const result = backend.runWebGLProgram(maxPoolBackpropProgram, [
        dy,
        maxPool3dPositions
    ], x.dtype);
    backend.disposeIntermediateTensorInfo(maxPool3dPositions);
    return result;
}
const $63a48a37371a55dd$export$5201426bb10bd5eb = {
    kernelName: (0, $i64bB.MaxPool3DGrad),
    backendName: 'webgl',
    kernelFunc: $63a48a37371a55dd$export$e68b9bef571dd4ea
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");



function $2bf8033ad06b4bf4$export$85dfd1121f049514(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, input: input, output: output } = inputs;
    const x = input;
    (0, $03fc80a4a4cef09e$export$1412c17b2531581a)([
        input,
        output
    ], 'maxPoolGrad');
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    const convInfo = (0, $i64bB.backend_util).computePool2DInfo(x.shape, filterSize, strides, 1 /* dilations */ , pad, dimRoundingMode);
    const getPositions = true;
    const maxPoolPositionsProgram = new (0, $61fdd45f941bfa6f$export$ddaa65439647a5ac)(convInfo, 'max', getPositions);
    const maxPoolPositions = backend.runWebGLProgram(maxPoolPositionsProgram, [
        x
    ], x.dtype);
    const maxPoolBackPropProgram = new (0, $0142bb2b0864c09a$export$ab6144ed51884dd)(convInfo);
    const result = backend.runWebGLProgram(maxPoolBackPropProgram, [
        dy,
        maxPoolPositions
    ], x.dtype);
    backend.disposeIntermediateTensorInfo(maxPoolPositions);
    return result;
}
const $2bf8033ad06b4bf4$export$e01a7f8dbee29127 = {
    kernelName: (0, $i64bB.MaxPoolGrad),
    backendName: 'webgl',
    kernelFunc: $2bf8033ad06b4bf4$export$85dfd1121f049514
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $f5d5fe02a3622472$export$3cc34964a47e7a3f(x, includeBatchInIndex, convInfo, backend) {
    let program = new (0, $61fdd45f941bfa6f$export$ddaa65439647a5ac)(convInfo, 'max', false);
    const poolOutput = backend.runWebGLProgram(program, [
        x
    ], 'float32');
    program = new (0, $61fdd45f941bfa6f$export$ddaa65439647a5ac)(convInfo, 'max', true, true, includeBatchInIndex);
    const indexOutput = backend.runWebGLProgram(program, [
        x
    ], 'float32');
    return [
        poolOutput,
        indexOutput
    ];
}


const $abe62b018b6c1520$export$a069ee2247a7d1ce = {
    kernelName: (0, $i64bB.MaxPoolWithArgmax),
    backendName: 'webgl',
    kernelFunc: ({ inputs: inputs, attrs: attrs, backend: backend })=>{
        const { x: x } = inputs;
        const { filterSize: filterSize, strides: strides, pad: pad, includeBatchInIndex: includeBatchInIndex } = attrs;
        const webglBackend = backend;
        (0, $i64bB.util).assert(x.shape.length === 4, ()=>`Error in maxPool: input must be rank 4 but got rank ${x.shape.length}.`);
        const dilations = [
            1,
            1
        ];
        (0, $i64bB.util).assert((0, $i64bB.backend_util).eitherStridesOrDilationsAreOne(strides, dilations), ()=>'Error in maxPool: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
        const convInfo = (0, $i64bB.backend_util).computePool2DInfo(x.shape, filterSize, strides, dilations, pad);
        const [result, indexes] = (0, $f5d5fe02a3622472$export$3cc34964a47e7a3f)(x, includeBatchInIndex, convInfo, webglBackend);
        return [
            result,
            indexes
        ];
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


function $31e959cdd2f032e0$export$320c6ab5e6e7bcef(x, reduceShape, outShape, backend) {
    const inSize = (0, $i64bB.util).sizeFromShape(reduceShape);
    const xSize = (0, $i64bB.util).sizeFromShape(x.shape);
    const batchSize = xSize / inSize;
    const reshapedInput = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: x
        },
        attrs: {
            shape: [
                batchSize,
                inSize
            ]
        },
        backend: backend
    });
    const reduced = (0, $8c1b6ed50cb28ef5$export$533b26079ad0b4b)(reshapedInput, 'float32', 'mean', backend);
    const reshapedOutput = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: reduced
        },
        attrs: {
            shape: outShape
        },
        backend: backend
    });
    backend.disposeIntermediateTensorInfo(reshapedInput);
    backend.disposeIntermediateTensorInfo(reduced);
    return reshapedOutput;
}



const $4a80966bb249c896$export$b934af0ccd0cdbe1 = {
    kernelName: (0, $i64bB.Mean),
    backendName: 'webgl',
    kernelFunc: ({ inputs: inputs, attrs: attrs, backend: backend })=>{
        const { x: x } = inputs;
        const { keepDims: keepDims, axis: axis } = attrs;
        const webglBackend = backend;
        const xRank = x.shape.length;
        const origAxes = (0, $i64bB.util).parseAxisParam(axis, x.shape);
        let axes = origAxes;
        const permutedAxes = (0, $i64bB.backend_util).getAxesPermutation(axes, xRank);
        const meanInputIsTransposed = permutedAxes != null;
        const shouldExecuteOnCPU = webglBackend.shouldExecuteOnCPU([
            x
        ]);
        const intermediates = [];
        let meanInput = x;
        if (meanInputIsTransposed) {
            if (shouldExecuteOnCPU) {
                const xTexData = webglBackend.texData.get(meanInput.dataId);
                const values = xTexData.values;
                const newShape = new Array(xRank);
                for(let i = 0; i < newShape.length; i++)newShape[i] = x.shape[permutedAxes[i]];
                const meanInputValues = (0, $377486a788efd20b$export$a0105d4a7143676c)(values, x.shape, x.dtype, permutedAxes, newShape);
                meanInput = webglBackend.makeTensorInfo(newShape, x.dtype);
                const meanInputData = webglBackend.texData.get(meanInput.dataId);
                meanInputData.values = meanInputValues;
            } else meanInput = (0, $3fdf015ef273b3f6$export$986b9e65182e08d)(x, permutedAxes, webglBackend);
            intermediates.push(meanInput);
            axes = (0, $i64bB.backend_util).getInnerMostAxes(axes.length, xRank);
        }
        (0, $i64bB.backend_util).assertAxesAreInnerMostDims('sum', axes, xRank);
        const [meanOutShape, reduceShape] = (0, $i64bB.backend_util).computeOutAndReduceShapes(meanInput.shape, axes);
        let outShape = meanOutShape;
        if (keepDims) // rather than reshape at the end, set the target shape here.
        outShape = (0, $i64bB.backend_util).expandShapeToKeepDim(meanOutShape, origAxes);
        const out = (0, $31e959cdd2f032e0$export$320c6ab5e6e7bcef)(meanInput, reduceShape, outShape, webglBackend);
        for (const i of intermediates)webglBackend.disposeIntermediateTensorInfo(i);
        return out;
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");



function $361ad92d998b60b5$export$96ec731ed4dcb222(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    const xRank = x.shape.length;
    const origAxes = (0, $i64bB.util).parseAxisParam(axis, x.shape);
    let axes = origAxes;
    const permutedAxes = (0, $i64bB.backend_util).getAxesPermutation(axes, xRank);
    let permutedX = x;
    if (permutedAxes != null) {
        permutedX = (0, $6cab078553124169$export$9cb09a71b7d66923)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutedAxes
            }
        });
        axes = (0, $i64bB.backend_util).getInnerMostAxes(axes.length, x.shape.length);
    }
    (0, $i64bB.backend_util).assertAxesAreInnerMostDims('min', axes, xRank);
    const [outShape, reduceShape] = (0, $i64bB.backend_util).computeOutAndReduceShapes(permutedX.shape, axes);
    const inSize = (0, $i64bB.util).sizeFromShape(reduceShape);
    const a2D = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: permutedX
        },
        backend: backend,
        attrs: {
            shape: [
                -1,
                inSize
            ]
        }
    });
    const reduced = (0, $8c1b6ed50cb28ef5$export$533b26079ad0b4b)(a2D, a2D.dtype, 'min', backend);
    let res;
    if (keepDims) {
        const newShape = (0, $i64bB.backend_util).expandShapeToKeepDim(outShape, origAxes);
        res = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
            inputs: {
                x: reduced
            },
            backend: backend,
            attrs: {
                shape: newShape
            }
        });
    } else res = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: reduced
        },
        backend: backend,
        attrs: {
            shape: outShape
        }
    });
    backend.disposeIntermediateTensorInfo(a2D);
    backend.disposeIntermediateTensorInfo(reduced);
    if (permutedAxes != null) backend.disposeIntermediateTensorInfo(permutedX);
    return res;
}
const $361ad92d998b60b5$export$3cd9f9a31b38cf18 = {
    kernelName: (0, $i64bB.Min),
    backendName: 'webgl',
    kernelFunc: $361ad92d998b60b5$export$96ec731ed4dcb222
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");




const $1b132b43b24c455f$var$MINIMUM = (0, $a3544edc66d558ba$export$39f0cca2b63399f6) + `
  return min(a, b);
`;
const $1b132b43b24c455f$var$MINIMUM_PACKED = `
  vec4 result = vec4(min(a, b));
  bvec4 isNaNA = isnan(a);
  bvec4 isNaNB = isnan(b);
  bvec4 isNaN = bvec4(isNaNA.x || isNaNB.x, isNaNA.y || isNaNB.y, isNaNA.z || isNaNB.z, isNaNA.w || isNaNB.w);
  ` + (0, $1b00798c48aa5c1a$export$2b4d5cee4bd7b2dd) + `
  return result;
`;
const $1b132b43b24c455f$export$916782c1f0ddb132 = (0, $2e65282075da2b30$export$29353c66e70e3e16)({
    opSnippet: $1b132b43b24c455f$var$MINIMUM,
    packedOpSnippet: $1b132b43b24c455f$var$MINIMUM_PACKED,
    cpuKernelImpl: (0, $377486a788efd20b$export$1f01be3f637863fa)
});
const $1b132b43b24c455f$export$ea24ffbbbce8d546 = {
    kernelName: (0, $i64bB.Minimum),
    backendName: 'webgl',
    kernelFunc: $1b132b43b24c455f$export$916782c1f0ddb132
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
class $c517d8ad2fe99776$export$284b676bb83fc2a7 {
    constructor(xShape, paddings, mode){
        this.variableNames = [
            'x'
        ];
        this.outputShape = paddings.map((p, i)=>p[0] + xShape[i] + p[1]);
        const rank = xShape.length;
        const dtype = (0, $ba2c54ffbda39e8e$export$859efd105c10c755)(rank);
        const start = paddings.map((p)=>p[0]).join(',');
        const end = paddings.map((p, i)=>p[0] + xShape[i]).join(',');
        const unpackedCoords = [
            'coords[0]',
            'coords[1]',
            'coords[2]',
            'coords[3]'
        ].slice(0, rank);
        const offset = mode === 'reflect' ? 0 : 1;
        if (rank === 1) {
            this.userCode = `
        int start = ${start};
        int end = ${end};

        void main() {
          int outC = getOutputCoords();
          if (outC < start) {
            outC = start * 2 - outC - ${offset};
          } else if(outC >= end) {
            outC = (end - 1) * 2 - outC + ${offset};
          }
          setOutput(getX(outC - start));
        }
      `;
            return;
        }
        this.userCode = `
      ${dtype} start = ${dtype}(${start});
      ${dtype} end = ${dtype}(${end});

      void main() {
        ${dtype} outC = getOutputCoords();
        for (int i = 0; i < ${rank}; i++) {
          if (outC[i] < start[i]) {
            outC[i] = start[i] * 2 - outC[i] - ${offset};
          } else if(outC[i] >= end[i]) {
            outC[i] = (end[i] - 1) * 2 - outC[i] + ${offset};
          }
        }
        ${dtype} coords = outC - start;
        setOutput(getX(${unpackedCoords}));
      }
    `;
    }
}


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $f018b7a8284db1b1$export$8b179cde16652b52 {
    constructor(xShape, paddings, mode){
        this.variableNames = [
            'x'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.outputShape = paddings.map((p, i)=>p[0] + xShape[i] + p[1]);
        const rank = xShape.length;
        const dtype = (0, $ba2c54ffbda39e8e$export$859efd105c10c755)(rank);
        const start = paddings.map((p)=>p[0]).join(',');
        const end = paddings.map((p, i)=>p[0] + xShape[i]).join(',');
        const coords = (0, $30912e1180ed417f$export$7a4d1d0d17b69972)('rc', rank);
        const source = (0, $30912e1180ed417f$export$7a4d1d0d17b69972)('source', rank);
        const cLimit = `${coords[rank - 1]} < ${this.outputShape[rank - 1]}`;
        const innerDims = rank === 1 ? 'source' : `vec2(${source.slice(-2).join()})`;
        const offset = mode === 'reflect' ? 0 : 1;
        let mainLoop = '';
        if (rank === 1) {
            const padSetup = `
        ${dtype} source = rc;
        if (source < start) {
          source = start * 2 - source - ${offset};
        } else if (source >= end) {
          source = (end - 1) * 2 - source + ${offset};
        }
        source -= start;
      `;
            mainLoop = `
        ${dtype} rc = outputLoc;
        ${padSetup}
        result[0] = getChannel(getX(${source.join()}), ${innerDims});
        ${coords[rank - 1]} += 1;
        if(${cLimit}) {
          ${padSetup}
          result[1] = getChannel(getX(${source.join()}), ${innerDims});
        }
      `;
        } else {
            const padSetup = `
        ${dtype} source = rc;
        ${dtype} lt = ${dtype}(lessThan(source, start));
        ${dtype} gte = ${dtype}(greaterThanEqual(source, end));
        ${dtype} orig = 1 - (lt + gte);
        source = orig * source +
                lt * (start * 2 - source - ${offset}) +
                gte * ((end - 1) * 2 - source + ${offset});
        source -= start;
      `;
            mainLoop = `
        ${dtype} rc = outputLoc;
        ${padSetup}
        result[0] = getChannel(getX(${source.join()}), ${innerDims});
        ${coords[rank - 1]} += 1;
        if(${cLimit}) {
          ${padSetup}
          result[1] = getChannel(getX(${source.join()}), ${innerDims});
        }
        rc = outputLoc;
        ${coords[rank - 2]} += 1;
        if(${coords[rank - 2]} < ${this.outputShape[rank - 2]}) {
          ${padSetup}
          result[2] = getChannel(getX(${source.join()}), ${innerDims});
          ${coords[rank - 1]} += 1;
          if(${cLimit}) {
            ${padSetup}
            result[3] = getChannel(getX(${source.join()}), ${innerDims});
          }
        }
      `;
        }
        this.userCode = `
      const ${dtype} start = ${dtype}(${start});
      const ${dtype} end = ${dtype}(${end});

      void main() {
        ${dtype} outputLoc = getOutputCoords();
        vec4 result = vec4(0.);
        ${mainLoop}
        setOutput(result);
      }
    `;
    }
}


const $12c5ac49f0f2180d$export$cd4ff5cd9b95abe8 = ({ inputs: inputs, backend: backend, attrs: attrs })=>{
    const { x: x } = inputs;
    const { paddings: paddings, mode: mode } = attrs;
    const program = (0, $i64bB.env)().getBool('WEBGL_PACK_ARRAY_OPERATIONS') ? new (0, $f018b7a8284db1b1$export$8b179cde16652b52)(x.shape, paddings, mode) : new (0, $c517d8ad2fe99776$export$284b676bb83fc2a7)(x.shape, paddings, mode);
    const output = backend.runWebGLProgram(program, [
        x
    ], x.dtype);
    return output;
};
const $12c5ac49f0f2180d$export$2cfd6c6c7daeb5fc = {
    kernelName: (0, $i64bB.MirrorPad),
    backendName: 'webgl',
    kernelFunc: $12c5ac49f0f2180d$export$cd4ff5cd9b95abe8
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


const $414c6e096693281c$var$MOD = `if (b == 0.0) return NAN;
  return mod(a, b);`;
const $414c6e096693281c$var$MOD_PACKED = `
  vec4 result = mod(a, b);
  bvec4 isNaN = equal(b, vec4(0.0));
  ` + (0, $1b00798c48aa5c1a$export$2b4d5cee4bd7b2dd) + `
  return result;
`;
const $414c6e096693281c$export$842a2cf37af977e1 = (0, $2e65282075da2b30$export$29353c66e70e3e16)({
    opSnippet: $414c6e096693281c$var$MOD,
    packedOpSnippet: $414c6e096693281c$var$MOD_PACKED
});
const $414c6e096693281c$export$9037685a81180a9c = {
    kernelName: (0, $i64bB.Mod),
    backendName: 'webgl',
    kernelFunc: $414c6e096693281c$export$842a2cf37af977e1
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $35263866b3f98783$export$f8cda6c8ea4f2110 {
    constructor(batchSize, numOutcomes, numSamples){
        this.variableNames = [
            'probs'
        ];
        this.customUniforms = [
            {
                name: 'seed',
                type: 'float'
            }
        ];
        this.outputShape = [
            batchSize,
            numSamples
        ];
        this.userCode = `
      void main() {
        ivec2 coords = getOutputCoords();
        int batch = coords[0];

        float r = random(seed);
        float cdf = 0.0;

        for (int i = 0; i < ${numOutcomes - 1}; i++) {
          cdf += getProbs(batch, i);

          if (r < cdf) {
            setOutput(float(i));
            return;
          }
        }

        // If no other event happened, last event happened.
        setOutput(float(${numOutcomes - 1}));
      }
    `;
    }
}


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

// Without the equality check div produces 0.9999 for a = b, which when
// floored can cause errors.
const $009cdfbf6f91cb52$var$DIV = `
if (a == b) {
  return 1.0;
};
return a / b;`;
// We do the same as in ./binaryop_gpu, with vec4 and ivec4.
// On Linux, the vectorized implementation produces NaNs when a and b are 0.
const $009cdfbf6f91cb52$var$DIV_PACKED = `
  // vec4 one = vec4(equal(a, b));
  // return one + (vec4(1.0) - one) * a / b;
  vec4 result = a / b;
  if(a.x == b.x) {
    result.x = 1.;
  }
  if(a.y == b.y) {
    result.y = 1.;
  }
  if(a.z == b.z) {
    result.z = 1.;
  }
  if(a.w == b.w) {
    result.w = 1.;
  }

  return result;
`;
const $009cdfbf6f91cb52$export$f76766520aabd67 = (0, $2e65282075da2b30$export$29353c66e70e3e16)({
    opSnippet: $009cdfbf6f91cb52$var$DIV,
    packedOpSnippet: $009cdfbf6f91cb52$var$DIV_PACKED,
    checkOutOfBounds: true
});
const $009cdfbf6f91cb52$export$15c5d6176b30b9a6 = {
    kernelName: (0, $i64bB.RealDiv),
    backendName: 'webgl',
    kernelFunc: $009cdfbf6f91cb52$export$f76766520aabd67
};



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


const $1b60e5a3ab7a8d10$var$SUB = 'return a - b;';
const $1b60e5a3ab7a8d10$export$f93b5905241a7cca = (0, $2e65282075da2b30$export$29353c66e70e3e16)({
    opSnippet: $1b60e5a3ab7a8d10$var$SUB,
    packedOpSnippet: $1b60e5a3ab7a8d10$var$SUB,
    supportsComplex: true,
    cpuKernelImpl: (0, $377486a788efd20b$export$be7474e96b733333)
});
const $1b60e5a3ab7a8d10$export$5d068476dad60c4d = {
    kernelName: (0, $i64bB.Sub),
    backendName: 'webgl',
    kernelFunc: $1b60e5a3ab7a8d10$export$f93b5905241a7cca
};



function $57af78475e4ec5cb$export$e008137e76238601(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { logits: logits } = inputs;
    const { dim: dim } = attrs;
    const axes = (0, $i64bB.util).parseAxisParam([
        dim
    ], logits.shape);
    const maxLogit = (0, $732f8dce2eff8c69$export$8960430cfd85939f)({
        inputs: {
            x: logits
        },
        backend: backend,
        attrs: {
            reductionIndices: axes,
            keepDims: false
        }
    });
    const expandedShape = (0, $i64bB.backend_util).expandShapeToKeepDim(maxLogit.shape, axes);
    const maxLogitsReshaped = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: maxLogit
        },
        backend: backend,
        attrs: {
            shape: expandedShape
        }
    });
    const a = (0, $1b60e5a3ab7a8d10$export$f93b5905241a7cca)({
        inputs: {
            a: logits,
            b: maxLogitsReshaped
        },
        backend: backend
    });
    const b = (0, $f564a957992b7970$export$b310ec824aaee37f)({
        inputs: {
            x: a
        },
        backend: backend
    });
    const sumExp = (0, $579f4cd1cc49add3$export$8a63f25cc62965f1)({
        inputs: {
            x: b
        },
        backend: backend,
        attrs: {
            axis: axes,
            keepDims: false
        }
    });
    const sumExpReshaped = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: sumExp
        },
        backend: backend,
        attrs: {
            shape: expandedShape
        }
    });
    const res = (0, $009cdfbf6f91cb52$export$f76766520aabd67)({
        inputs: {
            a: b,
            b: sumExpReshaped
        },
        backend: backend
    });
    backend.disposeIntermediateTensorInfo(maxLogit);
    backend.disposeIntermediateTensorInfo(maxLogitsReshaped);
    backend.disposeIntermediateTensorInfo(a);
    backend.disposeIntermediateTensorInfo(b);
    backend.disposeIntermediateTensorInfo(sumExp);
    backend.disposeIntermediateTensorInfo(sumExpReshaped);
    return res;
}
const $57af78475e4ec5cb$export$c022691f23e2ee69 = {
    kernelName: (0, $i64bB.Softmax),
    backendName: 'webgl',
    kernelFunc: $57af78475e4ec5cb$export$e008137e76238601
};


function $9b9904aa6656bc38$export$f4d580f3101a1c7e(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { logits: logits } = inputs;
    const { numSamples: numSamples, seed: seed, normalized: normalized } = attrs;
    const probs = normalized ? logits : (0, $57af78475e4ec5cb$export$e008137e76238601)({
        inputs: {
            logits: logits
        },
        backend: backend,
        attrs: {
            dim: logits.shape.length - 1
        }
    });
    const batchSize = probs.shape[0];
    const numOutcomes = probs.shape[1];
    const program = new (0, $35263866b3f98783$export$f8cda6c8ea4f2110)(batchSize, numOutcomes, numSamples);
    const customValues = [
        [
            seed
        ]
    ];
    const res = backend.runWebGLProgram(program, [
        probs
    ], 'int32', customValues);
    if (!normalized) backend.disposeIntermediateTensorInfo(probs);
    return res;
}
const $9b9904aa6656bc38$export$ad960e364767f0e2 = {
    kernelName: (0, $i64bB.Multinomial),
    backendName: 'webgl',
    kernelFunc: $9b9904aa6656bc38$export$f4d580f3101a1c7e
};



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");



const $bdcfb36f87e7b0d8$var$NEG = (0, $d607b1799b79a159$export$39f0cca2b63399f6) + `
  return -x;
`;
const $bdcfb36f87e7b0d8$var$NEG_PACKED = `
  vec4 result = -x;
  bvec4 isNaN = isnan(x);

  result.r = isNaN.r ? x.r : result.r;
  result.g = isNaN.g ? x.g : result.g;
  result.b = isNaN.b ? x.b : result.b;
  result.a = isNaN.a ? x.a : result.a;

  return result;
`;
function $bdcfb36f87e7b0d8$export$d9493ff0dfa0fdd5(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    if (backend.shouldExecuteOnCPU([
        x
    ])) {
        const xData = backend.texData.get(x.dataId);
        const [outValues, newShape] = (0, $377486a788efd20b$export$1cbcde7624effb15)(xData.values, x.shape, x.dtype);
        return backend.makeTensorInfo(newShape, x.dtype, outValues);
    }
    let program;
    if ((0, $i64bB.env)().getBool('WEBGL_PACK_UNARY_OPERATIONS')) program = new (0, $d654f6ab3c8e3848$export$4d8daca4f85ed73d)(x.shape, $bdcfb36f87e7b0d8$var$NEG_PACKED);
    else program = new (0, $d607b1799b79a159$export$f93811a5a466fd42)(x.shape, $bdcfb36f87e7b0d8$var$NEG);
    return backend.runWebGLProgram(program, [
        x
    ], x.dtype);
}
const $bdcfb36f87e7b0d8$export$cc7b18b8229c3db = {
    kernelName: (0, $i64bB.Neg),
    backendName: 'webgl',
    kernelFunc: $bdcfb36f87e7b0d8$export$d9493ff0dfa0fdd5
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
const $c8e13cee1ea8ed41$var$nonMaxSuppressionV3Impl = (0, $i64bB.kernel_impls).nonMaxSuppressionV3Impl;
function $c8e13cee1ea8ed41$export$8917e4bf7f7f5d42(args) {
    (0, $i64bB.backend_util).warn("tf.nonMaxSuppression() in webgl locks the UI thread. Call tf.nonMaxSuppressionAsync() instead");
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { boxes: boxes, scores: scores } = inputs;
    const { maxOutputSize: maxOutputSize, iouThreshold: iouThreshold, scoreThreshold: scoreThreshold } = attrs;
    const boxesVals = backend.readSync(boxes.dataId);
    const scoresVals = backend.readSync(scores.dataId);
    const { selectedIndices: selectedIndices } = $c8e13cee1ea8ed41$var$nonMaxSuppressionV3Impl(boxesVals, scoresVals, maxOutputSize, iouThreshold, scoreThreshold);
    return backend.makeTensorInfo([
        selectedIndices.length
    ], 'int32', new Int32Array(selectedIndices));
}
const $c8e13cee1ea8ed41$export$549561cd158f260a = {
    kernelName: (0, $i64bB.NonMaxSuppressionV3),
    backendName: 'webgl',
    kernelFunc: $c8e13cee1ea8ed41$export$8917e4bf7f7f5d42
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
const $25e5e9f8d015448f$var$nonMaxSuppressionV4Impl = (0, $i64bB.kernel_impls).nonMaxSuppressionV4Impl;
function $25e5e9f8d015448f$export$ad519bdebe8f4dcf(args) {
    (0, $i64bB.backend_util).warn("tf.nonMaxSuppression() in webgl locks the UI thread. Call tf.nonMaxSuppressionAsync() instead");
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { boxes: boxes, scores: scores } = inputs;
    const { maxOutputSize: maxOutputSize, iouThreshold: iouThreshold, scoreThreshold: scoreThreshold, padToMaxOutputSize: padToMaxOutputSize } = attrs;
    const boxesVals = backend.readSync(boxes.dataId);
    const scoresVals = backend.readSync(scores.dataId);
    const { selectedIndices: selectedIndices, validOutputs: validOutputs } = $25e5e9f8d015448f$var$nonMaxSuppressionV4Impl(boxesVals, scoresVals, maxOutputSize, iouThreshold, scoreThreshold, padToMaxOutputSize);
    return [
        backend.makeTensorInfo([
            selectedIndices.length
        ], 'int32', new Int32Array(selectedIndices)),
        backend.makeTensorInfo([], 'int32', new Int32Array([
            validOutputs
        ]))
    ];
}
const $25e5e9f8d015448f$export$906b8fb32c570e9d = {
    kernelName: (0, $i64bB.NonMaxSuppressionV4),
    backendName: 'webgl',
    kernelFunc: $25e5e9f8d015448f$export$ad519bdebe8f4dcf
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
const $d298368f7be34cf7$var$nonMaxSuppressionV5Impl = (0, $i64bB.kernel_impls).nonMaxSuppressionV5Impl;
function $d298368f7be34cf7$export$49e389fdbe01a534(args) {
    (0, $i64bB.backend_util).warn("tf.nonMaxSuppression() in webgl locks the UI thread. Call tf.nonMaxSuppressionAsync() instead");
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { boxes: boxes, scores: scores } = inputs;
    const { maxOutputSize: maxOutputSize, iouThreshold: iouThreshold, scoreThreshold: scoreThreshold, softNmsSigma: softNmsSigma } = attrs;
    const boxesVals = backend.readSync(boxes.dataId);
    const scoresVals = backend.readSync(scores.dataId);
    const maxOutputSizeVal = maxOutputSize;
    const iouThresholdVal = iouThreshold;
    const scoreThresholdVal = scoreThreshold;
    const softNmsSigmaVal = softNmsSigma;
    const { selectedIndices: selectedIndices, selectedScores: selectedScores } = $d298368f7be34cf7$var$nonMaxSuppressionV5Impl(boxesVals, scoresVals, maxOutputSizeVal, iouThresholdVal, scoreThresholdVal, softNmsSigmaVal);
    return [
        backend.makeTensorInfo([
            selectedIndices.length
        ], 'int32', new Int32Array(selectedIndices)),
        backend.makeTensorInfo([
            selectedScores.length
        ], 'float32', new Float32Array(selectedScores))
    ];
}
const $d298368f7be34cf7$export$4c00b682f309701d = {
    kernelName: (0, $i64bB.NonMaxSuppressionV5),
    backendName: 'webgl',
    kernelFunc: $d298368f7be34cf7$export$49e389fdbe01a534
};



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $14bad1076fa74aa1$export$314e506cf5800fc5 {
    constructor(numIndices, depth, onValue, offValue){
        this.variableNames = [
            'indices'
        ];
        this.outputShape = [
            numIndices,
            depth
        ];
        this.userCode = `
      void main() {
        ivec2 coords = getOutputCoords();
        int index = round(getIndices(coords.x));
        setOutput(mix(float(${offValue}), float(${onValue}),
                      float(index == coords.y)));
      }
    `;
    }
}



const $8498c66b76463c69$export$341b5490a776d041 = (args)=>{
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { indices: indices } = inputs;
    const { dtype: dtype, depth: depth, onValue: onValue, offValue: offValue } = attrs;
    const indicesSize = (0, $i64bB.util).sizeFromShape(indices.shape);
    const program = new (0, $14bad1076fa74aa1$export$314e506cf5800fc5)(indicesSize, depth, onValue, offValue);
    const reshaped = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: indices
        },
        backend: backend,
        attrs: {
            shape: [
                indicesSize
            ]
        }
    });
    const result = backend.runWebGLProgram(program, [
        reshaped
    ], dtype);
    backend.disposeIntermediateTensorInfo(reshaped);
    const outShape = [
        ...indices.shape,
        depth
    ];
    const out = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: result
        },
        backend: backend,
        attrs: {
            shape: outShape
        }
    });
    backend.disposeIntermediateTensorInfo(result);
    return out;
};
const $8498c66b76463c69$export$dde5645b472b80b2 = {
    kernelName: (0, $i64bB.OneHot),
    backendName: 'webgl',
    kernelFunc: $8498c66b76463c69$export$341b5490a776d041
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");




/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");




function $4d9f12f1439683dc$export$cb1f824e7733584d(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    if (x.dtype === 'complex64') {
        const realPart = (0, $3d07b56624286bfa$export$9fc57fb453bdbd67)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const r = $4d9f12f1439683dc$export$cb1f824e7733584d({
            inputs: {
                x: realPart
            },
            backend: backend
        });
        const imagPart = (0, $26faf84d87c54a60$export$d78fab5778ab392b)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const i = $4d9f12f1439683dc$export$cb1f824e7733584d({
            inputs: {
                x: imagPart
            },
            backend: backend
        });
        const result = (0, $f23c2381cb68ff19$export$83a0e34f1302825b)({
            inputs: {
                real: r,
                imag: i
            },
            backend: backend
        });
        backend.disposeIntermediateTensorInfo(realPart);
        backend.disposeIntermediateTensorInfo(r);
        backend.disposeIntermediateTensorInfo(imagPart);
        backend.disposeIntermediateTensorInfo(i);
        return result;
    } else return (0, $248d06c44cbf77ee$export$9563e054e6f787fb)({
        attrs: {
            shape: x.shape,
            dtype: x.dtype,
            value: x.dtype === 'string' ? '' : 0
        },
        backend: backend
    });
}
const $4d9f12f1439683dc$export$15368df05c479e41 = {
    kernelName: (0, $i64bB.ZerosLike),
    backendName: 'webgl',
    kernelFunc: $4d9f12f1439683dc$export$cb1f824e7733584d
};


function $1d2c03b43676110a$export$fb6afd6214fee9e9(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    if (x.dtype === 'string') throw new Error('onesLike is not supported under string dtype');
    else if (x.dtype === 'complex64') {
        const realPart = (0, $3d07b56624286bfa$export$9fc57fb453bdbd67)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const r = $1d2c03b43676110a$export$fb6afd6214fee9e9({
            inputs: {
                x: realPart
            },
            backend: backend
        });
        const imagPart = (0, $26faf84d87c54a60$export$d78fab5778ab392b)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const i = (0, $4d9f12f1439683dc$export$cb1f824e7733584d)({
            inputs: {
                x: imagPart
            },
            backend: backend
        });
        const result = (0, $f23c2381cb68ff19$export$83a0e34f1302825b)({
            inputs: {
                real: r,
                imag: i
            },
            backend: backend
        });
        backend.disposeIntermediateTensorInfo(realPart);
        backend.disposeIntermediateTensorInfo(r);
        backend.disposeIntermediateTensorInfo(imagPart);
        backend.disposeIntermediateTensorInfo(i);
        return result;
    } else // TODO(cais, smilkov): Add WebGL shader for onesLike:
    //   https://github.com/tensorflow/tfjs/issues/1293
    return (0, $248d06c44cbf77ee$export$9563e054e6f787fb)({
        attrs: {
            shape: x.shape,
            dtype: x.dtype,
            value: 1
        },
        backend: backend
    });
}
const $1d2c03b43676110a$export$d8d7015eb6ab37d0 = {
    kernelName: (0, $i64bB.OnesLike),
    backendName: 'webgl',
    kernelFunc: $1d2c03b43676110a$export$fb6afd6214fee9e9
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


function $43ea7f7750daad11$export$2a703dbb0cb35339(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { axis: axis } = attrs;
    if (inputs.length === 1) return (0, $0d346f16979dfda2$export$d660d8ed21f46635)({
        inputs: {
            input: inputs[0]
        },
        backend: backend,
        attrs: {
            dim: axis
        }
    });
    const shape = inputs[0].shape;
    const dtype = inputs[0].dtype;
    inputs.forEach((t)=>{
        (0, $i64bB.util).assertShapesMatch(shape, t.shape, 'All tensors passed to stack must have matching shapes');
        (0, $i64bB.util).assert(dtype === t.dtype, ()=>'All tensors passed to stack must have matching dtypes');
    });
    const intermediateTensorInfos = [];
    const expandedTensors = inputs.map((t)=>{
        const expandedT = (0, $0d346f16979dfda2$export$d660d8ed21f46635)({
            inputs: {
                input: t
            },
            backend: backend,
            attrs: {
                dim: axis
            }
        });
        intermediateTensorInfos.push(expandedT);
        return expandedT;
    });
    const result = (0, $c761d8b937eefeed$export$ee1b3e54f0441b22)({
        inputs: expandedTensors,
        backend: backend,
        attrs: {
            axis: axis
        }
    });
    intermediateTensorInfos.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return result;
}
const $43ea7f7750daad11$export$1645fa8803aa1f86 = {
    kernelName: (0, $i64bB.Pack),
    backendName: 'webgl',
    kernelFunc: $43ea7f7750daad11$export$2a703dbb0cb35339
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
class $c1eadaabb51be24e$export$15f19b307ce21f0a {
    constructor(xShape, paddings, constantValue){
        this.variableNames = [
            'x'
        ];
        this.customUniforms = [
            {
                name: 'value',
                type: 'float'
            }
        ];
        this.outputShape = paddings.map((p, i)=>p[0] + xShape[i] + p[1]);
        const rank = xShape.length;
        const type = (0, $ba2c54ffbda39e8e$export$859efd105c10c755)(rank);
        const start = paddings.map((p)=>p[0]).join(',');
        const end = paddings.map((p, i)=>p[0] + xShape[i]).join(',');
        const unpackedCoords = [
            'coords[0]',
            'coords[1]',
            'coords[2]',
            'coords[3]'
        ].slice(0, rank);
        if (rank === 1) {
            this.userCode = `
        int start = ${start};
        int end = ${end};

        void main() {
          int outC = getOutputCoords();
          if (outC < start || outC >= end) {
            setOutput(value);
          } else {
            setOutput(getX(outC - start));
          }
        }
      `;
            return;
        }
        this.userCode = `
      ${type} start = ${type}(${start});
      ${type} end = ${type}(${end});

      void main() {
        ${type} outC = getOutputCoords();
        if (any(lessThan(outC, start)) || any(greaterThanEqual(outC, end))) {
          setOutput(value);
        } else {
          ${type} coords = outC - start;
          setOutput(getX(${unpackedCoords}));
        }
      }
    `;
    }
}


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $e253ac1590fd4b6f$export$ed21e062cfba77c5 {
    constructor(xShape, paddings, constantValue){
        this.variableNames = [
            'x'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.customUniforms = [
            {
                name: 'value',
                type: 'float'
            }
        ];
        this.outputShape = paddings.map((p, i)=>p[0] + xShape[i] + p[1]);
        const rank = xShape.length;
        const dtype = (0, $ba2c54ffbda39e8e$export$859efd105c10c755)(rank);
        const start = paddings.map((p)=>p[0]).join(',');
        const end = paddings.map((p, i)=>p[0] + xShape[i]).join(',');
        const coords = (0, $30912e1180ed417f$export$7a4d1d0d17b69972)('rc', rank);
        const source = (0, $30912e1180ed417f$export$7a4d1d0d17b69972)('source', rank);
        const cLimit = `${coords[rank - 1]} < ${this.outputShape[rank - 1]}`;
        const innerDims = rank === 1 ? 'source' : `vec2(${source.slice(-2).join()})`;
        const componentSetup = [
            `${dtype} rc = outputLoc;`,
            `${coords[rank - 1]} += 1;
       if(${cLimit}) {
      `,
            rank === 1 ? '' : `}
       rc = outputLoc;
       ${coords[rank - 2]} += 1;
       if(${coords[rank - 2]} < ${this.outputShape[rank - 2]}) {`,
            rank === 1 ? '' : `  ${coords[rank - 1]} += 1;
         if(${cLimit}) {`
        ];
        const paddingArea = rank === 1 ? 'rc < start || rc >= end' : 'any(lessThan(rc, start)) || any(greaterThanEqual(rc, end))';
        let mainLoop = '';
        for(let i = 0, j = rank === 1 ? 2 : 4; i < j; i++)mainLoop += `
        ${componentSetup[i]}
        if (${paddingArea}) {
          result[${i}] = float(value);
        } else {
          ${dtype} source = rc - start;
          result[${i}] = getChannel(getX(${source.join()}), ${innerDims});
        }
      `;
        mainLoop += rank === 1 ? `} ` : `}}`;
        this.userCode = `
      const ${dtype} start = ${dtype}(${start});
      const ${dtype} end = ${dtype}(${end});

      void main() {
        ${dtype} outputLoc = getOutputCoords();
        vec4 result = vec4(0.);
        ${mainLoop}
        setOutput(result);
      }
    `;
    }
}



const $379eb6e5685c7da3$export$f676d6ad4f38bb89 = (args)=>{
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { paddings: paddings, constantValue: constantValue } = attrs;
    if ((0, $i64bB.util).sizeFromShape(x.shape) === 0) {
        // Short-circuit the computation, since x doesn't have value, only
        // the shape is used to compute output shape to pad.
        const outputShape = paddings.map((p, i)=>p[0] + x.shape[i] + p[1]);
        return (0, $248d06c44cbf77ee$export$9563e054e6f787fb)({
            backend: backend,
            attrs: {
                shape: outputShape,
                value: constantValue,
                dtype: x.dtype
            }
        });
    }
    const program = (0, $i64bB.env)().getBool('WEBGL_PACK_ARRAY_OPERATIONS') ? new (0, $e253ac1590fd4b6f$export$ed21e062cfba77c5)(x.shape, paddings, constantValue) : new (0, $c1eadaabb51be24e$export$15f19b307ce21f0a)(x.shape, paddings, constantValue);
    const customValues = [
        [
            constantValue
        ]
    ];
    return backend.runWebGLProgram(program, [
        x
    ], x.dtype, customValues);
};
const $379eb6e5685c7da3$export$b0317e720bfd61fc = {
    kernelName: (0, $i64bB.PadV2),
    backendName: 'webgl',
    kernelFunc: $379eb6e5685c7da3$export$f676d6ad4f38bb89
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


const $8fb9dbd7dc454230$var$POW = `
  if(a < 0.0 && floor(b) < b){
    return NAN;
  }
  if (b == 0.0) {
    return 1.0;
  }
  return (round(mod(b, 2.0)) != 1) ?
      pow(abs(a), b) : sign(a) * pow(abs(a), b);
`;
const $8fb9dbd7dc454230$var$POW_PACKED = `
  // isModRound1 has 1 for components with round(mod(b, 2.0)) == 1, 0 otherwise.
  vec4 isModRound1 = vec4(equal(round(mod(b, 2.0)), ivec4(1)));
  vec4 multiplier = sign(a) * isModRound1 + (vec4(1.0) - isModRound1);
  vec4 result = multiplier * pow(abs(a), b);

  // Ensure that a^0 = 1, including 0^0 = 1 as this correspond to TF and JS
  bvec4 isExpZero = equal(b, vec4(0.0));
  result.r = isExpZero.r ? 1.0 : result.r;
  result.g = isExpZero.g ? 1.0 : result.g;
  result.b = isExpZero.b ? 1.0 : result.b;
  result.a = isExpZero.a ? 1.0 : result.a;

  bvec4 isNaN1 = lessThan(a, vec4(0.0));
  bvec4 isNaN2 = lessThan(floor(b), b);
  bvec4 isNaN = bvec4(isNaN1.x && isNaN2.x, isNaN1.y && isNaN2.y, isNaN1.z && isNaN2.z, isNaN1.w && isNaN2.w);
  ` + (0, $1b00798c48aa5c1a$export$2b4d5cee4bd7b2dd) + `
  return result;
`;
const $8fb9dbd7dc454230$export$9c297f60e22e3389 = (0, $2e65282075da2b30$export$29353c66e70e3e16)({
    opSnippet: $8fb9dbd7dc454230$var$POW,
    packedOpSnippet: $8fb9dbd7dc454230$var$POW_PACKED
});
const $8fb9dbd7dc454230$export$b823d49786719761 = {
    kernelName: (0, $i64bB.Pow),
    backendName: 'webgl',
    kernelFunc: $8fb9dbd7dc454230$export$9c297f60e22e3389
};



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");




function $dffda8227da65443$export$5e143010dea16c85(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    const xRank = x.shape.length;
    const toDispose = [];
    const origAxes = (0, $i64bB.util).parseAxisParam(axis, x.shape);
    let axes = origAxes;
    const permutedAxes = (0, $i64bB.backend_util).getAxesPermutation(axes, xRank);
    let permutedX = x;
    if (permutedAxes != null) {
        permutedX = (0, $6cab078553124169$export$9cb09a71b7d66923)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutedAxes
            }
        });
        axes = (0, $i64bB.backend_util).getInnerMostAxes(axes.length, xRank);
        toDispose.push(permutedX);
    }
    (0, $i64bB.backend_util).assertAxesAreInnerMostDims('prod', axes, xRank);
    let res;
    if (backend.shouldExecuteOnCPU([
        permutedX
    ])) {
        const xVals = backend.texData.get(permutedX.dataId).values;
        const { outVals: outVals, outShape: outShape, outDtype: outDtype } = (0, $377486a788efd20b$export$2d654219115cec80)(permutedX.shape, permutedX.dtype, xVals, axes);
        res = backend.makeTensorInfo(outShape, outDtype, outVals);
    } else {
        const [outShape, reduceShape] = (0, $i64bB.backend_util).computeOutAndReduceShapes(permutedX.shape, axes);
        const inSize = (0, $i64bB.util).sizeFromShape(reduceShape);
        const a2D = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
            inputs: {
                x: permutedX
            },
            backend: backend,
            attrs: {
                shape: [
                    -1,
                    inSize
                ]
            }
        });
        const outputDType = (0, $i64bB.sumOutType)(x.dtype);
        const reduced = (0, $8c1b6ed50cb28ef5$export$533b26079ad0b4b)(a2D, outputDType, 'prod', backend);
        res = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
            inputs: {
                x: reduced
            },
            backend: backend,
            attrs: {
                shape: outShape
            }
        });
        toDispose.push(a2D);
        toDispose.push(reduced);
    }
    if (keepDims) {
        toDispose.push(res);
        const newShape = (0, $i64bB.backend_util).expandShapeToKeepDim(res.shape, origAxes);
        res = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
            inputs: {
                x: res
            },
            backend: backend,
            attrs: {
                shape: newShape
            }
        });
    }
    toDispose.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return res;
}
const $dffda8227da65443$export$d556aa935cef5c0c = {
    kernelName: (0, $i64bB.Prod),
    backendName: 'webgl',
    kernelFunc: $dffda8227da65443$export$5e143010dea16c85
};


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

function $155385e0abb1f75e$export$e7118f605df251dd(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { paramsNestedSplits: paramsNestedSplits, paramsDenseValues: paramsDenseValues, indices: indices } = inputs;
    const { outputRaggedRank: outputRaggedRank } = attrs;
    const $paramsNestedSplits = paramsNestedSplits.map((t)=>backend.readSync(t.dataId));
    const $paramsNestedSplitsShapes = paramsNestedSplits.map((t)=>t.shape);
    const $paramsDenseValues = backend.readSync(paramsDenseValues.dataId);
    const $indices = backend.readSync(indices.dataId);
    const [outputNestedSplits, outputDenseValues, outputDenseValuesShape] = (0, $377486a788efd20b$export$7cf38d50772f4bbc)($paramsNestedSplits, $paramsNestedSplitsShapes, $paramsDenseValues, paramsDenseValues.shape, paramsDenseValues.dtype, $indices, indices.shape, outputRaggedRank);
    const outputNestedSplitsTensors = outputNestedSplits.map((splits)=>backend.makeTensorInfo([
            splits.length
        ], 'int32', splits));
    const outputDenseValuesTensor = backend.makeTensorInfo(outputDenseValuesShape, paramsDenseValues.dtype, outputDenseValues);
    return outputNestedSplitsTensors.concat([
        outputDenseValuesTensor
    ]);
}
const $155385e0abb1f75e$export$cebb8a7d5932c7e8 = {
    kernelName: (0, $i64bB.RaggedGather),
    backendName: 'webgl',
    kernelFunc: $155385e0abb1f75e$export$e7118f605df251dd
};


/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

function $0fa10c28cfabb2db$export$a173be400c6762b5(args) {
    const { inputs: inputs, backend: backend } = args;
    const { starts: starts, limits: limits, deltas: deltas } = inputs;
    const $starts = backend.readSync(starts.dataId);
    const $limits = backend.readSync(limits.dataId);
    const $deltas = backend.readSync(deltas.dataId);
    const [rtNestedSplitsData, rtDenseValuesData] = (0, $377486a788efd20b$export$46d9d0942af5d1c2)($starts, starts.shape, starts.dtype, $limits, limits.shape, $deltas, deltas.shape);
    const rtNestedSplits = backend.makeTensorInfo([
        rtNestedSplitsData.length
    ], 'int32', rtNestedSplitsData);
    const rtDenseValues = backend.makeTensorInfo([
        rtDenseValuesData.length
    ], starts.dtype, rtDenseValuesData);
    return [
        rtNestedSplits,
        rtDenseValues
    ];
}
const $0fa10c28cfabb2db$export$91ddd62a193b9401 = {
    kernelName: (0, $i64bB.RaggedRange),
    backendName: 'webgl',
    kernelFunc: $0fa10c28cfabb2db$export$a173be400c6762b5
};


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

function $bb3e44408fa68e6b$export$621e390307cbbaa1(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { shape: shape, values: values, defaultValue: defaultValue, rowPartitionTensors: rowPartitionTensors } = inputs;
    const { rowPartitionTypes: rowPartitionTypes } = attrs;
    const $shape = backend.readSync(shape.dataId);
    const $values = backend.readSync(values.dataId);
    const $defaultValue = backend.readSync(defaultValue.dataId);
    const $rowPartitionValues = rowPartitionTensors.map((t)=>backend.readSync(t.dataId));
    const rowPartitionValuesShapes = rowPartitionTensors.map((t)=>t.shape);
    const [outputShape, output] = (0, $377486a788efd20b$export$b3c4ab635ddc431f)($shape, shape.shape, $values, values.shape, values.dtype, $defaultValue, defaultValue.shape, $rowPartitionValues, rowPartitionValuesShapes, rowPartitionTypes);
    return backend.makeTensorInfo(outputShape, values.dtype, output);
}
const $bb3e44408fa68e6b$export$792f441e33dcdf26 = {
    kernelName: (0, $i64bB.RaggedTensorToTensor),
    backendName: 'webgl',
    kernelFunc: $bb3e44408fa68e6b$export$621e390307cbbaa1
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

const $97a00e65e93acdcd$export$d02631cccf789723 = (args)=>{
    const { backend: backend, attrs: attrs } = args;
    const { start: start, stop: stop, step: step, dtype: dtype } = attrs;
    const values = (0, $377486a788efd20b$export$fbee6deed7e76443)(start, stop, step, dtype);
    return backend.makeTensorInfo([
        values.length
    ], dtype, values);
};
const $97a00e65e93acdcd$export$361c4075706e31c2 = {
    kernelName: (0, $i64bB.Range),
    backendName: 'webgl',
    kernelFunc: $97a00e65e93acdcd$export$d02631cccf789723
};




/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

const $4c1d1885d9605a9a$var$RECIPROCAL = `return 1.0 / x;`;
const $4c1d1885d9605a9a$export$163bc8c839a1ac04 = (0, $2e65282075da2b30$export$ba4daf5748026fba)({
    opSnippet: $4c1d1885d9605a9a$var$RECIPROCAL
});
const $4c1d1885d9605a9a$export$412a6b66203fdf72 = {
    kernelName: (0, $i64bB.Reciprocal),
    backendName: 'webgl',
    kernelFunc: $4c1d1885d9605a9a$export$163bc8c839a1ac04
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


const $f30b554a6f09ab36$var$RELU = (0, $d607b1799b79a159$export$39f0cca2b63399f6) + `
  return (x < 0.0) ? 0.0 : x;
`;
const $f30b554a6f09ab36$var$RELU_PACKED = `
  vec4 result = x * vec4(greaterThanEqual(x, vec4(0.0)));
  bvec4 isNaN = isnan(x);

  result.r = isNaN.r ? x.r : result.r;
  result.g = isNaN.g ? x.g : result.g;
  result.b = isNaN.b ? x.b : result.b;
  result.a = isNaN.a ? x.a : result.a;

  return result;
`;
const $f30b554a6f09ab36$export$16d1e4612cc0139f = (0, $2e65282075da2b30$export$ba4daf5748026fba)({
    opSnippet: $f30b554a6f09ab36$var$RELU,
    packedOpSnippet: $f30b554a6f09ab36$var$RELU_PACKED
});
const $f30b554a6f09ab36$export$731f9199bde068eb = {
    kernelName: (0, $i64bB.Relu),
    backendName: 'webgl',
    kernelFunc: $f30b554a6f09ab36$export$16d1e4612cc0139f
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


const $edf36a5ae3cebc82$var$RELU6 = (0, $d607b1799b79a159$export$39f0cca2b63399f6) + `
  return (x < 0.0) ? 0.0 : min(6.0, x);
`;
const $edf36a5ae3cebc82$var$RELU6_PACKED = `
  vec4 result = min(x, vec4(6.)) * vec4(greaterThanEqual(x, vec4(0.0)));
  bvec4 isNaN = isnan(x);

  result.r = isNaN.r ? x.r : result.r;
  result.g = isNaN.g ? x.g : result.g;
  result.b = isNaN.b ? x.b : result.b;
  result.a = isNaN.a ? x.a : result.a;

  return result;
`;
const $edf36a5ae3cebc82$export$4a62bcb95e9c44c4 = (0, $2e65282075da2b30$export$ba4daf5748026fba)({
    opSnippet: $edf36a5ae3cebc82$var$RELU6,
    packedOpSnippet: $edf36a5ae3cebc82$var$RELU6_PACKED
});
const $edf36a5ae3cebc82$export$92c30890ad649d53 = {
    kernelName: (0, $i64bB.Relu6),
    backendName: 'webgl',
    kernelFunc: $edf36a5ae3cebc82$export$4a62bcb95e9c44c4
};



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $ed403ee7de7c0df1$export$52b2ccd78b972549 {
    constructor(inputShape, newHeight, newWidth, alignCorners, halfPixelCenters){
        this.variableNames = [
            'A'
        ];
        this.outputShape = [];
        const [batch, oldHeight, oldWidth, depth] = inputShape;
        this.outputShape = [
            batch,
            newHeight,
            newWidth,
            depth
        ];
        const effectiveInSize = [
            alignCorners && newHeight > 1 ? oldHeight - 1 : oldHeight,
            alignCorners && newWidth > 1 ? oldWidth - 1 : oldWidth
        ];
        const effectiveOutSize = [
            alignCorners && newHeight > 1 ? newHeight - 1 : newHeight,
            alignCorners && newWidth > 1 ? newWidth - 1 : newWidth
        ];
        let sourceFracIndexRC;
        if (halfPixelCenters) sourceFracIndexRC = `(vec2(yRC) + vec2(0.5)) * effectiveInputOverOutputRatioRC` + ` - vec2(0.5)`;
        else sourceFracIndexRC = `vec2(yRC) * effectiveInputOverOutputRatioRC`;
        this.userCode = `
      const vec2 effectiveInputOverOutputRatioRC = vec2(
          ${effectiveInSize[0] / effectiveOutSize[0]},
          ${effectiveInSize[1] / effectiveOutSize[1]});
      const vec2 inputShapeRC = vec2(${oldHeight}.0, ${oldWidth}.0);

      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];
        ivec2 yRC = coords.yz;

        // Fractional source index.
        vec2 sourceFracIndexRC = ${sourceFracIndexRC};

        // Compute the four integer indices.
        ivec2 sourceFloorRC = ivec2(max(sourceFracIndexRC, vec2(0.0)));
        ivec2 sourceCeilRC = ivec2(
          min(inputShapeRC - 1.0, ceil(sourceFracIndexRC)));

        float topLeft = getA(b, sourceFloorRC.x, sourceFloorRC.y, d);
        float bottomLeft = getA(b, sourceCeilRC.x, sourceFloorRC.y, d);
        float topRight = getA(b, sourceFloorRC.x, sourceCeilRC.y, d);
        float bottomRight = getA(b, sourceCeilRC.x, sourceCeilRC.y, d);

        vec2 fracRC = sourceFracIndexRC - vec2(sourceFloorRC);

        float top = topLeft + (topRight - topLeft) * fracRC.y;
        float bottom = bottomLeft + (bottomRight - bottomLeft) * fracRC.y;
        float newValue = top + (bottom - top) * fracRC.x;

        setOutput(newValue);
      }
    `;
    }
}


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $f54a9b15c02f2a3c$export$b334a0f2524628a {
    constructor(inputShape, newHeight, newWidth, alignCorners, halfPixelCenters){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.outputShape = [];
        const [batch, oldHeight, oldWidth, depth] = inputShape;
        this.outputShape = [
            batch,
            newHeight,
            newWidth,
            depth
        ];
        const effectiveInSize = [
            alignCorners && newHeight > 1 ? oldHeight - 1 : oldHeight,
            alignCorners && newWidth > 1 ? oldWidth - 1 : oldWidth
        ];
        const effectiveOutSize = [
            alignCorners && newHeight > 1 ? newHeight - 1 : newHeight,
            alignCorners && newWidth > 1 ? newWidth - 1 : newWidth
        ];
        let sourceFracIndexRC;
        if (halfPixelCenters) sourceFracIndexRC = `(vec3(yRC) + vec3(0.5)) * ` + `effectiveInputOverOutputRatioRC - vec3(0.5)`;
        else sourceFracIndexRC = `vec3(yRC) * effectiveInputOverOutputRatioRC`;
        this.userCode = `
      const vec3 effectiveInputOverOutputRatioRC = vec3(
          ${effectiveInSize[0] / effectiveOutSize[0]},
          ${effectiveInSize[1] / effectiveOutSize[1]},
          ${effectiveInSize[1] / effectiveOutSize[1]});
      const vec3 inputShapeRC = vec3(${oldHeight}.0, ${oldWidth}.0,
                                     ${oldWidth}.0);

      float getAValue(int b, int r, int c, int d) {
        return getChannel(getA(b, r, c, d), vec2(c, d));
      }

      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];
        // Calculate values for next column in yRC.z.
        ivec3 yRC = coords.yzz + ivec3(0, 0, 1);

        // Fractional source index.
        vec3 sourceFracIndexRC = ${sourceFracIndexRC};

        // Compute the four integer indices.
        ivec3 sourceFloorRC = ivec3(max(sourceFracIndexRC, vec3(0.0)));
        ivec3 sourceCeilRC = ivec3(
          min(inputShapeRC - 1.0, ceil(sourceFracIndexRC)));

        // Should we calculate next column and row elements in 2x2 packed cell.
        bool hasNextCol = d < ${depth - 1};
        bool hasNextRow = coords.z < ${newWidth - 1};

        // In parallel, construct four corners for all four components in
        // packed 2x2 cell.
        vec4 topLeft = vec4(
          getAValue(b, sourceFloorRC.x, sourceFloorRC.y, d),
          hasNextCol ? getAValue(b, sourceFloorRC.x, sourceFloorRC.y, d + 1)
                     : 0.0,
          hasNextRow ? getAValue(b, sourceFloorRC.x, sourceFloorRC.z, d)
                     : 0.0,
          (hasNextRow && hasNextCol) ?
            getAValue(b, sourceFloorRC.x, sourceFloorRC.z, d + 1) : 0.0);

        vec4 bottomLeft = vec4(
          getAValue(b, sourceCeilRC.x, sourceFloorRC.y, d),
          hasNextCol ? getAValue(b, sourceCeilRC.x, sourceFloorRC.y, d + 1)
                     : 0.0,
          hasNextRow ? getAValue(b, sourceCeilRC.x, sourceFloorRC.z, d)
                     : 0.0,
          (hasNextRow && hasNextCol) ?
            getAValue(b, sourceCeilRC.x, sourceFloorRC.z, d + 1) : 0.0);

        vec4 topRight = vec4(
          getAValue(b, sourceFloorRC.x, sourceCeilRC.y, d),
          hasNextCol ? getAValue(b, sourceFloorRC.x, sourceCeilRC.y, d + 1)
                     : 0.0,
          hasNextRow ? getAValue(b, sourceFloorRC.x, sourceCeilRC.z, d)
                     : 0.0,
          (hasNextRow && hasNextCol) ?
            getAValue(b, sourceFloorRC.x, sourceCeilRC.z, d + 1) : 0.0);

        vec4 bottomRight = vec4(
          getAValue(b, sourceCeilRC.x, sourceCeilRC.y, d),
          hasNextCol ? getAValue(b, sourceCeilRC.x, sourceCeilRC.y, d + 1)
                     : 0.0,
          hasNextRow ? getAValue(b, sourceCeilRC.x, sourceCeilRC.z, d)
                     : 0.0,
          (hasNextRow && hasNextCol) ?
            getAValue(b, sourceCeilRC.x, sourceCeilRC.z, d + 1) : 0.0);

        vec3 fracRC = sourceFracIndexRC - vec3(sourceFloorRC);

        vec4 top = mix(topLeft, topRight, fracRC.yyzz);
        vec4 bottom = mix(bottomLeft, bottomRight, fracRC.yyzz);
        vec4 newValue = mix(top, bottom, fracRC.x);

        setOutput(newValue);
      }
    `;
    }
}


function $d7d24d31ce35f034$export$1f1cbc7da93d06a0(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { images: images } = inputs;
    const { alignCorners: alignCorners, halfPixelCenters: halfPixelCenters, size: size } = attrs;
    const [newHeight, newWidth] = size;
    const program = (0, $i64bB.env)().getBool('WEBGL_PACK_IMAGE_OPERATIONS') ? new (0, $f54a9b15c02f2a3c$export$b334a0f2524628a)(images.shape, newHeight, newWidth, alignCorners, halfPixelCenters) : new (0, $ed403ee7de7c0df1$export$52b2ccd78b972549)(images.shape, newHeight, newWidth, alignCorners, halfPixelCenters);
    return backend.runWebGLProgram(program, [
        images
    ], 'float32');
}
const $d7d24d31ce35f034$export$a37a56137abc1357 = {
    kernelName: (0, $i64bB.ResizeBilinear),
    backendName: 'webgl',
    kernelFunc: $d7d24d31ce35f034$export$1f1cbc7da93d06a0
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $e215711b31f3d4e1$export$dd552814323a3592 {
    constructor(dyShape, inputShape, alignCorners){
        this.variableNames = [
            'dy'
        ];
        this.outputShape = [];
        this.outputShape = inputShape;
        const [, xHeight, xWidth] = inputShape;
        const [, yHeight, yWidth] = dyShape;
        // In the backwards pass, we want to find the pixels that were generated for
        // each pixel in the input image the forward pass and add the corresponding
        // coefficient from dy to the gradient (with some interpolation).
        const effectiveXSize = [
            alignCorners && yHeight > 1 ? xHeight - 1 : xHeight,
            alignCorners && yWidth > 1 ? xWidth - 1 : xWidth
        ];
        const effectiveYSize = [
            alignCorners && yHeight > 1 ? yHeight - 1 : yHeight,
            alignCorners && yWidth > 1 ? yWidth - 1 : yWidth
        ];
        const heightScale = effectiveXSize[0] / effectiveYSize[0];
        const widthScale = effectiveXSize[1] / effectiveYSize[1];
        const invHeightScale = 1 / heightScale;
        const invWidthScale = 1 / widthScale;
        // This defines the size of the window of values around a particular
        // index in dy that we want to search for contributions to dx.
        const winHeight = Math.ceil(invHeightScale) * 2 + 2;
        const winWidth = Math.ceil(invWidthScale) * 2 + 2;
        this.userCode = `
      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];
        int r = coords[1];
        int c = coords[2];

        float accumulator = 0.0;

        const float heightScale = float(${heightScale});
        const float widthScale = float(${widthScale});

        const float invHeightScale = float(${invHeightScale});
        const float invWidthScale = float(${invWidthScale});

        const int winHeight = int(${winHeight});
        const int winWidth = int(${winWidth});

        // Compute bounds for where in dy we will look
        float startRLerp = floor(float(r) * invHeightScale);
        int startDyR = int(startRLerp - float(winHeight / 2));

        float startCLerp = floor(float(c) * invWidthScale);
        int startDyC = int(startCLerp - float(winWidth / 2));

        // Loop over dy
        for (int dyROffset = 0; dyROffset < winHeight; dyROffset++) {
          int dyR = dyROffset + startDyR;

          // Guard against the window exceeding the bounds of dy
          if (dyR < 0 || dyR >= ${yHeight}) {
            continue;
          }

          for (int dyCOffset = 0; dyCOffset < winWidth; dyCOffset++) {
            int dyC = dyCOffset + startDyC;

            // Guard against the window exceeding the bounds of dy
            if (dyC < 0 || dyC >= ${yWidth}) {
              continue;
            }

            float dxR = float(dyR) * heightScale;
            int topDxRIndex = int(floor(dxR));
            int bottomDxRIndex = int(min(ceil(dxR), ${xHeight - 1}.0));
            float dxRLerp = dxR - float(topDxRIndex);
            float inverseDxRLerp = 1.0 - dxRLerp;

            float dxC = float(dyC) * widthScale;
            int leftDxCIndex = int(floor(dxC));
            int rightDxCIndex = int(min(ceil(dxC), ${xWidth - 1}.0));
            float dxCLerp = dxC - float(leftDxCIndex);
            float inverseDxCLerp = 1.0 - dxCLerp;

            if (r == topDxRIndex && c == leftDxCIndex) {
              // topLeft
              accumulator +=
                getDy(b, dyR, dyC, d) * inverseDxRLerp * inverseDxCLerp;
            }

            if (r == topDxRIndex && c == rightDxCIndex) {
              // topRight
              accumulator += getDy(b, dyR, dyC, d) * inverseDxRLerp * dxCLerp;
            }

            if (r == bottomDxRIndex && c == leftDxCIndex) {
              // bottomLeft
              accumulator += getDy(b, dyR, dyC, d) * dxRLerp * inverseDxCLerp;
            }

            if (r == bottomDxRIndex && c == rightDxCIndex) {
              // bottomRight
              accumulator += getDy(b, dyR, dyC, d) * dxRLerp * dxCLerp;
            }
          }
        }
        // End loop over dy

        setOutput(accumulator);
      }
    `;
    }
}


function $1190a0baca979f1c$export$8899506794ec394(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { images: images, dy: dy } = inputs;
    const { alignCorners: alignCorners } = attrs;
    const program = new (0, $e215711b31f3d4e1$export$dd552814323a3592)(dy.shape, images.shape, alignCorners);
    return backend.runWebGLProgram(program, [
        dy
    ], dy.dtype);
}
const $1190a0baca979f1c$export$51f84ca614e84763 = {
    kernelName: (0, $i64bB.ResizeBilinearGrad),
    backendName: 'webgl',
    kernelFunc: $1190a0baca979f1c$export$8899506794ec394
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $3c7ea54096197197$export$2218952be90fb74a {
    constructor(inputShape, newHeight, newWidth, alignCorners, halfPixelCenters){
        this.variableNames = [
            'A'
        ];
        this.outputShape = [];
        const [batch, oldHeight, oldWidth, depth] = inputShape;
        this.outputShape = [
            batch,
            newHeight,
            newWidth,
            depth
        ];
        const effectiveInSize = [
            alignCorners && newHeight > 1 ? oldHeight - 1 : oldHeight,
            alignCorners && newWidth > 1 ? oldWidth - 1 : oldWidth
        ];
        const effectiveOutSize = [
            alignCorners && newHeight > 1 ? newHeight - 1 : newHeight,
            alignCorners && newWidth > 1 ? newWidth - 1 : newWidth
        ];
        // When align corners is false, we rounds the value with floor.
        const roundBase = alignCorners ? '0.5' : '0.0';
        let sourceFracIndexRC;
        if (halfPixelCenters) sourceFracIndexRC = `max((vec2(yRC) + vec2(0.5)) * effectiveInputOverOutputRatioRC` + `, vec2(0.0))`;
        else sourceFracIndexRC = `vec2(yRC) * effectiveInputOverOutputRatioRC`;
        this.userCode = `
      const vec2 effectiveInputOverOutputRatioRC = vec2(
          ${effectiveInSize[0] / effectiveOutSize[0]},
          ${effectiveInSize[1] / effectiveOutSize[1]});
      const vec2 inputShapeRC = vec2(${oldHeight}.0, ${oldWidth}.0);

      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];
        ivec2 yRC = coords.yz;

        // Fractional source index.
        vec2 sourceFracIndexRC = ${sourceFracIndexRC};

        // Compute the coordinators of nearest neighbor point.
        ivec2 sourceNearestRC = ivec2(
          min(inputShapeRC - 1.0, floor(sourceFracIndexRC + ${roundBase})));
        float newValue = getA(b, sourceNearestRC.x, sourceNearestRC.y, d);

        setOutput(newValue);
      }
    `;
    }
}


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $6d89ee53e63d7ead$export$a616f6d9a33abf84 {
    constructor(inputShape, newHeight, newWidth, alignCorners, halfPixelCenters){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.outputShape = [];
        const [batch, oldHeight, oldWidth, depth] = inputShape;
        this.outputShape = [
            batch,
            newHeight,
            newWidth,
            depth
        ];
        const effectiveInSize = [
            alignCorners && newHeight > 1 ? oldHeight - 1 : oldHeight,
            alignCorners && newWidth > 1 ? oldWidth - 1 : oldWidth
        ];
        const effectiveOutSize = [
            alignCorners && newHeight > 1 ? newHeight - 1 : newHeight,
            alignCorners && newWidth > 1 ? newWidth - 1 : newWidth
        ];
        // When align corners is false, we rounds the value with floor.
        const roundBase = alignCorners ? '0.5' : '0.0';
        let sourceFracIndexRC;
        if (halfPixelCenters) sourceFracIndexRC = `max((vec3(yRC) + vec3(0.5)) * ` + `effectiveInputOverOutputRatioRC, vec3(0.0))`;
        else sourceFracIndexRC = `vec3(yRC) * effectiveInputOverOutputRatioRC`;
        this.userCode = `
      const vec3 effectiveInputOverOutputRatioRC = vec3(
          ${effectiveInSize[0] / effectiveOutSize[0]},
          ${effectiveInSize[1] / effectiveOutSize[1]},
          ${effectiveInSize[1] / effectiveOutSize[1]});
      const vec3 inputShapeRC = vec3(${oldHeight}.0, ${oldWidth}.0,
                                     ${oldWidth}.0);

      float getAValue(int b, int r, int c, int d) {
        return getChannel(getA(b, r, c, d), vec2(c, d));
      }

      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];
        // Calculate values for next column in yRC.z.
        ivec3 yRC = coords.yzz + ivec3(0, 0, 1);

        // Fractional source index.
        vec3 sourceFracIndexRC = ${sourceFracIndexRC};

        // Compute the coordinators of nearest neighbor point.
        ivec3 sourceNearestRC = ivec3(
          min(inputShapeRC - 1.0, floor(sourceFracIndexRC + ${roundBase})));

        // Should we calculate next column and row elements in 2x2 packed cell.
        bool hasNextCol = d < ${depth - 1};
        bool hasNextRow = coords.z < ${newWidth - 1};

        vec4 newValue = vec4(
          getAValue(b, sourceNearestRC.x, sourceNearestRC.y, d),
          hasNextCol ? getAValue(b, sourceNearestRC.x, sourceNearestRC.y, d + 1)
                     : 0.0,
          hasNextRow ? getAValue(b, sourceNearestRC.x, sourceNearestRC.z, d)
                     : 0.0,
          (hasNextRow && hasNextCol) ?
            getAValue(b, sourceNearestRC.x, sourceNearestRC.z, d + 1) : 0.0);

        setOutput(newValue);
      }
    `;
    }
}


function $63afc1d59801f149$export$74a902ae74ac2560(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { images: images } = inputs;
    const { alignCorners: alignCorners, halfPixelCenters: halfPixelCenters, size: size } = attrs;
    const [newHeight, newWidth] = size;
    const program = (0, $i64bB.env)().getBool('WEBGL_PACK_IMAGE_OPERATIONS') ? new (0, $6d89ee53e63d7ead$export$a616f6d9a33abf84)(images.shape, newHeight, newWidth, alignCorners, halfPixelCenters) : new (0, $3c7ea54096197197$export$2218952be90fb74a)(images.shape, newHeight, newWidth, alignCorners, halfPixelCenters);
    return backend.runWebGLProgram(program, [
        images
    ], images.dtype);
}
const $63afc1d59801f149$export$2b6a92caba113b89 = {
    kernelName: (0, $i64bB.ResizeNearestNeighbor),
    backendName: 'webgl',
    kernelFunc: $63afc1d59801f149$export$74a902ae74ac2560
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $d78c0304618e2b4e$export$b6671a84abe827c4 {
    constructor(dyShape, inputShape, alignCorners){
        this.variableNames = [
            'dy'
        ];
        this.outputShape = [];
        this.outputShape = inputShape;
        const [, xHeight, xWidth] = inputShape;
        const [, yHeight, yWidth] = dyShape;
        // In the backwards pass, we want to find the pixels that were generated for
        // each pixel in the input image the forward pass and add the corresponding
        // coefficient from dy to the gradient (with some interpolation).
        const effectiveXSize = [
            alignCorners && yHeight > 1 ? xHeight - 1 : xHeight,
            alignCorners && yWidth > 1 ? xWidth - 1 : xWidth
        ];
        const effectiveYSize = [
            alignCorners && yHeight > 1 ? yHeight - 1 : yHeight,
            alignCorners && yWidth > 1 ? yWidth - 1 : yWidth
        ];
        const heightScale = effectiveXSize[0] / effectiveYSize[0];
        const widthScale = effectiveXSize[1] / effectiveYSize[1];
        const invHeightScale = 1 / heightScale;
        const invWidthScale = 1 / widthScale;
        // This defines the size of the window of values around a particular
        // index in dy that we want to search for contributions to dx.
        const winHeight = Math.ceil(invHeightScale) * 2 + 2;
        const winWidth = Math.ceil(invWidthScale) * 2 + 2;
        this.userCode = `
      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];
        int r = coords[1];
        int c = coords[2];

        float accumulator = 0.0;

        const float heightScale = float(${heightScale});
        const float widthScale = float(${widthScale});

        const float invHeightScale = float(${invHeightScale});
        const float invWidthScale = float(${invWidthScale});

        const int winHeight = int(${winHeight});
        const int winWidth = int(${winWidth});

        // Compute bounds for where in dy we will look
        float startRLerp = floor(float(r) * invHeightScale);
        int startDyR = int(floor(startRLerp - float(winHeight / 2)));

        float startCLerp = floor(float(c) * invWidthScale);
        int startDyC = int(floor(startCLerp - float(winWidth / 2)));

        // Loop over dy
        for (int dyROffset = 0; dyROffset < winHeight; dyROffset++) {
          int dyR = dyROffset + startDyR;

          // Guard against the window exceeding the bounds of dy
          if (dyR < 0 || dyR >= ${yHeight}) {
            continue;
          }

          for (int dyCOffset = 0; dyCOffset < winWidth; dyCOffset++) {
            int dyC = dyCOffset + startDyC;

            // Guard against the window exceeding the bounds of dy
            if (dyC < 0 || dyC >= ${yWidth}) {
              continue;
            }

            float sourceFracRow =
              float(${effectiveXSize[0]}) *
                (float(dyR) / float(${effectiveYSize[0]}));

            float sourceFracCol =
                float(${effectiveXSize[1]}) *
                  (float(dyC) / float(${effectiveYSize[1]}));

            int sourceNearestRow = int(min(
                float(int(${xHeight}) - 1),
                ${alignCorners} ? float(round(sourceFracRow)) :
                                  float(floor(sourceFracRow))));

            int sourceNearestCol = int(min(
                float(int(${xWidth}) - 1),
                ${alignCorners} ? float(round(sourceFracCol)) :
                                  float(floor(sourceFracCol))));

            if (r == sourceNearestRow && c == sourceNearestCol) {
              accumulator += getDy(b, dyR, dyC, d);
            }
          }
        }
        // End loop over dy

        setOutput(accumulator);
      }
    `;
    }
}


function $e8d5b8825368dcdd$export$2b75795f158f1b18(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { images: images, dy: dy } = inputs;
    const { alignCorners: alignCorners } = attrs;
    const program = new (0, $d78c0304618e2b4e$export$b6671a84abe827c4)(dy.shape, images.shape, alignCorners);
    return backend.runWebGLProgram(program, [
        dy
    ], dy.dtype);
}
const $e8d5b8825368dcdd$export$2b08d810b5090fe1 = {
    kernelName: (0, $i64bB.ResizeNearestNeighborGrad),
    backendName: 'webgl',
    kernelFunc: $e8d5b8825368dcdd$export$2b75795f158f1b18
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
class $67d13ae84ff00d60$export$abc2effa29e77e92 {
    constructor(xShape, axis){
        this.variableNames = [
            'x'
        ];
        const rank = xShape.length;
        if (rank > 4) throw new Error(`WebGL backend: Reverse of rank-${rank} tensor is not yet supported`);
        this.outputShape = xShape;
        if (rank === 1) {
            this.userCode = `
        void main() {
          int coord = getOutputCoords();
          setOutput(getX(${xShape[0]} - coord - 1));
        }
      `;
            return;
        }
        const getInCoord = (i)=>{
            if (axis.indexOf(i) !== -1 && xShape[i] !== 1) return `${xShape[i]} - coords[${i}] - 1`;
            return `coords[${i}]`;
        };
        const inCoords = xShape.map((_, i)=>getInCoord(i)).join(',');
        const type = (0, $ba2c54ffbda39e8e$export$859efd105c10c755)(rank);
        this.userCode = `
      void main() {
        ${type} coords = getOutputCoords();
        setOutput(getX(${inCoords}));
      }
    `;
    }
}


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $43c4d498b18f602e$export$e427e51a4a356956 {
    constructor(xShape, axis){
        this.variableNames = [
            'x'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        const rank = xShape.length;
        if (rank > 4) throw new Error(`WebGL backend: Reverse of rank-${rank} tensor is not yet supported`);
        this.outputShape = xShape;
        const channels = (0, $30912e1180ed417f$export$7a4d1d0d17b69972)('rc', rank);
        const nextColumn = `${channels[rank - 1]} + 1 < ${this.outputShape[rank - 1]}`;
        const nextRow = `${channels[rank - 2]} + 1 < ${this.outputShape[rank - 2]}`;
        const type = (0, $ba2c54ffbda39e8e$export$859efd105c10c755)(rank);
        if (rank === 1) this.userCode = `
        void main(){
          int rc = getOutputCoords();
          vec4 result = vec4(0.);
          result.r = getChannel(getX(${xShape[0]} - rc - 1),
            ${xShape[0]} - rc - 1);
          if(${nextColumn}){
              result.g = getChannel(getX(${xShape[0]} - (rc  + 1) - 1),
                ${xShape[0]} - (rc  + 1) - 1);
          }
          setOutput(result);
        }
      `;
        else this.userCode = `
        void main() {
          ${type} rc = getOutputCoords();
          vec4 result = vec4(0.);
          result.r = ${getR(channels.slice())};
          if(${nextColumn}){
            result.g = ${getG(channels.slice())};
          }
          if(${nextRow}) {
            result.b = ${getB(channels.slice())};
            if(${nextColumn}) {
              result.a = ${getA(channels.slice())};
            }
          }
          setOutput(result);
        }
    `;
        function getR(channels) {
            return getChannel(channels);
        }
        function getG(channels) {
            channels[rank - 1] = '(' + channels[rank - 1] + ` + 1)`;
            return getChannel(channels);
        }
        function getB(channels) {
            channels[rank - 2] = '(' + channels[rank - 2] + ` + 1)`;
            return getChannel(channels);
        }
        function getA(channels) {
            channels[rank - 1] = '(' + channels[rank - 1] + ` + 1)`;
            channels[rank - 2] = '(' + channels[rank - 2] + ` + 1)`;
            return getChannel(channels);
        }
        function getChannel(channels) {
            const inCoordsArray = xShape.map((_, i)=>getInCoord(i, channels));
            const inCoords = inCoordsArray.join(',');
            const innerDims = inCoordsArray.slice(-2).join(',');
            return `getChannel(getX(${inCoords}), vec2(${innerDims}))`;
        }
        function getInCoord(i, channels1) {
            if (axis.indexOf(i) !== -1 && xShape[i] !== 1) return `${xShape[i]} - ${channels1[i]} - 1`;
            else return `${channels1[i]}`;
        }
    }
}



function $fb2cfa1996ec5742$export$66c1ae025e96b4bc(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { dims: dims } = attrs;
    const xRank = x.shape.length;
    const $dims = (0, $i64bB.util).parseAxisParam(dims, x.shape);
    if (xRank === 0) return (0, $2b13f312c76ad9c3$export$f0954fd7d5368655)({
        inputs: {
            x: x
        },
        backend: backend
    });
    const program = (0, $i64bB.env)().getBool('WEBGL_PACK_ARRAY_OPERATIONS') ? new (0, $43c4d498b18f602e$export$e427e51a4a356956)(x.shape, $dims) : new (0, $67d13ae84ff00d60$export$abc2effa29e77e92)(x.shape, $dims);
    return backend.runWebGLProgram(program, [
        x
    ], x.dtype);
}
const $fb2cfa1996ec5742$export$cab6a4e8d2ed8e8d = {
    kernelName: (0, $i64bB.Reverse),
    backendName: 'webgl',
    kernelFunc: $fb2cfa1996ec5742$export$66c1ae025e96b4bc
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $aaf7de3882081d4e$export$a37df1d4e69844e7 {
    constructor(imageShape, fillValue){
        this.variableNames = [
            'Image'
        ];
        this.outputShape = [];
        this.customUniforms = [
            {
                name: 'params',
                type: 'vec4'
            }
        ];
        const imageHeight = imageShape[1];
        const imageWidth = imageShape[2];
        this.outputShape = imageShape;
        let fillSnippet = '';
        if (typeof fillValue === 'number') fillSnippet = `float outputValue = ${fillValue.toFixed(2)};`;
        else fillSnippet = `
        vec3 fill = vec3(${fillValue.join(',')});
        float outputValue = fill[coords[3]];`;
        this.userCode = `
        void main() {
          ivec4 coords = getOutputCoords();
          int x = coords[2];
          int y = coords[1];
          float coordXFloat = (float(x) - params[0]) * params[3] -
            (float(y) - params[1]) * params[2];
          float coordYFloat = (float(x) - params[0]) * params[2] +
            (float(y) - params[1]) * params[3];
          int coordX = int(round(coordXFloat + params[0]));
          int coordY = int(round(coordYFloat + params[1]));
          ${fillSnippet}
          if(coordX >= 0 && coordX < ${imageWidth} && coordY >= 0 && coordY < ${imageHeight}) {
            outputValue = getImage(coords[0], coordY, coordX, coords[3]);
          }
          setOutput(outputValue);
        }
    `;
    }
}


const $5834fa005761b86c$export$44ba8c83417ab668 = {
    kernelName: (0, $i64bB.RotateWithOffset),
    backendName: 'webgl',
    kernelFunc: ({ inputs: inputs, attrs: attrs, backend: backend })=>{
        const { image: image } = inputs;
        const { radians: radians, fillValue: fillValue, center: center } = attrs;
        const webglBackend = backend;
        const program = new (0, $aaf7de3882081d4e$export$a37df1d4e69844e7)(image.shape, fillValue);
        const [centerX, centerY] = (0, $i64bB.backend_util).getImageCenter(center, image.shape[1], image.shape[2]);
        const customValues = [
            [
                centerX,
                centerY,
                Math.sin(radians),
                Math.cos(radians)
            ]
        ];
        const output = webglBackend.runWebGLProgram(program, [
            image
        ], image.dtype, customValues);
        return output;
    }
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

const $a5e701f48ff22533$var$ROUND = `
  // OpenGL ES does not support round function.
  // The algorithm is based on banker's rounding.
  float base = floor(x);
  if ((x - base) < 0.5) {
    return floor(x);
  } else if ((x - base) > 0.5) {
    return ceil(x);
  } else {
    if (mod(base, 2.0) == 0.0) {
      return base;
    } else {
      return base + 1.0;
    }
  }
`;
const $a5e701f48ff22533$export$2077e0241d6afd3c = (0, $2e65282075da2b30$export$ba4daf5748026fba)({
    opSnippet: $a5e701f48ff22533$var$ROUND
});
const $a5e701f48ff22533$export$6c09e3291f636503 = {
    kernelName: (0, $i64bB.Round),
    backendName: 'webgl',
    kernelFunc: $a5e701f48ff22533$export$2077e0241d6afd3c
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


const $9598331f45c2683c$var$RSQRT = `return inversesqrt(x);`;
const $9598331f45c2683c$export$1cc01d192953037e = (0, $2e65282075da2b30$export$ba4daf5748026fba)({
    opSnippet: $9598331f45c2683c$var$RSQRT,
    cpuKernelImpl: (0, $377486a788efd20b$export$431ccb02913a1aee)
});
const $9598331f45c2683c$export$941104b789956ef6 = {
    kernelName: (0, $i64bB.Rsqrt),
    backendName: 'webgl',
    kernelFunc: $9598331f45c2683c$export$1cc01d192953037e
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
class $12266010f6be1cf7$export$8d0317f5c5cbc1ac {
    constructor(updateSize, sliceDim, indicesRank, updatesRank, strides, shape, summingDupeIndex = true, defaultIsTensor = false){
        this.variableNames = [
            'updates',
            'indices',
            'defaultValue'
        ];
        this.outputShape = shape;
        const stridesType = (0, $ba2c54ffbda39e8e$export$859efd105c10c755)(strides.length);
        const dtype = (0, $ba2c54ffbda39e8e$export$859efd105c10c755)(shape.length);
        let indicesString = '';
        if (indicesRank === 1) indicesString = 'i';
        else if (indicesRank === 2) indicesString = 'i, j';
        const indicesSnippet = `getIndices(${indicesString})`;
        let updatesString = '';
        if (updatesRank === 1) updatesString = 'i';
        else if (updatesRank === 2) updatesString = 'i, coords[1]';
        const updatesSnippet = `getUpdates(${updatesString})`;
        let defaultValuesString = '';
        if (defaultIsTensor) defaultValuesString = 'coords[0], coords[1]';
        const defaultValueSnippet = `getDefaultValue(${defaultValuesString})`;
        const strideString = sliceDim > 1 ? 'strides[j]' : 'strides';
        this.userCode = `
        ${stridesType} strides = ${stridesType}(${strides});

        void main() {
          ${dtype} coords = getOutputCoords();
          float sum = 0.0;
          bool found = false;
          for (int i = 0; i < ${updateSize}; i++) {
            int flattenedIndex = 0;
            for (int j = 0; j < ${sliceDim}; j++) {
              int index = round(${indicesSnippet});
              flattenedIndex += index * ${strideString};
            }
            if (flattenedIndex == coords[0]) {
              sum += ${updatesSnippet};
              found = true;
            }
          }
          setOutput(mix(${defaultValueSnippet}, sum, float(found)));
        }
      `;
    }
}


/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
class $f94abe8bd598bcd9$export$6e81fd9352ed9fbb {
    constructor(updateSize, sliceDim, indicesRank, updatesRank, strides, shape, summingDupeIndex = true, defaultIsTensor = false){
        this.variableNames = [
            'updates',
            'indices',
            'defaultValue'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.outputShape = shape;
        const stridesType = (0, $ba2c54ffbda39e8e$export$859efd105c10c755)(strides.length);
        const dtype = (0, $ba2c54ffbda39e8e$export$859efd105c10c755)(shape.length);
        let indicesString = '';
        if (indicesRank === 1) indicesString = 'i';
        else if (indicesRank === 2) indicesString = 'i, j';
        const indicesSnippet = `getIndices(${indicesString})`;
        let updatesString = '';
        if (updatesRank === 1) updatesString = 'i';
        else if (updatesRank === 2) updatesString = 'i, coords[1]';
        const updatesSnippet = `getUpdates(${updatesString})`;
        let defaultValuesString = '';
        if (defaultIsTensor) defaultValuesString = 'coords[0], coords[1]';
        const defaultValueSnippet = `getDefaultValue(${defaultValuesString})`;
        const strideString = sliceDim > 1 ? 'strides[j]' : 'strides';
        const strideString2 = sliceDim > 1 ? 'strides[j + 1]' : 'strides';
        this.userCode = `
        ${stridesType} strides = ${stridesType}(${strides});

        void main() {
          ${dtype} coords = getOutputCoords();
          vec4 sum = vec4(0.);
          vec4 found = vec4(0.);
          for (int i = 0; i < ${updateSize}; i+=2) {
            ivec2 flattenedIndex = ivec2(0);
            for (int j = 0; j < ${sliceDim}; j+=2) {
              ivec4 index = round(${indicesSnippet});
              flattenedIndex += index.xz * ${strideString};
              if (j + 1 < ${sliceDim}) {
                flattenedIndex += index.yw * ${strideString2};
              }
            }
            if (flattenedIndex[0] == coords[0] || flattenedIndex[1] == coords[0] ||
                flattenedIndex[0] == coords[0] + 1 || flattenedIndex[1] == coords[0] + 1) {
              vec4 updVals = ${updatesSnippet};
              if (flattenedIndex[0] == coords[0]) {
                sum.xy += updVals.xy;
                found.xy = vec2(1.);
              } else if (flattenedIndex[0] == coords[0] + 1) {
                sum.zw += updVals.xy;
                found.zw = vec2(1.);
              }
              if (flattenedIndex[1] == coords[0]) {
                sum.xy += updVals.zw;
                found.xy = vec2(1.);
              } else if (flattenedIndex[1] == coords[0] + 1) {
                sum.zw += updVals.zw;
                found.zw = vec2(1.);
              }
            }
          }
          setOutput(mix(${defaultValueSnippet}, sum, found));
        }
      `;
    }
}



function $b582a7eea73ccbb9$export$b6f42038a536d877(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { indices: indices, updates: updates } = inputs;
    const { shape: shape } = attrs;
    const { sliceRank: sliceRank, numUpdates: numUpdates, sliceSize: sliceSize, strides: strides, outputSize: outputSize } = (0, $i64bB.backend_util).calculateShapes(updates, indices, shape);
    const flattenShape = [
        outputSize / sliceSize,
        sliceSize
    ];
    if (outputSize === 0) return backend.makeTensorInfo(shape, indices.dtype);
    const flattenIndices = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: indices
        },
        backend: backend,
        attrs: {
            shape: [
                numUpdates,
                sliceRank
            ]
        }
    });
    const flattenX = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: updates
        },
        backend: backend,
        attrs: {
            shape: [
                numUpdates,
                sliceSize
            ]
        }
    });
    const defaultValue = backend.makeTensorInfo([], 'float32', new Float32Array([
        0
    ])); // scalar(0)
    let program;
    if ((0, $i64bB.env)().getBool('WEBGL_PACK')) program = new (0, $f94abe8bd598bcd9$export$6e81fd9352ed9fbb)(numUpdates, sliceRank, flattenIndices.shape.length, flattenX.shape.length, strides, flattenShape);
    else program = new (0, $12266010f6be1cf7$export$8d0317f5c5cbc1ac)(numUpdates, sliceRank, flattenIndices.shape.length, flattenX.shape.length, strides, flattenShape);
    const res = backend.runWebGLProgram(program, [
        flattenX,
        flattenIndices,
        defaultValue
    ], flattenX.dtype);
    const reshaped = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: res
        },
        backend: backend,
        attrs: {
            shape: shape
        }
    });
    backend.disposeIntermediateTensorInfo(flattenIndices);
    backend.disposeIntermediateTensorInfo(flattenX);
    backend.disposeIntermediateTensorInfo(res);
    backend.disposeIntermediateTensorInfo(defaultValue);
    return reshaped;
}
const $b582a7eea73ccbb9$export$573371744f044f5 = {
    kernelName: (0, $i64bB.ScatterNd),
    backendName: 'webgl',
    kernelFunc: $b582a7eea73ccbb9$export$b6f42038a536d877
};


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
class $7e7113c59fe4901b$export$2511b5550383de5c {
    constructor(batchSize, numInputs, numValues, side){
        this.variableNames = [
            'sortedSequence',
            'values'
        ];
        this.customUniforms = [
            {
                name: 'numInputs',
                type: 'int'
            }
        ];
        this.outputShape = [
            batchSize,
            numValues
        ];
        const webGL2LoopHead = 'while (left < right) {';
        // WebGL1 doesn't accept non constant loop conditions, so upper bound loop
        // iterations.
        const webGL1LoopHead = `for (int i = 0; i < ${Math.ceil(Math.log2(numInputs + 1))}; ++i) { if (left >= right) break;`;
        const loopHead = (0, $i64bB.env)().getNumber('WEBGL_VERSION') === 2 ? webGL2LoopHead : webGL1LoopHead;
        // left corresponds to lower bound and right to upper bound.
        const boundComparator = side === 'left' ? '<' : '<=';
        this.userCode = `
       int findBound(int batch, float value) {
         int left = 0;
         int right = numInputs;
         int mid;
         ${loopHead}
           mid = (left + right) / 2;
           if (getSortedSequence(batch, mid) ${boundComparator} value) {
             left = mid + 1;
           } else {
             right = mid;
           }
         }
         return right;
       }

       void main() {
         ivec2 coords = getOutputCoords();
         int batch = coords[0];
         int valueIndex = coords[1];

         float value = getValues(batch, valueIndex);

         setOutput(float(findBound(batch, value)));
       }
     `;
    }
}


function $e4b358c10b05bcbf$export$56fad8d65b0adbdd(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { sortedSequence: sortedSequence, values: values } = inputs;
    const { side: side } = attrs;
    const program = new (0, $7e7113c59fe4901b$export$2511b5550383de5c)(sortedSequence.shape[0], sortedSequence.shape[1], values.shape[1], side);
    const customValues = [
        [
            sortedSequence.shape[1]
        ]
    ];
    return backend.runWebGLProgram(program, [
        sortedSequence,
        values
    ], 'int32', customValues);
}
const $e4b358c10b05bcbf$export$4b437b1a1aa6472f = {
    kernelName: (0, $i64bB.SearchSorted),
    backendName: 'webgl',
    kernelFunc: $e4b358c10b05bcbf$export$56fad8d65b0adbdd
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
class $0d279f0b0f0b1c32$export$845ed2d1f74ef297 {
    constructor(cRank, shape, rank){
        this.variableNames = [
            'c',
            'a',
            'b'
        ];
        this.outputShape = shape;
        let cCoords;
        let abCoords;
        if (rank > 4) throw Error(`Where for rank ${rank} is not yet supported`);
        if (rank === 1) {
            abCoords = `resRC`;
            cCoords = `resRC`;
        } else {
            const currentCoords = [
                'resRC.x',
                'resRC.y',
                'resRC.z',
                'resRC.w'
            ];
            const cCoordVars = [];
            const abCoordVars = [];
            for(let i = 0; i < shape.length; i++){
                abCoordVars.push(`${currentCoords[i]}`);
                if (i < cRank) cCoordVars.push(`${currentCoords[i]}`);
            }
            cCoords = cCoordVars.join();
            abCoords = abCoordVars.join();
        }
        const dtype = (0, $ba2c54ffbda39e8e$export$859efd105c10c755)(rank);
        this.userCode = `
      void main() {
        ${dtype} resRC = getOutputCoords();
        float cVal = getC(${cCoords});
        if (cVal >= 1.0) {
          setOutput(getA(${abCoords}));
        } else {
          setOutput(getB(${abCoords}));
        }
      }
    `;
    }
}


function $afbd292455431049$export$2e6c959c16ff56b8(args) {
    const { inputs: inputs, backend: backend } = args;
    const { condition: condition, t: t, e: e } = inputs;
    const program = new (0, $0d279f0b0f0b1c32$export$845ed2d1f74ef297)(condition.shape.length, t.shape, t.shape.length);
    return backend.runWebGLProgram(program, [
        condition,
        t,
        e
    ], (0, $i64bB.upcastType)(t.dtype, e.dtype));
}
const $afbd292455431049$export$7ff911e710ee72fc = {
    kernelName: (0, $i64bB.Select),
    backendName: 'webgl',
    kernelFunc: $afbd292455431049$export$2e6c959c16ff56b8
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

const $0478ded2e013bef8$var$SELU = `
  // Stable and Attracting Fixed Point (0, 1) for Normalized Weights.
  // see: https://arxiv.org/abs/1706.02515
  float scaleAlpha = ${(0, $i64bB.backend_util).SELU_SCALEALPHA};
  float scale = ${(0, $i64bB.backend_util).SELU_SCALE};
  return (x >= 0.0) ? scale * x : scaleAlpha * (exp(x) - 1.0);
`;
const $0478ded2e013bef8$export$a5f8240d9e99b438 = (0, $2e65282075da2b30$export$ba4daf5748026fba)({
    opSnippet: $0478ded2e013bef8$var$SELU
});
const $0478ded2e013bef8$export$8afc8558705c1a39 = {
    kernelName: (0, $i64bB.Selu),
    backendName: 'webgl',
    kernelFunc: $0478ded2e013bef8$export$a5f8240d9e99b438
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


const $0748024561a6ce75$var$SIGMOID = (0, $2e65282075da2b30$export$bf39b1cb254b6187) + `
  return 1.0 / (1.0 + exp(-1.0 * x));
`;
const $0748024561a6ce75$var$SIGMOID_PACKED = `
  vec4 result = 1.0 / (1.0 + exp(-1.0 * x));
  bvec4 isNaN = isnan(x);

  result.r = isNaN.r ? x.r : result.r;
  result.g = isNaN.g ? x.g : result.g;
  result.b = isNaN.b ? x.b : result.b;
  result.a = isNaN.a ? x.a : result.a;

  return result;
`;
const $0748024561a6ce75$export$3b295495ca3cad7c = (0, $2e65282075da2b30$export$ba4daf5748026fba)({
    opSnippet: $0748024561a6ce75$var$SIGMOID,
    packedOpSnippet: $0748024561a6ce75$var$SIGMOID_PACKED,
    cpuKernelImpl: (0, $377486a788efd20b$export$9b816377c2ca1f1f)
});
const $0748024561a6ce75$export$195d1cf7c59f3ef = {
    kernelName: (0, $i64bB.Sigmoid),
    backendName: 'webgl',
    kernelFunc: $0748024561a6ce75$export$3b295495ca3cad7c
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

// Sign does not propagate NANs.
const $91f700997aefd0de$var$SIGN = `
  if (isnan(x)) { return 0.0; }
  return sign(x);
`;
const $91f700997aefd0de$export$c5552dfdbc7cec71 = (0, $2e65282075da2b30$export$ba4daf5748026fba)({
    opSnippet: $91f700997aefd0de$var$SIGN
});
const $91f700997aefd0de$export$9c0fb3eb2124ceb7 = {
    kernelName: (0, $i64bB.Sign),
    backendName: 'webgl',
    kernelFunc: $91f700997aefd0de$export$c5552dfdbc7cec71
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


const $3c9cb0977514b79f$var$SIN = (0, $2e65282075da2b30$export$bf39b1cb254b6187) + `
  return sin(x);
`;
const $3c9cb0977514b79f$var$SIN_PACKED = `
  vec4 result = sin(x);
  bvec4 isNaN = isnan(x);
  ${(0, $1b00798c48aa5c1a$export$2b4d5cee4bd7b2dd)}
  return result;
`;
const $3c9cb0977514b79f$export$5de3937cb4b592ed = (0, $2e65282075da2b30$export$ba4daf5748026fba)({
    opSnippet: $3c9cb0977514b79f$var$SIN,
    packedOpSnippet: $3c9cb0977514b79f$var$SIN_PACKED
});
const $3c9cb0977514b79f$export$d993ec4e5c253b66 = {
    kernelName: (0, $i64bB.Sin),
    backendName: 'webgl',
    kernelFunc: $3c9cb0977514b79f$export$5de3937cb4b592ed
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

const $99c3d27bd6b9c880$var$SINH = `
  float e2x = exp(x);
  return (e2x - 1.0 / e2x) / 2.0;
`;
const $99c3d27bd6b9c880$export$545004b505d7c555 = (0, $2e65282075da2b30$export$ba4daf5748026fba)({
    opSnippet: $99c3d27bd6b9c880$var$SINH
});
const $99c3d27bd6b9c880$export$b92766b47f18ac85 = {
    kernelName: (0, $i64bB.Sinh),
    backendName: 'webgl',
    kernelFunc: $99c3d27bd6b9c880$export$545004b505d7c555
};




/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

const $1f435b901469df60$var$SOFTPLUS = `
  float epsilon = 1.1920928955078125e-7;
  float threshold = log(epsilon) + 2.0;

  bool too_large = x > -threshold;
  bool too_small = x < threshold;

  float result;
  float exp_x = exp(x);

  if (too_large){
    result = x;
  }
  else if (too_small){
    result = exp_x;
  }
  else{
    result = log(exp_x + 1.0);
  }
  return result;
`;
const $1f435b901469df60$export$76aa560a8c2b0055 = (0, $2e65282075da2b30$export$ba4daf5748026fba)({
    opSnippet: $1f435b901469df60$var$SOFTPLUS
});
const $1f435b901469df60$export$d9bcfe553d12d9e3 = {
    kernelName: (0, $i64bB.Softplus),
    backendName: 'webgl',
    kernelFunc: $1f435b901469df60$export$76aa560a8c2b0055
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");



const $573199a3541dbc61$export$effb9d7cae92012f = (args)=>{
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { blockShape: blockShape, paddings: paddings } = attrs;
    (0, $i64bB.util).assert(x.shape.length <= 4, ()=>"spaceToBatchND for rank > 4 with a WebGL backend not implemented yet");
    const prod = blockShape.reduce((a, b)=>a * b);
    const completePaddings = [
        [
            0,
            0
        ]
    ];
    completePaddings.push(...paddings);
    for(let i = 1 + blockShape.length; i < x.shape.length; ++i)completePaddings.push([
        0,
        0
    ]);
    const toDispose = [];
    const paddedX = (0, $379eb6e5685c7da3$export$f676d6ad4f38bb89)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            paddings: completePaddings,
            constantValue: 0
        }
    });
    const reshapedPaddedShape = (0, $i64bB.backend_util).getReshaped(paddedX.shape, blockShape, prod, false);
    const permutedReshapedPaddedPermutation = (0, $i64bB.backend_util).getPermuted(reshapedPaddedShape.length, blockShape.length, false);
    const flattenShape = (0, $i64bB.backend_util).getReshapedPermuted(paddedX.shape, blockShape, prod, false);
    const reshapedPaddedX = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: paddedX
        },
        backend: backend,
        attrs: {
            shape: reshapedPaddedShape
        }
    });
    const paddedXT = (0, $6cab078553124169$export$9cb09a71b7d66923)({
        inputs: {
            x: reshapedPaddedX
        },
        backend: backend,
        attrs: {
            perm: permutedReshapedPaddedPermutation
        }
    });
    const result = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: paddedXT
        },
        backend: backend,
        attrs: {
            shape: flattenShape
        }
    });
    toDispose.push(paddedX);
    toDispose.push(reshapedPaddedX);
    toDispose.push(paddedXT);
    toDispose.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return result;
};
const $573199a3541dbc61$export$2f85417863d2050b = {
    kernelName: (0, $i64bB.SpaceToBatchND),
    backendName: 'webgl',
    kernelFunc: $573199a3541dbc61$export$effb9d7cae92012f
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

function $ad01a3592ad9ab72$export$c82a1904a15b5028(args) {
    const { inputs: inputs, backend: backend } = args;
    const { indices: indices, values: values, denseShape: denseShape, defaultValue: defaultValue } = inputs;
    if (denseShape.shape.length !== 1) throw new Error(`Dense shape must be a vector, saw:
         ${denseShape.shape}`);
    if (indices.shape.length !== 2) throw new Error(`Indices must be a matrix, saw:
         ${indices.shape}`);
    if (values.shape.length !== 1) throw new Error(`Values must be a vector, saw:
         ${values.shape}`);
    if (defaultValue.shape.length !== 0) throw new Error(`Default value must be a scalar, saw:
        ${defaultValue.shape}`);
    const $indices = backend.readSync(indices.dataId);
    const $values = backend.readSync(values.dataId);
    const $denseShape = backend.readSync(denseShape.dataId);
    const $defaultValue = backend.readSync(defaultValue.dataId)[0];
    const [outputIndices, outputIndicesShape, outputValues, emptyRowIndicator, reverseIndexMap] = (0, $377486a788efd20b$export$6cee5fb970d08428)($indices, indices.shape, indices.dtype, $values, values.dtype, $denseShape, $defaultValue);
    return [
        backend.makeTensorInfo(outputIndicesShape, indices.dtype, outputIndices),
        backend.makeTensorInfo([
            outputIndicesShape[0]
        ], values.dtype, outputValues),
        backend.makeTensorInfo([
            emptyRowIndicator.length
        ], 'bool', new Uint8Array(emptyRowIndicator.map((value)=>Number(value)))),
        backend.makeTensorInfo([
            reverseIndexMap.length
        ], indices.dtype, new Int32Array(reverseIndexMap))
    ];
}
const $ad01a3592ad9ab72$export$818286c593224d1a = {
    kernelName: (0, $i64bB.SparseFillEmptyRows),
    backendName: 'webgl',
    kernelFunc: $ad01a3592ad9ab72$export$c82a1904a15b5028
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

function $e97f58197a9c9461$export$1408c45865e11fc6(args) {
    const { inputs: inputs, backend: backend } = args;
    const { inputIndices: inputIndices, inputShape: inputShape, newShape: newShape } = inputs;
    if (inputIndices.shape.length !== 2) throw new Error(`Input indices should be a matrix but received shape ${inputIndices.shape}`);
    if (inputShape.shape.length !== 1) throw new Error(`Input shape should be a vector but received shape ${inputShape.shape}`);
    if (newShape.shape.length !== 1) throw new Error(`Target shape should be a vector but received shape ${newShape.shape}`);
    const $inputShape = Array.from(backend.readSync(inputShape.dataId));
    const $inputIndices = backend.readSync(inputIndices.dataId);
    const targetShape = Array.from(backend.readSync(newShape.dataId));
    const [newIndices, indicesShape, outputShape] = (0, $377486a788efd20b$export$d17b3360054ff370)($inputIndices, inputIndices.shape, inputIndices.dtype, $inputShape, targetShape);
    return [
        backend.makeTensorInfo(indicesShape, inputIndices.dtype, newIndices),
        backend.makeTensorInfo([
            outputShape.length
        ], newShape.dtype, new Int32Array(outputShape))
    ];
}
const $e97f58197a9c9461$export$eb106efc10374803 = {
    kernelName: (0, $i64bB.SparseReshape),
    backendName: 'webgl',
    kernelFunc: $e97f58197a9c9461$export$1408c45865e11fc6
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

function $0408c14210b44049$export$dbc0c9096869d04e(args) {
    const { inputs: inputs, backend: backend } = args;
    const { data: data, indices: indices, segmentIds: segmentIds } = inputs;
    if (data.shape.length < 1) throw new Error(`Data should be at least 1 dimensional but received scalar`);
    if (indices.shape.length !== 1) throw new Error(`Indices should be a vector but received shape
              ${indices.shape}`);
    if (segmentIds.shape.length !== 1) throw new Error(`Segment ids should be a vector but received shape
              ${segmentIds.shape}`);
    const $data = backend.readSync(data.dataId);
    const $indices = backend.readSync(indices.dataId);
    const $segmentIds = backend.readSync(segmentIds.dataId);
    const [outputData, outputDataShape] = (0, $377486a788efd20b$export$a503222c03b33888)($data, data.shape, data.dtype, $indices, $segmentIds, true);
    return backend.makeTensorInfo(outputDataShape, data.dtype, outputData);
}
const $0408c14210b44049$export$51e7224ae14d7f78 = {
    kernelName: (0, $i64bB.SparseSegmentMean),
    backendName: 'webgl',
    kernelFunc: $0408c14210b44049$export$dbc0c9096869d04e
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

function $51e2314a5b39202d$export$2255ce53fc777865(args) {
    const { inputs: inputs, backend: backend } = args;
    const { data: data, indices: indices, segmentIds: segmentIds } = inputs;
    if (data.shape.length < 1) throw new Error(`Data should be at least 1 dimensional but received scalar`);
    if (indices.shape.length !== 1) throw new Error(`Indices should be a vector but received shape
             ${indices.shape}`);
    if (segmentIds.shape.length !== 1) throw new Error(`Segment ids should be a vector but received shape
             ${segmentIds.shape}`);
    const $data = backend.readSync(data.dataId);
    const $indices = backend.readSync(indices.dataId);
    const $segmentIds = backend.readSync(segmentIds.dataId);
    const [outputData, outputDataShape] = (0, $377486a788efd20b$export$a503222c03b33888)($data, data.shape, data.dtype, $indices, $segmentIds);
    return backend.makeTensorInfo(outputDataShape, data.dtype, outputData);
}
const $51e2314a5b39202d$export$73fa0270f28b9555 = {
    kernelName: (0, $i64bB.SparseSegmentSum),
    backendName: 'webgl',
    kernelFunc: $51e2314a5b39202d$export$2255ce53fc777865
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");



function $279f720d4c5f508b$export$1be4b823dd1a3080(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { sparseIndices: sparseIndices, sparseValues: sparseValues, defaultValue: defaultValue } = inputs;
    const { outputShape: outputShape } = attrs;
    const { sliceRank: sliceRank, numUpdates: numUpdates, sliceSize: sliceSize, strides: strides, outputSize: outputSize } = (0, $i64bB.backend_util).calculateShapes(sparseValues, sparseIndices, outputShape);
    const sumDupeIndices = false;
    if (sparseValues.dtype === 'string') {
        const indicesBuf = backend.bufferSync(sparseIndices);
        const updatesBuf = backend.bufferSync(sparseValues);
        const $defaultValue = (0, $i64bB.util).decodeString(backend.readSync(defaultValue.dataId)[0]);
        const outBuf = (0, $377486a788efd20b$export$2295c910080b5ca7)(indicesBuf, updatesBuf, outputShape, outputSize, sliceSize, numUpdates, sliceRank, strides, $defaultValue, sumDupeIndices);
        return backend.makeTensorInfo(outputShape, outBuf.dtype, outBuf.values);
    }
    const program = new (0, $12266010f6be1cf7$export$8d0317f5c5cbc1ac)(numUpdates, sliceRank, sparseIndices.shape.length, sparseValues.shape.length, strides, [
        outputSize,
        1
    ], sumDupeIndices);
    const res = backend.runWebGLProgram(program, [
        sparseValues,
        sparseIndices,
        defaultValue
    ], sparseValues.dtype);
    const reshaped = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: res
        },
        backend: backend,
        attrs: {
            shape: outputShape
        }
    });
    backend.disposeIntermediateTensorInfo(res);
    return reshaped;
}
const $279f720d4c5f508b$export$7bc088f8ad44ef99 = {
    kernelName: (0, $i64bB.SparseToDense),
    backendName: 'webgl',
    kernelFunc: $279f720d4c5f508b$export$1be4b823dd1a3080
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

function $3d0c43215a921f05$export$c0085d48b0a75d8f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { numOrSizeSplits: numOrSizeSplits, axis: axis } = attrs;
    const $axis = (0, $i64bB.util).parseAxisParam(axis, x.shape)[0];
    const splitSizes = (0, $i64bB.backend_util).prepareSplitSize(x, numOrSizeSplits, $axis);
    const xRank = x.shape.length;
    const begin = new Array(xRank).fill(0);
    const size = x.shape.slice();
    return splitSizes.map((s)=>{
        const sliceSize = [
            ...size
        ];
        sliceSize[$axis] = s;
        const sliceT = (0, $c4b4f5c2e7e1b97a$export$58adb3bec8346d0f)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                begin: begin,
                size: sliceSize
            }
        });
        begin[$axis] += s;
        return sliceT;
    });
}
const $3d0c43215a921f05$export$317be24be3af9ea0 = {
    kernelName: (0, $i64bB.SplitV),
    backendName: 'webgl',
    kernelFunc: $3d0c43215a921f05$export$c0085d48b0a75d8f
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


const $cdd97f1adbf6ab71$var$SQRT = `return sqrt(x);`;
const $cdd97f1adbf6ab71$export$eba8049fb5020b81 = (0, $2e65282075da2b30$export$ba4daf5748026fba)({
    opSnippet: $cdd97f1adbf6ab71$var$SQRT,
    packedOpSnippet: $cdd97f1adbf6ab71$var$SQRT,
    cpuKernelImpl: (0, $377486a788efd20b$export$548a22b20eeaf85b)
});
const $cdd97f1adbf6ab71$export$a592ba9268f10eeb = {
    kernelName: (0, $i64bB.Sqrt),
    backendName: 'webgl',
    kernelFunc: $cdd97f1adbf6ab71$export$eba8049fb5020b81
};


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

const $9e39869fb26c6983$var$SQUARE = `return x * x;`;
const $9e39869fb26c6983$export$dd4f28cef696bc7d = (0, $2e65282075da2b30$export$ba4daf5748026fba)({
    opSnippet: $9e39869fb26c6983$var$SQUARE
});
const $9e39869fb26c6983$export$7c77bece4d51efc4 = {
    kernelName: (0, $i64bB.Square),
    backendName: 'webgl',
    kernelFunc: $9e39869fb26c6983$export$dd4f28cef696bc7d
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

const $fe269d9515830fc9$var$SQUARED_DIFFERENCE = 'return (a - b) * (a - b);';
const $fe269d9515830fc9$export$b178697fb6d0b37f = (0, $2e65282075da2b30$export$29353c66e70e3e16)({
    opSnippet: $fe269d9515830fc9$var$SQUARED_DIFFERENCE,
    packedOpSnippet: $fe269d9515830fc9$var$SQUARED_DIFFERENCE
});
const $fe269d9515830fc9$export$9ed4691d69db8a43 = {
    kernelName: (0, $i64bB.SquaredDifference),
    backendName: 'webgl',
    kernelFunc: $fe269d9515830fc9$export$b178697fb6d0b37f
};


/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

function $9bd181afbd5ddc65$export$2bdfdc7ae087914d(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    if (x.dtype !== 'string') throw new Error('Input must be of datatype string');
    const $x = backend.readSync(x.dataId);
    const stringInput = (0, $i64bB.backend_util).fromUint8ToStringArray($x);
    const output = (0, $377486a788efd20b$export$b3e893e48b8d1e39)(stringInput, 'string', attrs);
    return backend.makeTensorInfo(x.shape, 'string', output);
}
const $9bd181afbd5ddc65$export$1069b2f6977254f4 = {
    kernelName: (0, $i64bB.StaticRegexReplace),
    backendName: 'webgl',
    kernelFunc: $9bd181afbd5ddc65$export$2bdfdc7ae087914d
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

function $2ed3c62597f7cafa$export$35d34bc0ed591a92({ inputs: inputs, attrs: attrs, backend: backend }) {
    const { x: x } = inputs;
    const opSnippet = (0, $d607b1799b79a159$export$39f0cca2b63399f6) + `
    return x > 0.0 ? 1.0 : float(${attrs.alpha});
  `;
    const program = new (0, $d607b1799b79a159$export$f93811a5a466fd42)(x.shape, opSnippet);
    return backend.runWebGLProgram(program, [
        x
    ], x.dtype);
}
const $2ed3c62597f7cafa$export$c42ffaf52eb2647 = {
    kernelName: (0, $i64bB.Step),
    backendName: 'webgl',
    kernelFunc: $2ed3c62597f7cafa$export$35d34bc0ed591a92
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
class $4541dfa8b78a3131$export$335c52ce94f359f6 {
    constructor(begin, strides, size){
        this.variableNames = [
            'x'
        ];
        this.outputShape = size;
        const rank = size.length;
        const inputDtype = (0, $ba2c54ffbda39e8e$export$859efd105c10c755)(size.length);
        const dtype = (0, $ba2c54ffbda39e8e$export$859efd105c10c755)(size.length);
        let newCoords = '';
        if (rank === 1) newCoords = 'coords * strides + begin';
        else {
            let outputAxis = 0;
            newCoords = size.map((_, i)=>{
                outputAxis++;
                return size.length === 1 ? `coords * strides[${i}] + begin[${i}]` : `coords[${outputAxis - 1}] * strides[${i}] + begin[${i}]`;
            }).join(',');
        }
        this.userCode = `
      ${inputDtype} begin = ${inputDtype}(${begin});
      ${inputDtype} strides = ${inputDtype}(${strides});

      void main() {
        ${dtype} coords = getOutputCoords();
        setOutput(getX(${newCoords}));
      }
    `;
    }
}




function $b319f8808af3f1a1$export$4ae57224f3b0605c(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { begin: begin, end: end, strides: strides, beginMask: beginMask, endMask: endMask, ellipsisMask: ellipsisMask, newAxisMask: newAxisMask, shrinkAxisMask: shrinkAxisMask } = attrs;
    const { finalShapeSparse: finalShapeSparse, finalShape: finalShape, isIdentity: isIdentity, sliceDim0: sliceDim0, isSimpleSlice: isSimpleSlice, begin: $begin, end: $end, strides: $strides } = (0, $i64bB.slice_util).sliceInfo(x.shape, begin, end, strides, beginMask, endMask, ellipsisMask, newAxisMask, shrinkAxisMask);
    let result;
    if (isIdentity) // Optimization #1, slice is a no-op plus reshape
    result = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            shape: finalShape
        }
    });
    else if (sliceDim0 || isSimpleSlice) {
        // Optimization #2, slice is memory contiguous (only occurs in dim 0)
        (0, $i64bB.util).assert(x.shape.length >= 1, ()=>`Input must have rank at least 1, got: ${x.shape.length}`);
        const size = (0, $i64bB.slice_util).computeOutShape($begin, $end, $strides);
        // To tolerate begin[0] > end[0] (a 0-output slice), we min(begin, end).
        const sliced = (0, $c4b4f5c2e7e1b97a$export$58adb3bec8346d0f)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                begin: $begin,
                size: size
            }
        });
        result = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
            inputs: {
                x: sliced
            },
            backend: backend,
            attrs: {
                shape: finalShape
            }
        });
        backend.disposeIntermediateTensorInfo(sliced);
    } else {
        const shouldExecuteOnCPU = backend.shouldExecuteOnCPU([
            x
        ]);
        if (shouldExecuteOnCPU) {
            // tslint:disable-next-line: no-unnecessary-type-assertion
            const values = backend.readSync(x.dataId);
            // tslint:disable-next-line: no-unnecessary-type-assertion
            const xBuf = (0, $i64bB.buffer)(x.shape, x.dtype, values);
            const resultValues = (0, $377486a788efd20b$export$efd4e188e5de0188)(finalShapeSparse, xBuf, $strides, $begin);
            result = backend.makeTensorInfo(finalShape, x.dtype, resultValues.values);
        } else {
            const program = new (0, $4541dfa8b78a3131$export$335c52ce94f359f6)($begin, $strides, finalShapeSparse);
            result = backend.runWebGLProgram(program, [
                x
            ], x.dtype);
        }
    }
    const resultReshaped = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: result
        },
        backend: backend,
        attrs: {
            shape: finalShape
        }
    });
    backend.disposeIntermediateTensorInfo(result);
    return resultReshaped;
}
const $b319f8808af3f1a1$export$81773633114187bd = {
    kernelName: (0, $i64bB.StridedSlice),
    backendName: 'webgl',
    kernelFunc: $b319f8808af3f1a1$export$4ae57224f3b0605c
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

function $4d7066b1ff67f75a$export$3490514dcc63b044(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { separator: separator, nGramWidths: nGramWidths, leftPad: leftPad, rightPad: rightPad, padWidth: padWidth, preserveShortSequences: preserveShortSequences } = attrs;
    const { data: data, dataSplits: dataSplits } = inputs;
    const $data = backend.readSync(data.dataId);
    const $dataSplits = backend.readSync(dataSplits.dataId);
    const [nGrams, nGramsSplits] = (0, $377486a788efd20b$export$bb9e83cb65884ef3)($data, $dataSplits, separator, nGramWidths, leftPad, rightPad, padWidth, preserveShortSequences);
    return [
        backend.makeTensorInfo([
            nGrams.length
        ], 'string', nGrams),
        backend.makeTensorInfo(dataSplits.shape, 'int32', nGramsSplits)
    ];
}
const $4d7066b1ff67f75a$export$35e13284eed34c22 = {
    kernelName: (0, $i64bB.StringNGrams),
    backendName: 'webgl',
    kernelFunc: $4d7066b1ff67f75a$export$3490514dcc63b044
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

function $b8078f32ea2e52f8$export$aa7f8babb17e7672(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { skipEmpty: skipEmpty } = attrs;
    const { input: input, delimiter: delimiter } = inputs;
    if (input.dtype !== 'string') throw new Error('Input must be of datatype string');
    if (input.shape.length !== 1) throw new Error(`Input must be a vector, got shape: ${input.shape}`);
    if (delimiter.shape.length !== 0) throw new Error(`Delimiter must be a scalar, got shape: ${delimiter.shape}`);
    const $input = backend.readSync(input.dataId);
    const $delimiter = backend.readSync(delimiter.dataId)[0];
    const [indices, values, shape] = (0, $377486a788efd20b$export$bb4b4a9a1db97dea)($input, $delimiter, skipEmpty);
    const outputSize = values.length;
    return [
        backend.makeTensorInfo([
            outputSize,
            2
        ], 'int32', indices),
        backend.makeTensorInfo([
            outputSize
        ], 'string', values),
        backend.makeTensorInfo([
            2
        ], 'int32', new Int32Array(shape))
    ];
}
const $b8078f32ea2e52f8$export$c51cbbd627a96532 = {
    kernelName: (0, $i64bB.StringSplit),
    backendName: 'webgl',
    kernelFunc: $b8078f32ea2e52f8$export$aa7f8babb17e7672
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

function $abaa2f715d582461$export$6195616d6fd0c848(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { numBuckets: numBuckets } = attrs;
    const { input: input } = inputs;
    if (input.dtype !== 'string') throw new Error('Input must be of datatype string');
    if (numBuckets <= 0) throw new Error(`Number of buckets must be at least 1`);
    const $input = backend.readSync(input.dataId);
    const output = (0, $377486a788efd20b$export$d7d8a9bba3df6e63)($input, numBuckets);
    return backend.makeTensorInfo(input.shape, 'int32', output);
}
const $abaa2f715d582461$export$a88a78b2b233f507 = {
    kernelName: (0, $i64bB.StringToHashBucketFast),
    backendName: 'webgl',
    kernelFunc: $abaa2f715d582461$export$6195616d6fd0c848
};




/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

const $9c7c587bb0a01e51$var$TAN = `return tan(x);`;
const $9c7c587bb0a01e51$export$fcdd3b0b3246a325 = (0, $2e65282075da2b30$export$ba4daf5748026fba)({
    opSnippet: $9c7c587bb0a01e51$var$TAN
});
const $9c7c587bb0a01e51$export$97648844df7611f3 = {
    kernelName: (0, $i64bB.Tan),
    backendName: 'webgl',
    kernelFunc: $9c7c587bb0a01e51$export$fcdd3b0b3246a325
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

const $49483ca617d860db$var$TANH = `
  float e2x = exp(-2.0 * abs(x));
  return sign(x) * (1.0 - e2x) / (1.0 + e2x);
`;
const $49483ca617d860db$export$7128670e45beef9a = (0, $2e65282075da2b30$export$ba4daf5748026fba)({
    opSnippet: $49483ca617d860db$var$TANH
});
const $49483ca617d860db$export$a2fc7de1a1e4eee0 = {
    kernelName: (0, $i64bB.Tanh),
    backendName: 'webgl',
    kernelFunc: $49483ca617d860db$export$7128670e45beef9a
};


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


function $393ae9af6bbeb118$export$d3ac02769385eb36(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { tensor: tensor, indices: indices, updates: updates } = inputs;
    const {} = attrs;
    const { sliceRank: sliceRank, numUpdates: numUpdates, sliceSize: sliceSize, strides: strides, outputSize: outputSize } = (0, $i64bB.backend_util).calculateShapes(updates, indices, tensor.shape);
    const flattenShape = [
        outputSize / sliceSize,
        sliceSize
    ];
    if (outputSize === 0) return backend.makeTensorInfo(tensor.shape, indices.dtype);
    const flattenIndices = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: indices
        },
        backend: backend,
        attrs: {
            shape: [
                numUpdates,
                sliceRank
            ]
        }
    });
    const flattenX = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: updates
        },
        backend: backend,
        attrs: {
            shape: [
                numUpdates,
                sliceSize
            ]
        }
    });
    const flattenTensor = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: tensor
        },
        backend: backend,
        attrs: {
            shape: flattenShape
        }
    });
    const program = new (0, $12266010f6be1cf7$export$8d0317f5c5cbc1ac)(numUpdates, sliceRank, flattenIndices.shape.length, flattenX.shape.length, strides, flattenShape, false, true);
    const res = backend.runWebGLProgram(program, [
        flattenX,
        flattenIndices,
        flattenTensor
    ], flattenTensor.dtype);
    const reshaped = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: res
        },
        backend: backend,
        attrs: {
            shape: tensor.shape
        }
    });
    backend.disposeIntermediateTensorInfo(flattenIndices);
    backend.disposeIntermediateTensorInfo(flattenX);
    backend.disposeIntermediateTensorInfo(flattenTensor);
    backend.disposeIntermediateTensorInfo(res);
    return reshaped;
}
const $393ae9af6bbeb118$export$2819813ce8339b64 = {
    kernelName: (0, $i64bB.TensorScatterUpdate),
    backendName: 'webgl',
    kernelFunc: $393ae9af6bbeb118$export$d3ac02769385eb36
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
class $a9f465e742d1ab41$export$215140f0ab19f420 {
    constructor(aShape, reps){
        this.variableNames = [
            'A'
        ];
        const outputShape = new Array(aShape.length);
        for(let i = 0; i < outputShape.length; i++)outputShape[i] = aShape[i] * reps[i];
        this.outputShape = outputShape;
        this.rank = outputShape.length;
        const dtype = (0, $ba2c54ffbda39e8e$export$859efd105c10c755)(this.rank);
        const sourceCoords = $a9f465e742d1ab41$var$getSourceCoords(aShape);
        this.userCode = `
      void main() {
        ${dtype} resRC = getOutputCoords();
        setOutput(getA(${sourceCoords}));
      }
    `;
    }
}
function $a9f465e742d1ab41$var$getSourceCoords(aShape) {
    const rank = aShape.length;
    if (rank > 5) throw Error(`Tile for rank ${rank} is not yet supported`);
    if (rank === 1) return `imod(resRC, ${aShape[0]})`;
    const currentCoords = [
        'resRC.x',
        'resRC.y',
        'resRC.z',
        'resRC.w',
        'resRC.u'
    ];
    const sourceCoords = [];
    for(let i = 0; i < aShape.length; i++)sourceCoords.push(`imod(${currentCoords[i]}, ${aShape[i]})`);
    return sourceCoords.join();
}


function $bee0a451396ec95d$export$3c17558da18e4d75(params) {
    const { inputs: inputs, backend: backend, attrs: attrs } = params;
    const { x: x } = inputs;
    const { reps: reps } = attrs;
    // tile gpu program cannot handle rank > 5 case.
    if (x.dtype === 'string' || x.shape.length > 5) {
        // Even thought string tensor is always on CPU, just to be consistent on how
        // to access tensor data.
        const data = backend.readSync(x.dataId);
        const value = x.dtype === 'string' ? data.map((d)=>(0, $i64bB.util).decodeString(d)) : data;
        const buf = (0, $i64bB.buffer)(x.shape, x.dtype, value);
        const outBuf = (0, $377486a788efd20b$export$349e02a266ab3131)(buf, reps);
        return backend.makeTensorInfo(outBuf.shape, outBuf.dtype, outBuf.values);
    }
    const program = new (0, $a9f465e742d1ab41$export$215140f0ab19f420)(x.shape, reps);
    const output = backend.runWebGLProgram(program, [
        x
    ], x.dtype);
    return output;
}
const $bee0a451396ec95d$export$a5a9f8050ba7f41e = {
    kernelName: (0, $i64bB.Tile),
    backendName: 'webgl',
    kernelFunc: $bee0a451396ec95d$export$3c17558da18e4d75
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");

// Based on Algorithm 2 of Bitonic Top K, ref:
// https://anilshanbhag.in/static/papers/gputopk_sigmod18.pdf
// The original algorithm is based on computing the top K only, however
// since for TFJS we require the indices of the top K values as well then the
// algorithm found here is a bit modified. Rather than producing the values
// at each step, the indices containing the top K are generated instead.
// The output values are not generated to reduce the number of outputs in the
// GPU, the values can easily be retrieved from the indices using a gather
// op.
class $49e8d0916bd9985d$export$5ee54e3c81d6f6e7 {
    /**
     * @param shape desired output shape (can be larger than input shape, output
     *                                    will be padded with -Infinity)
     */ constructor(shape){
        this.variableNames = [
            'x',
            'indices'
        ];
        // |n| Size of the original input of TopK.
        // |firstPass|indicates if this is the first time swap is being used which
        // means no indices input containing the top K is present yet.
        // |inc| Swaps pairs of indices (0, inc), (1, inc + 1), (2, inc + 2) ...
        this.customUniforms = [
            {
                name: 'n',
                type: 'int'
            },
            {
                name: 'firstPass',
                type: 'int'
            },
            {
                name: 'negativeInf',
                type: 'float'
            },
            {
                name: 'dir',
                type: 'int'
            },
            {
                name: 'inc',
                type: 'int'
            }
        ];
        this.outputShape = shape;
        this.userCode = `
       void main() {
         ivec2 coords = getOutputCoords();
         int batch = coords[0];
         int elemIdx = coords[1];

         // We compare elements pair-wise within a group of size 2 * inc.
         // The comparing rule for each group alternates between ascending
         // and descending. Within each group, we compare each pair at
         // positions i and i+inc. To decide whether an element at position i
         // is x0 or x1, we mod it by 2 * inc, if the result is smaller than
         // inc, it is in the first half of the group, we denote it as x0,
         // otherwise we denote it as x1.
         // For example, as shown in the Bitonic top K paper referenced above,
         // Figure5(a) shows that element[1] is in the
         // second half of the group when group size is 2, but it is in the
         // first half of the group when group size is 4.

         bool isFirstInPair = imod(elemIdx, 2 * inc) < inc;
         int i = isFirstInPair ? elemIdx : elemIdx - inc;

         int i0 = firstPass == 1 ? i : int(getIndices(batch, i));
         int i1 = firstPass == 1 ? i + inc : int(getIndices(batch, i + inc));
         float x0 = i0 < n ? getX(batch, i0) : negativeInf;
         float x1 = i1 < n ? getX(batch, i1) : negativeInf;

         // Denotes which direction indices are in (ascending or descending).
         bool reverse = imod(elemIdx, 2 * dir) >= dir;
         bool isGreater = x0 > x1 || (x0 == x1 && i1 > i0);
         if (reverse == isGreater) { // Elements in opposite order of direction
           int iTemp = i0;
           i0 = i1;
           i1 = iTemp;
         }
         if (isFirstInPair) {
            setOutput(float(i0));
         } else {
            setOutput(float(i1));
         }
       }
     `;
    }
}
class $49e8d0916bd9985d$export$c3fbf8b38d821ac9 {
    /**
     * @param shape desired output shape (must be half of the input size)
     */ constructor(shape){
        this.variableNames = [
            'x',
            'indices'
        ];
        // |n| Size of the original input of TopK
        // |firstPass| indicates if this is the first time swap is being used which
        // means no indices input containing the top K is present yet.
        // |k| Top k elements desired
        this.customUniforms = [
            {
                name: 'n',
                type: 'int'
            },
            {
                name: 'firstPass',
                type: 'int'
            },
            {
                name: 'k',
                type: 'int'
            }
        ];
        this.outputShape = shape;
        this.userCode = `
    void main() {
         // Takes max of indices (0, k), (1, k + 1), (2, k + 2) ...
         ivec2 coords = getOutputCoords();
         int batch = coords[0];
         int elemIdx = coords[1];

         // The output size is half of the previous size.
         // If the previous sequence is | | | | _ _ _ _  | | | |  _ _ _ _ (k=4),
         // we only need to output the indices at positions |, the indices at
         // positions _ can be thrown away, see Figure5(b) After Phase 2
         // (Merge phase) in the Bitonic Top K paper referenced above.
         // For example, the paper shows we only need to output the orange bars.
         // The output sequence should look like this | | | | | | | |.
         // Because the sequence is halved, to map the output index back
         // to the previous sequence to find the corresponding value,
         // we need to double the index. When we double the index,
         // we basically interpolate a position, so 2i looks like
         // | _ | _ | _ | _ | _ | _ | _. We move the | to the first k position
         // of each 2k positions by - elemIdx % k. E.g. for output at
         // index 4,5,6,7, we want to get the corresponding element at
         // original index 8,9,10,11, for output at index 8,9,10,11,
         // we want to get the corresponding element at original index
         // 16,17,18,19, so on and so forth.

         int i = elemIdx < k ? elemIdx : (elemIdx * 2 - imod(elemIdx, k));
         int i0 = firstPass == 1 ? i : int(getIndices(batch, i));
         int i1 = firstPass == 1 ? i + k : int(getIndices(batch, i + k));

         float x0 = getX(batch, i0);
         float x1 = i1 < n ? getX(batch, i1) : x0;

         setOutput(x0 >= x1 ? float(i0) : float(i1));
       }
     `;
    }
}






function $6ca4532597a6b98f$var$disposeIntermediateTensorInfoOrNull(backend, tensorInfo) {
    if (tensorInfo !== null) backend.disposeIntermediateTensorInfo(tensorInfo);
}
function $6ca4532597a6b98f$var$roundUpToPow2(num) {
    let pow2 = 1;
    while(pow2 < num)pow2 *= 2;
    return pow2;
}
function $6ca4532597a6b98f$export$7e641efc73a2d81(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { k: k, sorted: sorted } = attrs;
    // Empirically determined constant used to determine last dim threshold for
    // handing off execution to the CPU.
    const TOPK_LAST_DIM_CPU_HANDOFF_SIZE_THRESHOLD = (0, $i64bB.env)().getNumber('TOPK_LAST_DIM_CPU_HANDOFF_SIZE_THRESHOLD');
    // Empirically determined constant used to determine k threshold for handing
    // off execution to the CPU.
    const TOPK_K_CPU_HANDOFF_THRESHOLD = (0, $i64bB.env)().getNumber('TOPK_K_CPU_HANDOFF_THRESHOLD');
    const xShape = x.shape;
    const lastDim = xShape[xShape.length - 1];
    if (backend.shouldExecuteOnCPU([
        x
    ]) || lastDim < TOPK_LAST_DIM_CPU_HANDOFF_SIZE_THRESHOLD || k > TOPK_K_CPU_HANDOFF_THRESHOLD) {
        const xVals = backend.readSync(x.dataId);
        const [allTopKVals, allTopKIndices] = (0, $377486a788efd20b$export$cc4aa6851cf96e2b)(xVals, xShape, x.dtype, k, sorted);
        return [
            backend.makeTensorInfo(allTopKVals.shape, allTopKVals.dtype, allTopKVals.values),
            backend.makeTensorInfo(allTopKIndices.shape, allTopKIndices.dtype, allTopKIndices.values)
        ];
    }
    if (k === 0) {
        xShape[xShape.length - 1] = 0;
        return [
            backend.makeTensorInfo(xShape, x.dtype, []),
            backend.makeTensorInfo(xShape, 'int32', [])
        ];
    }
    if (lastDim === 1 /* firstPass */ ) return [
        x,
        (0, $248d06c44cbf77ee$export$9563e054e6f787fb)({
            attrs: {
                shape: xShape,
                dtype: 'int32',
                value: 0
            },
            backend: backend
        })
    ];
    // Eagerly unpack x input since it is passed in to all the shaders which
    // require unpacked inputs.
    const xtexData = backend.texData.get(x.dataId);
    const xIsPacked = xtexData !== null && xtexData.isPacked;
    const xUnPacked = xIsPacked ? backend.unpackTensor(x) : x;
    // Reshape into a 2d tensor [batch, lastDim] and compute topk along lastDim.
    const xSize = (0, $i64bB.util).sizeFromShape(xShape);
    const batch = xSize / lastDim;
    const x2D = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: xUnPacked
        },
        attrs: {
            shape: [
                batch,
                lastDim
            ]
        },
        backend: backend
    });
    if (xIsPacked) $6ca4532597a6b98f$var$disposeIntermediateTensorInfoOrNull(backend, xUnPacked);
    const kPow2 = $6ca4532597a6b98f$var$roundUpToPow2(k);
    const lastDimPow2 = $6ca4532597a6b98f$var$roundUpToPow2(lastDim);
    // Only the indices containing the top K are kept at every step to reduce
    // number of outputs in the GPU algorithms, so once the final set of indices
    // is computed then gather is used to grab the corresponding values
    // from the original input.
    let indices = null;
    // GPU algorithm always takes in an indices input but this input is not used
    // on the first run of a GPU algorithm, therefore if indices is null we simply
    // pass in x2D instead of it but the value will not actually be used
    const getInputs = ()=>indices === null ? [
            x2D,
            x2D
        ] : [
            x2D,
            indices
        ];
    const runSwap = (dir, inc, shape)=>{
        const inputs = getInputs();
        const program = new (0, $49e8d0916bd9985d$export$5ee54e3c81d6f6e7)(shape);
        const fistPass = indices === null ? 1 : 0;
        const customValues = [
            [
                lastDim
            ],
            [
                fistPass
            ],
            [
                Number.NEGATIVE_INFINITY
            ],
            [
                dir
            ],
            [
                inc
            ]
        ];
        const prevIndices = indices;
        indices = backend.runWebGLProgram(program, inputs, 'int32', customValues);
        $6ca4532597a6b98f$var$disposeIntermediateTensorInfoOrNull(backend, prevIndices);
    };
    // Step 1: local sort
    for(let len = 1; len < kPow2; len *= 2){
        const dir = len * 2;
        for(let inc = len; inc >= 1; inc /= 2)runSwap(dir, inc, [
            batch,
            lastDimPow2
        ]);
    }
    // Step 2: merge
    for(let indicesSize = lastDimPow2; indicesSize > kPow2; indicesSize /= 2){
        const inputs = getInputs();
        const mergeProgram = new (0, $49e8d0916bd9985d$export$c3fbf8b38d821ac9)([
            batch,
            indicesSize / 2
        ]);
        const firstPass = indices === null ? 1 : 0;
        const customValues = [
            [
                lastDim
            ],
            [
                firstPass
            ],
            [
                kPow2
            ]
        ];
        const prevIndices = indices;
        indices = backend.runWebGLProgram(mergeProgram, inputs, 'int32', customValues);
        $6ca4532597a6b98f$var$disposeIntermediateTensorInfoOrNull(backend, prevIndices);
        // Step 3: rebuild
        const len = kPow2 / 2;
        const dir = len * 2;
        for(let inc = len; inc >= 1; inc /= 2)runSwap(dir, inc, indices.shape);
    }
    // Keep only the requested top K results instead of kPow2
    let prevIndices = indices;
    indices = (0, $c4b4f5c2e7e1b97a$export$58adb3bec8346d0f)({
        inputs: {
            x: indices
        },
        backend: backend,
        attrs: {
            begin: 0,
            size: [
                batch,
                k
            ]
        }
    });
    $6ca4532597a6b98f$var$disposeIntermediateTensorInfoOrNull(backend, prevIndices);
    // Gather values on last dimension
    let values = (0, $9675e221f7767bae$export$3d75b4295ded9925)({
        inputs: {
            x: x2D,
            indices: indices
        },
        backend: backend,
        attrs: {
            axis: 1,
            batchDims: 1
        }
    });
    $6ca4532597a6b98f$var$disposeIntermediateTensorInfoOrNull(backend, x2D);
    // Reshape back to the original input shape, except that the last
    // dimension is k.
    const newShape = xShape.slice(0, -1);
    newShape.push(k);
    prevIndices = indices;
    indices = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: indices
        },
        attrs: {
            shape: newShape
        },
        backend: backend
    });
    $6ca4532597a6b98f$var$disposeIntermediateTensorInfoOrNull(backend, prevIndices);
    const prevValues = values;
    values = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: values
        },
        attrs: {
            shape: newShape
        },
        backend: backend
    });
    $6ca4532597a6b98f$var$disposeIntermediateTensorInfoOrNull(backend, prevValues);
    return [
        values,
        indices
    ];
}
const $6ca4532597a6b98f$export$cffaee31213314ce = {
    kernelName: (0, $i64bB.TopK),
    backendName: 'webgl',
    kernelFunc: $6ca4532597a6b98f$export$7e641efc73a2d81
};


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $8e0b00a101b7ca12$export$c83a293baf8f269d {
    constructor(imageHeight, imageWidth, interpolation, fillMode, fillValue, outShape){
        this.variableNames = [
            'Image',
            'Transforms'
        ];
        this.outputShape = outShape;
        const interpolationModeId = interpolation === 'nearest' ? 1 : 2;
        let fillModeId;
        switch(fillMode){
            case 'constant':
                fillModeId = 1;
                break;
            case 'reflect':
                fillModeId = 2;
                break;
            case 'wrap':
                fillModeId = 3;
                break;
            case 'nearest':
                fillModeId = 4;
                break;
            default:
                fillModeId = 1;
                break;
        }
        this.userCode = `
            float mapCoord(float outCoord, float len) {
              float inCoord = outCoord;
              if(${fillModeId} == 2) {
                if (inCoord < 0.0) {
                  if (len <= 1.0) {
                    inCoord = 0.0;
                  } else {
                    float sz2 = 2.0 * len;
                    if (inCoord < sz2) {
                      inCoord = sz2 * float(int(float(-inCoord / sz2))) +
                      inCoord;
                    }
                    inCoord = inCoord < -len ? inCoord + sz2 : -inCoord - 1.0;
                  }
                } else if (inCoord > len - 1.0) {
                  if (len <= 1.0) {
                    inCoord = 0.0;
                  } else {
                    float sz2 = 2.0 * len;
                    inCoord -= sz2 * float(int(float(inCoord / sz2)));
                    if (inCoord >= len) {
                      inCoord = sz2 - inCoord - 1.0;
                    }
                  }
                }
                return clamp(inCoord, 0.0, len - 1.0);
              } else if (${fillModeId} == 3) {
                if (inCoord < 0.0) {
                  if (len <= 1.0) {
                    inCoord = 0.0;
                  } else {
                    float sz = len - 1.0;
                    inCoord += len * (float(int(float(-inCoord / sz))) + 1.0);
                  }
                } else if (inCoord > len - 1.0) {
                  if (len <= 1.0) {
                    inCoord = 0.0;
                  } else {
                    float sz = len - 1.0;
                    inCoord -= len * float(int(float(inCoord / sz)));
                  }
                }
                return clamp(inCoord, 0.0, len - 1.0);
              } else if (${fillModeId} == 4) {
                return clamp(outCoord, 0.0, len - 1.0);
              } else {
                return outCoord;
              }
            }

            float readWithFillValue(int batch, int coordY, int coordX,
              int channel) {
              float outputValue;
              if (0 <= coordY && coordY < ${imageHeight} && 0 <= coordX && coordX < ${imageWidth}) {
                  outputValue = getImage(batch, coordY, coordX, channel);
              } else {
                outputValue = float(${fillValue});
              }
              return outputValue;
            }

            void main() {
              ivec4 coords = getOutputCoords();
              float outputValue;
              int batch = coords[0];
              int x = coords[2];
              int y = coords[1];
              int channel = coords[3];
              float xf = float(x);
              float yf = float(y);
              float a1 = getTransforms(batch, 0);
              float a2 = getTransforms(batch, 1);
              float a3 = getTransforms(batch, 2);
              float b1 = getTransforms(batch, 3);
              float b2 = getTransforms(batch, 4);
              float b3 = getTransforms(batch, 5);
              float c1 = getTransforms(batch, 6);
              float c2 = getTransforms(batch, 7);
              float projection = c1 * xf + c2 * yf + 1.0;
              if (projection == 0.0) {
                outputValue = float(${fillValue});
              } else {
                float inX = (a1 * xf + a2 * yf + a3) / projection;
                float inY = (b1 * xf + b2 * yf + b3) / projection;
                float mapX = mapCoord(inX, float(${imageWidth}));
                float mapY = mapCoord(inY, float(${imageHeight}));

                if (${interpolationModeId} == 1) {
                  int coordY = int(round(mapY));
                  int coordX = int(round(mapX));
                  outputValue = readWithFillValue(batch, coordY, coordX,
                    channel);
                } else {
                  float yFloor = floor(mapY);
                  float xFloor = floor(mapX);
                  float yCeil = yFloor + 1.0;
                  float xCeil = xFloor + 1.0;
                  float valueYFloor = (xCeil - mapX) *
                  readWithFillValue(batch, int(yFloor), int(xFloor), channel) +
                  (mapX - xFloor) *
                  readWithFillValue(batch, int(yFloor), int(xCeil), channel);
                  float valueYCeil = (xCeil - mapX) *
                  readWithFillValue(batch, int(yCeil), int(xFloor), channel) +
                  (mapX - xFloor) *
                  readWithFillValue(batch, int(yCeil), int(xCeil), channel);
                  outputValue = (yCeil - mapY) * valueYFloor +
                  (mapY - yFloor) * valueYCeil;
                }
              }
              setOutput(outputValue);
            }
        `;
    }
}


function $d64b0ee2680b0d0c$export$51186ad6e864892a(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { image: image, transforms: transforms } = inputs;
    const { interpolation: interpolation, fillMode: fillMode, fillValue: fillValue, outputShape: outputShape } = attrs;
    const [batch, imageHeight, imageWidth, numChannels] = image.shape;
    const [outHeight, outWidth] = outputShape != null ? outputShape : [
        imageHeight,
        imageWidth
    ];
    const outShape = [
        batch,
        outHeight,
        outWidth,
        numChannels
    ];
    const program = new (0, $8e0b00a101b7ca12$export$c83a293baf8f269d)(imageHeight, imageWidth, interpolation, fillMode, fillValue, outShape);
    return backend.runWebGLProgram(program, [
        image,
        transforms
    ], 'float32');
}
const $d64b0ee2680b0d0c$export$1c7a3de6335954ed = {
    kernelName: (0, $i64bB.Transform),
    backendName: 'webgl',
    kernelFunc: $d64b0ee2680b0d0c$export$51186ad6e864892a
};



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


function $eeaa638cb205af56$export$7a5d5c156e7dc406(args) {
    const { inputs: inputs, attrs: attrs, backend: backend } = args;
    const { axis: axis } = attrs;
    const { x: x } = inputs;
    (0, $03fc80a4a4cef09e$export$1412c17b2531581a)(x, 'unique');
    // For now, always forward calculation to the CPU backend.
    console.warn('WARNING: ', 'UI might be locked temporarily as data is being downloaded');
    const values = backend.readSync(x.dataId);
    const { outputValues: outputValues, outputShape: outputShape, indices: indices } = (0, $377486a788efd20b$export$c417de669ad2e148)(values, axis, x.shape, x.dtype);
    return [
        backend.makeTensorInfo(outputShape, x.dtype, outputValues),
        backend.makeTensorInfo([
            indices.length
        ], 'int32', indices)
    ];
}
const $eeaa638cb205af56$export$78cd70dcd092910e = {
    kernelName: (0, $i64bB.Unique),
    backendName: 'webgl',
    kernelFunc: $eeaa638cb205af56$export$7a5d5c156e7dc406
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");


function $77e8d3b99dd9fb05$export$417857010dc9287f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { value: value } = inputs;
    let { axis: axis } = attrs;
    if (axis < 0) axis += value.shape.length;
    const x = value;
    const xRank = x.shape.length;
    const num = value.shape[axis];
    const outShape = new Array(xRank - 1);
    let outIndex = 0;
    for(let i = 0; i < xRank; i++)if (i !== axis) outShape[outIndex++] = x.shape[i];
    const toDispose = [];
    const begin = new Array(xRank).fill(0);
    const size = x.shape.slice();
    size[axis] = 1;
    const res = new Array(num);
    for(let i = 0; i < res.length; i++){
        begin[axis] = i;
        const sliced = (0, $c4b4f5c2e7e1b97a$export$58adb3bec8346d0f)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                begin: begin,
                size: size
            }
        });
        const reshaped = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
            inputs: {
                x: sliced
            },
            backend: backend,
            attrs: {
                shape: outShape
            }
        });
        res[i] = reshaped;
        toDispose.push(sliced);
    }
    toDispose.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return res;
}
const $77e8d3b99dd9fb05$export$d06292128cae50d6 = {
    kernelName: (0, $i64bB.Unpack),
    backendName: 'webgl',
    kernelFunc: $77e8d3b99dd9fb05$export$417857010dc9287f
};


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i64bB = parcelRequire("i64bB");
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $278e5ed9000af6de$export$543f739d986d05c3 {
    constructor(segOpInfo, segOpType){
        this.variableNames = [
            'x',
            'segmentIds'
        ];
        const windowSize = segOpInfo.windowSize;
        const batchSize = segOpInfo.batchSize;
        const inSize = segOpInfo.inSize;
        const numSegments = segOpInfo.numSegments;
        const outSize = numSegments * Math.ceil(inSize / windowSize);
        this.outputShape = [
            batchSize,
            outSize
        ];
        const initializationValue = '0.0';
        const returnValue = `sumValue`;
        const windowSizeNearestVec4 = Math.floor(windowSize / 4) * 4;
        const windowSizeVec4Remainder = windowSize % 4;
        const updateSnippet = `
        sumValue += dot(values, segFilter);
    `;
        let checkValueOutOfBounds = '';
        if (inSize % windowSize > 0) checkValueOutOfBounds = `
        if (inIdx < 0 || inIdx >= ${inSize}) {
          return initializationValue;
        }
      `;
        let checkSegmentIdOutOfBounds = '';
        if (inSize % windowSize > 0) checkSegmentIdOutOfBounds = `
        if (inIdx < 0 || inIdx >= ${inSize}) {
          return -1.0;
        }
      `;
        this.userCode = `
      const float initializationValue = ${initializationValue};

      float getValue(int batch, int inIdx) {
        ${checkValueOutOfBounds}
        return getX(batch, inIdx);
      }

      float getSegmentIdAtIndex(int inIdx) {
        ${checkSegmentIdOutOfBounds}
        return getSegmentIds(inIdx);
      }

      void main() {
        ivec2 coords = getOutputCoords();
        int batch = coords[0];
        int outIdx = coords[1];
        int inOffset = int(floor(float(outIdx) / float(
          ${numSegments})) * float(${windowSize}));
        int currentSeg = int(mod(float(outIdx), float(${numSegments})));

        float sumValue = 0.0;

        for (int i = 0; i < ${windowSizeNearestVec4}; i += 4) {
          int inIdx = inOffset + i;
          vec4 values = vec4(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            getValue(batch, inIdx + 2),
            getValue(batch, inIdx + 3)
          );

          vec4 segFilter = vec4(
            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,
            int(getSegmentIdAtIndex(inIdx + 1)) == currentSeg ? 1 : 0,
            int(getSegmentIdAtIndex(inIdx + 2)) == currentSeg ? 1 : 0,
            int(getSegmentIdAtIndex(inIdx + 3)) == currentSeg ? 1 : 0
          );

          ${updateSnippet}
        }

        int inIdx = inOffset + ${windowSizeNearestVec4};
        if (${windowSizeVec4Remainder === 1}) {
          vec4 values = vec4(
            getValue(batch, inIdx),
            initializationValue,
            initializationValue,
            initializationValue
          );

          int inIdxSeg = int(getSegmentIdAtIndex(inIdx));

          vec4 segFilter = vec4(
            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,
            0,
            0,
            0
          );

          ${updateSnippet}
        } else if (${windowSizeVec4Remainder === 2}) {
          vec4 values = vec4(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            initializationValue,
            initializationValue
          );

          vec4 segFilter = vec4(
            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,
            int(getSegmentIdAtIndex(inIdx + 1)) == currentSeg ? 1 : 0,
              0,
              0
          );

          ${updateSnippet}
        } else if (${windowSizeVec4Remainder === 3}) {
          vec4 values = vec4(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            getValue(batch, inIdx + 2),
            initializationValue
          );

          vec4 segFilter = vec4(
            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,
            int(getSegmentIdAtIndex(inIdx + 1)) == currentSeg ? 1 : 0,
            int(getSegmentIdAtIndex(inIdx + 2)) == currentSeg ? 1 : 0,
            0
          );

          ${updateSnippet}
        }
        setOutput(${returnValue});
      }
    `;
    }
}






function $6ba5c5ec34423439$export$ba7c4d144d85a309(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, segmentIds: segmentIds } = inputs;
    const { numSegments: numSegments } = attrs;
    const xRank = x.shape.length;
    const toDispose = [];
    let axis = 0;
    const permutation = (0, $i64bB.backend_util).getAxesPermutation([
        axis
    ], xRank);
    let permutedX = x;
    if (permutation != null) {
        permutedX = (0, $6cab078553124169$export$9cb09a71b7d66923)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutation
            }
        });
        toDispose.push(permutedX);
        axis = (0, $i64bB.backend_util).getInnerMostAxes(1, xRank)[0];
    }
    const outShape = (0, $i64bB.backend_util).segment_util.computeOutShape(permutedX.shape, axis, numSegments);
    const inSize = (0, $i64bB.util).sizeFromShape([
        permutedX.shape[axis]
    ]);
    const a2D = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: permutedX
        },
        backend: backend,
        attrs: {
            shape: [
                -1,
                inSize
            ]
        }
    });
    toDispose.push(a2D);
    const outputDType = (0, $i64bB.sumOutType)(x.dtype);
    const segOpCompute = (x, segOpType, segmentIds, dtype, numSegments)=>{
        const batchSize = x.shape[0];
        const inSize = x.shape[1];
        const windowSize = (0, $i64bB.backend_util).segment_util.segOpComputeOptimalWindowSize(inSize, numSegments);
        const segOpInfo = {
            windowSize: windowSize,
            inSize: inSize,
            batchSize: batchSize,
            numSegments: numSegments
        };
        const program = new (0, $278e5ed9000af6de$export$543f739d986d05c3)(segOpInfo, segOpType);
        const output = backend.compileAndRun(program, [
            x,
            segmentIds
        ], dtype);
        toDispose.push(output);
        // No need to run another GPGPU program.
        if (output.shape[1] === numSegments) return output;
        const rangeInfo = (0, $97a00e65e93acdcd$export$d02631cccf789723)({
            backend: backend,
            attrs: {
                start: 0,
                stop: numSegments,
                step: 1,
                dtype: 'float32'
            }
        });
        const tileInfo = (0, $bee0a451396ec95d$export$3c17558da18e4d75)({
            inputs: {
                x: rangeInfo
            },
            backend: backend,
            attrs: {
                reps: [
                    inSize / windowSize
                ]
            }
        });
        toDispose.push(rangeInfo);
        toDispose.push(tileInfo);
        const result = segOpCompute(output, segOpType, tileInfo, dtype, numSegments);
        return result;
    };
    const segOpResult = segOpCompute(a2D, 'unsortedSegmentSum', segmentIds, outputDType, numSegments);
    const reshaped = (0, $6e79ac71d9dab042$export$9eaad88cf88cee2b)({
        inputs: {
            x: segOpResult
        },
        backend: backend,
        attrs: {
            shape: outShape
        }
    });
    let result = reshaped;
    if (permutation != null) {
        toDispose.push(reshaped);
        const perm = (0, $i64bB.backend_util).getUndoAxesPermutation(permutation);
        result = (0, $6cab078553124169$export$9cb09a71b7d66923)({
            inputs: {
                x: result
            },
            backend: backend,
            attrs: {
                perm: perm
            }
        });
    }
    toDispose.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return result;
}
const $6ba5c5ec34423439$export$71e3626a4ca29968 = {
    kernelName: (0, $i64bB.UnsortedSegmentSum),
    backendName: 'webgl',
    kernelFunc: $6ba5c5ec34423439$export$ba7c4d144d85a309
};



// List all kernel configs here
const $beca2dddb9cdec78$var$kernelConfigs = [
    (0, $2a7a93337843b2bb$export$f70d36da1c218f84),
    (0, $d0fa4de08a37af90$export$d66f48648b9d5ec7),
    (0, $8a8ab7765d71f855$export$255826ca70737275),
    (0, $3ca6396ddc5af6e7$export$3f520b71a56c9e70),
    (0, $f8bb1e7111872926$export$b1f3a580afb68e4c),
    (0, $dda9f85674249e4f$export$ff8000bc6f0313e1),
    (0, $c337b9c2f734e218$export$4e3f081eb1a330fa),
    (0, $e675eb466b36fc13$export$1a8ff634f2df3da6),
    (0, $68d2329c08364cbd$export$ec7419fc9ad0069e),
    (0, $45e40558cf021cec$export$21836a5e5fa09eb4),
    (0, $67101c5a52055102$export$de5cb0ef95dd6700),
    (0, $4372eb63392d2d83$export$20d424616c76166),
    (0, $e21a181ab3eb5f8b$export$159d632e3ff13624),
    (0, $3d001d64672abbe9$export$c53c7ab019edb8a0),
    (0, $07f6172ea9c55cba$export$e9ce1ba75fc9b746),
    (0, $896cba4644372bbe$export$6c901824a23e6150),
    (0, $424aa4ac34c4d8fe$export$5a9c81d240244392),
    (0, $7d7e351f6798b687$export$1eeb8780807d0508),
    (0, $301cf15fac264e3e$export$ac3f8709351ab225),
    (0, $0d7807b255cc9584$export$d0dd993198185538),
    (0, $07d4496ea817584e$export$df2dc5c7a755e418),
    (0, $0e7ba385a90d21de$export$44e08e19f97e5513),
    (0, $4059b2d79778b36c$export$af9f0093738840fb),
    (0, $c545ba0c343ec7d9$export$6d53927dafa38bf9),
    (0, $ff697a7195ce28b0$export$8f7b2ec0c6f08fb2),
    (0, $e7854ff584c008b2$export$ac4d0f0f3927a8f3),
    (0, $b19701b33ab731bd$export$df387212b1898306),
    (0, $1bd954b3a607232d$export$f7ee8f07ce0ff4e1),
    (0, $f23c2381cb68ff19$export$67917f7910d27fd8),
    (0, $5602b12947b1b973$export$a4817d2978acc054),
    (0, $c761d8b937eefeed$export$c8cf96dae25282e5),
    (0, $99d9bdf968f11961$export$4a39bf13b4378042),
    (0, $26c7888026485ba8$export$7a95f55d2d2e7d24),
    (0, $3f08c21d8204efd0$export$19bbc19fff1ed26f),
    (0, $a1f837211cd242b8$export$1fe590fda0829040),
    (0, $fdd940dd9e7b76d4$export$6dce9169640850fa),
    (0, $0ff1dfa52085b1cf$export$cdcac766a3ef1744),
    (0, $5d30812f5875ff7d$export$ff099a1da5235a7e),
    (0, $c88a83e60aff56ce$export$c5824052b09ba0ed),
    (0, $327b096734c2bb70$export$f7086edcf0050c7f),
    (0, $95ccf3692624d814$export$db50d81ed60c5a35),
    (0, $e62976d7f9bb3deb$export$2f6196f3316e7ed2),
    (0, $26c3558c7225fa23$export$88ba267b84334692),
    (0, $00c79c2fddb4312a$export$9c5b88dcb1d2008b),
    (0, $3dc6eb74e808d751$export$240667804b7c390e),
    (0, $25fb5d98fa7976fa$export$30bc0ac3775583fc),
    (0, $3ce31c59b66b30c6$export$55d12409e744bebe),
    (0, $dfdbed2ad431d135$export$56dc5d812a22748f),
    (0, $7f951b7ac7fc14fd$export$36d3c11f61a8891a),
    (0, $d152d30c63739394$export$40bbf341885a23b7),
    (0, $9c8866d19b592f1b$export$b990686634ee3cce),
    (0, $4cae63a555950558$export$59bb07dd04647a1d),
    (0, $788ea5612f442218$export$3c8bc3d8ee318217),
    (0, $c314644caa7f3634$export$d044ffef16079bd),
    (0, $f564a957992b7970$export$2fd7ea0fcf021f34),
    (0, $0d346f16979dfda2$export$86341ba0ce5d8e60),
    (0, $c399b2eaa41286db$export$16db8a08b36f938),
    (0, $4597301918ebe5d9$export$a4d564e380763c78),
    (0, $248d06c44cbf77ee$export$c953bf474b2bde62),
    (0, $ea3eeae1bf3305ed$export$c9ec83cb23304466),
    (0, $24be6ac7d51ef330$export$7e9a0f96fa6bd01c),
    (0, $9fd7092a51fba04c$export$7eac933a0c7fd37f),
    (0, $584621bf945dd066$export$b22e14d614fc7178),
    (0, $c695c8cad511bf86$export$5b64efa829ddf94e),
    (0, $aa836a252d269e1d$export$58481cc3409b412c),
    (0, $4266c995ff3a7172$export$d9700eb1c7f5c969),
    (0, $9675e221f7767bae$export$b1bd3139c91d8765),
    (0, $d8ef954c91d00c6a$export$8c4f7e92d92310f8),
    (0, $a87d5b64457a8833$export$7a6926f9fcac24ca),
    (0, $2b13f312c76ad9c3$export$c426d3942537ad84),
    (0, $4efb69686add259c$export$dc267425bf21b465),
    (0, $26faf84d87c54a60$export$ddfc128c2801add7),
    (0, $ed8c7f06f282f5a1$export$4d45c8f7b9ffdaf1),
    (0, $b7d8d8aa3e580525$export$bc383b82282e9b5a),
    (0, $7165148d8787b3d0$export$d58ff790c765c1f0),
    (0, $442fcb85a2be5920$export$aa04ab963fdf437f),
    (0, $ac08ecf54857ad6b$export$8d4530ce8b6ffc3c),
    (0, $6f550f45598f64ef$export$9f26bd257393dd8),
    (0, $1675ed15c165f58f$export$46b96f742c70959b),
    (0, $53e959040aa3f91a$export$a4ae1f00643ddd14),
    (0, $a1abd1c31271db41$export$c458b9e5ba980198),
    (0, $ebb2ba64f27ac58d$export$257f1e82e69113fb),
    (0, $ecbbeb478d5c896c$export$68e2dd0840056271),
    (0, $7c5010a82846f235$export$ce04b6546987ef43),
    (0, $dc1573362b66fa9e$export$6fb124d5a6994734),
    (0, $b71b311e76fffe49$export$99a62fc039d7aca0),
    (0, $732f8dce2eff8c69$export$7d79147246e312bb),
    (0, $937eb548d92b33db$export$45b97bdc342e72a2),
    (0, $14a0076dde30b024$export$45c8263b38f19e33),
    (0, $34f80b63f5f4d6ad$export$91a8fc5da39ec855),
    (0, $63a48a37371a55dd$export$5201426bb10bd5eb),
    (0, $2bf8033ad06b4bf4$export$e01a7f8dbee29127),
    (0, $abe62b018b6c1520$export$a069ee2247a7d1ce),
    (0, $4a80966bb249c896$export$b934af0ccd0cdbe1),
    (0, $361ad92d998b60b5$export$3cd9f9a31b38cf18),
    (0, $1b132b43b24c455f$export$ea24ffbbbce8d546),
    (0, $12c5ac49f0f2180d$export$2cfd6c6c7daeb5fc),
    (0, $414c6e096693281c$export$9037685a81180a9c),
    (0, $9b9904aa6656bc38$export$ad960e364767f0e2),
    (0, $14ecc88d5b9c3d28$export$745576778aafee88),
    (0, $bdcfb36f87e7b0d8$export$cc7b18b8229c3db),
    (0, $c8e13cee1ea8ed41$export$549561cd158f260a),
    (0, $25e5e9f8d015448f$export$906b8fb32c570e9d),
    (0, $d298368f7be34cf7$export$4c00b682f309701d),
    (0, $32100f910ecbf976$export$d003d4d7e1500775),
    (0, $8498c66b76463c69$export$dde5645b472b80b2),
    (0, $1d2c03b43676110a$export$d8d7015eb6ab37d0),
    (0, $43ea7f7750daad11$export$1645fa8803aa1f86),
    (0, $379eb6e5685c7da3$export$b0317e720bfd61fc),
    (0, $8fb9dbd7dc454230$export$b823d49786719761),
    (0, $d02b300568754543$export$a5c4a9b694579636),
    (0, $dffda8227da65443$export$d556aa935cef5c0c),
    (0, $155385e0abb1f75e$export$cebb8a7d5932c7e8),
    (0, $0fa10c28cfabb2db$export$91ddd62a193b9401),
    (0, $bb3e44408fa68e6b$export$792f441e33dcdf26),
    (0, $97a00e65e93acdcd$export$361c4075706e31c2),
    (0, $3d07b56624286bfa$export$4b7bce57557ae68b),
    (0, $009cdfbf6f91cb52$export$15c5d6176b30b9a6),
    (0, $4c1d1885d9605a9a$export$412a6b66203fdf72),
    (0, $f30b554a6f09ab36$export$731f9199bde068eb),
    (0, $edf36a5ae3cebc82$export$92c30890ad649d53),
    (0, $6e79ac71d9dab042$export$cfa02e698602aca2),
    (0, $d7d24d31ce35f034$export$a37a56137abc1357),
    (0, $1190a0baca979f1c$export$51f84ca614e84763),
    (0, $63afc1d59801f149$export$2b6a92caba113b89),
    (0, $e8d5b8825368dcdd$export$2b08d810b5090fe1),
    (0, $fb2cfa1996ec5742$export$cab6a4e8d2ed8e8d),
    (0, $5834fa005761b86c$export$44ba8c83417ab668),
    (0, $a5e701f48ff22533$export$6c09e3291f636503),
    (0, $9598331f45c2683c$export$941104b789956ef6),
    (0, $b582a7eea73ccbb9$export$573371744f044f5),
    (0, $e4b358c10b05bcbf$export$4b437b1a1aa6472f),
    (0, $afbd292455431049$export$7ff911e710ee72fc),
    (0, $0478ded2e013bef8$export$8afc8558705c1a39),
    (0, $0748024561a6ce75$export$195d1cf7c59f3ef),
    (0, $91f700997aefd0de$export$9c0fb3eb2124ceb7),
    (0, $3c9cb0977514b79f$export$d993ec4e5c253b66),
    (0, $99c3d27bd6b9c880$export$b92766b47f18ac85),
    (0, $c4b4f5c2e7e1b97a$export$8d8a1e11dd2cc6c4),
    (0, $57af78475e4ec5cb$export$c022691f23e2ee69),
    (0, $1f435b901469df60$export$d9bcfe553d12d9e3),
    (0, $573199a3541dbc61$export$2f85417863d2050b),
    (0, $ad01a3592ad9ab72$export$818286c593224d1a),
    (0, $e97f58197a9c9461$export$eb106efc10374803),
    (0, $0408c14210b44049$export$51e7224ae14d7f78),
    (0, $51e2314a5b39202d$export$73fa0270f28b9555),
    (0, $279f720d4c5f508b$export$7bc088f8ad44ef99),
    (0, $3d0c43215a921f05$export$317be24be3af9ea0),
    (0, $cdd97f1adbf6ab71$export$a592ba9268f10eeb),
    (0, $9e39869fb26c6983$export$7c77bece4d51efc4),
    (0, $fe269d9515830fc9$export$9ed4691d69db8a43),
    (0, $9bd181afbd5ddc65$export$1069b2f6977254f4),
    (0, $2ed3c62597f7cafa$export$c42ffaf52eb2647),
    (0, $b319f8808af3f1a1$export$81773633114187bd),
    (0, $4d7066b1ff67f75a$export$35e13284eed34c22),
    (0, $b8078f32ea2e52f8$export$c51cbbd627a96532),
    (0, $abaa2f715d582461$export$a88a78b2b233f507),
    (0, $1b60e5a3ab7a8d10$export$5d068476dad60c4d),
    (0, $579f4cd1cc49add3$export$47edea402251c258),
    (0, $9c7c587bb0a01e51$export$97648844df7611f3),
    (0, $49483ca617d860db$export$a2fc7de1a1e4eee0),
    (0, $393ae9af6bbeb118$export$2819813ce8339b64),
    (0, $bee0a451396ec95d$export$a5a9f8050ba7f41e),
    (0, $6ca4532597a6b98f$export$cffaee31213314ce),
    (0, $d64b0ee2680b0d0c$export$1c7a3de6335954ed),
    (0, $6cab078553124169$export$895a002a39b774be),
    (0, $eeaa638cb205af56$export$78cd70dcd092910e),
    (0, $77e8d3b99dd9fb05$export$d06292128cae50d6),
    (0, $6ba5c5ec34423439$export$71e3626a4ca29968),
    (0, $4d9f12f1439683dc$export$15368df05c479e41)
];
for (const kernelConfig of $beca2dddb9cdec78$var$kernelConfigs)(0, $i64bB.registerKernel)(kernelConfig);




/** @license See the LICENSE file. */ // This code is auto-generated, do not modify this file!
const $5fc97fed21c47195$export$83d89fbfd8236492 = '4.22.0';


const $ecee5d60577d193c$export$83d89fbfd8236492 = {
    'tfjs-core': (0, $i64bB.version_core),
    'tfjs-backend-cpu': (0, $a2dd452fb583d973$export$83d89fbfd8236492),
    'tfjs-backend-webgl': (0, $93bc77f288d060bd$export$83d89fbfd8236492),
    'tfjs-data': (0, $4bf16420126b0bf6$export$83d89fbfd8236492),
    'tfjs-layers': (0, $3e25243b0afd8066$export$83d89fbfd8236492),
    'tfjs-converter': (0, $40l72.version_converter),
    'tfjs': (0, $5fc97fed21c47195$export$83d89fbfd8236492)
};


var $i64bB = parcelRequire("i64bB");
class $24ba8c8cb566c6a3$export$2e2bcd8739ae039 {
    constructor(el){
        this.el = el;
        this.metadataLoaded = false;
        this.dataLoaded = false;
        this.setUpListeners();
    }
    setUpListeners() {
        // based on https://github.com/tensorflow/tfjs-models/blob/af59ff3eb3350986173ac8c8ae504806b02dad39/body-pix/demo/index.js/#L135-L137
        this.el.addEventListener("loadedmetadata", ()=>{
            this.el.width = this.el.videoWidth;
            this.el.height = this.el.videoHeight;
            this.metadataLoaded = true;
        });
        this.el.addEventListener("loadeddata", ()=>{
            this.dataLoaded = true;
        });
    }
    /**
   * Get the non-Mac camera, if available
   */ async getWebCam() {
        const devices = await navigator.mediaDevices.enumerateDevices();
        return devices.find((device)=>device.kind === "videoinput" && !device.label.includes("FaceTime"));
    }
    async setUpCamera(targetWidth, targetHeight) {
        // favor the webcam, if available
        const webcam = await this.getWebCam();
        const constraints = {
            audio: false,
            video: {
                width: targetWidth,
                height: targetHeight,
                deviceId: webcam?.deviceId
            }
        };
        const stream = await navigator.mediaDevices.getUserMedia(constraints);
        this.el.srcObject = stream;
    }
    turnOffWebcam() {
        this.metadataLoaded = false;
        this.dataLoaded = false;
        const stream = this.el.srcObject;
        stream?.getTracks().forEach((track)=>track.stop());
        this.el.srcObject = null;
    }
    isLoaded() {
        return this.metadataLoaded && this.dataLoaded;
    }
    /**
   * @returns a Video instance with a "virtual" element (outside of the DOM) matching the size of the provided canvas
   */ static matchCanvas(canvas) {
        const videoEl = document.createElement("video");
        videoEl.autoplay = true;
        videoEl.width = canvas.width();
        videoEl.height = canvas.height();
        return new $24ba8c8cb566c6a3$export$2e2bcd8739ae039(videoEl);
    }
}


const $816ad028d040dfc8$export$83595b84fc78b9b4 = (selector)=>{
    const el = document.getElementById(selector);
    if (!el) throw new Error(`Element '${el}' not found`);
    return el;
};
const $816ad028d040dfc8$export$31b21d0167753bb4 = (element)=>{
    // https://stackoverflow.com/a/38929456
    const cs = getComputedStyle(element);
    const paddingX = parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight);
    const paddingY = parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom);
    const borderX = parseFloat(cs.borderLeftWidth) + parseFloat(cs.borderRightWidth);
    const borderY = parseFloat(cs.borderTopWidth) + parseFloat(cs.borderBottomWidth);
    // Element width and height minus padding and border
    const width = element.offsetWidth - paddingX - borderX;
    const height = element.offsetHeight - paddingY - borderY;
    return {
        width: width,
        height: height
    };
};


class $7d44629e1ea23552$export$2e2bcd8739ae039 {
    constructor(el, loadingIndicator){
        this.el = el;
        this.loadingIndicator = loadingIndicator;
        this.setSize();
        const ctx = this.el.getContext("2d");
        if (!ctx) throw new Error("context couldn't be retrieved");
        this.context = ctx;
    }
    // canvas needs the width and height set explicitly
    // https://stackoverflow.com/a/2588404
    setSize() {
        const { width: width, height: height } = (0, $816ad028d040dfc8$export$31b21d0167753bb4)(this.el);
        this.el.width = width;
        this.el.height = height;
    }
    width() {
        return this.el.width;
    }
    height() {
        return this.el.height;
    }
    loaded() {
        this.loadingIndicator.remove();
    }
    clear() {
        // https://stackoverflow.com/a/2142549/358804
        this.context.clearRect(0, 0, this.width(), this.height());
    }
}



var $3HJq6 = parcelRequire("3HJq6");


var $bj515 = parcelRequire("bj515");
/**
 * dat-gui JavaScript Controller Library
 * https://github.com/dataarts/dat.gui
 *
 * Copyright 2011 Data Arts Team, Google Creative Lab
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ function $a4c493de23d91c5d$var$___$insertStyle(css) {
    if (!css) return;
    if (typeof window === 'undefined') return;
    var style = document.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    document.head.appendChild(style);
    return css;
}
function $a4c493de23d91c5d$var$colorToString(color, forceCSSHex) {
    var colorFormat = color.__state.conversionName.toString();
    var r = Math.round(color.r);
    var g = Math.round(color.g);
    var b = Math.round(color.b);
    var a = color.a;
    var h = Math.round(color.h);
    var s = color.s.toFixed(1);
    var v = color.v.toFixed(1);
    if (forceCSSHex || colorFormat === 'THREE_CHAR_HEX' || colorFormat === 'SIX_CHAR_HEX') {
        var str = color.hex.toString(16);
        while(str.length < 6)str = '0' + str;
        return '#' + str;
    } else if (colorFormat === 'CSS_RGB') return 'rgb(' + r + ',' + g + ',' + b + ')';
    else if (colorFormat === 'CSS_RGBA') return 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
    else if (colorFormat === 'HEX') return '0x' + color.hex.toString(16);
    else if (colorFormat === 'RGB_ARRAY') return '[' + r + ',' + g + ',' + b + ']';
    else if (colorFormat === 'RGBA_ARRAY') return '[' + r + ',' + g + ',' + b + ',' + a + ']';
    else if (colorFormat === 'RGB_OBJ') return '{r:' + r + ',g:' + g + ',b:' + b + '}';
    else if (colorFormat === 'RGBA_OBJ') return '{r:' + r + ',g:' + g + ',b:' + b + ',a:' + a + '}';
    else if (colorFormat === 'HSV_OBJ') return '{h:' + h + ',s:' + s + ',v:' + v + '}';
    else if (colorFormat === 'HSVA_OBJ') return '{h:' + h + ',s:' + s + ',v:' + v + ',a:' + a + '}';
    return 'unknown format';
}
var $a4c493de23d91c5d$var$ARR_EACH = Array.prototype.forEach;
var $a4c493de23d91c5d$var$ARR_SLICE = Array.prototype.slice;
var $a4c493de23d91c5d$var$Common = {
    BREAK: {},
    extend: function extend(target) {
        this.each($a4c493de23d91c5d$var$ARR_SLICE.call(arguments, 1), function(obj) {
            var keys = this.isObject(obj) ? Object.keys(obj) : [];
            keys.forEach((function(key) {
                if (!this.isUndefined(obj[key])) target[key] = obj[key];
            }).bind(this));
        }, this);
        return target;
    },
    defaults: function defaults(target) {
        this.each($a4c493de23d91c5d$var$ARR_SLICE.call(arguments, 1), function(obj) {
            var keys = this.isObject(obj) ? Object.keys(obj) : [];
            keys.forEach((function(key) {
                if (this.isUndefined(target[key])) target[key] = obj[key];
            }).bind(this));
        }, this);
        return target;
    },
    compose: function compose() {
        var toCall = $a4c493de23d91c5d$var$ARR_SLICE.call(arguments);
        return function() {
            var args = $a4c493de23d91c5d$var$ARR_SLICE.call(arguments);
            for(var i = toCall.length - 1; i >= 0; i--)args = [
                toCall[i].apply(this, args)
            ];
            return args[0];
        };
    },
    each: function each(obj, itr, scope) {
        if (!obj) return;
        if ($a4c493de23d91c5d$var$ARR_EACH && obj.forEach && obj.forEach === $a4c493de23d91c5d$var$ARR_EACH) obj.forEach(itr, scope);
        else if (obj.length === obj.length + 0) {
            var key = void 0;
            var l = void 0;
            for(key = 0, l = obj.length; key < l; key++){
                if (key in obj && itr.call(scope, obj[key], key) === this.BREAK) return;
            }
        } else for(var _key in obj){
            if (itr.call(scope, obj[_key], _key) === this.BREAK) return;
        }
    },
    defer: function defer(fnc) {
        setTimeout(fnc, 0);
    },
    debounce: function debounce(func, threshold, callImmediately) {
        var timeout = void 0;
        return function() {
            var obj = this;
            var args = arguments;
            function delayed() {
                timeout = null;
                if (!callImmediately) func.apply(obj, args);
            }
            var callNow = callImmediately || !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(delayed, threshold);
            if (callNow) func.apply(obj, args);
        };
    },
    toArray: function toArray(obj) {
        if (obj.toArray) return obj.toArray();
        return $a4c493de23d91c5d$var$ARR_SLICE.call(obj);
    },
    isUndefined: function isUndefined(obj) {
        return obj === undefined;
    },
    isNull: function isNull(obj) {
        return obj === null;
    },
    isNaN: function(_isNaN) {
        function isNaN1(_x) {
            return _isNaN.apply(this, arguments);
        }
        isNaN1.toString = function() {
            return _isNaN.toString();
        };
        return isNaN1;
    }(function(obj) {
        return isNaN(obj);
    }),
    isArray: Array.isArray || function(obj) {
        return obj.constructor === Array;
    },
    isObject: function isObject(obj) {
        return obj === Object(obj);
    },
    isNumber: function isNumber(obj) {
        return obj === obj + 0;
    },
    isString: function isString(obj) {
        return obj === obj + '';
    },
    isBoolean: function isBoolean(obj) {
        return obj === false || obj === true;
    },
    isFunction: function isFunction(obj) {
        return obj instanceof Function;
    }
};
var $a4c493de23d91c5d$var$INTERPRETATIONS = [
    {
        litmus: $a4c493de23d91c5d$var$Common.isString,
        conversions: {
            THREE_CHAR_HEX: {
                read: function read(original) {
                    var test = original.match(/^#([A-F0-9])([A-F0-9])([A-F0-9])$/i);
                    if (test === null) return false;
                    return {
                        space: 'HEX',
                        hex: parseInt('0x' + test[1].toString() + test[1].toString() + test[2].toString() + test[2].toString() + test[3].toString() + test[3].toString(), 0)
                    };
                },
                write: $a4c493de23d91c5d$var$colorToString
            },
            SIX_CHAR_HEX: {
                read: function read(original) {
                    var test = original.match(/^#([A-F0-9]{6})$/i);
                    if (test === null) return false;
                    return {
                        space: 'HEX',
                        hex: parseInt('0x' + test[1].toString(), 0)
                    };
                },
                write: $a4c493de23d91c5d$var$colorToString
            },
            CSS_RGB: {
                read: function read(original) {
                    var test = original.match(/^rgb\(\s*(\S+)\s*,\s*(\S+)\s*,\s*(\S+)\s*\)/);
                    if (test === null) return false;
                    return {
                        space: 'RGB',
                        r: parseFloat(test[1]),
                        g: parseFloat(test[2]),
                        b: parseFloat(test[3])
                    };
                },
                write: $a4c493de23d91c5d$var$colorToString
            },
            CSS_RGBA: {
                read: function read(original) {
                    var test = original.match(/^rgba\(\s*(\S+)\s*,\s*(\S+)\s*,\s*(\S+)\s*,\s*(\S+)\s*\)/);
                    if (test === null) return false;
                    return {
                        space: 'RGB',
                        r: parseFloat(test[1]),
                        g: parseFloat(test[2]),
                        b: parseFloat(test[3]),
                        a: parseFloat(test[4])
                    };
                },
                write: $a4c493de23d91c5d$var$colorToString
            }
        }
    },
    {
        litmus: $a4c493de23d91c5d$var$Common.isNumber,
        conversions: {
            HEX: {
                read: function read(original) {
                    return {
                        space: 'HEX',
                        hex: original,
                        conversionName: 'HEX'
                    };
                },
                write: function write(color) {
                    return color.hex;
                }
            }
        }
    },
    {
        litmus: $a4c493de23d91c5d$var$Common.isArray,
        conversions: {
            RGB_ARRAY: {
                read: function read(original) {
                    if (original.length !== 3) return false;
                    return {
                        space: 'RGB',
                        r: original[0],
                        g: original[1],
                        b: original[2]
                    };
                },
                write: function write(color) {
                    return [
                        color.r,
                        color.g,
                        color.b
                    ];
                }
            },
            RGBA_ARRAY: {
                read: function read(original) {
                    if (original.length !== 4) return false;
                    return {
                        space: 'RGB',
                        r: original[0],
                        g: original[1],
                        b: original[2],
                        a: original[3]
                    };
                },
                write: function write(color) {
                    return [
                        color.r,
                        color.g,
                        color.b,
                        color.a
                    ];
                }
            }
        }
    },
    {
        litmus: $a4c493de23d91c5d$var$Common.isObject,
        conversions: {
            RGBA_OBJ: {
                read: function read(original) {
                    if ($a4c493de23d91c5d$var$Common.isNumber(original.r) && $a4c493de23d91c5d$var$Common.isNumber(original.g) && $a4c493de23d91c5d$var$Common.isNumber(original.b) && $a4c493de23d91c5d$var$Common.isNumber(original.a)) return {
                        space: 'RGB',
                        r: original.r,
                        g: original.g,
                        b: original.b,
                        a: original.a
                    };
                    return false;
                },
                write: function write(color) {
                    return {
                        r: color.r,
                        g: color.g,
                        b: color.b,
                        a: color.a
                    };
                }
            },
            RGB_OBJ: {
                read: function read(original) {
                    if ($a4c493de23d91c5d$var$Common.isNumber(original.r) && $a4c493de23d91c5d$var$Common.isNumber(original.g) && $a4c493de23d91c5d$var$Common.isNumber(original.b)) return {
                        space: 'RGB',
                        r: original.r,
                        g: original.g,
                        b: original.b
                    };
                    return false;
                },
                write: function write(color) {
                    return {
                        r: color.r,
                        g: color.g,
                        b: color.b
                    };
                }
            },
            HSVA_OBJ: {
                read: function read(original) {
                    if ($a4c493de23d91c5d$var$Common.isNumber(original.h) && $a4c493de23d91c5d$var$Common.isNumber(original.s) && $a4c493de23d91c5d$var$Common.isNumber(original.v) && $a4c493de23d91c5d$var$Common.isNumber(original.a)) return {
                        space: 'HSV',
                        h: original.h,
                        s: original.s,
                        v: original.v,
                        a: original.a
                    };
                    return false;
                },
                write: function write(color) {
                    return {
                        h: color.h,
                        s: color.s,
                        v: color.v,
                        a: color.a
                    };
                }
            },
            HSV_OBJ: {
                read: function read(original) {
                    if ($a4c493de23d91c5d$var$Common.isNumber(original.h) && $a4c493de23d91c5d$var$Common.isNumber(original.s) && $a4c493de23d91c5d$var$Common.isNumber(original.v)) return {
                        space: 'HSV',
                        h: original.h,
                        s: original.s,
                        v: original.v
                    };
                    return false;
                },
                write: function write(color) {
                    return {
                        h: color.h,
                        s: color.s,
                        v: color.v
                    };
                }
            }
        }
    }
];
var $a4c493de23d91c5d$var$result = void 0;
var $a4c493de23d91c5d$var$toReturn = void 0;
var $a4c493de23d91c5d$var$interpret = function interpret() {
    $a4c493de23d91c5d$var$toReturn = false;
    var original = arguments.length > 1 ? $a4c493de23d91c5d$var$Common.toArray(arguments) : arguments[0];
    $a4c493de23d91c5d$var$Common.each($a4c493de23d91c5d$var$INTERPRETATIONS, function(family) {
        if (family.litmus(original)) {
            $a4c493de23d91c5d$var$Common.each(family.conversions, function(conversion, conversionName) {
                $a4c493de23d91c5d$var$result = conversion.read(original);
                if ($a4c493de23d91c5d$var$toReturn === false && $a4c493de23d91c5d$var$result !== false) {
                    $a4c493de23d91c5d$var$toReturn = $a4c493de23d91c5d$var$result;
                    $a4c493de23d91c5d$var$result.conversionName = conversionName;
                    $a4c493de23d91c5d$var$result.conversion = conversion;
                    return $a4c493de23d91c5d$var$Common.BREAK;
                }
            });
            return $a4c493de23d91c5d$var$Common.BREAK;
        }
    });
    return $a4c493de23d91c5d$var$toReturn;
};
var $a4c493de23d91c5d$var$tmpComponent = void 0;
var $a4c493de23d91c5d$var$ColorMath = {
    hsv_to_rgb: function hsv_to_rgb(h, s, v) {
        var hi = Math.floor(h / 60) % 6;
        var f = h / 60 - Math.floor(h / 60);
        var p = v * (1.0 - s);
        var q = v * (1.0 - f * s);
        var t = v * (1.0 - (1.0 - f) * s);
        var c = [
            [
                v,
                t,
                p
            ],
            [
                q,
                v,
                p
            ],
            [
                p,
                v,
                t
            ],
            [
                p,
                q,
                v
            ],
            [
                t,
                p,
                v
            ],
            [
                v,
                p,
                q
            ]
        ][hi];
        return {
            r: c[0] * 255,
            g: c[1] * 255,
            b: c[2] * 255
        };
    },
    rgb_to_hsv: function rgb_to_hsv(r, g, b) {
        var min = Math.min(r, g, b);
        var max = Math.max(r, g, b);
        var delta = max - min;
        var h = void 0;
        var s = void 0;
        if (max !== 0) s = delta / max;
        else return {
            h: NaN,
            s: 0,
            v: 0
        };
        if (r === max) h = (g - b) / delta;
        else if (g === max) h = 2 + (b - r) / delta;
        else h = 4 + (r - g) / delta;
        h /= 6;
        if (h < 0) h += 1;
        return {
            h: h * 360,
            s: s,
            v: max / 255
        };
    },
    rgb_to_hex: function rgb_to_hex(r, g, b) {
        var hex = this.hex_with_component(0, 2, r);
        hex = this.hex_with_component(hex, 1, g);
        hex = this.hex_with_component(hex, 0, b);
        return hex;
    },
    component_from_hex: function component_from_hex(hex, componentIndex) {
        return hex >> componentIndex * 8 & 0xFF;
    },
    hex_with_component: function hex_with_component(hex, componentIndex, value) {
        return value << ($a4c493de23d91c5d$var$tmpComponent = componentIndex * 8) | hex & ~(0xFF << $a4c493de23d91c5d$var$tmpComponent);
    }
};
var $a4c493de23d91c5d$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $a4c493de23d91c5d$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $a4c493de23d91c5d$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $a4c493de23d91c5d$var$get = function get(object, property, receiver) {
    if (object === null) object = Function.prototype;
    var desc = Object.getOwnPropertyDescriptor(object, property);
    if (desc === undefined) {
        var parent = Object.getPrototypeOf(object);
        if (parent === null) return undefined;
        else return get(parent, property, receiver);
    } else if ("value" in desc) return desc.value;
    else {
        var getter = desc.get;
        if (getter === undefined) return undefined;
        return getter.call(receiver);
    }
};
var $a4c493de23d91c5d$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $a4c493de23d91c5d$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var $a4c493de23d91c5d$var$Color = function() {
    function Color() {
        $a4c493de23d91c5d$var$classCallCheck(this, Color);
        this.__state = $a4c493de23d91c5d$var$interpret.apply(this, arguments);
        if (this.__state === false) throw new Error('Failed to interpret color arguments');
        this.__state.a = this.__state.a || 1;
    }
    $a4c493de23d91c5d$var$createClass(Color, [
        {
            key: 'toString',
            value: function toString() {
                return $a4c493de23d91c5d$var$colorToString(this);
            }
        },
        {
            key: 'toHexString',
            value: function toHexString() {
                return $a4c493de23d91c5d$var$colorToString(this, true);
            }
        },
        {
            key: 'toOriginal',
            value: function toOriginal() {
                return this.__state.conversion.write(this);
            }
        }
    ]);
    return Color;
}();
function $a4c493de23d91c5d$var$defineRGBComponent(target, component, componentHexIndex) {
    Object.defineProperty(target, component, {
        get: function get$$1() {
            if (this.__state.space === 'RGB') return this.__state[component];
            $a4c493de23d91c5d$var$Color.recalculateRGB(this, component, componentHexIndex);
            return this.__state[component];
        },
        set: function set$$1(v) {
            if (this.__state.space !== 'RGB') {
                $a4c493de23d91c5d$var$Color.recalculateRGB(this, component, componentHexIndex);
                this.__state.space = 'RGB';
            }
            this.__state[component] = v;
        }
    });
}
function $a4c493de23d91c5d$var$defineHSVComponent(target, component) {
    Object.defineProperty(target, component, {
        get: function get$$1() {
            if (this.__state.space === 'HSV') return this.__state[component];
            $a4c493de23d91c5d$var$Color.recalculateHSV(this);
            return this.__state[component];
        },
        set: function set$$1(v) {
            if (this.__state.space !== 'HSV') {
                $a4c493de23d91c5d$var$Color.recalculateHSV(this);
                this.__state.space = 'HSV';
            }
            this.__state[component] = v;
        }
    });
}
$a4c493de23d91c5d$var$Color.recalculateRGB = function(color, component, componentHexIndex) {
    if (color.__state.space === 'HEX') color.__state[component] = $a4c493de23d91c5d$var$ColorMath.component_from_hex(color.__state.hex, componentHexIndex);
    else if (color.__state.space === 'HSV') $a4c493de23d91c5d$var$Common.extend(color.__state, $a4c493de23d91c5d$var$ColorMath.hsv_to_rgb(color.__state.h, color.__state.s, color.__state.v));
    else throw new Error('Corrupted color state');
};
$a4c493de23d91c5d$var$Color.recalculateHSV = function(color) {
    var result = $a4c493de23d91c5d$var$ColorMath.rgb_to_hsv(color.r, color.g, color.b);
    $a4c493de23d91c5d$var$Common.extend(color.__state, {
        s: result.s,
        v: result.v
    });
    if (!$a4c493de23d91c5d$var$Common.isNaN(result.h)) color.__state.h = result.h;
    else if ($a4c493de23d91c5d$var$Common.isUndefined(color.__state.h)) color.__state.h = 0;
};
$a4c493de23d91c5d$var$Color.COMPONENTS = [
    'r',
    'g',
    'b',
    'h',
    's',
    'v',
    'hex',
    'a'
];
$a4c493de23d91c5d$var$defineRGBComponent($a4c493de23d91c5d$var$Color.prototype, 'r', 2);
$a4c493de23d91c5d$var$defineRGBComponent($a4c493de23d91c5d$var$Color.prototype, 'g', 1);
$a4c493de23d91c5d$var$defineRGBComponent($a4c493de23d91c5d$var$Color.prototype, 'b', 0);
$a4c493de23d91c5d$var$defineHSVComponent($a4c493de23d91c5d$var$Color.prototype, 'h');
$a4c493de23d91c5d$var$defineHSVComponent($a4c493de23d91c5d$var$Color.prototype, 's');
$a4c493de23d91c5d$var$defineHSVComponent($a4c493de23d91c5d$var$Color.prototype, 'v');
Object.defineProperty($a4c493de23d91c5d$var$Color.prototype, 'a', {
    get: function get$$1() {
        return this.__state.a;
    },
    set: function set$$1(v) {
        this.__state.a = v;
    }
});
Object.defineProperty($a4c493de23d91c5d$var$Color.prototype, 'hex', {
    get: function get$$1() {
        if (this.__state.space !== 'HEX') {
            this.__state.hex = $a4c493de23d91c5d$var$ColorMath.rgb_to_hex(this.r, this.g, this.b);
            this.__state.space = 'HEX';
        }
        return this.__state.hex;
    },
    set: function set$$1(v) {
        this.__state.space = 'HEX';
        this.__state.hex = v;
    }
});
var $a4c493de23d91c5d$var$Controller = function() {
    function Controller(object, property) {
        $a4c493de23d91c5d$var$classCallCheck(this, Controller);
        this.initialValue = object[property];
        this.domElement = document.createElement('div');
        this.object = object;
        this.property = property;
        this.__onChange = undefined;
        this.__onFinishChange = undefined;
    }
    $a4c493de23d91c5d$var$createClass(Controller, [
        {
            key: 'onChange',
            value: function onChange(fnc) {
                this.__onChange = fnc;
                return this;
            }
        },
        {
            key: 'onFinishChange',
            value: function onFinishChange(fnc) {
                this.__onFinishChange = fnc;
                return this;
            }
        },
        {
            key: 'setValue',
            value: function setValue(newValue) {
                this.object[this.property] = newValue;
                if (this.__onChange) this.__onChange.call(this, newValue);
                this.updateDisplay();
                return this;
            }
        },
        {
            key: 'getValue',
            value: function getValue() {
                return this.object[this.property];
            }
        },
        {
            key: 'updateDisplay',
            value: function updateDisplay() {
                return this;
            }
        },
        {
            key: 'isModified',
            value: function isModified() {
                return this.initialValue !== this.getValue();
            }
        }
    ]);
    return Controller;
}();
var $a4c493de23d91c5d$var$EVENT_MAP = {
    HTMLEvents: [
        'change'
    ],
    MouseEvents: [
        'click',
        'mousemove',
        'mousedown',
        'mouseup',
        'mouseover'
    ],
    KeyboardEvents: [
        'keydown'
    ]
};
var $a4c493de23d91c5d$var$EVENT_MAP_INV = {};
$a4c493de23d91c5d$var$Common.each($a4c493de23d91c5d$var$EVENT_MAP, function(v, k) {
    $a4c493de23d91c5d$var$Common.each(v, function(e) {
        $a4c493de23d91c5d$var$EVENT_MAP_INV[e] = k;
    });
});
var $a4c493de23d91c5d$var$CSS_VALUE_PIXELS = /(\d+(\.\d+)?)px/;
function $a4c493de23d91c5d$var$cssValueToPixels(val) {
    if (val === '0' || $a4c493de23d91c5d$var$Common.isUndefined(val)) return 0;
    var match = val.match($a4c493de23d91c5d$var$CSS_VALUE_PIXELS);
    if (!$a4c493de23d91c5d$var$Common.isNull(match)) return parseFloat(match[1]);
    return 0;
}
var $a4c493de23d91c5d$var$dom = {
    makeSelectable: function makeSelectable(elem, selectable) {
        if (elem === undefined || elem.style === undefined) return;
        elem.onselectstart = selectable ? function() {
            return false;
        } : function() {};
        elem.style.MozUserSelect = selectable ? 'auto' : 'none';
        elem.style.KhtmlUserSelect = selectable ? 'auto' : 'none';
        elem.unselectable = selectable ? 'on' : 'off';
    },
    makeFullscreen: function makeFullscreen(elem, hor, vert) {
        var vertical = vert;
        var horizontal = hor;
        if ($a4c493de23d91c5d$var$Common.isUndefined(horizontal)) horizontal = true;
        if ($a4c493de23d91c5d$var$Common.isUndefined(vertical)) vertical = true;
        elem.style.position = 'absolute';
        if (horizontal) {
            elem.style.left = 0;
            elem.style.right = 0;
        }
        if (vertical) {
            elem.style.top = 0;
            elem.style.bottom = 0;
        }
    },
    fakeEvent: function fakeEvent(elem, eventType, pars, aux) {
        var params = pars || {};
        var className = $a4c493de23d91c5d$var$EVENT_MAP_INV[eventType];
        if (!className) throw new Error('Event type ' + eventType + ' not supported.');
        var evt = document.createEvent(className);
        switch(className){
            case 'MouseEvents':
                var clientX = params.x || params.clientX || 0;
                var clientY = params.y || params.clientY || 0;
                evt.initMouseEvent(eventType, params.bubbles || false, params.cancelable || true, window, params.clickCount || 1, 0, 0, clientX, clientY, false, false, false, false, 0, null);
                break;
            case 'KeyboardEvents':
                var init = evt.initKeyboardEvent || evt.initKeyEvent;
                $a4c493de23d91c5d$var$Common.defaults(params, {
                    cancelable: true,
                    ctrlKey: false,
                    altKey: false,
                    shiftKey: false,
                    metaKey: false,
                    keyCode: undefined,
                    charCode: undefined
                });
                init(eventType, params.bubbles || false, params.cancelable, window, params.ctrlKey, params.altKey, params.shiftKey, params.metaKey, params.keyCode, params.charCode);
                break;
            default:
                evt.initEvent(eventType, params.bubbles || false, params.cancelable || true);
                break;
        }
        $a4c493de23d91c5d$var$Common.defaults(evt, aux);
        elem.dispatchEvent(evt);
    },
    bind: function bind(elem, event, func, newBool) {
        var bool = newBool || false;
        if (elem.addEventListener) elem.addEventListener(event, func, bool);
        else if (elem.attachEvent) elem.attachEvent('on' + event, func);
        return $a4c493de23d91c5d$var$dom;
    },
    unbind: function unbind(elem, event, func, newBool) {
        var bool = newBool || false;
        if (elem.removeEventListener) elem.removeEventListener(event, func, bool);
        else if (elem.detachEvent) elem.detachEvent('on' + event, func);
        return $a4c493de23d91c5d$var$dom;
    },
    addClass: function addClass(elem, className) {
        if (elem.className === undefined) elem.className = className;
        else if (elem.className !== className) {
            var classes = elem.className.split(/ +/);
            if (classes.indexOf(className) === -1) {
                classes.push(className);
                elem.className = classes.join(' ').replace(/^\s+/, '').replace(/\s+$/, '');
            }
        }
        return $a4c493de23d91c5d$var$dom;
    },
    removeClass: function removeClass(elem, className) {
        if (className) {
            if (elem.className === className) elem.removeAttribute('class');
            else {
                var classes = elem.className.split(/ +/);
                var index = classes.indexOf(className);
                if (index !== -1) {
                    classes.splice(index, 1);
                    elem.className = classes.join(' ');
                }
            }
        } else elem.className = undefined;
        return $a4c493de23d91c5d$var$dom;
    },
    hasClass: function hasClass(elem, className) {
        return new RegExp('(?:^|\\s+)' + className + '(?:\\s+|$)').test(elem.className) || false;
    },
    getWidth: function getWidth(elem) {
        var style = getComputedStyle(elem);
        return $a4c493de23d91c5d$var$cssValueToPixels(style['border-left-width']) + $a4c493de23d91c5d$var$cssValueToPixels(style['border-right-width']) + $a4c493de23d91c5d$var$cssValueToPixels(style['padding-left']) + $a4c493de23d91c5d$var$cssValueToPixels(style['padding-right']) + $a4c493de23d91c5d$var$cssValueToPixels(style.width);
    },
    getHeight: function getHeight(elem) {
        var style = getComputedStyle(elem);
        return $a4c493de23d91c5d$var$cssValueToPixels(style['border-top-width']) + $a4c493de23d91c5d$var$cssValueToPixels(style['border-bottom-width']) + $a4c493de23d91c5d$var$cssValueToPixels(style['padding-top']) + $a4c493de23d91c5d$var$cssValueToPixels(style['padding-bottom']) + $a4c493de23d91c5d$var$cssValueToPixels(style.height);
    },
    getOffset: function getOffset(el) {
        var elem = el;
        var offset = {
            left: 0,
            top: 0
        };
        if (elem.offsetParent) do {
            offset.left += elem.offsetLeft;
            offset.top += elem.offsetTop;
            elem = elem.offsetParent;
        }while (elem);
        return offset;
    },
    isActive: function isActive(elem) {
        return elem === document.activeElement && (elem.type || elem.href);
    }
};
var $a4c493de23d91c5d$var$BooleanController = function(_Controller) {
    $a4c493de23d91c5d$var$inherits(BooleanController, _Controller);
    function BooleanController(object, property) {
        $a4c493de23d91c5d$var$classCallCheck(this, BooleanController);
        var _this2 = $a4c493de23d91c5d$var$possibleConstructorReturn(this, (BooleanController.__proto__ || Object.getPrototypeOf(BooleanController)).call(this, object, property));
        var _this = _this2;
        _this2.__prev = _this2.getValue();
        _this2.__checkbox = document.createElement('input');
        _this2.__checkbox.setAttribute('type', 'checkbox');
        function onChange() {
            _this.setValue(!_this.__prev);
        }
        $a4c493de23d91c5d$var$dom.bind(_this2.__checkbox, 'change', onChange, false);
        _this2.domElement.appendChild(_this2.__checkbox);
        _this2.updateDisplay();
        return _this2;
    }
    $a4c493de23d91c5d$var$createClass(BooleanController, [
        {
            key: 'setValue',
            value: function setValue(v) {
                var toReturn = $a4c493de23d91c5d$var$get(BooleanController.prototype.__proto__ || Object.getPrototypeOf(BooleanController.prototype), 'setValue', this).call(this, v);
                if (this.__onFinishChange) this.__onFinishChange.call(this, this.getValue());
                this.__prev = this.getValue();
                return toReturn;
            }
        },
        {
            key: 'updateDisplay',
            value: function updateDisplay() {
                if (this.getValue() === true) {
                    this.__checkbox.setAttribute('checked', 'checked');
                    this.__checkbox.checked = true;
                    this.__prev = true;
                } else {
                    this.__checkbox.checked = false;
                    this.__prev = false;
                }
                return $a4c493de23d91c5d$var$get(BooleanController.prototype.__proto__ || Object.getPrototypeOf(BooleanController.prototype), 'updateDisplay', this).call(this);
            }
        }
    ]);
    return BooleanController;
}($a4c493de23d91c5d$var$Controller);
var $a4c493de23d91c5d$var$OptionController = function(_Controller) {
    $a4c493de23d91c5d$var$inherits(OptionController, _Controller);
    function OptionController(object, property, opts) {
        $a4c493de23d91c5d$var$classCallCheck(this, OptionController);
        var _this2 = $a4c493de23d91c5d$var$possibleConstructorReturn(this, (OptionController.__proto__ || Object.getPrototypeOf(OptionController)).call(this, object, property));
        var options = opts;
        var _this = _this2;
        _this2.__select = document.createElement('select');
        if ($a4c493de23d91c5d$var$Common.isArray(options)) {
            var map = {};
            $a4c493de23d91c5d$var$Common.each(options, function(element) {
                map[element] = element;
            });
            options = map;
        }
        $a4c493de23d91c5d$var$Common.each(options, function(value, key) {
            var opt = document.createElement('option');
            opt.innerHTML = key;
            opt.setAttribute('value', value);
            _this.__select.appendChild(opt);
        });
        _this2.updateDisplay();
        $a4c493de23d91c5d$var$dom.bind(_this2.__select, 'change', function() {
            var desiredValue = this.options[this.selectedIndex].value;
            _this.setValue(desiredValue);
        });
        _this2.domElement.appendChild(_this2.__select);
        return _this2;
    }
    $a4c493de23d91c5d$var$createClass(OptionController, [
        {
            key: 'setValue',
            value: function setValue(v) {
                var toReturn = $a4c493de23d91c5d$var$get(OptionController.prototype.__proto__ || Object.getPrototypeOf(OptionController.prototype), 'setValue', this).call(this, v);
                if (this.__onFinishChange) this.__onFinishChange.call(this, this.getValue());
                return toReturn;
            }
        },
        {
            key: 'updateDisplay',
            value: function updateDisplay() {
                if ($a4c493de23d91c5d$var$dom.isActive(this.__select)) return this;
                this.__select.value = this.getValue();
                return $a4c493de23d91c5d$var$get(OptionController.prototype.__proto__ || Object.getPrototypeOf(OptionController.prototype), 'updateDisplay', this).call(this);
            }
        }
    ]);
    return OptionController;
}($a4c493de23d91c5d$var$Controller);
var $a4c493de23d91c5d$var$StringController = function(_Controller) {
    $a4c493de23d91c5d$var$inherits(StringController, _Controller);
    function StringController(object, property) {
        $a4c493de23d91c5d$var$classCallCheck(this, StringController);
        var _this2 = $a4c493de23d91c5d$var$possibleConstructorReturn(this, (StringController.__proto__ || Object.getPrototypeOf(StringController)).call(this, object, property));
        var _this = _this2;
        function onChange() {
            _this.setValue(_this.__input.value);
        }
        function onBlur() {
            if (_this.__onFinishChange) _this.__onFinishChange.call(_this, _this.getValue());
        }
        _this2.__input = document.createElement('input');
        _this2.__input.setAttribute('type', 'text');
        $a4c493de23d91c5d$var$dom.bind(_this2.__input, 'keyup', onChange);
        $a4c493de23d91c5d$var$dom.bind(_this2.__input, 'change', onChange);
        $a4c493de23d91c5d$var$dom.bind(_this2.__input, 'blur', onBlur);
        $a4c493de23d91c5d$var$dom.bind(_this2.__input, 'keydown', function(e) {
            if (e.keyCode === 13) this.blur();
        });
        _this2.updateDisplay();
        _this2.domElement.appendChild(_this2.__input);
        return _this2;
    }
    $a4c493de23d91c5d$var$createClass(StringController, [
        {
            key: 'updateDisplay',
            value: function updateDisplay() {
                if (!$a4c493de23d91c5d$var$dom.isActive(this.__input)) this.__input.value = this.getValue();
                return $a4c493de23d91c5d$var$get(StringController.prototype.__proto__ || Object.getPrototypeOf(StringController.prototype), 'updateDisplay', this).call(this);
            }
        }
    ]);
    return StringController;
}($a4c493de23d91c5d$var$Controller);
function $a4c493de23d91c5d$var$numDecimals(x) {
    var _x = x.toString();
    if (_x.indexOf('.') > -1) return _x.length - _x.indexOf('.') - 1;
    return 0;
}
var $a4c493de23d91c5d$var$NumberController = function(_Controller) {
    $a4c493de23d91c5d$var$inherits(NumberController, _Controller);
    function NumberController(object, property, params) {
        $a4c493de23d91c5d$var$classCallCheck(this, NumberController);
        var _this = $a4c493de23d91c5d$var$possibleConstructorReturn(this, (NumberController.__proto__ || Object.getPrototypeOf(NumberController)).call(this, object, property));
        var _params = params || {};
        _this.__min = _params.min;
        _this.__max = _params.max;
        _this.__step = _params.step;
        if ($a4c493de23d91c5d$var$Common.isUndefined(_this.__step)) {
            if (_this.initialValue === 0) _this.__impliedStep = 1;
            else _this.__impliedStep = Math.pow(10, Math.floor(Math.log(Math.abs(_this.initialValue)) / Math.LN10)) / 10;
        } else _this.__impliedStep = _this.__step;
        _this.__precision = $a4c493de23d91c5d$var$numDecimals(_this.__impliedStep);
        return _this;
    }
    $a4c493de23d91c5d$var$createClass(NumberController, [
        {
            key: 'setValue',
            value: function setValue(v) {
                var _v = v;
                if (this.__min !== undefined && _v < this.__min) _v = this.__min;
                else if (this.__max !== undefined && _v > this.__max) _v = this.__max;
                if (this.__step !== undefined && _v % this.__step !== 0) _v = Math.round(_v / this.__step) * this.__step;
                return $a4c493de23d91c5d$var$get(NumberController.prototype.__proto__ || Object.getPrototypeOf(NumberController.prototype), 'setValue', this).call(this, _v);
            }
        },
        {
            key: 'min',
            value: function min(minValue) {
                this.__min = minValue;
                return this;
            }
        },
        {
            key: 'max',
            value: function max(maxValue) {
                this.__max = maxValue;
                return this;
            }
        },
        {
            key: 'step',
            value: function step(stepValue) {
                this.__step = stepValue;
                this.__impliedStep = stepValue;
                this.__precision = $a4c493de23d91c5d$var$numDecimals(stepValue);
                return this;
            }
        }
    ]);
    return NumberController;
}($a4c493de23d91c5d$var$Controller);
function $a4c493de23d91c5d$var$roundToDecimal(value, decimals) {
    var tenTo = Math.pow(10, decimals);
    return Math.round(value * tenTo) / tenTo;
}
var $a4c493de23d91c5d$var$NumberControllerBox = function(_NumberController) {
    $a4c493de23d91c5d$var$inherits(NumberControllerBox, _NumberController);
    function NumberControllerBox(object, property, params) {
        $a4c493de23d91c5d$var$classCallCheck(this, NumberControllerBox);
        var _this2 = $a4c493de23d91c5d$var$possibleConstructorReturn(this, (NumberControllerBox.__proto__ || Object.getPrototypeOf(NumberControllerBox)).call(this, object, property, params));
        _this2.__truncationSuspended = false;
        var _this = _this2;
        var prevY = void 0;
        function onChange() {
            var attempted = parseFloat(_this.__input.value);
            if (!$a4c493de23d91c5d$var$Common.isNaN(attempted)) _this.setValue(attempted);
        }
        function onFinish() {
            if (_this.__onFinishChange) _this.__onFinishChange.call(_this, _this.getValue());
        }
        function onBlur() {
            onFinish();
        }
        function onMouseDrag(e) {
            var diff = prevY - e.clientY;
            _this.setValue(_this.getValue() + diff * _this.__impliedStep);
            prevY = e.clientY;
        }
        function onMouseUp() {
            $a4c493de23d91c5d$var$dom.unbind(window, 'mousemove', onMouseDrag);
            $a4c493de23d91c5d$var$dom.unbind(window, 'mouseup', onMouseUp);
            onFinish();
        }
        function onMouseDown(e) {
            $a4c493de23d91c5d$var$dom.bind(window, 'mousemove', onMouseDrag);
            $a4c493de23d91c5d$var$dom.bind(window, 'mouseup', onMouseUp);
            prevY = e.clientY;
        }
        _this2.__input = document.createElement('input');
        _this2.__input.setAttribute('type', 'text');
        $a4c493de23d91c5d$var$dom.bind(_this2.__input, 'change', onChange);
        $a4c493de23d91c5d$var$dom.bind(_this2.__input, 'blur', onBlur);
        $a4c493de23d91c5d$var$dom.bind(_this2.__input, 'mousedown', onMouseDown);
        $a4c493de23d91c5d$var$dom.bind(_this2.__input, 'keydown', function(e) {
            if (e.keyCode === 13) {
                _this.__truncationSuspended = true;
                this.blur();
                _this.__truncationSuspended = false;
                onFinish();
            }
        });
        _this2.updateDisplay();
        _this2.domElement.appendChild(_this2.__input);
        return _this2;
    }
    $a4c493de23d91c5d$var$createClass(NumberControllerBox, [
        {
            key: 'updateDisplay',
            value: function updateDisplay() {
                this.__input.value = this.__truncationSuspended ? this.getValue() : $a4c493de23d91c5d$var$roundToDecimal(this.getValue(), this.__precision);
                return $a4c493de23d91c5d$var$get(NumberControllerBox.prototype.__proto__ || Object.getPrototypeOf(NumberControllerBox.prototype), 'updateDisplay', this).call(this);
            }
        }
    ]);
    return NumberControllerBox;
}($a4c493de23d91c5d$var$NumberController);
function $a4c493de23d91c5d$var$map(v, i1, i2, o1, o2) {
    return o1 + (o2 - o1) * ((v - i1) / (i2 - i1));
}
var $a4c493de23d91c5d$var$NumberControllerSlider = function(_NumberController) {
    $a4c493de23d91c5d$var$inherits(NumberControllerSlider, _NumberController);
    function NumberControllerSlider(object, property, min, max, step) {
        $a4c493de23d91c5d$var$classCallCheck(this, NumberControllerSlider);
        var _this2 = $a4c493de23d91c5d$var$possibleConstructorReturn(this, (NumberControllerSlider.__proto__ || Object.getPrototypeOf(NumberControllerSlider)).call(this, object, property, {
            min: min,
            max: max,
            step: step
        }));
        var _this = _this2;
        _this2.__background = document.createElement('div');
        _this2.__foreground = document.createElement('div');
        $a4c493de23d91c5d$var$dom.bind(_this2.__background, 'mousedown', onMouseDown);
        $a4c493de23d91c5d$var$dom.bind(_this2.__background, 'touchstart', onTouchStart);
        $a4c493de23d91c5d$var$dom.addClass(_this2.__background, 'slider');
        $a4c493de23d91c5d$var$dom.addClass(_this2.__foreground, 'slider-fg');
        function onMouseDown(e) {
            document.activeElement.blur();
            $a4c493de23d91c5d$var$dom.bind(window, 'mousemove', onMouseDrag);
            $a4c493de23d91c5d$var$dom.bind(window, 'mouseup', onMouseUp);
            onMouseDrag(e);
        }
        function onMouseDrag(e) {
            e.preventDefault();
            var bgRect = _this.__background.getBoundingClientRect();
            _this.setValue($a4c493de23d91c5d$var$map(e.clientX, bgRect.left, bgRect.right, _this.__min, _this.__max));
            return false;
        }
        function onMouseUp() {
            $a4c493de23d91c5d$var$dom.unbind(window, 'mousemove', onMouseDrag);
            $a4c493de23d91c5d$var$dom.unbind(window, 'mouseup', onMouseUp);
            if (_this.__onFinishChange) _this.__onFinishChange.call(_this, _this.getValue());
        }
        function onTouchStart(e) {
            if (e.touches.length !== 1) return;
            $a4c493de23d91c5d$var$dom.bind(window, 'touchmove', onTouchMove);
            $a4c493de23d91c5d$var$dom.bind(window, 'touchend', onTouchEnd);
            onTouchMove(e);
        }
        function onTouchMove(e) {
            var clientX = e.touches[0].clientX;
            var bgRect = _this.__background.getBoundingClientRect();
            _this.setValue($a4c493de23d91c5d$var$map(clientX, bgRect.left, bgRect.right, _this.__min, _this.__max));
        }
        function onTouchEnd() {
            $a4c493de23d91c5d$var$dom.unbind(window, 'touchmove', onTouchMove);
            $a4c493de23d91c5d$var$dom.unbind(window, 'touchend', onTouchEnd);
            if (_this.__onFinishChange) _this.__onFinishChange.call(_this, _this.getValue());
        }
        _this2.updateDisplay();
        _this2.__background.appendChild(_this2.__foreground);
        _this2.domElement.appendChild(_this2.__background);
        return _this2;
    }
    $a4c493de23d91c5d$var$createClass(NumberControllerSlider, [
        {
            key: 'updateDisplay',
            value: function updateDisplay() {
                var pct = (this.getValue() - this.__min) / (this.__max - this.__min);
                this.__foreground.style.width = pct * 100 + '%';
                return $a4c493de23d91c5d$var$get(NumberControllerSlider.prototype.__proto__ || Object.getPrototypeOf(NumberControllerSlider.prototype), 'updateDisplay', this).call(this);
            }
        }
    ]);
    return NumberControllerSlider;
}($a4c493de23d91c5d$var$NumberController);
var $a4c493de23d91c5d$var$FunctionController = function(_Controller) {
    $a4c493de23d91c5d$var$inherits(FunctionController, _Controller);
    function FunctionController(object, property, text) {
        $a4c493de23d91c5d$var$classCallCheck(this, FunctionController);
        var _this2 = $a4c493de23d91c5d$var$possibleConstructorReturn(this, (FunctionController.__proto__ || Object.getPrototypeOf(FunctionController)).call(this, object, property));
        var _this = _this2;
        _this2.__button = document.createElement('div');
        _this2.__button.innerHTML = text === undefined ? 'Fire' : text;
        $a4c493de23d91c5d$var$dom.bind(_this2.__button, 'click', function(e) {
            e.preventDefault();
            _this.fire();
            return false;
        });
        $a4c493de23d91c5d$var$dom.addClass(_this2.__button, 'button');
        _this2.domElement.appendChild(_this2.__button);
        return _this2;
    }
    $a4c493de23d91c5d$var$createClass(FunctionController, [
        {
            key: 'fire',
            value: function fire() {
                if (this.__onChange) this.__onChange.call(this);
                this.getValue().call(this.object);
                if (this.__onFinishChange) this.__onFinishChange.call(this, this.getValue());
            }
        }
    ]);
    return FunctionController;
}($a4c493de23d91c5d$var$Controller);
var $a4c493de23d91c5d$var$ColorController = function(_Controller) {
    $a4c493de23d91c5d$var$inherits(ColorController, _Controller);
    function ColorController(object, property) {
        $a4c493de23d91c5d$var$classCallCheck(this, ColorController);
        var _this2 = $a4c493de23d91c5d$var$possibleConstructorReturn(this, (ColorController.__proto__ || Object.getPrototypeOf(ColorController)).call(this, object, property));
        _this2.__color = new $a4c493de23d91c5d$var$Color(_this2.getValue());
        _this2.__temp = new $a4c493de23d91c5d$var$Color(0);
        var _this = _this2;
        _this2.domElement = document.createElement('div');
        $a4c493de23d91c5d$var$dom.makeSelectable(_this2.domElement, false);
        _this2.__selector = document.createElement('div');
        _this2.__selector.className = 'selector';
        _this2.__saturation_field = document.createElement('div');
        _this2.__saturation_field.className = 'saturation-field';
        _this2.__field_knob = document.createElement('div');
        _this2.__field_knob.className = 'field-knob';
        _this2.__field_knob_border = '2px solid ';
        _this2.__hue_knob = document.createElement('div');
        _this2.__hue_knob.className = 'hue-knob';
        _this2.__hue_field = document.createElement('div');
        _this2.__hue_field.className = 'hue-field';
        _this2.__input = document.createElement('input');
        _this2.__input.type = 'text';
        _this2.__input_textShadow = '0 1px 1px ';
        $a4c493de23d91c5d$var$dom.bind(_this2.__input, 'keydown', function(e) {
            if (e.keyCode === 13) onBlur.call(this);
        });
        $a4c493de23d91c5d$var$dom.bind(_this2.__input, 'blur', onBlur);
        $a4c493de23d91c5d$var$dom.bind(_this2.__selector, 'mousedown', function() {
            $a4c493de23d91c5d$var$dom.addClass(this, 'drag').bind(window, 'mouseup', function() {
                $a4c493de23d91c5d$var$dom.removeClass(_this.__selector, 'drag');
            });
        });
        $a4c493de23d91c5d$var$dom.bind(_this2.__selector, 'touchstart', function() {
            $a4c493de23d91c5d$var$dom.addClass(this, 'drag').bind(window, 'touchend', function() {
                $a4c493de23d91c5d$var$dom.removeClass(_this.__selector, 'drag');
            });
        });
        var valueField = document.createElement('div');
        $a4c493de23d91c5d$var$Common.extend(_this2.__selector.style, {
            width: '122px',
            height: '102px',
            padding: '3px',
            backgroundColor: '#222',
            boxShadow: '0px 1px 3px rgba(0,0,0,0.3)'
        });
        $a4c493de23d91c5d$var$Common.extend(_this2.__field_knob.style, {
            position: 'absolute',
            width: '12px',
            height: '12px',
            border: _this2.__field_knob_border + (_this2.__color.v < 0.5 ? '#fff' : '#000'),
            boxShadow: '0px 1px 3px rgba(0,0,0,0.5)',
            borderRadius: '12px',
            zIndex: 1
        });
        $a4c493de23d91c5d$var$Common.extend(_this2.__hue_knob.style, {
            position: 'absolute',
            width: '15px',
            height: '2px',
            borderRight: '4px solid #fff',
            zIndex: 1
        });
        $a4c493de23d91c5d$var$Common.extend(_this2.__saturation_field.style, {
            width: '100px',
            height: '100px',
            border: '1px solid #555',
            marginRight: '3px',
            display: 'inline-block',
            cursor: 'pointer'
        });
        $a4c493de23d91c5d$var$Common.extend(valueField.style, {
            width: '100%',
            height: '100%',
            background: 'none'
        });
        $a4c493de23d91c5d$var$linearGradient(valueField, 'top', 'rgba(0,0,0,0)', '#000');
        $a4c493de23d91c5d$var$Common.extend(_this2.__hue_field.style, {
            width: '15px',
            height: '100px',
            border: '1px solid #555',
            cursor: 'ns-resize',
            position: 'absolute',
            top: '3px',
            right: '3px'
        });
        $a4c493de23d91c5d$var$hueGradient(_this2.__hue_field);
        $a4c493de23d91c5d$var$Common.extend(_this2.__input.style, {
            outline: 'none',
            textAlign: 'center',
            color: '#fff',
            border: 0,
            fontWeight: 'bold',
            textShadow: _this2.__input_textShadow + 'rgba(0,0,0,0.7)'
        });
        $a4c493de23d91c5d$var$dom.bind(_this2.__saturation_field, 'mousedown', fieldDown);
        $a4c493de23d91c5d$var$dom.bind(_this2.__saturation_field, 'touchstart', fieldDown);
        $a4c493de23d91c5d$var$dom.bind(_this2.__field_knob, 'mousedown', fieldDown);
        $a4c493de23d91c5d$var$dom.bind(_this2.__field_knob, 'touchstart', fieldDown);
        $a4c493de23d91c5d$var$dom.bind(_this2.__hue_field, 'mousedown', fieldDownH);
        $a4c493de23d91c5d$var$dom.bind(_this2.__hue_field, 'touchstart', fieldDownH);
        function fieldDown(e) {
            setSV(e);
            $a4c493de23d91c5d$var$dom.bind(window, 'mousemove', setSV);
            $a4c493de23d91c5d$var$dom.bind(window, 'touchmove', setSV);
            $a4c493de23d91c5d$var$dom.bind(window, 'mouseup', fieldUpSV);
            $a4c493de23d91c5d$var$dom.bind(window, 'touchend', fieldUpSV);
        }
        function fieldDownH(e) {
            setH(e);
            $a4c493de23d91c5d$var$dom.bind(window, 'mousemove', setH);
            $a4c493de23d91c5d$var$dom.bind(window, 'touchmove', setH);
            $a4c493de23d91c5d$var$dom.bind(window, 'mouseup', fieldUpH);
            $a4c493de23d91c5d$var$dom.bind(window, 'touchend', fieldUpH);
        }
        function fieldUpSV() {
            $a4c493de23d91c5d$var$dom.unbind(window, 'mousemove', setSV);
            $a4c493de23d91c5d$var$dom.unbind(window, 'touchmove', setSV);
            $a4c493de23d91c5d$var$dom.unbind(window, 'mouseup', fieldUpSV);
            $a4c493de23d91c5d$var$dom.unbind(window, 'touchend', fieldUpSV);
            onFinish();
        }
        function fieldUpH() {
            $a4c493de23d91c5d$var$dom.unbind(window, 'mousemove', setH);
            $a4c493de23d91c5d$var$dom.unbind(window, 'touchmove', setH);
            $a4c493de23d91c5d$var$dom.unbind(window, 'mouseup', fieldUpH);
            $a4c493de23d91c5d$var$dom.unbind(window, 'touchend', fieldUpH);
            onFinish();
        }
        function onBlur() {
            var i = $a4c493de23d91c5d$var$interpret(this.value);
            if (i !== false) {
                _this.__color.__state = i;
                _this.setValue(_this.__color.toOriginal());
            } else this.value = _this.__color.toString();
        }
        function onFinish() {
            if (_this.__onFinishChange) _this.__onFinishChange.call(_this, _this.__color.toOriginal());
        }
        _this2.__saturation_field.appendChild(valueField);
        _this2.__selector.appendChild(_this2.__field_knob);
        _this2.__selector.appendChild(_this2.__saturation_field);
        _this2.__selector.appendChild(_this2.__hue_field);
        _this2.__hue_field.appendChild(_this2.__hue_knob);
        _this2.domElement.appendChild(_this2.__input);
        _this2.domElement.appendChild(_this2.__selector);
        _this2.updateDisplay();
        function setSV(e) {
            if (e.type.indexOf('touch') === -1) e.preventDefault();
            var fieldRect = _this.__saturation_field.getBoundingClientRect();
            var _ref = e.touches && e.touches[0] || e, clientX = _ref.clientX, clientY = _ref.clientY;
            var s = (clientX - fieldRect.left) / (fieldRect.right - fieldRect.left);
            var v = 1 - (clientY - fieldRect.top) / (fieldRect.bottom - fieldRect.top);
            if (v > 1) v = 1;
            else if (v < 0) v = 0;
            if (s > 1) s = 1;
            else if (s < 0) s = 0;
            _this.__color.v = v;
            _this.__color.s = s;
            _this.setValue(_this.__color.toOriginal());
            return false;
        }
        function setH(e) {
            if (e.type.indexOf('touch') === -1) e.preventDefault();
            var fieldRect = _this.__hue_field.getBoundingClientRect();
            var _ref2 = e.touches && e.touches[0] || e, clientY = _ref2.clientY;
            var h = 1 - (clientY - fieldRect.top) / (fieldRect.bottom - fieldRect.top);
            if (h > 1) h = 1;
            else if (h < 0) h = 0;
            _this.__color.h = h * 360;
            _this.setValue(_this.__color.toOriginal());
            return false;
        }
        return _this2;
    }
    $a4c493de23d91c5d$var$createClass(ColorController, [
        {
            key: 'updateDisplay',
            value: function updateDisplay() {
                var i = $a4c493de23d91c5d$var$interpret(this.getValue());
                if (i !== false) {
                    var mismatch = false;
                    $a4c493de23d91c5d$var$Common.each($a4c493de23d91c5d$var$Color.COMPONENTS, function(component) {
                        if (!$a4c493de23d91c5d$var$Common.isUndefined(i[component]) && !$a4c493de23d91c5d$var$Common.isUndefined(this.__color.__state[component]) && i[component] !== this.__color.__state[component]) {
                            mismatch = true;
                            return {};
                        }
                    }, this);
                    if (mismatch) $a4c493de23d91c5d$var$Common.extend(this.__color.__state, i);
                }
                $a4c493de23d91c5d$var$Common.extend(this.__temp.__state, this.__color.__state);
                this.__temp.a = 1;
                var flip = this.__color.v < 0.5 || this.__color.s > 0.5 ? 255 : 0;
                var _flip = 255 - flip;
                $a4c493de23d91c5d$var$Common.extend(this.__field_knob.style, {
                    marginLeft: 100 * this.__color.s - 7 + 'px',
                    marginTop: 100 * (1 - this.__color.v) - 7 + 'px',
                    backgroundColor: this.__temp.toHexString(),
                    border: this.__field_knob_border + 'rgb(' + flip + ',' + flip + ',' + flip + ')'
                });
                this.__hue_knob.style.marginTop = (1 - this.__color.h / 360) * 100 + 'px';
                this.__temp.s = 1;
                this.__temp.v = 1;
                $a4c493de23d91c5d$var$linearGradient(this.__saturation_field, 'left', '#fff', this.__temp.toHexString());
                this.__input.value = this.__color.toString();
                $a4c493de23d91c5d$var$Common.extend(this.__input.style, {
                    backgroundColor: this.__color.toHexString(),
                    color: 'rgb(' + flip + ',' + flip + ',' + flip + ')',
                    textShadow: this.__input_textShadow + 'rgba(' + _flip + ',' + _flip + ',' + _flip + ',.7)'
                });
            }
        }
    ]);
    return ColorController;
}($a4c493de23d91c5d$var$Controller);
var $a4c493de23d91c5d$var$vendors = [
    '-moz-',
    '-o-',
    '-webkit-',
    '-ms-',
    ''
];
function $a4c493de23d91c5d$var$linearGradient(elem, x, a, b) {
    elem.style.background = '';
    $a4c493de23d91c5d$var$Common.each($a4c493de23d91c5d$var$vendors, function(vendor) {
        elem.style.cssText += 'background: ' + vendor + 'linear-gradient(' + x + ', ' + a + ' 0%, ' + b + ' 100%); ';
    });
}
function $a4c493de23d91c5d$var$hueGradient(elem) {
    elem.style.background = '';
    elem.style.cssText += 'background: -moz-linear-gradient(top,  #ff0000 0%, #ff00ff 17%, #0000ff 34%, #00ffff 50%, #00ff00 67%, #ffff00 84%, #ff0000 100%);';
    elem.style.cssText += 'background: -webkit-linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);';
    elem.style.cssText += 'background: -o-linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);';
    elem.style.cssText += 'background: -ms-linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);';
    elem.style.cssText += 'background: linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);';
}
var $a4c493de23d91c5d$var$css = {
    load: function load(url, indoc) {
        var doc = indoc || document;
        var link = doc.createElement('link');
        link.type = 'text/css';
        link.rel = 'stylesheet';
        link.href = url;
        doc.getElementsByTagName('head')[0].appendChild(link);
    },
    inject: function inject(cssContent, indoc) {
        var doc = indoc || document;
        var injected = document.createElement('style');
        injected.type = 'text/css';
        injected.innerHTML = cssContent;
        var head = doc.getElementsByTagName('head')[0];
        try {
            head.appendChild(injected);
        } catch (e) {}
    }
};
var $a4c493de23d91c5d$var$saveDialogContents = "<div id=\"dg-save\" class=\"dg dialogue\">\n\n  Here's the new load parameter for your <code>GUI</code>'s constructor:\n\n  <textarea id=\"dg-new-constructor\"></textarea>\n\n  <div id=\"dg-save-locally\">\n\n    <input id=\"dg-local-storage\" type=\"checkbox\"/> Automatically save\n    values to <code>localStorage</code> on exit.\n\n    <div id=\"dg-local-explain\">The values saved to <code>localStorage</code> will\n      override those passed to <code>dat.GUI</code>'s constructor. This makes it\n      easier to work incrementally, but <code>localStorage</code> is fragile,\n      and your friends may not see the same values you do.\n\n    </div>\n\n  </div>\n\n</div>";
var $a4c493de23d91c5d$var$ControllerFactory = function ControllerFactory(object, property) {
    var initialValue = object[property];
    if ($a4c493de23d91c5d$var$Common.isArray(arguments[2]) || $a4c493de23d91c5d$var$Common.isObject(arguments[2])) return new $a4c493de23d91c5d$var$OptionController(object, property, arguments[2]);
    if ($a4c493de23d91c5d$var$Common.isNumber(initialValue)) {
        if ($a4c493de23d91c5d$var$Common.isNumber(arguments[2]) && $a4c493de23d91c5d$var$Common.isNumber(arguments[3])) {
            if ($a4c493de23d91c5d$var$Common.isNumber(arguments[4])) return new $a4c493de23d91c5d$var$NumberControllerSlider(object, property, arguments[2], arguments[3], arguments[4]);
            return new $a4c493de23d91c5d$var$NumberControllerSlider(object, property, arguments[2], arguments[3]);
        }
        if ($a4c493de23d91c5d$var$Common.isNumber(arguments[4])) return new $a4c493de23d91c5d$var$NumberControllerBox(object, property, {
            min: arguments[2],
            max: arguments[3],
            step: arguments[4]
        });
        return new $a4c493de23d91c5d$var$NumberControllerBox(object, property, {
            min: arguments[2],
            max: arguments[3]
        });
    }
    if ($a4c493de23d91c5d$var$Common.isString(initialValue)) return new $a4c493de23d91c5d$var$StringController(object, property);
    if ($a4c493de23d91c5d$var$Common.isFunction(initialValue)) return new $a4c493de23d91c5d$var$FunctionController(object, property, '');
    if ($a4c493de23d91c5d$var$Common.isBoolean(initialValue)) return new $a4c493de23d91c5d$var$BooleanController(object, property);
    return null;
};
function $a4c493de23d91c5d$var$requestAnimationFrame(callback) {
    setTimeout(callback, 1000 / 60);
}
var $a4c493de23d91c5d$var$requestAnimationFrame$1 = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || $a4c493de23d91c5d$var$requestAnimationFrame;
var $a4c493de23d91c5d$var$CenteredDiv = function() {
    function CenteredDiv() {
        $a4c493de23d91c5d$var$classCallCheck(this, CenteredDiv);
        this.backgroundElement = document.createElement('div');
        $a4c493de23d91c5d$var$Common.extend(this.backgroundElement.style, {
            backgroundColor: 'rgba(0,0,0,0.8)',
            top: 0,
            left: 0,
            display: 'none',
            zIndex: '1000',
            opacity: 0,
            WebkitTransition: 'opacity 0.2s linear',
            transition: 'opacity 0.2s linear'
        });
        $a4c493de23d91c5d$var$dom.makeFullscreen(this.backgroundElement);
        this.backgroundElement.style.position = 'fixed';
        this.domElement = document.createElement('div');
        $a4c493de23d91c5d$var$Common.extend(this.domElement.style, {
            position: 'fixed',
            display: 'none',
            zIndex: '1001',
            opacity: 0,
            WebkitTransition: '-webkit-transform 0.2s ease-out, opacity 0.2s linear',
            transition: 'transform 0.2s ease-out, opacity 0.2s linear'
        });
        document.body.appendChild(this.backgroundElement);
        document.body.appendChild(this.domElement);
        var _this = this;
        $a4c493de23d91c5d$var$dom.bind(this.backgroundElement, 'click', function() {
            _this.hide();
        });
    }
    $a4c493de23d91c5d$var$createClass(CenteredDiv, [
        {
            key: 'show',
            value: function show() {
                var _this = this;
                this.backgroundElement.style.display = 'block';
                this.domElement.style.display = 'block';
                this.domElement.style.opacity = 0;
                this.domElement.style.webkitTransform = 'scale(1.1)';
                this.layout();
                $a4c493de23d91c5d$var$Common.defer(function() {
                    _this.backgroundElement.style.opacity = 1;
                    _this.domElement.style.opacity = 1;
                    _this.domElement.style.webkitTransform = 'scale(1)';
                });
            }
        },
        {
            key: 'hide',
            value: function hide() {
                var _this = this;
                var hide = function hide() {
                    _this.domElement.style.display = 'none';
                    _this.backgroundElement.style.display = 'none';
                    $a4c493de23d91c5d$var$dom.unbind(_this.domElement, 'webkitTransitionEnd', hide);
                    $a4c493de23d91c5d$var$dom.unbind(_this.domElement, 'transitionend', hide);
                    $a4c493de23d91c5d$var$dom.unbind(_this.domElement, 'oTransitionEnd', hide);
                };
                $a4c493de23d91c5d$var$dom.bind(this.domElement, 'webkitTransitionEnd', hide);
                $a4c493de23d91c5d$var$dom.bind(this.domElement, 'transitionend', hide);
                $a4c493de23d91c5d$var$dom.bind(this.domElement, 'oTransitionEnd', hide);
                this.backgroundElement.style.opacity = 0;
                this.domElement.style.opacity = 0;
                this.domElement.style.webkitTransform = 'scale(1.1)';
            }
        },
        {
            key: 'layout',
            value: function layout() {
                this.domElement.style.left = window.innerWidth / 2 - $a4c493de23d91c5d$var$dom.getWidth(this.domElement) / 2 + 'px';
                this.domElement.style.top = window.innerHeight / 2 - $a4c493de23d91c5d$var$dom.getHeight(this.domElement) / 2 + 'px';
            }
        }
    ]);
    return CenteredDiv;
}();
var $a4c493de23d91c5d$var$styleSheet = $a4c493de23d91c5d$var$___$insertStyle(".dg ul{list-style:none;margin:0;padding:0;width:100%;clear:both}.dg.ac{position:fixed;top:0;left:0;right:0;height:0;z-index:0}.dg:not(.ac) .main{overflow:hidden}.dg.main{-webkit-transition:opacity .1s linear;-o-transition:opacity .1s linear;-moz-transition:opacity .1s linear;transition:opacity .1s linear}.dg.main.taller-than-window{overflow-y:auto}.dg.main.taller-than-window .close-button{opacity:1;margin-top:-1px;border-top:1px solid #2c2c2c}.dg.main ul.closed .close-button{opacity:1 !important}.dg.main:hover .close-button,.dg.main .close-button.drag{opacity:1}.dg.main .close-button{-webkit-transition:opacity .1s linear;-o-transition:opacity .1s linear;-moz-transition:opacity .1s linear;transition:opacity .1s linear;border:0;line-height:19px;height:20px;cursor:pointer;text-align:center;background-color:#000}.dg.main .close-button.close-top{position:relative}.dg.main .close-button.close-bottom{position:absolute}.dg.main .close-button:hover{background-color:#111}.dg.a{float:right;margin-right:15px;overflow-y:visible}.dg.a.has-save>ul.close-top{margin-top:0}.dg.a.has-save>ul.close-bottom{margin-top:27px}.dg.a.has-save>ul.closed{margin-top:0}.dg.a .save-row{top:0;z-index:1002}.dg.a .save-row.close-top{position:relative}.dg.a .save-row.close-bottom{position:fixed}.dg li{-webkit-transition:height .1s ease-out;-o-transition:height .1s ease-out;-moz-transition:height .1s ease-out;transition:height .1s ease-out;-webkit-transition:overflow .1s linear;-o-transition:overflow .1s linear;-moz-transition:overflow .1s linear;transition:overflow .1s linear}.dg li:not(.folder){cursor:auto;height:27px;line-height:27px;padding:0 4px 0 5px}.dg li.folder{padding:0;border-left:4px solid rgba(0,0,0,0)}.dg li.title{cursor:pointer;margin-left:-4px}.dg .closed li:not(.title),.dg .closed ul li,.dg .closed ul li>*{height:0;overflow:hidden;border:0}.dg .cr{clear:both;padding-left:3px;height:27px;overflow:hidden}.dg .property-name{cursor:default;float:left;clear:left;width:40%;overflow:hidden;text-overflow:ellipsis}.dg .cr.function .property-name{width:100%}.dg .c{float:left;width:60%;position:relative}.dg .c input[type=text]{border:0;margin-top:4px;padding:3px;width:100%;float:right}.dg .has-slider input[type=text]{width:30%;margin-left:0}.dg .slider{float:left;width:66%;margin-left:-5px;margin-right:0;height:19px;margin-top:4px}.dg .slider-fg{height:100%}.dg .c input[type=checkbox]{margin-top:7px}.dg .c select{margin-top:5px}.dg .cr.function,.dg .cr.function .property-name,.dg .cr.function *,.dg .cr.boolean,.dg .cr.boolean *{cursor:pointer}.dg .cr.color{overflow:visible}.dg .selector{display:none;position:absolute;margin-left:-9px;margin-top:23px;z-index:10}.dg .c:hover .selector,.dg .selector.drag{display:block}.dg li.save-row{padding:0}.dg li.save-row .button{display:inline-block;padding:0px 6px}.dg.dialogue{background-color:#222;width:460px;padding:15px;font-size:13px;line-height:15px}#dg-new-constructor{padding:10px;color:#222;font-family:Monaco, monospace;font-size:10px;border:0;resize:none;box-shadow:inset 1px 1px 1px #888;word-wrap:break-word;margin:12px 0;display:block;width:440px;overflow-y:scroll;height:100px;position:relative}#dg-local-explain{display:none;font-size:11px;line-height:17px;border-radius:3px;background-color:#333;padding:8px;margin-top:10px}#dg-local-explain code{font-size:10px}#dat-gui-save-locally{display:none}.dg{color:#eee;font:11px 'Lucida Grande', sans-serif;text-shadow:0 -1px 0 #111}.dg.main::-webkit-scrollbar{width:5px;background:#1a1a1a}.dg.main::-webkit-scrollbar-corner{height:0;display:none}.dg.main::-webkit-scrollbar-thumb{border-radius:5px;background:#676767}.dg li:not(.folder){background:#1a1a1a;border-bottom:1px solid #2c2c2c}.dg li.save-row{line-height:25px;background:#dad5cb;border:0}.dg li.save-row select{margin-left:5px;width:108px}.dg li.save-row .button{margin-left:5px;margin-top:1px;border-radius:2px;font-size:9px;line-height:7px;padding:4px 4px 5px 4px;background:#c5bdad;color:#fff;text-shadow:0 1px 0 #b0a58f;box-shadow:0 -1px 0 #b0a58f;cursor:pointer}.dg li.save-row .button.gears{background:#c5bdad url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAANCAYAAAB/9ZQ7AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAQJJREFUeNpiYKAU/P//PwGIC/ApCABiBSAW+I8AClAcgKxQ4T9hoMAEUrxx2QSGN6+egDX+/vWT4e7N82AMYoPAx/evwWoYoSYbACX2s7KxCxzcsezDh3evFoDEBYTEEqycggWAzA9AuUSQQgeYPa9fPv6/YWm/Acx5IPb7ty/fw+QZblw67vDs8R0YHyQhgObx+yAJkBqmG5dPPDh1aPOGR/eugW0G4vlIoTIfyFcA+QekhhHJhPdQxbiAIguMBTQZrPD7108M6roWYDFQiIAAv6Aow/1bFwXgis+f2LUAynwoIaNcz8XNx3Dl7MEJUDGQpx9gtQ8YCueB+D26OECAAQDadt7e46D42QAAAABJRU5ErkJggg==) 2px 1px no-repeat;height:7px;width:8px}.dg li.save-row .button:hover{background-color:#bab19e;box-shadow:0 -1px 0 #b0a58f}.dg li.folder{border-bottom:0}.dg li.title{padding-left:16px;background:#000 url(data:image/gif;base64,R0lGODlhBQAFAJEAAP////Pz8////////yH5BAEAAAIALAAAAAAFAAUAAAIIlI+hKgFxoCgAOw==) 6px 10px no-repeat;cursor:pointer;border-bottom:1px solid rgba(255,255,255,0.2)}.dg .closed li.title{background-image:url(data:image/gif;base64,R0lGODlhBQAFAJEAAP////Pz8////////yH5BAEAAAIALAAAAAAFAAUAAAIIlGIWqMCbWAEAOw==)}.dg .cr.boolean{border-left:3px solid #806787}.dg .cr.color{border-left:3px solid}.dg .cr.function{border-left:3px solid #e61d5f}.dg .cr.number{border-left:3px solid #2FA1D6}.dg .cr.number input[type=text]{color:#2FA1D6}.dg .cr.string{border-left:3px solid #1ed36f}.dg .cr.string input[type=text]{color:#1ed36f}.dg .cr.function:hover,.dg .cr.boolean:hover{background:#111}.dg .c input[type=text]{background:#303030;outline:none}.dg .c input[type=text]:hover{background:#3c3c3c}.dg .c input[type=text]:focus{background:#494949;color:#fff}.dg .c .slider{background:#303030;cursor:ew-resize}.dg .c .slider-fg{background:#2FA1D6;max-width:100%}.dg .c .slider:hover{background:#3c3c3c}.dg .c .slider:hover .slider-fg{background:#44abda}\n");
$a4c493de23d91c5d$var$css.inject($a4c493de23d91c5d$var$styleSheet);
var $a4c493de23d91c5d$var$CSS_NAMESPACE = 'dg';
var $a4c493de23d91c5d$var$HIDE_KEY_CODE = 72;
var $a4c493de23d91c5d$var$CLOSE_BUTTON_HEIGHT = 20;
var $a4c493de23d91c5d$var$DEFAULT_DEFAULT_PRESET_NAME = 'Default';
var $a4c493de23d91c5d$var$SUPPORTS_LOCAL_STORAGE = function() {
    try {
        return !!window.localStorage;
    } catch (e) {
        return false;
    }
}();
var $a4c493de23d91c5d$var$SAVE_DIALOGUE = void 0;
var $a4c493de23d91c5d$var$autoPlaceVirgin = true;
var $a4c493de23d91c5d$var$autoPlaceContainer = void 0;
var $a4c493de23d91c5d$var$hide = false;
var $a4c493de23d91c5d$var$hideableGuis = [];
var $a4c493de23d91c5d$var$GUI = function GUI(pars) {
    var _this = this;
    var params = pars || {};
    this.domElement = document.createElement('div');
    this.__ul = document.createElement('ul');
    this.domElement.appendChild(this.__ul);
    $a4c493de23d91c5d$var$dom.addClass(this.domElement, $a4c493de23d91c5d$var$CSS_NAMESPACE);
    this.__folders = {};
    this.__controllers = [];
    this.__rememberedObjects = [];
    this.__rememberedObjectIndecesToControllers = [];
    this.__listening = [];
    params = $a4c493de23d91c5d$var$Common.defaults(params, {
        closeOnTop: false,
        autoPlace: true,
        width: GUI.DEFAULT_WIDTH
    });
    params = $a4c493de23d91c5d$var$Common.defaults(params, {
        resizable: params.autoPlace,
        hideable: params.autoPlace
    });
    if (!$a4c493de23d91c5d$var$Common.isUndefined(params.load)) {
        if (params.preset) params.load.preset = params.preset;
    } else params.load = {
        preset: $a4c493de23d91c5d$var$DEFAULT_DEFAULT_PRESET_NAME
    };
    if ($a4c493de23d91c5d$var$Common.isUndefined(params.parent) && params.hideable) $a4c493de23d91c5d$var$hideableGuis.push(this);
    params.resizable = $a4c493de23d91c5d$var$Common.isUndefined(params.parent) && params.resizable;
    if (params.autoPlace && $a4c493de23d91c5d$var$Common.isUndefined(params.scrollable)) params.scrollable = true;
    var useLocalStorage = $a4c493de23d91c5d$var$SUPPORTS_LOCAL_STORAGE && localStorage.getItem($a4c493de23d91c5d$var$getLocalStorageHash(this, 'isLocal')) === 'true';
    var saveToLocalStorage = void 0;
    var titleRow = void 0;
    Object.defineProperties(this, {
        parent: {
            get: function get$$1() {
                return params.parent;
            }
        },
        scrollable: {
            get: function get$$1() {
                return params.scrollable;
            }
        },
        autoPlace: {
            get: function get$$1() {
                return params.autoPlace;
            }
        },
        closeOnTop: {
            get: function get$$1() {
                return params.closeOnTop;
            }
        },
        preset: {
            get: function get$$1() {
                if (_this.parent) return _this.getRoot().preset;
                return params.load.preset;
            },
            set: function set$$1(v) {
                if (_this.parent) _this.getRoot().preset = v;
                else params.load.preset = v;
                $a4c493de23d91c5d$var$setPresetSelectIndex(this);
                _this.revert();
            }
        },
        width: {
            get: function get$$1() {
                return params.width;
            },
            set: function set$$1(v) {
                params.width = v;
                $a4c493de23d91c5d$var$setWidth(_this, v);
            }
        },
        name: {
            get: function get$$1() {
                return params.name;
            },
            set: function set$$1(v) {
                params.name = v;
                if (titleRow) titleRow.innerHTML = params.name;
            }
        },
        closed: {
            get: function get$$1() {
                return params.closed;
            },
            set: function set$$1(v) {
                params.closed = v;
                if (params.closed) $a4c493de23d91c5d$var$dom.addClass(_this.__ul, GUI.CLASS_CLOSED);
                else $a4c493de23d91c5d$var$dom.removeClass(_this.__ul, GUI.CLASS_CLOSED);
                this.onResize();
                if (_this.__closeButton) _this.__closeButton.innerHTML = v ? GUI.TEXT_OPEN : GUI.TEXT_CLOSED;
            }
        },
        load: {
            get: function get$$1() {
                return params.load;
            }
        },
        useLocalStorage: {
            get: function get$$1() {
                return useLocalStorage;
            },
            set: function set$$1(bool) {
                if ($a4c493de23d91c5d$var$SUPPORTS_LOCAL_STORAGE) {
                    useLocalStorage = bool;
                    if (bool) $a4c493de23d91c5d$var$dom.bind(window, 'unload', saveToLocalStorage);
                    else $a4c493de23d91c5d$var$dom.unbind(window, 'unload', saveToLocalStorage);
                    localStorage.setItem($a4c493de23d91c5d$var$getLocalStorageHash(_this, 'isLocal'), bool);
                }
            }
        }
    });
    if ($a4c493de23d91c5d$var$Common.isUndefined(params.parent)) {
        this.closed = params.closed || false;
        $a4c493de23d91c5d$var$dom.addClass(this.domElement, GUI.CLASS_MAIN);
        $a4c493de23d91c5d$var$dom.makeSelectable(this.domElement, false);
        if ($a4c493de23d91c5d$var$SUPPORTS_LOCAL_STORAGE) {
            if (useLocalStorage) {
                _this.useLocalStorage = true;
                var savedGui = localStorage.getItem($a4c493de23d91c5d$var$getLocalStorageHash(this, 'gui'));
                if (savedGui) params.load = JSON.parse(savedGui);
            }
        }
        this.__closeButton = document.createElement('div');
        this.__closeButton.innerHTML = GUI.TEXT_CLOSED;
        $a4c493de23d91c5d$var$dom.addClass(this.__closeButton, GUI.CLASS_CLOSE_BUTTON);
        if (params.closeOnTop) {
            $a4c493de23d91c5d$var$dom.addClass(this.__closeButton, GUI.CLASS_CLOSE_TOP);
            this.domElement.insertBefore(this.__closeButton, this.domElement.childNodes[0]);
        } else {
            $a4c493de23d91c5d$var$dom.addClass(this.__closeButton, GUI.CLASS_CLOSE_BOTTOM);
            this.domElement.appendChild(this.__closeButton);
        }
        $a4c493de23d91c5d$var$dom.bind(this.__closeButton, 'click', function() {
            _this.closed = !_this.closed;
        });
    } else {
        if (params.closed === undefined) params.closed = true;
        var titleRowName = document.createTextNode(params.name);
        $a4c493de23d91c5d$var$dom.addClass(titleRowName, 'controller-name');
        titleRow = $a4c493de23d91c5d$var$addRow(_this, titleRowName);
        var onClickTitle = function onClickTitle(e) {
            e.preventDefault();
            _this.closed = !_this.closed;
            return false;
        };
        $a4c493de23d91c5d$var$dom.addClass(this.__ul, GUI.CLASS_CLOSED);
        $a4c493de23d91c5d$var$dom.addClass(titleRow, 'title');
        $a4c493de23d91c5d$var$dom.bind(titleRow, 'click', onClickTitle);
        if (!params.closed) this.closed = false;
    }
    if (params.autoPlace) {
        if ($a4c493de23d91c5d$var$Common.isUndefined(params.parent)) {
            if ($a4c493de23d91c5d$var$autoPlaceVirgin) {
                $a4c493de23d91c5d$var$autoPlaceContainer = document.createElement('div');
                $a4c493de23d91c5d$var$dom.addClass($a4c493de23d91c5d$var$autoPlaceContainer, $a4c493de23d91c5d$var$CSS_NAMESPACE);
                $a4c493de23d91c5d$var$dom.addClass($a4c493de23d91c5d$var$autoPlaceContainer, GUI.CLASS_AUTO_PLACE_CONTAINER);
                document.body.appendChild($a4c493de23d91c5d$var$autoPlaceContainer);
                $a4c493de23d91c5d$var$autoPlaceVirgin = false;
            }
            $a4c493de23d91c5d$var$autoPlaceContainer.appendChild(this.domElement);
            $a4c493de23d91c5d$var$dom.addClass(this.domElement, GUI.CLASS_AUTO_PLACE);
        }
        if (!this.parent) $a4c493de23d91c5d$var$setWidth(_this, params.width);
    }
    this.__resizeHandler = function() {
        _this.onResizeDebounced();
    };
    $a4c493de23d91c5d$var$dom.bind(window, 'resize', this.__resizeHandler);
    $a4c493de23d91c5d$var$dom.bind(this.__ul, 'webkitTransitionEnd', this.__resizeHandler);
    $a4c493de23d91c5d$var$dom.bind(this.__ul, 'transitionend', this.__resizeHandler);
    $a4c493de23d91c5d$var$dom.bind(this.__ul, 'oTransitionEnd', this.__resizeHandler);
    this.onResize();
    if (params.resizable) $a4c493de23d91c5d$var$addResizeHandle(this);
    saveToLocalStorage = function saveToLocalStorage() {
        if ($a4c493de23d91c5d$var$SUPPORTS_LOCAL_STORAGE && localStorage.getItem($a4c493de23d91c5d$var$getLocalStorageHash(_this, 'isLocal')) === 'true') localStorage.setItem($a4c493de23d91c5d$var$getLocalStorageHash(_this, 'gui'), JSON.stringify(_this.getSaveObject()));
    };
    this.saveToLocalStorageIfPossible = saveToLocalStorage;
    function resetWidth() {
        var root = _this.getRoot();
        root.width += 1;
        $a4c493de23d91c5d$var$Common.defer(function() {
            root.width -= 1;
        });
    }
    if (!params.parent) resetWidth();
};
$a4c493de23d91c5d$var$GUI.toggleHide = function() {
    $a4c493de23d91c5d$var$hide = !$a4c493de23d91c5d$var$hide;
    $a4c493de23d91c5d$var$Common.each($a4c493de23d91c5d$var$hideableGuis, function(gui) {
        gui.domElement.style.display = $a4c493de23d91c5d$var$hide ? 'none' : '';
    });
};
$a4c493de23d91c5d$var$GUI.CLASS_AUTO_PLACE = 'a';
$a4c493de23d91c5d$var$GUI.CLASS_AUTO_PLACE_CONTAINER = 'ac';
$a4c493de23d91c5d$var$GUI.CLASS_MAIN = 'main';
$a4c493de23d91c5d$var$GUI.CLASS_CONTROLLER_ROW = 'cr';
$a4c493de23d91c5d$var$GUI.CLASS_TOO_TALL = 'taller-than-window';
$a4c493de23d91c5d$var$GUI.CLASS_CLOSED = 'closed';
$a4c493de23d91c5d$var$GUI.CLASS_CLOSE_BUTTON = 'close-button';
$a4c493de23d91c5d$var$GUI.CLASS_CLOSE_TOP = 'close-top';
$a4c493de23d91c5d$var$GUI.CLASS_CLOSE_BOTTOM = 'close-bottom';
$a4c493de23d91c5d$var$GUI.CLASS_DRAG = 'drag';
$a4c493de23d91c5d$var$GUI.DEFAULT_WIDTH = 245;
$a4c493de23d91c5d$var$GUI.TEXT_CLOSED = 'Close Controls';
$a4c493de23d91c5d$var$GUI.TEXT_OPEN = 'Open Controls';
$a4c493de23d91c5d$var$GUI._keydownHandler = function(e) {
    if (document.activeElement.type !== 'text' && (e.which === $a4c493de23d91c5d$var$HIDE_KEY_CODE || e.keyCode === $a4c493de23d91c5d$var$HIDE_KEY_CODE)) $a4c493de23d91c5d$var$GUI.toggleHide();
};
$a4c493de23d91c5d$var$dom.bind(window, 'keydown', $a4c493de23d91c5d$var$GUI._keydownHandler, false);
$a4c493de23d91c5d$var$Common.extend($a4c493de23d91c5d$var$GUI.prototype, {
    add: function add(object, property) {
        return $a4c493de23d91c5d$var$_add(this, object, property, {
            factoryArgs: Array.prototype.slice.call(arguments, 2)
        });
    },
    addColor: function addColor(object, property) {
        return $a4c493de23d91c5d$var$_add(this, object, property, {
            color: true
        });
    },
    remove: function remove(controller) {
        this.__ul.removeChild(controller.__li);
        this.__controllers.splice(this.__controllers.indexOf(controller), 1);
        var _this = this;
        $a4c493de23d91c5d$var$Common.defer(function() {
            _this.onResize();
        });
    },
    destroy: function destroy() {
        if (this.parent) throw new Error("Only the root GUI should be removed with .destroy(). For subfolders, use gui.removeFolder(folder) instead.");
        if (this.autoPlace) $a4c493de23d91c5d$var$autoPlaceContainer.removeChild(this.domElement);
        var _this = this;
        $a4c493de23d91c5d$var$Common.each(this.__folders, function(subfolder) {
            _this.removeFolder(subfolder);
        });
        $a4c493de23d91c5d$var$dom.unbind(window, 'keydown', $a4c493de23d91c5d$var$GUI._keydownHandler, false);
        $a4c493de23d91c5d$var$removeListeners(this);
    },
    addFolder: function addFolder(name) {
        if (this.__folders[name] !== undefined) throw new Error('You already have a folder in this GUI by the name "' + name + '"');
        var newGuiParams = {
            name: name,
            parent: this
        };
        newGuiParams.autoPlace = this.autoPlace;
        if (this.load && this.load.folders && this.load.folders[name]) {
            newGuiParams.closed = this.load.folders[name].closed;
            newGuiParams.load = this.load.folders[name];
        }
        var gui = new $a4c493de23d91c5d$var$GUI(newGuiParams);
        this.__folders[name] = gui;
        var li = $a4c493de23d91c5d$var$addRow(this, gui.domElement);
        $a4c493de23d91c5d$var$dom.addClass(li, 'folder');
        return gui;
    },
    removeFolder: function removeFolder(folder) {
        this.__ul.removeChild(folder.domElement.parentElement);
        delete this.__folders[folder.name];
        if (this.load && this.load.folders && this.load.folders[folder.name]) delete this.load.folders[folder.name];
        $a4c493de23d91c5d$var$removeListeners(folder);
        var _this = this;
        $a4c493de23d91c5d$var$Common.each(folder.__folders, function(subfolder) {
            folder.removeFolder(subfolder);
        });
        $a4c493de23d91c5d$var$Common.defer(function() {
            _this.onResize();
        });
    },
    open: function open() {
        this.closed = false;
    },
    close: function close() {
        this.closed = true;
    },
    hide: function hide() {
        this.domElement.style.display = 'none';
    },
    show: function show() {
        this.domElement.style.display = '';
    },
    onResize: function onResize() {
        var root = this.getRoot();
        if (root.scrollable) {
            var top = $a4c493de23d91c5d$var$dom.getOffset(root.__ul).top;
            var h = 0;
            $a4c493de23d91c5d$var$Common.each(root.__ul.childNodes, function(node) {
                if (!(root.autoPlace && node === root.__save_row)) h += $a4c493de23d91c5d$var$dom.getHeight(node);
            });
            if (window.innerHeight - top - $a4c493de23d91c5d$var$CLOSE_BUTTON_HEIGHT < h) {
                $a4c493de23d91c5d$var$dom.addClass(root.domElement, $a4c493de23d91c5d$var$GUI.CLASS_TOO_TALL);
                root.__ul.style.height = window.innerHeight - top - $a4c493de23d91c5d$var$CLOSE_BUTTON_HEIGHT + 'px';
            } else {
                $a4c493de23d91c5d$var$dom.removeClass(root.domElement, $a4c493de23d91c5d$var$GUI.CLASS_TOO_TALL);
                root.__ul.style.height = 'auto';
            }
        }
        if (root.__resize_handle) $a4c493de23d91c5d$var$Common.defer(function() {
            root.__resize_handle.style.height = root.__ul.offsetHeight + 'px';
        });
        if (root.__closeButton) root.__closeButton.style.width = root.width + 'px';
    },
    onResizeDebounced: $a4c493de23d91c5d$var$Common.debounce(function() {
        this.onResize();
    }, 50),
    remember: function remember() {
        if ($a4c493de23d91c5d$var$Common.isUndefined($a4c493de23d91c5d$var$SAVE_DIALOGUE)) {
            $a4c493de23d91c5d$var$SAVE_DIALOGUE = new $a4c493de23d91c5d$var$CenteredDiv();
            $a4c493de23d91c5d$var$SAVE_DIALOGUE.domElement.innerHTML = $a4c493de23d91c5d$var$saveDialogContents;
        }
        if (this.parent) throw new Error('You can only call remember on a top level GUI.');
        var _this = this;
        $a4c493de23d91c5d$var$Common.each(Array.prototype.slice.call(arguments), function(object) {
            if (_this.__rememberedObjects.length === 0) $a4c493de23d91c5d$var$addSaveMenu(_this);
            if (_this.__rememberedObjects.indexOf(object) === -1) _this.__rememberedObjects.push(object);
        });
        if (this.autoPlace) $a4c493de23d91c5d$var$setWidth(this, this.width);
    },
    getRoot: function getRoot() {
        var gui = this;
        while(gui.parent)gui = gui.parent;
        return gui;
    },
    getSaveObject: function getSaveObject() {
        var toReturn = this.load;
        toReturn.closed = this.closed;
        if (this.__rememberedObjects.length > 0) {
            toReturn.preset = this.preset;
            if (!toReturn.remembered) toReturn.remembered = {};
            toReturn.remembered[this.preset] = $a4c493de23d91c5d$var$getCurrentPreset(this);
        }
        toReturn.folders = {};
        $a4c493de23d91c5d$var$Common.each(this.__folders, function(element, key) {
            toReturn.folders[key] = element.getSaveObject();
        });
        return toReturn;
    },
    save: function save() {
        if (!this.load.remembered) this.load.remembered = {};
        this.load.remembered[this.preset] = $a4c493de23d91c5d$var$getCurrentPreset(this);
        $a4c493de23d91c5d$var$markPresetModified(this, false);
        this.saveToLocalStorageIfPossible();
    },
    saveAs: function saveAs(presetName) {
        if (!this.load.remembered) {
            this.load.remembered = {};
            this.load.remembered[$a4c493de23d91c5d$var$DEFAULT_DEFAULT_PRESET_NAME] = $a4c493de23d91c5d$var$getCurrentPreset(this, true);
        }
        this.load.remembered[presetName] = $a4c493de23d91c5d$var$getCurrentPreset(this);
        this.preset = presetName;
        $a4c493de23d91c5d$var$addPresetOption(this, presetName, true);
        this.saveToLocalStorageIfPossible();
    },
    revert: function revert(gui) {
        $a4c493de23d91c5d$var$Common.each(this.__controllers, function(controller) {
            if (!this.getRoot().load.remembered) controller.setValue(controller.initialValue);
            else $a4c493de23d91c5d$var$recallSavedValue(gui || this.getRoot(), controller);
            if (controller.__onFinishChange) controller.__onFinishChange.call(controller, controller.getValue());
        }, this);
        $a4c493de23d91c5d$var$Common.each(this.__folders, function(folder) {
            folder.revert(folder);
        });
        if (!gui) $a4c493de23d91c5d$var$markPresetModified(this.getRoot(), false);
    },
    listen: function listen(controller) {
        var init = this.__listening.length === 0;
        this.__listening.push(controller);
        if (init) $a4c493de23d91c5d$var$updateDisplays(this.__listening);
    },
    updateDisplay: function updateDisplay() {
        $a4c493de23d91c5d$var$Common.each(this.__controllers, function(controller) {
            controller.updateDisplay();
        });
        $a4c493de23d91c5d$var$Common.each(this.__folders, function(folder) {
            folder.updateDisplay();
        });
    }
});
function $a4c493de23d91c5d$var$addRow(gui, newDom, liBefore) {
    var li = document.createElement('li');
    if (newDom) li.appendChild(newDom);
    if (liBefore) gui.__ul.insertBefore(li, liBefore);
    else gui.__ul.appendChild(li);
    gui.onResize();
    return li;
}
function $a4c493de23d91c5d$var$removeListeners(gui) {
    $a4c493de23d91c5d$var$dom.unbind(window, 'resize', gui.__resizeHandler);
    if (gui.saveToLocalStorageIfPossible) $a4c493de23d91c5d$var$dom.unbind(window, 'unload', gui.saveToLocalStorageIfPossible);
}
function $a4c493de23d91c5d$var$markPresetModified(gui, modified) {
    var opt = gui.__preset_select[gui.__preset_select.selectedIndex];
    if (modified) opt.innerHTML = opt.value + '*';
    else opt.innerHTML = opt.value;
}
function $a4c493de23d91c5d$var$augmentController(gui, li, controller) {
    controller.__li = li;
    controller.__gui = gui;
    $a4c493de23d91c5d$var$Common.extend(controller, {
        options: function options(_options) {
            if (arguments.length > 1) {
                var nextSibling = controller.__li.nextElementSibling;
                controller.remove();
                return $a4c493de23d91c5d$var$_add(gui, controller.object, controller.property, {
                    before: nextSibling,
                    factoryArgs: [
                        $a4c493de23d91c5d$var$Common.toArray(arguments)
                    ]
                });
            }
            if ($a4c493de23d91c5d$var$Common.isArray(_options) || $a4c493de23d91c5d$var$Common.isObject(_options)) {
                var _nextSibling = controller.__li.nextElementSibling;
                controller.remove();
                return $a4c493de23d91c5d$var$_add(gui, controller.object, controller.property, {
                    before: _nextSibling,
                    factoryArgs: [
                        _options
                    ]
                });
            }
        },
        name: function name(_name) {
            controller.__li.firstElementChild.firstElementChild.innerHTML = _name;
            return controller;
        },
        listen: function listen() {
            controller.__gui.listen(controller);
            return controller;
        },
        remove: function remove() {
            controller.__gui.remove(controller);
            return controller;
        }
    });
    if (controller instanceof $a4c493de23d91c5d$var$NumberControllerSlider) {
        var box = new $a4c493de23d91c5d$var$NumberControllerBox(controller.object, controller.property, {
            min: controller.__min,
            max: controller.__max,
            step: controller.__step
        });
        $a4c493de23d91c5d$var$Common.each([
            'updateDisplay',
            'onChange',
            'onFinishChange',
            'step',
            'min',
            'max'
        ], function(method) {
            var pc = controller[method];
            var pb = box[method];
            controller[method] = box[method] = function() {
                var args = Array.prototype.slice.call(arguments);
                pb.apply(box, args);
                return pc.apply(controller, args);
            };
        });
        $a4c493de23d91c5d$var$dom.addClass(li, 'has-slider');
        controller.domElement.insertBefore(box.domElement, controller.domElement.firstElementChild);
    } else if (controller instanceof $a4c493de23d91c5d$var$NumberControllerBox) {
        var r = function r(returned) {
            if ($a4c493de23d91c5d$var$Common.isNumber(controller.__min) && $a4c493de23d91c5d$var$Common.isNumber(controller.__max)) {
                var oldName = controller.__li.firstElementChild.firstElementChild.innerHTML;
                var wasListening = controller.__gui.__listening.indexOf(controller) > -1;
                controller.remove();
                var newController = $a4c493de23d91c5d$var$_add(gui, controller.object, controller.property, {
                    before: controller.__li.nextElementSibling,
                    factoryArgs: [
                        controller.__min,
                        controller.__max,
                        controller.__step
                    ]
                });
                newController.name(oldName);
                if (wasListening) newController.listen();
                return newController;
            }
            return returned;
        };
        controller.min = $a4c493de23d91c5d$var$Common.compose(r, controller.min);
        controller.max = $a4c493de23d91c5d$var$Common.compose(r, controller.max);
    } else if (controller instanceof $a4c493de23d91c5d$var$BooleanController) {
        $a4c493de23d91c5d$var$dom.bind(li, 'click', function() {
            $a4c493de23d91c5d$var$dom.fakeEvent(controller.__checkbox, 'click');
        });
        $a4c493de23d91c5d$var$dom.bind(controller.__checkbox, 'click', function(e) {
            e.stopPropagation();
        });
    } else if (controller instanceof $a4c493de23d91c5d$var$FunctionController) {
        $a4c493de23d91c5d$var$dom.bind(li, 'click', function() {
            $a4c493de23d91c5d$var$dom.fakeEvent(controller.__button, 'click');
        });
        $a4c493de23d91c5d$var$dom.bind(li, 'mouseover', function() {
            $a4c493de23d91c5d$var$dom.addClass(controller.__button, 'hover');
        });
        $a4c493de23d91c5d$var$dom.bind(li, 'mouseout', function() {
            $a4c493de23d91c5d$var$dom.removeClass(controller.__button, 'hover');
        });
    } else if (controller instanceof $a4c493de23d91c5d$var$ColorController) {
        $a4c493de23d91c5d$var$dom.addClass(li, 'color');
        controller.updateDisplay = $a4c493de23d91c5d$var$Common.compose(function(val) {
            li.style.borderLeftColor = controller.__color.toString();
            return val;
        }, controller.updateDisplay);
        controller.updateDisplay();
    }
    controller.setValue = $a4c493de23d91c5d$var$Common.compose(function(val) {
        if (gui.getRoot().__preset_select && controller.isModified()) $a4c493de23d91c5d$var$markPresetModified(gui.getRoot(), true);
        return val;
    }, controller.setValue);
}
function $a4c493de23d91c5d$var$recallSavedValue(gui, controller) {
    var root = gui.getRoot();
    var matchedIndex = root.__rememberedObjects.indexOf(controller.object);
    if (matchedIndex !== -1) {
        var controllerMap = root.__rememberedObjectIndecesToControllers[matchedIndex];
        if (controllerMap === undefined) {
            controllerMap = {};
            root.__rememberedObjectIndecesToControllers[matchedIndex] = controllerMap;
        }
        controllerMap[controller.property] = controller;
        if (root.load && root.load.remembered) {
            var presetMap = root.load.remembered;
            var preset = void 0;
            if (presetMap[gui.preset]) preset = presetMap[gui.preset];
            else if (presetMap[$a4c493de23d91c5d$var$DEFAULT_DEFAULT_PRESET_NAME]) preset = presetMap[$a4c493de23d91c5d$var$DEFAULT_DEFAULT_PRESET_NAME];
            else return;
            if (preset[matchedIndex] && preset[matchedIndex][controller.property] !== undefined) {
                var value = preset[matchedIndex][controller.property];
                controller.initialValue = value;
                controller.setValue(value);
            }
        }
    }
}
function $a4c493de23d91c5d$var$_add(gui, object, property, params) {
    if (object[property] === undefined) throw new Error('Object "' + object + '" has no property "' + property + '"');
    var controller = void 0;
    if (params.color) controller = new $a4c493de23d91c5d$var$ColorController(object, property);
    else {
        var factoryArgs = [
            object,
            property
        ].concat(params.factoryArgs);
        controller = $a4c493de23d91c5d$var$ControllerFactory.apply(gui, factoryArgs);
    }
    if (params.before instanceof $a4c493de23d91c5d$var$Controller) params.before = params.before.__li;
    $a4c493de23d91c5d$var$recallSavedValue(gui, controller);
    $a4c493de23d91c5d$var$dom.addClass(controller.domElement, 'c');
    var name = document.createElement('span');
    $a4c493de23d91c5d$var$dom.addClass(name, 'property-name');
    name.innerHTML = controller.property;
    var container = document.createElement('div');
    container.appendChild(name);
    container.appendChild(controller.domElement);
    var li = $a4c493de23d91c5d$var$addRow(gui, container, params.before);
    $a4c493de23d91c5d$var$dom.addClass(li, $a4c493de23d91c5d$var$GUI.CLASS_CONTROLLER_ROW);
    if (controller instanceof $a4c493de23d91c5d$var$ColorController) $a4c493de23d91c5d$var$dom.addClass(li, 'color');
    else $a4c493de23d91c5d$var$dom.addClass(li, $a4c493de23d91c5d$var$_typeof(controller.getValue()));
    $a4c493de23d91c5d$var$augmentController(gui, li, controller);
    gui.__controllers.push(controller);
    return controller;
}
function $a4c493de23d91c5d$var$getLocalStorageHash(gui, key) {
    return document.location.href + '.' + key;
}
function $a4c493de23d91c5d$var$addPresetOption(gui, name, setSelected) {
    var opt = document.createElement('option');
    opt.innerHTML = name;
    opt.value = name;
    gui.__preset_select.appendChild(opt);
    if (setSelected) gui.__preset_select.selectedIndex = gui.__preset_select.length - 1;
}
function $a4c493de23d91c5d$var$showHideExplain(gui, explain) {
    explain.style.display = gui.useLocalStorage ? 'block' : 'none';
}
function $a4c493de23d91c5d$var$addSaveMenu(gui) {
    var div = gui.__save_row = document.createElement('li');
    $a4c493de23d91c5d$var$dom.addClass(gui.domElement, 'has-save');
    gui.__ul.insertBefore(div, gui.__ul.firstChild);
    $a4c493de23d91c5d$var$dom.addClass(div, 'save-row');
    var gears = document.createElement('span');
    gears.innerHTML = '&nbsp;';
    $a4c493de23d91c5d$var$dom.addClass(gears, 'button gears');
    var button = document.createElement('span');
    button.innerHTML = 'Save';
    $a4c493de23d91c5d$var$dom.addClass(button, 'button');
    $a4c493de23d91c5d$var$dom.addClass(button, 'save');
    var button2 = document.createElement('span');
    button2.innerHTML = 'New';
    $a4c493de23d91c5d$var$dom.addClass(button2, 'button');
    $a4c493de23d91c5d$var$dom.addClass(button2, 'save-as');
    var button3 = document.createElement('span');
    button3.innerHTML = 'Revert';
    $a4c493de23d91c5d$var$dom.addClass(button3, 'button');
    $a4c493de23d91c5d$var$dom.addClass(button3, 'revert');
    var select = gui.__preset_select = document.createElement('select');
    if (gui.load && gui.load.remembered) $a4c493de23d91c5d$var$Common.each(gui.load.remembered, function(value, key) {
        $a4c493de23d91c5d$var$addPresetOption(gui, key, key === gui.preset);
    });
    else $a4c493de23d91c5d$var$addPresetOption(gui, $a4c493de23d91c5d$var$DEFAULT_DEFAULT_PRESET_NAME, false);
    $a4c493de23d91c5d$var$dom.bind(select, 'change', function() {
        for(var index = 0; index < gui.__preset_select.length; index++)gui.__preset_select[index].innerHTML = gui.__preset_select[index].value;
        gui.preset = this.value;
    });
    div.appendChild(select);
    div.appendChild(gears);
    div.appendChild(button);
    div.appendChild(button2);
    div.appendChild(button3);
    if ($a4c493de23d91c5d$var$SUPPORTS_LOCAL_STORAGE) {
        var explain = document.getElementById('dg-local-explain');
        var localStorageCheckBox = document.getElementById('dg-local-storage');
        var saveLocally = document.getElementById('dg-save-locally');
        saveLocally.style.display = 'block';
        if (localStorage.getItem($a4c493de23d91c5d$var$getLocalStorageHash(gui, 'isLocal')) === 'true') localStorageCheckBox.setAttribute('checked', 'checked');
        $a4c493de23d91c5d$var$showHideExplain(gui, explain);
        $a4c493de23d91c5d$var$dom.bind(localStorageCheckBox, 'change', function() {
            gui.useLocalStorage = !gui.useLocalStorage;
            $a4c493de23d91c5d$var$showHideExplain(gui, explain);
        });
    }
    var newConstructorTextArea = document.getElementById('dg-new-constructor');
    $a4c493de23d91c5d$var$dom.bind(newConstructorTextArea, 'keydown', function(e) {
        if (e.metaKey && (e.which === 67 || e.keyCode === 67)) $a4c493de23d91c5d$var$SAVE_DIALOGUE.hide();
    });
    $a4c493de23d91c5d$var$dom.bind(gears, 'click', function() {
        newConstructorTextArea.innerHTML = JSON.stringify(gui.getSaveObject(), undefined, 2);
        $a4c493de23d91c5d$var$SAVE_DIALOGUE.show();
        newConstructorTextArea.focus();
        newConstructorTextArea.select();
    });
    $a4c493de23d91c5d$var$dom.bind(button, 'click', function() {
        gui.save();
    });
    $a4c493de23d91c5d$var$dom.bind(button2, 'click', function() {
        var presetName = prompt('Enter a new preset name.');
        if (presetName) gui.saveAs(presetName);
    });
    $a4c493de23d91c5d$var$dom.bind(button3, 'click', function() {
        gui.revert();
    });
}
function $a4c493de23d91c5d$var$addResizeHandle(gui) {
    var pmouseX = void 0;
    gui.__resize_handle = document.createElement('div');
    $a4c493de23d91c5d$var$Common.extend(gui.__resize_handle.style, {
        width: '6px',
        marginLeft: '-3px',
        height: '200px',
        cursor: 'ew-resize',
        position: 'absolute'
    });
    function drag(e) {
        e.preventDefault();
        gui.width += pmouseX - e.clientX;
        gui.onResize();
        pmouseX = e.clientX;
        return false;
    }
    function dragStop() {
        $a4c493de23d91c5d$var$dom.removeClass(gui.__closeButton, $a4c493de23d91c5d$var$GUI.CLASS_DRAG);
        $a4c493de23d91c5d$var$dom.unbind(window, 'mousemove', drag);
        $a4c493de23d91c5d$var$dom.unbind(window, 'mouseup', dragStop);
    }
    function dragStart(e) {
        e.preventDefault();
        pmouseX = e.clientX;
        $a4c493de23d91c5d$var$dom.addClass(gui.__closeButton, $a4c493de23d91c5d$var$GUI.CLASS_DRAG);
        $a4c493de23d91c5d$var$dom.bind(window, 'mousemove', drag);
        $a4c493de23d91c5d$var$dom.bind(window, 'mouseup', dragStop);
        return false;
    }
    $a4c493de23d91c5d$var$dom.bind(gui.__resize_handle, 'mousedown', dragStart);
    $a4c493de23d91c5d$var$dom.bind(gui.__closeButton, 'mousedown', dragStart);
    gui.domElement.insertBefore(gui.__resize_handle, gui.domElement.firstElementChild);
}
function $a4c493de23d91c5d$var$setWidth(gui, w) {
    gui.domElement.style.width = w + 'px';
    if (gui.__save_row && gui.autoPlace) gui.__save_row.style.width = w + 'px';
    if (gui.__closeButton) gui.__closeButton.style.width = w + 'px';
}
function $a4c493de23d91c5d$var$getCurrentPreset(gui, useInitialValues) {
    var toReturn = {};
    $a4c493de23d91c5d$var$Common.each(gui.__rememberedObjects, function(val, index) {
        var savedValues = {};
        var controllerMap = gui.__rememberedObjectIndecesToControllers[index];
        $a4c493de23d91c5d$var$Common.each(controllerMap, function(controller, property) {
            savedValues[property] = useInitialValues ? controller.initialValue : controller.getValue();
        });
        toReturn[index] = savedValues;
    });
    return toReturn;
}
function $a4c493de23d91c5d$var$setPresetSelectIndex(gui) {
    for(var index = 0; index < gui.__preset_select.length; index++)if (gui.__preset_select[index].value === gui.preset) gui.__preset_select.selectedIndex = index;
}
function $a4c493de23d91c5d$var$updateDisplays(controllerArray) {
    if (controllerArray.length !== 0) $a4c493de23d91c5d$var$requestAnimationFrame$1.call(window, function() {
        $a4c493de23d91c5d$var$updateDisplays(controllerArray);
    });
    $a4c493de23d91c5d$var$Common.each(controllerArray, function(c) {
        c.updateDisplay();
    });
}
var $a4c493de23d91c5d$export$35e9368ef982300f = {
    Color: $a4c493de23d91c5d$var$Color,
    math: $a4c493de23d91c5d$var$ColorMath,
    interpret: $a4c493de23d91c5d$var$interpret
};
var $a4c493de23d91c5d$export$a6506504f799c5d5 = {
    Controller: $a4c493de23d91c5d$var$Controller,
    BooleanController: $a4c493de23d91c5d$var$BooleanController,
    OptionController: $a4c493de23d91c5d$var$OptionController,
    StringController: $a4c493de23d91c5d$var$StringController,
    NumberController: $a4c493de23d91c5d$var$NumberController,
    NumberControllerBox: $a4c493de23d91c5d$var$NumberControllerBox,
    NumberControllerSlider: $a4c493de23d91c5d$var$NumberControllerSlider,
    FunctionController: $a4c493de23d91c5d$var$FunctionController,
    ColorController: $a4c493de23d91c5d$var$ColorController
};
var $a4c493de23d91c5d$export$df3a06d6289f983e = {
    dom: $a4c493de23d91c5d$var$dom
};
var $a4c493de23d91c5d$export$6367ea12ae86a4eb = {
    GUI: $a4c493de23d91c5d$var$GUI
};
var $a4c493de23d91c5d$export$983832d820c96993 = $a4c493de23d91c5d$var$GUI;
var $a4c493de23d91c5d$var$index = {
    color: $a4c493de23d91c5d$export$35e9368ef982300f,
    controllers: $a4c493de23d91c5d$export$a6506504f799c5d5,
    dom: $a4c493de23d91c5d$export$df3a06d6289f983e,
    gui: $a4c493de23d91c5d$export$6367ea12ae86a4eb,
    GUI: $a4c493de23d91c5d$export$983832d820c96993
};
var $a4c493de23d91c5d$export$2e2bcd8739ae039 = $a4c493de23d91c5d$var$index;



var $bj515 = parcelRequire("bj515");
const $34ab983e052db14f$export$e506a1d27d1eaa20 = {
    fullscreen: false,
    speechDetection: true
};
const $34ab983e052db14f$export$6367ea12ae86a4eb = new $a4c493de23d91c5d$export$983832d820c96993();
$34ab983e052db14f$export$6367ea12ae86a4eb.useLocalStorage = true;
const $34ab983e052db14f$export$52279a4478cf302a = $34ab983e052db14f$export$6367ea12ae86a4eb.add($34ab983e052db14f$export$e506a1d27d1eaa20, "fullscreen");
const $34ab983e052db14f$export$fdab520b99e2679 = $34ab983e052db14f$export$6367ea12ae86a4eb.add($34ab983e052db14f$export$e506a1d27d1eaa20, "speechDetection");
const $34ab983e052db14f$var$commandsGui = $34ab983e052db14f$export$6367ea12ae86a4eb.addFolder("Voice commands");
const $34ab983e052db14f$var$commandList = $34ab983e052db14f$var$commandsGui.domElement.childNodes[0];
// add the list of commands
for (const action of (0, $bj515.default)){
    const command = (0, $bj515.primaryCommand)(action);
    if (!command) continue;
    const commandEl = document.createElement("li");
    commandEl.innerText = `${action.description}: ${command} | ${action.keycode}`;
    $34ab983e052db14f$var$commandList.appendChild(commandEl);
}



var $dOTXv = parcelRequire("dOTXv");
const $55fa4825131210ec$var$DEFAULT_DEVICE_ID = "default";
const $55fa4825131210ec$var$isDefaultInput = (device)=>device.kind === "audioinput" && device.deviceId === $55fa4825131210ec$var$DEFAULT_DEVICE_ID;
/**
 * @returns the default audio input device, if available
 */ const $55fa4825131210ec$var$getDefaultInput = async (md)=>{
    const devices = await md.enumerateDevices();
    const device = devices.find($55fa4825131210ec$var$isDefaultInput);
    if (device) return device;
    return null;
};
const $55fa4825131210ec$export$ca1b3f18c1e75712 = async (md)=>{
    const device = await $55fa4825131210ec$var$getDefaultInput(md);
    if (!device) return false;
    return device.label.toLowerCase().includes("bluetooth");
};



var $8L83R = parcelRequire("8L83R");
let $95c3c95449516725$var$showBluetoothWarning = false;
const $95c3c95449516725$export$7fb230a809b6747d = async ()=>{
    const isBluetooth = await (0, $55fa4825131210ec$export$ca1b3f18c1e75712)(navigator.mediaDevices);
    $95c3c95449516725$var$showBluetoothWarning = !isBluetooth;
};
const $95c3c95449516725$var$baseColor = $8L83R.RED;
const $95c3c95449516725$var$redMax = $8L83R.toRGBA(Object.assign({}, $95c3c95449516725$var$baseColor, {
    a: 0.5
}));
const $95c3c95449516725$var$redMin = $8L83R.toRGBA(Object.assign({}, $95c3c95449516725$var$baseColor, {
    a: 0
}));
const $95c3c95449516725$var$pctOfHeight = 0.08;
const $95c3c95449516725$export$c96f603757533ec9 = (canvas)=>{
    if ($95c3c95449516725$var$showBluetoothWarning) {
        const ctx = canvas.context;
        // bottom
        const rect1YStart = canvas.height() * (1 - $95c3c95449516725$var$pctOfHeight);
        const gradient1 = ctx.createLinearGradient(0, canvas.height(), 0, rect1YStart);
        gradient1.addColorStop(0, $95c3c95449516725$var$redMax);
        gradient1.addColorStop(1, $95c3c95449516725$var$redMin);
        ctx.fillStyle = gradient1;
        ctx.fillRect(0, rect1YStart, canvas.width(), canvas.height());
        // top
        const rect2YStop = canvas.height() * $95c3c95449516725$var$pctOfHeight;
        const gradient2 = ctx.createLinearGradient(0, 0, 0, rect2YStop);
        gradient2.addColorStop(0, $95c3c95449516725$var$redMax);
        gradient2.addColorStop(1, $95c3c95449516725$var$redMin);
        ctx.fillStyle = gradient2;
        ctx.fillRect(0, 0, canvas.width(), rect2YStop);
    }
};


let $d2acd151c83ac5ba$var$lastPose;
const $d2acd151c83ac5ba$export$24177d392731615d = async (monitor, detector, canvas, effects)=>{
    monitor.stats.begin();
    if (detector.isReady()) {
        let pose;
        try {
            pose = await detector.detect();
        } catch (error) {
            // For some reason, a WASM error happens in the pose detection sometimes, which stops it. Restart it.
            console.warn("WASM error, restarting pose detection");
            console.warn(error);
            detector.reset();
        }
        // if no current pose is detected, use the last one to avoid flickering
        if (!pose) pose = $d2acd151c83ac5ba$var$lastPose;
        canvas.loaded();
        if (pose) {
            (0, $dOTXv.sortEfects)(pose, effects);
            // do this as late as possible
            canvas.clear();
            for (const effect of effects)await effect.onAnimationFrame(pose, canvas);
        }
        $d2acd151c83ac5ba$var$lastPose = pose;
    } else canvas.clear();
    (0, $95c3c95449516725$export$c96f603757533ec9)(canvas);
    monitor.stats.end();
    // loop
    requestAnimationFrame(()=>$d2acd151c83ac5ba$export$24177d392731615d(monitor, detector, canvas, effects));
};
// do this outside the animation loop to avoid slowing it down
setInterval(()=>(0, $95c3c95449516725$export$7fb230a809b6747d)(), 1000);



var $bj515 = parcelRequire("bj515");


class $0a574527fd522632$export$2e2bcd8739ae039 {
    constructor(effects, video){
        this.onVoiceCommand = (command)=>{
            console.log("command received:", command);
            const action = (0, $bj515.actionForCommand)(command);
            if (!action) {
                console.warn(`command "${command}" not found`);
                return;
            }
            action.callback(this.effects, this.video);
        };
        this.onCheckboxChange = (value)=>{
            if (value) this.startIfAllowed();
            else this.stop();
        };
        this.effects = effects;
        this.video = video;
        const iframe = (0, $816ad028d040dfc8$export$83595b84fc78b9b4)("speech");
        this.speechWindow = iframe.contentWindow;
        // set up handlers
        this.speechWindow.addEventListener("load", ()=>{
            this.startIfAllowed();
        });
        window.addEventListener("message", (event)=>{
            // ignore messages from React DevTools
            // https://github.com/facebook/react-devtools/issues/812
            if (event.data.source?.toString().startsWith("react-devtools-")) return;
            this.onVoiceCommand(event.data);
        });
        (0, $34ab983e052db14f$export$fdab520b99e2679).onChange(this.onCheckboxChange);
    }
    isAllowed() {
        return (0, $34ab983e052db14f$export$e506a1d27d1eaa20).speechDetection;
    }
    startIfAllowed() {
        if (this.isAllowed()) this.speechWindow.postMessage("start", "*");
    }
    stop() {
        this.speechWindow.postMessage("stop", "*");
    }
}


/**
 * avoid being creepy by only watching+listening when the window is visible
 */ const $f87a04cfd7f7cd85$var$onVisibilityChange = (video, canvas, listenerController)=>{
    if (document.hidden) {
        video.turnOffWebcam();
        listenerController.stop();
    } else {
        // try to match output resolution
        video.setUpCamera(canvas.width(), canvas.height());
        listenerController.startIfAllowed();
    }
};
const $f87a04cfd7f7cd85$export$43d666542bf3febf = (video, canvas, effects)=>{
    const listenerController = new (0, $0a574527fd522632$export$2e2bcd8739ae039)(effects, video);
    $f87a04cfd7f7cd85$var$onVisibilityChange(video, canvas, listenerController);
    document.addEventListener("visibilitychange", ()=>$f87a04cfd7f7cd85$var$onVisibilityChange(video, canvas, listenerController), false);
};



const $4c2faa70635d9970$var$onFullscreenChange = async (canvas)=>{
    if ((0, $34ab983e052db14f$export$e506a1d27d1eaa20).fullscreen) await canvas.el.requestFullscreen();
};
const $4c2faa70635d9970$export$15cedb3a57eeff75 = (canvas)=>{
    // need to subscribe to the element instead of the Controller due to
    // https://javascript.plainenglish.io/user-gesture-restricted-web-apis-d794454453f7
    (0, $34ab983e052db14f$export$52279a4478cf302a).domElement.addEventListener("change", ()=>$4c2faa70635d9970$var$onFullscreenChange(canvas));
    document.addEventListener("fullscreenchange", ()=>(0, $34ab983e052db14f$export$52279a4478cf302a).setValue(!!document.fullscreenElement));
};


var $8d6448069697305c$exports = {};
// stats.js - http://github.com/mrdoob/stats.js
(function(f, e) {
    $8d6448069697305c$exports = e();
})($8d6448069697305c$exports, function() {
    var f = function() {
        function e(a) {
            c.appendChild(a.dom);
            return a;
        }
        function u(a) {
            for(var d = 0; d < c.children.length; d++)c.children[d].style.display = d === a ? "block" : "none";
            l = a;
        }
        var l = 0, c = document.createElement("div");
        c.style.cssText = "position:fixed;top:0;left:0;cursor:pointer;opacity:0.9;z-index:10000";
        c.addEventListener("click", function(a) {
            a.preventDefault();
            u(++l % c.children.length);
        }, !1);
        var k = (performance || Date).now(), g = k, a = 0, r = e(new f.Panel("FPS", "#0ff", "#002")), h = e(new f.Panel("MS", "#0f0", "#020"));
        if (self.performance && self.performance.memory) var t = e(new f.Panel("MB", "#f08", "#201"));
        u(0);
        return {
            REVISION: 16,
            dom: c,
            addPanel: e,
            showPanel: u,
            begin: function() {
                k = (performance || Date).now();
            },
            end: function() {
                a++;
                var c = (performance || Date).now();
                h.update(c - k, 200);
                if (c > g + 1E3 && (r.update(1E3 * a / (c - g), 100), g = c, a = 0, t)) {
                    var d = performance.memory;
                    t.update(d.usedJSHeapSize / 1048576, d.jsHeapSizeLimit / 1048576);
                }
                return c;
            },
            update: function() {
                k = this.end();
            },
            domElement: c,
            setMode: u
        };
    };
    f.Panel = function(e, f, l) {
        var c = Infinity, k = 0, g = Math.round, a = g(window.devicePixelRatio || 1), r = 80 * a, h = 48 * a, t = 3 * a, v = 2 * a, d = 3 * a, m = 15 * a, n = 74 * a, p = 30 * a, q = document.createElement("canvas");
        q.width = r;
        q.height = h;
        q.style.cssText = "width:80px;height:48px";
        var b = q.getContext("2d");
        b.font = "bold " + 9 * a + "px Helvetica,Arial,sans-serif";
        b.textBaseline = "top";
        b.fillStyle = l;
        b.fillRect(0, 0, r, h);
        b.fillStyle = f;
        b.fillText(e, t, v);
        b.fillRect(d, m, n, p);
        b.fillStyle = l;
        b.globalAlpha = .9;
        b.fillRect(d, m, n, p);
        return {
            dom: q,
            update: function(h, w) {
                c = Math.min(c, h);
                k = Math.max(k, h);
                b.fillStyle = l;
                b.globalAlpha = 1;
                b.fillRect(0, 0, r, m);
                b.fillStyle = f;
                b.fillText(g(h) + " " + e + " (" + g(c) + "-" + g(k) + ")", t, v);
                b.drawImage(q, d + a, m, n - a, p, d, m, n - a, p);
                b.fillRect(d + n - a, m, a, p);
                b.fillStyle = l;
                b.globalAlpha = .9;
                b.fillRect(d + n - a, m, a, g((1 - h / w) * p));
            }
        };
    };
    return f;
});


var $b6d5cb441591cd82$exports = {};
$b6d5cb441591cd82$exports = import.meta.resolve("lo3i6");


const $74bc29b06604a3fd$var$listenForAudio = async (callback)=>{
    const stream = await navigator.mediaDevices.getUserMedia({
        audio: true,
        video: false
    });
    // https://stackoverflow.com/a/62732195/358804
    const audioContext = new AudioContext();
    await audioContext.audioWorklet.addModule((0, (/*@__PURE__*/$parcel$interopDefault($b6d5cb441591cd82$exports))));
    const node = new AudioWorkletNode(audioContext, "volume-meter");
    node.port.onmessage = (event)=>{
        // https://github.com/GoogleChromeLabs/web-audio-samples/blob/eed2a8613af551f2b1d166a01c834e8431fdf3c6/src/audio-worklet/basic/volume-meter/main.js#L13
        const volume = event.data * 500;
        callback(volume);
    };
    const microphone = audioContext.createMediaStreamSource(stream);
    microphone.connect(node).connect(audioContext.destination);
};
const $74bc29b06604a3fd$var$setUpVolumePanel = (stats)=>{
    // https://github.com/mrdoob/stats.js/blob/master/examples/custom.html
    const volumePanel = stats.addPanel(new (0, (/*@__PURE__*/$parcel$interopDefault($8d6448069697305c$exports))).Panel("volume", "#f8f", "#212"));
    $74bc29b06604a3fd$var$listenForAudio((volume)=>volumePanel.update(volume, 70));
    // workaround to show both Panels
    const volumeEl = stats.dom.children[3];
    volumeEl.style.display = "block";
    return volumePanel;
};
const $74bc29b06604a3fd$var$createMonitor = ()=>{
    const stats = new (0, (/*@__PURE__*/$parcel$interopDefault($8d6448069697305c$exports)))();
    stats.showPanel(0);
    const volumePanel = $74bc29b06604a3fd$var$setUpVolumePanel(stats);
    document.body.appendChild(stats.dom);
    const monitor = {
        stats: stats,
        volumePanel: volumePanel
    };
    return monitor;
};
var $74bc29b06604a3fd$export$2e2bcd8739ae039 = $74bc29b06604a3fd$var$createMonitor;



var $51Ld3 = parcelRequire("51Ld3");
const $ecb74c2a8f25c0d0$var$onKeyPress = (event, effects, video)=>{
    const action = (0, $bj515.actionForKeyCode)(event.code);
    if (!action) {
        console.warn(`no action for key "${event.code}"`);
        return;
    }
    action.callback(effects, video);
};
const $ecb74c2a8f25c0d0$var$createCanvas = ()=>{
    const canvasEl = (0, $816ad028d040dfc8$export$83595b84fc78b9b4)("canvas");
    const loadingIndicator = (0, $816ad028d040dfc8$export$83595b84fc78b9b4)("loading");
    return new (0, $7d44629e1ea23552$export$2e2bcd8739ae039)(canvasEl, loadingIndicator);
};
const $ecb74c2a8f25c0d0$var$setup = async ()=>{
    // https://www.tensorflow.org/js/guide/platform_environment#backends
    $i64bB.setBackend("webgl");
    // https://www.tensorflow.org/js/guide/platform_environment#flags
    $i64bB.enableProdMode();
    const canvas = $ecb74c2a8f25c0d0$var$createCanvas();
    const video = (0, $24ba8c8cb566c6a3$export$2e2bcd8739ae039).matchCanvas(canvas);
    const monitor = (0, $74bc29b06604a3fd$export$2e2bcd8739ae039)();
    const detector = new (0, $3HJq6.default)(video);
    const effects = [];
    // start with static
    (0, $51Ld3.default).addTo(effects);
    // kick off the video display
    (0, $d2acd151c83ac5ba$export$24177d392731615d)(monitor, detector, canvas, effects);
    document.addEventListener("keypress", (event)=>$ecb74c2a8f25c0d0$var$onKeyPress(event, effects, video));
    (0, $f87a04cfd7f7cd85$export$43d666542bf3febf)(video, canvas, effects);
    (0, $4c2faa70635d9970$export$15cedb3a57eeff75)(canvas);
};
$ecb74c2a8f25c0d0$var$setup();


//# sourceMappingURL=repo.52619bb8.js.map
